


  
  

  var faTurnUp = {
    prefix: 'fal',
    iconName: 'turn-up',
    icon: [
      384,
      512,
      [10548,"level-up-alt"],
      'f3bf',
      
      'M128 160l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L192 35.8 317.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7L256 160c-17.7 0-32 14.3-32 32l0 176c0 61.9-50.1 112-112 112l-64 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48l0-176c0-17.7-14.3-32-32-32zM206 5.3C202.1 1.9 197.2 0 192 0s-10.1 1.9-14 5.3L44.9 124.5C36.7 131.8 32 142.3 32 153.3C32 174.7 49.3 192 70.7 192L96 192l32 0 0 32 0 144c0 8.8-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l64 0c79.5 0 144-64.5 144-144l0-144 0-32 32 0 25.3 0c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L206 5.3z'
      
    ]
  };

  
    var faLevelUpAlt = faTurnUp;
  

  
  

  var faMessageText = {
    prefix: 'fal',
    iconName: 'message-text',
    icon: [
      512,
      512,
      ["comment-alt-text"],
      'e1e6',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM192 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0-64 0z'
      
    ]
  };

  
    var faCommentAltText = faMessageText;
  

  
  

  var faSquareZ = {
    prefix: 'fal',
    iconName: 'square-z',
    icon: [
      448,
      512,
      [],
      'e288',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 32l160 0c6 0 11.5 3.3 14.2 8.7s2.3 11.7-1.2 16.6L175.1 352 304 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-6 0-11.5-3.4-14.2-8.7s-2.3-11.7 1.2-16.6L272.9 160 144 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPersonCircleCheck = {
    prefix: 'fal',
    iconName: 'person-circle-check',
    icon: [
      576,
      512,
      [],
      'e53e',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91L224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faHandHoldingMedical = {
    prefix: 'fal',
    iconName: 'hand-holding-medical',
    icon: [
      576,
      512,
      [],
      'e05c',
      
      'M266.7 0l42.7 0c17.7 0 32 14.3 32 32l0 42.7 42.7 0c17.7 0 32 14.3 32 32l0 42.7c0 17.7-14.3 32-32 32l-42.7 0 0 42.7c0 17.7-14.3 32-32 32l-42.7 0c-17.7 0-32-14.3-32-32l0-42.7-42.7 0c-17.7 0-32-14.3-32-32l0-42.7c0-17.7 14.3-32 32-32l42.7 0 0-42.7c0-17.7 14.3-32 32-32zm0 32l0 58.7c0 8.8-7.2 16-16 16l-58.7 0 0 42.7 58.7 0c8.8 0 16 7.2 16 16l0 58.7 42.7 0 0-58.7c0-8.8 7.2-16 16-16l58.7 0 0-42.7-58.7 0c-8.8 0-16-7.2-16-16l0-58.7-42.7 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fal',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      'M307.2 66.2L47.6 160l74 26.7c10.3-6.9 21.5-12.6 33.4-17.1l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-1.5 .5-2.9 1.1-4.3 1.7l145.3 52.5c4.1 1.5 8.4 2.2 12.8 2.2s8.7-.8 12.8-2.2L592.4 160 332.8 66.2c-4.1-1.5-8.4-2.2-12.8-2.2s-8.7 .8-12.8 2.2zM296.3 283.9L126.9 222.7C99.4 246 82.1 279.9 80.2 316.9c5.9 13.2 10.2 27.5 13.4 41.5c6.4 27.6 10.7 65.9 2.1 108.7c-.9 4.3-3.4 8-7.1 10.4s-8.2 3.1-12.4 2l-64-16c-5.2-1.3-9.4-5.1-11.2-10.2s-.9-10.7 2.3-14.9c8.6-11.7 16-24.6 22.5-37.6C37.2 377.8 48 348.4 48 320c0-.6 0-1.2 .1-1.8c1.4-41 18-79.1 45.1-107.7L15.8 182.6C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1L624.2 137.4c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zm-122-10L160.4 406.3c.7 .8 1.8 2.1 3.7 3.7c6 5.2 16.5 11.5 31.9 17.5C226.4 439.4 270.3 448 320 448s93.6-8.6 124.1-20.6c15.4-6 25.8-12.3 31.9-17.5c1.9-1.6 3-2.8 3.7-3.7L465.7 273.8l31-11.2L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 31 11.2zM480.5 405s0 0-.1 .1c0-.1 .1-.1 .1-.1zm-321 0s0 0 .1 .1c0-.1-.1-.1-.1-.1zM67 444.2c2.5-20.7 1.7-40-.5-56.7c-3.8 10-8 19.3-12.1 27.6c-3.8 7.6-7.9 15.2-12.5 22.8L67 444.2z'
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faMessageMiddle = {
    prefix: 'fal',
    iconName: 'message-middle',
    icon: [
      512,
      512,
      ["comment-middle-alt"],
      'e1e1',
      
      'M343.5 384L448 384c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l104.5 0c9.5 0 18.5 4.2 24.6 11.5L256 471l62.9-75.5C325 388.2 334 384 343.5 384zM268.3 485.7s0 0 0 0L256 496l12.3-10.2s0 0 0 0zM168.5 416L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-104.5 0-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z'
      
    ]
  };

  
    var faCommentMiddleAlt = faMessageMiddle;
  

  
  

  var faVideo = {
    prefix: 'fal',
    iconName: 'video',
    icon: [
      576,
      512,
      ["video-camera"],
      'f03d',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 47.2 0 161.6 0 47.2c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM519.4 411.3L416 354.4l0-36.5 118.8 65.4c.9 .5 1.9 .8 3 .8c3.4 0 6.2-2.8 6.2-6.2l0-243.6c0-3.4-2.8-6.2-6.2-6.2c-1 0-2.1 .3-3 .8L416 194.1l0-36.5 103.4-56.9c5.6-3.1 12-4.7 18.4-4.7c21.1 0 38.2 17.1 38.2 38.2l0 243.6c0 21.1-17.1 38.2-38.2 38.2c-6.4 0-12.8-1.6-18.4-4.7z'
      
    ]
  };

  
    var faVideoCamera = faVideo;
  

  
  

  var faSquareSlidersVertical = {
    prefix: 'fal',
    iconName: 'square-sliders-vertical',
    icon: [
      448,
      512,
      ["sliders-v-square"],
      'f3f2',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 96c-8.8 0-16 7.2-16 16l0 48-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-48c0-8.8-7.2-16-16-16zm0 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM304 128c-8.8 0-16 7.2-16 16l0 112-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-112c0-8.8-7.2-16-16-16zm0 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faSlidersVSquare = faSquareSlidersVertical;
  

  
  

  var faPlusMinus = {
    prefix: 'fal',
    iconName: 'plus-minus',
    icon: [
      384,
      512,
      [],
      'e43c',
      
      'M176 208l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144L32 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0zM16 464c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 448c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faBulldozer = {
    prefix: 'fal',
    iconName: 'bulldozer',
    icon: [
      640,
      512,
      [],
      'e655',
      
      'M80 64l92.2 0c6.1 0 11.6 3.4 14.3 8.8L246.1 192 64 192 64 80c0-8.8 7.2-16 16-16zM32 80l0 112 0 16 0 16 0 97.6C12.2 341.8 0 369.5 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-23.8-7.4-45.9-20.1-64l68.1 0 0 40.8c0 18.7 6.6 36.8 18.5 51.2l65.2 78.2c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5l-65.2-78.2c-7.2-8.6-11.1-19.5-11.1-30.7l0-113.7c0-11.2 3.9-22.1 11.1-30.7l65.2-78.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L546.5 212c-12 14.4-18.5 32.5-18.5 51.2l0 40.8-80 0 0-48c0-35.3-28.7-64-64-64l-16 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-54.1 0L215.2 58.5C207 42.3 190.4 32 172.2 32L80 32C53.5 32 32 53.5 32 80zM64 224l207.7 0c.2 0 .4 0 .7 0L384 224c17.7 0 32 14.3 32 32l0 42.8c-14.5-6.9-30.8-10.8-48-10.8l-256 0c-17.2 0-33.5 3.9-48 10.8L64 224zm48 96l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-256 0c-44.2 0-80-35.8-80-80s35.8-80 80-80zm32 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBarcode = {
    prefix: 'fal',
    iconName: 'barcode',
    icon: [
      512,
      512,
      [],
      'f02a',
      
      'M0 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 48zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16L64 48zm80-16c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416zm80-16c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416zM496 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFileMp4 = {
    prefix: 'fal',
    iconName: 'file-mp4',
    icon: [
      512,
      512,
      [],
      'e649',
      
      'M64 480l16 0 0 32-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM157.7 359.8L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm84.7 11.3c-3-3-4.7-7.1-4.7-11.3l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-4.2 0-8.3-1.7-11.3-4.7z'
      
    ]
  };

  

  
  

  var faShieldKeyhole = {
    prefix: 'fal',
    iconName: 'shield-keyhole',
    icon: [
      512,
      512,
      [],
      'e248',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7l0 74.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-74.3c23.1-6.9 40-28.3 40-53.7z'
      
    ]
  };

  

  
  

  var faReflectVertical = {
    prefix: 'fal',
    iconName: 'reflect-vertical',
    icon: [
      512,
      512,
      [],
      'e665',
      
      'M0 256c0-8.8 7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16zM384 480L256 352 128 480l256 0zM128 512c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0zm0-480L256 160 384 32 128 32zM98.4 19.8C103.4 7.8 115.1 0 128 0L384 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9z'
      
    ]
  };

  

  
  

  var faSquareShareNodes = {
    prefix: 'fal',
    iconName: 'square-share-nodes',
    icon: [
      448,
      512,
      ["share-alt-square"],
      'f1e1',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-18.4 0-35.1-7.8-46.7-20.3l-81.7 44.6c.3 2.5 .5 5.1 .5 7.7s-.2 5.2-.5 7.7l81.7 44.6C284.9 295.8 301.6 288 320 288c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-5.4 .7-10.6 1.9-15.6l-78.2-42.7C168.1 309.6 149.2 320 128 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c21.2 0 40.1 10.4 51.7 26.3l78.2-42.7c-1.3-5-1.9-10.2-1.9-15.6c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faShareAltSquare = faSquareShareNodes;
  

  
  

  var faComet = {
    prefix: 'fal',
    iconName: 'comet',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8C0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7l-26.1 0L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4 320 32zm154.6 .3c.5-.2 1-.3 1.5-.3c2.1 0 3.8 1.7 3.8 3.8c0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3l50.6 0L338.5 409.8C306.7 453.9 255.6 480 201.3 480C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32l0 57.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM169.1 283.7c10.4-1.5 19.4-8.1 24.1-17.5L208 236.2l14.8 30.1c4.7 9.4 13.7 16 24.1 17.5l33.2 4.8-24 23.4c-7.5 7.4-11 17.9-9.2 28.3l5.7 33.1-29.7-15.6c-9.3-4.9-20.5-4.9-29.8 0l-29.7 15.6 5.7-33.1c1.8-10.4-1.7-21-9.2-28.3l-24-23.4 33.2-4.8zm53.3-90.8c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L208 386.1l58.4 30.7c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z'
      
    ]
  };

  

  
  

  var faJetFighter = {
    prefix: 'fal',
    iconName: 'jet-fighter',
    icon: [
      640,
      512,
      ["fighter-jet"],
      'f0fb',
      
      'M224 32l23.9 0L352.6 176 224 176l0-144zM384.2 208l106 0c1.9 0 3.8 .3 5.6 1l107.6 40.3c2.8 1 4.6 3.7 4.6 6.6s-1.8 5.6-4.6 6.6L495.8 303c-1.8 .7-3.7 1-5.6 1l-106 0-.4 0L208 304l-48 0c-4.2 0-8.3 1.7-11.3 4.7l-38.6 38.6c-3 3-7.1 4.7-11.3 4.7L80 352c-8.8 0-16-7.2-16-16l0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64c0-8.8 7.2-16 16-16l18.7 0c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7l48 0 175.8 0 .4 0zM32 272l0 64c0 26.5 21.5 48 48 48l18.7 0c12.7 0 24.9-5.1 33.9-14.1L166.6 336l25.4 0 0 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 47.8 0 .4 0 47.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16.6 0L392.1 336l98.1 0c5.8 0 11.5-1 16.9-3.1l107.6-40.3c15.3-5.7 25.4-20.3 25.4-36.6s-10.1-30.9-25.4-36.6L507.1 179.1c-5.4-2-11.1-3.1-16.9-3.1l-98.1 0L287.4 32 304 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L256.2 0l-.4 0L208 0 192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 144-25.4 0-33.9-33.9c-9-9-21.2-14.1-33.9-14.1L80 128c-26.5 0-48 21.5-48 48l0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0zM224 480l0-144 128.6 0L247.9 480 224 480z'
      
    ]
  };

  
    var faFighterJet = faJetFighter;
  

  
  

  var faPageCaretUp = {
    prefix: 'fal',
    iconName: 'page-caret-up',
    icon: [
      384,
      512,
      ["file-caret-up"],
      'e42a',
      
      'M352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l181.5 0c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6L352 448zM64 512l256 0c35.3 0 64-28.7 64-64l0-309.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64zM203.8 197.2c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2l139.6 0c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6zM192 231.7L243.6 288l-103.3 0L192 231.7z'
      
    ]
  };

  
    var faFileCaretUp = faPageCaretUp;
  

  
  

  var faHandshakeSimple = {
    prefix: 'fal',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      'M263.9 64l8.7 0L237.4 99.2c-16.6 4.1-32.2 11.9-45.5 23.1l-40.5 34c-2.9 2.4-6.5 3.8-10.3 3.8L48 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l87.3 0 36-30.3C197.2 76 230 64 263.9 64zm28.4 35c23.8-22.5 55.3-35 88.1-35c30.2 0 59.4 10.6 82.5 30.1L503.3 128l88.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-94.5 0c-3.8 0-7.4-1.3-10.3-3.8l-44.8-37.7C425 104 403.1 96 380.4 96c-24.6 0-48.2 9.4-66.1 26.3l-79.4 75c-14.9 14.1-14.6 38 .8 51.6c13.5 12 33.8 11.8 47-.4l76.1-70.2c6.5-6 16.6-5.6 22.6 .9s5.6 16.6-.9 22.6l-8.1 7.5L458 294.8c7 7 12.1 15.2 15.1 24l118.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-116.2 0c-2.3 13.8-9.2 27-20.6 37c-15.7 14-36.5 18.8-55.7 14.8c-2.7 8.1-7 15.8-13 22.5c-23 25.9-62 28.6-88.4 7.3c-.8 .7-1.5 1.5-2.3 2.2c-26.4 23.6-66.7 22.5-91.8-2.6l-24.3-24.3-.1-.1-15.4-15.4-28.6-28.6c-7.5-7.5-17.7-11.7-28.3-11.7L48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.4 0c19.1 0 37.4 7.6 50.9 21.1l28.6 28.6 39.9 39.8c13.1 13.1 34 13.6 47.8 1.3c3.2-2.9 5.8-6.2 7.6-9.8c2.4-4.5 6.7-7.6 11.8-8.4s10.1 .9 13.7 4.5l8.1 8.1c13.1 13.1 34.6 12.5 46.9-1.4c5.8-6.5 8.5-14.7 8.1-22.9c-.3-6 2.8-11.6 8-14.6s11.6-2.8 16.6 .5c11.8 7.6 27.6 6.7 38.6-3c13.7-12.2 14.4-33.5 1.4-46.5L348.9 231l-44.5 41c-25.3 23.4-64.2 23.7-90 .8C185 246.7 184.3 201 212.9 174l79.4-75z'
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faEyes = {
    prefix: 'fal',
    iconName: 'eyes',
    icon: [
      640,
      512,
      [],
      'e367',
      
      'M304 256c0 55.6-16.9 104.7-42.8 139.2C235.3 429.7 202.1 448 168 448s-67.3-18.3-93.2-52.8c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C100.7 82.3 133.9 64 168 64s67.3 18.3 93.2 52.8C287.1 151.3 304 200.4 304 256zm16-95.5C293.1 84.5 235.2 32 168 32C75.2 32 0 132.3 0 256S75.2 480 168 480c67.2 0 125.1-52.5 152-128.5C346.9 427.5 404.8 480 472 480c92.8 0 168-100.3 168-224s-75.2-224-168-224c-67.2 0-125.1 52.5-152 128.5zm58.8 234.7c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C404.7 82.3 437.9 64 472 64s67.3 18.3 93.2 52.8C591.1 151.3 608 200.4 608 256s-16.9 104.7-42.8 139.2S506.1 448 472 448s-67.3-18.3-93.2-52.8zM32 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm352-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleJ = {
    prefix: 'fal',
    iconName: 'circle-j',
    icon: [
      512,
      512,
      [],
      'e112',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-368c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-144z'
      
    ]
  };

  

  
  

  var faGalleryThumbnails = {
    prefix: 'fal',
    iconName: 'gallery-thumbnails',
    icon: [
      576,
      512,
      [],
      'e3aa',
      
      'M512 32c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L64 320c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l448 0zM64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 0zm0 448l0 32-32 0 0-32 32 0zM32 416c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm160 32l32 0 0 32-32 0 0-32zm-32 0l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm224 0l0 32-32 0 0-32 32 0zm-32-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm160 32l32 0 0 32-32 0 0-32zm-32 0l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faHandPointLeft = {
    prefix: 'fal',
    iconName: 'hand-point-left',
    icon: [
      512,
      512,
      [],
      'f0a5',
      
      'M56 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0 40 0 0-32c0-5.5 .6-10.8 1.6-16L56 128zm216 48s0 0 0 0l0 32s0 0 0 0l0 24c0 13.2 10.7 24 24 24c0 0 0 0 0 0c13.3 0 24-10.7 24-24l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 15.7-6.4 29.8-16.8 40c10.4 10.2 16.8 24.3 16.8 40c0 13.8-5 26.4-13.2 36.1C351.7 358.4 360 374.2 360 392c0 8.6-1.9 16.7-5.4 24C424.1 414.6 480 357.8 480 288l0-64c0-70.7-57.3-128-128-128l-32 0c-26.5 0-48 21.5-48 48l0 32zm-32 32l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l31.9 0c0 0 0 0 .1 0l13.4 0c-3.5-7.3-5.4-15.4-5.4-24l0-24zm-90.6 0L56 208c-30.9 0-56-25.1-56-56s25.1-56 56-56l200 0c14.6-19.4 37.8-32 64-32l32 0c88.4 0 160 71.6 160 160l0 64c0 88.4-71.6 160-160 160l-48 0-32 0-24 0c-30.9 0-56-25.1-56-56c0-12.1 3.8-23.3 10.4-32.5C186.5 349.6 176 332 176 312c0-9.7 2.5-18.8 6.8-26.7C160.3 278 144 256.9 144 232c0-8.6 1.9-16.7 5.4-24zM272 288l-40 0c-13.2 0-24 10.8-24 24c0 13.3 10.7 24 24 24l16 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24c0 0 0 0 0 0l-24 0zm0 128l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0z'
      
    ]
  };

  

  
  

  var faPineapple = {
    prefix: 'fal',
    iconName: 'pineapple',
    icon: [
      512,
      512,
      [],
      'e31f',
      
      'M387.4 2.6c-12 5.2-21.8 13-29.1 22.5c-12.5-12.2-32.5-12-44.9 .3c-17.1 17.1-26.7 38.9-28.8 61.2c11 3.3 21.7 7.9 31.7 13.6C315.1 81.4 321.7 62.3 336 48l14.7 14.7c3.9 3.9 9.6 5.5 15 4.3s9.7-5.2 11.5-10.4C380.8 46 388.5 36.9 400 32l3.6 14.3c1.2 4.8 4.6 8.9 9.2 10.8s9.8 1.7 14.2-.8c9.5-5.4 20.4-8.3 31.5-8.3l5.5 0 0 5.5c0 11.2-2.9 22-8.3 31.5c-2.5 4.3-2.8 9.6-.8 14.2s6 8 10.8 9.2L480 112c-4.9 11.5-14 19.2-24.6 22.8c-5.2 1.8-9.2 6.1-10.4 11.5s.4 11 4.3 15L464 176c-14.3 14.3-33.4 20.9-52.1 19.8c5.7 10 10.2 20.7 13.6 31.7c22.3-2.1 44.1-11.7 61.2-28.8c12.4-12.4 12.5-32.4 .3-44.9c9.4-7.3 17.3-17.1 22.5-29.1c3.7-8.6 3.4-18.4-.7-26.8c-3.6-7.2-9.7-12.7-17.1-15.6c2.9-9.2 4.4-18.9 4.4-28.7l0-5.5c0-17.7-14.3-32-32-32l-5.5 0c-9.8 0-19.5 1.5-28.7 4.4c-2.9-7.4-8.4-13.5-15.6-17.1c-8.4-4.2-18.2-4.4-26.8-.7zM67.9 406.6C44.9 383.7 32 352.5 32 320s12.9-63.7 35.9-86.6l85.5-85.5c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l37.5 37.5c23 23 35.9 54.1 35.9 86.6s-12.9 63.7-35.9 86.6l-85.5 85.5c-23 23-54.1 35.9-86.6 35.9s-63.7-12.9-86.6-35.9L67.9 406.6zM45.3 429.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3l85.5-85.5c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-37.5-37.5C320.3 96.3 281 80 240 80s-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3zM148.7 212.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm128 0c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 409.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faCloudQuestion = {
    prefix: 'fal',
    iconName: 'cloud-question',
    icon: [
      640,
      512,
      [],
      'e492',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM232.7 201.8c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L336 300.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM296 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faFaceWoozy = {
    prefix: 'fal',
    iconName: 'face-woozy',
    icon: [
      512,
      512,
      [],
      'e3a2',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM205.3 120.9c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2zm6.6 118.6l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM327.7 169.9c-4.5 8.9-7.7 22.4-7.7 38.1s3.2 29.2 7.7 38.1c2.2 4.5 4.5 7.2 6.2 8.7c.8 .7 1.4 1 1.7 1.1c.2 .1 .3 .1 .3 .1s.1 0 .1 0s0 0 0 0s0 0 .1 0c0 0 .1 0 .3-.1c.3-.1 .9-.4 1.7-1.1c1.7-1.5 4-4.2 6.2-8.7c4.5-8.9 7.7-22.4 7.7-38.1s-3.2-29.2-7.7-38.1c-2.2-4.5-4.5-7.2-6.2-8.7c-.8-.7-1.4-1-1.7-1.1c-.2-.1-.3-.1-.3-.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0-.1 0-.3 .1c-.3 .1-.9 .4-1.7 1.1c-1.7 1.5-4 4.2-6.2 8.7zm-28.6-14.3c6.6-13.3 18.8-27.6 36.9-27.6s30.3 14.3 36.9 27.6c7.1 14.2 11.1 32.8 11.1 52.4s-3.9 38.2-11.1 52.4C366.3 273.7 354.2 288 336 288s-30.3-14.3-36.9-27.6C291.9 246.2 288 227.6 288 208s3.9-38.2 11.1-52.4z'
      
    ]
  };

  

  
  

  var faKipSign = {
    prefix: 'fal',
    iconName: 'kip-sign',
    icon: [
      384,
      512,
      [],
      'e1c4',
      
      'M80 32c8.8 0 16 7.2 16 16l0 174.4L325.9 35.6c6.9-5.6 16.9-4.5 22.5 2.3s4.5 16.9-2.3 22.5L125.1 240 368 240c8.8 0 16 7.2 16 16s-7.2 16-16 16l-242.9 0 221 179.6c6.9 5.6 7.9 15.6 2.3 22.5s-15.7 7.9-22.5 2.3L96 289.6 96 465c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-193-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0L64 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFileGif = {
    prefix: 'fal',
    iconName: 'file-gif',
    icon: [
      512,
      512,
      [],
      'e645',
      
      'M64 480l112 0 0 32L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM224 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm160-24l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faMasksTheater = {
    prefix: 'fal',
    iconName: 'masks-theater',
    icon: [
      640,
      512,
      [127917,"theater-masks"],
      'f630',
      
      'M371.6 28c1.7 1.2 3.2 2.5 4.5 4c-23 .4-42.7 2.7-59.5 6.3c-26.4-6.7-68.1-10.5-131.4-.1C76.9 56.1 41.9 92.8 32.6 105.7l0 .1c-.1 .8-.2 2.4 .3 5L60.8 274.5c5.4 31.5 19.5 58.8 41.8 76.9c20.8 16.8 46.9 35.3 74 48.2c16.9 8.1 32.9 13.4 47.4 15.5c6.8 10.4 14.5 21.4 23 32.5c-58 4.9-123.3-37.8-165-71.7c-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28zM159 286.9c9.4-7.6 22-15.8 37.8-21.8l-1.7 10.2c-1.5 9-2.5 18.2-2.9 27.5c-4.7 2.8-8.9 5.8-12.4 8.7c-5.7 4.7-11.3 9.9-15.7 15.9c-5 7.2-15.1 9.1-22.5 4.2c-7.4-4.9-9.4-14.8-4.4-22.1c5.9-8.6 13.8-16 21.8-22.6zm-3.9-122.6c3.1-8.2 12.5-12.4 20.9-9.3s12.7 12.3 9.5 20.5c-5.9 15.4-19.8 27.5-37.6 30.4s-35-4-45.7-16.7c-5.7-6.8-4.7-16.8 2.2-22.4s17.2-4.6 22.9 2.1c7.8 9.3 23.5 6.7 27.8-4.6zm230 346.3c-60-9.8-110.5-74.6-140.1-122c-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9C289.5 76.8 344 51.8 460.2 70.9S619.5 131 634.5 152.1c5.8 8.1 6.4 18.2 4.7 28L611.3 343.8c-6.4 37.2-23.5 72.2-53.2 96.2c-43.7 35.4-113.1 80.5-173 70.7zm-58.5-69.5c21.7 21.3 43.5 34.7 63.8 38s45.4-2.4 73-15.6c27.1-13 53.2-31.4 74-48.2c22.3-18.1 36.4-45.4 41.8-76.9l27.9-163.7c.4-2.5 .4-4.2 .3-5l0-.1c-9.4-12.9-44.3-49.7-152.6-67.5s-153.6 5.9-166.7 15.1l0 .1c-.4 .7-1 2.2-1.4 4.8L258.7 285.9c-5.4 31.5-1.1 61.9 14 86.1c14.1 22.6 32.6 48.3 53.9 69.2zm24.7-202.5c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.5-10.1s-11.6 1.3-15.2 5.6zm147.8 85.7l.6-.2c3.1-1 6.1-2 9.1-3.1c3.7-1.4 7.3-2.9 10.9-4.5c6.2-2.8 13.5 1.6 12.4 8.3c-.7 4.2-1.7 8.3-2.8 12.3c-1 3.5-2.2 7-3.6 10.4l-.3 .7-.4 .9c-19.7 47-70.6 76.1-123.9 67.4s-91.7-52.5-94.8-103.3c0-.5-.1-1.1-.1-1.6c-.2-3.6-.1-7.3 .1-11c.2-4.1 .7-8.3 1.4-12.5c1.1-6.6 9.5-8.5 14.5-3.9c2.8 2.6 5.8 5.2 8.8 7.7c2.5 2 5 4 7.6 5.9l.5 .4c22 15.9 48 27.2 76.8 31.9s57.1 2.4 83.2-5.6zm-20.7 37.4c-21.9 3.4-44.8 3.4-67.8-.4s-44.6-11.1-64.2-21.3c10.9 22.9 32.8 40.4 60.2 44.9s53.9-5 71.8-23.2zm1.2-102c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.6-10.1s-11.6 1.3-15.2 5.6z'
      
    ]
  };

  
    var faTheaterMasks = faMasksTheater;
  

  
  

  var faStapler = {
    prefix: 'fal',
    iconName: 'stapler',
    icon: [
      640,
      512,
      [],
      'e5af',
      
      'M448 352l0 32L80 384c-26.5 0-48 21.5-48 48s21.5 48 48 48l512 0c26.5 0 48-21.5 48-48l0-16 0-32 0-48 0-32 0-4.7c0-36.4-20.5-69.6-53.1-85.9L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L11.5 144.7C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L72 242l0 78c0 17.7 14.3 32 32 32l344 0zm-64-32l-280 0 0-70 280 70zm224 64l-128 0 0-48c0-14.7-10-27.5-24.2-31L51.3 203.8C39.9 201 32 190.8 32 179.1c0-5.5 1.8-10.9 5.1-15.3l32.3-43.1C96.2 85 138.3 64 182.9 64c22 0 43.8 5.1 63.5 15L572.6 242.1c21.7 10.8 35.4 33 35.4 57.2l0 4.7 0 32 0 48zM480 416l128 0 0 16c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16s7.2-16 16-16l368 0 32 0z'
      
    ]
  };

  

  
  

  var faD = {
    prefix: 'fal',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      'M48 64c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l112 0c106 0 192-86 192-192s-86-192-192-192L48 64zM0 80C0 53.5 21.5 32 48 32l112 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L48 480c-26.5 0-48-21.5-48-48L0 80z'
      
    ]
  };

  

  
  

  var faBedFront = {
    prefix: 'fal',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      'M64 96l0 40.6c9.4-5.4 20.3-8.6 32-8.6l112 0c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7l112 0c11.7 0 22.6 3.1 32 8.6L448 96c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zm416 96l0 48c19.4 14.6 32 37.8 32 64l0 96 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-96c0-26.2 12.6-49.4 32-64l0-48 0-96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 96zm-32 33.6l0-33.6c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32 14.3-32 32l0 32 160 0c5.5 0 10.8 .6 16 1.6zM240 224l0-32c0-17.7-14.3-32-32-32L96 160c-17.7 0-32 14.3-32 32l0 33.6c5.2-1 10.5-1.6 16-1.6l160 0zm240 80c0-26.5-21.5-48-48-48L80 256c-26.5 0-48 21.5-48 48l0 80 448 0 0-80z'
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faHorizontalRule = {
    prefix: 'fal',
    iconName: 'horizontal-rule',
    icon: [
      640,
      512,
      [8213],
      'f86c',
      
      'M0 256c0-8.8 7.2-16 16-16l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faTrowel = {
    prefix: 'fal',
    iconName: 'trowel',
    icon: [
      512,
      512,
      [],
      'e589',
      
      'M491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-11-11-102 102 75.5 75.5c12.6 12.6 7.5 34.1-9.4 39.7L36.2 506.1C17.5 512.4-.4 494.5 5.9 475.8L92.7 215.2c5.6-16.9 27.1-22 39.7-9.4L208 281.4l102-102-11-11c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zM321.6 138.2c-2.1 2.1-2.1 5.5 0 7.5l44.7 44.7c2.1 2.1 5.5 2.1 7.5 0L469.2 95c14.4-14.4 14.4-37.8 0-52.2s-37.8-14.4-52.2 0l-95.4 95.4zM41.3 470.7L274.4 393 119 237.6 41.3 470.7z'
      
    ]
  };

  

  
  

  var faUmbrella = {
    prefix: 'fal',
    iconName: 'umbrella',
    icon: [
      576,
      512,
      [],
      'f0e9',
      
      'M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32.4C132.8 55.6 18.9 156 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7c10.5 11.7 29.8 2.9 27.8-12.7C557.1 156 443.2 55.6 304 48.4L304 16zm80 278.3c-19.6-32.5-55.2-54.3-96-54.3s-76.4 21.8-96 54.3C172.4 261.8 136.8 240 96 240c-17.6 0-36.7 4.1-53.7 11.8C73.3 153 171 80 288 80s214.7 73 245.7 171.8C516.7 244.1 497.6 240 480 240c-40.8 0-76.4 21.8-96 54.3zM272 306.7l0 139.8c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7C191.1 498 213.8 512 238.6 512c36.1 0 65.4-29.3 65.4-65.4l0-139.8c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7z'
      
    ]
  };

  

  
  

  var faCameraCctv = {
    prefix: 'fal',
    iconName: 'camera-cctv',
    icon: [
      576,
      512,
      ["cctv"],
      'f8ac',
      
      'M128 32L32 200 320 320 512 192 128 32zM100.2 16.1c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9l-85.6-35.7L175 437.7c-2.4 6.2-8.3 10.3-15 10.3L32 448l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 117 0 43.6-114.4-172.9-72c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168zM396.9 345.6l31.4-20.9 83.3 37.9 27.6-66.3-41-18.2 31.5-21 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-3.3 8-13.5 12-21.4 8.4L396.9 345.6z'
      
    ]
  };

  
    var faCctv = faCameraCctv;
  

  
  

  var faGrid2 = {
    prefix: 'fal',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      'M80 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L80 64zM32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM80 320c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zM32 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 64l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM336 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 288c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zm-48 16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z'
      
    ]
  };

  

  
  

  var faSack = {
    prefix: 'fal',
    iconName: 'sack',
    icon: [
      512,
      512,
      [],
      'f81c',
      
      'M310.5 144l-109 0-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32 156.9 32l48.4 70.2 6.7 9.8 87.8 0 6.7-9.8zM0 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 121.9 37.6C111 21.7 122.4 0 141.7 0L370.3 0c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faCircleT = {
    prefix: 'fal',
    iconName: 'circle-t',
    icon: [
      512,
      512,
      [],
      'e124',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0-112 0z'
      
    ]
  };

  

  
  

  var faBuildingColumns = {
    prefix: 'fal',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      'M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192L256 192l224.8 0c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24L34.3 160 256 34.4 477.7 160l-171.1 0zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-128-32 0 0 128-80 0 0-128-32 0 0 128-96 0 0-128-32 0 0 128-80 0 0-128-32 0 0 128zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l432 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L40 416zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480z'
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faPersonMilitaryPointing = {
    prefix: 'fal',
    iconName: 'person-military-pointing',
    icon: [
      576,
      512,
      [],
      'e54a',
      
      'M256 59.1l0 4.9s0 0 0 0l128 0s0 0 0 0l0-26.2L256 59.1zM398.2 95.2c1.2 5.4 1.8 11 1.8 16.8c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.8 .6-11.4 1.8-16.8C231.5 92.4 224 83.1 224 72l0-19.7c0-11.7 8.5-21.7 20.1-23.7l144-24C402.7 2.2 416 13.5 416 28.3L416 72c0 11.1-7.5 20.4-17.8 23.2zm-33 .8l-90.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16zM32 240c0-8.8 7.2-16 16-16l192 0 16 0 88 0 .3 0c40.2 0 77.3 21.5 97.2 56.4L541.9 456.1c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L416 300.2 416 464c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-31.6c0-.2 0-.5 0-.7L224 256 48 256c-8.8 0-16-7.2-16-16zM256 464c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-16-128 0 0 16zM384 296c0-4.3-.7-8.5-1.9-12.4L273.8 416 384 416l0-120zm-40-40l-88 0 0 131.2L360.4 259.5c-5-2.3-10.6-3.5-16.4-3.5z'
      
    ]
  };

  

  
  

  var faUsersGear = {
    prefix: 'fal',
    iconName: 'users-gear',
    icon: [
      640,
      512,
      ["users-cog"],
      'f509',
      
      'M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM261.3 384c-54.2 0-98.4 42.5-101.2 96l224.8 0c.7 1 1.4 1.9 2.2 2.8c14.6 18.5 35.8 25.2 55.4 23.1c.9 2 1.9 4.1 3 6l-290.9 0c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352l98.7 0c.9 11.9 5.3 22.9 12 32c0 0 0 0 0 0l-110.7 0zM528 224l-15 0-65 0c0-11-1.4-21.8-4-32l84 0c55.2 0 101.1 40 110.3 92.6c-11.4-14.2-26.8-21.3-42.3-22.7c-14.1-22.7-39.3-37.9-68-37.9zM387.1 285.2c-4.3 5.5-8.3 11.3-11.9 17.4c-15.6 11-34.7 17.5-55.2 17.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 16.7-4.3 32.4-11.8 46.1c-6.3 3.7-12.1 8.7-17.1 15.1zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM432 80a80 80 0 1 1 160 0A80 80 0 1 1 432 80zM196 192c-2.6 10.2-4 21-4 32l-80 0c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112l84 0zm188 32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm116.9 64.7c-.3 16-9.3 29-22 36.4c-12.8 7.4-28.5 8.6-42.4 .9c-4.9 6.4-8.9 13.4-12 20.8c13.7 8.2 20.5 22.4 20.5 37.2s-6.9 29-20.5 37.2c3.1 7.4 7.2 14.4 12 20.8c13.9-7.7 29.6-6.6 42.4 .9c12.7 7.4 21.7 20.3 22 36.4c7.9 1 16.2 1 24 0c.3-16 9.3-29 22-36.4c12.8-7.4 28.5-8.6 42.4-.9c4.9-6.4 8.9-13.4 12-20.8c-13.7-8.2-20.5-22.4-20.5-37.2s6.9-29 20.5-37.2c-3.1-7.4-7.2-14.4-12-20.8c-13.9 7.7-29.6 6.6-42.4-.9c-12.7-7.4-21.7-20.3-22-36.4c-7.9-1-16.2-1-24 0zm-6.1-31.5c11.8-1.7 24.3-1.7 36.2 0c16.2 2.3 25.9 16.5 25.9 30.7c0 3.6 1.8 7 6.1 9.5c4.2 2.4 7.9 2.3 11.1 .4c12.2-7.1 29.4-5.8 39.5 7.1c7.5 9.5 13.6 20.1 18.2 31.4c6.1 15.2-1.4 30.7-13.6 37.7c-3.2 1.8-5.2 5.1-5.2 9.9s2 8.1 5.2 9.9c12.2 7.1 19.7 22.6 13.6 37.7c-4.5 11.3-10.7 21.9-18.1 31.4c-10.1 12.8-27.3 14.1-39.5 7.1c-3.2-1.8-6.9-2-11.1 .4c-4.3 2.5-6.1 5.9-6.1 9.5c0 14.1-9.7 28.4-25.9 30.7c-11.8 1.7-24.3 1.7-36.2 0c-16.2-2.3-25.9-16.5-25.9-30.7c0-3.6-1.8-7-6.1-9.5c-4.2-2.4-7.9-2.3-11.1-.4c-12.2 7.1-29.4 5.8-39.5-7.1c-7.5-9.5-13.6-20.1-18.1-31.4c-6.1-15.2 1.4-30.7 13.6-37.7c3.2-1.8 5.2-5.1 5.2-9.9s-2-8.1-5.2-9.9c-12.2-7.1-19.7-22.6-13.6-37.7c4.5-11.3 10.7-21.9 18.2-31.4c10.1-12.8 27.3-14.1 39.5-7.1c3.2 1.8 6.9 2 11.1-.4c4.3-2.5 6.1-5.9 6.1-9.5c0-14.1 9.7-28.4 25.9-30.7zm107.3 89.1s0 0 0 0s0 0 0 0s0 0 0 0zM512 368a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 16a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faUsersCog = faUsersGear;
  

  
  

  var faMagnifyingGlassDollar = {
    prefix: 'fal',
    iconName: 'magnifying-glass-dollar',
    icon: [
      512,
      512,
      ["search-dollar"],
      'f688',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm16-312c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0s0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z'
      
    ]
  };

  
    var faSearchDollar = faMagnifyingGlassDollar;
  

  
  

  var faX = {
    prefix: 'fal',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      'M380.2 58.3c5.7-6.7 4.9-16.8-1.9-22.5s-16.8-4.9-22.6 1.9L192 231.2 28.2 37.7c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5L171 256 3.8 453.7c-5.7 6.7-4.9 16.8 1.9 22.6s16.8 4.9 22.5-1.9L192 280.8 355.8 474.3c5.7 6.7 15.8 7.6 22.6 1.9s7.6-15.8 1.9-22.6L213 256 380.2 58.3z'
      
    ]
  };

  

  
  

  var faSkullCow = {
    prefix: 'fal',
    iconName: 'skull-cow',
    icon: [
      640,
      512,
      [],
      'f8de',
      
      'M55.6 1.9c6.8 3.7 10 11.8 7.5 19.1L52 54.5c-2.5 7.5-3.4 15.4-2.6 23.2C52.3 106.3 76.3 128 105 128l79.4 0C202 108.4 227.6 96 256 96l128 0c28.4 0 54 12.4 71.6 32l79.4 0c28.7 0 52.7-21.7 55.6-50.3c.8-7.8-.1-15.8-2.6-23.2L576.8 21.1c-2.5-7.4 .7-15.4 7.5-19.1s15.3-2 20.1 4.1l7.5 9.3c18.2 22.7 28 50.9 28 80l0 16.7c0 70.7-57.3 128-128 128l-32 0 0 48c0 41.8-26.7 77.3-64 90.5l-26.4 87.9c-8.1 27.1-33 45.6-61.3 45.6l-16.8 0c-28.3 0-53.2-18.5-61.3-45.6L224 378.5c-37.3-13.2-64-48.7-64-90.5l0-48-32 0C57.3 240 0 182.7 0 112L0 95.3C0 66.2 9.9 38 28 15.3L35.5 6C40.3 0 48.8-1.8 55.6 1.9zM480 208l32 0c49.7 0 90.6-37.8 95.5-86.3C591.6 145 564.9 160 535 160l-60.4 0c3.5 10 5.5 20.8 5.5 32l0 16zM105 160c-29.9 0-56.6-15-72.5-38.3C37.4 170.2 78.3 208 128 208l32 0 0-16c0-11.2 1.9-22 5.5-32L105 160zM234.6 348.4c9.6 3.4 17 11.2 20 21L281 457.2c4.1 13.5 16.5 22.8 30.7 22.8l16.8 0c14.1 0 26.6-9.3 30.7-22.8l26.4-87.9c2.9-9.8 10.4-17.6 20-21c24.9-8.8 42.6-32.6 42.6-60.4l0-96c0-35.3-28.7-64-64-64l-128 0c-35.3 0-64 28.7-64 64l0 96c0 27.8 17.7 51.5 42.6 60.4zM232 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faComputerSpeaker = {
    prefix: 'fal',
    iconName: 'computer-speaker',
    icon: [
      640,
      512,
      [],
      'f8b2',
      
      'M64 384c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l229.5 0c4.2-11.9 10.7-22.8 19-32L64 32C28.7 32 0 60.7 0 96L0 352c0 35.3 28.7 64 64 64l224 0 0-32L64 384zm48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l200.4 0c-8.3-9.2-14.8-20.1-19-32L112 448zM576 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32l192 0zM384 32c-35.3 0-64 28.7-64 64l0 320c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L384 32zm96 352a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM496 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM480 96a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faFerrisWheel = {
    prefix: 'fal',
    iconName: 'ferris-wheel',
    icon: [
      512,
      512,
      [],
      'e174',
      
      'M272 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM211.8 66.7c-20.4 4.8-39.6 12.9-56.9 23.7c3.3 6.5 5.2 13.9 5.2 21.7c0 7.4-1.7 14.4-4.7 20.7l68.2 68.2c5.1-3 10.6-5.3 16.5-6.8l0-100.7c-12.7-4.5-23-14.2-28.2-26.6zM272 194c5.9 1.5 11.4 3.8 16.5 6.8l68.2-68.2c-3-6.3-4.7-13.3-4.7-20.7c0-7.8 1.9-15.2 5.2-21.7c-17.3-10.8-36.5-18.8-56.9-23.7C295 79 284.7 88.8 272 93.3L272 194zm39.1 29.5c3 5.1 5.3 10.6 6.8 16.5l100.7 0c4.3-12.1 13.3-22 24.9-27.5c-4.5-20.5-12.2-39.8-22.7-57.3c-6.3 3.1-13.4 4.8-20.9 4.8c-7.4 0-14.4-1.7-20.7-4.7l-68.2 68.2zM418.7 272L318 272c-4.6 17.9-16.7 32.7-32.8 41l81.4 176.3c2.3 5 1.9 10.7-1 15.3s-8 7.4-13.5 7.4l-192 0c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3L226.8 313c-16.1-8.2-28.2-23.1-32.8-41L93.3 272c-4.2 11.8-12.8 21.5-23.9 27c4.9 20.4 13.1 39.5 24 56.8c5.7-2.4 12-3.7 18.6-3.7c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48c0-8.1 2-15.7 5.5-22.3c-14.9-22.4-26-47.7-32.1-74.8C16 298 0 278.9 0 256c0-22.5 15.5-41.4 36.3-46.6C42 181.2 53 154.8 68.1 131.5c-2.7-6-4.1-12.6-4.1-19.5c0-26.5 21.5-48 48-48c6.7 0 13 1.4 18.8 3.8c23.6-15.9 50.4-27.5 79.2-33.5C215.9 14.5 234.3 0 256 0s40.1 14.5 46 34.3c28.8 6 55.6 17.6 79.2 33.5C387 65.4 393.3 64 400 64c26.5 0 48 21.5 48 48c0 6.9-1.5 13.6-4.1 19.5c15.2 23.3 26.1 49.7 31.8 77.9c20.9 5.2 36.3 24.1 36.3 46.6c0 22.9-16 42-37.4 46.8c-6.1 27.1-17.1 52.4-32.1 74.8c3.5 6.7 5.5 14.3 5.5 22.3c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c6.6 0 12.9 1.3 18.6 3.7c10.9-17.3 19.1-36.4 24-56.8c-11.1-5.5-19.7-15.2-23.9-27zM194 240c1.5-5.9 3.8-11.4 6.8-16.5l-68.2-68.2c-6.3 3-13.3 4.7-20.7 4.7c-7.5 0-14.6-1.7-20.9-4.8C80.6 172.7 72.9 192 68.4 212.5C79.9 218 89 227.9 93.3 240L194 240zm254 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64-144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-89.8L185 480l142 0L256 326.2zm0-38.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fal',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 47.5c-6.3 .1-12.6 .3-18.8 .9c-24 2-47.9 7.8-67.4 20.6C37.7 98.1 23.2 118 17.9 146c-3.8 20.3-1.9 38.2 5.7 53.7C31 215 43.1 226.5 57.1 235.4c26.7 17 63.6 26.7 97.2 35.5l1.7 .4c35.7 9.4 67.8 17.9 89.8 31.9c10.6 6.8 17.8 14.2 21.9 22.6c4 8.3 5.8 19 3 33.8c-3.9 20.7-18.4 36.4-42.9 46c-24.9 9.8-59.1 12.6-98 7c-24.4-3.6-61-12.1-91.3-25.2c-8.1-3.5-17.5 .2-21 8.4s.2 17.5 8.4 21c33.6 14.5 73.1 23.5 99.3 27.4c0 0 .1 0 .1 0c6.4 .9 12.7 1.6 18.9 2.1l0 49.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48.6c23.2-.7 44.8-4.7 63.4-11.9c32-12.5 56.2-35.7 62.7-69.9c3.8-20.3 1.9-38.2-5.7-53.7c-7.4-15.3-19.6-26.8-33.5-35.6c-26.7-17-63.6-26.7-97.2-35.5l-1.7-.4c-35.7-9.4-67.8-17.9-89.8-31.9c-10.6-6.8-17.8-14.2-21.9-22.6c-4-8.3-5.8-19-3-33.8c3.6-19.3 13.1-31.8 26-40.2c13.4-8.8 31.5-13.7 52.6-15.5c42.3-3.5 91.3 6 124.3 14c8.6 2.1 17.2-3.2 19.3-11.8s-3.2-17.2-11.8-19.3c-21.9-5.3-52.1-11.7-83.8-14.4L176 16z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faCircleWaveformLines = {
    prefix: 'fal',
    iconName: 'circle-waveform-lines',
    icon: [
      512,
      512,
      ["waveform-circle"],
      'e12d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 144l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faWaveformCircle = faCircleWaveformLines;
  

  
  

  var faFaceNoseSteam = {
    prefix: 'fal',
    iconName: 'face-nose-steam',
    icon: [
      576,
      512,
      [],
      'e382',
      
      'M64 256C64 132.3 164.3 32 288 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9c-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C544 114.6 429.4 0 288 0S32 114.6 32 256c0 11.6 .8 22.9 2.3 34.1c1.2 8.8 9.2 14.9 18 13.7s14.9-9.2 13.7-18c-1.3-9.8-2-19.7-2-29.9zM243.2 475.5c-8.7-1.8-17.1 3.8-18.9 12.5s3.8 17.1 12.5 18.9c16.6 3.4 33.7 5.1 51.2 5.1s34.6-1.8 51.2-5.1c8.7-1.8 14.3-10.2 12.5-18.9s-10.2-14.3-18.9-12.5c-14.5 2.9-29.5 4.5-44.8 4.5s-30.3-1.5-44.8-4.5zm-7.2-163.3c3.8-6.3 2.8-14.4-2.4-19.5s-13.2-6.2-19.5-2.4l-67.1 40.3c-1.1-1.4-2.3-2.8-3.7-4.1c-18.7-18.7-49.1-18.7-67.9 0c-2.7 2.7-5 5.6-6.9 8.8c-13.7-1.2-27.8 3.4-38.3 13.9c-17.9 17.9-18.7 46.4-2.5 65.2c-10.3 23.4-5.8 51.8 13.4 70.9s47.5 23.6 70.9 13.4c18.9 16.2 47.3 15.4 65.2-2.5c10.5-10.5 15.1-24.6 13.9-38.3c3.1-1.9 6.1-4.2 8.8-6.9c18.7-18.7 18.7-49.1 0-67.9c-1.3-1.3-2.7-2.5-4.1-3.7l40.3-67.1zm124.3-21.1c-6.3-3.8-14.4-2.8-19.5 2.4s-6.2 13.3-2.4 19.5l40.3 67.1c-1.4 1.1-2.8 2.4-4.1 3.7c-18.7 18.7-18.7 49.1 0 67.9c2.7 2.7 5.6 5 8.8 6.9c-1.2 13.7 3.4 27.8 13.9 38.3c17.9 17.9 46.4 18.7 65.2 2.5c23.4 10.3 51.8 5.8 70.9-13.4s23.6-47.5 13.4-70.9c16.2-18.9 15.4-47.3-2.5-65.2c-10.5-10.5-24.6-15.1-38.3-13.9c-1.9-3.1-4.2-6.1-6.9-8.8c-18.7-18.7-49.1-18.7-67.9 0c-1.3 1.3-2.5 2.7-3.7 4.1l-67.1-40.3zM148.6 366.8l26.9-16.2-16.2 26.9c-2.6 4.4-3 9.8-1 14.5s6.1 8.2 11.1 9.3c2.8 .7 5.4 2.1 7.6 4.3c6.2 6.2 6.2 16.4 0 22.6c-2.3 2.3-5.2 3.8-8.2 4.4c-4.9 1-9 4.1-11.2 8.5s-2.3 9.6-.1 14.1c2.9 6 1.8 13.3-3.1 18.2c-6.2 6.2-16.4 6.2-22.6 0c-1-1-1.9-2.2-2.6-3.4c-2.3-4-6.2-6.8-10.7-7.7s-9.2 .2-12.9 3c-12.5 9.6-30.6 8.7-42.1-2.8s-12.4-29.5-2.8-42.1c2.8-3.7 3.9-8.4 3-12.9s-3.7-8.4-7.7-10.7c-1.2-.7-2.3-1.5-3.4-2.6c-6.2-6.2-6.2-16.4 0-22.6c4.9-4.9 12.3-6 18.2-3.1c4.5 2.1 9.7 2.1 14.1-.1s7.6-6.4 8.5-11.2c.6-3 2-5.8 4.4-8.2c6.2-6.2 16.4-6.2 22.6 0c2.2 2.2 3.6 4.8 4.3 7.6c1.2 5 4.6 9.1 9.3 11.1s10.1 1.6 14.5-1zm266.2 11.7l-16.2-26.9 26.9 16.2c4.4 2.6 9.8 3 14.5 1s8.2-6.1 9.3-11.1c.7-2.8 2.1-5.4 4.3-7.6c6.2-6.2 16.4-6.2 22.6 0c2.3 2.3 3.8 5.2 4.4 8.2c1 4.9 4.1 9 8.5 11.2s9.6 2.3 14.1 .1c6-2.9 13.3-1.8 18.2 3.1c6.2 6.2 6.2 16.4 0 22.6c-1 1-2.2 1.9-3.4 2.6c-4 2.3-6.8 6.2-7.7 10.7s.2 9.2 3 12.9c9.6 12.5 8.7 30.6-2.8 42.1s-29.5 12.4-42.1 2.8c-3.7-2.8-8.4-3.9-12.9-3s-8.4 3.7-10.7 7.7c-.7 1.2-1.5 2.3-2.6 3.4c-6.2 6.2-16.4 6.2-22.6 0c-4.9-4.9-6-12.3-3.1-18.2c2.1-4.5 2.1-9.7-.1-14.1s-6.4-7.6-11.2-8.5c-3-.6-5.8-2-8.2-4.4c-6.2-6.2-6.2-16.4 0-22.6c2.2-2.2 4.9-3.6 7.6-4.3c5-1.2 9.1-4.6 11.1-9.3s1.6-10.1-1-14.5zM128 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm192 0c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm101.1-96.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1zm-266.1 0c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2z'
      
    ]
  };

  

  
  

  var faTurkishLiraSign = {
    prefix: 'fal',
    iconName: 'turkish-lira-sign',
    icon: [
      384,
      512,
      ["try","turkish-lira"],
      'e2bb',
      
      'M80 32c8.8 0 16 7.2 16 16l0 77.1L251.6 80.6c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 158.4l0 62.7 155.6-44.5c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 254.4 96 448l95.2 0C277 448 347.5 380.4 351 294.7l1-23.3c.4-8.8 7.8-15.7 16.7-15.3s15.7 7.8 15.3 16.7L383 296c-4.3 102.8-88.9 184-191.8 184L80 480c-8.8 0-16-7.2-16-16l0-200.5-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 230.2l0-62.7-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 134.2 64 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faTry = faTurkishLiraSign;
  
    var faTurkishLira = faTurkishLiraSign;
  

  
  

  var faPrint = {
    prefix: 'fal',
    iconName: 'print',
    icon: [
      512,
      512,
      [9113,128424,128438],
      'f02f',
      
      'M96 160l-32 0 0-96C64 28.7 92.7 0 128 0L357.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3l0 69.5-32 0 0-69.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4L128 32c-17.7 0-32 14.3-32 32l0 96zm352 64L64 224c-17.7 0-32 14.3-32 32l0 128 32 0 0-32c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 32 32 0 0-128c0-17.7-14.3-32-32-32zm0 192l0 64c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-64-32 0c-17.7 0-32-14.3-32-32L0 256c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 128c0 17.7-14.3 32-32 32l-32 0zM96 352l0 128 320 0 0-128L96 352zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCommentXmark = {
    prefix: 'fal',
    iconName: 'comment-xmark',
    icon: [
      512,
      512,
      ["comment-times"],
      'f4b5',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM180.7 164.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 240l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 262.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 240l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 217.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faCommentTimes = faCommentXmark;
  

  
  

  var faFaceSmileRelaxed = {
    prefix: 'fal',
    iconName: 'face-smile-relaxed',
    icon: [
      512,
      512,
      [],
      'e392',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z'
      
    ]
  };

  

  
  

  var faArrowsSpin = {
    prefix: 'fal',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      'M257.1 79.5c-11.3 0-22.4 1.1-33.1 3.1l0-32.5c10.8-1.7 21.9-2.6 33.1-2.6c53.8 0 102.8 20.4 139.7 53.9l27.1-27.1c15.1-15.1 41-4.4 41 17l0 86.1c0 8.8-7.2 16-16 16l-86.1 0c-21.4 0-32.1-25.9-17-41l28.3-28.3c-31.1-27.7-72.1-44.6-117-44.6zM124.2 140.2c-26.8 30.9-43.1 71.2-43.1 115.3c0 11.1 1 21.9 3 32.5l-32.5 0c-1.7-10.6-2.5-21.4-2.5-32.5c0-53 19.8-101.3 52.4-138L74.3 90.3c-15.1-15.1-4.4-41 17-41l86.1 0c8.8 0 16 7.2 16 16l0 86.1c0 21.4-25.9 32.1-41 17l-28.2-28.2zM433.1 255.5c0-10.8-1-21.3-2.8-31.5l32.4 0c1.6 10.3 2.4 20.8 2.4 31.5c0 53.8-20.4 102.8-53.9 139.7l28.7 28.7c15.1 15.1 4.4 41-17 41l-86.1 0c-8.8 0-16-7.2-16-16l0-86.1c0-21.4 25.8-32.1 41-17l26.7 26.7c27.7-31.1 44.6-72.1 44.6-117zM288 428.8l0 32.4c-10.1 1.5-20.4 2.3-30.9 2.3c-53 0-101.3-19.8-138-52.4L90.3 439.9c-15.1 15.1-41 4.4-41-17l0-86.1c0-8.8 7.2-16 16-16l86.1 0c21.4 0 32.1 25.9 17 41l-26.6 26.6c30.9 26.8 71.2 43.1 115.3 43.1c10.5 0 20.8-.9 30.9-2.7zm115.6 4.1l-50.7-50.7 0 50.7 50.7 0zM161.4 132.1l0-50.7-50.7 0 50.7 50.7zm-80 271.5l50.7-50.7-50.7 0 0 50.7zM382.2 161.4l50.7 0 0-50.7-50.7 50.7z'
      
    ]
  };

  

  
  

  var faExclamation = {
    prefix: 'fal',
    iconName: 'exclamation',
    icon: [
      128,
      512,
      [10069,10071,61738],
      '21',
      
      'M80 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 304c0 8.8 7.2 16 16 16s16-7.2 16-16L80 48zM64 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTentArrowsDown = {
    prefix: 'fal',
    iconName: 'tent-arrows-down',
    icon: [
      576,
      512,
      [],
      'e581',
      
      'M203.9 117.3c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48L128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 148.1-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zm352 0c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48L480 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 148.1-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zM297.5 163.1c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512l343.1 0c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM124.5 316.8L272 207.7l0 112 0 .5L272 480l-155.6 0c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8zM304 315.4l0-107.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1l-53.7 0-.3-.4L304 315.4zM304 480l0-103.8L368.2 480 304 480z'
      
    ]
  };

  

  
  

  var faPlane = {
    prefix: 'fal',
    iconName: 'plane',
    icon: [
      576,
      512,
      [],
      'f072',
      
      'M562.7 221.2c7.6 9.5 13.3 21.3 13.3 34.8c0 26.9-21.6 47.1-41.8 59.2c-21.1 12.7-47.3 20.8-67.9 20.8l-100.5 0L279.1 487.8c-8.5 15-24.5 24.2-41.7 24.2l-56.2 0c-21.3 0-36.6-20.3-30.8-40.8L189.1 336 136 336 97.6 387.2C91.6 395.3 82.1 400 72 400l-42 0c-16.6 0-30-13.4-30-30c0-2.8 .4-5.6 1.2-8.2L31.4 256 1.2 150.3C.4 147.6 0 144.8 0 142c0-16.6 13.4-30 30-30l42 0c10.1 0 19.6 4.7 25.6 12.8L136 176l53.1 0L150.4 40.8C144.6 20.3 160 0 181.2 0l56.2 0c17.2 0 33.1 9.2 41.7 24.2L365.9 176l100.5 0c20.7 0 46.9 8.4 68 21.2c10.7 6.5 20.8 14.5 28.4 24zm-45 3.3c-17.3-10.5-37.9-16.6-51.3-16.6l-109.7 0c-5.7 0-11-3.1-13.9-8.1L251.3 40.1l13.9-7.9-13.9 7.9c-2.8-5-8.2-8.1-13.9-8.1l-56.2 0 44.5 155.6c1.4 4.8 .4 10-2.6 14s-7.8 6.4-12.8 6.4L128 208c-5 0-9.8-2.4-12.8-6.4L72 144l-39.4 0L63.4 251.6c.8 2.9 .8 5.9 0 8.8L32.6 368 72 368l43.2-57.6c3-4 7.8-6.4 12.8-6.4l82.3 0c5 0 9.8 2.4 12.8 6.4s4 9.2 2.6 14L181.2 480l56.2 0c5.7 0 11-3.1 13.9-8.1l91.4-159.9c2.9-5 8.2-8.1 13.9-8.1l109.7 0c13.6 0 34.2-5.9 51.4-16.2C535.8 276.9 544 265.1 544 256c0-4.1-1.7-9-6.3-14.8c-4.6-5.8-11.5-11.5-20-16.7z'
      
    ]
  };

  

  
  

  var faFaceSadTear = {
    prefix: 'fal',
    iconName: 'face-sad-tear',
    icon: [
      512,
      512,
      [128546,"sad-tear"],
      'f5b4',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM160 300.4c-5.5 6.9-11 14.3-16.2 22c-11.4 17.1-15.8 29-15.8 34.9c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0-5.9-4.4-17.8-15.8-34.9c-5.1-7.7-10.7-15.1-16.2-22zm-8.6-40.3c4.3-5.5 12.8-5.5 17.1 0c1.6 2 3.3 4.1 5.2 6.3c18.9 23 50.3 61.2 50.3 90.8c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-29.2 30.8-66.9 49.6-90c0 0 0 0 0 0s0 0 0 0c2.1-2.6 4.1-5 5.8-7.2zM256 320c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16s7.2-16 16-16zM359.6 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faSadTear = faFaceSadTear;
  

  
  

  var faBlockBrickFire = {
    prefix: 'fal',
    iconName: 'block-brick-fire',
    icon: [
      640,
      512,
      ["firewall"],
      'e3dc',
      
      'M168 64l0 64 72 0 32 0 72 0 0-64L168 64zm-32 0L96 64C78.3 64 64 78.3 64 96l0 32 72 0 0-64zM64 160l0 80 72 0 32 0 72 0 0-80L64 160zm0 192l72 0 0-80-72 0 0 80zm0 32l0 32c0 17.7 14.3 32 32 32l144 0 0-64-72 0-32 0-72 0zm104-32l120 0c.1 10.9 1.1 21.6 3 32l-19 0 0 64 42.4 0c6.6 11.4 14.4 22.2 23.2 32L96 480c-35.3 0-64-28.7-64-64L32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 48.6c-1.7-1.5-3.3-3.1-5-4.6c-7.7-7-17.2-10.9-27-11.8L448 96c0-17.7-14.3-32-32-32l-40 0 0 64 0 32-104 0 0 80 54.9 0c-.6 .9-1.1 1.8-1.7 2.7c-5.8 9.5-11.3 19.3-16.2 29.3l-141 0 0 80zM447.1 193.1c-21.7 19.8-45.3 44.8-63.7 72.3c-19 28.5-31.4 58.3-31.4 86.7c0 33.7 12.7 64.2 33.6 87c-1.1-5.4-1.6-10.9-1.6-16.6c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0c23.6 17.7 87.4 70.8 87.4 128.2c0 5.5-.5 10.9-1.6 16.2C595.3 416 608 385.7 608 352.2c0-22.6-8.5-48-22.2-72.6c-13-23.4-30.1-44.9-46.7-60.7l-21 23.7c-3 3.3-7.2 5.3-11.7 5.4s-8.8-1.7-11.9-5l-47.4-49.8zM480 480c2.4 0 4.8-.1 7.1-.2c33.7-3.3 56.9-29.4 56.9-57.3c0-17.4-10.1-37.7-27.4-58.5c-12.1-14.5-25.8-27-36.6-35.8c-10.7 8.8-24.5 21.3-36.6 35.8c-17.3 20.7-27.4 41.1-27.4 58.5c0 27.9 23.3 54 57 57.3c2.3 .1 4.7 .2 7 .2zM320 352.2c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c11.1-10.1 28.2-10 39.3 .1c.3 .3 .6 .5 .8 .8l37.9 39.9L518 194.5c.4-.4 .7-.8 1.1-1.2c11.2-10.3 28.5-10.3 39.7 .1c19.7 18.3 39.8 43.2 55 70.6C629 291.2 640 322.2 640 352.2c0 85.6-66.4 154.9-150.8 159.6c-3 .3-6.1 .4-9.2 .4c-3.1 0-6.1-.1-9.1-.4c-85.2-4.6-150.9-74-150.9-159.6z'
      
    ]
  };

  
    var faFirewall = faBlockBrickFire;
  

  
  

  var faUserInjured = {
    prefix: 'fal',
    iconName: 'user-injured',
    icon: [
      448,
      512,
      [],
      'f728',
      
      'M320 128c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16l62.7 0 126.7 0c.9 5.2 1.3 10.5 1.3 16zM307.2 80l-69.5 0 39.8-31.8c12.2 8.2 22.4 19.1 29.8 31.8zM243.8 34L186.4 80l-45.5 0c16.6-28.7 47.6-48 83.2-48c6.8 0 13.4 .7 19.8 2zM352 128A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM32 480c.5-33.7 12.4-64.6 32-89l0 89-32 0zm64 0l0-118.7c12.9-8.8 27.3-15.6 42.7-19.9L226.9 480 96 480zm224-32c0 17.7-14.3 32-32 32l-23.2 0-40.7-64 63.9 0c17.7 0 32 14.3 32 32zM80 512l80 0 16 0 112 0 130.3 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512L80 512zm336-32l-72.5 0c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64l-84.3 0-30.5-47.9c1.7-.1 3.4-.1 5.1-.1l91.4 0c80 0 145 64.3 146.3 144z'
      
    ]
  };

  

  
  

  var faTableCellsRowUnlock = {
    prefix: 'fal',
    iconName: 'table-cells-row-unlock',
    icon: [
      640,
      512,
      [],
      'e691',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64 448 0 0-64c0-17.7-14.3-32-32-32L64 64zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 40.6 0c-5.4 9.4-8.6 20.3-8.6 32l-32 0 0 96zM192 320l128 0 0-128-128 0 0 128zm288-48l0 48 48 0 48 0 32 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480l160 0 0-128-160 0 0 128z'
      
    ]
  };

  

  
  

  var faBrainCircuit = {
    prefix: 'fal',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      'M192 32c26.5 0 48 21.5 48 48l0 48-27.3 0c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24l27.3 0 0 112-48 0c-24.9 0-45.4 19-47.8 43.2C130 321.3 120 335.5 120 352c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.2-9.6-30.1-23.4-36.4c1.9-6.7 8.1-11.6 15.4-11.6l48 0 0 128c0 26.5-21.5 48-48 48c-20.4 0-37.9-12.8-44.8-30.8c-2.7-7.1-10.1-11.3-17.6-10c-3.1 .5-6.3 .8-9.5 .8c-30.9 0-56-25.1-56-56c0-7.8 1.6-15.2 4.4-21.8c3.1-7.2 .4-15.7-6.3-19.8C44 331 32 310.9 32 288c0-19.1 8.4-36.3 21.7-48.1c4.8-4.2 6.6-10.9 4.6-17c-1.5-4.7-2.4-9.7-2.4-15c0-20.4 12.8-38 30.9-44.9c7.3-2.8 11.5-10.4 10-18c-.6-3-.9-6-.9-9.2c0-22.4 15.4-41.3 36.2-46.5c6.6-1.7 11.4-7.3 12-14C146.5 51.1 167 32 192 32zm80 128l48 0c8.8 0 16 7.2 16 16l0 11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-11.3c0-26.5-21.5-48-48-48l-48 0 0-48c0-26.5 21.5-48 48-48c25 0 45.5 19.1 47.8 43.4c.6 6.7 5.4 12.4 12 14C400.6 94.7 416 113.6 416 136c0 3.1-.3 6.2-.9 9.2c-1.5 7.6 2.7 15.2 10 18C443.2 170 456 187.6 456 208c0 5.2-.8 10.3-2.4 15c-2 6.1-.2 12.8 4.6 17C471.6 251.7 480 268.9 480 288c0 22.9-12 43-30.2 54.3c-6.7 4.2-9.3 12.6-6.3 19.8c2.8 6.7 4.4 14.1 4.4 21.8c0 30.9-25.1 56-56 56c-3.3 0-6.5-.3-9.5-.8c-7.5-1.3-14.9 2.9-17.6 10c-6.9 18-24.4 30.8-44.8 30.8c-26.5 0-48-21.5-48-48l0-48 59.3 0c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24L272 352l0-192zM192 512c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c29.6 0 55.5-16.1 69.3-40c.9 0 1.8 0 2.7 0c48.6 0 88-39.4 88-88c0-7.6-1-15-2.8-22c21.2-17.6 34.8-44.2 34.8-74c0-25.1-9.6-48-25.4-65c.9-4.9 1.4-9.9 1.4-15c0-29.6-16.1-55.5-40-69.3c0-.9 0-1.8 0-2.7c0-33.6-20.7-62.4-50.1-74.2C389.7 26.4 357.9 0 320 0c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-37.9 0-69.7 26.4-77.9 61.8C84.7 73.6 64 102.4 64 136c0 .9 0 1.8 0 2.7C40.1 152.5 24 178.4 24 208c0 5.1 .5 10.1 1.4 15C9.6 240 0 262.9 0 288c0 29.8 13.6 56.4 34.8 74C33 369 32 376.4 32 384c0 48.6 39.4 88 88 88c.9 0 1.8 0 2.7 0c13.8 23.9 39.7 40 69.3 40zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSkiBootSki = {
    prefix: 'fal',
    iconName: 'ski-boot-ski',
    icon: [
      640,
      512,
      [],
      'e3cd',
      
      'M415.6 19.4c1.9-8.6-3.7-17.1-12.3-19s-17.1 3.7-19 12.3L380.2 32 168 32c-7.6 0-14.2 5.3-15.7 12.8L88.2 358.4c-6.1 29.8 16.7 57.6 47 57.6L432 416c26.5 0 48-21.5 48-48l0-52.2c0-18.2-10.3-34.8-26.5-42.9l-83.2-41.6L415.6 19.4zM279.2 64l94.2 0-20.6 96c-.3 0-.5 0-.8 0l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l41.9 0-6.9 32L288 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l60.2 0 90.9 45.5c5.4 2.7 8.8 8.3 8.8 14.3l0 52.2c0 8.8-7.2 16-16 16l-296.8 0c-10.1 0-17.7-9.3-15.7-19.2l25.2-123.3c43.6-20 107.6-67.2 134.4-177.5zm-33 0c-20.3 76-60 115.7-93 136.6L181.1 64l65.1 0zM640 416c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l528 0c53 0 96-43 96-96z'
      
    ]
  };

  

  
  

  var faKeyboardBrightnessLow = {
    prefix: 'fal',
    iconName: 'keyboard-brightness-low',
    icon: [
      640,
      512,
      [],
      'e1c1',
      
      'M320 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zM184 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBenchTree = {
    prefix: 'fal',
    iconName: 'bench-tree',
    icon: [
      640,
      512,
      [],
      'e2e7',
      
      'M575.2 106.1c-1.9 11.9 3.1 23.9 12.9 30.9C600.2 145.8 608 160 608 176c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48c0-16 7.8-30.2 19.9-38.9c9.8-7.1 14.7-19 12.9-30.9c-.5-3.3-.8-6.7-.8-10.1c0-35.3 28.7-64 64-64s64 28.7 64 64c0 3.5-.3 6.8-.8 10.1zm31.6 5c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176c0 44.2 35.8 80 80 80l32 0 0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240 32 0c44.2 0 80-35.8 80-80c0-26.7-13.1-50.3-33.2-64.9zM64 224l256 0 0 64-16 0L80 288l-16 0 0-64zm0 96l0 48-16 0-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 16 0 224 0 16 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0-16 0 0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32zm224 0l0 48L96 368l0-48 192 0z'
      
    ]
  };

  

  
  

  var faCircle3 = {
    prefix: 'fal',
    iconName: 'circle-3',
    icon: [
      512,
      512,
      [],
      'e0f0',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l100.7 0-79.2 67.9c-5.1 4.4-6.9 11.5-4.6 17.7s8.4 10.4 15.1 10.4l63.5-.3c26.7-.1 48.4 21.5 48.4 48.2c0 26.6-21.6 48.2-48.2 48.2l-36 0c-17.5 0-34-8.2-44.5-22.2l-2.5-3.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4l2.5 3.4c16.5 22.1 42.5 35 70.1 35l36 0c44.3 0 80.2-35.9 80.2-80.2c0-44.4-36.1-80.4-80.6-80.2l-19.9 .1 78.9-67.6c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4l-144 0z'
      
    ]
  };

  

  
  

  var faCardsBlank = {
    prefix: 'fal',
    iconName: 'cards-blank',
    icon: [
      640,
      512,
      [],
      'e4df',
      
      'M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6l.1-.1L427.4 365.5l.1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3l.1 .2 167 289.3 .1 .2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9c-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8c-.2 .1-.5 .3-.7 .4l-192.3 111c-.2 .1-.5 .3-.7 .4c-26.4 14.9-59.8 6-75.3-20zM324.1 499l33.2-19.1c.9 .1 1.8 .2 2.7 .2l224 0c13.3 0 24-10.7 24-24l0-336c0-13.3-10.7-24-24-24L373 96 354.7 64.2c1.7-.2 3.5-.2 5.3-.2l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0c-13.7 0-26.2-4.9-35.9-13z'
      
    ]
  };

  

  
  

  var faBone = {
    prefix: 'fal',
    iconName: 'bone',
    icon: [
      576,
      512,
      [129460],
      'f5d7',
      
      'M143.2 174.3C138.6 148 115.6 128 88 128c-30.9 0-56 25.1-56 56c0 16.3 7 31 18.2 41.3c17.9 16.4 17.9 45 0 61.4C39 297 32 311.7 32 328c0 30.9 25.1 56 56 56c27.6 0 50.6-20 55.2-46.3C146.3 320 161.7 304 183 304L393 304c21.3 0 36.7 16 39.8 33.7C437.4 364 460.4 384 488 384c30.9 0 56-25.1 56-56c0-16.3-7-31-18.2-41.3c-17.9-16.4-17.9-45 0-61.4C537 215 544 200.3 544 184c0-30.9-25.1-56-56-56c-27.6 0-50.6 20-55.2 46.3C429.7 192 414.3 208 393 208L183 208c-21.3 0-36.7-16-39.8-33.7zm31.5-5.5c.7 4.1 4.1 7.3 8.3 7.3L393 176c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88c0 25.7-11 48.8-28.5 64.9c-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88c-43.4 0-79.5-31.4-86.7-72.7c-.7-4.1-4.1-7.3-8.3-7.3L183 336c-4.1 0-7.6 3.2-8.3 7.3C167.5 384.6 131.4 416 88 416c-48.6 0-88-39.4-88-88c0-25.7 11-48.8 28.5-64.9c4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88c43.4 0 79.5 31.4 86.7 72.7z'
      
    ]
  };

  

  
  

  var faFileCheck = {
    prefix: 'fal',
    iconName: 'file-check',
    icon: [
      384,
      512,
      [],
      'f316',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM283.3 294c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-95.4 95.4-42-42c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L154 400.6c6.2 6.2 16.4 6.2 22.6 0L283.3 294z'
      
    ]
  };

  

  
  

  var faArrowUpFromWaterPump = {
    prefix: 'fal',
    iconName: 'arrow-up-from-water-pump',
    icon: [
      576,
      512,
      [],
      'e4b6',
      
      'M112 32c-8.8 0-16 7.2-16 16l0 208 160 0 0-208c0-8.8-7.2-16-16-16L112 32zM288 48l0 208 144 0 0-201.4-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 54.6 464 256l48 0c35.3 0 64 28.7 64 64l0 105c-5.3-3.1-11.2-5.4-17.5-6.9c-4.8-1.1-9.7-2.8-14.5-4.8l0-93.3c0-17.7-14.3-32-32-32l-64 0-160 0-32 0L96 288l-32 0c-17.7 0-32 14.3-32 32l0 93.3c-4.8 2.1-9.7 3.7-14.5 4.8C11.2 419.6 5.3 421.9 0 425L0 320c0-35.3 28.7-64 64-64L64 48C64 21.5 85.5 0 112 0L240 0c26.5 0 48 21.5 48 48zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z'
      
    ]
  };

  

  
  

  var faBoot = {
    prefix: 'fal',
    iconName: 'boot',
    icon: [
      512,
      512,
      [129406],
      'f782',
      
      'M32 32l320 0 0 64L32 96l0-64zM0 32L0 96l0 32 32 0 320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zM240 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 32-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l90.8 0c3.4 3 7.4 5.3 12 6.7l91.6 27.5c27.1 8.1 45.6 33 45.6 61.3l0 32.6L32 384l0-224L0 160 0 384l0 31.7 0 .3 0 41.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16l14.9 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l11 0c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7l14.9 0c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6l0-41.4 0-.3 0-31.7 0-32.6c0-42.4-27.8-79.8-68.4-92L352 232l0-56c0-8.8-7.2-16-16-16l-96 0zM480.3 416l0 41.4c0 6.1-2.4 11.9-6.7 16.2s-10.1 6.7-16.2 6.7l-14.9 0c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l22.4 22.4-22.4-22.4-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5l-11 0c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5l-11 0c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6L134.3 485l21.8-21.8c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5l-14.9 0c-6.1 0-11.9-2.4-16.2-6.7s-6.7-10.1-6.7-16.2l0-41.4 .3 0 448 0 .3 0z'
      
    ]
  };

  

  
  

  var faTruckContainer = {
    prefix: 'fal',
    iconName: 'truck-container',
    icon: [
      640,
      512,
      [],
      'f4dc',
      
      'M64 32l288 0c35.3 0 64 28.7 64 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 96C0 60.7 28.7 32 64 32zM448 160c0-17.7 14.3-32 32-32l56 0c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8l0 5.3 0 48 0 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80l-160 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48L448 368l0-112 0-16 0-16 0-64zm144 64l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4l-56 0 0 64 112 0zm16 32l-128 0 0 80c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9l0-56 0-48zM112 96c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPenFancySlash = {
    prefix: 'fal',
    iconName: 'pen-fancy-slash',
    icon: [
      640,
      512,
      [],
      'e210',
      
      'M548.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C576 36.9 539.1 0 493.6 0c-23.4 0-45.6 9.9-61.3 27.3L308.2 165.2 333.4 185 456.1 48.7C465.7 38.1 479.3 32 493.6 32C521.4 32 544 54.6 544 82.4c0 14.3-6.1 27.9-16.7 37.5L398.1 236.1l25.5 20.1L548.7 143.7zM304.2 325L280 403.7c-3 9.9-10.7 17.7-20.5 20.9L131.2 467.4 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3l-67.4 67.4 42.8-128.3c3.3-9.8 11.1-17.4 20.9-20.5L240.7 275l-30.5-24.1-47.3 14.6c-19.8 6.1-35.4 21.3-41.9 40.9L66.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L269.6 455c19.6-6.5 34.9-22.1 40.9-41.9l20.6-66.8L304.2 325zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faToggleLargeOff = {
    prefix: 'fal',
    iconName: 'toggle-large-off',
    icon: [
      576,
      512,
      [],
      'e5b0',
      
      'M160 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 32l256 0c88.4 0 160-71.6 160-160s-71.6-160-160-160L160 96C71.6 96 0 167.6 0 256s71.6 160 160 160zm96-32c38.9-29.2 64-75.7 64-128s-25.1-98.8-64-128l160 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-160 0z'
      
    ]
  };

  

  
  

  var faLightSwitchOff = {
    prefix: 'fal',
    iconName: 'light-switch-off',
    icon: [
      384,
      512,
      [],
      'e018',
      
      'M176 464l0 16L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l112 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 112 0c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32l-112 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM176 344l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm-48 24l0-96 128 0 0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0-224c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96-128 0 0-96zM96 368c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224z'
      
    ]
  };

  

  
  

  var faCupcake = {
    prefix: 'fal',
    iconName: 'cupcake',
    icon: [
      448,
      512,
      [129473],
      'e402',
      
      'M208 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7L148 64c-36.2 0-65.8 28.3-67.9 64l-.1 0c-44.2 0-80 35.8-80 80s35.8 80 80 80l288 0c44.2 0 80-35.8 80-80s-35.8-80-80-80C368 57.3 310.7 0 240 0L208 0zm32 49.3c0-6-1.1-11.8-3.3-17.3l3.3 0c53 0 96 43 96 96c0 4-.6 7.8-1.7 11.4c-1.4 4.8-.5 10.1 2.5 14.1s7.8 6.4 12.8 6.4l18.3 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L80 256c-26.5 0-48-21.5-48-48s21.5-48 48-48l17.4 0c4.9 0 9.5-2.2 12.5-6.1s4.1-8.8 3-13.6c-.6-2.7-1-5.4-1-8.3c0-19.9 16.1-36 36-36l45.3 0C219.1 96 240 75.1 240 49.3zM89.7 471.4c3.7 23.4 23.8 40.6 47.4 40.6l46.7 0 .3 0 79.7 0 .3 0 46.7 0c23.6 0 43.8-17.2 47.4-40.6L382 320l-32.4 0L326.7 466.5c-1.2 7.8-7.9 13.5-15.8 13.5l-29.5 0 13.3-160-32.1 0L249.3 480l-50.6 0L185.4 320l-32.1 0 13.3 160-29.5 0c-7.9 0-14.6-5.7-15.8-13.5L98.4 320 66 320 89.7 471.4z'
      
    ]
  };

  

  
  

  var faBugSlash = {
    prefix: 'fal',
    iconName: 'bug-slash',
    icon: [
      640,
      512,
      [],
      'e490',
      
      'M560 304c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-8c0-22.9-7.4-44.2-20-61.4l79.3-79.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L437.4 180c-17.2-12.6-38.4-20-61.4-20l-74.3 0 40.5 32 33.8 0c39.8 0 72 32.2 72 72l0 11.5L484.1 304l75.9 0zM411.4 409.7c-19.7 20.1-46 33.7-75.4 37.4l0-96.8-32-25.3L304 447c-63.1-7.9-112-61.7-112-127l0-32 0-24c0-8.5 1.5-16.6 4.2-24.2l-26.1-20.6C163.6 232.8 160 248 160 264l0 8-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 16c0 30.2 8.4 58.4 22.9 82.5l-82.2 82.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l79-79C231.5 460.1 273.4 480 320 480c46 0 87.4-19.4 116.6-50.4l-25.2-19.9zM224 98.7L261.2 128l126.4 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96s-96 43-96 96l0 2.7zM320 32c35.3 0 64 28.7 64 64L256 96c0-35.3 28.7-64 64-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faFaceSadSweat = {
    prefix: 'fal',
    iconName: 'face-sad-sweat',
    icon: [
      576,
      512,
      [],
      'e38a',
      
      'M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5l0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM348.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM391.6 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.7-99.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm153.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faLocationPinSlash = {
    prefix: 'fal',
    iconName: 'location-pin-slash',
    icon: [
      640,
      512,
      ["map-marker-slash"],
      'f60c',
      
      'M512 192C512 86 426 0 320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192zM176.6 255.4c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faMapMarkerSlash = faLocationPinSlash;
  

  
  

  var faWindWarning = {
    prefix: 'fal',
    iconName: 'wind-warning',
    icon: [
      640,
      512,
      ["wind-circle-exclamation"],
      'f776',
      
      'M390.3 352c-33.2 57.4-95.2 96-166.3 96C118 448 32 362 32 256S118 64 224 64s192 86 192 192l32 0C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480c89.4 0 166.5-52.3 202.4-128l-36.1 0zM224 128c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM496 480l48 0c53 0 96-43 96-96s-43-96-96-96l-208 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48-256c53 0 96-43 96-96s-43-96-96-96l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-72.1 0c2.7 10.4 4.7 21.1 6.1 32l66 0z'
      
    ]
  };

  
    var faWindCircleExclamation = faWindWarning;
  

  
  

  var faPaperclipVertical = {
    prefix: 'fal',
    iconName: 'paperclip-vertical',
    icon: [
      384,
      512,
      [],
      'e3c2',
      
      'M64 96c0-53 43-96 96-96s96 43 96 96l0 256c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 288c0 53 43 96 96 96s96-43 96-96l0-240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 240c0 70.7-57.3 128-128 128s-128-57.3-128-128L64 96z'
      
    ]
  };

  

  
  

  var faHundredPoints = {
    prefix: 'fal',
    iconName: 'hundred-points',
    icon: [
      512,
      512,
      [128175,"100"],
      'e41c',
      
      'M177.4 93.3c5-35.2 35.2-61.3 70.7-61.3c43.5 0 76.9 38.5 70.7 81.5L302.6 226.7c-5 35.2-35.2 61.3-70.7 61.3c-43.5 0-76.9-38.5-70.7-81.5L177.4 93.3zM248.1 64c-19.6 0-36.3 14.4-39 33.9L192.9 211c-3.4 23.8 15 45 39 45c19.6 0 36.3-14.4 39-33.9L287.1 109c3.4-23.8-15-45-39-45zM129.8 35.2c4.6 3.5 6.9 9.2 6 15l-40 256c-1.4 8.8-9.6 14.9-18.3 13.6s-14.7-9.3-13.3-18.1L99.7 74.4 54.3 94.6c-8.1 3.6-17.5 0-21-8.1s.3-17.5 8.4-21.1l72-32c5.4-2.4 11.5-1.7 16.1 1.8zM425.6 32c42.8 0 76.1 37.3 71.2 79.8l-11.2 96.7c-4.2 36.1-34.8 63.4-71.2 63.4c-42.8 0-76.1-37.3-71.2-79.8l11.2-96.7C358.6 59.3 389.2 32 425.6 32zM386.2 99.1L375 195.8c-2.7 23.5 15.7 44.2 39.4 44.2c20.1 0 37.1-15.1 39.4-35.1L465 108.2C467.7 84.6 449.3 64 425.6 64c-20.1 0-37.1 15.1-39.4 35.1zM511.9 333.9c1.2 8.8-5 16.8-13.7 18l-480 64c-8.8 1.2-16.8-5-18-13.7s5-16.8 13.7-18l480-64c8.8-1.2 16.8 5 18 13.7zM466 447.9l-256 32c-8.8 1.1-16.8-5.1-17.9-13.9s5.1-16.8 13.9-17.9l256-32c8.8-1.1 16.8 5.1 17.9 13.9s-5.1 16.8-13.9 17.9z'
      
    ]
  };

  
    var fa100 = faHundredPoints;
  

  
  

  var faDown = {
    prefix: 'fal',
    iconName: 'down',
    icon: [
      384,
      512,
      ["arrow-alt-down"],
      'f354',
      
      'M189.7 448l4.6 0c4.4 0 8.6-1.8 11.6-5L348.5 293.2c2.2-2.3 3.5-5.4 3.5-8.7c0-6.9-5.6-12.6-12.6-12.6L256 272c-8.8 0-16-7.2-16-16l0-176c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 176c0 8.8-7.2 16-16 16l-83.4 0c-6.9 0-12.6 5.6-12.6 12.6c0 3.2 1.2 6.3 3.5 8.7L178.1 443c3 3.2 7.2 5 11.6 5zM384 284.6c0 11.4-4.4 22.5-12.3 30.7L229 465.1c-9.1 9.5-21.6 14.9-34.8 14.9l-4.6 0c-13.1 0-25.7-5.4-34.8-14.9L12.3 315.3C4.4 307 0 296 0 284.6C0 260 20 240 44.6 240l67.4 0 0-160c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160 67.4 0c24.6 0 44.6 20 44.6 44.6z'
      
    ]
  };

  
    var faArrowAltDown = faDown;
  

  
  

  var faNoteSticky = {
    prefix: 'fal',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l208 0 0-96c0-26.5 21.5-48 48-48l96 0 0-208c0-17.7-14.3-32-32-32L64 64zM304 434.7L402.7 336 320 336c-8.8 0-16 7.2-16 16l0 82.7zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 213.5c0 17-6.7 33.3-18.7 45.3L322.7 461.3c-12 12-28.3 18.7-45.3 18.7L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faDiceD12 = {
    prefix: 'fal',
    iconName: 'dice-d12',
    icon: [
      512,
      512,
      [],
      'f6ce',
      
      'M200.3 32c-2.8 0-5.6 .7-8 2.1L128.7 70.9 256 111.2 383.3 70.9 319.7 34.1c-2.4-1.4-5.2-2.1-8-2.1L200.3 32zM92 92.8c-.8 .9-1.6 1.9-2.2 2.9L34.2 192.2c.6 .5 1.2 1 1.7 1.6l95.8 106.4L240 246.1l0-106.4L92 92.8zM32 237.3l0 74.4c0 2.8 .7 5.6 2.1 8l55.7 96.5c1.4 2.4 3.4 4.5 5.9 5.9l62.7 36.2-44.5-130L32 237.3zM199.7 480c.2 0 .4 0 .6 0l111.5 0c.7 0 1.4 0 2.1-.1l50.6-151.8L256 273.9 147.7 328.1l52 151.9zM355 457.5l61.2-35.4c2.4-1.4 4.5-3.4 5.9-5.9l55.7-96.5c1.4-2.4 2.1-5.2 2.1-8l0-74.4-81.9 90.9L355 457.5zM477.8 192.2L422.1 95.7c-.6-1.1-1.3-2-2.2-2.9L272 139.7l0 106.4 108.3 54.1 95.8-106.4c.5-.6 1.1-1.1 1.7-1.6zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4L311.7 0c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24l0 111.5c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4l-111.5 0c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24L0 200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z'
      
    ]
  };

  

  
  

  var faGramophone = {
    prefix: 'fal',
    iconName: 'gramophone',
    icon: [
      384,
      512,
      [],
      'f8bd',
      
      'M132.6 32.1c.2 .1 .4 .4 .5 .7C145 62.6 183.4 144.5 268 208.6c-47.9 .3-112.8 17-193.6 73.9c-1.8 1.3-3.9 1.2-5.4 .2c-1.5-1-2.3-2.9-1.8-4.7L132.3 32c.1 0 .2 0 .3 .1zM36.3 269.8c-4 15 2 30.9 15 39.5c12.8 8.5 29.3 7.9 41.6-.7c112.2-79 186.5-72.7 221.9-61.4c11.9 3.8 20.1 16.1 21.1 33.4c-1.5 21.9-19.7 39.2-42 39.3l-.2 0L176 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l117.7 0 .2 0 6.4 0c37.4 0 67.7-30.3 67.7-67.7c0-1.1 0-2.3-.1-3.4c0-1.1 .1-2.1 .1-3.2c0-29.5-17.6-54.9-41.6-68.7C220.9 148.4 175.4 52.4 162.9 21C158 8.8 146.2 0 132.3 0c-14.5 0-27.2 9.8-30.9 23.8l-65.1 246zM304 416c8.8 0 16 7.2 16 16l0 48L64 480l0-48c0-8.8 7.2-16 16-16l224 0zM80 384c-26.5 0-48 21.5-48 48l0 48s0 0 0 0l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0s0 0 0 0l0-48c0-26.5-21.5-48-48-48L80 384z'
      
    ]
  };

  

  
  

  var faJar = {
    prefix: 'fal',
    iconName: 'jar',
    icon: [
      320,
      512,
      [],
      'e516',
      
      'M64 0L256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 32c-8.8 0-16-7.2-16-16S55.2 0 64 0zm0 96c-17.7 0-32 14.3-32 32l0 64 256 0 0-64c0-17.7-14.3-32-32-32L64 96zM32 224l0 128 256 0 0-128L32 224zm0 160l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64L32 384zM0 128C0 92.7 28.7 64 64 64l192 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128z'
      
    ]
  };

  

  
  

  var faMagnet = {
    prefix: 'fal',
    iconName: 'magnet',
    icon: [
      448,
      512,
      [129522],
      'f076',
      
      'M48 64c-8.8 0-16 7.2-16 16l0 48 80 0 0-48c0-8.8-7.2-16-16-16L48 64zM32 256c0 106 86 192 192 192s192-86 192-192l0-96-80 0 0 96c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-96-80 0 0 96zM416 128l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48 80 0zM0 80C0 53.5 21.5 32 48 32l48 0c26.5 0 48 21.5 48 48l0 176c0 44.2 35.8 80 80 80s80-35.8 80-80l0-176c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 176c0 123.7-100.3 224-224 224S0 379.7 0 256L0 80z'
      
    ]
  };

  

  
  

  var faCircle2 = {
    prefix: 'fal',
    iconName: 'circle-2',
    icon: [
      512,
      512,
      [],
      'e0ef',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM217 174.4c9.8-9.2 22.7-14.2 36.1-14c28.2 .4 50.9 23.4 50.9 51.6c0 13.7-5.4 26.8-15.1 36.5L180.7 356.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-105.4 0 80.9-80.9c15.7-15.7 24.5-37 24.5-59.1c0-45.7-36.7-83-82.4-83.6c-21.7-.3-42.7 7.8-58.5 22.7L181 164.3c-6.4 6.1-6.7 16.2-.7 22.6s16.2 6.7 22.6 .7L217 174.4z'
      
    ]
  };

  

  
  

  var fa1 = {
    prefix: 'fal',
    iconName: '1',
    icon: [
      256,
      512,
      [],
      '31',
      
      'M144 48c0-5.9-3.2-11.3-8.5-14.1s-11.5-2.5-16.4 .8l-96 64c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L112 77.9 112 448l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-400z'
      
    ]
  };

  

  
  

  var faFalafel = {
    prefix: 'fal',
    iconName: 'falafel',
    icon: [
      576,
      512,
      [129478],
      'e40a',
      
      'M160.4 177.7c-11.7-15.9-11.2-38 1.5-53.4c2.3-2.7 3.1-6.5 2.2-10.1c-5.1-20.1 4.7-41.3 23.7-50c3.1-1.4 5.4-4.3 6.1-7.9C198 35.9 216 21 237 21.6c3.3 .1 6.5-1.4 8.6-4.3C258 .5 280.7-4.9 299.3 4.9c3 1.6 6.5 1.6 9.4 0C327.3-4.9 350 .5 362.4 17.3c2.1 2.9 5.3 4.4 8.6 4.3c21-.6 39 14.3 42.9 34.7c.7 3.6 3.1 6.5 6.1 7.9c19 8.7 28.8 29.9 23.7 50c-.9 3.6 0 7.4 2.2 10.1c13.2 16 13.2 39.3 0 55.3c-2.3 2.7-3.1 6.5-2.2 10.1c.2 1 .5 2 .6 3c-4.2 .6-8.4 1.6-12.5 3c-6.6-2.2-13.4-3.4-20.2-3.7c-1.4-11.7 2-23.6 9.6-32.8c3.5-4.2 3.5-10.4 0-14.5c-8.8-10.7-12-25-8.6-38.4c1.4-5.5-1.4-10.9-6-13c-12.6-5.8-21.6-17.4-24.2-30.9c-1.1-5.5-5.7-9-10.6-8.9c-13.9 .4-27-6.1-35.3-17.3c-3.1-4.3-8.6-5.4-13-3.1c-12.3 6.5-27 6.5-39.3 0c-4.4-2.3-9.9-1.2-13 3.1C263.1 47.5 250 54 236 53.6c-4.9-.1-9.5 3.4-10.6 8.9c-2.6 13.6-11.6 25.2-24.2 30.9c-4.6 2.1-7.4 7.5-6 13c3.4 13.4 .2 27.7-8.6 38.4c-3.5 4.2-3.5 10.4 0 14.5c4.7 5.6 7.8 12.3 9.1 19.3c-11.4-3.1-23.5-3.5-35.3-.9zM240 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm27.2 182.2c-.5-3.7-2.8-7.1-6.5-8.8c-12.8-5.7-22-17.2-24.7-30.9c-1.1-5.3-5.8-9.1-11.3-8.9c-14 .4-27.3-6-35.7-17.1c-3.3-4.3-9.2-5.7-14.1-3.2c-12.4 6.4-27.2 6.4-39.6 0c-4.9-2.5-10.8-1.1-14.1 3.2c-8.4 11.2-21.7 17.5-35.7 17.1c-5.5-.2-10.2 3.7-11.3 8.9c-2.7 13.7-12 25.2-24.7 30.9c-5 2.2-7.6 7.7-6.2 12.9c3.5 13.5 .2 27.9-8.8 38.6c-3.5 4.1-3.5 10.1 0 14.3c9 10.7 12.3 25 8.8 38.6c-1.3 5.2 1.3 10.6 6.2 12.9c12.8 5.7 22 17.2 24.7 30.9c1.1 5.3 5.8 9.1 11.3 8.9c14-.4 27.3 6 35.7 17.1c3.3 4.3 9.2 5.7 14.1 3.2c12.4-6.4 27.2-6.4 39.6 0c4.9 2.5 10.8 1.1 14.1-3.2c8.4-11.1 21.7-17.5 35.7-17.1c5.5 .2 10.2-3.7 11.3-8.9c2.7-13.7 12-25.2 24.7-30.9c2.5-1.1 4.4-3 5.5-5.3c-.1 12 2.8 23.7 8.2 34.2l-.7 .3c-3.3 1.5-5.7 4.4-6.4 8c-4.1 20.6-22.5 35.2-43.5 34.6c-3.6-.1-7.1 1.6-9.2 4.4c-12.7 16.8-35.6 22-54.3 12.4c-3.2-1.7-7.1-1.7-10.3 0c-18.7 9.6-41.6 4.4-54.3-12.4c-2.2-2.9-5.6-4.5-9.2-4.4c-21 .6-39.4-14-43.5-34.6c-.7-3.5-3.1-6.5-6.4-8c-19.2-8.6-29.4-29.7-24.2-50.1c.9-3.5 .1-7.1-2.3-9.9c-13.6-16.1-13.6-39.6 0-55.6c2.3-2.7 3.2-6.4 2.3-9.9c-5.3-20.4 5-41.5 24.2-50.1c3.3-1.5 5.7-4.4 6.4-8c4.1-20.6 22.5-35.2 43.5-34.6c3.6 .1 7.1-1.6 9.2-4.4c12.7-16.8 35.6-22 54.3-12.4c3.2 1.7 7.1 1.7 10.3 0c18.7-9.6 41.6-4.4 54.3 12.4c2.2 2.9 5.6 4.5 9.2 4.4c21-.6 39.4 14 43.5 34.6c.7 3.5 3.1 6.5 6.4 8c2.9 1.3 5.6 2.9 8.1 4.7c-7.6 9.7-12.6 21.2-14.6 33.3zM64 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm13.1-159c-3.7-2-8.4-1-11.1 2.7c-7.9 10.8-20.6 17-34 16.6c-4.1-.1-8.1 2.8-9 7.6c-2.5 13.1-11.2 24.2-23.3 29.8c-3.9 1.8-6.3 6.4-5.1 11.2c3.3 12.9 .2 26.7-8.3 36.9c-3 3.6-3 8.9 0 12.5c8.5 10.3 11.5 24 8.3 36.9c-1.2 4.7 1.2 9.4 5.1 11.2c12.2 5.6 20.8 16.7 23.3 29.8c.9 4.7 4.9 7.7 9 7.6c13.4-.4 26.1 5.9 34 16.6c2.7 3.6 7.4 4.6 11.1 2.7c11.9-6.3 26-6.3 37.8 0c3.7 2 8.4 1 11.1-2.7c7.9-10.8 20.6-17 34-16.6c4.1 .1 8.1-2.8 9-7.6c2.5-13.1 11.2-24.2 23.3-29.8c3.9-1.8 6.3-6.4 5.1-11.2c-2.5-9.7-1.3-19.9 3-28.8c-25.6-4.9-53-20.9-75.5-43.4c-24.1-24.1-40.5-53.5-44.2-80.3c-1.3-.5-2.5-1.1-3.7-1.7zM428 228.7c1.3 .7 2.6 1 4 1c4.3 0 8.5 1.7 11.5 4.8s4.6 7.3 4.5 11.6c-.5 18.2 11 45.6 35.6 70.2c26.8 26.8 56.4 37.7 74.2 35.3c4.5-.6 9.1 .7 12.6 3.7s5.5 7.3 5.6 11.9c.2 9.7-3 19.5-9.6 27.4c-1.9 2.3-2.7 5.6-1.9 8.7c4.9 19.4-4.5 39.7-22.8 48.1c-2.6 1.2-4.6 3.7-5.2 6.8c-3.8 19.6-21.1 34-41.4 33.4c-2.8-.1-5.5 1.2-7.3 3.7c-12 16.2-33.8 21.4-51.8 12c-2.5-1.3-5.5-1.3-8 0c-17.9 9.4-39.8 4.2-51.8-12c-1.8-2.4-4.6-3.7-7.3-3.7c-20.2 .6-37.5-13.8-41.4-33.4c-.6-3.1-2.6-5.6-5.2-6.8c-18.3-8.4-27.7-28.8-22.8-48.1c.8-3.1 0-6.3-1.9-8.7c-12.8-15.4-12.8-37.9 0-53.3c1.9-2.3 2.7-5.6 1.9-8.7c-4.9-19.4 4.5-39.7 22.8-48.1c2.6-1.2 4.6-3.7 5.2-6.8c3.8-19.6 21.1-34 41.4-33.4c2.8 .1 5.5-1.2 7.3-3.7c12-16.2 33.8-21.4 51.8-12z'
      
    ]
  };

  

  
  

  var faPenSwirl = {
    prefix: 'fal',
    iconName: 'pen-swirl',
    icon: [
      512,
      512,
      [],
      'e214',
      
      'M454.8 45.5c-12.6-12.6-32.9-12.5-45.4 .1L383 72.4l57 57 26.7-26.8c12.5-12.5 12.5-32.8 0-45.2L454.8 45.5zM218.2 239.2c-4.3 4.4-7.3 9.9-8.6 15.9l-12.9 61.7 61.5-12.9c6.1-1.3 11.7-4.3 16.1-8.7L417.4 152 360.5 95.1 218.2 239.2zM386.7 23.1c24.9-25.3 65.7-25.4 90.8-.3l11.9 11.9c25 25 25 65.5 0 90.5L296.9 317.8c-8.8 8.8-20 14.8-32.1 17.4l-85.5 17.9c-5.3 1.1-10.8-.5-14.6-4.3s-5.5-9.3-4.3-14.6l18-85.7c2.5-12 8.5-23.1 17.1-31.8L386.7 23.1zM301.1 52.9C286.5 49.7 271.5 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c8.8 0 16 7.2 16 16s-7.2 16-16 16C123.5 496 16 388.5 16 256S123.5 16 256 16c24.7 0 48.5 3.7 71 10.7L301.1 52.9zM485.5 185.7c6.8 22.2 10.5 45.8 10.5 70.3c0 79.5-64.5 144-144 144c-12.4 0-24.5-1.6-36-4.5c-8.6-2.2-13.7-10.9-11.5-19.5s10.9-13.7 19.5-11.5c8.9 2.3 18.3 3.5 28 3.5c61.9 0 112-50.1 112-112c0-15.1-1.6-29.9-4.7-44.1l26.2-26.2z'
      
    ]
  };

  

  
  

  var faCommentExclamation = {
    prefix: 'fal',
    iconName: 'comment-exclamation',
    icon: [
      512,
      512,
      [],
      'f4af',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm0 80c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faGripDots = {
    prefix: 'fal',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      'M384 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 176a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM208 336a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faSquareFull = {
    prefix: 'fal',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      'M480 32l0 448L32 480 32 32l448 0zM32 0L0 0 0 32 0 480l0 32 32 0 448 0 32 0 0-32 0-448 0-32L480 0 32 0z'
      
    ]
  };

  

  
  

  var faStopwatch20 = {
    prefix: 'fal',
    iconName: 'stopwatch-20',
    icon: [
      448,
      512,
      [],
      'e06f',
      
      'M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64.6C100.6 104.8 16 194.5 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-47.6-16-91.4-42.9-126.5l38.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-37 37c-33.7-32.3-78.3-53.3-127.7-57L240 32l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 0zm80 480a176 176 0 1 1 0-352 176 176 0 1 1 0 352zm16-240l0 128c0 26.5 21.5 48 48 48s48-21.5 48-48l0-128c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-16c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM151.8 235.3c2.3-6.8 8.6-11.3 15.7-11.3c9.1 0 16.5 7.4 16.5 16.5l0 14.8c0 7.1-2.4 14-6.9 19.6l-32.6 40.7c-15.9 19.9-24.5 44.5-24.5 70l0 14.3c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c.4-17.6 6.5-34.6 17.5-48.3L202.1 295c9-11.2 13.9-25.2 13.9-39.6l0-14.8c0-26.8-21.7-48.5-48.5-48.5c-20.9 0-39.4 13.4-46.1 33.2l-.6 1.7c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l.6-1.7z'
      
    ]
  };

  

  
  

  var faShieldExclamation = {
    prefix: 'fal',
    iconName: 'shield-exclamation',
    icon: [
      512,
      512,
      [],
      'e247',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 128c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCloudSun = {
    prefix: 'fal',
    iconName: 'cloud-sun',
    icon: [
      640,
      512,
      [9925],
      'f6c4',
      
      'M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l71 11.8-40.2 57.5c11.4-3.3 23.4-5.1 35.8-5.1c2.2 0 4.5 .1 6.7 .2l38.5-55c3.1-4.5 3.8-10.3 1.6-15.4s-6.7-8.7-12.1-9.6L317.9 98.1 303.8 13.4zm-59.9 275c7.8-30.6 26.5-56.8 51.9-74.1c.1-2.1 .2-4.2 .2-6.3c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6zM264 208a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm40 112c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-266.6 0c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1l266.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.9 224 368 224z'
      
    ]
  };

  

  
  

  var faSyringe = {
    prefix: 'fal',
    iconName: 'syringe',
    icon: [
      512,
      512,
      [128137],
      'f48e',
      
      'M404.7 4.7c-6.2 6.2-6.2 16.4 0 22.6L433.4 56 384 105.4 315.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80 80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 456 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-40-40-40-40c-6.2-6.2-16.4-6.2-22.6 0zm-272 224L82.7 278.6c-12 12-18.7 28.3-18.7 45.3l0 101.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448l101.5 0c17 0 33.3-6.7 45.3-18.7l192-192-22.6-22.6-192 192c-6 6-14.1 9.4-22.6 9.4L96 416l0-92.1c0-8.5 3.4-16.6 9.4-22.6L144 262.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240 208 198.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 176l66.7-66.7L274.7 86.6l-78.1 78.1s0 0 0 0s0 0 0 0l-64 64s0 0 0 0s0 0 0 0z'
      
    ]
  };

  

  
  

  var faBoombox = {
    prefix: 'fal',
    iconName: 'boombox',
    icon: [
      640,
      512,
      [128254],
      'f8a5',
      
      'M144 32l352 0c26.5 0 48 21.5 48 48l0 80L96 160l0-80c0-26.5 21.5-48 48-48zM64 80l0 80c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l0-80c0-44.2-35.8-80-80-80L144 0C99.8 0 64 35.8 64 80zM80 192l480 0 16 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l16 0zM96 336a80 80 0 1 1 160 0A80 80 0 1 1 96 336zm192 0A112 112 0 1 0 64 336a112 112 0 1 0 224 0zm176-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM208 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z'
      
    ]
  };

  

  
  

  var faUserNurse = {
    prefix: 'fal',
    iconName: 'user-nurse',
    icon: [
      448,
      512,
      [],
      'f82f',
      
      'M128 128l0 16 192 0 0-16 0-57.8-96-36-96 36 0 57.8zM96 160l0-32 0-57.8c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8 0 32 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zm224 16l-192 0c0 53 43 96 96 96s96-43 96-96zM119 359.1C68.7 376.5 32.5 424 32 480l384 0c-.5-56-36.7-103.5-86.9-120.9L259 433.6c-19 20.1-51 20.1-69.9 0L119 359.1zm22.4-22.9l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6c10.5-3.4 21.8 .4 29.4 8.5zM216 48l16 0c4.4 0 8 3.6 8 8l0 16 16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0 0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l16 0 0-16c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faTrashCheck = {
    prefix: 'fal',
    iconName: 'trash-check',
    icon: [
      448,
      512,
      [],
      'e2af',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64l47.1 0L416 64l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-18.3 0L388.2 452.6C385.9 486.1 358 512 324.4 512l-200.8 0c-33.6 0-61.4-25.9-63.8-59.4L34.3 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32.1 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480l200.8 0c16.8 0 30.7-13 31.9-29.7L381.6 96 66.4 96zM331.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 329.4 308.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBridgeSuspension = {
    prefix: 'fal',
    iconName: 'bridge-suspension',
    icon: [
      640,
      512,
      [],
      'e4cd',
      
      'M128 0c6.4 0 11.9 3.7 14.5 9.2l6.6 13.2C181.4 87.1 247.6 128 320 128s138.6-40.9 170.9-105.6l6.6-13.2C500.1 3.7 505.6 0 512 0c7.2 0 13.3 4.7 15.3 11.3c14.5 43 58.7 87.5 102.6 104.9c8.2 3.3 12.2 12.6 9 20.8s-12.6 12.2-20.8 9c-33-13.1-66-38.6-90.1-69.1L528 256l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 288c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-179.2c-24.1 30.5-57.1 56-90.1 69.1c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8C54 98.7 98.2 54.3 112.7 11.3C114.7 4.7 120.8 0 128 0zm16 256l64 0 0-126.1c-24.5-14.2-46.3-33.1-64-55.8l0 182zm96 0l64 0 0-96.6c-22.2-1.6-43.7-6.5-64-14.3L240 256zm96 0l64 0 0-110.8c-20.3 7.8-41.8 12.7-64 14.3l0 96.6zm96 0l64 0 0-182c-17.7 22.7-39.5 41.6-64 55.8L432 256zM16 320l16 0c53 0 96 43 96 96l0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16c0-70.7 57.3-128 128-128s128 57.3 128 128l0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48c0-53 43-96 96-96l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-35.3 0-64 28.7-64 64l0 48c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-16c0-53-43-96-96-96s-96 43-96 96l0 16c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-48c0-35.3-28.7-64-64-64l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTrainTram = {
    prefix: 'fal',
    iconName: 'train-tram',
    icon: [
      448,
      512,
      [128650],
      'e5b4',
      
      'M41.3 50c9.1-11.4 22.9-18 37.5-18L208 32l0 64-48 0c-53 0-96 43-96 96l0 160c0 28.9 12.8 54.8 33 72.4L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l65.8-65.8c10.8 4.2 22.6 6.5 34.9 6.5l128 0c12.3 0 24-2.3 34.9-6.5l65.8 65.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L351 424.4c20.2-17.6 33-43.5 33-72.4l0-160c0-53-43-96-96-96l-48 0 0-64 129.2 0c14.6 0 28.4 6.6 37.5 18l12.8 16c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5L431.7 30C416.5 11 393.5 0 369.2 0L78.8 0C54.5 0 31.5 11 16.3 30L3.5 46C-2 52.9-.9 63 6 68.5S23 72.9 28.5 66L41.3 50zM160 128l48 0 32 0 48 0c35.3 0 64 28.7 64 64l0 64L96 256l0-64c0-35.3 28.7-64 64-64zM96 288l256 0 0 64c0 35.3-28.7 64-64 64l-128 0c-35.3 0-64-28.7-64-64l0-64zm96 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faStarshipFreighter = {
    prefix: 'fal',
    iconName: 'starship-freighter',
    icon: [
      576,
      512,
      [],
      'e03a',
      
      'M377.1 371.9L315.5 285c2.9-9.2 4.5-18.9 4.5-29c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c.6 0 1.1 0 1.7 0l60.7 85.7C266.8 444.4 245.8 448 224 448C118 448 32 362 32 256S118 64 224 64c104.4 0 189.3 83.3 191.9 187c0 1.6 .1 3.3 .1 5c0 1.7 0 3.5-.1 5.2c-1.1 41.5-15.4 79.8-38.9 110.7zM405.4 400l-8.5 0-.6-.9c22.5-27.1 38.7-59.5 46.5-95.1l4.6 0 96.6 0 0 42.1L405.4 400zM460 413.1l95.6-37.2c12.3-4.8 20.4-16.6 20.4-29.8l0-42.1c0-17.7-14.3-32-32-32l-64.5 0-32.1 0c.4-5.3 .6-10.6 .6-16c0-5.3-.2-10.6-.6-15.8l0-.2 32.1 0 64.5 0c17.7 0 32-14.3 32-32l0-42.1c0-13.2-8.1-25-20.4-29.8L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c28.7 0 57.1-3.6 84.8-10.7l13.5 19.1C332.8 503.2 349.8 512 368 512l56 0c30.9 0 56-25.1 56-56c0-17.2-7.8-32.6-20-42.9zM447.4 208l-4.6 0c-8.4-38.6-26.8-73.5-52.3-101.8L544 165.9l0 42.1-96.6 0zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM348.2 469.6L262.3 344.1c15-6.5 28-16.8 37.9-29.6L380.7 432l43.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0c-7.9 0-15.3-3.9-19.8-10.4z'
      
    ]
  };

  

  
  

  var faUserLarge = {
    prefix: 'fal',
    iconName: 'user-large',
    icon: [
      512,
      512,
      ["user-alt"],
      'f406',
      
      'M368 144a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM32 480l448 0c-.7-70.8-58.3-128-129.3-128l-189.4 0C90.3 352 32.7 409.2 32 480zM0 481.3C0 392.2 72.2 320 161.3 320l189.4 0C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z'
      
    ]
  };

  
    var faUserAlt = faUserLarge;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fal',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      'M232 415.8c-25.2-36.2-40-80.3-40-127.8c0-99.1 64.3-183.1 153.5-212.7C312.4 48.2 270.1 32 224 32C118 32 32 118 32 224s86 192 192 192c2.7 0 5.4-.1 8-.2zm36.4-5C353 390.8 416 314.7 416 224c0-46.7-16.7-89.5-44.4-122.8C287 121.2 224 197.3 224 288c0 46.7 16.7 89.5 44.4 122.8zm-11.6 34.8c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM408 96.2c25.2 36.3 40 80.3 40 127.8c0 99.1-64.3 183.1-153.5 212.7C327.6 463.8 369.9 480 416 480c106 0 192-86 192-192s-86-192-192-192c-2.7 0-5.4 .1-8 .2z'
      
    ]
  };

  

  
  

  var faRulerVertical = {
    prefix: 'fal',
    iconName: 'ruler-vertical',
    icon: [
      256,
      512,
      [],
      'f548',
      
      'M192 32c17.7 0 32 14.3 32 32l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 32c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0z'
      
    ]
  };

  

  
  

  var faRightLeftLarge = {
    prefix: 'fal',
    iconName: 'right-left-large',
    icon: [
      640,
      512,
      [],
      'e5e1',
      
      'M205.2 496c-12.4 0-24.4-4.6-33.7-12.8L49.3 374.6C38.3 364.8 32 350.7 32 336s6.3-28.8 17.3-38.6L171.5 188.8c9.3-8.3 21.3-12.8 33.7-12.8c28 0 50.8 22.7 50.8 50.8V240H400c8.8 0 16 7.2 16 16v29.2c0 10.4 8.4 18.8 18.8 18.8c4.6 0 9-1.7 12.5-4.7L569.4 190.7c4.2-3.7 6.6-9.1 6.6-14.7s-2.4-10.9-6.6-14.7L447.3 52.7c-3.4-3.1-7.9-4.7-12.5-4.7C424.4 48 416 56.4 416 66.8V96c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V66.8c0-28 22.7-50.8 50.8-50.8c12.4 0 24.4 4.6 33.7 12.8L590.7 137.4c11 9.8 17.3 23.8 17.3 38.6s-6.3 28.8-17.3 38.6L468.5 323.2c-9.3 8.3-21.3 12.8-33.7 12.8c-28 0-50.8-22.7-50.8-50.8V272H240c-8.8 0-16-7.2-16-16V226.8c0-10.4-8.4-18.8-18.8-18.8c-4.6 0-9 1.7-12.5 4.7L70.6 321.3c-4.2 3.7-6.6 9.1-6.6 14.7s2.4 10.9 6.6 14.7L192.7 459.3c3.4 3.1 7.9 4.7 12.5 4.7c10.4 0 18.8-8.4 18.8-18.8V416c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H256v13.2c0 28-22.7 50.8-50.8 50.8z'
      
    ]
  };

  

  
  

  var faArrowDownFromArc = {
    prefix: 'fal',
    iconName: 'arrow-down-from-arc',
    icon: [
      512,
      512,
      [],
      'e614',
      
      'M256 160c8.8 0 16 7.2 16 16l0 277.9L372 341.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6l-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 453.9 240 176c0-8.8 7.2-16 16-16zM0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C480 132.3 379.7 32 256 32S32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fal',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      'M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM203.3 88.7C185.1 73.3 161.7 64 136 64C78.6 64 32 110.6 32 168c0 25.7 9.3 49.1 24.7 67.3c10.1 11.9 10.1 29.5 0 41.4C41.3 294.9 32 318.3 32 344c0 57.4 46.6 104 104 104c25.7 0 49.1-9.3 67.3-24.7c11.9-10.1 29.5-10.1 41.4 0C262.9 438.7 286.3 448 312 448c57.4 0 104-46.6 104-104c0-25.7-9.3-49.1-24.7-67.3c-10.1-11.9-10.1-29.5 0-41.4C406.7 217.1 416 193.7 416 168c0-57.4-46.6-104-104-104c-25.7 0-49.1 9.3-67.3 24.7c-11.9 10.1-29.5 10.1-41.4 0zM272 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMinus = {
    prefix: 'fal',
    iconName: 'magnifying-glass-minus',
    icon: [
      512,
      512,
      ["search-minus"],
      'f010',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM112 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  
    var faSearchMinus = faMagnifyingGlassMinus;
  

  
  

  var faCalendarHeart = {
    prefix: 'fal',
    iconName: 'calendar-heart',
    icon: [
      448,
      512,
      [],
      'e0d3',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zm80 205.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 393.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 240c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z'
      
    ]
  };

  

  
  

  var faMask = {
    prefix: 'fal',
    iconName: 'mask',
    icon: [
      576,
      512,
      [],
      'f6fa',
      
      'M80.9 150.2C46 180.3 32 222.2 32 272c0 47.9 16.9 83.2 41.9 106.7C99.2 402.4 135 416 176 416l8.4 0c12.1 0 23.2-6.8 28.6-17.7L236.2 352l28.6 14.3-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4l-8.4 0C80 448 0 384 0 272S64 64 288 64s288 96 288 208s-80 176-176 176l-8.4 0c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3L236.2 352c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7l8.4 0c41 0 76.8-13.6 102.1-37.3c25-23.4 41.9-58.7 41.9-106.7c0-49.8-14-91.7-48.9-121.8C459.3 119.3 396.2 96 288 96s-171.3 23.3-207.1 54.2zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm288 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faTreeDecorated = {
    prefix: 'fal',
    iconName: 'tree-decorated',
    icon: [
      448,
      512,
      [],
      'f7dc',
      
      'M236.4 5.9C233.3 2.2 228.8 0 224 0s-9.3 2.2-12.4 5.9L70.3 178.6c-4.1 5-6.3 11.2-6.3 17.6C64 211.6 76.4 224 91.8 224l18.9 0L38.1 314.8c-3.9 4.9-6.1 11.1-6.1 17.4C32 347.5 44.5 360 59.8 360l21.3 0L5.2 467.6C1.8 472.4 0 478 0 483.9C0 499.4 12.6 512 28.1 512L160 512l128 0 131.9 0c15.5 0 28.1-12.6 28.1-28.1c0-5.8-1.8-11.5-5.2-16.2L366.9 360l21.3 0c15.4 0 27.8-12.5 27.8-27.8c0-6.3-2.2-12.5-6.1-17.4L337.3 224l18.9 0c15.4 0 27.8-12.4 27.8-27.8c0-6.4-2.2-12.6-6.3-17.6L236.4 5.9zM412.4 480L288 480l-128 0L35.6 480l89.5-126.8c3.4-4.9 3.9-11.3 1.1-16.6s-8.2-8.6-14.2-8.6l-43.5 0 88-110c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1l-43.3 0L224 41.3 347.3 192 304 192c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l88 110L336 328c-6 0-11.5 3.3-14.2 8.6s-2.3 11.7 1.1 16.6L412.4 480zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFileHalfDashed = {
    prefix: 'fal',
    iconName: 'file-half-dashed',
    icon: [
      384,
      512,
      [],
      'e698',
      
      'M32 288L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 96L32 288zm0 32l320 0 32 0 0-156.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0C28.7 0 0 28.7 0 64L0 320l32 0zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM0 352l0 64 32 0 0-64L0 352zM64 512l0-32c-17.7 0-32-14.3-32-32L0 448c0 35.3 28.7 64 64 64zm256-32l0 32c35.3 0 64-28.7 64-64l-32 0c0 17.7-14.3 32-32 32zm64-128l-32 0 0 64 32 0 0-64zM96 480l0 32 80 0 0-32-80 0zm112 0l0 32 80 0 0-32-80 0z'
      
    ]
  };

  

  
  

  var faBrush = {
    prefix: 'fal',
    iconName: 'brush',
    icon: [
      384,
      512,
      [],
      'f55d',
      
      'M256 352c-17.7 0-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32l-48 0c-26.5 0-48-21.5-48-48l0-16 320 0 0 16c0 26.5-21.5 48-48 48l-48 0zm96-96L32 256 32 64c0-17.7 14.3-32 32-32l32 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 64 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 96 0c17.7 0 32 14.3 32 32l0 192zM80 384l16 0 32 0 0 32 0 32c0 35.3 28.7 64 64 64s64-28.7 64-64l0-32 0-32 32 0 16 0c44.2 0 80-35.8 80-80l0-240c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 304c0 44.2 35.8 80 80 80z'
      
    ]
  };

  

  
  

  var faMugSaucer = {
    prefix: 'fal',
    iconName: 'mug-saucer',
    icon: [
      640,
      512,
      ["coffee"],
      'f0f4',
      
      'M416 64l16 0 16 0 0 160 0 32 0 32c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-224 288 0zm64 224l0-32 48 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-80 0-16 0-16 0L128 32c-17.7 0-32 14.3-32 32l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96zm48-64l-48 0 0-160 48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448z'
      
    ]
  };

  
    var faCoffee = faMugSaucer;
  

  
  

  var faGarlic = {
    prefix: 'fal',
    iconName: 'garlic',
    icon: [
      512,
      512,
      [129476],
      'e40e',
      
      'M192 48c0-8.8 7.2-16 16-16l32 0 0 38.2c0 51.4 18.4 101.1 51.9 140.2l17.1 19.9c17.5 20.4 27.1 46.5 27.1 73.3C336 365.6 285.8 416 224 416c-61.9 0-112-50.1-112-112l0-5.3c0-24.4 7.6-48.3 21.8-68.2L149 209.3c24.6-34.5 39.2-75 42.3-117.1c.4-3.6 .6-7.3 .6-11l0-6.1L192 56l0-8zm-32 0l0 8 0 19.2c0 4.7-.2 9.3-.5 14c-2.1 16.4-10.4 31.6-23.5 42L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448l3.5 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 3.5 0C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2c-15.2-12.1-24-30.5-24-50L352 48c0-26.5-21.5-48-48-48L208 0c-26.5 0-48 21.5-48 48zM72.7 222.8l61-48.8c-3.3 5.7-6.8 11.3-10.7 16.7l-15.2 21.2C89.7 237.3 80 267.6 80 298.7l0 5.3c0 45.1 20.7 85.4 53.2 111.8C76.7 412 32 365 32 307.5c0-33 15-64.1 40.7-84.7zM371.5 416l-57.2 0c32.7-26.5 53.7-67.1 53.7-112.3c0-34.5-12.3-68-34.8-94.2l-17.1-19.9C287.7 156.4 272 114 272 70.2L272 32l32 0c8.8 0 16 7.2 16 16l0 33.2c0 29.2 13.3 56.7 36 75l83.3 66.6C465 243.4 480 274.6 480 307.5C480 367.4 431.4 416 371.5 416z'
      
    ]
  };

  

  
  

  var faCommentArrowUp = {
    prefix: 'fal',
    iconName: 'comment-arrow-up',
    icon: [
      512,
      512,
      [],
      'e144',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 150.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 182.6 240 320c0 8.8 7.2 16 16 16s16-7.2 16-16l0-137.4z'
      
    ]
  };

  

  
  

  var faRectangleWide = {
    prefix: 'fal',
    iconName: 'rectangle-wide',
    icon: [
      640,
      512,
      [],
      'f2fc',
      
      'M576 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z'
      
    ]
  };

  

  
  

  var faWindowMinimize = {
    prefix: 'fal',
    iconName: 'window-minimize',
    icon: [
      512,
      512,
      [128469],
      'f2d1',
      
      'M16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448z'
      
    ]
  };

  

  
  

  var faFileInvoice = {
    prefix: 'fal',
    iconName: 'file-invoice',
    icon: [
      384,
      512,
      [],
      'f570',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm0 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM224 432c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm64-96L96 336l0-64 192 0 0 64zM96 240c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 240z'
      
    ]
  };

  

  
  

  var faHandDots = {
    prefix: 'fal',
    iconName: 'hand-dots',
    icon: [
      512,
      512,
      ["allergies"],
      'f461',
      
      'M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8c30.9 0 56 25.1 56 56l0 13.4c7.3-3.5 15.4-5.4 24-5.4c30.9 0 56 25.1 56 56l0 184c0 97.2-78.8 176-176 176l-8.5 0c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L128 288.8 128 88c0-30.9 25.1-56 56-56c9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 239.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3l8.5 0c79.5 0 144-64.5 144-144l0-184c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9l0 88.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-87.9c0 0 0 0 0-.1l0-64c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9L320 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-151.9c0 0 0 0 0-.1l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 23.9c0 0 0 0 0 .1l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-151.9c0 0 0 0 0-.1zm32 232a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faAllergies = faHandDots;
  

  
  

  var faArrowDownToDottedLine = {
    prefix: 'fal',
    iconName: 'arrow-down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e095',
      
      'M363.3 219.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4 208 192l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144 0 105.4L340.7 196.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faClockTwelveThirty = {
    prefix: 'fal',
    iconName: 'clock-twelve-thirty',
    icon: [
      512,
      512,
      [],
      'e359',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 144l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faOnion = {
    prefix: 'fal',
    iconName: 'onion',
    icon: [
      448,
      512,
      [129477],
      'e427',
      
      'M195.8 0c2.7 0 5.3 .5 7.7 1.5c0 0 .1 0 .1 0c3.2 1.4 6 3.5 8.1 6.3c0 0 0 0 0 0c.7 .9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3c0 0 0 0 0 0c2.1-2.8 4.9-5 8.1-6.3c0 0 .1 0 .1 0c2.4-1 5-1.5 7.7-1.5c10.9 0 19.6 9 21.3 19.8c2.1 13.6 6.5 25.6 12.4 36.6l.1 0s0 0 0 0s0 0 0 0l.1 .1 .2 .4 .7 1.4 1.2 2.2c15.3 25.7 39.5 45.4 64.5 65.7C399 163.7 448 203.5 448 288c0 83.4-62.5 139.3-140.4 163.1l-.1 .1-.6 .6-.2 .2c0 0 0 0-.1 .1c0 0 0 0 0 0s0 0 0 0l-.1-.1c-.1-.1-.2-.2-.3-.4l-.1 0 13.1 39.4c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-14-42c-11.5 2.1-23.1 3.5-34.8 4.3l0 32.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32.6c-11.7-.8-23.3-2.2-34.8-4.3l-14 42c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2L142 451.5C63.4 428 0 372 0 288c0-84.5 49-124.3 95.3-162C120.5 105.6 144.8 85.8 160 60l1-1.8 .7-1.3 .2-.3 .1-.1c0 0 0 0 0 0s0 0 0 0l.1 0c6-11 10.3-23 12.5-36.6C176.2 9 184.9 0 195.8 0zM119.2 147.9l-4.8 3.9s0 0 0 0c-4.5 3.7-8.9 7.3-13.1 10.7C62 195.3 32 227 32 288c0 43.8 21.5 78.3 56.8 103.3c6 4.3 12.5 8.3 19.2 11.9C93.2 378.7 80 345.3 80 304c0-48.4 19.7-108.4 39.2-156.1zm48 277.2c14.6 3.4 29.6 5.5 44.9 6.4c-2.2-4.5-4.5-9.4-6.8-14.9C194.6 391.3 184 355.2 184 312c0-61.9 6.1-128.6 12.1-179.6c3-25.6 6-47.3 8.3-62.6c1.1-7.7 2.1-13.8 2.7-17.9l.2-1.3c-2.3-1-4.4-2.3-6.5-3.7c-3.4 10.4-7.7 19.9-12.9 28.7l-1.2 2.4c-2.1 4.1-5.2 10.1-8.9 17.6c-7.4 15-17.2 35.9-27.1 59.7C130.8 203.4 112 260.8 112 304c0 39.4 14.5 70.3 29.2 91.5c7.3 10.6 14.7 18.7 20.1 24.1c2.4 2.4 4.4 4.2 5.9 5.5zm80.7 5.5c14.7-1.5 29.2-4.2 43.1-8c.8-.8 1.6-1.7 2.6-2.7c5.1-5.6 12-13.8 18.9-24.3c13.8-21 27-49.9 27-83.6c0-44.9-19.7-104.3-40.5-154.1c-10.3-24.6-20.5-46.2-28.2-61.6c-3.8-7.7-7-13.9-9.3-18.1l-1.2-2.2c-5.2-8.9-9.7-18.6-13.1-29.1c-2.3 1.7-4.8 3-7.4 4.1c0 0 0 .1 0 .1l-.2 1.2c-.2 1-.4 2.6-.7 4.6c-.6 4.1-1.6 10-2.7 17.6c-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c4.7 11.2 9.4 19.9 12.8 25.8l.3 .5zm81.9-282c20.5 49.6 41.7 112.6 41.7 163.4c0 34.3-10.9 63.9-23.6 86.7c3.9-2.4 7.7-4.9 11.4-7.4c35.3-25 56.8-59.5 56.8-103.3c0-61-30-92.7-69.3-125.5c-4.1-3.5-8.5-7-13.1-10.7l-3.9-3.2z'
      
    ]
  };

  

  
  

  var faUserClock = {
    prefix: 'fal',
    iconName: 'user-clock',
    icon: [
      640,
      512,
      [],
      'f4fd',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM32 480c1.2-79.7 66.2-144 146.3-144l91.4 0c18.2 0 35.6 3.3 51.7 9.4c1.4-10.8 3.8-21.4 7-31.5c-18.4-6.4-38.2-9.9-58.8-9.9l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l365.1 0c-12.9-9.1-24.5-19.9-34.6-32L32 480zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCloudShowers = {
    prefix: 'fal',
    iconName: 'cloud-showers',
    icon: [
      512,
      512,
      [],
      'f73f',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM128 384c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm-96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z'
      
    ]
  };

  

  
  

  var faThumbsUp = {
    prefix: 'fal',
    iconName: 'thumbs-up',
    icon: [
      512,
      512,
      [61575,128077],
      'f164',
      
      'M288.8 81.7c3.5-12.8 16.7-20.3 29.5-16.8s20.3 16.7 16.8 29.5l-4.5 16.4c-5.5 20.2-13.9 39.3-24.7 56.9c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2L448 192c17.7 0 32 14.3 32 32c0 11.3-5.9 21.3-14.8 27c-7.2 4.6-9.5 13.9-5.3 21.3c2.6 4.6 4.1 10 4.1 15.7c0 12.4-7 23.1-17.3 28.5c-4.2 2.2-7.3 6.1-8.3 10.8s.1 9.5 3 13.2c4.2 5.4 6.7 12.2 6.7 19.5c0 14.2-9.2 26.3-22.1 30.4c-7.8 2.5-12.4 10.6-10.7 18.6c.5 2.2 .7 4.5 .7 6.9c0 17.7-14.3 32-32 32l-89.5 0c-15.8 0-31.2-4.7-44.4-13.4l-38.5-25.7c-9-6-16.6-13.7-22.4-22.6c-4.9-7.4-14.8-9.4-22.2-4.6s-9.4 14.8-4.6 22.2c8.1 12.3 18.7 23.1 31.4 31.6l38.5 25.7c18.4 12.3 40 18.8 62.1 18.8l89.5 0c35.3 0 64-28.7 64-64l0-.6c19.1-11.1 32-31.7 32-55.4c0-8.7-1.8-17.1-4.9-24.7C487.9 323.6 496 306.8 496 288c0-6.5-1-12.8-2.8-18.7C504.8 257.7 512 241.7 512 224c0-35.3-28.7-64-64-64l-101.6 0c6.2-13.1 11.3-26.7 15.1-40.9l4.5-16.4c8.1-29.8-9.5-60.6-39.3-68.8s-60.6 9.5-68.8 39.3l-4.5 16.4c-8.9 32.6-29.6 60.8-58.2 79l-3.1 2c-11.8 7.5-21.7 17.1-29.5 28.2c-5.1 7.2-3.3 17.2 4 22.3s17.2 3.3 22.3-4c5.4-7.7 12.2-14.4 20.4-19.5l3.1-2c35.3-22.4 60.9-57.2 71.9-97.5l4.5-16.4zM32 224l64 0 0 224-64 0 0-224zM0 224L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fal',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faIdCardClip = {
    prefix: 'fal',
    iconName: 'id-card-clip',
    icon: [
      576,
      512,
      ["id-card-alt"],
      'f47f',
      
      'M320 32l-64 0 0 64 64 0 0-64zM256 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm64 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zM64 64l128 0 0 32L64 96c-17.7 0-32 14.3-32 32l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 96l0-32 128 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64z'
      
    ]
  };

  
    var faIdCardAlt = faIdCardClip;
  

  
  

  var faEarthAsia = {
    prefix: 'fal',
    iconName: 'earth-asia',
    icon: [
      512,
      512,
      [127759,"globe-asia"],
      'f57e',
      
      'M480 256c0-91.8-55.2-170.7-134.2-205.3l-22.3 55.8c-4.8 11.9-15 20.8-27.4 24l-17 4.3c-5.6 1.4-7.9 8-4.5 12.6l16.1 21.5c10.2 13.6 10.7 32.1 1.3 46.2l-10.7 16.1c-10.4 15.6-27.9 24.9-46.6 24.9l-2.3 0c-5.4 0-9.2 5.2-7.7 10.3l6 19.9c7.4 24.8-11.1 49.8-37 49.8c-16.8 0-32.2-9.5-39.7-24.5l-9.3-18.5c-2.4-4.9-9-5.9-12.8-2.1l-15.4 15.4c-9.5 9.5-23 13.6-36.1 10.9l-42-8.4C62 407 150.5 480 256 480c47.4 0 91.4-14.7 127.6-39.9l-8.5-6.1-10.6 3.9c-27.7 10.3-58.6-2.7-70.6-29.6L288.4 396c-11.9-26.5-1.5-57.7 23.8-71.8L348.4 304l6.1-9.5c9-14 24.4-22.5 41.1-22.5s32.1 8.5 41.1 22.5l1.9 2.9 15.7-4.4c7.5-2.1 15.4-1.9 22.8 .4c2-12.2 3.1-24.7 3.1-37.4zm-11.6 68.4c-1.8-.9-3.8-1-5.6-.5l-15.8 4.4c-13.4 3.8-27.8-1.7-35.3-13.5l-2-3.1c-3.1-4.8-8.4-7.7-14.1-7.7s-11 2.9-14.1 7.7l-6.1 9.5c-2.8 4.4-6.7 8.1-11.4 10.7l-36.2 20.2c-10.9 6.1-15.3 19.4-10.2 30.8l5.5 12.4c5.2 11.5 18.4 17.1 30.3 12.7L372 401c5-1.9 10.6-1.1 15 2l22.4 16.2c27.3-25.6 48.1-58 59.9-94.5l-.9-.4zM315.6 40c-19-5.2-38.9-8-59.6-8C132.3 32 32 132.3 32 256c0 6.4 .3 12.8 .8 19l53.7 10.7c2.6 .5 5.3-.3 7.2-2.2l15.4-15.4c19.3-19.3 51.9-14 64.1 10.4l9.3 18.5c2.1 4.2 6.4 6.8 11 6.8c4.5 0 7.7-4.3 6.4-8.6l-6-19.9c-7.7-25.7 11.5-51.5 38.3-51.5l2.3 0c8 0 15.5-4 20-10.7l10.7-16.1c1.9-2.8 1.8-6.5-.3-9.2l-16.1-21.5c-17.2-22.9-5.5-55.9 22.3-62.8l17-4.3c2.5-.6 4.5-2.4 5.5-4.8L315.6 40zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm163.9 88.5l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 3c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zM366.3 143.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z'
      
    ]
  };

  
    var faGlobeAsia = faEarthAsia;
  

  
  

  var faHotel = {
    prefix: 'fal',
    iconName: 'hotel',
    icon: [
      512,
      512,
      [127976],
      'f594',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l16 0 0 448-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0 32 0 224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-448 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 0zM272 432l0 48-32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48L64 480 64 32l384 0 0 448-144 0 0-48zM320 96l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zM240 64c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zM208 224l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zm80-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zM96 96l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zm-32 96c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zm68.4 154.7C211 362.3 232.3 352 256 352s45 10.3 59.6 26.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C319 334.4 289.2 320 256 320s-63 14.4-83.5 37.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3z'
      
    ]
  };

  

  
  

  var fa9 = {
    prefix: 'fal',
    iconName: '9',
    icon: [
      320,
      512,
      [],
      '39',
      
      'M32 192c0 70.7 57.3 128 128 128c69.7 0 126.3-55.7 128-124.9c0-1 0-2 0-3.1c0-70.7-57.3-128-128-128S32 121.3 32 192zM193.2 348.5c-10.7 2.3-21.8 3.5-33.2 3.5C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 2 0 3.9-.1 5.9c-1.4 37.9-15.9 74.2-41.1 102.6L124 474.6c-5.9 6.6-16 7.2-22.6 1.3s-7.2-16-1.3-22.6l93.2-104.8z'
      
    ]
  };

  

  
  

  var faAlbumCollection = {
    prefix: 'fal',
    iconName: 'album-collection',
    icon: [
      512,
      512,
      [],
      'f8a0',
      
      'M32 16c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 0C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 64c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512l342.9 0c29 0 53.1-22.1 55.8-50.9l24.7-272c3-32.8-22.8-61.1-55.8-61.1L59.8 128zM35.9 186.2C34.6 172.1 45.7 160 59.8 160l392.4 0c14.1 0 25.2 12.1 23.9 26.2l-24.7 272c-1.1 12.4-11.5 21.8-23.9 21.8L84.5 480c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272zM256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96s128 49.3 128 96s-50.3 96-128 96zm0 32c88.4 0 160-57.3 160-128s-71.6-128-160-128s-160 57.3-160 128s71.6 128 160 128zm0-104c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20z'
      
    ]
  };

  

  
  

  var faGifts = {
    prefix: 'fal',
    iconName: 'gifts',
    icon: [
      640,
      512,
      [],
      'f79c',
      
      'M193.1 21.3c3-8.3-1.4-17.5-9.7-20.4s-17.5 1.4-20.4 9.7L144.5 62.8 127.2 10.9C124.4 2.6 115.3-2 106.9 .8S94 12.7 96.8 21.1L113 69.7 65.4 35.1c-7.1-5.2-17.2-3.6-22.4 3.5s-3.6 17.2 3.5 22.4L94.8 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l136.6 0c-5.4-9.4-8.6-20.3-8.6-32L64 480c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l160 0c13.5 0 25.1 8.4 29.8 20.3c5.7-10 13.1-18.9 21.6-26.4C263.8 106.2 245.1 96 224 96l-30.8 0 48.2-35.1c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5L176.3 68.7l16.8-47.4zM361.8 172.6L401.4 224l-9.4 0-56 0c-17.7 0-32-14.3-32-32c0-17.6 14.4-32 32.2-32c10 0 19.6 4.7 25.6 12.6zM272 192c0 11.7 3.1 22.6 8.6 32l-8.6 0c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-8.6 0c5.4-9.4 8.6-20.3 8.6-32c0-35.4-28.9-64-64.2-64c-19.9 0-38.8 9.2-51 25.1L432 211.4l-44.8-58.3c-12.2-15.8-31.1-25.1-51-25.1c-35.3 0-64.2 28.6-64.2 64zm-16 80c0-8.8 7.2-16 16-16l64 0 56 0 24 0 0 96-160 0 0-80zm0 192l0-80 160 0 0 96-144 0c-8.8 0-16-7.2-16-16zm352 0c0 8.8-7.2 16-16 16l-144 0 0-96 160 0 0 80zm0-192l0 80-160 0 0-96 24 0 56 0 64 0c8.8 0 16 7.2 16 16zM472 224l-9.4 0 39.6-51.4c6.1-7.9 15.6-12.6 25.6-12.6c17.7 0 32.2 14.4 32.2 32c0 17.7-14.3 32-32 32l-56 0z'
      
    ]
  };

  

  
  

  var faCircle4 = {
    prefix: 'fal',
    iconName: 'circle-4',
    icon: [
      512,
      512,
      [],
      'e0f1',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM229.9 129.1c8.2 3.3 12.2 12.6 8.9 20.8L183.6 288 288 288l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-128 0c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c3.3-8.2 12.6-12.2 20.8-8.9z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fal',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendarMinus = {
    prefix: 'fal',
    iconName: 'calendar-minus',
    icon: [
      448,
      512,
      [],
      'f272',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM304 352c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0z'
      
    ]
  };

  

  
  

  var faBandage = {
    prefix: 'fal',
    iconName: 'bandage',
    icon: [
      640,
      512,
      [129657,"band-aid"],
      'f462',
      
      'M480 128l0 256 80 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-80 0zm-32 0l-256 0 0 256 256 0 0-256zM160 384l0-256-80 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l80 0zm0-288l32 0 256 0 32 0 80 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80l-80 0-32 0-256 0-32 0-80 0c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l80 0zm112 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faBandAid = faBandage;
  

  
  

  var faClapperboardPlay = {
    prefix: 'fal',
    iconName: 'clapperboard-play',
    icon: [
      512,
      512,
      [],
      'e132',
      
      'M480 192l0 224c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-224 448 0zm0-32l-97.4 0 87.3-87.3C476.1 78.5 480 86.8 480 96l0 64zm-249.4 0l96-96 106.7 0-96 96-106.7 0zm-45.3 0L78.6 160l96-96 106.7 0-96 96zM64 64l65.4 0-96 96L32 160l0-64c0-17.7 14.3-32 32-32zm448 96l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64 0 16 0 16L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224 0-16 0-16zM216.1 226.2c-4.9-2.9-11.1-2.9-16.1-.1s-8.1 8.1-8.1 13.9l0 160c0 5.7 3.1 11 8.1 13.9s11.1 2.8 16.1-.1l136-80c4.9-2.9 7.9-8.1 7.9-13.8s-3-10.9-7.9-13.8l-136-80zM312.4 320L224 372 224 268l88.4 52z'
      
    ]
  };

  

  
  

  var faSensorCloud = {
    prefix: 'fal',
    iconName: 'sensor-cloud',
    icon: [
      640,
      512,
      ["sensor-smoke"],
      'e02c',
      
      'M64 64l320 0c17.7 0 32 14.3 32 32l0 129c11.2 1.4 21.9 4.2 32 8.3L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l173.8 0c-5.2-9.9-9.1-20.7-11.4-32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zM336 352c0-35.3 28.7-64 64-64c24.4 0 45.7 13.7 56.5 33.9c2.5 4.6 7 7.7 12.1 8.3s10.3-1.3 13.8-5.1C489.8 317 500.3 312 512 312c22.1 0 40 17.9 40 40c0 .4 0 .9 0 1.3c-.2 7.7 5 14.4 12.5 16.1c24.9 5.7 43.6 28 43.6 54.6c0 30.9-25.1 56-56 56l-208 0c-30.9 0-56-25.1-56-56c0-24.4 15.6-45.2 37.4-52.8c6.7-2.4 11-8.8 10.7-15.9c-.1-1.1-.1-2.2-.1-3.3zm64-96c-50.8 0-92.4 39.5-95.8 89.5C275.6 360 256 389.7 256 424c0 48.6 39.4 88 88 88l208 0c48.6 0 88-39.4 88-88c0-37.6-23.6-69.7-56.7-82.3c-5-34.9-35-61.7-71.3-61.7c-13.9 0-27 4-38 10.8c-17.6-21.3-44.2-34.8-74-34.8z'
      
    ]
  };

  
    var faSensorSmoke = faSensorCloud;
  

  
  

  var faBookUser = {
    prefix: 'fal',
    iconName: 'book-user',
    icon: [
      448,
      512,
      [],
      'f7e7',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 272c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48l-64 0z'
      
    ]
  };

  

  
  

  var faWatchSmart = {
    prefix: 'fal',
    iconName: 'watch-smart',
    icon: [
      384,
      512,
      [],
      'e2cc',
      
      'M96 48l0 16 192 0 0-16c0-8.8-7.2-16-16-16L112 32c-8.8 0-16 7.2-16 16zM64 65.6L64 48C64 21.5 85.5 0 112 0L272 0c26.5 0 48 21.5 48 48l0 17.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368L0 144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16L96 448l0 16zM80 96c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L80 96zm128 80l0 71.4 40.9 27.2c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-48-32c-4.5-3-7.1-8-7.1-13.3l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBrain = {
    prefix: 'fal',
    iconName: 'brain',
    icon: [
      512,
      512,
      [129504],
      'f5dc',
      
      'M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c23.9 13.8 40 39.7 40 69.3c0 5.1-.5 10.1-1.4 15c15.8 17.1 25.4 40 25.4 65c0 29.8-13.6 56.4-34.8 74c1.8 7.1 2.8 14.4 2.8 22c0 48.6-39.4 88-88 88c-.9 0-1.8 0-2.7 0c-13.8 23.9-39.7 40-69.3 40c-26.2 0-49.4-12.6-64-32zm16-48c0 26.5 21.5 48 48 48c20.4 0 37.9-12.8 44.8-30.8c2.7-7.1 10.1-11.3 17.6-10c3.1 .5 6.3 .8 9.5 .8c30.9 0 56-25.1 56-56c0-7.8-1.6-15.2-4.4-21.8c-3.1-7.2-.4-15.7 6.3-19.8C468 331 480 310.9 480 288c0-19.1-8.4-36.3-21.7-48.1c-4.8-4.2-6.6-10.9-4.6-17c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48l0 352z'
      
    ]
  };

  

  
  

  var faPompebled = {
    prefix: 'fal',
    iconName: 'pompebled',
    icon: [
      512,
      512,
      [],
      'e43d',
      
      'M257.2 22.7c53.3 36.8 58 117.1 21.4 183.5l-.4 .7-.5 .7c-.6 .9-.4 2 .3 2.5c.2 .2 .4 .2 .4 .2s.2 0 .2 0s.2 0 .3-.1s.3-.2 .4-.5l.4-.6 .4-.5c47.8-58 123.3-82.4 176.4-44.3c64 45.3 72.1 140.1 25.2 209.7c0 0 0 0 0 0c-83.4 123.2-257.1 185-380.5 96.5l9.3-13-9.3 13c0 0 0 0 0 0C-21.9 382.3-27.4 196.3 56.1 73.1c0 0 0 0 0 0L69.3 82 56.1 73c0 0 0 0 0 0C103.1 2.9 192.9-22.8 257.2 22.7zM238.8 48.8C192.6 16.1 122.2 31.9 82.6 90.9c0 0 0 0 0 .1C5.7 204.5 15 369.3 120.1 444.4c0 0 0 0 0 0C224.2 519 378.6 469.5 455.5 356c39.6-58.7 29.4-132.7-17.2-165.7l-.1-.1c-33.4-24-90.3-12.8-132.7 38.3c-10.7 14.7-31 18.3-46 7.5c-14.7-10.6-18.2-30.8-8.5-45.8C283.1 131.4 273.1 72.4 239 49l-.2-.1s0 0 0 0z'
      
    ]
  };

  

  
  

  var faBowlingBall = {
    prefix: 'fal',
    iconName: 'bowling-ball',
    icon: [
      512,
      512,
      [],
      'f436',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-120-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM240 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faUnicorn = {
    prefix: 'fal',
    iconName: 'unicorn',
    icon: [
      640,
      512,
      [129412],
      'f727',
      
      'M448 32l24 0 8 0 5.8 0c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1l-32 0c-8.8 0-16 7.2-16 16l0 52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9L384 472c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-137.3c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L202.2 291.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1l-33.2 0c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-28 22.7-50.7 50.7-50.7l45.3 0 40 0 88 0c8.8 0 16-7.2 16-16c0-61.9 50.1-112 112-112zM564.2 64c-2.5-12.2-7.7-23.4-15-32.9C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16L485.8 0 480 0l-8 0L448 0C373.9 0 312.8 56 304.9 128L232 128l-40 0-45.3 0c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3l33.2 0c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6 304 472c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-153.6c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2l0-40 7.4 0 1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-4.7-49.4 65.2-21.7c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3l-66.5 0zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faDice = {
    prefix: 'fal',
    iconName: 'dice',
    icon: [
      640,
      512,
      [127922],
      'f522',
      
      'M252.3 57c-15.6-15.6-40.9-15.6-56.6 0L57 195.7c-15.6 15.6-15.6 40.9 0 56.6L195.7 391c15.6 15.6 40.9 15.6 56.6 0L391 252.3c15.6-15.6 15.6-40.9 0-56.6L252.3 57zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 448l0-34.2 32-32 0 66.2c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-109.3 0c0-10.8-1.7-21.6-5-32L576 192c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSquareEnvelope = {
    prefix: 'fal',
    iconName: 'square-envelope',
    icon: [
      448,
      512,
      ["envelope-square"],
      'f199',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM352 160l0 29.2L231.3 255.6c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9L96 189.2 96 160l256 0zm0 65.7L352 352 96 352l0-126.3 105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8L352 225.7zM96 128c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L96 128z'
      
    ]
  };

  
    var faEnvelopeSquare = faSquareEnvelope;
  

  
  

  var faPersonWalkingArrowRight = {
    prefix: 'fal',
    iconName: 'person-walking-arrow-right',
    icon: [
      640,
      512,
      [],
      'e552',
      
      'M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm419.1-190c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5L579.8 240 384 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l195.8 0-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80z'
      
    ]
  };

  

  
  

  var faRectangleBarcode = {
    prefix: 'fal',
    iconName: 'rectangle-barcode',
    icon: [
      576,
      512,
      ["barcode-alt"],
      'f463',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm288 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm80-16c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM160 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm80-16c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z'
      
    ]
  };

  
    var faBarcodeAlt = faRectangleBarcode;
  

  
  

  var faSquareS = {
    prefix: 'fal',
    iconName: 'square-s',
    icon: [
      448,
      512,
      [],
      'e27d',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160.7 94c-1.5 8.5-.5 14.1 1.5 18.2c2 4.2 5.7 8.3 11.7 12.3c12.8 8.4 31.8 13.9 54.4 20.1l1.5 .4c20.7 5.7 44.5 12.3 62 23.8c9.3 6.1 17.7 14.3 23 25.2c5.3 11.1 6.6 23.8 4 37.7c-4.5 24.3-21.6 40.2-43.1 48.5c-21.1 8.1-47.2 9.5-74.1 5.6c0 0-.1 0-.1 0c0 0 0 0 0 0c-17-2.6-46.2-11.2-61.2-15.9c-8.4-2.6-13.1-11.6-10.5-20.1s11.6-13.1 20.1-10.5c15.2 4.8 42.2 12.6 56.4 14.8c23.4 3.4 43.6 1.8 57.9-3.8c13.9-5.4 21.2-13.8 23.1-24.4c1.5-8.5 .5-14.1-1.5-18.2c-2-4.2-5.7-8.3-11.7-12.3c-12.8-8.4-31.8-13.9-54.4-20.1l-1.5-.4s0 0 0 0c-20.7-5.7-44.5-12.3-62-23.8c-9.3-6.1-17.7-14.3-23-25.2c-5.3-11.1-6.6-23.8-4-37.7c4.5-24.3 21.6-40.2 43.1-48.5c21.1-8.1 47.2-9.5 74.1-5.6c8.4 1.2 25.9 5 34.1 7c8.6 2.2 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6c-7.6-1.9-24-5.4-31-6.4c-23.4-3.5-43.6-1.8-57.9 3.8c-13.9 5.4-21.2 13.8-23.1 24.4z'
      
    ]
  };

  

  
  

  var faTurnDown = {
    prefix: 'fal',
    iconName: 'turn-down',
    icon: [
      384,
      512,
      [10549,"level-down-alt"],
      'f3be',
      
      'M128 352l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.9 .8 3.7 2.2 5L192 476.2 317.8 363.7c1.4-1.3 2.2-3.1 2.2-5c0-3.7-3-6.7-6.7-6.7L256 352c-17.7 0-32-14.3-32-32l0-176c0-61.9-50.1-112-112-112L48 32c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l64 0c26.5 0 48 21.5 48 48l0 176c0 17.7-14.3 32-32 32zm78 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L44.9 387.5C36.7 380.2 32 369.7 32 358.7C32 337.3 49.3 320 70.7 320L96 320l32 0 0-32 0-144c0-8.8-7.2-16-16-16l-64 0C21.5 128 0 106.5 0 80L0 48C0 21.5 21.5 0 48 0l64 0c79.5 0 144 64.5 144 144l0 144 0 32 32 0 25.3 0c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.5-12.9 28.8L206 506.7z'
      
    ]
  };

  
    var faLevelDownAlt = faTurnDown;
  

  
  

  var faWheelchairMove = {
    prefix: 'fal',
    iconName: 'wheelchair-move',
    icon: [
      448,
      512,
      ["wheelchair-alt"],
      'e2ce',
      
      'M368 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 368 0zM199.5 106.9c-11.9-4.9-25.6-2.1-34.7 7l-41.4 41.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l41.4-41.4c18.2-18.2 45.6-23.7 69.5-14L313.5 119c31.7 13 40 54.1 15.8 78.4l-49.1 49.1c6.9 7.9 13.1 16.4 18.4 25.6l113.5 0c20.5 0 35.7 19 31.2 38.9L415.6 435.5c-1.9 8.6-10.5 14.1-19.1 12.1s-14.1-10.5-12.1-19.1L412.1 304l-99.4 0c4.8 15.2 7.3 31.3 7.3 48c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c5.6 0 11.1 .3 16.5 .8l67.7-67.7-44.7-18.3zm107.2 67.8c8.1-8.1 5.3-21.8-5.3-26.1l-25.1-10.3-62.8 62.8c15.7 5.6 30.3 13.5 43.3 23.4l49.9-49.9zM160 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  
    var faWheelchairAlt = faWheelchairMove;
  

  
  

  var faFaceGrimace = {
    prefix: 'fal',
    iconName: 'face-grimace',
    icon: [
      512,
      512,
      [128556,"grimace"],
      'f57f',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-176 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGrimace = faFaceGrimace;
  

  
  

  var faChessPawnPiece = {
    prefix: 'fal',
    iconName: 'chess-pawn-piece',
    icon: [
      256,
      512,
      ["chess-pawn-alt"],
      'f444',
      
      'M176 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16 80l-6.1 0 10.7 96-32.2 0-10.7-96L128 256l-25.7 0L91.6 352l-32.2 0 10.7-96L64 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 18-6 34.6-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-1.8 128c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4L39.4 512C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1l124.4 0zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4l177.1 0c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416 33.1 468.7z'
      
    ]
  };

  
    var faChessPawnAlt = faChessPawnPiece;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fal',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      'M171.3 4.7c-6.1-6.1-15.9-6.3-22.2-.4l-104 96c-6.5 6-6.9 16.1-.9 22.6s16.1 6.9 22.6 .9L144 52.5l0 404.8L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4l0-402.7 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faWaterLadder = {
    prefix: 'fal',
    iconName: 'water-ladder',
    icon: [
      576,
      512,
      ["ladder-water","swimming-pool"],
      'f5c5',
      
      'M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 112.2 224 0L384 112c0-44.2 35.8-80 80-80s80 35.8 80 80l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 128.2 0 138.1c-10.8 4-21.8 6.2-32 6.2c0 0 0 0 0 0l0-128.3-224 0 0 122.1c-9.5-3.5-18.8-8.3-27.1-14.1c-1.6-1.1-3.2-2.2-4.9-3.1l0-120.9L128 112zm64 336c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z'
      
    ]
  };

  
    var faLadderWater = faWaterLadder;
  
    var faSwimmingPool = faWaterLadder;
  

  
  

  var faCalendarDay = {
    prefix: 'fal',
    iconName: 'calendar-day',
    icon: [
      448,
      512,
      [],
      'f783',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zm40 160l80 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8zm-40 8l0 80c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faBellRing = {
    prefix: 'fal',
    iconName: 'bell-ring',
    icon: [
      512,
      512,
      [],
      'e62c',
      
      'M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L76.3 416C51.8 416 32 396.2 32 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C78.6 306.7 96 264.8 96 221.1L96 192c0-83 63.1-151.2 144-159.2L240 16zm16 48c-70.7 0-128 57.3-128 128l0 29.1c0 52.2-20.7 102.3-57.7 139.2L67.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM225.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C307.6 494.2 283.9 512 256 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM119.4 21.8c5.7 6.8 4.7 16.9-2.1 22.5C74.9 79.5 48 132.6 48 192c0 8.8-7.2 16-16 16s-16-7.2-16-16C16 122.7 47.5 60.8 96.9 19.7c6.8-5.7 16.9-4.7 22.5 2.1zM397.8 44.3c-6.8-5.7-7.7-15.7-2.1-22.5s15.7-7.7 22.5-2.1c49.4 41.1 80.9 103 80.9 172.3c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-59.4-26.9-112.5-69.3-147.7z'
      
    ]
  };

  

  
  

  var faAudioDescriptionSlash = {
    prefix: 'fal',
    iconName: 'audio-description-slash',
    icon: [
      640,
      512,
      [],
      'e0a8',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448L96 448c-17.7 0-32-14.3-32-32l0-280.6L32 110.2 32 416c0 35.3 28.7 64 64 64l404.4 0-40.5-32zM544 32L139.6 32l40.5 32L544 64c17.7 0 32 14.3 32 32l0 280.6 32 25.3L608 96c0-35.3-28.7-64-64-64zM512 256c0-53-43-96-96-96l-64 0c-8.8 0-16 7.2-16 16l0 11.1 32 25.3 0-20.4 48 0c35.3 0 64 28.7 64 64c0 13.4-4.1 25.8-11.1 36l25.2 19.9c11.3-15.7 17.9-35 17.9-55.9zM129.7 328.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 304l92.2 0 19.6 39.2c4 7.9 13.6 11.1 21.5 7.2c5.1-2.6 8.3-7.5 8.8-12.8L237 272l-43.1 0 12.2-24.4-25.7-20.3L129.7 328.8z'
      
    ]
  };

  

  
  

  var faFileSpreadsheet = {
    prefix: 'fal',
    iconName: 'file-spreadsheet',
    icon: [
      384,
      512,
      [],
      'f65b',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM96 384l80 0 0 32-80 0 0-32zm0-32l0-32 80 0 0 32-80 0zm112 64l0-32 80 0 0 32-80 0zm0-64l0-32 80 0 0 32-80 0zm112 16l0-16 0-32 0-16 0-16 0-32c0-17.7-14.3-32-32-32l-96 0-96 0c-17.7 0-32 14.3-32 32l0 32 0 16 0 16 0 32 0 16 0 16 0 32c0 17.7 14.3 32 32 32l80 0 16 0 16 0 80 0c17.7 0 32-14.3 32-32l0-32 0-16zM288 256l0 32-96 0-96 0 0-32 96 0 96 0z'
      
    ]
  };

  

  
  

  var faWheat = {
    prefix: 'fal',
    iconName: 'wheat',
    icon: [
      512,
      512,
      [],
      'f72d',
      
      'M433.1 36c-28.7 1.4-51.7 24.4-53.1 53.1l-2.3 45.2 45.2-2.3c28.7-1.4 51.7-24.4 53.1-53.1l2.3-45.2L433.1 36zM348 87.5C350.3 42.4 386.4 6.3 431.5 4l54-2.7c14.2-.7 25.9 11 25.2 25.2l-2.7 54c-2.3 45.1-38.3 81.2-83.5 83.5l-16.9 .8c23.1 5 45.2 16.6 63.2 34.6L493.4 222c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-17.4 17.4-39.8 26.7-62.5 28l6 6c6.2 6.2 6.2 16.4 0 22.6L369 369c-17.4 17.4-39.8 26.7-62.5 28l6 6c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-37.5 37.5-98.3 37.5-135.8 0l-33.9-33.9s0 0 0 0L27.3 507.1c-6.2 6.2-16.4 6.3-22.6 0s-6.2-16.4 0-22.6L86.2 403 52.3 369.1c-37.5-37.5-37.5-98.3 0-135.8l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0L312.4 41c18.3 18.3 29.9 40.7 34.8 64.2l.9-17.7zm88.8 168.4l22.6-22.6L448.1 222c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm-181-90.5l33.9 33.9 1.5-1.5c36-37.6 35.5-97.3-1.5-134.3L278.5 52.3 255.9 74.9c-25 25-25 65.5 0 90.5zm-56.6-11.3L188 142.8l-22.6 22.6c-25 25-25 65.5 0 90.5l33.9 33.9 1.3-1.3c36.2-37.6 35.8-97.4-1.3-134.5zM108.8 380.3l.8-.8c36.7-37.6 36.4-97.7-.8-135L97.5 233.3 74.9 255.9c-25 25-25 65.5 0 90.5l33.9 33.9zm147.1 56.5l22.6-22.6L267.2 403c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm90.5-90.5l22.6-22.6-11.3-11.3c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0z'
      
    ]
  };

  

  
  

  var faTurnLeft = {
    prefix: 'fal',
    iconName: 'turn-left',
    icon: [
      512,
      512,
      [],
      'e636',
      
      'M160 304l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L35.8 240 148.3 114.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 57.3c0 17.7 14.3 32 32 32l176 0c61.9 0 112 50.1 112 112l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112c0-26.5-21.5-48-48-48l-176 0c-17.7 0-32 14.3-32 32zM5.3 226C1.9 229.9 0 234.8 0 240s1.9 10.1 5.3 14L124.5 387.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-25.3 0-32 32 0 144 0c8.8 0 16 7.2 16 16l0 112c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-112c0-79.5-64.5-144-144-144l-144 0-32 0 0-32 0-25.3C192 97.3 174.7 80 153.3 80c-11 0-21.5 4.7-28.8 12.9L5.3 226z'
      
    ]
  };

  

  
  

  var faCircleCaretRight = {
    prefix: 'fal',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm352 0c0-9.6-4-18.7-11-25.2L238.2 135.3c-5.1-4.7-11.8-7.3-18.7-7.3c-15.2 0-27.5 12.3-27.5 27.5l0 201c0 15.2 12.3 27.5 27.5 27.5c6.9 0 13.6-2.6 18.7-7.3L341 281.2c7-6.5 11-15.6 11-25.2zm-32.7-1.7c.5 .4 .7 1.1 .7 1.7s-.3 1.3-.7 1.7L224 346.2l0-180.3 95.3 88.4z'
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faHands = {
    prefix: 'fal',
    iconName: 'hands',
    icon: [
      576,
      512,
      ["sign-language","signing"],
      'f2a7',
      
      'M439.9 395.4c11.5-2.6 22.9-6.3 34-11.4c62.7-28.4 102.7-91 102.2-159.8l-.5-75.6c-.2-26.5-21.8-47.8-48.3-47.7c-19.5 .1-36.2 11.9-43.6 28.6L439 31C428.1 6.8 399.7-3.9 375.5 7c-5.7 2.6-10.6 6.1-14.7 10.4C347.3 1.1 324.2-4.8 304 4.3s-31 30.5-27.6 51.3c-5.9 .3-11.8 1.7-17.5 4.2c-19.3 8.8-30 28.7-27.9 48.7l40.4 17.5-7.2-15.9c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8L315.1 145l10.2 4.4 .4 .2s0 0 0 0c12.8 5.7 24.8 12.6 35.9 20.5L322.4 83.8 309.2 54.6c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l13.2 29.1L391.2 158c3.6 8 13.1 11.6 21.2 8s11.6-13.1 8-21.2L380.7 57.4c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l71.5 157.8c3.1 6.9 10.6 10.6 18 9s12.6-8.2 12.6-15.7l-.3-46.2c-.1-8.8 7.1-16 15.9-16.1s16.1 7.1 16.1 15.9l.5 75.7c.4 56.1-32.3 107.3-83.5 130.4c-4.6 2.1-9.2 3.9-13.9 5.4c-1.3 12-3.6 23.8-6.9 35.1zm-209.4-218l69.1 30.7c51.3 22.8 84.4 73.7 84.4 129.8C384 416.4 320.4 480 241.9 480L112 480c-8.8 0-16-7.2-16-16c0-8.8 7.1-16 16-16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64.1 0L96 416c0 0 0 0 0 0l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16c0 0 0 0 0 0l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 352c0 0 0 0 0 0l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c0 0 0 0 0 0l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16c0-8.8 7.2-16 16-16l173.2 0c7.6 0 14.1-5.3 15.7-12.7s-2.2-14.9-9.2-17.9l-42.2-18.8c-8.1-3.6-11.7-13-8.1-21.1s13-11.7 21.1-8.1zM67.4 446.3C65.2 451.8 64 457.8 64 464c0 26.5 21.5 48 48 48l129.9 0C338.1 512 416 434.1 416 337.9c0-68.8-40.5-131.1-103.4-159.1l-69.1-30.7c-24.2-10.8-52.6 .1-63.4 24.4c-7.9 17.8-4.1 37.8 8.1 51.5L80 224c-26.5 0-48 21.5-48 48c0 6.2 1.2 12.2 3.4 17.7C15 295.2 0 313.9 0 336s15 40.8 35.4 46.3C33.2 387.8 32 393.8 32 400c0 22.1 15 40.8 35.4 46.3z'
      
    ]
  };

  
    var faSignLanguage = faHands;
  
    var faSigning = faHands;
  

  
  

  var faLifeRing = {
    prefix: 'fal',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      'M402.7 425.3C363.4 459.4 312.1 480 256 480s-107.4-20.6-146.7-54.7l91.1-91C216.1 345.4 235.3 352 256 352s39.9-6.6 55.6-17.7l91.1 91zm22.6-22.6l-91-91.1C345.4 295.9 352 276.7 352 256s-6.6-39.9-17.7-55.6l91-91.1C459.4 148.6 480 199.9 480 256s-20.6 107.4-54.7 146.7zM448 425.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0S131.8 24.2 86.6 64L75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L64 86.6C24.2 131.8 0 191.1 0 256s24.2 124.2 64 169.4L52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448c45.1 39.8 104.4 64 169.4 64s124.2-24.2 169.4-64l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L448 425.4zM402.7 86.7l-91.1 91.1C295.9 166.6 276.7 160 256 160s-39.9 6.6-55.6 17.7L109.3 86.7C148.6 52.6 199.9 32 256 32s107.4 20.6 146.7 54.7zM177.7 311.6L86.7 402.7C52.6 363.4 32 312.1 32 256s20.6-107.4 54.7-146.7l91.1 91.1C166.6 216.1 160 235.3 160 256s6.6 39.9 17.7 55.6zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faMoneyBill1Wave = {
    prefix: 'fal',
    iconName: 'money-bill-1-wave',
    icon: [
      576,
      512,
      ["money-bill-wave-alt"],
      'f53b',
      
      'M32 112.5c0 0 0 0 0-.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c.1-.1 .4-.6 1.3-1.2c2-1.3 4.7-1.8 6.9-1.2c18.7 5.1 37.3 8.1 55.8 9.5l0 .5c0 35.3-28.7 64-64 64l0-71.5zm0 309.9L32 376c35.3 0 64 28.7 64 64l0 6.8c-19.5-1.9-38.7-6-57.8-13.2c-2.5-.9-6.2-4.5-6.2-11.3zM128 440c0-53-43-96-96-96l0-128c52.9 0 95.8-42.8 96-95.6c57.8-1 113.9-15.3 165.7-28.6c4.4-1.1 8.7-2.2 13-3.3C356.9 75.8 403.3 65 448 64l0 8c0 53 43 96 96 96l0 128c-52.9 0-95.8 42.8-96 95.6c-57.8 1-113.9 15.3-165.7 28.6c-4.4 1.1-8.7 2.2-13 3.3C219.1 436.2 172.7 447 128 448l0-8zm352-47.5l0-.5c0-35.3 28.7-64 64-64l0 71.5c0 .1 0 .1 0 .1s0 0 0 0c-.1 .1-.4 .6-1.3 1.2c-2 1.3-4.7 1.8-6.9 1.2c-18.6-5.1-37.3-8.1-55.8-9.5zm0-327.3c19.5 1.9 38.7 6 57.8 13.2c2.5 .9 6.2 4.5 6.2 11.3l0 46.3c-35.3 0-64-28.7-64-64l0-6.8zM0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM400 256c0-65-44.9-128-112-128s-112 63-112 128s44.9 128 112 128s112-63 112-128zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM272 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0z'
      
    ]
  };

  
    var faMoneyBillWaveAlt = faMoneyBill1Wave;
  

  
  

  var faEngine = {
    prefix: 'fal',
    iconName: 'engine',
    icon: [
      640,
      512,
      [],
      'e16e',
      
      'M416 80c0 8.8-7.2 16-16 16l-80 0 0 32 16 0 60.6 0c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L144 384c-26.5 0-48-21.5-48-48l0-64-8 0-56 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 56 0 8 0 0-64c0-26.5 21.5-48 48-48l16 0 128 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16zM304 160l-144 0-16 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l28.8 0c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12L448 416c17.7 0 32-14.3 32-32l0-157.7c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4L336 160l-32 0s0 0 0 0s0 0 0 0zM168 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-32l0 192 32 0 0-192-32 0zm-32 0c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192z'
      
    ]
  };

  

  
  

  var faTire = {
    prefix: 'fal',
    iconName: 'tire',
    icon: [
      512,
      512,
      [],
      'f631',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm319.9 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-9.9 30.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zM240 383l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4zM130.3 280.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2zm102.1-83.7c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faScannerGun = {
    prefix: 'fal',
    iconName: 'scanner-gun',
    icon: [
      576,
      512,
      ["scanner"],
      'f488',
      
      'M112 64c-44.2 0-80 35.8-80 80s35.8 80 80 80l130.9 0 37.1 0 24 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L112 64zM80 251.4C33.8 237.6 0 194.7 0 144C0 82.1 50.1 32 112 32l192 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-42.8 0L144.3 454.6c-13.4 22.8-42.9 30.5-65.7 17L25.2 440.2C2.4 426.8-5.2 397.5 8.1 374.7L80 251.4zm34.3 4.6L35.7 390.8c-4.4 7.6-1.9 17.4 5.7 21.9l53.4 31.4c7.6 4.5 17.4 1.9 21.9-5.7L224.1 256l-109.7 0zM432 32l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L432 64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm16 80l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm16 48l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM416 464c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faScanner = faScannerGun;
  

  
  

  var faAlignRight = {
    prefix: 'fal',
    iconName: 'align-right',
    icon: [
      448,
      512,
      [],
      'f038',
      
      'M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16L176 80c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 208c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0zm16 144c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 464c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0z'
      
    ]
  };

  

  
  

  var faWindowFlip = {
    prefix: 'fal',
    iconName: 'window-flip',
    icon: [
      512,
      512,
      ["window-alt"],
      'f40f',
      
      'M448 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l384 0zm64 32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320zm-96 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faWindowAlt = faWindowFlip;
  

  
  

  var faInputText = {
    prefix: 'fal',
    iconName: 'input-text',
    icon: [
      640,
      512,
      [],
      'e1bf',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm176 32c6.5 0 12.4 4 14.9 10.1l64 160c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9L216.4 320l-.4 0-80 0-.4 0-8.8 21.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l64-160c2.4-6.1 8.3-10.1 14.9-10.1zm0 59.1L148.4 288l55.1 0L176 219.1zM288 176c0-8.8 7.2-16 16-16l56 0c30.9 0 56 25.1 56 56c0 12.1-3.8 23.3-10.4 32.5C421.5 258.4 432 276 432 296c0 30.9-25.1 56-56 56l-72 0c-8.8 0-16-7.2-16-16l0-16 0-64 0-64 0-16zm72 96l-40 0 0 48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm0-32c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0 48 40 0z'
      
    ]
  };

  

  
  

  var faHandHoldingBox = {
    prefix: 'fal',
    iconName: 'hand-holding-box',
    icon: [
      576,
      512,
      [],
      'f47b',
      
      'M208 32l0 96c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7L288 113.9l56.8 28.4c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6l0-96 64 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l64 0zM224 0L144 0C117.5 0 96 21.5 96 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L352 0 224 0zm16 32l96 0 0 70.1L295.2 81.7c-4.5-2.3-9.8-2.3-14.3 0L240 102.1 240 32zM195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368 16 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 4.8 0 4-2.7 79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1L344 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 24 0 60.6 0c2.9 0 5.7-.8 8.2-2.3L511.3 355c3.4-2 7.2-3 11.1-3l1.3 0c11.2 0 20.3 9.1 20.3 20.3c0 6.9-3.5 13.3-9.2 17L415.1 467.1c-13 8.4-28.1 12.9-43.6 12.9L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l355.5 0c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3l-1.3 0c-9.7 0-19.1 2.6-27.5 7.6L400.2 384l-5.6 0c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56l-148.6 0z'
      
    ]
  };

  

  
  

  var faDungeon = {
    prefix: 'fal',
    iconName: 'dungeon',
    icon: [
      512,
      512,
      [],
      'f6d9',
      
      'M319.3 163.6c6.2 4.2 11.9 9.1 17.1 14.4c6.1 6.3 14 11 22.7 13.5c-1.6 8.9-.8 18 2.2 26.2c3 8.2 5 16.9 6 25.9c1.1 10.4 5.7 20.5 12.9 28.5c-7.6 8.5-12.2 19.7-12.2 32l0 48c0 12.3 4.6 23.5 12.2 32c-7.6 8.5-12.2 19.7-12.2 32l0 48c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32l0-48c0-12.3-4.6-23.5-12.2-32c7.9-8.8 12.6-20.7 11.6-34.2c-2.1-30.4-9.6-59.3-21.4-85.8c-6.1-13.8-17.3-22.4-29.8-25.8c2.1-12.8-1-26.6-10.8-37.9c-17.9-20.6-39-38.3-62.5-52.3c-13-7.7-27.1-8.3-39.3-3.9c-5.7-11.7-16.2-21.1-30.8-24.7C297.2 2.5 276.9 0 256 0s-41.2 2.5-60.7 7.2c-14.6 3.6-25.1 13-30.8 24.7c-12.2-4.4-26.3-3.8-39.3 3.9c-23.6 14-44.7 31.7-62.5 52.3c-9.8 11.3-13 25.1-10.8 37.9c-12.5 3.5-23.7 12.1-29.8 25.8C10.2 178.5 2.8 207.4 .6 237.8c-1 13.5 3.7 25.4 11.6 34.2C4.6 280.5 0 291.7 0 304l0 48c0 12.3 4.6 23.5 12.2 32C4.6 392.5 0 403.7 0 416l0 48c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32l0-48c0-12.3-4.6-23.5-12.2-32c7.2-8 11.7-18.1 12.9-28.5c1-9 3.1-17.7 6-25.9c3-8.2 3.8-17.4 2.2-26.2c8.7-2.4 16.6-7.2 22.7-13.5c5.2-5.3 10.9-10.2 17.1-14.4c7.2-4.9 13.2-11.9 17.1-20c8.5 3 17.6 3.8 26.2 2.2c6.5-1.2 13.2-1.8 20-1.8s13.5 .6 20 1.8c8.6 1.5 17.7 .8 26.2-2.2c3.9 8.1 9.9 15.1 17.1 20zm62-5s0 0 0 0c-6.9 4.6-16.2 3.1-22-2.9c-6.7-6.9-14-13.1-21.9-18.5c-6.7-4.6-9.8-13.1-6.8-20.6l.2-.6c0 0 0 0 0 0l17.9-44.8c3.5-8.7 13.6-12.6 21.6-7.8c20.6 12.3 39.1 27.8 54.8 45.8c6 6.9 4.2 17.4-3.5 22.5l-1 .7s0 0 0 0l-39.4 26.2zm16.2 27.6l1.5-1c0 0 0 0 0 0L438.4 159s0 0 0 0c7.8-5.2 18.5-2.6 22.3 6c10.3 23.2 16.8 48.5 18.7 75.1c.6 8.8-6.6 16-15.4 16l-48 0c-8.8 0-15.9-7.2-16.9-16c-1.3-11.6-3.9-22.7-7.8-33.3c-2.7-7.5-.5-16.1 6.2-20.5zM416 400l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM193 59.3c0 0 0 0 0 0l-.2-.4c-3.4-8.6 1.1-18.3 10.1-20.5c17-4.1 34.8-6.3 53.1-6.3s36.1 2.2 53.1 6.3c9 2.2 13.5 11.9 10.1 20.5l-.2 .4c0 0 0 0 0 .1l-17.9 44.8s0 0 0 0c-3.1 7.6-11.4 11.6-19.4 10.1c-8.3-1.5-16.9-2.3-25.7-2.3s-17.3 .8-25.7 2.3c-8.1 1.5-16.4-2.5-19.4-10.1c0 0 0 0 0 0L193 59.3zm-51.3 4.1c8-4.8 18.2-.9 21.6 7.8c0 0 0 0 0 0L181.2 116s0 0 0 0l.2 .6c3 7.5-.1 16-6.8 20.6c-7.9 5.4-15.3 11.6-21.9 18.5c-5.8 6-15.1 7.5-22 2.9L91.4 132.3s0 0 0 0l-1-.7c-7.6-5.1-9.5-15.6-3.5-22.5c15.7-18 34.1-33.5 54.8-45.8zM51.3 165c3.8-8.6 14.5-11.2 22.3-6L113 185.2s0 0 0 0l1.5 1c6.6 4.4 8.9 13 6.2 20.5c-3.9 10.6-6.5 21.7-7.8 33.3c-1 8.8-8 16-16.9 16l-48 0c-8.8 0-16.1-7.2-15.4-16c1.9-26.6 8.4-51.9 18.7-75.1zM112 304l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16zm288 0c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM32 416c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240z'
      
    ]
  };

  

  
  

  var faRoadCircleExclamation = {
    prefix: 'fal',
    iconName: 'road-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e565',
      
      'M157.5 74c9.2-25.2 33.2-42 60.1-42l204.9 0c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21L336 64l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-86.4 0c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43l238.5 0c5.9 11.4 12.9 22.2 21 32l-259.6 0c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208l0 86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPaperPlane = {
    prefix: 'fal',
    iconName: 'paper-plane',
    icon: [
      512,
      512,
      [61913],
      'f1d8',
      
      'M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8 .1 290s8.4 22.9 19.6 27.6L160 376l0 93c0 23.8 19.3 43 43 43c13.1 0 25.4-5.9 33.6-16.1l52.8-66 .1 0 114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2l-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1c-6.1 0-11-4.9-11-11l0-79.7 66.6 27.8zm43.1-16.7l-96.6-40.3L474.1 70.5 416 448 301.8 400.4zM450.5 48.8L173.6 347 32 288 450.5 48.8z'
      
    ]
  };

  

  
  

  var faColumns3 = {
    prefix: 'fal',
    iconName: 'columns-3',
    icon: [
      640,
      512,
      [],
      'e361',
      
      'M448 64l0 384 128 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L448 64zm-32 0L224 64l0 384 192 0 0-384zM192 448l0-384L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l128 0zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faRightLeft = {
    prefix: 'fal',
    iconName: 'right-left',
    icon: [
      512,
      512,
      ["exchange-alt"],
      'f362',
      
      'M352 222.7c0 18.4 14.9 33.3 33.3 33.3c8.4 0 16.4-3.1 22.6-8.8l99-91.4c3.3-3 5.1-7.3 5.1-11.8s-1.9-8.7-5.1-11.8l-99-91.4c-6.1-5.7-14.2-8.8-22.6-8.8C366.9 32 352 46.9 352 65.3l0 62.7L16 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l336 0 0 62.7zm33.3 1.3c-.7 0-1.3-.6-1.3-1.3l0-157.5c0-.7 .6-1.3 1.3-1.3c.3 0 .6 .1 .9 .3L472.4 144l-86.3 79.7c-.2 .2-.5 .3-.9 .3zM126.7 480c18.4 0 33.3-14.9 33.3-33.3l0-62.7 336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-336 0 0-62.7c0-18.4-14.9-33.3-33.3-33.3c-8.4 0-16.4 3.1-22.6 8.8l-99 91.4C1.9 359.3 0 363.5 0 368s1.9 8.7 5.1 11.8l99 91.4c6.1 5.7 14.2 8.8 22.6 8.8zm1.3-33.3c0 .7-.6 1.3-1.3 1.3c-.3 0-.6-.1-.9-.3L39.6 368l86.3-79.7c.2-.2 .5-.3 .9-.3c.7 0 1.3 .6 1.3 1.3l0 157.5z'
      
    ]
  };

  
    var faExchangeAlt = faRightLeft;
  

  
  

  var faMessageDollar = {
    prefix: 'fal',
    iconName: 'message-dollar',
    icon: [
      512,
      512,
      ["comment-alt-dollar"],
      'f650',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM272 104c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0s0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z'
      
    ]
  };

  
    var faCommentAltDollar = faMessageDollar;
  

  
  

  var faGridHorizontal = {
    prefix: 'fal',
    iconName: 'grid-horizontal',
    icon: [
      448,
      512,
      [],
      'e307',
      
      'M40 160c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0zM0 168c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM40 320c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0zM0 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM248 160l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8zm-48-32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0zm-40 8c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM408 160l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8zm-48-32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0zm-40 8c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48z'
      
    ]
  };

  

  
  

  var faCircleO = {
    prefix: 'fal',
    iconName: 'circle-o',
    icon: [
      512,
      512,
      [],
      'e119',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z'
      
    ]
  };

  

  
  

  var faScannerKeyboard = {
    prefix: 'fal',
    iconName: 'scanner-keyboard',
    icon: [
      512,
      512,
      [],
      'f489',
      
      'M128 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM400 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l224 0zM64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm40 96l144 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-144 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l144 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-144 0c-22.1 0-40 17.9-40 40zM80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM64 400c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-80c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm-16 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faHillRockslide = {
    prefix: 'fal',
    iconName: 'hill-rockslide',
    icon: [
      576,
      512,
      [],
      'e508',
      
      'M238.5 127.7c-5.5-9.7-5.5-21.6 0-31.4l27-48C271.1 38.2 281.8 32 293.4 32l53.3 0c11.6 0 22.2 6.2 27.9 16.3l27 48c5.5 9.7 5.5 21.6 0 31.4l-27 48c-5.7 10.1-16.3 16.3-27.9 16.3l-53.3 0c-11.6 0-22.2-6.2-27.9-16.3l-27-48zM293.4 64l-27 48 27 48 53.3 0 27-48-27-48-53.3 0zM32 118.6L32 448c0 17.7 14.3 32 32 32l329.4 0L32 118.6zm-32 0C0 90.1 34.5 75.8 54.6 96L416 457.4c20.2 20.2 5.9 54.6-22.6 54.6L64 512c-35.3 0-64-28.7-64-64L0 118.6zM432.3 406.5c-10.1-5.7-16.3-16.3-16.3-27.9l0-53.3c0-11.6 6.2-22.2 16.3-27.9l48-27c9.7-5.5 21.6-5.5 31.4 0l48 27c10.1 5.7 16.3 16.3 16.3 27.9l0 53.3c0 11.6-6.2 22.2-16.3 27.9l-48 27c-9.7 5.5-21.6 5.5-31.4 0l-48-27zm63.7-.9l48-27 0-53.3-48-27-48 27 0 53.3 48 27zM128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMaskFace = {
    prefix: 'fal',
    iconName: 'mask-face',
    icon: [
      640,
      512,
      [],
      'e1d7',
      
      'M320 96c20.9 0 41.3 6.2 58.6 17.8l37.1 24.8c21 14 45.7 21.5 71 21.5l17.2 0 8 0 0 64c0 106-86 192-192 192s-192-86-192-192l0-64 8 0 16 0 1.2 0c25.3 0 50-7.5 71-21.5l37.1-24.8C278.7 102.2 299.1 96 320 96zM153.2 128l-1.2 0-16 0-8 0-80 0c-26.5 0-48 21.5-48 48l0 85c0 51.4 35 96.2 84.8 108.7l71.3 17.8 14.9 3.7c39.6 35.3 91.8 56.8 149 56.8s109.4-21.5 149-56.8l14.9-3.7 71.3-17.8C605 357.2 640 312.4 640 261l0-85c0-26.5-21.5-48-48-48l-80 0-8 0-17.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1zM48 160l48 0 0 64c0 46.3 14 89.3 38.1 125L92.6 338.7C57 329.8 32 297.8 32 261l0-85c0-8.8 7.2-16 16-16zM547.4 338.7L505.9 349c24.1-35.7 38.1-78.7 38.1-125l0-64 48 0c8.8 0 16 7.2 16 16l0 85c0 36.7-25 68.7-60.6 77.6zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm-16 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faBottleDroplet = {
    prefix: 'fal',
    iconName: 'bottle-droplet',
    icon: [
      320,
      512,
      [],
      'e4c4',
      
      'M72 16C72 7.2 79.2 0 88 0l8 0s0 0 0 0l32 0 64 0 32 0 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0 0 113.1c38.3 22.1 64 63.5 64 110.9l0 192c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-192c0-47.4 25.7-88.7 64-110.9L96 32l-8 0c-8.8 0-16-7.2-16-16zM192 32l-64 0 0 113.1c0 11.4-6.1 22-16 27.7C83.2 189.5 64 220.5 64 256l0 192c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-192c0-35.5-19.2-66.5-48-83.2c-9.9-5.7-16-16.3-16-27.7L192 32zm0 305c0-5.6-4-17.2-14.6-33.5c-5.4-8.3-11.5-16.5-17.4-23.6c-5.9 7.2-12 15.3-17.4 23.6C132 319.8 128 331.4 128 337c0 16.6 13.8 31 32 31c11.5 0 19.3-3.4 23.8-7.5c4-3.6 8.2-10.3 8.2-23.5zm32 0c0 42-28.7 63-64 63s-64-28.2-64-63c0-31 34.9-73.5 53.2-93.6c5.9-6.5 15.8-6.5 21.6 0C189.1 263.5 224 306 224 337z'
      
    ]
  };

  

  
  

  var faTurnDownRight = {
    prefix: 'fal',
    iconName: 'turn-down-right',
    icon: [
      512,
      512,
      [],
      'e455',
      
      'M352 208l0-57.3c0-3.7 3-6.7 6.7-6.7c1.9 0 3.7 .8 5 2.2L476.2 272 363.7 397.8c-1.3 1.4-3.1 2.2-5 2.2c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-17.7-14.3-32-32-32l-176 0C82.1 304 32 253.9 32 192L32 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 112c0 26.5 21.5 48 48 48l176 0c17.7 0 32-14.3 32-32zm154.7 78c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 124.9c-7.3-8.2-17.8-12.9-28.8-12.9c-21.4 0-38.7 17.3-38.7 38.7l0 25.3 0 32-32 0-144 0c-8.8 0-16-7.2-16-16l0-112c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 192c0 79.5 64.5 144 144 144l144 0 32 0 0 32 0 25.3c0 21.4 17.3 38.7 38.7 38.7c11 0 21.5-4.7 28.8-12.9L506.7 286z'
      
    ]
  };

  

  
  

  var faFaceThinking = {
    prefix: 'fal',
    iconName: 'face-thinking',
    icon: [
      512,
      512,
      [],
      'e39b',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5C424 483.2 512 379.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3c2.4 8.5 11.2 13.5 19.7 11.2s13.5-11.2 11.2-19.7c-5.2-19-8.1-39-8.1-59.7zm165.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l70.5 23.5L160 348.8l0-28.8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 120c0 39.8 32.2 72 72 72l47.8 0c29.4 0 55.9-17.9 66.9-45.3l23.9-59.6 47-18.4c20.9-8.2 32.8-29.4 30.1-50.7c-2.3-18.7-15.1-34.7-33.3-40.8L197.1 256.8zM320 342.7c0 .4 0 .9 0 1.3c0 0 0 0 0 0c0 6.4-3.9 12.4-10.2 14.9l-53.5 20.9c-4.3 1.7-7.7 5.2-9.2 9.5c-.1 .2-.1 .4-.2 .6l-26 64.9C214.8 470 200.1 480 183.8 480L136 480c-22.1 0-40-17.9-40-40l0-120c0-8.8 7.2-16 16-16s16 7.2 16 16l0 52.2c0 5.3 2.6 10.2 7 13.2s9.9 3.6 14.9 1.7l148.3-58c8.2-3.2 17.5 .8 20.7 9.1c.6 1.5 .9 3 1.1 4.5zM200.4 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-87.2l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 94.1 162.3 90 127.1 110.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4c23.5-13.4 52.9-10.6 73.4 7z'
      
    ]
  };

  

  
  

  var faShare = {
    prefix: 'fal',
    iconName: 'share',
    icon: [
      512,
      512,
      ["mail-forward"],
      'f064',
      
      'M296 160c13.3 0 24-10.7 24-24l0-8 0-16 0-48L480 208 320 352l0-48 0-16 0-8c0-13.3-10.7-24-24-24l-8 0-96 0c-70.7 0-128 57.3-128 128c0 8.3 .7 16.1 2 23.2C47.9 383.7 32 350.1 32 304c0-79.5 64.5-144 144-144l112 0 8 0zm-8 144l0 16 0 32c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2l0 32 0 16 0 16-32 0-80 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l64 0 32 0 0 16z'
      
    ]
  };

  
    var faMailForward = faShare;
  

  
  

  var faDownLeft = {
    prefix: 'fal',
    iconName: 'down-left',
    icon: [
      384,
      512,
      [],
      'e16a',
      
      'M72 384c-4.4 0-8-3.6-8-8l0-201.4c0-3.7 3-6.6 6.6-6.6c1.8 0 3.4 .7 4.7 1.9l61.4 61.4c6.2 6.2 16.4 6.2 22.6 0L272 118.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L329.4 144c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L216.7 288.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l61.4 61.4c1.2 1.2 1.9 2.9 1.9 4.7c0 3.7-3 6.6-6.6 6.6L72 384zm-40-8c0 22.1 17.9 40 40 40l201.4 0c21.3 0 38.6-17.3 38.6-38.6c0-10.2-4.1-20.1-11.3-27.3L250.6 300 352 198.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L326.6 96C316.4 85.8 302.5 80 288 80s-28.4 5.8-38.6 16L148 197.4 97.9 147.3C90.7 140.1 80.9 136 70.6 136C49.3 136 32 153.3 32 174.6L32 376z'
      
    ]
  };

  

  
  

  var faDatabase = {
    prefix: 'fal',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      'M416 416c0 2.4-1 7.4-8.4 14.9c-7.5 7.6-19.9 15.9-37.8 23.6C334.1 469.8 282.6 480 224 480s-110.1-10.2-145.8-25.5c-17.9-7.7-30.3-16-37.8-23.6C33 423.4 32 418.4 32 416l0-84.5c17.2 8.9 38.1 16.3 61.2 21.9C130.7 362.7 175.8 368 224 368s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9l0 84.5zm0-212.5l0 90.6c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 330.9 270 336 224 336s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3l0-90.6c17.2 8.9 38.1 16.3 61.2 21.9C130.7 234.7 175.8 240 224 240s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9zm0-37.4c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 202.9 270 208 224 208s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3L32 96c0-2.4 1-7.4 8.4-14.9c7.5-7.6 19.9-15.9 37.8-23.6C113.9 42.2 165.4 32 224 32s110.1 10.2 145.8 25.5c17.9 7.7 30.3 16 37.8 23.6C415 88.6 416 93.6 416 96l0 70.1zM448 416l0-320C448 43 347.7 0 224 0S0 43 0 96L0 416c0 53 100.3 96 224 96s224-43 224-96z'
      
    ]
  };

  

  
  

  var faNoteMedical = {
    prefix: 'fal',
    iconName: 'note-medical',
    icon: [
      448,
      512,
      [],
      'e200',
      
      'M384 64c17.7 0 32 14.3 32 32l0 213.5c0 3.6-.6 7.2-1.8 10.5L336 320c-26.5 0-48 21.5-48 48l0 78.2c-3.3 1.2-6.9 1.8-10.5 1.8L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zm2.7 288L320 418.7l0-50.7c0-8.8 7.2-16 16-16l50.7 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l213.5 0c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3L448 96c0-35.3-28.7-64-64-64L64 32zM176 144l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48 32 0z'
      
    ]
  };

  

  
  

  var faTriangleExclamation = {
    prefix: 'fal',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3c0 10.2 8.2 18.4 18.4 18.4l411.2 0c10.2 0 18.4-8.2 18.4-18.4c0-3.3-.9-6.4-2.5-9.3L276.5 75.8C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8L34.5 420.4zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4L50.4 480C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faSnake = {
    prefix: 'fal',
    iconName: 'snake',
    icon: [
      512,
      512,
      [128013],
      'f716',
      
      'M293.9 88L277 88l-97 0C115.9 88 64 139.9 64 204s51.9 116 116 116l164 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-87.9 0c0 0 0 0 0 0s0 0-.1 0s0 0 0 0l-140.8 0c-8.4 0-16.8 1.7-24.6 4.9L44.8 456l45.8 19.1c7.8 3.3 16.2 4.9 24.6 4.9l60.7 0c0 0 0 0 0 0c0 0 .1 0 .1 0c0 0 0 0 0 0l168 0c57.4 0 104-46.6 104-104s-46.6-104-104-104l-164 0c-37.6 0-68-30.4-68-68s30.4-68 68-68l92 0 17.1 0 9.5 14.2c14.1 21.1 37.7 33.8 63.1 33.8l4.5 0c12.3 0 24.5-2.7 35.6-7.9L455 151.3c15.3-7.1 25-22.5 25-39.3s-9.8-32.2-25-39.3L400.5 47.3C390.2 42.5 379 40 367.7 40c-25.8 0-49.9 12.8-64.2 34l-9.5 14zM176 512l-.1 0-60.7 0c-12.7 0-25.2-2.5-36.9-7.4L14.8 478.2C5.8 474.4 0 465.7 0 456s5.8-18.4 14.8-22.2l63.5-26.5c11.7-4.9 24.2-7.4 36.9-7.4L256 400l.1 0 87.9 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-164 0C98.3 352 32 285.7 32 204S98.3 56 180 56l97 0c20.3-29.9 54.2-48 90.7-48c16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-53.1 24.8c-8.7 4-17.8 7-27.1 8.8c-7.2 1.4-14.6 2.1-22 2.1l-4.5 0c-6 0-11.9-.5-17.7-1.5c-8-1.3-15.7-3.5-23.1-6.5c-19.7-8-36.8-21.8-48.9-40l-92 0c-19.9 0-36 16.1-36 36s16.1 36 36 36l135.1 0 28.9 0c6 0 11.9 .4 17.7 1.1c1.5 .2 3 .4 4.5 .7c6.8 1.1 13.5 2.8 19.9 4.8C440.6 264.4 480 315.6 480 376c0 75.1-60.9 136-136 136l-168 0zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faHandcuffs = {
    prefix: 'fal',
    iconName: 'handcuffs',
    icon: [
      640,
      512,
      [],
      'e4f8',
      
      'M248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 72c13.3 0 24 10.7 24 24c22.1 0 40 17.9 40 40l0 21.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7L96 184c0-22.1 17.9-40 40-40c0-13.3 10.7-24 24-24zm32 75.2l0-11.2c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2zM288 352A128 128 0 1 0 32 352a128 128 0 1 0 256 0zm-64 0A64 64 0 1 0 96 352a64 64 0 1 0 128 0zM64 352a96 96 0 1 1 192 0A96 96 0 1 1 64 352zm416 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-64-72c0-22.1 17.9-40 40-40c0-13.3 10.7-24 24-24s24 10.7 24 24c22.1 0 40 17.9 40 40l0 21.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160c-47.4 0-90-20.6-119.3-53.3c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3C408 463.5 442.1 480 480 480c70.7 0 128-57.3 128-128s-57.3-128-128-128c-37.9 0-72 16.5-95.4 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c15.2-17 34-30.7 55.3-40l0-21.3zm32 11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2l0-11.2c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 11.2zM368 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm80 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faInhaler = {
    prefix: 'fal',
    iconName: 'inhaler',
    icon: [
      576,
      512,
      [],
      'f5f9',
      
      'M542.5 93.5L429.5 65.3l-16.7 62.2-25.8-25.8 14-51.8c3.4-12.6 16.3-20.2 29-17l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248l-25.8-25.8L542.5 93.5zM380.7 186l-9.3 34.5c-5.6 21-24.6 35.5-46.4 35.5L232 256c-4.4 0-8 3.6-8 8l0 176c0 4.4 3.6 8 8 8l224 0c3.6 0 6.8-2.4 7.7-5.9l37.1-136L380.7 186zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480l-224 0c-22.1 0-40-17.9-40-40l0-176c0-22.1 17.9-40 40-40l93.1 0c7.2 0 13.6-4.9 15.4-11.8L357 150.9c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM8 256a24 24 0 1 1 48 0A24 24 0 1 1 8 256zm96 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBookJournalWhills = {
    prefix: 'fal',
    iconName: 'book-journal-whills',
    icon: [
      448,
      512,
      ["journal-whills"],
      'f66a',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l368 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-320c0-26.5-21.5-48-48-48L64 0zM384 416l0 64L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l336 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 384zM190.5 86.3c-3.6-4.2-9.7-5.4-14.6-2.8C130.8 106.8 100 153.8 100 208c0 77.3 62.7 140 140 140s140-62.7 140-140c0-54.2-30.8-101.2-75.9-124.5c-4.9-2.5-11-1.4-14.6 2.8s-3.9 10.3-.7 14.8C295.9 111 300 123 300 136c0 17.8-7.7 33.7-20 44.7c-4.9 4.4-5.4 11.9-1 16.9c8.1 9.2 13 21.2 13 34.4c0 23.2-15.2 42.9-36.3 49.6l-.9-23.4 2.2 2.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-9-9 12.7 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-12.7 0 9-9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-4.2 4.2L248 87.7c-.2-4.3-3.7-7.7-8-7.7s-7.8 3.4-8 7.7l-4.8 120.2-4.2-4.2c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l9 9L208 224c-4.4 0-8 3.6-8 8s3.6 8 8 8l12.7 0-9 9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l2.2-2.2-.9 23.4c-21-6.7-36.3-26.3-36.3-49.6c0-13.2 4.9-25.2 13-34.4c4.4-4.9 3.9-12.5-1-16.9c-12.3-11-20-27-20-44.7c0-13 4.1-25 11.1-34.8c3.2-4.5 2.9-10.6-.7-14.8zm133.1 41.2c11 11.4 19.7 25.1 25.3 40.3l-18.5 18.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l12.2-12.2c1.4 7.3 2.2 14.8 2.2 22.5l0 .7-25.7 25.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L353 234.3C341.1 285.7 295 324 240 324s-101.1-38.3-113-89.7l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L124 208.7l0-.7c0-7.7 .8-15.2 2.2-22.5l12.2 12.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-18.5-18.5c5.6-15.2 14.3-28.8 25.3-40.3c-.3 2.8-.4 5.6-.4 8.4c0 20.9 7.6 40 20.2 54.7C168.5 202.6 164 216.8 164 232c0 42 34 76 76 76s76-34 76-76c0-15.2-4.5-29.4-12.2-41.3C316.4 176 324 156.9 324 136c0-2.8-.1-5.7-.4-8.4z'
      
    ]
  };

  
    var faJournalWhills = faBookJournalWhills;
  

  
  

  var faBookOpen = {
    prefix: 'fal',
    iconName: 'book-open',
    icon: [
      576,
      512,
      [128214,128366],
      'f518',
      
      'M156 32c44.6 0 89.7 8.6 132 22.6C330.3 40.6 375.4 32 420 32c55.4 0 107.2 14.6 128.9 21.6C565.7 59 576 74.5 576 91.1l0 311.5c0 26.9-25.1 44.8-49 40.6c-18.5-3.2-51.3-7.2-99-7.2c-58.9 0-97.8 24.3-111.2 34.1c-7.5 5.5-17.2 9.6-28.2 9.9c-.2 0-.5 0-.7 0l-.2 0-.3 0c-10.2 0-19.6-3.4-27-8.4C245.5 461.5 202 436 148 436c-45.2 0-80.1 4.4-100 7.7c-24 4-48-14.1-48-40.2L0 91.1C0 74.5 10.3 59 27.1 53.6C48.8 46.6 100.6 32 156 32zM304 440c20.3-13.5 63.1-36 124-36c49.5 0 84.1 4.2 104.4 7.6c2.5 .4 5.7-.3 8.2-2.3c2.2-1.8 3.4-4 3.4-6.8l0-311.5c0-3.5-2.1-6.1-4.9-7C518.6 77.5 470.5 64 420 64c-38.6 0-78.1 7.1-116 19l0 357zM272 83c-37.9-12-77.4-19-116-19C105.5 64 57.4 77.5 36.9 84c-2.8 .9-4.9 3.6-4.9 7l0 312.5c0 2.7 1.1 4.9 3.1 6.5c2.2 1.8 5.1 2.5 7.6 2.1c21.3-3.6 58-8.2 105.3-8.2c56.8 0 102.8 23.7 124 36.9L272 83z'
      
    ]
  };

  

  
  

  var faChevronsRight = {
    prefix: 'fal',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      'M75.3 459.3l192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm192 0l192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 244.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z'
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCorner = {
    prefix: 'fal',
    iconName: 'corner',
    icon: [
      448,
      512,
      [],
      'e3fe',
      
      'M0 176c0-8.8 7.2-16 16-16l384 0c26.5 0 48 21.5 48 48l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8-7.2-16-16-16L16 192c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faBahtSign = {
    prefix: 'fal',
    iconName: 'baht-sign',
    icon: [
      320,
      512,
      [],
      'e0ac',
      
      'M144 0c-8.8 0-16 7.2-16 16l0 48L37.6 64C16.8 64 0 80.8 0 101.6L0 240l0 32L0 406.3c0 23 18.7 41.7 41.7 41.7l86.3 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 56 0c57.4 0 104-46.6 104-104c0-44.7-28.2-82.8-67.8-97.5C274.1 227.4 288 199.3 288 168c0-57.4-46.6-104-104-104l-24 0 0-48c0-8.8-7.2-16-16-16zM128 96l0 144-96 0 0-138.4c0-3.1 2.5-5.6 5.6-5.6L128 96zm32 144l0-144 24 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-24 0zm-32 32l0 144-86.3 0c-5.4 0-9.7-4.4-9.7-9.7L32 272l96 0zm32 144l0-144 24 0 32 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-56 0z'
      
    ]
  };

  

  
  

  var faCowbell = {
    prefix: 'fal',
    iconName: 'cowbell',
    icon: [
      448,
      512,
      [],
      'f8b3',
      
      'M176 32l96 0c8.8 0 16 7.2 16 16l0 48L160 96l0-48c0-8.8 7.2-16 16-16zM128 48l0 48-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416l352 0c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96l-16 0 0-48c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zm16 80l160 0 32 0c7.1 0 13.4 4.7 15.4 11.6l64 224c1.4 4.8 .4 10-2.6 14s-7.8 6.4-12.8 6.4L48 384c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6l32 0zm80 384c35.3 0 64-28.7 64-64l-32 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l-32 0c0 35.3 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faLightbulbDollar = {
    prefix: 'fal',
    iconName: 'lightbulb-dollar',
    icon: [
      384,
      512,
      [],
      'f670',
      
      'M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9l32.4 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l32.4 0c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1c0 0 0 0 0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM146.7 448l90.5 0c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80l0-5.3c0-5.9-4.8-10.7-10.7-10.7l-138.7 0c-5.9 0-10.7 4.8-10.7 10.7l0 5.3zM208 88c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0s0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1L208 88z'
      
    ]
  };

  

  
  

  var faTireRugged = {
    prefix: 'fal',
    iconName: 'tire-rugged',
    icon: [
      512,
      512,
      [],
      'f634',
      
      'M229.8 32c-8.2 0-15.1 6.3-15.9 14.5l-.3 3.1c-.6 6.6-5.2 12.1-11.6 13.9c-15.5 4.3-30.2 10.5-43.9 18.2c-5.8 3.2-12.9 2.6-18-1.6l-2.4-2c-6.4-5.2-15.7-4.8-21.5 1L79.1 116.1c-5.8 5.8-6.3 15.1-1 21.5l2 2.4c4.2 5.1 4.8 12.3 1.6 18c-7.7 13.7-13.9 28.4-18.2 43.9c-1.8 6.4-7.3 11-13.9 11.6l-3.1 .3c-8.2 .8-14.5 7.7-14.5 15.9l0 52.4c0 8.2 6.3 15.1 14.5 15.9l3.1 .3c6.6 .6 12.1 5.2 13.9 11.6c4.3 15.5 10.5 30.2 18.2 43.9c3.2 5.8 2.6 12.9-1.6 18l-2 2.4c-5.2 6.4-4.8 15.7 1 21.5l37.1 37.1c5.8 5.8 15.1 6.3 21.5 1l2.4-2c5.1-4.2 12.3-4.8 18-1.6c13.7 7.7 28.4 13.9 43.9 18.2c6.4 1.8 11 7.3 11.6 13.9l.3 3.1c.8 8.2 7.7 14.5 15.9 14.5l52.4 0c8.2 0 15.1-6.3 15.9-14.5l.3-3.1c.6-6.6 5.2-12.1 11.6-13.9c15.5-4.3 30.2-10.5 43.9-18.2c5.8-3.2 12.9-2.6 18 1.6l2.4 2c6.4 5.2 15.7 4.8 21.5-1l37.1-37.1c5.8-5.8 6.3-15.1 1-21.5l-2-2.4c-4.2-5.1-4.8-12.3-1.6-18c7.7-13.7 13.9-28.4 18.2-43.9c1.8-6.4 7.3-11 13.9-11.6l3.1-.3c8.2-.8 14.5-7.7 14.5-15.9l0-52.4c0-8.2-6.3-15.1-14.5-15.9l-3.1-.3c-6.6-.6-12.1-5.2-13.9-11.6c-4.3-15.5-10.5-30.2-18.2-43.9c-3.2-5.8-2.6-12.9 1.6-18l2-2.4c5.2-6.4 4.8-15.7-1-21.5L395.8 79.1c-5.8-5.8-15.1-6.3-21.5-1L372 80c-5.1 4.2-12.3 4.8-18 1.6c-13.7-7.7-28.4-13.9-43.9-18.2c-6.4-1.8-11-7.3-11.6-13.9l-.3-3.1c-.8-8.2-7.7-14.5-15.9-14.5l-52.4 0zm-46.4 3.6C188.9 14.9 207.7 0 229.8 0l52.4 0c22 0 40.9 14.9 46.4 35.6c11 3.6 21.7 8.1 31.9 13.2c18.5-10.7 42.4-8 58 7.6l37.1 37.1c15.6 15.6 18.3 39.4 7.6 58c5.2 10.2 9.6 20.9 13.2 31.9c20.7 5.5 35.6 24.3 35.6 46.4l0 52.4c0 22-14.9 40.9-35.6 46.4c-3.6 11-8.1 21.7-13.2 31.9c10.7 18.5 8 42.4-7.6 58l-37.1 37.1c-15.6 15.6-39.4 18.3-58 7.6c-10.2 5.2-20.9 9.6-31.9 13.2c-5.5 20.7-24.3 35.6-46.4 35.6l-52.4 0c-22 0-40.9-14.9-46.4-35.6c-11-3.6-21.7-8.1-31.9-13.2c-18.5 10.7-42.4 8-58-7.6L56.4 418.5c-15.6-15.6-18.3-39.5-7.6-58c-5.2-10.2-9.6-20.9-13.2-31.9C14.9 323.1 0 304.3 0 282.2l0-52.4c0-22 14.9-40.9 35.6-46.4c3.6-11 8.1-21.7 13.2-31.9c-10.7-18.5-8-42.4 7.6-58L93.5 56.4c15.6-15.6 39.5-18.3 58-7.6c10.2-5.2 20.9-9.6 31.9-13.2zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-75.9 96.6a24 24 0 1 1 14.8-45.7 24 24 0 1 1 -14.8 45.7zm167.2-30.2a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8zm-29.6 73.8a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zM199.6 333.7a24 24 0 1 1 28.2-38.8 24 24 0 1 1 -28.2 38.8z'
      
    ]
  };

  

  
  

  var faRectangleXmark = {
    prefix: 'fal',
    iconName: 'rectangle-xmark',
    icon: [
      512,
      512,
      [62164,"rectangle-times","times-rectangle","window-close"],
      'f410',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faRectangleTimes = faRectangleXmark;
  
    var faTimesRectangle = faRectangleXmark;
  
    var faWindowClose = faRectangleXmark;
  

  
  

  var faHandBackPointRibbon = {
    prefix: 'fal',
    iconName: 'hand-back-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a0',
      
      'M152 0C121.1 0 96 25.1 96 56l0 8L16 64C9.8 64 4.2 67.5 1.6 73.1S-.3 85.2 3.5 90l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9S9.8 176 16 176l80 0 0 80.6c-3.2 2-6.4 4.2-9.5 6.5L64 280c-20.1 15.1-32 38.8-32 64l0 19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2L320 512c61.9 0 112-50.1 112-112l0-8 0-88c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-8.5 0-16.6 1.7-24 4.7L208 56c0-30.9-25.1-56-56-56zM128 176l48 0 0 37.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3c15.6 0 28.6 11.2 31.4 25.9c1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32l0 88 0 8c0 44.2-35.8 80-80 80l-135.7 0c-18.5 0-36.8-4.6-53.1-13.4l-8.3-4.5C86.6 442.6 64 404.7 64 363.5L64 344c0-15.1 7.1-29.3 19.2-38.4L96 296l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-78.3 0-1.7 0-88zm48-32L49.3 144l11.2-14c4.7-5.8 4.7-14.1 0-20L49.3 96 176 96l0 48zm0-80l-48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8z'
      
    ]
  };

  

  
  

  var faCartFlatbedSuitcase = {
    prefix: 'fal',
    iconName: 'cart-flatbed-suitcase',
    icon: [
      640,
      512,
      ["luggage-cart"],
      'f59d',
      
      'M0 16C0 7.2 7.2 0 16 0L80 0c26.5 0 48 21.5 48 48l0 320c0 8.8 7.2 16 16 16l80 0 288 0 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56.6 0c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32l-177.1 0c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32L144 416c-26.5 0-48-21.5-48-48L96 48c0-8.8-7.2-16-16-16L16 32C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM336 32c-8.8 0-16 7.2-16 16l0 32 128 0 0-32c0-8.8-7.2-16-16-16l-96 0zM480 80l32 0c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-112c0-35.3 28.7-64 64-64l32 0 0-32c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 32zM272 112l-16 0c-17.7 0-32 14.3-32 32l0 112c0 17.7 14.3 32 32 32l16 0 0-176zm32 176l160 0 0-176-160 0 0 176zm192 0l16 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32l-16 0 0 176z'
      
    ]
  };

  
    var faLuggageCart = faCartFlatbedSuitcase;
  

  
  

  var faEarthEurope = {
    prefix: 'fal',
    iconName: 'earth-europe',
    icon: [
      512,
      512,
      ["globe-europe"],
      'f7a2',
      
      'M477.7 288l-38.3 0c-6.2 0-12.3-2.2-17.1-6.2l-15.9-13.2c-4.6-3.8-5.2-10.5-1.5-15.2c14.6-18.3 1.6-45.4-21.8-45.4l-3.7 0c-6.3 0-11.4-5.1-11.4-11.4l0-9.4c0-18.4-22.2-27.6-35.2-14.6l-32.1 32.1c-2.6 2.6-6.8 2.6-9.4 0l-2.8-2.8c-6.3-6.3-14.8-9.8-23.7-9.8c-10.5 0-20.5 5-26.8 13.4l-10.7 14.3c-2 2.7-5.2 4.3-8.5 4.3c-5.9 0-10.7-4.8-10.7-10.7l0-1.6c0-3.3 1.3-6.4 3.6-8.7l18.7-18.7c6.2-6.2 9.7-14.7 9.7-23.5c0-4.3 2.4-8.2 6.2-10.1l59.2-29.6c20.2-10.1 26.9-35.6 14.2-54.3c-8.9-13.2-25.1-19.1-40-15.3l4.5-17.8C394.5 47.5 480 141.8 480 256c0 10.9-.8 21.5-2.3 32zm-7 32c-3.3 11-7.4 21.7-12.3 32l-19.8 0c-10.2 0-20.1-4.1-27.3-11.3l-4-4C396.6 326 382.2 320 367.1 320c-5.9 0-11.7-2.1-16.1-6l-26.6-22.8c-14.5-12.4-33-19.3-52.1-19.3l-20.9 0c-15.8 0-31.2 4.7-44.4 13.4l-27.4 18.3c-22.3 14.8-35.6 39.8-35.6 66.6l0 3.2c0 21.2 8.4 41.6 23.4 56.6l16 16c11.5 11.5 27.1 17.9 43.3 17.9c11.4 0 21.2 6.5 26.1 16C130.6 478.3 32 378.6 32 256C32 133.8 129.9 34.4 251.5 32l-6.9 27.6c-4.9 19.7 15.4 36.2 33.7 27.3l8.1-3.9c2.4-1.2 5.3-.4 6.8 1.8c1.8 2.7 .8 6.3-2 7.8l-59.2 29.6c-14.7 7.3-23.9 22.3-23.9 38.7c0 .3-.1 .6-.4 .9L189 180.4c-8.3 8.3-13 19.6-13 31.3l0 1.6c0 23.6 19.1 42.7 42.7 42.7c13.4 0 26.1-6.3 34.1-17.1l10.7-14.3c.3-.4 .7-.6 1.2-.6c.4 0 .8 .2 1.1 .4l2.8 2.8c15.1 15.1 39.6 15.1 54.7 0l15.4-15.4c5.8 15.3 20 26.5 36.9 28c-9.5 17.6-5.6 40 10.3 53.3l15.9 13.2c10.5 8.8 23.8 13.6 37.5 13.6l31.3 0zm-30.9 64c-35.1 50.3-90.2 85.5-153.8 94c-6.8-26.4-30.8-46-59.3-46c-7.8 0-15.2-3.1-20.7-8.6l-16-16c-9-9-14.1-21.2-14.1-33.9l0-3.2c0-16.1 8-31 21.4-39.9l27.4-18.3c7.9-5.3 17.1-8.1 26.6-8.1l20.9 0c11.5 0 22.5 4.1 31.2 11.6l26.6 22.8c10.3 8.8 23.4 13.7 37 13.7c6.6 0 12.9 2.6 17.5 7.3l4 4c13.2 13.2 31.2 20.7 49.9 20.7l1.2 0zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faGlobeEurope = faEarthEurope;
  

  
  

  var faPrintSlash = {
    prefix: 'fal',
    iconName: 'print-slash',
    icon: [
      640,
      512,
      [],
      'f686',
      
      'M480 463.9l0 16.1-320 0 0-128 178.3 0-40.5-32L160 320c-17.7 0-32 14.3-32 32l0 32-32 0 0-128c0-17.7 14.3-32 32-32l48.2 0-40.5-32-7.6 0c-35.3 0-64 28.7-64 64l0 128c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7 14.3 32 32 32l320 0c14.8 0 27.3-10.1 30.9-23.7L480 463.9zM137.5 30.4L163 50.5C168.1 39.6 179.2 32 192 32l229.5 0c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6l0 69.5 32 0 0-69.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0L192 0c-23 0-43.2 12.2-54.5 30.4zM512 192l-169.8 0 40.5 32L512 224c17.7 0 32 14.3 32 32l0 95.3 32 25.3L576 256c0-35.3-28.7-64-64-64zM496 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faRug = {
    prefix: 'fal',
    iconName: 'rug',
    icon: [
      640,
      512,
      [],
      'e569',
      
      'M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l16 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 48-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 48-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0 16 0 512 0 16 0 16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-16 0-16 0L64 64 48 64 32 64 16 64zM64 96l64 0 0 320-64 0 0-80 0-80 0-80 0-80zm448 0l64 0 0 80 0 80 0 80 0 80-64 0 0-320zm-32 0l0 320-320 0 0-320 320 0z'
      
    ]
  };

  

  
  

  var faUserTag = {
    prefix: 'fal',
    iconName: 'user-tag',
    icon: [
      640,
      512,
      [],
      'f507',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM416 480c0-2.4-.1-4.8-.3-7.2l26.8 26.8c-5.4 7.5-14.2 12.5-24.2 12.5L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c17.5 0 34.3 2.5 50.3 7.2l0 33 0 .7c-15.7-5.7-32.6-8.9-50.3-8.9l-91.4 0c-80 0-145 64.3-146.3 144l384 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM545.9 491.3c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3l0-82.7c0-17.7 14.3-32 32-32l82.7 0c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4zM384 256l0 82.7c0 8.5 3.4 16.6 9.4 22.6L500.7 468.7c6.2 6.2 16.4 6.2 22.6 0l73.4-73.4c6.2-6.2 6.2-16.4 0-22.6L489.4 265.4c-6-6-14.1-9.4-22.6-9.4L384 256zm24 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faImagePortrait = {
    prefix: 'fal',
    iconName: 'image-portrait',
    icon: [
      384,
      512,
      ["portrait"],
      'f3e0',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.4 320l-86.9 0c-18.6 0-34 14-36.3 32l159.4 0c-2.2-18-17.6-32-36.3-32zm-86.9-32l43.4 0 43.4 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0C92.3 384 80 371.7 80 356.6c0-37.9 30.7-68.6 68.6-68.6z'
      
    ]
  };

  
    var faPortrait = faImagePortrait;
  

  
  

  var faPersonFalling = {
    prefix: 'fal',
    iconName: 'person-falling',
    icon: [
      512,
      512,
      [],
      'e546',
      
      'M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 10.8c0 48.1-27.6 91.3-70 111.9c-1.8 .4-3.6 1.1-5.2 2.2c-.2 .1-.4 .3-.6 .4c-3 1.3-6.1 2.4-9.3 3.5C139.1 166.1 96 225.9 96 293.2L96 368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-74.8c0-21.7 5.6-42.5 15.8-60.6L322.6 504.8c4.9 7.4 14.8 9.4 22.2 4.6s9.4-14.8 4.6-22.2L252.7 340.1l57.5-44.7 67-6.7 74.6 89.5c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5l-74.6-89.5c-6.8-8.2-17.2-12.4-27.8-11.4l-61.9 6.2L244.8 160.5c46-27.9 75.2-78.2 75.2-133.7L320 16zM282.5 276.4l-47.4 36.9L165.4 207.2c-.4-.6-.8-1.1-1.3-1.7c13.4-13.5 30-24.1 48.9-30.4c.8-.3 1.7-.6 2.5-.9l66.9 102.1zM96 88a24 24 0 1 1 48 0A24 24 0 1 1 96 88zm80 0A56 56 0 1 0 64 88a56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fal',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      'M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm240 32l-224 0-80 0c-17.7 0-32 14.3-32 32l0 96 144 0 32 0 96 0 32 0 144 0 0-96c0-17.7-14.3-32-32-32l-80 0zM480 288l-144 0 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48L32 288l0 128c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-128zm-272 0l0 48 96 0 0-48-96 0z'
      
    ]
  };

  

  
  

  var faPotFood = {
    prefix: 'fal',
    iconName: 'pot-food',
    icon: [
      640,
      512,
      [127858],
      'e43f',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l.4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C131.7 51.6 128 38.2 128 16zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C227.7 51.6 224 38.2 224 16zM32 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l35.8 0c5.9 82.9 56.5 152.7 127.3 186.4c7.6 21.9 28.4 37.6 52.9 37.6l144 0c24.5 0 45.3-15.7 52.9-37.6C515.7 440.7 566.3 370.9 572.2 288l35.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-37.6 0c-6.6-18.6-24.3-32-45.3-32l-410.2 0c-21 0-38.7 13.4-45.3 32L32 256zm507.4-64c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80l34 0c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48l34 0zM225.3 463.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9l410.2 0c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1l-144 0c-10.4 0-19.4-6.7-22.7-16.1z'
      
    ]
  };

  

  
  

  var faCloudMoon = {
    prefix: 'fal',
    iconName: 'cloud-moon',
    icon: [
      640,
      512,
      [],
      'f6c3',
      
      'M460.6 35.9c-30 32-48.4 75-48.4 122.4c0 90.8 67.6 165.8 155.1 177.2c-21.5 10.8-45.8 16.9-71.5 16.9c-24.6 0-47.9-5.6-68.7-15.5c17.7 11 32.1 26.8 41.3 45.6c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c11.8 .3 23.2 2.4 33.9 6.1c-2.9-12.2-4.5-24.8-4.5-37.9C336 115.8 389.3 52 460.6 35.9zM112 320c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-266.6 0c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3C34.6 328.9 0 368.4 0 416c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1l266.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 242.6 210.9 224 176 224z'
      
    ]
  };

  

  
  

  var faLocationPen = {
    prefix: 'fal',
    iconName: 'location-pen',
    icon: [
      384,
      512,
      ["map-marker-edit"],
      'f607',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM252.3 131.7c-4.9-4.9-12.9-4.9-17.8 0l-8.1 8.1 17.8 17.8 8.1-8.1c4.9-4.9 4.9-12.9 0-17.8zM143.1 223.1c-2 2.1-3.5 4.6-4.2 7.4L134 250l19.4-4.9c2.8-.7 5.4-2.2 7.4-4.2l60.7-60.7-17.8-17.8-60.7 60.7zM211.8 109c17.4-17.4 45.7-17.4 63.1 0c17.4 17.4 17.4 45.6 0 63l-91.4 91.5c-6.2 6.2-13.9 10.5-22.3 12.6l-45.3 11.3c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l11.3-45.3c2.1-8.4 6.5-16.1 12.6-22.3L211.8 109z'
      
    ]
  };

  
    var faMapMarkerEdit = faLocationPen;
  

  
  

  var faSlashForward = {
    prefix: 'fal',
    iconName: 'slash-forward',
    icon: [
      320,
      512,
      [],
      '2f',
      
      'M312.2 2.3c7.6 4.5 10 14.4 5.5 22l-288 480c-4.5 7.6-14.4 10-22 5.5s-10-14.4-5.5-22l288-480c4.5-7.6 14.4-10 22-5.5z'
      
    ]
  };

  

  
  

  var faShieldQuartered = {
    prefix: 'fal',
    iconName: 'shield-quartered',
    icon: [
      512,
      512,
      [],
      'e575',
      
      'M66.8 112.3C55.5 117 47.9 127.7 48 139.8c.1 20 1.9 43.2 6.3 68.2L240 208l0-169.2L66.8 112.3zM61.1 240C82.3 324.6 133.3 420.1 240 472.6L240 240 61.1 240zM272 240l0 232.6c106.7-52.5 157.7-148 179-232.6l-179 0zm185.8-32c4.3-24.9 6.2-48.2 6.3-68.2c.1-12.1-7.5-22.8-18.8-27.6L272 38.8 272 208l185.8 0zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z'
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fal',
    iconName: 'hand-fist',
    icon: [
      448,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      'M254.2 233.7c7.7 4 16.5 6.3 25.8 6.3c12.1 0 23.3-3.8 32.5-10.4C322.4 245.5 340 256 360 256c8.6 0 16.7-1.9 24-5.4l0 5.4c0 38.6-19.5 72.6-49.2 92.7c-8.6 5.8-14.8 15.7-14.8 27.4L320 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-119.9c0 0 0 0 0-.1l.1-.1c.1-.2 .3-.5 .7-.7C390.9 349.3 416 305.6 416 256l0-56 0-8 0-40c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4L336 88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C246 16.3 224.9 0 200 0s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8C89.1 32 64 57.1 64 88l0 112c0 2.6 .2 5.1 .5 7.6C44.8 222.2 32 245.6 32 272c0 59 39.9 108.7 94.2 123.5c.8 .2 1.3 .6 1.6 1c.1 .2 .2 .3 .2 .3c0 0 0 0 0 0l0 99.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.3c0-16.3-11.9-28.4-25.4-32.1C93.9 353.5 64 316.2 64 272c0-26.5 21.5-48 48-48l88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c30.9 0 56-25.1 56-56c0-4.9-.6-9.7-1.8-14.3zM224 197.4c-7.3-3.5-15.4-5.4-24-5.4l-24 0 0-104 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 96 0 13.4zM144 192l-32 0c-5.5 0-10.8 .6-16 1.6L96 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104zm240 0l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40zM256 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96z'
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faAirplay = {
    prefix: 'fal',
    iconName: 'airplay',
    icon: [
      576,
      512,
      [],
      'e089',
      
      'M480 64L96 64c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l37.5 0-18.7 18.7c-4 4-7.4 8.5-10.2 13.3L96 416c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 192c0 53-43 96-96 96l-8.6 0c-2.8-4.8-6.2-9.2-10.2-13.3L442.5 384l37.5 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64zM162.2 435.7c-1.4 1.3-2.2 3.2-2.2 5.2c0 3.9 3.2 7.1 7.1 7.1l241.7 0c3.9 0 7.1-3.2 7.1-7.1c0-2-.8-3.8-2.2-5.2L293.6 322.2c-1.4-1.3-3.5-2.2-5.6-2.2s-4.2 .8-5.6 2.2L162.2 435.7zm-22-23.3L260.4 298.9c7.4-7 17.4-10.9 27.6-10.9s20.1 3.9 27.6 10.9L435.7 412.4c7.8 7.4 12.3 17.7 12.3 28.5c0 21.6-17.5 39.1-39.1 39.1l-241.7 0c-21.6 0-39.1-17.5-39.1-39.1c0-10.8 4.4-21.1 12.3-28.5z'
      
    ]
  };

  

  
  

  var faLamp = {
    prefix: 'fal',
    iconName: 'lamp',
    icon: [
      448,
      512,
      [],
      'f4ca',
      
      'M112 32L32 224l384 0L336 32 112 32zM82.5 19.7C87.4 7.8 99.1 0 112 0L336 0c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2L32 256c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 312.2l0-24.2 32 0 0 24.2c0 14.8-6.7 27.8-16.5 36.6c-6.8 6.1-19.3 18.4-29.8 34.1C135 398.9 128 415.8 128 432c0 17.1 5.8 31.8 12.1 42.6c1 1.7 4.8 5.4 14.4 5.4l139 0c9.7 0 13.5-3.7 14.4-5.4c6.3-10.8 12.1-25.5 12.1-42.6c0-16.2-7-33.1-17.7-49.1c-10.5-15.7-23-28-29.8-34.1c-9.8-8.8-16.5-21.8-16.5-36.6l0-24.2 32 0 0 24.2c0 4.9 2.2 9.5 5.9 12.8C309.7 339.3 352 382 352 432c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3l-139 0c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-50 42.3-92.7 58.1-107c3.6-3.3 5.9-7.9 5.9-12.8z'
      
    ]
  };

  

  
  

  var faArrowsSplitUpAndLeft = {
    prefix: 'fal',
    iconName: 'arrows-split-up-and-left',
    icon: [
      512,
      512,
      [],
      'e4bc',
      
      'M235.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 54.6 336 384l0 16c0 44.2 35.8 80 80 80l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-61.9 0-112-50.1-112-112l0-16c0-44.2-35.8-80-80-80L54.6 304l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272 224 272c31.3 0 59.7 12.9 80 33.6l0-251-68.7 68.7z'
      
    ]
  };

  

  
  

  var faSquareW = {
    prefix: 'fal',
    iconName: 'square-w',
    icon: [
      448,
      512,
      [],
      'e285',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm103.1 58.8l56.3 162.6 49.4-154.2c2.1-6.6 8.3-11.1 15.2-11.1s13.1 4.5 15.2 11.1l49.4 154.2 56.3-162.6c2.9-8.4 12-12.8 20.4-9.9s12.8 12 9.9 20.4l-72 208c-2.3 6.5-8.4 10.8-15.3 10.8s-13-4.6-15.1-11.1L224 220.5 175.2 372.9c-2.1 6.6-8.2 11-15.1 11.1s-13.1-4.3-15.3-10.8l-72-208c-2.9-8.4 1.5-17.5 9.9-20.4s17.5 1.5 20.4 9.9z'
      
    ]
  };

  

  
  

  var faTruckArrowRight = {
    prefix: 'fal',
    iconName: 'truck-arrow-right',
    icon: [
      640,
      512,
      [],
      'e58b',
      
      'M352 32c17.7 0 32 14.3 32 32l0 320-133.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l288 0zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-148.2c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352zM481.3 128c4.7 0 9.1 2 12.1 5.6L570.9 224 416 224l0-96 65.3 0zM416 344.4l0-88.4 160 0 0 128-5.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 160 112 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l153.4 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z'
      
    ]
  };

  

  
  

  var faDiagramSuccessor = {
    prefix: 'fal',
    iconName: 'diagram-successor',
    icon: [
      512,
      512,
      [],
      'e47a',
      
      'M480 352c0-17.7-14.3-32-32-32L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zm32 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM256 96c0-17.7-14.3-32-32-32l-32 0L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64zm23.4-32c5.4 9.4 8.6 20.3 8.6 32l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c35.3 0 64 28.7 64 64l0 89.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L400 185.4 400 96c0-17.7-14.3-32-32-32l-88.6 0zM96 368l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 400c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCartFlatbedBoxes = {
    prefix: 'fal',
    iconName: 'cart-flatbed-boxes',
    icon: [
      640,
      512,
      ["dolly-flatbed-alt"],
      'f475',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l64 0c8.8 0 16 7.2 16 16l0 320c0 26.5 21.5 48 48 48l24.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32l177.1 0c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32l56.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0-288 0-80 0c-8.8 0-16-7.2-16-16l0-320c0-26.5-21.5-48-48-48L16 0zM544 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-416l128 0 0 224-128 0 0-224zm-32 0l0 224c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L224 32c-17.7 0-32 14.3-32 32zm320 0l0 64-64 0 0-64 64 0zM448 32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm0 192l128 0 0 64-128 0 0-64zm-32 0l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faDollyFlatbedAlt = faCartFlatbedBoxes;
  

  
  

  var faAngleLeft = {
    prefix: 'fal',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z'
      
    ]
  };

  

  
  

  var faBuildings = {
    prefix: 'fal',
    iconName: 'buildings',
    icon: [
      512,
      512,
      [],
      'e0cc',
      
      'M448 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32l160 0zM288 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L288 0zM192 128L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l152.4 0c-8.3-9.2-14.8-20.1-19-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l128 0 0-32zM88 320c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm224 8c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48zm32-8l0-32 32 0 0 32-32 0zM88 192c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM320 88l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm-8 192l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24zm8-64l32 0 0 32-32 0 0-32z'
      
    ]
  };

  

  
  

  var faHouseCircleCheck = {
    prefix: 'fal',
    iconName: 'house-circle-check',
    icon: [
      640,
      512,
      [],
      'e509',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7 96 432c0 26.5 21.5 48 48 48l64 0 0-160c0-17.7 14.3-32 32-32l96 0c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9L240 320l0 160 16 0 80 0 24.2 0c10 12.1 21.7 22.9 34.6 32L144 512c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faSwordLaser = {
    prefix: 'fal',
    iconName: 'sword-laser',
    icon: [
      512,
      512,
      [],
      'e03b',
      
      'M503.8 57.1l-210 232.7-22.7-22.7L480 35.7l0-3.7-3.7 0L244.8 240.9l-22.7-22.7L454.9 8.2C460.7 2.9 468.4 0 476.3 0L480 0c17.7 0 32 14.3 32 32l0 3.7c0 7.9-2.9 15.6-8.2 21.4zM187.3 228.7l16 16 64 64s0 0 0 0s0 0 0 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7-57.9 57.9c1.2 2.3 1.9 4.9 1.9 7.5c0 4.2-1.7 8.3-4.7 11.3L118.6 496c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L16 470.6C5.8 460.4 0 446.5 0 432s5.8-28.4 16-38.6l76.7-76.7c5.1-5.1 12.8-6 18.8-2.8L169.4 256l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM152 318.6L134.6 336 176 377.4 193.4 360 152 318.6zM174.6 296L216 337.4 233.4 320 192 278.6 174.6 296zM38.6 416c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L64 473.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6L161.4 408 104 350.6 38.6 416z'
      
    ]
  };

  

  
  

  var faTomato = {
    prefix: 'fal',
    iconName: 'tomato',
    icon: [
      512,
      512,
      [],
      'e330',
      
      'M235.3 4.7L224 16C235.3 4.7 235.3 4.7 235.3 4.7s0 0 0 0s0 0 0 0c0 0 0 0 .1 .1l.2 .2 .4 .5c.4 .4 .8 .9 1.4 1.5c1.1 1.3 2.6 3.1 4.4 5.4c3.5 4.7 8 11.5 12.5 20.4c6 12 11.9 27.8 15.1 47.4c52.9 1.7 102.9 13.6 145.6 35.3c13.2 6.7 20.1 21.6 16.6 36s-16.3 24.5-31.1 24.5l-4.8 0c6.7 11.5 5.5 26.1-3.1 36.5c-9.1 10.9-24.2 14.5-37.2 8.9L256 178.8l-99.4 42.6c-13 5.6-28.2 1.9-37.2-8.9c-8.7-10.5-9.8-25.2-2.9-36.8l-.2 0c-13.3 2-26.9-4.5-33.4-17.1c-8-15.8-1.7-35 14-43c0 0 0 0 0 0l.8-.4s0 0 0 0c41-20.6 88.6-32.3 139.1-34.6c-2.8-13.8-7.1-24.9-11.3-33.3c-3.5-7-7-12.2-9.5-15.6c-1.2-1.7-2.2-2.8-2.9-3.6c-.3-.4-.5-.6-.6-.7l-.1-.1c-6.2-6.3-6.1-16.3 .1-22.5c6.2-6.2 16.4-6.2 22.6 0zM240 112.3c-47.2 2-90.9 12.7-127.7 31.3c0 0 0 0 0 0l-.8 .4s0 0 0 0s0 0 0 0c1.2-.3 2.4-.4 3.6-.4l31.3 .2c5.9 0 11.3 3.3 14 8.5s2.4 11.5-.8 16.4L144 192l105.7-45.3c4-1.7 8.6-1.7 12.6 0L368 192l-15.4-23.1c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5l34.6 0c-37-18.8-81-29.7-128.5-31.7c-.2 8.7-7.3 15.7-16 15.7s-15.8-7-16-15.7zM73.4 195.4C47.3 223.5 32 259.8 32 304c0 55 23.6 97.8 62.5 127.7C134.1 462.2 190.8 480 256 480s121.9-17.8 161.5-48.3C456.4 401.8 480 359 480 304c0-44.2-15.3-80.5-41.4-108.6c8.7-6.4 15.7-15 20.3-25.1C492.2 204.5 512 249.6 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304c0-54.4 19.8-99.6 53.1-133.7c.4 .9 .8 1.8 1.3 2.7c4.7 9.2 11.2 16.7 18.9 22.4z'
      
    ]
  };

  

  
  

  var faBatteryThreeQuarters = {
    prefix: 'fal',
    iconName: 'battery-three-quarters',
    icon: [
      576,
      512,
      ["battery-4"],
      'f241',
      
      'M432 128c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 384c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l352 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80L80 96zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM112 192l192 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM64 208l0 96c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery4 = faBatteryThreeQuarters;
  

  
  

  var faCheck = {
    prefix: 'fal',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faIceSkate = {
    prefix: 'fal',
    iconName: 'ice-skate',
    icon: [
      576,
      512,
      [9976],
      'f7ac',
      
      'M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 7.4-4.1 1.1L67.6 82.2C46.6 87.8 32 106.8 32 128.6L32 336c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-30c0-36.7-25-68.7-60.6-77.6L320 195.5l0-51.5 0-128zM75.9 113.1L288 56.6l0 71.4-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l62 0 141.6 35.4C465 264.7 480 283.9 480 306l0 30c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-207.4c0-7.2 4.9-13.6 11.9-15.5zM128 432l0-16-32 0 0 16 0 48-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 288 0 96 0c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 26.5-21.5 48-48 48l-80 0 0-48 0-16-32 0 0 16 0 48-256 0 0-48z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fal',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 80l91.4 0c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144zm0-32C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM512 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fal',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l368 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-320c0-26.5-21.5-48-48-48L64 0zM384 416l0 64L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l32 0 0 352-32 0zm64 0l0-352 272 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-272 0zm48-240c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faTurkey = {
    prefix: 'fal',
    iconName: 'turkey',
    icon: [
      640,
      512,
      [],
      'f725',
      
      'M496 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 2.7-.3 5.4-1 7.9c-1.3 5.2-.5 11.1 2.9 16c3.7 5.2 9.4 8 15.2 8.2c17.1 .6 30.9 14.7 30.9 32c0 17.7-14.3 32-32 32c-6 0-12.6-.6-20.3-1.5l-3.9-.5c-6.3-.7-13.2-1.5-19.9-2c-15.9-1-35.4-.4-51.5 11l-41.6 29.3c-18.8 13.2-30.5 32-39.1 50.6c-5.3 11.3-10 24.3-14.4 36.2c-2.5 6.7-4.8 13.1-7.1 18.8c-4.9 12.2-12.9 23.3-23.9 32.2C320 362 269.6 356.7 241.8 322.3S219.3 237.6 253.7 209.8c17.2-13.9 38.3-19.5 58.7-17.4c14.5 1.5 31.2 3.1 47.6 2c16.5-1.2 33.7-5.3 48.9-16l63.6-44.9c12.8-9 18.4-22.7 20.9-34.8C495.9 86.7 496 73.8 496 64zM528 0c-35.3 0-64 28.7-64 64c0 10.1-.2 19.7-1.9 28.1c-1.8 8.3-4.6 12.9-8.1 15.3l-40.3 28.4C370.6 110.5 325.7 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-60.3-25-116.1-62.2-162.2l-26.2 18.5C522 282.3 544 332 544 384c0 24.6-7.4 40.5-18.3 52c-11.6 12.3-29.6 22.1-54.5 29.2C420.4 479.7 353.4 480 288 480s-132.4-.3-183.2-14.8c-24.9-7.1-42.9-16.9-54.5-29.2C39.4 424.5 32 408.6 32 384c0-68 37.6-132 91.4-180.2C177.6 155.2 242.3 128 288 128c27.3 0 61.5 9.7 96.1 28c-7.6 3.8-16.4 5.8-26.5 6.5c-13.1 .9-27.2-.3-41.9-1.9c-28.5-3-58.2 4.9-82.2 24.3c-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c15.3-12.4 26.5-28 33.4-45.1c3.1-7.7 5.7-14.9 8.3-21.9c0 0 0 0 0 0c4-10.8 7.7-21.1 12.6-31.6c7.6-16.4 16.3-29.3 28.5-37.9l41.6-29.3c6.7-4.7 16.5-6.2 31-5.2c5.8 .4 11.7 1.1 18 1.8l4.3 .5c7.6 .9 15.9 1.7 23.9 1.7c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64z'
      
    ]
  };

  

  
  

  var faClipboardListCheck = {
    prefix: 'fal',
    iconName: 'clipboard-list-check',
    icon: [
      384,
      512,
      [],
      'f737',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM171.3 235.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'fal',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      'M448 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z'
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faCommentSms = {
    prefix: 'fal',
    iconName: 'comment-sms',
    icon: [
      512,
      512,
      ["sms"],
      'f7cd',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 176 96 192.5 96 212.8zM372.8 176c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 185.1 192 192l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9z'
      
    ]
  };

  
    var faSms = faCommentSms;
  

  
  

  var faBasketShoppingMinus = {
    prefix: 'fal',
    iconName: 'basket-shopping-minus',
    icon: [
      576,
      512,
      [],
      'e652',
      
      'M327.9 2.2c-7.6 4.5-10.2 14.2-5.8 21.9l98 167.9-264.3 0 98-167.9c4.5-7.6 1.9-17.4-5.8-21.9s-17.4-1.9-21.9 5.8L118.8 192 65 192l-33 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0L99.9 463.5C107 492 132.6 512 162 512L414 512c29.4 0 55-20 62.1-48.5L536 224l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-33 0-53.8 0L349.8 7.9c-4.5-7.6-14.2-10.2-21.9-5.8zM73 224l430 0L445.1 455.8C441.5 470 428.7 480 414 480L162 480c-14.7 0-27.5-10-31-24.2L73 224zM208 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fal',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      'M192 64l0 96 288 0 0-64c0-17.7-14.3-32-32-32L192 64zm-32 0L64 64C46.3 64 32 78.3 32 96l0 64 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l256 0c17.7 0 32-14.3 32-32l0-64-288 0 0 96zM480 320l0-128-288 0 0 128 288 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faHandBackPointDown = {
    prefix: 'fal',
    iconName: 'hand-back-point-down',
    icon: [
      448,
      512,
      [],
      'e19e',
      
      'M136 512c-30.9 0-56-25.1-56-56l0-200.6c-3.2-2-6.4-4.2-9.5-6.5L48 232c-20.1-15.1-32-38.8-32-64l0-19.5c0-53 29.1-101.7 75.7-126.8l8.3-4.5C121 5.9 144.4 0 168.3 0L304 0c61.9 0 112 50.1 112 112l0 8 0 88c0 35.3-28.7 64-64 64c-2.8 0-5.6-.2-8.3-.5c-11 19.4-31.8 32.5-55.7 32.5c-5.3 0-10.5-.7-15.5-1.9c-10.8 20.2-32 33.9-56.5 33.9c-8.5 0-16.6-1.7-24-4.7L192 456c0 30.9-25.1 56-56 56zm-24-56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-157.5c0-7.1 4.6-13.3 11.4-15.3s14 .6 18 6.5c5.8 8.7 15.6 14.3 26.7 14.3c15.6 0 28.6-11.2 31.4-25.9c1-5.1 4.4-9.5 9.2-11.6s10.3-1.8 14.8 .9c4.8 2.9 10.5 4.6 16.6 4.6c14.7 0 27.2-10 30.9-23.6c1.2-4.4 4.2-8.1 8.3-10.1s8.8-2.2 13.1-.6c3.6 1.4 7.6 2.2 11.8 2.2c17.7 0 32-14.3 32-32l0-88 0-8c0-44.2-35.8-80-80-80L168.3 32c-18.5 0-36.8 4.6-53.1 13.4l-7.6-14.1 7.6 14.1-8.3 4.5C70.6 69.4 48 107.3 48 148.5L48 168c0 15.1 7.1 29.3 19.2 38.4L80 216l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 78.3 0 1.7 0 208z'
      
    ]
  };

  

  
  

  var faH5 = {
    prefix: 'fal',
    iconName: 'h5',
    icon: [
      640,
      512,
      [],
      'e412',
      
      'M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 256 0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 256 0 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160L32 240 32 80zM432 64c-7.6 0-14.2 5.4-15.7 12.9l-32 160c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9l128 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-71.6 0c-17.2 0-32.5-11-37.9-27.4l-3.2-9.7c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l3.2 9.7c9.8 29.4 37.3 49.2 68.3 49.2l71.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-108.5 0L445.1 96 592 96c8.8 0 16-7.2 16-16s-7.2-16-16-16L432 64z'
      
    ]
  };

  

  
  

  var fa4 = {
    prefix: 'fal',
    iconName: '4',
    icon: [
      384,
      512,
      [],
      '34',
      
      'M174.3 55.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-144 288c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l272 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L41.9 320 174.3 55.2z'
      
    ]
  };

  

  
  

  var faSoftServe = {
    prefix: 'fal',
    iconName: 'soft-serve',
    icon: [
      384,
      512,
      [127846,"creemee"],
      'e400',
      
      'M192 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7L116 64c-37.6 0-68 30.4-68 68c0 11.5 2.8 22.2 7.8 31.7C23.5 174 0 204.2 0 240c0 32.8 19.7 61 48 73.3L48 352c0 22.2 15.1 41 35.7 46.4L92.6 470c3 24 23.4 42 47.6 42l103.5 0c24.2 0 44.6-18 47.6-42l8.9-71.6C320.9 393 336 374.2 336 352l0-38.7c28.3-12.3 48-40.5 48-73.3c0-37.2-25.4-68.5-59.8-77.4c7.5-12.1 11.8-26.3 11.8-41.6C336 54.2 281.8 0 215 0L192 0zM304 288L80 288c-26.5 0-48-21.5-48-48s21.5-48 48-48l8.3 0 23.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-18.6 0C85.2 153.4 80 143.3 80 132c0-19.9 16.1-36 36-36l61.3 0C203.1 96 224 75.1 224 49.3c0-5.9-1.1-11.7-3.2-17.1c46.5 3 83.2 41.6 83.2 88.8c0 16.2-8.2 30.5-20.8 39L240 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l47.7 0 .3 0 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48zM80 320l224 0 0 32c0 8.8-7.2 16-16 16l-2 0c-8.1 0-14.9 6-15.9 14l-10.5 84c-1 8-7.8 14-15.9 14l-103.5 0c-8.1 0-14.9-6-15.9-14l-10.5-84c-1-8-7.8-14-15.9-14l-2 0c-8.8 0-16-7.2-16-16l0-32z'
      
    ]
  };

  
    var faCreemee = faSoftServe;
  

  
  

  var faFaceViewfinder = {
    prefix: 'fal',
    iconName: 'face-viewfinder',
    icon: [
      512,
      512,
      [],
      'e2ff',
      
      'M48 0C21.5 0 0 21.5 0 48l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 0zM464 0L368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96zm464 48c26.5 0 48-21.5 48-48l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z'
      
    ]
  };

  

  
  

  var faGripDotsVertical = {
    prefix: 'fal',
    iconName: 'grip-dots-vertical',
    icon: [
      256,
      512,
      [],
      'e411',
      
      'M64 96A16 16 0 1 0 32 96a16 16 0 1 0 32 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faSpinnerScale = {
    prefix: 'fal',
    iconName: 'spinner-scale',
    icon: [
      512,
      512,
      [],
      'e62a',
      
      'M256 44a20 20 0 1 1 0 40 20 20 0 1 1 0-40zM204 64a52 52 0 1 0 104 0A52 52 0 1 0 204 64zm28 384a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM472 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM76 256a12 12 0 1 1 -24 0 12 12 0 1 1 24 0zM64 212a44 44 0 1 0 0 88 44 44 0 1 0 0-88zm344.7-74.8a24 24 0 1 1 -33.9-33.9 24 24 0 1 1 33.9 33.9zm22.6-56.6a56 56 0 1 0 -79.2 79.2 56 56 0 1 0 79.2-79.2zM92.2 391.8a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM384 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM131.5 131.5a16 16 0 1 1 -22.6-22.6 16 16 0 1 1 22.6 22.6zm22.6-45.3A48 48 0 1 0 86.3 154.2a48 48 0 1 0 67.9-67.9z'
      
    ]
  };

  

  
  

  var faM = {
    prefix: 'fal',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      'M11.3 32.7c6.7-2.1 14 .5 17.9 6.3L224 323.7 418.8 39c4-5.8 11.2-8.3 17.9-6.3S448 41 448 48l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-364.3L237.2 361c-3 4.4-7.9 7-13.2 7s-10.2-2.6-13.2-7L32 99.7 32 464c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 48c0-7 4.6-13.2 11.3-15.3z'
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fal',
    iconName: 'desktop',
    icon: [
      576,
      512,
      [61704,128421,"desktop-alt"],
      'f390',
      
      'M512 32L64 32C46.3 32 32 46.3 32 64l0 192 512 0 0-192c0-17.7-14.3-32-32-32zm64 224l0 32 0 64c0 35.3-28.7 64-64 64l-149.1 0 10.7 64 58.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-72 0-144 0-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.4 0 10.7-64L64 416c-35.3 0-64-28.7-64-64l0-64 0-32L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 192zM32 288l0 64c0 17.7 14.3 32 32 32l167.7 0c.2 0 .4 0 .6 0l111.5 0c.2 0 .4 0 .6 0L512 384c17.7 0 32-14.3 32-32l0-64L32 288zM234.9 480l106.2 0-10.7-64-84.9 0-10.7 64z'
      
    ]
  };

  
    var faDesktopAlt = faDesktop;
  

  
  

  var faDiceD8 = {
    prefix: 'fal',
    iconName: 'dice-d8',
    icon: [
      512,
      512,
      [],
      'f6d2',
      
      'M240 51.3L44.3 247.1l195.7 81 0-276.8zM72.8 293.5L240 460.7l0-98L72.8 293.5zM272 460.7L439.2 293.5 272 362.7l0 98zM467.8 247.1L272 51.3l0 276.8 195.8-81zM239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7z'
      
    ]
  };

  

  
  

  var faShower = {
    prefix: 'fal',
    iconName: 'shower',
    icon: [
      512,
      512,
      [128703],
      'f2cc',
      
      'M32 115.9C32 87.2 55.2 64 83.9 64c13.8 0 27 5.5 36.7 15.2l28.1 28.1c.5 .5 1.1 1 1.7 1.5c-33 43.9-29.5 106.5 10.4 146.4l4.7 4.7-16.8 16.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.8 16.8-4.7-4.7C279.3 56.9 216.7 53.4 172.8 86.4c-.4-.6-.9-1.2-1.5-1.7L143.2 56.6C127.5 40.8 106.1 32 83.9 32C37.6 32 0 69.6 0 115.9L0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-348.1zm151.4 3.5c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7L188.1 237.3l-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM424 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faDoNotEnter = {
    prefix: 'fal',
    iconName: 'do-not-enter',
    icon: [
      512,
      512,
      [],
      'f5ec',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm112-16l0 32c0 4.4 3.6 8 8 8l272 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-272 0c-4.4 0-8 3.6-8 8zm-32 0c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-272 0c-22.1 0-40-17.9-40-40l0-32z'
      
    ]
  };

  

  
  

  var faGaugeSimpleHigh = {
    prefix: 'fal',
    iconName: 'gauge-simple-high',
    icon: [
      512,
      512,
      [61668,"tachometer","tachometer-fast"],
      'f62a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64z'
      
    ]
  };

  
    var faTachometer = faGaugeSimpleHigh;
  
    var faTachometerFast = faGaugeSimpleHigh;
  

  
  

  var faArrowDownBigSmall = {
    prefix: 'fal',
    iconName: 'arrow-down-big-small',
    icon: [
      576,
      512,
      ["sort-size-down"],
      'f88c',
      
      'M171.3 475.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4 176 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 432l0-64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 64zM352 80c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-128zm-32 0l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L368 32c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faSortSizeDown = faArrowDownBigSmall;
  

  
  

  var faCalendarLines = {
    prefix: 'fal',
    iconName: 'calendar-lines',
    icon: [
      448,
      512,
      ["calendar-note"],
      'e0d5',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zM96 368c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm16-112l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faCalendarNote = faCalendarLines;
  

  
  

  var faScaleBalanced = {
    prefix: 'fal',
    iconName: 'scale-balanced',
    icon: [
      640,
      512,
      [9878,"balance-scale"],
      'f24e',
      
      'M384 64c0 29.8-20.4 54.9-48 62l0 354 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-208 0-208 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0 0-354c-27.6-7.1-48-32.2-48-62L112 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l152.6 0C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32L512 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L384 64zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320l-192 0 0-1.6c0 0 0 .1 0 .1l0 1.6c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288l171.3 0L512 147.3zM384 320l0-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6l0 1.6c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320L32 320l0-1.6c0 0 0 .1 0 .1l0 1.6zm10.3-32l171.3 0L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320l0-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6l0 1.6c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faBalanceScale = faScaleBalanced;
  

  
  

  var faDrawPolygon = {
    prefix: 'fal',
    iconName: 'draw-polygon',
    icon: [
      448,
      512,
      [],
      'f5ee',
      
      'M96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0zM80 158l0 196c22.5 5.8 40.2 23.5 46 46l196 0c2.9-11.1 8.6-21 16.4-28.9l-32.2-53.7c-5.8 1.7-11.9 2.6-18.2 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.3 0 12.4 .9 18.2 2.6l32.2-53.7c-7.8-7.9-13.5-17.8-16.4-28.9l-196 0c-5.8 22.5-23.5 40.2-46 46zM365.8 354.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64c-29.8 0-54.9-20.4-62-48l-196 0c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-196C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32c29.8 0 54.9 20.4 62 48l196 0c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.4-.9-18.2-2.6l-32.2 53.7C345 222.6 352 238.5 352 256s-7 33.4-18.4 44.9l32.2 53.7zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM352 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFaceMonocle = {
    prefix: 'fal',
    iconName: 'face-monocle',
    icon: [
      512,
      512,
      [],
      'e380',
      
      'M448 371.4L448 224c0-8.8-7.2-16-16-16c-.9 0-1.8 .1-2.7 .2c-10.7-46-52-80.2-101.3-80.2c-57.4 0-104 46.6-104 104s46.6 104 104 104c37.1 0 69.6-19.4 88-48.5l0 106.5c0 5.9 .4 11.8 1.2 17.6C376.5 453.7 319.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 42.2-11.7 81.7-32 115.4zm3.9 49.4C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM176.4 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328 160a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM160 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C221.3 339.5 193.7 336 176 336c-8.8 0-16 7.2-16 16zM305.2 105.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 77c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 99.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z'
      
    ]
  };

  

  
  

  var faRss = {
    prefix: 'fal',
    iconName: 'rss',
    icon: [
      448,
      512,
      ["feed"],
      'f09e',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16c220.9 0 400 179.1 400 400c0 8.8 7.2 16 16 16s16-7.2 16-16C448 225.4 254.6 32 16 32zm0 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c141.4 0 256 114.6 256 256c0 8.8 7.2 16 16 16s16-7.2 16-16c0-159.1-128.9-288-288-288zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFeed = faRss;
  

  
  

  var faArrowTrendDown = {
    prefix: 'fal',
    iconName: 'arrow-trend-down',
    icon: [
      576,
      512,
      [],
      'e097',
      
      'M368 400c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16l0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 137.4L331.3 148.7c-6.2-6.2-16.4-6.2-22.6 0L192 265.4 27.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0L320 182.6 521.4 384 384 384c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faCookieBite = {
    prefix: 'fal',
    iconName: 'cookie-bite',
    icon: [
      512,
      512,
      [],
      'f564',
      
      'M182.8 28.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4zm46.3 19.7c15 58.3 62 103.6 121.2 116.4c15.6 54.1 59 96.4 113.7 110.5c0 11.2-2.5 22.3-7.5 32.5L419.8 383c-6.8 14.1-17.9 25.6-31.7 32.9l-74 39.5c-13.7 7.3-29.4 10.1-44.8 7.9l-83-11.7c-15.4-2.2-29.7-9.2-40.9-20L85.1 373.2c-11.2-10.9-18.7-25-21.4-40.4L49.1 250c-2.7-15.4-.5-31.3 6.4-45.4L92.2 129c6.8-14.1 17.9-25.6 31.7-32.9l74-39.5c9.7-5.2 20.4-8.1 31.2-8.6zM184 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPeopleSimple = {
    prefix: 'fal',
    iconName: 'people-simple',
    icon: [
      512,
      512,
      [],
      'e21b',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320l84.9 0c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L192 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm17.5 151.2L298.4 352l171.2 0L430.5 215.2C426.6 201.5 414 192 399.7 192l-31.4 0c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-64 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z'
      
    ]
  };

  

  
  

  var faFaceAngry = {
    prefix: 'fal',
    iconName: 'face-angry',
    icon: [
      512,
      512,
      [128544,"angry"],
      'f556',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm82.7-116.1c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      
    ]
  };

  
    var faAngry = faFaceAngry;
  

  
  

  var faFunction = {
    prefix: 'fal',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      'M80 80c0-44.2 35.8-80 80-80l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-26.5 0-48 21.5-48 48l0 112 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 174.1c0 41.1-31.1 75.5-72 79.6l-22.4 2.2C8.8 480.8 1 474.4 .1 465.6s5.5-16.6 14.3-17.5l22.4-2.2C61.3 443.4 80 422.7 80 398.1L80 224l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0L80 80zm221.5 80.5C272.8 206.1 256 260.9 256 320s16.8 113.9 45.5 159.5c4.7 7.5 2.5 17.4-5 22.1s-17.4 2.5-22.1-5C242.5 445.9 224 385.2 224 320s18.5-125.9 50.5-176.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1zm260.9 0c-4.7-7.5-2.5-17.4 5-22.1s17.4-2.5 22.1 5C621.5 194.1 640 254.8 640 320s-18.5 125.9-50.5 176.5c-4.7 7.5-14.6 9.7-22.1 5s-9.7-14.6-5-22.1C591.2 433.9 608 379.1 608 320s-16.8-113.9-45.5-159.5zM379.3 244.7L432 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fal',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      'M384 64c17.7 0 32 14.3 32 32l0 144-176 0 0-176 144 0zm32 208l0 144c0 17.7-14.3 32-32 32l-144 0 0-176 176 0zM208 240L32 240 32 96c0-17.7 14.3-32 32-32l144 0 0 176zM32 272l176 0 0 176L64 448c-17.7 0-32-14.3-32-32l0-144zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  

  
  

  var faAnchor = {
    prefix: 'fal',
    iconName: 'anchor',
    icon: [
      576,
      512,
      [9875],
      'f13d',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 256-32 0c-79.5 0-144-64.5-144-144l0-25.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6 64 336c0 97.2 78.8 176 176 176l48 0 48 0c97.2 0 176-78.8 176-176l0-25.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6l0 25.4c0 79.5-64.5 144-144 144l-32 0 0-256 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faCircleQuarter = {
    prefix: 'fal',
    iconName: 'circle-quarter',
    icon: [
      512,
      512,
      [],
      'e11f',
      
      'M224 34.3L224 224 34.3 224C48.3 125.9 125.9 48.3 224 34.3zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z'
      
    ]
  };

  

  
  

  var faBookQuran = {
    prefix: 'fal',
    iconName: 'book-quran',
    icon: [
      448,
      512,
      ["quran"],
      'f687',
      
      'M384 0c35.3 0 64 28.7 64 64l0 384s0 0 0 0c0 35.3-28.7 64-64 64L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-66.7C13.4 406.7 0 388.9 0 368L0 48C0 21.5 21.5 0 48 0L384 0zM64 416l0 64 320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32L48 32c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l336 0zM298.1 166.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L328 215.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L304 233.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zM126.4 208c0 62.7 50.9 113.6 113.6 113.6c11.7 0 23-1.8 33.6-5c-53.3-5.9-98.3-51.6-98.3-108.6s45-102.6 98.3-108.6c-10.6-3.3-21.9-5-33.6-5c-62.7 0-113.6 50.9-113.6 113.6zM240 65.6c28.5 0 55 8.4 77.3 22.8c10.5 6.8 11.8 18.8 8.4 27.2s-12.8 16-25 13.6c-48.6-9.9-96.6 28.8-96.6 78.8s48 88.7 96.6 78.8c12.3-2.5 21.6 5.2 25 13.6s2.1 20.4-8.4 27.2C295 342 268.5 350.4 240 350.4c-78.6 0-142.4-63.8-142.4-142.4s63.8-142.4 142.4-142.4z'
      
    ]
  };

  
    var faQuran = faBookQuran;
  

  
  

  var faDeleteRight = {
    prefix: 'fal',
    iconName: 'delete-right',
    icon: [
      576,
      512,
      [],
      'e154',
      
      'M32 128c0-17.7 14.3-32 32-32l306.7 0c8.5 0 16.6 3.4 22.6 9.4L544 256 393.4 406.6c-6 6-14.1 9.4-22.6 9.4L64 416c-17.7 0-32-14.3-32-32l0-256zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l306.7 0c17 0 33.3-6.7 45.3-18.7L566.6 278.6c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6L416 82.7C404 70.7 387.7 64 370.7 64L64 64zm84.7 116.7c-6.2 6.2-6.2 16.4 0 22.6L201.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L246.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'fal',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faTornado = {
    prefix: 'fal',
    iconName: 'tornado',
    icon: [
      448,
      512,
      [127786],
      'f76f',
      
      'M352 122.6c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9l-78.2 78.2c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l5.9-35.7c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6L0 32C0 14.3 14.3 0 32 0L393.4 0C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-12 12-18.8 28.4-18.8 45.4zM32 45.6c0 28.7 5.5 56.6 15.7 82.4l272.4 0c-.1-1.8-.2-3.6-.2-5.4c0-25.5 10.1-50 28.2-68L370.7 32 32 32l0 13.6zM142.4 238.7L200 272.5l0-.5 204.9 0c-3.4-7.3-7.6-14.2-12.5-20.8l-53.2-70.9c-4.7-6.3-8.6-13.1-11.7-20.3L63.4 160c19 31.9 45.9 59.2 79 78.7zM253.5 304l5.3 3.1c24.5 14.4 44.3 35.6 57 61c13.8 27.5 18.5 58.6 13.7 89l51.9-51.9c22.1-22.1 34.5-52.1 34.5-83.3c0-6-.5-12-1.4-17.9l-161.1 0z'
      
    ]
  };

  

  
  

  var faFireFlameCurved = {
    prefix: 'fal',
    iconName: 'fire-flame-curved',
    icon: [
      384,
      512,
      ["fire-alt"],
      'f7e4',
      
      'M53.9 186.1C19.4 220.6 0 267.4 0 316.2l0 11.5C0 429.5 82.5 512 184.3 512l15.1 0C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L230.9 78.2C221.4 69.1 216 56.6 216 43.4l0-22.1C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5l-19.5 26c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.9 11.3-.4 22.5 1.6 33.5c2.8 15.3 8.3 29.9 16.4 43.3c.6 1.1 1.3 2.1 2 3.2c1.6 2.5 3.4 5 5.2 7.5l32 42.7c7 9.3 10.8 20.7 10.8 32.4l0 14c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-87.7 0-12c0-10.8-6.1-20.2-15-25c-4-2.1-8.5-3.3-13.3-3.3c-7.5 0-14.7 3-20 8.3L53.9 186.1zM184.5 52.6c2.1 18.5 10.7 35.8 24.3 48.7L287 175.8c41.5 39.5 65 94.3 65 151.6C352 411.7 283.7 480 199.4 480l-15.1 0C100.2 480 32 411.8 32 327.7l0-11.5c0-40.3 16-79 44.5-107.5L88 197.3 88 288c0 39.8 32.2 72 72 72s72-32.2 72-72l0-14c0-18.6-6-36.7-17.2-51.6l-32-42.7c-14.1-18.8-20.8-42.1-18.9-65.6l.9-10.8c1.5-18 8-35.2 18.9-49.6l.8-1.1zm18.7-24.9s0 0 0 0l-8.5-6.4 8.5 6.4s0 0 0 0z'
      
    ]
  };

  
    var faFireAlt = faFireFlameCurved;
  

  
  

  var faArrowUpZA = {
    prefix: 'fal',
    iconName: 'arrow-up-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-up-alt"],
      'f882',
      
      'M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l94.7 0L339.5 198c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-94.7 0L492.5 58c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1L352 32zm64 256c-6.1 0-11.6 3.4-14.3 8.8L337.8 424.6c-.1 .2-.2 .4-.3 .6l-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L361.9 448l108.2 0 11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7c-.1-.2-.2-.4-.3-.6L430.3 296.8c-2.7-5.4-8.2-8.8-14.3-8.8zM377.9 416L416 339.8 454.1 416l-76.2 0z'
      
    ]
  };

  
    var faSortAlphaUpAlt = faArrowUpZA;
  

  
  

  var faPersonWalkingArrowLoopLeft = {
    prefix: 'fal',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
      640,
      512,
      [],
      'e551',
      
      'M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm334.6 90.6c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L412.2 368l75.8 0c83.9 0 152-68.1 152-152s-68.1-152-152-152L336 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l152 0c66.3 0 120 53.7 120 120s-53.7 120-120 120l-75.8 0 62.1-51.7c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80c-3.6 3-5.8 7.5-5.8 12.3s2.1 9.3 5.8 12.3l96 80z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fal',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M64 480l224 0c17.7 0 32-14.3 32-32l0-64 32 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 32-64 0c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32zM224 320l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L224 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32zm-64-32l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faLinkSlash = {
    prefix: 'fal',
    iconName: 'link-slash',
    icon: [
      640,
      512,
      ["chain-broken","chain-slash","unlink"],
      'f127',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L492 310.3l25.3 20L591.5 256zM414.6 412.2l-33.4-26.3c-26.1 1.3-52.5-8.1-72.5-28c-14.2-14.2-23-31.7-26.4-50.1L249 281.5c-2.4 35.7 10.1 72 37.2 99.1c34.8 34.8 84.6 45.3 128.5 31.7zM331.2 154.1c14.2 14.2 23 31.7 26.4 50.1L391 230.5c2.4-35.7-10.1-72-37.2-99.1c-34.8-34.8-84.6-45.3-128.5-31.7l33.4 26.3c26.1-1.3 52.5 8.1 72.5 28zM148 201.7l-25.3-20L48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L148 201.7z'
      
    ]
  };

  
    var faChainBroken = faLinkSlash;
  
    var faChainSlash = faLinkSlash;
  
    var faUnlink = faLinkSlash;
  

  
  

  var faPlugCircleExclamation = {
    prefix: 'fal',
    iconName: 'plug-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e55d',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64c0 83 63.1 151.2 144 159.2l0 96.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96.8c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128l0-64 256 0 0 56.2c9.8-8.1 20.6-15.2 32-21l0-35.2 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0L64 144l-32 0-16 0zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faHandHolding = {
    prefix: 'fal',
    iconName: 'hand-holding',
    icon: [
      576,
      512,
      [],
      'f4bd',
      
      'M195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368 16 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c3.2 0 6.2-.9 8.9-2.7l79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1L344 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 24 0 60.6 0c2.9 0 5.7-.8 8.2-2.3L511.3 355c3.4-2 7.2-3 11.1-3l1.3 0c11.2 0 20.3 9.1 20.3 20.3c0 6.9-3.5 13.3-9.2 17L415.1 467.1c-13 8.4-28.1 12.9-43.6 12.9L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l355.5 0c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3l-1.3 0c-9.7 0-19.1 2.6-27.5 7.6L400.2 384l-5.6 0c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56l-148.6 0z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueWink = {
    prefix: 'fal',
    iconName: 'face-grin-tongue-wink',
    icon: [
      512,
      512,
      [128540,"grin-tongue-wink"],
      'f58b',
      
      'M256 32C132.3 32 32 132.3 32 256c0 79.8 41.7 149.8 104.5 189.5c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5C47.7 427.3 0 347.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 91.2-47.7 171.3-119.5 216.6c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1C438.3 405.8 480 335.8 480 256C480 132.3 379.7 32 256 32zm96 351.4l0 32.6c0 53-43 96-96 96s-96-43-96-96l0-32.7c-20.2-15.7-36.3-36.2-46.8-59.8c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7c-10.4 23.6-26.6 44.2-46.9 59.9zm-32-4.7c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64l0-37.4zM336 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM124.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM336.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGrinTongueWink = faFaceGrinTongueWink;
  

  
  

  var faCirclePlus = {
    prefix: 'fal',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faShoePrints = {
    prefix: 'fal',
    iconName: 'shoe-prints',
    icon: [
      640,
      512,
      [],
      'f54b',
      
      'M319.9 47c31.6-7.9 68.4-15 96.1-15c43.5 0 94.5 11 133.7 30.6c41 20.5 58.3 44.3 58.3 65.4c0 19.6-13.4 35.6-46.2 48.1C529.9 188.2 490.2 192 464 192c-39.2 0-61-12.3-88.1-27.8l-.5-.3c-22.9-13.1-49.1-28.1-87.4-33.7l0-74.6c8.8-2.6 19.8-5.6 31.9-8.6zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32l0 96 0 32s0 0 0 0zm-64-32c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-32-32 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l32 0 0-32-32 0zm-.1 337c-12.1-3-23-6-31.9-8.6l0-74.6c38.2-5.6 64.5-20.6 87.4-33.7l.5-.3C275 332.3 296.8 320 336 320c26.2 0 65.9 3.8 97.8 15.9C466.6 348.4 480 364.4 480 384c0 21.1-17.4 44.9-58.3 65.4C382.5 469 331.5 480 288 480c-27.7 0-64.5-7.2-96.1-15zM128 352s0 0 0 0l0 32 0 96s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM64 384l32 0 0-32-32 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l32 0 0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faDragon = {
    prefix: 'fal',
    iconName: 'dragon',
    icon: [
      640,
      512,
      [128009],
      'f6d5',
      
      'M288.8 10.9C291 4.4 297.1 0 304 0L432 0l16 0 35.8 0c32.7 0 63.8 14.3 85 39.1l56 65.4c9.7 11.4 15.1 25.8 15.1 40.8c0 34.6-28.1 62.7-62.7 62.7l-22.8 0c-21.2 0-41.6-8.4-56.6-23.4l-8.6-8.6-9.4 0 0 12c0 17.6 8.3 34.2 22.4 44.8l90.7 68C622.6 323 640 357.7 640 394.7c0 62-48 112.7-108.9 117c-1 .2-2 .3-3.1 .3l-5.3 0L440 512 48.4 512c-24.7 .2-45.9-18.5-48.2-43.6c-2.4-26.4 17-49.8 43.4-52.2l378.3-35-29-34.9C366.4 314.7 352 274.8 352 233.7l0-45.4s0 0 0 0l0-.3s0 0 0 0l0-34.1-55.2-27.6c-5-2.5-8.3-7.4-8.8-12.9s1.9-10.9 6.3-14.2L341.3 64 294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9zM525.9 480c.4-.1 .8-.1 1.3-.1c45-2.3 80.8-39.6 80.8-85.2c0-26.9-12.6-52.2-34.1-68.3l-90.7-68C461 241.8 448 215.7 448 188l0-28c0-8.8 7.2-16 16-16l32 0c4.2 0 8.3 1.7 11.3 4.7l13.3 13.3c9 9 21.2 14.1 33.9 14.1l22.8 0c17 0 30.7-13.8 30.7-30.7c0-7.3-2.6-14.4-7.4-20l-56-65.4C529.4 42.2 507.2 32 483.8 32L448 32l-16 0-80 0 25.6 19.2c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-43.3 32.5 40.8 20.4c5.4 2.7 8.8 8.3 8.8 14.3l0 44s0 0 0 0l0 .3s0 0 0 0l0 45.4c0 33.7 11.8 66.3 33.4 92.2L459 375.8c3.2 3.9 5 8.8 5 13.9c0 11.2-8.5 20.6-19.7 21.6L46.5 448.1c-8.8 .8-15.3 8.6-14.5 17.4c.8 8.4 7.8 14.6 16.1 14.5l.2 0s0 0 0 0L440 480l82.7 0 3.2 0zM320 199.4l0 34.2c0 1.4 0 2.8 0 4.3L171.7 139c-6.1-4-14.1-3.5-19.5 1.4L63 219.7l127.6-11.6c6.7-.6 13.1 3 15.9 9.1s1.6 13.3-3.2 18.1L150.6 288l176.6 0c3 11 6.8 21.7 11.5 32L112 320c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l48.8-48.8-132 12c-6.9 .6-13.4-3.2-16.1-9.6S.2 232.6 5.4 228L130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87zM495.2 57.7l32 16c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z'
      
    ]
  };

  

  
  

  var faWifiWeak = {
    prefix: 'fal',
    iconName: 'wifi-weak',
    icon: [
      640,
      512,
      ["wifi-1"],
      'f6aa',
      
      'M320 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faWifi1 = faWifiWeak;
  

  
  

  var faBorderBottom = {
    prefix: 'fal',
    iconName: 'border-bottom',
    icon: [
      448,
      512,
      [],
      'f84d',
      
      'M448 464c0 8.8-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16zM392 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 352A24 24 0 1 1 8 352a24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM440 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 160a24 24 0 1 1 48 0A24 24 0 1 1 8 160zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm144 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM440 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 64a24 24 0 1 1 48 0A24 24 0 1 1 8 64zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm48 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm48 192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  

  
  

  var faVolumeSlash = {
    prefix: 'fal',
    iconName: 'volume-slash',
    icon: [
      640,
      512,
      [128263],
      'f2e2',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-59.6-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1s-4.7 16.9 2.1 22.5C521.4 161.9 544 206.3 544 256c0 28.7-7.5 55.6-20.8 78.9l25.4 20C566 326 576 292.2 576 256zM472 294.4c5.2-11.8 8-24.8 8-38.4c0-31.4-15.1-59.3-38.4-76.8c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C438 216.5 448 235.1 448 256c0 6.1-.9 12-2.4 17.6L472 294.4zM352 61.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5l-72.1 64.1 25.5 20.1L320 66.7l0 107.8 32 25.3 0-137.9zM88 192l47.6 0L95.1 160 88 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L302.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-87.4-32-25.3 0 107.8L183.6 324c-2.9-2.6-6.7-4-10.6-4l-85 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faSdCard = {
    prefix: 'fal',
    iconName: 'sd-card',
    icon: [
      384,
      512,
      [],
      'f7c2',
      
      'M352 64l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-293.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4L320 32c17.7 0 32 14.3 32 32zm32 384l0-384c0-35.3-28.7-64-64-64L154.5 0c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64zM192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z'
      
    ]
  };

  

  
  

  var faAmpGuitar = {
    prefix: 'fal',
    iconName: 'amp-guitar',
    icon: [
      512,
      512,
      [],
      'f8a1',
      
      'M139.6 51.9C168.3 27.2 210.1 0 256 0s87.7 27.2 116.4 51.9c4.8 4.1 9.3 8.2 13.4 12.1L448 64c35.3 0 64 28.7 64 64l0 128 0 16 0 16 0 160c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 288l0-16 0-16L0 128C0 92.7 28.7 64 64 64l62.2 0c4.2-4 8.7-8.1 13.4-12.1zm36 12.1l160.8 0C312.1 46 284 32 256 32s-56.1 14-80.4 32zM480 288L32 288l0 160c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-160zm0-32l0-128c0-17.7-14.3-32-32-32L64 96c-17.7 0-32 14.3-32 32l0 128 448 0zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faLighthouse = {
    prefix: 'fal',
    iconName: 'lighthouse',
    icon: [
      640,
      512,
      [],
      'e612',
      
      'M23.2 1.7C15.3-2.3 5.6 .9 1.7 8.8s-.7 17.5 7.2 21.5l128 64c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-128-64zm128 188.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-128 64c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l128-64zM312.1 2.1l-112 64c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l8.1-4.6 0 38.7 32 0 0-57 64-36.6L384 71l0 57 32 0 0-38.7 8.1 4.6c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-112-64c-4.9-2.8-11-2.8-15.9 0zM250.2 192l139.5 0 57.6 288L384 480l0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-63.4 0 57.6-288zm-32.6 0l-57 285.2c-.2 .9-.3 1.9-.4 2.8L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l45.1 0 66.9 0 32 0 64 0 32 0 66.9 0 45.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16.1 0c-.1-.9-.2-1.9-.4-2.8L422.4 192l9.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-192 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l9.6 0zM352 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM638.3 8.9c-4-7.9-13.6-11.1-21.5-7.2l-128 64c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l128-64c7.9-4 11.1-13.6 7.2-21.5zm-156.6 160c-4 7.9-.7 17.5 7.2 21.5l128 64c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-128-64c-7.9-4-17.5-.7-21.5 7.2z'
      
    ]
  };

  

  
  

  var faBahai = {
    prefix: 'fal',
    iconName: 'bahai',
    icon: [
      576,
      512,
      ["haykal"],
      'f666',
      
      'M287.7 0c7.2 0 13.6 4.9 15.5 11.9l32.2 120.7L437.8 60.8c5.9-4.2 13.9-3.8 19.5 .8s7.3 12.5 4.2 19l-53 113.1 124.6 10.7c7.2 .6 13.1 6 14.4 13.2s-2.4 14.2-9 17.3L425 287.7l88.5 88.2c5.1 5.1 6.2 13 2.6 19.3s-11 9.3-18 7.5L377.3 370.2l11 124.4c.6 7.2-3.6 14-10.5 16.4s-14.4 .1-18.6-5.9L287.7 402.7 216.1 505.2c-4.2 5.9-11.8 8.3-18.6 5.9s-11.1-9.2-10.5-16.4l11-124.4L77.3 402.6c-7 1.9-14.4-1.2-18-7.5s-2.6-14.2 2.6-19.3l88.5-88.2L37 235c-6.6-3.1-10.3-10.1-9-17.3s7.2-12.5 14.4-13.2l124.6-10.7L114 80.7c-3.1-6.6-1.4-14.4 4.2-19s13.5-5 19.5-.8L240 132.6 272.2 11.9c1.9-7 8.2-11.9 15.5-11.9zm0 78L265 162.9c-1.3 5-5.1 9.1-10 10.9s-10.4 1.1-14.7-1.9l-72-50.5L205.6 201c2.2 4.7 2 10.3-.6 14.8s-7.3 7.5-12.5 7.9l-87.6 7.5 79.7 37c4.7 2.2 8.1 6.6 9 11.7s-.8 10.4-4.5 14.1l-62.2 62 84.9-22.8c5-1.4 10.4-.2 14.4 3.2s6.1 8.5 5.7 13.7l-7.8 87.5 50.4-72.1c3-4.3 7.9-6.8 13.1-6.8s10.1 2.6 13.1 6.8l50.4 72.1-7.8-87.5c-.5-5.2 1.6-10.3 5.7-13.7s9.4-4.6 14.4-3.2l84.9 22.8-62.2-62c-3.7-3.7-5.4-9-4.5-14.1s4.3-9.5 9-11.7l79.7-37-87.6-7.5c-5.2-.4-9.9-3.4-12.5-7.9s-2.9-10-.6-14.8L407 121.4l-72 50.5c-4.3 3-9.8 3.7-14.7 1.9s-8.6-5.9-10-10.9L287.7 78z'
      
    ]
  };

  
    var faHaykal = faBahai;
  

  
  

  var faUserDoctorMessage = {
    prefix: 'fal',
    iconName: 'user-doctor-message',
    icon: [
      640,
      512,
      ["user-md-chat"],
      'f82e',
      
      'M128 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM160 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-96l0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-30.9C80.2 354.7 32.6 411.8 32 480l384 0c-.5-62.4-40.4-115.4-96-135.5l0 25.8c23.1 6.9 40 28.3 40 53.7l0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24c0-25.4 16.9-46.8 40-53.7l0-33.3c-5.6-.7-11.4-1-17.2-1l-93.6 0-1.2 0zM0 481.2C0 383.3 79.3 304 177.2 304l93.6 0C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8L30.8 512C13.8 512 0 498.2 0 481.2zM544 192l48 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L432 32c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l16 0c17.7 0 32 14.3 32 32l0 8 44.8-33.6c5.5-4.2 12.3-6.4 19.2-6.4zm-65.1 80.8l-9.6 7.2-8.5 6.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-10.7 0-12 0-1.4 0-32-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-64 48-1.1 .8z'
      
    ]
  };

  
    var faUserMdChat = faUserDoctorMessage;
  

  
  

  var faTrailer = {
    prefix: 'fal',
    iconName: 'trailer',
    icon: [
      640,
      512,
      [],
      'e041',
      
      'M56 64l400 0c13.3 0 24 10.7 24 24l0 264-197.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L56 352c-13.3 0-24-10.7-24-24L32 88c0-13.3 10.7-24 24-24zM288 384l328 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-104 0 0-264c0-30.9-25.1-56-56-56L56 32C25.1 32 0 57.1 0 88L0 328c0 30.9 25.1 56 56 56l40 0c0 53 43 96 96 96s96-43 96-96zm-32 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM112 96c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faBoxHeart = {
    prefix: 'fal',
    iconName: 'box-heart',
    icon: [
      448,
      512,
      [],
      'f49d',
      
      'M240 64l102.4 0c12.6 0 24.1 7.4 29.2 19l34.2 77L240 160l0-96zm0 128l176 0 0 224c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-224 176 0 32 0zm-32-32L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19L208 64l0 96zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM146.7 264.5c14.3-14.3 37.4-14.3 51.7 0l14.3 14.3c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l14.3-14.3c14.3-14.3 37.4-14.3 51.7 0s14.3 37.4 0 51.7L224 393.4l-77.3-77.3c-14.3-14.3-14.3-37.4 0-51.7zM221 241.8c-26.8-26.8-70.2-26.8-96.9 0s-26.8 70.2 0 96.9L201.4 416c12.5 12.5 32.8 12.5 45.3 0l77.3-77.3c26.8-26.8 26.8-70.2 0-96.9s-70.2-26.8-96.9 0l-3 3-3-3z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fal',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faBoothCurtain = {
    prefix: 'fal',
    iconName: 'booth-curtain',
    icon: [
      512,
      512,
      [],
      'f734',
      
      'M0 32L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16L32 32l32 0L64 0 32 0C14.3 0 0 14.3 0 32zm288 0l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352 64 0zM256 448c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c11.7 0 22.6-3.1 32-8.6l0 56.6c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 0-336 0-16c0-17.7-14.3-32-32-32L208 0 128 0C110.3 0 96 14.3 96 32l0 352c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7zM480 48l0 336c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352 64 0 0 16zM384 32l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352 64 0zM192 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352 64 0 0 352z'
      
    ]
  };

  

  
  

  var faCloudMoonRain = {
    prefix: 'fal',
    iconName: 'cloud-moon-rain',
    icon: [
      576,
      512,
      [],
      'f73c',
      
      'M357.5 109.6c10.8-32.9 36.5-59.3 69.4-71c-17.1 22.5-27.3 50.4-27.3 80.8c0 63.2 44.1 116.1 103.2 130.4c-10.6 3.7-21.9 5.8-33.7 6.2c4.6 9.8 7.9 20.4 9.5 31.5c34-3.1 64.7-17.8 87.8-40.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-5.8 1-11.7 1.5-17.8 1.5c-57.2 0-103.4-45.9-103.4-102.2c0-38.1 21.1-71.4 52.5-89c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-4.1-.3-8.2-.5-12.3-.5C401.2 0 346.7 41.2 327.4 98.5c10.7 2.3 20.7 6.1 30 11.1zM88.6 418.5c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zM112 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-266.6 0c-.1 0-.3 0-.4 0c-.1 0-.1 0-.2 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3C34.6 200.9 0 240.4 0 288c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1l266.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 114.6 210.9 96 176 96z'
      
    ]
  };

  

  
  

  var faUpDown = {
    prefix: 'fal',
    iconName: 'up-down',
    icon: [
      256,
      512,
      [8597,11021,"arrows-alt-v"],
      'f338',
      
      'M103.3 9.7C110 3.5 118.8 0 128 0s18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3L192 160l0 192 25.7 0c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7s-18-3.5-24.7-9.7l-91-84C4.5 411.1 0 400.9 0 390.3C0 369.1 17.1 352 38.3 352L64 352l0-192-25.7 0C17.1 160 0 142.9 0 121.7c0-10.7 4.5-20.9 12.3-28.1l91-84zM128 32c-1.1 0-2.2 .4-3 1.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3L80 128c8.8 0 16 7.2 16 16l0 224s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 8.8-7.2 16-16 16l-41.7 0c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.8 2-4.6c0-3.5-2.8-6.3-6.3-6.3L176 384c-8.8 0-16-7.2-16-16c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l0-224c0-8.8 7.2-16 16-16l41.7 0c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2z'
      
    ]
  };

  
    var faArrowsAltV = faUpDown;
  

  
  

  var faPencilMechanical = {
    prefix: 'fal',
    iconName: 'pencil-mechanical',
    icon: [
      512,
      512,
      [],
      'e5ca',
      
      'M440 0c-9.4 0-18.3 3.7-25 10.3L376.4 48.9c-2.7-.6-5.6-.9-8.4-.9c-10.2 0-20.1 4.1-27.3 11.3L311.3 88.7 281.9 59.3c-18.7-18.7-49.1-18.7-67.9 0L108.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L236.7 81.9c6.2-6.2 16.4-6.2 22.6 0l29.4 29.4L80.4 319.7c-5.5 5.5-9.6 12.2-11.9 19.6L32 456l.7 .7-28 28c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28-28 .7 .7 116.7-36.5c7.4-2.3 14.1-6.4 19.6-11.9L452.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3c0-2.9-.3-5.7-.9-8.4L501.7 97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L465 10.3C458.3 3.7 449.4 0 440 0zm4.7 108.7L403.3 67.3 437.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 69.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-34.3 34.3zm-14.6 30.6c1.2 1.2 1.9 2.9 1.9 4.7s-.7 3.4-1.9 4.7L188.7 390.1l-66.7-66.7L363.3 81.9c1.2-1.2 2.9-1.9 4.7-1.9s3.4 .7 4.7 1.9l57.4 57.4zM99 348.8c.2-.8 .5-1.5 .9-2.3l65.5 65.5c-.7 .4-1.5 .7-2.3 .9L69.9 442.1 99 348.8z'
      
    ]
  };

  

  
  

  var faTurtle = {
    prefix: 'fal',
    iconName: 'turtle',
    icon: [
      576,
      512,
      [128034],
      'f726',
      
      'M200 64C124.9 64 64 124.9 64 200l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40c0-92.8 75.2-168 168-168s168 75.2 168 168l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40c0-75.1-60.9-136-136-136zM400 188.6c0-42.3 34.3-76.6 76.6-76.6c54.9 0 99.4 44.5 99.4 99.4l0 12.6c0 35.3-28.7 64-64 64l-20.5 0c-20.3 57.4-74.7 96-135.8 96l-3.7 0 0 48c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-48-32 0 0 48c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-48-16 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l312 0c22.1 0 40-17.9 40-40l0-59.4zM256 416l0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16 0-32 0-32 35.7 0c48.2 0 91-30.8 106.3-76.6l2.8-8.5c2.2-6.5 8.3-10.9 15.2-10.9l32 0c17.7 0 32-14.3 32-32l0-12.6c0-37.2-30.2-67.4-67.4-67.4C452 144 432 164 432 188.6l0 59.4c0 39.8-32.2 72-72 72l-40 0-64 0-96 0-64 0-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32 0 32 0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16 0-32 0-32 96 0 0 32 0 32zM480 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCaravanSimple = {
    prefix: 'fal',
    iconName: 'caravan-simple',
    icon: [
      640,
      512,
      ["caravan-alt"],
      'e000',
      
      'M80 64c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64L544 384l0-192c0-70.7-57.3-128-128-128L80 64zM96 416l-16 0c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l336 0c88.4 0 160 71.6 160 160l0 192 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-32 0-256 0c0 53-43 96-96 96s-96-43-96-96zM256 160l-128 0 0 64 128 0 0-64zM128 128l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm224 32l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM256 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faCaravanAlt = faCaravanSimple;
  

  
  

  var faPersonWalkingLuggage = {
    prefix: 'fal',
    iconName: 'person-walking-luggage',
    icon: [
      576,
      512,
      [],
      'e554',
      
      'M400 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 368 56a56 56 0 1 0 112 0zM341.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L433.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L464.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L411.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm-94.8-63.4c-7.5-4.6-17.4-2.2-22 5.3l-25.2 41.4c-.6-.4-1.1-.7-1.7-1.1L144 304c-15.3-8.8-34.9-3.6-43.7 11.7l-64 110.9c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l36.3-62.9 70.2-115.3c4.6-7.5 2.2-17.4-5.3-22zM118 473.7L64 442.6l64-110.9 55.4 32-27.5 47.6-38 62.4z'
      
    ]
  };

  

  
  

  var faParagraphLeft = {
    prefix: 'fal',
    iconName: 'paragraph-left',
    icon: [
      384,
      512,
      ["paragraph-rtl"],
      'f878',
      
      'M320 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0 208 0 176 0 144 0C82.1 0 32 50.1 32 112s50.1 112 112 112l48 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 0-16 0-176 64 0 0 272c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272zM192 32l0 160-48 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l32 0 16 0zM122.2 348.3c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80C2.1 406.7 0 411.3 0 416s2.1 9.3 5.8 12.3l96 80c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L60.2 432 368 432c8.8 0 16-7.2 16-16s-7.2-16-16-16L60.2 400l62.1-51.7z'
      
    ]
  };

  
    var faParagraphRtl = faParagraphLeft;
  

  
  

  var faBagsShopping = {
    prefix: 'fal',
    iconName: 'bags-shopping',
    icon: [
      576,
      512,
      [128717],
      'f847',
      
      'M160 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64-128 0 0-64zm-32 64l-64 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l96 0 0-32-96 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l32 0c0-35.3-28.7-64-64-64l-64 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64zM512 288c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l256 0zM192 320l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-256 0c-35.3 0-64 28.7-64 64zm128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16z'
      
    ]
  };

  

  
  

  var faFan = {
    prefix: 'fal',
    iconName: 'fan',
    icon: [
      512,
      512,
      [],
      'f863',
      
      'M242.5 134.2c-1.1 10.6 3.2 21 11.4 27.8s19.2 9.1 29.4 6.1c16.9-4.9 39.3-8.2 68.8-8.2l.1 0c59.5-.2 108.2 37.9 123.1 92.2l-97.5-9.7c-10.6-1.1-21 3.2-27.8 11.4s-9.1 19.2-6.1 29.4c4.9 16.9 8.2 39.3 8.2 68.8l0 .1c.2 59.5-37.9 108.2-92.2 123.1l9.7-97.5c1.1-10.6-3.2-21-11.4-27.8s-19.2-9.1-29.4-6.1c-16.9 4.9-39.3 8.2-68.8 8.2l-.1 0c-59.5 .2-108.2-37.9-123.1-92.2l97.5 9.7c10.6 1.1 21-3.2 27.8-11.4s9.1-19.2 6.1-29.4c-4.9-16.9-8.2-39.3-8.2-68.8l0-.1c-.2-59.5 37.9-108.2 92.2-123.1l-9.7 97.5zM480.1 252.7s0 0 0 0c0 0 0 0 0 0zM32 259.3s0 0 0 0c0 0 0 0 0 0zM252.7 32s0 0 0 0c0 0 0 0 0 0zm21.6 105.5l3.4-33.9 6.8-68.3c1.9-18.8-13.1-35.5-31.6-31.5C179.9 19.2 127.7 82.7 128 160c0 16.6 1 31.5 2.7 44.9c1.6 12.2 3.9 23.1 6.7 32.8l-33.9-3.4-68.3-6.8C16.4 225.6-.3 240.6 3.7 259.1C19.2 332.2 82.8 384.3 160 384c16.6 0 31.5-1 44.9-2.7c12.2-1.6 23.1-3.9 32.8-6.7l-3.4 33.9-6.8 68.3c-1.9 18.8 13.1 35.5 31.6 31.5C332.2 492.8 384.3 429.3 384 352c0-16.6-1-31.5-2.7-44.9c-1.6-12.2-3.9-23.1-6.7-32.8l33.9 3.4 68.3 6.8c18.8 1.9 35.5-13.1 31.5-31.6C492.8 179.8 429.3 127.7 352 128c-16.6 0-31.5 1-44.9 2.7c-12.2 1.6-23.1 3.9-32.8 6.7zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBlockBrick = {
    prefix: 'fal',
    iconName: 'block-brick',
    icon: [
      448,
      512,
      ["wall-brick"],
      'e3db',
      
      'M136 64l0 64 72 0 32 0 72 0 0-64L136 64zm-32 0L64 64C46.3 64 32 78.3 32 96l0 32 72 0 0-64zM32 160l0 80 72 0 32 0 72 0 0-80L32 160zm0 192l72 0 0-80-72 0 0 80zm0 32l0 32c0 17.7 14.3 32 32 32l144 0 0-64-72 0-32 0-72 0zm104-32l176 0 0-80-176 0 0 80zm208 0l72 0 0-80-72 0 0 80zm72 32l-72 0-32 0-72 0 0 64 144 0c17.7 0 32-14.3 32-32l0-32zm0-224l-176 0 0 80 72 0 32 0 72 0 0-80zm0-32l0-32c0-17.7-14.3-32-32-32l-40 0 0 64 72 0zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faWallBrick = faBlockBrick;
  

  
  

  var faVoicemail = {
    prefix: 'fal',
    iconName: 'voicemail',
    icon: [
      640,
      512,
      [],
      'f897',
      
      'M144 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM288 240c0 45.2-20.9 85.6-53.5 112l171 0C372.9 325.6 352 285.2 352 240c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144l-352 0C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zM496 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224z'
      
    ]
  };

  

  
  

  var faPersonArrowDownToLine = {
    prefix: 'fal',
    iconName: 'person-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e538',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM160 480l0-128 64 0 0 128-64 0zm-32 0L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 96 0 384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-368 0 0-277.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L275.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.1 128 480zM480 48l0 313.4-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L512 361.4 512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faObjectIntersect = {
    prefix: 'fal',
    iconName: 'object-intersect',
    icon: [
      512,
      512,
      [],
      'e49d',
      
      'M96 32L64 32C46.3 32 32 46.3 32 64l0 32L0 96 0 64C0 28.7 28.7 0 64 0L96 0l0 32zm32 0l0-32 96 0 0 32-96 0zM0 128l32 0 0 96L0 224l0-96zM288 32l-32 0 0-32 32 0c35.3 0 64 28.7 64 64l0 64-32 0 0-64c0-17.7-14.3-32-32-32zm32 128l32 0 0 32 0 64 0 32c0 35.3-28.7 64-64 64l-64 0-32 0-32 0 0-32 0-64 0-32c0-35.3 28.7-64 64-64l64 0 32 0zM160 384l32 0 0 64c0 17.7 14.3 32 32 32l32 0 0 32-32 0c-35.3 0-64-28.7-64-64l0-64zm-32-32l-64 0c-35.3 0-64-28.7-64-64l0-32 32 0 0 32c0 17.7 14.3 32 32 32l64 0 0 32zM384 192l0-32 64 0c35.3 0 64 28.7 64 64l0 32-32 0 0-32c0-17.7-14.3-32-32-32l-64 0zM288 512l0-32 96 0 0 32-96 0zm160 0l-32 0 0-32 32 0c17.7 0 32-14.3 32-32l0-32 32 0 0 32c0 35.3-28.7 64-64 64zm64-128l-32 0 0-96 32 0 0 96zM224 192c-17.7 0-32 14.3-32 32l0 96 96 0c17.7 0 32-14.3 32-32l0-96-96 0z'
      
    ]
  };

  

  
  

  var faChimney = {
    prefix: 'fal',
    iconName: 'chimney',
    icon: [
      448,
      512,
      [],
      'f78b',
      
      'M32 64l384 0 0 64-16 0-224 0L48 128l-16 0 0-64zm0 96l0 112 0 128 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 96 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 80 0 112 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-128 0-112c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32zm352 0l0 96-112 0-80 0 0-96 192 0zm-224 0l0 96-96 0 0-96 96 0zm16 224L64 384l0-96 112 0 80 0 0 96-80 0zm112 0l0-96 96 0 0 96-96 0z'
      
    ]
  };

  

  
  

  var faVialCircleCheck = {
    prefix: 'fal',
    iconName: 'vial-circle-check',
    icon: [
      512,
      512,
      [],
      'e596',
      
      'M0 48c0-8.8 7.2-16 16-16l16 0 32 0 128 0 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 202.8c-20.2 28.6-32 63.5-32 101.2l0-144L64 224l0 160c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96L32 64 16 64C7.2 64 0 56.8 0 48zM64 64l0 128 128 0 0-128L64 64zM368 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faInfinity = {
    prefix: 'fal',
    iconName: 'infinity',
    icon: [
      640,
      512,
      [8734,9854],
      'f534',
      
      'M0 233.5C0 157.5 61.5 96 137.5 96c39.3 0 76.7 16.8 102.7 46.1L320 231.9l79.8-89.8C425.9 112.8 463.3 96 502.5 96C578.5 96 640 157.5 640 233.5l0 45.1C640 354.5 578.5 416 502.5 416c-39.3 0-76.7-16.8-102.7-46.1L320 280.1l-79.8 89.8C214.1 399.2 176.7 416 137.5 416C61.5 416 0 354.5 0 278.5l0-45.1zM298.6 256l-82.3-92.6c-20-22.5-48.7-35.4-78.8-35.4C79.2 128 32 175.2 32 233.5l0 45.1C32 336.8 79.2 384 137.5 384c30.1 0 58.8-12.9 78.8-35.4L298.6 256zm42.8 0l82.3 92.6c20 22.5 48.7 35.4 78.8 35.4C560.8 384 608 336.8 608 278.5l0-45.1C608 175.2 560.8 128 502.5 128c-30.1 0-58.8 12.9-78.8 35.4L341.4 256z'
      
    ]
  };

  

  
  

  var faCassetteVhs = {
    prefix: 'fal',
    iconName: 'cassette-vhs',
    icon: [
      576,
      512,
      [128252,"vhs"],
      'f8ec',
      
      'M32 160l0 256c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-256L32 160zm0-32l512 0 0-32c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 32zM576 96l0 32 0 16 0 16 0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160l0-16 0-16L0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64zM136 208l72 0 160 0 72 0c3.5 0 6.9 1.1 9.7 3.3L440 224c9.7-12.7 9.7-12.7 9.7-12.7s0 0 0 0s0 0 0 0c0 0 0 0 .1 0l.2 .1 .5 .4c.4 .3 1 .8 1.6 1.3c1.3 1.1 3.2 2.7 5.3 4.8c4.3 4.1 9.9 10.2 15.6 18c11.3 15.5 23 38.8 23 68s-11.8 52.5-23 68c-5.7 7.8-11.3 13.8-15.6 18c-2.1 2.1-4 3.7-5.3 4.8c-.7 .6-1.2 1-1.6 1.3l-.5 .4-.2 .1c0 0 0 0-.1 0c0 0 0 0 0 0s0 0 0 0L440 384l9.7 12.7c-2.8 2.1-6.2 3.3-9.7 3.3l-72 0-160 0-72 0c-3.5 0-6.9-1.1-9.7-3.3L136 384c-9.7 12.7-9.7 12.7-9.7 12.7s0 0 0 0s0 0 0 0c0 0 0 0-.1 0l-.2-.1-.5-.4c-.4-.3-1-.8-1.6-1.3c-1.3-1.1-3.2-2.7-5.3-4.8c-4.3-4.1-9.9-10.2-15.6-18c-11.3-15.5-23-38.8-23-68s11.8-52.5 23-68c5.7-7.8 11.3-13.8 15.6-18c2.1-2.1 4-3.7 5.3-4.8c.7-.6 1.2-1 1.6-1.3l.5-.4 .2-.1c0 0 0 0 .1 0c0 0 0 0 0 0s0 0 0 0L136 224l-9.7-12.7c2.8-2.1 6.2-3.3 9.7-3.3zm4.9 33c-3.2 3.1-7.6 7.8-11.9 13.7c-8.7 12.1-17 28.8-17 49.2s8.2 37.2 17 49.2c4.3 6 8.7 10.6 11.9 13.7c.4 .4 .7 .7 1.1 1l50.1 0 0-32c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-32-50.1 0c-.3 .3-.7 .7-1.1 1zM352 368l0-128-128 0 0 128 128 0zm82.1 0l.6-.5 .5-.5c3.2-3.1 7.6-7.8 11.9-13.7c8.7-12.1 17-28.8 17-49.2s-8.2-37.2-17-49.2c-4.3-6-8.7-10.6-11.9-13.7c-.4-.4-.7-.7-1.1-1L384 240l0 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 32 50.1 0z'
      
    ]
  };

  
    var faVhs = faCassetteVhs;
  

  
  

  var faChartColumn = {
    prefix: 'fal',
    iconName: 'chart-column',
    icon: [
      512,
      512,
      [],
      'e0e3',
      
      'M16 32c8.8 0 16 7.2 16 16l0 352c0 26.5 21.5 48 48 48l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 480c-44.2 0-80-35.8-80-80L0 48c0-8.8 7.2-16 16-16zM144 256c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM256 144l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 48c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16zm112-80l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faHippo = {
    prefix: 'fal',
    iconName: 'hippo',
    icon: [
      640,
      512,
      [129435],
      'f6ed',
      
      'M427.3 44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l12.1 12.1c-4.4 3.2-8.4 6.8-12 10.8L382 81.2C353.6 69.8 323.4 64 292.9 64L224 64C118 64 32 150 32 256l0 8s0 0 0 0l0 19.1c0 25.4-8.7 50.1-24.5 70L3.5 358C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90L64 264s0 0 0 0l0-8c0-88.4 71.6-160 160-160l68.9 0c26.5 0 52.7 5 77.2 14.9l18.2 7.3c-2.8 8.1-4.3 16.8-4.3 25.9l0 5c0 9.5-4.5 18.4-10.8 25.6C360 190.1 352 210.1 352 232c0 45.9 35.1 83.6 80 87.6l0 16.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 88 0c2.7 0 5.4-.1 8-.4l0 16.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-25.6c28.5-14.6 48-44.2 48-78.4c0-30.8-15.8-57.8-39.7-73.6c-4.9-3.2-8.3-8.5-8.3-14.4c0-22.4-9.2-42.7-24.1-57.3l11.4-11.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L540.2 69.1C531.5 65.8 521.9 64 512 64l-48 0c-5.4 0-10.7 .5-15.8 1.6L427.3 44.7zM448 288l-8 0c-30.9 0-56-25.1-56-56c0-14 5.1-26.7 13.5-36.5c9.2-10.7 18.5-26.7 18.5-46.5l0-5c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48c0 13.4 5.5 24.7 13.2 33c-25.7 5.1-45.2 27.7-45.2 55c0 8.8 7.2 16 16 16s16-7.2 16-16c0-13.3 10.7-24 24-24s24 10.7 24 24c0 30.9-25.1 56-56 56l-104 0zm-32 83.8l0 52.2c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-60.1c0-5.1-2.4-9.9-6.5-12.9s-9.4-3.9-14.3-2.4l-11.3 3.6c-31.2 9.8-64.6 9.8-95.8 0l-11.3-3.6c-4.9-1.5-10.2-.6-14.3 2.4s-6.5 7.8-6.5 12.9l0 60.1c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-72c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 72c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-38.6c31.5 8.1 64.5 8.1 96 0l0 38.6c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-40c-12.3 0-23.5-4.6-32-12.2zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-40 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c13.3 0 24 10.7 24 24c0 8.8 7.2 16 16 16s16-7.2 16-16c0-30.9-25.1-56-56-56zm88-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTransformerBolt = {
    prefix: 'fal',
    iconName: 'transformer-bolt',
    icon: [
      384,
      512,
      [],
      'e2a4',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L64 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-16zM48 112c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 288-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 288 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-288 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L48 160l-32 0zM64 480l0-288 256 0 0 288L64 480zm78.6-144l61.9-61.9-4.4 44.3c-.4 4.5 1 9 4.1 12.3s7.3 5.3 11.9 5.3l25.4 0-61.9 61.9 4.4-44.3c.4-4.5-1-9-4.1-12.3s-7.3-5.3-11.9-5.3l-25.4 0zm75.6-112c-5.6 0-11 2.2-15 6.2L102.3 331c-4.1 4.1-6.3 9.6-6.3 15.3c0 12 9.7 21.7 21.7 21.7l32.7 0-5.7 56.6c-1.3 12.5 8.6 23.4 21.2 23.4c5.6 0 11-2.2 15-6.2L281.7 341c4.1-4.1 6.3-9.6 6.3-15.3c0-12-9.7-21.7-21.7-21.7l-32.7 0 5.7-56.6c1.3-12.5-8.6-23.4-21.2-23.4z'
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fal',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l160 0 0 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-400 160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L192 32 16 32z'
      
    ]
  };

  

  
  

  var faOilCan = {
    prefix: 'fal',
    iconName: 'oil-can',
    icon: [
      640,
      512,
      [],
      'f613',
      
      'M336 96c8.8 0 16-7.2 16-16s-7.2-16-16-16L176 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-112 0-32 0-48 0c-26.5 0-48 21.5-48 48l0 62.7c0 20 12.4 37.9 31.1 44.9L96 340l0 28c0 26.5 21.5 48 48 48l259.1 0c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8L272 160l0-64 64 0zm97.7 124.6c6.5 3.2 13.9 4.2 21 2.7l129.1-27.7L427.1 373.2c-6.1 6.9-14.8 10.8-24 10.8L144 384c-8.8 0-16-7.2-16-16l0-16 0-34.2L128 192l240.9 0c5 0 9.9 1.2 14.3 3.4l50.5 25.2zM96 305.8L42.4 285.7c-6.2-2.3-10.4-8.3-10.4-15L32 208c0-8.8 7.2-16 16-16l48 0 0 113.8z'
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fal',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      'M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L321 0zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512l159 0c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33L0 480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1L32 480l0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z'
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fal',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      'M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6L48 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l98 0L109.1 336 16 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.7 0L80.4 460.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6 127.2 0-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6L400 368c8.8 0 16-7.2 16-16s-7.2-16-16-16l-98 0 36.9-160 93.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-85.7 0 21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6-127.2 0 21.3-92.4zM178.9 176L306 176 269.1 336 142 336l36.9-160z'
      
    ]
  };

  

  
  

  var faFaceExplode = {
    prefix: 'fal',
    iconName: 'face-explode',
    icon: [
      512,
      512,
      ["exploding-head"],
      'e2fe',
      
      'M296 32c-11.2 0-21.3 4.6-28.6 12c-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8c-7.3-7.4-17.4-12-28.6-12c-22.1 0-40 17.9-40 40l0 4.2c0 6.3-3.7 12-9.5 14.6s-12.5 1.5-17.2-2.7C143.7 83.1 136.2 80 128 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 16 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-18.7 0c1.8 5 2.7 10.4 2.7 16l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-8.8-7.2-16-16-16l-16 0-32 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.7 0 13.1 1 19.1 2.9C156.2 21.4 183.6 0 216 0c14.8 0 28.6 4.5 40 12.1C267.4 4.5 281.2 0 296 0c32.4 0 59.8 21.4 68.9 50.9c6-1.9 12.5-2.9 19.1-2.9c35.3 0 64 28.7 64 64s-28.7 64-64 64l-48 0c-8.8 0-16 7.2-16 16l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-26.5 21.5-48 48-48l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-8.2 0-15.7 3.1-21.3 8.1c-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6l0-4.2c0-22.1-17.9-40-40-40zM32 260.3c3.1-.7 6.1-1.8 9-3.4l28.7-16.1c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0L411 240.8c9.7-5.5 21.6-5.5 31.4 0L471 256.9c2.8 1.6 5.8 2.7 9 3.4c5.7 1.2 11.6 .9 17.2-1l9.5-3.3 5.3-1.8 0 1.8c0 11.1-.7 22-2.1 32.7C493.9 414.7 386.3 512 256 512S18.1 414.7 2.1 288.7C.7 278 0 267.1 0 256l0-1.8L5.3 256l9.5 3.3c5.6 1.9 11.5 2.3 17.2 1zm53.3 8.4L56.7 284.8c-6.8 3.8-14.2 6.3-21.8 7.5C52.3 398.8 144.7 480 256 480s203.7-81.2 221.1-187.7c-7.6-1.2-14.9-3.7-21.8-7.5l-28.7-16.1-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0L85.3 268.7zm91 43.3a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 352c35.3 0 64 28.7 64 64l0 5.3c0 14.7-11.9 26.7-26.7 26.7l-74.7 0c-14.7 0-26.7-11.9-26.7-26.7l0-5.3c0-35.3 28.7-64 64-64zm-32 64l64 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z'
      
    ]
  };

  
    var faExplodingHead = faFaceExplode;
  

  
  

  var faSquareXmark = {
    prefix: 'fal',
    iconName: 'square-xmark',
    icon: [
      448,
      512,
      [10062,"times-square","xmark-square"],
      'f2d3',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm148.7 84.7c6.2-6.2 16.4-6.2 22.6 0L224 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faTimesSquare = faSquareXmark;
  
    var faXmarkSquare = faSquareXmark;
  

  
  

  var faFacePouting = {
    prefix: 'fal',
    iconName: 'face-pouting',
    icon: [
      512,
      512,
      [],
      'e387',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm85.3-102.7c4.5-3.5 8.4-8.6 10-15.1c1.6-6.7 .5-13.5-2.7-19.5C331.2 342 296.1 320 256 320c-40.1 0-75.1 22-92.5 54.7c-3.2 6-4.3 12.8-2.7 19.5c1.6 6.5 5.4 11.6 10 15.1c8.8 6.8 21.2 8.7 32.4 4.5c16.2-6.1 34-9.4 52.9-9.4c18.9 0 36.7 3.4 52.9 9.4c11.2 4.2 23.6 2.4 32.4-4.5zm-25.7-27.1c-18.5-6.4-38.6-9.9-59.6-9.9c-20.9 0-41 3.5-59.6 9.8C209.4 364 231.1 352 256 352s46.7 12.1 59.6 30.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      
    ]
  };

  

  
  

  var faContainerStorage = {
    prefix: 'fal',
    iconName: 'container-storage',
    icon: [
      640,
      512,
      [],
      'f4b7',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l16 0 0 384-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 544 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-384 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L48 32 16 32zM64 448L64 64l512 0 0 384L64 448zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224z'
      
    ]
  };

  

  
  

  var faEarthOceania = {
    prefix: 'fal',
    iconName: 'earth-oceania',
    icon: [
      512,
      512,
      ["globe-oceania"],
      'e47b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16.7-303.5c-5-1.3-10.3 0-14.3 3.3l-25.2 21.5c-1.9 1.6-4.4 2.2-6.8 1.7l-.3-.1-4-5.3C211.8 216 195.8 208 178.7 208s-33.1 8-43.4 21.7l-5.3 7L94.7 253.5C66 267.1 54.4 302 69.2 330.1l3.3 6.2c12.6 24 40.6 35.5 66.5 27.3l20.4-6.5L205.2 373l27 17.4c9.6 6.2 20.9 9.5 32.3 9.5c18.4 0 35.7-8.4 47-22.9l12.1-15.4c8-10.2 12.4-22.9 12.4-35.9s-4.4-25.6-12.4-35.9l-18-22.9c-3.8-4.9-6.9-10.3-9.2-16.1l-12.8-32.7c-1.9-4.8-6-8.4-11-9.7zm-94 31.5c7 0 13.6 3.3 17.8 8.9l4 5.3c4.7 6.2 11.5 10.6 19.2 12.1l.3 .1c12.1 2.5 24.6-.8 34-8.7l8.1-6.9 4.6 11.8c3.4 8.7 8 16.8 13.8 24.2l17.9 22.9c3.6 4.6 5.6 10.3 5.6 16.1s-2 11.5-5.6 16.1l-12.1 15.4c-5.2 6.7-13.3 10.6-21.8 10.6c-5.3 0-10.5-1.5-15-4.4l-28.7-18.5c-1.1-.7-2.2-1.3-3.5-1.7l-52.7-18.2c-3.3-1.1-6.8-1.2-10.1-.1l-25.4 8.1c-11.1 3.5-23.1-1.4-28.5-11.7l-3.3-6.2c-6.3-12.1-1.4-27 10.9-32.8l35.3-16.8c4.7-2.2 8.7-5.5 11.8-9.7l5.3-7c4.2-5.6 10.8-8.9 17.8-8.9zm103-114.6c-12.4-14.4-32.1-20.2-50.2-14.7l-43.1 12.9c-19.8 5.9-23.3 32.4-5.8 43.3l39.4 24.6c9.4 5.8 20.4 8.3 31.4 6.9l37.9-4.7c19-2.4 27.7-24.9 15.2-39.4l-24.8-28.9zm-41 15.9c6.1-1.8 12.6 .1 16.7 4.9l15.1 17.6-23.2 2.9c-3.6 .5-7.3-.4-10.5-2.3l-24.4-15.2 26.2-7.9zM248 432c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM431.2 306.9c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l8 24c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-8-24zm-19.9 80.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z'
      
    ]
  };

  
    var faGlobeOceania = faEarthOceania;
  

  
  

  var faGopuram = {
    prefix: 'fal',
    iconName: 'gopuram',
    icon: [
      512,
      512,
      [],
      'f664',
      
      'M112 0c8.8 0 16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 0 32 0 16 0 48 0 2.7c18.6 6.6 32 24.4 32 45.3l0 48c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3l0 80c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3l0 64c0 26.5-21.5 48-48 48l-144 0-32 0-64 0-32 0L48 512c-26.5 0-48-21.5-48-48l0-64c0-20.9 13.4-38.7 32.1-45.3c-.1-.9-.1-1.8-.1-2.7l0-80c0-20.9 13.4-38.8 32.1-45.3c-.1-.9-.1-1.8-.1-2.7l0-48c0-20.9 13.4-38.7 32-45.3l0-2.7 0-48 0-16 0-32 0-16c0-8.8 7.2-16 16-16zM224 480l64 0c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0l64 0 0-96-32 0-48 0-32 0-32 0-32 0-48 0-32 0 0 96 64 0c0-35.3 28.7-64 64-64s64 28.7 64 64zM128 80l0 48 256 0 0-48 0-16L128 64l0 16zm-16 80c-8.8 0-16 7.2-16 16l0 48 64 0 0-64-32 0-16 0zm48 96l0 96 48 0 0-16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 16 48 0 0-96-32 0-48 0-32 0-48 0-32 0zm112-48l0 16 48 0 0-64-128 0 0 64 48 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 144l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 32 0zM416 224l0-48c0-8.8-7.2-16-16-16l-16 0-32 0 0 64 64 0zm0 32l-32 0 0 96 64 0 0-80c0-8.8-7.2-16-16-16l-16 0zm0 224l48 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0-32 0 0 96zM128 256l-32 0-16 0c-8.8 0-16 7.2-16 16l0 80 64 0 0-96zM96 384l-32 0-16 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0 0-96z'
      
    ]
  };

  

  
  

  var faMelon = {
    prefix: 'fal',
    iconName: 'melon',
    icon: [
      512,
      512,
      [],
      'e310',
      
      'M480 256c0-35.8-8.4-69.7-23.4-99.7c-8.4 56.6-47.7 127.6-110.2 190.1S212.9 448.2 156.3 456.6c30 14.9 63.9 23.4 99.7 23.4c123.7 0 224-100.3 224-224zM55.4 355.7c8.4-56.6 47.7-127.6 110.2-190.1S299.1 63.8 355.7 55.4C325.7 40.4 291.8 32 256 32C132.3 32 32 132.3 32 256c0 35.8 8.4 69.7 23.4 99.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM414.3 97.7c-11.8-11.8-38.7-18.4-84.2-3.2c-43.5 14.5-94.7 46.5-142 93.8s-79.3 98.5-93.8 142c-15.2 45.5-8.6 72.4 3.2 84.2s38.7 18.4 84.2 3.2c43.5-14.5 94.7-46.5 142-93.8s79.3-98.5 93.8-142c15.2-45.5 8.6-72.4-3.2-84.2z'
      
    ]
  };

  

  
  

  var faLightbulbCflOn = {
    prefix: 'fal',
    iconName: 'lightbulb-cfl-on',
    icon: [
      640,
      512,
      [],
      'e5a7',
      
      'M23.2 1.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32C.9 26.4-2.3 16.7 1.7 8.8S15.3-2.3 23.2 1.7zm608 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM87.2 318.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm480-28.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM267.9 4.5C302.5-4.1 336 22 336 57.7c0 3.4-.3 6.8-.9 10l76.8-19.2C446.5 39.9 480 66 480 101.7c0 15.6-6.6 29.9-17.3 40c10.6 9.9 17.3 24 17.3 40c0 15.6-6.6 29.9-17.3 40c10.6 9.9 17.3 24 17.3 40c0 25.1-17.1 47.1-41.5 53.2L368 332.5l0 19.5 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-34.5 32-8 0 42.5 32 0 0-32c0-7.3 5-13.7 12.1-15.5l82.6-20.7c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.9-25.7-28.3-22.1l-63.8 15.9-64 16-.1 0-63.7 15.9C193.5 296.1 160 270 160 234.3c0-15.6 6.6-29.9 17.3-40c-10.6-9.9-17.3-24-17.3-40c0-15.6 6.6-29.9 17.3-40c-10.6-9.9-17.3-24-17.3-40c0-25.1 17.1-47.1 41.5-53.2L267.9 4.5zm84 379.5L256 384l0 64 128 0 0-64-31.9 0-.1 0-.1 0zM284.1 240.5l146.6-36.7c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.8-25.6-28.2-22.2L228.1 207.5l-.2 .1-18.6 4.6c-10.2 2.5-17.3 11.7-17.3 22.1c0 14.8 13.9 25.7 28.3 22.1l63.8-15.9zm10.4-129.6l-66.4 16.6c0 0 0 0-.1 0l-18.8 4.7c-10.2 2.5-17.3 11.7-17.3 22.1c0 14.8 13.8 25.6 28.2 22.2l191.7-47.9 .2-.1 18.6-4.6c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.9-25.7-28.3-22.1L294.6 110.9c0 0 0 0-.1 0zM304 57.7c0-14.8-13.9-25.7-28.3-22.1L209.3 52.2C199.1 54.7 192 63.8 192 74.3c0 14.8 13.9 25.7 28.3 22.1c0 0 0 0 0 0l66.4-16.6c0 0 0 0 0 0C296.9 77.3 304 68.2 304 57.7z'
      
    ]
  };

  

  
  

  var faCardHeart = {
    prefix: 'fal',
    iconName: 'card-heart',
    icon: [
      384,
      512,
      [],
      'e3eb',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 221.3c0 7.8 3.1 15.2 8.6 20.7L192 313.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM141.3 160c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z'
      
    ]
  };

  

  
  

  var faShieldHeart = {
    prefix: 'fal',
    iconName: 'shield-heart',
    icon: [
      512,
      512,
      [],
      'e574',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM162.3 214.2c0-19.6 15.9-35.5 35.5-35.5c9.5 0 18.7 3.8 25.4 10.7l21.4 21.9c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8l21.4-21.9c6.7-6.8 15.8-10.7 25.4-10.7c19.6 0 35.5 15.9 35.5 35.5l0 1.5c0 9.7-3.8 19-10.6 25.9L256 326.5l-83.1-84.9c-6.8-6.9-10.6-16.2-10.6-25.9l0-1.5zm35.5-67.5c-37.3 0-67.5 30.2-67.5 67.5l0 1.5c0 18.1 7.1 35.4 19.7 48.3l94.6 96.5c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8L362 264c12.6-12.9 19.7-30.2 19.7-48.3l0-1.5c0-37.3-30.2-67.5-67.5-67.5c-18.1 0-35.5 7.3-48.2 20.3l-10 10.2-10-10.2c-12.7-13-30.1-20.3-48.2-20.3z'
      
    ]
  };

  

  
  

  var faVacuum = {
    prefix: 'fal',
    iconName: 'vacuum',
    icon: [
      640,
      512,
      [],
      'e04d',
      
      'M192.4 89.2C203.2 37.2 249 0 302.1 0L528 0c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320l0 128c0 35.3-28.7 64-64 64l-75.3 0c10.4-9.2 19.2-20 26.2-32l49.1 0c17.7 0 32-14.3 32-32l0-128c0-88.4-71.6-160-160-160c-17.7 0-32 14.3-32 32l0 96c-11 0-21.8 1.4-32 4l0-100c0-35.3 28.7-64 64-64c54.6 0 103.9 22.8 138.8 59.4c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80L302.1 32c-37.9 0-70.6 26.6-78.3 63.7L197 224l-32.7 0L192.4 89.2zM157.7 256l32.7 0L163.7 384.1C197.3 386 224 413.9 224 448c0 35.3-28.7 64-64 64L24.2 512C10.8 512 0 501.2 0 487.8c0-5.2 .8-10.4 2.5-15.3l7.6-22.9C23.2 410.4 59.9 384 101.2 384l29.8 0 26.7-128zM144.3 416c-.2 0-.4 0-.6 0l-42.5 0c-27.5 0-52 17.6-60.7 43.8L33.7 480 160 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.7 0zM448 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBroom = {
    prefix: 'fal',
    iconName: 'broom',
    icon: [
      576,
      512,
      [129529],
      'f51a',
      
      'M571.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-208 208-45.3-45.3c-4.8-4.8-11.2-7.4-17.9-7.4c-12.4 0-23 9-25 21.2l-9.1 54.7-9.8-1.4c-46.3-6.6-93 9-126 42L97 287c-21.1 21.1-33 49.8-33 79.7c0 1.3 .1 2.5 .4 3.7C66.1 378.2 73 384 81.3 384L96 384 81.3 398.7l-15 15L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512l171.9 0c39.4 0 77.2-15.6 105-43.5c33.1-33.1 48.6-79.7 42-126l-1.4-9.8 54.7-9.1c12.2-2 21.2-12.6 21.2-25c0-6.7-2.7-13.2-7.4-17.9l-45.3-45.3 208-208zM274.7 242.7l7.2-43.5 94.9 94.9-43.5 7.2-58.7-58.7zM229 266.2l24.7 3.5 52.6 52.6 3.5 24.7c5.2 36.3-7 72.9-33 98.9C255 467.7 225.4 480 194.5 480L45.3 480l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9c-4.8-11.5-15.8-19.2-28.2-19.7c2.9-16 10.7-30.8 22.3-42.4l10.5-10.5c25.9-25.9 62.6-38.1 98.9-33z'
      
    ]
  };

  

  
  

  var faCoinBlank = {
    prefix: 'fal',
    iconName: 'coin-blank',
    icon: [
      512,
      512,
      [],
      'e3fb',
      
      'M90.7 281.9C49 258.5 32 231.1 32 208s17-50.5 58.7-73.9C131.4 111.2 189.8 96 256 96s124.6 15.2 165.3 38.1C463 157.5 480 184.9 480 208s-17 50.5-58.7 73.9C380.6 304.8 322.2 320 256 320s-124.6-15.2-165.3-38.1zM240 351.7l0 64c-22.5-.7-44-3-64-6.6l0-64.3c20.3 3.8 41.8 6.1 64 6.9zM96 320.4c14.8 6.7 30.8 12.4 48 17.1l0 64.6c-17.7-4.7-33.8-10.5-48-17l0-64.7zM64 303.2l0 63.6c-23.5-16.9-32-34-32-46.8l0-42.2c9 9.2 19.8 17.7 32 25.5zM272 415.7l0-64c22.2-.8 43.7-3.1 64-6.9l0 64.3c-20 3.6-41.5 5.8-64 6.6zM448 303.2c12.2-7.8 23-16.3 32-25.5l0 42.2c0 12.9-8.5 29.9-32 46.8l0-63.6zm-32 17.2l0 64.7c-14.2 6.5-30.3 12.3-48 17l0-64.6c17.2-4.7 33.2-10.5 48-17.1zM256 64C114.6 64 0 128.5 0 208l0 32 0 80c0 70.7 114.6 128 256 128s256-57.3 256-128l0-80 0-32c0-79.5-114.6-144-256-144z'
      
    ]
  };

  

  
  

  var faCircleArrowUpLeft = {
    prefix: 'fal',
    iconName: 'circle-arrow-up-left',
    icon: [
      512,
      512,
      [],
      'e0fb',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-352l-136 0c-8.8 0-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-105.4L324.7 347.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 192l97.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCircleG = {
    prefix: 'fal',
    iconName: 'circle-g',
    icon: [
      512,
      512,
      [],
      'e10f',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96c24.6 0 47 9.2 64 24.4c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l62.7 0c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faSkeleton = {
    prefix: 'fal',
    iconName: 'skeleton',
    icon: [
      512,
      512,
      [],
      'f620',
      
      'M256 0c8.8 0 16 7.2 16 16l0 48 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L272 96l0 64 208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-208 0 0 64 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 75.4 86.6-24.7c6.3-1.8 12.8-2.7 19.3-2.7c38.8 0 70.2 31.4 70.2 70.2l0 5.2c0 18.5-6.8 36.3-19 50.1l-26.9 30.2c-11.5 12.9-28 20.3-45.3 20.3l-201.6 0c-17.3 0-33.8-7.4-45.3-20.3L83 461.4c-12.3-13.8-19-31.6-19-50.1l0-5.2c0-38.8 31.4-70.2 70.2-70.2c6.5 0 13 .9 19.3 2.7L240 363.4l0-75.4-112 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-64L32 192c-8.8 0-16-7.2-16-16s7.2-16 16-16l208 0 0-64L96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l144 0 0-48c0-8.8 7.2-16 16-16zM96 406.2l0 5.2c0 10.6 3.9 20.9 11 28.8l26.9 30.2c5.4 6.1 13.2 9.6 21.4 9.6l201.6 0c8.2 0 15.9-3.5 21.4-9.6L405 440.2c7.1-7.9 11-18.2 11-28.8l0-5.2c0-21.1-17.1-38.2-38.2-38.2c-3.5 0-7.1 .5-10.5 1.5l-93.8 26.8c-11.5 3.3-23.7 3.3-35.2 0l-93.8-26.8c-3.4-1-6.9-1.5-10.5-1.5C113.1 368 96 385.1 96 406.2zM160 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleCurrency = {
    prefix: 'fal',
    iconName: 'display-chart-up-circle-currency',
    icon: [
      640,
      512,
      [],
      'e5e5',
      
      'M64 32l448 0c17.7 0 32 14.3 32 32l0 134.6c11.2 3.2 21.9 7.4 32 12.6L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l149.1 0-10.7 64L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 34.8 0c-12.9-9.1-24.5-19.9-34.6-32l-19.1 0L288 480l-53.1 0 10.7-64 42.4 0 38.6 0c-2.9-10.3-4.9-21-5.9-32l-88.5 0c-.2 0-.4 0-.6 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM480 192.7l0-80.7c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6l0 48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM470.6 342.6a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3c21.6 13.2 49.1 13.2 70.7 0z'
      
    ]
  };

  

  
  

  var faPersonBiking = {
    prefix: 'fal',
    iconName: 'person-biking',
    icon: [
      640,
      512,
      [128692,"biking"],
      'f84a',
      
      'M392 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 392 0a56 56 0 1 0 0 112zM224 384A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM608 384a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM309.1 166.4c6.1-5.2 15.1-5.1 21.1 .3l59.1 53.2c2.9 2.6 6.8 4.1 10.7 4.1l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-73.9 0-54.5-49.1c-17.9-16.1-45-16.5-63.3-.8l-59.1 50.6c-23.9 20.5-21.9 58.1 4 76L320 328.4l0 87.6c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-5.3-2.6-10.2-6.9-13.2l-93.7-64.4c-8.7-6-9.3-18.5-1.3-25.3l59.1-50.6z'
      
    ]
  };

  
    var faBiking = faPersonBiking;
  

  
  

  var faTemperatureLow = {
    prefix: 'fal',
    iconName: 'temperature-low',
    icon: [
      512,
      512,
      [],
      'f76b',
      
      'M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L112 96zM176 0C123 0 80 43 80 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L272 96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-34c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fal',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      'M320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm127-80c-7.9 63.1-61.7 112-127 112s-119.1-48.9-127-112L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l177 0c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112l177 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-177 0z'
      
    ]
  };

  

  
  

  var faFileMusic = {
    prefix: 'fal',
    iconName: 'file-music',
    icon: [
      384,
      512,
      [],
      'f8b6',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM304 232c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-116.9 96-36 0 83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-144zM256 392c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12zM128 424c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12z'
      
    ]
  };

  

  
  

  var faClockOne = {
    prefix: 'fal',
    iconName: 'clock-one',
    icon: [
      512,
      512,
      [],
      'e34e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 91.2 34.7-52c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-64 96c-3.9 5.9-11.2 8.5-17.9 6.4s-11.4-8.3-11.4-15.3l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCompassSlash = {
    prefix: 'fal',
    iconName: 'compass-slash',
    icon: [
      640,
      512,
      [],
      'f5e9',
      
      'M448.8 439.3C412.4 464.9 368 480 320 480C196.3 480 96 379.7 96 256c0-29.3 5.6-57.2 15.8-82.8L85.7 152.6C71.8 184.2 64 219.2 64 256c0 141.4 114.6 256 256 256c58.2 0 111.9-19.4 154.9-52.2l-26.1-20.6zM320 0C261.8 0 208.1 19.4 165.1 52.2l26.1 20.6C227.6 47.1 272 32 320 32c123.7 0 224 100.3 224 224c0 29.3-5.6 57.2-15.8 82.8l26.1 20.6c14-31.6 21.7-66.6 21.7-103.4C576 114.6 461.4 0 320 0zM186.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l111-37-30-23.7-91.1 30.4 27-80.9-26.7-21.1-30.6 91.9zM301.6 159.9l30 23.7 91.1-30.4-27 80.9 26.7 21.1 30.6-91.9c8.3-25-15.5-48.8-40.5-40.5l-111 37zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faMusic = {
    prefix: 'fal',
    iconName: 'music',
    icon: [
      512,
      512,
      [127925],
      'f001',
      
      'M512 23c0-12.7-10.3-23-23-23c-2.3 0-4.6 .3-6.8 1l-311 95.7C164.6 98.8 160 105 160 112l0 120 0 140.4C143 359.7 120.6 352 96 352c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-185.7 288-88.6 0 150.7c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-231.6c0-.2 0-.5 0-.7L512 23zM480 368c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM160 432c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM480 124.2L192 212.8l0-89L480 35.2l0 89z'
      
    ]
  };

  

  
  

  var faYinYang = {
    prefix: 'fal',
    iconName: 'yin-yang',
    icon: [
      512,
      512,
      [9775],
      'f6ad',
      
      'M480 256c0 123.7-100.3 224-224 224c-57.4 0-104-46.6-104-104s46.6-104 104-104c75.1 0 136-60.9 136-136c0-26.5-7.6-51.2-20.6-72C436.5 103.1 480 174.5 480 256zM256 32c57.4 0 104 46.6 104 104s-46.6 104-104 104c-75.1 0-136 60.9-136 136c0 26.5 7.6 51.2 20.6 72C75.5 408.9 32 337.5 32 256C32 132.3 132.3 32 256 32zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faSendBackward = {
    prefix: 'fal',
    iconName: 'send-backward',
    icon: [
      512,
      512,
      [],
      'f87f',
      
      'M64 32l224 0c17.7 0 32 14.3 32 32l0 64 32 0 0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-32-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM288 96c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96l0 160c0 17.7 14.3 32 32 32l32 0 0-32-32 0L96 96l160 0 0 32 32 0 0-32zm-64 96l224 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32zm-64 32l0 224c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faCheese = {
    prefix: 'fal',
    iconName: 'cheese',
    icon: [
      512,
      512,
      [],
      'f7ef',
      
      'M480 244l0 12L32 256c0-9.3 4.6-18 12.4-23.1L295.7 65.3c1.3-.8 2.8-1.3 4.3-1.3c99.4 0 180 80.6 180 180zM32 288l448 0 0 128c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-128zm480-32l0-12c0-117.1-94.9-212-212-212c-7.8 0-15.5 2.3-22 6.7L26.6 206.2C10 217.3 0 236 0 256L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-160z'
      
    ]
  };

  

  
  

  var faSquareStar = {
    prefix: 'fal',
    iconName: 'square-star',
    icon: [
      448,
      512,
      [],
      'e27f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm238.3 16.9l36.2 73.4 81.1 11.8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-58.6 57.2 13.8 80.7c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 342.1l-72.5 38.1c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.6l13.8-80.7L83.5 225.4c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l81-11.8 36.2-73.4c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9zm-40 95.1c-2.3 4.7-6.8 8-12 8.8L129 225.1l41.5 40.4c3.8 3.7 5.5 9 4.6 14.2l-9.8 57.1 51.2-26.9c4.7-2.5 10.2-2.5 14.9 0l51.2 26.9-9.8-57.1c-.9-5.2 .8-10.5 4.6-14.2L319 225.1l-57.3-8.3c-5.2-.8-9.7-4-12-8.8L224 156.2l-25.6 51.9z'
      
    ]
  };

  

  
  

  var faWineGlassEmpty = {
    prefix: 'fal',
    iconName: 'wine-glass-empty',
    icon: [
      320,
      512,
      ["wine-glass-alt"],
      'f5ce',
      
      'M46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32 61.2 32 46.4 195.6zm-31.9-2.9L29.4 29.1C30.9 12.6 44.7 0 61.2 0L258.8 0c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5L176 480l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-128.9C65.9 342.7 7.2 272.8 14.5 192.7z'
      
    ]
  };

  
    var faWineGlassAlt = faWineGlassEmpty;
  

  
  

  var faPenSlash = {
    prefix: 'fal',
    iconName: 'pen-slash',
    icon: [
      640,
      512,
      [],
      'e213',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20L382.4 117 459 193.6l-50.6 50.6 25.3 20L559 138.8zM317.2 335.4l-93.6 93.6c-7.6 7.6-16.9 13.1-27.2 16.1l-92.8 27.3 27.3-92.8c3-10.3 8.6-19.6 16.1-27.2l84.6-84.6-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM459.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8z'
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fal',
    iconName: 'moon',
    icon: [
      384,
      512,
      [9214,127769],
      'f186',
      
      'M190.6 66.8c-38.8 37.8-62.9 90.7-62.9 149.2c0 108.9 83.5 198.3 189.9 207.3C289.8 439 257.7 448 223.5 448C117.7 448 32 362.1 32 256c0-94.8 68.5-173.5 158.6-189.2zm66.1-21.5c-1.5-6.9-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3z'
      
    ]
  };

  

  
  

  var faArrowUpFromLine = {
    prefix: 'fal',
    iconName: 'arrow-up-from-line',
    icon: [
      384,
      512,
      [8613,"arrow-from-bottom"],
      'f342',
      
      'M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6 176 192l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-105.4L308.7 187.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448z'
      
    ]
  };

  
    var faArrowFromBottom = faArrowUpFromLine;
  

  
  

  var faCarrot = {
    prefix: 'fal',
    iconName: 'carrot',
    icon: [
      512,
      512,
      [129365],
      'f787',
      
      'M320 88c0-23.9 14.5-45.4 23-55.8c0 0 0 0 .1 0c.1-.1 .4-.2 .9-.2c.4 0 .7 .1 .8 .1C352.9 42.3 368 65.6 368 96c0 14.7-1.8 22.9-3.2 26.9c-.6 1.6-1 2.6-1.2 2.9c-5.2 6.3-4.8 15.6 1.1 21.4s15.2 6.2 21.4 1.1c.4-.2 1.3-.7 2.9-1.2c4-1.3 12.2-3.2 26.9-3.2c30.4 0 53.7 15.1 63.9 23.2c0 .1 .1 .4 .1 .8c0 .5-.1 .8-.2 .9c0 0 0 0 0 .1c-10.4 8.5-32 23-55.8 23c-17.7 0-28.7-3.3-37.7-8.6c-9.8-5.7-18.3-14-31-26.7s-21.1-21.2-26.7-31c-5.3-9.1-8.6-20-8.6-37.7zm49.8-75.9C363.1 3.7 353.2 0 344 0s-19 3.7-25.7 11.8C308.7 23.6 288 52.5 288 88c0 19.5 3.3 34.8 9.9 48.2c-14.3-5.3-29.7-8.2-45.8-8.2c-50.9 0-97.2 29.3-119.1 75.2L2.3 477.7C-2 486.9-.2 497.8 7 505s18.1 9.1 27.3 4.7L308.8 379c45.9-21.9 75.2-68.2 75.2-119.1c0-16.1-2.9-31.5-8.2-45.8c13.4 6.6 28.6 9.9 48.2 9.9c35.5 0 64.4-20.7 76.2-30.3C508.3 187 512 177.2 512 168c0-9.2-3.7-19.1-12.1-25.8c-12.7-10.1-43-30.2-83.9-30.2c-6.3 0-11.9 .3-16.8 .8c.5-4.9 .8-10.5 .8-16.8c0-40.9-20.2-71.2-30.2-83.9zM252.1 160c55.2 0 99.9 44.7 99.9 99.9c0 38.5-22.2 73.6-56.9 90.2L174.2 407.6l-34.9-34.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l26.9 26.9L40.9 471.1 151.7 238.4l29 29c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.6-36.6c18-29.6 50.3-48.1 85.4-48.1z'
      
    ]
  };

  

  
  

  var faAmpersand = {
    prefix: 'fal',
    iconName: 'ampersand',
    icon: [
      448,
      512,
      [],
      '26',
      
      'M175.2 64l33.9 0c34.7 0 62.9 28.2 62.9 62.9c0 20.5-10 39.8-26.8 51.5L181.6 223l-51.1-51.1C118.7 160 112 144 112 127.2C112 92.3 140.3 64 175.2 64zm29.4 181.9l59-41.3c25.4-17.8 40.5-46.8 40.5-77.8C304 74.5 261.5 32 209.1 32l-33.9 0C122.6 32 80 74.6 80 127.2c0 25.2 10 49.5 27.9 67.3L155 241.6 72.9 299C47.3 317 32 346.3 32 377.7l0 6.3c0 53 43 96 96 96l80 0c35.3 0 68.4-16.6 89.6-44.8l21.8-29.1 69.2 69.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72.5-72.5 74-98.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-71.2 95L204.6 245.9zm-26.6 18.6L296.6 383.2 272 416c-15.1 20.1-38.8 32-64 32l-80 0c-35.3 0-64-28.7-64-64l0-6.3c0-20.9 10.2-40.5 27.3-52.4l86.6-60.7z'
      
    ]
  };

  

  
  

  var faAtomSimple = {
    prefix: 'fal',
    iconName: 'atom-simple',
    icon: [
      512,
      512,
      ["atom-alt"],
      'f5d3',
      
      'M175.1 438.1c-50.8 16.9-82.3 10.1-96.7-4.4s-21.3-46-4.4-96.7c5.4-16.2 12.9-33.3 22.5-50.9c16.8 23.8 36.7 47.4 59.4 70.1s46.3 42.6 70.1 59.4c-17.6 9.6-34.7 17.2-50.9 22.5zM55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zM178.5 333.5c-25.3-25.3-46.6-51.6-63.8-77.5c17.2-25.9 38.6-52.3 63.8-77.5s51.6-46.6 77.5-63.8c25.9 17.2 52.3 38.6 77.5 63.8s46.6 51.6 63.8 77.5c-17.2 25.9-38.6 52.3-63.8 77.5s-51.6 46.6-77.5 63.8c-25.9-17.2-52.3-38.6-77.5-63.8zM155.8 155.8c-22.7 22.7-42.6 46.3-59.4 70.1c-9.6-17.6-17.2-34.7-22.5-50.9c-16.9-50.8-10-82.3 4.4-96.7s46-21.3 96.7-4.4c16.2 5.4 33.3 12.9 50.9 22.5c-23.8 16.8-47.4 36.7-70.1 59.4zm200.3 0c-22.7-22.7-46.3-42.6-70.1-59.4c17.6-9.6 34.7-17.2 50.9-22.5c50.8-16.9 82.3-10 96.7 4.4s21.3 46 4.4 96.7c-5.4 16.2-12.9 33.3-22.5 50.9c-16.8-23.8-36.7-47.4-59.4-70.1zm0 200.3c22.7-22.7 42.6-46.3 59.4-70.1c9.6 17.6 17.2 34.7 22.5 50.9c16.9 50.8 10.1 82.3-4.4 96.7s-46 21.3-96.7 4.4c-16.2-5.4-33.3-12.9-50.9-22.5c23.8-16.8 47.4-36.7 70.1-59.4zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faAtomAlt = faAtomSimple;
  

  
  

  var faPenLine = {
    prefix: 'fal',
    iconName: 'pen-line',
    icon: [
      576,
      512,
      [],
      'e212',
      
      'M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4 417.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L429.8 39.6zM83.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L39.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM240 480l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faDog = {
    prefix: 'fal',
    iconName: 'dog',
    icon: [
      576,
      512,
      [128021],
      'f6d3',
      
      'M322.9 349.5c8.2 6 13.1 15.6 13.1 25.8l0 80.7c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-194.1c0 0 0 0-.1 0L307.6 208c-.3 0-.7 0-1 0L160 208l-24 0-40 0 0 248c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-80.7c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2s31.7-2.5 46.3-7.2c9.7-3.1 20.4-1.4 28.6 4.6zm82.9-130.7c2.6-15.4 15.9-26.7 31.6-26.7l42.7 0c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16l-32 0c-8.5 0-16.6-3.4-22.6-9.4L455.4 68.7c-3-3-7.1-4.7-11.3-4.7L400 64c-10.1 0-19.6-4.7-25.6-12.8L362.5 35.4 338.2 181.3c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM45.6 159.3C54.5 169.7 67.6 176 82 176l14 0 40 0 24 0 146.7 0L331.9 24.8C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32l44.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l32 0c26.5 0 48 21.5 48 48l0 16c0 53-43 96-96 96l-42.7 0L432 256l0 200c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-47.3 0-33.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1l0 33.3 0 47.3c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-248c0-.7 0-1.4 .1-2c-.7-.2-1.4-.3-2.1-.5c-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fal',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      'M305.9 155.3l50.7 50.7L477.1 85.7c3.1-3.1 3.1-8.2 0-11.3L437.7 34.9c-3.1-3.1-8.2-3.1-11.3 0L305.9 155.3zm-22.6 22.6L34.9 426.3c-3.1 3.1-3.1 8.2 0 11.3l39.4 39.4c3.1 3.1 8.2 3.1 11.3 0L334.1 228.7l-50.7-50.7zM12.3 403.7L403.7 12.3c15.6-15.6 40.9-15.6 56.6 0l39.4 39.4c15.6 15.6 15.6 40.9 0 56.6L108.3 499.7c-15.6 15.6-40.9 15.6-56.6 0L12.3 460.3c-15.6-15.6-15.6-40.9 0-56.6z'
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faTents = {
    prefix: 'fal',
    iconName: 'tents',
    icon: [
      640,
      512,
      [],
      'e582',
      
      'M425.5 3.1c-5.7-4.2-13.4-4.2-19 0L236 129.1c9.5 1.8 18.7 5.8 26.8 12l5.4 4.1L416 35.9 579.5 156.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1l-130.8 0 4.8 32 126 0c29 0 51.3-25.5 47.6-54.2L617.6 163.4c-1.7-12.9-8.6-24.6-19.1-32.4L425.5 3.1zm-192 160c-5.7-4.2-13.4-4.2-19 0L41.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L4.8 457.8C1.1 486.5 23.5 512 52.4 512l343.1 0c29 0 51.3-25.5 47.6-54.2L425.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM60.5 316.8L208 207.7 208 480 52.4 480c-9.7 0-17.1-8.5-15.9-18.1L54.1 327.6c.6-4.3 2.9-8.2 6.4-10.8zM240 309.9l0-102.2L387.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1l-50.1 0-.2-.4-104-168c-.4-.6-.7-1.1-1.2-1.6zM240 480l0-109.5L307.8 480 240 480z'
      
    ]
  };

  

  
  

  var faCricketBatBall = {
    prefix: 'fal',
    iconName: 'cricket-bat-ball',
    icon: [
      512,
      512,
      [127951,"cricket"],
      'f449',
      
      'M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L354.6 180l34.1 34.1c18.7 18.7 18.7 49.1 0 67.9l-33.3 33.3c0 0 0 0 0 0L172.7 497.9c-9 9-21.2 14.1-33.9 14.1l-2.7 0C60.9 512 0 451.1 0 376l0-2.7c0-12.7 5.1-24.9 14.1-33.9L196.7 156.7c0 0 0 0 0 0l33.4-33.4c18.7-18.7 49.1-18.7 67.9 0L332 157.4 484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zM192 206.6L36.7 361.9c-3 3-4.7 7.1-4.7 11.3l0 2.7c0 57.4 46.6 104 104 104l2.7 0c4.2 0 8.3-1.7 11.3-4.7L305.4 320 240 320c-26.5 0-48-21.5-48-48l0-65.4zM337.4 288l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6l-90.7-90.7c-6.2-6.2-16.4-6.2-22.6 0L224 174.6l0 97.4c0 8.8 7.2 16 16 16l97.4 0zM480 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faCricket = faCricketBatBall;
  

  
  

  var faDiagramCells = {
    prefix: 'fal',
    iconName: 'diagram-cells',
    icon: [
      512,
      512,
      [],
      'e475',
      
      'M480 160c0 17.7-14.3 32-32 32L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 64zm-32 64c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0zm64 192l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zm-64 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32z'
      
    ]
  };

  

  
  

  var faFaceDiagonalMouth = {
    prefix: 'fal',
    iconName: 'face-diagonal-mouth',
    icon: [
      512,
      512,
      [129764],
      'e47e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm372.4 63.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTentArrowTurnLeft = {
    prefix: 'fal',
    iconName: 'tent-arrow-turn-left',
    icon: [
      576,
      512,
      [],
      'e580',
      
      'M114.8 27.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112 464 112c44.2 0 80 35.8 80 80l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-61.9-50.1-112-112-112L57.4 80l57.4-52.2zM297.5 163.1c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512l343.1 0c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7l0 112c0 .2 0 .4 0 .5L272 480l-155.6 0c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8L272 207.7zm32 168.5L368.2 480 304 480l0-103.8zm0-60.8l0-107.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1l-53.7 0-.3-.4L304 315.4z'
      
    ]
  };

  

  
  

  var faBanParking = {
    prefix: 'fal',
    iconName: 'ban-parking',
    icon: [
      512,
      512,
      ["parking-circle-slash"],
      'f616',
      
      'M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm76-170.6c30.9-16 52-48.2 52-85.4c0-53-43-96-96-96l-88 0c-13.3 0-24 10.7-24 24l0 1.4L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L332 309.4zM307.6 285L208 185.4l0-25.4 80 0c35.3 0 64 28.7 64 64c0 28.5-18.7 52.7-44.4 61zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 257.9l0 46.1 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 30.1 0L176 257.9z'
      
    ]
  };

  
    var faParkingCircleSlash = faBanParking;
  

  
  

  var faPenNib = {
    prefix: 'fal',
    iconName: 'pen-nib',
    icon: [
      512,
      512,
      [10001],
      'f5ad',
      
      'M377.4 45.3L310.6 112 400 201.4l66.7-66.7c12.5-12.5 12.5-32.8 0-45.3L422.6 45.3c-12.5-12.5-32.8-12.5-45.3 0zM279.7 97.7l75.1-75.1c25-25 65.5-25 90.5 0l44.1 44.1c25 25 25 65.5 0 90.5l-75.1 75.1L376.8 370c-7.3 26.6-27.7 47.6-54.2 55.6L47.4 508.1c-12.3 3.7-25.7 .3-34.7-8.8s-12.5-22.4-8.8-34.7L86.5 189.4c7.9-26.4 28.9-46.9 55.6-54.2L279.7 97.7zm3.6 32.2L150.5 166.1c-16 4.4-28.6 16.6-33.3 32.5L42.7 446.7 152.9 336.5c-5.6-9.5-8.9-20.6-8.9-32.5c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L65.3 469.3l248.1-74.4c15.9-4.8 28.2-17.4 32.5-33.3l36.2-132.8-98.9-98.9zM208 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faScythe = {
    prefix: 'fal',
    iconName: 'scythe',
    icon: [
      640,
      512,
      [],
      'f710',
      
      'M639.7 19.1c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6L550.1 304 400 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l143.7 0L512.3 492.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l96-480zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224l507.6 0 6.4-32L37.2 192C64.7 149.7 158.7 32 352 32l219.8 0 5.1-25.4c.5-2.3 1.1-4.5 1.8-6.6L352 0z'
      
    ]
  };

  

  
  

  var faHouseChimneyWindow = {
    prefix: 'fal',
    iconName: 'house-chimney-window',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4 384 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 136.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1L480 64l-64 0 0 43.6 64 56.5zM96 206.7L96 432c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7zM240 192l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zm0 32l0 96 96 0 0-96-96 0z'
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fal',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM276.7 132.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 256 299.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faGolfBallTee = {
    prefix: 'fal',
    iconName: 'golf-ball-tee',
    icon: [
      384,
      512,
      ["golf-ball"],
      'f450',
      
      'M288 320c38.9-29.2 64-75.7 64-128c0-88.4-71.6-160-160-160S32 103.6 32 192c0 52.3 25.1 98.8 64 128l-47.1 0C18.5 286 0 241.2 0 192C0 86 86 0 192 0S384 86 384 192c0 49.2-18.5 94-48.9 128L288 320zM80 352l112 0 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM226.1 248.6c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5zm-52.3-49.3c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4zm113.5-17.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5z'
      
    ]
  };

  
    var faGolfBall = faGolfBallTee;
  

  
  

  var faHouseMedical = {
    prefix: 'fal',
    iconName: 'house-medical',
    icon: [
      576,
      512,
      [],
      'e3b2',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48zM272 176c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  

  
  

  var faPersonSeat = {
    prefix: 'fal',
    iconName: 'person-seat',
    icon: [
      384,
      512,
      [],
      'e21e',
      
      'M176 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM152 32a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 336c0 61.9 50.1 112 112 112l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-44.2 0-80-35.8-80-80l0-192zm116 64c15.5 0 28 12.5 28 28l0 4 0 88-40 0c-8.8 0-16-7.2-16-16l0-76c0-15.5 12.5-28 28-28zm58.8 16c-5.6-27.4-29.8-48-58.8-48c-33.1 0-60 26.9-60 60l0 76c0 26.5 21.5 48 48 48l56 0 40.6 0c15.3 0 28.4 10.8 31.4 25.7l16.3 81.4c1.5 7.5 8.1 12.9 15.7 12.9l72 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.9 0-13.7-68.6c-6-29.9-32.2-51.4-62.8-51.4L208 328l0-72 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.2 0z'
      
    ]
  };

  

  
  

  var faDitto = {
    prefix: 'fal',
    iconName: 'ditto',
    icon: [
      320,
      512,
      [],
      '22',
      
      'M96 98.3L96 96c0-17.7-14.3-32-32-32S32 78.3 32 96l0 2.3c0 2 .2 3.9 .5 5.9L58 251c.5 2.9 3 5 6 5s5.5-2.1 6-5L95.5 104.2l30.9 5.4-30.9-5.4c.3-1.9 .5-3.9 .5-5.9zm-96 0L0 96C0 60.7 28.7 32 64 32s64 28.7 64 64l0 2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4zm288 0l0-2.3c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 2.3c0 2 .2 3.9 .5 5.9L250 251c.5 2.9 3 5 6 5s5.5-2.1 6-5l25.5-146.8 30.9 5.4-30.9-5.4c.3-1.9 .5-3.9 .5-5.9zm-96 0l0-2.3c0-35.3 28.7-64 64-64s64 28.7 64 64l0 2.3c0 3.8-.3 7.6-1 11.4L293.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L193 109.6c-.7-3.8-1-7.5-1-11.4z'
      
    ]
  };

  

  
  

  var faPhonePlus = {
    prefix: 'fal',
    iconName: 'phone-plus',
    icon: [
      576,
      512,
      [],
      'f4d2',
      
      'M416 208l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-55 78.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C215.5 494.5 32 300.7 32 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L361 286.7zM480 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C66.6 57 64 60.2 64 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z'
      
    ]
  };

  

  
  

  var faGlassesRound = {
    prefix: 'fal',
    iconName: 'glasses-round',
    icon: [
      576,
      512,
      [128083,"glasses-alt"],
      'f5f5',
      
      'M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L46.6 241.5C70.5 220.6 101.8 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c34.2 0 65.5 12.6 89.4 33.5L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7c29 0 54.2 19.6 61.5 47.6l48.7 188.8c4.4 17 6.6 34.4 6.6 52l0 23.6c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-8.2 .7-16.2 2.1-24l-36.2 0c1.4 7.8 2.1 15.8 2.1 24c0 75.1-60.9 136-136 136S0 419.1 0 344l0-23.6c0-17.5 2.2-35 6.6-52L55.3 79.6C62.5 51.6 87.8 32 116.8 32c9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM544 344a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM136 448a104 104 0 1 0 0-208 104 104 0 1 0 0 208z'
      
    ]
  };

  
    var faGlassesAlt = faGlassesRound;
  

  
  

  var faCommentNodes = {
    prefix: 'fal',
    iconName: 'comment-nodes',
    icon: [
      640,
      512,
      [],
      'e696',
      
      'M256 64C125.8 64 32 148.6 32 240c0 37.1 15.5 70.6 40 100c5.2 6.3 8.4 14.8 7.4 23.9c-3.1 27-11.4 52.5-25.7 76.3c-.5 .9-1.1 1.8-1.6 2.6c11.1-2.9 22.2-7 32.7-11.5L91.2 446l-6.4-14.7c17-7.4 33-16.7 48.4-27.4c8.5-5.9 19.4-7.5 29.2-4.2C193 410.1 224.1 416 256 416c13.2 0 26-.9 38.4-2.5c-4.1 10.7-6.2 21.9-6.4 32.9c-10.5 1.1-21.2 1.6-32 1.6c-36 0-70.5-6.7-103.8-17.9c-.2-.1-.5 0-.7 .1c-16.9 11.7-34.7 22.1-53.9 30.5C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.8s-1.1-12.8 3.4-17.4c8.1-8.2 15.2-18.2 21.7-29c11.7-19.6 18.7-40.6 21.3-63.1c0 0-.1-.1-.1-.2C19.6 327.1 0 286.6 0 240C0 125.2 114.5 32 256 32c122.7 0 225.1 70.1 250.2 163.6c-8.3-2.3-17.1-3.6-26.2-3.6c-2.9 0-5.7 .1-8.6 .4C445.5 121.2 363 64 256 64zM512 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 0c0 35.3-28.7 64-64 64c-6.3 0-12.4-.9-18.2-2.6l-32.2 53.7c8 8.1 13.6 18.2 16.4 28.9l68.1 0c2.8-10.7 8.3-20.8 16.3-28.9L515 377.4c10.1-3.9 19.3-9.6 27.4-16.5l15.4 25.7c27.7-8.2 58.5 3.2 73.6 29.4c17.7 30.6 7.2 69.7-23.4 87.4s-69.7 7.2-87.4-23.4c-3-5.1-5.1-10.5-6.6-16L446 464c-1.4 5.5-3.6 10.9-6.6 16c-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4c15.1-26.1 45.9-37.6 73.6-29.4l32.2-53.7C423 321.4 416 305.5 416 288c0-35.3 28.7-64 64-64s64 28.7 64 64zM356.3 432a32 32 0 1 0 55.4 32 32 32 0 1 0 -55.4-32zm247.4 0a32 32 0 1 0 -55.4 32 32 32 0 1 0 55.4-32z'
      
    ]
  };

  

  
  

  var faBinary = {
    prefix: 'fal',
    iconName: 'binary',
    icon: [
      384,
      512,
      [],
      'e33b',
      
      'M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L288 192l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L64 480l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM0 80l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80L80 0C35.8 0 0 35.8 0 80zM80 32l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80l-32 0zm-48 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64z'
      
    ]
  };

  

  
  

  var faAvocado = {
    prefix: 'fal',
    iconName: 'avocado',
    icon: [
      512,
      512,
      [],
      'e0aa',
      
      'M480 144c0 34.8-15.9 66-40.9 86.6c-22.3 18.4-42.7 44.7-49.1 77.6c-9.4 47.7-31 93.8-57.5 120.3c-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9c26.5-26.5 72.5-48.1 120.3-57.5c32.9-6.4 59.3-26.8 77.6-49.1C302 47.9 333.2 32 368 32c61.9 0 112 50.1 112 112zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM176.1 240.1c38.2-38.2 88.1-40.4 112.1-16.4s21.8 73.9-16.4 112.1s-88.1 40.4-112.1 16.4s-21.8-73.9 16.4-112.1zm134.8-39c-41.4-41.4-112.1-28.8-157.4 16.4s-57.8 116-16.4 157.4s112.1 28.8 157.4-16.4s57.8-116 16.4-157.4z'
      
    ]
  };

  

  
  

  var faGunSlash = {
    prefix: 'fal',
    iconName: 'gun-slash',
    icon: [
      640,
      512,
      [],
      'e19c',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM473.4 240c8.5 0 16.6-3.4 22.6-9.4L518.6 208l57.4 0c17.7 0 32-14.3 32-32l0-80c0-17.7-14.3-32-32-32l-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L180.1 64l40.5 32L528 96l48 0 0 80-57.4 0c-8.5 0-16.6 3.4-22.6 9.4L473.4 208l-110.9 0L403 240l70.4 0zM249.5 281.9L208 448 96 448l40.1-160.5c4.3-17 1.3-33.8-6.7-47.5l67 0-40.5-32-66.7 0L74 208l-10 0 0-72.6L32 110.2 32 208c0 17.7 14.3 32 32 32l10 0c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480l112 0c14.7 0 27.5-10 31-24.2l38-152.1-27.5-21.7z'
      
    ]
  };

  

  
  

  var faArrowsRepeat1 = {
    prefix: 'fal',
    iconName: 'arrows-repeat-1',
    icon: [
      512,
      512,
      ["repeat-1-alt"],
      'f366',
      
      'M0 255.2C-.4 264 6.4 271.5 15.2 272s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112l214.4 0-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L390.6 80 176.2 80C82.4 80 5.1 153.5 .4 247.2l-.4 8zm512 1.6c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400l-214.4 0 57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80c-3.3 3-5.2 7.3-5.2 11.8s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L121.4 432l214.4 0c93.8 0 171.1-73.5 175.8-167.2l.4-8zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L256 240l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  
    var faRepeat1Alt = faArrowsRepeat1;
  

  
  

  var faArrowUpShortWide = {
    prefix: 'fal',
    iconName: 'arrow-up-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-up-alt"],
      'f885',
      
      'M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6 112 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0z'
      
    ]
  };

  
    var faSortAmountUpAlt = faArrowUpShortWide;
  

  
  

  var faShield = {
    prefix: 'fal',
    iconName: 'shield',
    icon: [
      512,
      512,
      [128737,"shield-blank"],
      'f132',
      
      'M268.5 37.3c-8-3.4-17-3.4-25 0l-176.7 75C55.5 117 47.9 127.7 48 139.8c.5 94 39.3 259.8 195.4 334.5c7.9 3.8 17.2 3.8 25.1 0c156.1-74.7 195-240.4 195.5-334.5c.1-12.1-7.5-22.8-18.8-27.6l-176.7-75zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z'
      
    ]
  };

  
    var faShieldBlank = faShield;
  

  
  

  var faFileExport = {
    prefix: 'fal',
    iconName: 'file-export',
    icon: [
      576,
      512,
      ["arrow-right-from-file"],
      'f56e',
      
      'M352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 64 32 0 0-92.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80-32 0 0 80zm-.5-288L240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zm123.8 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L521.4 304 208 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l313.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  
    var faArrowRightFromFile = faFileExport;
  

  
  

  var faPhoneMissed = {
    prefix: 'fal',
    iconName: 'phone-missed',
    icon: [
      640,
      512,
      [],
      'e226',
      
      'M112 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4 98.7 98.7C251.5 178.1 285 192 320 192s68.5-13.9 93.3-38.6L523.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L390.6 130.7C371.9 149.5 346.5 160 320 160s-51.9-10.5-70.6-29.3L150.6 32 240 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 0zM39.1 366.5C86.8 320.1 186.2 255.1 320 255.1s233.2 65 280.9 111.3c7.6 7.4 9.5 19.8 3.7 31.3l-37.4 73.5c-3.3 6.5-10.6 10-17.7 8.4l-88.7-19.8c-7.3-1.6-12.5-8.1-12.5-15.6l0-82.1c0-7.2-4.8-13.5-11.8-15.4l-36.1-9.9c-52.6-14.4-108.1-14.4-160.7 0l-36.1 9.9c-7 1.9-11.8 8.2-11.8 15.4l0 82.1c0 7.5-5.2 14-12.5 15.6L90.6 479.7c-7.1 1.6-14.4-1.9-17.7-8.4L35.5 397.8c-5.8-11.5-3.9-23.9 3.7-31.3zM320 223.1C175.8 223.1 68.8 293 16.8 343.5c-19.3 18.7-21 46.8-9.9 68.7l37.4 73.5c9.9 19.5 31.8 29.9 53.2 25.1l88.7-19.8c21.9-4.9 37.5-24.4 37.5-46.9l0-69.8 24.4-6.7c47.1-12.9 96.7-12.9 143.8 0l24.4 6.7 0 69.8c0 22.5 15.6 42 37.5 46.9l88.7 19.8c21.4 4.8 43.3-5.6 53.2-25.1l37.4-73.5c11.1-21.9 9.4-50-9.9-68.7c-52-50.5-159-120.4-303.2-120.4z'
      
    ]
  };

  

  
  

  var faFireSmoke = {
    prefix: 'fal',
    iconName: 'fire-smoke',
    icon: [
      640,
      512,
      [],
      'f74b',
      
      'M349.4 93.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C441 154 448 179.4 448 192.2c0 25.3-7.4 48.9-20.1 68.8c7.4 5.8 14.3 12.1 20.7 18.9c2.7-1.8 5.5-3.5 8.4-5.2c14.6-24.1 23-52.4 23-82.5c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 30 8.2 58.3 22.7 82.4c3 1.7 5.9 3.5 8.7 5.3c6.3-6.8 13.2-13.1 20.6-18.8c-12.7-19.9-20-43.6-20-68.9c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1C298 51.9 311.6 66.5 324.4 82c6.2 7.4 15.3 11.6 25 11.5zM224 194c0 19.2 4.8 36.3 13.5 50.5c9.5-5.1 19.6-9.3 30.1-12.6c-7.1-9.6-11.5-22.2-11.5-38c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4 .5 .6 .1 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0L347 191l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1c6.9 19 3.9 39.8-7 54.8c10.5 3.3 20.5 7.5 30 12.6c16.2-27 17-62.2 1.3-91.1c0 0 0-.1 0-.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C229 164.3 224 178.3 224 194zM213.9 364c15-44.2 56.9-76 106.1-76s91.1 31.8 106.1 76c2.1 6.2 7.7 10.5 14.2 10.8s12.6-3.2 15.4-9.1C468.6 338.7 496.1 320 528 320c44.2 0 80 35.8 80 80s-35.8 80-80 80l-123.3 0-169.3 0L112 480c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.9 0 59.4 18.7 72.3 45.7c2.8 5.9 8.9 9.5 15.4 9.1s12.1-4.7 14.2-10.8zM320 256c-52.6 0-98.6 28.2-123.7 70.3C175.8 302.8 145.6 288 112 288C50.1 288 0 338.1 0 400s50.1 112 112 112l123.3 0 169.3 0L528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-33.6 0-63.8 14.8-84.3 38.3C418.6 284.2 372.6 256 320 256z'
      
    ]
  };

  

  
  

  var faFaceGrinBeamSweat = {
    prefix: 'fal',
    iconName: 'face-grin-beam-sweat',
    icon: [
      512,
      512,
      [128517,"grin-beam-sweat"],
      'f583',
      
      'M432.2 68.6c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.6c0 .2 0 .2 0 .1c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.2-.7-.8-3.7-3.4-9.5c-3-6.7-7.4-14.6-12.8-23.1c-5-7.9-10.5-15.8-15.8-23c-5.3 7.2-10.8 15.1-15.8 23zm7.3-64.5c4.3-5.5 12.8-5.5 17.1 0C473.9 25.8 512 76.3 512 101.3c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 37.9-75.5 55.5-97.2zM256 32C132.3 32 32 132.3 32 256s100.3 224 224 224s224-100.3 224-224c0-20.7-2.8-40.7-8.1-59.7c-2.4-8.5 2.6-17.3 11.2-19.7s17.3 2.6 19.7 11.2c6 21.7 9.2 44.6 9.2 68.3c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c43.1 0 83.8 10.7 119.5 29.5c7.8 4.1 10.8 13.8 6.7 21.6S368.3 62 360.5 57.8C329.3 41.3 293.8 32 256 32zm90 313.8c-28.5 5.4-58.7 8.3-89.9 8.3s-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3zm33.8-41.1c12.3-3.7 24.2 7 19.1 18.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4zM143.5 219.9c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4zm172.9-25.4c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5z'
      
    ]
  };

  
    var faGrinBeamSweat = faFaceGrinBeamSweat;
  

  
  

  var faTrumpet = {
    prefix: 'fal',
    iconName: 'trumpet',
    icon: [
      640,
      512,
      [127930],
      'f8e3',
      
      'M608 96.8l0 286.5c-10-14.3-33.6-45.3-67.1-73.1C507 282.1 461.3 256 408 256l-40 0-5.3 0L288 256l-80 0-48 0L32 256l0-32 176 0 80 0 80 0 40 0c53.3 0 99-26.1 132.9-54.1C574.4 142.1 598 111 608 96.8zM352 288l0 128-48 0 0-128 48 0zm32 128l0-128 24 0c42.8 0 81.4 21 112.5 46.8c30.9 25.6 52.8 54.6 61.7 67.4c5.9 8.5 15.6 13.9 26.4 13.9c17.4 0 31.4-14.1 31.4-31.4l0-289.1C640 78.1 625.9 64 608.6 64c-10.8 0-20.5 5.4-26.4 13.9c-8.9 12.8-30.8 41.8-61.7 67.4C489.4 171 450.8 192 408 192l-24 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-48 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-48 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L32 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 0 64 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l56.4 0C73.2 305 64 327.4 64 352c0 53 43 96 96 96l48 0 80 0 80 0 48 0c47.4 0 86.7-34.3 94.6-79.4c-3.4-3.1-6.9-6.2-10.5-9.2c-6.7-5.5-13.5-10.6-20.5-15.2c.3 2.6 .5 5.2 .5 7.8c0 35.3-28.7 64-64 64l-32 0zm-112 0l-48 0 0-128 48 0 0 128zm-80 0l-32 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l32 0 0 128z'
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fal',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      'M32 132l0-84c0-8.8-7.2-16-16-16S0 39.2 0 48L0 176c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-90.4 0C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16l0 112c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4 272 144c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faNestingDolls = {
    prefix: 'fal',
    iconName: 'nesting-dolls',
    icon: [
      640,
      512,
      [],
      'e3ba',
      
      'M192 32c53 0 96 43 96 96l0 80 0 16 32 0 0-16 0-80C320 57.3 262.7 0 192 0S64 57.3 64 128l0 80 0 16 32 0 0-16 0-80c0-53 43-96 96-96zm64.6 448L74.5 480c-9.2 0-14-3.5-15.9-6.4C46.9 455.7 32 424.8 32 384c0-32.6 13.6-63.3 30-96l250.2 0c5.4-11.4 12.1-22.2 19.9-32L51.9 256c-5.9 0-11.3 3.3-14 8.6C20.2 299.6 0 339.6 0 384c0 48.8 17.9 85.7 31.8 107.1C41.1 505.3 57.5 512 74.5 512l186.9 0c-4.8-10.1-6.4-21.3-4.8-32zM148.2 131.8c17.1-5.3 32.2-15.2 43.8-28.3c11.5 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2zm65.1-52.7c-5.6-7.3-14.1-10.2-21.3-10.2s-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5c-10.8 2.3-22.6 13.4-18.8 28.7c3.4 13.6 10.4 26.5 21.1 37.2c31.2 31.2 81.9 31.2 113.1 0c10.6-10.6 17.7-23.5 21.1-37.2c3.8-15.4-8-26.5-18.8-28.7c-15.1-3.2-28.3-11.7-37.5-23.5zM464 343.5c11.5 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2c17.1-5.3 32.2-15.2 43.8-28.3zm0-34.6c-7.3 0-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5c-10.8 2.3-22.6 13.4-18.8 28.7c3.4 13.6 10.4 26.6 21.1 37.2c31.2 31.2 81.9 31.2 113.1 0c10.6-10.6 17.7-23.5 21.1-37.2c3.8-15.4-8-26.5-18.8-28.7c-15.1-3.2-28.3-11.7-37.5-23.5c-5.6-7.3-14.1-10.2-21.3-10.2zM588.7 455.3c3.7 8.1 7.8 16.4 12.7 24.7l-274.8 0c4.9-8.3 9-16.6 12.7-24.7C353.1 425 360 393.3 360 360c0-57.4 46.6-104 104-104s104 46.6 104 104c0 33.3 6.9 65 20.7 95.3zm46.8 18.7c-7-10-12.6-20.9-17.7-32C605.9 415.9 600 388.7 600 360c0-75.1-60.9-136-136-136s-136 60.9-136 136c0 28.7-5.9 55.9-17.8 82.1c-5 11.1-10.7 22-17.7 32c0 0 0 0 0 0c-5.2 7.3-5.9 16.9-1.8 24.9c4.1 8 12.3 13 21.3 13l304 0c9 0 17.2-5 21.3-13s3.4-17.6-1.8-24.9z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMusic = {
    prefix: 'fal',
    iconName: 'magnifying-glass-music',
    icon: [
      512,
      512,
      [],
      'e65f',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM281.6 99.2c-4-3-9.2-4-14-2.6l-56 16c-6.9 2-11.6 8.2-11.6 15.4l0 63.6c0 .2 0 .5 0 .7l0 21.2c-8.4-3.5-17.9-5.5-28-5.5c-33.1 0-60 21.5-60 48s26.9 48 60 48s60-21.5 60-48c0 0 0 0 0 0l0-51.9 44.4-12.7c6.9-2 11.6-8.2 11.6-15.4l0-64c0-5-2.4-9.8-6.4-12.8zM194.4 247c4.7 3.8 5.6 7.2 5.6 9c0 0 0 0 0 0c0 1.8-.8 5.2-5.6 8.9c-4.8 3.8-12.6 7-22.4 7s-17.6-3.2-22.4-7c-4.7-3.8-5.6-7.2-5.6-9s.8-5.2 5.6-9c4.8-3.8 12.6-7 22.4-7s17.6 3.2 22.4 7zM232 170.8l0-30.7 24-6.9 0 30.7-24 6.9z'
      
    ]
  };

  

  
  

  var faChairOffice = {
    prefix: 'fal',
    iconName: 'chair-office',
    icon: [
      448,
      512,
      [],
      'f6c1',
      
      'M288 32c17.7 0 32 14.3 32 32l0 160 32 0 0-160c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 160 32 0 0-160c0-17.7 14.3-32 32-32l128 0zM64 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zm352 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zM352 288l32 64-160 0L64 352l32-64 256 0zM240 384l144 0c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-32-64C375.2 262.8 364.1 256 352 256L96 256c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384l144 0 0 48-16 0c-35.3 0-64 28.7-64 64c0 8.8 7.2 16 16 16s16-7.2 16-16c0-17.7 14.3-32 32-32l16 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c17.7 0 32 14.3 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-28.7-64-64-64l-16 0 0-48z'
      
    ]
  };

  

  
  

  var faFishCooked = {
    prefix: 'fal',
    iconName: 'fish-cooked',
    icon: [
      576,
      512,
      [],
      'f7fe',
      
      'M143.4 191.2c21.4-23.6 49.6-47.6 80.7-65.6C255.3 107.5 288.4 96 320 96c51.6 0 108.2 26.5 152.4 61.5c22 17.4 40.2 36.4 52.9 54.3c13 18.4 18.7 33.7 18.7 44.2s-5.7 25.8-18.7 44.2c-12.6 17.9-30.9 36.9-52.9 54.3C428.2 389.5 371.6 416 320 416c-31.6 0-64.7-11.5-95.9-29.6c-31.1-18-59.3-42-80.7-65.6c-5.4-5.9-14.3-7-20.9-2.4L37.6 376.8 62.1 266.4c1.5-6.9 1.5-14 0-20.8L37.6 135.2l84.9 58.4c6.6 4.5 15.5 3.5 20.9-2.4zM320 64c-39.1 0-77.8 14.1-111.9 33.9c-29.8 17.2-56.8 39.3-78.7 61.6L43.7 100.6c-4.4-3-9.6-4.6-14.9-4.6C12 96-.5 111.6 3.2 128L30.8 252.5c.5 2.3 .5 4.7 0 6.9L3.2 384c-3.6 16.4 8.8 32 25.6 32c5.3 0 10.5-1.6 14.9-4.6l-9.1-13.2 9.1 13.2 85.6-58.9c21.9 22.4 49 44.4 78.7 61.6C242.2 433.9 280.9 448 320 448c61.4 0 124.8-30.9 172.3-68.5c23.9-18.9 44.4-40.1 59.2-60.9C565.8 298.2 576 276.2 576 256s-10.2-42.2-24.5-62.6c-14.7-20.8-35.2-42-59.2-60.9C444.8 94.9 381.4 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z'
      
    ]
  };

  

  
  

  var faPenPaintbrush = {
    prefix: 'fal',
    iconName: 'pen-paintbrush',
    icon: [
      576,
      512,
      ["pencil-paintbrush"],
      'f618',
      
      'M320.5 410c4.9 39.5 38.6 70 79.4 70l139.2 0c-21.2 0-37.5-11.5-47.2-24.9c-9.5-13.1-14.2-30-12.5-46.7c.3-2.7 .4-5.5 .4-8.3c0-40.8-30.5-74.5-70-79.4l26.5-26.5c43.9 15.1 75.5 56.8 75.5 105.9c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4l4.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-49.1 0-90.8-31.6-105.9-75.5L320.5 410zm-187-186L18.7 109.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0L224 133.5l-22.6 22.6L86.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L156.1 201.4 133.5 224zM461.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L373 94.4 449.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L461.8 39.6zM115.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L71.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L427 193.6 350.4 117 115.1 352.4zM405.2 17c21.9-21.9 57.3-21.9 79.2 0L527 59.6c21.9 21.9 21.9 57.3 0 79.2L214.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L405.2 17z'
      
    ]
  };

  
    var faPencilPaintbrush = faPenPaintbrush;
  

  
  

  var faBrowser = {
    prefix: 'fal',
    iconName: 'browser',
    icon: [
      512,
      512,
      [128468],
      'f37e',
      
      'M160 64l0 64 320 0 0-32c0-17.7-14.3-32-32-32L160 64zm-32 0L64 64C46.3 64 32 78.3 32 96l0 32 96 0 0-64zM32 160l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256-336 0L32 160zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faFireplace = {
    prefix: 'fal',
    iconName: 'fireplace',
    icon: [
      640,
      512,
      [],
      'f79a',
      
      'M0 32C0 14.3 14.3 0 32 0L608 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 352c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128c0-88.4-71.6-160-160-160s-160 71.6-160 160l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-352C14.3 128 0 113.7 0 96L0 32zm64 96l0 352 64 0 0-128c0-106 86-192 192-192s192 86 192 192l0 128 64 0 0-352L64 128zM608 32L32 32l0 64 576 0 0-64zM339.3 323.1c-9 .2-17.6-3.4-23.7-9.9l-13.8-14.5c-2-2.1-4.1-4.5-5.6-6.2l-.2-.2c-13.6 13-27.7 28.6-38.9 45.3c-13.4 20.1-21.4 40-21.4 58.2c0 17.9 5.4 34.3 14.6 47.9c2.3-40.4 46.7-77.4 63.4-89.9c3.8-2.8 8.8-2.8 12.6 0c16.7 12.5 60.9 49.4 63.4 89.7c9.3-13.5 14.7-29.9 14.7-47.7c0-14.4-5.5-31.4-15-48.6c-7.4-13.3-16.6-25.6-26-35.7l-.7 .8c-5.9 6.7-14.4 10.6-23.4 10.8zM320 480c1.5 0 3 0 4.6-.1c20.4-2.1 33.3-17.8 33.3-32.9c0-9.6-5.8-22.4-17.9-36.9c-6.4-7.7-13.5-14.6-19.9-20.2c-6.4 5.6-13.5 12.5-19.9 20.2c-12.1 14.6-17.9 27.4-17.9 36.9c0 15.2 12.9 30.9 33.3 32.9c1.5 .1 3 .1 4.5 .1zM203.6 395.7c0-27.2 11.7-53.4 26.8-76c15.2-22.8 34.5-42.9 51.6-58.3c4.2-3.8 9.5-5.6 14.8-5.5c8.3 .2 14.5 5.6 20.1 11.6c1.3 1.4 2.5 2.8 3.7 4.2c0 0 0 0 0 0s0 0 0 0c1.5 1.7 2.9 3.3 4.4 4.9l13.8 14.5 8.9-10c1.9-2.1 4.1-3.6 6.6-4.7c.5-.2 1.1-.4 1.6-.6c2.3-.8 4.7-1.1 7-1.1c5.2 0 10.4 1.9 14.5 5.7c14.3 13.3 28.9 31.4 40 51.4c11 19.8 19 42.3 19 64.1c0 62.3-48.3 112.6-109.7 116.1c-2.2 .2-4.4 .3-6.7 .3c-2.2 0-4.4-.1-6.6-.3c-62-3.3-109.8-53.8-109.8-116.1z'
      
    ]
  };

  

  
  

  var faDiceD10 = {
    prefix: 'fal',
    iconName: 'dice-d10',
    icon: [
      512,
      512,
      [],
      'f6cd',
      
      'M213.8 84.1L55.6 264.1l92.7-21.8L213.8 84.1zM48.6 298.6L240 463.6l0-135.1-83.1-55.4L48.6 298.6zM272 463.6l191.4-165L355.1 273.2 272 328.6l0 135.1zM456.4 264.1L298.2 84.1l65.4 158.2 92.7 21.8zM256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zm0 300.8L332.2 250 256 65.8 179.8 250 256 300.8z'
      
    ]
  };

  

  
  

  var faQrcode = {
    prefix: 'fal',
    iconName: 'qrcode',
    icon: [
      448,
      512,
      [],
      'f029',
      
      'M144 64L48 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32zm96 288l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM48 288l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zM256 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm0 224c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 68 64 0 0-68c0-8.8 7.2-16 16-16s16 7.2 16 16l0 84c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-68-32 0 0 152c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-168zM88 104l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM72 376c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM344 104l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM320 448c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm96-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSubtitlesSlash = {
    prefix: 'fal',
    iconName: 'subtitles-slash',
    icon: [
      640,
      512,
      [],
      'e610',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448L96 448c-17.7 0-32-14.3-32-32l0-280.6L32 110.2 32 416c0 35.3 28.7 64 64 64l404.4 0-40.5-32zM544 32L139.6 32l40.5 32L544 64c17.7 0 32 14.3 32 32l0 280.6 32 25.3L608 96c0-35.3-28.7-64-64-64zM423.3 256l40.5 32 32.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-72.7 0zM144 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l113.2 0-40.5-32L144 256zm160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l74.8 0-40.5-32L304 352zm-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faAlbumCircleUser = {
    prefix: 'fal',
    iconName: 'album-circle-user',
    icon: [
      576,
      512,
      [],
      'e48d',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l211.2 0c5.9 11.4 12.9 22.2 21 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7L416 96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM492 462.6c-7.8-9.1-19.4-14.6-31.8-14.6l-56.4 0c-12.4 0-23.9 5.5-31.8 14.6c17.3 11 37.9 17.4 60 17.4s42.7-6.4 60-17.4zm24.3-20.8C533.5 422.1 544 396.2 544 368c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 28.2 10.5 54.1 27.7 73.8c13.8-16.1 34.2-25.8 56.1-25.8l56.4 0c21.8 0 42.2 9.6 56.1 25.8zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  

  
  

  var faPancakes = {
    prefix: 'fal',
    iconName: 'pancakes',
    icon: [
      512,
      512,
      [129374],
      'e42d',
      
      'M73.8 100c8.5-6.2 21.9-12.5 39.9-18c13.7-4.2 29.6-7.9 47.2-10.7c-.5 2.8-.8 5.7-.8 8.7c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48c0-3-.3-5.9-.8-8.7c17.5 2.9 33.4 6.5 47.2 10.7c18 5.5 31.3 11.8 39.9 18c8.9 6.5 9.8 10.7 9.8 12c0 1.1-.6 4.3-6.6 9.5c-5.9 5.1-15.5 10.5-29 15.7c-26.7 10.2-65.3 18-110.4 21.2c-25.2 1.8-46.1 22.4-46.1 48.7l0 80.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-85.7c0-25.1-20.7-43.9-43.1-46.7c-28.5-3.5-52.9 18.5-52.9 47L128 336c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-169.9c0-19-11.4-33.8-23.4-43c-7.9-6-8.6-9.9-8.6-11.1c0-1.3 .9-5.5 9.8-12zM199.5 66.5C217.3 64.9 236.3 64 256 64s38.7 .9 56.5 2.5C317 69.3 320 74.3 320 80c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16c0-5.7 3-10.7 7.5-13.5zm-95.3-15C84.5 57.5 67.5 65 54.9 74.1C42.8 83 32 95.6 32 112c0 15.6 9.8 27.8 21.1 36.5c7.4 5.7 10.9 12.1 10.9 17.6L64 336c0 26.5 21.5 48 48 48s48-21.5 48-48l0-133.5c0-9.5 7.8-16.3 17-15.2c8.9 1.1 15 8.5 15 14.9l0 85.7c0 26.5 21.5 48 48 48s48-21.5 48-48l0-80.9c0-8.5 6.9-16.1 16.4-16.8c47-3.4 88.9-11.6 119.5-23.3c15.2-5.8 28.6-12.9 38.4-21.3C472 137.4 480 126.1 480 112c0-16.4-10.8-29-22.9-37.9c-12.5-9.1-29.6-16.6-49.3-22.7C368.2 39.3 314.6 32 256 32s-112.2 7.3-151.8 19.5zM426.8 210.7c-28.1 9.5-64.7 15.9-106.8 19l0 32.1c64.8-4.6 119.7-16.7 153.9-37.3c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7c-28.4 9.6-65.4 16-108 19.1c-2.1 12.1-7 23.3-13.9 32.9c71.3-3.8 132.1-16.1 169-38.3c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7C385.2 368.8 325.1 376 256 376c-25.8 0-50.3-1-73.1-3c-6.2 11.9-15.3 22-26.3 29.4c30.6 3.8 64.1 5.6 99.4 5.6c92.1 0 172.8-12.4 217.9-39.5c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7C385.2 440.8 325.1 448 256 448s-129.2-7.2-170.8-21.3C40.9 411.7 32 394.8 32 384c0-4.4 1.4-9.7 6.1-15.5l1.1 .6C34.6 359 32 347.8 32 336l0-24 0-72 0-67.4c-8.9-7.1-18.9-17.3-25.3-30.9C2.3 149.8 0 158.5 0 168c0 13.5 4.7 25.5 13.4 36C4.7 214.5 0 226.5 0 240s4.7 25.5 13.4 36C4.7 286.5 0 298.5 0 312s4.7 25.5 13.4 36C4.7 358.5 0 370.5 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-13.5-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36c0-9.5-2.3-18.3-6.7-26.3c-5.8 12.1-14.3 21.6-22.2 28.3c-1.2 1-2.5 2.1-3.7 3.1c-2.7 10.6-14.7 24.8-52.6 37.6z'
      
    ]
  };

  

  
  

  var faCamcorder = {
    prefix: 'fal',
    iconName: 'camcorder',
    icon: [
      576,
      512,
      [128249,"video-handheld"],
      'f8a8',
      
      'M96 112c0-26.5 21.5-48 48-48l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 32c-44.2 0-80 35.8-80 80l0 48c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-17 0-158 0-17c0-35.3-28.7-64-64-64L96 160l0-48zM80 192l240 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l16 0zM520.3 460.5c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4l0 35.1 117.4-52.8c1-.4 2-.7 3.1-.7c4.2 0 7.5 3.4 7.5 7.5l0 209c0 4.2-3.4 7.5-7.5 7.5c-1.1 0-2.1-.2-3.1-.7L416 378.5l0 35.1 104.3 46.9zM64 240c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  
    var faVideoHandheld = faCamcorder;
  

  
  

  var faAnglesLeft = {
    prefix: 'fal',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      'M68.1 245.3c-5.5 6.1-5.5 15.3 0 21.4l144 160c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6L101.5 256 235.9 106.7c5.9-6.6 5.4-16.7-1.2-22.6s-16.7-5.4-22.6 1.2l-144 160zm336-160l-144 160c-5.5 6.1-5.5 15.3 0 21.4l144 160c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6L293.5 256 427.9 106.7c5.9-6.6 5.4-16.7-1.2-22.6s-16.7-5.4-22.6 1.2z'
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faBuilding = {
    prefix: 'fal',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zm-96 96l-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-64 0-32 0-64 0-32 0zM64 120c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zM248 96l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zM64 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zm152-32l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32z'
      
    ]
  };

  

  
  

  var faTicketSimple = {
    prefix: 'fal',
    iconName: 'ticket-simple',
    icon: [
      576,
      512,
      ["ticket-alt"],
      'f3ff',
      
      'M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 66c0 7.3-4.9 13.7-12 15.5c-20.7 5.3-36 24.1-36 46.5s15.3 41.2 36 46.5c7.1 1.8 12 8.2 12 15.5l0 66c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-66c0-7.3 4.9-13.7 12-15.5c20.7-5.3 36-24.1 36-46.5s-15.3-41.2-36-46.5C4.9 207.7 0 201.3 0 194l0-66zM64 96c-17.7 0-32 14.3-32 32l0 54.7C60.2 195 80 223.2 80 256s-19.8 61-48 73.3L32 384c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-54.7c-28.2-12.3-48-40.5-48-73.3s19.8-61 48-73.3l0-54.7c0-17.7-14.3-32-32-32L64 96z'
      
    ]
  };

  
    var faTicketAlt = faTicketSimple;
  

  
  

  var faAward = {
    prefix: 'fal',
    iconName: 'award',
    icon: [
      384,
      512,
      [],
      'f559',
      
      'M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM1.3 441.8l41.2-97.9c1.5 1.8 3.6 4.8 6.9 10.8c4 7.4 9.1 14 15 19.6L41.8 428l38.1-5.7c6.2-.9 12.3 1.8 15.7 7.1L116.9 462l26-61.8c1.8 .9 4.1 2.2 6.9 3.9c7 4.3 14.5 7.4 22.2 9.3l-37.3 88.7c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4l-37.3-88.7c7.7-2 15.2-5.1 22.2-9.3c2.8-1.7 5.1-3 6.9-3.9l26 61.8 21.3-32.6c3.4-5.2 9.6-8 15.7-7.1l38.1 5.7-22.6-53.7c5.9-5.6 11-12.2 15-19.6c3.3-6 5.4-9 6.9-10.8l41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z'
      
    ]
  };

  

  
  

  var faUserGroupSimple = {
    prefix: 'fal',
    iconName: 'user-group-simple',
    icon: [
      640,
      512,
      [],
      'e603',
      
      'M88 136a72 72 0 1 1 144 0A72 72 0 1 1 88 136zm176 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm144 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm176 0a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM208 320c53 0 96 43 96 96l0 16c0 8.8-7.2 16-16 16L48 448c-8.8 0-16-7.2-16-16l0-16c0-53 43-96 96-96l80 0zm-80-32C57.3 288 0 345.3 0 416l0 16c0 26.5 21.5 48 48 48l240 0c26.5 0 48-21.5 48-48l0-16c0-32.4-12-61.9-31.8-84.4C280.7 304.9 246.3 288 208 288l-80 0zM432 480l80 0c70.7 0 128-57.3 128-128l0-16c0-26.5-21.5-48-48-48l-240 0c-12.7 0-24.2 4.9-32.8 13c7.7 7.4 14.7 15.7 20.8 24.5c2.9-3.4 7.2-5.5 12.1-5.5l240 0c8.8 0 16 7.2 16 16l0 16c0 53-43 96-96 96l-80 0c-24.6 0-47-9.2-64-24.4l0 8.4c0 9.8-1.8 19.2-5 27.8c19.9 12.8 43.6 20.2 69 20.2z'
      
    ]
  };

  

  
  

  var faConveyorBeltEmpty = {
    prefix: 'fal',
    iconName: 'conveyor-belt-empty',
    icon: [
      640,
      512,
      [],
      'e150',
      
      'M96 352c-35.3 0-64 28.7-64 64s28.7 64 64 64l448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L96 352zM0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm128-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFlagPennant = {
    prefix: 'fal',
    iconName: 'flag-pennant',
    icon: [
      448,
      512,
      [128681,"pennant"],
      'f456',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 32 0 64 0 320l0 32L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-145.1L432.9 213.2c9.1-3.1 15.1-11.6 15.1-21.2s-6.1-18.1-15.1-21.2L32 33.1 32 16zm0 50.9L396.1 192 32 317.1 32 66.9z'
      
    ]
  };

  
    var faPennant = faFlagPennant;
  

  
  

  var faPersonFallingBurst = {
    prefix: 'fal',
    iconName: 'person-falling-burst',
    icon: [
      640,
      512,
      [],
      'e547',
      
      'M240 0c8.8 0 16 7.2 16 16l0 10.8c0 55.4-29.2 105.8-75.2 133.7l67.3 102.6 59.4-5.9c13.2-1.3 25.9 5.7 31.8 17.5l43.1 86.1c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L310.6 289l-64.4 6.4-57.5 44.7 96.6 147.1c4.9 7.4 2.8 17.3-4.6 22.2s-17.3 2.8-22.2-4.6L79.8 232.6C69.6 250.7 64 271.5 64 293.2L64 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-74.8c0-67.3 43.1-127.1 106.9-148.4c3.2-1.1 6.2-2.2 9.3-3.5c.2-.1 .4-.3 .6-.4c1.6-1.1 3.4-1.8 5.2-2.2c42.4-20.6 70-63.8 70-111.9L224 16c0-8.8 7.2-16 16-16zM171.1 313.3l47.4-36.9L151.6 174.3c-.8 .3-1.7 .6-2.5 .9c-18.9 6.3-35.5 16.8-48.9 30.4c.4 .5 .9 1.1 1.3 1.7l69.7 106.1zM56 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 56 32zM464 291.5l-57 47.2-27.6-55.2L380 251l-21.4-4.5c-13.2-15-32.9-23.2-53.3-21.5l-11.8 1c-.4-.9-.7-1.9-1-2.9c-1.4-6.1 .9-12.4 5.8-16.2l60.9-46.8L324.6 91.4c-2.8-5.6-2.1-12.3 1.8-17.2s10.3-7.1 16.3-5.6l74.6 18.4 32.1-69.8C452.1 11.6 457.8 8 464 8s11.9 3.6 14.5 9.3l32.1 69.8 74.6-18.4c6.1-1.5 12.5 .7 16.3 5.6s4.6 11.6 1.8 17.2l-34.6 68.6 60.9 46.8c5 3.8 7.2 10.2 5.8 16.2s-6.2 10.8-12.3 12.1L548 251l1.4 76.8c.1 6.2-3.4 12-9.1 14.7s-12.3 1.9-17.1-2.1l-59.2-49zm0-229.2l-23.1 50.2c-3.2 7-10.9 10.7-18.4 8.9l-53.7-13.3 24.9 49.4c3.5 6.9 1.6 15.2-4.5 19.9l-43.8 33.7 54.1 11.3c7.5 1.6 12.9 8.3 12.7 15.9l-1 55.3 42.6-35.2c5.9-4.9 14.5-4.9 20.4 0l42.6 35.2-1-55.3c-.1-7.7 5.2-14.4 12.7-15.9l54.1-11.3-43.8-33.7c-6.1-4.7-8-13-4.5-19.9l24.9-49.4-53.7 13.3c-7.5 1.8-15.2-1.9-18.4-8.9L464 62.3z'
      
    ]
  };

  

  
  

  var faArrowRightToLine = {
    prefix: 'fal',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      'M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zM347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 192 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faAnt = {
    prefix: 'fal',
    iconName: 'ant',
    icon: [
      640,
      512,
      [],
      'e680',
      
      'M513.9 36.7c3-3 7.1-4.7 11.3-4.7L592 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L525.3 0c-12.7 0-24.9 5.1-33.9 14.1L456.2 49.2C406.2 56.8 368 99.9 368 152c0 14.3 2.9 27.9 8.1 40.3c-2.7-.2-5.4-.3-8.1-.3c-27.4 0-52.2 11.5-69.7 30c-16.5-54.4-67.1-94-126.9-94l-6.1 0C74 128 0 202 0 293.3C0 343.4 40.6 384 90.7 384l34.9 0L66.1 488.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6L162.4 384l29.6 0c4.8 0 9.5-.3 14.1-.9l-60 104.9c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l78.7-137.7c12.6-8.1 23.4-18.6 31.8-30.9c4.6 8.1 10.3 15.5 17 21.9l-11.2 18.6-.2 .3s0 0 0 0l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l63.9-111.9 10.1-16.8c12.2 5.6 25.8 8.7 40.1 8.7c12.3 0 24-2.3 34.9-6.5L443.4 418c4.6 4.6 8.2 10.1 10.6 16.1l27.1 67.8c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-27.1-67.8c-4-10.1-10-19.2-17.7-26.9l-35-35c6.8-5.9 12.7-12.7 17.6-20.3l85.1 60.8c8.3 5.9 14.4 14.3 17.6 23.9l25.4 76.3c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-25.4-76.3c-5.3-16-15.6-30-29.4-39.8L461.5 310c1.7-7.1 2.5-14.4 2.5-22c0-11.6-2-22.6-5.8-32.9c4.5 .6 9.1 .9 13.8 .9l61.3 0c41.2 0 74.7-33.4 74.7-74.7c0-64.9-46.4-119-107.8-130.9l13.8-13.8zM400 152c0-39.8 32.2-72 72-72l2.7 0c56 0 101.3 45.4 101.3 101.3c0 23.6-19.1 42.7-42.7 42.7L472 224c-39.8 0-72-32.2-72-72zm32 136a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM165.3 160l6.1 0C227 160 272 205 272 260.6l0 11.4c0 44.2-35.8 80-80 80L90.7 352C58.3 352 32 325.7 32 293.3C32 219.7 91.7 160 165.3 160zM496 164a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faLineColumns = {
    prefix: 'fal',
    iconName: 'line-columns',
    icon: [
      512,
      512,
      [],
      'f870',
      
      'M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM0 320c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432zM288 192c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L304 48zM288 320c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  

  
  

  var faCardSpade = {
    prefix: 'fal',
    iconName: 'card-spade',
    icon: [
      384,
      512,
      [],
      'e3ec',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm180.7 68.2c6.2-6.2 16.4-6.2 22.6 0l33.9 33.9L297 225.9c25 25 25 65.5 0 90.5c-24.5 24.5-63.9 25-89 1.5l0 34.2 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-34.2c-25.1 23.5-64.5 23-89-1.5c-25-25-25-65.5 0-90.5l59.7-59.7 33.9-33.9zM192 166.1l-22.6 22.6-59.7 59.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.8-25.8c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l25.8 25.8c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-59.7-59.7L192 166.1z'
      
    ]
  };

  

  
  

  var faSpade = {
    prefix: 'fal',
    iconName: 'spade',
    icon: [
      512,
      512,
      [9824],
      'f2f4',
      
      'M449.2 231.8c43.3 44.9 41 119.4-6.8 161.2c-41.5 34.7-104.2 29.3-143.7-10.6l-18.5-20.5c-6-6.6-14.4-10.4-23.3-10.5s-17.4 3.5-23.6 9.9l-19.8 20.8C173.6 422.6 110 427.4 70.7 393.2l-.2-.2s0 0 0 0c-48.7-41.8-51.1-116.3-7.8-161.2c0 0 0 0 0 0L256.4 32.1c.1 0 .2 .1 .3 .2L449.2 231.8s0 0 0 0zm23-22.2L279.4 9.7c-13-13-34-13-45.9 0L39.7 209.5c-55.9 57.9-52.9 153.8 10 207.8c53.1 46.3 134.4 38.2 184.6-10.8c.7-.7 1.5-1.5 2.2-2.2l3.5-3.7 0 79.4-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-79.4 3.4 3.8c.9 .9 1.8 1.8 2.7 2.7c50.2 48.6 130.1 56.4 185.1 10.3c61.9-53.9 64.9-149.8 9-207.8z'
      
    ]
  };

  

  
  

  var faArrowTurnDown = {
    prefix: 'fal',
    iconName: 'arrow-turn-down',
    icon: [
      384,
      512,
      ["level-down"],
      'f149',
      
      'M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0L128 0c44.2 0 80 35.8 80 80l0 377.4L308.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 457.4 176 80c0-26.5-21.5-48-48-48L16 32z'
      
    ]
  };

  
    var faLevelDown = faArrowTurnDown;
  

  
  

  var faBorderRight = {
    prefix: 'fal',
    iconName: 'border-right',
    icon: [
      448,
      512,
      [],
      'f852',
      
      'M432 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zM320 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192-48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm192-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faKnifeKitchen = {
    prefix: 'fal',
    iconName: 'knife-kitchen',
    icon: [
      576,
      512,
      [128298],
      'f6f5',
      
      'M485.7 33l-175 175 76.2 76.2 45-25c5.1-2.8 8.2-8.2 8.2-14l0-31.9c0-12.7 5.1-24.9 14.1-33.9l89-89c.6-.6 1-1.5 1-2.3s-.3-1.7-1-2.3L490.3 33c-.6-.6-1.5-1-2.3-1s-1.7 .3-2.3 1zM488 0c9.4 0 18.3 3.7 25 10.3L565.7 63c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-89 89c-3 3-4.7 7.1-4.7 11.3l0 31.9c0 17.4-9.4 33.5-24.7 42l-45 25c-12.5 6.9-28.1 4.8-38.2-5.3L288 230.6c-12.5-12.5-12.5-32.8 0-45.3l175-175C469.7 3.7 478.6 0 488 0zM4.7 468.7L242.7 230.6l22.6 22.6L46.6 472c21.7 5.1 43.9 8 65.4 8c99.8 0 165.6-39.9 232.5-102.4l-9-9c-12.5-12.5-12.5-32.7 0-45.2l33 33c11.5 12.6 11.3 32.2-1.3 43.9C296.6 466.3 223.2 512 112 512c-33.9 0-68.6-6.3-100.8-16.8C0 491.5-3.7 477.1 4.7 468.7zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faUpFromBracket = {
    prefix: 'fal',
    iconName: 'up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e590',
      
      'M222.2 32.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 164.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L288 176c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 32.8zM224 0c-9.5 0-18.6 3.9-25.1 10.8L74.5 142.8C67.8 150 64 159.5 64 169.3c0 21.4 17.3 38.7 38.7 38.7l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 10.8C242.6 3.9 233.5 0 224 0zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-96z'
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fal',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      'M89.2 4.8C83-1.5 72.8-1.6 66.5 4.6s-6.4 16.3-.2 22.6C81.2 42.4 98.9 55 118.6 64C58 91.8 16 153 16 224c0 91.8 70.3 167.2 160 175.3l0 32.7-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-32.7c89.7-8.1 160-83.5 160-175.3c0-71-42-132.2-102.6-160c19.6-9 37.3-21.6 52.3-36.8c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2C268.7 31.5 232.3 48 192 48S115.3 31.5 89.2 4.8zM192 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'
      
    ]
  };

  

  
  

  var faTransgender = {
    prefix: 'fal',
    iconName: 'transgender',
    icon: [
      512,
      512,
      [9895,"transgender-alt"],
      'f225',
      
      'M144 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 0C23.2 0 16 7.2 16 16l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4L89.4 96l-4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l4.7-4.7 13.2 13.2C106.8 157.9 96 189.7 96 224c0 83 63.1 151.2 144 159.2l0 32.8-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32.8c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16L368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l73.4 0-75.6 75.6C337.1 80.6 298.5 64 256 64s-81.1 16.6-109.8 43.6L134.6 96l4.7-4.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 73.4 70.6 32 144 32zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  
    var faTransgenderAlt = faTransgender;
  

  
  

  var faSimCard = {
    prefix: 'fal',
    iconName: 'sim-card',
    icon: [
      384,
      512,
      [],
      'f7c4',
      
      'M32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-293.5c0-8.5-3.4-16.6-9.4-22.6L252.1 41.4c-6-6-14.1-9.4-22.6-9.4L64 32C46.3 32 32 46.3 32 64zM0 448L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64zM64 280l0-40c0-26.5 21.5-48 48-48l48 0 16 0 16 0 40 0 40 0c26.5 0 48 21.5 48 48l0 40 0 80 0 40c0 26.5-21.5 48-48 48l-48 0-16 0-16 0-80 0c-26.5 0-48-21.5-48-48l0-40 0-80zM96 400c0 8.8 7.2 16 16 16l80 0 0-40-40 0-56 0 0 24zm176 16c8.8 0 16-7.2 16-16l0-24-64 0 0 40 48 0zm-64-72l80 0 0-48-56 0-56 0-80 0 0 48 56 0 56 0zm80-104c0-8.8-7.2-16-16-16l-40 0-40 0 0 40 40 0 56 0 0-24zM160 224l-48 0c-8.8 0-16 7.2-16 16l0 24 64 0 0-40z'
      
    ]
  };

  

  
  

  var faDiceFour = {
    prefix: 'fal',
    iconName: 'dice-four',
    icon: [
      448,
      512,
      [9859],
      'f524',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faMandolin = {
    prefix: 'fal',
    iconName: 'mandolin',
    icon: [
      512,
      512,
      [],
      'f6f9',
      
      'M459.3 4.7C454.3-.4 446.5-1.5 440.2 2l-72 40c-4 2.2-6.8 6-7.8 10.4l-23 99.5-38.6 38.6C227.4 187.1 0 187.6 0 336c0 97.2 78.8 176 176 176c148.4 0 148.9-227.4 145.4-298.8l38.6-38.6 99.5-23c4.4-1 8.2-3.9 10.4-7.8l40-72c3.5-6.2 2.4-14-2.7-19.1l-48-48zm-191.7 217l-43.1 43.1c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l43.1-43.1c.2 28.6-1.4 65.6-7.8 102.1c-6.6 37.9-18 72.4-35.6 96.7C230.3 466.1 208.4 480 176 480C96.5 480 32 415.5 32 336c0-32.4 13.9-54.3 36.8-70.8c24.3-17.6 58.8-29 96.7-35.6c36.5-6.4 73.5-7.9 102.1-7.8zM445.5 122l-72.1 16.6L390 66.5l55.2-30.7 30.9 30.9L445.5 122zM192 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMeter = {
    prefix: 'fal',
    iconName: 'meter',
    icon: [
      512,
      512,
      [],
      'e1e8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 144l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFaceGrinHearts = {
    prefix: 'fal',
    iconName: 'face-grin-hearts',
    icon: [
      512,
      512,
      [128525,"grin-hearts"],
      'f584',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM195.1 144.6c-9.3-2.5-18.8 3-21.3 12.3l-4.3 16.1c-2.3 8.5-11.1 13.6-19.6 11.3l-16.1-4.3c-9.3-2.5-18.8 3-21.3 12.3s3 18.8 12.3 21.3L190 230.9l17.4-65c2.5-9.3-3-18.8-12.3-21.3zm-52.2 4c7.1-26.3 34.1-42 60.4-34.9s42 34.1 34.9 60.4l-17.4 65c-4.6 17.1-22.1 27.2-39.2 22.6l-65.1-17.4c-26.3-7.1-42-34.1-34.9-60.4s34.1-42 60.4-34.9l.7 .2 .2-.6zm226.1 0l.2 .6 .7-.2c26.3-7.1 53.4 8.6 60.4 34.9s-8.6 53.4-34.9 60.4l-65.1 17.4c-17.1 4.6-34.6-5.6-39.2-22.6l-17.4-65c-7.1-26.3 8.6-53.4 34.9-60.4s53.4 8.6 60.4 34.9zm-52.2-4c-9.3 2.5-14.8 12-12.3 21.3l17.4 65 65.1-17.4c9.3-2.5 14.8-12 12.3-21.3s-12-14.8-21.3-12.3L362 184.2c-8.5 2.3-17.3-2.8-19.6-11.3l-4.3-16.1c-2.5-9.3-12-14.8-21.3-12.3z'
      
    ]
  };

  
    var faGrinHearts = faFaceGrinHearts;
  

  
  

  var faSplotch = {
    prefix: 'fal',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      'M189.1 416.1L86.4 425.5C65.8 427.3 48 411.1 48 390.4c0-7.6 2.5-15 7-21.1l18.8-25c14.5-19.4 22.1-43.1 21.6-67.3c-.5-20.2-6.6-39.8-17.6-56.6L37.3 158.5c-3.4-5.2-5.3-11.4-5.3-17.6c0-20.1 18.2-35.2 37.9-31.6l42.8 7.8c47 8.5 94.9-8.8 125.4-45.5l22.3-26.8c6.7-8 16.6-12.7 27.1-12.7c15.2 0 28.7 9.7 33.5 24.1l15 45.1c14.2 42.6 46.9 76.5 88.9 92.3l32.3 12.1c13.7 5.1 22.7 18.2 22.7 32.8c0 11-5.2 21.4-14 28L404 313c-33.4 25-51 65.8-46.4 107.3l2.5 22.7c2.2 19.8-13.3 37.1-33.2 37.1c-7.6 0-14.9-2.6-20.9-7.3L269 443c-21.8-17.5-49-27-77-27c-1 0-1.9 0-2.9 .1zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z'
      
    ]
  };

  

  
  

  var faSquareN = {
    prefix: 'fal',
    iconName: 'square-n',
    icon: [
      448,
      512,
      [],
      'e277',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm157 38.7L288 318.1 288 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 7-4.5 13.1-11.1 15.2s-13.9-.3-17.9-5.9L160 193.9 160 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-7 4.5-13.1 11.1-15.2s13.9 .3 17.9 5.9z'
      
    ]
  };

  

  
  

  var faArrowUpRightDots = {
    prefix: 'fal',
    iconName: 'arrow-up-right-dots',
    icon: [
      576,
      512,
      [],
      'e4b7',
      
      'M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l121.4 0L4.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 54.6 288 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L144 0zM528 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 464a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM528 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faSquareFragile = {
    prefix: 'fal',
    iconName: 'square-fragile',
    icon: [
      448,
      512,
      ["box-fragile","square-wine-glass-crack"],
      'f49b',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 32l0 80c0 44.2 35.8 80 80 80s80-35.8 80-80l0-80-73.4 0 20.7 20.7c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-30.2 20.1 31.5 26.3c6.8 5.7 7.7 15.7 2 22.5s-15.7 7.7-22.5 2l-48-40c-3.9-3.2-6-8.1-5.7-13.1s2.9-9.7 7.1-12.5l31.8-21.2L185.4 128 144 128zm-1.1-32l162.2 0c17.1 0 30.9 13.8 30.9 30.9l0 81.1c0 56.4-41.7 103.1-96 110.9l0 65.1 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-65.1c-54.3-7.8-96-54.4-96-110.9l0-81.1c0-17.1 13.8-30.9 30.9-30.9z'
      
    ]
  };

  
    var faBoxFragile = faSquareFragile;
  
    var faSquareWineGlassCrack = faSquareFragile;
  

  
  

  var faLockKeyholeOpen = {
    prefix: 'fal',
    iconName: 'lock-keyhole-open',
    icon: [
      576,
      512,
      ["lock-open-alt"],
      'f3c2',
      
      'M448 32c-53 0-96 43-96 96l0 64 16 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 272c0-44.2 35.8-80 80-80l240 0 0-64C320 57.3 377.3 0 448 0s128 57.3 128 128l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-53-43-96-96-96zM80 224c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0L80 224zM264 368l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z'
      
    ]
  };

  
    var faLockOpenAlt = faLockKeyholeOpen;
  

  
  

  var faConveyorBeltArm = {
    prefix: 'fal',
    iconName: 'conveyor-belt-arm',
    icon: [
      640,
      512,
      [],
      'e5f8',
      
      'M128 16c0 8.8 7.2 16 16 16l77.1 0-5.5 32.7C193.1 68.7 176 88.3 176 112c0 26.5 21.5 48 48 48c18.6 0 34.8-10.6 42.8-26.2L448 158l0 50c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8-5.9-14.8-13.9-15.9L271 102.1c-2.9-13.8-11.7-25.5-23.8-32.1l6.3-38L336 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 0c-8.8 0-16 7.2-16 16zm72 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM448 288l32 0 0 32-32 0 0-32zm-32-8l0 40-64 0 0-40c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 40-64 0 0-40c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 40c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96l-32 0 0-40c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM96 352l24 0 48 0 112 0 48 0 112 0 48 0 56 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64s28.7-64 64-64zm64-64l0 32-32 0 0-32 32 0zm128 32l0-32 32 0 0 32-32 0zM128 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faWarehouse = {
    prefix: 'fal',
    iconName: 'warehouse',
    icon: [
      640,
      512,
      [],
      'f494',
      
      'M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59L640 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-320.1c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 272c0 8.8-7.2 16-16 16c-.1 0-.2 0-.2 0l-415.5 0c-.1 0-.2 0-.2 0c-8.8 0-16-7.2-16-16l0-272zm32 256l384 0 0-64-384 0 0 64zM512 320l-384 0 0 64 384 0 0-64zM128 288l384 0 0-64-384 0 0 64z'
      
    ]
  };

  

  
  

  var faSunBright = {
    prefix: 'fal',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ["sun-alt"],
      'e28f',
      
      'M256 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16zM0 256c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zm400 0c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zM256 400c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16zM75 75c6.2-6.2 16.4-6.2 22.6 0l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zm0 362c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L97.6 437c-6.2 6.2-16.4 6.2-22.6 0zM357.8 154.2c-6.2-6.2-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0zm0 203.6c6.2-6.2 16.4-6.2 22.6 0L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'
      
    ]
  };

  
    var faSunAlt = faSunBright;
  

  
  

  var faGears = {
    prefix: 'fal',
    iconName: 'gears',
    icon: [
      640,
      512,
      ["cogs"],
      'f085',
      
      'M146.2 40.7l-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11c-14.6 4.6-27.9 12.4-39 22.5c-4 3.7-9.6 5.1-14.9 3.7L49.7 96.4c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7C56.8 160.7 56 168.2 56 176s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7L35.9 231.8c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6L74.9 249c5.3-1.4 10.9 0 14.9 3.7c11.1 10.2 24.3 17.9 39 22.5c5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5 .5 9.1 .7 13.8 .7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11c14.6-4.6 27.9-12.4 39-22.5c4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7c1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3 .4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3L245.1 103c-5.3 1.4-10.9 0-14.9-3.7c-11.1-10.2-24.3-17.9-39-22.5c-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2 .2-13.8 .7zM130.8 10.5C140.3 8.9 150.1 8 160 8s19.7 .9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3 .5 16.3 5.2c5.6 6.7 10.7 13.8 15.2 21.3l.2 .3s0 0 0 0l2.9 5.1 .2 .3s0 0 0 0c4.1 7.5 7.7 15.4 10.7 23.6c2.1 5.8 .7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7c-3 8.2-6.6 16-10.7 23.6l-.2 .3s0 0 0 0l-3 5.1-.2 .3s0 0 0 0c-4.5 7.5-9.6 14.6-15.2 21.3c-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7L201.8 330c-1.6 6-6.6 10.5-12.7 11.5c-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2c-5.7-6.8-10.9-14-15.4-21.6l-.1-.2s0 0 0 0l-2.6-4.5-.1-.2s0 0 0 0c-4.2-7.6-7.9-15.6-10.9-23.9c-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1C24.5 189.9 24 183 24 176s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7c3-8.3 6.7-16.3 10.9-23.9l.1-.2s0 0 0 0l2.6-4.5 .1-.2s0 0 0 0C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7L118.2 22c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328.7 365.8l25.1 6.9c5.2 1.4 9.4 5.4 11 10.6c4.6 14.6 12.4 27.9 22.5 39c3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2c7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8 .4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3L537 437.1c-1.4-5.3 0-10.9 3.7-14.9c10.2-11.1 17.9-24.3 22.5-39c1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5 .7-9.1 .7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6c-4.6-14.7-12.4-27.9-22.5-39c-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2c-7.2-1.6-14.8-2.4-22.6-2.4s-15.3 .8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9c-10.2 11.1-17.9 24.3-22.5 39c-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2 .7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3c6.7-5.6 13.8-10.7 21.3-15.2l.3-.2s0 0 0 0l5.1-2.9 .3-.2s0 0 0 0c7.5-4.1 15.4-7.7 23.6-10.7c5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9 .5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6c8.2 3 16 6.6 23.6 10.7l.3 .2s0 0 0 0l5.1 3 .3 .2s0 0 0 0c7.5 4.5 14.6 9.6 21.3 15.2c4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7c1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3c-6.8 5.7-14 10.9-21.6 15.4l-.2 .1s0 0 0 0l-4.5 2.6-.2 .1s0 0 0 0c-7.6 4.2-15.6 7.9-23.9 10.9c-5.8 2.1-12.3 .7-16.7-3.6l-20.1-19.8c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6c-8.3-3-16.3-6.7-23.9-10.9l-.2-.1s0 0 0 0l-4.5-2.6-.2-.1s0 0 0 0c-7.6-4.6-14.9-9.8-21.6-15.4c-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8L310 393.8c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCogs = faGears;
  

  
  

  var faPartyHorn = {
    prefix: 'fal',
    iconName: 'party-horn',
    icon: [
      512,
      512,
      [],
      'e31b',
      
      'M40 32a24 24 0 1 1 48 0A24 24 0 1 1 40 32zM456 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM172.7 147.3c-6.2-6.2-6.2-16.4 0-22.6l8.3-8.3c18-18 29.3-41.6 32.1-66.8l3-27.4c1-8.8 8.9-15.1 17.7-14.1s15.1 8.9 14.1 17.7l-3 27.4c-3.6 32.5-18.2 62.8-41.3 85.9l-8.3 8.3c-6.2 6.2-16.4 6.2-22.6 0zm192 169.4l8.3-8.3c23.1-23.1 53.4-37.7 85.9-41.3l27.4-3c8.8-1 16.7 5.4 17.7 14.1s-5.4 16.7-14.1 17.7l-27.4 3c-25.3 2.8-48.8 14.1-66.8 32.1l-8.3 8.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm135.5-303c5.7 6.7 4.9 16.8-1.9 22.5l-10 8.5C475 55.9 458.1 61.9 440.7 61.4c-21-.6-38.6 15.6-39.8 36.5l-1.8 30c-2.2 38.2-34.4 67.7-72.6 66.6c-9.5-.3-18.8 3-26.1 9.2l-10 8.5c-6.7 5.7-16.8 4.9-22.5-1.9s-4.9-16.8 1.9-22.5l10-8.5c13.3-11.2 30.3-17.2 47.7-16.7c21 .6 38.6-15.6 39.8-36.5l1.8-30c2.2-38.2 34.4-67.7 72.6-66.6c9.5 .3 18.8-3 26.1-9.2l10-8.5c6.7-5.7 16.8-4.9 22.6 1.9zM32.2 479.6c0 0 .1 .1 .1 .1s.1 .1 .1 .1l76.2-28.6L60.7 403.4 32.2 479.6zm169.6-63.2L95.6 310.3 73 370.7c.8 .6 1.6 1.2 2.3 1.9l64 64c.7 .7 1.4 1.5 2 2.4l60.5-22.7zM234.7 404l53.3-20c0-.1 0-.1 .1-.2s0-.1 0-.2L128.3 224c-.1 0-.1 0-.2 0s-.1 0-.2 .1l-20 53.3L234.7 404zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4L310.9 361.3c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18.1 519.4-7.4 494 2 468.8L98.1 212.6z'
      
    ]
  };

  

  
  

  var faPeace = {
    prefix: 'fal',
    iconName: 'peace',
    icon: [
      512,
      512,
      [9774],
      'f67c',
      
      'M240 479.4l0-189.7L93.2 409.9c37.4 39.6 89.1 65.5 146.8 69.6zM72.9 385.1L240 248.4l0-215.9C123.8 40.8 32 137.7 32 256c0 48.1 15.1 92.6 40.9 129.1zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm16-32.6c57.7-4.1 109.4-30 146.8-69.6L272 289.8l0 189.7zm167.1-94.3c25.8-36.5 40.9-81 40.9-129.1c0-118.3-91.8-215.2-208-223.4l0 215.9L439.1 385.1z'
      
    ]
  };

  

  
  

  var faRobot = {
    prefix: 'fal',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      'M320 0c8.8 0 16 7.2 16 16l0 80 112 0c53 0 96 43 96 96l0 224c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96l0-224c0-53 43-96 96-96l112 0 0-80c0-8.8 7.2-16 16-16zM192 128c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-128 0-128 0zm16 256l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM48 224l16 0 0 32-16 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l16 0 0 32-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM592 384c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-16 0 0-32 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0 0-32 16 0z'
      
    ]
  };

  

  
  

  var faWhale = {
    prefix: 'fal',
    iconName: 'whale',
    icon: [
      640,
      512,
      [128011],
      'f72c',
      
      'M164.9 .8c5.7 1.8 9.9 6.7 10.9 12.6l14.1 84.7 84.7 14.1c5.9 1 10.8 5.2 12.6 10.9s.3 12-3.9 16.2L242.6 180c-18.3 18.3-44.2 26.6-69.7 22.3L111 192 70.8 250.4c-9.2 13.3-10.4 30.6-3.1 45c7.5 15.1 22.9 24.6 39.7 24.6l3.2 0c11.3 0 22.2-3.8 31-10.9L270.9 205.7C333.8 155.4 411.8 128 492.3 128C573.9 128 640 194.1 640 275.7L640 384c0 53-43 96-96 96l-381.6 0C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l46.5-46.5 3.4-3.4-7.9-47.4C81.4 89.6 89.7 63.7 108 45.4L148.7 4.7c4.2-4.2 10.5-5.8 16.2-3.9zM149.3 49.3L130.6 68c-11 11-16 26.5-13.4 41.8l8.7 52.2 52.2 8.7c15.3 2.5 30.9-2.4 41.8-13.4l18.7-18.7-65.3-10.9c-6.7-1.1-12-6.4-13.2-13.2L149.3 49.3zM368 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-334.1 .5c-1.3 6.9-1.9 14-1.9 21.2C32 389.6 90.4 448 162.4 448L544 448c35.3 0 64-28.7 64-64l0-108.3C608 211.8 556.2 160 492.3 160c-73.2 0-144.2 24.9-201.4 70.7L161.6 334.1c-14.5 11.6-32.4 17.9-50.9 17.9l-3.2 0c-28.9 0-55.4-16.4-68.4-42.2c-2.2-4.3-3.9-8.8-5.2-13.3z'
      
    ]
  };

  

  
  

  var faArrowUpTriangleSquare = {
    prefix: 'fal',
    iconName: 'arrow-up-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-up"],
      'f88a',
      
      'M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 432l0-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM416 67.5L490.7 192l-149.4 0L416 67.5zM307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1l173.9 0c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32s-19.1 5.2-24.2 13.7L307.6 186zM320 432c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96z'
      
    ]
  };

  
    var faSortShapesUp = faArrowUpTriangleSquare;
  

  
  

  var faTowerControl = {
    prefix: 'fal',
    iconName: 'tower-control',
    icon: [
      448,
      512,
      [],
      'e2a2',
      
      'M160 16c0-8.8 7.2-16 16-16l48 0 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 48 0c17.7 0 32 14.3 32 32l0 32 80.9 0c26.2 0 45.3 24.8 38.7 50.1L402.6 320.2c7.6 1.2 13.4 7.8 13.4 15.8c0 8.8-7.2 16-16 16l-48 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-192 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-48 0c-8.8 0-16-7.2-16-16c0-8 5.8-14.6 13.4-15.8L8.4 178.1C1.8 152.8 20.9 128 47.1 128l80.9 0 0-32c0-17.7 14.3-32 32-32l48 0 0-32-32 0c-8.8 0-16-7.2-16-16zM128 160.2l0-.2-80.9 0c-5.2 0-9.1 5-7.7 10L78.5 320l49.6 0 0-159.8zM160 320l128 0 0-159.8 0-.2-128 0 0 160zM320 160l0 160 49.6 0 39.1-150c1.3-5.1-2.5-10-7.7-10L320 160zm-32-32l0-32L160 96l0 32 128 0z'
      
    ]
  };

  

  
  

  var faSpinner = {
    prefix: 'fal',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      
      'M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z'
      
    ]
  };

  

  
  

  var faCircleQuarters = {
    prefix: 'fal',
    iconName: 'circle-quarters',
    icon: [
      512,
      512,
      [],
      'e3f8',
      
      'M402.7 425.3L256 278.6 109.3 425.3C148.6 459.4 199.9 480 256 480s107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256s-20.6-107.4-54.7-146.7L278.6 256 425.3 402.7zm-22.6-316C363.4 52.6 312.1 32 256 32s-107.4 20.6-146.7 54.7L256 233.4 402.7 86.7zm-316 22.6C52.6 148.6 32 199.9 32 256s20.6 107.4 54.7 146.7L233.4 256 86.7 109.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faRotate = {
    prefix: 'fal',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      'M426.1 301.2C406.2 376.5 337.6 432 256 432c-51 0-96.9-21.7-129-56.3l41-41c5.1-5.1 8-12.1 8-19.3c0-15.1-12.2-27.3-27.3-27.3L48 288c-8.8 0-16 7.2-16 16l0 100.7C32 419.8 44.2 432 59.3 432c7.2 0 14.2-2.9 19.3-8l25.7-25.7C142.3 438.7 196.2 464 256 464c97.4 0 179.2-67 201.8-157.4c2.4-9.7-5.2-18.6-15.2-18.6c-7.8 0-14.5 5.6-16.5 13.2zM385 136.3l-41 41c-5.1 5.1-8 12.1-8 19.3c0 15.1 12.2 27.3 27.3 27.3L464 224c8.8 0 16-7.2 16-16l0-100.7C480 92.2 467.8 80 452.7 80c-7.2 0-14.2 2.9-19.3 8l-25.7 25.7C369.7 73.3 315.8 48 256 48C158.6 48 76.8 115 54.2 205.4c-2.4 9.7 5.2 18.6 15.2 18.6c7.8 0 14.5-5.6 16.5-13.2C105.8 135.5 174.4 80 256 80c51 0 96.9 21.7 129.1 56.3zM448 192l-73.4 0L448 118.6l0 73.4zM64 320l73.4 0L64 393.4 64 320z'
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faCircleTrash = {
    prefix: 'fal',
    iconName: 'circle-trash',
    icon: [
      512,
      512,
      ["trash-circle"],
      'e126',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 144l32.1 0 9.3 0 11.3-11.3c3-3 7.1-4.7 11.3-4.7l64 0c4.2 0 8.3 1.7 11.3 4.7L310.6 144l9.3 0 32.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-2.1 0L338 354.1c-1.1 16.8-15.1 29.9-31.9 29.9l-100.1 0c-16.8 0-30.8-13.1-31.9-29.9L162.1 176l-2.1 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm157.8 32l-123.6 0 11.7 176 100.1 0 11.7-176z'
      
    ]
  };

  
    var faTrashCircle = faCircleTrash;
  

  
  

  var faHandPeace = {
    prefix: 'fal',
    iconName: 'hand-peace',
    icon: [
      512,
      512,
      [9996],
      'f25b',
      
      'M253.4 .3c-30.8-3-58.2 19.6-61.1 50.3L177.9 199 123.8 66.8c-11.7-28.6-44.4-42.3-73-30.6s-42.3 44.4-30.6 73L84.5 266.5C71.8 280.7 64 299.4 64 320l0 32c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-39.9c0 0 0 0 0-.1l0-64c0 0 0 0 0-.1l0-7.9c0-3.2-.9-6.1-2.5-8.6C438.4 208.6 417.2 192 392 192c-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-6.9 0-13.6 1.3-19.7 3.6L303.7 61.4c3-30.8-19.6-58.2-50.3-61.1zM111.1 247L49.8 97.1c-5-12.3 .9-26.3 13.1-31.3s26.3 .9 31.3 13.1L160.1 240 144 240c-11.7 0-22.8 2.5-32.9 7zM232 240l-25.9 0 18-186.3c1.3-13.2 13-22.9 26.2-21.6s22.9 13 21.6 26.2l-18 186.1c-6.7-2.9-14.1-4.4-21.9-4.4zm80-32c13.3 0 24 10.7 24 24l0 16 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24c0 0 0 0 0 0l0-64c0-13.3 10.7-24 24-24zm32.5 133.6C354.4 357.5 372 368 392 368c8.4 0 16.4-1.9 23.5-5.2C410.1 428.5 355 480 288 480l-64 0c-70.7 0-128-57.3-128-128l0-32c0-26.5 21.5-48 48-48l88 0c13.2 0 24 10.7 24 24c0 0 0 0 0 0c0 13.3-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c12.1 0 23.3-3.8 32.5-10.4zM416 312c0 13.2-10.8 24-24 24c-13.3 0-24-10.7-24-24l0-16 0-48c0-13.3 10.7-24 24-24c13.2 0 24 10.7 24 24c0 0 0 0 0 0l0 64c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faDial = {
    prefix: 'fal',
    iconName: 'dial',
    icon: [
      576,
      512,
      ["dial-med-high"],
      'e15b',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm11.3 243.3l89.8-89.8c39.1 50.2 35.5 122.9-10.6 169c-50 50-131 50-181 0s-50-131 0-181c46.2-46.2 118.8-49.7 169-10.6l-89.8 89.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM401.1 174.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faDialMedHigh = faDial;
  

  
  

  var faAlt = {
    prefix: 'fal',
    iconName: 'alt',
    icon: [
      640,
      512,
      [],
      'e08a',
      
      'M462 107.7c6.1-7.4 15.2-11.7 24.8-11.7L624 96c8.8 0 16-7.2 16-16s-7.2-16-16-16L486.7 64c-19.2 0-37.4 8.6-49.5 23.5L178 404.3c-6.1 7.4-15.2 11.7-24.8 11.7L16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l137.3 0c19.2 0 37.4-8.6 49.5-23.5L462 107.7zM432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  

  
  

  var faDiagramLeanCanvas = {
    prefix: 'fal',
    iconName: 'diagram-lean-canvas',
    icon: [
      640,
      512,
      [],
      'e156',
      
      'M512 64l0 256 96 0 0-224c0-17.7-14.3-32-32-32l-64 0zm-32 0l-96 0 0 128 96 0 0-128zM352 64l-64 0 0 256 64 0 0-256zm-96 0l-96 0 0 128 96 0 0-128zM128 64L64 64C46.3 64 32 78.3 32 96l0 224 96 0 0-256zM32 352l0 64c0 17.7 14.3 32 32 32l240 0 0-96L32 352zm304 96l240 0c17.7 0 32-14.3 32-32l0-64-272 0 0 96zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM256 320l0-96-96 0 0 96 96 0zm224-96l-96 0 0 96 96 0 0-96z'
      
    ]
  };

  

  
  

  var faMugTeaSaucer = {
    prefix: 'fal',
    iconName: 'mug-tea-saucer',
    icon: [
      640,
      512,
      [],
      'e1f5',
      
      'M240 64l176 0 16 0 16 0 0 160 0 32 0 32c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-224 80 0 0 40.5-36.5 30.4C164.2 141 160 150 160 159.5l0 64.5c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64.5c0-9.5-4.2-18.5-11.5-24.6L240 104.5 240 64zM224 32l-96 0c-17.7 0-32 14.3-32 32l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96l0-32 48 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-80 0-16 0-16 0L224 32zM480 224l0-160 48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-48 0zM0 464c0 8.8 7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448c-8.8 0-16 7.2-16 16zM192 224l0-64.5 32-26.7 32 26.7 0 64.5-64 0z'
      
    ]
  };

  

  
  

  var faTtyAnswer = {
    prefix: 'fal',
    iconName: 'tty-answer',
    icon: [
      640,
      512,
      ["teletype-answer"],
      'e2b9',
      
      'M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0zM312 64l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm0 96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM504 64l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-200 0l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faTeletypeAnswer = faTtyAnswer;
  

  
  

  var faSpeakers = {
    prefix: 'fal',
    iconName: 'speakers',
    icon: [
      640,
      512,
      [],
      'f8e0',
      
      'M256 256.8l0 63.6C248.5 284 215.3 256 176 256c-44.2 0-80 35.8-80 80s35.8 80 80 80c39.3 0 72.5-28 80-64.4l0 63.6c-20.7 20.3-49.1 32.8-80 32.8c-61.9 0-112-50.1-112-112s50.1-112 112-112c30.9 0 59.3 12.5 80 32.8zM261.5 480c4.2 11.9 10.7 22.8 19 32L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L280.4 0c-8.3 9.2-14.8 20.1-19 32L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l197.5 0zM176 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM152 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L352 32zM288 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-384zm176 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM440 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faFaceVomit = {
    prefix: 'fal',
    iconName: 'face-vomit',
    icon: [
      576,
      512,
      [],
      'e3a0',
      
      'M288 32C164.3 32 64 132.3 64 256c0 57.4 21.6 109.7 57 149.3c5.9 6.6 5.3 16.7-1.3 22.6s-16.7 5.3-22.6-1.3C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c35.5-39.6 57-91.9 57-149.3C512 132.3 411.7 32 288 32zM161.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L203.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L372.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 488a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm520-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm92.5-47.6c8.6-1.9 17.2 3.5 19.1 12.1l6.1 27.4c5.2 23.5 20.8 43.4 42.3 54.2l39.1 19.6c6.6 3.3 10.1 10.8 8.4 18s-8.2 12.3-15.6 12.3l-352 0c-7.4 0-13.9-5.1-15.6-12.3s1.8-14.7 8.4-18L144 462.1c21.5-10.8 37.1-30.7 42.3-54.2l6.1-27.4c1.9-8.6 10.5-14.1 19.1-12.1s14.1 10.5 12.1 19.1l-6.1 27.4c-5.8 26.2-20.8 49.2-41.9 65.1l224.7 0c-21.1-15.9-36.1-38.9-41.9-65.1l-6.1-27.4c-1.9-8.6 3.5-17.2 12.1-19.1zm-189.1 4c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c5.6-19.8 24.1-38.7 48-52.1C217.3 297.6 250 288 288 288s70.7 9.6 95.4 23.5c24 13.5 42.4 32.3 48 52.1c2.4 8.5-2.5 17.3-11 19.8s-17.3-2.5-19.8-11c-2.4-8.3-12.6-21.5-32.9-33C348 328.3 320.7 320 288 320s-60 8.3-79.7 19.4c-20.4 11.5-30.6 24.7-32.9 33z'
      
    ]
  };

  

  
  

  var faHammer = {
    prefix: 'fal',
    iconName: 'hammer',
    icon: [
      576,
      512,
      [128296],
      'f6e3',
      
      'M398.5 206.8c8.6-.1 16.8 3.3 22.9 9.4L472 266.7 514.7 224l-48.3-48.3c-6.5-6.5-9.9-15.4-9.3-24.5c1-17-5.2-34.2-18.5-46.7L394 62.4C373.2 42.9 345.8 32 317.2 32l-18.1 0c-15.7 0-31.2 3.3-45.5 9.7l-17.6 7.8 51.2 27.9C297.6 83 304 93.8 304 105.5l0 12.1c0 12.6 5 24.7 13.9 33.7l38.1 38.1c11.7 11.7 27.1 17.5 42.4 17.4zm138.8-5.4l3.3 3.3 8-8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16-3.3-3.3-50.6-50.6c-23.6 .2-47.3-8.7-65.4-26.7l-38.1-38.1C280.4 159 272 138.8 272 117.6l0-12.1L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0l18.1 0c36.7 0 72 14 98.7 39.1l44.6 42c20.5 19.3 30.1 45.9 28.5 72l48.3 48.3zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l9.7 9.7L47.9 401.7c-10.1 8.4-15.9 20.9-15.9 34C32 460.2 51.8 480 76.3 480c13.1 0 25.6-5.8 34-15.9L305.7 229.6l5.1 5.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z'
      
    ]
  };

  

  
  

  var faPersonPraying = {
    prefix: 'fal',
    iconName: 'person-praying',
    icon: [
      448,
      512,
      [128720,"pray"],
      'f683',
      
      'M256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM200.5 176l.9 0c12.4 0 23.7 7.2 29 18.5l3.1 6.7c-.1 .2-.2 .5-.3 .7L157.1 384.6l-26.7-16.8c-13.1-8.2-18.4-24.6-12.7-39l53.1-132.7c4.9-12.1 16.6-20.1 29.7-20.1zm112 306.5l-128-80.6 67.3-161.5 12.4 26.5c9.2 19.7 34.9 24.7 50.8 9.9l95.9-89.1c6.5-6 6.9-16.1 .8-22.6s-16.1-6.9-22.6-.8l-95.9 89.1-33.8-72.4c-10.5-22.5-33.1-36.9-58-36.9l-.9 0c-26.2 0-49.7 15.9-59.4 40.2L88 316.9c-11.5 28.7-.8 61.5 25.3 77.9L248.6 480 48 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c7.1 0 13.4-4.7 15.4-11.6s-.8-14.2-6.8-18z'
      
    ]
  };

  
    var faPray = faPersonPraying;
  

  
  

  var faCloudsSun = {
    prefix: 'fal',
    iconName: 'clouds-sun',
    icon: [
      640,
      512,
      [],
      'f746',
      
      'M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l10.4 1.7c9.9-11.5 22.5-20.6 36.8-26.3l-30.7-5.1L303.8 13.4zM291.6 217.2c-2.1-7.9-3.3-16.3-3.3-24.9c0-5.7 .5-11.3 1.5-16.7C276.9 143 245.2 120 208 120c-48.6 0-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6c7.3-28.9 24.5-53.9 47.7-71.1zM264 208a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm309.9 47.6c8.2 8 15.2 17.2 20.7 27.4c26.6-10.6 45.4-36.5 45.4-66.9c0-39.8-32.2-72-72-72c-3.2 0-6.4 .2-9.5 .6C551.4 107.9 519 80.1 480 80.1c-34.2 0-63.3 21.4-74.8 51.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c9.9-3.9 20.4-6.7 31.4-8l0-.5 0-.4c0-17.7 14.3-32 32-32c3.8 0 7.3 .6 10.6 1.8c16.4 5.7 34.3-2.6 40.5-18.8c6.9-18.1 24.4-30.9 44.9-30.9c23.3 0 42.8 16.7 47.1 38.7c3.2 16.6 18.8 27.8 35.6 25.6c1.7-.2 3.5-.3 5.3-.3c22.1 0 40 17.9 40 40c0 20.1-14.8 36.7-34.1 39.5zM304 320c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-266.6 0c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1l266.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.9 224 368 224z'
      
    ]
  };

  

  
  

  var faTrophy = {
    prefix: 'fal',
    iconName: 'trophy',
    icon: [
      576,
      512,
      [127942],
      'f091',
      
      'M176 32l224 0c9 0 15.4 7.3 15.1 15c-6.2 163.9-44.9 239.2-76.1 273.5c-15.5 17.1-29.9 24.8-39.3 28.3c-4.8 1.8-8.5 2.6-10.6 3c-.5 .1-.9 .1-1.2 .2c-.3 0-.7-.1-1.2-.2c-2.1-.3-5.8-1.1-10.6-3c-9.4-3.5-23.8-11.3-39.3-28.3C205.8 286.2 167.1 210.9 160.9 47c-.3-7.8 6.2-15 15.1-15zM400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L48 64C22 64-1.3 85.6 1.8 113.7c10.1 94 61.9 158.2 118.1 199.9c55.9 41.4 117.1 61.3 149.3 66.9l.1-.3c.9 .3 1.8 .6 2.7 .8l0 98.9-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-98.9c.9-.3 1.8-.5 2.7-.8l.1 .3c32.2-5.7 93.4-25.5 149.3-66.9c56.3-41.7 108-105.9 118.1-199.9C577.3 85.6 554 64 528 64l-81.6 0c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm44.2 96L528 96c9.3 0 15.2 7.3 14.4 14.3c-8.9 82.9-54.3 139.8-105.4 177.6c-19.6 14.6-40 26.2-59.2 35.3C407 281.9 434.5 212.5 444.2 96zm-246 227.2c-19.2-9.1-39.6-20.7-59.2-35.3C87.9 250.1 42.5 193.2 33.6 110.3C32.8 103.3 38.7 96 48 96l83.8 0c9.8 116.5 37.2 185.9 66.4 227.2z'
      
    ]
  };

  

  
  

  var faWheatSlash = {
    prefix: 'fal',
    iconName: 'wheat-slash',
    icon: [
      640,
      512,
      [],
      'e339',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM523.5 278.5l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-18-18-40-29.5-63.2-34.6l16.9-.8c45.1-2.3 81.2-38.4 83.5-83.5l2.7-54c.7-14.2-11-25.9-25.2-25.2L495.5 4C450.4 6.3 414.3 42.4 412 87.5l-.9 17.7c-4.9-23.5-16.5-46-34.8-64.2L353.8 18.4c-6.2-6.2-16.4-6.2-22.6 0L297.2 52.3C278.5 71 269.2 95.5 269.1 120l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.5 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7zM286.9 311.4l-25.3-20-29 29c1.3-20.6-2.4-41.5-11-60.6l-73.7-58.2-31.6 31.6c-37.5 37.5-37.5 98.3 0 135.8L150.2 403 68.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l81.5-81.5s0 0 0 0l33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.5-98.6-37.2l31.7-31.7zM542.3 33.7L540 78.9c-1.4 28.7-24.4 51.7-53.1 53.1l-45.2 2.3L444 89.1c1.4-28.7 24.4-51.7 53.1-53.1l45.2-2.3zM172.8 380.3l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.2 37.2 37.5 97.4 .8 135l-.8 .8zm147.1 56.5c-25 25-65.5 25-90.5 0L195.4 403c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z'
      
    ]
  };

  

  
  

  var faThumbtack = {
    prefix: 'fal',
    iconName: 'thumbtack',
    icon: [
      384,
      512,
      [128204,128392,"thumb-tack"],
      'f08d',
      
      'M119.9 34.5L107.8 191.4c-.7 9.7-5.9 18.6-13.9 24c-27 18.3-47.3 46.2-55.6 79.6L32 320l144 0 0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96 144 0-6.2-25c-8.3-33.4-28.6-61.3-55.6-79.6c-8.1-5.5-13.2-14.3-13.9-24L264.1 34.5c-.1-.8-.1-1.6-.1-2.5L120 32c0 .8 0 1.6-.1 2.5zM176 352L32 352c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L85.5 64 88 32 64 32c-2.9 0-5.6-.8-7.9-2.1C51.2 27.1 48 21.9 48 16C48 7.2 55.2 0 64 0L88 0 296 0l24 0c8.8 0 16 7.2 16 16c0 5.9-3.2 11.1-8.1 13.9c-2.3 1.3-5 2.1-7.9 2.1l-24 0 2.5 32 9.6 124.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-144 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144z'
      
    ]
  };

  
    var faThumbTack = faThumbtack;
  

  
  

  var faSignatureSlash = {
    prefix: 'fal',
    iconName: 'signature-slash',
    icon: [
      640,
      512,
      [],
      'e3cb',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384L336 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l83.4 0-40.5-32zm85-96l40.5 32 55.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96.2 0zm162 127.9c8-.9 14.2-7.7 14.2-15.9c0-8.8-7.2-16-16-16l-38.6 0 40.4 31.9zM478.3 183.2c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3l-117 31.9L374 217.1l59.7-16.3L411 246.3l25.7 20.3 41.7-83.4zM320 131.4l0-3.4c0-53-43-96-96-96c-22.2 0-42.6 7.5-58.9 20.2l26.3 20.7c9.6-5.7 20.7-8.9 32.6-8.9c35.3 0 64 28.7 64 64l0 3.4c0 5.8-.1 11.7-.4 17.5L318.1 173c1.3-13.8 1.9-27.7 1.9-41.6zM155 243.7c-34.8 9.5-59 41.1-59 77.2l0 92.6c0 36.7 29.8 66.5 66.5 66.5c24 0 46.2-13 57.9-33.9L247.5 398c15.6-27.7 28.7-56.8 39-86.9L259.8 290c-10.2 32-23.7 62.9-40.2 92.3l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6c-19 0-34.5-15.4-34.5-34.5l0-92.6c0-21.6 14.5-40.6 35.4-46.3L220.5 259l-31.2-24.7L155 243.7zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z'
      
    ]
  };

  

  
  

  var faPhoneHangup = {
    prefix: 'fal',
    iconName: 'phone-hangup',
    icon: [
      640,
      512,
      [],
      'e225',
      
      'M320 128C185.6 128 85.9 196.7 38.8 245c-7.2 7.4-8.9 19.3-3.5 30.5l38.3 78.6c3.3 6.7 10.7 10.3 18 8.6l88-20.5c7.2-1.7 12.4-8.1 12.4-15.6l0-86.6c0-7.1 4.7-13.4 11.6-15.4l32.9-9.4c54.6-15.6 112.4-15.6 167 0l32.9 9.4c6.9 2 11.6 8.2 11.6 15.4l0 86.6c0 7.4 5.1 13.9 12.4 15.6l88 20.5c7.3 1.7 14.7-1.9 18-8.6l38.3-78.6c5.5-11.2 3.7-23.2-3.5-30.5C554.1 196.7 454.4 128 320 128zM15.9 222.6C67.2 170.1 174.6 96 320 96s252.8 74.1 304.1 126.6c18.1 18.5 19.8 45.6 9.3 66.9l-38.3 78.6c-9.8 20.1-32.2 30.8-54 25.7l-88-20.5c-21.7-5.1-37.1-24.4-37.1-46.8l0-74.5L394.7 246c-48.8-14-100.6-14-149.4 0L224 252.1l0 74.5c0 22.3-15.4 41.7-37.1 46.8l-88 20.5c-21.8 5.1-44.2-5.6-54-25.7L6.5 289.5c-10.4-21.3-8.7-48.4 9.3-66.9z'
      
    ]
  };

  

  
  

  var faFaceSmile = {
    prefix: 'fal',
    iconName: 'face-smile',
    icon: [
      512,
      512,
      [128578,"smile"],
      'f118',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faSmile = faFaceSmile;
  

  
  

  var faPersonSign = {
    prefix: 'fal',
    iconName: 'person-sign',
    icon: [
      512,
      512,
      [],
      'f757',
      
      'M421.5 1c8.3 3.1 12.5 12.3 9.5 20.5l-7.3 19.8 70.3 25.6c12.5 4.5 18.9 18.3 14.3 30.8L470.1 202.9c-4.5 12.5-18.3 18.9-30.8 14.3l-70.9-25.8L319 325.5c-3.1 8.3-12.3 12.5-20.5 9.5s-12.5-12.3-9.5-20.5l20.5-55.8-33.9-11.3c-18.9-6.3-35.8-17.5-48.9-32.5L208 193.4l0 138.1 41.2 68.6c4.5 7.5 6.8 16 6.8 24.7l0 71.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-71.1c0-2.9-.8-5.7-2.3-8.2L182.9 352 112 352l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160 0-124.2L30.3 311.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L56 188.2C69.6 161.1 97.3 144 127.6 144l43.4 0c23.1 0 45 10 60.2 27.3l19.7 22.5c9.4 10.7 21.4 18.7 34.9 23.2l34.8 11.6 17.7-48.2-64.4-23.4c-12.5-4.5-18.9-18.3-14.3-30.8L297.9 21.1c4.5-12.5 18.3-18.9 30.8-14.3l65 23.7L401 10.5C404 2.2 413.2-2.1 421.5 1zM112 178.6L112 320l64 0 0-143.7c-1.7-.2-3.3-.3-5-.3l-43.4 0c-5.4 0-10.6 .9-15.6 2.6zM144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM325.2 39.5l-32.8 90.2 150.4 54.7 32.8-90.2L325.2 39.5z'
      
    ]
  };

  

  
  

  var faDisplay = {
    prefix: 'fal',
    iconName: 'display',
    icon: [
      576,
      512,
      [],
      'e163',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l167.7 0c.2 0 .4 0 .6 0l111.5 0c.2 0 .4 0 .6 0L512 384c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32L64 32zM213.1 416L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-149.1 0 10.7 64 58.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-72 0-144 0-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.4 0 10.7-64zm32.4 0l-10.7 64 106.2 0-10.7-64-84.9 0z'
      
    ]
  };

  

  
  

  var faCoinVertical = {
    prefix: 'fal',
    iconName: 'coin-vertical',
    icon: [
      384,
      512,
      [],
      'e3fd',
      
      'M256 256c0-66.2-15.2-124.6-38.1-165.3C194.5 49 167.1 32 144 32s-50.5 17-73.9 58.7C47.2 131.4 32 189.8 32 256s15.2 124.6 38.1 165.3C93.5 463 120.9 480 144 480s50.5-17 73.9-58.7C240.8 380.6 256 322.2 256 256zm24.8 80l64.3 0c3.6-20 5.8-41.5 6.6-64l-64 0c-.8 22.2-3.1 43.7-6.9 64zm-7.3 32c-4.7 17.2-10.5 33.2-17.1 48l64.7 0c6.5-14.2 12.3-30.3 17-48l-64.6 0zM213.8 480l42.2 0c12.8 0 29.9-8.5 46.8-32l-63.6 0c-7.8 12.2-16.3 23-25.5 32zm74-240l64 0c-.7-22.5-3-44-6.6-64l-64.3 0c3.8 20.3 6.1 41.8 6.9 64zm-74-208c9.2 9 17.7 19.8 25.5 32l63.6 0c-16.9-23.5-34-32-46.8-32l-42.2 0zm59.8 112l64.6 0c-4.7-17.7-10.5-33.8-17-48l-64.7 0c6.7 14.8 12.4 30.8 17.1 48zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0l32 0 80 0c70.7 0 128 114.6 128 256s-57.3 256-128 256l-80 0-32 0zM88 256c0 47.1 7.4 89.1 18.8 118.7c5.7 14.8 12.2 25.8 18.5 32.7c6.3 6.9 11.3 8.6 14.7 8.6s8.3-1.7 14.7-8.6c6.3-6.9 12.8-17.8 18.5-32.7C184.6 345.1 192 303.1 192 256s-7.4-89.1-18.8-118.7c-5.7-14.8-12.2-25.8-18.5-32.7C148.3 97.7 143.4 96 140 96s-8.3 1.7-14.7 8.6c-6.3 6.9-12.8 17.8-18.5 32.7C95.4 166.9 88 208.9 88 256zM140 64c15.4 0 28.3 8.2 38.3 19c9.9 10.9 18.2 25.7 24.7 42.7c13.2 34.1 21 80.2 21 130.2s-7.8 96.1-21 130.2c-6.6 17-14.8 31.9-24.7 42.7c-9.9 10.9-22.9 19-38.3 19s-28.3-8.2-38.3-19c-9.9-10.9-18.2-25.7-24.7-42.7C63.8 352.1 56 306.1 56 256s7.8-96.1 21-130.2c6.6-17 14.8-31.9 24.7-42.7c9.9-10.9 22.9-19 38.3-19z'
      
    ]
  };

  

  
  

  var faLocationCheck = {
    prefix: 'fal',
    iconName: 'location-check',
    icon: [
      384,
      512,
      ["map-marker-check"],
      'f606',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM283.3 150L176.6 256.6c-6.2 6.2-16.4 6.2-22.6 0l-53.3-53.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l42 42 95.4-95.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faMapMarkerCheck = faLocationCheck;
  

  
  

  var faConveyorBelt = {
    prefix: 'fal',
    iconName: 'conveyor-belt',
    icon: [
      640,
      512,
      [],
      'f46e',
      
      'M464 32c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l64 0 0 112c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3l0-112 64 0zM272 32l96 0 0 80L329.6 83.2c-5.7-4.3-13.5-4.3-19.2 0L272 112l0-80zM176 0c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48L176 0zM608 416c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64s28.7-64 64-64l448 0c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faGlassWaterDroplet = {
    prefix: 'fal',
    iconName: 'glass-water-droplet',
    icon: [
      384,
      512,
      [],
      'e4f5',
      
      'M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7l303.7 0c4.7 0 8.4 4 8 8.7L329.5 305.4l-23.9 12c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3l-24-12L32.1 40.7zm25.4 302l6.6 3.3c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l6.5-3.2-9.1 108C315.8 467.3 302 480 285.4 480L98.6 480c-16.6 0-30.5-12.7-31.9-29.3l-9.1-108zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512l186.8 0c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0L40.1 0zM192 216c-19.6 0-32-14.5-32-28c0 .1 0 .1 0-.1c0 0 0 0 0 0c.1-.6 .6-3.3 2.9-8.8c2.6-6.1 6.5-13.4 11.4-21.3c5.4-8.8 11.6-17.8 17.6-26c6 8.2 12.1 17.1 17.6 26c4.9 8 8.8 15.2 11.4 21.3c2.3 5.5 2.8 8.2 2.9 8.8c0 0 0 0 0 0l0 .1c0 13.5-12.4 28-32 28zm0 32c35.3 0 64-26.9 64-60c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 117.9 128 164 128 188c0 33.1 28.7 60 64 60z'
      
    ]
  };

  

  
  

  var faTruckMoving = {
    prefix: 'fal',
    iconName: 'truck-moving',
    icon: [
      640,
      512,
      [],
      'f4df',
      
      'M72 64c-22.1 0-40 17.9-40 40l0 200 0 32c13.4-10 30-16 48-16c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48L448 368l0-112 0-32 0-120c0-22.1-17.9-40-40-40L72 64zM480 336c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9l0-56 0-48-128 0 0 80zm0-176l0 64 112 0-43.2-57.6c-3-4-7.8-6.4-12.8-6.4l-56 0zm160 90.7l0 5.3 0 48 0 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80l-160 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80l0-32 0-64L0 104C0 64.2 32.2 32 72 32l336 0c39.8 0 72 32.2 72 72l0 24 56 0c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fal',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faHandMiddleFinger = {
    prefix: 'fal',
    iconName: 'hand-middle-finger',
    icon: [
      448,
      512,
      [128405],
      'f806',
      
      'M224 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 170.7c0 5.2 2.5 10.1 6.8 13.1s9.7 3.8 14.6 2c3.3-1.2 6.9-1.8 10.7-1.8c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32l0 88 0 8c0 44.2-35.8 80-80 80l-135.7 0c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C86.6 442.6 64 404.7 64 363.5L64 344c0-15.1 7.1-29.3 19.2-38.4l22.5-16.9c2-1.5 4.1-3 6.3-4.4l0 59.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-.9-.1-1.9-.2-2.8c.2-.9 .2-1.8 .2-2.8l0-2.4c0-17.7 14.3-32 32-32c8.2 0 15.7 3.1 21.3 8.1c4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6L224 56zM248 0c-30.9 0-56 25.1-56 56l0 138c-5.1-1.3-10.5-2-16-2c-32.5 0-59.3 24.2-63.4 55.6c-9.1 4.2-17.8 9.4-26 15.5L64 280c-20.1 15.1-32 38.8-32 64l0 19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2L320 512c61.9 0 112-50.1 112-112l0-8 0-88c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5l0-152c0-30.9-25.1-56-56-56z'
      
    ]
  };

  

  
  

  var faBrightnessLow = {
    prefix: 'fal',
    iconName: 'brightness-low',
    icon: [
      512,
      512,
      [],
      'e0ca',
      
      'M280 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM432 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96-128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM408 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm0-256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 384a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z'
      
    ]
  };

  

  
  

  var faGaugeCircleMinus = {
    prefix: 'fal',
    iconName: 'gauge-circle-minus',
    icon: [
      640,
      512,
      [],
      'e497',
      
      'M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18.1 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCarTilt = {
    prefix: 'fal',
    iconName: 'car-tilt',
    icon: [
      640,
      512,
      [],
      'f5e5',
      
      'M131.7 88.2L304.3 41.9c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6 .5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8C39.5 271.5 30.2 304.8 39 337.6l22 82.1L65.3 436s0 0 0 0l11.8 44L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-515.4 0-10-37.2 1.5-.4L508.7 332.9l1.5-.4L522 376.6c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4L384.8 46.2C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9L60.9 243.3zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zM420.4 262a22.8 22.8 0 1 0 -11.8-44.1A22.8 22.8 0 1 0 420.4 262z'
      
    ]
  };

  

  
  

  var faVrCardboard = {
    prefix: 'fal',
    iconName: 'vr-cardboard',
    icon: [
      640,
      512,
      [],
      'f729',
      
      'M576 96L64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l136.4 0c12.1 0 23.2-6.8 28.6-17.7L268.2 320c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l-21.5 10.7L371.8 320l39.2 78.3c5.4 10.8 16.5 17.7 28.6 17.7L576 416c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-136.4 0c-24.2 0-46.4-13.7-57.2-35.4l-39.2-78.3c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-39.2 78.3c-10.8 21.7-33 35.4-57.2 35.4L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64zM176 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm336 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faShieldMinus = {
    prefix: 'fal',
    iconName: 'shield-minus',
    icon: [
      512,
      512,
      [],
      'e249',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  

  
  

  var faThermometer = {
    prefix: 'fal',
    iconName: 'thermometer',
    icon: [
      512,
      512,
      [],
      'f491',
      
      'M352.8 53.8L310.6 96l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 118.6 246.6 160l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 182.6 224l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 246.6l-22.6 22.6c-6 6-9.4 14.1-9.4 22.6l0 92.1 92.1 0c8.5 0 16.6-3.4 22.6-9.4L458.2 159.2c14-14 21.8-32.9 21.8-52.7C480 65.4 446.6 32 405.5 32c-19.8 0-38.7 7.8-52.7 21.8zM276.7 84.7l53.5-53.5c20-20 47.1-31.2 75.3-31.2C464.3 0 512 47.7 512 106.5c0 28.2-11.2 55.3-31.2 75.3L265.4 397.3c-12 12-28.3 18.7-45.3 18.7l-101.5 0L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L96 393.4l0-101.5c0-17 6.7-33.3 18.7-45.3l33.9-33.9 64-64 64-64s0 0 0 0s0 0 0 0z'
      
    ]
  };

  

  
  

  var faCloudMinus = {
    prefix: 'fal',
    iconName: 'cloud-minus',
    icon: [
      640,
      512,
      [],
      'e35d',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM224 272l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTrafficLight = {
    prefix: 'fal',
    iconName: 'traffic-light',
    icon: [
      320,
      512,
      [128678],
      'f637',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 70.7 57.3 128 128 128s128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faCloudMusic = {
    prefix: 'fal',
    iconName: 'cloud-music',
    icon: [
      640,
      512,
      [],
      'f8ae',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM409.1 186.8c4.3 3 6.9 7.9 6.9 13.2l0 128c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5l0-67.4-96 36L288 360c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5l0-74.5c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8zM384 332c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12zM256 364c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12z'
      
    ]
  };

  

  
  

  var faDownToDottedLine = {
    prefix: 'fal',
    iconName: 'down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e408',
      
      'M222.2 351.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 219.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L288 208c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 351.2zM224 384c-9.5 0-18.6-3.9-25.1-10.8L74.5 241.2C67.8 234 64 224.5 64 214.7c0-21.4 17.3-38.7 38.7-38.7l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 373.1c-6.5 6.9-15.6 10.8-25.1 10.8zm192 44a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 428a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm312 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 428a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-72 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  

  
  

  var faFaceExpressionless = {
    prefix: 'fal',
    iconName: 'face-expressionless',
    icon: [
      512,
      512,
      [],
      'e373',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 80l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm176-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBabyCarriage = {
    prefix: 'fal',
    iconName: 'baby-carriage',
    icon: [
      512,
      512,
      ["carriage-baby"],
      'f77d',
      
      'M.7 224c-.2-2.9-.4-5.7-.5-8.6C0 212.9 0 210.5 0 208l0-16 .1 0C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192l8 0s0 0 0 0l152 0 0-48c0-26.5 21.5-48 48-48l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 48 0 16 0 8-.2 0c-.1 2.7-.3 5.3-.5 8c-1.8 22.2-7.5 44-16.8 64.5c-11.5 25.4-28.2 48.3-49.2 67.5c-20.9 19.2-45.6 34.2-72.6 44.5S253 416 224 416s-57.9-5.2-84.8-15.5s-51.6-25.3-72.6-44.5C45.7 336.9 28.9 314 17.5 288.5C8.2 268 2.5 246.2 .7 224zm216.4-32L113.7 42.8C66.3 76.2 34.7 130.4 32.2 192l184.9 0zM32.8 224c1.8 17.6 6.4 34.9 13.8 51.4c9.6 21.4 23.8 40.8 41.6 57.1s39 29.3 62.3 38.2s48.3 13.4 73.5 13.4s50.2-4.6 73.5-13.4s44.5-21.8 62.3-38.2s32-35.7 41.6-57.1c7.4-16.4 12.1-33.7 13.8-51.4L256 224l-.2 0-223 0zM80 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm304 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faCarriageBaby = faBabyCarriage;
  

  
  

  var faRadio = {
    prefix: 'fal',
    iconName: 'radio',
    icon: [
      512,
      512,
      [128251],
      'f8d7',
      
      'M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6s-11-13.6-19.6-11.3L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66C.3 185.2 0 188.5 0 192l0 1.2L0 240 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-309.9 0 362-96.5zM32 193.2c0-2.2 .1-4.3 .4-6.4C34.9 171.6 48.1 160 64 160l384 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-208 0-46.8zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM80 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 304zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm256 16a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z'
      
    ]
  };

  

  
  

  var faEllipsisStroke = {
    prefix: 'fal',
    iconName: 'ellipsis-stroke',
    icon: [
      512,
      512,
      ["ellipsis-h-alt"],
      'f39b',
      
      'M416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM256 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM128 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-96 0a64 64 0 1 0 128 0A64 64 0 1 0 32 256z'
      
    ]
  };

  
    var faEllipsisHAlt = faEllipsisStroke;
  

  
  

  var faBatteryQuarter = {
    prefix: 'fal',
    iconName: 'battery-quarter',
    icon: [
      576,
      512,
      ["battery-2"],
      'f243',
      
      'M432 128c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 384c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l352 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80L80 96zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM112 192l32 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM64 208l0 96c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery2 = faBatteryQuarter;
  

  
  

  var faVideoSlash = {
    prefix: 'fal',
    iconName: 'video-slash',
    icon: [
      640,
      512,
      [],
      'f4e2',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM416 175.2l0-47.2c0-35.3-28.7-64-64-64L180.1 64l40.5 32L352 96c17.7 0 32 14.3 32 32l0 97 32 25.3 0-75zM64 384l0-248.6L34.1 111.8C32.7 117 32 122.4 32 128l0 256c0 35.3 28.7 64 64 64l256 0c26.4 0 49-16 58.8-38.8l-27.1-21.4C381.8 403.7 368.4 416 352 416L96 416c-17.7 0-32-14.3-32-32zM576 134.2l0 242.4 26.5 20.9c3.5-5.8 5.5-12.5 5.5-19.7l0-243.6c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L448 157.6l0 36.5 118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2z'
      
    ]
  };

  

  
  

  var faFrame = {
    prefix: 'fal',
    iconName: 'frame',
    icon: [
      448,
      512,
      [],
      'e495',
      
      'M448 112c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L96 96l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 256-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 256 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-256 48 0c8.8 0 16-7.2 16-16zM96 384l0-256 256 0 0 256L96 384z'
      
    ]
  };

  

  
  

  var faComputerClassic = {
    prefix: 'fal',
    iconName: 'computer-classic',
    icon: [
      448,
      512,
      [],
      'f8b1',
      
      'M384 32c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 400c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM64 0C28.7 0 0 28.7 0 64L0 368c0 23.7 12.9 44.4 32 55.4L32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-56.6c19.1-11.1 32-31.7 32-55.4l0-304c0-35.3-28.7-64-64-64L64 0zm0 432l320 0 0 48L64 480l0-48zM352 96l0 128L96 224 96 96l256 0zM96 64C78.3 64 64 78.3 64 96l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 64zM224 336c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zM96 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPumpSoap = {
    prefix: 'fal',
    iconName: 'pump-soap',
    icon: [
      448,
      512,
      [],
      'e06b',
      
      'M128 48c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l76.1 0c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L354.7 89.4c-6-6-14.1-9.4-22.6-9.4L256 80l0 48-32 0 0-80c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 80-32 0 0-80zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480l186.4 0c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3l-149.1 0c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7l149.1 0c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3L98.8 512c-37.4 0-66.9-32-63.8-69.3l18.7-224zM156.2 345.1c-2.7 5.3-4.2 11.2-4.2 17.2c0 20.8 16.9 37.7 37.7 37.7l4.7 0c20.8 0 37.7-16.9 37.7-37.7c0-6-1.4-11.9-4.2-17.2L192 275.4l-35.8 69.7zM192 240c10.9 0 20.9 6.1 25.9 15.8l38.4 74.7c5.1 9.9 7.7 20.8 7.7 31.9c0 38.5-31.2 69.7-69.7 69.7l-4.7 0c-38.5 0-69.7-31.2-69.7-69.7c0-11.1 2.6-22 7.7-31.9l38.4-74.7c5-9.7 15-15.8 25.9-15.8z'
      
    ]
  };

  

  
  

  var faCarRear = {
    prefix: 'fal',
    iconName: 'car-rear',
    icon: [
      512,
      512,
      ["car-alt"],
      'f5de',
      
      'M159.6 64l192.8 0c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6L96 192c-3.6 0-7.2 .2-10.7 .6l28.3-94.4c6.1-20.3 24.8-34.2 46-34.2zM74.7 227.9l.1-.3c6.6-2.3 13.8-3.6 21.2-3.6l320 0c7.4 0 14.5 1.3 21.2 3.6l.1 .3 .5-.1c24.6 8.9 42.3 32.5 42.3 60.2l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32c0 17.7-14.3 32-32 32l-96 0 0-32c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 32-96 0c-17.7 0-32-14.3-32-32l0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c0-27.7 17.6-51.3 42.3-60.2l.5 .1zM320 384l-128 0 0-32 128 0 0 32zM48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288l0 64c0 23.7 12.9 44.4 32 55.4L32 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 384 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-56.6c19.1-11.1 32-31.7 32-55.4l0-64c0-35.7-19.4-66.8-48.3-83.3l-.4-1.3L429 89c-10.2-33.8-41.3-57-76.6-57L159.6 32C124.3 32 93.1 55.2 83 89L48.7 203.4z'
      
    ]
  };

  
    var faCarAlt = faCarRear;
  

  
  

  var faRetweet = {
    prefix: 'fal',
    iconName: 'retweet',
    icon: [
      576,
      512,
      [],
      'f079',
      
      'M96 103.9L146.5 160 45.5 160 96 103.9zm88 60.5c0-6.8-2.5-13.4-7.1-18.4l-69-76.7c-3-3.4-7.4-5.3-11.9-5.3s-8.9 1.9-11.9 5.3L15.1 146C10.5 151.1 8 157.6 8 164.4C8 179.7 20.3 192 35.6 192L80 192l0 144c0 44.2 35.8 80 80 80l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0c-26.5 0-48-21.5-48-48l0-144 44.4 0c15.2 0 27.6-12.3 27.6-27.6zM480 408.1L429.5 352l100.9 0L480 408.1zm-88-60.5c0 6.8 2.5 13.4 7.1 18.4l69 76.7c3 3.4 7.4 5.3 11.9 5.3s8.9-1.9 11.9-5.3l69-76.7c4.6-5.1 7.1-11.6 7.1-18.4c0-15.2-12.3-27.6-27.6-27.6L496 320l0-144c0-44.2-35.8-80-80-80L272 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0c26.5 0 48 21.5 48 48l0 144-44.4 0c-15.2 0-27.6 12.3-27.6 27.6z'
      
    ]
  };

  

  
  

  var faClockFive = {
    prefix: 'fal',
    iconName: 'clock-five',
    icon: [
      512,
      512,
      [],
      'e349',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 139.2 61.3 92c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-64-96c-1.8-2.6-2.7-5.7-2.7-8.9l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSignalWeak = {
    prefix: 'fal',
    iconName: 'signal-weak',
    icon: [
      640,
      512,
      ["signal-1"],
      'f68c',
      
      'M64 384c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faSignal1 = faSignalWeak;
  

  
  

  var faChevronRight = {
    prefix: 'fal',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z'
      
    ]
  };

  

  
  

  var faGenderless = {
    prefix: 'fal',
    iconName: 'genderless',
    icon: [
      384,
      512,
      [],
      'f22d',
      
      'M192 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faBriefcaseMedical = {
    prefix: 'fal',
    iconName: 'briefcase-medical',
    icon: [
      512,
      512,
      [],
      'f469',
      
      'M176 32l160 0c8.8 0 16 7.2 16 16l0 48L160 96l0-48c0-8.8 7.2-16 16-16zM128 48l0 48L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-48c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zm16 80l224 0 80 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l80 0zm96 48c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  

  
  

  var faTurntable = {
    prefix: 'fal',
    iconName: 'turntable',
    icon: [
      576,
      512,
      [],
      'f8e4',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm160 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 17.4L480 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176.5c-16 1.4-30.9 10.8-38.6 26.2l-16 32c-11.8 23.6-2.2 52.2 21.3 64s52.2 2.2 64-21.3l16-32c10.6-21.2 3.9-46.5-14.6-59.9zM452.3 320c2.3 0 4.6 .6 6.8 1.7c7.9 4 11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c2.7-5.5 8.2-8.7 14-8.8l.7 0z'
      
    ]
  };

  

  
  

  var faPersonToDoor = {
    prefix: 'fal',
    iconName: 'person-to-door',
    icon: [
      576,
      512,
      [58704],
      'e433',
      
      'M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM179.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L224.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L298 253.2c5.9 20.6 24.7 34.8 46.2 34.8l55.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.9 0c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L218.3 302.4 190.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1L101.3 384 16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.3 0c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM528 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-146.7c-5 1.8-10.4 2.7-16 2.7l-16 0 0 144c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L432 0c-26.5 0-48 21.5-48 48l0 176 16 0c5.6 0 11 1 16 2.7L416 48c0-8.8 7.2-16 16-16l96 0z'
      
    ]
  };

  

  
  

  var faDisease = {
    prefix: 'fal',
    iconName: 'disease',
    icon: [
      512,
      512,
      [],
      'f7fa',
      
      'M64.1 280.3c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3l-10 0c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42zM253.6 93.2c-28.3 42.4-78.9 64.3-129.2 56l-59.6-9.9c-17.2-2.9-32.8 10.4-32.8 27.8c0 7.5 3 14.6 8.3 19.9l29.2 29.2c17 17 26.6 40.1 26.6 64.1c0 24.4-9.8 47.8-27.3 64.8L55.7 357.9c-4.9 4.8-7.7 11.4-7.7 18.3c0 16.4 15.1 28.5 31.1 25l62.3-13.8c10-2.2 20.3-3.4 30.5-3.4l10 0c34.5 0 68 11.7 94.9 33.3L307.8 442c4.8 3.9 10.8 6 17 6c15.1 0 27.3-12.2 27.3-27.3l0-25.2c0-48.1 29.5-91.2 74.3-108.6l36.9-14.3c10.1-3.9 16.8-13.7 16.8-24.5c0-12.7-9.1-23.6-21.6-25.9l-28-5.1c-49.1-9-88.1-46.4-99-95.2l-7.1-31.5C320.9 75 307.2 64 291.3 64c-11.3 0-21.9 5.7-28.2 15.1l-9.4 14.1zM304 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM136 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faNotdef = {
    prefix: 'fal',
    iconName: 'notdef',
    icon: [
      384,
      512,
      [],
      'e1fe',
      
      'M32 452.5L172.3 256 32 59.5l0 392.9zM51.7 480l280.7 0L192 283.5 51.7 480zm160-224L352 452.5l0-392.9L211.7 256zM332.3 32L51.7 32 192 228.5 332.3 32zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z'
      
    ]
  };

  

  
  

  var faTrashCanUndo = {
    prefix: 'fal',
    iconName: 'trash-can-undo',
    icon: [
      448,
      512,
      ["trash-can-arrow-turn-left","trash-undo-alt"],
      'f896',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm155.9 93.3c5.9 6.6 5.4 16.7-1.2 22.6l-49 44.1 70.3 0c44.2 0 80 35.8 80 80l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40c0-26.5-21.5-48-48-48l-70.3 0 49 44.1c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-80-72c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l80-72c6.6-5.9 16.7-5.4 22.6 1.2z'
      
    ]
  };

  
    var faTrashCanArrowTurnLeft = faTrashCanUndo;
  
    var faTrashUndoAlt = faTrashCanUndo;
  

  
  

  var faFilterSlash = {
    prefix: 'fal',
    iconName: 'filter-slash',
    icon: [
      640,
      512,
      [],
      'e17d',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm541 93.3c5.9-7.1 9.1-16 9.1-25.2C576 49.7 558.3 32 536.5 32L139.6 32l40.5 32 356.4 0c4.2 0 7.5 3.4 7.5 7.5c0 1.8-.6 3.4-1.7 4.8l-137 165.5 25.1 19.8L566.9 96.7zM352 362.8l0 83.3c0 1-.8 1.9-1.9 1.9c-.4 0-.8-.1-1.1-.4l-61-47.4 0-87.9L256 287l0 113.2c0 9.9 4.6 19.2 12.4 25.3l61 47.4c5.9 4.6 13.3 7.1 20.8 7.1c18.7 0 33.9-15.2 33.9-33.9l0-58.1-32-25.3z'
      
    ]
  };

  

  
  

  var faTablePivot = {
    prefix: 'fal',
    iconName: 'table-pivot',
    icon: [
      512,
      512,
      [],
      'e291',
      
      'M160 64l0 96 320 0 0-64c0-17.7-14.3-32-32-32L160 64zm0 128l0 256 288 0c17.7 0 32-14.3 32-32l0-224-320 0zM128 64L64 64C46.3 64 32 78.3 32 96l0 64 96 0 0-96zM32 416c0 17.7 14.3 32 32 32l64 0 0-256-96 0 0 224zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM446.8 278.1c-2.5 6-8.3 9.9-14.8 9.9l-16 0 0 48c0 26.5-21.5 48-48 48l-48 0 0 16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 16 48 0c8.8 0 16-7.2 16-16l0-48-16 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z'
      
    ]
  };

  

  
  

  var faHandLizard = {
    prefix: 'fal',
    iconName: 'hand-lizard',
    icon: [
      512,
      512,
      [],
      'f258',
      
      'M0 120C0 89.1 25.1 64 56 64l230.6 0c36.2 0 70.1 17.5 91.1 46.9L491.1 269.7c13.6 19 20.9 41.8 20.9 65.1l0 97.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-97.2c0-16.7-5.2-32.9-14.9-46.5L351.7 129.5c-15-21-39.3-33.5-65.1-33.5L56 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0c3.2 0 6.2 .9 8.9 2.7l96 64c4.4 3 7.1 8 7.1 13.3l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-23.4L267.2 352 120 352c-30.9 0-56-25.1-56-56s25.1-56 56-56l136 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L56 176c-30.9 0-56-25.1-56-56z'
      
    ]
  };

  

  
  

  var faMoneyBillSimple = {
    prefix: 'fal',
    iconName: 'money-bill-simple',
    icon: [
      576,
      512,
      [],
      'e1f1',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faClouds = {
    prefix: 'fal',
    iconName: 'clouds',
    icon: [
      640,
      512,
      [],
      'f744',
      
      'M208 32c39.9 0 73 29.2 79 67.4c.9 5.6 4.7 10.3 9.9 12.4s11.2 1.2 15.7-2.3C323.5 101 337.1 96 352 96c35.3 0 64 28.7 64 64c0 14.7-5 28.3-13.3 39.1l.9 .8c12.2-4.5 25.3-7.2 39-7.8c3.6-10 5.5-20.8 5.5-32.1c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96l64.9 0c1.2-11.1 3.7-21.8 7.3-32L96 256c-35.3 0-64-28.7-64-64s28.7-64 64-64c4.4 0 8.7 .4 12.8 1.3c4.8 1 9.7-.3 13.4-3.4s5.9-7.7 5.8-12.6c0-.4 0-.9 0-1.3c0-44.2 35.8-80 80-80zm16 272c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM640 408c0-55.2-43-100.3-97.3-103.8C535.2 258.7 495.6 224 448 224c-19.3 0-37.3 5.7-52.4 15.5C375.3 210.8 341.9 192 304 192c-61.9 0-112 50.1-112 112c0 2.6 .1 5.3 .3 7.9C154.6 327.5 128 364.6 128 408c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104z'
      
    ]
  };

  

  
  

  var faBacteria = {
    prefix: 'fal',
    iconName: 'bacteria',
    icon: [
      640,
      512,
      [],
      'e059',
      
      'M310.4 1.3c8.1 3.5 11.8 12.9 8.3 21.1L314 33.1C329.7 41 342.7 53.8 350.9 70l10.7-4.7c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c1.7 20.2-4 39.8-15.3 55.6l6 3.7c7.5 4.7 9.8 14.5 5.2 22s-14.5 9.8-22 5.2l-13.3-8.2c-7.6 4.7-16.2 8.3-25.4 10.5c-6.8 1.6-13.2 3.4-19.1 5.4l3.8 17.3c1.9 8.6-3.5 17.2-12.1 19.1s-17.2-3.5-19.1-12.1L246 208.8c-19.4 11.6-31.2 25.3-38.8 37.2l7.6 3.6c8 3.8 11.4 13.3 7.6 21.3s-13.3 11.4-21.3 7.6l-7.4-3.5c-1 3.3-1.7 6.7-2.3 10.1c-1.5 14.1-6.5 27.1-14 38.1L187.6 334c6.1 6.4 5.8 16.6-.6 22.6s-16.6 5.8-22.6-.6l-9.6-10.2c-15.3 10.2-34 15.6-53.7 13.9l-6.4 14.7c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1L70 350.9c-16-8.1-28.9-21.1-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1L24.3 283c-.4-4.8-.4-9.6 .1-14.6c1.1-12.1 3.8-24.2 7-35.9c.2-.9 .5-1.7 .7-2.6l-15.2-7.6c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l11.6 5.8c4.8-11.7 11-24.2 18.8-37.2c1.9-3.2 3.9-6.4 6.1-9.6l-5.1-3.8c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2l5 3.7c10.9-13.1 23.5-25.8 38.1-37.8L114.4 72.4c-4.6-7.5-2.3-17.4 5.2-22s17.4-2.3 22 5.2l9 14.7c14.5-9.4 30.6-18 48.3-25.5l-3.6-8.5c-3.5-8.1 .3-17.5 8.4-21s17.5 .3 21 8.4L229 33.8c9-2.8 18.3-5.4 28.1-7.6c8.7-2 17.4-2.6 25.8-1.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3zM192 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm31.7 81.6c.1-.5 .1-.9 .2-1.4c2.8-18.2 10.3-34.8 18.2-48c16-26.7 46.7-59.1 109.6-73.6c28-6.5 45.4-34.4 39-62.4s-34.4-45.4-62.4-39c-93.1 21.5-146.4 73-175.4 121.4C74.8 202.3 66.7 224.5 62.2 241c-2.9 10.6-5.1 20.8-6 30.3c-2.6 28.6 18.5 53.8 47.1 56.4c28.3 2.6 53.3-18 56.4-46.1zm161.6 208l4.7-10.7c-15.6-7.9-28.7-20.7-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1l14.7-6.4c-1.7-20.2 4-39.8 15.3-55.6l-6-3.7c-7.5-4.6-9.8-14.5-5.2-22s14.5-9.8 22-5.2l13.3 8.2c7.6-4.7 16.2-8.3 25.4-10.5c6.8-1.6 13.2-3.4 19.1-5.4l-3.8-17.3c-1.9-8.6 3.5-17.2 12.1-19.1s17.2 3.5 19.1 12.1l2.4 10.7c19.4-11.6 31.2-25.3 38.8-37.2l-7.6-3.6c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6l7.4 3.5c1-3.3 1.7-6.7 2.3-10.1c1.5-14.1 6.5-27.1 14-38.1L452.4 178c-6.1-6.4-5.8-16.6 .6-22.6s16.6-5.8 22.6 .6l9.6 10.2c15.3-10.2 34-15.6 53.7-13.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3s11.8 12.9 8.3 21.1L570 161.1c16 8.1 28.9 21.1 36.9 36.9l10.7-4.7c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c.4 4.8 .4 9.6-.1 14.6c-1.1 12.1-3.8 24.2-7 35.9c-.2 .9-.5 1.7-.7 2.6l15.2 7.6c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-11.6-5.8c-4.8 11.7-11 24.2-18.8 37.2c-1.9 3.2-3.9 6.4-6.1 9.6l5.1 3.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-5-3.7c-10.9 13.1-23.5 25.8-38.1 37.8l10.3 16.8c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2l-9-14.7c-14.5 9.4-30.6 18-48.3 25.5l3.6 8.5c3.5 8.1-.3 17.5-8.4 21s-17.5-.3-21-8.4L411 478.2c-9 2.8-18.3 5.4-28.1 7.6c-8.7 2-17.4 2.6-25.8 1.9l-6.4 14.6c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1zM416 408a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm64.3-177.6c0 .5-.1 .9-.2 1.4c-2.8 18.2-10.3 34.8-18.2 48c-16 26.7-46.7 59.1-109.6 73.6c-28 6.5-45.4 34.4-39 62.4s34.4 45.4 62.4 39c93.1-21.5 146.4-73 175.4-121.4c14.2-23.6 22.2-45.8 26.7-62.3c2.9-10.6 5.1-20.8 6-30.3c2.6-28.6-18.5-53.8-47.1-56.4c-28.3-2.6-53.3 18-56.4 46.1z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fal',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z'
      
    ]
  };

  

  
  

  var faArrowLeftToArc = {
    prefix: 'fal',
    iconName: 'arrow-left-to-arc',
    icon: [
      512,
      512,
      [],
      'e616',
      
      'M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM309.4 116l-144 128c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L218.1 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-277.9 0L330.6 140c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z'
      
    ]
  };

  

  
  

  var faNose = {
    prefix: 'fal',
    iconName: 'nose',
    icon: [
      448,
      512,
      [],
      'e5bd',
      
      'M190.2 8.6c-4.1-7.8-13.7-10.9-21.6-6.8s-10.9 13.7-6.8 21.6c74 142.4 171.9 248.6 223.7 299.3c19.1 18.7 30.5 43.7 30.5 69.6c0 48.5-39.3 87.7-87.7 87.7l-34 0-2.3-2.6-38.7-43.5c-19.1-21.5-46.5-33.8-75.3-33.8c-27.6 0-49.9 22.3-49.9 49.9l0 6.1c0 30.9 25.1 56 56 56l144.3 0C394.4 512 448 458.4 448 392.3c0-35.3-15.5-68.3-40.1-92.4c-50.5-49.5-145.8-153-217.7-291.2zm39.1 446.5L251.5 480 184 480c-13.3 0-24-10.7-24-24l0-6.1c0-9.9 8-17.9 17.9-17.9c19.7 0 38.4 8.4 51.4 23.1zm-98-151.4c8.6-1.9 14.1-10.4 12.3-19s-10.4-14.1-19-12.3l-22.8 4.9C42.4 290 0 342.4 0 403.2c0 38.2 17 74.5 46.3 98.9l7.4 6.2c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5l-7.4-6.2C44.8 459.1 32 431.9 32 403.2c0-45.6 31.9-85.1 76.5-94.6l22.8-4.9z'
      
    ]
  };

  

  
  

  var faHollyBerry = {
    prefix: 'fal',
    iconName: 'holly-berry',
    icon: [
      512,
      512,
      [],
      'f7aa',
      
      'M288 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 0a64 64 0 1 0 0 128A64 64 0 1 0 256 0zM128 289.3l0-20.9 2.3 .8c24 8 49.8 8.7 74.2 2.1l5.9-1.6-1.6 5.9c-6.6 24.4-5.9 50.2 2.1 74.2l1 2.9C164.6 358 128 398.1 128 446.7l0 20.9-2.3-.8c-24-8-49.8-8.7-74.2-2.1l-5.9 1.6 1.6-5.9c6.6-24.4 5.9-50.2-2.1-74.2l-1-2.9C91.4 378 128 337.9 128 289.3zM115.6 497.2l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8l0-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3c-15.5-5.2-31.6 6.4-31.6 22.8l0 32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4c-4.9 17.9 11.6 34.4 29.5 29.5L60 495.6c18.3-5 37.6-4.5 55.6 1.5zm46-415.6c-28.4 6.5-49.6 32-49.6 62.4c0 35.3 28.7 64 64 64c30.4 0 55.8-21.2 62.4-49.6c-10.9-2-21.2-5.9-30.5-11.3C206.3 163.3 192.6 176 176 176c-17.7 0-32-14.3-32-32c0-16.6 12.7-30.3 28.9-31.9c-5.4-9.3-9.3-19.6-11.3-30.5zm112 76.8c6.5 28.4 32 49.6 62.4 49.6c35.3 0 64-28.7 64-64c0-30.4-21.2-55.8-49.6-62.4c-2 10.9-5.9 21.2-11.3 30.5c16.2 1.5 28.9 15.2 28.9 31.9c0 17.7-14.3 32-32 32c-16.6 0-30.3-12.7-31.9-28.9c-9.3 5.4-19.6 9.3-30.5 11.3zM384 289.3c0 48.6 36.6 88.7 83.8 94.1l-1 2.9c-8 24-8.7 49.8-2.1 74.2l1.6 5.9-5.9-1.6c-24.4-6.6-50.2-5.9-74.2 2.1l-2.3 .8 0-20.9c0-48.6-36.6-88.7-83.8-94.1l1-2.9c8-24 8.7-49.8 2.1-74.2l-1.6-5.9 5.9 1.6c24.4 6.6 50.2 5.9 74.2-2.1l2.3-.8 0 20.9zm12.4 207.9c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.7 452c-5-18.3-4.5-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7l0-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-19.4-5.3c-17.9-4.9-34.4 11.6-29.5 29.5l5.3 19.4c5 18.3 4.4 37.6-1.5 55.6l-4.3 12.8c-5.2 15.5 6.4 31.6 22.8 31.6c34.6 0 62.7 28.1 62.7 62.7l0 32c0 16.4 16 27.9 31.6 22.8l12.8-4.3z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fal',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 320c0-70.7-57.3-128-128-128l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c53 0 96 43 96 96c0 24.2-8.9 46.3-23.7 63.1L609.5 403c19-22.3 30.5-51.3 30.5-83zM459.9 448l-40.5-32-83.5 0c-52.9 0-95.9-42.9-95.9-95.9c0-13.9 3-27.2 8.4-39.2l-25.7-20.3c-9.4 17.8-14.6 38.1-14.6 59.5C208 390.8 265.2 448 335.9 448l124.1 0zM400 191.9c0 13.9-3 27.2-8.4 39.2l25.7 20.3c9.4-17.8 14.6-38.1 14.6-59.5C432 121.2 374.8 64 304.1 64L180.1 64l40.5 32 83.5 0c52.9 0 95.9 42.9 95.9 95.9zm-344.3-63L30.5 109C11.5 131.4 0 160.3 0 192c0 70.7 57.3 128 128 128l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-53 0-96-43-96-96c0-24.2 8.9-46.3 23.7-63.1z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faDrumstickBite = {
    prefix: 'fal',
    iconName: 'drumstick-bite',
    icon: [
      512,
      512,
      [],
      'f6d7',
      
      'M192 272c0 26.5 21.5 48 48 48l88.2 0c-5.3-15-8.2-31.2-8.2-48c0-79.5 64.5-144 144-144c2.6 0 5.3 .1 7.9 .2C452.2 72.2 398.8 32 336 32c-79.5 0-144 64.5-144 144l0 96zm-32 0l0-96C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1l-96 0c-3 0-6-.2-8.9-.5L192 390.6s0 0 0 0c0 0 0 0 0 .1c0 .1-.1 .5-.1 1.2c.1 1.5 .7 3.5 2 5.2c8.9 12 14.2 26.9 14.2 42.9c0 39.8-32.2 72-72 72c-37.2 0-67.8-28.2-71.6-64.4C28.2 443.8 0 413.2 0 376c0-39.8 32.2-72 72-72c16.1 0 30.9 5.3 42.9 14.2c1.7 1.2 3.7 1.9 5.2 2c.7 0 1.1-.1 1.2-.1c0 0 0 0 .1 0l39.1-39.1c-.3-2.9-.5-5.9-.5-8.9zm12.2 42.4L144 342.7c-15 15-36.5 9.9-48.1 1.2C89.2 338.9 81 336 72 336c-22.1 0-40 17.9-40 40s17.9 40 40 40c13.1 0 24 10.9 24 24c0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.8c-8.7-11.7-13.7-33.2 1.2-48.1l28.2-28.2c-10.3-6.4-18.9-15.1-25.4-25.4z'
      
    ]
  };

  

  
  

  var faDinosaur = {
    prefix: 'fal',
    iconName: 'dinosaur',
    icon: [
      640,
      512,
      [],
      'e5fe',
      
      'M417.6 19.2C426.7 7.1 440.9 0 456 0l13 0C563.5 0 640 76.5 640 170.9l0 50.9c0 76.5-39.4 147.6-104.3 188.2L512 424.9l0 39.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-11c-3.5 .9-7.5 1.8-11.7 2.6c-14.2 3-32.3 6-52.4 7.5c-.5-11.2-3.4-21.9-8.2-31.5c20.5-1.1 39.4-4.1 54-7.2c9.1-1.9 16.5-3.8 21.6-5.3c2.5-.7 4.5-1.3 5.8-1.7c.6-.2 1.1-.4 1.4-.5l.3-.1c0 0 0 0 .1 0c0 0 0 0 0 0c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-47.7c0-2.8 .6-5.6 2-8s3.4-4.5 5.8-6l31-19.4c55.5-34.7 89.2-95.6 89.2-161l0-50.9C608 94.2 545.8 32 469.1 32l-13 0c-5.1 0-9.8 2.4-12.8 6.4l-6.8 9.1c-6.7 8.9-15.8 15.9-26.1 20c-11 4.4-18.2 15.1-18.2 26.9l0 1.8c0 17.5 14.2 31.7 31.7 31.7l74.5 0c34.1 0 61.8 27.7 61.8 61.8l0 23c0 32.7-26.5 59.1-59.1 59.1c-27.3 0-53.9-8.5-76.2-24.4l-26-18.6c-33.7-24.1-74-37-115.4-37c-49.6 0-97.3 18.5-133.9 51.9L61.1 324.4C42.6 341.4 32 365.4 32 390.5c0 49.4 40.1 89.5 89.5 89.5l121 0c7.5 0 13.5-6.1 13.5-13.5c0-6.4-4.4-11.9-10.7-13.2l-97.6-21.1C117.5 425.6 96 398.9 96 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 15.8 11 29.5 26.5 32.8L252.1 422C273 426.5 288 445 288 466.5c0 25.1-20.4 45.5-45.5 45.5l-121 0C54.4 512 0 457.6 0 390.5c0-34.1 14.4-66.7 39.6-89.7l88.2-80.5c42.5-38.8 97.9-60.3 155.5-60.3c48.1 0 94.9 15 134 43l26 18.6c16.8 12 36.9 18.4 57.6 18.4c15 0 27.1-12.1 27.1-27.1l0-23c0-16.5-13.4-29.8-29.8-29.8l-74.5 0c-35.2 0-63.7-28.5-63.7-63.7l0-1.8c0-24.9 15.2-47.4 38.3-56.6c4.9-2 9.2-5.3 12.4-9.5l6.8-9.1zM448 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fal',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      'M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z'
      
    ]
  };

  

  
  

  var faMessageMinus = {
    prefix: 'fal',
    iconName: 'message-minus',
    icon: [
      512,
      512,
      ["comment-alt-minus"],
      'f4a7',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zm96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  
    var faCommentAltMinus = faMessageMinus;
  

  
  

  var faFill = {
    prefix: 'fal',
    iconName: 'fill',
    icon: [
      512,
      512,
      [],
      'f575',
      
      'M59.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l97.4 97.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-64.4 64.4L59.3 4.7zm97.4 142.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88 64.4-64.4c15.6-15.6 40.9-15.6 56.6 0L451.7 211.7c15.6 15.6 15.6 40.9 0 56.6L432 288 35 288c1.7-13.6 7.8-26.8 18.2-37.3L156.7 147.3zM53.3 341.3C47 335 42.3 327.7 39.2 320L400 320 261.3 458.7c-25 25-65.5 25-90.5 0L53.3 341.3z'
      
    ]
  };

  

  
  

  var faGlassHalf = {
    prefix: 'fal',
    iconName: 'glass-half',
    icon: [
      384,
      512,
      ["glass-half-empty","glass-half-full"],
      'e192',
      
      'M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7l303.7 0c4.7 0 8.4 4 8 8.7L336.3 224 47.6 224 32.1 40.7zM50.3 256l283.4 0L317.2 450.7C315.8 467.3 302 480 285.4 480L98.6 480c-16.6 0-30.5-12.7-31.9-29.3L50.3 256zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512l186.8 0c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0L40.1 0z'
      
    ]
  };

  
    var faGlassHalfEmpty = faGlassHalf;
  
    var faGlassHalfFull = faGlassHalf;
  

  
  

  var faMessageCode = {
    prefix: 'fal',
    iconName: 'message-code',
    icon: [
      512,
      512,
      [],
      'e1df',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM219.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z'
      
    ]
  };

  

  
  

  var faSchoolFlag = {
    prefix: 'fal',
    iconName: 'school-flag',
    icon: [
      576,
      512,
      [],
      'e56e',
      
      'M304 64l80 0 0-32-80 0 0 32zM272 16c0-8.8 7.2-16 16-16L400 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-84.5 0 89.6 64L512 160c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-160 0-32 0-64 0-32 0L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l106.9 0L272 87.8 272 64l0-48zm48 400c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zm32 64l160 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-112 0c-3.3 0-6.6-1-9.3-3L288 115.7 185.3 189c-2.7 1.9-6 3-9.3 3L64 192c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l160 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64zM256 240a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM64 256c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zm64 0l-32 0 0 32 32 0 0-32zm320-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zM64 384c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zm64 0l-32 0 0 32 32 0 0-32zm320-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0z'
      
    ]
  };

  

  
  

  var faTablet = {
    prefix: 'fal',
    iconName: 'tablet',
    icon: [
      448,
      512,
      ["tablet-android"],
      'f3fb',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faTabletAndroid = faTablet;
  

  
  

  var faCommentQuote = {
    prefix: 'fal',
    iconName: 'comment-quote',
    icon: [
      512,
      512,
      [],
      'e14c',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM208 176l0 24 0 24-48 0 0-48 48 0zm-48 80l48 0c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 322.7 240 290.7 240 254l0-30 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm144-80l48 0 0 24 0 24-48 0 0-48zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 322.7 384 290.7 384 254l0-30 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l48 0z'
      
    ]
  };

  

  
  

  var faCameraSlash = {
    prefix: 'fal',
    iconName: 'camera-slash',
    icon: [
      640,
      512,
      [],
      'e0d9',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 376.6L576 160c0-35.3-28.7-64-64-64l-71.1 0L430.5 64.8C423.9 45.2 405.6 32 384.9 32L255.1 32c-20.7 0-39 13.2-45.5 32.8l-5.9 17.8 26.7 21.1 9.6-28.7c2.2-6.5 8.3-10.9 15.2-10.9l129.9 0c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9l82.7 0c17.7 0 32 14.3 32 32l0 191.3 32 25.3zM96 160.7L67.7 138.4c-2.4 6.8-3.7 14-3.7 21.6l0 256c0 35.3 28.7 64 64 64l372.4 0-40.5-32L128 448c-17.7 0-32-14.3-32-32l0-255.3zM378.4 383.6l-27.6-21.8c-9.5 4-19.9 6.1-30.8 6.1c-44.2 0-80-35.8-80-80c0-4.4 .3-8.6 1-12.8l-27.6-21.8c-3.5 10.9-5.4 22.5-5.4 34.6c0 61.9 50.1 112 112 112c21.4 0 41.4-6 58.4-16.4z'
      
    ]
  };

  

  
  

  var faCloudBoltSun = {
    prefix: 'fal',
    iconName: 'cloud-bolt-sun',
    icon: [
      640,
      512,
      ["thunderstorm-sun"],
      'f76e',
      
      'M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm96 72c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-13.6 0c-.5 11.8-4.9 23-12.4 32l25.7 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 42 27 77.7 64.6 90.7c1.6-10.9 6.5-21.1 14.1-29.1C243.7 342 224 317.3 224 288c0-35.3 28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 184l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4l48.3 0-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4l-48.3 0zM457.6 224c-5.1 0-10.1 2-13.8 5.5L294.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6l49.4 0-34.9 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L505.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6L441 328l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z'
      
    ]
  };

  
    var faThunderstormSun = faCloudBoltSun;
  

  
  

  var faBellSlash = {
    prefix: 'fal',
    iconName: 'bell-slash',
    icon: [
      640,
      512,
      [61943,128277],
      'f1f6',
      
      'M378.8 384l-238.6 0c-6.8 0-12.3-5.5-12.3-12.3c0-3.3 1.3-6.4 3.6-8.7l2.8-2.8c33.4-33.4 53.5-77.5 57.1-124.2L160 211.2l0 9.9c0 43.7-17.4 85.6-48.3 116.6l-2.8 2.8c-8.3 8.3-13 19.6-13 31.3c0 24.5 19.8 44.3 44.3 44.3l279.1 0-40.5-32zM304 32.8C264.5 36.7 229.2 55 203.4 82.4l25.2 19.9C251.9 78.7 284.2 64 320 64c70.7 0 128 57.3 128 128l0 29.1c0 21.4 3.5 42.5 10.2 62.4l75.1 59.3c-.7-.8-1.5-1.7-2.3-2.5l-2.8-2.8C497.4 306.7 480 264.8 480 221.1l0-29.1c0-83-63.1-151.2-144-159.2L336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16.8zM289.8 458.7c-2.9-8.3-12.1-12.7-20.4-9.8s-12.7 12.1-9.8 20.4c8.8 24.8 32.5 42.7 60.4 42.7s51.6-17.8 60.4-42.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8C345.8 471.1 333.9 480 320 480s-25.8-8.9-30.2-21.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faStoreLock = {
    prefix: 'fal',
    iconName: 'store-lock',
    icon: [
      640,
      512,
      [],
      'e4a6',
      
      'M520.6 120.9s0 0 0 0c8.1 12.7 9.2 26.8 5.6 39.1c.6 0 1.2 0 1.8 0c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c1.2 .9 2.5 1.8 3.8 2.7c6.1-9.1 13.5-17.2 22-24.1c-5.7-3.1-10.8-7.1-15.1-11.8c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5c-29.3-4-47.7-41-29.1-70.6c0 0 0 0 0 0L111.6 32l352.8 0 56.2 88.9zM96 352l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80 0 16 0 16 0 64c0 35.3 28.7 64 64 64l264.6 0c-5.4-9.4-8.6-20.3-8.6-32l-256 0c-17.7 0-32-14.3-32-32l0-64 288 0 0-32L96 352zM528 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faEyeDropperHalf = {
    prefix: 'fal',
    iconName: 'eye-dropper-half',
    icon: [
      512,
      512,
      [],
      'e173',
      
      'M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c0 0 0 0 0 0l-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4s0 0 0 0s0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6l0 41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480l41.2 0c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-185.4 0 84.7-84.7zM64 378.5c0-9.5 2.8-18.7 8-26.5l177.4 0-81.9 81.9c-9 9-21.2 14.1-33.9 14.1L88 448l-4.2 0-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7 0-4.2 0-45.5z'
      
    ]
  };

  

  
  

  var faBezierCurve = {
    prefix: 'fal',
    iconName: 'bezier-curve',
    icon: [
      640,
      512,
      [],
      'f55b',
      
      'M352 64c8.8 0 16 7.2 16 16l0 21.2 0 10.8 0 22 0 10c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-10 0-22 0-10.8L272 80c0-8.8 7.2-16 16-16l64 0zm83.4 64l78.6 0c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48L400 96l0-16c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 16L126 96c-7.1-27.6-32.2-48-62-48C28.7 48 0 76.7 0 112s28.7 64 64 64c29.8 0 54.9-20.4 62-48l78.6 0C139.5 167.2 96 238.5 96 320l-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0c0-77.5 45.9-144.3 112-174.6c.7 25.9 21.9 46.6 48 46.6l64 0c26 0 47.2-20.7 48-46.6c66.1 30.3 112 97.1 112 174.6l-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0c0-81.5-43.5-152.8-108.6-192zM544 352l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l16 0 32 0zm-416 0l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l16 0 32 0zM32 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm512 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faSignalStreamSlash = {
    prefix: 'fal',
    iconName: 'signal-stream-slash',
    icon: [
      640,
      512,
      [],
      'e250',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-70.7-25.5-135.5-67.8-185.6c-5.7-6.8-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5C521.4 135.6 544 193.1 544 256c0 29.5-5 57.8-14.1 84.1L556.3 361C569 328.5 576 293 576 256zm-96 0c0-46.4-16.5-89-43.9-122.2c-5.6-6.8-15.7-7.8-22.5-2.1s-7.8 15.7-2.1 22.5C434.3 181.9 448 217.3 448 256c0 6.3-.4 12.5-1.1 18.7l28.6 22.6c2.9-13.3 4.4-27.1 4.4-41.3zM139.9 195.3l-26-20.5C102.4 199.5 96 227 96 256c0 46.4 16.5 89 43.9 122.2c5.6 6.8 15.7 7.8 22.5 2.1s7.8-15.7 2.1-22.5C141.7 330.1 128 294.7 128 256c0-21.5 4.2-42 11.9-60.7zm-77.2-61L37.2 114.3C13.5 156.1 0 204.5 0 256c0 70.7 25.5 135.5 67.8 185.6c5.7 6.8 15.8 7.6 22.5 1.9s7.6-15.8 1.9-22.5C54.6 376.4 32 318.9 32 256c0-44 11.1-85.4 30.7-121.6z'
      
    ]
  };

  

  
  

  var faFolderCheck = {
    prefix: 'fal',
    iconName: 'folder-check',
    icon: [
      512,
      512,
      [],
      'e64e',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM363.3 235.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 329.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faSquareDivide = {
    prefix: 'fal',
    iconName: 'square-divide',
    icon: [
      448,
      512,
      [],
      'e26a',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faSignHanging = {
    prefix: 'fal',
    iconName: 'sign-hanging',
    icon: [
      512,
      512,
      ["sign"],
      'f4d9',
      
      'M80 0c8.8 0 16 7.2 16 16l0 48 400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 96l0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16L64 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l48 0 0-48C64 7.2 71.2 0 80 0zm80 160l0 192 288 0 0-192-288 0zm-32 0c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-192z'
      
    ]
  };

  
    var faSign = faSignHanging;
  

  
  

  var faVacuumRobot = {
    prefix: 'fal',
    iconName: 'vacuum-robot',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM356.7 155.3c-55.6-55.6-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c55.6-55.6 55.6-145.8 0-201.4zm-144 57.4c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z'
      
    ]
  };

  

  
  

  var faAngle = {
    prefix: 'fal',
    iconName: 'angle',
    icon: [
      448,
      512,
      [],
      'e08c',
      
      'M238.3 55.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-208 416c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L41.9 448 238.3 55.2zM295 238.9c-16.3-20.5-35-39.1-55.6-55.2c-7.7-6.1-19-3.2-23.4 5.6c-3.5 7.1-1.4 15.6 4.8 20.5c17.8 14.1 34 30.2 48.2 47.9c5.3 6.6 14.7 8.4 21.9 3.9c7.8-4.9 9.9-15.4 4.1-22.7zm14.5 84.9c9.9 22.2 17.3 45.7 21.7 70.3c1.4 8 8.2 14 16.3 14c9.6 0 17.2-8.4 15.5-17.9c-4.9-28.4-13.4-55.5-25-81c-3.9-8.6-14.5-11.4-22.5-6.4c-7 4.4-9.4 13.5-6 21z'
      
    ]
  };

  

  
  

  var faOliveBranch = {
    prefix: 'fal',
    iconName: 'olive-branch',
    icon: [
      640,
      512,
      [],
      'e317',
      
      'M128 96C89.1 96 59.2 78.1 41.6 64C59.2 49.9 89.1 32 128 32s68.8 17.9 86.4 32C196.8 78.1 166.9 96 128 96zm0-96C59.2 0 14.1 44.2 2.8 56.6C.9 58.6 0 61.2 0 64s.9 5.4 2.8 7.4c8.2 8.9 34 34.5 73.8 48C30.6 147.6 0 198.2 0 256l0 16c0 8.8 7.2 16 16 16l32 0c88.4 0 160-71.6 160-160l0-13.6L330.4 55.6C362.8 40.1 398.3 32 434.3 32L624 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L434.3 0c-40.7 0-81 9.2-117.7 26.8L253.6 57c-.1-.2-.3-.3-.4-.4C241.9 44.2 196.8 0 128 0zm47.7 128c.1 0 .2 0 .3 0c0 70.7-57.3 128-128 128l-16 0c0-70.7 57.3-128 128-128l15.7 0zM412.2 436.6C390.7 465.2 363.4 480 336 480s-54.7-14.8-76.2-43.4S224 366.8 224 320s14.3-87.9 35.8-116.6C281.3 174.8 308.6 160 336 160s54.7 14.8 76.2 43.4C433.7 232.1 448 273.2 448 320s-14.3 87.9-35.8 116.6zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c13.6 10.4 25.7 22.9 36.2 36.9c.5 .7 1 1.4 1.5 2c28.3 9 57.7 26.8 83.4 53.5c33.1 34.4 52.4 75.3 57.5 112.6c5.2 37.5-3.9 68.9-23.6 89.3c-19.5 20.2-48.9 29.2-84 24c-5-.7-10.1-1.8-15.2-3.1c-5.2 10-11 19.5-17.4 28.3z'
      
    ]
  };

  

  
  

  var faPlugCircleMinus = {
    prefix: 'fal',
    iconName: 'plug-circle-minus',
    icon: [
      576,
      512,
      [],
      'e55e',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64c0 83 63.1 151.2 144 159.2l0 96.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96.8c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128l0-64 256 0 0 56.2c9.8-8.1 20.6-15.2 32-21l0-35.2 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0L64 144l-32 0-16 0zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faArrowTrendUp = {
    prefix: 'fal',
    iconName: 'arrow-trend-up',
    icon: [
      576,
      512,
      [],
      'e098',
      
      'M368 112c0-8.8 7.2-16 16-16l176 0c8.8 0 16 7.2 16 16l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-137.4L331.3 363.3c-6.2 6.2-16.4 6.2-22.6 0L192 246.6 27.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l176-176c6.2-6.2 16.4-6.2 22.6 0L320 329.4 521.4 128 384 128c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faStore = {
    prefix: 'fal',
    iconName: 'store',
    icon: [
      576,
      512,
      [],
      'f54e',
      
      'M520.6 120.9s0 0 0 0c18.7 29.6 .3 66.6-29.2 70.6c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5c-29.3-4-47.7-41-29.1-70.6c0 0 0 0 0 0L111.6 32l352.8 0 56.2 88.9zM483.4 224c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2zM80 256c-8.8 0-16 7.2-16 16l0 80 0 16 0 16 0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64 0-16 0-16 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80L96 352l0-80c0-8.8-7.2-16-16-16zM96 384l384 0 0 64c0 17.7-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32l0-64z'
      
    ]
  };

  

  
  

  var faDisplayArrowDown = {
    prefix: 'fal',
    iconName: 'display-arrow-down',
    icon: [
      576,
      512,
      [],
      'e164',
      
      'M64 0L240 0l0 32L64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l167.7 0c.2 0 .4 0 .6 0l111.5 0c.2 0 .4 0 .6 0L512 384c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32L336 32l0-32L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-149.1 0 10.7 64 58.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-72 0-144 0-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.4 0 10.7-64L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM245.6 416l-10.7 64 106.2 0-10.7-64-84.9 0zM304 16l0 217.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 233.4 272 16c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCircleGf = {
    prefix: 'fal',
    iconName: 'circle-gf',
    icon: [
      512,
      512,
      [],
      'e67f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128c35.3 0 64 28.7 64 64l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64zm96 16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 96 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z'
      
    ]
  };

  

  
  

  var faChartScatter = {
    prefix: 'fal',
    iconName: 'chart-scatter',
    icon: [
      512,
      512,
      [],
      'f7ee',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFaceEyesXmarks = {
    prefix: 'fal',
    iconName: 'face-eyes-xmarks',
    icon: [
      512,
      512,
      [],
      'e374',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm260.2 80l-8.4 0c-29 0-53.2 20.6-58.6 48l125.7 0c-5.5-27.4-29.6-48-58.6-48zm-8.4-32l8.4 0c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2l-151.6 0c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faPlanetMoon = {
    prefix: 'fal',
    iconName: 'planet-moon',
    icon: [
      576,
      512,
      [],
      'e01f',
      
      'M512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 480C118 480 32 394 32 288c0-8.1 .5-16.1 1.5-24l58.6 0c8.5 0 16.6 3.4 22.6 9.4L152 310.6l0 31.5c0 17 9.6 32.6 24.8 40.2c4.4 2.2 7.2 6.7 7.2 11.6l0 15.3C184 435 205 456 230.8 456c16.2 0 31.3-8.4 39.9-22.3l45.5-73.9c7.8-12.6 11.9-27.1 11.9-41.9l0-21.9c0-26.5-21.5-48-48-48l-61.5 0c-5.2 0-10-3-12.4-7.7c-2.2-4.4-1.9-9.7 .9-13.9L249.3 163c9.8-14.7 14.4-32.1 13.3-49.7l-.9-13.6C349.6 117.2 416 194.8 416 288c0 106-86 192-192 192zM40.3 232C64.3 153.3 137.4 96 224 96c1.8 0 3.5 0 5.3 .1l1.3 19.3c.7 10.5-2.1 21-8 29.8l-42.3 63.5c-9.1 13.7-10.2 31.2-2.9 45.9c7.8 15.5 23.6 25.3 41 25.3l61.5 0c8.8 0 16 7.2 16 16l0 21.9c0 8.9-2.5 17.6-7.1 25.2L243.4 417c-2.7 4.4-7.5 7-12.6 7c-8.2 0-14.8-6.6-14.8-14.8l0-15.3c0-17-9.6-32.6-24.8-40.2c-4.4-2.2-7.2-6.7-7.2-11.6l0-38.1 0-6.6-4.7-4.7-41.9-41.9c-12-12-28.3-18.7-45.3-18.7l-51.8 0zM227.2 64c-1.1 0-2.1 0-3.2 0C100.3 64 0 164.3 0 288S100.3 512 224 512s224-100.3 224-224c0-111.7-81.7-204.2-188.6-221.2c0 0 0 0 0 0c-10.5-1.7-21.3-2.6-32.3-2.8c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faHexagonNodesBolt = {
    prefix: 'fal',
    iconName: 'hexagon-nodes-bolt',
    icon: [
      576,
      512,
      [],
      'e69a',
      
      'M200 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40 53.7c23.1-6.9 40-28.3 40-53.7c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7l0 92.6c-8.6 2.6-16.3 7.1-22.7 13.2l-74.8-42.7c5.5-23.4-4.7-48.6-26.5-61.2C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c3.9 2.2 7.9 4 12 5.2l0 84.6c-4.1 1.2-8.1 2.9-12 5.2C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c21.9-12.6 32-37.8 26.5-61.3l46.3-26.4c-6.9-8.1-12.3-17.5-15.9-27.8L94.7 311.5c-6.5-6.2-14.3-10.6-22.7-13.1l0-84.7c8.4-2.5 16.2-6.9 22.7-13.1l74.8 42.7c-1 4.1-1.5 8.4-1.5 12.7c0 25.4 16.9 46.8 40 53.7l0 92.6c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56c30.7 0 55.6-24.7 56-55.2c-7.5-12.9-13.5-26.8-17.6-41.5c-6.3-5.9-13.9-10.4-22.4-12.9l0-92.6c8.6-2.6 16.3-7.1 22.7-13.2l6.8 3.9c4.1-9.9 9.2-19.4 15-28.3l-5.9-3.3c1-4.1 1.5-8.4 1.5-12.7c0-25.4-16.9-46.8-40-53.7l0-92.6zM440.5 132C425 105.2 390.8 96 364 111.5c-21.9 12.6-32 37.8-26.6 61.2l-46.3 26.4c6.9 8.1 12.3 17.5 15.9 27.8l46.2-26.4c2.5 2.3 5.1 4.4 7.9 6.3c21.7-9.5 45.6-14.8 70.8-14.8c2 0 4 0 5.9 .1c12.1-17.3 13.8-40.6 2.6-60.1zM380 139.2a24 24 0 1 1 24 41.6 24 24 0 1 1 -24-41.6zM35.2 148a24 24 0 1 1 41.6 24A24 24 0 1 1 35.2 148zM200 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM76.8 340A24 24 0 1 1 35.2 364a24 24 0 1 1 41.6-24zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96 136a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z'
      
    ]
  };

  

  
  

  var faFolderMinus = {
    prefix: 'fal',
    iconName: 'folder-minus',
    icon: [
      512,
      512,
      [],
      'f65d',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zm96 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleArrowRight = {
    prefix: 'fal',
    iconName: 'floppy-disk-circle-arrow-right',
    icon: [
      576,
      512,
      ["save-circle-arrow-right"],
      'e180',
      
      'M32 96l0 320c0 17.7 14.3 32 32 32l211.2 0c5.9 11.4 12.9 22.2 21 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3l0 22.2c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7l0-22.2c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6l0 94.2c0 17.7-14.3 32-32 32L96 192c-17.7 0-32-14.3-32-32l0-96C46.3 64 32 78.3 32 96zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64l0 96 192 0 0-96L96 64zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
  

  
  

  var faPhotoFilm = {
    prefix: 'fal',
    iconName: 'photo-film',
    icon: [
      640,
      512,
      ["photo-video"],
      'f87c',
      
      'M576 32L256 32c-17.7 0-32 14.3-32 32l0 169.4L297.4 160c12.5-12.5 32.8-12.5 45.3 0L384 201.4 489.4 96c12.5-12.5 32.8-12.5 45.3 0L608 169.4 608 64c0-17.7-14.3-32-32-32zm64 176c0 0 0 0 0 .1l0 80c0 35.3-28.7 64-64 64l-304 0c0 0 0 0 0 0l-16 0c-35.3 0-64-28.7-64-64l0-16s0 0 0 0l0-208c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 144zm-32 6.7l-96-96L395.3 235.3 310.6 320 576 320c17.7 0 32-14.3 32-32l0-73.4zM265.4 320l96-96L320 182.6l-96 96 0 9.4c0 17.7 14.3 32 32 32l9.4 0zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 160l32 0 0 32-32 0 0 80 0 128 0 80 256 0 0-96 32 0 0 96 32 0c17.7 0 32-14.3 32-32l0-64 32 0 0 64c0 35.3-28.7 64-64 64l-32 0-16 0-16 0-256 0-16 0-16 0-32 0c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l32 0 16 0 16 0zM32 256l64 0 0-64-32 0c-17.7 0-32 14.3-32 32l0 32zm0 160l0 32c0 17.7 14.3 32 32 32l32 0 0-64-64 0zm64-32l0-96-64 0 0 96 64 0z'
      
    ]
  };

  
    var faPhotoVideo = faPhotoFilm;
  

  
  

  var faVideoArrowDownLeft = {
    prefix: 'fal',
    iconName: 'video-arrow-down-left',
    icon: [
      576,
      512,
      [],
      'e2c8',
      
      'M320 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-47.2 0-161.6 0-47.2c0-35.3-28.7-64-64-64L64 64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2l0-243.6c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6l0 36.5 118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2l0 243.6c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9l0 36.5zM224 352c8.8 0 16-7.2 16-16s-7.2-16-16-16l-73.4 0L283.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 297.4l0-73.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16l112 0z'
      
    ]
  };

  

  
  

  var faCandleHolder = {
    prefix: 'fal',
    iconName: 'candle-holder',
    icon: [
      448,
      512,
      [128367],
      'f6bc',
      
      'M112 112c0 26.5 21.5 48 48 48s48-21.5 48-48c0-8.8-6.5-24-20.5-43.1C178.4 56.4 168 45.1 160 36.8c-8 8.3-18.4 19.6-27.5 32.1C118.5 88 112 103.2 112 112zm48 80c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zM0 496c0-8.8 7.2-16 16-16l48 0 0-208c0-26.5 21.5-48 48-48l32 0 64 0c26.5 0 48 21.5 48 48l0 208 72.6 0c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64l-128 0-32 0L96 512l-32 0-48 0c-8.8 0-16-7.2-16-16zM128 256l-16 0c-8.8 0-16 7.2-16 16l0 208 128 0 0-208c0-8.8-7.2-16-16-16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zM384 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faClockTen = {
    prefix: 'fal',
    iconName: 'clock-ten',
    icon: [
      512,
      512,
      [],
      'e354',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 114.1-71.1-47.4c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l96 64c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSirenOn = {
    prefix: 'fal',
    iconName: 'siren-on',
    icon: [
      640,
      512,
      [],
      'e02e',
      
      'M55.2 33.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 192l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM492 320l-32.2 0L439.3 156c-2-16-15.6-28-31.8-28l-175 0c-16.1 0-29.8 12-31.8 28L180.2 320 148 320l21-167.9c4-32 31.2-56.1 63.5-56.1l175 0c32.3 0 59.5 24 63.5 56.1L492 320zm-250.1 0l14.2-114c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9L274.1 320l-32.2 0zM496 384l-352 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM144 352l352 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-352 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faRocket = {
    prefix: 'fal',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      'M188.9 372l-50.4-50.4c18.6-42.7 61.7-137.7 95.1-187C304.6 30.1 409 24.6 475.7 36.3c11.7 66.7 6.2 171.1-98.4 242c-49.4 33.5-145.5 75.6-188.4 93.7zm-79.9-62.8c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2l0-90.2c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-90.2 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l102.5 0c-3.6 8-6.8 15.2-9.4 21.2zM256 470.1l0-92.5c30.3-13.7 65.4-30.3 96-47l0 71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160l71.5 0c-16.9 30.7-34 65.8-48.1 96l-91.2 0L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z'
      
    ]
  };

  

  
  

  var faClockEleven = {
    prefix: 'fal',
    iconName: 'clock-eleven',
    icon: [
      512,
      512,
      [],
      'e347',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 91.2-34.7-52c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l64 96c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faLassoSparkles = {
    prefix: 'fal',
    iconName: 'lasso-sparkles',
    icon: [
      576,
      512,
      [],
      'e1c9',
      
      'M336 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16zM0 176C0 85.4 112 10.8 256 1.1l0 32C129.7 42 32 102.6 32 176c0 47.1 40.2 88.9 102.4 115.2c0 0 0 0 0 0c5.5 2.3 11.2 4.5 17 6.6c0 0 0 0 0 0C190.9 311.9 237.8 320 288 320c141.4 0 256-64.5 256-144c0-45.5-37.5-86-96-112.4l0-33.9C525.2 61.2 576 115 576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105l-87 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l87 0c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176zM512 368l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFaceDisappointed = {
    prefix: 'fal',
    iconName: 'face-disappointed',
    icon: [
      512,
      512,
      [],
      'e36f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faFileCircleInfo = {
    prefix: 'fal',
    iconName: 'file-circle-info',
    icon: [
      576,
      512,
      [58604],
      'e493',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16l0-32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 48s0 0 0 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faArrowLeftFromArc = {
    prefix: 'fal',
    iconName: 'arrow-left-from-arc',
    icon: [
      512,
      512,
      [],
      'e615',
      
      'M480 256C480 132.3 379.7 32 256 32c-8.8 0-16-7.2-16-16s7.2-16 16-16C397.4 0 512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM149.4 116c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L58.1 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16L58.1 272 170.6 372c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3L5.4 268C2 264.9 0 260.6 0 256s2-8.9 5.4-12l144-128z'
      
    ]
  };

  

  
  

  var faMap = {
    prefix: 'fal',
    iconName: 'map',
    icon: [
      576,
      512,
      [62072,128506],
      'f279',
      
      'M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8l0 317.5 128-51.2 0-317.5L32 122.8zm352 320l0-318.7L192 69.2l0 318.7 192 54.9zm32-2.4l128-51.2 0-317.5L416 122.8l0 317.5z'
      
    ]
  };

  

  
  

  var faUserHairLong = {
    prefix: 'fal',
    iconName: 'user-hair-long',
    icon: [
      448,
      512,
      [],
      'e45b',
      
      'M320 128c0-5.5-.5-10.8-1.3-16l-30.1 0c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3L320 288c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.7 0c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3l58.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-58.7 0C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7l18.6 0C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64l28.9 0c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM32 480L416 480c-1.9-71-60-128-131.5-128l-120.9 0C92.1 352 33.9 409 32 480zM0 483.6C0 393.2 73.2 320 163.6 320l120.9 0C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6z'
      
    ]
  };

  

  
  

  var faAxeBattle = {
    prefix: 'fal',
    iconName: 'axe-battle',
    icon: [
      512,
      512,
      [],
      'f6b3',
      
      'M73.6 52.1C47.4 93.7 32 144.4 32 192c0 48.6 16.1 100.9 43.5 142.9c7.2-15 16.3-28.9 26.1-41c22.1-27.2 56.1-54.2 106.4-65l0 32.9c-38.6 9.9-64.4 31.2-81.6 52.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3C25.5 327.7 0 257.4 0 192C0 126.4 25.6 56.5 67.7 5.7C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c2.9 20.2 12.8 40.3 24.9 56.4c15.9 21.3 42.5 43.5 87.2 52.9l0 32.6c-56.2-10.1-91.3-37.7-112.8-66.3C87 78.7 79.4 66 73.6 52.1zM304 261.8l0-32.9c50.3 10.8 84.4 37.8 106.5 65c9.9 12.1 18.9 26 26.1 41c20.8-32.1 35.2-70.2 40.8-108.2l-12.1-12.1c-12.5-12.5-12.5-32.8 0-45.3l12.1-12.1c-5.4-36.8-19.2-73.7-39-105.2C432.7 66 425 78.7 416.9 89.6c-21.5 28.6-56.7 56.2-112.9 66.3l0-32.6c44.8-9.4 71.3-31.7 87.3-52.9c12.1-16.1 22-36.2 24.9-56.4c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c37.2 44.9 61.5 104.6 66.7 163.2l-.4 .4L488 192l22.6 22.6 .4 .4c-5.2 58.5-29.4 118.6-66.7 163.2c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8c-17.2-21.1-43-42.4-81.7-52.3zM272 48l0 448c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-448c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCars = {
    prefix: 'fal',
    iconName: 'cars',
    icon: [
      640,
      512,
      [],
      'f85b',
      
      'M124.2 32l135.6 0c14.3 0 26.8 9.5 30.8 23.2L306.8 112c-.9 0-1.9 0-2.8 0L80 112c-.9 0-1.9 0-2.8 0L93.4 55.2C97.4 41.5 109.9 32 124.2 32zM62.7 46.4L41 122.1C16.6 135.8 0 162 0 192l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 225.6 0c3.7-3.7 7.7-7.1 11.9-10.2l6.2-21.8L32 256l0-16 0-48c0-26.5 21.5-48 48-48l224 0c11.8 0 22.6 4.3 31 11.3c10.3-5.5 21.6-9.2 33.6-10.6c-6.8-9.2-15.5-17-25.6-22.6L321.3 46.4C313.5 18.9 288.4 0 259.8 0L124.2 0C95.6 0 70.5 18.9 62.7 46.4zM80 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm300.2-16l135.6 0c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4l-135.6 0c-28.6 0-53.7 18.9-61.5 46.4zM608 416l0 16-320 0 0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faShekelSign = {
    prefix: 'fal',
    iconName: 'shekel-sign',
    icon: [
      448,
      512,
      [8362,"ils","shekel","sheqel","sheqel-sign"],
      'f20b',
      
      'M80 32C53.5 32 32 53.5 32 80l0 384c0 8.8 7.2 16 16 16s16-7.2 16-16L64 80c0-8.8 7.2-16 16-16l112 0c44.2 0 80 35.8 80 80l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-61.9-50.1-112-112-112L80 32zM304 480c61.9 0 112-50.1 112-112l0-320c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 320c0 44.2-35.8 80-80 80l-112 0c-8.8 0-16-7.2-16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 256c0 26.5 21.5 48 48 48l112 0z'
      
    ]
  };

  
    var faIls = faShekelSign;
  
    var faShekel = faShekelSign;
  
    var faSheqel = faShekelSign;
  
    var faSheqelSign = faShekelSign;
  

  
  

  var faTally2 = {
    prefix: 'fal',
    iconName: 'tally-2',
    icon: [
      640,
      512,
      [],
      'e295',
      
      'M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416z'
      
    ]
  };

  

  
  

  var faTeeth = {
    prefix: 'fal',
    iconName: 'teeth',
    icon: [
      576,
      512,
      [],
      'f62e',
      
      'M96 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L96 64zM0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 128zm160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32 64 0 0-32zM96 288l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0zm75.5 79c-11.4 10.6-26.7 17-43.5 17c-35.3 0-64-28.7-64-64l0-48 0-48c0-35.3 28.7-64 64-64c14 0 27 4.5 37.6 12.2c10.9-26 36.5-44.2 66.4-44.2c22.6 0 42.8 10.4 56 26.7c13.2-16.3 33.4-26.7 56-26.7c29.9 0 55.5 18.2 66.4 44.2C421 164.5 434 160 448 160c35.3 0 64 28.7 64 64l0 48 0 48c0 35.3-28.7 64-64 64c-16.8 0-32-6.5-43.5-17c-12.8 19.9-35.1 33-60.5 33c-22.6 0-42.8-10.4-56-26.7c-13.2 16.3-33.4 26.7-56 26.7c-25.4 0-47.7-13.2-60.5-33zM232 160c-22.1 0-40 17.9-40 40l0 24 0 32 80 0 0-56c0-22.1-17.9-40-40-40zM192 320l0 8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-40-80 0 0 32zm224-64l64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32zm0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0 0 32zm-72 48c22.1 0 40-17.9 40-40l0-8 0-32-80 0 0 40c0 22.1 17.9 40 40 40zm40-112l0-32 0-24c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 56 80 0z'
      
    ]
  };

  

  
  

  var faBlender = {
    prefix: 'fal',
    iconName: 'blender',
    icon: [
      512,
      512,
      [],
      'f517',
      
      'M0 72C0 32.2 32.2 0 72 0l56 0 24 0 8.1 0L471 0c20.8 0 36.1 19.6 31 39.8L423.1 355.4C456 365.3 480 395.9 480 432l0 32c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-32c0-37.8 26.2-69.5 61.5-77.9L148 240l-76 0c-39.8 0-72-32.2-72-72L0 72zM128 432l0 32c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-32c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48zM423 224l-119 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l127 0 16-64-143 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l151 0 16-64L162.8 32l26.7 320L391 352l32-128zM72 32C49.9 32 32 49.9 32 72l0 96c0 22.1 17.9 40 40 40l73.3 0L130.7 32 72 32zM288 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faWrenchSimple = {
    prefix: 'fal',
    iconName: 'wrench-simple',
    icon: [
      384,
      512,
      [],
      'e2d1',
      
      'M137 2.8c4.4 3 7 7.9 7 13.2l0 152 48 36 48-36 0-152c0-5.3 2.6-10.2 7-13.2s9.9-3.6 14.8-1.7C332.9 28.9 384 94.1 384 176c0 71.1-38.6 133.1-96 166.3L288 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-163.2c0-6 3.4-11.5 8.7-14.2C316.6 292.1 352 238.2 352 176c0-58.9-31.9-107.7-80-134.8L272 176c0 5-2.4 9.8-6.4 12.8l-64 48c-5.7 4.3-13.5 4.3-19.2 0l-64-48c-4-3-6.4-7.8-6.4-12.8l0-134.8C63.9 68.3 32 117.1 32 176c0 62.2 35.4 116.1 87.3 142.6c5.4 2.7 8.7 8.2 8.7 14.2L128 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-153.7C38.6 309.1 0 247.1 0 176C0 94.1 51.1 28.9 122.2 1.1C127.1-.8 132.7-.2 137 2.8z'
      
    ]
  };

  

  
  

  var faPeanut = {
    prefix: 'fal',
    iconName: 'peanut',
    icon: [
      512,
      512,
      [],
      'e430',
      
      'M127.1 249.9l.2 0 .2 0c25.9-5.1 58.5-14.4 83.1-39s33.9-57.2 39-83.1l0-.2 0-.2c1.5-8.2 3.8-16 6.9-23.5c0 0 0 0 0 0c5.5-13.4 13.7-26 24.5-37c0 0 0 0 0 0C302.4 45.2 331.6 32 364 32l68 0c26.5 0 48 21.5 48 48l0 68c0 15.8-3.1 30.8-8.8 44.4c0 0 0 0 0 0c-5.6 13.6-14 26.4-25.2 37.6c-11.2 11.2-24 19.6-37.7 25.2c0 0 0 0 0 0c-7.5 3.1-15.3 5.4-23.5 6.9l-.2 0-.2 0c-25.9 5.1-58.5 14.4-83.1 39s-33.9 57.2-39 83.1l0 .2 0 .2c-1.5 8.2-3.8 16-6.9 23.5c0 0 0 0 0 0c-5.5 13.4-13.7 26-24.5 37c0 0 0 0 0 0C209.6 466.8 180.4 480 148 480l-68 0c-26.5 0-48-21.5-48-48l0-68c0-15.8 3.1-30.8 8.8-44.4c0 0 0 0 0 0c5.6-13.6 14-26.4 25.2-37.6c11.2-11.2 24-19.6 37.7-25.2c0 0 0 0 0 0c7.5-3.1 15.3-5.4 23.5-6.9zM148 512c41.3 0 78.7-16.9 105.5-44.2c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.5-7.2 33.9-17.9 48.1-32.1c14.2-14.2 24.9-30.5 32.1-48C508 187.2 512 168.1 512 148l0-68c0-44.2-35.8-80-80-80L364 0c-41.3 0-78.7 16.9-105.5 44.2c-13.8 14-24.2 30.1-31.3 47.2c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364l0 68c0 44.2 35.8 80 80 80l68 0zM435.2 128a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-64 64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-224 224a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 435.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM435.2 192a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 371.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4z'
      
    ]
  };

  

  
  

  var faBuildingMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'building-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e61c',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 128c9.8-7.4 20.6-13.7 32-18.7L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c29.2 0 53.9-19.6 61.6-46.4C371 460.8 361.1 454.9 352 448c0 17.7-14.3 32-32 32l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM296 224l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l40 0c0-32.4 9.6-62.5 26.2-87.7c-4.4-5.1-10.9-8.3-18.2-8.3zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm160 32l0-32 32 0 0 32-32 0zm192-63.9a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faCakeSlice = {
    prefix: 'fal',
    iconName: 'cake-slice',
    icon: [
      512,
      512,
      [127856,"shortcake"],
      'e3e5',
      
      'M296 64L52.3 256 480 256c0-64-28-112-65-144s-83-48-119-48zM0 272c0-9.8 4.5-19.1 12.2-25.1l264-208c5.6-4.4 12.6-6.9 19.8-6.9c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256l0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4c0 0 0 0 0 .1l0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .1 0 .1 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2c0 35.4-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-48 0-96zm32 80l448 0 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4L32 288l0 64zm0 32l0 32c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2L32 384z'
      
    ]
  };

  
    var faShortcake = faCakeSlice;
  

  
  

  var faEquals = {
    prefix: 'fal',
    iconName: 'equals',
    icon: [
      448,
      512,
      [62764],
      '3d',
      
      'M32 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 144zm0 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 336z'
      
    ]
  };

  

  
  

  var faH2 = {
    prefix: 'fal',
    iconName: 'h2',
    icon: [
      640,
      512,
      [],
      'f314',
      
      'M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 256 0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 256 0 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160L32 240 32 80zm400.1 41.5c19.2-16.5 43.7-25.5 69-25.5l5.8 0c47 0 85 38.1 85 85c0 23.1-9.4 45.2-26.1 61.2l-185 178.2c-4.7 4.5-6.2 11.5-3.7 17.5s8.3 10 14.8 10l232 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192.3 0L588.1 265.3C611.1 243.3 624 212.8 624 181c0-64.6-52.4-117-117-117l-5.8 0c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6c-6.7 5.8-7.5 15.9-1.7 22.6s15.8 7.5 22.6 1.7l21.7-18.6z'
      
    ]
  };

  

  
  

  var faArrowRightFromLine = {
    prefix: 'fal',
    iconName: 'arrow-right-from-line',
    icon: [
      448,
      512,
      [8614,"arrow-from-left"],
      'f343',
      
      'M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 288 240l-176 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L292.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80z'
      
    ]
  };

  
    var faArrowFromLeft = faArrowRightFromLine;
  

  
  

  var faIslandTropical = {
    prefix: 'fal',
    iconName: 'island-tropical',
    icon: [
      512,
      512,
      [127965,"island-tree-palm"],
      'f811',
      
      'M150.8 96L66.9 96C76.3 68.3 109.1 32 176 32c45.5 0 75.1 16.8 92.3 35.9c4.4 4.9 11.2 6.6 17.4 4.3C299.5 67.2 316.2 64 336 64c66.9 0 99.7 36.3 109.1 64l-184.3 0c-4.2 0-8.3 1.7-11.3 4.7L133.9 248.2c-13-26.2-15.4-75 31.8-122.3l.1-.1c11.4-11.4 22.8-19.8 33.9-26c7.7-4.3 10.5-14 6.3-21.7s-14-10.5-21.7-6.3C173 78.1 161.8 86 150.8 96zM176 0C91.6 0 45.8 49.5 34.7 92.2C29.1 113.6 47.7 128 64 128l58.1 0c-37.5 52.8-32.9 107.4-13.7 140.3c11.2 19.1 34.5 16.2 46.1 4.6l83.1-83.1c-.4 3.9-.9 7.9-1.4 12.1c-5.3 40.7-17 94.1-42.4 150.1L160 352C89.3 352 32 409.3 32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32c0-65-48.4-118.6-111.1-126.9c19.6-64.1 20.6-123.6 16.1-168.7c-.9-8.7-1.9-16.8-3.1-24.4L448 160c16.3 0 34.9-14.4 29.3-35.8C466.2 81.5 420.4 32 336 32c-19 0-36.1 2.5-51.4 6.9C260.8 16.5 224.7 0 176 0zM285.4 160c1.4 8.4 2.7 17.6 3.7 27.6c4.4 44 3.2 102.1-17.4 164.4l-43 0c23-54.6 34-106.1 39.2-145.9c2.3-18 3.5-33.6 4-46.1l13.5 0zM288 384c53 0 96 43 96 96L64 480c0-53 43-96 96-96l128 0z'
      
    ]
  };

  
    var faIslandTreePalm = faIslandTropical;
  

  
  

  var faBracketSquare = {
    prefix: 'fal',
    iconName: 'bracket-square',
    icon: [
      192,
      512,
      ["bracket","bracket-left"],
      '5b',
      
      'M0 80C0 53.5 21.5 32 48 32l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 64c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-26.5 0-48-21.5-48-48L0 80z'
      
    ]
  };

  
    var faBracket = faBracketSquare;
  
    var faBracketLeft = faBracketSquare;
  

  
  

  var faHighlighterLine = {
    prefix: 'fal',
    iconName: 'highlighter-line',
    icon: [
      576,
      512,
      [],
      'e1af',
      
      'M166.6 319.2L122.9 363c-3.1 3.1-3.1 8.2 0 11.3l62.8 62.8c3.1 3.1 8.2 3.1 11.3 0l43.7-43.7c6-6 14.1-9.4 22.6-9.4l48 0c5.2 0 10-2.5 13-6.7l19.4-27L209.6 216.3l-27 19.4c-4.2 3-6.7 7.8-6.7 13l0 48c0 8.5-3.4 16.6-9.4 22.6zm196 4.8L523.8 99.5c2.7-3.8 4.2-8.4 4.2-13c0-5.9-2.4-11.6-6.5-15.8L489.3 38.5c-4.2-4.2-9.9-6.5-15.8-6.5c-4.7 0-9.2 1.5-13 4.2L236 197.4 362.6 324zm-51.3 92l-48 0-43.7 43.7c-11.4 11.4-27.9 14.5-42 9.3l-36 36c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17l84-84c-5.2-14.2-2.1-30.7 9.3-42L144 296.6l0-48c0-15.5 7.4-30 20-39L441.8 10.2C451 3.6 462.1 0 473.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L350.4 396c-9 12.6-23.5 20-39 20zM111 407.6L38.6 480l82.7 0 31-31L111 407.6zM240 480l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFlaskGear = {
    prefix: 'fal',
    iconName: 'flask-gear',
    icon: [
      640,
      512,
      [],
      'e5f1',
      
      'M288 196.8L288 32 160 32l0 164.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320l203.7 0c2.2 13.3 10.3 25 21.2 32L81.2 352 37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480L351 480c15.6 13.1 36.9 13.7 53 4.8l0 .9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0L288 0l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 164.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-1.9 3.3-3.7 6.6-5.4 10l-14.8-24.1C292.9 232 288 214.6 288 196.8zm175.3 43c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5c12.8 11.4 18.5 27.7 18.5 42.4s-5.7 31-18.5 42.4L390.7 426c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7l33.7 0c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6c-12.6-7.2-23.5-20.2-26.5-36.7l-33.7 0zm43.5-32c11.8 0 21.4 9.6 21.4 21.4l0 1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 303.1c5.7 10.2 2.3 23.1-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29L592.5 450c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18l0 1.6c0 11.8-9.6 21.4-21.4 21.4l-53.4 0c-11.7 0-21.3-9.5-21.3-21.3l0-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.7-14.7-4.2-21.2-.3l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 403.1c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2l0-1.4c0-11.7 9.5-21.3 21.3-21.3l53.4 0zM424.1 353.1a56 56 0 1 1 112.1 0 56 56 0 1 1 -112.1 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCopyright = {
    prefix: 'fal',
    iconName: 'copyright',
    icon: [
      512,
      512,
      [169],
      'f1f9',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm67.9-188.1c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faSymbols = {
    prefix: 'fal',
    iconName: 'symbols',
    icon: [
      512,
      512,
      [128291,"icons-alt"],
      'f86e',
      
      'M16 0L208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 32C7.2 32 0 24.8 0 16S7.2 0 16 0zm0 64l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16L96 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16zM473.7 4.1C493.5 .2 512 15.3 512 35.5L512 168l-.2 0c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-91.4L352 61.1 352 200l-.2 0c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-97.8c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm16 148a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm171.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0zM480 464a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM76.4 256l8.6 0c32.6 0 59.1 26.4 59.1 59.1c0 18.1-8.3 35.2-22.6 46.4l-20.2 15.8 49.8 45.3 47.3-35.5c7.1-5.3 17.1-3.9 22.4 3.2s3.9 17.1-3.2 22.4l-42.4 31.8 43.5 39.6c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-48.1-43.7-46.8 35.1C91.3 507.5 77.8 512 64 512c-35.5 0-64-29.1-64-64.3c0-19.7 9-38.6 24.6-50.8l27.1-21.3L35.8 361C23.2 349.6 16 333.4 16 316.4C16 283 43 256 76.4 256zM57.3 337.4l20 18.2 24.4-19.2c6.5-5.1 10.3-13 10.3-21.3c0-14.9-12.1-27.1-27.1-27.1l-8.6 0C60.7 288 48 300.7 48 316.4c0 8 3.4 15.6 9.3 21zM44.4 422C36.6 428.2 32 437.7 32 447.7C32 465.5 46.5 480 64 480c6.9 0 13.7-2.2 19.2-6.4L125 442.2 75.8 397.4 44.4 422z'
      
    ]
  };

  
    var faIconsAlt = faSymbols;
  

  
  

  var faRulerCombined = {
    prefix: 'fal',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      'M192 192l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288 0 96c0 1.1 .1 2.2 .2 3.3C33.8 467.4 47.5 480 64 480l96 0 288 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm64 96l192 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-288 0-96 0C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5l0-96L0 64C0 28.7 28.7 0 64 0l96 0c35.3 0 64 28.7 64 64l0 192 0 32 32 0z'
      
    ]
  };

  

  
  

  var faSquareQ = {
    prefix: 'fal',
    iconName: 'square-q',
    icon: [
      448,
      512,
      [],
      'e27b',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 256c0 53 43 96 96 96c20.7 0 39.9-6.6 55.6-17.7l-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.9 50.9C313.4 295.9 320 276.7 320 256c0-53-43-96-96-96s-96 43-96 96zm224 0c0 29.6-10 56.8-26.9 78.5l22.2 22.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.2-22.2C280.8 374 253.6 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z'
      
    ]
  };

  

  
  

  var faLinesLeaning = {
    prefix: 'fal',
    iconName: 'lines-leaning',
    icon: [
      384,
      512,
      [],
      'e51e',
      
      'M190.9 53.7c3.2-8.2-.9-17.5-9.2-20.7s-17.5 .9-20.7 9.2l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l160-416zm84.7-21.3c-8.6-2-17.2 3.4-19.2 12l-96 416c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l96-416c2-8.6-3.4-17.2-12-19.2zM368 32c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faArrowDownToBracket = {
    prefix: 'fal',
    iconName: 'arrow-down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e094',
      
      'M363.3 219.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 281.4L340.7 196.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 336l0 96c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faArrowDownUpLock = {
    prefix: 'fal',
    iconName: 'arrow-down-up-lock',
    icon: [
      640,
      512,
      [],
      'e4b0',
      
      'M139.3 507.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L144 457.4 144 272l160 0 32 0 80 0c0-11.1 1.6-21.9 4.6-32L336 240l0-185.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 54.6 304 240l-160 0-32 0-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 185.4L43.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM144 200l0-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 152 32 0zM336 312l-32 0 0 152c0 8.8 7.2 16 16 16s16-7.2 16-16l0-152zm192-88c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faTrashArrowUp = {
    prefix: 'fal',
    iconName: 'trash-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore"],
      'f829',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64l47.1 0L416 64l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-18.3 0L388.2 452.6C385.9 486.1 358 512 324.4 512l-200.8 0c-33.6 0-61.4-25.9-63.8-59.4L34.3 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32.1 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480l200.8 0c16.8 0 30.7-13 31.9-29.7L381.6 96 66.4 96zM224 176c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6 240 392c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-161.4-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z'
      
    ]
  };

  
    var faTrashRestore = faTrashArrowUp;
  

  
  

  var faKeySkeleton = {
    prefix: 'fal',
    iconName: 'key-skeleton',
    icon: [
      448,
      512,
      [128477],
      'f6f3',
      
      'M304 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 34 11.8 65.2 31.5 89.9L4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 432 80 390.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L102.6 368 214.1 256.5C238.8 276.2 270 288 304 288z'
      
    ]
  };

  

  
  

  var faDownFromBracket = {
    prefix: 'fal',
    iconName: 'down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e66b',
      
      'M225.8 479.2c-.5 .5-1.1 .8-1.8 .8s-1.4-.3-1.8-.8L97.8 347.3c-1.2-1.2-1.8-2.9-1.8-4.6c0-3.7 3-6.7 6.7-6.7l57.3 0c8.8 0 16-7.2 16-16l0-120c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8l0 120c0 8.8 7.2 16 16 16l57.3 0c3.7 0 6.7 3 6.7 6.7c0 1.7-.6 3.3-1.8 4.6L225.8 479.2zM224 512c9.5 0 18.6-3.9 25.1-10.8L373.5 369.2c6.8-7.2 10.5-16.7 10.5-26.5c0-21.4-17.3-38.7-38.7-38.7L304 304l0-104c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40l0 104-41.3 0C81.3 304 64 321.3 64 342.7c0 9.9 3.8 19.4 10.5 26.5L198.9 501.2c6.5 6.9 15.6 10.8 25.1 10.8zM416 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-44.2-35.8-80-80-80L80 0C35.8 0 0 35.8 0 80l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 96z'
      
    ]
  };

  

  
  

  var faTractor = {
    prefix: 'fal',
    iconName: 'tractor',
    icon: [
      640,
      512,
      [128668],
      'f722',
      
      'M128 48l0 111.2c6.9-18.3 24.5-31.2 45-31.2l38.1 0c21.7 0 40.3 14.5 46.1 34.7c12.6-7 27.6-7.8 40.7-2.7l.4 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .4 0L289.9 41.4c-2.6-5.7-8.3-9.4-14.6-9.4L144 32c-8.8 0-16 7.2-16 16zM96 157.3L96 48c0-26.5 21.5-48 48-48L275.3 0c18.9 0 36 11.1 43.8 28.3L378.3 160l.3 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .6 0 .6 0 .7 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .2 0 0-40.2c0-29.7 11.8-58.2 32.8-79.2l3.9-3.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-3.9 3.9c-15 15-23.4 35.4-23.4 56.6l0 40.2 .2 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0c22.2 0 39.9 18 39.9 40l0 60.5c0 12.2-5.5 23.6-15 31.2L567.1 338c-11.3 9.1-25.4 14-40 14l-144.9 0c-4.4 15.9-16.9 28.5-32.9 33.2c10.2 18.4 7.3 41.8-8.1 57.1l-26.9 26.9c-15.3 15.4-38.7 18.3-57.1 8.1C251.3 497.5 232.7 512 211 512L173 512c-21.7 0-40.3-14.5-46.1-34.7c-18.4 10.2-41.8 7.3-57.1-8.1L42.8 442.3l11-11-11 11c-15.3-15.4-18.3-38.7-8.1-57.1C14.5 379.3 0 360.7 0 339L0 301c0-21.7 14.5-40.3 34.7-46.1c-10.2-18.4-7.3-41.8 8.1-57.1l26.9-26.9c7.4-7.4 16.6-11.9 26.3-13.4zM384 320l143.2 0c7.3 0 14.3-2.5 20-7L605 266.7c1.9-1.5 3-3.8 3-6.2l0-60.5c0-4.5-3.6-8-7.9-8l-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.7 0-.6 0-.6 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0c0 0-.1 0-.1 0c-.2 0-.5 0-.7 0l-.6 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.6 0 5.7 5.7c15.4 15.4 18.3 38.7 8.1 57.1c20.2 5.8 34.7 24.4 34.7 46.1l0 19zM512 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM157 174.4l-1.3 12.9c-.6 6-4.5 11.1-10.1 13.3c-1.8 .7-3.5 1.4-5.2 2.2c-5.5 2.4-11.9 1.6-16.6-2.3l-10.1-8.2c-6.4-5.2-15.6-4.7-21.4 1.1L65.4 220.3c-5.8 5.8-6.3 15.1-1.1 21.4l8.2 10.1c3.8 4.7 4.7 11.1 2.3 16.6c-.8 1.7-1.5 3.5-2.2 5.2c-2.2 5.6-7.3 9.5-13.3 10.1L46.4 285C38.2 285.9 32 292.7 32 301L32 339c0 8.2 6.2 15.1 14.4 15.9l12.9 1.3c6 .6 11.1 4.5 13.3 10.1c.7 1.8 1.4 3.5 2.2 5.2c2.4 5.5 1.6 11.9-2.3 16.6l-8.2 10.1c-5.2 6.4-4.7 15.6 1.1 21.4l26.9 26.9c5.8 5.8 15.1 6.3 21.4 1.1l10.1-8.2c4.7-3.8 11.1-4.7 16.6-2.3c1.7 .8 3.5 1.5 5.2 2.2c5.6 2.2 9.5 7.3 10.1 13.3l1.3 12.9c.8 8.2 7.7 14.4 15.9 14.4l38.1 0c8.2 0 15.1-6.2 15.9-14.4l1.3-12.9c.6-6 4.5-11.1 10.1-13.3c1.8-.7 3.5-1.4 5.2-2.2c5.5-2.4 11.9-1.6 16.6 2.3l10.1 8.2c6.4 5.2 15.6 4.7 21.4-1.1l26.9-26.9c5.8-5.8 6.3-15.1 1.1-21.4l-8.2-10.1c-3.8-4.7-4.7-11.1-2.3-16.6c.8-1.7 1.5-3.4 2.2-5.2c2.2-5.6 7.3-9.5 13.3-10.1l12.9-1.3c8.2-.8 14.4-7.7 14.4-15.9l0-38.1c0-8.2-6.2-15.1-14.4-15.9l-12.9-1.3c-6-.6-11.1-4.5-13.3-10.1c-.7-1.8-1.4-3.5-2.2-5.2c-2.4-5.5-1.6-11.9 2.3-16.6l8.2-10.1c5.2-6.4 4.7-15.6-1.1-21.4l-26.9-26.9c-5.8-5.8-15.1-6.3-21.4-1.1l-10.1 8.2c-4.7 3.8-11.1 4.7-16.6 2.3c-1.7-.8-3.5-1.5-5.2-2.2c-5.6-2.2-9.5-7.3-10.1-13.3L227 174.4c-.8-8.2-7.7-14.4-15.9-14.4L173 160c-8.2 0-15.1 6.2-15.9 14.4zM137.6 320a54.4 54.4 0 1 0 108.8 0 54.4 54.4 0 1 0 -108.8 0zM192 406.4a86.4 86.4 0 1 1 0-172.8 86.4 86.4 0 1 1 0 172.8z'
      
    ]
  };

  

  
  

  var faQuoteLeft = {
    prefix: 'fal',
    iconName: 'quote-left',
    icon: [
      448,
      512,
      [8220,"quote-left-alt"],
      'f10d',
      
      'M0 208C0 146.1 50.1 96 112 96l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-44.2 0-80 35.8-80 80l0 24.6c9.4-5.4 20.3-8.6 32-8.6l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-80zm32 80l0 32 0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm352-32l-64 0c-17.7 0-32 14.3-32 32l0 32 0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zM256 320l0-32 0-80c0-61.9 50.1-112 112-112l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-44.2 0-80 35.8-80 80l0 24.6c9.4-5.4 20.3-8.6 32-8.6l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32z'
      
    ]
  };

  
    var faQuoteLeftAlt = faQuoteLeft;
  

  
  

  var faUsersLine = {
    prefix: 'fal',
    iconName: 'users-line',
    icon: [
      640,
      512,
      [],
      'e592',
      
      'M147.2 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 288l-96 0c-35.3 0-64 28.7-64 64l224 0c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96l96 0c53 0 96 43 96 96c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 288l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l88 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-88 0c-17.7 0-32 14.3-32 32zm480-32l-88 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l88 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32zM16 448l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBaby = {
    prefix: 'fal',
    iconName: 'baby',
    icon: [
      448,
      512,
      [],
      'f77c',
      
      'M224 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM46.1 146.8c20.5-23.1 55.9-25.2 79.1-4.7l24.2 21.5C169.9 181.9 196.5 192 224 192s54.1-10.1 74.6-28.4l24.2-21.5c23.1-20.5 58.5-18.5 79.1 4.7s18.5 58.5-4.6 79.1L373 247.3c-16.1 14.3-33.9 26-53 35.1l0 32.3 49.9 56.1c16.9 19 18.9 47.1 4.7 68.3l-32 48c-17.2 25.7-51.9 32.7-77.7 15.5s-32.7-51.9-15.5-77.7l8-12L238.9 392l-29.7 0-18.6 20.9 8 12c17.2 25.7 10.2 60.5-15.5 77.7s-60.5 10.2-77.7-15.5l-32-48c-14.1-21.2-12.2-49.2 4.7-68.3L128 314.7l0-26.7c0 0 0 0 0-.1s0 0 0-.1l0-5.5c-19.1-9-37-20.8-53-35.1L50.8 225.9c-23.1-20.5-25.2-55.9-4.7-79.1zM160 304l0 16.8c0 .2 0 .4 0 .6l38.9 38.9c1-.2 2-.3 3-.3l44.1 0c1 0 2 .1 3 .3L288 321.4c0-.2 0-.4 0-.6l0-16.8-128 0zm128-32c0-6.5 3.9-12.3 9.9-14.7c19.6-8.1 37.8-19.5 53.9-33.8l24.2-21.5c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2l-24.2 21.5C293.5 211 259.3 224 224 224s-69.5-13-95.9-36.5l-24.2-21.5c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9l24.2 21.5c16.1 14.3 34.4 25.7 53.9 33.8c6 2.5 9.8 8.3 9.9 14.7l128 0zm18.7 75.9l-34 34 16.8 19c4.8 5.4 5.4 13.4 1.4 19.5L276 442.7c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c6.1-9.1 5.2-21.1-2-29.3l-39.2-44.1zm-131.4 34l-34-34-39.2 44.1c-7.3 8.2-8.1 20.2-2 29.3l32 48c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-14.9-22.3c-4-6.1-3.5-14.1 1.4-19.5l16.8-19z'
      
    ]
  };

  

  
  

  var faCirclePhoneFlip = {
    prefix: 'fal',
    iconName: 'circle-phone-flip',
    icon: [
      512,
      512,
      ["phone-circle-alt"],
      'e11c',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm52.8 144.1c-1.9-.4-3.8 .6-4.5 2.3l-24 56c-.7 1.6-.2 3.5 1.1 4.7l20.3 16.6c6.1 5 7.6 13.6 3.7 20.4c-14.7 25.4-35.9 46.6-61.4 61.4c-6.8 3.9-15.4 2.4-20.4-3.7l-16.6-20.3c-1.1-1.4-3-1.8-4.7-1.1l-56 24c-1.8 .8-2.7 2.6-2.3 4.5l12 56c.4 1.8 2 3.2 3.9 3.2l.2 0c114.7-.1 207.6-93.1 207.7-207.8l0-.2s0 0 0 0s0 0 0 0c0-1.9-1.3-3.5-3.2-3.9l-56-12zM160 400l-.3 0c-16.8-.2-31.3-12-34.9-28.5l-12-56c-3.6-16.8 5.2-33.9 21-40.6l56-24c14.7-6.3 31.9-2.1 42 10.3l7.5 9.2c11.9-8.6 22.4-19.1 31-31l-9.2-7.5c-12.4-10.2-16.6-27.3-10.3-42l24-56c6.8-15.8 23.8-24.6 40.6-21l56 12c16.5 3.5 28.3 18.1 28.5 34.9l0 .3c0 132.5-107.4 240-240 240z'
      
    ]
  };

  
    var faPhoneCircleAlt = faCirclePhoneFlip;
  

  
  

  var faBuildingShield = {
    prefix: 'fal',
    iconName: 'building-shield',
    icon: [
      576,
      512,
      [],
      'e4d8',
      
      'M320 32L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0c1.3 0 2.6-.1 3.9-.2c7.9 8.6 16.6 16.9 26.3 24.7c-9 4.8-19.3 7.6-30.2 7.6l-64 0-32 0-64 0-32 0-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 143-32 12.8L352 64c0-17.7-14.3-32-32-32zM272 240c-8.8 0-16 7.2-16 16l0 32 0 8.2 0 23.8-8 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c8.2 0 15.4 4.1 19.7 10.3L301.6 240 272 240zM192 384c-17.7 0-32 14.3-32 32l0 64 64 0 0-64c0-17.7-14.3-32-32-32zM88 96l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zm128-40c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zM88 224l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zm224.1 13.4c1.3 53 22.6 129.5 95.9 170L416 263l-95.9 38.4zm223.9 0L448 263l0 208.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z'
      
    ]
  };

  

  
  

  var faCartCircleXmark = {
    prefix: 'fal',
    iconName: 'cart-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e3f4',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2l129.5 0c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16l-129.5 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l187.2 0c5.9-11.4 12.9-22.2 21-32l-214.8 0L106.1 64l433.4 0L507.4 192.4c10.9 .7 21.5 2.4 31.7 5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm136-88a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faFaceSmileTongue = {
    prefix: 'fal',
    iconName: 'face-smile-tongue',
    icon: [
      512,
      512,
      [],
      'e394',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c36.4 0 71-7.6 102.4-21.3c8.1-3.5 11.8-13 8.3-21.1s-13-11.8-21.1-8.3c-27.4 12-57.7 18.6-89.6 18.6C132.3 480 32 379.7 32 256zm124.5-61.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 161.9 194.8 152 176 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm160 0c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 161.9 354.8 152 336 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-224.6 78c-8.5 2.3-13.6 11.1-11.3 19.6C102 372.3 171.9 432 256 432c31 0 60.1-8.1 85.5-22.4l45.3 29.6c36.8 24 86.2 12.2 108.2-25.8l1.4-2.4c21.4-37.1 9.8-84.4-26.3-107.5l-45.2-28.8c-1.4-1-3-1.7-4.8-2.2c-8.5-2.3-17.3 2.8-19.6 11.3C382.5 351.5 324.1 400 256 400s-126.5-48.5-144.5-116.1c-2.3-8.5-11.1-13.6-19.6-11.3zm278 117.4C394 369.6 413 343 424.8 312.6l28.1 17.9c21.7 13.8 28.6 42.2 15.8 64.5l-1.4 2.4c-12.8 22.2-41.6 29-63 15l-34.4-22.5z'
      
    ]
  };

  

  
  

  var faPesoSign = {
    prefix: 'fal',
    iconName: 'peso-sign',
    icon: [
      384,
      512,
      [],
      'e222',
      
      'M71.4 32C49.6 32 32 49.6 32 71.4L32 128l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 80 0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 128 0c65.6 0 122-39.5 146.7-96l29.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-29.3 0C314 71.5 257.6 32 192 32L71.4 32zm231.5 96L64 128l0-56.6c0-4.1 3.3-7.4 7.4-7.4L192 64c47.4 0 88.7 25.7 110.9 64zM64 160l252 0c2.6 10.2 4 21 4 32s-1.4 21.8-4 32L64 224l0-64zm238.9 96c-22.1 38.3-63.5 64-110.9 64L64 320l0-64 238.9 0z'
      
    ]
  };

  

  
  

  var faClawMarks = {
    prefix: 'fal',
    iconName: 'claw-marks',
    icon: [
      576,
      512,
      [],
      'f6c2',
      
      'M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0L170.9 116.3c13.5 13.5 21.1 31.8 21.1 50.9l0 24.8 24.8 0c19.1 0 37.4 7.6 50.9 21.1l95.2 95.2c13.5 13.5 21.1 31.8 21.1 50.9l0 24.8 24.8 0c19.1 0 37.4 7.6 50.9 21.1l79.6 79.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79.6-79.6c-7.5-7.5-17.7-11.7-28.3-11.7L368 416c-8.8 0-16-7.2-16-16l0-40.8c0-10.6-4.2-20.8-11.7-28.3l-95.2-95.2c-7.5-7.5-17.7-11.7-28.3-11.7L176 224c-8.8 0-16-7.2-16-16l0-40.8c0-10.6-4.2-20.8-11.7-28.3L36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm0 224c6.2-6.2 16.4-6.2 22.6 0l81.9 81.9c12 12 18.7 28.3 18.7 45.3l0 28.1 28.1 0c17 0 33.3 6.7 45.3 18.7l81.9 81.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-81.9-81.9c-6-6-14.1-9.4-22.6-9.4L144 416c-8.8 0-16-7.2-16-16l0-44.1c0-8.5-3.4-16.6-9.4-22.6L36.7 251.3c-6.2-6.2-6.2-16.4 0-22.6zM283.3 4.7l17.9 17.9c12 12 18.7 28.3 18.7 45.3L320 96l28.1 0c17 0 33.3 6.7 45.3 18.7l35.9 35.9c12 12 18.7 28.3 18.7 45.3l0 28.1 28.1 0c17 0 33.3 6.7 45.3 18.7l17.9 17.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-17.9-17.9c-6-6-14.1-9.4-22.6-9.4L432 256c-8.8 0-16-7.2-16-16l0-44.1c0-8.5-3.4-16.6-9.4-22.6l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4L304 128c-8.8 0-16-7.2-16-16l0-44.1c0-8.5-3.4-16.6-9.4-22.6L260.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faRhombus = {
    prefix: 'fal',
    iconName: 'rhombus',
    icon: [
      448,
      512,
      [],
      'e23b',
      
      'M438.5 230.1l-184-216C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9zM230.1 34.8l184 216c2.5 3 2.5 7.4 0 10.4l-184 216c-1.5 1.8-3.7 2.8-6.1 2.8s-4.6-1-6.1-2.8l-184-216c-2.5-3-2.5-7.4 0-10.4l184-216c1.5-1.8 3.7-2.8 6.1-2.8s4.6 1 6.1 2.8z'
      
    ]
  };

  

  
  

  var faChalkboardUser = {
    prefix: 'fal',
    iconName: 'chalkboard-user',
    icon: [
      640,
      512,
      ["chalkboard-teacher"],
      'f51c',
      
      'M576 32L224 32c-17.7 0-32 14.3-32 32l0 36c-10.2-2.6-21-4-32-4l0-32c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-16 0-160 0-16 0-47.2 0c-5.3-11.4-11.8-22.2-19.5-32l66.7 0 0-48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 48c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32zM544 384l0-48c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 48 128 0zM224 224A64 64 0 1 0 96 224a64 64 0 1 0 128 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM32.1 480l255.7 0c-2.8-53.5-47-96-101.2-96l-53.3 0c-54.2 0-98.4 42.5-101.2 96zM0 485.3C0 411.7 59.7 352 133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3z'
      
    ]
  };

  
    var faChalkboardTeacher = faChalkboardUser;
  

  
  

  var faArrowsUpDownLeftRight = {
    prefix: 'fal',
    iconName: 'arrows-up-down-left-right',
    icon: [
      512,
      512,
      ["arrows"],
      'f047',
      
      'M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6 240 240 54.6 240l44.7-44.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 240 272l0 185.4-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 457.4 272 272l185.4 0-44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6l-72-72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 272 240l0-185.4 44.7 44.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72-72z'
      
    ]
  };

  
    var faArrows = faArrowsUpDownLeftRight;
  

  
  

  var faFaceSmirking = {
    prefix: 'fal',
    iconName: 'face-smirking',
    icon: [
      512,
      512,
      [],
      'e397',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm375.8 82.6l-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2L192 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l112.6 0c19.6 0 36.2-14.1 39.5-33.4l.2-1.2c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fal',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faCloudCheck = {
    prefix: 'fal',
    iconName: 'cloud-check',
    icon: [
      640,
      512,
      [],
      'e35c',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM427.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 329.4 404.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faFort = {
    prefix: 'fal',
    iconName: 'fort',
    icon: [
      640,
      512,
      [],
      'e486',
      
      'M32 96l64 0 32 0 64 0 0 16 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48 0-16zM0 160c0 23.7 12.9 44.4 32 55.4l0 8.6 0 224c0 35.3 28.7 64 64 64l144 0 32 0 96 0 32 0 144 0c35.3 0 64-28.7 64-64l0-224 0-8.6c19.1-11.1 32-31.7 32-55.4l0-48 0-16 0-32 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 0 32-32 0-32 0 0-32 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 0 32-32 0-32 0 0-32 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 32 0 16 0 48c0 11.7 3.1 22.6 8.6 32l-209.1 0c5.4-9.4 8.6-20.3 8.6-32l0-48 0-16 0-32 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 0 32-32 0-32 0 0-32 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 0 32L64 64 32 64l0-32 0-16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 64 0 96l0 16 0 48zM400 480l0-80c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 80-48 0 0-256 256 0 0 256-48 0zm80-256l96 0 0 224c0 17.7-14.3 32-32 32l-64 0 0-256zM64 448l0-224 96 0 0 256-64 0c-17.7 0-32-14.3-32-32zm304 32l-96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80zM608 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48 0-16 64 0 32 0 64 0 0 16 0 48z'
      
    ]
  };

  

  
  

  var faComputer = {
    prefix: 'fal',
    iconName: 'computer',
    icon: [
      640,
      512,
      [],
      'e4e5',
      
      'M384 64c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-108.5 0L264 352l-80 0-11.5 0L64 352c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 384l97.8 0-21.3 64L80 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l49.8 0 22.2 0 144 0 22.2 0 49.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-60.5 0-21.3-64 97.8 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64zm110.2 64l21.3-64 56.9 0 21.3 64-99.6 0zM528 64l64 0c8.8 0 16 7.2 16 16l0 48-96 0 0-48c0-8.8 7.2-16 16-16zm-16 96l96 0 0 32-96 0 0-32zm0 272l0-208 96 0 0 208c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zM480 80l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'fal',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      'M144 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L32 64l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 48c0-8.8 7.2-16 16-16l128 0zM0 336c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16L0 336zM432 32c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112L304 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0zM416 336c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-112z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fal',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faHatBeach = {
    prefix: 'fal',
    iconName: 'hat-beach',
    icon: [
      640,
      512,
      [],
      'e606',
      
      'M192 224l0 10.8 0 3.9c.3 .5 1.1 1.5 2.6 2.9c4.2 4 11.9 9 24.2 13.9C243.1 265.3 278.8 272 320 272c11.5 0 22.6-.5 33.1-1.5c-.7-3.8-1.1-7.7-1.1-11.8c0-12.5 3.8-24.6 10.8-34.7c-.5-.7-1-1.4-1.4-2.2c-13.2 1.4-27.1 2.2-41.4 2.2c-44.2 0-84.2-7.2-113.1-18.7c-4.4-1.8-8.6-3.7-12.5-5.6c-1.5 7.9-2.3 16-2.3 24.4zm160-34.7c0-31.1 23.2-56.8 53.3-60.7C382.6 108.3 352.7 96 320 96c-50.9 0-94.9 29.7-115.5 72.8c3.8 2.2 8.6 4.5 14.2 6.8C243.1 185.3 278.8 192 320 192c11.1 0 21.8-.5 32-1.4c0-.4 0-.9 0-1.3zM320 64c55.7 0 104.7 28.4 133.3 71.5c8.9-4.9 19-7.5 29.4-7.5c33.8 0 61.3 27.4 61.3 61.3c0 12.5-3.8 24.6-10.8 34.7c5.2 7.6 8.7 16.2 10.1 25.3l67 26.8c17.9 7.2 29.7 24.6 29.7 43.9c0 17.7-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7C8.9 354.5 0 337.7 0 320c0-19.3 11.8-36.7 29.7-43.9L160 224c0-88.4 71.6-160 160-160zM482.7 320c-12.5 0-24.6-3.8-34.7-10.8c-10.1 7-22.2 10.8-34.7 10.8c-17.5 0-33.2-7.3-44.4-19c-15.4 2-31.8 3-48.9 3c-44.2 0-84.2-7.2-113.1-18.7c-14.5-5.8-26.2-12.7-34.3-20.3c-2.9-2.8-5.4-5.6-7.3-8.6L41.6 305.8c-5.8 2.3-9.6 7.9-9.6 14.2c0 6.1 2.9 15 15.1 26.6c12.3 11.6 31.8 23.5 58.5 34.2C158.9 402.1 234.7 416 320 416s161.1-13.9 214.4-35.2c26.7-10.7 46.2-22.6 58.5-34.2C605.1 335 608 326.1 608 320c0-6.2-3.8-11.9-9.6-14.2l-59.1-23.6c-9.2 22.2-31.1 37.8-56.6 37.8zM413.3 160c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7l2.7 2.7c6.2 6.2 6.2 16.4 0 22.6l-2.7 2.7c-5.5 5.5-8.6 12.9-8.6 20.7c0 16.2 13.1 29.3 29.3 29.3c7.8 0 15.2-3.1 20.7-8.6l2.7-2.7c6.2-6.2 16.4-6.2 22.6 0l2.7 2.7c5.5 5.5 12.9 8.6 20.7 8.6c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7l-2.7-2.7c-6.2-6.2-6.2-16.4 0-22.6l2.7-2.7c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-2.7 2.7c-6.2 6.2-16.4 6.2-22.6 0l-2.7-2.7c-5.5-5.5-12.9-8.6-20.7-8.6zM448 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSquarePhone = {
    prefix: 'fal',
    iconName: 'square-phone',
    icon: [
      448,
      512,
      ["phone-square"],
      'f098',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm175 44.1l-64 16c-1.8 .4-3 2-3 3.9c0 114.9 97.1 212 212 212c1.8 0 3.4-1.3 3.9-3l16-64c.5-2-.6-4.1-2.6-4.8l-48-16c-1.4-.5-3-.1-4.1 1l-24.4 24.4c-5 5-12.6 6.1-18.8 2.8c-31.5-16.7-57.7-42.9-74.4-74.4c-3.3-6.2-2.1-13.8 2.8-18.8l24.4-24.4c1.1-1.1 1.4-2.7 1-4.1l-16-48c-.7-2-2.7-3.1-4.8-2.6zm35.1-7.5l16 48c4.3 12.9 .9 27.2-8.7 36.8l-15.7 15.7c11.5 18.1 27 33.6 45.1 45.1l15.7-15.7c9.6-9.6 23.9-13 36.8-8.7l48 16c17.8 5.9 28.1 24.6 23.5 42.9l-16 64c-4 16-18.4 27.3-34.9 27.3C187.5 404 76 292.5 76 160c0-16.5 11.2-30.9 27.3-34.9l64-16c18.2-4.6 36.9 5.7 42.9 23.5z'
      
    ]
  };

  
    var faPhoneSquare = faSquarePhone;
  

  
  

  var fa2 = {
    prefix: 'fal',
    iconName: '2',
    icon: [
      320,
      512,
      [],
      '32',
      
      'M148 64c-28.8 0-56.9 11.5-77.2 31.8L43.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L48.2 73.1C74.6 46.8 110.9 32 148 32c76.5 0 140 61.9 140 138.8c0 38.4-15.9 75-43.9 101.3L56.5 448 304 448c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-6.6 0-12.5-4-14.9-10.1s-.9-13.1 3.9-17.6L222.2 248.7c21.5-20.2 33.8-48.4 33.8-77.9C256 112 207.2 64 148 64z'
      
    ]
  };

  

  
  

  var faGun = {
    prefix: 'fal',
    iconName: 'gun',
    icon: [
      576,
      512,
      [],
      'e19b',
      
      'M496 32c8.8 0 16 7.2 16 16l0 16 32 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32l-57.4 0L464 230.6c-6 6-14.1 9.4-22.6 9.4l-46.1 0-28.6 80.1c-6.8 19.1-24.9 31.9-45.2 31.9L233 352 207 455.8C203.5 470 190.7 480 176 480L64 480c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L73.1 279.8c5-20.2-10.2-39.8-31-39.8l-10 0c-17.7 0-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64l448 0 0-16c0-8.8 7.2-16 16-16zM241 320l80.5 0c6.8 0 12.8-4.3 15.1-10.6L361.3 240 261 240l-20 80zM32 96l0 112 10 0 15.2 0L235 208l1 0 14.9 0 16.1 0 174.3 0L464 185.4c6-6 14.1-9.4 22.6-9.4l57.4 0 0-80-48 0L32 96zM228 240L97.5 240c8 13.7 10.9 30.5 6.7 47.5L64 448l112 0 52-208z'
      
    ]
  };

  

  
  

  var faChildCombatant = {
    prefix: 'fal',
    iconName: 'child-combatant',
    icon: [
      576,
      512,
      ["child-rifle"],
      'e4e0',
      
      'M144 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM480 336l0-10.7 52.2-17.4 .9-.3c6.5-2.2 10.9-8.3 10.9-15.2l0-12.5 0-72c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 24-32 8 0-8 0-24 0-1 0-47 0-48c0-17.7-14.3-32-32-32l0-32 0-64 0-16c0-8.8-7.2-16-16-16L416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 32 0 32 0 32c-17.7 0-32 14.3-32 32l0 34.7c-18.6 6.6-32 24.4-32 45.3l0 112c0 19.9 12.1 36.9 29.3 44.2c.9 .4 1.8 .7 2.7 1l0 82.7 0 16c0 8.8 7.2 16 16 16l16 0 60.1 0 19.9 0c4.9 0 9.4-2.2 12.5-6s4.2-8.7 3.1-13.5l-4.3-19.5L498.2 432l-7.1-32 32.8 0 4.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-36.9 0-7.1 0L480 350.2l0-14.2zm-27.3 38.9l5.6 25.1 1.5 6.9 9.1 41.1 7.1 32L448 480l-4.7 0L416 480l0-32 0-50.7 0-13.3c0-4.2-1.6-8-4.3-10.9c-2.9-3.2-7.1-5.1-11.7-5.1c-6.4 0-12-3.8-14.5-9.3c-.7-1.6-1.2-3.3-1.4-5.1c-.1-.5-.1-1-.1-1.6l0-112c0-2.4 .5-4.7 1.5-6.7c2.5-5.5 8.1-9.3 14.5-9.3c4.6 0 8.8-2 11.7-5.1c2.6-2.9 4.3-6.7 4.3-10.9l0-13.3 0-2.7 0-32 32 0 0 32 0 16 0 48 0 32 0 8 0 6.3 0 23.1 0 3.7 0 7 0 14.2 0 1.8c0 1.2 .1 2.3 .4 3.5c0 0 0 0 0 0l.4 1.7 2.4 10.8 1.5 6.9zM144 199.9c7.7-5.1 16.8-7.9 26.3-7.9l11.3 0c9.5 0 18.6 2.8 26.3 7.9l0 .1 0 152-64 0 0-152 0-.1zM144 384l64 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-252.7 42.4 69.1c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-59.8-97.5c-14.5-23.7-40.4-38.2-68.2-38.2l-11.3 0c-27.8 0-53.7 14.5-68.2 38.2L42.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3L112 243.3 112 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112z'
      
    ]
  };

  
    var faChildRifle = faChildCombatant;
  

  
  

  var faKeynote = {
    prefix: 'fal',
    iconName: 'keynote',
    icon: [
      512,
      512,
      [],
      'f66c',
      
      'M304 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zM240 0c-20.9 0-38.7 13.4-45.3 32L184 32c-44.2 0-80 35.8-80 80l0 48-10.3 0c-18.2 0-34.8 10.3-42.9 26.5L5.1 277.9c-3.3 6.7-5.1 14-5.1 21.5L0 304l0 48c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-48 0-4.7c0-7.5-1.7-14.8-5.1-21.5l-45.7-91.3c-8.1-16.3-24.8-26.5-42.9-26.5L136 160l0-48c0-26.5 21.5-48 48-48l10.7 0c6.6 18.6 24.4 32 45.3 32l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L240 0zM32 352l0-32 448 0 0 32L32 352zm3.8-64l43.6-87.2c2.7-5.4 8.3-8.8 14.3-8.8l324.7 0c6.1 0 11.6 3.4 14.3 8.8L476.2 288 35.8 288zM144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-64-32 0 0 64-96 0z'
      
    ]
  };

  

  
  

  var faShareFromSquare = {
    prefix: 'fal',
    iconName: 'share-from-square',
    icon: [
      576,
      512,
      [61509,"share-square"],
      'f14d',
      
      'M400 280l0-40 0-16c0-8.8-7.2-16-16-16l-16 0-16 0-16 0-46.5 0c-53.8 0-97.5 43.6-97.5 97.5c0 5.3 .7 10.3 1.9 15C175.5 301.9 160 276 160 240c0-70.7 57.3-128 128-128l48 0 32 0 16 0c8.8 0 16-7.2 16-16l0-16 0-40c0-4.4 3.6-8 8-8c2.1 0 4 .8 5.5 2.2l128.8 122c1 1 1.6 2.3 1.6 3.8s-.6 2.8-1.6 3.8l-128.8 122c-1.5 1.4-3.5 2.2-5.5 2.2c-4.5 0-8-3.6-8-8zm-32-40l0 32 0 8c0 22.1 18 40 40 40c10.2 0 20.1-3.9 27.5-11L564.4 187c7.4-7 11.6-16.8 11.6-27s-4.2-20-11.6-27L435.6 11c-7.4-7-17.3-11-27.5-11C386 0 368 17.9 368 40l0 8 0 32-32 0-48 0c-88.4 0-160 71.6-160 160c0 93.4 82.8 134.8 100.6 142.6c2.2 1 4.6 1.4 7.1 1.4c11.2 0 20.3-9.1 20.3-20.3l0-.9c0-6.8-3.3-13.1-8.3-17.7c-9.5-8.6-23.7-24.1-23.7-39.7c0-36.1 29.3-65.5 65.5-65.5l46.5 0 16 0 16 0zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32z'
      
    ]
  };

  
    var faShareSquare = faShareFromSquare;
  

  
  

  var faGrip = {
    prefix: 'fal',
    iconName: 'grip',
    icon: [
      448,
      512,
      ["grip-horizontal"],
      'f58d',
      
      'M408 384c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 192c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 384l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8zm48 32l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 384l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8zm48 32l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z'
      
    ]
  };

  
    var faGripHorizontal = faGrip;
  

  
  

  var faJackOLantern = {
    prefix: 'fal',
    iconName: 'jack-o-lantern',
    icon: [
      576,
      512,
      [127875],
      'f30e',
      
      'M272.6 96.7c-13.2 1.1-26.1 3.8-38.3 7.7l41.1-94c2.8-6.3 9-10.4 15.8-10.4l1.2 0c2.3 0 4.7 .5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9l0 72.6c-10.2-4-20.9-7.1-32-9.1l0-53.8-20.9-9L272.6 96.7zm-94.7 38c-4 3.2-7.3 6.9-10 10.9c-5.3-1-10.6-1.5-16-1.5c-31.3 0-60.9 17.1-83.3 47.4S32 264.3 32 312s14.3 90.3 36.7 120.6s52 47.4 83.3 47.4c20.7 0 40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C247.4 472.5 267.3 480 288 480s40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C383.4 472.5 403.3 480 424 480c31.3 0 60.9-17.1 83.3-47.4S544 359.7 544 312s-14.3-90.3-36.7-120.6s-52-47.4-83.3-47.4c-5.4 0-10.8 .5-16 1.5c-2.7-4-6-7.7-10-10.9c-6.2-4.9-12.7-9.5-19.5-13.6c14.3-5.8 29.5-9 45.5-9c43.8 0 82.2 24.1 109 60.4s43 85.7 43 139.6s-16.1 103.3-43 139.6S467.8 512 424 512c-24.7 0-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9s-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9c-43.8 0-82.2-24.1-109-60.4S0 365.9 0 312s16.1-103.3 43-139.6S108.2 112 152 112c15.9 0 31.2 3.2 45.5 9c-6.8 4.1-13.3 8.6-19.5 13.6zm40 49.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5c24.6-19.8 56-31.6 90-31.6s65.4 11.8 90 31.6c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5c-19.2-15.4-43.5-24.6-70-24.6s-50.8 9.2-70 24.6zm2.5 29.4l32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L208 249.6 188.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm160 0l32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L368 249.6 348.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm55.3 76c12.7-7.5 30.1-6.6 41.6 4.9c7.1 7.1 11.3 18.1 8 29.6c-4.3 14.8-16 44-46.1 69.4C409 419.4 361.5 440 288 440s-121-20.6-151.4-46.2c-30.1-25.4-41.9-54.6-46.1-69.4c-3.3-11.5 1-22.5 8-29.6c11.5-11.5 28.9-12.4 41.6-4.9c21.5 12.6 73.9 38 147.8 38s126.4-25.4 147.8-38zm18.1 27.2c-.6-.1-1.3 .1-1.9 .4C427.3 332.1 369.3 360 288 360c-5.4 0-10.8-.1-16-.4l0 8.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.3c-56.2-7.8-96.5-27.6-116.1-39.1c-.6-.3-1.3-.5-1.9-.4c-.1 0-.2 0-.3 .1c3.5 11.3 12.8 33 35.5 52.2c5.4 4.5 11.6 9 18.8 13.2c.7-8.2 7.6-14.6 15.9-14.6c8.8 0 16 7.2 16 16l0 12.7c21 6.8 47.3 11.3 80 11.3c17.9 0 33.8-1.3 48-3.6l0-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 12.7c22.2-7.2 38.6-17.1 50.7-27.4c22.8-19.2 32-40.9 35.5-52.2c-.1 0-.1 0-.2 0l-.1 0z'
      
    ]
  };

  

  
  

  var faUserVneckHair = {
    prefix: 'fal',
    iconName: 'user-vneck-hair',
    icon: [
      448,
      512,
      [],
      'e462',
      
      'M320 128c0-5.5-.5-10.8-1.3-16l-30.1 0c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM228.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7l18.6 0C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64l28.9 0c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zm89.6 290.1l-57.2-76.3C72.6 358.8 32 410.7 32 472l0 8 384 0 0-8c0-61.3-40.6-113.2-96.4-130.2l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-80.5 56.6-147.7 132.1-164.2z'
      
    ]
  };

  

  
  

  var faPartyBell = {
    prefix: 'fal',
    iconName: 'party-bell',
    icon: [
      512,
      512,
      [],
      'e31a',
      
      'M32 224C32 118 118 32 224 32c30.3 0 59 7 84.5 19.6c7.1 3.5 11.5 11 11.5 19.1c0 6-2.4 11.7-6.6 15.9L86.6 313.4c-4.2 4.2-9.9 6.6-15.9 6.6c-8.1 0-15.6-4.3-19.1-11.5C39 283 32 254.3 32 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zM480 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM352 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 480a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM364.7 172.7c-6.2 6.2-6.2 16.4 0 22.6l8.3 8.3c23.1 23.1 53.4 37.7 85.9 41.3l27.4 3c8.8 1 16.7-5.4 17.7-14.1s-5.4-16.7-14.1-17.7l-27.4-3c-25.3-2.8-48.8-14.1-66.8-32.1l-8.2-8.3c-6.2-6.2-16.4-6.2-22.6 0zm-169.4 192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l8.3 8.2c18 18 29.3 41.6 32.1 66.8l3 27.4c1 8.8 8.9 15.1 17.7 14.1s15.1-8.9 14.1-17.7l-3-27.4c-3.6-32.5-18.2-62.8-41.3-85.9l-8.3-8.3zm303 135.5c6.7-5.7 7.6-15.8 1.9-22.6l-8.5-10c-6.2-7.3-9.4-16.6-9.2-26.1c1-38.2-28.5-70.4-66.6-72.6l-30-1.8c-20.9-1.2-37.1-18.8-36.5-39.8c.5-17.4-5.5-34.4-16.7-47.7l-8.5-10c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5l8.5 10c6.2 7.3 9.4 16.6 9.2 26.1c-1 38.2 28.5 70.4 66.6 72.6l30 1.8c20.9 1.2 37.1 18.8 36.5 39.8c-.5 17.4 5.5 34.4 16.7 47.7l8.5 10c5.7 6.7 15.8 7.6 22.6 1.9z'
      
    ]
  };

  

  
  

  var faPaintbrushPencil = {
    prefix: 'fal',
    iconName: 'paintbrush-pencil',
    icon: [
      576,
      512,
      [],
      'e206',
      
      'M534.5 86.6L369.9 251.3 324.6 206 489.3 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM347.3 273.9l-36.6 36.6-36.1 36.1s0 0 0 0l-4.6 4.6L224.6 306l40.7-40.7s0 0 0 0L302 228.6l45.3 45.3zM176 320c6.9 0 13.5 .9 19.9 2.5l57.7 57.7c1.6 6.3 2.5 13 2.5 19.9c0 44.2-35.8 80-80 80L36.8 480C58 480 74.3 468.5 84 455.1c9.5-13.1 14.2-30 12.5-46.7c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80zm110.3 60.2L557.2 109.3c25-25 25-65.5 0-90.5s-65.5-25-90.5 0l-271 271c-6.4-1.1-13-1.7-19.7-1.7c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-6.8-.6-13.4-1.7-19.8zM170.8 17C148.9-4.9 113.5-4.9 91.6 17L49 59.6c-21.9 21.9-21.9 57.3 0 79.2L166.5 256.3c3.1-.2 6.3-.3 9.5-.3c2.7 0 5.3 .1 7.9 .2l13.9-13.9L149 193.6 225.6 117l48.8 48.8L297 143.2 170.8 17zM410.1 301.6l50.8 50.8c7.6 7.6 13.1 16.9 16.1 27.2l27.3 92.8-92.8-27.3c-10.3-3-19.6-8.6-27.2-16.1l-50.8-50.8-13.8 13.8c.1 2.7 .2 5.4 .2 8.1c0 3.2-.1 6.4-.3 9.5l42 42c11.4 11.4 25.4 19.7 40.8 24.2l121 35.6c5.6 1.7 11.7 .1 15.8-4s5.7-10.2 4-15.8l-35.6-121c-4.5-15.4-12.9-29.4-24.2-40.8l-50.8-50.8-22.6 22.6zM114.2 39.6c9.4-9.4 24.6-9.4 33.9 0L203 94.4 126.4 171 71.6 116.2c-9.4-9.4-9.4-24.6 0-33.9l42.6-42.6z'
      
    ]
  };

  

  
  

  var faBarsFilter = {
    prefix: 'fal',
    iconName: 'bars-filter',
    icon: [
      448,
      512,
      [],
      'e0ad',
      
      'M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16zM288 400c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faHandSparkles = {
    prefix: 'fal',
    iconName: 'hand-sparkles',
    icon: [
      640,
      512,
      [],
      'e05d',
      
      'M328 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56l0 200.8-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L184.2 439.4C230.7 485.9 293.8 512 359.5 512l8.5 0c37.3 0 71.8-11.6 100.3-31.3c-9.6-5.5-17.4-13.7-22.3-23.6C423.5 471.6 396.7 480 368 480l-8.5 0c-57.3 0-112.2-22.8-152.7-63.3L103 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8L224 88c0-13.3 10.7-24 24-24s24 10.7 24 24c0 0 0 0 0 .1L272 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0 0 0 0 0-.1L304 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 0 0 0 0 .1L352 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-152.1C384 74.7 394.8 64 408 64c13.3 0 24 10.7 24 24l0 64c0 0 0 0 0 .1l0 87.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-88.1c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24l0 184c0 1.1 0 2.1 0 3.2c7.1-11.9 18.5-20.9 32-24.9L544 152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4L464 88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C374 16.3 352.9 0 328 0zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48zM336 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zm240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faVolumeXmark = {
    prefix: 'fal',
    iconName: 'volume-xmark',
    icon: [
      576,
      512,
      ["volume-mute","volume-times"],
      'f6a9',
      
      'M151.6 188L288 66.7l0 378.6L151.6 324c-2.9-2.6-6.7-4-10.6-4l-85 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l85 0c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM411.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 256l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 278.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 256l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 233.4l-68.7-68.7z'
      
    ]
  };

  
    var faVolumeMute = faVolumeXmark;
  
    var faVolumeTimes = faVolumeXmark;
  

  
  

  var faBurgerGlass = {
    prefix: 'fal',
    iconName: 'burger-glass',
    icon: [
      640,
      512,
      [],
      'e0ce',
      
      'M32.1 40.7L42.2 160l299.6 0L351.8 40.7c.4-4.7-3.3-8.7-8-8.7L40.1 32c-4.7 0-8.4 4-8 8.7zM44.9 192L66.7 450.7C68.1 467.3 81.9 480 98.6 480L260 480c3.7 11.9 9.7 22.7 17.6 32l-179 0c-33.3 0-61-25.5-63.8-58.6L.2 43.4C-1.7 20 16.7 0 40.1 0L343.8 0c23.4 0 41.8 20 39.9 43.4L372.5 176.5c-12.2 4.7-23.4 10.1-33.5 16l0-.4L44.9 192zm286.1 87.4c-5.7 6.2-9.2 14.6-10.4 24.4l287 0c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4l-305.2 0c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3l277.3 0c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7l-234.7 0c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7l234.7 0c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3l-277.3 0z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fal',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M384 352l-160 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l108.1 0c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3L416 320c0 17.7-14.3 32-32 32zM433.9 81.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L224 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-32-32 0 0 32c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0 0-32-64 0z'
      
    ]
  };

  

  
  

  var faSnowmanHead = {
    prefix: 'fal',
    iconName: 'snowman-head',
    icon: [
      448,
      512,
      ["frosty-head"],
      'f79b',
      
      'M128 32l192 0c17.7 0 32 14.3 32 32l0 96 32 0 0-96c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 96 32 0 0-96c0-17.7 14.3-32 32-32zM352 224l.7 0c29.3 31.4 47.3 73.6 47.3 120c0 52-22.5 98.8-58.5 131c-3 2.7-8.3 5-15.8 5l-203.5 0c-7.5 0-12.7-2.2-15.8-5C70.5 442.8 48 396 48 344c0-46.4 17.9-88.6 47.3-120l.7 0 256 0zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l38.1 0C30.1 257.9 16 299.3 16 344c0 61.5 26.7 116.8 69.1 154.8c10.1 9.1 23.6 13.2 37.1 13.2l203.5 0c13.6 0 27-4.1 37.1-13.2C405.3 460.8 432 405.5 432 344c0-44.7-14.1-86.1-38.1-120l38.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-32 0L96 192l-32 0-48 0zM144 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 320c-26.5 0-48 21.5-48 48l0 1c0 6.9 1.4 13.6 4.2 19.9l29.2 65.6c2.6 5.8 8.3 9.5 14.6 9.5s12.1-3.7 14.6-9.5l29.2-65.6c2.8-6.3 4.2-13 4.2-19.9l0-1c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 1c0 2.4-.5 4.7-1.5 6.9L224 408.6l-14.5-32.7c-1-2.2-1.5-4.5-1.5-6.9l0-1z'
      
    ]
  };

  
    var faFrostyHead = faSnowmanHead;
  

  
  

  var faSidebar = {
    prefix: 'fal',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      
      'M448 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-224 0 0-384 224 0zM64 64l128 0 0 384L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zm0-32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM80 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 96zM64 176c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z'
      
    ]
  };

  

  
  

  var faChartPyramid = {
    prefix: 'fal',
    iconName: 'chart-pyramid',
    icon: [
      512,
      512,
      [],
      'e0e6',
      
      'M269.8 87.7c-6.2-10.6-21.5-10.6-27.6 0L181.3 192l149.3 0L269.8 87.7zM106.7 320l298.7 0-56-96-186.7 0-56 96zM88 352L46 423.9C39.8 434.6 47.5 448 59.9 448l392.3 0c12.3 0 20-13.4 13.8-24.1L424 352 88 352zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0L493.6 407.8c18.7 32-4.4 72.2-41.5 72.2L59.9 480c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z'
      
    ]
  };

  

  
  

  var faPedestal = {
    prefix: 'fal',
    iconName: 'pedestal',
    icon: [
      448,
      512,
      [],
      'e20d',
      
      'M352 32L96 32C78.3 32 64 46.3 64 64l0 384-32 0L32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 384-32 0 0-384c0-17.7-14.3-32-32-32zM16 480l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM320 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faDiagramProject = {
    prefix: 'fal',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      'M136 64c13.3 0 24 10.7 24 24l0 24 0 32 0 24c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l80 0zm56 104l0-24 192 0 0 24c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56l0 24-192 0 0-24c0-30.9-25.1-56-56-56L56 32C25.1 32 0 57.1 0 88l0 80c0 30.9 25.1 56 56 56l80 0c8.6 0 16.7-1.9 24-5.4l72.2 96.3c-5.2 8.5-8.2 18.5-8.2 29.1l0 80c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-8.6 0-16.7 1.9-24 5.4l-72.2-96.3c5.2-8.5 8.2-18.5 8.2-29.1zm224 0l0-24 0-32 0-24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zM360 320c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l80 0z'
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faJetFighterUp = {
    prefix: 'fal',
    iconName: 'jet-fighter-up',
    icon: [
      512,
      512,
      [],
      'e518',
      
      'M270.6 9.5C268.1 3.7 262.3 0 256 0s-12.1 3.7-14.6 9.5L181.5 144.2c-3.6 8.2-5.5 17-5.5 26l0 40-.4 .3L32 299.3 32 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56 0 40 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 144 0 0 3.4-42.2 66.8c-3.8 6-5.8 13-5.8 20.1c0 20.8 16.9 37.7 37.7 37.7l180.6 0c20.8 0 37.7-16.9 37.7-37.7c0-7.1-2-14.1-5.8-20.1L336 387.4l0-3.4 144 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-40 0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 27.3L336.4 210.4l-.4-.3 0-40c0-9-1.9-17.8-5.5-26L270.6 9.5zM480 352l-144 0 0-104.2 144 89.1 0 15.1zm-304 0L32 352l0-15.1 144-89.1L176 352zm34.8-194.8L256 55.4l45.2 101.8c1.8 4.1 2.8 8.5 2.8 13L304 392c0 3 .9 6 2.5 8.5l44.6 70.7c.6 .9 .9 2 .9 3.1c0 3.2-2.6 5.7-5.7 5.7L272 480l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-74.3 0c-3.2 0-5.7-2.6-5.7-5.7c0-1.1 .3-2.1 .9-3.1l44.6-70.7c1.6-2.6 2.5-5.5 2.5-8.5l0-221.8c0-4.5 .9-8.9 2.8-13z'
      
    ]
  };

  

  
  

  var faAwardSimple = {
    prefix: 'fal',
    iconName: 'award-simple',
    icon: [
      384,
      512,
      [],
      'e0ab',
      
      'M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM88 390c9.7 4.3 20.3 6.6 31.3 6.8l-16.6 72 83-35.6c4-1.7 8.6-1.7 12.6 0l83 35.6-16.6-72c10.9-.2 21.5-2.5 31.3-6.8l23.6 102.4c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9L88 390z'
      
    ]
  };

  

  
  

  var faCircleP = {
    prefix: 'fal',
    iconName: 'circle-p',
    icon: [
      512,
      512,
      [],
      'e11a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16l0 144 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-88 0zm88 144l-72 0 0-112 72 0c30.9 0 56 25.1 56 56s-25.1 56-56 56z'
      
    ]
  };

  

  
  

  var faBaseball = {
    prefix: 'fal',
    iconName: 'baseball',
    icon: [
      512,
      512,
      [9918,129358,"baseball-ball"],
      'f433',
      
      'M256.6 480c-.4-5.3-.6-10.6-.6-16c0-5.8 .2-11.6 .7-17.3c.7-8.8 8.5-15.4 17.3-14.6s15.4 8.5 14.6 17.3c-.4 4.8-.6 9.7-.6 14.7c0 4.6 .2 9.1 .5 13.7c97.7-14.2 174.9-91.5 189.1-189.1c-4.5-.3-9.1-.5-13.7-.5c-4.9 0-9.8 .2-14.7 .6c-8.8 .7-16.5-5.8-17.3-14.6s5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7c5.4 0 10.7 .2 16 .6l0-.6C480 132.3 379.7 32 256 32l-.6 0c.4 5.3 .6 10.6 .6 16c0 5.8-.2 11.6-.7 17.3c-.7 8.8-8.5 15.4-17.3 14.6s-15.4-8.5-14.6-17.3c.4-4.8 .6-9.7 .6-14.7c0-4.6-.2-9.1-.5-13.7C125.8 48.6 48.6 125.8 34.3 223.5c4.5 .3 9.1 .5 13.7 .5c4.9 0 9.8-.2 14.7-.6c8.8-.7 16.5 5.8 17.3 14.6s-5.8 16.5-14.6 17.3c-5.7 .5-11.5 .7-17.3 .7c-5.4 0-10.7-.2-16-.6l0 .6c0 123.7 100.3 224 224 224l.6 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm121.3-48c38.3-17.6 69.2-48.5 86.7-86.7c3.7-8 13.2-11.6 21.2-7.9s11.6 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5c-8 3.7-17.5 .2-21.2-7.9s-.2-17.5 7.9-21.2zM390.7 304c-38.3 17.6-69.2 48.5-86.7 86.7c-3.7 8-13.2 11.6-21.2 7.9s-11.6-13.2-7.9-21.2c20.8-45.2 57.2-81.7 102.5-102.5c8-3.7 17.5-.2 21.2 7.9s.2 17.5-7.9 21.2z'
      
    ]
  };

  
    var faBaseballBall = faBaseball;
  

  
  

  var faGlobeStand = {
    prefix: 'fal',
    iconName: 'globe-stand',
    icon: [
      448,
      512,
      [],
      'f5f6',
      
      'M28.7 348.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l10-10C99 394.1 145.1 412.1 192 415.4l0 64.6L80 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-64.6c51.9-3.7 102.7-25.4 142.4-65c83.7-83.7 87.3-217.1 10.9-305.1l10-10c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L343.8 33.6c-6.2 6.2-6.2 16.4 0 22.6c75 75 75 196.5 0 271.5s-196.5 75-271.5 0c-6.2-6.2-16.4-6.2-22.6 0L28.7 348.7zM80 192a128 128 0 1 1 256 0A128 128 0 1 1 80 192zm288 0A160 160 0 1 0 48 192a160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faFaceTongueSweat = {
    prefix: 'fal',
    iconName: 'face-tongue-sweat',
    icon: [
      576,
      512,
      [],
      'e39e',
      
      'M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256c0 83.8-40.2 158.1-102.4 204.8C398.8 492.9 345.6 512 288 512s-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2c15.6 11.8 32.9 21.5 51.3 28.9c-8.1-13.9-12.8-30.1-12.9-47.3c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7c-.1 17.2-4.8 33.4-12.9 47.3c18.4-7.4 35.7-17.1 51.3-28.9C476.8 394.3 512 329.3 512 256C512 132.3 411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5l0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM211.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM224 417.6c0 34.5 27.9 62.4 62.4 62.4l3.2 0c34.5 0 62.4-27.9 62.4-62.4l0-14.6c0-14.9-12.1-27-27-27l-2.5 0c-10.9 0-20.4 7.4-23 18c-3 12-20 12-23 0c-2.6-10.6-12.1-18-23-18l-2.5 0c-14.9 0-27 12.1-27 27l0 14.6z'
      
    ]
  };

  

  
  

  var faCircleRadiation = {
    prefix: 'fal',
    iconName: 'circle-radiation',
    icon: [
      512,
      512,
      [9762,"radiation-alt"],
      'f7ba',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160.6 148.1c2.4-2.1 5.3-2.8 8.4-2c3.3 .8 6.9 3.2 9.1 7.1l37.2 64.4c7.4-7.8 16.9-13.5 27.7-16l-37.2-64.4c-12.7-22-43.9-32.9-66.4-13c-28.1 24.9-48.2 58.6-56 96.9c-5.9 29.4 19.1 51 44.5 51l74.3 0c-1.5-5.1-2.3-10.4-2.3-16s.8-10.9 2.3-16L128 240c-4.5 0-8.4-1.9-10.7-4.4c-2.2-2.3-3.1-5.1-2.5-8.3c6.3-31.3 22.7-58.9 45.8-79.3zm54.7 146.4l-37.2 64.4c-12.7 22-6.6 54.4 21.9 64c17.6 5.9 36.5 9.1 56 9.1s38.4-3.2 56-9.1c28.5-9.6 34.6-42 21.9-64l-37.2-64.4c-7.4 7.8-16.9 13.5-27.7 16l37.2 64.4c2.3 3.9 2.6 8.2 1.6 11.4c-.9 3.1-2.9 5.2-5.9 6.2c-14.4 4.8-29.8 7.4-45.8 7.4s-31.5-2.6-45.8-7.4c-3-1-5-3.2-5.9-6.2c-1-3.3-.7-7.5 1.6-11.4L243 310.5c-10.8-2.6-20.3-8.2-27.7-16zM309.7 272l74.3 0c25.4 0 50.5-21.5 44.5-51c-7.7-38.3-27.8-72.1-56-96.9c-22.5-19.9-53.7-9-66.4 13L269 201.5c10.8 2.6 20.3 8.2 27.7 16l37.2-64.4c2.3-3.9 5.8-6.3 9.1-7.1c3.1-.7 6-.1 8.4 2c23.1 20.4 39.5 48 45.8 79.3c.6 3.1-.3 5.9-2.5 8.3c-2.3 2.5-6.2 4.4-10.7 4.4l-74.3 0c1.5 5.1 2.3 10.4 2.3 16s-.8 10.9-2.3 16zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faRadiationAlt = faCircleRadiation;
  

  
  

  var faMusicNoteSlash = {
    prefix: 'fal',
    iconName: 'music-note-slash',
    icon: [
      640,
      512,
      ["music-alt-slash"],
      'f8d0',
      
      'M352 189.1l147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5l0-112.9C512 10.3 501.7 0 488.9 0c-2 0-4 .3-5.9 .8L331.9 40.5c-7 1.8-11.9 8.2-11.9 15.5l0 118.5 32 25.3 0-10.6zM320 337.5l0 38.5c-20.3-14.8-48.7-24-80-24c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-69.2-32-25.3zm0 94.5c0 9.1-5.1 20.3-19.4 30.5C286.3 472.7 265 480 240 480s-46.3-7.3-60.6-17.5C165.1 452.3 160 441.1 160 432s5.1-20.3 19.4-30.5C193.7 391.3 215 384 240 384s46.3 7.3 60.6 17.5C314.9 411.7 320 422.9 320 432zM480 123.6L352 156.1l0-87.8L480 34.6l0 88.9zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faMusicAltSlash = faMusicNoteSlash;
  

  
  

  var faMango = {
    prefix: 'fal',
    iconName: 'mango',
    icon: [
      512,
      512,
      [],
      'e30f',
      
      'M416 112c-24.6 0-47-9.2-64-24.4l0 42.9 0 32.5 0 13.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-41.3 0-82.7 14.5-114 43.4l-1.2 1.1-1.3 1c-39 29.3-58.5 59.9-78 92l-2.9 4.7c-18.6 30.9-39.6 65.5-79.4 93.2c-4.7 3.4-8 7.8-9.8 12.7c-4.3 11.8 1.8 27.7 19.9 33.3l1.3 .4 1.2 .5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 .1 0l.6 .2c.6 .2 1.6 .6 2.9 1.1c2.7 1 6.8 2.4 12.2 4.2c10.9 3.5 27 8.2 47.6 13C160.3 470.4 218.9 480 288 480c73.4 0 120.4-29.5 149.7-65.2c30.3-37 42.3-81.4 42.3-109.6c0-36.4-15-73.2-45.9-101.8c-14.8-13.7-31.8-24.1-50.1-31.3l0-32.1c4 1 8 1.9 12.1 2.5c21.7 8.6 42 21.1 59.7 37.4c37.5 34.6 56.2 80 56.2 125.3C512 375.9 454.5 512 288 512c-144 0-244.1-39.9-244.1-39.9C10.3 461.8-7.9 428.4 3.3 397.4c4.1-11.5 11.8-21.1 21.4-28c34.3-23.8 52.1-53.2 71.2-84.7c20.6-34 42.6-70.4 88.4-104.8C221.7 145.3 270.9 128 320 128l0-112c0-8.8 7.2-16 16-16l24 0 60.7 0C471.1 0 512 40.9 512 91.3c0 11.4-9.3 20.7-20.7 20.7L472 112l-56 0zm16 208c0 61.9-50.1 112-112 112c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80c0-8.8 7.2-16 16-16s16 7.2 16 16zM354 32c7.1 27.6 32.2 48 62 48l56 0 6.9 0c-5.3-27.3-29.3-48-58.2-48L360 32l-6 0z'
      
    ]
  };

  

  
  

  var faLinkHorizontal = {
    prefix: 'fal',
    iconName: 'link-horizontal',
    icon: [
      640,
      512,
      ["chain-horizontal"],
      'e1cb',
      
      'M128 64C57.3 64 0 121.3 0 192s57.3 128 128 128l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-53 0-96-43-96-96s43-96 96-96l176.1 0c52.9 0 95.9 42.9 95.9 95.9c0 50.3-38.9 92-89 95.6l-8.1 .6c-8.8 .6-15.4 8.3-14.8 17.1s8.3 15.4 17.1 14.8l8.1-.6C380.2 314.6 432 258.9 432 191.9C432 121.2 374.8 64 304.1 64L128 64zM512 448c70.7 0 128-57.3 128-128s-57.3-128-128-128l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c53 0 96 43 96 96s-43 96-96 96l-176.1 0c-52.9 0-95.9-42.9-95.9-95.9c0-50.3 38.9-92 89-95.6l8.1-.6c8.8-.6 15.4-8.3 14.8-17.1s-8.3-15.4-17.1-14.8l-8.1 .6C259.8 197.4 208 253.1 208 320.1C208 390.8 265.2 448 335.9 448L512 448z'
      
    ]
  };

  
    var faChainHorizontal = faLinkHorizontal;
  

  
  

  var faPhoneIntercom = {
    prefix: 'fal',
    iconName: 'phone-intercom',
    icon: [
      512,
      512,
      [],
      'e434',
      
      'M80 64c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16L32 80c0-8.8 7.2-16 16-16l32 0zM48 32C21.5 32 0 53.5 0 80L0 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 32zM448 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32l224 0zM224 32c-35.3 0-64 28.7-64 64l0 320c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L224 32zm32 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32-32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM256 128l160 0 0 96-160 0 0-96zm-32 0l0 96c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L256 96c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faSquareChevronLeft = {
    prefix: 'fal',
    iconName: 'square-chevron-left',
    icon: [
      448,
      512,
      ["chevron-square-left"],
      'f32a',
      
      'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm68.7-235.3l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L166.6 256 267.3 356.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faChevronSquareLeft = faSquareChevronLeft;
  

  
  

  var faClapperboard = {
    prefix: 'fal',
    iconName: 'clapperboard',
    icon: [
      512,
      512,
      [],
      'e131',
      
      'M32 192l0 224c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-224L32 192zm350.6-32l97.4 0 0-64c0-9.2-3.9-17.5-10.1-23.3L382.6 160zm-45.3 0l96-96L326.6 64l-96 96 106.7 0zm-56-96L174.6 64l-96 96 106.7 0 96-96zm-152 0L64 64C46.3 64 32 78.3 32 96l0 64 1.4 0 96-96zM512 96l0 64 0 16 0 16 0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192l0-16 0-16L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64z'
      
    ]
  };

  

  
  

  var faDiamondHalfStroke = {
    prefix: 'fal',
    iconName: 'diamond-half-stroke',
    icon: [
      512,
      512,
      [],
      'e5b8',
      
      'M272 44.7l0 422.6L477.7 261.7c3.1-3.1 3.1-8.2 0-11.3L272 44.7zM240 467.3l0-422.6L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L240 467.3zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216z'
      
    ]
  };

  

  
  

  var faSquareArrowDown = {
    prefix: 'fal',
    iconName: 'square-arrow-down',
    icon: [
      448,
      512,
      ["arrow-square-down"],
      'f339',
      
      'M64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm235.3-36.7l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 329.4 240 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 185.4-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0z'
      
    ]
  };

  
    var faArrowSquareDown = faSquareArrowDown;
  

  
  

  var faArrowRightLongToLine = {
    prefix: 'fal',
    iconName: 'arrow-right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d5',
      
      'M640 80l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16s16 7.2 16 16zM507.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272 16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l441.4 0L340.7 123.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l144 144z'
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fal',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      'M240 479.4l0-446.9C123.8 40.8 32 137.7 32 256s91.8 215.2 208 223.4zM480 256c0-118.3-91.8-215.2-208-223.4l0 446.9C388.2 471.2 480 374.3 480 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faStarfighter = {
    prefix: 'fal',
    iconName: 'starfighter',
    icon: [
      640,
      512,
      [],
      'e037',
      
      'M269.6 35.2L240.1 278.1l-.1 1 0 1 0 152c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-152 0-1-.1-1L370.4 35.2C368 15.1 351 0 330.7 0L309.3 0C289 0 272 15.1 269.6 35.2zM309.3 32l21.5 0c4 0 7.5 3 7.9 7L368 281l0 151c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-151L301.3 39c.5-4 3.9-7 7.9-7zM64 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-19.3 72.1 30c8.6 12.8 23.3 21.3 39.9 21.3l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48l0 16-64 0 0-160 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32zm0 298l0-42 64 0 0 68.7L64 394zM608 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 160-64 0 0-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c16.6 0 31.3-8.4 39.9-21.3l72.1-30 0 19.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32zM512 352l64 0 0 42-64 26.7 0-68.7zM320 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faUserGraduate = {
    prefix: 'fal',
    iconName: 'user-graduate',
    icon: [
      448,
      512,
      [],
      'f501',
      
      'M228.7 .7c-3.1-.9-6.3-.9-9.4 0l-208 64C4.6 66.8 0 73 0 80s4.6 13.2 11.3 15.3L32 101.7l0 71.7L.8 266.9C-.8 271.8 0 277.2 3 281.4s7.8 6.6 13 6.6l64 0c5.1 0 10-2.5 13-6.6s3.8-9.5 2.2-14.4L64 173.4l0-61.9 155.3 47.8c3.1 .9 6.3 .9 9.4 0l208-64C443.4 93.2 448 87 448 80s-4.6-13.2-11.3-15.3l-208-64zM224 127.3L70.4 80 224 32.7 377.6 80 224 127.3zM188.1 439.8c19.1 21.5 52.7 21.5 71.8 0l71.1-80c49.2 18 84.4 65 85 120.2L32 480c.5-55.2 35.7-102.3 85-120.2l71.1 80zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-71-45.9-131.3-109.6-152.8c-10.9-3.7-22.7 .4-30.3 9L236 418.5c-6.4 7.2-17.6 7.2-23.9 0l-72.1-81.1c-7.6-8.6-19.4-12.7-30.3-9zM48 226.6L57.8 256l-19.6 0L48 226.6zm48-71.8L96 176c0 70.7 57.3 128 128 128s128-57.3 128-128l0-21.2-32 9.8 0 11.3c0 53-43 96-96 96s-96-43-96-96l0-11.3-32-9.8z'
      
    ]
  };

  

  
  

  var faObjectUnion = {
    prefix: 'fal',
    iconName: 'object-union',
    icon: [
      512,
      512,
      [],
      'e49f',
      
      'M160 320c17.7 0 32 14.3 32 32l0 96c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 224c0 17.7 14.3 32 32 32l96 0zm-32 32l-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 64 0 32 32 0 64 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 0-32-32 0z'
      
    ]
  };

  

  
  

  var faCartShoppingFast = {
    prefix: 'fal',
    iconName: 'cart-shopping-fast',
    icon: [
      640,
      512,
      [],
      'e0dc',
      
      'M64 16C64 7.2 71.2 0 80 0l37.9 0c20.6 0 38.6 13 45.3 32l440.4 0c20.8 0 36.1 19.6 31 39.8L592.6 239.5C585.5 268 559.9 288 530.5 288L216 288l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6L560 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-304.8 0c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C132 37.3 125.5 32 117.9 32L80 32c-8.8 0-16-7.2-16-16zM530.5 256c14.7 0 27.5-10 31-24.2L603.5 64 170.1 64l39.3 192 321.1 0zM256 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM16 128l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 288c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHexagonExclamation = {
    prefix: 'fal',
    iconName: 'hexagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e417',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM256 128c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faMusicNote = {
    prefix: 'fal',
    iconName: 'music-note',
    icon: [
      384,
      512,
      ["music-alt"],
      'f8cf',
      
      'M384 23.1C384 10.3 373.7 0 360.9 0c-2 0-4 .3-5.9 .8L203.9 40.5c-7 1.8-11.9 8.2-11.9 15.5l0 320c-20.3-14.8-48.7-24-80-24C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80l0-242.9 147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5l0-112.9zM192 432c0 9.1-5.1 20.3-19.4 30.5C158.3 472.7 137 480 112 480s-46.3-7.3-60.6-17.5C37.1 452.3 32 441.1 32 432s5.1-20.3 19.4-30.5C65.7 391.3 87 384 112 384s46.3 7.3 60.6 17.5C186.9 411.7 192 422.9 192 432zM352 123.6L224 156.1l0-87.8L352 34.6l0 88.9z'
      
    ]
  };

  
    var faMusicAlt = faMusicNote;
  

  
  

  var faWaffle = {
    prefix: 'fal',
    iconName: 'waffle',
    icon: [
      512,
      512,
      [129479],
      'e466',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 80l0 64 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm-96 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm0-32l64 0 0-64-64 0 0 64z'
      
    ]
  };

  

  
  

  var faCloudFog = {
    prefix: 'fal',
    iconName: 'cloud-fog',
    icon: [
      640,
      512,
      [127787,"fog"],
      'f74e',
      
      'M160 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM576 216c0-55.2-43-100.3-97.3-103.8C471.2 66.7 431.6 32 384 32c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0C178.1 0 128 50.1 128 112c0 2.6 .1 5.3 .3 7.9C90.6 135.5 64 172.6 64 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM0 400c0 8.8 7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 384c-8.8 0-16 7.2-16 16zm64 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 480c-8.8 0-16 7.2-16 16zm224 0c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  
    var faFog = faCloudFog;
  

  
  

  var faFish = {
    prefix: 'fal',
    iconName: 'fish',
    icon: [
      576,
      512,
      [128031],
      'f578',
      
      'M162.4 306.8c11.1 13.4 24.1 26.8 38.7 39.2c35.5 30 81.4 54 134.8 54s99.3-24 134.8-54c35.5-30 60.8-66 73.2-90c-12.4-24-37.6-60-73.2-90c-35.5-30-81.4-54-134.8-54s-99.3 24-134.8 54c-14.6 12.4-27.6 25.8-38.7 39.2L145.1 226l-23.4-13.6L32 160l45.8 80.1L86.9 256l-9.1 15.9L32 352l89.7-52.3L145.1 286l17.3 20.8zM4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1zM416 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fal',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.3-399.1c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4zm-40 95.1L256 156.2l25.6 51.9c2.3 4.7 6.8 8 12 8.8l57.3 8.3-41.5 40.4c-3.8 3.7-5.5 9-4.6 14.2l9.8 57.1-51.2-26.9c-4.7-2.5-10.2-2.5-14.9 0l-51.2 26.9 9.8-57.1c.9-5.2-.8-10.5-4.6-14.2L161 225.1l57.3-8.3c5.2-.8 9.7-4 12-8.8z'
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCircle1 = {
    prefix: 'fal',
    iconName: 'circle-1',
    icon: [
      512,
      512,
      [],
      'e0ee',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 130.2c4.9 2.9 8 8.1 8 13.8l0 208 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-180.4-32.1 18.3c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l56-32c5-2.8 11-2.8 16 .1z'
      
    ]
  };

  

  
  

  var faCommentHeart = {
    prefix: 'fal',
    iconName: 'comment-heart',
    icon: [
      512,
      512,
      [],
      'e5c8',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM176 221.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 313.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zm72.6-43.3c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4z'
      
    ]
  };

  

  
  

  var faStarSharp = {
    prefix: 'fal',
    iconName: 'star-sharp',
    icon: [
      576,
      512,
      [],
      'e28b',
      
      'M288 43.6L239.2 196.9C237.1 203.5 231 208 224 208L75.3 208l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6l114.7-89.2c5.8-4.5 13.9-4.5 19.6 0l114.7 89.2L368.7 316.7c-2-6.5 .4-13.6 5.9-17.6l126-91L352 208c-7 0-13.1-4.5-15.2-11.1L288 43.6zM262.3 18.8C265.9 7.6 276.3 0 288 0s22.1 7.6 25.7 18.8l50 157.2 153.7 0c14.7 0 26.6 11.9 26.6 26.6c0 8.5-4.1 16.6-11 21.6L402.6 318.3l50.8 167c4.1 13.3-5.9 26.8-19.8 26.8c-4.6 0-9.1-1.5-12.7-4.4L288 404.3 155.1 507.6c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176l153.7 0 50-157.2z'
      
    ]
  };

  

  
  

  var faUserMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'user-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e5c5',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 80l91.4 0c6.5 0 12.9 .4 19.2 1.2c-.6-5.7-.9-11.4-.9-17.2c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3l-32 0-224 0L32 480c1.2-79.7 66.2-144 146.3-144zM448 224.1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faTruckFast = {
    prefix: 'fal',
    iconName: 'truck-fast',
    icon: [
      640,
      512,
      ["shipping-fast"],
      'f48b',
      
      'M128 32l224 0c17.7 0 32 14.3 32 32l0 320-133.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4L96 288l-32 0 0 96 0 32c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-148.2c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96L416 96l0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 32L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 96l0-32c0-17.7 14.3-32 32-32zM570.9 224L416 224l0-96 65.3 0c4.7 0 9.1 2 12.1 5.6L570.9 224zM416 256l160 0 0 128-5.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4l0-88.4zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM48 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 160zM16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 224z'
      
    ]
  };

  
    var faShippingFast = faTruckFast;
  

  
  

  var faLacrosseStickBall = {
    prefix: 'fal',
    iconName: 'lacrosse-stick-ball',
    icon: [
      576,
      512,
      [],
      'e3b6',
      
      'M344 32s0 0 0 0c-44.3 0-83.7 28.4-97.7 70.4l-.8 2.4c-6.2 18.8-14.3 43-31.6 64.2l-34.4 42c-12.6 15.4-19.5 34.7-19.5 54.7c0 47.7 38.7 86.3 86.3 86.3c19.9 0 39.2-6.9 54.7-19.5l42-34.4c21.1-17.3 45.2-25.3 64-31.5l1.8-.6 .8-.3s0 0 0 0c42-14 70.4-53.3 70.4-97.6c0 0 0 0 0-.1l0-.2 0-.1c0-28.8-18.4-62.8-45.6-90.1C407.2 50.4 373.2 32 344.4 32l-.2 0-.2 0zm.3-32C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3c0 58.1-37.2 109.7-92.3 128.1l-.8 .3c-19.8 6.6-39.1 13-55.6 26.5l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-26.9 0-51.7-9-71.6-24.1L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152.1 337.3C137 317.4 128 292.6 128 265.7c0-27.3 9.5-53.8 26.7-74.9l34.4-42c13.5-16.5 19.9-35.8 26.5-55.6c0 0 0 0 0 0l.3-.8C234.3 37.2 285.9 0 344 0l.3 0zM544 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faSquareChevronRight = {
    prefix: 'fal',
    iconName: 'square-chevron-right',
    icon: [
      448,
      512,
      ["chevron-square-right"],
      'f32b',
      
      'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM315.3 267.3l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 256 180.7 155.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l112 112c6.2 6.2 6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faChevronSquareRight = faSquareChevronRight;
  

  
  

  var faPersonSnowboarding = {
    prefix: 'fal',
    iconName: 'person-snowboarding',
    icon: [
      512,
      512,
      [127938,"snowboarding"],
      'f7ce',
      
      'M221.3 7.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l40.6 61c7.1 10.6 18 17.9 30.5 20.4l37 7.4-83.3 39.2c-16.8 7.9-27.6 24.8-27.6 43.4l0 83.1-88.9 59.2c-4.2 2.8-6.6 7.2-7.1 11.8l-18.9-7.4c-7.5-2.9-14.2-7.8-19.4-14L28.3 293.8c-5.7-6.8-15.7-7.7-22.5-2s-7.7 15.7-2 22.5l29.5 35.4C41.8 360 52.9 368 65.5 372.9L406.9 506.5c9.3 3.6 19.2 5.5 29.2 5.5l43.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-43.9 0c-6 0-11.9-1.1-17.5-3.3l-92.9-36.4c.4-.6 .7-1.3 1-1.9l41-93.8c11.7-26.8 3.8-58.2-19.3-76.2l-38.8-30.2 96.1-54.1 80 68c6.7 5.7 16.8 4.9 22.6-1.8s4.9-16.8-1.8-22.6l-141-119.9c-3.7-3.1-7.6-6-11.6-8.6c-.8-.6-1.6-1.1-2.4-1.5c-11.2-6.9-23.6-11.7-36.6-14.3l-42.6-8.5c-4.2-.8-7.8-3.3-10.2-6.8l-40.6-61zm60.8 209.8l-46.6-36.2 106.8-50.3c.8 .6 1.5 1.2 2.2 1.8l35 29.8-97.5 54.8zM224 212.3l104.7 81.4c11.6 9 15.5 24.7 9.7 38.1l-41 93.8c-.5 1.1-.8 2.2-1 3.3L125.7 362.1l84-56c8.9-5.9 14.2-15.9 14.2-26.6l0-67.2zM424 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 424 0a56 56 0 1 0 0 112z'
      
    ]
  };

  
    var faSnowboarding = faPersonSnowboarding;
  

  
  

  var faArrowsRetweet = {
    prefix: 'fal',
    iconName: 'arrows-retweet',
    icon: [
      640,
      512,
      ["retweet-alt"],
      'f361',
      
      'M116.7 68.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 118.6 144 336c0 26.5 21.5 48 48 48l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0c-44.2 0-80-35.8-80-80l0-217.4L51.3 179.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88zM528 393.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 393.4 496 176c0-26.5-21.5-48-48-48l-144 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l144 0c44.2 0 80 35.8 80 80l0 217.4z'
      
    ]
  };

  
    var faRetweetAlt = faArrowsRetweet;
  

  
  

  var faUserHeadset = {
    prefix: 'fal',
    iconName: 'user-headset',
    icon: [
      448,
      512,
      [],
      'f82d',
      
      'M224 32C135.6 32 64 103.6 64 192l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C32 86 118 0 224 0S416 86 416 192l0 16c0 61.9-50.1 112-112 112l-64 0-16 0-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l32 0c44.2 0 80-35.8 80-80l0-16c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256l-8.4 0c15.2-17 24.4-39.4 24.4-64c0-53-43-96-96-96s-96 43-96 96c0 24.6 9.3 47.1 24.5 64.1c-5.4 9.4-8.5 20.3-8.5 31.9c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352l16 0 16 0 64 0 9.6 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l73.6 0zm105.6 32l-179.2 0C80 384 35.5 426.4 32.2 480l383.6 0c-3.3-53.6-47.8-96-102.2-96z'
      
    ]
  };

  

  
  

  var faY = {
    prefix: 'fal',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      'M28.9 38.5c-5.2-7.1-15.2-8.7-22.4-3.4S-2.1 50.3 3.1 57.5L176 293.2 176 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-170.8L380.9 57.5c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L192 260.9 28.9 38.5z'
      
    ]
  };

  

  
  

  var faCarBurst = {
    prefix: 'fal',
    iconName: 'car-burst',
    icon: [
      640,
      512,
      ["car-crash"],
      'f5e1',
      
      'M190.5 17.3C187.9 11.6 182.2 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l25.7-21.3c.3-2.9 .8-5.8 1.6-8.7l11.8-43.9-32.7 27 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l48.2-11.9 23.2-38.7L222.6 87.2 190.5 17.3zM380.9 86.9l164.4 44c13.8 3.7 23.5 16.1 23.7 30.4l1.3 75.7-264-70.7 38.9-64.9c7.3-12.3 21.9-18.2 35.7-14.5zm-63.2-2l-46.2 77c-32.6 2.9-61.4 25.6-70.3 59L175 318.8c-.3 1.3-.6 2.6-.7 3.8l-.3-.1L159.1 378c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l9.7-36 360.5 96.6-9.7 36.1c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l15.4-57.5c0 0 0 0-.1 0c.2-.6 .4-1.1 .5-1.7l26.2-97.8c8.9-33.4-4.6-67.5-31.4-86.3L601 160.8c-.5-28.6-19.8-53.4-47.4-60.8L389.2 56c-27.6-7.4-56.8 4.4-71.5 28.9zM569 269.8c25.6 6.9 40.8 33.2 33.9 58.8l-24.1 90.1L208 319.3l24.1-90.1c6.9-25.6 33.2-40.8 58.8-33.9l278 74.5zM278.3 294a28 28 0 1 0 14.5-54.1A28 28 0 1 0 278.3 294zm286.6 47.8a28 28 0 1 0 -54.1-14.5 28 28 0 1 0 54.1 14.5z'
      
    ]
  };

  
    var faCarCrash = faCarBurst;
  

  
  

  var faBoxDollar = {
    prefix: 'fal',
    iconName: 'box-dollar',
    icon: [
      448,
      512,
      ["box-usd"],
      'f4a0',
      
      'M240 64l102.4 0c12.6 0 24.1 7.4 29.2 19l34.2 77L240 160l0-96zm0 128l176 0 0 224c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-224 176 0 32 0zm-32-32L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19L208 64l0 96zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM240 216c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z'
      
    ]
  };

  
    var faBoxUsd = faBoxDollar;
  

  
  

  var faWind = {
    prefix: 'fal',
    iconName: 'wind',
    icon: [
      512,
      512,
      [],
      'f72e',
      
      'M288 16c0 8.8 7.2 16 16 16l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L16 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L304 0c-8.8 0-16 7.2-16 16zm64 384c0 8.8 7.2 16 16 16l56 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l408 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-56 0c-8.8 0-16 7.2-16 16zM112 512l64 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faCircleExclamationCheck = {
    prefix: 'fal',
    iconName: 'circle-exclamation-check',
    icon: [
      640,
      512,
      [],
      'e10d',
      
      'M32 256C32 132.3 132.3 32 256 32c95.3 0 176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C458 68 364.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c75.8 0 144-33 190.8-85.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3c-41 45.9-100.6 74.7-167 74.7C132.3 480 32 379.7 32 256zM272 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zM256 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM619.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L480 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faWreathLaurel = {
    prefix: 'fal',
    iconName: 'wreath-laurel',
    icon: [
      640,
      512,
      [],
      'e5d2',
      
      'M384 32c44.2 0 80 35.8 80 80c-44.2 0-80-35.8-80-80zM494.6 94C486 40.7 439.7 0 384 0L368 0c-8.8 0-16 7.2-16 16l0 16c0 61.9 50.1 112 112 112l8.1 0c25.7 31.5 39.9 71 39.9 112c0 72.8-40.5 136.1-100.2 168.7c9.4 2.3 18.7 5 27.8 8.2c0 0 0 0 0 0c12.3 4.3 24.3 9.3 36 15.2l4.6 2.3c51.5 9 105.4-14.2 133-62.1L630 359c3.9-6.8 1.6-15.5-5.2-19.4c-11.4-6.6-23.6-11-35.9-13.3c31-23.4 51-60.5 51-102.3l0-33.8c0-7.9-6.4-14.2-14.2-14.2c-13.2 0-25.9 2.3-37.7 6.4c15.2-35.7 14-77.9-6.9-114.1L564.2 39c-3.9-6.8-12.6-9.1-19.4-5.2c-24.3 14-41.5 35.7-50.2 60.2zM319.8 480l.2 0 19.6 0c37.3 0 74 8.7 107.3 25.3l9.9 5c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-9.9-5C423.4 457.8 381.8 448 339.6 448L320 448c-106 0-192-86-192-192c0-41 14.2-80.5 39.9-112l8.1 0c61.9 0 112-50.1 112-112l0-16c0-8.8-7.2-16-16-16L256 0C200.3 0 154 40.7 145.4 94c-8.8-24.5-25.9-46.2-50.2-60.2c-6.8-3.9-15.5-1.6-19.4 5.2L58.9 68.3C38 104.5 36.8 146.7 51.9 182.4c-11.8-4.1-24.5-6.4-37.7-6.4C6.4 176 0 182.4 0 190.2L0 224c0 41.8 20 78.9 51 102.3c-12.3 2.3-24.4 6.7-35.9 13.3C8.4 343.5 6.1 352.2 10 359l16.9 29.3c29.8 51.7 90.2 74.7 145.1 59.4c6.9-1.9 13.7-4.4 20.3-7.6c10.2 7.1 21 13.4 32.4 18.7c-15.8 4.6-31.1 10.6-45.9 18l-9.9 5c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l9.9-5c33.3-16.7 70.1-25.3 107.3-25.3l19.3 0zM176 112c0-21.6 8.5-41.2 22.4-55.5C213 41.4 233.4 32 256 32c0 44.2-35.8 80-80 80zM96 289.8l0 24.8C58.7 301.4 32 265.8 32 224l0-14.1c36.6 8.1 64 40.8 64 79.8zm448 24.8l0-24.8c0-39.1 27.4-71.7 64-79.8l0 14.1c0 41.8-26.7 77.4-64 90.5zM142.9 397.3l12.4 21.4c-38.9 7.2-79.8-10.2-100.7-46.4l-7-12.2c35.8-11.3 75.8 3.3 95.3 37.1zM96.7 194.7C71 164.6 65.7 120.5 86.6 84.3l7-12.2c27.7 25.3 35 67.3 15.5 101.1L96.7 194.7zm434.1-21.4c-19.5-33.8-12.1-75.8 15.5-101.1l7 12.2c20.9 36.2 15.5 80.4-10.2 110.4l-12.4-21.4zm-33.8 224c19.5-33.8 59.6-48.4 95.3-37.1l-7 12.2c-20.9 36.2-61.8 53.6-100.7 46.4l12.4-21.4z'
      
    ]
  };

  

  
  

  var faMegaphone = {
    prefix: 'fal',
    iconName: 'megaphone',
    icon: [
      576,
      512,
      [128227],
      'f675',
      
      'M560 32c-8.8 0-16 7.2-16 16l0 11.5L32 187.5 32 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 19.5L0 208l0 96 0 12.5L0 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-11.5 131.7 32.9c-2.4 8.4-3.7 17.4-3.7 26.6c0 53 43 96 96 96c46.2 0 84.7-32.6 93.9-76L544 452.5l0 11.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24 0-368 0-24c0-8.8-7.2-16-16-16zM544 419.5L32 291.5l0-71 512-128 0 327zM192 384c0-6.5 1-12.9 2.8-18.8l124 31C313.1 425.7 287.2 448 256 448c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faUserShield = {
    prefix: 'fal',
    iconName: 'user-shield',
    icon: [
      640,
      512,
      [],
      'f505',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM32 480c1.2-79.7 66.2-144 146.3-144l91.4 0c19.4 0 37.9 3.8 54.9 10.6c-2.2-12.4-3.5-24.3-4.1-35.3c-16.1-4.8-33.1-7.3-50.7-7.3l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c1.8 0 3.5-.2 5.3-.5c-13.4-9.7-25.1-20.3-35.5-31.5L32 480zm352-178.6L480 263l0 208.4c-73.4-40.5-94.6-117.1-95.9-170zm223.9 0c-1.3 53-22.6 129.5-95.9 170L512 263l95.9 38.4zm-103-75.7c-5.7-2.3-12.1-2.3-17.8 0l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48z'
      
    ]
  };

  

  
  

  var faMushroom = {
    prefix: 'fal',
    iconName: 'mushroom',
    icon: [
      512,
      512,
      [127812],
      'e425',
      
      'M130.8 105c17.5 23.6 45.6 39 77.2 39c46.1 0 84.6-32.5 93.9-75.9c41 8.6 77.3 30.1 104.3 60.2c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64c22.4 0 42.1-11.5 53.5-28.9c1.6 10.1 2.5 20.5 2.5 31c0 16.5-13.4 29.9-29.9 29.9L288 288l-64 0L85.9 288C69.4 288 56 274.6 56 258.1c0-62.2 29.3-117.6 74.8-153.1zM116.1 75.9C60.3 117.1 24 183.4 24 258.1C24 292.3 51.7 320 85.9 320l105.5 0 32.6 0 64 0 32.6 0 105.5 0c34.2 0 61.9-27.7 61.9-61.9C488 133.2 386.8 32 261.9 32l-11.8 0c-38 0-73.9 9.4-105.3 26c0 0 0 0 0 0c-10 5.3-19.6 11.3-28.6 18c0 0 0 0 0 0zm41.5 11.5c27.5-14.9 59-23.4 92.5-23.4l11.8 0c2.7 0 5.4 .1 8 .2C262.8 91.7 237.8 112 208 112c-20.5 0-38.7-9.6-50.4-24.6zM326.6 352L294 352l18 96-112 0 18-96-32.6 0-16.9 90.1c-1.8 9.4 .7 19 6.8 26.3s15.1 11.6 24.6 11.6l112 0c9.5 0 18.5-4.2 24.6-11.6s8.6-17 6.8-26.3L326.6 352zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm208-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faPlanetRinged = {
    prefix: 'fal',
    iconName: 'planet-ringed',
    icon: [
      512,
      512,
      [129680],
      'e020',
      
      'M480 32c-2.5 0-6.6 .4-12.8 1.9c-15.8 3.9-37.7 13.4-64.7 29.3l-2 1.2c-9.5-7.2-19.5-13.6-29.8-19.2c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c5.6 10.3 12 20.2 19.2 29.8l-1.2 2c-15.9 27-25.5 48.9-29.3 64.7C32.4 473.5 32 477.5 32 480c2.5 0 6.6-.4 12.8-1.9c15.8-3.9 37.7-13.4 64.7-29.3c9.9-5.9 20.3-12.5 31.1-19.7C84.7 391.7 48 328.2 48 256C48 141.1 141.1 48 256 48c72.2 0 135.7 36.7 173 92.5c7.3-10.8 13.9-21.1 19.7-31.1c15.9-26.9 25.5-48.9 29.3-64.7c1.5-6.3 1.9-10.3 1.9-12.8zM408.9 168.8C378.6 115.8 321.5 80 256 80C158.8 80 80 158.8 80 256c0 65.5 35.8 122.6 88.8 152.9C209 379.1 253 341.1 297.1 297.1s82-88.1 111.9-128.2zM202.3 423.7c16.9 5.4 34.9 8.3 53.7 8.3c97.2 0 176-78.8 176-176c0-18.7-2.9-36.7-8.3-53.7c-29 37.6-64.2 77.6-104 117.3s-79.8 74.9-117.3 104z'
      
    ]
  };

  

  
  

  var faUserDoctorHair = {
    prefix: 'fal',
    iconName: 'user-doctor-hair',
    icon: [
      448,
      512,
      [],
      'e458',
      
      'M320 128c0-5.5-.5-10.8-1.3-16l-30.1 0c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM228.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7l18.6 0C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64l28.9 0c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zm80 208l0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-30.9C80.2 354.7 32.6 411.8 32 480l384 0c-.5-62.4-40.4-115.4-96-135.5l0 25.8c23.1 6.9 40 28.3 40 53.7l0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24c0-25.4 16.9-46.8 40-53.7l0-33.3c-5.6-.7-11.4-1-17.2-1l-93.6 0-1.2 0zm-32 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM0 481.2C0 383.3 79.3 304 177.2 304l93.6 0C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8L30.8 512C13.8 512 0 498.2 0 481.2z'
      
    ]
  };

  

  
  

  var faSquareY = {
    prefix: 'fal',
    iconName: 'square-y',
    icon: [
      448,
      512,
      [],
      'e287',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm124 53.5L224 263.7 324 149.5c5.8-6.7 15.9-7.3 22.6-1.5s7.3 15.9 1.5 22.6L240 294l0 90c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-90L100 170.5c-5.8-6.7-5.1-16.8 1.5-22.6s16.8-5.1 22.6 1.5z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fal',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M412.1 416.6C398.1 361.1 347.9 320 288 320l-64 0c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1l64 0c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faJugDetergent = {
    prefix: 'fal',
    iconName: 'jug-detergent',
    icon: [
      384,
      512,
      [],
      'e519',
      
      'M128 64l0-32 64 0 0 32-64 0zM96 64L80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 64 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-40c0-13.3-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24l0 40zm32 96l128 0c53 0 96 43 96 96l0 192c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-192c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-192c0-70.7-57.3-128-128-128l-128 0zm128 80c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-96c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96z'
      
    ]
  };

  

  
  

  var faDiagramSubtask = {
    prefix: 'fal',
    iconName: 'diagram-subtask',
    icon: [
      512,
      512,
      [],
      'e479',
      
      'M448 64c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-304 0-32 0-48 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0zM144 224l304 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l48 0 0 96c0 44.2 35.8 80 80 80l32 0 0 16c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-160 0c-35.3 0-64 28.7-64 64l0 16-32 0c-26.5 0-48-21.5-48-48l0-96zm304 96c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l160 0z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fal',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faShrimp = {
    prefix: 'fal',
    iconName: 'shrimp',
    icon: [
      512,
      512,
      [129424],
      'e448',
      
      'M0 96C0 60.7 28.7 32 64 32l368 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 64C46.3 64 32 78.3 32 96s14.3 32 32 32l272 0c97.2 0 176 78.8 176 176s-78.8 176-176 176l-96 0c-8.8 0-16-7.2-16-16c0-4.4 1.8-8.4 4.7-11.3L265.4 416l-36.7-36.7c-5-5-6.1-12.7-2.7-19s10.5-9.5 17.4-8L348.9 375c3.2 .7 6.4 1 9.7 1c14 0 25.4-11.4 25.4-25.4l0-2.6c0-15.5-12.5-28-28-28l-116 0c-91.8 0-167.2-70.3-175.3-160l-.7 0C28.7 160 0 131.3 0 96zM336 448l0-43.1L289.6 395l9.7 9.7c6.2 6.2 6.2 16.4 0 22.6L278.6 448l57.4 0zm32-3.6c33-7.5 61.7-26.3 81.7-52.1l-39.8-15.9c-8.1 16.1-23.5 27.8-41.9 30.8l0 37.2zm98.7-79.8c8.6-18.4 13.3-39 13.3-60.6c0-9.3-.9-18.3-2.5-27.1l-67.4 45c3.3 6.9 5.4 14.4 5.9 22.4l50.8 20.3zm.8-119.5C447 199.6 403.6 166.6 352 160.9L352 288l4 0c12 0 23.3 3.6 32.7 9.7l78.8-52.5zM320 160L96.9 160c8 72 69 128 143.1 128l80 0 0-128zM208 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleDivide = {
    prefix: 'fal',
    iconName: 'circle-divide',
    icon: [
      512,
      512,
      [],
      'e106',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-96 56c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faBorderLeft = {
    prefix: 'fal',
    iconName: 'border-left',
    icon: [
      448,
      512,
      [],
      'f84f',
      
      'M16 480c-8.8 0-16-7.2-16-16L0 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16zm112-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 472a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM224 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 472a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM224 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192 48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 184a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faTv = {
    prefix: 'fal',
    iconName: 'tv',
    icon: [
      640,
      512,
      [63717,"television","tv-alt"],
      'f26c',
      
      'M64 32C46.3 32 32 46.3 32 64l0 320c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 64zM112 480l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faTelevision = faTv;
  
    var faTvAlt = faTv;
  

  
  

  var faDownFromDottedLine = {
    prefix: 'fal',
    iconName: 'down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e407',
      
      'M222.2 447.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 315.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L288 304c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 447.2zM224 480c-9.5 0-18.6-3.9-25.1-10.8L74.5 337.2C67.8 330 64 320.5 64 310.7c0-21.4 17.3-38.7 38.7-38.7l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 469.2c-6.5 6.9-15.6 10.8-25.1 10.8zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fal',
    iconName: 'arrow-up',
    icon: [
      384,
      512,
      [8593],
      'f062',
      
      'M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6 176 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4L356.7 235.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-176-176z'
      
    ]
  };

  

  
  

  var faBoneBreak = {
    prefix: 'fal',
    iconName: 'bone-break',
    icon: [
      640,
      512,
      [],
      'f5d8',
      
      'M320 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM164.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm310.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM270.7 244.3c-2.3-8.5-11.1-13.6-19.6-11.3l-73.4 19.7c-4 1.1-8.1-1.1-9.9-4.9c-17.7-38.1-60.6-59.1-102.6-47.8C18.3 212.6-9.6 260.8 3 307.8C9.7 332.6 26.3 352 47.4 363c4.9 2.6 6.7 9.1 3.7 13.8c-12.8 20.1-17.4 45.3-10.8 70.1c12.6 46.9 60.8 74.8 107.8 62.2c41.9-11.2 68.6-50.9 64.9-92.7c-.4-4.1 2.1-8.1 6.1-9.1l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-73.4 19.7c-20.6 5.5-31.3 24.9-29.7 42.9c2.4 26.6-14.7 51.8-41.3 59c-29.9 8-60.6-9.7-68.6-39.6c-4.2-15.8-1.3-31.8 6.9-44.6c13.1-20.5 5.7-48.1-15.9-59.3c-13.5-7-24-19.4-28.2-35.2c-8-29.9 9.7-60.6 39.6-68.6c26.6-7.1 54 6.2 65.3 30.4c7.6 16.3 26.6 27.8 47.2 22.3l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6zM388.9 233c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6L454 283.6c20.6 5.5 39.6-5.9 47.2-22.3c11.2-24.2 38.6-37.5 65.3-30.4c29.9 8 47.6 38.7 39.6 68.6c-4.2 15.8-14.7 28.2-28.2 35.2c-21.6 11.2-28.9 38.8-15.9 59.3c8.2 12.8 11.1 28.8 6.9 44.6c-8 29.9-38.7 47.6-68.6 39.6c-26.6-7.1-43.7-32.4-41.3-59c1.6-18-9.1-37.4-29.7-42.9l-73.4-19.7c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l73.4 19.7c4 1.1 6.5 5 6.1 9.1c-3.7 41.8 23 81.5 64.9 92.7c46.9 12.6 95.2-15.3 107.8-62.2c6.6-24.8 2-50-10.8-70.1c-3-4.7-1.2-11.2 3.7-13.8c21.1-11 37.7-30.5 44.4-55.3c12.6-46.9-15.3-95.2-62.2-107.8c-41.9-11.2-84.9 9.8-102.6 47.8c-1.7 3.8-5.9 5.9-9.9 4.9L388.9 233z'
      
    ]
  };

  

  
  

  var faLandmarkDome = {
    prefix: 'fal',
    iconName: 'landmark-dome',
    icon: [
      512,
      512,
      ["landmark-alt"],
      'f752',
      
      'M256 0c8.8 0 16 7.2 16 16l0 16.7c87.9 7.2 159 73.7 173.3 159.3l18.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0L96 224l-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l18.7 0C81 106.3 152.1 39.9 240 32.7L240 16c0-8.8 7.2-16 16-16zM99.2 192l313.6 0C398 119 333.4 64 256 64s-142 55-156.8 128zM64 352l0-96 32 0 0 96 80 0 0-96 32 0 0 96 96 0 0-96 32 0 0 96 80 0 0-96 32 0 0 96c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zM24 432c0-8.8 7.2-16 16-16l432 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L40 448c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faLandmarkAlt = faLandmarkDome;
  

  
  

  var faBrazilianRealSign = {
    prefix: 'fal',
    iconName: 'brazilian-real-sign',
    icon: [
      512,
      512,
      [],
      'e46c',
      
      'M400 0c8.8 0 16 7.2 16 16l0 48.5c16.8 1.4 33.3 5.4 48.9 11.9L478.2 82c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6l-13.3-5.6C436.9 99.4 420 96 403 96l-15.7 0c-37.2 0-67.3 30.1-67.3 67.3c0 28.6 18.1 54.1 45.1 63.6l80.3 28c39.9 13.9 66.6 51.5 66.6 93.8c0 53.7-42.7 97.5-96 99.3l0 48.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48.5c-22.1-1.8-43.5-8.6-62.6-20l-25.6-15.3c-7.6-4.5-10-14.4-5.5-21.9s14.4-10.1 21.9-5.5l25.6 15.3c17.4 10.4 37.3 15.9 57.5 15.9l17.3 0c37.2 0 67.3-30.1 67.3-67.3c0-28.6-18.1-54.1-45.1-63.6l-80.3-28c-39.9-13.9-66.6-51.5-66.6-93.8c0-53.7 42.7-97.5 96-99.3L384 16c0-8.8 7.2-16 16-16zM0 80C0 53.5 21.5 32 48 32l64 0c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2l-80 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 304 0 80zM32 288l80 0c61.9 0 112-50.1 112-112s-50.1-112-112-112L48 64c-8.8 0-16 7.2-16 16l0 208z'
      
    ]
  };

  

  
  

  var faHatWinter = {
    prefix: 'fal',
    iconName: 'hat-winter',
    icon: [
      512,
      512,
      [],
      'f7a8',
      
      'M256 32c7.2 11.3 20.8 16.9 33.9 14c0 0 0 0 0 0c0 0 0 0 0 0C287 59.2 292.6 72.8 304 80c0 0 0 0 0 0c0 0 0 0 0 0c-11.3 7.2-16.9 20.8-14 33.9c0 0 0 0 0 0c0 0 0 0 0 0c-13.1-2.9-26.7 2.7-33.9 14c0 0 0 0 0 0c0 0 0 0 0 0c-7.2-11.3-20.8-16.9-33.9-14c0 0 0 0 0 0c0 0 0 0 0 0c2.9-13.1-2.7-26.7-14-33.9c0 0 0 0 0 0c0 0 0 0 0 0c11.3-7.2 16.9-20.8 14-33.9c0 0 0 0 0 0c0 0 0 0 0 0c13.1 2.9 26.7-2.7 33.9-14c0 0 0 0 0 0c0 0 0 0 0 0zm56.5-8.6c-8-8-19.3-10.9-29.6-8.6C277.3 5.9 267.3 0 256 0s-21.3 5.9-27 14.8c-10.3-2.3-21.5 .6-29.6 8.6s-10.9 19.3-8.6 29.6C181.9 58.7 176 68.7 176 80s5.9 21.3 14.8 27c-2.3 10.3 .6 21.5 8.6 29.6s19.3 10.9 29.6 8.6c5.7 8.9 15.7 14.8 27 14.8s21.3-5.9 27-14.8c10.3 2.3 21.5-.6 29.6-8.6s10.9-19.3 8.6-29.6c8.9-5.7 14.8-15.7 14.8-27s-5.9-21.3-14.8-27c2.3-10.3-.6-21.5-8.6-29.6zM32 456c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24zM0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56s-25.1-56-56-56L56 400c-30.9 0-56 25.1-56 56zM162.5 134.6C64.3 188.2 39.4 321.8 33.6 368l32.3 0c.8-5.8 1.9-12.8 3.3-20.6c.5-2.9 1.1-5.9 1.8-9l8.2-4.1L127.8 310c4.8-2.4 10.4-2.2 15.1 .4l26.3 15c13.9 8 30.9 8.4 45.3 1.3l34.4-17.2c4.5-2.3 9.8-2.3 14.3 0l34.4 17.2c14.4 7.2 31.3 6.7 45.3-1.3l26.3-15c4.6-2.7 10.3-2.8 15.1-.4l48.7 24.3 8.2 4.1c.6 3.1 1.2 6.1 1.8 9c1.5 7.9 2.5 14.8 3.3 20.6l32.3 0c-5.8-46.2-30.7-179.8-128.8-233.4c-2.5 9-7.3 17.5-14.4 24.6c-.9 .9-1.8 1.8-2.8 2.6c40.1 21.1 66.4 58.5 84.3 99.1c5.4 12.2 9.9 24.5 13.6 36.4l-31.9-15.9c-14.4-7.2-31.3-6.7-45.3 1.3l-26.3 15c-4.6 2.7-10.3 2.8-15.1 .4l-34.4-17.2c-13.5-6.8-29.4-6.8-42.9 0L200.2 298c-4.8 2.4-10.4 2.2-15.1-.4l-26.3-15c-13.9-8-30.9-8.4-45.3-1.3L81.6 297.3c3.7-11.9 8.2-24.2 13.6-36.4c17.9-40.6 44.3-78 84.3-99.1c-1-.8-1.9-1.7-2.8-2.6c-7.1-7.1-11.9-15.6-14.4-24.6z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlay = {
    prefix: 'fal',
    iconName: 'magnifying-glass-play',
    icon: [
      512,
      512,
      [],
      'e660',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm40.1-208l-62.4 36.2 0-72.4L248.1 208zm47.9 0c0-5.7-3-11-8-13.8l-110.2-64c-4.9-2.9-11.1-2.9-16 0s-8 8.1-8 13.9l0 128c0 5.7 3.1 11 8 13.9s11.1 2.8 16 0l110.2-64c4.9-2.9 8-8.1 8-13.8z'
      
    ]
  };

  

  
  

  var faPersonHarassing = {
    prefix: 'fal',
    iconName: 'person-harassing',
    icon: [
      576,
      512,
      [],
      'e549',
      
      'M216 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM112 320l64 0 0-158.8c-3.4-.8-6.9-1.2-10.5-1.2l-34.2 0c-6.8 0-13.3 1.4-19.3 4l0 156zm179.8-37.6L208 183.9 208 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.8L30.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L60.7 170.3c13.9-26 41-42.3 70.6-42.3l34.2 0c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8zM304 32l56 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm88 96c30.9 0 56 25.1 56 56l0 112c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1L464 439.6l0-95.6c0-30.9 25.1-56 56-56zm0 192c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z'
      
    ]
  };

  

  
  

  var faNfcPen = {
    prefix: 'fal',
    iconName: 'nfc-pen',
    icon: [
      576,
      512,
      [],
      'e1fa',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l202.3 0-8 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 124.2-32 32L416 96c0-17.7-14.3-32-32-32zm0 64l0 156.2-32 32L352 128l-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-82.7c0-17.7 14.3-32 32-32l112 0c17.7 0 32 14.3 32 32zM276.2 408.3l-1.9 7.7L96 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 256 190.7 0c-4.8 7.4-8.4 15.6-10.5 24.3zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm294.8 24c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L536.2 304c6.2-6.2 6.2-16.4 0-22.6L518.8 264zM342.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L488.7 351.4l-40-40L342.5 417.7zM473.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L473.5 241.4z'
      
    ]
  };

  

  
  

  var faChessKing = {
    prefix: 'fal',
    iconName: 'chess-king',
    icon: [
      448,
      512,
      [9818],
      'f43f',
      
      'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 0 48L59.6 128C26.7 128 0 154.7 0 187.6c0 8.2 1.7 16.3 4.9 23.8L66.1 352l34.9 0L34.3 198.6c-1.5-3.5-2.3-7.2-2.3-11C32 172.4 44.4 160 59.6 160L224 160l164.4 0c15.2 0 27.6 12.4 27.6 27.6c0 3.8-.8 7.5-2.3 11L347 352l34.9 0 61.1-140.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6L240 128l0-48 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0 0-32zM382.9 468.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L71.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L97.8 416l252.4 0 32.7 52.7zM97.8 384c-11.1 0-21.4 5.7-27.2 15.1L37.9 451.8C34.1 458 32 465.2 32 472.6C32 494.3 49.7 512 71.4 512l305.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1L97.8 384z'
      
    ]
  };

  

  
  

  var faRankingStar = {
    prefix: 'fal',
    iconName: 'ranking-star',
    icon: [
      640,
      512,
      [],
      'e561',
      
      'M300.5 77.2l-3.7 7.5-8.3 1.2L245 92.2 276.6 123l6 5.9-1.4 8.3-7.4 43.3 39-20.6 7.4-3.9 7.5 3.9 38.7 20.3-7.4-43.3-1.4-8.3 6.1-5.9 31.4-30.3-43.4-6.3-8.3-1.2-3.7-7.5L320 37.8 300.5 77.2zm-5-62c10.3-20.6 39.4-19.9 49.1 .1l19.9 40.2 44 6.3 .2 0s0 0 0 0c22.1 3.4 31.5 30.6 15.3 46.9l-.2 .2s0 0 0 0l-31.9 30.8 7.5 43.7 0 .3s0 0 0 0c3.4 22-19.5 39.1-39.8 28.9l-.3-.1s0 0 0 0L320.2 192l-39.5 20.9-.3 .2s0 0 0 0c-20.3 10.2-43.2-6.9-39.8-28.9l0-.3s0 0 0 0l7.5-43.8-31.9-31.1-.2-.2s0 0 0 0c-16.2-16.2-6.7-43.5 15.3-46.9l.2 0s0 0 0 0l44-6.3 19.9-40.2c0 0 0 0 0 0zM192 368l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48zm224 64l0 32c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96 0-64c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 128zM256 304l0 160c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM32 368l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm448 64l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm16-48l96 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faPhoneOffice = {
    prefix: 'fal',
    iconName: 'phone-office',
    icon: [
      576,
      512,
      [],
      'f67d',
      
      'M176 32c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l32 0zM144 0C120.3 0 99.6 12.9 88.6 32L64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-32 0L320 32l-88.6 0C220.4 12.9 199.7 0 176 0L144 0zM288 64l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l16 0 0 304c0 35.3 28.7 64 64 64l32 0c35.3 0 64-28.7 64-64l0-304 48 0zm192 0l0 64-160 0 0-64 160 0zM352 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM480 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z'
      
    ]
  };

  

  
  

  var faEnvelopes = {
    prefix: 'fal',
    iconName: 'envelopes',
    icon: [
      576,
      512,
      [],
      'e170',
      
      'M512 64c17.7 0 32 14.3 32 32l0 19.6L364.4 247.3c-16.9 12.4-39.9 12.4-56.8 0L128 115.6 128 96c0-17.7 14.3-32 32-32l352 0zM128 320l0-164.7L288.7 273.1c28.2 20.7 66.5 20.7 94.6 0L544 155.3 544 320c0 17.7-14.3 32-32 32l-352 0c-17.7 0-32-14.3-32-32zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 352c0 70.7 57.3 128 128 128l336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-336 0c-53 0-96-43-96-96l0-240z'
      
    ]
  };

  

  
  

  var faDownLong = {
    prefix: 'fal',
    iconName: 'down-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-down"],
      'f309',
      
      'M88 352l-49.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.9 .8 3.7 2.2 5L160 476.2 285.8 363.7c1.4-1.3 2.2-3.1 2.2-5c0-3.7-3-6.7-6.7-6.7L232 352c-17.7 0-32-14.3-32-32l0-272c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 272c0 17.7-14.3 32-32 32zm86 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L12.9 387.5C4.7 380.2 0 369.7 0 358.7C0 337.3 17.3 320 38.7 320L56 320l32 0 0-32L88 48c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 240 0 32 32 0 17.3 0c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.5-12.9 28.8L174 506.7z'
      
    ]
  };

  
    var faLongArrowAltDown = faDownLong;
  

  
  

  var faJugBottle = {
    prefix: 'fal',
    iconName: 'jug-bottle',
    icon: [
      640,
      512,
      [],
      'e5fb',
      
      'M128 64l0-32 64 0 0 32-64 0zM96 64L80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 64 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-40c0-13.3-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24l0 40zm32 96l128 0c53 0 96 43 96 96l0 8s0 0 0 0l0 9.7 0 22.3 0 80 0 20.2 0 11.8s0 0 0 0l0 40c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-192c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-192c0-70.7-57.3-128-128-128l-128 0zm128 80c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-96c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zM404 494.6c13.2 10.9 30.1 17.4 48.4 17.4L564 512c42 0 76-34 76-76c0-19.5-7.4-37.3-19.5-50.8C632.6 372.3 640 355 640 336c0-18.8-7.2-35.9-19-48.8c11.8-13.2 19-30.6 19-49.7c0-28.9-16.7-55.2-42.9-67.5l-4.7-2.2c-11-5.1-23-7.8-35.1-7.8l-88.5 0c-13.5 0-26.9 3-39.1 8.7l-9.6 4.5c-7.4 3.5-14.1 8.1-19.8 13.7c5.7 11.8 9.9 24.4 12.6 37.7c3.7-9.7 11.1-17.8 20.8-22.3l9.6-4.5c8-3.7 16.7-5.7 25.5-5.7l88.5 0c7.4 0 14.8 1.6 21.5 4.8l4.7 2.2c14.9 7 24.5 22 24.5 38.5c0 10.9-4.1 20.8-10.9 28.4c-11 12.3-10.9 30.9 .3 43.1C604 316.1 608 325.5 608 336c0 10.6-4.1 20.2-10.8 27.3c-11.4 12.1-11.6 30.9-.5 43.3c7 7.8 11.3 18.1 11.3 29.4c0 24.3-19.7 44-44 44l-111.6 0c-15.5 0-29.3-8-37.1-20.4c-1.5 12.5-5.5 24.3-11.3 34.9zM480 104c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 24 32 0 0-24c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 24 32 0 0-24z'
      
    ]
  };

  

  
  

  var faSdCards = {
    prefix: 'fal',
    iconName: 'sd-cards',
    icon: [
      448,
      512,
      [],
      'e240',
      
      'M416 368c0 17.7-14.3 32-32 32l-240 0c-17.7 0-32-14.3-32-32l0-213.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4L384 32c17.7 0 32 14.3 32 32l0 304zM448 64c0-35.3-28.7-64-64-64L234.5 0c-17 0-33.3 6.7-45.3 18.7L98.7 109.3c-12 12-18.7 28.3-18.7 45.3L80 368c0 35.3 28.7 64 64 64l240 0c35.3 0 64-28.7 64-64l0-304zM240 64c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 384c0 70.7 57.3 128 128 128l240 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-240 0c-53 0-96-43-96-96l0-272z'
      
    ]
  };

  

  
  

  var faTowerCell = {
    prefix: 'fal',
    iconName: 'tower-cell',
    icon: [
      576,
      512,
      [],
      'e585',
      
      'M40.9 9.1c-8.2-3.2-17.5 .9-20.7 9.2C7.2 52.2 0 89.2 0 128s7.2 75.8 20.3 109.8c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C38.4 196 32 162.8 32 128s6.4-67.9 18.1-98.2c3.2-8.2-.9-17.5-9.2-20.7zm494.1 0c-8.2 3.2-12.4 12.4-9.2 20.7C537.6 60.1 544 93.2 544 128s-6.4 67.9-18.1 98.2c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2c13.1-33.9 20.3-71 20.3-109.8s-7.2-75.8-20.3-109.8c-3.2-8.2-12.4-12.4-20.7-9.2zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm47.3 75.1C345.7 159.7 352 144.6 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 16.6 6.3 31.7 16.7 43.1L97.4 489.4c-3.6 8.1 0 17.5 8 21.2s17.5 0 21.2-8l39-86.6 244.9 0 39 86.6c3.6 8.1 13.1 11.7 21.2 8s11.7-13.1 8-21.2L335.3 171.1zM396.1 384l-216.1 0 28.8-64 158.5 0 28.8 64zM308.2 188.8L352.9 288l-129.7 0 44.7-99.2c6.3 2.1 13.1 3.3 20.2 3.3s13.8-1.1 20.2-3.3zM140 70.4c3.5-8.1-.2-17.5-8.3-21.1s-17.5 .2-21.1 8.3C101.2 79.2 96 103 96 128s5.2 48.8 14.7 70.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1c-7.7-17.6-12-37.1-12-57.6s4.3-40 12-57.6zM465.3 57.6c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c7.7 17.6 12 37.1 12 57.6s-4.3 40-12 57.6c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3C474.8 176.8 480 153 480 128s-5.2-48.8-14.7-70.4z'
      
    ]
  };

  

  
  

  var faSchoolLock = {
    prefix: 'fal',
    iconName: 'school-lock',
    icon: [
      640,
      512,
      [],
      'e56f',
      
      'M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96 576 96c35.3 0 64 28.7 64 64l0 112c0-30.5-12.2-58.2-32-78.4l0-33.6c0-17.7-14.3-32-32-32l-112 0c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7L64 128c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l192 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96c0 11.7 3.1 22.6 8.6 32l-8.6 0-32 0-64 0-32 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l107.2 0 140-93.3zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 64 0 0-96zM128 160l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 32 0 0-64-32 0zM96 352c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64zm64 0l-32 0 0 64 32 0 0-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 64l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 64c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm160 80l-160 0 0 128 160 0 0-128z'
      
    ]
  };

  

  
  

  var faCircleEllipsis = {
    prefix: 'fal',
    iconName: 'circle-ellipsis',
    icon: [
      512,
      512,
      [],
      'e10a',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM184 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  

  
  

  var faWatermelonSlice = {
    prefix: 'fal',
    iconName: 'watermelon-slice',
    icon: [
      512,
      512,
      [],
      'e337',
      
      'M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0C481.5 58.9 512 132.5 512 209.1l0 4C512 378.2 378.2 512 213.2 512l-4 0c-76.7 0-150.2-30.5-204.5-84.7c-6.2-6.2-6.2-16.4 0-22.6l400-400zm11 34.3L391 63.7c35.5 40.8 57 94 57 152.3c0 128.1-103.9 232-232 232c-58.3 0-111.6-21.5-152.3-57L39 415.6C85.8 457 146.3 480 209.1 480l4 0C360.5 480 480 360.5 480 213.2l0-4c0-62.8-23-123.3-64.4-170.2zM86.3 368.3C121.3 398 166.5 416 216 416c110.5 0 200-89.5 200-200c0-49.5-18-94.7-47.7-129.7L86.3 368.3zm261-203.6l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-168 72l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faHandHoldingMagic = {
    prefix: 'fal',
    iconName: 'hand-holding-magic',
    icon: [
      576,
      512,
      [],
      'f6e5',
      
      'M160 80c0 26.5 21.5 48 48 48l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-44.2 0-80-35.8-80-80s35.8-80 80-80L328 0c66.3 0 120 53.7 120 120s-53.7 120-120 120l-56 0 0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-26.5c0-16.3 13.2-29.5 29.5-29.5l58.5 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L208 32c-26.5 0-48 21.5-48 48zm-9 237.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7L80 400l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  

  
  

  var faListUl = {
    prefix: 'fal',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM176 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L176 80zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faCodeCompare = {
    prefix: 'fal',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      
      'M322.8 484.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6L265.4 400l70.6 0c44.2 0 80-35.8 80-80l0-161.6c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4L448 320c0 61.9-50.1 112-112 112l-70.6 0 57.4 52.2zM384 80a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM189.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L246.6 112 176 112c-44.2 0-80 35.8-80 80l0 161.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4L64 192c0-61.9 50.1-112 112-112l70.6 0L189.2 27.8zM128 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faDropletDegree = {
    prefix: 'fal',
    iconName: 'droplet-degree',
    icon: [
      512,
      512,
      ["dewpoint"],
      'f748',
      
      'M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7l1.3 0c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM384 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faDewpoint = faDropletDegree;
  

  
  

  var faSkullCrossbones = {
    prefix: 'fal',
    iconName: 'skull-crossbones',
    icon: [
      448,
      512,
      [9760,128369],
      'f714',
      
      'M300.1 198.4c-7.6 6.1-12.1 15.3-12.1 25l0 16.6c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-16.6c0-9.8-4.4-19-12.1-25C125.1 180.2 112 155 112 128c0-49.6 46.5-96 112-96s112 46.4 112 96c0 27-13.1 52.2-35.9 70.4zM320 240l0-16.6c29.5-23.4 48-57.5 48-95.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 37.9 18.5 72 48 95.4l0 16.6c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48zm126.5 57.3c-3.7-8-13.2-11.5-21.2-7.8L224 382.4 22.7 289.5c-8-3.7-17.5-.2-21.2 7.8s-.2 17.5 7.8 21.2L185.8 400 9.3 481.5c-8 3.7-11.5 13.2-7.8 21.2s13.2 11.5 21.2 7.8L224 417.6l201.3 92.9c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L262.2 400l176.5-81.5c8-3.7 11.5-13.2 7.8-21.2zM208 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faClub = {
    prefix: 'fal',
    iconName: 'club',
    icon: [
      512,
      512,
      [9827],
      'f327',
      
      'M358.3 154.9c1.1-6.1 1.7-12.4 1.7-18.9c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 6.5 .6 12.8 1.7 18.9c1.6 8.8-.5 17.9-5.9 25s-13.5 11.7-22.4 12.6C73 197.8 32 242.1 32 296c0 57.4 46.6 104 104 104c39.7 0 74.2-22.2 91.8-55c5.6-10.4 16.4-16.9 28.2-16.9s22.6 6.5 28.2 16.9c17.6 32.8 52.1 55 91.8 55c57.4 0 104-46.6 104-104c0-53.9-41-98.2-93.4-103.5c-8.9-.9-17-5.5-22.4-12.6s-7.5-16.2-5.9-25zm31.5 5.8c7.4 .7 14.7 2.1 21.7 4C469.4 180.3 512 233.1 512 296c0 75.1-60.9 136-136 136c-39.4 0-74.9-16.8-99.7-43.5c-1.5-1.6-2.9-3.2-4.3-4.8l0 96.4 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-96.4c-1.4 1.6-2.8 3.3-4.3 4.8C210.9 415.2 175.4 432 136 432C60.9 432 0 371.1 0 296c0-62.9 42.6-115.8 100.6-131.3c7-1.9 14.3-3.2 21.7-4c-1.3-7.1-2.1-14.5-2.2-22c0-.9 0-1.8 0-2.7C120 60.9 180.9 0 256 0s136 60.9 136 136c0 .9 0 1.8 0 2.7c-.1 7.5-.9 14.8-2.2 22z'
      
    ]
  };

  

  
  

  var faHospitals = {
    prefix: 'fal',
    iconName: 'hospitals',
    icon: [
      576,
      512,
      [],
      'f80e',
      
      'M512 32L320 32c-17.7 0-32 14.3-32 32l0 16c-9.3-7-20.2-12-32-14.4l0-1.6c0-35.3 28.7-64 64-64L512 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-192 0c-5.1 0-10-.6-14.7-1.7c6.3-8.9 10.9-19.2 13.2-30.3c.5 0 1.1 0 1.6 0l192 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32zM224 128L64 128c-17.7 0-32 14.3-32 32l0 192 224 0 0-192c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64L32 384l0 64zM64 96l160 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64zM320 320l0-32 224 0 0 32-224 0zm0 96l0-32 224 0 0 32-224 0zM136 176l16 0c4.4 0 8 3.6 8 8l0 40 40 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-40 0 0 40c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-40-40 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l40 0 0-40c0-4.4 3.6-8 8-8zM416 88c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 40 40 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-40 0 0 40c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-40-40 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l40 0 0-40z'
      
    ]
  };

  

  
  

  var faBookArrowRight = {
    prefix: 'fal',
    iconName: 'book-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0b9',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l368 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-96-32 0 0 96c0 8.8-7.2 16-16 16L64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l336 0c8.8 0 16 7.2 16 16l0 96 32 0 0-96c0-26.5-21.5-48-48-48L64 0zM384 416l0 64L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0zM539.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L585.4 192 272 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l313.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  

  
  

  var faBellPlus = {
    prefix: 'fal',
    iconName: 'bell-plus',
    icon: [
      448,
      512,
      [],
      'f849',
      
      'M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM224 160c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBatteryFull = {
    prefix: 'fal',
    iconName: 'battery-full',
    icon: [
      576,
      512,
      [128267,"battery","battery-5"],
      'f240',
      
      'M432 128c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 384c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l352 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80L80 96zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM112 192l288 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM64 208l0 96c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-288 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery = faBatteryFull;
  
    var faBattery5 = faBatteryFull;
  

  
  

  var faChevronDown = {
    prefix: 'fal',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z'
      
    ]
  };

  

  
  

  var faMoneyBillSimpleWave = {
    prefix: 'fal',
    iconName: 'money-bill-simple-wave',
    icon: [
      576,
      512,
      [],
      'e1f2',
      
      'M32 422.3c0 6.8 3.7 10.4 6.2 11.3c72.8 27.2 146.7 11.3 231.1-10.2c4.3-1.1 8.6-2.2 13-3.3c77.8-19.9 165.3-42.3 253.5-18.2c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0l0-.1 0-309.9c0-6.8-3.7-10.4-6.2-11.3C465 51.2 391.1 67.1 306.7 88.5c-4.3 1.1-8.6 2.2-13 3.3C215.9 111.7 128.4 134.1 40.2 110c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2c0 0 0 0 0 0c0 0 0 0 0 .1l0 309.9zm-32 0L0 112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3l0 309.9c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z'
      
    ]
  };

  

  
  

  var faHandsHoldingDiamond = {
    prefix: 'fal',
    iconName: 'hands-holding-diamond',
    icon: [
      640,
      512,
      ["hand-receiving"],
      'f47c',
      
      'M342.6 9.4l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM224 128l96 96 96-96L320 32l-96 96zM64 64c35.3 0 64 28.7 64 64l0 124.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5L512 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6L608 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16s0 0 0 0l44-44s0 0 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3l0 77.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16s0 0 0 0l-44-44s0 0 0 0l-10.7-10.8C106.8 305.4 96 279.4 96 252.3L96 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2L0 128C0 92.7 28.7 64 64 64z'
      
    ]
  };

  
    var faHandReceiving = faHandsHoldingDiamond;
  

  
  

  var faUserHoodie = {
    prefix: 'fal',
    iconName: 'user-hoodie',
    icon: [
      448,
      512,
      [],
      'e68a',
      
      'M312.5 252.4c-11 10.5-17.9 26.4-15.8 43.6c2.3 18.3 14.1 32.7 28.9 39.8C379.2 361.8 416 416.6 416 480L32 480c0-63.4 36.8-118.2 90.4-144.1c14.8-7.2 26.6-21.5 28.9-39.8c2.2-17.3-4.8-33.1-15.8-43.6C111.1 229.1 96 196.3 96 160C96 89.3 153.3 32 224 32s128 57.3 128 128c0 36.3-15.1 69.1-39.5 92.4zm22.1 23.1C365.1 246.4 384 205.4 384 160C384 71.6 312.4 0 224 0S64 71.6 64 160c0 45.4 18.9 86.4 49.3 115.5c4.5 4.3 6.9 10.4 6.2 16.6c-.8 6.6-5.1 12.1-11.1 15C44.2 338.2 0 403.9 0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32c0-76.1-44.2-141.8-108.4-172.9c-5.9-2.9-10.2-8.4-11.1-15c-.8-6.2 1.7-12.3 6.2-16.6zM176 352c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM160 157.3c0-33 27.8-61.3 64-61.3s64 28.3 64 61.3c0 17.5-8.5 35.8-22.9 53.6c-13.1 16.2-29 29.5-41.1 38.5c-12.1-8.9-28-22.3-41.1-38.5c-14.4-17.9-22.9-36.1-22.9-53.6zM224 64c-53 0-96 41.8-96 93.3c0 55.6 53.3 100.9 80.5 120.4c9.4 6.7 21.7 6.7 31.1 0C266.7 258.2 320 213 320 157.3c0-51.5-43-93.3-96-93.3z'
      
    ]
  };

  

  
  

  var faTransporter2 = {
    prefix: 'fal',
    iconName: 'transporter-2',
    icon: [
      512,
      512,
      [],
      'e044',
      
      'M64 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16L16 64C7.2 64 0 56.8 0 48s7.2-16 16-16l16 0 0-16C32 7.2 39.2 0 48 0s16 7.2 16 16zM480 336l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16l-224 0zM383.7 224l-40.2 0-22-29c-.5-.7-1-1.3-1.5-1.9l0 30.9-32 0 0-47.8c-1.6-.2-3.1-.2-4.7-.2l-54.6 0c-1.6 0-3.2 .1-4.7 .2l0 47.8-32 0 0-30.9c-.5 .6-1 1.3-1.5 1.9l-22 29-40.2 0L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7l54.6 0c25 0 48.6 11.7 63.7 31.7L383.7 224zM96 272c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.1 16 15.9c0 0 0 0 0 .1s0 0 0 .1c0 8.8-7.2 15.9-16 15.9l-288 0c-8.8 0-16-7.2-16-16zm64 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faPersonCircleExclamation = {
    prefix: 'fal',
    iconName: 'person-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e53f',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91L224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSuitcaseRolling = {
    prefix: 'fal',
    iconName: 'suitcase-rolling',
    icon: [
      384,
      512,
      [],
      'f5c1',
      
      'M128 48l0 80 128 0 0-80c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM96 128l0-80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 80 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16L96 480l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l32 0zM80 448l224 0 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-48 0-160 0-48 0c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l16 0zM96 256c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faDisplaySlash = {
    prefix: 'fal',
    iconName: 'display-slash',
    icon: [
      640,
      512,
      ["desktop-slash"],
      'e2fa',
      
      'M32 110.3L32 352c0 35.3 28.7 64 64 64l149.1 0-10.7 64L176 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 72 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.4 0-10.7-64 24.3 0-40.5-32-2.4 0c-.2 0-.4 0-.6 0l-111.5 0c-.2 0-.4 0-.6 0L96 384c-17.7 0-32-14.3-32-32l0-216.4L32 110.3zm562.5 281C603 380.5 608 366.8 608 352l0-288c0-35.3-28.7-64-64-64L96 0c-1.5 0-3 .1-4.4 .2L99 .2 139.4 32 544 32c17.7 0 32 14.3 32 32l0 288c0 7.3-2.5 14.1-6.6 19.5l25.1 19.8zM277.6 416l84.9 0 10.7 64-106.2 0 10.7-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faDesktopSlash = faDisplaySlash;
  

  
  

  var faCircleMicrophoneLines = {
    prefix: 'fal',
    iconName: 'circle-microphone-lines',
    icon: [
      512,
      512,
      ["microphone-circle-alt"],
      'e117',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-64 0-16c0-35.3-28.7-64-64-64zm32 64l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 65.3 48.9 119.1 112 127l0 17c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17c63.1-7.9 112-61.7 112-127l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16z'
      
    ]
  };

  
    var faMicrophoneCircleAlt = faCircleMicrophoneLines;
  

  
  

  var faSquarePen = {
    prefix: 'fal',
    iconName: 'square-pen',
    icon: [
      448,
      512,
      ["pen-square","pencil-square"],
      'f14b',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm299.5 67.3c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L213.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L254.2 140.7z'
      
    ]
  };

  
    var faPenSquare = faSquarePen;
  
    var faPencilSquare = faSquarePen;
  

  
  

  var faTablePicnic = {
    prefix: 'fal',
    iconName: 'table-picnic',
    icon: [
      512,
      512,
      [],
      'e32d',
      
      'M191.6 64L80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l88.2 0L115.8 224 16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l86.7 0 34.6 0 237.4 0 34.6 0 86.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-99.8 0L343.8 96 432 96c8.8 0 16-7.2 16-16s-7.2-16-16-16L320.4 64c-.2 0-.5 0-.7 0L192.4 64c-.2 0-.5 0-.7 0zM309.3 96l52.4 128-211.2 0L202.7 96l106.5 0zM89.6 288L33.2 425.9c-3.3 8.2 .6 17.5 8.8 20.9s17.5-.6 20.9-8.8L124.2 288l-34.6 0zm332.8 0l-34.6 0 61.4 150.1c3.3 8.2 12.7 12.1 20.9 8.8s12.1-12.7 8.8-20.9L422.4 288z'
      
    ]
  };

  

  
  

  var faReceipt = {
    prefix: 'fal',
    iconName: 'receipt',
    icon: [
      384,
      512,
      [129534],
      'f543',
      
      'M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16L0 496c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5l52.7-46.1 45.4 45.4c6.2 6.2 16.4 6.2 22.6 0L192 462.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4L357.5 508c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6l0-480c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4L304.7 50.1 259.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7L32 51.3 69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8 .7L352 51.3l0 409.5L314.5 428c-6.3-5.5-15.9-5.2-21.8 .7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4 91.3 428.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z'
      
    ]
  };

  

  
  

  var faFilePen = {
    prefix: 'fal',
    iconName: 'file-pen',
    icon: [
      576,
      512,
      [128221,"file-edit"],
      'f31c',
      
      'M64 480l194.6 0-1.1 4.5c-2.3 9.2-1.8 18.8 1.3 27.5L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 121.8-32 32L352 192l-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zm167 104c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 39.9 39.9 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L518.6 264zM342.4 417.5c-2.1 2.1-3.5 4.6-4.2 7.4L326 473.9l48.9-12.2c2.8-.7 5.4-2.2 7.4-4.2L488.5 351.3l-39.9-39.9L342.4 417.5zM473.3 241.4c18.7-18.7 49.1-18.7 67.9 0l17.3 17.3c18.7 18.7 18.7 49.1 0 67.9L405 480.1c-6.2 6.2-13.9 10.5-22.3 12.6l-74.8 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.8c2.1-8.4 6.5-16.2 12.6-22.3L473.3 241.4z'
      
    ]
  };

  
    var faFileEdit = faFilePen;
  

  
  

  var faWalkieTalkie = {
    prefix: 'fal',
    iconName: 'walkie-talkie',
    icon: [
      384,
      512,
      [],
      'f8ef',
      
      'M96 16C96 7.2 88.8 0 80 0S64 7.2 64 16l0 80-8 0C25.1 96 0 121.1 0 152L0 302.1c0 10.6 4.2 20.8 11.7 28.3l17.9 17.9c1.5 1.5 2.3 3.5 2.3 5.7L32 456c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-102.1c0-2.1 .8-4.2 2.3-5.7l17.9-17.9c7.5-7.5 11.7-17.7 11.7-28.3L384 152c0-30.9-25.1-56-56-56L96 96l0-80zM80 128l248 0c13.3 0 24 10.7 24 24l0 150.1c0 2.1-.8 4.2-2.3 5.7l-17.9 17.9c-7.5 7.5-11.7 17.7-11.7 28.3L320 456c0 13.3-10.7 24-24 24L88 480c-13.3 0-24-10.7-24-24l0-102.1c0-10.6-4.2-20.8-11.7-28.3L34.3 307.7c-1.5-1.5-2.3-3.5-2.3-5.7L32 152c0-13.3 10.7-24 24-24l24 0zm96-80c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zM96 192c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faWand = {
    prefix: 'fal',
    iconName: 'wand',
    icon: [
      512,
      512,
      [],
      'f72a',
      
      'M446.8 9.9C454 3.5 463.2 0 472.8 0C494.5 0 512 17.5 512 39.2l0 .5c0 9-3.1 17.8-8.7 24.8L448 133.6l0 26.4c0 17.7-14.3 32-32 32l-24.9 0L119 494.4C108.9 505.6 94.5 512 79.4 512c-14.1 0-27.7-5.6-37.6-15.6L15.6 470.2C5.6 460.2 0 446.7 0 432.6c0-15.1 6.5-29.5 17.7-39.6L96 323.1 96 296c0-22.1 17.9-40 40-40l33.9 0L446.8 9.9zm26 22.1c-1.8 0-3.5 .6-4.8 1.8L186.6 284c-2.9 2.6-6.7 4-10.6 4l-40 0c-4.4 0-8 3.6-8 8l0 34.3c0 4.6-1.9 8.9-5.3 11.9L39.1 416.9c-4.5 4-7.1 9.7-7.1 15.8c0 5.6 2.2 11 6.2 14.9l26.2 26.2c4 4 9.4 6.2 15 6.2c6 0 11.8-2.6 15.8-7L372.1 165.3c3-3.4 7.4-5.3 11.9-5.3l32 0 0-32c0-3.6 1.2-7.2 3.5-10l58.8-73.5c1.1-1.4 1.7-3.1 1.7-4.8l0-.5c0-4-3.2-7.2-7.2-7.2z'
      
    ]
  };

  

  
  

  var faCartArrowDown = {
    prefix: 'fal',
    iconName: 'cart-arrow-down',
    icon: [
      576,
      512,
      [],
      'f218',
      
      'M0 16C0 7.2 7.2 0 16 0L53.9 0c22.8 0 42.5 16 47 38.4L145.4 256l321.1 0c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288L152 288l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-304.8 0c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32L16 32C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM336 16l0 137.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 153.4 304 16c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faColon = {
    prefix: 'fal',
    iconName: 'colon',
    icon: [
      192,
      512,
      [],
      '3a',
      
      'M128 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 128zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 384z'
      
    ]
  };

  

  
  

  var faCartFlatbedEmpty = {
    prefix: 'fal',
    iconName: 'cart-flatbed-empty',
    icon: [
      640,
      512,
      ["dolly-flatbed-empty"],
      'f476',
      
      'M0 16C0 7.2 7.2 0 16 0L80 0c26.5 0 48 21.5 48 48l0 320c0 8.8 7.2 16 16 16l80 0 288 0 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56.6 0c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32l-177.1 0c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32L144 416c-26.5 0-48-21.5-48-48L96 48c0-8.8-7.2-16-16-16L16 32C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faDollyFlatbedEmpty = faCartFlatbedEmpty;
  

  
  

  var faLobster = {
    prefix: 'fal',
    iconName: 'lobster',
    icon: [
      512,
      512,
      [129438],
      'e421',
      
      'M32 80c0-19.2 11.3-35.8 27.6-43.4L48.3 92.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l16-80c.9-4.7-.3-9.6-3.3-13.3S84.8 0 80 0C35.8 0 0 35.8 0 80l0 48c0 35.3 28.7 64 64 64c6.2 0 12.2-.9 17.9-2.5l26.9 20.1c19.4 14.5 43 22.4 67.2 22.4l0 24-32.9 0c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4l32.9 0 0 16-53.6 0c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1l53.6 0 0 16-.9 0c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1l.9 0s0 0 0 0l18.5 51.7C169.7 444.6 152 468.2 152 496c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16c0-27.8-17.7-51.4-42.5-60.3L336 384s0 0 0 0l.9 0c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4l-.9 0 0-16 53.6 0c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5L336 304l0-16 32.9 0c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1L336 256l0-24c24.2 0 47.8-7.9 67.2-22.4l26.9-20.1c5.7 1.7 11.7 2.5 17.9 2.5c35.3 0 64-28.7 64-64l0-48c0-44.2-35.8-80-80-80c-4.8 0-9.3 2.1-12.4 5.9s-4.3 8.6-3.3 13.3l16 80c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L452.4 36.6C468.7 44.2 480 60.8 480 80l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 16.7 6.4 31.9 16.9 43.3L384 184c-13.8 10.4-30.7 16-48 16c0-25.6-14.7-48.9-32-67.2l0-52.1c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7l0 25c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8l0-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7l0 52.1c-17.3 18.3-32 41.6-32 67.2c-17.3 0-34.2-5.6-48-16l-16.9-12.7C121.6 159.9 128 144.7 128 128l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48zM304 200l0 32 0 40 0 27.6c-1 .2-2.1 .4-3.3 .6c-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6l0-27.6 0-40 0-32s0 0 0 0c0-12.1 6.5-26.2 19.3-40.9c9-10.4 19.7-19.2 28.7-25.7c9.1 6.4 19.7 15.3 28.7 25.7C297.5 173.8 304 187.9 304 200c0 0 0 0 0 0zM208 332.2c11.6 2 27.7 3.8 48 3.8s36.4-1.8 48-3.8l0 15.4c-1 .2-2.1 .4-3.3 .6c-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6l0-15.4zM256 384c20 0 35.8-1.7 47.3-3.7l-5.5 15.5c-12.9 2.1-29.3 4.2-41.8 4.2s-28.9-2.1-41.8-4.2l-5.5-15.5c11.5 1.9 27.4 3.7 47.3 3.7zm-30.1 45.8c10 1.2 20.7 2.2 30.1 2.2s20.1-1 30.1-2.2c-2.9 15.2 5.7 30.7 20.7 36.1c7.2 2.6 13.2 7.6 17 14.2l-135.4 0c3.8-6.5 9.7-11.6 17-14.2c15-5.4 23.6-20.8 20.7-36.1z'
      
    ]
  };

  

  
  

  var faBracketCurly = {
    prefix: 'fal',
    iconName: 'bracket-curly',
    icon: [
      256,
      512,
      ["bracket-curly-left"],
      '7b',
      
      'M64 112c0-44.2 35.8-80 80-80l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48l0 53.5c0 21.2-8.4 41.6-23.4 56.6L38.6 256l33.9 33.9c15 15 23.4 35.4 23.4 56.6L96 400c0 26.5 21.5 48 48 48l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-44.2 0-80-35.8-80-80l0-53.5c0-12.7-5.1-24.9-14.1-33.9L4.7 267.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l45.3-45.3c9-9 14.1-21.2 14.1-33.9L64 112z'
      
    ]
  };

  
    var faBracketCurlyLeft = faBracketCurly;
  

  
  

  var faTaxiBus = {
    prefix: 'fal',
    iconName: 'taxi-bus',
    icon: [
      640,
      512,
      [],
      'e298',
      
      'M192 32c79 0 124.2 20.8 146.2 38.1c7 5.5 11.1 14.4 12.9 25.9L192 96 33 96c1.7-11.5 5.9-20.3 12.9-25.9C67.8 52.8 113 32 192 32zM32 224l0-96 144 0 0 96L32 224zm0 128l0-96 160 0 83.8 0 9.1-32L208 224l0-96 136.6 0c8.4-14.5 22.3-25.4 38.9-29.8C381.8 79.5 375.6 59 358 45C329.2 22.2 276.5 0 192 0S54.8 22.2 26 45C4.5 62.1 0 88.9 0 110.2L0 352c0 23.7 12.9 44.4 32 55.4L32 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 160 0 0-32L64 384c-17.7 0-32-14.3-32-32zm96-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM488 160c4.4 0 8 3.6 8 8l0 8-96 0 0-8c0-4.4 3.6-8 8-8l80 0zm-120 8l0 9.2c-23.3 4.5-42.6 21.8-49.3 45.2L297 298.1c-24.5 13.7-41 39.9-41 69.9l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-6.7-23.5-26-40.7-49.3-45.2l0-9.2c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40zm16 40l128 0 3.8 0c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2l3.8 0zM608 432l-320 0 0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48 0 16zM360 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm200 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCirclesOverlap3 = {
    prefix: 'fal',
    iconName: 'circles-overlap-3',
    icon: [
      512,
      512,
      ["pronoun"],
      'e6a1',
      
      'M224.2 275.7c3.2-6.4 6.9-12.5 10.9-18.3c-21-20.2-49.3-32.7-80.6-33.4c15.8 25 40.5 43.7 69.7 51.7zM108.8 198.2c-3.2-12.2-4.8-25-4.8-38.2C104 76.1 172.1 8 256 8s152 68.1 152 152c0 13.2-1.7 26-4.8 38.2C466.1 216.8 512 275 512 344c0 83.9-68.1 152-152 152c-40.2 0-76.8-15.6-104-41.1C228.8 480.4 192.2 496 152 496C68.1 496 0 427.9 0 344c0-69 45.9-127.2 108.8-145.8zm31.6-5.8c3.8-.3 7.7-.4 11.6-.4c40.2 0 76.8 15.6 104 41.1c27.2-25.5 63.8-41.1 104-41.1c3.9 0 7.7 .1 11.6 .4c2.9-10.3 4.4-21.2 4.4-32.4c0-66.3-53.7-120-120-120s-120 53.7-120 120c0 11.2 1.5 22.1 4.4 32.4zM357.5 224c-31.3 .6-59.6 13.2-80.6 33.4c4 5.8 7.7 12 10.9 18.3c29.2-8 53.9-26.7 69.7-51.7zM244.4 311.6c-2.9 10.3-4.4 21.2-4.4 32.4c0 21.8 5.8 42.3 16 59.9c10.2-17.6 16-38.1 16-59.9c0-11.2-1.5-22.1-4.4-32.4c-3.8 .3-7.7 .4-11.6 .4s-7.7-.1-11.6-.4zm-31.6-5.8c-40.5-12-74-40.4-92.7-77.5C69.3 242.2 32 288.8 32 344c0 66.3 53.7 120 120 120c32.2 0 61.5-12.7 83.1-33.4C218 406 208 376.2 208 344c0-13.2 1.7-26 4.8-38.2zm86.3 0c3.2 12.2 4.8 25 4.8 38.2c0 32.2-10 62-27.1 86.6C298.5 451.3 327.8 464 360 464c66.3 0 120-53.7 120-120c0-55.2-37.3-101.8-88.2-115.7c-18.7 37.1-52.2 65.5-92.7 77.5z'
      
    ]
  };

  
    var faPronoun = faCirclesOverlap3;
  

  
  

  var faPeach = {
    prefix: 'fal',
    iconName: 'peach',
    icon: [
      512,
      512,
      [],
      'e20b',
      
      'M128 0C101.5 0 80 21.5 80 48c0 17 3.8 33.1 10.6 47.5c9.9-4.1 20.1-7.5 30.7-10.1C115.4 74.3 112 61.5 112 48c0-8.8 7.2-16 16-16l32 0c37.2 0 68.5 25.4 77.4 59.9c12.1 2.8 25 2.8 37.1 0C283.5 57.4 314.8 32 352 32l32 0c8.8 0 16 7.2 16 16c0 13.5-3.4 26.3-9.3 37.5c10.6 2.5 20.9 5.9 30.7 10.1C428.2 81.1 432 65 432 48c0-26.5-21.5-48-48-48L352 0c-40.7 0-76.4 21.8-96 54.3C236.4 21.8 200.7 0 160 0L128 0zm40 144c69.7 0 127.2 52.4 135.1 120c1 8.8 8.1 16 16.9 16s16.1-7.2 15.2-16c-4-42.8-24.1-80.9-54.1-108.2c6.9-1.2 13.8-2.9 20.5-5.1c13.3-4.4 27.5-6.7 42.4-6.7c75.1 0 136 60.9 136 136c0 51.7-38.2 97-91.1 134c-51.5 36.1-108.6 58.2-128.2 65.3c-1.1 .4-2.6 .7-4.7 .7s-3.5-.3-4.7-.7c-19.6-7-76.7-29.2-128.2-65.3C70.2 377 32 331.7 32 280c0-75.1 60.9-136 136-136zm123.7-23.7c-23 7.5-48.4 7.5-71.4 0c-16.5-5.4-34-8.3-52.3-8.3C75.2 112 0 187.2 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-92.8-75.2-168-168-168c-18.3 0-35.9 2.9-52.3 8.3z'
      
    ]
  };

  

  
  

  var faNairaSign = {
    prefix: 'fal',
    iconName: 'naira-sign',
    icon: [
      448,
      512,
      [],
      'e1f6',
      
      'M93.2 38.9c-4-5.8-11.2-8.3-17.9-6.2S64 41 64 48l0 208-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 130.7 0L354.8 473.1c4 5.8 11.2 8.3 17.9 6.2s11.2-8.3 11.2-15.3l0-176 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 208-108.5 0L93.2 38.9zM265.6 288l86.4 0 0 124.8L265.6 288zm-61.1-32L96 256 96 99.2 204.5 256z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleXmark = {
    prefix: 'fal',
    iconName: 'floppy-disk-circle-xmark',
    icon: [
      576,
      512,
      ["floppy-disk-times","save-circle-xmark","save-times"],
      'e181',
      
      'M32 96l0 320c0 17.7 14.3 32 32 32l211.2 0c5.9 11.4 12.9 22.2 21 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3l0 22.2c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7l0-22.2c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6l0 94.2c0 17.7-14.3 32-32 32L96 192c-17.7 0-32-14.3-32-32l0-96C46.3 64 32 78.3 32 96zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64l0 96 192 0 0-96L96 64zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z'
      
    ]
  };

  
    var faFloppyDiskTimes = faFloppyDiskCircleXmark;
  
    var faSaveCircleXmark = faFloppyDiskCircleXmark;
  
    var faSaveTimes = faFloppyDiskCircleXmark;
  

  
  

  var faLocationQuestion = {
    prefix: 'fal',
    iconName: 'location-question',
    icon: [
      384,
      512,
      ["map-marker-question"],
      'f60b',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM104.7 137.8c6.5-24.6 28.7-41.8 54.2-41.8L216 96c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L208 236.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM168 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faMapMarkerQuestion = faLocationQuestion;
  

  
  

  var faSignalGood = {
    prefix: 'fal',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      'M336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288zM192 288c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faTrashCanArrowUp = {
    prefix: 'fal',
    iconName: 'trash-can-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore-alt"],
      'f82a',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm160 80c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6 240 392c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-161.4-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z'
      
    ]
  };

  
    var faTrashRestoreAlt = faTrashCanArrowUp;
  

  
  

  var faChevronsDown = {
    prefix: 'fal',
    iconName: 'chevrons-down',
    icon: [
      512,
      512,
      ["chevron-double-down"],
      'f322',
      
      'M52.7 75.3l192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4 75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm0 192l192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 425.4 75.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faChevronDoubleDown = faChevronsDown;
  

  
  

  var faPersonDotsFromLine = {
    prefix: 'fal',
    iconName: 'person-dots-from-line',
    icon: [
      576,
      512,
      ["diagnoses"],
      'f470',
      
      'M344 88A56 56 0 1 0 232 88a56 56 0 1 0 112 0zM200 88a88 88 0 1 1 176 0A88 88 0 1 1 200 88zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 256l0-191.4c-21.4 6.5-40.2 14.2-56.3 21.9c-20 9.6-35.5 19.2-45.9 26.3c-5.2 3.6-9.2 6.5-11.7 8.5c-1.3 1-2.2 1.8-2.9 2.3l-.6 .5-.1 .1s0 0 0 0s0 0 0 0c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6L48 304c-10.4-12.1-10.4-12.1-10.4-12.1s0 0 0 0s0 0 0 0l.1-.1 .3-.2 1-.8c.8-.7 2-1.6 3.5-2.8c3.1-2.4 7.5-5.7 13.3-9.6c11.6-7.9 28.5-18.3 50.1-28.7C149.1 228.8 211.5 208 288 208s138.9 20.8 182.1 41.6c21.6 10.4 38.5 20.8 50.1 28.7c5.8 3.9 10.2 7.3 13.3 9.6c1.5 1.2 2.7 2.1 3.5 2.8l1 .8 .3 .2 .1 .1c0 0 0 0 0 0s0 0 0 0L528 304l10.4-12.1c6.7 5.8 7.4 15.9 1.7 22.6s-15.9 7.4-22.5 1.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1-.1-.6-.5c-.6-.5-1.6-1.3-2.9-2.3c-2.6-2-6.5-4.9-11.7-8.5c-10.4-7.1-25.9-16.7-45.9-26.3c-16-7.7-34.9-15.4-56.3-21.9L400 448l-32 0 0-199.6c-24.3-5.1-51-8.4-80-8.4s-55.7 3.2-80 8.4L208 448l-32 0zM0 496c0-8.8 7.2-16 16-16l544 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16zM304 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faDiagnoses = faPersonDotsFromLine;
  

  
  

  var faTableTennisPaddleBall = {
    prefix: 'fal',
    iconName: 'table-tennis-paddle-ball',
    icon: [
      512,
      512,
      [127955,"ping-pong-paddle-ball","table-tennis"],
      'f45d',
      
      'M423.8 88.2c56.7 56.7 70.5 139.9 41.5 209.6c10 4.2 19.4 9.6 27.9 16.1c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7c-24 24-37.5 56.6-37.5 90.5l0 2.7c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6 .3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5l2.7 0c3.1 0 6.1-.1 9.2-.3c-5.6-9.8-10-20.4-12.9-31.7c-25.1-.3-49.1-10.3-66.9-28.1l-9.8-9.8c-26.3-26.3-69.3-24.7-93.6 3.3L64 480 32 448l66.6-57.7c28.1-24.3 29.6-67.4 3.3-93.6l-9.8-9.8C74.1 268.9 64 244.4 64 219l0-2.7c0-18.2 5.2-35.8 14.6-51L293.2 379.8c3.3-11.1 8-21.6 14-31.3L99.5 140.9l52.7-52.7c75-75 196.5-75 271.5 0zM352 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  
    var faPingPongPaddleBall = faTableTennisPaddleBall;
  
    var faTableTennis = faTableTennisPaddleBall;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faRupiahSign = {
    prefix: 'fal',
    iconName: 'rupiah-sign',
    icon: [
      512,
      512,
      [],
      'e23d',
      
      'M0 80C0 53.5 21.5 32 48 32l64 0c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2l-80 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 304 0 80zM32 288l80 0c61.9 0 112-50.1 112-112s-50.1-112-112-112L48 64c-8.8 0-16 7.2-16 16l0 208zm288-80l0 144 80 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-64 0c-8.8 0-16 7.2-16 16zm16-48l64 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-80 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-288c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faTableCellsRowLock = {
    prefix: 'fal',
    iconName: 'table-cells-row-lock',
    icon: [
      640,
      512,
      [],
      'e67a',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64 448 0 0-64c0-17.7-14.3-32-32-32L64 64zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 40.6 0c-5.4 9.4-8.6 20.3-8.6 32l-32 0 0 96zM192 320l128 0 0-128-128 0 0 128zm336-96c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm160 80l-160 0 0 128 160 0 0-128z'
      
    ]
  };

  

  
  

  var faBurgerLettuce = {
    prefix: 'fal',
    iconName: 'burger-lettuce',
    icon: [
      512,
      512,
      [],
      'e3e3',
      
      'M256 64c94.4 0 172.9 68.1 189 157.8l0 .1c0 .1-.1 .2-.3 .3c-.7 .8-2.4 1.7-4.7 1.7L72 224c-2.4 0-4-1-4.7-1.7c-.1-.1-.2-.2-.3-.3l0-.1C83.1 132.1 161.6 64 256 64zM35.5 216.2C31.6 237.9 49.9 256 72 256l368 0c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2zM128 448c-35.3 0-64-28.7-64-64l384 0c0 35.3-28.7 64-64 64l-256 0zM32 384c0 53 43 96 96 96l256 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L64 352c-17.7 0-32 14.3-32 32zM176 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 334.4c19.6 0 35.2-9.4 47.6-16.8l2.1-1.3c13.5-8.1 24.4-14 38.3-14c13.5 0 22.2 5.5 34.9 13.7c12.7 8.2 28.6 18.3 53.1 18.3c24.4 0 39.5-10.1 51.6-18.1l.4-.3c11.8-7.9 20.7-13.6 36-13.6c15.7 0 26.7 6 39.5 13.9l2.6 1.6c11.7 7.3 26.6 16.5 45.9 16.5c18.5 0 32.7-4.6 42.4-9.5c4.9-2.4 8.6-4.9 11.2-6.9c1.3-1 2.3-1.8 3.1-2.5c.4-.3 .7-.6 .9-.8l.3-.3 .1-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0L480 304l10.2 10.2c5.6-5.6 5.6-14.7 0-20.4c-5.6-5.6-14.6-5.6-20.2-.1l-.2 .2c-.2 .2-.7 .6-1.4 1.1c-1.4 1-3.7 2.6-6.8 4.1c-6.2 3.1-16 6.5-29.6 6.5c-10.9 0-19.2-5.1-32.6-13.4l-.8-.5c-13.3-8.2-30.3-18.1-54.5-18.1c-24.4 0-39.5 10.1-51.6 18.1l-.4 .3c-11.8 7.9-20.7 13.6-36 13.6c-15.5 0-25.3-5.9-37.5-13.7l-1.4-.9c-11.9-7.7-26.9-17.4-49.1-17.4c-22.7 0-39.8 10.1-53.1 18c-14.2 8.5-23.6 14-34.9 14c-13.5 0-23.3-3.4-29.6-6.5c-3.1-1.6-5.4-3.1-6.8-4.1c-.7-.5-1.2-.9-1.4-1.1l-.2-.2c-5.6-5.5-14.7-5.4-20.2 .1c-5.6 5.6-5.6 14.7 0 20.4L32 304c-10.2 10.2-10.2 10.2-10.2 10.2s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.1 .1 .3 .3c.2 .2 .6 .5 .9 .8c.8 .7 1.8 1.5 3.1 2.5c2.6 2 6.3 4.4 11.2 6.9c9.8 4.9 24 9.5 42.4 9.5z'
      
    ]
  };

  

  
  

  var faSquareDownLeft = {
    prefix: 'fal',
    iconName: 'square-down-left',
    icon: [
      448,
      512,
      [],
      'e26b',
      
      'M64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm144-88l0-113.4c0-3.7 3-6.6 6.6-6.6c1.8 0 3.4 .7 4.7 1.9l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0l59.1-59.1c3.6-3.6 9-4.9 13.9-3.3c2 .7 3.8 1.8 5.3 3.3l22.1 22.1c1.5 1.5 2.6 3.3 3.3 5.3c1.6 4.9 .4 10.3-3.3 13.9l-59.1 59.1c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c1.2 1.2 1.9 2.9 1.9 4.7c0 3.7-3 6.6-6.6 6.6L152 336c-4.4 0-8-3.6-8-8zm8 40l113.4 0c21.3 0 38.6-17.3 38.6-38.6c0-10.2-4.1-20.1-11.3-27.3L278.6 288l47.7-47.7c12.2-12.2 16.5-30.3 11-46.7c-2.2-6.7-6-12.8-11-17.8l-22.1-22.1c-5-5-11.1-8.8-17.8-11c-16.4-5.5-34.5-1.2-46.7 11L192 201.4l-14.1-14.1c-7.2-7.2-17.1-11.3-27.3-11.3c-21.3 0-38.6 17.3-38.6 38.6L112 328c0 22.1 17.9 40 40 40z'
      
    ]
  };

  

  
  

  var faCupTogo = {
    prefix: 'fal',
    iconName: 'cup-togo',
    icon: [
      448,
      512,
      ["coffee-togo"],
      'f6c5',
      
      'M87.9 42.9L70.2 96l307.6 0L360.1 42.9c-2.2-6.5-8.3-10.9-15.2-10.9L103.1 32c-6.9 0-13 4.4-15.2 10.9zM47.6 128L16 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l20.5 0L57.5 32.8C64.1 13.2 82.4 0 103.1 0L344.9 0c20.7 0 39 13.2 45.5 32.8L411.5 96 432 96c8.8 0 16 7.2 16 16s-7.2 16-16 16l-31.6 0c-.2 0-.5 0-.7 0L48.4 128c-.2 0-.5 0-.7 0zm27 325.9L47.4 160l32.1 0 5.9 64 277.1 0 5.9-64 32.1 0L373.4 453.9c-3 32.9-30.7 58.1-63.7 58.1l-171.3 0c-33.1 0-60.7-25.2-63.7-58.1zM359.6 256L88.4 256l11.9 128 247.4 0 11.9-128zM344.8 416l-241.5 0 3.2 35c1.5 16.5 15.3 29 31.9 29l171.3 0c16.5 0 30.3-12.6 31.9-29l3.2-35z'
      
    ]
  };

  
    var faCoffeeTogo = faCupTogo;
  

  
  

  var faFont = {
    prefix: 'fal',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      'M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L37.4 448 16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-23.9 0 40.6-96 222.5 0 40.6 96L352 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-21.4 0L238.7 41.8zm83 278.2l-195.4 0L224 89.1 321.7 320z'
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fal',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      'M56.3 66.3c-4.9-3-11.1-3.1-16.2-.3s-8.2 8.2-8.2 14l0 352c0 5.8 3.1 11.1 8.2 14s11.2 2.7 16.2-.3l288-176c4.8-2.9 7.7-8.1 7.7-13.7s-2.9-10.7-7.7-13.7l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z'
      
    ]
  };

  

  
  

  var faTreeCity = {
    prefix: 'fal',
    iconName: 'tree-city',
    icon: [
      640,
      512,
      [],
      'e587',
      
      'M336 32c-8.8 0-16 7.2-16 16l0 448c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-448c0-26.5 21.5-48 48-48L464 0c26.5 0 48 21.5 48 48l0 144 32 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 16 0c26.5 0 48 21.5 48 48l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8-7.2-16-16-16l-32 0-64 0c-8.8 0-16-7.2-16-16l0-160c0-8.8-7.2-16-16-16L336 32zm48 32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zm96 192c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zm64 0l-32 0 0 32 32 0 0-32zm-32 96l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zM352 224c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zm64 0l-32 0 0 32 32 0 0-32zm-32 96l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zM128 224c8.8 0 16 7.2 16 16l0 48 32 0c26.5 0 48-21.5 48-48c0-16-7.8-30.2-19.9-38.9l-8-5.8c-4.9-3.5-7.4-9.5-6.4-15.5l.4-2.6c1.1-6.7 1.9-11.9 1.9-17.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.3 .8 10.5 1.9 17.2l.4 2.6c.9 6-1.5 11.9-6.4 15.5l-8 5.8C39.8 209.8 32 224 32 240c0 26.5 21.5 48 48 48l32 0 0-48c0-8.8 7.2-16 16-16zm-16 96l-32 0c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c0 0 0 0 0 0c-.7-4.7-1.2-9.9-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.2-.5 10.4-1.2 15.1c0 0 0 0 0 0C242.9 189.7 256 213.3 256 240c0 44.2-35.8 80-80 80l-32 0 0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176z'
      
    ]
  };

  

  
  

  var faFileMinus = {
    prefix: 'fal',
    iconName: 'file-minus',
    icon: [
      384,
      512,
      [],
      'f318',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM96 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 320z'
      
    ]
  };

  

  
  

  var faEarListen = {
    prefix: 'fal',
    iconName: 'ear-listen',
    icon: [
      512,
      512,
      ["assistive-listening-systems"],
      'f2a2',
      
      'M350 8.2c-4.3 7.7-1.5 17.5 6.2 21.8C430.1 71 480 149.7 480 240c0 8.8 7.2 16 16 16s16-7.2 16-16C512 137.6 455.4 48.4 371.8 2C364.1-2.3 354.3 .5 350 8.2zM96 240c0-79.5 64.5-144 144-144s144 64.5 144 144c0 41.9-17.9 79.7-46.5 106c-10.1 9.2-17.5 22.6-17.5 38c0 53-43 96-96 96l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c70.7 0 128-57.3 128-128c0-4.8 2.4-10.1 7.1-14.4C394.1 337.4 416 291.3 416 240c0-97.2-78.8-176-176-176S64 142.8 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM52.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM160 240c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  
    var faAssistiveListeningSystems = faEarListen;
  

  
  

  var faLink = {
    prefix: 'fal',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      'M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z'
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBallotCheck = {
    prefix: 'fal',
    iconName: 'ballot-check',
    icon: [
      448,
      512,
      [],
      'f733',
      
      'M384 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16zM160 384c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM72 376l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm91.3-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L104 257.4 91.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z'
      
    ]
  };

  

  
  

  var faGrillHot = {
    prefix: 'fal',
    iconName: 'grill-hot',
    icon: [
      448,
      512,
      [],
      'e5a5',
      
      'M112 0c-8.8 0-16 7.2-16 16l0 4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2l0 4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2l0-4c0-8.8-7.2-16-16-16zM256 352l-64 0c-88.4 0-160-71.6-160-160l384 0c0 88.4-71.6 160-160 160zM32 160c-17.7 0-32 14.3-32 32c0 80.5 49.5 149.4 119.7 177.9l-7.4 16.2c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48l177.9 0 17.6 38.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L328.3 369.9C398.5 341.4 448 272.5 448 192c0-17.7-14.3-32-32-32L32 160zM140.4 401.9l10.2-22.4c13.4 2.9 27.2 4.5 41.5 4.5l64 0c14.2 0 28.1-1.5 41.5-4.5L321.3 432 158 432c-3-11.7-9.2-22-17.6-30.1zM64 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2l0 4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2l0-4z'
      
    ]
  };

  

  
  

  var faLandmarkMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'landmark-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e622',
      
      'M448 288c-11 0-21.7-1.1-32-3.2l0 67.2-80 0 0-109.7c-5.8-5.7-11.1-11.8-16-18.3l-16 0 0 128-96 0 0-128-32 0 0 128-80 0 0-128-32 0 0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64zM263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192l270.2 0c-4.4-10.2-7.9-20.9-10.1-32L34.3 160 256 34.4l46.7 26.5c4.5-9.8 10-19 16.3-27.6L263.9 2.1zM24 432c0 8.8 7.2 16 16 16l432 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L40 416c-8.8 0-16 7.2-16 16zM0 496c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480c-8.8 0-16 7.2-16 16zM448 32.1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 185 576 157.7 576 128.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faBoxesStacked = {
    prefix: 'fal',
    iconName: 'boxes-stacked',
    icon: [
      576,
      512,
      [62625,"boxes","boxes-alt"],
      'f468',
      
      'M384 32c17.7 0 32 14.3 32 32l0 128 32 0 0-128c0-35.3-28.7-64-64-64L320 0 256 0 192 0c-35.3 0-64 28.7-64 64l0 128 32 0 0-128c0-17.7 14.3-32 32-32l32 0 0 56c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-56 32 0zM256 32l64 0 0 56c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-56zm71.6 480L512 512c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-64 0-64 0-56.4 0c8.3 9.2 14.8 20.1 19 32l5.5 0 0 31.9c0 0 0 0 0 .1l0 24c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-56 32 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-165.5 0c-4.2 11.9-10.7 22.8-19 32zM384 256l64 0 0 56c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-56zm-128 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l32 0 0 56c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-56 32 0zM128 312l0-56 64 0 0 56c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm128-88l-32 0-32 0-64 0-32 0-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64z'
      
    ]
  };

  
    var faBoxes = faBoxesStacked;
  
    var faBoxesAlt = faBoxesStacked;
  

  
  

  var faTimer = {
    prefix: 'fal',
    iconName: 'timer',
    icon: [
      512,
      512,
      [],
      'e29e',
      
      'M256 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-79.4C388.2 40.8 480 137.7 480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-61.9 25.1-117.8 65.6-158.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C28.7 121.3 0 185.3 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM171.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  

  
  

  var faSpeaker = {
    prefix: 'fal',
    iconName: 'speaker',
    icon: [
      384,
      512,
      [],
      'f8df',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM272 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM80 336a112 112 0 1 1 224 0A112 112 0 1 1 80 336zm88 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56-208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCarBus = {
    prefix: 'fal',
    iconName: 'car-bus',
    icon: [
      640,
      512,
      [],
      'f85a',
      
      'M45.8 70.1C38.8 75.7 34.7 84.5 33 96l159 0 159 0c-1.7-11.5-5.9-20.3-12.9-25.9C316.2 52.8 271 32 192 32S67.8 52.8 45.8 70.1zM32 128l0 96 144 0 0-96L32 128zm0 128l0 96c0 17.7 14.3 32 32 32l160 0 0 32L64 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-56.6C12.9 396.4 0 375.7 0 352L0 110.2C0 88.9 4.5 62.1 26 45C54.8 22.2 107.5 0 192 0s137.2 22.2 166 45c21.5 17 26 43.9 26 65.2l0 33.8-3.8 0c-9.8 0-19.2 1.5-28.2 4.2l0-20.2-144 0 0 96 76.9 0-9.1 32L192 256 32 256zm72 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm276.2-80c-14.3 0-26.8 9.5-30.8 23.2L333.2 288c.9 0 1.9 0 2.8 0l224 0c.9 0 1.9 0 2.8 0l-16.2-56.8c-3.9-13.7-16.5-23.2-30.8-23.2l-135.6 0zm-61.5 14.4c7.8-27.5 33-46.4 61.5-46.4l135.6 0c28.6 0 53.7 18.9 61.5 46.4L599 298.1c24.5 13.7 41 39.9 41 69.9l0 48 0 16 0 32 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-320 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-32 0-16 0-48c0-30 16.6-56.2 41-69.9l21.6-75.7zM608 416l0-48c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 48 0 16 320 0 0-16zM336 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faStarHalf = {
    prefix: 'fal',
    iconName: 'star-half',
    icon: [
      576,
      512,
      [61731],
      'f089',
      
      'M226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2l129.7-69.3 0-345.1-53.4 110zM293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9z'
      
    ]
  };

  

  
  

  var faMoneyFromBracket = {
    prefix: 'fal',
    iconName: 'money-from-bracket',
    icon: [
      640,
      512,
      [],
      'e312',
      
      'M80 32C53.5 32 32 53.5 32 80l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 80C0 35.8 35.8 0 80 0L560 0c44.2 0 80 35.8 80 80l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-26.5-21.5-48-48-48L80 32zM496 96c8.8 0 16 7.2 16 16l0 344c0 30.9-25.1 56-56 56l-272 0c-30.9 0-56-25.1-56-56l0-344c0-8.8 7.2-16 16-16s16 7.2 16 16l0 272c53 0 96 43 96 96l128 0c0-53 43-96 96-96l0-272c0-8.8 7.2-16 16-16zM224 480c0-35.3-28.7-64-64-64l0 40c0 13.3 10.7 24 24 24l40 0zm232 0c13.3 0 24-10.7 24-24l0-40c-35.3 0-64 28.7-64 64l40 0zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z'
      
    ]
  };

  

  
  

  var faCheckToSlot = {
    prefix: 'fal',
    iconName: 'check-to-slot',
    icon: [
      576,
      512,
      ["vote-yea"],
      'f772',
      
      'M144 64c-8.8 0-16 7.2-16 16l0 304 320 0 0-304c0-8.8-7.2-16-16-16L144 64zM480 80l0 304 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0-320 0-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48zM48 320l16 0 0 32-16 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0-32 16 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM379.3 174L272.6 280.6c-6.2 6.2-16.4 6.2-22.6 0l-53.3-53.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l42 42 95.4-95.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faVoteYea = faCheckToSlot;
  

  
  

  var faCloudHail = {
    prefix: 'fal',
    iconName: 'cloud-hail',
    icon: [
      512,
      512,
      [],
      'f739',
      
      'M176 32c-44.2 0-80 35.8-80 80c0 5.4 .5 10.6 1.5 15.7c1.7 8.3-3.5 16.5-11.7 18.6c-31 8-53.9 36.2-53.9 69.7c0 39.8 32.2 72 72 72l304 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-2.2 0-4.4 .1-6.6 .3c-4.5 .4-8.9-1.1-12.2-4.1s-5.2-7.3-5.2-11.8l0-.3c0-35.3-28.7-64-64-64c-17.8 0-33.9 7.2-45.5 19c-3.7 3.7-9 5.4-14.1 4.5s-9.6-4.3-11.8-9C235.9 51 208.2 32 176 32zm238.7 80.2C469 115.7 512 160.8 512 216c0 57.4-46.6 104-104 104l-304 0C46.6 320 0 273.4 0 216c0-43.4 26.6-80.5 64.3-96.1c-.2-2.6-.3-5.2-.3-7.9C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c47.6 0 87.2 34.7 94.7 80.2zM96 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMeterFire = {
    prefix: 'fal',
    iconName: 'meter-fire',
    icon: [
      640,
      512,
      [],
      'e1eb',
      
      'M256 32c76.2 0 143.5 38 183.9 96.1c12.4-1 25.2 3 35 11.9c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-8.5-7.8-16.3-16.3-23.2-25.5C305.3 475.9 281.1 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32zM368 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 4.4 1.8 8.5 4.7 11.4c8.3-11.6 17.4-23.1 27.3-34.4l0-40.9zm-192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm175.1 49.1l47.4 49.8c3.1 3.2 7.4 5 11.9 5s8.7-2 11.7-5.4l21-23.7c16.6 15.9 33.7 37.3 46.7 60.7c13.7 24.6 22.2 50 22.2 72.6c0 33.5-12.7 63.9-33.6 86.6c1-5.2 1.6-10.7 1.6-16.2c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 312.1 384 365.2 384 422.6c0 5.7 .6 11.2 1.6 16.6c-21-22.8-33.6-53.3-33.6-87c0-28.4 12.4-58.2 31.4-86.7c18.4-27.5 42-52.6 63.7-72.3zM480 480c-2.4 0-4.7-.1-7-.2c-33.7-3.2-57-29.4-57-57.3c0-17.4 10.1-37.7 27.4-58.5c12.1-14.5 25.8-27 36.6-35.8c10.7 8.8 24.5 21.3 36.6 35.8c17.3 20.7 27.4 41.1 27.4 58.5c0 27.8-23.2 54-56.9 57.3c-2.4 .1-4.7 .2-7.1 .2zM320 352.2c0 85.6 65.7 155 150.9 159.6c3 .3 6 .4 9.1 .4c3.1 0 6.2-.1 9.2-.4C573.6 507 640 437.7 640 352.2c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-11.2-10.4-28.5-10.4-39.7-.1c-.4 .4-.8 .7-1.1 1.2l-12.3 13.8-37.9-39.9c-.3-.3-.5-.5-.8-.8c-11.1-10.1-28.1-10.1-39.3-.1c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2z'
      
    ]
  };

  

  
  

  var faSquareE = {
    prefix: 'fal',
    iconName: 'square-e',
    icon: [
      448,
      512,
      [],
      'e26d',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 32l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0 0 80 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 80 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0c-17.7 0-32-14.3-32-32l0-96 0-96c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faHeadSideHeart = {
    prefix: 'fal',
    iconName: 'head-side-heart',
    icon: [
      512,
      512,
      [],
      'e1aa',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm112-34.7c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 281.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 128c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z'
      
    ]
  };

  

  
  

  var faParagraph = {
    prefix: 'fal',
    iconName: 'paragraph',
    icon: [
      448,
      512,
      [182],
      'f1dd',
      
      'M32 192c0-88.4 71.6-160 160-160l64 0 176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-400-64 0 0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-64 0c-88.4 0-160-71.6-160-160zM256 320l0-256-64 0C121.3 64 64 121.3 64 192s57.3 128 128 128l64 0z'
      
    ]
  };

  

  
  

  var faFax = {
    prefix: 'fal',
    iconName: 'fax',
    icon: [
      512,
      512,
      [128224,128439],
      'f1ac',
      
      'M160 64c0-17.7 14.3-32 32-32l196.1 0c8.5 0 16.6 3.4 22.6 9.4l27.9 27.9c6 6 9.4 14.1 9.4 22.6l0 68.1 32 0 0-68.1c0-17-6.7-33.3-18.7-45.3L433.4 18.7C421.4 6.7 405.1 0 388.1 0L192 0c-35.3 0-64 28.7-64 64l0 72.6c-9.4-5.4-20.3-8.6-32-8.6l-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l32 0c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7l256 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-288 0 0-128zm0 160l288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-224zm-32-32l0 16 0 240c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32zM296 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faDeerRudolph = {
    prefix: 'fal',
    iconName: 'deer-rudolph',
    icon: [
      576,
      512,
      [],
      'f78f',
      
      'M240 0c8.8 0 16 7.2 16 16l0 24c0 13.3 10.7 24 24 24l8 0 8 0c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 8.6-1.9 16.7-5.4 24l38.8 0L416 64c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 22-12.7 41.1-31.2 50.2l35 35C483.1 108 500.2 96 520 96c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.9 0-5.7-.3-8.4-.7c-3.4 27.5-26.8 48.7-55.2 48.7l-52.5 0-18.6 61.8c-.9 3-1.4 6.1-1.4 9.2l0 161c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-104-14.8 0c-24.1 0-47.7-5.7-69-16.6c-.9 17.8-10.1 34.4-25.3 44.6c-9.3 6.2-13.4 17.9-9.8 28.6l11.6 34.8c8.6 25.9-10.6 52.6-37.9 52.6l-29.4 0c-17.2 0-32.5-11-37.9-27.4L37.9 420.2c-4.4-13.1-4.4-27.3 0-40.5l8.5-25.4c1.1-3.3 1.6-6.7 1.6-10.1l0-4.3c0-8.5-3.4-16.6-9.4-22.6l-3.9-3.9c-.7-.7-1.5-1.5-2.2-2.3L32 321c-.6 8.8-8.1 15.5-17 15s-15.5-8.1-15-17l3.3-53c3.2-50.6 45.1-90 95.8-90l4.8 0 16 0 180.7 0 10-35.9-13.8 9.2c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l40-26.7L296 96l-8 0-8 0c-30.9 0-56-25.1-56-56l0-24c0-8.8 7.2-16 16-16zM348.3 124.2l-20 72.1c-1.9 6.9-8.2 11.7-15.4 11.7L120 208l-16 0c-30.9 0-56 25.1-56 56l0 4.1c0 8.5 3.4 16.6 9.4 22.6l3.9 3.9c12 12 18.7 28.3 18.7 45.3l0 4.3c0 6.9-1.1 13.7-3.3 20.2l-8.5 25.4c-2.2 6.6-2.2 13.7 0 20.2l21.5 64.4c1.1 3.3 4.1 5.5 7.6 5.5l29.4 0c5.5 0 9.3-5.4 7.6-10.5l-11.6-34.8c-8.1-24.3 1.1-51.1 22.4-65.3c8.2-5.4 12.4-15.1 10.8-24.8l-3.7-21.9c-1-6.3 1.7-12.6 7.1-16.1s12.3-3.4 17.6 .1l13.7 9.2C210.3 329 233.5 336 257.2 336l30.8 0c8.8 0 16 7.2 16 16l0 120c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-161c0-6.2 .9-12.4 2.7-18.4l22-73.3c2-6.8 8.3-11.4 15.3-11.4l64.4 0c13 0 23.6-10.6 23.6-23.6c0-6.3-2.5-12.3-6.9-16.7l-60.4-60.4c-7.2-7.2-17-11.3-27.2-11.3c-17.3 0-32.5 11.5-37.1 28.2zM400 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm136 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFishBones = {
    prefix: 'fal',
    iconName: 'fish-bones',
    icon: [
      576,
      512,
      [],
      'e304',
      
      'M42.4 141.5l27.3 22.8c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L44.8 101.8C40.3 98.1 34.6 96 28.7 96c-17.1 0-29.3 16.7-24 33L46 256 4.7 383c-5.3 16.3 6.8 33 24 33c5.9 0 11.6-2.1 16.1-5.8L34.6 397.9l10.2 12.3 45.4-37.9c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2L42.4 370.5l32-98.5 69.5 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 64 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 64 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 48 0 0 120.9c0 11.3 11.4 19 21.4 13.8c20.1-10.3 38.2-22.9 54-36.3c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-15.8-13.4-33.9-26-54-36.3c-10.1-5.1-21.4 2.5-21.4 13.8L416 240l-48 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-64 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-64 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-69.5 0-32-98.5zM447.7 259.2c.2-1 .3-2.1 .3-3.2s-.1-2.2-.3-3.2l0-104.7c8.2 5.6 16 11.5 23.4 17.7c35.6 30 60.9 66.1 73.2 90.1c0 .1 0 .2 0 .3c-12.4 24-37.7 60.1-73.2 90.1c-7.3 6.2-15.1 12.1-23.4 17.7l0-104.7z'
      
    ]
  };

  

  
  

  var faHeartCircleBolt = {
    prefix: 'fal',
    iconName: 'heart-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e4fc',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z'
      
    ]
  };

  

  
  

  var faIceCream = {
    prefix: 'fal',
    iconName: 'ice-cream',
    icon: [
      448,
      512,
      [127848],
      'f810',
      
      'M224 0C139.7 0 70.6 65.2 64.4 147.9C36.2 157.7 16 184.5 16 216c0 39.8 32.2 72 72 72l45.5 0 181 0 45.5 0c39.8 0 72-32.2 72-72c0-31.5-20.2-58.3-48.4-68.1C377.4 65.2 308.3 0 224 0zM96 160s0 0 0 0C96 89.3 153.3 32 224 32s128 57.3 128 128l0 .5c0 8 5.8 14.7 13.7 15.9c19.4 2.8 34.3 19.5 34.3 39.6c0 22.1-17.9 40-40 40l-45.5 0-181 0L88 256c-22.1 0-40-17.9-40-40c0-20.1 14.9-36.8 34.3-39.6c7.9-1.1 13.8-7.9 13.7-15.9l0-.5zM200.1 498.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320l-36.9 0L224 475.5 135.1 320l-36.9 0L200.1 498.1z'
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fal',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faDrum = {
    prefix: 'fal',
    iconName: 'drum',
    icon: [
      512,
      512,
      [129345],
      'f569',
      
      'M509.6 39.5c4.7 7.5 2.4 17.4-5.1 22l-86.3 53.9C475.4 133 512 162.8 512 208l0 160c0 22.6-13.6 41.6-32.3 56.2c-18.8 14.7-44.9 26.8-75.1 35.9C362.8 472.7 311.3 480 256 480s-106.8-7.3-148.6-19.9c-30.3-9.1-56.3-21.2-75.1-35.9C13.6 409.6 0 390.6 0 368L0 208C0 128 114.6 96 256 96c42.7 0 82.9 2.9 118.3 9.2L487.5 34.4c7.5-4.7 17.4-2.4 22 5.1zM332 131.6c-23.5-2.4-49-3.6-76-3.6c-69 0-128.5 7.9-169.4 23.8C45.3 167.9 32 187.6 32 208c0 11.2 11.3 31.5 55.7 50.6C129 276.5 188.5 288 256 288s127-11.5 168.3-29.4C468.7 239.5 480 219.2 480 208c0-20.4-13.3-40.1-54.6-56.2c-13.1-5.1-28.2-9.4-44.8-12.8L248.5 221.6c-7.5 4.7-17.4 2.4-22-5.1s-2.4-17.4 5.1-22L332 131.6zM480 263.2c-16.2 12.8-38.1 24-64 32.9l0 126.4c18.3-7 33.2-15 44-23.5c14.8-11.6 20-22.2 20-31l0-104.8zm-96 42.3c-33.3 8.2-71.4 13.3-112 14.3l0 128c41.5-1.1 79.7-6.6 112-15.1l0-127.2zM240 319.8c-40.6-1.1-78.7-6.1-112-14.3l0 127.2c32.3 8.5 70.5 14 112 15.1l0-128zM96 296.1c-25.9-8.9-47.8-20.1-64-32.9L32 368c0 8.8 5.3 19.5 20 31c10.8 8.5 25.6 16.5 44 23.5l0-126.4z'
      
    ]
  };

  

  
  

  var faKite = {
    prefix: 'fal',
    iconName: 'kite',
    icon: [
      640,
      512,
      [129665],
      'f6f4',
      
      'M338.2 50.8L273 344.4 457.4 160 341.1 43.7c-1.3 2.2-2.3 4.5-2.8 7.1zM258.9 407.9l-5.4 1.2-88.2 88.2c-9.4 9.4-22.1 14.6-35.3 14.6C102.4 512 80 489.6 80 462.1l0-145.8L24.2 349.7c-4.9 3-11.1 3-16.1 .2S0 341.8 0 336l0-96c0-5.8 3.1-11.1 8.1-13.9s11.2-2.8 16.1 .2L80 259.7 80 208c0-26.5-21.5-48-48-48l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c44.2 0 80 35.8 80 80l0 51.7 55.8-33.5c4.9-3 11.1-3 16.1-.2s8.1 8.2 8.1 13.9l0 96c0 5.8-3.1 11.1-8.1 13.9s-11.2 2.8-16.1-.2L112 316.3l0 145.8c0 9.9 8 17.9 17.9 17.9c4.8 0 9.3-1.9 12.7-5.3l88.2-88.2 1.2-5.4L307 43.9C312.7 18.2 335.4 0 361.7 0L584 0c30.9 0 56 25.1 56 56l0 222.3c0 26.2-18.2 49-43.9 54.7L258.9 407.9zM480 182.6L295.6 367l293.6-65.2c2.6-.6 4.9-1.5 7.1-2.8L480 182.6zM608 56c0-.4 0-.9 0-1.3L502.6 160 608 265.4 608 56zM584 32L374.6 32 480 137.4 585.3 32c-.4 0-.9 0-1.3 0zM32 268.3l0 39.5L64.9 288 32 268.3zm128 39.5l0-39.5L127.1 288 160 307.7z'
      
    ]
  };

  

  
  

  var faRectangleTerminal = {
    prefix: 'fal',
    iconName: 'rectangle-terminal',
    icon: [
      512,
      512,
      [],
      'e236',
      
      'M448 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM99.9 149.6c-5.8 6.7-5 16.8 1.7 22.6L199.4 256l-97.8 83.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM224 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0z'
      
    ]
  };

  

  
  

  var faAngle90 = {
    prefix: 'fal',
    iconName: 'angle-90',
    icon: [
      448,
      512,
      [],
      'e08d',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 464c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 448 32 48zm160.8 75c-29.9-13.2-62.2-21.9-96-25.3c-9.1-.9-16.8 6.4-16.8 15.6c0 8.5 6.7 15.5 15.1 16.4c29.3 3.2 57.3 10.7 83.3 22c7.6 3.3 16.6 .8 21-6.3c4.9-8 2-18.5-6.6-22.3zM297.5 247.4c5.1 7.1 14.8 9.3 22.2 4.7c7.6-4.7 10-14.8 4.7-22.1c-20.6-28.8-45.8-54-74.6-74.6c-7.3-5.2-17.4-2.9-22.1 4.7c-4.6 7.4-2.3 17.1 4.7 22.2c24.9 18 46.9 40 64.9 64.9zm30.8 54.1c11.3 26 18.8 54 22 83.3c.9 8.5 7.9 15.1 16.4 15.1c9.2 0 16.5-7.7 15.6-16.8c-3.4-33.9-12.2-66.1-25.3-96c-3.8-8.6-14.3-11.6-22.3-6.6c-7.1 4.4-9.6 13.4-6.3 21z'
      
    ]
  };

  

  
  

  var faPersonWalkingWithCane = {
    prefix: 'fal',
    iconName: 'person-walking-with-cane',
    icon: [
      512,
      512,
      ["blind"],
      'f29d',
      
      'M184 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 184 0a56 56 0 1 0 0 112zm-30.4 32c-31.6 0-60.3 18.6-73.1 47.5l-47.1 106c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l47.1-106c2.5-5.6 6-10.6 10.3-14.8l0 96c0 17 9 32.7 23.7 41.4L256 393.2 256 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.8c0-11.3-6-21.8-15.8-27.6l-32.2-19 0-156.2c2.1 2.1 4 4.5 5.7 7l77 115.5c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-77-115.5c-14.8-22.3-39.8-35.6-66.6-35.6l-52.2 0zM152 285.7L152 176c.5 0 1.1 0 1.6 0l52.2 0c.8 0 1.5 0 2.3 .1l0 151.7-48.1-28.3c-4.9-2.9-7.9-8.1-7.9-13.8zM96.6 491.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2l34.2-125.4L133.1 358 96.6 491.8zm354.3 13.3c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L372.3 335.4c-2.8 3.2-6 6.1-9.7 8.5c-5.7 3.8-11.9 6.2-18.3 7.3L450.8 505.1z'
      
    ]
  };

  
    var faBlind = faPersonWalkingWithCane;
  

  
  

  var faTransporterEmpty = {
    prefix: 'fal',
    iconName: 'transporter-empty',
    icon: [
      512,
      512,
      [],
      'e046',
      
      'M144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16l-224 0z'
      
    ]
  };

  

  
  

  var faHotdog = {
    prefix: 'fal',
    iconName: 'hotdog',
    icon: [
      512,
      512,
      [127789],
      'f80f',
      
      'M458.9 154.9l-304 304c-28.1 28.1-73.7 28.1-101.8 0S25 385.2 53.1 357.1l304-304c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zm22.6 22.6c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-60.9c-6.2-6.2-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1c-4.5 2.3-8.5 3.4-13.6 4.7l-1.5 .4c-4.7 1.2-10.9 2.7-17.3 5.6c-7.4 3.4-14.8 8.4-22.7 16.3c-16.2 16.2-20.5 30.7-24 42.7c0 0 0 0 0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.5 7.8-12.4 9.1c-3 1.3-5.8 1.7-10.6 2.4l-.4 .1c-4.6 .6-10.9 1.6-18 4.5c-7.4 3.1-14.8 8.1-22.6 15.9c-16.2 16.2-20.5 30.7-24 42.7c0 0 0 0 0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.7 8.1-13.3 9.8c-3.6 1.6-6.9 2.5-12 3.7l-1.2 .3c-5.6 1.4-12.6 3.2-20.4 7.3c-7.9 4-16 9.9-25 18.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1c4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4s0 0 0 0c4.7-1.2 10.9-2.7 17.3-5.6c7.4-3.4 14.8-8.4 22.7-16.3c16.2-16.2 20.5-30.7 24-42.7c0 0 0 0 0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.5-7.8 12.4-9.1c3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5c7.4-3.1 14.8-8.1 22.6-15.9c16.2-16.2 20.5-30.7 24-42.7c0 0 0 0 0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.7-8.1 13.3-9.8c3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3c7.9-4 16-9.9 25-18.9c6.2-6.2 6.2-16.4 0-22.6zM264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8l22.6-22.6C34.3 276.4 32 270.3 32 264c0-6.9 2.7-13.5 7.6-18.3L17.2 223.2l22.4 22.4L245.7 39.6c4.9-4.9 11.5-7.6 18.3-7.6c6.3 0 12.4 2.3 17.2 6.5l22.6-22.6C293.1 5.7 278.8 0 264 0zM208.2 496.2c10.7 10.2 25 15.8 39.8 15.8c15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41c0-14.8-5.7-29.1-15.8-39.8l-22.6 22.6c4.2 4.7 6.5 10.8 6.5 17.2c0 6.9-2.7 13.5-7.6 18.3L266.3 472.4c-4.9 4.9-11.5 7.6-18.3 7.6c-6.3 0-12.4-2.3-17.2-6.5l-22.6 22.6z'
      
    ]
  };

  

  
  

  var faEarMuffs = {
    prefix: 'fal',
    iconName: 'ear-muffs',
    icon: [
      640,
      512,
      [],
      'f795',
      
      'M320 32c-91.9 0-167.4 70.5-175.3 160.3c-11.7 1-22.7 4.2-32.6 9.2C115.5 89.7 207.3 0 320 0S524.5 89.7 527.9 201.5c-9.9-5.1-20.9-8.3-32.6-9.2C487.4 102.5 411.9 32 320 32zM496 224.6c9 1.3 17.2 4.7 24.3 9.7c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-30.9 25.1-56 56-56c2.7 0 5.4 .2 8 .6zM152 224c30.9 0 56 25.1 56 56c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2c7.1-5 15.3-8.4 24.3-9.7c2.6-.4 5.3-.6 8-.6zm20.8 100c-5.7-9.9-5.7-22.1 0-32c2-3.5 3.2-7.6 3.2-12c0-13.3-10.7-24-24-24c-5.2 0-9.9 1.6-13.8 4.4c-8 5.6-18.1 7.3-27.4 4.6c-2.1-.6-4.4-1-6.8-1c-8.5 0-16 4.4-20.3 11.2c-4.2 6.7-10.7 11.5-18.3 13.7C55.3 291.8 48 301.1 48 312c0 2.3 .3 4.4 .9 6.4c3.2 11.5-.4 23.9-9.1 32C34.9 354.8 32 361 32 368s2.9 13.2 7.7 17.6c8.8 8.1 12.3 20.4 9.1 32c-.5 2-.9 4.1-.9 6.4c0 10.9 7.3 20.2 17.4 23.1c7.6 2.2 14.1 7 18.3 13.7C88 467.6 95.5 472 104 472c2.4 0 4.6-.3 6.8-1c9.4-2.7 19.5-1 27.4 4.6c3.9 2.8 8.6 4.4 13.8 4.4c13.3 0 24-10.7 24-24c0-4.4-1.2-8.5-3.2-12c-5.7-9.9-5.7-22.1 0-32c2-3.5 3.2-7.6 3.2-12c0-5.1-1.6-9.8-4.3-13.7c-7.7-11-7.7-25.6 0-36.6c2.7-3.9 4.3-8.6 4.3-13.7c0-4.4-1.2-8.5-3.2-12zM464 280c0 4.4 1.2 8.5 3.2 12c5.7 9.9 5.7 22.1 0 32c-2 3.5-3.2 7.6-3.2 12c0 5.1 1.6 9.8 4.3 13.7c7.7 11 7.7 25.6 0 36.6c-2.7 3.9-4.3 8.6-4.3 13.7c0 4.4 1.2 8.5 3.2 12c5.7 9.9 5.7 22.1 0 32c-2 3.5-3.2 7.6-3.2 12c0 13.3 10.7 24 24 24c5.2 0 9.9-1.6 13.8-4.4c8-5.6 18.1-7.3 27.4-4.6c2.1 .6 4.4 1 6.8 1c8.5 0 16-4.4 20.3-11.2c4.2-6.7 10.7-11.5 18.3-13.7c10.1-2.9 17.4-12.2 17.4-23.1c0-2.3-.3-4.4-.9-6.4c-3.2-11.5 .4-23.9 9.1-32c4.8-4.4 7.7-10.7 7.7-17.6s-2.9-13.2-7.7-17.6c-8.8-8.1-12.3-20.4-9.1-32c.5-2 .9-4.1 .9-6.4c0-10.9-7.3-20.2-17.4-23.1c-7.6-2.2-14.1-7-18.3-13.7C552 268.4 544.5 264 536 264c-2.4 0-4.6 .3-6.8 1c-9.4 2.7-19.5 1-27.4-4.6c-3.9-2.8-8.6-4.4-13.8-4.4c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faRouteInterstate = {
    prefix: 'fal',
    iconName: 'route-interstate',
    icon: [
      512,
      512,
      [],
      'f61b',
      
      'M53.7 63.9C113 85.7 195.6 75.8 256 35.6c60.4 40.2 143 50.1 202.3 28.3c3.3 34.5 5.1 66.4 5.1 96.1L256 160 48.2 160c.2-29.8 2.2-61.8 5.5-96.1zM48.7 192l414 0c-2.3 44.8-9.9 84.2-24.8 119.4c-27.8 66-82.2 119.8-182.3 167.1C154.1 435.2 99.9 381.6 72.6 314.8c-14.8-36.1-22-76.7-23.9-122.8zM270 6.4c-8.4-5.9-19.7-5.9-28.1 0C186.2 45.5 107.2 53 57.4 30.9C43.2 24.6 24.6 33 22.8 50.6C11.9 158.8 11.7 250.5 43 326.9c31.7 77.4 94.5 136.7 203.5 182.5c6.2 2.6 13.4 2.5 19.5-.4c106.7-49.8 169.3-109 201.4-185.2c31.8-75.4 32.7-165 21.8-273.2c-1.8-17.6-20.4-26.1-34.6-19.7C404.8 53 325.8 45.5 270 6.4z'
      
    ]
  };

  

  
  

  var faBroccoli = {
    prefix: 'fal',
    iconName: 'broccoli',
    icon: [
      512,
      512,
      [129382],
      'e3e2',
      
      'M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96l8 0s47.7 54.5 80.2 138.3c5 12.8 17.1 21.7 30.9 21.7l81.9 0c13.8 0 25.9-8.9 30.9-21.7C360.3 406.5 408 352 408 352l8 0c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zm19.2 352l-2 4.9L256 400l-17.2-43.1-2-4.9 38.4 0zm-72.9 0l24 59.9C231.1 424 242.9 432 256 432s24.9-8 29.7-20.1l24-59.9 57.7 0c-4.1 5.6-8.9 12.3-13.9 20c-16.9 25.5-38.2 62.1-55.4 106.7c-.2 .6-.6 1-.9 1.2c-.1 .1-.2 .1-.2 .1l-81.8 0c0 0-.1 0-.2-.1c-.3-.2-.6-.6-.9-1.2c-17.3-44.6-38.5-81.2-55.4-106.7c-5.1-7.7-9.8-14.4-13.9-20l57.7 0zM194.6 77.8C202.5 51.3 227 32 256 32s53.5 19.3 61.4 45.8c1.4 4.7 4.8 8.5 9.3 10.3s9.6 1.5 13.9-.9C348.7 82.6 358 80 368 80c30.9 0 56 25.1 56 56c0 11.8-3.6 22.7-9.8 31.7c-3.1 4.6-3.7 10.4-1.5 15.5s6.9 8.6 12.4 9.4c31 4.4 54.9 31.1 54.9 63.4c0 35.3-28.7 64-64 64L96 320c-35.3 0-64-28.7-64-64c0-32.3 23.9-59 54.9-63.4c5.5-.8 10.2-4.3 12.4-9.4s1.7-10.9-1.5-15.5c-6.2-9-9.8-19.9-9.8-31.7c0-30.9 25.1-56 56-56c10 0 19.3 2.6 27.4 7.2c4.2 2.4 9.3 2.7 13.9 .9s8-5.6 9.3-10.3z'
      
    ]
  };

  

  
  

  var faFaceSmilingHands = {
    prefix: 'fal',
    iconName: 'face-smiling-hands',
    icon: [
      640,
      512,
      [],
      'e396',
      
      'M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2zM290.1 478c-8.8-1.2-16.8 5-18 13.7s5 16.8 13.7 18c11.2 1.5 22.6 2.3 34.1 2.3s22.9-.8 34.1-2.3c8.8-1.2 14.9-9.2 13.7-18s-9.2-14.9-18-13.7c-9.8 1.3-19.7 2-29.9 2s-20.1-.7-29.9-2zM384 384.8l0-32.8 0-2.4 0-51.2c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3l0 11.7 0 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4s0 0 0 0l51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6c0 0 0 0 0 0l-34 34L488 318.6s0 0 0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c0 0 0 0 0 0l-16 16-34 34L520 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34s0 0 0 0s0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5c0 0 0 0 0 0l-5.1 5.1-26.9 26.9-2 2L552 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L584 414.6l-37.5 37.5C528.7 470 504.4 480 479.2 480c-52.6 0-95.2-42.6-95.2-95.2zM320 400c11.6 0 22.4-1.2 32.5-3.4C358.5 461.3 412.9 512 479.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L447 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 53.6 0 11.8c-9.8 2.7-20.4 4.2-32 4.2s-22.2-1.5-32-4.2l0-11.8 0-53.6c0-28.7-23.3-52-52-52c-17.9 0-33.6 9-43 22.7l-47.1-47.1c-18.7-18.7-49.1-18.7-67.9 0c-1 1-2 2.1-3 3.2c-15.7-3.7-32.8 .5-45 12.8s-16.5 29.4-12.8 45c-1.1 .9-2.2 1.9-3.2 3C-4.1 304.2-4.7 333.2 12.2 352c-16.9 18.8-16.3 47.8 1.8 65.9l56.8 56.8c23.9 23.9 56.2 37.3 89.9 37.3c66.3 0 120.7-50.7 126.7-115.4c10.1 2.2 21 3.4 32.5 3.4zM220.5 178.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 145.9 258.8 136 240 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 145.9 418.8 136 400 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zM100.7 267.3s0 0 0 0c-6.2-6.2-6.2-16.4 0-22.6c.7-.7 1.4-1.3 2.1-1.8c6.2-4.4 14.9-3.8 20.5 1.8L174.6 296s0 0 0 0l9.4 9.4 2.3 2.3 10.4 10.4 5.7 5.7c5 5 13.7 1.5 13.7-5.7l0-8 0-11.7c0-1 .1-2 .2-3c.1-.9 .3-1.7 .6-2.5c2.4-8.4 10.1-14.5 19.2-14.5c11 0 20 9 20 20l0 51.2 0 2.4 0 32.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L56 414.6 36.7 395.3c-5.6-5.6-6.2-14.3-1.8-20.5c.5-.7 1.1-1.4 1.8-2.1c6.2-6.2 16.4-6.2 22.6 0l2 2L78.6 392c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4L70.7 365.3l-2-2L41.8 336.4l-5.1-5.1s0 0 0 0c-5.6-5.6-6.2-14.3-1.8-20.5c.5-.7 1.1-1.4 1.8-2.1c6.2-6.2 16.4-6.2 22.6 0c0 0 0 0 0 0s0 0 0 0l34 34L110.6 360s0 0 0 0c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-17.3-17.3-34-34-16-16s0 0 0 0c-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3s7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l16 16 34 34L142.6 328s0 0 0 0c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4c0 0 0 0 0 0l-17.3-17.3-34-34z'
      
    ]
  };

  

  
  

  var faOilCanDrip = {
    prefix: 'fal',
    iconName: 'oil-can-drip',
    icon: [
      640,
      512,
      [],
      'e205',
      
      'M352 80c0 8.8-7.2 16-16 16l-64 0 0 64 96.9 0c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7L144 416c-26.5 0-48-21.5-48-48l0-28L31.1 315.7C12.4 308.7 0 290.7 0 270.7L0 208c0-26.5 21.5-48 48-48l48 0 32 0 112 0 0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0c8.8 0 16 7.2 16 16zM454.7 223.3c-7.1 1.5-14.5 .6-21-2.7l-50.5-25.2c-4.4-2.2-9.3-3.4-14.3-3.4L128 192l0 125.8 0 34.2 0 16c0 8.8 7.2 16 16 16l259.1 0c9.2 0 17.9-3.9 24-10.8L583.8 195.6 454.7 223.3zM96 192l-48 0c-8.8 0-16 7.2-16 16l0 62.7c0 6.7 4.1 12.6 10.4 15L96 305.8 96 192zM608 400c0 0 0 0 0-.1l0-.2c0-.1 0-.3 0-.6c-.1-.5-.2-1.2-.3-2.1c-.3-1.8-.9-4.2-1.7-7c-1.7-5.7-4.2-12.5-7.4-20c-2-4.7-4.2-9.5-6.5-14.3c-2.3 4.8-4.4 9.6-6.5 14.3c-7.1 16.6-9.5 26.7-9.5 29.9c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5c1.2-1.1 3.7-4 3.7-12.5zm32 0c0 32-21.5 48-48 48s-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400z'
      
    ]
  };

  

  
  

  var faObjectsAlignLeft = {
    prefix: 'fal',
    iconName: 'objects-align-left',
    icon: [
      512,
      512,
      [],
      'e3be',
      
      'M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 16zM160 176c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L176 96c-8.8 0-16 7.2-16 16l0 64zm-32-64c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm32 288c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16l0 64zm-32-64c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z'
      
    ]
  };

  

  
  

  var faDharmachakra = {
    prefix: 'fal',
    iconName: 'dharmachakra',
    icon: [
      512,
      512,
      [9784],
      'f655',
      
      'M256 0c8.8 0 16 7.2 16 16l0 32.6c45.4 3.5 86.7 21.5 119.3 49.4L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414 120.7c27.9 32.6 46 73.9 49.4 119.3l32.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32.6 0c-3.5 45.4-21.5 86.7-49.4 119.3L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L391.3 414c-32.6 27.9-73.9 46-119.3 49.4l0 32.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32.6c-45.4-3.5-86.7-21.5-119.3-49.4L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L98 391.3c-27.9-32.6-46-73.9-49.4-119.3L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l32.6 0c3.5-45.4 21.5-86.7 49.4-119.3L75 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L120.7 98c32.6-27.9 73.9-46 119.3-49.4L240 16c0-8.8 7.2-16 16-16zM120.7 143.4c-22.2 26.7-36.7 60-40 96.6l80.6 0c2.4-14.4 8.1-27.9 16.4-39.6l-57-57zm79.6 34.4c11.4-8.1 24.9-13.9 39.6-16.4l0-80.6c-36.6 3.3-69.9 17.8-96.6 40l57 57zM210.5 211c-11.5 11.6-18.4 27.5-18.5 44.5l0 .5 0 .5c0 3.3 .3 6.7 .9 10.1c2.3 13.5 8.6 25.3 17.6 34.4c.1 .1 .2 .2 .3 .3s.2 .2 .2 .3c11.6 11.5 27.5 18.4 44.5 18.5l.5 0 .5 0c3.3 0 6.7-.3 10.1-.9c13.5-2.3 25.3-8.6 34.4-17.6c.1-.1 .2-.2 .3-.3s.2-.2 .2-.2c14-14.1 21.2-34.5 17.6-55.6c-2.3-13.5-8.6-25.3-17.6-34.4c-.1-.1-.2-.2-.3-.3s-.2-.2-.2-.2c-11.6-11.5-27.5-18.4-44.5-18.5l-.5 0-.5 0c-3.3 0-6.7 .3-10.1 .9c-13.5 2.3-25.3 8.6-34.4 17.6c-.1 .1-.2 .2-.3 .3s-.2 .2-.3 .2zM177.7 311.6c-8.1-11.4-13.9-24.9-16.4-39.6l-80.6 0c3.3 36.6 17.8 69.9 40 96.6l57-57zm-34.4 79.6c26.7 22.2 60 36.7 96.6 40l0-80.6c-14.4-2.4-27.9-8.1-39.6-16.4l-57 57zm168.3-57c-11.4 8.1-24.9 13.9-39.6 16.4l0 80.6c36.6-3.3 69.9-17.8 96.6-40l-57-57zm79.6 34.4c22.2-26.7 36.7-60 40-96.6l-80.6 0c-2.4 14.4-8.1 27.9-16.4 39.6l57 57zm-57-168.3c8.1 11.4 13.9 24.9 16.4 39.6l80.6 0c-3.3-36.6-17.8-69.9-40-96.6l-57 57zm34.4-79.6c-26.7-22.2-60-36.7-96.6-40l0 80.6c14.4 2.4 27.9 8.1 39.6 16.4l57-57z'
      
    ]
  };

  

  
  

  var faCircleUpLeft = {
    prefix: 'fal',
    iconName: 'circle-up-left',
    icon: [
      512,
      512,
      [],
      'e128',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 184c0-4.4 3.6-8 8-8l113.4 0c3.7 0 6.6 3 6.6 6.6c0 1.8-.7 3.4-1.9 4.7l-25.4 25.4c-6.2 6.2-6.2 16.4 0 22.6l59.1 59.1c3.6 3.6 4.9 9 3.3 13.9c-.7 2-1.8 3.8-3.3 5.3l-22.1 22.1c-1.5 1.5-3.3 2.6-5.3 3.3c-4.9 1.6-10.3 .4-13.9-3.3l-59.1-59.1c-6.2-6.2-16.4-6.2-22.6 0l-25.4 25.4c-1.2 1.2-2.9 1.9-4.7 1.9c-3.7 0-6.6-3-6.6-6.6L176 184zm8-40c-22.1 0-40 17.9-40 40l0 113.4c0 21.3 17.3 38.6 38.6 38.6c10.2 0 20.1-4.1 27.3-11.3L224 310.6l47.7 47.7c12.2 12.2 30.3 16.5 46.7 11c6.7-2.2 12.8-6 17.8-11l22.1-22.1c5-5 8.8-11.1 11-17.8c5.5-16.4 1.2-34.5-11-46.7L310.6 224l14.1-14.1c7.2-7.2 11.3-17.1 11.3-27.3c0-21.3-17.3-38.6-38.6-38.6L184 144z'
      
    ]
  };

  

  
  

  var faCloudHailMixed = {
    prefix: 'fal',
    iconName: 'cloud-hail-mixed',
    icon: [
      512,
      512,
      [],
      'f73a',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM24 512a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM183.9 370.1c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm192 0c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm-282 21.8c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32z'
      
    ]
  };

  

  
  

  var faDiagramSankey = {
    prefix: 'fal',
    iconName: 'diagram-sankey',
    icon: [
      576,
      512,
      [],
      'e158',
      
      'M354.1 64c-5.6 0-10.8 2.9-13.7 7.8L263 200.7c-8.7 14.5-24.3 23.3-41.2 23.3L16 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l205.9 0c5.6 0 10.8-2.9 13.7-7.8L313 55.3C321.6 40.8 337.3 32 354.1 32L560 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L354.1 64zM201.7 320l74.5 120.4c2.9 4.7 8.1 7.6 13.6 7.6L560 448c8.8 0 16 7.2 16 16s-7.2 16-16 16l-270.2 0c-16.6 0-32.1-8.6-40.8-22.7L164 320 16 320c-8.8 0-16-7.2-16-16s7.2-16 16-16l164.9 0 .7-.4 .3 .4L560 288c8.8 0 16 7.2 16 16s-7.2 16-16 16l-358.3 0z'
      
    ]
  };

  

  
  

  var faBarsStaggered = {
    prefix: 'fal',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      'M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faUserBountyHunter = {
    prefix: 'fal',
    iconName: 'user-bounty-hunter',
    icon: [
      448,
      512,
      [],
      'e2bf',
      
      'M80 0C71.2 0 64 7.2 64 16l0 248c0 1 .1 2 .3 3l-.2 3.5c-.8 12 7.5 22.7 19.2 25.1l114.6 22.9c16.2 3.2 36.1 3.2 52.3 0l114.6-22.9c11.8-2.4 20-13.1 19.2-25.1l-8.3-128.2C370.5 62.2 304.1 0 224 0C170.5 0 123.1 27.7 96 70l0-38c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 0zm21.1 193.1c7.3 4.5 15.8 10.5 24.4 17.9c18.8 16.4 36.3 39.1 41.2 68.5l-70.2-14 4.7-72.4zm98.5 93.1c-3.3-45.3-28.9-78.1-53.1-99.2c-13-11.4-25.9-19.7-35.6-25.2c-1.1-.6-2.1-1.2-3.1-1.7L208 160l0 127.7c-1.3-.2-2.6-.4-3.9-.7l-4.5-.9zm40.4 1.6L240 160l100.2 0c-1 .5-2 1.1-3.1 1.7c-9.7 5.5-22.6 13.9-35.6 25.2c-24.2 21.1-49.8 53.9-53.1 99.2l-4.5 .9c-1.3 .3-2.5 .5-3.9 .7zm41.3-8.2c4.9-29.5 22.4-52.1 41.2-68.5c8.5-7.4 17.1-13.4 24.4-17.9l4.7 72.4-70.2 14zM341.6 128L224 128l-117.6 0C117.6 72.9 166.3 32 224 32s106.4 40.9 117.6 96zM134.4 384l179.2 0c54.4 0 98.9 42.4 102.2 96l-105.2 0L241 410.3c-9.4-9.4-24.6-9.4-33.9 0L137.4 480 32.2 480c3.3-53.6 47.8-96 102.2-96zM224 438.6L265.4 480l-82.7 0L224 438.6zM25.6 512L144 512l160 0 118.4 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352l-179.2 0C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512z'
      
    ]
  };

  

  
  

  var faChessRook = {
    prefix: 'fal',
    iconName: 'chess-rook',
    icon: [
      448,
      512,
      [9820],
      'f447',
      
      'M64 32C46.3 32 32 46.3 32 64l0 121.3c0 14 6.1 27.3 16.8 36.4L87.6 255l-5.1 97 32 0L120 248.8c.3-5-1.8-9.8-5.6-13L69.6 197.4c-3.5-3-5.6-7.5-5.6-12.1L64 64l80 0 0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 96 0 0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 80 0 0 121.3c0 4.7-2 9.1-5.6 12.1l-44.8 38.4c-3.8 3.2-5.8 8-5.6 13L333.5 352l32 0-5.1-97 38.8-33.3c10.6-9.1 16.8-22.4 16.8-36.4L416 64c0-17.7-14.3-32-32-32L64 32zM224 160c-26.5 0-48 21.5-48 48l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-32 0 0-48zM97.8 416l252.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L71.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L97.8 416zm252.4-32L97.8 384c-11.1 0-21.4 5.7-27.2 15.1L37.9 451.8C34.1 458 32 465.2 32 472.6C32 494.3 49.7 512 71.4 512l305.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z'
      
    ]
  };

  

  
  

  var faWineBottle = {
    prefix: 'fal',
    iconName: 'wine-bottle',
    icon: [
      512,
      512,
      [],
      'f72f',
      
      'M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6c-4.4 4.4-10.6 5.7-16.1 4l-86.6 86.6c-8 8-10.9 19.6-9.6 30.9c4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l22.6 22.6c-12.5 12.5-12.5 32.8 0 45.3l88 88c12.5 12.5 32.8 12.5 45.3 0l24.7-24.7L66.1 312.7 41.4 337.4 18.7 314.7 180.2 153.3c28.1-28.1 66.3-40.2 103-36.2c11.3 1.2 22.9-1.6 30.9-9.6l86.6-86.6c-1.7-5.5-.4-11.7 4-16.1zM88.7 290.1L221.9 423.3l89.4-89.4L178.1 200.7 88.7 290.1zm112-112L333.9 311.3l2.2-2.2c21-21 30-49.4 27-76.9c-2-18.3 2.3-40.5 18.8-57l13.3-13.3-45.3-45.3L336.7 130c-16.5 16.5-38.7 20.8-57 18.8c-27.5-3-55.9 6-76.9 27l-2.2 2.2zm172-84l45.3 45.3 49.4-49.4L422.1 44.7 372.7 94.1z'
      
    ]
  };

  

  
  

  var faWhiskeyGlassIce = {
    prefix: 'fal',
    iconName: 'whiskey-glass-ice',
    icon: [
      512,
      512,
      ["glass-whiskey-rocks"],
      'f7a1',
      
      'M480 64L430 406.9c-3.4 23.6-23.7 41.1-47.5 41.1l-253 0c-23.8 0-44.1-17.5-47.5-41.1L32 64l448 0zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32zM255.4 195.3l.6-.6c-5-1.8-10.4-2.7-16-2.7l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l73.8 0-19-19c-4-4-7.6-8.4-10.6-13L144 352c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l82.7 0 28.7-28.7zm67.9 45.3l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0zm-45.3-22.6l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 399c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z'
      
    ]
  };

  
    var faGlassWhiskeyRocks = faWhiskeyGlassIce;
  

  
  

  var faPollPeople = {
    prefix: 'fal',
    iconName: 'poll-people',
    icon: [
      640,
      512,
      [],
      'f759',
      
      'M80 48a16 16 0 1 1 32 0A16 16 0 1 1 80 48zm64 0A48 48 0 1 0 48 48a48 48 0 1 0 96 0zM592 64c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0 0-96 80 0zM272 64l208 0 0 96-208 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 32zM592 352c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-208 0 0-96 208 0zm-320 0l80 0 0 96-80 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-320 0zM1.1 486.1L.1 494C-1 502.8 5.2 510.8 14 511.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42l31 0c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1l-31 0c-40.3 0-74.4 30-79.4 70.1zm0-288L.1 206C-1 214.8 5.2 222.8 14 223.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42l31 0c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1l-31 0c-40.3 0-74.4 30-79.4 70.1zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faHospital = {
    prefix: 'fal',
    iconName: 'hospital',
    icon: [
      640,
      512,
      [62589,127973,"hospital-alt","hospital-wide"],
      'f0f8',
      
      'M160 64c0-35.3 28.7-64 64-64L416 0c35.3 0 64 28.7 64 64l0 32 96 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-160 0s0 0 0 0l-64 0-64 0-64 0s0 0 0 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l96 0 0-32zM480 336l0 144 96 0c17.7 0 32-14.3 32-32l0-128-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32c0-17.7-14.3-32-32-32l-96 0 0 208zM160 128l-96 0c-17.7 0-32 14.3-32 32l0 32 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 64 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 128c0 17.7 14.3 32 32 32l96 0 0-352zM448 336l0-272c0-17.7-14.3-32-32-32L224 32c-17.7 0-32 14.3-32 32l0 416 64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0 0-144zm-96 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zM304 64l32 0c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm8 56c0 8.8-7.2 16-16 16l-24 0 0 16 24 0c8.8 0 16 7.2 16 16l0 24 16 0 0-24c0-8.8 7.2-16 16-16l24 0 0-16-24 0c-8.8 0-16-7.2-16-16l0-24-16 0 0 24z'
      
    ]
  };

  
    var faHospitalAlt = faHospital;
  
    var faHospitalWide = faHospital;
  

  
  

  var faLampDesk = {
    prefix: 'fal',
    iconName: 'lamp-desk',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M381.3 96L480 96 288 288l0-98.7c0-8.5-3.4-16.6-9.4-22.6l-38.1-38.1C230 118 224 103.6 224 88.6C224 57.3 249.3 32 280.6 32c15 0 29.4 6 40 16.6l38.1 38.1c6 6 14.1 9.4 22.6 9.4zm0-32L343.2 25.9C326.6 9.3 304.1 0 280.6 0C231.7 0 192 39.7 192 88.6c0 21.7 7.9 42.5 22.2 58.6l-97.5 97.5c-4 4-5.6 9.9-4.1 15.4L171.2 480 16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-163.7 0L145.8 260.8l90.8-90.8L256 189.3l0 98.7c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l192-192c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-98.7 0zm-2.6 223.9C391 298 406.8 304 424 304c39.8 0 72-32.2 72-72c0-17.2-6-33-16.1-45.4L457 209.5c4.4 6.4 7 14.2 7 22.5c0 22.1-17.9 40-40 40c-8.4 0-16.1-2.6-22.5-7l-22.8 22.8z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenText = {
    prefix: 'fal',
    iconName: 'envelope-open-text',
    icon: [
      512,
      512,
      [],
      'f658',
      
      'M392 32L120 32c-13.3 0-24 10.7-24 24l0 166.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6L64 56C64 25.1 89.1 0 120 0L392 0c30.9 0 56 25.1 56 56l0 142.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5 416 56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3l0 189c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-189c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35l0 189c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 259zM176 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSquareAmpersand = {
    prefix: 'fal',
    iconName: 'square-ampersand',
    icon: [
      448,
      512,
      [],
      'e260',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm176 88c0 6.2 2.4 12.1 6.6 16.6l22.1 23.3 21.8-15C235 203 240 193.5 240 183.2c0-12.8-10.4-23.2-23.2-23.2L200 160c-13.3 0-24 10.7-24 24zm68.7 51.2l-17.5 12.1 45.4 47.7L307 246.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-38 53.2L331.6 357c6.1 6.4 5.8 16.5-.6 22.6s-16.5 5.8-22.6-.6l-32.4-34-6.3 8.8c-13.5 18.9-35.3 30.2-58.6 30.2l-36 0c-34.9 0-63.2-28.3-63.2-63.2c0-20.8 10.2-40.3 27.4-52.1l38.7-26.6-18.6-19.5C149.5 212.2 144 198.4 144 184c0-30.9 25.1-56 56-56l16.8 0c30.5 0 55.2 24.7 55.2 55.2c0 20.8-10.2 40.2-27.3 52zm-87.1 59.9c-8.5 5.8-13.5 15.4-13.5 25.7c0 17.2 14 31.2 31.2 31.2l36 0c12.9 0 25-6.2 32.5-16.8l9.8-13.8-53.2-55.8-42.9 29.5z'
      
    ]
  };

  

  
  

  var faGaugeHigh = {
    prefix: 'fal',
    iconName: 'gauge-high',
    icon: [
      512,
      512,
      [62461,"tachometer-alt","tachometer-alt-fast"],
      'f625',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm344-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faTachometerAlt = faGaugeHigh;
  
    var faTachometerAltFast = faGaugeHigh;
  

  
  

  var faSquareThisWayUp = {
    prefix: 'fal',
    iconName: 'square-this-way-up',
    icon: [
      448,
      512,
      ["box-up"],
      'f49f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM112 368l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-256c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32L160 304c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-133.4-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5zm160 0c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32L320 304c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-133.4-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5z'
      
    ]
  };

  
    var faBoxUp = faSquareThisWayUp;
  

  
  

  var faSection = {
    prefix: 'fal',
    iconName: 'section',
    icon: [
      256,
      512,
      [],
      'e447',
      
      'M32.5 84.7c3.6-20.1 16.3-34.6 36.9-43.4c21.2-9.1 50.6-11.9 84.4-6.6c10.7 1.7 43.5 8.1 54 10.9c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-12-3.2-46-9.8-57.3-11.6C121-2.9 85.1-.3 56.7 11.9C27.8 24.3 6.5 47 .9 79.7c0 .3-.1 .6-.1 .8c-2.2 19 .4 35.7 7.6 50c7.1 14.2 18.1 25 30.7 33.6c4.6 3.1 9.6 6 14.7 8.7c-26.7 12-46.7 33-52.1 63.1c-.1 .3-.1 .6-.1 .9c-2.3 18.3 .4 34.3 7.8 48.1c7.2 13.6 18.3 23.9 30.8 32c23.3 15 54.8 24 83.1 32.1l3.3 .9c30.8 8.8 57.7 16.8 75.9 29.5c8.7 6.1 14.6 12.7 18 20.3c3.3 7.5 4.8 17.2 2.3 30.6c-3.4 18.5-15.7 32.3-36.5 40.8c-21.3 8.7-50.7 11.3-84.4 6.3c-16.9-2.6-45.6-11.9-67.8-19.1c0 0 0 0 0 0s0 0 0 0c-4.8-1.5-9.2-3-13.2-4.3c-8.4-2.7-17.4 2-20.1 10.4s2 17.4 10.4 20.1c3.4 1.1 7.4 2.4 11.8 3.8C44.9 495.5 77.2 506 97 509.1c0 0 .1 0 .1 0c37.5 5.6 73.1 3.2 101.3-8.3c28.6-11.7 50.2-33.2 55.9-64.7c3.4-18.6 1.8-35-4.6-49.4c-6.3-14.3-16.8-25.1-28.9-33.6c-1.7-1.2-3.5-2.4-5.4-3.5c20-13.1 34.4-32.5 38.9-58.7c3.3-19.4 1.8-36.4-4.5-51.3c-6.2-14.8-16.6-26.2-28.8-35.2c-23.6-17.4-56.4-27.3-85.9-36.1l-.5-.1c-30.8-9.3-58.3-17.5-77.6-30.6c-9.4-6.3-16-13.4-20.1-21.4c-4-7.9-6-17.9-4.5-31.5zM178 332.3c-14.1-5.1-28.8-9.3-42.7-13.2l-.5-.1s0 0 0 0c-30.7-8.7-58.1-16.6-77.4-29c-9.3-6-15.9-12.6-19.8-20c-3.8-7.2-5.8-16.3-4.3-28.8c3.5-18.3 15.8-32 36.4-40.4c10.1-4.1 22-6.9 35.4-8.1c5.9 1.8 11.8 3.6 17.5 5.3c0 0 0 0 0 0l3.3 1c30.9 9.3 57.9 17.8 76.1 31.2c8.7 6.4 14.8 13.5 18.3 21.8c3.5 8.2 4.9 18.9 2.5 33.4c-3.8 22.2-19.1 38.5-44.8 46.8z'
      
    ]
  };

  

  
  

  var faSquare0 = {
    prefix: 'fal',
    iconName: 'square-0',
    icon: [
      448,
      512,
      [],
      'e255',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-64 96l0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faInbox = {
    prefix: 'fal',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      
      'M32 416l0-88.1c0-2.6 .3-5.2 1-7.8l0-.1 101.1 0 23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7l140.2 0c12.1 0 23.2-6.8 28.6-17.7L377.9 320 479 320l0 .1c.6 2.5 1 5.1 1 7.8l0 88.1c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32zM471 288l-93.1 0c-12.1 0-23.2 6.8-28.6 17.7L326.1 352l-140.2 0-23.2-46.3c-5.4-10.8-16.5-17.7-28.6-17.7L41 288 90.9 88.2C94.5 74 107.3 64 122 64L390 64c14.7 0 27.5 10 31 24.2L471 288zM0 327.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32L122 32C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z'
      
    ]
  };

  

  
  

  var faFaceSunglasses = {
    prefix: 'fal',
    iconName: 'face-sunglasses',
    icon: [
      512,
      512,
      [],
      'e398',
      
      'M256 480C132.3 480 32 379.7 32 256c0-16.4 1.8-32.5 5.1-47.9l4.4 26.4c5.1 30.9 31.8 53.5 63.1 53.5l78.7 0c31.3 0 58-22.6 63.1-53.5l8-48c.6-3.5 .9-7.1 .9-10.5l1.3 0c0 3.5 .3 7 .9 10.5l8 48c5.1 30.9 31.8 53.5 63.1 53.5l78.7 0c31.3 0 58-22.6 63.1-53.5l4.4-26.4c3.4 15.4 5.1 31.5 5.1 47.9c0 123.7-100.3 224-224 224zm-9.2-336c-11-19-31.5-32-55.4-32l-94.7 0c-4.6 0-9.1 .5-13.4 1.4C124.3 63.7 186.5 32 256 32s131.7 31.7 172.8 81.4c-4.3-.9-8.8-1.4-13.4-1.4l-94.7 0c-24 0-44.5 13-55.4 32l-18.5 0zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM289.1 181.3c-3.3-19.5 11.8-37.3 31.6-37.3l40.7 0-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l25.4 0L316 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48zM358.6 256l52.7-52.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-25.4 0 32-32 8.7 0c19.8 0 34.8 17.8 31.6 37.3l-8 48C436.3 244.7 423 256 407.3 256l-48.7 0zM96.7 144l40.7 0-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l25.4 0L92 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48C61.8 161.8 76.9 144 96.7 144zm90.7 59.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-25.4 0 32-32 8.7 0c19.8 0 34.8 17.8 31.6 37.3l-8 48C212.3 244.7 199 256 183.3 256l-48.7 0 52.7-52.7z'
      
    ]
  };

  

  
  

  var faSocks = {
    prefix: 'fal',
    iconName: 'socks',
    icon: [
      512,
      512,
      [129510],
      'f696',
      
      'M140.8 465.9C129 475 114.4 480 99.5 480L96 480c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C143.4 300.4 160 267.3 160 232l0-104 128 0 0-32L160 96l0-48c0-8.8 7.2-16 16-16l113.6 0C292 20.2 297 9.4 303.9 .1c-1-.1-2-.1-3-.1L176 0c-26.5 0-48 21.5-48 48l0 184c0 25.2-11.9 48.9-32 64L38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96l3.5 0c22 0 43.4-7.3 60.8-20.8l16.1-12.4c-5.4-9.6-9.6-19.9-12.4-30.8c0 0-.1 0-.1 0l-23.2 17.9zM368 0c-26.5 0-48 21.5-48 48l0 184c0 25.2-11.9 48.9-32 64l-57.6 43.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96l3.5 0c22 0 43.4-7.3 60.8-20.8l116.1-89.7c27.4-21.2 43.5-53.9 43.5-88.6L512 48c0-26.5-21.5-48-48-48L368 0zM352 48c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 48L352 96l0-48zm0 80l128 0 0 184.9c0 24.8-11.5 48.2-31.1 63.3L332.8 465.9C321 475 306.4 480 291.5 480l-3.5 0c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C335.4 300.4 352 267.3 352 232l0-104z'
      
    ]
  };

  

  
  

  var faGrid4 = {
    prefix: 'fal',
    iconName: 'grid-4',
    icon: [
      448,
      512,
      [],
      'e198',
      
      'M24 97.6L24 56l41.6 0 0 41.6L24 97.6zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zM24 456l0-41.6 41.6 0 0 41.6L24 456zM16 32C7.2 32 0 39.2 0 48l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16L16 32zm0 119.5c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zM0 286.9l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zM16 390.4c-8.8 0-16 7.2-16 16L0 464c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zM143.5 97.6l0-41.6 41.6 0 0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm-8-424c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zm0 119.5c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zm-16 135.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zM262.9 56l41.6 0 0 41.6-41.6 0 0-41.6zm0 119.5l41.6 0 0 41.6-41.6 0 0-41.6zm0 119.5l41.6 0 0 41.6-41.6 0 0-41.6zm0 119.5l41.6 0 0 41.6-41.6 0 0-41.6zM238.9 48l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm0 119.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zm-16 135.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zM382.4 97.6l0-41.6L424 56l0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm0 119.5l0-41.6 41.6 0 0 41.6-41.6 0zm-8-424c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16L448 48c0-8.8-7.2-16-16-16l-57.6 0zm0 119.5c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0zm-16 135.5l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0z'
      
    ]
  };

  

  
  

  var faBatteryEmpty = {
    prefix: 'fal',
    iconName: 'battery-empty',
    icon: [
      576,
      512,
      ["battery-0"],
      'f244',
      
      'M80 128c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L80 128zM0 176c0-44.2 35.8-80 80-80l352 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176zm560 16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faBattery0 = faBatteryEmpty;
  

  
  

  var faSnowflakeDroplets = {
    prefix: 'fal',
    iconName: 'snowflake-droplets',
    icon: [
      640,
      512,
      [],
      'e5c1',
      
      'M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 73.4L267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L304 134.6l0 93.7-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l13.4 50.1-63.5-36.7c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L117.6 200c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l81-21.7L288 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S109 309.7 117.6 312l50.1 13.4-45.1 26L137.2 380l46.5-26.8-13.4 50.1c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L304 283.7l0 93.7-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 422.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L336 377.4l0-93.7 81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1L502.8 380l14.7-28.5-45.1-26L522.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L352 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L336 228.3l0-93.7 59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L336 89.4 336 16zM576 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9c0 17.9-14.5 32.3-32 32.3s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9L576 377.5zm-18-35l-38.9 75.6c-4.7 9.1-7.1 19.3-7.1 29.5c0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L594 342.5l-.1-.1-1.9-3.7-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1 .1zM35.6 432.8L64 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9C96 465.6 81.5 480 64 480s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9zM7.1 418.1C2.4 427.2 0 437.4 0 447.7C0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L82 342.5l-.1-.1L80 338.7l-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1 .1L7.1 418.1z'
      
    ]
  };

  

  
  

  var faDove = {
    prefix: 'fal',
    iconName: 'dove',
    icon: [
      512,
      512,
      [128330],
      'f4ba',
      
      'M273 128.8c-.7 5-1 10.1-1 15.2l0 21.6c-5.2-1.6-10.5-3.4-15.9-5.3c-22.5-30-40.1-66.5-45.7-109.4c-9.9 15.5-21.1 37.2-30.5 65c-9.1-8.3-17.2-17.4-24-27.5C171 50.2 188.8 23.8 201.2 9.3c5.2-6 13.4-7.8 21-5.8c10.9 2.9 18 13.1 18.4 24.4c1.3 38.9 13.9 72.5 32.4 100.8zM64.7 42.2C68.8 35.5 76 32 83.2 32c10.7 0 19.3 7.6 21.5 17.2c12.8 56.5 50.9 94.7 94.7 119.9c36.2 20.8 75.4 32.1 104.7 36.8l0-61.9c0-44.2 35.8-80 80-80l99.7 0C499.3 64 512 76.7 512 92.3c0 5.6-1.7 11-4.7 15.7L480 148.8 480 288c0 88.4-71.6 160-160 160l-71.4 0-78.9 60.7c-2.8 2.2-6.2 3.3-9.8 3.3C77.3 512 21.7 466.2 3.2 441.6c-3-4.1-4-9.3-2.5-14.2s5.1-8.7 9.9-10.5l123-44.3C89.2 341.3 32 282.5 32 184C32 108.2 52 62.6 64.7 42.2zM80.9 81.6C72.5 103 64 136.5 64 184c0 103.8 74 156.5 113.7 178.6c5.5 3.1 8.7 9 8.2 15.3s-4.6 11.6-10.5 13.8l-130.7 47c21.4 18.2 59.2 39.8 110 41.2l78.8-60.6c2.8-2.2 6.2-3.3 9.8-3.3l76.8 0c70.7 0 128-57.3 128-128l0-144c0-3.2 .9-6.2 2.7-8.9L476.8 96 384 96c-26.5 0-48 21.5-48 48l0 80c0 4.5-1.9 8.7-5.2 11.8s-7.7 4.5-12.2 4.2c-33.6-2.8-86.6-15.1-135.3-43c-42.5-24.4-82.7-61.4-102.5-115.3zM360 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faHandBackPointRight = {
    prefix: 'fal',
    iconName: 'hand-back-point-right',
    icon: [
      512,
      512,
      [],
      'e1a1',
      
      'M512 168c0-30.9-25.1-56-56-56l-200.6 0c-2-3.2-4.2-6.4-6.5-9.5L232 80c-15.1-20.1-38.8-32-64-32l-19.5 0c-53 0-101.7 29.1-126.8 75.7L17.2 132C5.9 153 0 176.4 0 200.3L0 336c0 61.9 50.1 112 112 112l8 0 88 0c35.3 0 64-28.7 64-64c0-2.8-.2-5.6-.5-8.3c19.4-11 32.5-31.8 32.5-55.7c0-5.3-.7-10.5-1.9-15.5c20.2-10.8 33.9-32 33.9-56.5c0-8.5-1.7-16.6-4.7-24L456 224c30.9 0 56-25.1 56-56zm-56-24c13.3 0 24 10.7 24 24s-10.7 24-24 24l-157.5 0c-7.1 0-13.3 4.6-15.3 11.4s.6 14 6.5 18c8.7 5.8 14.3 15.6 14.3 26.7c0 15.6-11.2 28.6-25.9 31.4c-5.1 1-9.5 4.4-11.6 9.2s-1.8 10.3 .9 14.8c2.9 4.8 4.6 10.5 4.6 16.6c0 14.7-10 27.2-23.6 30.9c-4.4 1.2-8.1 4.2-10.1 8.3s-2.2 8.8-.6 13.1c1.4 3.6 2.2 7.6 2.2 11.8c0 17.7-14.3 32-32 32l-88 0-8 0c-44.2 0-80-35.8-80-80l0-135.7c0-18.5 4.6-36.8 13.4-53.1l-14.1-7.6 14.1 7.6 4.5-8.3C69.4 102.6 107.3 80 148.5 80L168 80c15.1 0 29.3 7.1 38.4 19.2L216 112l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l78.3 0 1.7 0 208 0z'
      
    ]
  };

  

  
  

  var faHatChef = {
    prefix: 'fal',
    iconName: 'hat-chef',
    icon: [
      512,
      512,
      [],
      'f86b',
      
      'M170.9 83.4C187 52.8 219.1 32 256 32s69 20.8 85 51.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 13.9-5.5C379.1 72.7 396.5 64 416 64c35.3 0 64 28.7 64 64c0 4-.4 7.8-1 11.6l-.1 .5c-3.5 22.8-14.2 58.4-26.1 93.5c-11.8 34.7-24.3 67.7-31 84.7c-.4 1-1.4 1.8-2.8 1.8l-45.2 0 25.9-141.1c1.6-8.7-4.2-17-12.8-18.6s-17 4.2-18.6 12.8l-26.4 144c-.2 1-.3 1.9-.3 2.9L272 320l0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-69.6 0c0-1-.1-1.9-.3-2.9l-26.4-144c-1.6-8.7-9.9-14.4-18.6-12.8s-14.4 9.9-12.8 18.6L138.2 320 93 320c-1.4 0-2.4-.8-2.8-1.8c-6.6-17-19.2-50-31-84.7C47.3 198.4 36.6 162.8 33.1 140l-.1-.5c-.7-3.7-1-7.6-1-11.6c0-35.3 28.7-64 64-64c19.5 0 36.9 8.7 48.6 22.4c3.5 4 8.7 6.1 13.9 5.5s9.9-3.8 12.4-8.5zM256 0c-41.9 0-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2C43 32 0 75 0 128c0 5.8 .5 11.5 1.5 17.1c4 25.9 15.6 63.8 27.4 98.7c12 35.3 24.7 68.8 31.4 86C65.6 343.4 78.7 352 93 352l326 0c14.3 0 27.4-8.6 32.6-22.2c6.7-17.2 19.4-50.7 31.4-86c11.8-34.9 23.4-72.8 27.4-98.7c1-5.5 1.5-11.2 1.5-17.1c0-53-43-96-96-96c-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0zM64 384l0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64-32 0 0 64c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-64-32 0z'
      
    ]
  };

  

  
  

  var faGameBoard = {
    prefix: 'fal',
    iconName: 'game-board',
    icon: [
      448,
      512,
      [],
      'f867',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128l64 0 0-64-64 0 0 64zm96 0l64 0 0-64-64 0 0 64zm0 32l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64z'
      
    ]
  };

  

  
  

  var faPersonBurst = {
    prefix: 'fal',
    iconName: 'person-burst',
    icon: [
      640,
      512,
      [],
      'e53b',
      
      'M456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM467.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM448 496l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-293.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L563.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.6 16.3-70.6 42.3L337.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L416 202.1 416 496c0 8.8 7.2 16 16 16s16-7.2 16-16zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6L222.6 87.2 190.5 17.3zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z'
      
    ]
  };

  

  
  

  var faCrateApple = {
    prefix: 'fal',
    iconName: 'crate-apple',
    icon: [
      512,
      512,
      ["apple-crate"],
      'f6b1',
      
      'M219.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM75 126c6.3-10.4 13.1-14 21-14c9.3 0 23.1 3.9 35.6 8.8c18.2 7.1 38.5 7.1 56.7 0c12.5-4.9 26.4-8.8 35.6-8.8c7.9 0 14.7 3.6 21 14c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6l32.3 0c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6l32.3 0c-1-6.6-1.5-13.4-1.5-20.6c0-17.5 4.2-34.2 11-45.5zm403.7 66c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c4.5 7.4 8.2 15.3 11.1 23.6c4.3 1.3 8.6 2.8 12.8 4.5c18.2 7.1 38.5 7.1 56.7 0c12.5-4.9 26.4-8.8 35.6-8.8c7.9 0 14.7 3.6 21 14c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6l32.3 0zM32 384l448 0 0 72c0 13.3-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24l0-72zm0-32l0-72c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24l0 72L32 352zm480 0l0-72c0-30.9-25.1-56-56-56L56 224c-30.9 0-56 25.1-56 56l0 72 0 16 0 16 0 72c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-72 0-16 0-16zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faAppleCrate = faCrateApple;
  

  
  

  var faFileSvg = {
    prefix: 'fal',
    iconName: 'file-svg',
    icon: [
      512,
      512,
      [],
      'e64b',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM205.7 352l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L176 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C169.8 430.8 160 415 160 397.7c0-25.2 20.4-45.7 45.7-45.7zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm-152 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faEarthAmericas = {
    prefix: 'fal',
    iconName: 'earth-americas',
    icon: [
      512,
      512,
      [127758,"earth","earth-america","globe-americas"],
      'f57d',
      
      'M256 480C132.3 480 32 379.7 32 256c0-11.8 .9-23.3 2.7-34.6l3 6.7c9.3 21 27.3 37 49.2 43.9l63 19.7c15.5 4.9 26.1 19.2 26.1 35.5l0 15c0 17 9.6 32.6 24.8 40.2c4.4 2.2 7.2 6.7 7.2 11.6l0 22.7c0 26.2 21.2 47.4 47.4 47.4c21.8 0 40.7-14.8 46-35.9l4.4-17.6c2.6-10.2 9.2-19 18.3-24.2l11.6-6.6c19.9-11.4 32.2-32.6 32.2-55.6l0-8.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-12-12-28.3-18.7-45.3-18.7l-48.8 0c-5 0-9.9-1.2-14.3-3.4l-45.9-22.9c-2.1-1-3.8-2.7-4.8-4.8l-.7-1.4c-2.3-4.6-.4-10.2 4.2-12.5c2.2-1.1 4.8-1.3 7.1-.5l24.2 8.1c15 5 31.5-.7 40.3-13.8c8.6-12.9 7.7-30-2.2-41.9l-17.9-21.5c-2.5-3-2.5-7.4 .1-10.3l20.1-23.5c13.2-15.4 15.3-37.4 5.2-55.1L259.6 32C337.1 33.2 405 73.8 444.3 134.6l-38.2 15.3c-23.6 9.4-35.7 35.6-27.7 59.7l16.9 50.7c5.2 15.6 18 27.4 33.9 31.4L475 303.2C453.3 404.3 363.5 480 256 480zM48 172.7C77.3 99.7 143.8 45.7 224 34.3l14.9 26.1c3.4 5.9 2.7 13.2-1.7 18.4l-20.1 23.5c-12.7 14.8-12.9 36.6-.4 51.6l17.9 21.5c.9 1.1 1 2.6 .2 3.7c-.8 1.2-2.2 1.7-3.6 1.2L207 172.1c-10.4-3.5-21.7-2.7-31.5 2.2c-20.4 10.2-28.7 35-18.5 55.4l.7 1.4c4.1 8.3 10.9 15 19.2 19.2l45.9 22.9c8.9 4.4 18.7 6.8 28.6 6.8l48.8 0c8.5 0 16.6 3.4 22.6 9.4l3.9 3.9c6 6 9.4 14.1 9.4 22.6l0 8.3c0 11.5-6.2 22.1-16.1 27.8l-11.6 6.6c-16.7 9.6-28.8 25.5-33.5 44.2l-4.4 17.6c-1.7 6.9-7.9 11.7-15 11.7c-8.5 0-15.4-6.9-15.4-15.4l0-22.7c0-17-9.6-32.6-24.8-40.2c-4.4-2.2-7.2-6.7-7.2-11.6l0-15c0-30.3-19.7-57-48.6-66.1l-63-19.7c-13.2-4.1-23.9-13.7-29.5-26.3L48 172.7zM480 256c0 5.2-.2 10.3-.5 15.4l-42.6-10.6c-5.3-1.3-9.6-5.3-11.3-10.5l-16.9-50.7c-2.7-8 1.4-16.8 9.2-19.9l41.8-16.7c13 28.3 20.2 59.9 20.2 93.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faEarth = faEarthAmericas;
  
    var faEarthAmerica = faEarthAmericas;
  
    var faGlobeAmericas = faEarthAmericas;
  

  
  

  var faHexagonImage = {
    prefix: 'fal',
    iconName: 'hexagon-image',
    icon: [
      512,
      512,
      [],
      'e504',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32l29.6 51.3L116 280.6c15.4-15.4 40.4-15.6 56.1-.5l55.3 53.4 95.4-101.8c15.8-16.9 42.6-16.9 58.4 0l68.3 72.8L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm92 191.3l69.8-74.4-55.6-53.8c-3.1-3-8.1-3-11.2 .1L89.9 352l45.8 79.4zm297.1-97.8l-74.9-79.9c-3.2-3.4-8.5-3.4-11.7 0L164.1 447.8l184.2 0c11.4 0 22-6.1 27.7-16l56.8-98.3zM208 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faEraser = {
    prefix: 'fal',
    iconName: 'eraser',
    icon: [
      576,
      512,
      [],
      'f12d',
      
      'M353 74.3c-9.4-9.4-24.6-9.4-33.9 0l-111 111L390.6 368l111-111c9.4-9.4 9.4-24.6 0-33.9L353 74.3zM74.3 319c-9.4 9.4-9.4 24.6 0 33.9l88 88c4.5 4.5 10.6 7 17 7l121.4 0c6.4 0 12.5-2.5 17-7L368 390.6 185.4 208 74.3 319zM296.4 51.7c21.9-21.9 57.3-21.9 79.2 0L524.3 200.4c21.9 21.9 21.9 57.3 0 79.2L355.9 448 528 448c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0 0-.1c-1.1 .1-2.2 .1-3.3 .1l-121.4 0c-14.9 0-29.1-5.9-39.6-16.4l-88-88c-21.9-21.9-21.9-57.3 0-79.2L296.4 51.7z'
      
    ]
  };

  

  
  

  var faBullseyePointer = {
    prefix: 'fal',
    iconName: 'bullseye-pointer',
    icon: [
      512,
      512,
      [],
      'f649',
      
      'M256 480c123.7 0 224-100.3 224-224S379.7 32 256 32S32 132.3 32 256c0 10.4 .7 20.6 2.1 30.6l-9.6 3.5c-7.8 2.9-14.7 7.7-19.9 13.9C1.5 288.5 0 272.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-16.4 0-32.5-1.5-48.1-4.5c6.2-5.3 11-12.1 13.9-19.9l3.5-9.6c10 1.4 20.2 2.1 30.6 2.1zm-7.7-64.2L260 383.9c68.8-2.1 124-58.6 124-127.9c0-70.7-57.3-128-128-128c-69.3 0-125.8 55.1-127.9 124L96.2 263.7c-.1-2.6-.2-5.1-.2-7.7c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-2.6 0-5.2-.1-7.7-.2zM271 261.5l-79.2 215c-2.3 6.2-8.1 10.3-14.7 10.5s-12.6-3.8-15.1-9.9l-30.5-74L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L108.9 380.5 34.9 350c-6.1-2.5-10-8.5-9.9-15.1s4.3-12.4 10.5-14.7l215-79.2c5.9-2.2 12.4-.7 16.8 3.7s5.9 11 3.7 16.8zM143.3 360c3.9 1.6 7.1 4.8 8.7 8.7l24 58.2L229 283 85.1 336l58.2 24z'
      
    ]
  };

  

  
  

  var faDroplet = {
    prefix: 'fal',
    iconName: 'droplet',
    icon: [
      384,
      512,
      [128167,"tint"],
      'f043',
      
      'M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7l1.3 0c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  
    var faTint = faDroplet;
  

  
  

  var faCircleWifi = {
    prefix: 'fal',
    iconName: 'circle-wifi',
    icon: [
      512,
      512,
      [],
      'e67d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm122.2-28.7c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6c41.1-37 95.6-59.6 155.2-59.6s114.1 22.6 155.2 59.6c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C354.4 195.4 307.5 176 256 176s-98.4 19.4-133.8 51.4zM256 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-72c-24.8 0-47.3 9.4-64.4 24.8c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6c22.7-20.5 52.8-33 85.8-33s63.1 12.5 85.8 33c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-17-15.4-39.6-24.8-64.4-24.8z'
      
    ]
  };

  

  
  

  var faNotebook = {
    prefix: 'fal',
    iconName: 'notebook',
    icon: [
      512,
      512,
      [],
      'e201',
      
      'M192 32l-64 0c-17.7 0-32 14.3-32 32l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 96 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 96 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 17.7 14.3 32 32 32l64 0 0-448zm32 448l192 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L224 32l0 448zm-16 32l-80 0c-35.3 0-64-28.7-64-64l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-96-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-96-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48C64 28.7 92.7 0 128 0l80 0L416 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-208 0z'
      
    ]
  };

  

  
  

  var faFolderMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'folder-magnifying-glass',
    icon: [
      512,
      512,
      ["folder-search"],
      'e18b',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM240 208a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160c20.7 0 39.9-6.6 55.6-17.7l45.1 45.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-45.1-45.1C329.4 311.9 336 292.7 336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z'
      
    ]
  };

  
    var faFolderSearch = faFolderMagnifyingGlass;
  

  
  

  var faCandyCorn = {
    prefix: 'fal',
    iconName: 'candy-corn',
    icon: [
      640,
      512,
      [],
      'f6bd',
      
      'M480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 20.1-7 52-15.6 84c-9.1 33.8-21.4 73-34.7 110.4c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3C357 213 344.7 173.8 335.6 140C327 108 320 76.1 320 56c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM602.6 48.4C564.9 36.1 522.3 32 480 32c-42.1 0-84.4 4.2-122.2 16.3C354.2 49.6 352 53 352 56c0 13.3 4.4 36.2 11.3 63.4c1.2-.2 2.6-.3 4.1-.5c6.2-.8 15.2-1.8 26.2-2.8c22-2 52.6-4.1 86.4-4.1s64.3 2 86.4 4.1c11 1 20 2 26.2 2.8c1.6 .2 2.9 .4 4.1 .5C603.6 92.2 608 69.3 608 56c0-3.4-2.2-6.5-5.4-7.6zM371.8 150.6c8.1 28.2 18.1 59.3 28.7 89.1l1.3 3.7c21.1-1.8 48.4-3.4 78.2-3.4s57.1 1.6 78.2 3.4l1.3-3.7c10.6-29.8 20.6-60.9 28.7-89.1c-5.9-.7-14.4-1.7-24.8-2.6c-21.4-2-50.9-3.9-83.4-3.9s-62.1 2-83.4 3.9c-10.4 1-18.9 1.9-24.8 2.6zm68.8 186.9c6.9 13.8 13.5 26.4 21.5 35.7c7.6 8.8 13.1 10.9 17.9 10.9s10.4-2.1 17.9-10.9c8-9.2 14.6-21.8 21.5-35.7c8.8-17.6 18.1-39.3 27.2-62.9c-19-1.4-41.9-2.5-66.6-2.5s-47.6 1.1-66.6 2.5c9.1 23.6 18.4 45.3 27.2 62.9zM85.1 203.3c31.2-31.2 67-61 106.6-81c15.4-7.7 34-4.7 46.2 7.5c14.2 14.2 31.8 41.8 48.3 70.4c17.5 30.3 36.5 66.8 53.6 102.6c16.9 35.7 32.4 71.8 42.2 101c9.6 28.6 22.2 68.7-2.7 93.6s-65 12.2-93.6 2.7c-29.3-9.8-65.4-25.2-101-42.2c-35.9-17-72.3-36.1-102.6-53.5c-28.7-16.5-56.2-34.2-70.4-48.3c-12.2-12.2-15-31.2-7.3-46.6c20.3-39.4 49.7-75 80.8-106.2zM206 150.9c-35.4 17.9-68.4 45.2-98.3 75.1C78 255.7 51 288.6 32.9 323.9c-1.7 3.4-.8 7.4 1.4 9.5c9.4 9.4 28.8 22.5 52.8 36.8c.7-1 1.6-2.1 2.6-3.3c3.8-4.9 9.5-12 16.5-20.5c14.2-17 34.3-40 58.2-63.9s46.9-44 63.9-58.2c8.5-7.1 15.6-12.7 20.5-16.5c1.2-1 2.3-1.8 3.3-2.6c-14.3-24.1-27.4-43.4-36.8-52.8c-2.4-2.4-6.1-3-9.2-1.5zm-91 235.4c25.7 14.2 54.7 29.1 83.3 42.7l3.5 1.7c13.7-16.2 31.9-36.6 52.9-57.7s41.5-39.2 57.7-52.9l-1.7-3.5c-13.6-28.6-28.5-57.6-42.7-83.3c-4.7 3.7-11.4 9-19.4 15.7c-16.5 13.7-38.7 33.2-61.8 56.2s-42.5 45.3-56.2 61.8c-6.7 8.1-12 14.7-15.7 19.4zm180.8 83.5c14.7 4.9 28.2 9.1 40.4 10c11.6 .9 17-1.6 20.4-5s5.8-8.8 5-20.4c-.9-12.2-5.1-25.7-10-40.4c-6.3-18.6-15.1-40.6-25.3-63.7c-14.4 12.4-31.4 27.8-48.9 45.3s-32.9 34.5-45.3 48.9c23.1 10.2 45.1 19 63.7 25.3z'
      
    ]
  };

  

  
  

  var faMessageQuote = {
    prefix: 'fal',
    iconName: 'message-quote',
    icon: [
      512,
      512,
      ["comment-alt-quote"],
      'e1e4',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM208 144l0 24 0 24-48 0 0-48 48 0zm-48 80l48 0c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 290.7 240 258.7 240 222l0-30 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm144-80l48 0 0 24 0 24-48 0 0-48zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 290.7 384 258.7 384 222l0-30 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l48 0z'
      
    ]
  };

  
    var faCommentAltQuote = faMessageQuote;
  

  
  

  var faUserRobotXmarks = {
    prefix: 'fal',
    iconName: 'user-robot-xmarks',
    icon: [
      448,
      512,
      [],
      'e4a7',
      
      'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0c-44.2 0-80 35.8-80 80l0 96c0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80l0-96c0-44.2-35.8-80-80-80l-64 0 0-48zM96 144c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c-26.5 0-48-21.5-48-48l0-96zM16 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM96 384l256 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16l-32 0 0-32c0-17.7-14.3-32-32-32l-48 0-64 0-64 0-48 0c-17.7 0-32 14.3-32 32l0 32-32 0c-8.8 0-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64zm16 64l32 0 0 32-32 0 0-32zm96 0l0 32-32 0 0-32 32 0zm16 64l64 0 48 0 32 0 32 0c26.5 0 48-21.5 48-48l0-16c0-53-43-96-96-96L96 352c-53 0-96 43-96 96l0 16c0 26.5 21.5 48 48 48l32 0 32 0 48 0 64 0zm16-64l32 0 0 32-32 0 0-32zm96 0l0 32-32 0 0-32 32 0zM137.3 118.7c-5.2-5.2-13.5-5.2-18.7 0s-5.2 13.5 0 18.7L141.3 160l-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0L160 178.7l22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L178.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L160 141.3l-22.7-22.7zm109.3 0c-5.2 5.2-5.2 13.5 0 18.7L269.3 160l-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0L288 178.7l22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L306.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L288 141.3l-22.7-22.7c-5.2-5.2-13.5-5.2-18.7 0z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fal',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      'M180.7 475.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 425.4 208 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4L27.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z'
      
    ]
  };

  

  
  

  var faPersonSwimming = {
    prefix: 'fal',
    iconName: 'person-swimming',
    icon: [
      576,
      512,
      [127946,"swimmer"],
      'f5c4',
      
      'M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 384.1 0 390.4 0 398.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 401.9 161.7 416 192 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 401.9 353.7 416 384 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 374 404.9 384 384 384s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 374 212.9 384 192 384s-41.7-9.9-58.2-21.2zM258.4 185L412.3 315.5c10.7-3.5 21.4-8.8 30.9-15.4l.2-.2-163-138.3C309.5 140.5 345.3 128 384 128l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-114.9 0-208 93.1-208 208l0 14.8c5.5 1.1 10.9 1.7 16 1.7c5.4 0 10.7-.5 16-1.6l0-14.9c0-46.8 18.3-89.4 48.1-121l2.3 2z'
      
    ]
  };

  
    var faSwimmer = faPersonSwimming;
  

  
  

  var faTRex = {
    prefix: 'fal',
    iconName: 't-rex',
    icon: [
      640,
      512,
      [],
      'e629',
      
      'M439.3 32c-26.8 0-51 16.3-61 41.3l-11.5 28.7c-.8 2-2 3.8-3.5 5.4l-48 48c-3 3-7.1 4.7-11.3 4.7l-36.1 0c-38.4 0-72.6 24.6-84.7 61.1l-14.4 43.1c-7.9 23.8-30.2 39.9-55.3 39.9c-15.5 0-30.3-6.1-41.2-17.1l-3.6-3.6C55.4 270.1 48 252.1 48 233.4l0-15.6c-10.5 18.1-16 38.6-16 59.5l0 3.4C32 346.6 85.4 400 151.4 400l40.7 0c-.1-1.3-.1-2.6-.1-3.9l0-28.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 28.1c0 8.5 3.4 16.6 9.4 22.6l58.9 58.9c1.5 1.5 3.5 2.3 5.7 2.3l86.1 0 0-8c0-13.3-10.7-24-24-24l-8 0c-6.9 0-13-4.4-15.2-10.9l-16-48c-2.2-6.5 .1-13.7 5.6-17.9C342 359.5 352 340.9 352 320c0-35.3-28.7-64-64-64c-8.8 0-16-7.2-16-16s7.2-16 16-16c53 0 96 43 96 96c0 27.2-11.3 51.7-29.4 69.2l9 27C392.8 418 416 442.3 416 472l0 8c0 17.7-14.3 32-32 32l-86.1 0c-10.6 0-20.8-4.2-28.3-11.7l-58.9-58.9c-2.9-2.9-5.5-6-7.7-9.4l-51.6 0C67.8 432 0 364.2 0 280.6l0-3.4c0-27.3 7.4-54 21.4-77.4l6.6-11c14.6-24.3 51.9-14 51.9 14.4l0 30.2c0 10.2 4.1 20.1 11.3 27.3l3.6 3.6c4.9 4.9 11.6 7.7 18.6 7.7c11.3 0 21.4-7.2 24.9-18l14.4-43.1c16.5-49.5 62.9-82.9 115.1-82.9l29.5 0 41-41 10.2-25.6C363.4 24.3 399.4 0 439.3 0c10.7 0 21.4 1.8 31.4 5.2C478.5 1.9 487 0 496 0c23.7 0 44.4 12.9 55.4 32l8.6 0c44.2 0 80 35.8 80 80l0 32c0 24.1-17.7 44-40.8 47.5l-13.8 13.8c-12 12-28.3 18.7-45.3 18.7l-69.5 0L429 265.6l26.8 15.3c15 8.5 24.2 24.5 24.2 41.7l0 13.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-13.4c0-5.7-3.1-11-8.1-13.9l-26.7-15.3c-3.1-14.7-8.7-28.5-16.4-40.9l55.9-55.9c3-3 7.1-4.7 11.3-4.7l76.1 0c2.6 0 5.2-.3 7.7-.9c-9.2-1.8-17.8-6.4-24.5-13.1l-13.3-13.3c-3-3-7.1-4.7-11.3-4.7L480 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l18.7 0c12.7 0 24.9 5.1 33.9 14.1l13.3 13.3c3 3 7.1 4.7 11.3 4.7l34.7 0c8.8 0 16-7.2 16-16l0-32c0-26.5-21.5-48-48-48l-18.7 0c-6.8 0-12.8-4.3-15.1-10.7C521.8 40.9 509.9 32 496 32c-6 0-11.5 1.6-16.3 4.4c-4.4 2.6-9.8 2.9-14.5 .9c-8.2-3.5-17-5.4-26-5.4zM480 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPretzel = {
    prefix: 'fal',
    iconName: 'pretzel',
    icon: [
      512,
      512,
      [129384],
      'e441',
      
      'M149.4 64C84.6 64 32 116.6 32 181.4c0 64.6 28 122.7 72.7 162.8l27.6-39.9C100.1 273.3 80 229.7 80 181.4c0-38.3 31.1-69.4 69.4-69.4l6.6 0c42 0 76 34 76 76l0 3.6c0 16.2-4.9 32-14.2 45.3l-18.2 26.3-33 47.6c0 0 0 0 0 0l-45.6 65.8c0 0 0 0 0 0L92.3 418.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1l34.5-49.8c4-5.8 11.3-8.3 18-6.1c20.9 6.7 43.2 10.3 66.4 10.3l5.4 0 5.4 0c15.5 0 30.6-1.6 45.1-4.7l-30.4-44c-4.8 .4-9.7 .6-14.7 .6l-5.4 0-5.4 0c-8.4 0-16.6-.6-24.7-1.8c-5.5-.8-10.2-4.4-12.4-9.4s-1.6-10.9 1.5-15.5l27.8-40.1c3-4.3 7.9-6.9 13.2-6.9s10.2 2.6 13.2 6.9l13 18.8 14.7 21.3 48.9 70.6 34.5 49.8s0 0 0 0c7.5 10.9 22.5 13.6 33.4 6.1s13.6-22.5 6.1-33.4l-28.8-41.6c-4.9-7-3.4-16.6 3.4-21.8C446.5 315 480 252.1 480 181.4C480 116.6 427.4 64 362.6 64L356 64c-34.7 0-66 14.2-88.6 37.2c-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8C222 78.2 190.7 64 156 64l-6.6 0zM326.1 423.6c-20.6 5.5-42.3 8.4-64.7 8.4l-5.4 0-5.4 0c-22.3 0-44-2.9-64.7-8.4L158 463.9c-17.6 25.4-52.5 31.8-77.9 14.2S48.4 425.6 66 400.1c0 0 0 0 0 0l20.4-29.5C33.5 324.7 0 257 0 181.4C0 98.9 66.9 32 149.4 32l6.6 0c38 0 72.9 13.6 100 36.3C283.1 45.6 318 32 356 32l6.6 0C445.1 32 512 98.9 512 181.4c0 75.6-33.5 143.3-86.3 189.3L446 400.1c17.6 25.4 11.3 60.3-14.2 77.9s-60.3 11.3-77.9-14.2c0 0 0 0 0 0l-27.9-40.3zM173.3 245l18.2-26.3c5.5-8 8.5-17.4 8.5-27.1l0-3.6c0-24.3-19.7-44-44-44l-6.6 0c-20.7 0-37.4 16.7-37.4 37.4c0 37.3 14.8 71.2 38.8 96.2L173.3 245zM356 144c-24.3 0-44 19.7-44 44l0 3.6c0 9.7 3 19.1 8.5 27.1l40.7 58.8c24-24.9 38.8-58.8 38.8-96.2c0-20.7-16.7-37.4-37.4-37.4l-6.6 0zm-76 44c0-42 34-76 76-76l6.6 0c38.3 0 69.4 31.1 69.4 69.4c0 53.7-24.8 101.5-63.5 132.8c-3.5 2.8-7.9 4-12.3 3.4s-8.3-3.1-10.9-6.7L294.2 237c-9.2-13.3-14.2-29.1-14.2-45.3l0-3.6z'
      
    ]
  };

  

  
  

  var faQuotes = {
    prefix: 'fal',
    iconName: 'quotes',
    icon: [
      576,
      512,
      [],
      'e234',
      
      'M0 88C0 39.4 39.4 0 88 0l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0C57.1 32 32 57.1 32 88l0 10.7C37 97 42.4 96 48 96l32 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-8 0-24L0 88zm32 56l0 24 0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM160 88c0-48.6 39.4-88 88-88l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0c-30.9 0-56 25.1-56 56l0 10.7c5-1.8 10.4-2.7 16-2.7l32 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-8 0-24 0-56zm32 80l0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 24zM576 424c0 48.6-39.4 88-88 88l-8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0c30.9 0 56-25.1 56-56l0-10.7c-5 1.8-10.4 2.7-16 2.7l-32 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 8 0 24 0 56zm-32-56l0-24 0-8c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM416 424c0 48.6-39.4 88-88 88l-8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0c30.9 0 56-25.1 56-56l0-10.7c-5 1.8-10.4 2.7-16 2.7l-32 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 8 0 24 0 56zm-32-80l0-8c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-24z'
      
    ]
  };

  

  
  

  var faGreaterThan = {
    prefix: 'fal',
    iconName: 'greater-than',
    icon: [
      384,
      512,
      [62769],
      '3e',
      
      'M1.7 72.8c-4 7.9-.7 17.5 7.2 21.5L332.2 256 8.8 417.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l352-176c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-352-176c-7.9-4-17.5-.7-21.5 7.2z'
      
    ]
  };

  

  
  

  var faFile = {
    prefix: 'fal',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z'
      
    ]
  };

  

  
  

  var faBoxOpenFull = {
    prefix: 'fal',
    iconName: 'box-open-full',
    icon: [
      640,
      512,
      ["box-full"],
      'f49c',
      
      'M256 32c53 0 96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C384 57.3 326.7 0 256 0S128 57.3 128 128c0 8.8 7.2 16 16 16s16-7.2 16-16c0-53 43-96 96-96zM80.4 161.5c-14.1-1.6-27.5 6.2-33.1 19.2l-32 74.7C5.4 278.2 18.7 304.4 43 310l159.2 36.7c18.9 4.4 38.6-3.1 49.9-18.9L320 232.9l67.9 95.1c11.3 15.8 30.9 23.2 49.9 18.9L597 310c24.3-5.6 37.6-31.8 27.8-54.7l-32-74.7c-5.6-13-19-20.8-33.1-19.2L320 189.2 80.4 161.5zm-3.7 31.8l214.5 24.8-65.1 91.2c-3.8 5.3-10.3 7.7-16.6 6.3L50.2 278.9c-4.9-1.1-7.5-6.4-5.6-10.9l32-74.7zM544 348.7l0 61.8c0 7.3-5 13.7-12.1 15.5L336 475l0-139c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 139L108.1 426C101 424.3 96 417.9 96 410.5l0-61.8-32-9.1 0 71c0 22 15 41.2 36.4 46.6l208 52c7.6 1.9 15.6 1.9 23.3 0l208-52c21.4-5.3 36.4-24.5 36.4-46.6l0-71-32 9.1zM348.8 218.1l214.5-24.8 32 74.7c2 4.6-.7 9.8-5.6 10.9L430.6 315.6c-6.3 1.5-12.9-1-16.6-6.3l-65.1-91.2zm146.4-181c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-32 96c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l32-96z'
      
    ]
  };

  
    var faBoxFull = faBoxOpenFull;
  

  
  

  var faCrab = {
    prefix: 'fal',
    iconName: 'crab',
    icon: [
      512,
      512,
      [129408],
      'e3ff',
      
      'M112 32C73.3 32 41 59.5 33.6 96l97.1 0c4.2 0 8.3-1.7 11.3-4.7l6.6-6.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.6 6.6c-9 9-21.2 14.1-33.9 14.1L32 128l0 20.1c0 11.5 6.2 22.1 16.1 27.8l78.8 45C145.1 206 167.5 196 192 193l0-49c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 49c24.5 3.1 46.9 13.1 65.1 28l78.8-45c10-5.7 16.1-16.3 16.1-27.8l0-20.1-98.7 0c-12.7 0-24.9-5.1-33.9-14.1l-6.6-6.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l6.6 6.6c3 3 7.1 4.7 11.3 4.7l97.1 0C471 59.5 438.7 32 400 32l-16 0 25.6 19.2c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-64-48c-5.5-4.1-7.8-11.3-5.6-17.9S329.1 0 336 0l64 0c61.9 0 112 50.1 112 112l0 36.1c0 23-12.3 44.2-32.2 55.6l-72.1 41.2c6 8.3 11.1 17.4 15 27.1l37.5 0 28.6-14.3c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-2.2 1.1-4.7 1.7-7.2 1.7l-33 0c.7 5.2 1 10.6 1 16l0 8 22.2 9.2c1.9 .8 3.7 2 5.2 3.5l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.8-29.8-25.7-10.7-31.1 31.1L421.7 401c2.1 .8 4 2 5.6 3.6l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.6-29.6-49.8-19-15.1 15.1L377.3 451c4.2 3 6.7 7.9 6.7 13l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-23.8L318.1 448l-124.1 0L160 472.2l0 23.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-5.2 2.5-10 6.7-13l35.2-25.1-15.1-15.1-49.8 19L75.3 459.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.6-1.6 3.5-2.8 5.6-3.6l39.6-15.1L98.8 354.8 73.1 365.6 43.3 395.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.5-1.5 3.2-2.6 5.2-3.5L80 328l0-8c0-5.4 .3-10.8 1-16l-33 0c-2.5 0-4.9-.6-7.2-1.7l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2L51.8 272l37.5 0c3.9-9.7 9-18.8 15-27.1L32.2 203.7C12.3 192.3 0 171.1 0 148.1L0 112C0 50.1 50.1 0 112 0l64 0c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-64 48c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4L128 32l-16 0zM304 224l-96 0c-53 0-96 43-96 96l0 2.7L205.3 416l101.5 0L400 322.7l0-2.7c0-53-43-96-96-96z'
      
    ]
  };

  

  
  

  var faLocationDot = {
    prefix: 'fal',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faDialMedLow = {
    prefix: 'fal',
    iconName: 'dial-med-low',
    icon: [
      576,
      512,
      [],
      'e160',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM197.5 378.5c-46.2-46.2-49.7-118.8-10.6-169l89.8 89.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-89.8-89.8c50.2-39.1 122.9-35.5 169 10.6c50 50 50 131 0 181s-131 50-181 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircle0 = {
    prefix: 'fal',
    iconName: 'circle-0',
    icon: [
      512,
      512,
      [],
      'e0ed',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96l0 64c0 53 43 96 96 96s96-43 96-96l0-64c0-53-43-96-96-96zm-64 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64z'
      
    ]
  };

  

  
  

  var faHandshakeAngle = {
    prefix: 'fal',
    iconName: 'handshake-angle',
    icon: [
      640,
      512,
      ["hands-helping"],
      'f4c4',
      
      'M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L452.7 81.9c-9 9-21.2 14.1-33.9 14.1L304 96c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-88c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24 112 0c35.3 0 64 28.7 64 64c0 24.5-13.7 45.7-33.9 56.5c1.2 5 1.9 10.2 1.9 15.5c0 29.9-20.5 55-48.3 62.1C428.7 422.6 401.3 448 368 448l-130.7 0c-4.2 0-8.3 1.7-11.3 4.7l-54.6 54.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l54.6-54.6c9-9 21.2-14.1 33.9-14.1L368 416c17.7 0 32-14.3 32-32c0-1.8-.2-3.6-.4-5.4c-.8-4.7 .5-9.5 3.6-13.1s7.6-5.6 12.4-5.6l.4 0c17.7 0 32-14.3 32-32c0-6.1-1.7-11.7-4.6-16.6c-2.7-4.5-3.1-10-.9-14.8s6.5-8.2 11.6-9.2c14.8-2.8 25.9-15.8 25.9-31.4c0-17.7-14.3-32-32-32l-112 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-96c0-53 43-96 96-96l114.7 0c4.2 0 8.3-1.7 11.3-4.7L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zM125.6 190.3c9.2-24.5 27.6-43.5 50.4-53.8l0 37.1c-9.1 7.1-16.3 16.7-20.5 27.9l-26.1 69.6c-2.4 6.4-6.2 12.2-11 17.1L27.3 379.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l91.1-91.1c1.6-1.6 2.9-3.6 3.7-5.7l26.1-69.6zm509.8-57.6c6.2 6.2 6.2 16.4 0 22.6L543.6 247c-1.2-12.5-4.7-24.4-10.2-35l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faHandsHelping = faHandshakeAngle;
  

  
  

  var faAccentGrave = {
    prefix: 'fal',
    iconName: 'accent-grave',
    icon: [
      192,
      512,
      [],
      '60',
      
      'M64 65.3C64 46.9 78.9 32 97.3 32c16.1 0 30 11.6 32.8 27.5l22.5 126.2c.6 3.3-1.9 6.3-5.3 6.3c-1.7 0-3.4-.8-4.4-2.3L70.4 86.9C66.2 81 64 74 64 66.8l0-1.5zm-32 0l0 1.5c0 13.8 4.3 27.3 12.2 38.5l72.6 102.9c7 9.9 18.4 15.8 30.5 15.8c23.3 0 40.9-21 36.8-43.9L161.6 53.8C156.1 22.7 129 0 97.3 0C61.2 0 32 29.2 32 65.3z'
      
    ]
  };

  

  
  

  var faPaintRoller = {
    prefix: 'fal',
    iconName: 'paint-roller',
    icon: [
      512,
      512,
      [],
      'f5aa',
      
      'M352 32c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L64 128c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l288 0zm64 32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 96c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-32zM240 352c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l32 0zm-32-32c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l0-32c0-17.7 14.3-32 32-32l176 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l0 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-176 0c-35.3 0-64 28.7-64 64l0 32z'
      
    ]
  };

  

  
  

  var faTrafficLightStop = {
    prefix: 'fal',
    iconName: 'traffic-light-stop',
    icon: [
      320,
      512,
      [],
      'f63a',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 70.7 57.3 128 128 128s128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-136a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  

  
  

  var faPhoneSlash = {
    prefix: 'fal',
    iconName: 'phone-slash',
    icon: [
      640,
      512,
      [],
      'f3dd',
      
      'M480 510.9c-95.4-6.7-182.6-43.3-252.2-100.5L253.5 390c70.9 56.3 160.6 89.9 258.1 90l.3 0c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-8.7-5-17.1-10.4-25.3-16.2L344.8 318c4.9 3.2 9.9 6.3 15 9.3L393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8zM141.2 315.6C92.5 243.9 64 157.3 64 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c1.9 3.3 3.9 6.6 6 9.8l-25.2 19.9c-2.9-4.5-5.7-9.1-8.4-13.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 85.8 26 165.5 70.4 231.7l-25.2 19.9zM614.1 3.4c6.9-5.5 17-4.3 22.5 2.6s4.3 17-2.6 22.5l-608 480c-6.9 5.5-17 4.3-22.5-2.6s-4.3-17 2.6-22.5l608-480z'
      
    ]
  };

  

  
  

  var faStarOfLife = {
    prefix: 'fal',
    iconName: 'star-of-life',
    icon: [
      512,
      512,
      [],
      'f621',
      
      'M192 48c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 97.1 84.1-48.6c23-13.3 52.3-5.4 65.6 17.6l16 27.7c13.3 23 5.4 52.3-17.6 65.6L384 256l84.1 48.6c23 13.3 30.8 42.6 17.6 65.6l-16 27.7c-13.3 23-42.6 30.8-65.6 17.6L320 366.9l0 97.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-97.1-84.1 48.6c-23 13.3-52.3 5.4-65.6-17.6l-16-27.7c-13.3-23-5.4-52.3 17.6-65.6L128 256 43.9 207.4 51.6 194l-7.7 13.4c-23-13.3-30.8-42.6-17.6-65.6l16-27.7c13.3-23 42.6-30.8 65.6-17.6L192 145.1 192 48zm48-16c-8.8 0-16 7.2-16 16l0 124.9c0 5.7-3 11-8 13.9s-11 2.9-16 0L91.9 124.3c-7.7-4.4-17.4-1.8-21.9 5.9L54 157.9c-4.4 7.7-1.8 17.4 5.9 21.9L168 242.1c5 2.9 8 8.1 8 13.9s-3 11-8 13.9L59.9 332.3c-7.7 4.4-10.3 14.2-5.9 21.9l16 27.7c4.4 7.7 14.2 10.3 21.9 5.9L200 325.3c5-2.9 11-2.9 16 0s8 8.1 8 13.9L224 464c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-124.9c0-5.7 3-11 8-13.9s11-2.9 16 0l108.1 62.4c7.7 4.4 17.4 1.8 21.9-5.9l16-27.7c4.4-7.7 1.8-17.4-5.9-21.9L344 269.9c-5-2.9-8-8.1-8-13.9s3-11 8-13.9l108.1-62.4c7.7-4.4 10.3-14.2 5.9-21.9l-16-27.7c-4.4-7.7-14.2-10.3-21.9-5.9L312 186.7c-5 2.9-11 2.9-16 0s-8-8.1-8-13.9L288 48c0-8.8-7.2-16-16-16l-32 0z'
      
    ]
  };

  

  
  

  var faPlugCircleXmark = {
    prefix: 'fal',
    iconName: 'plug-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e560',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64c0 83 63.1 151.2 144 159.2l0 96.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96.8c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128l0-64 256 0 0 56.2c9.8-8.1 20.6-15.2 32-21l0-35.2 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0L64 144l-32 0-16 0zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faHexagonCheck = {
    prefix: 'fal',
    iconName: 'hexagon-check',
    icon: [
      512,
      512,
      [],
      'e416',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm319.6-36.7l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBowlSpoon = {
    prefix: 'fal',
    iconName: 'bowl-spoon',
    icon: [
      512,
      512,
      [129379],
      'e3e0',
      
      'M112 160c-49 0-80-33.1-80-64s31-64 80-64s80 33.1 80 64s-31 64-80 64zm0 32c55.5 0 101.6-34.6 110.5-80L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L222.5 80C213.6 34.6 167.5 0 112 0C50.1 0 0 43 0 96s50.1 96 112 96zm49.3 271.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9l410.2 0c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1l-144 0c-10.4 0-19.4-6.7-22.7-16.1zM50.9 224C23.3 224 1.4 247.2 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2c7.6 21.9 28.4 37.6 52.9 37.6l144 0c24.5 0 45.3-15.7 52.9-37.6c71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8L50.9 224z'
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fal',
    iconName: 'superscript',
    icon: [
      512,
      512,
      [],
      'f12b',
      
      'M464 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L432 160l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-144zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l39.2 0L157 256 55.2 416 16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-39.2 0L195 256 296.8 96 336 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4C74.6 66.8 69.5 64 64 64L16 64z'
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fal',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      'M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6 208 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM0 256c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240c-8.8 0-16 7.2-16 16zM224 512c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4 240 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z'
      
    ]
  };

  

  
  

  var faFilePpt = {
    prefix: 'fal',
    iconName: 'file-ppt',
    icon: [
      512,
      512,
      [],
      'e64a',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-64c0-8.8 7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-16 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faPinata = {
    prefix: 'fal',
    iconName: 'pinata',
    icon: [
      512,
      512,
      [],
      'e3c3',
      
      'M160 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 176 160 0c53 0 96 43 96 96l0 144c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-16c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 16c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-238.1L38.9 197.3C15.1 185.4 0 161 0 134.4C0 95.5 31.5 64 70.4 64L160 64l0-16zm96 336l96 0 3.7 0c10.2 0 20.3 1.9 29.7 5.7l23.1 9.2 36.9-12.3c7.2-2.4 15-2.2 22 .6l12.6 5 0-49.9c-4.7-.1-9.3-1.2-13.6-3.4l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6L128 342l0 50.3 12.6-5c7-2.8 14.8-3 22-.6L199.5 399l23.1-9.2c9.4-3.8 19.5-5.7 29.7-5.7l3.7 0zM128 307.6l19.4-7.8c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l17.6 8.8C474.2 279.3 447.8 256 416 256l-176 0c-3.5 0-6.7-1.1-9.4-3l-19.3 7.7c-7 2.8-14.8 3-22 .6L152.5 249 128 258.8l0 48.7zM224 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8-7.2 16-16 16L70.4 96C49.2 96 32 113.2 32 134.4c0 14.5 8.2 27.8 21.2 34.3l65.9 33c5.4 2.7 8.8 8.3 8.8 14.3l0 8.4 12.6-5c7-2.8 14.8-3 22-.6L199.5 231l24.5-9.8L224 48zM128 426.8l0 37.2c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16c0-6 .8-11.9 2.4-17.4c-1.7-.3-3.4-.7-5-1.2L152.5 417 128 426.8zm352 0L455.5 417l-36.9 12.3c-1.6 .6-3.3 1-5 1.2c1.6 5.5 2.4 11.4 2.4 17.4l0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-37.2zM152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fal',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M420.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256 443.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6 27.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256 4.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 420.7 36.7z'
      
    ]
  };

  

  
  

  var faCandyBar = {
    prefix: 'fal',
    iconName: 'candy-bar',
    icon: [
      640,
      512,
      [127851,"chocolate-bar"],
      'e3e8',
      
      'M155.5 74.7c2.3-6.4 8.3-10.7 15.1-10.7L320 64l16 0 16 0 224 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-224 0-16 0-16 0L64 448c-35.3 0-64-28.7-64-64L0 234.5c0-6.8 4.3-12.8 10.7-15.1C41.8 208.5 64 178.8 64 144c0-8.8 7.2-16 16-16c34.8 0 64.5-22.2 75.5-53.3zM192 96l0 96 128 0 0-96L192 96zm-32 30.4c-17 17.4-39.7 29.2-65 32.6c-1.6 11.7-4.9 22.8-9.8 33l74.8 0 0-65.6zm-96 96c-9.2 9.4-20 17.1-32 22.8L32 320l128 0 0-96-96 0 0-1.6zM32 352l0 32c0 17.7 14.3 32 32 32l96 0 0-64L32 352zm160 64l128 0 0-64-128 0 0 64zm128-96l0-96-128 0 0 96 128 0zm32 96l224 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L352 96l0 320z'
      
    ]
  };

  
    var faChocolateBar = faCandyBar;
  

  
  

  var faBell = {
    prefix: 'fal',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      'M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z'
      
    ]
  };

  

  
  

  var faTemperatureFull = {
    prefix: 'fal',
    iconName: 'temperature-full',
    icon: [
      320,
      512,
      ["temperature-4","thermometer-4","thermometer-full"],
      'f2c7',
      
      'M160 32c-35.3 0-64 28.7-64 64l0 156.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9L224 96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96l0 156.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5L64 96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-210c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature4 = faTemperatureFull;
  
    var faThermometer4 = faTemperatureFull;
  
    var faThermometerFull = faTemperatureFull;
  

  
  

  var faBee = {
    prefix: 'fal',
    iconName: 'bee',
    icon: [
      576,
      512,
      [],
      'e0b2',
      
      'M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-5.7 .3-11.4 .8-17C66.7 280.9 32 247.6 32 208c0-43.8 42.5-80 96-80c40.8 0 75.2 21.1 89.3 50.5C173.5 203.3 144 250.2 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-53.8-29.5-100.7-73.3-125.5c14-29.5 48.5-50.5 89.3-50.5c53.5 0 96 36.2 96 80c0 39.6-34.7 72.9-80.8 79c.5 5.6 .8 11.3 .8 17c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zM288 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM177.1 288c1.6-11.3 4.9-22.1 9.6-32l202.4 0c4.7 9.9 8 20.7 9.6 32l-221.7 0zm32.5-64c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32l-156.8 0zm188.7 96c-2 10.2-5.7 20.9-10.9 32l-198.9 0c-5.2-11.1-8.9-21.8-10.9-32l220.7 0zm-29 64c-5.4 8.1-11.3 16.3-17.6 24.5c-2 2.6-4 5.1-6 7.5l-115.4 0c-2-2.5-4-5-6-7.5c-6.4-8.1-12.3-16.3-17.6-24.5l162.7 0zm-52.1 64c-11.4 11.8-21.7 21.6-29.2 28.5c-7.6-6.9-17.9-16.6-29.2-28.5l58.5 0z'
      
    ]
  };

  

  
  

  var faPodcast = {
    prefix: 'fal',
    iconName: 'podcast',
    icon: [
      448,
      512,
      [],
      'f2ce',
      
      'M416 224c0 71.3-38.8 133.5-96.5 166.6c-1.4 11.5-3.2 23.4-5 34.8l-.6 3.8C392.8 394.7 448 315.8 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-1.9-11.5-3.7-23.5-5.1-35C70.8 357.5 32 295.3 32 224C32 118 118 32 224 32s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9c1.6-7.1 4.3-13.9 8.1-20.3c2.1-3.5 4.5-6.7 7-9.7c-19-20.1-30.6-47.1-30.6-76.9c0-61.9 50.1-112 112-112s112 50.1 112 112c0 29.8-11.6 56.8-30.6 76.9c2.5 2.9 4.9 6.1 7 9.7c3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zM224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM209.5 478.2c-3.6-13.6-8.6-37.7-12.7-63c-4.3-26.4-7.3-51.3-7.3-65.7c0-4.3 .9-5.8 1.1-6.1c.2-.3 .7-1.2 2.8-2.3c5.2-2.9 15.3-5.1 30.7-5.1s25.5 2.2 30.7 5.1c2.1 1.1 2.6 2 2.8 2.3c.2 .3 1.1 1.8 1.1 6.1c0 14.3-2.9 39.2-7.3 65.6c-4.1 25.2-9.1 49.4-12.8 63.1c-1 .4-2.5 .8-4.9 1.2c-2.7 .4-5.9 .6-9.7 .6s-7-.2-9.7-.6c-2.3-.4-3.9-.8-4.9-1.2zm-30.6 9.5c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2c0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2z'
      
    ]
  };

  

  
  

  var faCalendarUsers = {
    prefix: 'fal',
    iconName: 'calendar-users',
    icon: [
      640,
      512,
      [],
      'e5e2',
      
      'M208 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32-16 0-16 0-384 0-16 0-16 0 0-32 0-32c0-35.3 28.7-64 64-64l32 0 0-48c0-8.8 7.2-16 16-16zm39.4 512c5.4-9.4 8.6-20.3 8.6-32l128 0c0 11.7 3.1 22.6 8.6 32l-145.1 0zM480 96L160 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zm48 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM480 448c-17.7 0-32 14.3-32 32l160 0c0-17.7-14.3-32-32-32l-96 0zm-64 32c0-35.3 28.7-64 64-64l48 0 48 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zM160 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 304a80 80 0 1 1 160 0A80 80 0 1 1 32 304zm0 176l160 0c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm32-64l48 0 48 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSquareEllipsisVertical = {
    prefix: 'fal',
    iconName: 'square-ellipsis-vertical',
    icon: [
      448,
      512,
      [],
      'e26f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faClockTwo = {
    prefix: 'fal',
    iconName: 'clock-two',
    icon: [
      512,
      512,
      [],
      'e35a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 114.1 71.1-47.4c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSquareC = {
    prefix: 'fal',
    iconName: 'square-c',
    icon: [
      448,
      512,
      [],
      'e266',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm156.1 92.1c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-37.5-37.5-98.3-37.5-135.8 0z'
      
    ]
  };

  

  
  

  var faSquareH = {
    prefix: 'fal',
    iconName: 'square-h',
    icon: [
      448,
      512,
      ["h-square"],
      'f0fd',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm336 48l0 112 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-160 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96 160 0 0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faHSquare = faSquareH;
  

  
  

  var faBookCopy = {
    prefix: 'fal',
    iconName: 'book-copy',
    icon: [
      576,
      512,
      [],
      'e0be',
      
      'M224 64c0-17.7 14.3-32 32-32l272 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-272 0c-11.7 0-22.6 3.1-32 8.6L224 64zm-32 0l0 288c0 35.3 28.7 64 64 64l272 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-224c0-26.5-21.5-48-48-48L256 0c-35.3 0-64 28.7-64 64zm64 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0 0 64-256 0zm96 96l0-32-32 0 0 32L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l120.4 0c-8.3-9.2-14.8-20.1-19-32L64 384c-11.7 0-22.6 3.1-32 8.6L32 160c0-17.7 14.3-32 32-32l96 0 0-32L64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l272 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0z'
      
    ]
  };

  

  
  

  var faBed = {
    prefix: 'fal',
    iconName: 'bed',
    icon: [
      640,
      512,
      [128716],
      'f236',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 336l0 64 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 576 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-64 0-96c0-61.9-50.1-112-112-112l-224 0c-26.5 0-48 21.5-48 48l0 144L32 320 32 48zM608 384L32 384l0-32 240 0 336 0 0 32zm0-144l0 80-320 0 0-144c0-8.8 7.2-16 16-16l224 0c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPersonFairy = {
    prefix: 'fal',
    iconName: 'person-fairy',
    icon: [
      640,
      512,
      [],
      'e608',
      
      'M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM297.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C244.1 304 258.8 320 277.6 320l84.9 0c18.7 0 33.4-16 31.9-34.7L390.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0zm0-32l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L384 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7c-10.1 4.2-19.4 9.9-27.7 16.8C179.5 98.7 109.8 64 32 64l0 48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5c6.8 5.3 8.1 15 3 22l-9.1 12.4C108.5 373.6 96 409.3 96 448l16 0c42.5 0 81.6-15.1 112-40.2l0 39.5C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM413.5 153.5c-8.3-6.9-17.7-12.5-27.7-16.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0c-41.2 0-79.7-12-112-32.7l0-39.5c30.4 25.1 69.5 40.2 112 40.2l16 0c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4c-5.1-7-3.7-16.7 3-22l12.1-9.5C572.3 256.6 608 188.5 608 112l0-48c-77.8 0-147.5 34.7-194.5 89.5z'
      
    ]
  };

  

  
  

  var faMedal = {
    prefix: 'fal',
    iconName: 'medal',
    icon: [
      512,
      512,
      [127941],
      'f5a2',
      
      'M106.4 191.5c7.5-7.8 15.6-14.9 24.2-21.4L38.5 32l103.4 0 61.6 102.7c10.9-2.8 22.2-4.8 33.8-5.9l-68-113.3C163.5 5.9 153.1 0 141.9 0L24.6 0C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6L106.4 191.5zm168.3-62.7c11.6 1 22.9 3 33.8 5.9L370.1 32l103.4 0L381.5 170.1c8.6 6.5 16.7 13.7 24.2 21.4L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0L370.1 0c-11.2 0-21.7 5.9-27.4 15.5l-68 113.3zM256 192a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm38.8-229.5l-17.3-35.1c-8.8-17.8-34.2-17.8-43 0l-17.3 35.1-38.7 5.6c-19.7 2.9-27.5 27.1-13.3 40.9l28 27.3L186.5 395c-3.4 19.6 17.2 34.6 34.8 25.3L256 402.1l34.6 18.2c17.6 9.3 38.2-5.7 34.8-25.3l-6.6-38.6 28-27.3c14.2-13.9 6.4-38.1-13.3-40.9l-38.7-5.6zM244 300.5l12-24.3 12 24.3c3.5 7.1 10.3 12 18.1 13.1l26.8 3.9-19.4 18.9c-5.7 5.5-8.2 13.5-6.9 21.2l4.6 26.7-24-12.6c-7-3.7-15.3-3.7-22.3 0l-24 12.6 4.6-26.7c1.3-7.8-1.2-15.7-6.9-21.2l-19.4-18.9 26.8-3.9c7.8-1.1 14.6-6 18.1-13.1z'
      
    ]
  };

  

  
  

  var faTemperatureArrowUp = {
    prefix: 'fal',
    iconName: 'temperature-arrow-up',
    icon: [
      576,
      512,
      ["temperature-up"],
      'e040',
      
      'M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L112 96zM176 0C123 0 80 43 80 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L272 96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-210c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM420.7 36.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6 416 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faTemperatureUp = faTemperatureArrowUp;
  

  
  

  var faFileCircleXmark = {
    prefix: 'fal',
    iconName: 'file-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e5a1',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faTruckDroplet = {
    prefix: 'fal',
    iconName: 'truck-droplet',
    icon: [
      640,
      512,
      [],
      'e58c',
      
      'M352 32c17.7 0 32 14.3 32 32l0 320-133.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l288 0zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-148.2c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352zM416 128l65.3 0c4.7 0 9.1 2 12.1 5.6L570.9 224 416 224l0-96zm0 216.4l0-88.4 160 0 0 128-5.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM256 211c0 23.7-20.3 45-48 45s-48-21.3-48-45c0-1.7 .9-7.2 5-17.4c3.9-9.5 9.5-20.4 16.1-32.1c8.5-14.8 18.1-29.7 26.8-42.6c8.7 12.8 18.4 27.8 26.8 42.6c6.7 11.6 12.3 22.6 16.1 32.1c4.1 10.2 5 15.7 5 17.4zm32 0c0-32-45.2-98.9-67.6-130.2c-6.1-8.6-18.6-8.6-24.8 0C173.2 112.1 128 179 128 211c0 42.5 35.8 77 80 77s80-34.5 80-77z'
      
    ]
  };

  

  
  

  var faDrone = {
    prefix: 'fal',
    iconName: 'drone',
    icon: [
      512,
      512,
      [],
      'f85f',
      
      'M112 32c39.6 0 72.5 28.8 78.9 66.6c1.5 8.7 9.7 14.6 18.4 13.1s14.6-9.7 13.1-18.4C213.6 40.4 167.5 0 112 0C50.1 0 0 50.1 0 112c0 55.5 40.4 101.6 93.4 110.5c8.7 1.5 17-4.4 18.4-13.1s-4.4-17-13.1-18.4C60.8 184.5 32 151.6 32 112c0-44.2 35.8-80 80-80zm286.7 0c44.2 0 80 35.8 80 80c0 39.6-28.8 72.5-66.6 78.9c-8.7 1.5-14.6 9.7-13.1 18.4s9.7 14.6 18.4 13.1c53-8.9 93.4-54.9 93.4-110.5c0-61.9-50.1-112-112-112C343.2 0 297.1 40.4 288.2 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C326.1 60.8 359 32 398.7 32zM32 398.7c0-39.6 28.8-72.5 66.6-78.9c8.7-1.5 14.6-9.7 13.1-18.4s-9.7-14.6-18.4-13.1C40.4 297.1 0 343.2 0 398.7c0 61.9 50.1 112 112 112c55.5 0 101.6-40.4 110.5-93.4c1.5-8.7-4.4-17-13.1-18.4s-17 4.4-18.4 13.1c-6.3 37.8-39.3 66.6-78.9 66.6c-44.2 0-80-35.8-80-80zm366.7 80c-39.6 0-72.5-28.8-78.9-66.6c-1.5-8.7-9.7-14.6-18.4-13.1s-14.6 9.7-13.1 18.4c8.9 53 54.9 93.4 110.5 93.4c61.9 0 112-50.1 112-112c0-55.5-40.4-101.6-93.4-110.5c-8.7-1.5-17 4.4-18.4 13.1s4.4 17 13.1 18.4c37.8 6.3 66.6 39.3 66.6 78.9c0 44.2-35.8 80-80 80zM112 432c17.7 0 32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3L182.6 352l146.7 0 39.7 39.7c-.7 2.6-1.1 5.4-1.1 8.3c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32c-2.9 0-5.6 .4-8.3 1.1L352 329.4l0-146.7 39.7-39.7c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L329.4 160l-146.7 0-39.7-39.7c.7-2.6 1.1-5.4 1.1-8.3c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c2.9 0 5.6-.4 8.3-1.1L160 182.6l0 146.7-39.7 39.7c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-112l0-128 128 0 0 128-128 0z'
      
    ]
  };

  

  
  

  var faDiceD20 = {
    prefix: 'fal',
    iconName: 'dice-d20',
    icon: [
      512,
      512,
      [],
      'f6cf',
      
      'M217.5 56.4L77.9 140.2l61.4 44.7L217.5 56.4zM64 169.6l0 150.7 59.2-107.6L64 169.6zM104.8 388L240 469.1l0-70.3L104.8 388zM272 469.1L407.2 388 272 398.8l0 70.3zM448 320.3l0-150.7-59.2 43L448 320.3zM434.1 140.2L294.5 56.4l78.2 128.4 61.4-44.7zM243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6l0 224c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368l0-224c0-8.4 4.4-16.2 11.7-20.6l200-120zM225.3 365.5L145 239.4 81.9 354l143.3 11.5zM338.9 224l-165.7 0L256 354.2 338.9 224zM256 54.8L172.5 192l167.1 0L256 54.8zm30.7 310.7L430.1 354 367 239.4 286.7 365.5z'
      
    ]
  };

  

  
  

  var faBeerMug = {
    prefix: 'fal',
    iconName: 'beer-mug',
    icon: [
      512,
      512,
      ["beer-foam"],
      'e0b3',
      
      'M208 0c-26.3 0-50.2 10.6-67.6 27.8c0 0 0 0 0 0s0 0 0 0c0 0-.1 .1-.2 .1c-.2 .1-.4 .2-.8 .2c-.7 .1-1.3-.1-1.6-.3C125.7 20.3 111.3 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c15.3 0 29.7-4.3 41.9-11.8c.3-.2 .8-.4 1.6-.3c.3 0 .6 .1 .8 .2c.1 0 .1 .1 .2 .1c0 0 0 0 0 0s0 0 0 0C157.8 181.4 181.7 192 208 192s50.2-10.6 67.6-27.8c0 0 0 0 0 0s0 0 0 0l.1 0 .1 0c.2-.1 .4-.2 .8-.2c.7-.1 1.3 .1 1.6 .3c12.2 7.5 26.6 11.8 41.9 11.8c44.2 0 80-35.8 80-80s-35.8-80-80-80c-15.3 0-29.7 4.3-41.9 11.8c-.3 .2-.8 .4-1.6 .3c-.3 0-.6-.1-.8-.2c-.1 0-.1-.1-.2-.1c0 0 0 0 0 0s0 0 0 0C258.2 10.6 234.3 0 208 0zM163 50.5C174.5 39.1 190.4 32 208 32s33.5 7.1 45 18.5c11.3 11.2 29 12.4 41.8 4.5c7.3-4.5 15.9-7.1 25.1-7.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-9.2 0-17.8-2.6-25.1-7.1c-12.8-7.9-30.5-6.7-41.8 4.5c-11.6 11.5-27.5 18.5-45 18.5s-33.5-7.1-45-18.5c-11.3-11.2-29-12.4-41.8-4.5c-7.3 4.5-15.9 7.1-25.1 7.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.2 0 17.8 2.6 25.1 7.1c12.8 7.9 30.5 6.7 41.8-4.5zM32 187.9L32 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-13.5 80.1-35c29.1-12.7 47.9-41.5 47.9-73.3l0-54.1c0-44.2-35.8-80-80-80l-48 0 0-4.1c-9.7 6.7-20.4 12-32 15.4l0 220.3c0 .2 0 .5 0 .7l0 23.6c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-244.6c-11.6-3.4-22.3-8.7-32-15.4zM208 224c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zm224 0c26.5 0 48 21.5 48 48l0 54.1c0 19.1-11.3 36.3-28.8 44L384 399.5 384 224l48 0zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z'
      
    ]
  };

  
    var faBeerFoam = faBeerMug;
  

  
  

  var faFileHeart = {
    prefix: 'fal',
    iconName: 'file-heart',
    icon: [
      384,
      512,
      [],
      'e176',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm61.7 306.8c0-11.9 9.6-21.5 21.5-21.5l1.5 0c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5l1.5 0c11.9 0 21.5 9.6 21.5 21.5c0 5.8-2.3 11.4-6.5 15.4L192 380.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0z'
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fal',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faHandBackPointLeft = {
    prefix: 'fal',
    iconName: 'hand-back-point-left',
    icon: [
      512,
      512,
      [],
      'e19f',
      
      'M0 168c0-30.9 25.1-56 56-56l200.6 0c2-3.2 4.2-6.4 6.5-9.5L280 80c15.1-20.1 38.8-32 64-32l19.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L512 336c0 61.9-50.1 112-112 112l-8 0-88 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-5.3 .7-10.5 1.9-15.5c-20.2-10.8-33.9-32-33.9-56.5c0-8.5 1.7-16.6 4.7-24L56 224c-30.9 0-56-25.1-56-56zm56-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l157.5 0c7.1 0 13.3 4.6 15.3 11.4s-.6 14-6.5 18c-8.7 5.8-14.3 15.6-14.3 26.7c0 15.6 11.2 28.6 25.9 31.4c5.1 1 9.5 4.4 11.6 9.2s1.8 10.3-.9 14.8c-2.9 4.8-4.6 10.5-4.6 16.6c0 14.7 10 27.2 23.6 30.9c4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8 .6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8c0 17.7 14.3 32 32 32l88 0 8 0c44.2 0 80-35.8 80-80l0-135.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C442.6 102.6 404.7 80 363.5 80L344 80c-15.1 0-29.3 7.1-38.4 19.2L296 112l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-78.3 0-1.7 0L56 144z'
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fal',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      'M16 64c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 80c0-8.8 7.2-16 16-16zm203.3 84.7c6.2 6.2 6.2 16.4 0 22.6L150.6 240l338.7 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L489.4 272l-338.7 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM640 80l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBluetooth = {
    prefix: 'fal',
    iconName: 'bluetooth',
    icon: [
      384,
      512,
      [],
      'f293',
      
      'M185.4 1.4c5.7-2.6 12.5-1.5 17.2 2.6l144 128c3.6 3.2 5.5 7.7 5.4 12.5s-2.4 9.2-6.2 12.1L218.1 256l127.8 99.4c3.8 2.9 6 7.4 6.2 12.1s-1.8 9.3-5.4 12.5l-144 128c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6l0-207.3L57.8 380.6c-7 5.4-17 4.2-22.5-2.8s-4.2-17 2.8-22.5L165.9 256 38.2 156.6c-7-5.4-8.2-15.5-2.8-22.5s15.5-8.2 22.5-2.8L176 223.3 176 16c0-6.3 3.7-12 9.4-14.6zM208 288.7l0 171.7 103-91.6L208 288.7zm0-65.4l103-80.1L208 51.6l0 171.7z'
      
    ]
  };

  

  
  

  var faChartSimpleHorizontal = {
    prefix: 'fal',
    iconName: 'chart-simple-horizontal',
    icon: [
      448,
      512,
      [],
      'e474',
      
      'M416 240c0-8.8-7.2-16-16-16L48 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-32zm32 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM224 400c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-32zm32 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zm96-320l0-32c0-8.8-7.2-16-16-16L48 64c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16zm-16 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faMountainSun = {
    prefix: 'fal',
    iconName: 'mountain-sun',
    icon: [
      640,
      512,
      [],
      'e52f',
      
      'M608 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80zM456.1 480c13.2 0 23.9-10.7 23.9-23.9c0-4.5-1.3-8.9-3.7-12.7L259.6 98c-.8-1.3-2.2-2-3.6-2s-2.9 .8-3.6 2L35.7 443.4c-2.4 3.8-3.7 8.2-3.7 12.7C32 469.3 42.7 480 55.9 480l400.2 0zM55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1l-122.8 0L55.9 512zm447.5-85.6c5.6 8.9 8.6 19.2 8.6 29.7c0 8.6-1.9 16.7-5.4 23.9l72.2 0c16.1 0 29.1-13 29.1-29.1c0-5.3-1.5-10.6-4.3-15.2L480 232.9 431.7 312l71.7 114.3z'
      
    ]
  };

  

  
  

  var faCabin = {
    prefix: 'fal',
    iconName: 'cabin',
    icon: [
      512,
      512,
      [],
      'e46d',
      
      'M237.1 10c11.3-8.3 26.6-8.3 37.8 0L352 66.6 352 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 104-.6 0 13 9.6c12.3 9 19.6 23.3 19.6 38.6c0 21.4-14 39.5-33.3 45.6c.9 3.3 1.3 6.7 1.3 10.2l0 16c0 9-3 17.3-8 24c5 6.7 8 15 8 24l0 16c0 9-3 17.3-8 24c5 6.7 8 15 8 24l0 16c0 9-3 17.3-8 24c5 6.7 8 15 8 24l0 16c0 22.1-17.9 40-40 40l-80 0c-22.1 0-40-17.9-40-40l0-16c0-9 3-17.3 8-24c-5-6.7-8-15-8-24l0-16c0-9 3-17.3 8-24c-5-6.7-8-15-8-24l0-16c0-9 3-17.3 8-24c-5-6.7-8-15-8-24l0-16c0-2.7 .3-5.4 .8-8l-129.6 0c.5 2.6 .8 5.3 .8 8l0 16c0 9-3 17.3-8 24c5 6.7 8 15 8 24l0 16c0 9-3 17.3-8 24c5 6.7 8 15 8 24l0 16c0 9-3 17.3-8 24c5 6.7 8 15 8 24l0 16c0 22.1-17.9 40-40 40l-80 0c-22.1 0-40-17.9-40-40l0-16c0-9 3-17.3 8-24c-5-6.7-8-15-8-24l0-16c0-9 3-17.3 8-24c-5-6.7-8-15-8-24l0-16c0-9 3-17.3 8-24c-5-6.7-8-15-8-24l0-16c0-3.5 .5-7 1.3-10.2C14 247.6 0 229.5 0 208.1c0-15.2 7.3-29.6 19.6-38.6L237.1 10zM360 416l80 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8zm80 32l-80 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8zm8-104l0-16c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8zM360 224l80 0 24.1 0c8.8 0 15.9-7.1 15.9-15.9c0-5.1-2.4-9.8-6.5-12.8L256 35.8 38.5 195.4c-4.1 3-6.5 7.7-6.5 12.8c0 8.8 7.1 15.9 15.9 15.9L72 224l80 0 208 0zm0 32c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-80 0zM72 416l80 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8zm80 32l-80 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8zm8-104l0-16c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8zM72 256c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-80 0zM448 137l0-73-64 0 0 26L448 137zm-192-9a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fal',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e12e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM172.1 133.6c-5.8-6.7-15.9-7.5-22.6-1.7s-7.5 15.9-1.7 22.6L234.9 256 147.9 357.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7L256 280.6l83.9 97.8c5.8 6.7 15.8 7.5 22.6 1.7s7.5-15.8 1.7-22.6L277.1 256l87.1-101.6c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7L256 231.4l-83.9-97.8z'
      
    ]
  };

  

  
  

  var faFamilyDress = {
    prefix: 'fal',
    iconName: 'family-dress',
    icon: [
      512,
      512,
      [],
      'e301',
      
      'M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 64l31.4 0c11.5 0 21.8 6.1 27.5 15.6c-2.1-7.5-3.2-15.4-3.2-23.6c0-6.3 .7-12.5 1.9-18.4c-8.1-3.6-16.9-5.6-26.2-5.6l-31.4 0c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 49.6 0c-1-5.2-1.6-10.5-1.6-16l0-16L42.4 352 81.5 215.2C85.4 201.5 98 192 112.3 192zM366.4 384l49.6 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-9.3 0-18.1 2-26.2 5.6c1.3 5.9 1.9 12.1 1.9 18.4c0 8.2-1.1 16.1-3.2 23.6c5.7-9.5 16-15.6 27.5-15.6l31.4 0c14.3 0 26.8 9.5 30.8 23.2L469.6 352 368 352l0 16c0 5.5-.6 10.8-1.6 16zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c26.5 0 48 21.5 48 48l0 32c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-32c0-26.5 21.5-48 48-48zM208 413.3l0 82.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-82.7c18.6-6.6 32-24.4 32-45.3l0-32c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 32c0 20.9 13.4 38.7 32 45.3z'
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fal',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      'M256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5C14.4 191.9 0 206.3 0 224L0 432c0 17.7 14.4 31.9 32 32.7c114.9 4.7 186.9 33.7 208.8 43.8c4.8 2.2 9.9 3.5 15.1 3.5s10.4-1.3 15.1-3.5c21.9-10.1 93.9-39.1 208.8-43.8c17.7-.7 32-15 32-32.7l0-208c0-17.7-14.4-32.1-32-31.5C312.8 197.4 256 240 256 240zm-18.9 25.8L240 268l0 205.3c-34-13.8-104.4-36.4-206.7-40.6c-.5 0-.9-.2-1.2-.5c-.1-.1-.1-.1-.1-.2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0-207.5c80.5 2.4 133.2 13.9 164.9 24.1c15.9 5.1 26.7 9.9 33 13.2c3.2 1.6 5.3 2.9 6.4 3.6c.4 .3 .7 .5 .9 .6zM272 268l2.9-2.2c.1-.1 .4-.3 .9-.6c1.1-.7 3.2-1.9 6.4-3.6c6.3-3.3 17-8.1 33-13.2c31.8-10.2 84.5-21.6 164.9-24.1L480 432s0 0 0 0c0 0 0 0 0 .1c0 0-.1 .1-.1 .1c-.3 .3-.7 .5-1.2 .5C376.4 436.9 306 459.5 272 473.3L272 268z'
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faMicrophoneStand = {
    prefix: 'fal',
    iconName: 'microphone-stand',
    icon: [
      512,
      512,
      [127908],
      'f8cb',
      
      'M449.5 186.9L325.1 62.5l4.7-4.7c34.4-34.4 90.1-34.4 124.4 0s34.4 90.1 0 124.5l-4.7 4.7zm-22.6 22.6l-4.7 4.7c-17.5 17.5-40.6 26.1-63.6 25.8L272 153.4c-.4-23 8.2-46.1 25.8-63.6l4.7-4.7L426.9 209.5zM358.3 272c31.3 .4 62.7-11.3 86.5-35.1l4.7-4.7 11.3-11.3 11.3-11.3 4.7-4.7c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-4.7 4.7L291.1 51.1 279.8 62.5l-4.7 4.7C251.3 91 239.6 122.4 240 153.7L15 393.7c-9.6 10.3-15 23.9-15 38c0 14.7 5.8 28.8 16.3 39.3l24.8 24.8C51.5 506.2 65.6 512 80.4 512c14.1 0 27.7-5.4 38-15L256 367.9 256 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-158.1L358.3 272zM96.5 473.6c-4.4 4.1-10.1 6.4-16.1 6.4c-6.2 0-12.2-2.5-16.6-6.9L38.9 448.3c-4.4-4.4-6.9-10.4-6.9-16.6c0-6 2.3-11.7 6.4-16.1L256.4 183 329 255.6 96.5 473.6z'
      
    ]
  };

  

  
  

  var faUserHairMullet = {
    prefix: 'fal',
    iconName: 'user-hair-mullet',
    icon: [
      448,
      512,
      ["business-front","party-back","trian-balbot"],
      'e45c',
      
      'M320 144c0 53-43 96-96 96s-96-43-96-96l0-16c0-5.5 .5-10.8 1.3-16l11.3 0c32.1 0 62.3-13.7 83.4-37.2c21.1 23.5 51.3 37.2 83.4 37.2l11.3 0c.9 5.2 1.3 10.5 1.3 16l0 16zM97.2 110.5c-.8 5.7-1.2 11.6-1.2 17.5l0 16c0 15.6 2.8 30.6 7.9 44.5c-.7 26.5-7.7 46.3-21.3 66.6c-2.5 3.8-3.3 8.5-2.2 13s4.2 8.2 8.3 10.2l16 8c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-.6-.3c4.6-8.7 8.3-17.6 11.1-26.9c5.7 6.3 12.1 12 19 17l-11.8 35.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l10-29.9c14.5 5.7 30.3 8.8 46.9 8.8s32.3-3.1 46.9-8.8l10 29.9c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-11.8-35.5c6.9-5 13.2-10.7 19-17c2.8 9.3 6.5 18.2 11.1 26.9l-.6 .3c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l16-8c4.1-2.1 7.1-5.8 8.3-10.2s.4-9.2-2.2-13c-13.5-20.3-20.6-40.2-21.3-66.6c5.1-13.9 7.9-28.8 7.9-44.5l0-16c0-5.9-.4-11.8-1.2-17.5c5.4-2.6 9.2-8.1 9.2-14.5c0-8.8-7.2-16-16-16l-1.3 0c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80L104 80c-8.8 0-16 7.2-16 16c0 6.4 3.8 11.9 9.2 14.5zM140.8 80c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48c-26.7-.1-51.5-13.4-66.3-35.6l-3.5-5.3c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-3.5 5.3C192.4 66.6 167.5 79.9 140.8 80zm22.7 272l120.9 0c71.5 0 129.6 57 131.5 128L32 480c1.9-71 60-128 131.5-128zm0-32C73.2 320 0 393.2 0 483.6C0 499.3 12.7 512 28.4 512l391.1 0c15.7 0 28.4-12.7 28.4-28.4C448 393.2 374.8 320 284.4 320l-120.9 0z'
      
    ]
  };

  
    var faBusinessFront = faUserHairMullet;
  
    var faPartyBack = faUserHairMullet;
  
    var faTrianBalbot = faUserHairMullet;
  

  
  

  var faPodiumStar = {
    prefix: 'fal',
    iconName: 'podium-star',
    icon: [
      448,
      512,
      [],
      'f758',
      
      'M224 32l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L224 0c-20.9 0-38.7 13.4-45.3 32L168 32c-44.2 0-80 35.8-80 80l0 48-72 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-312 0 0-48c0-26.5 21.5-48 48-48l10.7 0c6.6 18.6 24.4 32 45.3 32zM47.3 224L73.5 455.2c3.7 32.3 31 56.8 63.6 56.8l173.7 0c32.5 0 59.9-24.4 63.6-56.8L400.7 224l-32.2 0L342.7 451.6c-1.8 16.2-15.5 28.4-31.8 28.4l-173.7 0c-16.3 0-30-12.2-31.8-28.4L79.5 224l-32.2 0zm214.2 58.8l-16.2-36.8c-8.2-18.6-34.2-18.6-42.4 0l-16.2 36.8-38.2 4.7c-20.5 2.5-26.6 27.4-13.2 40.4l28.7 27.8L156.2 396c-3.4 18 15.6 35.9 34.4 24.8L224 401.3l33.4 19.6c18.8 11 37.8-6.9 34.4-24.8l-7.6-40.3 28.7-27.8c13.4-13 7.3-37.9-13.2-40.4l-38.2-4.7zm-47.5 17.4l10.1-23 10.1 23c3.2 7.3 10 12.7 18.4 13.8l25.5 3.2-19.4 18.7c-5.8 5.6-8.2 13.8-6.8 21.5l5 26.1L235.6 371c-7.2-4.2-16-4.2-23.2 0l-21.2 12.4 5-26.1c1.5-7.7-1-15.9-6.8-21.5L170 317.1l25.5-3.2c8.3-1 15.2-6.5 18.4-13.8z'
      
    ]
  };

  

  
  

  var faUserTieHair = {
    prefix: 'fal',
    iconName: 'user-tie-hair',
    icon: [
      448,
      512,
      [],
      'e45f',
      
      'M320 128l0 16c0 53-43 96-96 96s-96-43-96-96l0-16 34.3 0c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4l30.1 0c.9 5.2 1.3 10.5 1.3 16zM228.7 52.7c-1.3 1.3-2.4 2.8-3.1 4.5C213.5 81 189.1 96 162.3 96l-28.9 0c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48l-18.6 0c-6.4 0-12.5-2.5-17-7L251.3 52.7c-6.2-6.2-16.4-6.2-22.6 0zM96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l9.8 0-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-79-56.8-144.7-131.8-158.6c-6.8-1.3-13.4 2.5-16.3 8.8L267.9 401l-21.7-65 9.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0-32 0zm17.5 160.5l-9.7-21.1L224 370.6l24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3 .7 .7 1.4 1 2.1L32 480c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480l-149.4 0c.3-.7 .7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z'
      
    ]
  };

  

  
  

  var faHandHoldingHand = {
    prefix: 'fal',
    iconName: 'hand-holding-hand',
    icon: [
      576,
      512,
      [],
      'e4f7',
      
      'M425 226.6c-13.1 8.8-28.6 13.4-44.4 13.4L232 240c-30.9 0-56-25.1-56-56c0-8.6 1.9-16.7 5.4-24l-5.6 0L81.1 216.4c-8.3 4.9-17.8 7.6-27.5 7.6l-1.3 0C23.4 224 0 200.6 0 171.7c0-17.7 9-34.2 23.8-43.9L143.4 50.1c18.2-11.8 39.4-18.1 61-18.1L560 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L204.5 64c-15.5 0-30.6 4.5-43.6 12.9L41.2 154.7c-5.8 3.7-9.2 10.1-9.2 17c0 11.2 9.1 20.3 20.3 20.3l1.3 0c3.9 0 7.7-1.1 11.1-3l98.5-58.7c2.5-1.5 5.3-2.3 8.2-2.3l60.6 0 24 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l148.6 0c9.5 0 18.7-2.8 26.6-8.1l79.9-53.3c2.6-1.8 5.7-2.7 8.9-2.7l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-59.2 0L425 226.6zM151 285.4c13.1-8.8 28.6-13.4 44.4-13.4L344 272c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 461.9c-18.2 11.8-39.4 18.1-61 18.1L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 384l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 365.3c-2.6 1.8-5.7 2.7-8.9 2.7l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 285.4z'
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fal',
    iconName: 'car',
    icon: [
      512,
      512,
      [128664,"automobile"],
      'f1b9',
      
      'M113.6 98.2L85.3 192.6c3.5-.4 7.1-.6 10.7-.6l320 0c3.6 0 7.2 .2 10.7 .6L398.4 98.2c-6.1-20.3-24.8-34.2-46-34.2L159.6 64c-21.2 0-39.9 13.9-46 34.2zM74.3 227.8C49.6 236.7 32 260.3 32 288l0 96 448 0 0-96c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6L96 224c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3-.5-.1zm-26-23.1l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57l192.8 0c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 221.2 512 252.3 512 288l0 96 0 16 0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16 0-16 0-96c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faAutomobile = faCar;
  

  
  

  var faBoxBallot = {
    prefix: 'fal',
    iconName: 'box-ballot',
    icon: [
      576,
      512,
      [128499],
      'f735',
      
      'M160 32l0 192 256 0 0-192L160 32zm-32 0c0-17.7 14.3-32 32-32L416 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-192zM48 160l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 112 512 0 0-112c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c26.5 0 48 21.5 48 48l0 112 0 16 0 16 0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352l0-16 0-16L0 208c0-26.5 21.5-48 48-48zM544 352L32 352l0 112c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16l0-112z'
      
    ]
  };

  

  
  

  var faCircleS = {
    prefix: 'fal',
    iconName: 'circle-s',
    icon: [
      512,
      512,
      [],
      'e121',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.7 190c2-10.7 9.2-19.1 23.1-24.4c14.3-5.5 34.5-7.2 57.9-3.8c7 1 23.4 4.5 31 6.4c8.6 2.2 17.3-3 19.4-11.6s-3-17.3-11.6-19.4c-8.2-2.1-25.7-5.8-34.1-7c-26.9-4-53.1-2.6-74.1 5.6c-21.5 8.3-38.6 24.2-43.1 48.5c-2.5 13.9-1.2 26.6 4 37.7c5.2 11 13.6 19.1 23 25.2c17.5 11.5 41.3 18.1 62 23.8c0 0 0 0 0 0l1.5 .4c22.6 6.3 41.6 11.7 54.4 20.1c6 4 9.7 8 11.7 12.3c1.9 4.1 3 9.7 1.5 18.2c-2 10.7-9.2 19.1-23.1 24.4c-14.3 5.5-34.5 7.2-57.9 3.8c-14.3-2.2-41.3-10-56.4-14.8c-8.4-2.7-17.4 2-20.1 10.5s2 17.4 10.5 20.1c15 4.7 44.2 13.3 61.2 15.9c0 0 0 0 0 0c0 0 .1 0 .1 0c26.9 4 53.1 2.6 74.1-5.6c21.5-8.3 38.6-24.2 43.1-48.5c2.5-13.9 1.2-26.6-4-37.7c-5.2-11-13.6-19.1-23-25.2c-17.5-11.5-41.3-18.1-62-23.8l-1.5-.4c-22.6-6.3-41.6-11.7-54.4-20.1c-6-4-9.7-8-11.7-12.3c-1.9-4.1-3-9.7-1.5-18.2z'
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fal',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      'M64 64C46.3 64 32 78.3 32 96l0 32 512 0 0-32c0-17.7-14.3-32-32-32L64 64zM32 160l0 64 512 0 0-64L32 160zm0 96l0 160c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-160L32 256zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faBowlChopsticks = {
    prefix: 'fal',
    iconName: 'bowl-chopsticks',
    icon: [
      512,
      512,
      [],
      'e2e9',
      
      'M499.1 31.7l-480 96C10.5 129.4 2 123.8 .3 115.1S4.2 98 12.9 96.3l480-96c8.7-1.7 17.1 3.9 18.8 12.6s-3.9 17.1-12.6 18.8zM512 142.9c.6 8.8-6.1 16.4-14.9 17l-480 32c-8.8 .6-16.4-6.1-17-14.9s6.1-16.4 14.9-17l480-32c8.8-.6 16.4 6.1 17 14.9zM144.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4c3.3 9.4 12.2 16.1 22.7 16.1l144 0c10.4 0 19.4-6.7 22.7-16.1c2.8-8.1 8.7-14.7 16.5-18.4c61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9L50.9 256c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.2 23.3 224 50.9 224l410.2 0c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-5 84.1-55.9 155.1-127.5 189.2C373.3 496.3 352.5 512 328 512l-144 0c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8z'
      
    ]
  };

  

  
  

  var faBug = {
    prefix: 'fal',
    iconName: 'bug',
    icon: [
      512,
      512,
      [],
      'f188',
      
      'M256 32c-35.3 0-64 28.7-64 64l128 0c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6zM36.7 100.7c6.2-6.2 16.4-6.2 22.6 0L138.6 180c17.2-12.6 38.4-20 61.4-20l112 0c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4l0 8 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320l0-16-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-8c0-22.9 7.4-44.2 20-61.4L36.7 123.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127l0-191c0-8.8 7.2-16 16-16s16 7.2 16 16l0 191c63.1-7.9 112-61.7 112-127l0-32 0-24c0-39.8-32.2-72-72-72l-112 0c-39.8 0-72 32.2-72 72l0 24 0 32z'
      
    ]
  };

  

  
  

  var faHandsHoldingCircle = {
    prefix: 'fal',
    iconName: 'hands-holding-circle',
    icon: [
      640,
      512,
      [],
      'e4fb',
      
      'M416 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM64 64c35.3 0 64 28.7 64 64l0 124.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5L512 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6L608 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16s0 0 0 0l44-44s0 0 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3l0 77.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16s0 0 0 0l-44-44s0 0 0 0l-10.7-10.8C106.8 305.4 96 279.4 96 252.3L96 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2L0 128C0 92.7 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassWaveform = {
    prefix: 'fal',
    iconName: 'magnifying-glass-waveform',
    icon: [
      512,
      512,
      [],
      'e661',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z'
      
    ]
  };

  

  
  

  var faEnvelopeDot = {
    prefix: 'fal',
    iconName: 'envelope-dot',
    icon: [
      576,
      512,
      ["envelope-badge"],
      'e16f',
      
      'M448 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 416 80a80 80 0 1 0 160 0zM512 384l0-193.1c-5.2 .7-10.6 1.1-16 1.1c-13.8 0-27-2.5-39.2-7.1L284.4 311.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9 32 128c0-17.7 14.3-32 32-32l321.1 0c-.7-5.2-1.1-10.6-1.1-16s.4-10.8 1.1-16L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM32 207.6L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0L480 207.6 480 384c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-176.4z'
      
    ]
  };

  
    var faEnvelopeBadge = faEnvelopeDot;
  

  
  

  var faGlobeWifi = {
    prefix: 'fal',
    iconName: 'globe-wifi',
    icon: [
      640,
      512,
      [],
      'e685',
      
      'M256 480c16.7 0 40.4-14.4 61.9-57.3c2.3-4.6 4.6-9.5 6.7-14.6c3.4 14.5 8.6 28.4 15.3 41.3c-3.9 6.8-8.1 13.2-12.4 19c6.5-2.2 12.8-4.6 19-7.4c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7l-.5-1.7L380 192c1.7 13.2 2.9 26.8 3.5 40.7c-12 10-22.6 21.5-31.6 34.3c.1-3.6 .1-7.3 .1-11c0-22.3-1.5-43.8-4.3-64l-183.4 0c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64l162.3 0c-2.9 10.3-4.9 21-5.9 32L170 352c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM170 160l172 0c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm288.4 0c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3l83.8 0zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160l83.7 0zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64l90.8 0c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64l-90.8 0zM184.5 468.3c-21-28.3-37.5-68.8-47.2-116.3l-83.7 0c25.9 54.5 73.1 96.9 130.9 116.3zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 104c-23.6 0-45 8.9-61.3 23.5c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6C435.2 308 464.2 296 496 296s60.8 12 82.7 31.7c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C541.1 336.9 519.6 328 496 328zM476 432a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm-6.7-37.7c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6C460.6 359 477.5 352 496 352s35.4 7 48.1 18.5c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-7.1-6.4-16.4-10.3-26.7-10.3s-19.6 3.9-26.7 10.3z'
      
    ]
  };

  

  
  

  var faToolbox = {
    prefix: 'fal',
    iconName: 'toolbox',
    icon: [
      512,
      512,
      [129520],
      'f552',
      
      'M176 64l160 0c8.8 0 16 7.2 16 16l0 48-192 0 0-48c0-8.8 7.2-16 16-16zM128 80l0 48-21.5 0c-17 0-33.3 6.7-45.3 18.7L18.7 189.3C6.7 201.3 0 217.5 0 234.5L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-181.5c0-17-6.7-33.3-18.7-45.3l-42.5-42.5c-12-12-28.3-18.7-45.3-18.7L384 128l0-48c0-26.5-21.5-48-48-48L176 32c-26.5 0-48 21.5-48 48zm16 80l224 0 37.5 0c8.5 0 16.6 3.4 22.6 9.4l42.5 42.5c6 6 9.4 14.1 9.4 22.6l0 85.5-128 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-128 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32L32 320l0-85.5c0-8.5 3.4-16.6 9.4-22.6l42.5-42.5c6-6 14.1-9.4 22.6-9.4l37.5 0zM32 352l128 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 128 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 128 0 0 64c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64z'
      
    ]
  };

  

  
  

  var faPersonThroughWindow = {
    prefix: 'fal',
    iconName: 'person-through-window',
    icon: [
      640,
      512,
      [],
      'e5a9',
      
      'M48 32c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l80 0 0-70.4c0-70.6 41.2-134.7 105.3-164.1c52.8-24.2 86.7-77 86.7-135.1L320 32 48 32zM352 46.4c0 63.8-33.6 122.3-87.4 154.7L328.1 288l64.5 0c9.3 0 18.2 4.1 24.3 11.2l91.2 106.4 8.9 10.4 74.9 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16L352 32l0 14.4zM367 416l107.9 0-82.3-96-51.3 0-54 40.5 93.5 126c5.3 7.1 3.8 17.1-3.3 22.4s-17.1 3.8-22.4-3.3L312.5 448 48 448c-26.5 0-48-21.5-48-48L0 48C0 21.5 21.5 0 48 0L592 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-201.5 0L367 416zm-98.7-81.2l35.1-26.3-67.6-92.4c-13.2 7.4-25.1 16.7-35.2 27.5l67.7 91.2zm-87.8-64.6c-13.2 22.4-20.6 48.3-20.6 75.4l0 70.4 128.7 0L180.6 270.2zM168 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 88 136z'
      
    ]
  };

  

  
  

  var faBells = {
    prefix: 'fal',
    iconName: 'bells',
    icon: [
      640,
      512,
      [],
      'f77f',
      
      'M282.6 40.1C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c2.6-9.1 4.4-18.4 5.4-27.7l-226-82.3 8.2-5.4c40.3-26.5 71.1-65.2 87.7-110.4l14.7-40c18.7-51 74.5-77.7 125.7-60.9c8.4-8.6 17.7-16.3 27.9-23c-4.5-2.2-9.1-4.2-13.9-6zm71.1 48.4c54.8-19.9 115.4 8.3 135.5 63L508 202.6c16.3 44.6 46.4 82.8 85.9 109.2l13.7 9.2s0 0 0 0L310.1 429.3l4.6-15.8c13.1-45.6 11.3-94.1-5-138.7l-18.8-51.2c-20.1-54.7 8.1-115.2 62.8-135.2zm165.5 52C493.2 69.2 414.1 32.5 342.8 58.4s-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2zM434.8 437.6c-6.7 5.8-7.4 15.9-1.6 22.6C450.5 480.1 479 488 505 477.8s41.5-35.5 40.5-61.8c-.3-8.8-7.7-15.7-16.6-15.4s-15.7 7.7-15.4 16.6c.5 13.2-7.3 25.8-20.3 30.9s-27.2 1.2-35.9-8.8c-5.8-6.7-15.9-7.4-22.6-1.6zM179.9 406.7c-8.7 10-23 13.9-35.9 8.8s-20.7-17.7-20.3-30.9c.3-8.8-6.6-16.2-15.4-16.6s-16.2 6.6-16.6 15.4c-.9 26.3 14.6 51.6 40.5 61.8s54.5 2.3 71.8-17.6c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6z'
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fal',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      'M176 64L80 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM80 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm96 288l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM80 288l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM336 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zM288 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm96 192c8.8 0 16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faKitMedical = {
    prefix: 'fal',
    iconName: 'kit-medical',
    icon: [
      576,
      512,
      ["first-aid"],
      'f479',
      
      'M128 448l320 0 0-384L128 64l0 384zm-32 0L96 64 64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l32 0zM64 32l32 0 16 0 16 0 320 0 16 0 16 0 32 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-32 0-16 0-16 0-320 0-16 0-16 0-32 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM480 448l32 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-32 0 0 384zM272 144l32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32zm0 32l0 48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-48 0 0 32 48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16l0-48-32 0z'
      
    ]
  };

  
    var faFirstAid = faKitMedical;
  

  
  

  var faChessPawn = {
    prefix: 'fal',
    iconName: 'chess-pawn',
    icon: [
      320,
      512,
      [9823],
      'f443',
      
      'M240 144A80 80 0 1 0 80 144a80 80 0 1 0 160 0zm16 112l-20.6 0L254 352l-32.6 0-18.6-96L160 256l-42.8 0L98.6 352 66 352l18.6-96L64 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l17.6 0C60.9 203.7 48 175.3 48 144C48 82.1 98.1 32 160 32s112 50.1 112 112c0 31.3-12.9 59.7-33.6 80l17.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4l241.1 0c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L254.2 416 65.8 416zm188.4-32c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4L39.4 512C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1l188.4 0z'
      
    ]
  };

  

  
  

  var faNfcSlash = {
    prefix: 'fal',
    iconName: 'nfc-slash',
    icon: [
      640,
      512,
      [],
      'e1fc',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM544 351.3L544 96c0-35.3-28.7-64-64-64L160 32c-6 0-11.9 .8-17.4 2.4L180.1 64 192 64l64 0 224 0c17.7 0 32 14.3 32 32l0 230 32 25.3zm-64-50.5L480 128c0-17.7-14.3-32-32-32L336 96c-17.7 0-32 14.3-32 32l0 33.8 32 25.3 0-59.1 112 0 0 147.5 32 25.3zM378.8 384L192 384l0-147.5-32-25.3L160 384c0 17.7 14.3 32 32 32l227.4 0-40.5-32zM128 186L96 160.7 96 416c0 35.3 28.7 64 64 64l320 0c6 0 11.9-.8 17.4-2.4L459.9 448 160 448c-17.7 0-32-14.3-32-32l0-230z'
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fal',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faAnchorCircleXmark = {
    prefix: 'fal',
    iconName: 'anchor-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4ac',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 256-32 0c-79.5 0-144-64.5-144-144l0-25.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6 64 336c0 97.2 78.8 176 176 176l48 0 48 0c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8l-32 0 0-256 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faTentDoublePeak = {
    prefix: 'fal',
    iconName: 'tent-double-peak',
    icon: [
      576,
      512,
      [],
      'e627',
      
      'M12.8 134.4l34.8-26.1c17.3-12.9 32.8-28 46.3-44.9L135 12c5.7-7.1 14.1-11.5 23.2-12s18 2.9 24.4 9.3l18.7 18.7c23 23 54.1 35.9 86.6 35.9s63.7-12.9 86.6-35.9L393.4 9.4c6.4-6.4 15.3-9.8 24.4-9.3s17.5 4.9 23.2 12l41.2 51.4c13.5 16.9 29 31.9 46.3 44.9l34.7 26.1c8.1 6 12.8 15.5 12.8 25.6l0 320c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32L0 160c0-10.1 4.7-19.6 12.8-25.6zm106-51c-15.2 19-32.7 35.9-52.1 50.5L32 160l0 32 512 0 0-32-34.7-26.1c-19.4-14.6-36.9-31.5-52.1-50.5L416 32 397.3 50.7C368.3 79.7 329 96 288 96s-80.3-16.3-109.3-45.3L160 32 118.8 83.4zM313.9 224l128 256L544 480l0-256-230.1 0zM272 224L32 224l0 256 240 0 0-256zm32 256l102.1 0L304 275.8 304 480z'
      
    ]
  };

  

  
  

  var faTicketsAirline = {
    prefix: 'fal',
    iconName: 'tickets-airline',
    icon: [
      640,
      512,
      ["tickets-perforated-plane","tickets-plane"],
      'e29b',
      
      'M128 96l0 224c0 17.7 14.3 32 32 32l416 0c17.7 0 32-14.3 32-32l0-47.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.8 40-64.5L608 96c0-17.7-14.3-32-32-32L160 64c-17.7 0-32 14.3-32 32zm484.1 45.6c.1 0 .1 0 .1 0s0 0 0 0c0 0 0 0-.1 0zm.1 132.9c0 0-.1 0-.1 0c.1 0 .1 0 .1 0zM160 32l416 0c35.3 0 64 28.7 64 64l0 56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1l0 56c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 96c8.8 0 16 7.2 16 16l0 256c0 44.2 35.8 80 80 80l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-416 0C50.1 480 0 429.9 0 368L0 112c0-8.8 7.2-16 16-16zm274.3 74.9c1.6 4.9 .8 10.2-2.2 14.4s-7.8 6.6-13 6.6l-45.3 0c-4.2 0-8.3-1.7-11.3-4.7L207.1 176 196 176l7.3 21.9c2.2 6.6 2.2 13.7 0 20.2L196 240l11.2 0 11.3-11.3c3-3 7.1-4.7 11.3-4.7l45.3 0c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L276 288l20 0c2.8 0 5.5-1.5 6.9-4l30.4-52.1c2.9-4.9 8.1-7.9 13.8-7.9l41.6 0c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13l-41.6 0c-5.7 0-11-3-13.8-7.9L302.9 132c-1.4-2.5-4.1-4-6.9-4l-20 0 14.3 42.9zM264.9 96L296 96c14.2 0 27.4 7.6 34.6 19.8l-13.8 8.1 13.8-8.1L356.3 160l32.4 0c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2C428.4 247.9 409 256 388.7 256l-32.4 0-25.8 44.2C323.4 312.4 310.2 320 296 320l-31.1 0c-16.4 0-27.9-16-22.8-31.6L252.9 256l-16.5 0-6.6 6.6c-6 6-14.1 9.4-22.6 9.4l-22.3 0c-16.4 0-27.9-16-22.8-31.6L172.9 208l-10.8-32.4c-5.2-15.5 6.4-31.6 22.8-31.6l22.3 0c8.5 0 16.6 3.4 22.6 9.4l6.6 6.6 16.5 0-10.8-32.4C236.9 112 248.5 96 264.9 96z'
      
    ]
  };

  
    var faTicketsPerforatedPlane = faTicketsAirline;
  
    var faTicketsPlane = faTicketsAirline;
  

  
  

  var faArrowRightLong = {
    prefix: 'fal',
    iconName: 'arrow-right-long',
    icon: [
      512,
      512,
      ["long-arrow-right"],
      'f178',
      
      'M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-144-144c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l441.4 0L340.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l144-144z'
      
    ]
  };

  
    var faLongArrowRight = faArrowRightLong;
  

  
  

  var faUserLock = {
    prefix: 'fal',
    iconName: 'user-lock',
    icon: [
      640,
      512,
      [],
      'f502',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM32 480c1.2-79.7 66.2-144 146.3-144l91.4 0c46.2 0 87.5 21.5 114.3 55l0-39c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32L32 480zM528 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faThumbsDown = {
    prefix: 'fal',
    iconName: 'thumbs-down',
    icon: [
      512,
      512,
      [61576,128078],
      'f165',
      
      'M288.8 430.3c3.5 12.8 16.7 20.3 29.5 16.8s20.3-16.7 16.8-29.5l-4.5-16.4c-5.5-20.2-13.9-39.3-24.7-56.9c-3.1-4.9-3.2-11.1-.4-16.2s8.2-8.2 14-8.2L448 320c17.7 0 32-14.3 32-32c0-11.3-5.9-21.3-14.8-27c-7.2-4.6-9.5-13.9-5.3-21.3c2.6-4.6 4.1-10 4.1-15.7c0-12.4-7-23.1-17.3-28.5c-4.2-2.2-7.3-6.1-8.3-10.8s.1-9.5 3-13.2c4.2-5.4 6.7-12.2 6.7-19.5c0-14.2-9.2-26.3-22.1-30.4c-7.8-2.5-12.4-10.6-10.7-18.6c.5-2.2 .7-4.5 .7-6.9c0-17.7-14.3-32-32-32l-89.5 0c-15.8 0-31.2 4.7-44.4 13.4l-38.5 25.7c-9 6-16.6 13.7-22.4 22.6c-4.9 7.4-14.8 9.4-22.2 4.6s-9.4-14.8-4.6-22.2c8.1-12.3 18.7-23.1 31.4-31.6l38.5-25.7c18.4-12.3 40-18.8 62.1-18.8L384 32c35.3 0 64 28.7 64 64l0 .6c19.1 11.1 32 31.7 32 55.4c0 8.7-1.8 17.1-4.9 24.7C487.9 188.4 496 205.2 496 224c0 6.5-1 12.8-2.8 18.7C504.8 254.3 512 270.3 512 288c0 35.3-28.7 64-64 64l-101.6 0c6.2 13.1 11.3 26.7 15.1 40.9l4.5 16.4c8.1 29.8-9.5 60.6-39.3 68.8s-60.6-9.5-68.8-39.3l-4.5-16.4c-8.9-32.6-29.6-60.8-58.2-79l-3.1-2 8.2-12.9-8.2 12.9c-11.8-7.5-21.7-17.1-29.5-28.2c-5.1-7.2-3.3-17.2 4-22.3s17.2-3.3 22.3 4c5.4 7.7 12.2 14.4 20.4 19.5l3.1 2c35.3 22.4 60.9 57.2 71.9 97.5l4.5 16.4zM32 352l64 0 0-224-64 0 0 224zM0 352L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faGripLines = {
    prefix: 'fal',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      'M448 192c0-8.8-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16zm0 128c0-8.8-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faHeadSideCough = {
    prefix: 'fal',
    iconName: 'head-side-cough',
    icon: [
      640,
      512,
      [],
      'e061',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 8 0 8 0 10.1-79 11.3c-18.9 2.7-33 18.9-33 38c0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456l-72 0c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8 56 0c30.9 0 56-25.1 56-56l0-8c0-8.3-6.4-15.3-14.7-15.9l-75.5-6.3c-3.3-.3-5.8-3-5.8-6.4c0-3.2 2.3-5.9 5.5-6.3l92.8-13.3c7.9-1.1 13.7-7.9 13.7-15.8l0-24s0 0 0 0l3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM512 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 368a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPanFood = {
    prefix: 'fal',
    iconName: 'pan-food',
    icon: [
      640,
      512,
      [129368],
      'e42b',
      
      'M522.4 352c4.5-9.4 8.3-19.3 11.5-29.4c.3-.9 .5-1.7 .8-2.6c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64c-3.1-10.6-7-20.8-11.6-30.7l-.6-1.3C486.5 84.3 409.4 32 320 32s-166.5 52.3-202.4 128c-4.9 10.2-9 20.9-12.3 32c0 0 0 0 0 0c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64c3.1 10.6 7 20.8 11.6 30.7l.6 1.3c36 75.7 113.1 128 202.4 128s166.5-52.3 202.4-128zm34.9 0c-38 93.8-130 160-237.4 160s-199.4-66.2-237.4-160L40 352c-22.1 0-40-17.9-40-40L0 200c0-22.1 17.9-40 40-40l42.6 0C120.6 66.2 212.6 0 320 0S519.4 66.2 557.4 160l42.6 0c22.1 0 40 17.9 40 40l0 112c0 22.1-17.9 40-40 40l-42.6 0zm10.5-160c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l32.1 0c4.4 0 8-3.6 8-8l0-112c0-4.4-3.6-8-8-8l-32.1 0zM72.1 192L40 192c-4.4 0-8 3.6-8 8l0 112c0 4.4 3.6 8 8 8l32.1 0c-5.3-20.5-8.1-41.9-8.1-64s2.8-43.5 8.1-64zM417.6 336c-21.5 0-42.2-8.6-57.4-23.8c-4.5-4.5-4.5-11.9 0-16.4l95.6-95.6c4.5-4.5 11.9-4.5 16.5 .1C487.4 215.4 496 236 496 257.3l0 2.4c0 27.4-14.7 52.6-38.4 66.2c-11.5 6.6-24.6 10-37.8 10l-2.1 0zM464 257.3c0-5.8-1.1-11.5-3.1-17l-60.5 60.5c5.5 2 11.3 3.1 17.3 3.1l2.1 0c7.7 0 15.3-2 22-5.8c13.8-7.9 22.3-22.5 22.3-38.4l0-2.4zm-260.7-54l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM235.3 299.3c-2.6 2.6-2.6 6.8 0 9.4l6.6 6.6c3 3 7.1 4.7 11.3 4.7l2.7 0 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64l0-32 0-2.7c0-4.2-1.7-8.3-4.7-11.3l-6.6-6.6c-2.6-2.6-6.8-2.6-9.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM320 384c0-17.7-14.3-32-32-32l-16 0c-8.8 0-16 7.2-16 16l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32zm0-288c-20.9 0-38.7 13.4-45.3 32l90.5 0c-6.6-18.6-24.4-32-45.3-32zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faPersonDollyEmpty = {
    prefix: 'fal',
    iconName: 'person-dolly-empty',
    icon: [
      512,
      512,
      [],
      'f4d1',
      
      'M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM0 340.3c.5 .4 1.1 .9 1.6 1.3L32 365.5 32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 340.3zM32 204l0 74.9c0 5.3 2.7 10.3 7.1 13.3L80 319.4l0-139.3c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28zm117.8 69.3L112 214.5l0 126.3L139.4 359c7.1 4.7 12 12 13.6 20.3l22.7 113.5c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6L121.6 385.6 21.4 318.8C8 309.9 0 294.9 0 278.9L0 204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256l44 0-20.3-84.2c-2.1-8.6 3.2-17.2 11.8-19.3s17.2 3.2 19.3 11.8l53.1 219.8c1.1-.1 2.2-.1 3.4-.1c25.7 0 47.9 15.1 58 37l146.1-36.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-148 37c-2.3 33.2-30 59.5-63.8 59.5c-35.3 0-64-28.7-64-64c0-22.9 12-42.9 30-54.3L228.5 288l-51.8 0c-10.9 0-21-5.5-26.9-14.7zM288 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCarTunnel = {
    prefix: 'fal',
    iconName: 'car-tunnel',
    icon: [
      512,
      512,
      [],
      'e4de',
      
      'M256 32C132.3 32 32 132.3 32 256l0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 256C0 114.6 114.6 0 256 0S512 114.6 512 256l0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240C480 132.3 379.7 32 256 32zM174.7 266.7l-19 54.3c4-.7 8.1-1 12.2-1l176 0c4.2 0 8.3 .4 12.2 1l-19-54.3C335 260.3 329 256 322.2 256l-132.3 0c-6.8 0-12.9 4.3-15.1 10.7zm-61.2 78.2l31-88.7c6.7-19.3 24.9-32.2 45.3-32.2l132.3 0c20.4 0 38.6 12.9 45.3 32.2l31 88.7C409.4 357.5 416 374 416 392l0 104c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-256 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-104c0-18 6.6-34.5 17.5-47.1zM128 448l256 0 0-56c0-22.1-17.9-40-40-40l-176 0c-22.1 0-40 17.9-40 40l0 56zm32-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faOmega = {
    prefix: 'fal',
    iconName: 'omega',
    icon: [
      448,
      512,
      [],
      'f67a',
      
      'M224 64C118 64 32 150 32 256c0 69.5 36.9 130.4 92.3 164.1c9.4 5.7 15.9 16.1 15.9 27.9c0 17.7-14.3 32-32 32L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l92.2 0s0 0 0 0c0 0 0 0 0-.1c-.1-.1-.2-.3-.5-.5C43.1 408.2 0 337.1 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 81.1-43.1 152.1-107.6 191.4c-.3 .2-.4 .3-.5 .5c0 0 0 .1 0 .1c0 0 0 0 0 0l92.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-92.2 0c-17.7 0-32-14.3-32-32c0-11.8 6.5-22.2 15.9-27.9C379.1 386.4 416 325.5 416 256c0-106-86-192-192-192z'
      
    ]
  };

  

  
  

  var faMountains = {
    prefix: 'fal',
    iconName: 'mountains',
    icon: [
      640,
      512,
      [9968],
      'f6fd',
      
      'M480 424.1c0 13.2-10.7 23.9-23.9 23.9L55.9 448C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L252.4 66c.8-1.3 2.2-2 3.6-2s2.9 .8 3.6 2L476.3 411.4c2.4 3.8 3.7 8.2 3.7 12.7zm-480 0C0 455 25 480 55.9 480l400.2 0 122.8 0c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1zM431.7 280L480 200.9 603.7 403.7c2.8 4.6 4.3 9.8 4.3 15.2c0 16.1-13 29.1-29.1 29.1l-72.2 0c3.4-7.3 5.4-15.4 5.4-23.9c0-10.5-3-20.8-8.6-29.7L431.7 280z'
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fal',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      'M212.7 363.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 329.4 75.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z'
      
    ]
  };

  

  
  

  var faAirConditioner = {
    prefix: 'fal',
    iconName: 'air-conditioner',
    icon: [
      576,
      512,
      [],
      'f8f4',
      
      'M64 32C46.3 32 32 46.3 32 64l0 128c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 256c-35.3 0-64-28.7-64-64L0 64zm112 64l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 288l0 144c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3c7.6-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48l0-144 32 0zm64 112l0-112 32 0 0 112c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8c23.9 13.8 40 39.7 40 69.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faSquareQuestion = {
    prefix: 'fal',
    iconName: 'square-question',
    icon: [
      448,
      512,
      ["question-square"],
      'f2fd',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm136.7 73.8c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 268.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faQuestionSquare = faSquareQuestion;
  

  
  

  var faOilTemperature = {
    prefix: 'fal',
    iconName: 'oil-temperature',
    icon: [
      576,
      512,
      ["oil-temp"],
      'f614',
      
      'M272 32c0-17.7 14.3-32 32-32l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 97.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4L272 112l0-80zm16 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM133.8 314.8c13.5 9.2 29.7 17.5 46.6 20.2c3.4 11.9 8.8 23 15.7 32.9c-1.3 .1-2.7 .1-4 .1c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 368.1 0 360 0 350.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM384 368c-1.3 0-2.7 0-4-.1c6.9-9.9 12.2-21 15.7-32.9c16.8-2.8 33.1-11.1 46.5-20.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 353.9 414.3 368 384 368zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z'
      
    ]
  };

  
    var faOilTemp = faOilTemperature;
  

  
  

  var faFaceDrooling = {
    prefix: 'fal',
    iconName: 'face-drooling',
    icon: [
      512,
      512,
      [],
      'e372',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM352 370.9L352 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-151.8c4.6-4.7 8.7-9.5 12.5-14.2c5.5-6.9 4.4-17-2.5-22.5s-17-4.4-22.5 2.5c-22.8 28.5-61.3 58-115.5 58s-92.7-29.5-115.5-58c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c26.7 33.4 73.5 70 140.5 70c11.2 0 21.9-1 32-2.9l0 66.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-76.2c11.7-4.7 22.3-10.4 32-16.9zM158.6 189.6c8.2-7.8 19.1-13.6 33.4-13.6c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.1 0-42.5 10.2-55.4 22.4c-12.6 12-20.4 26.3-23.8 36.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1c1.9-5.8 7-15.4 15.4-23.5zm210.2 23.5c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2c-3.4-10.2-11.1-24.6-23.8-36.5C362.5 154.2 344.1 144 320 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c14.3 0 25.2 5.8 33.4 13.6c8.4 8 13.5 17.7 15.4 23.5z'
      
    ]
  };

  

  
  

  var faDisplayCode = {
    prefix: 'fal',
    iconName: 'display-code',
    icon: [
      576,
      512,
      ["desktop-code"],
      'e165',
      
      'M512 32c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-167.7 0c-.2 0-.4 0-.6 0l-111.5 0c-.2 0-.4 0-.6 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l448 0zM64 416l149.1 0-10.7 64L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 72 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.4 0-10.7-64L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64 84.9 0 10.7 64-106.2 0zm16.4-324.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L377.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z'
      
    ]
  };

  
    var faDesktopCode = faDisplayCode;
  

  
  

  var faLessThan = {
    prefix: 'fal',
    iconName: 'less-than',
    icon: [
      384,
      512,
      [62774],
      '3c',
      
      'M382.3 72.8c4 7.9 .7 17.5-7.2 21.5L51.8 256 375.2 417.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-352-176C3.4 267.6 0 262.1 0 256s3.4-11.6 8.8-14.3l352-176c7.9-4 17.5-.7 21.5 7.2z'
      
    ]
  };

  

  
  

  var faArrowDownShortWide = {
    prefix: 'fal',
    iconName: 'arrow-down-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-desc","sort-amount-down-alt"],
      'f884',
      
      'M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4 112 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 48l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faSortAmountDesc = faArrowDownShortWide;
  
    var faSortAmountDownAlt = faArrowDownShortWide;
  

  
  

  var faFlorinSign = {
    prefix: 'fal',
    iconName: 'florin-sign',
    icon: [
      384,
      512,
      [],
      'e184',
      
      'M322.4 32c-32.1 0-61.2 19.2-73.7 48.8L188.2 224 48 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l126.6 0L105.8 418.7C98.3 436.5 80.9 448 61.6 448L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l45.6 0c32.1 0 61.2-19.2 73.7-48.8L209.4 256 336 256c8.8 0 16-7.2 16-16s-7.2-16-16-16l-113.1 0L278.2 93.3C285.7 75.5 303.1 64 322.4 64L368 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-45.6 0z'
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fal',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      'M507.8 37.2c5.9 6.5 5.5 16.7-1.1 22.6l-176 160c-6.3 5.7-16 5.5-22.1-.5L190.4 101 25.4 220.9c-7.1 5.2-17.2 3.6-22.4-3.5s-3.6-17.2 3.5-22.4l176-128c6.4-4.6 15.2-3.9 20.7 1.6L320.5 185.9 485.2 36.2c6.5-5.9 16.7-5.5 22.6 1.1zM80 432l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm144-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160zM336 432l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 288c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm144-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160z'
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fal',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M260.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L230.6 112 432 112c44.2 0 80 35.8 80 80l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-26.5-21.5-48-48-48l-201.4 0 52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6l80-80zm-9.4 256l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 400 80 400c-26.5 0-48 21.5-48 48l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-44.2 35.8-80 80-80l201.4 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM448 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM32 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0A64 64 0 1 1 0 128a64 64 0 1 1 128 0z'
      
    ]
  };

  

  
  

  var faGrill = {
    prefix: 'fal',
    iconName: 'grill',
    icon: [
      448,
      512,
      [],
      'e5a3',
      
      'M408 64c4.4 0 8 3.6 8 8l0 24c0 106-86 192-192 192S32 202 32 96l0-24c0-4.4 3.6-8 8-8l368 0zM40 32C17.9 32 0 49.9 0 72L0 96c0 92.5 56 171.9 136 206.1l-23.7 52c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64l168.6 0 24.8 54.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L312 302.1C392 267.9 448 188.5 448 96l0-24c0-22.1-17.9-40-40-40L40 32zM140.4 369.9l26.1-57.3c18.4 4.9 37.7 7.5 57.6 7.5s39.2-2.6 57.6-7.5L314.1 384l-162.6 0c-3-5.2-6.8-10-11.1-14.1zM96 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faCircleDown = {
    prefix: 'fal',
    iconName: 'circle-down',
    icon: [
      512,
      512,
      [61466,"arrow-alt-circle-down"],
      'f358',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm0-112c-9.2 0-18-3.5-24.7-9.7l-91-84c-7.8-7.2-12.3-17.4-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3l25.7 0 0-80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 80 25.7 0c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm-3-33.2c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.9 2-4.6c0-3.5-2.8-6.3-6.3-6.3L304 272c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-41.7 0c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84z'
      
    ]
  };

  
    var faArrowAltCircleDown = faCircleDown;
  

  
  

  var faPersonRunningFast = {
    prefix: 'fal',
    iconName: 'person-running-fast',
    icon: [
      512,
      512,
      [],
      'e5ff',
      
      'M352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM275.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L149.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L320.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L394 253.2c5.9 20.6 24.7 34.8 46.2 34.8l55.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.9 0c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L314.3 302.4 286.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1L197.3 384 112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.3 0c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm-16 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faTurnLeftDown = {
    prefix: 'fal',
    iconName: 'turn-left-down',
    icon: [
      384,
      512,
      [],
      'e637',
      
      'M256 352l57.3 0c3.7 0 6.7 3 6.7 6.7c0 1.9-.8 3.7-2.2 5L192 476.2 66.2 363.7c-1.4-1.3-2.2-3.1-2.2-5c0-3.7 3-6.7 6.7-6.7l57.3 0c17.7 0 32-14.3 32-32l0-176c0-61.9 50.1-112 112-112l64 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48l0 176c0 17.7 14.3 32 32 32zM178 506.7c3.8 3.4 8.8 5.3 14 5.3s10.1-1.9 14-5.3L339.1 387.5c8.2-7.3 12.9-17.8 12.9-28.8c0-21.4-17.3-38.7-38.7-38.7L288 320l-32 0 0-32 0-144c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L272 0C192.5 0 128 64.5 128 144l0 144 0 32-32 0-25.3 0C49.3 320 32 337.3 32 358.7c0 11 4.7 21.5 12.9 28.8L178 506.7z'
      
    ]
  };

  

  
  

  var faWaveTriangle = {
    prefix: 'fal',
    iconName: 'wave-triangle',
    icon: [
      640,
      512,
      [],
      'f89a',
      
      'M176.1 32c5.2 0 10.1 2.6 13 6.9L464.2 436.2 611 230.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-160 224c-3 4.2-7.9 6.7-13.1 6.7s-10.1-2.6-13-6.9L175.8 75.8 29 281.3c-5.1 7.2-15.1 8.9-22.3 3.7s-8.9-15.1-3.7-22.3l160-224c3-4.2 7.9-6.7 13.1-6.7z'
      
    ]
  };

  

  
  

  var faImagePolaroid = {
    prefix: 'fal',
    iconName: 'image-polaroid',
    icon: [
      448,
      512,
      [],
      'f8c4',
      
      'M416 384l0 32c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-32 384 0zM105.4 352L32 352l0-9.4 96-96L169.4 288l-60.7 60.7-3.3 3.3zm45.3 0l52.7-52.7L288 214.6l128 128 0 9.4-265.4 0zM416 297.4L310.6 192c-12.5-12.5-32.8-12.5-45.3 0L192 265.4 150.6 224c-12.5-12.5-32.8-12.5-45.3 0L32 297.4 32 96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 201.4zM448 336l0-240c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 336s0 0 0 0l0 16 0 16 0 16 0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32 0-16 0-16 0-16s0 0 0 0zM128 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faIndustry = {
    prefix: 'fal',
    iconName: 'industry',
    icon: [
      576,
      512,
      [],
      'f275',
      
      'M80 64c-8.8 0-16 7.2-16 16l0 224 0 48 0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-96 0-16 0-145.1c0-6.5-7.4-10.3-12.7-6.5l-138 99.3c-4.9 3.5-11.3 4-16.6 1.3s-8.7-8.2-8.7-14.2l0-81.9c0-6.4-7.1-10.2-12.4-6.7L184.9 242.6c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1L160 80c0-8.8-7.2-16-16-16L80 64zM32 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 119.4 113.8-75.9c26.6-17.7 62.2 1.3 62.2 33.3l0 50.6 112.6-81.1c26.5-19.1 63.4-.1 63.4 32.5L544 304l0 16 0 96c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-64 0-48L32 80z'
      
    ]
  };

  

  
  

  var faBoreHole = {
    prefix: 'fal',
    iconName: 'bore-hole',
    icon: [
      512,
      512,
      [],
      'e4c3',
      
      'M256 0c-8.8 0-16 7.2-16 16l0 242c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-242c0-8.8-7.2-16-16-16zm32 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM80 160l48 0 0 160c0 70.7 57.3 128 128 128s128-57.3 128-128l0-160 48 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48zm80 0c0-17.7-14.3-32-32-32l-48 0c-44.2 0-80 35.8-80 80L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-224c0-44.2-35.8-80-80-80l-48 0c-17.7 0-32 14.3-32 32l0 160c0 53-43 96-96 96s-96-43-96-96l0-160z'
      
    ]
  };

  

  
  

  var faArrowsRepeat = {
    prefix: 'fal',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      'M15.2 272C6.4 271.5-.4 264 0 255.2l.4-8C5.1 153.5 82.4 80 176.2 80l214.4 0L333.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L390.6 112l-214.4 0c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zm481.6-32c8.8 .4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2l-214.4 0 57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6L121.4 400l214.4 0c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2z'
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faHorseHead = {
    prefix: 'fal',
    iconName: 'horse-head',
    icon: [
      640,
      512,
      [],
      'f7ab',
      
      'M404 40.2c13.7-4.8 28 5.4 28 19.9c0 7-3.5 13.6-9.4 17.5l-31.5 21c-5.3 3.5-8 9.8-6.9 16s5.7 11.3 11.9 12.8l7 1.8c32.1 8 59.4 28.9 75.6 57.8l54.4 97.2c13.9 24.9 10.6 55.9-8.4 77.2c-12.7 14.3-30.9 22.5-50.1 22.5l-7.7 0c-22.2 0-43.2-10.3-56.8-27.8l-26-33.5c-7.4-9.5-21.1-11.2-30.6-3.8c-31.5 24.5-76.6 20.7-103.5-8.7l-30.3-33c-6-6.5-16.1-7-22.6-1s-7 16.1-1 22.6l30.3 33c22.3 24.3 53.2 36.3 84 35.2c.2 .6 .5 1.2 .8 1.7l35.9 66.4c3.1 5.8 4.8 12.3 4.8 18.9c0 14.3-11.6 25.9-25.9 25.9L128 480c-17.7 0-32-14.3-32-32l0-130c0-102.2 64.7-193.1 161.2-226.7L404 40.2zM375.4 420l-32-59.3c7.4-2.7 14.7-6.2 21.6-10.6l20 25.8c19.7 25.3 50 40.2 82.1 40.2l7.7 0c28.3 0 55.2-12.1 74-33.2c28-31.5 33-77.3 12.4-114.1l-54.4-97.2c-16-28.7-40.8-51.1-70.4-64.4l4.1-2.7C455.1 94.5 464 77.9 464 60.2C464 23.6 428-2 393.5 10L246.6 61.1C137.3 99.1 64 202.2 64 318l0 130c0 35.3 28.7 64 64 64l198.1 0c32 0 57.9-25.9 57.9-57.9c0-11.9-3-23.7-8.6-34.2zM400 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fal',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      ["dollar-circle","usd-circle"],
      'f2e8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 120l0 23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1l0-24.5c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faDollarCircle = faCircleDollar;
  
    var faUsdCircle = faCircleDollar;
  

  
  

  var faFaceLaughWink = {
    prefix: 'fal',
    iconName: 'face-laugh-wink',
    icon: [
      512,
      512,
      ["laugh-wink"],
      'f59c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80l-231.4 0c18.6 47.2 63.7 80 115.7 80zM126.5 288l259.1 0c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z'
      
    ]
  };

  
    var faLaughWink = faFaceLaughWink;
  

  
  

  var faSignalFair = {
    prefix: 'fal',
    iconName: 'signal-fair',
    icon: [
      640,
      512,
      ["signal-2"],
      'f68d',
      
      'M208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  
    var faSignal2 = faSignalFair;
  

  
  

  var faHouseTree = {
    prefix: 'fal',
    iconName: 'house-tree',
    icon: [
      640,
      512,
      [],
      'e1b3',
      
      'M404.1 37.1c6.4-7.1 17.4-7.1 23.8 0L538.5 160 480 160c-6.2 0-11.8 3.6-14.5 9.1s-1.8 12.2 2.1 17L575.8 318.6c.1 .2 .2 .3 .2 .5c0 .5-.4 .9-.9 .9L496 320c-6.3 0-12.1 3.7-14.6 9.5s-1.4 12.6 2.8 17.2L606 480l-191.6 0c-2.4 11.8-7.4 22.7-14.4 32l209.6 0c16.8 0 30.4-13.6 30.4-30.4c0-7.6-2.8-14.9-8-20.5L532.3 352l42.8 0c18.1 0 32.9-14.7 32.9-32.9c0-7.6-2.6-14.9-7.4-20.8L513.7 192l34.7 0c15.2 0 27.6-12.3 27.6-27.6c0-6.8-2.5-13.4-7.1-18.4L451.7 15.7c-19.1-21.2-52.3-21.2-71.4 0l-95.4 106 23.6 21.6L404.1 37.1zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6L352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-163.8zM0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2L0 448zM224 288l0 64-64 0 0-64 64 0zm-64-32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0z'
      
    ]
  };

  

  
  

  var faHockeyStickPuck = {
    prefix: 'fal',
    iconName: 'hockey-stick-puck',
    icon: [
      640,
      512,
      [],
      'e3ae',
      
      'M503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6L56 512c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l264.9 0L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352L128 352l0 128 90.8 0c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l40 0 0-128-40 0zm376 80c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-160 0zm-48 16c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 16c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-16z'
      
    ]
  };

  

  
  

  var faLaptopArrowDown = {
    prefix: 'fal',
    iconName: 'laptop-arrow-down',
    icon: [
      640,
      512,
      [],
      'e1c6',
      
      'M128 32l144 0 0 32L128 64c-17.7 0-32 14.3-32 32l0 256-32 0L64 96c0-35.3 28.7-64 64-64zM512 64L368 64l0-32 144 0c35.3 0 64 28.7 64 64l0 256-32 0 0-256c0-17.7-14.3-32-32-32zM76.8 448l486.4 0c20.3 0 37.4-13.5 42.9-32L33.9 416c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM336 48l0 217.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 265.4 304 48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBracketsSquare = {
    prefix: 'fal',
    iconName: 'brackets-square',
    icon: [
      448,
      512,
      ["brackets"],
      'f7e9',
      
      'M48 32C21.5 32 0 53.5 0 80L0 432c0 26.5 21.5 48 48 48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16L32 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 32zm352 0l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48z'
      
    ]
  };

  
    var faBrackets = faBracketsSquare;
  

  
  

  var faFaceSmileHearts = {
    prefix: 'fal',
    iconName: 'face-smile-hearts',
    icon: [
      640,
      512,
      [],
      'e390',
      
      'M422.7 21.4C391.3 7.7 356.5 0 320 0C178.6 0 64 114.6 64 256c0 11.1 .7 22 2.1 32.7c10.4 1.4 20.5 4.6 30 9.7c1.2-.6 2.4-1.3 3.6-1.8C97.3 283.4 96 269.9 96 256C96 132.3 196.3 32 320 32c34.4 0 66.9 7.7 96 21.6c.2-10.9 2.4-21.9 6.7-32.1zM534.5 191.3c6.2 20.5 9.5 42.2 9.5 64.7c0 24.2-3.8 47.6-11 69.4c3.8 1.4 7.4 3.1 11 5c7.4-4 15.3-6.8 23.4-8.5c5.6-21 8.6-43.1 8.6-65.9c0-23.6-3.2-46.4-9.1-68c-10.4 3.8-21.5 4.9-32.3 3.3zM428.5 452c-32.1 17.8-69.1 28-108.5 28c-46.7 0-90.1-14.3-126-38.7l-22.9 23c41.9 30 93.3 47.7 148.9 47.7c47.3 0 91.6-12.8 129.6-35.2l-8.3-8.3c-5-5.1-9.3-10.6-12.9-16.5zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-69.7 90.3c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm159.3-90.3c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM486.7 38.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0L486.7 71.4c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0c-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 94c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0L544 18.6l-2.4-2.4zm-448 320c-21.4-21.6-56.2-21.6-77.6 0C-5.3 357.7-5.3 392.5 16 414l55.5 55.8c13.5 13.6 35.5 13.6 49 0L176 414c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0L96 338.6l-2.4-2.4zM38.7 358.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7L97.9 447.2c-1 1-2.6 1-3.6 0L38.7 391.4c-9-9-9-23.7 0-32.7zm448 32c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0l-55.5-55.8c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0c-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 446c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0l-2.3 2.3-2.4-2.4z'
      
    ]
  };

  

  
  

  var faSquare8 = {
    prefix: 'fal',
    iconName: 'square-8',
    icon: [
      448,
      512,
      [],
      'e25d',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm172 96l-24 0c-37.6 0-68 30.4-68 68c0 20.2 8.8 38.4 22.9 50.9C148.1 260.7 136 282.9 136 308c0 42 34 76 76 76l24 0c42 0 76-34 76-76c0-25.1-12.1-47.3-30.9-61.1c14-12.5 22.9-30.6 22.9-50.9c0-37.6-30.4-68-68-68zM212 232c-19.9 0-36-16.1-36-36s16.1-36 36-36l24 0c19.9 0 36 16.1 36 36s-16.1 36-36 36l-24 0s0 0 0 0zm0 32s0 0 0 0l24 0c24.3 0 44 19.7 44 44s-19.7 44-44 44l-24 0c-24.3 0-44-19.7-44-44s19.7-44 44-44z'
      
    ]
  };

  

  
  

  var faSquareArrowLeft = {
    prefix: 'fal',
    iconName: 'square-arrow-left',
    icon: [
      448,
      512,
      ["arrow-square-left"],
      'f33a',
      
      'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm36.7-235.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L150.6 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16l-185.4 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faArrowSquareLeft = faSquareArrowLeft;
  

  
  

  var faGuitar = {
    prefix: 'fal',
    iconName: 'guitar',
    icon: [
      512,
      512,
      [],
      'f7a6',
      
      'M445.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 61.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5L406.6 72l39-39zM376.4 60.5l-15 67.5-35.5 35.5c-51.7-42.9-120-48-158.3-9.6c-12 12-19.7 26.8-23.4 43.2c-4.1 18.1-20.8 33.5-39.4 34.5C76.9 233 51 243.2 31.4 262.8C-17.4 311.7-8.3 400 51.8 460.2s148.5 69.3 197.4 20.4c19.6-19.6 29.8-45.5 31.2-73.4c.9-18.5 16.4-35.3 34.5-39.4c16.4-3.7 31.2-11.4 43.2-23.4c38.3-38.3 33.3-106.6-9.6-158.3L384 150.6l67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3L380.7 52.7c-2.2 2.2-3.6 4.9-4.3 7.8zM303.1 186.2l-74.4 74.4c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l74.4-74.4c34.5 42.9 31.7 91 9.7 113c-7.3 7.3-16.6 12.3-27.6 14.8c-30.7 6.9-57.7 34.7-59.4 69c-1.1 21-8.6 39.1-21.9 52.4c-32.2 32.2-99.9 31.8-152.1-20.4S21.8 317.6 54 285.4c13.3-13.3 31.4-20.9 52.4-21.9c34.3-1.7 62.1-28.7 69-59.4c2.5-11 7.5-20.3 14.8-27.6c22-22 70.1-24.8 113 9.7zM208 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faScreenUsers = {
    prefix: 'fal',
    iconName: 'screen-users',
    icon: [
      640,
      512,
      ["users-class"],
      'f63d',
      
      'M544 32L96 32C78.3 32 64 46.3 64 64l0 165.5c-11.9 4.2-22.8 10.7-32 19L32 64C32 28.7 60.7 0 96 0L544 0c35.3 0 64 28.7 64 64l0 184.4c-9.2-8.3-20.1-14.8-32-19L576 64c0-17.7-14.3-32-32-32zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 480l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm256-32c-17.7 0-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32l-64 0zm192 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faUsersClass = faScreenUsers;
  

  
  

  var faTrashCanSlash = {
    prefix: 'fal',
    iconName: 'trash-can-slash',
    icon: [
      640,
      512,
      ["trash-alt-slash"],
      'e2ad',
      
      'M512 96l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0-47.1 0L407 22.6C398.2 8.5 382.8 0 366.3 0L273.7 0C257.2 0 241.8 8.5 233 22.6L207.1 64l-27 0 40.5 32L480 96l0 204.8L512 326l0-230zM472.4 457.9C463.9 471.2 449 480 432 480l-224 0c-26.5 0-48-21.5-48-48l0-220.8L128 186l0 246c0 44.2 35.8 80 80 80l224 0c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9zM208 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-125.6-32-25.3L208 400zm96 0c0 8.8 7.2 16 16 16s16-7.2 16-16l0-49.8-32-25.3 0 75.1zm96-162.4l32 25.3 0-86.9c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 61.6zM260.2 39.5c2.9-4.7 8.1-7.5 13.6-7.5l92.5 0c5.5 0 10.6 2.8 13.6 7.5L395.1 64 244.9 64l15.3-24.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faTrashAltSlash = faTrashCanSlash;
  

  
  

  var faSun = {
    prefix: 'fal',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      'M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM265.1 97.7l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8l-17.4 94.5-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faObjectsAlignCenterHorizontal = {
    prefix: 'fal',
    iconName: 'objects-align-center-horizontal',
    icon: [
      512,
      512,
      [],
      'e3bc',
      
      'M448 176c0 8.8-7.2 16-16 16l-176 0L80 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l176 0s0 0 0 0s0 0 0 0l176 0c8.8 0 16 7.2 16 16l0 64zM272 224l160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 64l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0 0 64-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-64zm-16 96l112 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-112 0-112 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l112 0z'
      
    ]
  };

  

  
  

  var faChampagneGlass = {
    prefix: 'fal',
    iconName: 'champagne-glass',
    icon: [
      320,
      512,
      ["glass-champagne"],
      'f79e',
      
      'M74.5 160l171 0 7.3 53.6C260.5 269.9 216.8 320 160 320s-100.5-50.1-92.8-106.4L74.5 160zm4.4-32L91.9 32l136.1 0 13.1 96L78.8 128zM60.2 27.7L35.5 209.3C25.9 279.4 75.8 342.4 144 351l0 129-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-129c68.2-8.6 118.1-71.6 108.5-141.7L259.8 27.7C257.6 11.8 244.1 0 228.1 0L91.9 0c-16 0-29.5 11.8-31.7 27.7z'
      
    ]
  };

  
    var faGlassChampagne = faChampagneGlass;
  

  
  

  var faTrashUndo = {
    prefix: 'fal',
    iconName: 'trash-undo',
    icon: [
      448,
      512,
      ["trash-arrow-turn-left"],
      'f895',
      
      'M177.7 32l92.5 0c5.5 0 10.6 2.8 13.6 7.5L299.1 64 148.9 64l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0L177.7 0C161.2 0 145.8 8.5 137 22.6L111.1 64 64.1 64 32 64 16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l18.3 0L59.8 452.6C62.1 486.1 90 512 123.6 512l200.8 0c33.6 0 61.4-25.9 63.8-59.4L413.7 96 432 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32.1 0-47.1 0zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480l-200.8 0c-16.8 0-30.7-13-31.9-29.7L66.4 96l315.3 0zM219.9 189.3c-5.9-6.6-16-7.1-22.6-1.2l-80 72c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l80 72c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6l-49-44.1 70.3 0c26.5 0 48 21.5 48 48l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40c0-44.2-35.8-80-80-80l-70.3 0 49-44.1c6.6-5.9 7.1-16 1.2-22.6z'
      
    ]
  };

  
    var faTrashArrowTurnLeft = faTrashUndo;
  

  
  

  var faRubleSign = {
    prefix: 'fal',
    iconName: 'ruble-sign',
    icon: [
      384,
      512,
      [8381,"rouble","rub","ruble"],
      'f158',
      
      'M104.7 32C82.2 32 64 50.2 64 72.7L64 288l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 384l0-64 144 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L104.7 32zM96 288L96 72.7c0-4.8 3.9-8.7 8.7-8.7L240 64c61.9 0 112 50.1 112 112s-50.1 112-112 112L96 288z'
      
    ]
  };

  
    var faRouble = faRubleSign;
  
    var faRub = faRubleSign;
  
    var faRuble = faRubleSign;
  

  
  

  var faNotes = {
    prefix: 'fal',
    iconName: 'notes',
    icon: [
      512,
      512,
      [],
      'e202',
      
      'M128 96c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 160-80 0c-26.5 0-48 21.5-48 48l0 80-160 0c-17.7 0-32-14.3-32-32l0-256zM446.2 288c-1.6 4.5-4.2 8.7-7.6 12.1l-74.5 74.5c-3.4 3.4-7.6 6-12.1 7.6l0-78.2c0-8.8 7.2-16 16-16l78.2 0zM96 96l0 256c0 35.3 28.7 64 64 64l181.5 0c17 0 33.3-6.7 45.3-18.7l74.5-74.5c12-12 18.7-28.3 18.7-45.3L480 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM320 496c0-8.8-7.2-16-16-16l-176 0c-53 0-96-43-96-96l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 384c0 70.7 57.3 128 128 128l176 0c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faGearCode = {
    prefix: 'fal',
    iconName: 'gear-code',
    icon: [
      512,
      512,
      [],
      'e5e8',
      
      'M225.7 34c-1.1 1-1.9 2.3-2.4 3.8L209.6 85.5c-3.5 12.1-12.2 21.1-22.5 26.1c-7.6 3.6-14.8 7.8-21.7 12.5c-9.4 6.5-21.7 9.5-33.9 6.5l-48.2-12c-1.5-.4-3-.3-4.4 .2c-5.4 6.9-10.4 14.2-15 21.8l-4.2 7.3c-4.2 7.5-7.9 15.3-11.2 23.4c.3 1.5 1 2.9 2.1 4L85.2 211c8.7 9 12.2 21.1 11.3 32.5c-.3 4.1-.5 8.3-.5 12.5s.2 8.4 .5 12.5c.9 11.4-2.6 23.5-11.3 32.5L50.7 336.8c-1.1 1.1-1.8 2.5-2.1 4c3.3 8 7 15.8 11.2 23.4l4.2 7.3c4.6 7.6 9.6 14.8 15 21.8c1.4 .5 2.9 .5 4.4 .2l48.2-12c12.2-3 24.4 0 33.9 6.5c6.9 4.7 14.1 8.9 21.7 12.5c10.3 4.9 19.1 14 22.5 26.1l13.7 47.7c.4 1.5 1.3 2.8 2.4 3.8c9.9 1.3 20 2 30.3 2s20.4-.7 30.3-2c1.1-1 1.9-2.3 2.4-3.8l13.7-47.7c3.5-12.1 12.2-21.1 22.5-26.1c7.6-3.6 14.8-7.8 21.7-12.5c9.4-6.5 21.7-9.5 33.9-6.5l48.2 12c1.5 .4 3 .3 4.4-.2c5.4-6.9 10.4-14.2 14.9-21.8l4.2-7.3c4.2-7.5 7.9-15.3 11.2-23.4c-.3-1.5-1-2.9-2.1-4L426.8 301c-8.7-9-12.2-21.1-11.3-32.5c.3-4.1 .5-8.3 .5-12.5s-.2-8.4-.5-12.5c-.9-11.4 2.6-23.5 11.3-32.5l34.5-35.7c1.1-1.1 1.8-2.5 2.1-4c-3.3-8-7-15.8-11.2-23.3l-4.3-7.4c-4.6-7.6-9.5-14.8-14.9-21.8c-1.4-.5-2.9-.5-4.4-.2l-48.2 12c-12.2 3-24.4 0-33.9-6.5c-6.9-4.7-14.1-8.9-21.7-12.5c-10.3-4.9-19.1-14-22.5-26.1L288.7 37.8c-.4-1.5-1.3-2.8-2.4-3.8c-9.9-1.3-20-2-30.3-2s-20.4 .7-30.3 2zM217.6 2.9C230.1 1 243 0 256 0s25.9 1 38.4 2.9c1.7 .3 3.4 .8 5 1.6c9.5 4.9 16.9 13.6 20 24.5l13.7 47.7c.6 2.2 2.5 4.5 5.6 6c9.1 4.3 17.8 9.4 26 15c2.8 1.9 5.8 2.4 8 1.8l48.2-12c10.9-2.7 22.1-.7 31.1 5.1c1.5 .9 2.8 2.1 3.9 3.5c7.1 8.9 13.6 18.2 19.5 28l.2 .3L480 132l.1 .3c5.4 9.7 10.2 19.9 14.3 30.4c.6 1.6 1 3.3 1.1 5c.5 10.8-3.3 21.6-11.2 29.8l-34.5 35.7c-1.6 1.7-2.7 4.4-2.4 7.8c.4 5 .6 10 .6 15s-.2 10.1-.6 15c-.3 3.4 .8 6.2 2.4 7.8l34.5 35.7c7.9 8.2 11.7 19 11.2 29.8c-.1 1.7-.5 3.4-1.1 5c-4.1 10.5-8.9 20.6-14.3 30.4l-.1 .3-4.4 7.6-.2 .3c-5.9 9.8-12.4 19.2-19.5 28c-1.1 1.4-2.4 2.6-3.9 3.5c-9 5.7-20.2 7.8-31.1 5.1l-48.2-12c-2.2-.6-5.2-.1-8 1.8c-8.2 5.7-16.9 10.7-26 15c-3.1 1.5-4.9 3.8-5.6 6L319.4 483c-3.1 10.8-10.5 19.5-20 24.5c-1.6 .8-3.2 1.4-5 1.6C281.9 511 269 512 256 512s-25.9-1-38.4-2.9c-1.7-.3-3.4-.8-5-1.6c-9.5-4.9-16.9-13.6-20-24.5l-13.7-47.7c-.6-2.2-2.5-4.5-5.6-6c-9.1-4.3-17.8-9.4-26-15c-2.8-1.9-5.8-2.4-8-1.8l-48.2 12c-10.9 2.7-22.1 .7-31.1-5.1c-1.5-.9-2.8-2.1-3.9-3.5C49 407 42.4 397.6 36.5 387.8l-.1-.3L32 380l-.1-.3c-5.4-9.8-10.2-19.9-14.3-30.4c-.6-1.6-1-3.3-1.1-5c-.5-10.8 3.3-21.6 11.2-29.8l34.5-35.7c1.6-1.7 2.7-4.4 2.4-7.8c-.4-5-.6-10-.6-15s.2-10.1 .6-15c.3-3.4-.8-6.2-2.4-7.8L27.7 197.4c-7.9-8.2-11.7-19-11.2-29.8c.1-1.7 .5-3.4 1.1-5c4.1-10.5 8.9-20.6 14.3-30.4l.1-.3 4.4-7.6 .1-.3C42.4 114.3 49 105 56.1 96.1c1.1-1.4 2.4-2.6 3.9-3.5c9-5.7 20.2-7.8 31.1-5.1l48.2 12c2.2 .6 5.2 .1 8-1.8c8.2-5.7 16.9-10.7 26-15c3.1-1.5 4.9-3.8 5.6-6L192.6 29c3.1-10.8 10.5-19.5 20-24.5c1.6-.8 3.2-1.4 5-1.6zm70.2 159.8l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faYenSign = {
    prefix: 'fal',
    iconName: 'yen-sign',
    icon: [
      320,
      512,
      [165,"cny","jpy","rmb","yen"],
      'f157',
      
      'M29 38.7C23.8 31.5 13.8 29.9 6.7 35S-2.1 50.2 3 57.4L123 224l-75 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 64-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-64 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-75 0L317 57.4c5.2-7.2 3.5-17.2-3.6-22.3s-17.2-3.5-22.3 3.6l-131 182L29 38.7z'
      
    ]
  };

  
    var faCny = faYenSign;
  
    var faJpy = faYenSign;
  
    var faRmb = faYenSign;
  
    var faYen = faYenSign;
  

  
  

  var faPlaneCircleXmark = {
    prefix: 'fal',
    iconName: 'plane-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e557',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7l0 52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6l0 56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6l0 42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2c0 0 0 0 0 0L256 480.6l105.7 30.2s0 0 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4l0-39.4 57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8l0-56.2c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9l0-61.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7l0 61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1l0-52.5c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faToilet = {
    prefix: 'fal',
    iconName: 'toilet',
    icon: [
      448,
      512,
      [128701],
      'f7d8',
      
      'M0 16C0 7.2 7.2 0 16 0L432 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 32C7.2 32 0 24.8 0 16zM64 196.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6L384 64l32 0 0 146.6c2.1 1.2 4.2 2.5 6.1 3.8c13.9 9.4 25.9 23 25.9 41.6c0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5c0 24.3-19.7 43.9-43.9 43.9l-232.1 0C83.7 512 64 492.3 64 468.1c0-4.2 .6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6c1.9-1.3 4-2.6 6.1-3.8L32 64l32 0 0 132.8zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9C139.4 404.7 188.2 416 224 416s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9c-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15c-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8C33.8 247.7 32 252.9 32 256s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8c9.9-6.7 11.8-11.9 11.8-15zM112 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM351.5 464.7l-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2L96.5 464.7c-.3 1.1-.5 2.3-.5 3.4c0 6.6 5.3 11.9 11.9 11.9l232.1 0c6.6 0 11.9-5.3 11.9-11.9c0-1.2-.2-2.3-.5-3.4z'
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fal',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      'M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0L288.6 168.7C258.1 143.3 218.8 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L416 86.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L304 32zM32 304a144 144 0 1 1 288 0A144 144 0 1 1 32 304z'
      
    ]
  };

  

  
  

  var faVault = {
    prefix: 'fal',
    iconName: 'vault',
    icon: [
      576,
      512,
      [],
      'e2c5',
      
      'M64 32C46.3 32 32 46.3 32 64l0 352c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-352c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16L96 480l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-35.3 0-64-28.7-64-64L0 64zM352 240A128 128 0 1 0 96 240a128 128 0 1 0 256 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0c0 20.9-13.4 38.7-32 45.3L480 336c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-114.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftUp = {
    prefix: 'fal',
    iconName: 'arrow-turn-left-up',
    icon: [
      384,
      512,
      [],
      'e634',
      
      'M331.3 132.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L208 54.6 208 432c0 26.5 21.5 48 48 48l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0c-44.2 0-80-35.8-80-80l0-377.4L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128z'
      
    ]
  };

  

  
  

  var faPersonSimple = {
    prefix: 'fal',
    iconName: 'person-simple',
    icon: [
      256,
      512,
      [],
      'e220',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320l84.9 0c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L192 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z'
      
    ]
  };

  

  
  

  var faTableCellsColumnUnlock = {
    prefix: 'fal',
    iconName: 'table-cells-column-unlock',
    icon: [
      640,
      512,
      [],
      'e690',
      
      'M352 64l0 96 128 0 0-64c0-17.7-14.3-32-32-32l-96 0zm-32 0L192 64l0 96 128 0 0-96zM160 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l96 0 0-384zm32 384l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 40.6 0c-5.4 9.4-8.6 20.3-8.6 32l-32 0 0 96zM320 320l0-128-128 0 0 128 128 0zm160-48l0 48 48 0 48 0 32 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480l160 0 0-128-160 0 0 128z'
      
    ]
  };

  

  
  

  var faOilWell = {
    prefix: 'fal',
    iconName: 'oil-well',
    icon: [
      576,
      512,
      [],
      'e532',
      
      'M497.4 69.6c-6.9-25.6-33.2-40.8-58.8-33.9l-15.5 4.1L489.4 287l15.5-4.1c25.6-6.9 40.8-33.2 33.9-58.8L497.4 69.6zM430.4 4.7c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L429.2 185.8 96 272.2 96 480l36.5 0L200 277.3l36.9-9.6L208.9 352l126.3 0L301.5 251l31-8 79 237.1L560 480c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 63.2L223.8 206l33-99.1C259 100.4 265.1 96 272 96s13 4.4 15.2 10.9L312.5 183l108.4-28.1L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM281.5 191.1L272 162.6l-11.3 33.9 20.8-5.4zM377.8 480l-32-96-147.6 0-32 96 211.6 0z'
      
    ]
  };

  

  
  

  var faGlassWater = {
    prefix: 'fal',
    iconName: 'glass-water',
    icon: [
      384,
      512,
      [],
      'e4f4',
      
      'M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7l303.7 0c4.7 0 8.4 4 8 8.7l-8.2 97.7-38 19c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3l-38.1-19L32.1 40.7zm11.4 135L64.1 186c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l20.5-10.3-23.2 275C315.8 467.3 302 480 285.4 480L98.6 480c-16.6 0-30.5-12.7-31.9-29.3L43.5 175.6zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512l186.8 0c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0L40.1 0z'
      
    ]
  };

  

  
  

  var faTrashCanCheck = {
    prefix: 'fal',
    iconName: 'trash-can-check',
    icon: [
      448,
      512,
      [],
      'e2a9',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zM331.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 329.4 308.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fal',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      'M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224 389 224c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288 57.8 288C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256 192 256c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256 256 256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z'
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faMessageSlash = {
    prefix: 'fal',
    iconName: 'message-slash',
    icon: [
      640,
      512,
      ["comment-alt-slash"],
      'f4a9',
      
      'M378.8 384l-5.5 0c-6.9 0-13.7 2.2-19.2 6.4L256 464l0-48c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32l0-191.3L64 135.4 64 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416l46 0-40.5-32zM128 0c-8.3 0-16.1 1.6-23.4 4.4L139.6 32 512 32c17.7 0 32 14.3 32 32l0 287.3 28.3 22.3c2.4-6.8 3.7-14 3.7-21.6l0-288c0-35.3-28.7-64-64-64L128 0zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faCommentAltSlash = faMessageSlash;
  

  
  

  var faShieldCat = {
    prefix: 'fal',
    iconName: 'shield-cat',
    icon: [
      512,
      512,
      [],
      'e572',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM171.3 132.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 128c0 61.9 50.1 112 112 112s112-50.1 112-112l0-128c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5L281.4 192l-50.7 0-59.3-59.3zM176 272l0-89.4 36.7 36.7c3 3 7.1 4.7 11.3 4.7l64 0c4.2 0 8.3-1.7 11.3-4.7L336 182.6l0 89.4c0 44.2-35.8 80-80 80s-80-35.8-80-80zm56 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCaravan = {
    prefix: 'fal',
    iconName: 'caravan',
    icon: [
      640,
      512,
      [],
      'f8ff',
      
      'M416 64c70.7 0 128 57.3 128 128l0 192-64 0 0-216c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40l0 216-37.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L80 384c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l336 0zM80 416l16 0c0 53 43 96 96 96s96-43 96-96l64 0 96 0 96 0 32 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-192c0-88.4-71.6-160-160-160L80 32C35.8 32 0 67.8 0 112L0 336c0 44.2 35.8 80 80 80zM448 224l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 128-96 0 0-216c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8l0 56zM128 160l128 0 0 64-128 0 0-64zm-32 0l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zm96 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faArrowUpArrowDown = {
    prefix: 'fal',
    iconName: 'arrow-up-arrow-down',
    icon: [
      576,
      512,
      ["sort-up-down"],
      'e099',
      
      'M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zm352 342.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 425.4 432 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96z'
      
    ]
  };

  
    var faSortUpDown = faArrowUpArrowDown;
  

  
  

  var faHandWave = {
    prefix: 'fal',
    iconName: 'hand-wave',
    icon: [
      512,
      512,
      [],
      'e1a7',
      
      'M354.3 95.8c8.7-1.2 14.8-9.4 13.6-18.1l-1.2-8.5c-5-35.2-32.7-62.9-67.9-67.9L290.3 .2c-8.7-1.2-16.9 4.8-18.1 13.6s4.8 16.9 13.6 18.1l8.5 1.2c21.1 3 37.7 19.6 40.7 40.7l1.2 8.5c1.3 8.7 9.4 14.8 18.1 13.6zM13.7 368.2C5 369.4-1.1 377.5 .2 386.3l1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2c8.7 1.3 16.9-4.8 18.1-13.6s-4.8-16.9-13.6-18.1L73.8 431c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5c-1.2-8.7-9.4-14.8-18.1-13.6zM150.4 62.4c-21-10.8-47.5-7.3-65.1 10.3s-21 44.1-10.3 65.1c-8.7 2.6-16.8 7.3-23.7 14.1c-21.9 21.9-21.9 57.3 0 79.2l9.5 9.5c-7.6 2.7-14.8 7.1-20.9 13.2c-21.8 21.8-21.9 57.2-.2 79.1L162.9 457.1c34.8 35.1 82.2 54.9 131.7 54.9C397 512 480 429 480 326.6l0-13.8c0 0 0 0 0 0l0-.7c0 0 0 0 0 0L480 152c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 11L243.7 38.7c-21.9-21.9-57.3-21.9-79.2 0c-6.8 6.8-11.5 15-14.1 23.7zM108 95.3c9.4-9.4 24.6-9.4 33.9 0l8.8 8.8 .1 .1L288 241.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L187.1 95.3l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0L372.7 212.9c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-49.6c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 0 0 0 0 0l0 .7c0 0 0 0 0 0l0 13.9C448 411.3 379.3 480 294.6 480c-40.9 0-80.1-16.4-109-45.4L62.6 310.3c-9.3-9.4-9.3-24.6 .1-34c9.4-9.4 24.7-9.4 34.1 0l36 36 .1 .1 42.1 42.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-42.2-42.2L105.6 240c0 0 0 0-.1-.1L74 208.4c-9.4-9.4-9.4-24.6 0-33.9c9.3-9.3 24.4-9.4 33.8-.1L231.4 297.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-46.5-46.5-.1-.1L108 129.2c-9.4-9.4-9.4-24.6 0-33.9z'
      
    ]
  };

  

  
  

  var faFolderGear = {
    prefix: 'fal',
    iconName: 'folder-gear',
    icon: [
      512,
      512,
      ["folder-cog"],
      'e187',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM208 192l0 .7c0 1-.8 3.4-4.1 5.3c-3.2 1.8-5.5 1.4-6.5 .8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6 .3c.9 .5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6 .3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5 .8c3.3 1.9 4.1 4.3 4.1 5.3l0 .7c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-.7c0-1 .8-3.4 4.1-5.3c3.2-1.8 5.5-1.4 6.5-.8l.6 .3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6 .3c-.9 .5-3.3 1-6.5-.8c-3.3-1.9-4.1-4.3-4.1-5.3l0-.7c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 .7c0 15.1 9.4 26.8 20 33c10.7 6.2 25.5 8.3 38.5 .8l.6-.3 16 27.7-.6 .3c-13 7.5-18.6 21.4-18.6 33.8s5.5 26.3 18.6 33.8l.6 .3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5 .8c-10.6 6.2-20 17.9-20 33l0 .7-32 0 0-.7c0-15.1-9.4-26.8-20-33c-10.7-6.2-25.5-8.3-38.5-.8l-.6 .3-16-27.7 .6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7 .6 .3c13 7.5 27.8 5.4 38.5-.8c10.6-6.2 20-17.9 20-33l0-.7 32 0zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faFolderCog = faFolderGear;
  

  
  

  var faFolderMedical = {
    prefix: 'fal',
    iconName: 'folder-medical',
    icon: [
      512,
      512,
      [],
      'e18c',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM240 176c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  

  
  

  var faCameraWebSlash = {
    prefix: 'fal',
    iconName: 'camera-web-slash',
    icon: [
      640,
      512,
      ["webcam-slash"],
      'f833',
      
      'M544 224C544 100.3 443.7 0 320 0C262.8 0 210.5 21.5 170.9 56.8L196.5 77C229.9 48.9 273 32 320 32c106 0 192 86 192 192c0 30.9-7.3 60.1-20.3 86l25.6 20.2c17-31.6 26.7-67.8 26.7-106.2zM427.4 422.3l7.4 9.7 4.8 0-12.3-9.7zm-29.1-23C374.4 410.1 347.9 416 320 416c-106 0-192-86-192-192c0-12.1 1.1-24 3.3-35.5l-27.8-22C98.6 184.9 96 204.1 96 224c0 73.7 35.6 139 90.5 179.9L133 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4l336 0c9.1 0 17.5-5.2 21.5-13.4c1.5-3 2.3-6.3 2.4-9.5L500.4 480 416 480l-247.8 0 45.3-58.9C245.2 438.3 281.5 448 320 448c38.4 0 74.5-9.7 106.1-26.7l-27.8-22zM176 224c0 79.5 64.5 144 144 144c11.6 0 22.8-1.4 33.6-3.9L318 336c-51.4-.9-94.3-36.3-106.5-84.1l-35.5-28 0 .1zm256 0c0 12.1-1.9 23.7-5.4 34.6L453 279.4c7.1-17.1 11-35.8 11-55.4c0-79.5-64.5-144-144-144c-31.7 0-61 10.2-84.7 27.6l26.4 20.8c17-10.4 37-16.4 58.4-16.4c61.9 0 112 50.1 112 112zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faWebcamSlash = faCameraWebSlash;
  

  
  

  var faSaxophoneFire = {
    prefix: 'fal',
    iconName: 'saxophone-fire',
    icon: [
      640,
      512,
      ["sax-hot"],
      'f8db',
      
      'M125.4 60.7c6.2 6.5 14.8 10.1 23.7 9.9s17.4-4.1 23.4-10.8c1.1-1.2 2.1-2.5 3-3.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0-.1c11.3 11.7 22.6 26.5 31.5 42.4c10.6 19.1 16.9 38.4 16.9 55c0 13.6-2.8 26.6-7.9 38.3l34.1 0c3.8-12.1 5.8-24.9 5.8-38.3c0-24-8.8-48.7-20.9-70.5c-12.2-21.9-28.2-41.9-44-56.5c-4.5-4.2-10.2-6.2-15.9-6.2c-3.8 0-7.1 .9-10.1 2.5c-5.4 2.8-9.6 7.7-13.7 12.5c0 0 0 0 0 0c-.9 1.1-1.8 2.1-2.7 3.1L133.4 22.7c-1.6-1.7-3.2-3.5-4.8-5.3c-.7-.7-1.3-1.5-2-2.2C120 7.6 112.6 .3 102.4 0C96.6-.1 90.7 1.9 86.1 6c-18.7 16.9-40 39.1-56.7 64.1C12.8 95 0 123.9 0 153.7c0 13.3 2 26.2 5.7 38.3l34 0c-5-11.7-7.8-24.6-7.8-38.3c0-20.9 9.2-43.5 24.1-65.8c13.1-19.6 29.8-37.8 45.6-52.7c.4 .4 .8 .9 1.2 1.3l1.3 1.5s0 0 0 0c1.7 1.9 4 4.5 6.1 6.7l15.2 15.9zm9.5 46.8c-4.1-3.1-9.7-3.1-13.8 0c-16.4 12.3-56.9 45.9-67.4 84.5l33.9 0c3.4-7.6 8.8-15.9 16-24.6c7.9-9.5 16.8-17.9 24.4-24.4c7.6 6.5 16.4 14.9 24.4 24.4c7.3 8.7 12.6 17 16 24.6l33.9 0c-10.5-38.6-51-72.2-67.4-84.5zM521.9 64c-20.8 0-40.8 8.1-55.7 22.6L221.1 324.3c-2.3 2.3-5.4 3.5-8.7 3.5c-6.9 0-12.5-5.6-12.5-12.5l0-2.5c0-2.8 .8-5.6 2.3-7.9l30.6-49 7.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0L32 224l-16 0c-8.8 0-16 7.2-16 16c0 7.8 5.5 14.2 12.9 15.7L2.7 311.5C.9 321.5 0 331.7 0 341.9l0 7.6C0 439.2 72.8 512 162.6 512c48.8 0 94.9-21.9 125.8-59.6L522.8 165.9c3-3.7 7.6-5.9 12.4-5.9l77.5 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L606.1 87.4c-15-15-35.4-23.4-56.6-23.4l-27.6 0zM45.4 256l149.8 0-20 32c-4.7 7.5-7.1 16.1-7.1 24.9l0 2.5c0 24.6 19.9 44.5 44.5 44.5c11.6 0 22.7-4.5 31-12.5L488.5 109.5c9-8.7 20.9-13.5 33.4-13.5l27.6 0c12.7 0 24.9 5.1 33.9 14.1L601.4 128l-66.2 0c-14.4 0-28 6.5-37.2 17.6L263.6 432.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 480 32 421.5 32 349.4l0-7.6c0-8.3 .7-16.6 2.2-24.7L45.4 256zM144 328a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSaxHot = faSaxophoneFire;
  

  
  

  var faFileArrowDown = {
    prefix: 'fal',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4 208 240z'
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faCompactDisc = {
    prefix: 'fal',
    iconName: 'compact-disc',
    icon: [
      512,
      512,
      [128191,128192,128440],
      'f51f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-120 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144 64.5-144 144z'
      
    ]
  };

  

  
  

  var faToiletPortable = {
    prefix: 'fal',
    iconName: 'toilet-portable',
    icon: [
      320,
      512,
      [],
      'e583',
      
      'M32 64l0 32 256 0 0-32c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64zm0 64l0 320 256 0 0-112-24 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l24 0 0-80L32 128zM320 64l0 144 0 32 0 64 0 32 0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16L32 480l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64zM264 240c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l24 0 0-64-24 0z'
      
    ]
  };

  

  
  

  var faBrakeWarning = {
    prefix: 'fal',
    iconName: 'brake-warning',
    icon: [
      640,
      512,
      [],
      'e0c7',
      
      'M320 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm16-336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM77.5 100.6c4.8-7.4 2.6-17.3-4.8-22.1s-17.3-2.6-22.1 4.8C18.5 133.2 0 192.4 0 256s18.5 122.8 50.5 172.7c4.8 7.4 14.7 9.6 22.1 4.8s9.6-14.7 4.8-22.1C48.7 366.6 32 313.3 32 256s16.7-110.6 45.5-155.4zm512-17.3c-4.8-7.4-14.7-9.6-22.1-4.8s-9.6 14.7-4.8 22.1C591.3 145.4 608 198.7 608 256s-16.7 110.6-45.5 155.4c-4.8 7.4-2.6 17.3 4.8 22.1s17.3 2.6 22.1-4.8C621.4 378.8 640 319.6 640 256s-18.6-122.8-50.5-172.7z'
      
    ]
  };

  

  
  

  var faCircleHalf = {
    prefix: 'fal',
    iconName: 'circle-half',
    icon: [
      512,
      512,
      [],
      'e110',
      
      'M224 34.3C115.5 49.8 32 143.2 32 256s83.5 206.2 192 221.7l0-443.5zM224.1 2C241.6-.2 256 14.3 256 32l0 448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z'
      
    ]
  };

  

  
  

  var faWindsock = {
    prefix: 'fal',
    iconName: 'windsock',
    icon: [
      512,
      512,
      [],
      'f777',
      
      'M16 0c8.8 0 16 7.2 16 16l0 112 64 0 0-41.3c0-20.1 18.3-35.2 38-31.4L486 123c15.1 2.9 26 16.1 26 31.4l0 107.1c0 15.3-10.9 28.5-26 31.4L134 360.7c-19.7 3.8-38-11.3-38-31.4L96 288l-64 0 0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 272 0 144 0 16C0 7.2 7.2 0 16 0zM32 160l0 96 64 0 0-96-64 0zm96-73.3l0 242.5 96-18.5 0-205.6L128 86.7zm128 24.6l0 193.3L384 280 384 136 256 111.4zm160 30.8l0 131.8 64-12.3 0-107.1-64-12.3z'
      
    ]
  };

  

  
  

  var faMound = {
    prefix: 'fal',
    iconName: 'mound',
    icon: [
      576,
      512,
      [],
      'e52d',
      
      'M512.7 384L63.3 384 171.9 195.2C195.8 153.6 240.1 128 288 128s92.2 25.6 116.1 67.2L512.7 384zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48l449.4 0c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z'
      
    ]
  };

  

  
  

  var faPeoplePants = {
    prefix: 'fal',
    iconName: 'people-pants',
    icon: [
      640,
      512,
      [],
      'e219',
      
      'M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM147.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM128 496l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-293.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1 96 496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM467.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM448 496l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-293.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L563.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.6 16.3-70.6 42.3L337.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L416 202.1 416 496c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faGridRound2Plus = {
    prefix: 'fal',
    iconName: 'grid-round-2-plus',
    icon: [
      512,
      512,
      [],
      'e5dc',
      
      'M64 128a64 64 0 1 0 128 0A64 64 0 1 0 64 128zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c8.8 0 16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fal',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      'M32 208C32 118.9 98.2 45.3 184 33.6l0 65.1c0 16.4 12.1 29.1 26.8 32.1C291.3 147 352 218.1 352 303.4c0 89.1-66.2 162.7-152 174.4l0-65.1c0-16.4-12.1-29.1-26.8-32.1C92.7 364.4 32 293.3 32 208zM216 32.8c0-17.8-15.1-33.6-34.6-31.1C79.1 14.8 0 102.2 0 208C0 308.8 71.7 392.9 166.9 411.9c.5 .1 .8 .3 1 .5c.1 .1 .1 .1 .1 .1c0 0 0 0 0 0l0 65.9c0 17.8 15.1 33.6 34.6 31.1C304.9 496.6 384 409.3 384 303.4c0-100.8-71.7-184.9-166.9-203.9c-.5-.1-.8-.3-1-.5c-.1-.1-.1-.2-.1-.2l0-65.9zM240 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faUpload = {
    prefix: 'fal',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      'M272 54.6L272 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-313.4L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352L64 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-144 0 0-32 144 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l144 0 0 32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faUpFromLine = {
    prefix: 'fal',
    iconName: 'up-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-bottom"],
      'f346',
      
      'M190.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L318.2 196.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L256 208c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L190.2 64.8zM192 32c-9.5 0-18.6 3.9-25.1 10.8L42.5 174.8C35.8 182 32 191.5 32 201.3C32 222.7 49.3 240 70.7 240l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L217.1 42.8C210.6 35.9 201.5 32 192 32zM16 480l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  
    var faArrowAltFromBottom = faUpFromLine;
  

  
  

  var faMoneyCheckDollarPen = {
    prefix: 'fal',
    iconName: 'money-check-dollar-pen',
    icon: [
      640,
      512,
      ["money-check-edit-alt"],
      'f873',
      
      'M512 96L64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l274.2 0-8 32L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64c-10.9-.3-21.8 1.5-32 5.6l0-69.6c0-17.7-14.3-32-32-32zM256 304c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm16-112l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 144c8.8 0 16 7.2 16 16l0 9.6c5.9 1 19 3.5 24.1 4.9c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2s0 0 0 0c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-9.6c-9.4-1.7-23.5-6.6-32.4-9.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6s0 0 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4l0-9.3c0-8.8 7.2-16 16-16zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z'
      
    ]
  };

  
    var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
  

  
  

  var faCodeMerge = {
    prefix: 'fal',
    iconName: 'code-merge',
    icon: [
      448,
      512,
      [],
      'f387',
      
      'M80 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96.9 158.2C133 150.5 160 118.4 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4l0 195.2C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-119.1c26.4 32.6 66.8 53.5 112 53.5l81.6 0c7.4 36.5 39.7 64 78.4 64c44.2 0 80-35.8 80-80s-35.8-80-80-80c-38.7 0-71 27.5-78.4 64L208 256c-57 0-104.1-42.6-111.1-97.8zM416 272a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM128 432a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faStop = {
    prefix: 'fal',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      'M320 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z'
      
    ]
  };

  

  
  

  var faUpLong = {
    prefix: 'fal',
    iconName: 'up-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-up"],
      'f30c',
      
      'M88 160l-49.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L160 35.8 285.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7L232 160c-17.7 0-32 14.3-32 32l0 272c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-272c0-17.7-14.3-32-32-32zM174 5.3C170.1 1.9 165.2 0 160 0s-10.1 1.9-14 5.3L12.9 124.5C4.7 131.8 0 142.3 0 153.3C0 174.7 17.3 192 38.7 192L56 192l32 0 0 32 0 240c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-240 0-32 32 0 17.3 0c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L174 5.3z'
      
    ]
  };

  
    var faLongArrowAltUp = faUpLong;
  

  
  

  var faBlockQuote = {
    prefix: 'fal',
    iconName: 'block-quote',
    icon: [
      448,
      512,
      [],
      'e0b5',
      
      'M16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 80zM144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zM128 416c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 432z'
      
    ]
  };

  

  
  

  var faTruckPickup = {
    prefix: 'fal',
    iconName: 'truck-pickup',
    icon: [
      640,
      512,
      [128763],
      'f63c',
      
      'M256 80l0 112 229.3 0L389 70.1c-3-3.8-7.7-6.1-12.6-6.1L272 64c-8.8 0-16 7.2-16 16zM524.6 190.1l1.5 1.9 25.9 0c30.9 0 56 25.1 56 56l0 104 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0-16 0c0 53-43 96-96 96s-96-43-96-96l-96 0c0 53-43 96-96 96s-96-43-96-96l-16 0-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-104c0-30.9 25.1-56 56-56l136 0 0-112c0-26.5 21.5-48 48-48l104.5 0c14.7 0 28.6 6.7 37.7 18.3L524.6 190.1zM64 352l21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l106.9 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l21.5 0 0-104c0-13.3-10.7-24-24-24L88 224c-13.3 0-24 10.7-24 24l0 104zm176 32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm224 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faTowerBroadcast = {
    prefix: 'fal',
    iconName: 'tower-broadcast',
    icon: [
      576,
      512,
      ["broadcast-tower"],
      'f519',
      
      'M46.7 1.4c-8.1-3.6-17.5-.1-21.2 8C9.1 45.6 0 85.8 0 128s9.1 82.4 25.5 118.6c3.6 8.1 13.1 11.6 21.2 8s11.6-13.1 8-21.2C40.1 201.3 32 165.6 32 128s8.1-73.3 22.6-105.4c3.6-8.1 .1-17.5-8-21.2zm482.7 0c-8.1 3.6-11.6 13.1-8 21.2C535.9 54.7 544 90.4 544 128s-8.1 73.3-22.6 105.4c-3.6 8.1-.1 17.5 8 21.2s17.5 .1 21.2-8C566.9 210.4 576 170.2 576 128s-9.1-82.4-25.5-118.6c-3.6-8.1-13.1-11.6-21.2-8zM256 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm48 62c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62l0 306c0 8.8 7.2 16 16 16s16-7.2 16-16l0-306zM138.9 69.8c3.2-8.2-.9-17.5-9.1-20.7s-17.5 .9-20.7 9.1C100.6 79.8 96 103.4 96 128s4.6 48.2 13.1 69.8c3.2 8.2 12.5 12.3 20.7 9.1s12.3-12.5 9.1-20.7c-7-18-10.9-37.6-10.9-58.2s3.9-40.2 10.9-58.2zm328-11.6c-3.2-8.2-12.5-12.3-20.7-9.1s-12.3 12.5-9.1 20.7c7 18 10.9 37.6 10.9 58.2s-3.9 40.2-10.9 58.2c-3.2 8.2 .9 17.5 9.1 20.7s17.5-.9 20.7-9.1c8.5-21.7 13.1-45.2 13.1-69.8s-4.6-48.2-13.1-69.8z'
      
    ]
  };

  
    var faBroadcastTower = faTowerBroadcast;
  

  
  

  var faLoveseat = {
    prefix: 'fal',
    iconName: 'loveseat',
    icon: [
      512,
      512,
      ["couch-small"],
      'f4cc',
      
      'M320 64c53 0 96 43 96 96l0 37.5c10-3.5 20.8-5.5 32-5.5l0-32c0-70.7-57.3-128-128-128L192 32C121.3 32 64 89.3 64 160l0 32c11.2 0 22 1.9 32 5.5L96 160c0-53 43-96 96-96l128 0zM96 320l0 96 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-144c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32zM80 480c20.9 0 38.7-13.4 45.3-32l261.5 0c6.6 18.6 24.4 32 45.3 32l32 0c26.5 0 48-21.5 48-48l0-144c0-35.3-28.7-64-64-64s-64 28.7-64 64l-256 0c0-35.3-28.7-64-64-64s-64 28.7-64 64L0 432c0 26.5 21.5 48 48 48l32 0zm48-64l0-96 256 0 0 96-256 0zm288 16l0-16 0-96 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 144c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faCouchSmall = faLoveseat;
  

  
  

  var faPeopleDress = {
    prefix: 'fal',
    iconName: 'people-dress',
    icon: [
      640,
      512,
      [],
      'e217',
      
      'M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM126.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l48 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 64 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 48 0c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L246.1 368 208 368l-96 0-38.1 0 52.4-104.8zM160 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C231.7 148.6 197.3 128 160 128s-71.7 20.6-89.3 53.5L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L99 196.6c12-22.5 35.5-36.6 61-36.6zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l48 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 64 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 48 0c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368 528 368l-96 0-38.1 0 52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6z'
      
    ]
  };

  

  
  

  var faHandHoldingSkull = {
    prefix: 'fal',
    iconName: 'hand-holding-skull',
    icon: [
      576,
      512,
      [],
      'e1a4',
      
      'M176 128c0 33.3 20 63.5 51.9 81c6.4 3.5 9.6 10.9 7.8 17.9L228.5 256l119 0-7.3-29.1c-1.8-7.1 1.5-14.4 7.8-17.9C380 191.5 400 161.3 400 128c0-51.1-48.1-96-112-96s-112 44.9-112 96zM288 0c77.5 0 144 55.4 144 128c0 42.6-23.3 79.6-57.9 102.6l9.4 37.5c1.2 4.8 .1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2l-160 0c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l9.4-37.5c-34.6-23-57.9-60-57.9-102.6C144 55.4 210.5 0 288 0zM248 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7L80 400l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  

  
  

  var faBanana = {
    prefix: 'fal',
    iconName: 'banana',
    icon: [
      576,
      512,
      [],
      'e2e5',
      
      'M336 144c0 41.2-8.7 80.4-24.3 115.9c-8-7.6-17-14.2-26.5-19.5C297.3 210.7 304 178.1 304 144c0-31.4-5.6-61.3-15.9-89c-9.5-25.5 8.6-55 38-55c9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 11-.6 21.8-1.8 32.5c-11.4 1-22.6 3.6-33.3 7.5c2.1-13.1 3.1-26.4 3.1-40.1c0-75.3-32.5-143-84.3-189.9c-1.5-1.4-3.5-2.1-5.6-2.1c-3.3 0-5.5 1.4-7 3.6c-1.7 2.6-2 5.6-1.1 8.2C329.7 75 336 108.8 336 144zM253.9 296.2c-9.7-5.3-20.7-8.2-32-8.2c-11.6 0-22.9 3-32.9 8.7l-37 21.1c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l37-21.1c14.9-8.5 31.7-13 48.8-13c26.1 0 51.1 10.4 69.6 28.8l48 48 77.8-35.9c12.7-5.9 26.5-8.9 40.5-8.9c34.4 0 66.1 18.2 83.4 47.9l32.7 56c4.5 7.6 1.9 17.4-5.8 21.9s-17.4 1.9-21.9-5.8l-32.7-56c-11.6-19.8-32.8-32.1-55.8-32.1c-9.3 0-18.6 2-27.1 5.9l-1.4 .7C387.8 435 282.9 512 160 512L48 512c-26.5 0-48-21.5-48-48l0-16c0-26.5 21.5-48 48-48c84.4 0 159.2-40.8 205.9-103.8zm130.6 51.1l-41.7 19.3c-6.1 2.8-13.3 1.5-18-3.2l-46.4-46.4C225.8 386.8 142.2 432 48 432c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l112 0c96.7 0 180.9-53.6 224.4-132.7z'
      
    ]
  };

  

  
  

  var faHouseTurret = {
    prefix: 'fal',
    iconName: 'house-turret',
    icon: [
      640,
      512,
      [],
      'e1b4',
      
      'M288 448l0-163.8c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6L608 448c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32zM256 284.2L256 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L276.8 237c-13.2 12.1-20.8 29.2-20.8 47.2zM416 288l64 0 0 64-64 0 0-64zm-32 0l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM32 48c0-8.8 7.2-16 16-16l48 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 96 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 48 0c8.8 0 16 7.2 16 16l0 105.9 32-29.3L352 48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 203.8c0 11.8 4.3 23.1 12.1 31.9L64 294.1 64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-3.9-1.4-7.7-4-10.6L36 214.5c-2.6-2.9-4-6.7-4-10.6L32 48zM192 224l-32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32zm-16-80c-26.5 0-48 21.5-48 48l0 48c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-48c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faChartScatterBubble = {
    prefix: 'fal',
    iconName: 'chart-scatter-bubble',
    icon: [
      512,
      512,
      [],
      'e0e9',
      
      'M16 32c8.8 0 16 7.2 16 16l0 352c0 26.5 21.5 48 48 48l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 480c-44.2 0-80-35.8-80-80L0 48c0-8.8 7.2-16 16-16zM176 323.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm208 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48-92.8a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCircleVideo = {
    prefix: 'fal',
    iconName: 'circle-video',
    icon: [
      512,
      512,
      ["video-circle"],
      'e12b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320l0 32 0 64 0 32-128 0 0-128 128 0zm32 9.8l0-9.8c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-9.8 74.9 25c4.9 1.6 10.2 .8 14.4-2.2s6.6-7.8 6.6-13l0-128c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-74.9 25zm0 33.7l64-21.3 0 83.6-64-21.3 0-40.9z'
      
    ]
  };

  
    var faVideoCircle = faCircleVideo;
  

  
  

  var faGameBoardSimple = {
    prefix: 'fal',
    iconName: 'game-board-simple',
    icon: [
      448,
      512,
      ["game-board-alt"],
      'f868',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 240l112 0 0-112L96 128l0 112zM240 120l0 120 120 0c13.3 0 24 10.7 24 24l0 128c0 13.3-10.7 24-24 24l-128 0c-13.3 0-24-10.7-24-24l0-120L88 272c-13.3 0-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24l128 0c13.3 0 24 10.7 24 24zm0 264l112 0 0-112-112 0 0 112z'
      
    ]
  };

  
    var faGameBoardAlt = faGameBoardSimple;
  

  
  

  var faSkull = {
    prefix: 'fal',
    iconName: 'skull',
    icon: [
      512,
      512,
      [128128],
      'f54c',
      
      'M384 399.6c-.2-10.7 4.9-20.8 13.6-26.9c51.3-36 82.4-89.8 82.4-148.7c0-102.2-96.1-192-224-192S32 121.8 32 224c0 58.8 31.1 112.7 82.4 148.7c8.8 6.1 13.9 16.2 13.6 26.9l0 .4 0 64c0 8.8 7.2 16 16 16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c8.8 0 16-7.2 16-16l0-64 0-.4zm32-.7c0 .4 0 .7 0 1.1l0 64c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-64c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faTimelineArrow = {
    prefix: 'fal',
    iconName: 'timeline-arrow',
    icon: [
      640,
      512,
      [],
      'e29d',
      
      'M144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zm32 0c0 29.8-20.4 54.9-48 62l0 114 224 0 0-114c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62l0 114 195.8 0-62.1-51.7c-6.8-5.7-7.7-15.7-2-22.5s15.7-7.7 22.5-2l95.9 79.9c.6 .5 1.1 1 1.6 1.5c2.6 2.8 4.2 6.7 4.2 10.8c0 .3 0 .7 0 1c-.2 3.5-1.5 6.7-3.6 9.2c-.6 .8-1.3 1.5-2.1 2.1l-.1 .1-95.9 79.9c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5L579.8 288 256 288l0 82c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-82L16 288c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-114c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM400 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBowlRice = {
    prefix: 'fal',
    iconName: 'bowl-rice',
    icon: [
      512,
      512,
      [],
      'e2eb',
      
      'M176 80c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zM48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm81.3 233.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288l447.8 0c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 438.4 366.5 448 352 448l-192 0c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 256zM224 208c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-96 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM96 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm224 80c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm128 80c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zM288 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0z'
      
    ]
  };

  

  
  

  var faMillSign = {
    prefix: 'fal',
    iconName: 'mill-sign',
    icon: [
      384,
      512,
      [],
      'e1ed',
      
      'M287.2 21.1c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1L222.7 113.2c-12.3 8.2-22.8 18.9-30.7 31.4C173.6 115.4 141.1 96 104 96c-27.9 0-53.3 11-72 29l0-13c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80 .3 0c-.2 2.6-.3 5.3-.3 8L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-232c0-39.8 32.2-72 72-72s72 32.2 72 72l0 53.4L96.8 490.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L176 354.6l0 61.4 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 0-157.4 41.2-123.7c9.3-4.4 19.8-6.9 30.8-6.9c39.8 0 72 32.2 72 72l0 232c0 8.8 7.2 16 16 16s16-7.2 16-16l0-232c0-57.4-46.6-104-104-104c-6.3 0-12.4 .6-18.3 1.6l25.5-76.6z'
      
    ]
  };

  

  
  

  var faBalloons = {
    prefix: 'fal',
    iconName: 'balloons',
    icon: [
      640,
      512,
      [],
      'e2e4',
      
      'M172.8 342.4s0 0 0 0s0 0 0 0s0 0 0 0L160 352l-12.8-9.6s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8c-3.1-2.6-7.8-6.4-13.3-11.4c-11.2-10-26.1-24.5-40.9-42C58 249.1 32 204.5 32 160C32 89.3 89.3 32 160 32s128 57.3 128 128c0 44.5-26 89.1-56.5 125.4c-14.8 17.6-29.7 32-40.9 42c-5.6 5-10.2 8.8-13.3 11.4c-1.6 1.3-2.8 2.2-3.6 2.8l-.8 .6-.1 .1s0 0 0 0zm-9.4 39.9L180.2 416l-40.4 0 16.8-33.7 3.4-6.8 3.4 6.8zM192 368s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368L97.4 429.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l102.1 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L192 368zm139.2-84.9C362.3 367.8 448 432 448 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l102.1 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L512 432s128-96 128-208c0-88.4-71.6-160-160-160c-46.1 0-87.7 19.5-116.9 50.8c3.2 14.6 4.9 29.7 4.9 45.2c0 .7 0 1.3 0 2c21.8-39.4 63.8-66 112-66c70.7 0 128 57.3 128 128c0 44.5-26 89.1-56.5 125.4c-14.8 17.6-29.7 32-40.9 42c-5.6 5-10.2 8.8-13.3 11.4c-1.6 1.3-2.8 2.2-3.6 2.8l-.8 .6-.1 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L480 416l-12.8-9.6s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8c-3.1-2.6-7.8-6.4-13.3-11.4c-11.2-10-26.1-24.5-40.9-42C381.2 317 357.6 278 352.9 238.3c-6.1 16-13.6 31-21.7 44.7zM480 439.6l3.4 6.8L500.2 480l-40.4 0 16.8-33.7 3.4-6.8zM112 160c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zm320 64c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleDollar = {
    prefix: 'fal',
    iconName: 'chart-pie-simple-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e605',
      
      'M288 224l106.8 0c-12.9 9.1-24.5 19.9-34.6 32L272 256c-8.8 0-16-7.2-16-16l0-222.3C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5L288 224zm-32 64l83.2 0c-5.2 10.1-9.4 20.8-12.6 32L224 320c-17.7 0-32-14.3-32-32l0-218.4C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 256l0 32 32 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z'
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fal',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      'M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6 112 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 464l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faUtensils = {
    prefix: 'fal',
    iconName: 'utensils',
    icon: [
      448,
      512,
      [61685,127860,"cutlery"],
      'f2e7',
      
      'M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9L32 176c0 26.5 21.5 48 48 48l32 0 32 0c26.5 0 48-21.5 48-48l0-10.7c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2l0 10.7c0 44.2-35.8 80-80 80l-16 0 0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240-16 0c-44.2 0-80-35.8-80-80l0-10.7c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176l0 112c0 17.7 14.3 32 32 32l64 0 0-287.8-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32l0 288 0 16 0 16 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0c-35.3 0-64-28.7-64-64l0-112C288 32 400 0 416 0z'
      
    ]
  };

  
    var faCutlery = faUtensils;
  

  
  

  var faRotateRight = {
    prefix: 'fal',
    iconName: 'rotate-right',
    icon: [
      512,
      512,
      ["redo-alt","rotate-forward"],
      'f2f9',
      
      'M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3L480 176c0 8.8-7.2 16-16 16l-100.7 0c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160l73.4 0 0-73.4z'
      
    ]
  };

  
    var faRedoAlt = faRotateRight;
  
    var faRotateForward = faRotateRight;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fal',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M443.3 139.3c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 112 16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zm-342.6 352c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400 432 400c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 368l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faGolfClub = {
    prefix: 'fal',
    iconName: 'golf-club',
    icon: [
      512,
      512,
      [],
      'f451',
      
      'M510.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L303.5 365.1l-243-65.7C30 291.2 0 314.2 0 345.8L0 464c0 26.5 21.5 48 48 48l178.3 0c24.2 0 46.4-13.7 57.2-35.4l42.7-85.5 184-368zM52.2 330.4l236.8 64-34 68c-5.4 10.8-16.5 17.7-28.6 17.7L48 480c-8.8 0-16-7.2-16-16l0-16 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-16 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-22.2c0-10.5 10-18.2 20.2-15.4z'
      
    ]
  };

  

  
  

  var faCastle = {
    prefix: 'fal',
    iconName: 'castle',
    icon: [
      640,
      512,
      [],
      'e0de',
      
      'M128 40c0-22.1 17.9-40 40-40l24 0c22.1 0 40 17.9 40 40l0 24 32 0 0-24c0-22.1 17.9-40 40-40l32 0c22.1 0 40 17.9 40 40l0 24 32 0 0-24c0-22.1 17.9-40 40-40l24 0c22.1 0 40 17.9 40 40l0 184 32 0 0-24c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 232c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 200c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 24 32 0 0-184zm40-8c-4.4 0-8 3.6-8 8l0 184 320 0 0-184c0-4.4-3.6-8-8-8l-24 0c-4.4 0-8 3.6-8 8l0 40c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-40c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8l0 40c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-40c0-4.4-3.6-8-8-8l-24 0zM496 256l-352 0-64 0c-8.8 0-16-7.2-16-16l0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 232c0 26.5 21.5 48 48 48l144 0 0-80c0-53 43-96 96-96s96 43 96 96l0 80 144 0c26.5 0 48-21.5 48-48l0-232c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 40c0 8.8-7.2 16-16 16l-64 0zM384 400c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 80 128 0 0-80z'
      
    ]
  };

  

  
  

  var faKiwiBird = {
    prefix: 'fal',
    iconName: 'kiwi-bird',
    icon: [
      576,
      512,
      [],
      'f535',
      
      'M192 384c33.9 0 65.3-10.5 91.2-28.5c33.7-23.4 78.2-51.5 130.4-51.5l50.4 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-50.4 0c-52.2 0-96.7-28.1-130.4-51.5C257.3 74.5 225.9 64 192 64C103.6 64 32 135.6 32 224s71.6 160 160 160zm311.3-55.1L544 402.3l0-99.9c-11.4 11.6-25.2 20.7-40.7 26.5zM546 471.8l-75.5-136c-2.1 .1-4.3 .2-6.5 .2l-50.4 0c-41.2 0-78.3 22.3-112.1 45.8c-13.9 9.7-29.2 17.5-45.4 23.3l0 58.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-50.7c-10.4 1.7-21.1 2.7-32 2.7c-22.4 0-44-3.8-64-10.9l0 58.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-73.7C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c40.7 0 78.4 12.6 109.4 34.2c33.8 23.5 71 45.8 112.1 45.8l50.4 0c61.9 0 112 50.1 112 112l0 240c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBlanketFire = {
    prefix: 'fal',
    iconName: 'blanket-fire',
    icon: [
      640,
      512,
      [],
      'e3da',
      
      'M32 96c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 41c9.4-6.9 20.9-9.8 32-8.8L448 96c0-53-43-96-96-96L96 0C43 0 0 43 0 96L0 352c0 53 43 96 96 96l218.4 0c-5.9-10.1-10.9-20.9-14.9-32L96 416c-35.3 0-64-28.7-64-64s28.7-64 64-64l205.8 0c4.4-10.9 9.7-21.6 15.5-32L96 256c-24.6 0-47 9.2-64 24.4L32 96zM288 350.1c0-4.6 .3-9.3 .8-14.1L96 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l192.8 0c-.5-5.9-.8-11.9-.8-17.9zm159.1-157l47.4 49.8c3.1 3.2 7.4 5 11.9 5s8.7-2 11.7-5.4l21-23.7c16.6 15.9 33.7 37.3 46.7 60.7c13.7 24.6 22.2 50 22.2 72.6c0 33.5-12.7 63.9-33.6 86.6c1-5.2 1.6-10.7 1.6-16.2c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 312.1 384 365.2 384 422.6c0 5.7 .6 11.2 1.6 16.6c-21-22.8-33.6-53.3-33.6-87c0-28.4 12.4-58.2 31.4-86.7c18.4-27.5 42-52.6 63.7-72.3zM480 480c-2.4 0-4.7-.1-7-.2c-33.7-3.2-57-29.4-57-57.3c0-17.4 10.1-37.7 27.4-58.5c12.1-14.5 25.8-27 36.6-35.8c10.7 8.8 24.5 21.3 36.6 35.8c17.3 20.7 27.4 41.1 27.4 58.5c0 27.8-23.2 54-56.9 57.3c-2.4 .1-4.7 .2-7.1 .2zM320 352.2c0 85.6 65.7 155 150.9 159.6c3 .3 6 .4 9.1 .4c3.1 0 6.2-.1 9.2-.4C573.6 507 640 437.7 640 352.2c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-11.2-10.4-28.5-10.4-39.7-.1c-.4 .4-.8 .7-1.1 1.2l-12.3 13.8-37.9-39.9c-.3-.3-.5-.5-.8-.8c-11.1-10.1-28.1-10.1-39.3-.1c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2z'
      
    ]
  };

  

  
  

  var faButter = {
    prefix: 'fal',
    iconName: 'butter',
    icon: [
      640,
      512,
      [129480],
      'e3e4',
      
      'M480 96l0 192-32 0 0-192L128 96c-17.7 0-32 14.3-32 32l0 160-32 0 0-160c0-35.3 28.7-64 64-64l320 0 16 0 16 0 32 0c35.3 0 64 28.7 64 64l0 160-32 0 0-160c0-17.7-14.3-32-32-32l-32 0zM0 336c0-8.8 7.2-16 16-16l16 0 32 0 512 0 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48c0 26.5-21.5 48-48 48L80 448c-26.5 0-48-21.5-48-48l0-48-16 0c-8.8 0-16-7.2-16-16zm64 16l0 48c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16l0-48L64 352z'
      
    ]
  };

  

  
  

  var faHelmetBattle = {
    prefix: 'fal',
    iconName: 'helmet-battle',
    icon: [
      576,
      512,
      [],
      'f6eb',
      
      'M84.4 .6c8.5 2.4 13.4 11.3 11 19.8l-53 185.5C39.8 215 46.6 224 56 224c8.8 0 16 7.2 16 16s-7.2 16-16 16c-30.7 0-52.8-29.4-44.4-58.9l53-185.5C67 3.1 75.9-1.8 84.4 .6zM285.4 32c-1.3 0-2.2 .3-2.9 .6c-13.2 6.8-52.7 28.3-88.6 60.1C157.4 125 128 164.8 128 208c0 41.7-8.3 92.9-16.3 133.1c-4 20.2-8.1 37.9-11.1 50.6c-.7 3-1.4 5.8-2 8.2L240 477.7l0-192.6-45.9-9.2c-19.8-4-34.1-21.4-34.1-41.6c0-23.4 19-42.4 42.4-42.4l171.2 0c23.4 0 42.4 19 42.4 42.4c0 20.2-14.3 37.6-34.1 41.6L336 285.1l0 192.6 141.4-77.8c-.6-2.4-1.3-5.2-2-8.2c-3-12.6-7.1-30.4-11.1-50.6c-8-40.2-16.3-91.5-16.3-133.1c0-43.2-29.4-83-65.9-115.3c-35.9-31.8-75.4-53.3-88.6-60.1c-.7-.4-1.6-.6-2.9-.6l-5.2 0zm226 371.9c1.9 7.1-1.3 14.6-7.7 18.1L346.3 508.6c-3.9 2.1-8.2 3.3-12.6 3.5c-16.2 .7-29.7-12.3-29.7-28.5l0-198.5c0-15.3 10.8-28.4 25.7-31.4l45.9-9.2c4.9-1 8.3-5.2 8.3-10.2c0-5.7-4.6-10.4-10.4-10.4l-171.2 0c-5.7 0-10.4 4.6-10.4 10.4c0 4.9 3.5 9.2 8.3 10.2l45.9 9.2c15 3 25.7 16.1 25.7 31.4l0 198.5c0 16.2-13.5 29.2-29.7 28.5c-4.4-.2-8.7-1.4-12.6-3.5L72.3 422c-6.4-3.5-9.6-11-7.7-18.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0-.1l.1-.2 .3-1c.2-.9 .6-2.2 1-3.9c.9-3.4 2.1-8.3 3.6-14.5c3-12.3 6.9-29.6 10.9-49.4C88.3 295.1 96 246.3 96 208c0-57.5 38.5-105.4 76.7-139.3c38.8-34.3 81-57.3 95.2-64.6C273.5 1.3 279.5 0 285.4 0l5.2 0c5.9 0 11.9 1.3 17.5 4.2c14.2 7.3 56.3 30.2 95.2 64.6C441.5 102.6 480 150.5 480 208c0 38.3 7.7 87.1 15.7 126.9c4 19.8 7.9 37.1 10.9 49.4c1.5 6.2 2.7 11.1 3.6 14.5c.4 1.7 .8 3 1 3.9l.3 1 .1 .2c0 0 0 0 0 .1c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm-.1-392.3l53 185.5c8.4 29.5-13.7 58.9-44.4 58.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c9.4 0 16.2-9 13.6-18.1l-53-185.5c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11z'
      
    ]
  };

  

  
  

  var faCircleA = {
    prefix: 'fal',
    iconName: 'circle-a',
    icon: [
      512,
      512,
      [],
      'e0f7',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-6.1 0-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L185.9 304l140.2 0 27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-112-224c-2.7-5.4-8.3-8.8-14.3-8.8zm0 51.8L310.1 272l-108.2 0L256 163.8z'
      
    ]
  };

  

  
  

  var faDiceOne = {
    prefix: 'fal',
    iconName: 'dice-one',
    icon: [
      448,
      512,
      [9856],
      'f525',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faPotato = {
    prefix: 'fal',
    iconName: 'potato',
    icon: [
      512,
      512,
      [129364],
      'e440',
      
      'M480 144c0-61.9-50.1-112-112-112c-31 0-59 12.5-79.3 32.9c-29.6 29.7-65.7 56.7-102.4 76.8c-18.8 10.3-34.3 25.8-44.6 44.6C121.6 223 94.6 259.1 64.9 288.7C44.5 309 32 337 32 368c0 61.9 50.1 112 112 112c23.6 0 45.4-7.3 63.4-19.6c30.5-21 65.4-38.4 100.4-50.2c34.4-11.6 62.4-39.6 72.4-77.2c10.7-39.9 34.1-78.9 64.3-107.2C466.4 205.3 480 176.3 480 144zm32 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM180 264a20 20 0 1 1 0-40 20 20 0 1 1 0 40zM168 396a20 20 0 1 1 -40 0 20 20 0 1 1 40 0zM364 200a20 20 0 1 1 0-40 20 20 0 1 1 0 40z'
      
    ]
  };

  

  
  

  var faFileMedical = {
    prefix: 'fal',
    iconName: 'file-medical',
    icon: [
      384,
      512,
      [],
      'f477',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM176 224c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 80l0-48 32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z'
      
    ]
  };

  

  
  

  var faPipe = {
    prefix: 'fal',
    iconName: 'pipe',
    icon: [
      64,
      512,
      [],
      '7c',
      
      'M32 0c8.8 0 16 7.2 16 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16L16 16C16 7.2 23.2 0 32 0z'
      
    ]
  };

  

  
  

  var faMoonOverSun = {
    prefix: 'fal',
    iconName: 'moon-over-sun',
    icon: [
      512,
      512,
      ["eclipse-alt"],
      'f74a',
      
      'M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM265.1 97.7l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8l-17.4 94.5-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0zM174.2 256c0-43.2 33.9-78.7 77-81.6c-19.3 15.2-31.7 38.7-31.7 65.1c0 46 37.6 83.2 83.9 83.2l1.2 0c-13.5 9.5-30 15.1-47.8 15.1c-45.7 0-82.6-36.6-82.6-81.8zm82.6-113.8c-63 0-114.6 50.7-114.6 113.8s51.6 113.8 114.6 113.8c31 0 59.1-12.2 79.8-32.1c8.9-8.5 11.1-21.8 5.6-32.8s-17.6-17-29.7-15c-2.9 .5-5.9 .8-9 .8c-28.9 0-51.9-23.2-51.9-51.2c0-18.9 10.5-35.6 26.3-44.5c10.7-6 16.3-18.3 13.7-30.4s-12.8-20.9-25-22c-3.2-.3-6.4-.4-9.7-.4z'
      
    ]
  };

  
    var faEclipseAlt = faMoonOverSun;
  

  
  

  var faSeatAirline = {
    prefix: 'fal',
    iconName: 'seat-airline',
    icon: [
      448,
      512,
      [],
      'e244',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 142.3c0 14 3.1 27.9 9 40.6l87.3 187C109.4 398 137.7 416 168.8 416l55.2 0 0 64-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-64 102.2 0c27 0 51.2-17 60.3-42.5l28.6-80.1c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8L85.9 272 63.5 224 336 224c8.8 0 16-7.2 16-16s-7.2-16-16-16L48.6 192 38 169.3c-4-8.5-6-17.7-6-27.1L32 16zM240 384l-71.2 0c-18.6 0-35.6-10.8-43.5-27.7L100.9 304l308.4 0-21 58.8c-4.6 12.7-16.6 21.2-30.1 21.2L240 384z'
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fal',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      'M48 32C21.5 32 0 53.5 0 80L0 240 0 432c0 26.5 21.5 48 48 48l144 0c70.7 0 128-57.3 128-128c0-52.8-32-98.2-77.7-117.7C270 213.9 288 181 288 144c0-61.9-50.1-112-112-112L48 32zM192 256c53 0 96 43 96 96s-43 96-96 96L48 448c-8.8 0-16-7.2-16-16l0-176 144 0 16 0zm-16-32L32 224 32 80c0-8.8 7.2-16 16-16l128 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z'
      
    ]
  };

  

  
  

  var faSquareDownRight = {
    prefix: 'fal',
    iconName: 'square-down-right',
    icon: [
      448,
      512,
      [],
      'e26c',
      
      'M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM304 328l0-113.4c0-3.7-3-6.6-6.6-6.6c-1.8 0-3.4 .7-4.7 1.9l-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0l-59.1-59.1c-3.6-3.6-9-4.9-13.9-3.3c-2 .7-3.8 1.8-5.3 3.3l-22.1 22.1c-1.5 1.5-2.6 3.3-3.3 5.3c-1.6 4.9-.4 10.3 3.3 13.9l59.1 59.1c6.2 6.2 6.2 16.4 0 22.6l-25.4 25.4c-1.2 1.2-1.9 2.9-1.9 4.7c0 3.7 3 6.6 6.6 6.6L296 336c4.4 0 8-3.6 8-8zm-8 40l-113.4 0c-21.3 0-38.6-17.3-38.6-38.6c0-10.2 4.1-20.1 11.3-27.3L169.4 288l-47.7-47.7c-12.2-12.2-16.5-30.3-11-46.7c2.2-6.7 6-12.8 11-17.8l22.1-22.1c5-5 11.1-8.8 17.8-11c16.4-5.5 34.5-1.2 46.7 11L256 201.4l14.1-14.1c7.2-7.2 17.1-11.3 27.3-11.3c21.3 0 38.6 17.3 38.6 38.6L336 328c0 22.1-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faLaptopMedical = {
    prefix: 'fal',
    iconName: 'laptop-medical',
    icon: [
      640,
      512,
      [],
      'f812',
      
      'M128 64l384 0c17.7 0 32 14.3 32 32l0 256 32 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 256 32 0L96 96c0-17.7 14.3-32 32-32zM33.9 416l572.3 0c-5.5 18.5-22.6 32-42.9 32L76.8 448c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384zM304 112c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  

  
  

  var faFlyingDisc = {
    prefix: 'fal',
    iconName: 'flying-disc',
    icon: [
      448,
      512,
      [],
      'e3a9',
      
      'M401.7 78.3c14.5 14.5 21.3 46 4.4 96.7c-16.2 48.7-52 105.9-104.6 158.5S191.8 421.9 143.1 438.1c-50.8 16.9-82.3 10-96.7-4.4c-12.1-12.1-18.9-36.1-10.9-73.4c3 5.8 7 11.5 12.3 16.8c20 20 45.9 21.8 63.4 19.8c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c2-17.5 .2-43.4-19.8-63.4c-5.3-5.3-11-9.3-16.8-12.3c37.2-8 61.3-1.2 73.4 10.9zM105.1 175.5C8.3 282-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.2 356.2S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8c-6.5 6.5-12.8 13.1-18.7 19.7zM128.8 197c5.7-6.2 11.5-12.4 17.6-18.5c6.1-6.1 12.3-12 18.5-17.7c26.8-24.2 54-43.2 78.1-55.2c14.8-7.3 29.2-12.4 42.2-13.9c13-1.5 27 .5 37.2 10.6s12.1 24.2 10.6 37.2c-1.5 13-6.5 27.4-13.9 42.2c-14.7 29.7-40.3 64.1-72.8 96.7s-67 58.1-96.7 72.8c-14.8 7.3-29.2 12.4-42.2 13.9c-13 1.5-27-.5-37.2-10.6s-12.1-24.2-10.6-37.2c1.5-13 6.5-27.4 13.9-42.2c12-24.1 31-51.3 55.2-78.1z'
      
    ]
  };

  

  
  

  var faCalendarWeek = {
    prefix: 'fal',
    iconName: 'calendar-week',
    icon: [
      448,
      512,
      [],
      'f784',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zm40 160l240 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8zm-40 8l0 80c0 22.1 17.9 40 40 40l240 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-240 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faCarCircleBolt = {
    prefix: 'fal',
    iconName: 'car-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e342',
      
      'M113.6 98.2c6.1-20.3 24.8-34.2 46-34.2l192.8 0c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6L96 192c-3.6 0-7.2 .2-10.7 .6l28.3-94.4zM74.3 227.8l.5 .1 .1-.3c6.6-2.3 13.8-3.6 21.2-3.6l298.8 0c19.5-13.7 41.9-23.6 66.2-28.5L429 89c-10.2-33.8-41.3-57-76.6-57L159.6 32C124.3 32 93.1 55.2 83 89L48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288l0 96 0 16 0 16 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 294.6 0c-2.9-10.3-4.9-21-5.9-32L32 384l0-96c0-27.7 17.6-51.3 42.3-60.2zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z'
      
    ]
  };

  

  
  

  var faVectorCircle = {
    prefix: 'fal',
    iconName: 'vector-circle',
    icon: [
      512,
      512,
      [],
      'e2c6',
      
      'M280 32c4.4 0 8 3.6 8 8l0 10.4 0 32.5 0 5.1c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zm40 26l0-18c0-22.1-17.9-40-40-40L232 0c-22.1 0-40 17.9-40 40l0 18C128.6 78.5 78.5 128.6 58 192l-18 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l18 0c20.5 63.4 70.6 113.5 134 134l0 18c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-18c63.4-20.5 113.5-70.6 134-134l18 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-18 0C433.5 128.6 383.4 78.5 320 58zm-.2 33.9c45.9 17.9 82.4 54.4 100.3 100.3c-20.2 2-36.1 19-36.1 39.8l0 48c0 20.8 15.8 37.8 36.1 39.8c-17.9 45.9-54.4 82.4-100.3 100.3c-2-20.2-19-36.1-39.8-36.1l-48 0c-20.8 0-37.8 15.8-39.8 36.1c-45.9-17.9-82.4-54.4-100.3-100.3c20.2-2 36.1-19 36.1-39.8l0-48c0-20.8-15.8-37.8-36.1-39.8c17.9-45.9 54.4-82.4 100.3-100.3c2 20.2 19 36.1 39.8 36.1l48 0c20.8 0 37.8-15.8 39.8-36.1zM429.1 224s0 0 0 0l32.5 0s0 0 0 0l10.4 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l5.1 0zM288 429.1l0 32.5 0 10.4c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 5.1zM50.4 224s0 0 0 0l32.5 0s0 0 0 0l5.1 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l10.4 0z'
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fal',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-64 0 0-160c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 160-64 0c-26.5 0-48-21.5-48-48zm144 48l0-160 96 0 0 160-96 0z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faHeartCircleExclamation = {
    prefix: 'fal',
    iconName: 'heart-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4fe',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCourtSport = {
    prefix: 'fal',
    iconName: 'court-sport',
    icon: [
      640,
      512,
      [],
      'e643',
      
      'M64 64C46.3 64 32 78.3 32 96l0 32 32 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-32 0 0 32c0 17.7 14.3 32 32 32l240 0 0-97.3c-45.4-7.6-80-47.1-80-94.7s34.6-87.1 80-94.7L304 64 64 64zM336 350.7l0 97.3 240 0c17.7 0 32-14.3 32-32l0-32-32 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l32 0 0-32c0-17.7-14.3-32-32-32L336 64l0 97.3c45.4 7.6 80 47.1 80 94.7s-34.6 87.1-80 94.7zM336 194l0 124c27.6-7.1 48-32.2 48-62s-20.4-54.9-48-62zm-32 0c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62l0-124zM32 160l0 192 32 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-32 0zM576 352l32 0 0-192-32 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faOutdent = {
    prefix: 'fal',
    iconName: 'outdent',
    icon: [
      448,
      512,
      ["dedent"],
      'f03b',
      
      'M0 64c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48C7.2 48 0 55.2 0 64zM192 192c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zM0 448c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432c-8.8 0-16 7.2-16 16zM96 211.8l0 88.4L42.3 256 96 211.8zM7 243.6C-.8 250-.8 262 7 268.4l94.8 78.1c10.4 8.6 26.2 1.2 26.2-12.4l0-156.2c0-13.5-15.7-20.9-26.2-12.4L7 243.6z'
      
    ]
  };

  
    var faDedent = faOutdent;
  

  
  

  var faFaceWorried = {
    prefix: 'fal',
    iconName: 'face-worried',
    icon: [
      512,
      512,
      [],
      'e3a3',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM308.9 429.8c-16.2-6.1-34-9.4-52.9-9.4c-18.8 0-36.7 3.4-52.9 9.4c-11.2 4.2-23.6 2.3-32.4-4.5c-4.5-3.5-8.4-8.6-10-15.1c-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5c-1.6 6.5-5.5 11.6-10 15.1c-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2c18.5-6.4 38.6-9.8 59.6-9.8c21 0 41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zM152.4 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faFaceDotted = {
    prefix: 'fal',
    iconName: 'face-dotted',
    icon: [
      512,
      512,
      [129765],
      'e47f',
      
      'M256 0c-17.1 0-33.8 1.7-49.9 4.9c-8.7 1.7-14.3 10.1-12.6 18.8s10.1 14.3 18.8 12.6C226.4 33.5 241 32 256 32s29.6 1.5 43.7 4.3c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8C289.8 1.7 273.1 0 256 0zM398.2 43.1c-7.3-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2c24.4 16.4 45.5 37.4 61.8 61.8c4.9 7.3 14.9 9.3 22.2 4.4s9.3-14.9 4.4-22.2c-18.7-27.9-42.7-51.9-70.6-70.6zM131.6 69.7c7.3-4.9 9.3-14.9 4.4-22.2s-14.9-9.3-22.2-4.4C85.8 61.8 61.8 85.8 43.1 113.8c-4.9 7.3-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4c16.4-24.4 37.4-45.5 61.8-61.8zM36.3 212.3c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6C1.7 222.2 0 238.9 0 256s1.7 33.8 4.9 49.9c1.7 8.7 10.1 14.3 18.8 12.6s14.3-10.1 12.6-18.8C33.5 285.6 32 271 32 256s1.5-29.6 4.3-43.7zm470.9-6.2c-1.7-8.7-10.1-14.3-18.8-12.6s-14.3 10.1-12.6 18.8c2.8 14.1 4.3 28.8 4.3 43.7s-1.5 29.6-4.3 43.7c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6c3.2-16.2 4.9-32.9 4.9-49.9s-1.7-33.8-4.9-49.9zM69.7 380.4c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2c18.7 27.9 42.7 51.9 70.6 70.6c7.3 4.9 17.3 3 22.2-4.4s2.9-17.3-4.4-22.2c-24.4-16.4-45.5-37.4-61.8-61.8zm399.2 17.8c4.9-7.3 3-17.3-4.4-22.2s-17.3-2.9-22.2 4.4c-16.4 24.4-37.4 45.5-61.8 61.8c-7.3 4.9-9.3 14.9-4.4 22.2s14.9 9.3 22.2 4.4c27.9-18.7 51.9-42.7 70.6-70.6zM212.3 475.7c-8.7-1.7-17.1 3.9-18.8 12.6s3.9 17.1 12.6 18.8c16.2 3.2 32.9 4.9 49.9 4.9s33.8-1.7 49.9-4.9c8.7-1.7 14.3-10.1 12.6-18.8s-10.1-14.3-18.8-12.6C285.6 478.5 271 480 256 480s-29.6-1.5-43.7-4.3zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0z'
      
    ]
  };

  

  
  

  var faIdCard = {
    prefix: 'fal',
    iconName: 'id-card',
    icon: [
      576,
      512,
      [62147,"drivers-license"],
      'f2c2',
      
      'M64 64C46.3 64 32 78.3 32 96l512 0c0-17.7-14.3-32-32-32L64 64zM0 112L0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 16 0 304c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 112zm544 16L32 128l0 288c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-288zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM160 352c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48l-64 0zM336 208c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faDriversLicense = faIdCard;
  

  
  

  var faBookSkull = {
    prefix: 'fal',
    iconName: 'book-skull',
    icon: [
      448,
      512,
      ["book-dead"],
      'f6b7',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM240 96c-38.9 0-64 24.6-64 48c0 14.1 8.4 28 24.2 37.5c4.8 2.9 7.8 8.1 7.8 13.7l0 12.8 64 0 0-12.8c0-5.6 2.9-10.8 7.8-13.7C295.6 172 304 158.1 304 144c0-23.4-25.1-48-64-48zm-96 48c0-47.3 46.5-80 96-80s96 32.7 96 80c0 24.6-13 45.6-32 59.7l0 12.3c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-12.3c-19-14.1-32-35.1-32-59.7zm56 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM129.2 249.8c3.4-8.2 12.8-12 20.9-8.6L240 278.7l89.8-37.4c8.2-3.4 17.5 .5 20.9 8.6s-.5 17.5-8.6 20.9L281.6 296l60.6 25.2c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6L240 313.3l-89.8 37.4c-8.2 3.4-17.5-.5-20.9-8.6s.5-17.5 8.6-20.9L198.4 296l-60.6-25.2c-8.2-3.4-12-12.8-8.6-20.9z'
      
    ]
  };

  
    var faBookDead = faBookSkull;
  

  
  

  var faAlignCenter = {
    prefix: 'fal',
    iconName: 'align-center',
    icon: [
      448,
      512,
      [],
      'f037',
      
      'M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 48zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM96 320c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z'
      
    ]
  };

  

  
  

  var faFaceMeh = {
    prefix: 'fal',
    iconName: 'face-meh',
    icon: [
      512,
      512,
      [128528,"meh"],
      'f11a',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  
    var faMeh = faFaceMeh;
  

  
  

  var faCodePullRequestClosed = {
    prefix: 'fal',
    iconName: 'code-pull-request-closed',
    icon: [
      512,
      512,
      [],
      'e3f9',
      
      'M160 80A48 48 0 1 0 64 80a48 48 0 1 0 96 0zm32 0c0 38.7-27.5 71-64 78.4l0 195.2c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4l0-195.2C59.5 151 32 118.7 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM64 432a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm336 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM384 353.6L384 208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 145.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4zM332.7 12.7c6.2-6.2 16.4-6.2 22.6 0L400 57.4l44.7-44.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L422.6 80l44.7 44.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 102.6l-44.7 44.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L377.4 80 332.7 35.3c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fal',
    iconName: 'mobile',
    icon: [
      384,
      512,
      [128241,"mobile-android","mobile-phone"],
      'f3ce',
      
      'M96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L96 32zM32 64C32 28.7 60.7 0 96 0L288 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faMobileAndroid = faMobile;
  
    var faMobilePhone = faMobile;
  

  
  

  var faUserPilot = {
    prefix: 'fal',
    iconName: 'user-pilot',
    icon: [
      448,
      512,
      [],
      'e2c0',
      
      'M230.9 .8c-4.6-1-9.3-1-13.9 0l-144 32C61.7 35.3 52.5 43.8 49.3 55.1s-.2 23.3 8.1 31.6L80 109.3l0 1.6c0 15.6 7.6 31.8 23.2 40.1c22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1l0-1.6 22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32zM80 64L224 32 368 64 340.7 91.3c-3 3-4.7 7.1-4.7 11.3l0 8.2c0 5.8-2.8 10-6.2 11.8C312.2 132 280.4 144 224 144s-88.2-12-105.8-21.3c-3.4-1.8-6.2-6-6.2-11.8l0-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64zm41.5 320.8l70.9 62.1c18.1 15.8 45.1 15.8 63.2 0l70.9-62.1c48.4 6.1 86.2 45.9 89.3 95.2L32.2 480c3-49.3 40.9-89.1 89.3-95.2zm15.7-28.8c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6c0-71.6-55.9-130.1-126.5-134.2c-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0l-76.3-66.7zM304 432c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-9.1 4.3-19.6 8.5-31.8 12.1C318.1 246.9 275.9 288 224 288s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1c-.2 2.9-.3 5.8-.3 8.7zM183.2 65.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7z'
      
    ]
  };

  

  
  

  var faForward = {
    prefix: 'fal',
    iconName: 'forward',
    icon: [
      512,
      512,
      [9193],
      'f04e',
      
      'M474.4 256L256 414.1l0-316.2L474.4 256zM254 64c-16.6 0-30 13.5-30 30l0 103.4L47.7 69.7C42.5 66 36.4 64 30 64C13.5 64 0 77.5 0 94L0 418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L224 314.6 224 418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L502.1 275.4c6.2-4.5 9.9-11.7 9.9-19.4s-3.7-14.9-9.9-19.4L271.7 69.7C266.5 66 260.4 64 254 64zM224 275.1L32 414.1 32 97.9l192 139 0 38.2z'
      
    ]
  };

  

  
  

  var faLoader = {
    prefix: 'fal',
    iconName: 'loader',
    icon: [
      512,
      512,
      [],
      'e1d4',
      
      'M272 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 384l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 256c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm400-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM437 75c6.2 6.2 6.2 16.4 0 22.6l-67.9 67.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0zM165.5 369.1L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l67.9-67.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM75 75c6.2-6.2 16.4-6.2 22.6 0l67.9 67.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zM369.1 346.5L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-67.9-67.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faGlass = {
    prefix: 'fal',
    iconName: 'glass',
    icon: [
      384,
      512,
      [129371],
      'f804',
      
      'M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7l303.7 0c4.7 0 8.4 4 8 8.7L347.1 96 36.8 96 32.1 40.7zM39.5 128l305 0L317.2 450.7C315.8 467.3 302 480 285.4 480L98.6 480c-16.6 0-30.5-12.7-31.9-29.3L39.5 128zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512l186.8 0c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0L40.1 0z'
      
    ]
  };

  

  
  

  var faFileCircleCheck = {
    prefix: 'fal',
    iconName: 'file-circle-check',
    icon: [
      576,
      512,
      [],
      'e5a0',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faRotateExclamation = {
    prefix: 'fal',
    iconName: 'rotate-exclamation',
    icon: [
      512,
      512,
      [],
      'e23c',
      
      'M403.5 133.1C368.3 90.9 315.3 64 256 64C165.2 64 89.1 127 69.1 211.7c-2 8.6-10.6 13.9-19.2 11.9s-13.9-10.6-11.9-19.2C61.3 105.5 150.1 32 256 32c69.2 0 131 31.4 172.1 80.6L464 154.9 464 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l55.9 0-36.3-42.8s0 0 0 0l-.1-.1zM272 144l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 432c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-55.9 0 36.3 42.8s0 0 0 0l.1 .1C143.7 421.1 196.7 448 256 448c90.8 0 166.9-63 186.9-147.7c2-8.6 10.7-13.9 19.3-11.9s13.9 10.6 11.9 19.2C450.7 406.5 361.9 480 256 480c-69.2 0-131-31.4-172.1-80.6L48 357.1 48 416c0 8.8-7.2 16-16 16z'
      
    ]
  };

  

  
  

  var faScribble = {
    prefix: 'fal',
    iconName: 'scribble',
    icon: [
      512,
      512,
      [],
      'e23f',
      
      'M196.6 19.5C210.2 7 228 0 246.5 0l.9 0C287.5 0 320 32.5 320 72.6c0 19.2-7.6 37.7-21.3 51.3L75.9 346.7C68.3 354.4 64 364.7 64 375.4c0 22.4 18.2 40.6 40.6 40.6c10.8 0 21.1-4.3 28.7-11.9L388.1 149.3c13.6-13.6 32.1-21.3 51.3-21.3c40.1 0 72.6 32.5 72.6 72.6c0 19.2-7.6 37.7-21.3 51.3L370.5 372.1c-11.8 11.8-18.5 28-18.5 44.8c0 34.8 28.2 63.1 63 63.1c8.7 0 17.3-2 25.1-5.9l48.8-24.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48.8 24.4c-12.2 6.1-25.8 9.3-39.4 9.3c-52.5 0-95-42.7-95-95.1c0-25.2 10-49.5 27.9-67.4L468.1 229.3c7.6-7.6 11.9-17.9 11.9-28.7c0-22.4-18.2-40.6-40.6-40.6c-10.8 0-21.1 4.3-28.7 11.9L155.9 426.7c-13.6 13.6-32.1 21.3-51.3 21.3C64.5 448 32 415.5 32 375.4c0-19.2 7.6-37.7 21.3-51.3L276.1 101.3c7.6-7.6 11.9-17.9 11.9-28.7C288 50.2 269.8 32 247.4 32l-.9 0c-10.4 0-20.5 3.9-28.2 11L26.9 219.8c-6.5 6-16.6 5.6-22.6-.9s-5.6-16.6 .9-22.6L196.6 19.5z'
      
    ]
  };

  

  
  

  var faCommentsQuestion = {
    prefix: 'fal',
    iconName: 'comments-question',
    icon: [
      640,
      512,
      [],
      'e14e',
      
      'M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1s0 0 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5c0 0 0 0 0 0l.1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM147.9 104.1c5.5-15.4 20.1-25.7 36.4-25.7l41.3 0c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 173.4l0 .3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7l-41.3 0c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 236a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z'
      
    ]
  };

  

  
  

  var faCommentCaptions = {
    prefix: 'fal',
    iconName: 'comment-captions',
    icon: [
      512,
      512,
      [],
      'e146',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faEyeDropper = {
    prefix: 'fal',
    iconName: 'eye-dropper',
    icon: [
      512,
      512,
      ["eye-dropper-empty","eyedropper"],
      'f1fb',
      
      'M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c0 0 0 0 0 0l-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4s0 0 0 0s0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6l0 41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480l41.2 0c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L167.4 433.9c-9 9-21.2 14.1-33.9 14.1L88 448l-4.2 0-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7 0-4.2 0-45.5c0-12.7 5.1-24.9 14.1-33.9L187.3 235.3z'
      
    ]
  };

  
    var faEyeDropperEmpty = faEyeDropper;
  
    var faEyedropper = faEyeDropper;
  

  
  

  var faCloudBinary = {
    prefix: 'fal',
    iconName: 'cloud-binary',
    icon: [
      640,
      512,
      [],
      'e601',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM176 216c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 16c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-16zm40-8c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0zm72-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-8.8 0-16-7.2-16-16zm120-16l16 0c22.1 0 40 17.9 40 40l0 16c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-16c0-22.1 17.9-40 40-40zm-8 40l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zM192 320c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-8.8 0-16-7.2-16-16zm80 24c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 16c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-16zm40-8c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0zm88-32l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faOven = {
    prefix: 'fal',
    iconName: 'oven',
    icon: [
      448,
      512,
      [],
      'e01d',
      
      'M96 32C60.7 32 32 60.7 32 96l0 64 384 0 0-64c0-35.3-28.7-64-64-64L96 32zM32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256L32 192zM0 96C0 43 43 0 96 0L352 0c53 0 96 43 96 96l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM264 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 256l0 160 256 0 0-160L96 256zm-32 0c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-160zm64 48c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faDeleteLeft = {
    prefix: 'fal',
    iconName: 'delete-left',
    icon: [
      576,
      512,
      [9003,"backspace"],
      'f55a',
      
      'M544 128c0-17.7-14.3-32-32-32L205.3 96c-8.5 0-16.6 3.4-22.6 9.4L32 256 182.6 406.6c6 6 14.1 9.4 22.6 9.4L512 416c17.7 0 32-14.3 32-32l0-256zM512 64c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-306.7 0c-17 0-33.3-6.7-45.3-18.7L9.4 278.6c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6L160 82.7c12-12 28.3-18.7 45.3-18.7L512 64zM427.3 180.7c6.2 6.2 6.2 16.4 0 22.6L374.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faBackspace = faDeleteLeft;
  

  
  

  var faFaceGrin = {
    prefix: 'fal',
    iconName: 'face-grin',
    icon: [
      512,
      512,
      [128512,"grin"],
      'f580',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGrin = faFaceGrin;
  

  
  

  var faCloudSnow = {
    prefix: 'fal',
    iconName: 'cloud-snow',
    icon: [
      512,
      512,
      [127784],
      'f742',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM64 352c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16zm384 0c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16zM272 400c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32z'
      
    ]
  };

  

  
  

  var faShelves = {
    prefix: 'fal',
    iconName: 'shelves',
    icon: [
      640,
      512,
      ["inventory"],
      'f480',
      
      'M16 0c8.8 0 16 7.2 16 16l0 144 576 0 0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160 0 256 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 448l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64L0 176 0 16C0 7.2 7.2 0 16 0zM32 416l576 0 0-224L32 192l0 224zM448 32l-64 0 0 64 64 0 0-64zM384 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM128 288l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm192 0l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z'
      
    ]
  };

  
    var faInventory = faShelves;
  

  
  

  var faAnglesUpDown = {
    prefix: 'fal',
    iconName: 'angles-up-down',
    icon: [
      448,
      512,
      [],
      'e60d',
      
      'M234 19.5c-5.8-4.7-14.1-4.7-20 0L54 147.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l150-120 150 120c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5L234 19.5zm160 345c6.9-5.5 8-15.6 2.5-22.5s-15.6-8-22.5-2.5l-150 120L74 339.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5l160 128c5.8 4.7 14.1 4.7 20 0l160-128z'
      
    ]
  };

  

  
  

  var faDownload = {
    prefix: 'fal',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 313.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4 272 16zM140.1 320L64 320c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-76.1 0-32 32L448 352c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l108.1 0-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faArrowsDownToLine = {
    prefix: 'fal',
    iconName: 'arrows-down-to-line',
    icon: [
      576,
      512,
      [],
      'e4b8',
      
      'M560 448L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm11.3-164.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L464 345.4 464 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 297.4-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112zm-320-22.6c-6.2-6.2-16.4-6.2-22.6 0L144 345.4 144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 297.4L27.3 260.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faTugrikSign = {
    prefix: 'fal',
    iconName: 'tugrik-sign',
    icon: [
      384,
      512,
      [],
      'e2ba',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l160 0 0 147.5-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27 0 63-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27L176 456c0 8.8 7.2 16 16 16s16-7.2 16-16l0-123.5 115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L208 299.5l0-63 115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L208 203.5 208 64l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L192 32 16 32z'
      
    ]
  };

  

  
  

  var faBatterySlash = {
    prefix: 'fal',
    iconName: 'battery-slash',
    icon: [
      640,
      512,
      [],
      'f377',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384L112 384c-26.5 0-48-21.5-48-48l0-160c0-12 4.4-22.9 11.7-31.4L50.5 124.8C39 138.7 32 156.5 32 176l0 160c0 44.2 35.8 80 80 80l307.4 0-40.5-32zM464 96L220.6 96l40.5 32L464 128c26.5 0 48 21.5 48 48l0 150 30.7 24.3c.8-4.6 1.3-9.4 1.3-14.3l0-160c0-44.2-35.8-80-80-80zm128 96c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faClockSixThirty = {
    prefix: 'fal',
    iconName: 'clock-six-thirty',
    icon: [
      512,
      512,
      [],
      'e353',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faShip = {
    prefix: 'fal',
    iconName: 'ship',
    icon: [
      576,
      512,
      [128674],
      'f21a',
      
      'M240 0c-26.5 0-48 21.5-48 48l0 16-48 0c-26.5 0-48 21.5-48 48l0 125.3L62.7 248.1C27.9 259.3 18 303.8 44.6 328.8l88.4 82.9c6.4 6 16.6 5.7 22.6-.7s5.7-16.6-.7-22.6L66.5 305.4c-8.9-8.3-5.6-23.1 6-26.9L272 214l0 170c0 8.8 7.2 16 16 16s16-7.2 16-16l0-170 199.5 64.5c11.6 3.8 14.9 18.6 6 26.9l-88.4 82.9c-6.4 6-6.8 16.2-.7 22.6s16.2 6.8 22.6 .7l88.4-82.9c26.7-25 16.7-69.4-18.1-80.7L480 237.3 480 112c0-26.5-21.5-48-48-48l-48 0 0-16c0-26.5-21.5-48-48-48L240 0zM352 64L224 64l0-16c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 16zM192 96l16 0 160 0 16 0 48 0c8.8 0 16 7.2 16 16l0 114.9L302.8 180c-9.6-3.1-19.9-3.1-29.6 0L128 226.9 128 112c0-8.8 7.2-16 16-16l48 0zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2z'
      
    ]
  };

  

  
  

  var faGameConsoleHandheld = {
    prefix: 'fal',
    iconName: 'game-console-handheld',
    icon: [
      384,
      512,
      [],
      'f8bb',
      
      'M64 32C46.3 32 32 46.3 32 64l0 352c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-352c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 352c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 64zM96 224l192 0 0-128L96 96l0 128zM64 80c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 144c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32L64 80zM208 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16z'
      
    ]
  };

  

  
  

  var faPersonSledding = {
    prefix: 'fal',
    iconName: 'person-sledding',
    icon: [
      512,
      512,
      ["sledding"],
      'f7cb',
      
      'M392 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM1.7 248.8c4-7.9 13.6-11.1 21.5-7.1L419 440.6c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 270.3c-7.9-4-11.1-13.6-7.1-21.5zM160 144l160 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L230.6 272 344 272c13.3 0 24 10.7 24 24l0 72c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-105.4 0c-28.5 0-42.8-34.5-22.6-54.6L281.4 176 160 176c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faSledding = faPersonSledding;
  

  
  

  var faBuildingCircleXmark = {
    prefix: 'fal',
    iconName: 'building-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4d4',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 202.8c9.1-12.9 19.9-24.5 32-34.6L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm152-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-121.4 0l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z'
      
    ]
  };

  

  
  

  var faSprinkler = {
    prefix: 'fal',
    iconName: 'sprinkler',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M496 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 144A16 16 0 1 1 0 144a16 16 0 1 1 32 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm400 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 272A16 16 0 1 1 0 272a16 16 0 1 1 32 0zM96 80A16 16 0 1 1 64 80a16 16 0 1 1 32 0zM32 16A16 16 0 1 1 0 16a16 16 0 1 1 32 0zM256 64c8.8 0 16 7.2 16 16l0 176 120 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89 0 86.1c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-86.1-89-89c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l120 0 0-176c0-8.8 7.2-16 16-16zM139.3 288l75.3 75.3c6 6 9.4 14.1 9.4 22.6l0 86.1c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-86.1c0-8.5 3.4-16.6 9.4-22.6L372.7 288 256 288l-116.7 0z'
      
    ]
  };

  

  
  

  var faFaceLying = {
    prefix: 'fal',
    iconName: 'face-lying',
    icon: [
      512,
      512,
      [],
      'e37e',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.8 0 149.8-41.7 189.5-104.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1C427.3 464.3 347.2 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C373.8 0 472.9 79.5 502.8 187.7c2.3 8.5-2.6 17.3-11.2 19.7s-17.3-2.6-19.7-11.2C445.8 101.5 359 32 256 32zM152.4 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm160 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6zM288 224l160 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCloudRain = {
    prefix: 'fal',
    iconName: 'cloud-rain',
    icon: [
      512,
      512,
      [9926,127783],
      'f73d',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM82.3 451.9L96 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1l0 3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c0-3.2 .8-6.3 2.3-9.1zM54.2 436.6C50.1 444.1 48 452.5 48 461l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8L54.2 436.6zm188.1 15.3L256 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1l0 3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c0-3.2 .8-6.3 2.3-9.1zm-28.1-15.3c-4.1 7.5-6.2 15.8-6.2 24.3l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8-23.6 43.5zm201.8-10l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1l0 3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c0-3.2 .8-6.3 2.3-9.1L416 426.7zm-18.2-33.5l-23.6 43.5c-4.1 7.5-6.2 15.8-6.2 24.3l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8z'
      
    ]
  };

  

  
  

  var faShovelSnow = {
    prefix: 'fal',
    iconName: 'shovel-snow',
    icon: [
      512,
      512,
      [],
      'f7c3',
      
      'M419.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L358.9 42.5C344.2 57.1 336 77 336 97.8c0 15.8 4.7 30.5 12.8 42.8L272 217.4l-41.8-41.8c-16.4-16.4-42.3-18.7-61.4-5.5L20.6 273.3C7.7 282.3 0 297 0 312.7l0 2c0 12.7 5.1 24.9 14.1 33.9L163.3 497.9c9 9 21.2 14.1 33.9 14.1l2 0c15.7 0 30.4-7.7 39.4-20.6L341.8 343.1c13.3-19.1 11-44.9-5.5-61.4L294.6 240l76.8-76.8c12.3 8.1 27 12.8 42.8 12.8c20.7 0 40.6-8.2 55.3-22.9l37.8-37.8c6.2-6.2 6.2-16.4 0-22.6l-88-88zM381.5 65.1L408 38.6 473.4 104l-26.5 26.5c-8.7 8.7-20.4 13.5-32.7 13.5c-25.5 0-46.2-20.7-46.2-46.2c0-12.3 4.9-24 13.5-32.7zM187.2 196.4c6.4-4.4 15-3.7 20.5 1.8L313.8 304.4c5.5 5.5 6.2 14.1 1.8 20.4L212.4 473.1c-3 4.3-7.9 6.9-13.1 6.9l-2 0c-4.2 0-8.3-1.7-11.3-4.7L36.7 326.1c-3-3-4.7-7.1-4.7-11.3l0-2c0-5.2 2.6-10.1 6.9-13.1L187.2 196.4zm16.2 70.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z'
      
    ]
  };

  

  
  

  var faCableCar = {
    prefix: 'fal',
    iconName: 'cable-car',
    icon: [
      512,
      512,
      [57551,128673,"tram"],
      'f7da',
      
      'M288 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 256l0 96-128 0 0-96 48 0 32 0 48 0zm32 0l64 0c17.7 0 32 14.3 32 32l0 64-96 0 0-96zm96 128l0 64c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-64 112 0 160 0 112 0zM64 352l0-64c0-17.7 14.3-32 32-32l64 0 0 96-96 0zM416 224l-144 0 0-82.9L499.1 95.7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-240 48-240 48C4.2 162-1.4 170.5 .3 179.1s10.2 14.3 18.8 12.6L240 147.5l0 76.5L96 224c-35.3 0-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64z'
      
    ]
  };

  
    var faTram = faCableCar;
  

  
  

  var faGarage = {
    prefix: 'fal',
    iconName: 'garage',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59L640 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-320.1c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-384 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272zm32 96l384 0 0-96-384 0 0 96zm144 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSwap = {
    prefix: 'fal',
    iconName: 'swap',
    icon: [
      640,
      512,
      [],
      'e609',
      
      'M208 126.7c0 18.4-14.9 33.3-33.3 33.3L128 160l0 200c0 48.6 39.4 88 88 88s88-39.4 88-88l0-208c0-66.3 53.7-120 120-120s120 53.7 120 120l0 200 46.7 0c18.4 0 33.3 14.9 33.3 33.3c0 8.3-3.1 16.3-8.7 22.4l-75.5 83c-3 3.3-7.3 5.2-11.8 5.2s-8.8-1.9-11.8-5.2l-75.5-83c-5.6-6.1-8.7-14.1-8.7-22.4c0-18.4 14.9-33.3 33.3-33.3l46.7 0 0-200c0-48.6-39.4-88-88-88s-88 39.4-88 88l0 208c0 66.3-53.7 120-120 120s-120-53.7-120-120l0-200-46.7 0C30.9 160 16 145.1 16 126.7c0-8.3 3.1-16.3 8.7-22.4l75.5-83c3-3.3 7.3-5.2 11.8-5.2s8.8 1.9 11.8 5.2l75.5 83c5.6 6.1 8.7 14.1 8.7 22.4zM112 128s0 0 0 0s0 0 0 0l62.7 0c.7 0 1.3-.6 1.3-1.3c0-.3-.1-.6-.3-.9L112 55.8l-63.7 70c-.2 .2-.3 .6-.3 .9c0 .7 .6 1.3 1.3 1.3l62.7 0zM528 384l-62.7 0c-.7 0-1.3 .6-1.3 1.3c0 .3 .1 .6 .3 .9l63.7 70 63.7-70c.2-.2 .3-.6 .3-.9c0-.7-.6-1.3-1.3-1.3L528 384z'
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fal',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      'M10.5 33c6.3-2.3 13.4-.4 17.7 4.7L352 420.3 352 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 6.7-4.2 12.7-10.5 15s-13.4 .4-17.7-4.7L32 91.7 32 464c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 48c0-6.7 4.2-12.7 10.5-15z'
      
    ]
  };

  

  
  

  var faPeoplePulling = {
    prefix: 'fal',
    iconName: 'people-pulling',
    icon: [
      576,
      512,
      [],
      'e535',
      
      'M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm9.5 113.3c-.9 2-1.5 4.3-1.5 6.7l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 176c0-26.5 21.5-48 48-48l62.6 0c16.7 0 32.9 5.2 46.5 14.9l121.7 86.8c11.8-33.4 35.5-61.5 66.9-78.6l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L443.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L465.9 393 365.4 305.8c-14.4-12.5-20.1-32.4-14.4-50.6l26.6-85c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.3 9.2c-.2 1-.5 1.9-.9 2.8c-.8 2-2.1 3.7-3.5 5.1c-3.3 3.2-7.8 4.9-12.5 4.5c-1.9-.2-3.8-.6-5.5-1.5c-1-.5-1.9-1-2.7-1.6L148.2 175.9l75.3 316.4c2 8.6-3.3 17.2-11.9 19.3s-17.2-3.3-19.3-11.9L157.3 352l-56.4 0 26.9 141c1.7 8.7-4 17.1-12.7 18.7s-17.1-4-18.7-12.7L33.5 169.3zm79-5.6c-.3-1.2-.4-2.5-.4-3.7c-.5 0-.9 0-1.4 0l-46.3 0L94.8 320l54.9 0L112.4 163.7zM480 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 400 56zM381.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3L381.5 264.8zm-6.4 88.9c7.9 4 11.1 13.6 7.2 21.5l-30.8 61.7c-1.5 3.1-3.6 5.9-6 8.3l-62.2 62.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2z'
      
    ]
  };

  

  
  

  var faEyeEvil = {
    prefix: 'fal',
    iconName: 'eye-evil',
    icon: [
      640,
      512,
      [],
      'f6db',
      
      'M258.1 126.1c-11.2 3.2-21.8 7.3-31.7 12.1c-8.6 4.1-18.4 4.8-27.4 2l-55.9-17.5L161.7 151c8.3 12.6 8.2 29-.2 41.5c-4.5 6.7-8.3 13.7-11.3 20.8c-4.1 9.7-12 17.2-21.9 20.7L66.5 256l61.8 22.1c9.9 3.5 17.8 11 21.9 20.7c3 7.1 6.8 14.1 11.3 20.8c8.4 12.5 8.5 28.9 .2 41.5l-18.6 28.3L199 371.8c9.1-2.8 18.9-2.1 27.4 2c9.9 4.8 20.5 8.8 31.7 12.1c8.9 2.6 16.5 8.3 21.3 16.1L320 467l40.6-64.9c4.9-7.8 12.5-13.6 21.3-16.1c11.2-3.2 21.8-7.3 31.7-12.1c8.6-4.1 18.4-4.8 27.4-2l55.9 17.5L478.3 361c-8.3-12.6-8.2-29 .2-41.5c4.5-6.7 8.3-13.7 11.3-20.8c4.1-9.7 12-17.2 21.9-20.7L573.5 256l-61.8-22.1c-9.9-3.5-17.8-11-21.9-20.7c-3-7.1-6.8-14.1-11.3-20.8c-8.4-12.5-8.5-28.9-.2-41.5l18.6-28.3L441 140.2c-9.1 2.8-18.9 2.1-27.4-2c-9.9-4.8-20.5-8.8-31.7-12.1c-8.9-2.6-16.5-8.3-21.3-16.1L320 45l-40.6 64.9c-4.9 7.8-12.5 13.6-21.3 16.1zM0 256c0-9.6 6-18.2 15.1-21.4l100.6-35.9c4-9.4 8.9-18.5 14.7-27.1L89.2 108.8c-5.3-8-4.9-18.5 .8-26.1s15.7-10.9 24.9-8l95.3 29.8c11.8-5.7 24.4-10.5 37.5-14.3l47.8-76.5C300.8 5.1 310 0 320 0s19.2 5.1 24.5 13.6l47.8 76.5c13.1 3.8 25.7 8.6 37.5 14.3l95.3-29.8c9.2-2.9 19.1 .3 24.9 8s6.1 18.1 .8 26.1l-41.3 62.7c5.8 8.6 10.7 17.7 14.7 27.1l100.6 35.9c9 3.2 15.1 11.8 15.1 21.4s-6 18.2-15.1 21.4L524.3 313.3c-4 9.4-8.9 18.5-14.7 27.1l41.3 62.7c5.3 8 4.9 18.5-.8 26.1s-15.7 10.9-24.9 8l-95.3-29.8c-11.8 5.7-24.4 10.5-37.5 14.3l-47.8 76.5C339.2 506.9 330 512 320 512s-19.2-5.1-24.5-13.6l-47.8-76.5c-13.1-3.8-25.7-8.6-37.5-14.3l-95.3 29.8c-9.2 2.9-19.1-.3-24.9-8s-6.1-18.1-.8-26.1l41.3-62.7c-5.8-8.6-10.7-17.7-14.7-27.1L15.1 277.4C6 274.2 0 265.6 0 256zm249.2-21.5c-.8 4.3-1.2 8.8-1.2 13.5c0 39.8 32.2 72 72 72s72-32.2 72-72c0-4.6-.4-9.1-1.2-13.5l-.4 .1c-13.6 5.3-27.9 9.2-42.7 11.3c.2 3-.2 6.1-1.4 9.3c-5.5 14.4-13.5 24.4-18.1 29.3c-2.1 2.3-5.1 3.4-8.2 3.4s-6.1-1.1-8.2-3.4c-4.5-4.9-12.6-14.9-18.1-29.3c-1.2-3.2-1.6-6.3-1.4-9.3c-14.8-2.1-29.1-6-42.7-11.3l-.4-.1zM220.1 219c4.9-16.8 25-20.6 41.3-14.1c18.2 7.2 37.9 11.1 58.6 11.1s40.5-3.9 58.6-11.1c16.3-6.4 36.4-2.7 41.3 14.1c2.7 9.2 4.1 18.9 4.1 29c0 57.4-46.6 104-104 104s-104-46.6-104-104c0-10 1.4-19.8 4.1-29z'
      
    ]
  };

  

  
  

  var faUserHair = {
    prefix: 'fal',
    iconName: 'user-hair',
    icon: [
      448,
      512,
      [],
      'e45a',
      
      'M320 128c0-5.5-.5-10.8-1.3-16l-30.1 0c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM307.2 80C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64l28.9 0c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7l18.6 0zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zM32 480L416 480c-1.9-71-60-128-131.5-128l-120.9 0C92.1 352 33.9 409 32 480zM0 483.6C0 393.2 73.2 320 163.6 320l120.9 0C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6z'
      
    ]
  };

  

  
  

  var faShuttlecock = {
    prefix: 'fal',
    iconName: 'shuttlecock',
    icon: [
      512,
      512,
      [],
      'f45b',
      
      'M241.9 0c-12.1 0-23.2 6.8-28.6 17.7L92.2 259.8 73.4 278.6 33.1 318.9C11.9 340.1 0 368.9 0 398.9C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l40.2-40.2 18.9-18.9 242.1-121c10.8-5.4 17.7-16.5 17.7-28.6l0-46.1c0-17.7-14.3-32-32-32l-56 0 0-72c0-17.7-14.3-32-32-32l-72 0 0-56c0-17.7-14.3-32-32-32L241.9 0zm67.2 355.6l-75.7 37.8c0 0 0 0 0 0l-46.1-46.1 77.2-77.2 103-32.5-58.4 118zm47.5-23.7l53.3-107.6 .6-.2 69.5 0 0 46.1L356.5 331.8zM288 101.5l-.2 .6L180.2 155.5 241.9 32 288 32l0 69.5zm-13.6 43l-32.5 103-77.2 77.2-46.1-46.1c0 0 0 0 0 0l37.8-75.7 118-58.4zm6.1 87L315.7 120l76.3 0 0 76.3L280.5 231.5zM61.9 335.3L96 301.3 210.7 416l-34.1 34.1L61.9 335.3zm89.7 135c-11.7 6.3-24.9 9.7-38.5 9.7C68.3 480 32 443.7 32 398.9c0-13.6 3.4-26.8 9.7-38.5L151.6 470.3z'
      
    ]
  };

  

  
  

  var faCalculator = {
    prefix: 'fal',
    iconName: 'calculator',
    icon: [
      384,
      512,
      [128425],
      'f1ec',
      
      'M352 160l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288 320 0zm0-32L32 128l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64zm32 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64l0 64 0 16 0 16L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288 0-16 0-16zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 400z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fal',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M160 64l352 0c17.7 0 32 14.3 32 32l0 105.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4 128 96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64l0 208 0 16c0 35.3 28.7 64 64 64l80 0c0 0 0 0 0 0l272 0c35.3 0 64-28.7 64-64l0-80c0 0 0 0 0-.1l0-144zM464 166.6l80 80 0 73.4c0 17.7-14.3 32-32 32l-233.4 0 36.7-36.7L464 166.6zM281.4 304l-48 48L160 352c-17.7 0-32-14.3-32-32l0-9.4 80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 352c0 70.7 57.3 128 128 128l336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-336 0c-53 0-96-43-96-96l0-240zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faVenusDouble = {
    prefix: 'fal',
    iconName: 'venus-double',
    icon: [
      640,
      512,
      [9890],
      'f226',
      
      'M192 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM368 176c0 91.8-70.3 167.2-160 175.3l0 64.7 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64.7C86.3 343.2 16 267.8 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c7.3-7.8 14-16.2 20-25c23.6 17 52.6 27 84 27c79.5 0 144-64.5 144-144s-64.5-144-144-144c-31.3 0-60.3 10-84 27c-6-8.9-12.7-17.2-20-25C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 91.8-70.3 167.2-160 175.3l0 64.7 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64.7c-32.7-3-62.9-14.9-88-33.3z'
      
    ]
  };

  

  
  

  var faRightFromLine = {
    prefix: 'fal',
    iconName: 'right-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-left"],
      'f347',
      
      'M415.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L283.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L415.2 254.2zM448 256c0-9.5-3.9-18.6-10.8-25.1L305.2 106.5C298 99.8 288.5 96 278.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.3-3.8 26.5-10.5L437.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80z'
      
    ]
  };

  
    var faArrowAltFromLeft = faRightFromLine;
  

  
  

  var faPersonHiking = {
    prefix: 'fal',
    iconName: 'person-hiking',
    icon: [
      384,
      512,
      ["hiking"],
      'f6ec',
      
      'M288 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 208 56zM102.9 128.4c-19 2.5-35 16.1-40.1 35L40.2 246.3l31.9 5.3 30.8-123.2zm-1.5 138.1c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59l4.2 0c15.6 0 27.1 14.7 23.3 29.8L101.4 266.5zM368 160c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240-39.2 0c-10.9 0-21.1-5.6-27-14.8l-20.7-32.5L237.2 333.5l36.6 24.4c8.9 5.9 14.2 15.9 14.2 26.6L288 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-111.4-95-63.3c-16.3-10.8-24.3-30.4-20.4-49.6l19.8-96.5c6.1-29.9 35.1-49.3 65-43.7c20.6 3.9 38.7 16.1 50 33.8L312.8 224l39.2 0 0-48c0-8.8 7.2-16 16-16zM123.7 334.8c.5 .4 1.1 .8 1.6 1.1l26.4 17.6L111.4 500.2c-2.3 8.5-11.1 13.5-19.7 11.2s-13.5-11.2-11.2-19.7l43.2-157zm68.1-153.2L172 278.1c-1.3 6.4 1.4 12.9 6.8 16.5l29.8 19.9L240.3 173c-5.8-5.1-13-8.6-20.7-10c-12.8-2.4-25.1 5.9-27.8 18.6z'
      
    ]
  };

  
    var faHiking = faPersonHiking;
  

  
  

  var faClosedCaptioning = {
    prefix: 'fal',
    iconName: 'closed-captioning',
    icon: [
      576,
      512,
      [],
      'f20a',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm200 96c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3c6.3-6.2 16.4-6.1 22.6 .2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4c-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C233.2 199 217.4 192 200 192zm192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3c6.3-6.2 16.4-6.1 22.6 .2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4c-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C425.2 199 409.4 192 392 192z'
      
    ]
  };

  

  
  

  var faBadminton = {
    prefix: 'fal',
    iconName: 'badminton',
    icon: [
      576,
      512,
      [],
      'e33a',
      
      'M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7c7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3c72.5 39.4 169.9 17.5 234.7-47.4c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32L64 480 32 448l72-72zm352.9 88l-8.2 27.4c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7l11-36.6-33.4 0zM496 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32-32 0 0 32zm37.7-32l11 36.6c2.5 8.5 11.5 13.3 19.9 10.7s13.3-11.5 10.7-19.9L567.1 464l-33.4 0zM496 400c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16-32 0 0-16zm64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 16 0 32 32 0 32 0 32 0 0-32 0-16z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleExclamation = {
    prefix: 'fal',
    iconName: 'house-medical-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e512',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l250.8 0c-12.9-9.1-24.5-19.9-34.6-32L144 480c-26.5 0-48-21.5-48-48l0-225.3L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64l-12 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48 32 0 0 48c0 8.8 7.2 16 16 16l28.5 0c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faGearComplexCode = {
    prefix: 'fal',
    iconName: 'gear-complex-code',
    icon: [
      512,
      512,
      [],
      'e5eb',
      
      'M215 62.8l4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8C232.9 32.9 244.4 32 256 32s23.1 .9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8L297 62.8c2.9 14.4 13.2 25.2 25.5 30.3c0 0 0 0 0 0l1.5 .6c0 0 0 0 0 0c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3c9.1 6.7 17.7 14 25.6 21.9l.8 .8s0 0 0 0c7.9 8 15.3 16.5 21.9 25.6c-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5c0 0 0 0 0 0l.6 1.5c0 0 0 0 0 0c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5 .3 2.8 1 3.8 1.9c1.7 11.1 2.6 22.4 2.6 34l0 .4c0 11.6-.9 22.9-2.6 34c-1.1 1-2.4 1.6-3.8 1.9L449.2 297c-14.4 2.9-25.2 13.2-30.3 25.5c0 0 0 0 0 0l-.6 1.5c0 0 0 0 0 0c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1c-13.6 18.5-29.9 34.9-48.4 48.4c-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3c0 0 0 0 0 0l-1.5 .6c0 0 0 0 0 0c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8c-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8L215 449.2c-2.9-14.4-13.2-25.2-25.5-30.3c0 0 0 0 0 0l-1.5-.6c0 0 0 0 0 0c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2 .8-2.6 1.3-4.1 1.3c-18.5-13.6-34.9-29.9-48.4-48.4c.1-1.4 .5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5c0 0 0 0 0 0l-.6-1.5c0 0 0 0 0 0c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9C32.9 279.1 32 267.6 32 256s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9L62.8 215c14.4-2.9 25.2-13.2 30.3-25.5c0 0 0 0 0 0l.6-1.5c0 0 0 0 0 0c5.2-12.3 4.8-27.3-3.3-39.5L76.6 127.7c-.8-1.2-1.3-2.6-1.3-4.1c6.7-9.1 14-17.7 22-25.7l.8-.8s0 0 0 0c8-7.9 16.6-15.3 25.7-22c1.4 .1 2.8 .5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3c0 0 0 0 0 0l1.5-.6c0 0 0 0 0 0c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7c-2 .3-3.9 1-5.6 2.1c-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9c0 0 0 0 0 0c0 0 0 0-.1 0l-1.7 .7s0 0 0 0c0 0 0 0-.1 0c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6c-1.9 .5-3.8 1.3-5.4 2.5C96.6 55.2 85.6 64.4 75.4 74.5c0 0 0 0 0 0l-.8 .8c0 0 0 0 0 0C64.4 85.6 55.2 96.6 46.9 108.3c-1.2 1.6-2 3.5-2.5 5.4c-2.6 10.6-.8 22.1 5.6 31.7l13.8 20.6c1.5 2.2 2 5.7 .4 9.4c0 0 0 0 0 .1l-.7 1.7s0 0 0 0c0 0 0 0 0 .1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6c-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6c5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6 .5 5.4 2.6 6.9 6.3c0 0 0 0 0 .1l.7 1.7c0 0 0 0 0 .1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7c.5 1.9 1.3 3.8 2.5 5.4c16.8 23.8 37.6 44.6 61.5 61.5c1.6 1.2 3.5 2 5.4 2.5c10.6 2.6 22.1 .8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4c0 0 0 0 .1 0l1.7 .7c0 0 0 0 .1 0c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4c1.7 1 3.6 1.7 5.6 2.1c14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1c9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9c0 0 0 0 .1 0l1.7-.7c0 0 0 0 .1 0c3.7-1.5 7.1-1 9.4 .4L366.5 462c9.6 6.4 21.2 8.2 31.7 5.6c1.9-.5 3.8-1.3 5.4-2.5c23.8-16.8 44.6-37.6 61.5-61.4c1.2-1.6 2-3.5 2.5-5.4c2.6-10.6 .8-22.1-5.6-31.7l-13.8-20.6c-1.5-2.2-2-5.7-.4-9.4c0 0 0 0 0-.1l.7-1.7c0 0 0 0 0-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6c1-1.7 1.7-3.6 2.1-5.6c2.4-14 3.7-28.5 3.7-43.2c0 0 0 0 0 0l0-.4s0 0 0 0c0-14.7-1.3-29.1-3.7-43.2c-.3-2-1-3.9-2.1-5.6c-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3c0 0 0 0 0-.1l-.7-1.7c0 0 0 0 0-.1c-1.5-3.7-1-7.1 .4-9.4L462 145.5c6.4-9.6 8.2-21.2 5.6-31.7c-.5-1.9-1.3-3.8-2.5-5.4c-8.3-11.7-17.5-22.7-27.6-32.9c0 0 0 0 0 0l-.9-.9c0 0 0 0 0 0c-10.1-10.1-21.1-19.3-32.9-27.6c-1.6-1.2-3.5-2-5.4-2.5c-10.6-2.6-22.1-.8-31.7 5.6L345.9 63.7c-2.2 1.5-5.7 2-9.4 .4c0 0 0 0-.1 0l-1.7-.7c0 0 0 0-.1 0c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4c-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zm31.8 162.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z'
      
    ]
  };

  

  
  

  var faCirclePhoneHangup = {
    prefix: 'fal',
    iconName: 'circle-phone-hangup',
    icon: [
      512,
      512,
      ["phone-circle-down"],
      'e11d',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM112 248.6c.1-.5 .3-1.2 1.1-1.9c78.8-72.9 207-72.9 285.7 0c.8 .7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7c-37-11.9-77.4-11.9-114.3 0c-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9l-21.7-35.2c-.4-.7-.5-1.2-.4-1.8zm308.6-25.4c-91-84.3-238.2-84.3-329.2 0c-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9c0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1 .5-.1 .7c-1.8 16.6 8.5 31.3 23.3 36.9L359 317.5c16.6 6.3 36.4 .6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z'
      
    ]
  };

  
    var faPhoneCircleDown = faCirclePhoneHangup;
  

  
  

  var faCompressWide = {
    prefix: 'fal',
    iconName: 'compress-wide',
    icon: [
      512,
      512,
      [],
      'f326',
      
      'M128 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-112zm16 208c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112L16 320c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0zM352 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-128zM496 288c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l128 0z'
      
    ]
  };

  

  
  

  var faFaceSpiralEyes = {
    prefix: 'fal',
    iconName: 'face-spiral-eyes',
    icon: [
      512,
      512,
      [],
      'e485',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.9 374.9l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-139-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM349.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z'
      
    ]
  };

  

  
  

  var faArrowUpFromArc = {
    prefix: 'fal',
    iconName: 'arrow-up-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b4',
      
      'M256 480C132.3 480 32 379.7 32 256c0-8.8-7.2-16-16-16s-16 7.2-16 16C0 397.4 114.6 512 256 512s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224zM116 149.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 58.1 240 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-277.9L372 170.6c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4l-128 144z'
      
    ]
  };

  

  
  

  var faLightbulbMessage = {
    prefix: 'fal',
    iconName: 'lightbulb-message',
    icon: [
      576,
      512,
      [],
      'e687',
      
      'M327.8 224c5.3-15 8.2-31.1 8.2-48c0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19c0 0 0 0 0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 16.6-2.3 32.7-6.6 48l-33.6 0zM256 416l0 2c0 14.2 4.6 27.2 12.4 37.8C258.2 488.4 227.9 512 192 512c-44.2 0-80-35.8-80-80l0-5.3c0-5.9 4.8-10.7 10.7-10.7l69.3 0 64 0zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80zm80 304c20.9 0 38.7-13.4 45.3-32l-90.5 0c6.6 18.6 24.4 32 45.3 32zM320 256l224 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0 0 48c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L393.4 448 320 448c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32zm0 32l0 128 80 0c4.2 0 8.3 1.7 11.3 4.7L448 457.4l0-25.4c0-8.8 7.2-16 16-16l80 0 0-128-224 0z'
      
    ]
  };

  

  
  

  var faPipeValve = {
    prefix: 'fal',
    iconName: 'pipe-valve',
    icon: [
      512,
      512,
      [],
      'e439',
      
      'M272 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 80L32 192l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32L0 432l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 448 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-224 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-208 0 0-80 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-48zM256 224l224 0 0 192L32 416l0-192 224 0z'
      
    ]
  };

  

  
  

  var faClockFiveThirty = {
    prefix: 'fal',
    iconName: 'clock-five-thirty',
    icon: [
      512,
      512,
      [],
      'e34a',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400l0-91.2 34.7 52c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-64-96c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faPersonRifle = {
    prefix: 'fal',
    iconName: 'person-rifle',
    icon: [
      576,
      512,
      [],
      'e54e',
      
      'M260.7 192c28.3 0 55.1 10.7 75.3 29.1l0 275.1c-.1 8.7-7.2 15.8-16 15.8c-8.8 0-16-7.2-16-16l0-259.3c-12.7-8.2-27.7-12.7-43.3-12.7l-41.3 0c-15.7 0-30.7 4.6-43.3 12.8L176 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-220.2L62.3 439.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l85.5-170.9c19-37.9 57.8-61.9 100.2-61.9l41.3 0zM288 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM480 336l0 14.2 3.9 17.8 7.1 0 36.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-4.2 0-32.8 0 7.1 32 9.1 41.1 4.3 19.5c1.1 4.7-.1 9.7-3.1 13.5s-7.6 6-12.5 6l-19.9 0L416 512l-16 0c-8.8 0-16-7.2-16-16l0-16 0-86.1-2.7-1.4c-8.1-4.1-13.3-12.4-13.3-21.5l0-4.9 0-140.2 0-4.9c0-9.1 5.1-17.4 13.3-21.5l2.7-1.4 0-38.1c0-17.7 14.3-32 32-32l0-32 0-32 0-32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16 0 64 0 32c17.7 0 32 14.3 32 32l0 48 0 47 0 1 0 24 0 8 32-8 0-24 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 72 0 12.5c0 6.9-4.4 13-10.9 15.2l-.9 .3L480 325.3l0 10.7zm-27.3 38.9l-1.5-6.9-2.4-10.8-.4-1.7s0 0 0 0c-.3-1.1-.4-2.3-.4-3.5l0-1.8 0-14.2 0-7 0-3.7 0-23.1 0-6.3 0-8 0-32 0-48 0-16 0-32-32 0 0 32 0 6.1 0 9.9c0 6-3.4 11.6-8.8 14.3c0 0 0 0 0 0l-7.2 3.6 0 140.2 7.2 3.6c0 0 0 0 0 0c5.4 2.7 8.8 8.2 8.8 14.3l0 9.9 0 54.1 0 32 27.3 0 4.7 0 28.1 0-7.1-32-9.1-41.1-1.5-6.9-5.6-25.1z'
      
    ]
  };

  

  
  

  var faDiagramNext = {
    prefix: 'fal',
    iconName: 'diagram-next',
    icon: [
      512,
      512,
      [],
      'e476',
      
      'M480 160c0 17.7-14.3 32-32 32l-176 0-32 0L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 64zM272 224l176 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l176 0 0 105.4-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4 272 224zM448 480c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0z'
      
    ]
  };

  

  
  

  var faChartTreeMap = {
    prefix: 'fal',
    iconName: 'chart-tree-map',
    icon: [
      512,
      512,
      [],
      'e0ea',
      
      'M176 64c8.8 0 16 7.2 16 16l0 112c0 8.8-7.2 16-16 16L48 208c-8.8 0-16-7.2-16-16L32 80c0-8.8 7.2-16 16-16l128 0zM48 32C21.5 32 0 53.5 0 80L0 192c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 32zM176 304c8.8 0 16 7.2 16 16l0 112c0 8.8-7.2 16-16 16L48 448c-8.8 0-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16l128 0zM48 272c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 272zM304 64l160 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 80l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L304 32c-26.5 0-48 21.5-48 48zM464 224c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l160 0zM304 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0zm0 192l160 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm-48 16l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faTty = {
    prefix: 'fal',
    iconName: 'tty',
    icon: [
      512,
      512,
      ["teletype"],
      'f1e4',
      
      'M352 164.8l0 29.7c0 8.1 6.1 14.9 14.1 15.9l80.7 9.5c7.3 .9 14.2-3.3 16.8-10.1L473.9 183c6.4-16.6 2.5-31.1-6.1-38.7C426.2 107.6 352.1 64 256 64s-170.2 43.6-211.9 80.3c-8.6 7.6-12.5 22.1-6.1 38.7l10.4 26.8c2.6 6.8 9.5 11 16.8 10.1l80.7-9.5c8.1-.9 14.1-7.8 14.1-15.9l0-29.7c0-12.9 7.7-24.5 19.6-29.5c48.9-20.5 103.9-20.5 152.7 0c11.9 5 19.6 16.6 19.6 29.5zm-32 29.7l0-29.7c-40.9-17.2-87.1-17.2-128 0l0 29.7c0 24.3-18.2 44.8-42.4 47.7l-80.7 9.5c-21.7 2.6-42.5-9.9-50.4-30.3L8.2 194.5c-10.1-26-6.2-55.8 14.8-74.2C68.7 79.9 150 32 256 32s187.3 47.9 233 88.3c20.9 18.4 24.8 48.2 14.8 74.2l-10.4 26.8c-7.9 20.4-28.6 32.9-50.4 30.3l-80.7-9.5c-24.2-2.8-42.4-23.3-42.4-47.7zM72 291.2l32 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-32 0c-15.9 0-28.8-12.9-28.8-28.8l0-32c0-15.9 12.9-28.8 28.8-28.8zM68.8 320l0 32c0 1.8 1.4 3.2 3.2 3.2l32 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-32 0c-1.8 0-3.2 1.4-3.2 3.2zM72 403.2l32 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-32 0c-15.9 0-28.8-12.9-28.8-28.8l0-32c0-15.9 12.9-28.8 28.8-28.8zM68.8 432l0 32c0 1.8 1.4 3.2 3.2 3.2l32 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-32 0c-1.8 0-3.2 1.4-3.2 3.2zM408 403.2l32 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-32 0c-15.9 0-28.8-12.9-28.8-28.8l0-32c0-15.9 12.9-28.8 28.8-28.8zM404.8 432l0 32c0 1.8 1.4 3.2 3.2 3.2l32 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-32 0c-1.8 0-3.2 1.4-3.2 3.2zm-249.6 0c0-15.9 12.9-28.8 28.8-28.8l144 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-144 0c-15.9 0-28.8-12.9-28.8-28.8l0-32zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2l0 32c0 1.8 1.4 3.2 3.2 3.2l144 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-144 0zM155.2 320c0-15.9 12.9-28.8 28.8-28.8l32 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-32 0c-15.9 0-28.8-12.9-28.8-28.8l0-32zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2l0 32c0 1.8 1.4 3.2 3.2 3.2l32 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-32 0zm112-25.6l32 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-32 0c-15.9 0-28.8-12.9-28.8-28.8l0-32c0-15.9 12.9-28.8 28.8-28.8zM292.8 320l0 32c0 1.8 1.4 3.2 3.2 3.2l32 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-32 0c-1.8 0-3.2 1.4-3.2 3.2zm86.4 0c0-15.9 12.9-28.8 28.8-28.8l32 0c15.9 0 28.8 12.9 28.8 28.8l0 32c0 15.9-12.9 28.8-28.8 28.8l-32 0c-15.9 0-28.8-12.9-28.8-28.8l0-32zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2l0 32c0 1.8 1.4 3.2 3.2 3.2l32 0c1.8 0 3.2-1.4 3.2-3.2l0-32c0-1.8-1.4-3.2-3.2-3.2l-32 0z'
      
    ]
  };

  
    var faTeletype = faTty;
  

  
  

  var faLaptopFile = {
    prefix: 'fal',
    iconName: 'laptop-file',
    icon: [
      640,
      512,
      [],
      'e51d',
      
      'M448 32L128 32c-17.7 0-32 14.3-32 32l0 224 224 0 0 32L96 320l-32 0-30.1 0c5.5 18.5 22.7 32 42.9 32L320 352l0 32L76.8 384C34.4 384 0 349.6 0 307.2C0 296.6 8.6 288 19.2 288L64 288 64 64C64 28.7 92.7 0 128 0L448 0c35.3 0 64 28.7 64 64l0 32-32 0 0-32c0-17.7-14.3-32-32-32zM384 464c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-176-80 0c-26.5 0-48-21.5-48-48l0-80-80 0c-8.8 0-16 7.2-16 16l0 288zM512 160.5l0 79.5c0 8.8 7.2 16 16 16l79.5 0c-.7-2.8-2.1-5.4-4.2-7.4l-83.9-83.9c-2.1-2.1-4.6-3.5-7.4-4.2zm30.1-18.4l83.9 83.9c9 9 14.1 21.2 14.1 33.9L640 464c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l108.1 0c12.7 0 24.9 5.1 33.9 14.1z'
      
    ]
  };

  

  
  

  var faFlagUsa = {
    prefix: 'fal',
    iconName: 'flag-usa',
    icon: [
      448,
      512,
      [],
      'f74d',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 64 0 367l0 33 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-104 96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56l0-40zm0 298.6l107.1-23c33.6-7.2 68.6-4.4 100.7 8.1l25.8 10c45.2 17.6 95.1 18.8 141.2 3.5l9.2-3.1 0 35.6-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359l0-44.4zm0-32.7l0-39.3 102.2-21.9c36.4-7.8 74.3-3.9 108.4 11.3l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9l0 34.4-19.3 6.4c-38.9 13-81.2 11.9-119.4-2.9l-25.8-10c-37.9-14.7-79.2-18-119-9.5L32 281.9zm0-72L32 89 140.7 61.8c6.4-1.6 12.8-2.7 19.3-3.3l0 126.7c-10.9 .6-21.7 2-32.5 4.3L32 209.9zm160-24l0-47.8c17.4 2.1 34.4 6.7 50.6 13.9l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9l0 45.7-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zm0-80l0-46.6c13.9 2 27.4 6.2 40.1 12.6c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1 0 59.9-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zM88 120a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM88 168a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCitrus = {
    prefix: 'fal',
    iconName: 'citrus',
    icon: [
      512,
      512,
      [],
      'e2f4',
      
      'M384 96c35.3 0 64-28.7 64-64l-64 0c-35.3 0-64 28.7-64 64l64 0zm0 32l-80 0c-8.8 0-16-7.2-16-16l0-16c0-10 1.5-19.7 4.4-28.8c-11.8-2.1-24-3.2-36.4-3.2C141.1 64 48 157.1 48 272s93.1 208 208 208s208-93.1 208-208c0-44.3-13.9-85.5-37.5-119.2c10.3-3.6 20-8.5 28.9-14.5C481 176.5 496 222.5 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272S123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C325.3 14.7 353 0 384 0l80 0c8.8 0 16 7.2 16 16l0 16c0 53-43 96-96 96z'
      
    ]
  };

  

  
  

  var faLightsHoliday = {
    prefix: 'fal',
    iconName: 'lights-holiday',
    icon: [
      640,
      512,
      [],
      'f7b2',
      
      'M23.8 66C16 61.7 6.3 64.5 2 72.2S.5 89.7 8.2 94l13.5 7.5C109.7 150.4 208.7 176 309.3 176l10.7 0 10.7 0c100.6 0 199.6-25.6 287.5-74.5L631.8 94c7.7-4.3 10.5-14 6.2-21.8s-14-10.5-21.8-6.2l-13.5 7.5c-83.2 46.2-176.8 70.5-272 70.5L320 144l-10.7 0c-95.2 0-188.8-24.3-272-70.5L23.8 66zm99.8 156.2C86.7 217 50 238.2 37 274.6C20.9 319.9 46.9 414 69.5 422s102.2-48.6 118.3-93.8c13-36.5-2.1-76.1-34-95.3l14.6-41.1c-10.4-2.4-20.8-5.1-31.1-8.1l-13.7 38.4zM304 257.6c-36.5 7.4-64 39.7-64 78.4c0 48 56 128 80 128s80-80 80-128c0-38.7-27.5-71-64-78.4l0-49.6c-1.8 0-3.5 0-5.3 0L320 208l-10.7 0c-1.8 0-3.5 0-5.3 0l0 49.6zM486.3 233c-31.9 19.2-47 58.9-34 95.3c16.1 45.2 95.7 101.8 118.3 93.8s48.6-102.2 32.5-147.4c-13-36.5-49.7-57.7-86.6-52.4l-13.7-38.4c-10.3 3-20.7 5.6-31.1 8.1L486.3 233zM128.5 256.2c25 8.9 38 36.3 29.1 61.3c-4.9 13.7-22.6 34.4-45.9 52.1c-11 8.4-21.5 14.7-29.6 18.3l-.6 .3-.3-.6c-4-7.9-8.1-19.4-11.4-32.8c-6.9-28.4-7.5-55.7-2.7-69.4c8.9-25 36.3-38 61.3-29.1zM320 288c26.5 0 48 21.5 48 48c0 14.5-9.8 40-25.8 64.5c-7.6 11.6-15.3 21-21.7 27.1l-.5 .5-.5-.5c-6.4-6.1-14.2-15.6-21.7-27.1c-16-24.5-25.8-50-25.8-64.5c0-26.5 21.5-48 48-48zm-6.5 145.2c0 0 .1-.1 .2-.1l-.2 .1c-.1 0-.1 .1-.1 .1c0 0 0 0 .1 0zm12.8-.1c.2 .1 .3 .1 .3 .1s-.1-.1-.3-.1zM572.9 285.4c4.9 13.7 4.2 41-2.7 69.4c-3.2 13.4-7.4 24.9-11.4 32.8l-.3 .6-.6-.3c-8.1-3.6-18.6-9.9-29.6-18.3c-23.3-17.7-41-38.5-45.9-52.1c-8.9-25 4.2-52.4 29.1-61.3s52.4 4.2 61.3 29.1z'
      
    ]
  };

  

  
  

  var faPipeCollar = {
    prefix: 'fal',
    iconName: 'pipe-collar',
    icon: [
      512,
      512,
      [],
      'e437',
      
      'M68.3 166.3c5.9-12.2 3.4-26.8-6.2-36.4l-16-16c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0l16 16c9.6 9.6 24.2 12.1 36.4 6.2C193.5 55.3 223.8 48 256 48s62.5 7.3 89.7 20.3c12.2 5.9 26.8 3.4 36.4-6.2l16-16c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-16 16c-9.6 9.6-12.1 24.2-6.2 36.4c13 27.1 20.3 57.5 20.3 89.7s-7.3 62.5-20.3 89.7c-5.9 12.2-3.4 26.8 6.2 36.4l16 16c18.7 18.7 18.7 49.1 0 67.9s-49.1 18.7-67.9 0l-16-16c-9.6-9.6-24.2-12.1-36.4-6.2c-27.1 13-57.5 20.3-89.7 20.3s-62.5-7.3-89.7-20.3c-12.2-5.9-26.8-3.4-36.4 6.2l-16 16c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l16-16c9.6-9.6 12.1-24.2 6.2-36.4C55.3 318.5 48 288.2 48 256s7.3-62.5 20.3-89.7zM136.6 23.4C105.3-7.8 54.7-7.8 23.4 23.4s-31.2 81.9 0 113.1l16 16C24.4 183.9 16 218.9 16 256s8.4 72.1 23.4 103.5l-16 16c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l16-16c31.3 15 66.4 23.4 103.5 23.4s72.1-8.4 103.5-23.4l16 16c31.2 31.2 81.9 31.2 113.1 0s31.2-81.9 0-113.1l-16-16c15-31.3 23.4-66.4 23.4-103.5s-8.4-72.1-23.4-103.5l16-16c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-16 16C328.1 24.4 293.1 16 256 16s-72.1 8.4-103.5 23.4l-16-16zM128 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM448 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faPersonDressSimple = {
    prefix: 'fal',
    iconName: 'person-dress-simple',
    icon: [
      256,
      512,
      [],
      'e21c',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM81.5 215.2L42.4 352l171.2 0L174.5 215.2C170.6 201.5 158 192 143.7 192l-31.4 0c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L192 384l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-64 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-21.6 0c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z'
      
    ]
  };

  

  
  

  var faCircleB = {
    prefix: 'fal',
    iconName: 'circle-b',
    icon: [
      512,
      512,
      [],
      'e0fd',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 160l0 96 0 96c0 17.7 14.3 32 32 32l104 0c39.8 0 72-32.2 72-72c0-26.6-14.4-49.8-35.9-62.3C344.4 236.8 352 219.3 352 200c0-39.8-32.2-72-72-72l-88 0c-17.7 0-32 14.3-32 32zm160 40c0 22.1-17.9 40-40 40l-88 0 0-80 88 0c22.1 0 40 17.9 40 40zM192 352l0-80 88 0 16 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-104 0z'
      
    ]
  };

  

  
  

  var faRightLong = {
    prefix: 'fal',
    iconName: 'right-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-right"],
      'f30b',
      
      'M352 184l0-49.3c0-3.7 3-6.7 6.7-6.7c1.9 0 3.7 .8 5 2.2L476.2 256 363.7 381.8c-1.3 1.4-3.1 2.2-5 2.2c-3.7 0-6.7-3-6.7-6.7l0-49.3c0-17.7-14.3-32-32-32L48 296c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l272 0c17.7 0 32-14.3 32-32zm154.7 86c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 108.9c-7.3-8.2-17.8-12.9-28.8-12.9c-21.4 0-38.7 17.3-38.7 38.7l0 17.3 0 32-32 0L48 184c-26.5 0-48 21.5-48 48l0 48c0 26.5 21.5 48 48 48l240 0 32 0 0 32 0 17.3c0 21.4 17.3 38.7 38.7 38.7c11 0 21.5-4.7 28.8-12.9L506.7 270z'
      
    ]
  };

  
    var faLongArrowAltRight = faRightLong;
  

  
  

  var faLaptopSlash = {
    prefix: 'fal',
    iconName: 'laptop-slash',
    icon: [
      640,
      512,
      [],
      'e1c7',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.3 480l-40.5-32L76.8 448c-20.3 0-37.4-13.5-42.9-32l385.3 0-40.5-32L19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l423.5 0zM544 351.5l.7 .5 31.3 0 0-256c0-35.3-28.7-64-64-64L139.4 32l40.5 32L512 64c17.7 0 32 14.3 32 32l0 255.5zM64 135.6L64 352l32 0 0-191.2L64 135.6z'
      
    ]
  };

  

  
  

  var faCoin = {
    prefix: 'fal',
    iconName: 'coin',
    icon: [
      512,
      512,
      [129689],
      'f85c',
      
      'M256 320c66.2 0 124.6-15.2 165.3-38.1C463 258.5 480 231.1 480 208s-17-50.5-58.7-73.9C380.6 111.2 322.2 96 256 96s-124.6 15.2-165.3 38.1C49 157.5 32 184.9 32 208s17 50.5 58.7 73.9C131.4 304.8 189.8 320 256 320zm-80 24.8l0 64.3c20 3.6 41.5 5.8 64 6.6l0-64c-22.2-.8-43.7-3.1-64-6.9zm-32-7.3c-17.2-4.7-33.2-10.5-48-17.1l0 64.7c14.2 6.5 30.3 12.3 48 17l0-64.6zM32 277.8L32 320c0 12.9 8.5 29.9 32 46.8l0-63.6c-12.2-7.8-23-16.3-32-25.5zm240 74l0 64c22.5-.7 44-3 64-6.6l0-64.3c-20.3 3.8-41.8 6.1-64 6.9zm208-74c-9 9.2-19.8 17.7-32 25.5l0 63.6c23.5-16.9 32-34 32-46.8l0-42.2zM368 337.5l0 64.6c17.7-4.7 33.8-10.5 48-17l0-64.7c-14.8 6.7-30.8 12.4-48 17.1zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 32 0 80c0 70.7-114.6 128-256 128S0 390.7 0 320l0-80 0-32zm256-56c-47.1 0-89.1 7.4-118.7 18.8c-14.8 5.7-25.8 12.2-32.7 18.5C97.7 195.7 96 200.6 96 204s1.7 8.3 8.6 14.7c6.9 6.3 17.8 12.8 32.7 18.5C166.9 248.6 208.9 256 256 256s89.1-7.4 118.7-18.8c14.8-5.7 25.8-12.2 32.7-18.5c6.9-6.3 8.6-11.3 8.6-14.7s-1.7-8.3-8.6-14.7c-6.9-6.3-17.8-12.8-32.7-18.5C345.1 159.4 303.1 152 256 152zm192 52c0 15.4-8.2 28.3-19 38.3c-10.9 9.9-25.7 18.2-42.7 24.7c-34.1 13.2-80.2 21-130.2 21s-96.1-7.8-130.2-21c-17-6.6-31.9-14.8-42.7-24.7c-10.9-9.9-19-22.9-19-38.3s8.2-28.3 19-38.3c10.9-9.9 25.7-18.2 42.7-24.7c34.1-13.2 80.2-21 130.2-21s96.1 7.8 130.2 21c17 6.6 31.9 14.8 42.7 24.7c10.9 9.9 19 22.9 19 38.3z'
      
    ]
  };

  

  
  

  var faPowerOff = {
    prefix: 'fal',
    iconName: 'power-off',
    icon: [
      512,
      512,
      [9211],
      'f011',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256zM164.3 78.2c7.8-4.1 10.9-13.7 6.9-21.6s-13.7-10.9-21.6-6.9C75 88.3 24 166.2 24 256c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2c-7.8-4.1-17.5-1-21.6 6.9s-1 17.5 6.9 21.6C412.1 111.5 456 178.6 456 256c0 110.5-89.5 200-200 200S56 366.5 56 256c0-77.4 43.9-144.5 108.3-177.8z'
      
    ]
  };

  

  
  

  var faTicket = {
    prefix: 'fal',
    iconName: 'ticket',
    icon: [
      576,
      512,
      [127903],
      'f145',
      
      'M64 64C28.7 64 0 92.7 0 128l0 66c0 7.3 4.9 13.7 12 15.5c20.7 5.3 36 24.1 36 46.5s-15.3 41.2-36 46.5C4.9 304.3 0 310.7 0 318l0 66c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-66c0-7.3-4.9-13.7-12-15.5c-20.7-5.3-36-24.1-36-46.5s15.3-41.2 36-46.5c7.1-1.8 12-8.2 12-15.5l0-66c0-35.3-28.7-64-64-64L64 64zM32 128c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32l0 54.7c-28.2 12.3-48 40.5-48 73.3s19.8 61 48 73.3l0 54.7c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-54.7C60.2 317 80 288.8 80 256s-19.8-61-48-73.3L32 128zm128 64l256 0 0 128-256 0 0-128zm-32 0l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faSwordLaserAlt = {
    prefix: 'fal',
    iconName: 'sword-laser-alt',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      'M353.2 224L503.8 57.1c5.3-5.9 8.2-13.5 8.2-21.4l0-3.7c0-17.7-14.3-32-32-32l-3.7 0c-7.9 0-15.6 2.9-21.4 8.2L215.8 224l47.8 0L476.3 32l3.7 0 0 3.7L310.1 224l43.1 0zM139.3 270.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L331.3 283.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-146.7 0c-12.7 0-24.9 5.1-33.9 14.1zM281.4 288L184 385.4l-28.7-28.7L126.6 328l35.3-35.3c3-3 7.1-4.7 11.3-4.7l108.1 0zM144 390.6L161.4 408 93.2 476.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L66.6 468 144 390.6zM121.4 368L44 445.4l-8.2-8.2c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2L104 350.6 121.4 368z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fal',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faRouter = {
    prefix: 'fal',
    iconName: 'router',
    icon: [
      576,
      512,
      [],
      'f8da',
      
      'M352 32c62.9 0 120.4 22.6 165 60.2c6.8 5.7 16.8 4.8 22.5-1.9s4.8-16.8-1.9-22.5C487.5 25.5 422.7 0 352 0S216.5 25.5 166.4 67.8c-6.8 5.7-7.6 15.8-1.9 22.5s15.8 7.6 22.5 1.9C231.6 54.6 289.1 32 352 32zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80L64 320c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-144 0 0-80zM64 352l448 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm40 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm42.2-251.4C277.9 141.7 313.3 128 352 128s74.1 13.7 101.8 36.6c6.8 5.6 16.9 4.7 22.5-2.1s4.7-16.9-2.1-22.5C441 112.5 398.4 96 352 96s-89 16.5-122.2 43.9c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1z'
      
    ]
  };

  

  
  

  var faWandSparkles = {
    prefix: 'fal',
    iconName: 'wand-sparkles',
    icon: [
      512,
      512,
      [],
      'f72b',
      
      'M472.8 0c-9.6 0-18.9 3.5-26 9.9L169.9 256 136 256c-22.1 0-40 17.9-40 40l0 27.1L17.7 393C6.5 403.1 0 417.5 0 432.6c0 14.1 5.6 27.6 15.6 37.6l26.2 26.2c10 10 23.5 15.6 37.6 15.6c15.1 0 29.5-6.4 39.6-17.6L391.1 192l24.9 0c17.7 0 32-14.3 32-32l0-26.4 55.3-69.1c5.6-7 8.7-15.8 8.7-24.8l0-.5C512 17.5 494.5 0 472.8 0zM468 33.8c1.3-1.2 3-1.8 4.8-1.8c4 0 7.2 3.2 7.2 7.2l0 .5c0 1.7-.6 3.4-1.7 4.8L419.5 118c-2.3 2.8-3.5 6.4-3.5 10l0 32-32 0c-4.5 0-8.9 1.9-11.9 5.3L95.2 473c-4 4.5-9.8 7-15.8 7c-5.6 0-11-2.2-15-6.2L38.2 447.6c-4-4-6.2-9.3-6.2-14.9c0-6 2.6-11.7 7.1-15.8l83.6-74.6c3.4-3 5.3-7.4 5.3-11.9l0-34.3c0-4.4 3.6-8 8-8l40 0c3.9 0 7.7-1.4 10.6-4L468 33.8zM256 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faSquareU = {
    prefix: 'fal',
    iconName: 'square-u',
    icon: [
      448,
      512,
      [],
      'e281',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 64l0 128c0 44.2 35.8 80 80 80s80-35.8 80-80l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faPersonPregnant = {
    prefix: 'fal',
    iconName: 'person-pregnant',
    icon: [
      384,
      512,
      [],
      'e31e',
      
      'M192 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 192 0zm0 352l48 0 64 0 16 0 0-32c0-31.1-22.3-57.1-51.7-62.8c-12.9-2.5-23-12.6-25.4-25.5l-6.1-32.5c-4.3-22.7-24.1-39.2-47.2-39.2L176 160c-26.5 0-48 21.5-48 48l0 144 16 0 48 0zm1.9-223.9c36.6 2 67.5 28.7 74.3 65.1l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3l0 32c0 17.7-14.3 32-32 32l-16 0-48 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-32 0-32 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c-17.7 0-32-14.3-32-32l0-119.9L62.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L88.2 178.8c16.7-31.3 49.2-50.8 84.7-50.8l3.1 0 13.6 0 2.4 0c.7 0 1.3 0 1.9 .1z'
      
    ]
  };

  

  
  

  var faFlask = {
    prefix: 'fal',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      'M288 196.8L288 32 160 32l0 164.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320l246.2 0-44.8-72.9C292.9 232 288 214.6 288 196.8zM128 32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0L288 0l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 164.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 32zM37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480l309.2 0c20.7 0 37.4-16.7 37.4-37.4c0-6.9-1.9-13.7-5.5-19.6l-43.7-71L81.2 352 37.5 423z'
      
    ]
  };

  

  
  

  var faSwordsLaser = {
    prefix: 'fal',
    iconName: 'swords-laser',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      'M393.9 177.2c-4.8 2-8.2 6.1-9.4 10.9L185.1 8.2C179.3 2.9 171.6 0 163.7 0L160 0c-17.7 0-32 14.3-32 32l0 3.7c0 7.9 2.9 15.6 8.2 21.4L384 331.7l0 7.1c0 12.7 5.1 24.9 14.1 33.9L524.2 498.8c8.4 8.4 19.9 13.2 31.8 13.2s23.4-4.7 31.8-13.2l39-39c8.4-8.4 13.2-19.9 13.2-31.8s-4.7-23.4-13.2-31.8L411.3 180.7c-4.6-4.6-11.5-5.9-17.4-3.5zM160 35.7l0-3.7 3.7 0L384 230.8l0 53.1L160 35.7zM513.4 328l-28.7 28.7L456 385.4l-35.3-35.3c-3-3-4.7-7.1-4.7-11.3l0-108.1L513.4 328zM536 350.6l68.2 68.2c2.4 2.4 3.8 5.7 3.8 9.2s-1.4 6.7-3.8 9.2l-8.2 8.2L518.6 368 536 350.6zM573.4 468l-8.2 8.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L478.6 408 496 390.6 573.4 468zm-375-228.3l-11-11c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7-57.9 57.9c-6-3.2-13.7-2.3-18.8 2.8L16 393.4C5.8 403.6 0 417.5 0 432s5.8 28.4 16 38.6L41.4 496c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16l76.7-76.7c3-3 4.7-7.1 4.7-11.3c0-2.6-.7-5.2-1.9-7.5L256 342.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-11-11 26.2-29-21.6-23.9L249.6 291 221 262.4l31.6-28.5-21.4-23.8-32.8 29.6zM480 35.7L382.7 143.5l3 2.7c11.8-3.7 24.4-2.6 35.3 2.7l82.8-91.7c5.3-5.9 8.2-13.5 8.2-21.4l0-3.7c0-17.7-14.3-32-32-32l-3.7 0c-7.9 0-15.6 2.9-21.4 8.2l-111 100.2L367.8 130 476.3 32l3.7 0 0 3.7zM152 318.6L193.4 360 176 377.4 134.6 336 152 318.6zM174.6 296L192 278.6 233.4 320 216 337.4 174.6 296zM38.6 416L104 350.6 161.4 408 96 473.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L38.6 448c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16z'
      
    ]
  };

  

  
  

  var faCentSign = {
    prefix: 'fal',
    iconName: 'cent-sign',
    icon: [
      384,
      512,
      [],
      'e3f5',
      
      'M208 0c8.8 0 16 7.2 16 16l0 48c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3c7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96C137.1 96 64 168 64 256s73.1 160 164 160c37 0 71.1-12 98.5-32.1c7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-51.2C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8L192 16c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHamsa = {
    prefix: 'fal',
    iconName: 'hamsa',
    icon: [
      512,
      512,
      [],
      'f665',
      
      'M256 32c17.7 0 32 14.3 32 32l0 32 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16l50.7 0c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7l-90.2 90.2C348 461.3 303 480 256 480s-92-18.7-125.3-51.9L40.6 337.9C35.1 332.5 32 325 32 317.3C32 301.1 45.1 288 61.3 288l50.7 0c8.8 0 16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 0-32c0-17.7 14.3-32 32-32zm0-32c-27.9 0-51.7 17.9-60.4 42.8C185.4 36 173.2 32 160 32c-35.3 0-64 28.7-64 64l0 160-34.7 0C27.4 256 0 283.4 0 317.3c0 16.2 6.5 31.8 17.9 43.3l90.2 90.2C147.3 490 200.5 512 256 512s108.7-22 147.9-61.3l90.2-90.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3L416 256l0-160c0-35.3-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C307.7 17.9 283.9 0 256 0zM176.9 349.3c6.5-6.7 18.7-18.4 33.5-28.2c15.1-10.1 31.1-17 45.6-17s30.5 6.9 45.6 17c14.8 9.9 27 21.5 33.5 28.2c.4 .5 .9 1.3 .9 2.7s-.5 2.3-.9 2.7c-6.5 6.7-18.7 18.4-33.5 28.2c-15.1 10.1-31.1 17-45.6 17s-30.5-6.9-45.6-17c-14.8-9.9-27-21.5-33.5-28.2c-.4-.5-.9-1.3-.9-2.7s.5-2.3 .9-2.7zM256 272c-23.8 0-46.2 11-63.4 22.4c-17.4 11.6-31.4 25.1-38.7 32.7c-6.7 7-9.9 16.1-9.9 25s3.2 18 9.9 25c7.3 7.6 21.3 21 38.7 32.7C209.8 421 232.2 432 256 432s46.2-11 63.4-22.4c17.4-11.6 31.4-25.1 38.7-32.7c6.7-7 9.9-16.1 9.9-25s-3.2-18-9.9-25c-7.3-7.6-21.3-21-38.7-32.7C302.2 283 279.8 272 256 272zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faMapPin = {
    prefix: 'fal',
    iconName: 'map-pin',
    icon: [
      320,
      512,
      [128205],
      'f276',
      
      'M160 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM304 144c0 74.1-56 135.2-128 143.1L176 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208.9c-72-8-128-69-128-143.1C16 64.5 80.5 0 160 0s144 64.5 144 144zm-192 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faCroissant = {
    prefix: 'fal',
    iconName: 'croissant',
    icon: [
      512,
      512,
      [129360],
      'f7f6',
      
      'M32 288c0-15.3 1.3-30.2 3.9-44.7l169.6 68.4-124 96.4-11.7 8.3c-.9 .2-1.7 .3-2.3 .2c-.6-.1-.9-.2-1-.3c0 0 0 0 0 0c-.1 0-.2-.2-.5-.6C44.4 378.1 32 334.6 32 288zM7.4 222.9C2.6 243.8 0 265.6 0 288c0 52.3 14 101.4 38.4 143.7c9.3 16.2 28.9 20.8 45.3 13.7c25.7 27.9 57.4 50 93.2 64.3c3.9 1.5 8 2.3 12.2 2.3l5.4 0c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9L208 384l0-33.8 34.1-26.5c18.9 2 38.1-4.5 51.9-18.4L305.3 294c13.9-13.9 20.4-33 18.4-51.9L350.2 208l33.8 0 93.6 15.6c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6l0-5.4c0-4.2-.7-8.3-2.3-12.2c-14.3-35.8-36.5-67.5-64.3-93.2c7.1-16.4 2.5-36-13.7-45.3C389.4 14 340.3 0 288 0c-22.4 0-44.2 2.6-65.1 7.4C215.6 2.7 207 0 197.9 0c-5 0-10 .8-14.6 2.5C99.6 33.2 33.2 99.6 2.5 183.3C.8 188 0 193 0 197.9c0 9.1 2.7 17.7 7.4 24.9zm235.9-187C257.8 33.3 272.7 32 288 32c46.6 0 90.1 12.4 127.7 34.1c.4 .2 .5 .4 .6 .5c0 0 0 0 0 0c.1 .1 .2 .4 .3 1c.1 .6 .1 1.4-.2 2.3l-8.3 11.7-96.4 124L243.3 35.9zM188.6 480c-30-12-56.8-30.4-78.8-53.4L176 375.1l0 8.9 0 2.6 .4 2.6L191.6 480l-2.5 0c-.1 0-.2 0-.3 0c-.1 0-.1 0-.1 0zM375.1 176l51.4-66.1c23 21.9 41.4 48.7 53.4 78.8c0 .1 0 .2 0 .4l0 2.5-90.7-15.1-2.6-.4-2.6 0-8.9 0zM32.5 194.3C60 119.5 119.5 60 194.3 32.5c.8-.3 2-.5 3.6-.5c5.6 0 10.6 3.4 12.7 8.6l79.1 196.2c4.8 11.9 2 25.5-7.1 34.6l-11.3 11.3c-9.1 9.1-22.7 11.8-34.6 7.1L40.6 210.7c-5.2-2.1-8.6-7.1-8.6-12.7c0-1.6 .3-2.8 .5-3.6z'
      
    ]
  };

  

  
  

  var faNetworkWired = {
    prefix: 'fal',
    iconName: 'network-wired',
    icon: [
      640,
      512,
      [],
      'f6ff',
      
      'M400 32c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0-32 0-64 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l160 0zM336 192l64 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L240 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l64 0 0 48L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 0 48-64 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-64 0 0-48 288 0 0 48-64 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-64 0 0-48 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0 0-48zM496 352l64 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l64 0 32 0zm-320 0l64 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L80 480c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l64 0 32 0z'
      
    ]
  };

  

  
  

  var faFolderTree = {
    prefix: 'fal',
    iconName: 'folder-tree',
    icon: [
      576,
      512,
      [],
      'f802',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16l0 96L0 368c0 26.5 21.5 48 48 48l208 0 0-32L48 384c-8.8 0-16-7.2-16-16l0-240 224 0 0-32L32 96l0-80zM394.7 32l21.7 21.7C423 60.3 432 64 441.3 64L544 64l0 128-224 0 0-160 74.7 0zM288 32l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L441.3 32c-.8 0-1.7-.3-2.3-.9L417.4 9.4c-6-6-14.1-9.4-22.6-9.4L320 0c-17.7 0-32 14.3-32 32zm32 288l74.7 0 21.7 21.7C423 348.3 432 352 441.3 352L544 352l0 128-224 0 0-160zm-32 0l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-102.7 0c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4L320 288c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faPeople = {
    prefix: 'fal',
    iconName: 'people',
    icon: [
      640,
      512,
      [],
      'e216',
      
      'M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM147.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM128 496l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-293.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1 96 496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l48 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 64 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 48 0c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368 528 368l-96 0-38.1 0 52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6z'
      
    ]
  };

  

  
  

  var faCauldron = {
    prefix: 'fal',
    iconName: 'cauldron',
    icon: [
      448,
      512,
      [],
      'f6bf',
      
      'M160 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM60.1 244.9C72 223 85.2 204.3 94.9 192L224 192l129.1 0c9.7 12.3 22.9 31 34.8 52.9C404.3 275 416 307.1 416 334.4c0 45.1-21.4 80.4-56.1 105.5C324.5 465.5 275.4 480 224 480s-100.5-14.5-135.9-40.1C53.4 414.8 32 379.5 32 334.4c0-27.3 11.7-59.4 28.1-89.5zM55.2 192C30.2 228.1 0 283.9 0 334.4c0 37.4 11.9 69.4 32 95.5L32 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-34.2C106.3 494.6 164.6 512 224 512s117.7-17.4 160-50.2l0 34.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-66.1c20.1-26.1 32-58.1 32-95.5c0-50.5-30.2-106.3-55.2-142.4l39.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0-144 0L80 160l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l39.2 0z'
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fal',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faOutlet = {
    prefix: 'fal',
    iconName: 'outlet',
    icon: [
      448,
      512,
      [],
      'e01c',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 256c0 49.2 24.6 79.3 39.5 93.1c1.2 1.1 4.3 2.9 10.9 2.9l155.3 0c6.6 0 9.7-1.8 10.9-2.9C327.4 335.3 352 305.2 352 256s-24.6-79.3-39.5-93.1c-1.2-1.1-4.3-2.9-10.9-2.9l-155.3 0c-6.6 0-9.7 1.8-10.9 2.9C120.6 176.7 96 206.8 96 256zm-32 0c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4l155.3 0c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4l-155.3 0c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm112-64c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm-48 96c13.3 0 24 10.7 24 24l0 16c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-16c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faFilterList = {
    prefix: 'fal',
    iconName: 'filter-list',
    icon: [
      512,
      512,
      [],
      'e17c',
      
      'M27.6 64C12.4 64 0 76.4 0 91.6c0 6.7 2.4 13.2 6.8 18.2L112 230l0 130c0 10 4.7 19.5 12.7 25.5l76.2 57.5c4.2 3.2 9.4 4.9 14.7 4.9c13.5 0 24.4-10.9 24.4-24.4L240 230 345.2 109.8c4.4-5 6.8-11.5 6.8-18.2C352 76.4 339.6 64 324.4 64L27.6 64zM140 213.5L37.3 96l277.5 0L212 213.5c-2.6 2.9-4 6.7-4 10.5l0 184.3L144 360l0-136c0-3.9-1.4-7.6-4-10.5zM336 400c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zM320 256c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM400 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faKhanda = {
    prefix: 'fal',
    iconName: 'khanda',
    icon: [
      512,
      512,
      [9772],
      'f66d',
      
      'M266.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-48 40c-5.9 4.9-7.5 13.2-3.8 19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1 .1 .3 .6c.3 .5 .7 1.3 1.2 2.3c1 2 2.6 5 4.4 8.6c.5 .9 .9 1.9 1.4 2.9C167.1 97.4 144 134 144 176s23.1 78.6 57.3 97.8c-.5 1-1 2-1.4 2.9c-1.8 3.7-3.3 6.6-4.4 8.6c-.5 1-.9 1.8-1.2 2.3l-.3 .6-.1 .1s0 0 0 0s0 0 0 0s0 0 0 0c-3.6 6.7-2 15 3.8 19.9L240 343.5l0 19.1-34.6-23.8-41.1-28.2c-42.8-29.4-68.4-78-68.4-130c0-31.1 9.2-61.6 26.5-87.5l2.8-4.2c4-6 3.5-14-1.3-19.5s-12.7-7-19.2-3.7L112 80c-7.2-14.3-7.2-14.3-7.2-14.3s0 0 0 0s0 0 0 0l-.1 0-.3 .2-1 .5c-.8 .4-2 1.1-3.5 1.9C97 70 93 72.5 88.1 75.7c-9.7 6.4-22.5 16.1-35.4 29C26.9 130.4 0 170.3 0 224c0 53.1 26.4 100.5 51.2 133.6c12.6 16.7 25.1 30.3 34.5 39.7c4.7 4.7 8.7 8.4 11.5 10.9c1.4 1.3 2.5 2.2 3.3 2.9l.9 .8 .3 .2 .1 .1c0 0 0 0 0 0s0 0 0 0L112 400l-10.2 12.3c5.1 4.3 12.4 4.9 18.2 1.6l75.6-43 32.7 22.5-45.8 31.5c-2.1-.6-4.2-.9-6.5-.9c-13.3 0-24 10.7-24 24s10.7 24 24 24c11.9 0 21.8-8.7 23.7-20.1L240 424.1l0 28.1c-9.6 5.5-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7l0-28.9L312.2 451c1.5 11.8 11.6 21 23.8 21c13.3 0 24-10.7 24-24s-10.7-24-24-24c-2 0-3.9 .2-5.7 .7l-45.5-31.3 32.7-22.5 75.6 43c5.8 3.3 13 2.7 18.2-1.6L401.1 400c10.2 12.3 10.2 12.3 10.2 12.3s0 0 0 0s0 0 0 0l.1-.1 .3-.2 .9-.8c.8-.7 1.9-1.7 3.3-2.9c2.8-2.5 6.7-6.2 11.5-10.9c9.4-9.4 21.9-23 34.5-39.7c24.8-33.1 51.2-80.5 51.2-133.6c0-53.7-26.9-93.6-52.7-119.3c-12.9-12.9-25.8-22.6-35.4-29c-4.8-3.2-8.9-5.7-11.8-7.3c-1.5-.8-2.6-1.5-3.5-1.9l-1-.5-.3-.2-.1 0c0 0 0 0 0 0s0 0 0 0L401.1 80l7.2-14.3c-6.5-3.2-14.3-1.7-19.2 3.7s-5.3 13.4-1.3 19.5l2.8 4.2c17.3 25.9 26.5 56.4 26.5 87.5c0 51.9-25.6 100.6-68.4 130l-41.1 28.2L272 363.3l0-19.8 42.2-35.2c5.9-4.9 7.5-13.2 3.8-19.9c0 0 0 0 0 0s0 0 0 0l-.1-.1-.3-.6c-.3-.5-.7-1.3-1.2-2.3c-1-2-2.6-5-4.4-8.6c-.5-.9-.9-1.9-1.4-2.9C344.9 254.6 368 218 368 176s-23.1-78.6-57.3-97.8c.5-1 1-2 1.4-2.9c1.8-3.7 3.3-6.6 4.4-8.6c.5-1 .9-1.8 1.2-2.3l.3-.6 .1-.1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c3.6-6.7 2-15-3.8-19.9l-48-40zm31.3 103.9c23 14 38.4 39.4 38.4 68.4s-15.4 54.3-38.4 68.4C288.1 221 280 195 280 176s8.1-45 17.6-68.4zM214.4 244.4c-23-14-38.4-39.4-38.4-68.4s15.4-54.3 38.4-68.4C223.9 131 232 157 232 176s-8.1 45-17.6 68.4zM228.6 61.2l-.5-1.1L256 36.8l27.9 23.3-.5 1.1c-3.9 7.8-9 18.8-14.2 31.3c-4.6 11-9.3 23.7-13.2 36.8c-3.9-13.1-8.7-25.8-13.2-36.8C237.6 80 232.5 69 228.6 61.2zm14.2 198.4c4.6-11 9.3-23.7 13.2-36.8c3.9 13.1 8.7 25.8 13.2 36.8c5.2 12.5 10.3 23.5 14.2 31.3l.5 1.1L256 315.2l-27.9-23.3 .5-1.1c3.9-7.8 9-18.8 14.2-31.3zM70.2 132.7c-4.1 15.6-6.2 31.7-6.2 47.9c0 62.5 30.8 121 82.2 156.4l20 13.8-52.1 29.7c-1.7-1.6-3.7-3.5-5.8-5.7c-8.6-8.6-20.1-21-31.5-36.3C53.6 307.5 32 266.9 32 224c0-39 17.9-69.4 38.2-91.3zM481.1 224c0 42.9-21.6 83.5-44.8 114.4c-11.4 15.3-22.9 27.7-31.5 36.3c-2.1 2.1-4.1 4-5.8 5.7l-52.1-29.7 20-13.8c51.5-35.4 82.2-93.9 82.2-156.4c0-16.3-2.1-32.4-6.2-47.9c20.2 21.9 38.2 52.3 38.2 91.3z'
      
    ]
  };

  

  
  

  var faOlive = {
    prefix: 'fal',
    iconName: 'olive',
    icon: [
      448,
      512,
      [],
      'e316',
      
      'M160 448C89.3 448 32 390.7 32 320c0-84.8 39.8-148.3 91.7-191.4C176.5 84.7 239.5 64 280 64c18.4 0 39.8 9.7 59.3 22.6c9.2 6.1 16.9 12.3 22.3 16.9c2.7 2.3 4.8 4.2 6.1 5.4c.7 .6 1.2 1.1 1.5 1.4l.3 .3 .3 .3c.3 .3 .7 .8 1.4 1.5c1.3 1.3 3.1 3.4 5.4 6.1c4.6 5.4 10.8 13.1 16.9 22.3C406.3 160.2 416 181.6 416 200c0 40.5-20.7 103.5-64.6 156.3C308.3 408.2 244.8 448 160 448zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM260.4 132.4c3.6-3.6 11.2-6.2 24.2-3c12.6 3.2 27.6 11.5 41 24.9s21.8 28.4 24.9 41c3.2 13 .6 20.6-3 24.2s-11.2 6.2-24.2 3c-12.6-3.2-27.6-11.5-41-24.9s-21.8-28.4-24.9-41c-3.2-13-.6-20.6 3-24.2zm87.8-.7c-16.9-16.9-36.7-28.6-55.9-33.4c-18.8-4.7-39.9-3.2-54.5 11.4s-16.1 35.8-11.4 54.5c4.8 19.1 16.5 39 33.4 55.9s36.7 28.6 55.9 33.4c18.8 4.7 39.9 3.2 54.5-11.4s16.1-35.8 11.4-54.5c-4.8-19.1-16.5-39-33.4-55.9z'
      
    ]
  };

  

  
  

  var faHoneyPot = {
    prefix: 'fal',
    iconName: 'honey-pot',
    icon: [
      448,
      512,
      [127855],
      'e418',
      
      'M128 64l32 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 32 0 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-96 0 0 32 96 0c53 0 96 43 96 96L32 224c0-53 43-96 96-96l0-32L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0zM447.8 237.2c.2-4.3 .2-8.7 .2-13.2c0-42.9-21.1-80.8-53.4-104c12.9-8.6 21.4-23.3 21.4-40c0-26.5-21.5-48-48-48L176 32 80 32C53.5 32 32 53.5 32 80c0 16.7 8.5 31.4 21.4 40C21.1 143.2 0 181.1 0 224c0 4.5 .1 8.9 .2 13.2C.1 238.1 0 239 0 240c0 1.5 .2 2.9 .6 4.3c7.2 126.3 80.7 199 112.7 224.9c9.3 7.5 21.1 10.9 33.1 10.9l155.3 0c12 0 23.7-3.3 33.1-10.9c32-25.9 105.5-98.6 112.7-224.9c.4-1.4 .6-2.8 .6-4.3c0-1-.1-1.9-.2-2.8zM414.4 256c-2.4 23.5-7.3 44.9-13.9 64c-.2 0-.3 0-.5 0L48 320c-.2 0-.3 0-.5 0C41 300.9 36 279.5 33.6 256l380.8 0zm-27.1 96c-23.4 47.9-55.2 78.1-72.7 92.3c-2.5 2-6.7 3.7-12.9 3.7l-155.3 0c-6.3 0-10.5-1.7-12.9-3.7c-17.5-14.1-49.4-44.4-72.7-92.3l326.6 0z'
      
    ]
  };

  

  
  

  var faCoins = {
    prefix: 'fal',
    iconName: 'coins',
    icon: [
      512,
      512,
      [],
      'f51e',
      
      'M160 80c0 2.4 1.3 6.8 8.3 12.8c1.4 1.2 2.9 2.4 4.6 3.6c-15.4 .6-30.4 1.9-44.9 3.9L128 80c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C224.1 7.3 270 0 320 0s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2C503.4 52.3 512 64.7 512 80l0 104c0 0 0 0 0 0l0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4c-10.4 3.9-21.8 7.4-34.1 10.3l0-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2l0-66.2c-8.7 5.6-18.8 10.5-29.9 14.7c-10.4 3.9-21.8 7.4-34.1 10.3l0-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2l0-57.9c-8.8 5.4-19 10.1-30.1 14.1c-17.3 6.3-37.6 11.3-60 14.6c-1.9-1.9-3.8-3.8-5.7-5.5c-10.1-9.1-21.7-16.4-33.8-22.5c34.8-2.3 65.4-8.4 88.5-16.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C409.3 39 367.2 32 320 32s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM32 208c0 2.4 1.3 6.8 8.3 12.8c6.9 5.9 17.8 12 32.8 17.4C102.7 249 144.8 256 192 256s89.3-7 119-17.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C281.3 167 239.2 160 192 160s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM0 208c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C96.1 135.3 142 128 192 128s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2c10.9 9.3 19.4 21.8 19.4 37l0 104c0 0 0 0 0 0l0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4C288.1 501.3 242 509 192 509s-96.1-7.7-130.1-20.7c-17-6.5-31.8-14.6-42.7-24.4S0 441.3 0 425.9L0 312 0 208zm352 46.1c-8.8 5.4-19 10.1-30.1 14.1C287.9 280.7 242 288 192 288s-95.9-7.3-129.9-19.7c-11.1-4-21.3-8.7-30.1-14.1L32 312c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 355.7 144.8 363 192 363s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2l0-57.9zM32 425.9c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 469.6 144.8 477 192 477s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2l0-66.2c-8.7 5.6-18.8 10.5-29.9 14.7C288.1 387.4 242 395 192 395s-96.1-7.7-130.1-20.7c-11-4.2-21.1-9.1-29.9-14.7l0 66.2z'
      
    ]
  };

  

  
  

  var faMountainCity = {
    prefix: 'fal',
    iconName: 'mountain-city',
    icon: [
      640,
      512,
      [],
      'e52e',
      
      'M320 48c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 160c0 8.8 7.2 16 16 16l64 0 32 0c8.8 0 16 7.2 16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-26.5-21.5-48-48-48l-16 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-32 0 0-144c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 92.1 32 53L320 48zM226 161.2L302.5 288 223 288c-5 0-9.8 2.4-12.8 6.4l-34.7 46.2-33-47.7L222 161.2c.5-.9 1.3-1.2 2-1.2s1.5 .3 2 1.2zM32.5 475.4l92-152.4 37.4 54.1c2.9 4.2 7.7 6.8 12.9 6.9s10-2.3 13.1-6.4L231 320l90.8 0 93.8 155.4c.6 1 .6 2.2 .1 3.3c-.5 1-1.4 1.3-2.1 1.3L34.5 480c-.7 0-1.5-.4-2.1-1.3c-.6-1-.5-2.3 .1-3.3zM253.4 144.7C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512l379.1 0c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7zM352 96l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zm-32 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-17.7-14.3-32-32-32l-32 0zm96 96l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zm-32 96c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32z'
      
    ]
  };

  

  
  

  var faFluxCapacitor = {
    prefix: 'fal',
    iconName: 'flux-capacitor',
    icon: [
      448,
      512,
      [],
      'f8ba',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM292.7 255.2c3.7 .5 7.5 .8 11.3 .8c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c3.8 0 7.6-.3 11.3-.8l-45.3-45.3c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0L224 188.1l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-45.3 45.3zM173.8 273.7C155.6 288.4 144 310.8 144 336c0 44.2 35.8 80 80 80s80-35.8 80-80c0-25.2-11.6-47.6-29.8-62.3l-2.2 2.2 0 60.1c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-60.1-2.2-2.2zm-18.5-109c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4 75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z'
      
    ]
  };

  

  
  

  var faBatteryHalf = {
    prefix: 'fal',
    iconName: 'battery-half',
    icon: [
      576,
      512,
      ["battery-3"],
      'f242',
      
      'M432 128c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 384c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l352 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80L80 96zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM112 192l128 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-128 0z'
      
    ]
  };

  
    var faBattery3 = faBatteryHalf;
  

  
  

  var faBoltAuto = {
    prefix: 'fal',
    iconName: 'bolt-auto',
    icon: [
      576,
      512,
      [],
      'e0b6',
      
      'M291.4 0c-6.1 0-12 2.2-16.5 6.3L8.7 242.9C3.2 247.8 0 254.8 0 262.2C0 276.4 11.6 288 25.8 288l111.5 0L69.2 478.7C63.4 494.9 75.4 512 92.6 512c6.1 0 11.9-2.2 16.5-6.2L374.9 271.3c5.8-5.1 9.1-12.5 9.1-20.3c0-14.9-12.1-27-27-27l-110.3 0L314.8 33.3C320.6 17.1 308.6 0 291.4 0zM42.1 256L275.3 48.7l-66.4 186c-1.8 4.9-1 10.3 2 14.6s7.9 6.8 13.1 6.8l119.8 0L108.6 463.6l66.5-186.2c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8L42.1 256zM464 288c-6.1 0-11.6 3.4-14.3 8.8l-96 192c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L401.9 464l124.2 0 19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-96-192c-2.7-5.4-8.2-8.8-14.3-8.8zm0 51.8L510.1 432l-92.2 0L464 339.8z'
      
    ]
  };

  

  
  

  var faIndustryWindows = {
    prefix: 'fal',
    iconName: 'industry-windows',
    icon: [
      576,
      512,
      [127981,"industry-alt"],
      'f3b3',
      
      'M64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 149.3c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l138.7-92.5c5.3-3.5 12.4 .3 12.4 6.7l0 81.9c0 6 3.4 11.5 8.7 14.2s11.8 2.3 16.6-1.3l138-99.3c5.3-3.8 12.7 0 12.7 6.5L512 304l0 16 0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64 0-48L64 80zM80 32C53.5 32 32 53.5 32 80l0 224 0 48 0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-96 0-16 0-145.1c0-32.6-36.9-51.5-63.4-32.5L368 207.5l0-50.6c0-31.9-35.6-51-62.2-33.3L192 199.4 192 80c0-26.5-21.5-48-48-48L80 32zm56 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm104 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 40l0-32 32 0 0 32-32 0zm120-64c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm40 64l-32 0 0-32 32 0 0 32zm-288 0l0-32 32 0 0 32-32 0z'
      
    ]
  };

  
    var faIndustryAlt = faIndustryWindows;
  

  
  

  var faCarMirrors = {
    prefix: 'fal',
    iconName: 'car-mirrors',
    icon: [
      576,
      512,
      [],
      'e343',
      
      'M191.6 64c-21.2 0-39.9 13.9-46 34.2l-28.3 94.4c3.5-.4 7.1-.6 10.7-.6l320 0c3.6 0 7.2 .2 10.7 .6L430.4 98.2c-6.1-20.3-24.8-34.2-46-34.2L191.6 64zM106.7 227.9l-.5-.1C81.6 236.7 64 260.3 64 288l0 96 448 0 0-96c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6l-320 0c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3zM56.4 224L32 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l52.1 0L115 89c10.2-33.8 41.3-57 76.6-57l192.8 0c35.3 0 66.5 23.2 76.6 57l30.9 103 52.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24.4 0c15.2 17 24.4 39.4 24.4 64l0 96 0 16 0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L64 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16 0-16 0-96c0-24.6 9.2-47 24.4-64zM112 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRacquet = {
    prefix: 'fal',
    iconName: 'racquet',
    icon: [
      512,
      512,
      [],
      'f45a',
      
      'M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7c7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3c72.5 39.4 169.9 17.5 234.7-47.4c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32L64 480 32 448l72-72z'
      
    ]
  };

  

  
  

  var faPiggyBank = {
    prefix: 'fal',
    iconName: 'piggy-bank',
    icon: [
      576,
      512,
      [],
      'f4d3',
      
      'M272 32c34.8 0 64.5 22.2 75.5 53.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C362.3 31.2 320.8 0 272 0C216.5 0 170.4 40.4 161.5 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C199.5 60.8 232.4 32 272 32zM55.2 190.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L36.2 164C14 175.1 0 197.8 0 222.6c0 35.7 28.5 64.7 64 65.4c0 0 0 0 0 0c0 52.4 25.2 98.8 64 128l0 48c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-16 64 0 0 16c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-29.3c25.5-11.1 47.5-28.7 64-50.7l32 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-13.3 0c-10.7-24.6-27.4-45.9-48.3-62.2l7.2-25C495.4 116.3 480 96 458.8 96L456 96c-30.5 0-58.2 12.2-78.4 32L224 128c-77.4 0-142 55-156.8 128l-1.8 0C47 256 32 241 32 222.6c0-12.7 7.2-24.2 18.5-29.9l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM396.4 154.7C411 138.3 432.3 128 456 128l2.8 0-10.2 35.8c-1.9 6.7 .7 13.8 6.5 17.7c22.8 15.2 40.4 37.6 49.7 63.8c2.3 6.4 8.3 10.7 15.1 10.7l24.2 0 0 96-40.2 0c-5.3 0-10.3 2.7-13.3 7.1c-15.2 22.8-37.6 40.4-63.8 49.6C420.3 411 416 417 416 423.8l0 40.2c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-56.2c0-5.3-2.7-10.3-7.1-13.3C118.6 371.5 96 332.4 96 288c0-70.7 57.3-128 128-128l160 0s0 0 0 0l.4 0c4.6 0 8.9-1.9 11.9-5.3z'
      
    ]
  };

  

  
  

  var faCarBump = {
    prefix: 'fal',
    iconName: 'car-bump',
    icon: [
      640,
      512,
      [],
      'f5e0',
      
      'M131.7 88.2L304.3 41.9c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6 .5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8C39.5 271.5 30.2 304.8 39 337.6l22 82.1L65.3 436s0 0 0 0l15.8 58.8c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6L98.7 442.8l1.5-.4L508.7 332.9l1.5-.4L522 376.6c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1s0 0 0 0l-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4L384.8 46.2C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9L60.9 243.3zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zM420.4 262a22.8 22.8 0 1 0 -11.8-44.1A22.8 22.8 0 1 0 420.4 262zm43.4 236.2c4.1-28.4 28.5-50.3 58.1-50.3s54 21.8 58.1 50.3c1.3 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1c-6.3-44-44.1-77.7-89.8-77.7s-83.5 33.8-89.7 77.7c-1.3 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6z'
      
    ]
  };

  

  
  

  var faSushiRoll = {
    prefix: 'fal',
    iconName: 'sushi-roll',
    icon: [
      448,
      512,
      ["maki-roll","makizushi"],
      'e48b',
      
      'M448 136c0-22.4-12.2-39.9-25.9-52C408.5 71.9 390.5 62.4 371 55.1C331.8 40.4 279.8 32 224 32s-107.8 8.4-147 23.1C57.5 62.4 39.5 71.9 25.9 84C12.2 96.1 0 113.6 0 136L0 352c0 45.2 35.8 77.4 73.9 96.5C114 468.5 167.1 480 224 480s110-11.5 150.1-31.5C412.2 429.4 448 397.2 448 352l0-216zm-32 0c0 14.8-11.9 28.6-32.3 40c-89.2-.1-143.5-58.9-143.7-111.8c98.6 3 176 34 176 71.8zM32 136c0-37.7 77.4-68.7 176-71.8c0 12.5 2.1 24.9 6 36.7c-17.9 4.6-39.3 11.9-60.8 22.7c-26.7 13.4-54.4 32.6-75.2 59.1C49.3 170.2 32 153.9 32 136zm78.4 58.1c16.1-17.5 36.3-31.3 57.2-41.8c22-11 43.8-18 60.5-21.8c19.3 30.3 51.4 55 92 67.8C291.8 204.5 259 208 224 208c-42.5 0-81.8-5.2-113.6-13.9zM32 193c12.7 9.7 28.3 17.6 45 23.8c39.2 14.7 91.2 23.1 147 23.1s107.8-8.4 147-23.1c16.7-6.3 32.3-14.1 45-23.8l0 159c0 53-86 96-192 96s-192-43-192-96l0-159z'
      
    ]
  };

  
    var faMakiRoll = faSushiRoll;
  
    var faMakizushi = faSushiRoll;
  

  
  

  var faFaceHeadBandage = {
    prefix: 'fal',
    iconName: 'face-head-bandage',
    icon: [
      576,
      512,
      [],
      'e37a',
      
      'M288 32c2.4 0 4.9 0 7.3 .1c-29.3 9.7-57.6 21.4-84.8 35c-17.1 1.4-34.1 3.2-51 5.4C195.8 47 240.2 32 288 32zm80.1-19.2C342.9 4.5 316 0 288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2c-8.2 2-15.3 7.1-19.7 14.3C26.9 130.6 15 158.9 7.8 189c-2.4 10.2 .3 20.9 7.2 28.7c-2.5 2.8-4.9 5.6-7.3 8.5c-4.7 5.5-7.3 12.4-7.6 19.6C.1 249.2 0 252.6 0 256c0 31.4 5 61.7 14.4 90.1c3.8 11.6 13.9 20 26 21.7s24.1-3.7 30.9-13.8c31.3-46.3 69.9-87.2 114.1-121c-.7 2.2-1.1 4.6-1.1 7.1c0 13.3 10.7 24 24 24s24-10.7 24-24c0-13.1-10.5-23.7-23.5-24c12-8.2 24.4-15.8 37.2-23c13.9-.7 27.9-1 41.9-1c83.4 0 163.9 12.3 239.8 35.1c11 3.3 22.8 .5 31.2-7.4s11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1c-3.3-5.3-8-9.5-13.5-12.1c-.6-6-2.9-11.9-6.9-16.8c-21.2-26.5-47-49.1-76.2-66.8c-6.1-3.7-13.4-5.2-20.5-4.4c-16.2 2-32.2 4.6-48.1 7.9zM506.3 122.2c7.3 11.9 13.7 24.4 19 37.5c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26l-.8 0c-9.1-.3-18.3-.4-27.5-.4c-17.1 0-34.1 .5-51 1.5c-48.2 2.8-95.4 9.6-141.2 20c-7 1.6-13.9 3.3-20.9 5c-12.1 3.1-24.1 6.4-36 10c.5-2 1-4 1.5-6c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38c23.2-5.6 46.8-10.3 70.7-14.1c0 0 0 0 0 0c.8-.1 1.6-.3 2.5-.4c25-3.9 50.4-6.9 76.1-8.7c0 0 0 0 0 0s0 0 0 0C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4c2.2 .3 4.4 .6 6.6 .9c31.7 4.3 62.9 10.1 93.5 17.5l.3 .5zM177 199.3c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5c41-12.2 83.3-21.3 126.6-27.1zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2C419.3 71.1 360.6 64.9 300.6 64.1zm242.8 209c.6-8.8-6.1-16.4-14.9-17s-16.4 6.1-17 14.9C503.8 387.7 406.7 480 288 480c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C129.9 471.8 204.2 512 288 512c135.7 0 246.7-105.5 255.4-238.9zM373.2 397.5c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6C373.2 354.3 340.2 336 296 336c-16.4 0-31.4 2.5-44.8 6.8c-8.4 2.7-13.1 11.6-10.5 20.1s11.6 13.1 20.1 10.5c10.4-3.3 22.1-5.3 35.2-5.3c34.8 0 60.4 14.2 77.2 29.5zM392.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCircleLocationArrow = {
    prefix: 'fal',
    iconName: 'circle-location-arrow',
    icon: [
      512,
      512,
      ["location-circle"],
      'f602',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm127.7 27c-11.7 0-21.9-8.3-24.2-19.8c-2.4-11.4 3.7-23.1 14.5-27.7L338.5 141c9.5-3.9 20.2-1.9 27.3 5.3c7.2 7.1 9.2 17.8 5.2 27.2L276.5 394c-3.9 9.1-12.9 15-22.8 15c-1.6 0-3.3-.1-4.9-.5C237.3 406.2 229 396 229 384.2l0-69.2 0-32-32 0-69.3 0zm35.3-32l65.9 0c17.7 0 32 14.3 32 32l0 66 73.5-171.4L163.1 251z'
      
    ]
  };

  
    var faLocationCircle = faCircleLocationArrow;
  

  
  

  var faFolderHeart = {
    prefix: 'fal',
    iconName: 'folder-heart',
    icon: [
      512,
      512,
      [],
      'e189',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM176 253.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 345.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 192c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z'
      
    ]
  };

  

  
  

  var faPlaneUp = {
    prefix: 'fal',
    iconName: 'plane-up',
    icon: [
      512,
      512,
      [],
      'e22d',
      
      'M221.2 13.3C230.8 5.7 242.6 0 256 0c26.9 0 47.1 21.6 59.2 41.8C327.9 62.9 336 89.1 336 109.7l0 52.5 151.8 86.8c15 8.5 24.2 24.5 24.2 41.7l0 56.2c0 21.3-20.3 36.6-40.8 30.8L336 338.9l0 37.1 51.2 38.4c8.1 6 12.8 15.5 12.8 25.6l0 42c0 16.6-13.4 30-30 30c-2.8 0-5.6-.4-8.2-1.2c0 0 0 0 0 0L256 480.6 150.3 510.8s0 0 0 0c-2.7 .8-5.5 1.2-8.3 1.2c-16.6 0-30-13.4-30-30l0-42c0-10.1 4.7-19.6 12.8-25.6L176 376l0-37.1L40.8 377.6C20.3 383.4 0 368 0 346.8l0-56.2c0-17.2 9.2-33.1 24.2-41.7L176 162.1l0-52.5c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zm3.3 45C214.1 75.6 208 96.2 208 109.7l0 61.7c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9l0 56.2 155.6-44.5c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8l0 66.3c0 5-2.4 9.8-6.4 12.8L144 440l0 39.4 107.6-30.7c2.9-.8 5.9-.8 8.8 0L368 479.4l0-39.4-57.6-43.2c-4-3-6.4-7.8-6.4-12.8l0-66.3c0-5 2.4-9.8 6.4-12.8s9.2-4 14-2.6L480 346.8l0-56.2c0-5.7-3.1-11-8.1-13.9L312.1 185.3c-5-2.8-8.1-8.2-8.1-13.9l0-61.7c0-13.6-5.9-34.2-16.2-51.4C276.9 40.2 265.1 32 256 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20z'
      
    ]
  };

  

  
  

  var faMobileScreen = {
    prefix: 'fal',
    iconName: 'mobile-screen',
    icon: [
      384,
      512,
      ["mobile-android-alt"],
      'f3cf',
      
      'M288 32c17.7 0 32 14.3 32 32l0 256L64 320 64 64c0-17.7 14.3-32 32-32l192 0zm32 320l0 96c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-96 256 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zm48 416c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  
    var faMobileAndroidAlt = faMobileScreen;
  

  
  

  var faBellSchool = {
    prefix: 'fal',
    iconName: 'bell-school',
    icon: [
      512,
      512,
      [],
      'f5d5',
      
      'M208 384a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0 32c-41.2 0-79.7-12-112-32.7L96 448c0 17.7 14.3 32 32 32l144 0 16 0c17.7 0 32-14.3 32-32l0-64.7C287.7 404 249.2 416 208 416zm64 96l-144 0c-35.3 0-64-28.7-64-64l0-89.9C24.6 320.2 0 267 0 208C0 93.1 93.1 0 208 0S416 93.1 416 208c0 59-24.6 112.2-64 150.1l0 89.9c0 11.7-3.1 22.6-8.6 32l72.6 0c17.7 0 32-14.3 32-32l0-2.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3l0 2.7c0 35.3-28.7 64-64 64l-128 0-16 0zM256 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM464 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTemperatureThreeQuarters = {
    prefix: 'fal',
    iconName: 'temperature-three-quarters',
    icon: [
      320,
      512,
      ["temperature-3","thermometer-3","thermometer-three-quarters"],
      'f2c8',
      
      'M160 32c-35.3 0-64 28.7-64 64l0 156.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9L224 96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96l0 156.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5L64 96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-162c0-8.8 7.2-16 16-16s16 7.2 16 16l0 162c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature3 = faTemperatureThreeQuarters;
  
    var faThermometer3 = faTemperatureThreeQuarters;
  
    var faThermometerThreeQuarters = faTemperatureThreeQuarters;
  

  
  

  var faBoxingGlove = {
    prefix: 'fal',
    iconName: 'boxing-glove',
    icon: [
      448,
      512,
      [129354,"glove-boxing"],
      'f438',
      
      'M32 112c0-44.2 35.8-80 80-80l160 0c44.2 0 80 35.8 80 80l0 16-16 0c-38.7 0-71 27.5-78.4 64L144 192c-26.5 0-48-21.5-48-48l0-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 44.2 35.8 80 80 80l113.6 0c7.4 36.5 39.7 64 78.4 64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 38.9c0 17-6.7 33.3-18.7 45.3L336.4 353c-10.5 10.5-16.4 24.7-16.4 39.6l0 63.4c0 13.3-10.7 24-24 24L88 480c-13.3 0-24-10.7-24-24l0-104.4c0-4.6-1.9-8.9-5.3-11.9C42.3 325 32 303.7 32 280l0-168zM112 0C50.1 0 0 50.1 0 112L0 280c0 30.5 12.2 58.2 32 78.4L32 456c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-63.4c0-6.4 2.5-12.5 7-17l60.9-60.9c18-18 28.1-42.4 28.1-67.9l0-38.9c0-38.7-27.5-71-64-78.4l0-17.6C384 50.1 333.9 0 272 0L112 0zm40.9 338.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 403.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 364.8l-39.1-26.1z'
      
    ]
  };

  
    var faGloveBoxing = faBoxingGlove;
  

  
  

  var faHouseChimneyMedical = {
    prefix: 'fal',
    iconName: 'house-chimney-medical',
    icon: [
      576,
      512,
      ["clinic-medical"],
      'f7f2',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4 384 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 136.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1L480 64l-64 0 0 43.6 64 56.5zM96 206.7L96 432c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7zM272 176l32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32zm0 32l0 48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-48 0 0 32 48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16l0-48-32 0z'
      
    ]
  };

  
    var faClinicMedical = faHouseChimneyMedical;
  

  
  

  var faCards = {
    prefix: 'fal',
    iconName: 'cards',
    icon: [
      640,
      512,
      [],
      'e3ed',
      
      'M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6l.1-.1L427.4 365.5l.1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3l.1 .2 167 289.3 .1 .2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9c-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8c-.2 .1-.5 .3-.7 .4l-192.3 111c-.2 .1-.5 .3-.7 .4c-26.4 14.9-59.8 6-75.3-20zM360 512c-13.7 0-26.2-4.9-35.9-13l33.2-19.1c.9 .1 1.8 .2 2.7 .2l224 0c13.3 0 24-10.7 24-24l0-336c0-13.3-10.7-24-24-24L373 96 354.7 64.2c1.7-.2 3.5-.2 5.3-.2l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0zM469.4 162.8l-.1 .1s0 0 0 0c-6.7 5.7-7 16-1.1 22.2c0 0 0 0 0 0l35.9 37 35.7-37s0 0 0 0c5.9-6.1 5.6-16.4-.9-22.2c-5.1-4.2-13.4-4-19.1 1.7l-3.9 4.3c-3 3.3-7.2 5.2-11.7 5.3s-8.7-1.7-11.8-5l-4.3-4.5c-5.9-5.9-14.4-5.8-18.9-1.9zm-21-24.2c16.5-14.3 39.3-13.3 55.6-2.2c16.2-11.1 38.9-11.9 55.6 2.1l.2 .2s0 0 0 0c20.5 17.9 21.5 49.4 3 68.6c0 0 0 0 0 0L520.6 251l-.2 .2s0 0 0 0c-8.8 8.8-23.7 9.5-33-.3l-42.3-43.6c0 0 0 0 0 0c-18.5-19.2-17.6-50.8 3.2-68.7zM252.2 340.4l48.2-27.8c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9l-48.2 27.8c-7.7 4.4-17.4 1.8-21.9-5.9s-1.8-17.4 5.9-21.9zm-27-40.1l5.9-27.4c.9-4.4 3.6-8.1 7.5-10.4s8.4-2.9 12.7-1.6l27.6 8.1c12.9 3.5 26.2-3.2 29.6-13.2l0-.1c5-14.2-3.4-30-17.5-34c0 0 0 0 0 0l-90.2-25.7-22.6 90.8s0 0 0 0c-3.5 14.2 5.8 29.3 20.3 32.3c10.9 1.8 23-5.6 26.7-18.9zm31 7.9c-7.4 27.8-34.3 47.5-63.4 42.5l-.4-.1s0 0 0 0c-32.7-6.5-53.3-39.7-45.3-71.5l26.6-106.9c1-4.2 3.8-7.8 7.5-10s8.2-2.7 12.4-1.5L299.9 191c0 0 0 0 0 0c31.5 9.1 50 43.5 38.8 75.4c-10.1 29.4-42.9 40.6-68.5 33.6l-.3-.1s0 0 0 0l-11.2-3.3-2.4 10.9c-.1 .2-.1 .5-.2 .7z'
      
    ]
  };

  

  
  

  var faLocationDotSlash = {
    prefix: 'fal',
    iconName: 'location-dot-slash',
    icon: [
      640,
      512,
      ["map-marker-alt-slash"],
      'f605',
      
      'M385.8 389.5c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9zM320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192C512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80c-20.5 0-39.2 7.7-53.3 20.4l25.8 20.3c7.8-5.5 17.3-8.7 27.6-8.7c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7L390.4 230c6.1-11.3 9.6-24.3 9.6-38zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faMapMarkerAltSlash = faLocationDotSlash;
  

  
  

  var faCaretDown = {
    prefix: 'fal',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M165.6 349.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 236.3c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1l241.7 0c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 349.8zm22 23.3L307.7 259.6c7.8-7.4 12.3-17.7 12.3-28.4c0-21.6-17.5-39.1-39.1-39.1L39.1 192C17.5 192 0 209.5 0 231.1c0 10.8 4.4 21.1 12.3 28.5L132.4 373.1c7.4 7 17.3 10.9 27.6 10.9s20.1-3.9 27.6-10.9z'
      
    ]
  };

  

  
  

  var faBallot = {
    prefix: 'fal',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M384 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM72 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0z'
      
    ]
  };

  

  
  

  var faUsbDrive = {
    prefix: 'fal',
    iconName: 'usb-drive',
    icon: [
      640,
      512,
      [],
      'f8e9',
      
      'M64 128c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l352 0 0-256L64 128zM0 160c0-35.3 28.7-64 64-64l352 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-35.3 0-64-28.7-64-64L0 160zM480 384l0-32 128 0 0-192-128 0 0-32 128 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-128 0zm96-176a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM560 320a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faArrowsFromDottedLine = {
    prefix: 'fal',
    iconName: 'arrows-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a3',
      
      'M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6 208 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM8 256a24 24 0 1 0 48 0A24 24 0 1 0 8 256zm384 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM200 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96 280c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4 240 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z'
      
    ]
  };

  

  
  

  var faKeyboard = {
    prefix: 'fal',
    iconName: 'keyboard',
    icon: [
      576,
      512,
      [9000],
      'f11c',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm88 8l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM72 248c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM456 344c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm-280-8l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTimeline = {
    prefix: 'fal',
    iconName: 'timeline',
    icon: [
      640,
      512,
      [],
      'e29c',
      
      'M144 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 94c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62l0 114L16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l304 0 0 82c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-82 272 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-114c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62l0 114-320 0 0-114zM336 464a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM496 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fal',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      'M83.4 75.8c-27.8 11.5-45.1 30.6-49.8 56.6c-3.3 18.2-1.2 31.7 3.6 42.3c4.9 10.7 13.4 19.8 25.5 27.9c25 16.7 61.4 27 101.5 38l1.7 .5c38 10.5 79.3 21.8 109.1 41.8c15.5 10.4 28.7 23.6 36.8 41.1c8.1 17.5 10.3 37.9 6.1 61.3c-7 39-33.3 65.8-69.1 80.6c-35.3 14.5-80.2 17.7-127.9 10.5c0 0-.1 0-.1 0c-25-3.9-66.1-17.4-94.4-26.7c-5.7-1.9-10.9-3.6-15.3-5c-8.4-2.7-13-11.7-10.4-20.1s11.7-13 20.1-10.4c5 1.6 10.7 3.5 16.8 5.5c28.5 9.3 65.9 21.6 88 25.1c44 6.6 82.6 3.2 110.9-8.4c27.8-11.5 45.1-30.6 49.8-56.6c3.3-18.2 1.2-31.7-3.6-42.3c-4.9-10.7-13.4-19.8-25.5-27.9c-25-16.7-61.4-27-101.5-38l-1.7-.5c-38-10.5-79.3-21.8-109.1-41.8c-15.5-10.4-28.7-23.6-36.8-41.1C.1 170.5-2.1 150.2 2.1 126.8c7-39 33.3-65.8 69.1-80.6c35.3-14.5 80.2-17.7 127.9-10.5C213.4 37.9 256.9 46 272 49.8c8.6 2.2 13.7 10.9 11.5 19.5S272.6 83 264 80.8c-13.6-3.5-55.9-11.4-69.7-13.5l2.4-15.8-2.4 15.8c-44-6.6-82.7-3.3-111 8.4z'
      
    ]
  };

  

  
  

  var faOverline = {
    prefix: 'fal',
    iconName: 'overline',
    icon: [
      448,
      512,
      [],
      'f876',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32zm208 96c-88.4 0-160 71.6-160 160l0 32c0 88.4 71.6 160 160 160s160-71.6 160-160l0-32c0-88.4-71.6-160-160-160zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128l0 32c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-32z'
      
    ]
  };

  

  
  

  var faSquareUpLeft = {
    prefix: 'fal',
    iconName: 'square-up-left',
    icon: [
      448,
      512,
      [],
      'e282',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 88l0 113.4c0 3.7 3 6.6 6.6 6.6c1.8 0 3.4-.7 4.7-1.9l25.4-25.4c6.2-6.2 16.4-6.2 22.6 0l59.1 59.1c3.6 3.6 9 4.9 13.9 3.3c2-.7 3.8-1.8 5.3-3.3l22.1-22.1c1.5-1.5 2.6-3.3 3.3-5.3c1.6-4.9 .4-10.3-3.3-13.9l-59.1-59.1c-6.2-6.2-6.2-16.4 0-22.6l25.4-25.4c1.2-1.2 1.9-2.9 1.9-4.7c0-3.7-3-6.6-6.6-6.6L152 176c-4.4 0-8 3.6-8 8zm8-40l113.4 0c21.3 0 38.6 17.3 38.6 38.6c0 10.2-4.1 20.1-11.3 27.3L278.6 224l47.7 47.7c12.2 12.2 16.5 30.3 11 46.7c-2.2 6.7-6 12.8-11 17.8l-22.1 22.1c-5 5-11.1 8.8-17.8 11c-16.4 5.5-34.5 1.2-46.7-11L192 310.6l-14.1 14.1c-7.2 7.2-17.1 11.3-27.3 11.3c-21.3 0-38.6-17.3-38.6-38.6L112 184c0-22.1 17.9-40 40-40z'
      
    ]
  };

  

  
  

  var faBaseballBatBall = {
    prefix: 'fal',
    iconName: 'baseball-bat-ball',
    icon: [
      512,
      512,
      [],
      'f432',
      
      'M416 0c-14.5 0-28.4 5.8-38.6 16L226.1 167.2c-9.7 9.7-18.4 20.3-26 31.7L125.2 311.3c-6.4 9.6-13.8 18.6-22 26.8L32 409.4l-4.7-4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L9.4 432l11.3 11.3 48 48L80 502.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-4.7-4.7 71.2-71.2c8.2-8.2 17.2-15.6 26.8-22l112.4-74.9c11.4-7.6 22-16.3 31.7-26L496 134.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L454.6 16C444.4 5.8 430.5 0 416 0zM80 457.4L54.6 432l71.2-71.2c.7-.7 1.4-1.4 2.1-2.1L153.4 384c-.7 .7-1.4 1.4-2.1 2.1L80 457.4zm98.1-93.9l-29.6-29.6c1.1-1.6 2.2-3.2 3.3-4.8l74.9-112.4c6.4-9.6 13.8-18.6 22-26.8L400 38.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L473.4 80c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L322.1 263.2c-8.2 8.2-17.2 15.6-26.8 22L182.9 360.1c-1.6 1.1-3.2 2.2-4.8 3.3zM384 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPenNibSlash = {
    prefix: 'fal',
    iconName: 'pen-nib-slash',
    icon: [
      640,
      512,
      [],
      'e4a1',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM478.3 232.3l75.1-75.1c25-25 25-65.5 0-90.5L509.3 22.6c-25-25-65.5-25-90.5 0L343.7 97.7l-80.3 21.9 31.2 24.7 52.6-14.4 98.9 98.9-7.9 28.9 27.3 21.5 12.8-46.9zM379 394.3c-.5 .2-1.1 .4-1.7 .5L129.3 469.3 239.5 359.1c9.5 5.6 20.6 8.9 32.5 8.9c18.7 0 35.6-8 47.3-20.8L294 327.2c-5.7 5.4-13.5 8.8-22 8.8c-17.7 0-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L219.1 268c-7 10.2-11.1 22.6-11.1 36c0 11.9 3.2 23 8.9 32.5L106.7 446.7l64.8-216.1-27-21.3L67.9 464.6c-3.7 12.3-.3 25.7 8.8 34.7s22.4 12.5 34.7 8.8l275.2-82.5c7.2-2.2 14-5.3 20.2-9.3L379 394.3zM441.4 45.3c12.5-12.5 32.8-12.5 45.3 0l44.1 44.1c12.5 12.5 12.5 32.8 0 45.3L464 201.4 374.6 112l66.7-66.7z'
      
    ]
  };

  

  
  

  var faListRadio = {
    prefix: 'fal',
    iconName: 'list-radio',
    icon: [
      512,
      512,
      [],
      'e1d0',
      
      'M32 96a32 32 0 1 1 64 0A32 32 0 1 1 32 96zm96 0A64 64 0 1 0 0 96a64 64 0 1 0 128 0zm64 0c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faLampStreet = {
    prefix: 'fal',
    iconName: 'lamp-street',
    icon: [
      512,
      512,
      [],
      'e1c5',
      
      'M32 168C32 92.9 92.9 32 168 32c72.7 0 132 57 135.8 128.7c-83.1 6.9-151.1 66.7-170.3 145.6C127.3 331.8 148.3 352 171 352l298 0c22.7 0 43.7-20.2 37.5-45.7c-19.3-79-87.5-138.9-170.7-145.7C332 71.3 258.3 0 168 0C75.2 0 0 75.2 0 168L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-328zm288 24c75.2 0 138.4 51.9 155.4 121.9c.3 1.4 0 2.6-1 3.8c-1.1 1.3-3 2.3-5.5 2.3l-298 0c-2.4 0-4.4-1-5.5-2.3c-1-1.1-1.3-2.4-1-3.8C181.6 243.9 244.8 192 320 192zM241.6 384c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l-33.1 0c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32l-33.1 0z'
      
    ]
  };

  

  
  

  var faCloudSleet = {
    prefix: 'fal',
    iconName: 'cloud-sleet',
    icon: [
      512,
      512,
      [],
      'f741',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm256 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zM192 368c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zm240-16c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faFaucet = {
    prefix: 'fal',
    iconName: 'faucet',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 0 48-18.7 0c-12.7 0-24.9 5.1-33.9 14.1L121.4 256 16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7l69.5 0c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7l48 0c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48l-60.8 0c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8L16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l116.1 0c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48l52.1 0c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144l-41.4 0-33.9-33.9c-9-9-21.2-14.1-33.9-14.1L240 208l0-48 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0 0-48z'
      
    ]
  };

  

  
  

  var faArrowsMaximize = {
    prefix: 'fal',
    iconName: 'arrows-maximize',
    icon: [
      512,
      512,
      ["expand-arrows"],
      'f31d',
      
      'M336 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0L256 233.4 86.6 64 176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 32c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4L233.4 256 64 425.4 64 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-89.4 0L256 278.6 425.4 448 336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4L278.6 256 448 86.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L336 32z'
      
    ]
  };

  
    var faExpandArrows = faArrowsMaximize;
  

  
  

  var faCarBolt = {
    prefix: 'fal',
    iconName: 'car-bolt',
    icon: [
      512,
      512,
      [],
      'e341',
      
      'M113.6 98.2L85.3 192.6c3.5-.4 7.1-.6 10.7-.6l32 0 0 32-32 0c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3-.5-.1C49.6 236.7 32 260.3 32 288l0 96 448 0 0-96c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6l-32 0 0-32 32 0c3.6 0 7.2 .2 10.7 .6L398.4 98.2c-6.1-20.3-24.8-34.2-46-34.2L159.6 64c-21.2 0-39.9 13.9-46 34.2zM48.3 204.7l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57l192.8 0c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 221.2 512 252.3 512 288l0 96 0 16 0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16 0-16 0-96c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM299.3 123.3L230.6 192l89.4 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 224 192 224c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faPallet = {
    prefix: 'fal',
    iconName: 'pallet',
    icon: [
      640,
      512,
      [],
      'f482',
      
      'M16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 96-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 240 0 240 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-96 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0-240 0L80 352l-64 0zm80 32l208 0 0 96L96 480l0-96zm240 0l208 0 0 96-208 0 0-96z'
      
    ]
  };

  

  
  

  var faBackwardStep = {
    prefix: 'fal',
    iconName: 'backward-step',
    icon: [
      320,
      512,
      ["step-backward"],
      'f048',
      
      'M64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 161.9 0 28.2L32 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-135.8L242.6 441.8c5 4 11.2 6.2 17.6 6.2c15.4 0 27.8-12.4 27.8-27.8l0-328.4C288 76.4 275.6 64 260.2 64c-6.4 0-12.6 2.2-17.6 6.2L64 215.8 64 80zm192 20.6l0 310.7L65.3 256 256 100.6z'
      
    ]
  };

  
    var faStepBackward = faBackwardStep;
  

  
  

  var faTruckTow = {
    prefix: 'fal',
    iconName: 'truck-tow',
    icon: [
      640,
      512,
      [],
      'e2b8',
      
      'M96 64l0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16L64 32C64 20.2 70.4 9.8 80 4.3C84.7 1.6 90.2 0 96 0l3.8 0 45.9 0c9.1 0 17.8 3.9 23.9 10.7L384 252l0-108c0-26.5 21.5-48 48-48l56.5 0c19.8 0 38.4 9.1 50.5 24.7l90.8 116.8c6.6 8.4 10.1 18.8 10.1 29.5l0 101c0 26.5-21.5 48-48 48l-16 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l144 0L96 64zM250.5 384l138.9 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l21.5 0c8.8 0 16-7.2 16-16l0-80-192 0-32 0-10.8 0L208 288 48 288c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM416 416a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm97.8-275.6c-6.1-7.8-15.4-12.4-25.3-12.4L432 128c-8.8 0-16 7.2-16 16l0 112 187.7 0L513.8 140.4zM145.6 32l-29.9 0 112 224 117 0L145.6 32zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faInputNumeric = {
    prefix: 'fal',
    iconName: 'input-numeric',
    icon: [
      640,
      512,
      [],
      'e1bd',
      
      'M576 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM96 176c0 8.8 7.2 16 16 16l16 0 0 128-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-144c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm168.7 27.4c9.4-11.3 26.2-12.6 37.2-2.9c10.8 9.5 11.9 25.9 2.5 36.7l-76.6 88.3c-4.1 4.7-5.1 11.4-2.5 17.1s8.3 9.4 14.6 9.4l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-61 0 53.6-61.9c20.9-24.2 18.4-60.7-5.6-81.8c-24.6-21.5-62-18.5-82.9 6.5l-12.4 14.9c-5.7 6.8-4.7 16.9 2 22.5s16.9 4.7 22.5-2l12.4-14.9z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fal',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faDash = {
    prefix: 'fal',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      'M0 256c0-8.8 7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faRaindrops = {
    prefix: 'fal',
    iconName: 'raindrops',
    icon: [
      448,
      512,
      [],
      'f75c',
      
      'M160 85.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9l0 4.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-4.5c0-5.9-1.4-11.7-4.2-16.9L160 85.6zM148.3 39.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8l0 4.5c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM64 277.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9l0 4.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-4.5c0-5.9-1.4-11.7-4.2-16.9L64 277.6zM52.3 231.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8l0 4.5c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM239 301.5c-9.8 15.3-15 33.1-15 51.3c0 52.3 43.2 95.2 96 95.2s96-42.9 96-95.2c0-18.2-5.2-36-15-51.3L320 174.9 239 301.5zm-27-17.2l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z'
      
    ]
  };

  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fal',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      'M171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm352-342.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 86.6 432 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-377.4-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96z'
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faLightSwitchOn = {
    prefix: 'fal',
    iconName: 'light-switch-on',
    icon: [
      384,
      512,
      [],
      'e019',
      
      'M176 48l0-16L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l112 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 112 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L208 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM176 168l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48-24l0 96 128 0 0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm0 224c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96-128 0 0 96zM96 144c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224z'
      
    ]
  };

  

  
  

  var faSquareRootVariable = {
    prefix: 'fal',
    iconName: 'square-root-variable',
    icon: [
      576,
      512,
      ["square-root-alt"],
      'f698',
      
      'M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4L82.9 264.4c-2.8-5.2-8.2-8.4-14.1-8.4L16 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l52.8 0c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7C311.9 46.1 330.7 32 352.1 32L560 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L352.1 64zm52.6 180.7c6.2-6.2 16.4-6.2 22.6 0L480 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faSquareRootAlt = faSquareRootVariable;
  

  
  

  var faArrowUpFromDottedLine = {
    prefix: 'fal',
    iconName: 'arrow-up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e09b',
      
      'M235.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 86.6 208 192l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 0-105.4L340.7 187.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fal',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      'M16 32c8.8 0 16 7.2 16 16l0 240c0 88.4 71.6 160 160 160s160-71.6 160-160l0-240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 240c0 106-86 192-192 192S0 394 0 288L0 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faArrowTurnUp = {
    prefix: 'fal',
    iconName: 'arrow-turn-up',
    icon: [
      384,
      512,
      ["level-up"],
      'f148',
      
      'M16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c44.2 0 80-35.8 80-80l0-377.4L308.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 432c0 26.5-21.5 48-48 48L16 480z'
      
    ]
  };

  
    var faLevelUp = faArrowTurnUp;
  

  
  

  var faHexagonNodes = {
    prefix: 'fal',
    iconName: 'hexagon-nodes',
    icon: [
      448,
      512,
      [],
      'e699',
      
      'M200 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40 53.7c23.1-6.9 40-28.3 40-53.7c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7l0 92.6c-8.6 2.6-16.3 7.1-22.7 13.2l-74.8-42.7c5.5-23.4-4.7-48.6-26.5-61.2C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c3.9 2.2 7.9 4 12 5.2l0 84.6c-4.1 1.2-8.1 2.9-12 5.2C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c21.9-12.6 32-37.8 26.5-61.3l46.3-26.4c-6.9-8.1-12.3-17.5-15.9-27.8L94.7 311.5c-6.5-6.2-14.3-10.6-22.7-13.1l0-84.7c8.4-2.5 16.2-6.9 22.7-13.1l74.8 42.7c-1 4.1-1.5 8.4-1.5 12.7c0 25.4 16.9 46.8 40 53.7l0 92.6c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-92.6c8.6-2.6 16.3-7.1 22.7-13.2l74.8 42.7c-5.5 23.4 4.7 48.6 26.5 61.2c26.8 15.5 61 6.3 76.5-20.5s6.3-61-20.5-76.5c-3.9-2.2-7.9-4-12-5.2l0-84.6c4.1-1.2 8.1-2.9 12-5.2c26.8-15.5 36-49.7 20.5-76.5S390.8 96 364 111.5c-21.9 12.6-32 37.8-26.6 61.2l-46.3 26.4c6.9 8.1 12.3 17.5 15.9 27.8l46.2-26.4c6.5 6.2 14.3 10.7 22.7 13.1l0 84.7c-8.4 2.5-16.2 6.9-22.7 13.1l-74.8-42.7c1-4.1 1.5-8.4 1.5-12.7c0-25.4-16.9-46.8-40-53.7l0-92.6zm140 29.5a24 24 0 1 1 24 41.6 24 24 0 1 1 -24-41.6zM35.2 148a24 24 0 1 1 41.6 24A24 24 0 1 1 35.2 148zM200 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM76.8 340A24 24 0 1 1 35.2 364a24 24 0 1 1 41.6-24zM380 372.8a24 24 0 1 1 24-41.6 24 24 0 1 1 -24 41.6zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMobileSignalOut = {
    prefix: 'fal',
    iconName: 'mobile-signal-out',
    icon: [
      512,
      512,
      [],
      'e1f0',
      
      'M96 32l128 0 0-32L96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-160-32 0 0 160c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32L64 64c0-17.7 14.3-32 32-32zm64 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM272 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c114.9 0 208 93.1 208 208c0 8.8 7.2 16 16 16s16-7.2 16-16C512 107.5 404.5 0 272 0zm16 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 112c0 8.8 7.2 16 16 16c61.9 0 112 50.1 112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-79.5-64.5-144-144-144c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faGripVertical = {
    prefix: 'fal',
    iconName: 'grip-vertical',
    icon: [
      320,
      512,
      [],
      'f58e',
      
      'M32 440l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm184-40l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM32 232c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm224 0l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM32 72c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm224 0l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z'
      
    ]
  };

  

  
  

  var faSquareD = {
    prefix: 'fal',
    iconName: 'square-d',
    icon: [
      448,
      512,
      [],
      'e268',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM160 352l64 0c53 0 96-43 96-96s-43-96-96-96l-64 0 0 192zm-1.2-224l65.2 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-65.2 0c-17 0-30.8-13.8-30.8-30.8l0-194.5c0-17 13.8-30.8 30.8-30.8z'
      
    ]
  };

  

  
  

  var faAxe = {
    prefix: 'fal',
    iconName: 'axe',
    icon: [
      640,
      512,
      [129683],
      'f6b2',
      
      'M502.6 182.6L352 32l-96 96L406.6 278.6c6 6 9.4 14.1 9.4 22.6l0 82.7c106 0 192-86 192-192l-82.7 0c-8.5 0-16.6-3.4-22.6-9.4zM473.3 108l52 52 82.7 0c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224c-17.7 0-32-14.3-32-32l0-82.7L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0L404 38.7 433.4 9.4c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3L473.3 108zM450.6 85.4L480 56 456 32 426.6 61.4l24 24zM262.7 225.3L32 456l24 24L286.7 249.3l22.6 22.6L78.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3L240.1 202.6l22.6 22.6z'
      
    ]
  };

  

  
  

  var faChessClock = {
    prefix: 'fal',
    iconName: 'chess-clock',
    icon: [
      640,
      512,
      [],
      'f43d',
      
      'M240 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 64 384 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l96 0 0-64-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 64 0zM544 80c0 8.8-7.2 16-16 16L400 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16zM64 160c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L64 160zM176 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM520.6 360.6A80 80 0 1 0 407.4 247.4 80 80 0 1 0 520.6 360.6zM384.8 224.8A112 112 0 1 1 543.2 383.2 112 112 0 1 1 384.8 224.8zM176 240c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm333.3 41.4l-33.9 33.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faPeapod = {
    prefix: 'fal',
    iconName: 'peapod',
    icon: [
      512,
      512,
      [],
      'e31c',
      
      'M416 32C203.9 32 32 203.9 32 416l0 48c0 8.8 7.2 16 16 16l48 0c212.1 0 384-171.9 384-384l0-48c0-8.8-7.2-16-16-16l-48 0zm0-32l48 0c26.5 0 48 21.5 48 48l0 48c0 229.8-186.2 416-416 416l-48 0c-26.5 0-48-21.5-48-48l0-48C0 186.2 186.2 0 416 0zM368 112a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM112 368a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z'
      
    ]
  };

  

  
  

  var faShareAll = {
    prefix: 'fal',
    iconName: 'share-all',
    icon: [
      576,
      512,
      [],
      'f367',
      
      'M373.2 59.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1L551.2 178.4c17.5 15.9 17.5 43.3 0 59.2L394.8 379.8c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L529.7 213.9c3.5-3.2 3.5-8.7 0-11.8L373.2 59.8zM256 160l-80 0C96.5 160 32 224.5 32 304c0 46.1 15.9 79.7 34 103.2c-1.3-7.1-2-14.8-2-23.2c0-70.7 57.3-128 128-128l64 0c0 0 0 0 0 0l8 0c13.3 0 24 10.7 24 24l0 8 0 16 0 48L448 208 288 64l0 48 0 16 0 8c0 13.3-10.7 24-24 24l-8 0zm0 160l0-16 0-16-32 0-32 0c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176l48 0 32 0 0-16 0-16 0-32c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2l0-32z'
      
    ]
  };

  

  
  

  var faDisplayMedical = {
    prefix: 'fal',
    iconName: 'display-medical',
    icon: [
      576,
      512,
      ["desktop-medical"],
      'e166',
      
      'M512 32c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-167.7 0c-.2 0-.4 0-.6 0l-111.5 0c-.2 0-.4 0-.6 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l448 0zM64 416l149.1 0-10.7 64L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 72 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.4 0-10.7-64L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64 84.9 0 10.7 64-106.2 0zM272 96c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  
    var faDesktopMedical = faDisplayMedical;
  

  
  

  var faFolderMusic = {
    prefix: 'fal',
    iconName: 'folder-music',
    icon: [
      512,
      512,
      [],
      'e18d',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM345.1 178.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-116.9 96-36 0 83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-144c0-5.2-2.6-10.2-6.9-13.2zM320 340c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 372c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z'
      
    ]
  };

  

  
  

  var faHexagonVerticalNftSlanted = {
    prefix: 'fal',
    iconName: 'hexagon-vertical-nft-slanted',
    icon: [
      448,
      512,
      [],
      'e506',
      
      'M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9L0 164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4l0 184.6c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7l0-184.6c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM272 123.5c0 12.3-13.3 20-23.9 13.9l-24.2-13.8 0 117 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144 0-160.2c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6c0 0 .1 0 .1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3c5 2.8 8.1 8.2 8.1 13.9zm16 27.4c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3 0 155.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-174.2-23.8-13.6c-5-2.8-8.1-8.2-8.1-13.9zM143.8 128.6c8.8 0 16 7.2 16 16l0 224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2l0 61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270l0-125.4c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTabletScreen = {
    prefix: 'fal',
    iconName: 'tablet-screen',
    icon: [
      448,
      512,
      ["tablet-android-alt"],
      'f3fc',
      
      'M384 32c17.7 0 32 14.3 32 32l0 256L32 320 32 64c0-17.7 14.3-32 32-32l320 0zm32 320l0 96c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-96 384 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 416c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  
    var faTabletAndroidAlt = faTabletScreen;
  

  
  

  var faToiletPaperBlank = {
    prefix: 'fal',
    iconName: 'toilet-paper-blank',
    icon: [
      640,
      512,
      ["toilet-paper-alt"],
      'f71f',
      
      'M20.5 463.6c-2.8 4.7-4.3 10-4.5 15.4c-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512l269.9 0c22.3 0 45.4-12.1 55.4-36.1c10.7-25.8 27.3-76.6 36.3-158.9c.3-2.4 .5-4.9 .8-7.4c3.4-33.9 5.6-73 5.6-117.7c0-88.4 35.8-160 80-160s80 71.6 80 160s-35.8 160-80 160c-20.6 0-39.4-15.6-53.6-41.2c-1.6 16.4-3.6 31.8-5.7 46C452.2 372.7 471.9 384 496 384c40.7 0 69-32.2 85.2-64.6C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0L464 0 160 0C107 0 64 86 64 192c0 80.2-.4 180.8-36.2 257.3c-2.3 4.9-4.7 9.6-7.3 14.3c0 0 0 0 0 .1zM432.3 32c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 155.1-26.7 239-40.2 271.7c-4.3 10.3-14.5 16.3-25.9 16.3L48 480s0 0 0 0c.2-.3 .4-.6 .5-.9c24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-49.1 10-92 24.7-121.5C136.4 39.2 152.1 32 160 32l272.3 0zm49.2 180.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16z'
      
    ]
  };

  
    var faToiletPaperAlt = faToiletPaperBlank;
  

  
  

  var faFolderXmark = {
    prefix: 'fal',
    iconName: 'folder-xmark',
    icon: [
      512,
      512,
      ["folder-times"],
      'f65f',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM180.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 288l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 310.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 288l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 265.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faFolderTimes = faFolderXmark;
  

  
  

  var faFilmCanister = {
    prefix: 'fal',
    iconName: 'film-canister',
    icon: [
      576,
      512,
      ["film-cannister"],
      'f8b7',
      
      'M112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 0zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l16 0 0 384-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 256 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-384 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L48 64 16 64zM64 480L64 96l224 0 0 384L64 480zM384 200l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm8 152c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0zm88-152l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zM352 160l176 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48l0 32c0 8.8-7.2 16-16 16l-112 0 0 32 112 0c26.5 0 48-21.5 48-48l0-32c0-8.8 7.2-16 16-16c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-176 0 0 32z'
      
    ]
  };

  
    var faFilmCannister = faFilmCanister;
  

  
  

  var faSplit = {
    prefix: 'fal',
    iconName: 'split',
    icon: [
      512,
      512,
      [],
      'e254',
      
      'M404.7 36.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 144 400 144l-60.1 0c-8.5 0-16.6 3.4-22.6 9.4L214.6 256 317.3 358.6c6 6 14.1 9.4 22.6 9.4l60.1 0 57.4 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 400 400 400l-60.1 0c-17 0-33.3-6.7-45.3-18.7L190.1 276.7c-3-3-7.1-4.7-11.3-4.7L48 272l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 130.7 0c4.2 0 8.3-1.7 11.3-4.7L294.6 130.7c12-12 28.3-18.7 45.3-18.7l60.1 0 57.4 0L404.7 59.3c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faWaveformLines = {
    prefix: 'fal',
    iconName: 'waveform-lines',
    icon: [
      640,
      512,
      ["waveform-path"],
      'f8f2',
      
      'M320 0c8.8 0 16 7.2 16 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-480c0-8.8 7.2-16 16-16zM512 64c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16zM224 96c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16zm192 32c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM128 192c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM32 224c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm576 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faWaveformPath = faWaveformLines;
  

  
  

  var faWaterArrowUp = {
    prefix: 'fal',
    iconName: 'water-arrow-up',
    icon: [
      576,
      512,
      ["water-rise"],
      'f775',
      
      'M288 240c8.8 0 16-7.2 16-16l0-169.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6 272 224c0 8.8 7.2 16 16 16zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2zM192 352c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 352.1 0 358.4 0 366.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 369.9 161.7 384 192 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 369.9 353.7 384 384 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 342 404.9 352 384 352s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 342 212.9 352 192 352z'
      
    ]
  };

  
    var faWaterRise = faWaterArrowUp;
  

  
  

  var faPlaceOfWorship = {
    prefix: 'fal',
    iconName: 'place-of-worship',
    icon: [
      640,
      512,
      [],
      'f67f',
      
      'M320 0c4.2 0 8.3 1.7 11.3 4.7L406.6 80c6 6 9.4 14.1 9.4 22.6l0 89.3L457 217c14.3 8.7 23 24.2 23 41L480 480l96 0c17.7 0 32-14.3 32-32l0-69.9c0-10.9-5.5-21-14.6-26.9L512 298.6l0-38.1 98.8 63.9c18.2 11.8 29.2 32 29.2 53.7l0 69.9c0 35.3-28.7 64-64 64l-160 0s0 0 0 0l-32 0-32 0-64 0-32 0-32 0s0 0 0 0L64 512c-35.3 0-64-28.7-64-64l0-69.9c0-21.7 11-41.9 29.2-53.7L128 260.5l0 38.1L46.6 351.2c-9.1 5.9-14.6 16-14.6 26.9L32 448c0 17.7 14.3 32 32 32l96 0 0-222.1c0-16.7 8.7-32.2 23-41l41-25.1 0-89.3c0-8.5 3.4-16.6 9.4-22.6L308.7 4.7c3-3 7.1-4.7 11.3-4.7zM448 257.9c0-5.6-2.9-10.7-7.7-13.7l-48.7-29.8c-4.8-2.9-7.7-8.1-7.7-13.7l0-98.3-64-64-64 64 0 98.3c0 5.6-2.9 10.7-7.7 13.7l-48.7 29.8c-4.8 2.9-7.7 8.1-7.7 13.7L192 480l64 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 64 0 0-222.1zM352 480l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 64 0z'
      
    ]
  };

  

  
  

  var faPersonSkiJumping = {
    prefix: 'fal',
    iconName: 'person-ski-jumping',
    icon: [
      512,
      512,
      ["ski-jump"],
      'f7c7',
      
      'M432 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 352 56zM112 112c0-8.8 7.2-16 16-16l160 0 19.2 0c24.8 0 44.8 20.1 44.8 44.8c0 18.1-10.8 34.3-27.5 41.3L207 231.5c-1.6 2.4-3 4.9-4.2 7.5L142.6 374.5c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l60.2-135.4c2.6-5.9 6-11.5 9.9-16.6c.5-.7 1-1.3 1.5-1.9c.3-.4 .6-.7 .9-1.1L253.2 128 128 128c-8.8 0-16-7.2-16-16zm183.4 16l-42.5 49.6 59.3-24.9c4.8-2 7.9-6.7 7.9-11.8c0-7.1-5.7-12.8-12.8-12.8l-11.8 0zM496 176c8.8 0 16 7.2 16 16l0 7.3c0 35.9-20 68.8-51.9 85.3L23.3 510.2c-7.9 4.1-17.5 1-21.6-6.9s-1-17.5 6.9-21.6L445.4 256.1c21.3-11 34.6-32.9 34.6-56.9l0-7.3c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faSkiJump = faPersonSkiJumping;
  

  
  

  var faPlugCirclePlus = {
    prefix: 'fal',
    iconName: 'plug-circle-plus',
    icon: [
      576,
      512,
      [],
      'e55f',
      
      'M432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16zM112 0c8.8 0 16 7.2 16 16l0 96-32 0 0-96c0-8.8 7.2-16 16-16zM272 0c8.8 0 16 7.2 16 16l0 96-32 0 0-96c0-8.8 7.2-16 16-16zM0 160c0-8.8 7.2-16 16-16l16 0 32 0 256 0 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 35.2c-11.4 5.9-22.2 12.9-32 21l0-56.2L64 176l0 64c0 70.7 57.3 128 128 128c23.7 0 45.8-6.4 64.9-17.6c-.6 5.8-.9 11.7-.9 17.6c0 6.2 .3 12.3 .9 18.3c-15.2 6.8-31.7 11.2-48.9 12.9l0 96.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96.8C95.1 391.2 32 323 32 240l0-64-16 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faCircle7 = {
    prefix: 'fal',
    iconName: 'circle-7',
    icon: [
      512,
      512,
      [],
      'e0f4',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l132.4 0L194.1 360.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l128-224c2.8-5 2.8-11-.1-16s-8.1-8-13.8-8l-160 0z'
      
    ]
  };

  

  
  

  var faScannerTouchscreen = {
    prefix: 'fal',
    iconName: 'scanner-touchscreen',
    icon: [
      512,
      512,
      [],
      'f48a',
      
      'M128 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM400 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l224 0zM64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm40 96l144 0c4.4 0 8 3.6 8 8l0 208c0 4.4-3.6 8-8 8l-144 0c-4.4 0-8-3.6-8-8l0-208c0-4.4 3.6-8 8-8zm-40 8l0 208c0 22.1 17.9 40 40 40l144 0c22.1 0 40-17.9 40-40l0-208c0-22.1-17.9-40-40-40l-144 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faWaterArrowDown = {
    prefix: 'fal',
    iconName: 'water-arrow-down',
    icon: [
      576,
      512,
      ["water-lower"],
      'f774',
      
      'M288 0c8.8 0 16 7.2 16 16l0 169.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 185.4 272 16c0-8.8 7.2-16 16-16zM133.8 458.8C150.3 470 171.1 480 192 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM192 352c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 342 363.1 352 384 352s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 369.9 414.3 384 384 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 369.9 222.3 384 192 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 384.1 0 376 0 366.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 342 171.1 352 192 352z'
      
    ]
  };

  
    var faWaterLower = faWaterArrowDown;
  

  
  

  var faFaceSwear = {
    prefix: 'fal',
    iconName: 'face-swear',
    icon: [
      640,
      512,
      [],
      'e399',
      
      'M534.7 192C507.2 99.5 421.5 32 320 32S132.8 99.5 105.3 192l-33.2 0C100.5 81.6 200.7 0 320 0S539.5 81.6 567.9 192l-33.2 0zM264.4 176c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-8.1 4-15.3 10.2-19.6l-39.6-13.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-19.7-6.6c.8 2.3 1.2 4.8 1.2 7.4zm136 24c-13.3 0-24-10.7-24-24c0-2.7 .4-5.3 1.3-7.7l-20.6 6.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-39.1 13c6.3 4.3 10.4 11.6 10.4 19.8c0 13.3-10.7 24-24 24zM32 288l0 160c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L64 256c-17.7 0-32 14.3-32 32zM0 288c0-35.3 28.7-64 64-64l512 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 288zm400 64l-16 0 0 32 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-32 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-32-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0l0 32 32 0 0-32-32 0zm250.4-52.1c6.7 5.8 7.5 15.9 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 288c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM184 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 304l0 1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-2.3 1.7-2.2 4.5-.1 5.9c6.9 4.7 14.9 6.9 22.9 9.2c8.6 2.4 17.2 4.8 24.6 10.2c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4l0 .8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c3-1.8 2.9-6.7 .4-8.5c-6.8-5-15.2-7.3-23.6-9.7c-8.1-2.3-16.2-4.5-23.1-9.2c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7l0-1.5c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faRadioTuner = {
    prefix: 'fal',
    iconName: 'radio-tuner',
    icon: [
      512,
      512,
      ["radio-alt"],
      'f8d8',
      
      'M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6s-11-13.6-19.6-11.3L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66C.3 185.2 0 188.5 0 192l0 1.2L0 240 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-309.9 0 362-96.5zM32 193.2c0-2.2 .1-4.3 .4-6.4C34.9 171.6 48.1 160 64 160l384 0c17.7 0 32 14.3 32 32l0 32L32 224l0-30.8zM32 448l0-192 448 0 0 192c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32zM80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm272 32a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z'
      
    ]
  };

  
    var faRadioAlt = faRadioTuner;
  

  
  

  var faFaceSmilePlus = {
    prefix: 'fal',
    iconName: 'face-smile-plus',
    icon: [
      640,
      512,
      ["smile-plus"],
      'f5b9',
      
      'M560 16l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM416 288A192 192 0 1 0 32 288a192 192 0 1 0 384 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM126.9 330.1c4.5 11.2 15.1 29.1 31.8 44C175.1 388.7 196.8 400 224 400s48.9-11.3 65.3-25.9c16.7-14.9 27.3-32.8 31.8-44c3.3-8.2 12.6-12.2 20.8-8.9s12.2 12.6 8.9 20.8c-6.2 15.4-19.5 37.5-40.2 56C289.8 416.6 260.8 432 224 432s-65.8-15.4-86.7-34.1c-20.7-18.5-34-40.6-40.2-56c-3.3-8.2 .7-17.5 8.9-20.8s17.5 .7 20.8 8.9z'
      
    ]
  };

  
    var faSmilePlus = faFaceSmilePlus;
  

  
  

  var faMoped = {
    prefix: 'fal',
    iconName: 'moped',
    icon: [
      640,
      512,
      [],
      'e3b9',
      
      'M336 48c0-8.8 7.2-16 16-16l40.9 0c20.7 0 39 13.2 45.5 32.8l5.2 15.5L500.3 52c5.2-2.6 11-4 16.9-4C532 48 544 60 544 74.9l0 74.3c0 14.8-12 26.9-26.9 26.9c-5.9 0-11.6-1.4-16.9-4L469 156.4 494.5 233c5.7-.7 11.6-1 17.5-1c41.5 0 79.1 16.6 106.5 43.5c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C574.4 277.1 544.7 264 512 264c-56.5 0-104 39.1-116.7 91.8c-1.1 4.6-2 9.3-2.5 14.1c-.9 8.1-7.8 14.1-15.9 14.1L336 384l-48 0-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32l0-32c0-70.7 57.3-128 128-128l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7 14.3 32 32 32l32 0 16 0 16 0 11.4 0c.3-1.3 .6-2.5 .9-3.8c12.2-50.8 50-91.6 98.9-108.2l-55-165.1c-2.2-6.5-8.3-10.9-15.2-10.9L352 64c-8.8 0-16-7.2-16-16zm118.7 65.5c.2 .1 .3 .1 .5 .2L512 142.1l0-60.2-56.8 28.4c-.4 .2-.9 .4-1.3 .6l.9 2.6zM112 128l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96l-96 0c-53 0-96 43-96 96l0 32 37.5 0 35.1 0 110.9 0 17.1 0c-5.4-9.4-8.6-20.3-8.6-32l0-96zM160 448c35.3 0 64-28.7 64-64L96 384c0 35.3 28.7 64 64 64zm352 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faTemperatureSnow = {
    prefix: 'fal',
    iconName: 'temperature-snow',
    icon: [
      576,
      512,
      ["temperature-frigid"],
      'f768',
      
      'M368 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L368 96zM432 0c-53 0-96 43-96 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C303.7 293.1 288 328.8 288 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L528 96c0-53-43-96-96-96zM400 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-34c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM284.6 142.8l7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2L192 196.3l0-61.7 43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 89.4 192 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 41.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L160 134.6l0 61.7-53.4-30.8L90.7 106.3C88.5 97.8 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l7.6 28.3L31.6 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 224 90.6 254.8 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6L15.6 298.1C7.9 302.6 5.3 312.3 9.7 320s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2L160 251.7l0 61.7-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 358.6l0 41.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-41.4 20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 313.4l0-61.7 53.4 30.8 13.8 51.7c6.5-33.3 22.4-63.3 44.8-87l0-3.8-42.6 11.4L208 224l53.4-30.8L304 204.6l0-33.1-3.4-.9 3.4-2 0-37-19.4 11.2z'
      
    ]
  };

  
    var faTemperatureFrigid = faTemperatureSnow;
  

  
  

  var faTabletRugged = {
    prefix: 'fal',
    iconName: 'tablet-rugged',
    icon: [
      448,
      512,
      [],
      'f48f',
      
      'M64.5 58.4C67.1 43.4 80.2 32 96 32l256 0c15.8 0 28.9 11.4 31.5 26.4c.9 5 4.1 9.3 8.6 11.5L416 81.9l0 60.2-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3l0 32c0 6.1 3.4 11.6 8.8 14.3L416 225.9l0 60.2-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3l0 32c0 6.1 3.4 11.6 8.8 14.3L416 369.9l0 60.2-23.9 11.9c-4.5 2.3-7.7 6.6-8.6 11.5c-2.6 15-15.8 26.4-31.5 26.4L96 480c-15.8 0-28.9-11.4-31.5-26.4c-.9-5-4.1-9.3-8.6-11.5L32 430.1l0-60.2 23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3l0-32c0-6.1-3.4-11.6-8.8-14.3L32 286.1l0-60.2 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-32c0-6.1-3.4-11.6-8.8-14.3L32 142.1l0-60.2L55.9 69.9c4.5-2.3 7.7-6.5 8.6-11.5zM96 0C67.4 0 43.2 18.7 35 44.6L8.8 57.7C3.4 60.4 0 65.9 0 72l0 80c0 6.1 3.4 11.6 8.8 14.3L32 177.9l0 12.2L8.8 201.7C3.4 204.4 0 209.9 0 216l0 80c0 6.1 3.4 11.6 8.8 14.3L32 321.9l0 12.2L8.8 345.7C3.4 348.4 0 353.9 0 360l0 80c0 6.1 3.4 11.6 8.8 14.3L35 467.4C43.2 493.3 67.4 512 96 512l256 0c28.6 0 52.8-18.7 61-44.6l26.1-13.1c5.4-2.7 8.8-8.2 8.8-14.3l0-80c0-6.1-3.4-11.6-8.8-14.3L416 334.1l0-12.2 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-80c0-6.1-3.4-11.6-8.8-14.3L416 190.1l0-12.2 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-80c0-6.1-3.4-11.6-8.8-14.3L413 44.6C404.8 18.7 380.6 0 352 0L96 0zm32 96l192 0 0 320-192 0 0-320zM96 96l0 320c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L128 64c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faDistributeSpacingHorizontal = {
    prefix: 'fal',
    iconName: 'distribute-spacing-horizontal',
    icon: [
      512,
      512,
      [],
      'e365',
      
      'M464 0c-8.8 0-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480c0-8.8-7.2-16-16-16zM320 368c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 224zm32-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM64 16C64 7.2 56.8 0 48 0S32 7.2 32 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16L64 16z'
      
    ]
  };

  

  
  

  var faEyeDropperFull = {
    prefix: 'fal',
    iconName: 'eye-dropper-full',
    icon: [
      512,
      512,
      [],
      'e172',
      
      'M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c0 0 0 0 0 0l-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4s0 0 0 0s0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 39.9c-6.2-6.2-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6l0 41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480l41.2 0c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-112-112zM78.1 344.6L176 246.6 265.4 336l-97.9 97.9c-9 9-21.2 14.1-33.9 14.1L88 448l-4.2 0-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7 0-4.2 0-45.5c0-12.7 5.1-24.9 14.1-33.9z'
      
    ]
  };

  

  
  

  var faVials = {
    prefix: 'fal',
    iconName: 'vials',
    icon: [
      512,
      512,
      [],
      'f493',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l16 0 0 208 0 128c0 44.2 35.8 80 80 80s80-35.8 80-80l0-128 0-208 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L48 32 16 32zM64 256L64 64l96 0 0 192-96 0zm0 32l96 0 0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112zM304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 208 0 128c0 44.2 35.8 80 80 80s80-35.8 80-80l0-128 0-208 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L336 32l-32 0zm48 224l0-192 96 0 0 192-96 0zm0 32l96 0 0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112z'
      
    ]
  };

  

  
  

  var faShieldPlus = {
    prefix: 'fal',
    iconName: 'shield-plus',
    icon: [
      512,
      512,
      [],
      'e24a',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  

  
  

  var faBookFont = {
    prefix: 'fal',
    iconName: 'book-font',
    icon: [
      448,
      512,
      [],
      'e0bf',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM254.3 104.8l63.9 127.7c.1 .2 .2 .4 .3 .6l31.8 63.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 256l-108.2 0-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l31.8-63.7c.1-.2 .2-.4 .3-.6l63.9-127.7c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM278.1 224L240 147.8 201.9 224l76.2 0z'
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fal',
    iconName: 'cart-shopping',
    icon: [
      576,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2L496 384c8.8 0 16-7.2 16-16s-7.2-16-16-16l-304.8 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l314.6 0c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zm90.1 64l433.4 0L497.6 231.8C494 246 481.2 256 466.5 256l-321.1 0L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCarGarage = {
    prefix: 'fal',
    iconName: 'car-garage',
    icon: [
      640,
      512,
      [],
      'f5e2',
      
      'M328.5 2.5c-5.2-3.3-11.9-3.3-17.1 0l-304 192c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5L320 34.9 615.5 221.5c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1l-304-192zM252.2 208l135.6 0c14.3 0 26.8 9.5 30.8 23.2L434.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L169 298.1c-24.5 13.7-41 39.9-41 69.9l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.9-27.5-33-46.4-61.5-46.4l-135.6 0c-28.6 0-53.7 18.9-61.5 46.4zM480 416l0 16-320 0 0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48zM208 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faPersonMilitaryRifle = {
    prefix: 'fal',
    iconName: 'person-military-rifle',
    icon: [
      512,
      512,
      [],
      'e54b',
      
      'M192 64l0-4.9L320 37.8 320 64s0 0 0 0L192 64s0 0 0 0zm160 8l0-43.7c0-14.8-13.3-26.1-27.9-23.7l-144 24C168.5 30.6 160 40.6 160 52.3L160 72c0 11.1 7.5 20.4 17.8 23.2c-1.2 5.4-1.8 11-1.8 16.8c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.8-.6-11.4-1.8-16.8C344.5 92.4 352 83.1 352 72zM210.7 96l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16zM192 296c0-2.3 .2-4.6 .6-6.7L301.6 480 208 480c-8.8 0-16-7.2-16-16l0-168zM320 447.8l-106.9-187c5.6-3 12.1-4.7 18.9-4.7l48 0c22.1 0 40 17.9 40 40l0 151.8zM352 464l0-163.8 98.1 171.7c4.4 7.7 14.2 10.3 21.8 6s10.3-14.2 6-21.8L384 291.7l46.9-81.2c8.8-15.3 3.6-34.9-11.7-43.7l16-27.7 32-55.4 8-13.9c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l-16 27.7-16 27.7-16 27.7c-15.3-8.8-34.9-3.6-43.7 11.7L309.9 228c-9.5-2.6-19.5-4-29.6-4l-.3 0-48 0-.3 0c-40.2 0-77.3 21.5-97.2 56.4L34.1 456.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6L160 300.2 160 464c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48zM339.4 240.9l36-62.3 27.7 16-38.9 67.3c-7.3-8.2-15.6-15.3-24.8-21zM288 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faFlagSwallowtail = {
    prefix: 'fal',
    iconName: 'flag-swallowtail',
    icon: [
      448,
      512,
      ["flag-alt"],
      'f74c',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 32 0 64 0 320l0 32L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 392 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24L32 32l0-16zm0 48l376 0L326.4 172.8c-8.5 11.4-8.5 27 0 38.4L408 320 32 320 32 64z'
      
    ]
  };

  
    var faFlagAlt = faFlagSwallowtail;
  

  
  

  var faStarOfDavid = {
    prefix: 'fal',
    iconName: 'star-of-david',
    icon: [
      512,
      512,
      [10017],
      'f69a',
      
      'M418.3 286.6l-50 81.4 90.2 0c3 0 5.4-2.4 5.4-5.4c0-1-.3-2-.8-2.8l-44.9-73.1zM399.5 256L330.8 144l-149.6 0L112.5 256l68.7 112 149.6 0 68.7-112zm37.5 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4l-109.8 0-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400 53.4 400C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112l109.8 0 56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112l109.8 0c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zM368.4 144l50 81.4 44.9-73.1c.5-.9 .8-1.8 .8-2.8c0-3-2.4-5.4-5.4-5.4l-90.2 0zm-57.2-32L265.3 37.2c-2-3.2-5.5-5.2-9.3-5.2s-7.3 2-9.3 5.2L200.8 112l110.4 0zM143.6 144l-90.2 0c-3 0-5.4 2.4-5.4 5.4c0 1 .3 2 .8 2.8l44.9 73.1 50-81.4zm-50 142.6L48.8 359.7c-.5 .9-.8 1.8-.8 2.8c0 3 2.4 5.4 5.4 5.4l90.2 0-50-81.4zM200.8 400l45.9 74.8c2 3.2 5.5 5.2 9.3 5.2s7.3-2 9.3-5.2L311.2 400l-110.4 0z'
      
    ]
  };

  

  
  

  var faMosquito = {
    prefix: 'fal',
    iconName: 'mosquito',
    icon: [
      640,
      512,
      [],
      'e52b',
      
      'M182.4 3.4c-6.9 5.5-8.2 15.7-2.8 22.7l41.9 55.7L194 136.5c-3.2 6.3-2 14.1 3 19l45.1 45.1L79.3 226.2C34 232.1 0 272.5 0 320.3c0 84.5 97.6 126.9 154.6 67.1L272 280.4l0 23.9L228 357c-2.5 2.9-3.8 6.7-3.8 10.6l0 58.3-44.7 59.5c-5.3 7.1-4.1 17.3 2.8 22.7s16.8 4.2 22.1-2.9l48-63.9c2.1-2.8 3.3-6.3 3.3-9.9l0-57.9L272 354.1l0 45.4c0 26.5 21.5 48 48 48s48-21.5 48-48l0-45.4 16.2 19.4 0 57.9c0 3.6 1.2 7.1 3.3 9.9l48 63.9c5.3 7.1 15.2 8.4 22.1 2.9s8.2-15.7 2.8-22.7l-44.7-59.5 0-58.3c0-3.9-1.4-7.6-3.8-10.6l-44-52.7 0-23.9L485.4 387.4C542.4 447.2 640 404.9 640 320.3c0-47.9-34-88.2-79.4-94.2L397.9 200.7 443 155.6c5-5 6.2-12.7 3-19L418.6 81.8l41.9-55.7c5.3-7.1 4.1-17.3-2.8-22.7s-16.8-4.2-22.1 2.9l-48 63.9c-3.7 5-4.3 11.7-1.5 17.3l26.7 53.2L368 185.4l0-9.5c0-23.8-17.3-43.5-40-47.3l0-64.8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 64.8c-22.7 3.8-40 23.6-40 47.3l0 9.5-44.6-44.7L254 87.5c2.8-5.6 2.2-12.4-1.5-17.3l-48-63.9c-5.3-7.1-15.2-8.4-22.1-2.9zM272 237.1L133.1 363.8c-.5 .5-1.1 1-1.6 1.5C96.6 401.9 32 379.3 32 320.3c0-32.9 23.2-58.7 51.5-62.4c.3 0 .5-.1 .8-.1l185.8-29.1 1.9 1.9 0 6.4zM506.9 363.8L368 237l0-6.4 1.9-1.9 185.8 29.1c.3 0 .5 .1 .8 .1c28.3 3.7 51.5 29.5 51.5 62.4c0 58.9-64.6 81.6-99.5 45c-.5-.5-1-1-1.6-1.5zM304 399.5l0-223.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 223.6c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faDuck = {
    prefix: 'fal',
    iconName: 'duck',
    icon: [
      512,
      512,
      [129414],
      'f6d8',
      
      'M368 259l0-23.6c0-17.3 7.1-31.9 15.3-42.5L402.7 208l-19.4-15.1C393.8 179.4 400 162.5 400 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.5 32.2 64.2c9.8 7.3 14.5 19.5 12.3 31.5s-11.1 21.7-22.8 25l-165 46.2c-7 2-14.5 1.5-21.2-1.4L32.2 290.9C36.5 378 108.4 448 196 448l116 0c53 0 96-43 96-96c0-27.5-11.5-52.2-30-69.7c-6.4-6-10-14.4-10-23.2zm32-19l0 19c24.6 23.3 40 56.3 40 93c0 70.7-57.3 128-128 128l-116 0C87.8 480 0 391 0 282.7C0 268.1 11.9 256 26.6 256c3.6 0 7.2 .7 10.5 2.1L88 280l128.4-36L253 233.8c-9.8-7.3-18.3-16.1-25.2-26.2c-12.5-18.1-19.8-40-19.8-63.6c0-61.9 50.1-112 112-112c54.1 0 99.3 38.4 109.7 89.4c9.6 1.3 19.3 1.3 28.9 .1l24.2-3c15.5-1.9 29.2 10.1 29.2 25.8c0 52.9-42.9 95.7-95.7 95.7L400 240zm31.6-86.2c-1.7 20-8.8 38.6-19.7 54.2l4.4 0c32.9 0 59.9-24.9 63.3-56.8l-17 2.1c-10.3 1.3-20.7 1.5-31 .5zM312 152a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm13.2 159.7c-6.2 46.7-41.4 87-90.7 99.3c-40.4 10.1-81.2-.9-109.7-26.2c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3c20.7 18.3 50.6 26.6 80.7 19.1c36.8-9.2 62.3-39 66.7-72.5c1.2-8.8 9.2-14.9 18-13.7s14.9 9.2 13.7 18z'
      
    ]
  };

  

  
  

  var faMosque = {
    prefix: 'fal',
    iconName: 'mosque',
    icon: [
      640,
      512,
      [128332],
      'f678',
      
      'M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.4 54.5-29.8 73.5c34.3 1.2 61.8 29.3 61.8 64l0 96c0 35.3-28.7 64-64 64l-32 0-32 0-48 0-32 0-64 0-32 0-48 0-32 0-32 0c-35.3 0-64-28.7-64-64l0-96c0-34.6 27.5-62.8 61.8-64c-18.5-19-29.8-44.9-29.8-73.5c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6c0 0 0 0 0 0s0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zm32 480l0-56c0-10.1-4.7-19.6-12.8-25.6L400 384l-19.2 14.4c-8.1 6-12.8 15.5-12.8 25.6l0 56 64 0zm32 0l48 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 32 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-73.4 0L400 320l-102.6 0L224 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l32 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 48 0 0-56c0-20.1 9.5-39.1 25.6-51.2L400 344l38.4 28.8C454.5 384.9 464 403.9 464 424l0 56zM576 214.6c0-24-11.7-46.3-31.4-59.4c-5.6-3.7-11.1-7.3-16.5-10.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0c-48.6-32.1-92.1-60.7-128-102.7c-35.9 41.9-79.4 70.6-128 102.7c0 0 0 0 0 0c-5.5 3.6-11 7.2-16.6 10.9c-19.7 13.1-31.4 35.4-31.4 59.4c0 40.6 32.9 73.4 73.4 73.4L400 288l102.6 0c40.6 0 73.4-32.9 73.4-73.4zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126l0 2 0 32 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-96 0 0 16 0 272c0 17.7 14.3 32 32 32l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-35.3 0-64-28.7-64-64L0 176l0-50C0 83.2 20.2 42.9 54.4 17.2l16-12zM32 128l96 0 0-2c0-32.7-15.4-63.6-41.6-83.2L80 38l-6.4 4.8C47.4 62.4 32 93.3 32 126l0 2z'
      
    ]
  };

  

  
  

  var faBookHeart = {
    prefix: 'fal',
    iconName: 'book-heart',
    icon: [
      448,
      512,
      [],
      'f499',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM160 173.3c0 7.8 3.1 15.2 8.6 20.7L240 265.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM189.3 112c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z'
      
    ]
  };

  

  
  

  var faDropletSlash = {
    prefix: 'fal',
    iconName: 'droplet-slash',
    icon: [
      640,
      512,
      ["tint-slash"],
      'f5c7',
      
      'M320 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c2.8-6.4 5.8-13 9.1-19.7l-25.7-20.3C141.8 252.1 128 290.3 128 320c0 106 86 192 192 192c56.1 0 106.7-24.1 141.8-62.5l-25.2-19.9C407.4 460.6 366 480 320 480zM461.7 252.5c7.6 17.6 12.8 33.1 15.7 46.2L511.9 326c.1-2 .1-4 .1-6c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7c-13.3 16.8-39 50.2-66.4 90.3l25.2 19.9c27-39.7 52.6-73 66-89.9l1.3 0c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8zM240 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faTintSlash = faDropletSlash;
  

  
  

  var faGear = {
    prefix: 'fal',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.2-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.2-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCameraSecurity = {
    prefix: 'fal',
    iconName: 'camera-security',
    icon: [
      448,
      512,
      ["camera-home"],
      'f8fe',
      
      'M384 32c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-59.8 0-200.4 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM343.9 416l40.1 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l40.1 0L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3l272 0c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416zm-202.2 0l164.6 0 39.4 64-243.4 0 39.4-64zM224 304a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 208a128 128 0 1 0 256 0A128 128 0 1 0 96 208z'
      
    ]
  };

  
    var faCameraHome = faCameraSecurity;
  

  
  

  var faUserDoctorHairLong = {
    prefix: 'fal',
    iconName: 'user-doctor-hair-long',
    icon: [
      448,
      512,
      [],
      'e459',
      
      'M320 144c0 53-43 96-96 96s-96-43-96-96l0-16 34.3 0c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4l30.1 0c.9 5.2 1.3 10.5 1.3 16l0 16zm32-16C352 57.3 294.7 0 224 0S96 57.3 96 128c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2C37.5 227.9 32 238.9 32 250.7C32 271.3 48.7 288 69.3 288l58.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.7 0c-2.9 0-5.3-2.4-5.3-5.3c0-1.7 .8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.4C129.5 242.6 173.3 272 224 272s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.4l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3c0 2.9-2.4 5.3-5.3 5.3L320 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l58.7 0c20.6 0 37.3-16.7 37.3-37.3c0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 196.4 352 163.3 352 128zM225.5 57.1C213.5 81 189.1 96 162.3 96l-28.9 0c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48l-18.6 0c-6.4 0-12.5-2.5-17-7L251.3 52.7c-6.2-6.2-16.4-6.2-22.6 0c-1.3 1.3-2.4 2.8-3.1 4.5zM270.8 336c5.8 0 11.5 .3 17.2 1l0 33.3c-23.1 6.9-40 28.3-40 53.7l0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24c0-25.4-16.9-46.8-40-53.7l0-25.8c55.6 20 95.5 73 96 135.5L32 480c.5-68.2 48.2-125.3 112-140.2l0 30.9c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-34.7 1.2 0 93.6 0zM176 416a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM0 481.2c0 17 13.8 30.8 30.8 30.8l386.4 0c17 0 30.8-13.8 30.8-30.8C448 383.3 368.7 304 270.8 304l-93.6 0C79.3 304 0 383.3 0 481.2z'
      
    ]
  };

  

  
  

  var faFileCertificate = {
    prefix: 'fal',
    iconName: 'file-certificate',
    icon: [
      512,
      512,
      ["file-award"],
      'f5f3',
      
      'M480 448c0 17.7-14.3 32-32 32l-224 0 0 16c0 5.5-1 10.9-2.7 16L448 512c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 71.1 .1-.1c1.5-.7 4-2 6.6-3c8.2-3.4 16.9-4.6 25.3-4L160 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256zm-.5-288L368 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM249.8 288c0-.8 .2-2.4 3.5-10.4c6.3-15.4 1.6-33.1-11.6-43.2c-6.9-5.3-7.8-6.6-8.2-7.3s-1-2.1-2.2-10.7c-2.2-16.5-15.2-29.4-31.6-31.6c-8.6-1.2-10-1.8-10.7-2.2s-2-1.3-7.3-8.2c-10.2-13.1-27.9-17.9-43.2-11.6c-8 3.3-9.6 3.5-10.4 3.5s-2.4-.2-10.4-3.5c-15.4-6.3-33.1-1.6-43.2 11.6c-5.3 6.9-6.6 7.8-7.3 8.2s-2.1 1-10.7 2.2C39.9 187 27 199.9 24.7 216.4c-1.2 8.6-1.8 10-2.2 10.7s-1.3 2-8.2 7.3C1.2 244.5-3.5 262.2 2.8 277.6c3.3 8 3.5 9.6 3.5 10.4c0 0 0 0 0 0c0 .8-.2 2.4-3.5 10.4c-6.3 15.4-1.6 33.1 11.6 43.2c6.9 5.3 7.8 6.6 8.2 7.3s1 2.1 2.2 10.7C27 376.1 39.9 389 56.4 391.3c3.7 .5 6.1 .9 7.6 1.2L64 496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-103.5c1.6-.3 3.9-.7 7.6-1.2c16.5-2.2 29.4-15.2 31.6-31.6c1.2-8.6 1.8-10 2.2-10.7s1.3-2 8.2-7.3c13.1-10.2 17.9-27.9 11.6-43.2c-3.3-8-3.5-9.6-3.5-10.4c0 0 0 0 0 0zM96 466.1l0-50.9c7.1 1.5 14.6 .9 21.6-2c8-3.3 9.6-3.5 10.4-3.5s2.4 .2 10.4 3.5c7 2.9 14.5 3.4 21.6 2l0 50.9-23.1-15.4c-5.4-3.6-12.4-3.6-17.8 0L96 466.1zM38.2 288s0 0 0 0c0-8.1-2.9-15.4-5.8-22.5c-.8-2.1-.2-4.4 1.6-5.8c6.1-4.7 12.3-9.6 16.3-16.6s5.2-14.8 6.2-22.4c.3-2.2 2-3.9 4.2-4.2c7.7-1 15.4-2.2 22.4-6.2s11.8-10.2 16.6-16.3c1.4-1.8 3.7-2.4 5.8-1.6c7.1 2.9 14.4 5.8 22.5 5.8s15.4-2.9 22.5-5.8c2.1-.8 4.4-.2 5.8 1.6c4.7 6.1 9.6 12.3 16.6 16.3s14.8 5.2 22.4 6.2c2.2 .3 3.9 2 4.2 4.2c1 7.7 2.2 15.4 6.2 22.4s10.2 11.8 16.3 16.6c1.8 1.4 2.4 3.7 1.6 5.8c-2.9 7.1-5.8 14.4-5.8 22.5c0 0 0 0 0 0c0 8.1 2.9 15.4 5.8 22.5c.8 2.1 .2 4.4-1.6 5.8c-6.1 4.7-12.3 9.6-16.3 16.6s-5.2 14.8-6.2 22.4c-.3 2.2-2 3.9-4.2 4.2c-7.7 1-15.4 2.2-22.4 6.2s-11.8 10.2-16.6 16.3c-1.4 1.8-3.7 2.4-5.8 1.6c-7.1-2.9-14.4-5.8-22.5-5.8s-15.4 2.9-22.5 5.8c-2.1 .8-4.4 .2-5.8-1.6c-4.7-6.1-9.6-12.3-16.6-16.3s-14.8-5.2-22.4-6.2c-2.2-.3-3.9-2-4.2-4.2c-1-7.7-2.2-15.4-6.2-22.4s-10.2-11.8-16.3-16.6c-1.8-1.4-2.4-3.7-1.6-5.8c2.9-7.1 5.8-14.4 5.8-22.5z'
      
    ]
  };

  
    var faFileAward = faFileCertificate;
  

  
  

  var faMessageXmark = {
    prefix: 'fal',
    iconName: 'message-xmark',
    icon: [
      512,
      512,
      ["comment-alt-times","message-times"],
      'f4ab',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM180.7 132.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 230.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 208l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 185.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faCommentAltTimes = faMessageXmark;
  
    var faMessageTimes = faMessageXmark;
  

  
  

  var faHousePersonReturn = {
    prefix: 'fal',
    iconName: 'house-person-return',
    icon: [
      640,
      512,
      ["house-person-arrive","house-return"],
      'e011',
      
      'M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9 64 352c0 35.3 28.7 64 64 64l220.6 0 9.1-32-5.8 0-32 0-192 0c-17.7 0-32-14.3-32-32l0-191.5L240 37.1 367.9 146.7c5.8-9.1 12.6-17.4 20.4-24.7L250.4 3.9zM192 192l64 0 0 64-64 0 0-64zm-8-32c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0zM464 56a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-80 0a56 56 0 1 0 112 0A56 56 0 1 0 384 56zM522.4 172.3l12.7 6.9c27.5 15 47.4 40.8 55 71.2l2.4 9.6c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-2.4-9.5c-9.8-39-35.4-72.2-70.7-91.5l-12.7-6.9c-19.4-10.6-41.2-16.2-63.4-16.2c-36.9 0-69.7 23.6-81.4 58.7l-17.1 51.4c-3.4 10.1-10 18.8-18.9 24.8l-29.7 19.8c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l29.7-19.8c14.8-9.9 25.9-24.4 31.5-41.3l8.8-26.4L452.7 331l-43.6 37.8c-4.7 4.1-8.1 9.4-9.8 15.4L368.6 491.6c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11L430.1 393l100.6-87.2c14.4-12.5 20.1-32.4 14.4-50.6l-26.6-85c1.3 .6 2.6 1.3 3.9 2zm-7.9 92.5c1.9 6.1 0 12.7-4.8 16.9l-30.9 26.8-45-130c10-11.5 24.7-18.4 40.6-18.4c2.5 0 5 .1 7.5 .3l32.7 104.5zm6.4 88.9c-7.9 4-11.1 13.6-7.2 21.5l30.8 61.7c1.5 3.1 3.6 5.9 6 8.3l62.2 62.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2-30.8-61.7c-4-7.9-13.6-11.1-21.5-7.2z'
      
    ]
  };

  
    var faHousePersonArrive = faHousePersonReturn;
  
    var faHouseReturn = faHousePersonReturn;
  

  
  

  var faCartCircleArrowDown = {
    prefix: 'fal',
    iconName: 'cart-circle-arrow-down',
    icon: [
      640,
      512,
      [],
      'e3ef',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2l129.5 0c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16l-129.5 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l187.2 0c5.9-11.4 12.9-22.2 21-32l-214.8 0L106.1 64l433.4 0L507.4 192.4c10.9 .7 21.5 2.4 31.7 5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm360-88a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-256 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm211.3-3.3c-6.2-6.2-16.4-6.2-22.6 0L512 393.4l0-89.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56 56c6.2 6.2 16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faFaceSmileHalo = {
    prefix: 'fal',
    iconName: 'face-smile-halo',
    icon: [
      512,
      512,
      [],
      'e38f',
      
      'M480.3 78.1s0 0-.1 .1c0-.1 .1-.1 .1-.1zm-7.4-3.5c3.2 2.4 5 4.2 6.1 5.4c-1.1 1.2-2.9 3-6.1 5.4c-9 6.6-24 13.9-45.4 20.6C385 119.3 324.4 128 256 128s-129-8.7-171.5-22C63.1 99.3 48.1 92 39.1 85.4c-3.2-2.4-5-4.2-6.1-5.4c1.1-1.2 2.9-3 6.1-5.4c9-6.6 24-13.9 45.4-20.6C127 40.7 187.6 32 256 32s129 8.7 171.5 22c21.4 6.7 36.4 14 45.4 20.6zM31.7 78.1s0 0 .1 .1c0-.1-.1-.1-.1-.1zm0 3.8s0 0 .1-.1c0 .1-.1 .1-.1 .1zm448.5-.1c0 .1 .1 .1 .1 .1s0 0-.1-.1zM512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-9.5 3.9-19.7 7.6-30.5 11C453.8 198.2 464 233.9 464 272c0 114.9-93.1 208-208 208S48 386.9 48 272c0-38.1 10.2-73.8 28.1-104.5c-10.9-3.4-21.1-7.1-30.5-11zm110.9 94c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 217.9 194.8 208 176 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-14.9 89.4c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm162-64c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 217.9 354.8 208 336 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6z'
      
    ]
  };

  

  
  

  var faCircleBolt = {
    prefix: 'fal',
    iconName: 'circle-bolt',
    icon: [
      512,
      512,
      [],
      'e0fe',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm191.7 8l48.3 0c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L320.3 248 272 248c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L191.7 264zM313.6 112c14.7 0 24.4 15.2 18.2 28.5L297 216l49.4 0c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L215 296l-49.4 0c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L299.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z'
      
    ]
  };

  

  
  

  var faPresentationScreen = {
    prefix: 'fal',
    iconName: 'presentation-screen',
    icon: [
      576,
      512,
      ["presentation"],
      'f685',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 0zM32 64l0 224c0 35.3 28.7 64 64 64l176 0 0 41.4-91.3 91.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 422.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L304 393.4l0-41.4 176 0c35.3 0 64-28.7 64-64l0-224-32 0 0 224c0 17.7-14.3 32-32 32l-192 0L96 320c-17.7 0-32-14.3-32-32L64 64 32 64z'
      
    ]
  };

  
    var faPresentation = faPresentationScreen;
  

  
  

  var faHandsAslInterpreting = {
    prefix: 'fal',
    iconName: 'hands-asl-interpreting',
    icon: [
      640,
      512,
      ["american-sign-language-interpreting","asl-interpreting","hands-american-sign-language-interpreting"],
      'f2a3',
      
      'M146.5 3.7C122-6.5 93.9 5.1 83.7 29.5L9.8 206.8C3.3 222.4 0 239.1 0 256c0 70.7 57.3 128 128 128l80 0c41.5 0 77.7-22.6 97-56c10.7-18.4 7.7-41-5.8-56c13.5-15 16.4-37.6 5.8-56c-5.5-9.5-12.4-18.2-20.4-25.6l31-7.8c25.7-6.4 41.4-32.5 34.9-58.2s-32.5-41.4-58.2-34.9l-16.8 4.2 10-7.8c20.9-16.3 24.6-46.5 8.2-67.4l-12.6 9.9 12.6-9.9c-16.3-20.9-46.5-24.6-67.4-8.2L176 49.7c.7-19.4-10.5-38.1-29.5-46zM263.8 256l-.3 0-.3 0c-5.5-.1-10.7-3-13.6-8c-8.3-14.4-23.9-24-41.6-24c-26.5 0-48 21.5-48 48s21.5 48 48 48c17.7 0 33.3-9.6 41.6-24c2.9-5 8.1-7.9 13.6-8l.3 0 .3 0c2.6 0 5.2 .7 7.7 2.2c7.6 4.4 10.3 14.2 5.8 21.9c-13.8 23.9-39.7 40-69.3 40l-80 0c-53 0-96-43-96-96c0-12.7 2.5-25.2 7.4-36.9L113.2 41.8c3.4-8.2 12.8-12 20.9-8.6s12 12.8 8.6 20.9L127.9 89.9c-2.8 6.7-.7 14.5 5.1 18.9s13.8 4.4 19.6-.1l93.6-73.3c7-5.4 17-4.2 22.5 2.7s4.2 17-2.7 22.5l-69.3 54.2c-5.9 4.7-7.8 12.8-4.5 19.6s10.9 10.3 18.3 8.5l89.8-22.4c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-66.3 16.6c-6.7 1.7-11.5 7.4-12.1 14.3s3.4 13.3 9.7 16c16 6.8 29.4 18.7 38 33.7c4.4 7.6 1.8 17.4-5.8 21.9c-2.5 1.4-5.1 2.1-7.7 2.2zm-41.9 8c1.7 2.9 3.6 5.6 5.8 8c-2.1 2.4-4.1 5.1-5.8 8c-2.8 4.9-8 8-13.9 8c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.9 0 11.1 3.2 13.9 8zM493.5 508.3c24.5 10.2 52.6-1.4 62.8-25.8l73.8-177.2c6.5-15.6 9.8-32.3 9.8-49.2c0-70.7-57.3-128-128-128l-80 0c-41.5 0-77.7 22.6-97 56c-10.7 18.4-7.7 41 5.8 56c-13.5 15-16.4 37.6-5.8 56c5.5 9.5 12.4 18.2 20.4 25.6l-31 7.8c-25.7 6.4-41.4 32.5-34.9 58.2s32.5 41.4 58.2 34.9l16.8-4.2-10 7.8c-20.9 16.3-24.6 46.5-8.2 67.4s46.5 24.6 67.4 8.2L464 462.3c-.7 19.4 10.6 38.1 29.5 46zM376.2 256l.3 0 .3 0c5.5 .1 10.7 3 13.6 8c8.3 14.4 23.9 24 41.6 24c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.7 0-33.3 9.6-41.6 24c-2.9 5-8.1 7.9-13.6 8l-.3 0-.3 0c-2.6 0-5.2-.7-7.7-2.2c-7.6-4.4-10.3-14.2-5.8-21.9c13.8-23.9 39.7-40 69.3-40l80 0c53 0 96 43 96 96c0 12.7-2.5 25.2-7.4 36.9L526.8 470.2c-3.4 8.2-12.8 12-20.9 8.6s-12-12.8-8.6-20.9l14.9-35.8c2.8-6.7 .7-14.5-5.1-18.9s-13.8-4.4-19.6 .1l-93.6 73.3c-7 5.4-17 4.2-22.5-2.7s-4.2-17 2.7-22.5l69.3-54.2c5.9-4.7 7.8-12.8 4.5-19.6s-10.9-10.3-18.3-8.5l-89.8 22.4c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l66.3-16.6c6.7-1.7 11.5-7.4 12.1-14.3s-3.4-13.3-9.7-16c-16-6.8-29.4-18.7-38-33.7c-4.4-7.6-1.8-17.4 5.8-21.9c2.5-1.4 5.1-2.1 7.7-2.2zm41.9-8c-1.7-2.9-3.6-5.6-5.8-8c2.1-2.4 4.1-5.1 5.8-8c2.8-4.9 8-8 13.9-8c8.8 0 16 7.2 16 16s-7.2 16-16 16c-5.9 0-11.1-3.2-13.9-8z'
      
    ]
  };

  
    var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  
    var faAslInterpreting = faHandsAslInterpreting;
  
    var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  

  
  

  var faChartUser = {
    prefix: 'fal',
    iconName: 'chart-user',
    icon: [
      640,
      512,
      ["user-chart"],
      'f6a3',
      
      'M576 32L224 32c-17.7 0-32 14.3-32 32l0 36c-10.2-2.6-21-4-32-4l0-32c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-5.3-11.4-11.8-22.2-19.5-32L576 384c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32zM400 128c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-57.4L395.3 267.3c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L384 233.4 473.4 144 416 144c-8.8 0-16-7.2-16-16zM160 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 384c-54.2 0-98.4 42.5-101.2 96l255.7 0c-2.8-53.5-47-96-101.2-96l-53.3 0zm0-32l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z'
      
    ]
  };

  
    var faUserChart = faChartUser;
  

  
  

  var faBookCircleArrowRight = {
    prefix: 'fal',
    iconName: 'book-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0bc',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l262.6 0c-2.9-10.3-4.9-21-5.9-32L64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l336 0c8.8 0 16 7.2 16 16l0 163.2c10.1-5.2 20.8-9.4 32-12.6L448 48c0-26.5-21.5-48-48-48L64 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faVolumeOff = {
    prefix: 'fal',
    iconName: 'volume-off',
    icon: [
      320,
      512,
      [],
      'f026',
      
      'M288 66.7L151.6 188c-2.9 2.6-6.7 4-10.6 4l-85 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l85 0c3.9 0 7.7 1.4 10.6 4L288 445.3l0-378.6zM270.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8l0 388.4c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L134.9 352 56 352c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l78.9 0L270.4 39.5z'
      
    ]
  };

  

  
  

  var faFlaskRoundPoison = {
    prefix: 'fal',
    iconName: 'flask-round-poison',
    icon: [
      448,
      512,
      ["flask-poison"],
      'f6e0',
      
      'M160 32l128 0 0 125.7c0 18.2 10.1 33.7 24.4 42C364.9 230.3 400 287.1 400 352c0 47.4-18.7 90.4-49.2 122.1c-3.1 3.2-8.8 5.9-17 5.9l-219.6 0c-8.2 0-13.9-2.7-17-5.9C66.7 442.4 48 399.4 48 352c0-64.9 35.1-121.7 87.6-152.2c14.3-8.3 24.4-23.9 24.4-42L160 32zM320 157.7L320 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L304 0 144 0 112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 125.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4zM128 312c0-36.4 39.2-72 96-72s96 35.6 96 72c0 20.5-11.7 40.1-32.7 54c-8.7 5.8-15.3 15.8-15.3 27.7l0 22.3-96 0 0-22.3c0-11.9-6.6-21.9-15.3-27.7c-21-13.9-32.7-33.5-32.7-54zm96-104c-66.9 0-128 43.2-128 104c0 33.6 19.3 62.3 47.1 80.7c.5 .3 .7 .6 .9 .9c.1 .1 .1 .2 .1 .2l0 22.3c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-22.3c0 0 0-.1 .1-.2c.1-.2 .4-.6 .9-.9C332.7 374.3 352 345.6 352 312c0-60.8-61.1-104-128-104zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faFlaskPoison = faFlaskRoundPoison;
  

  
  

  var faFrancSign = {
    prefix: 'fal',
    iconName: 'franc-sign',
    icon: [
      320,
      512,
      [],
      'e18f',
      
      'M104 32C81.9 32 64 49.9 64 72l0 136 0 112-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 320l0-96 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 192 96 72c0-4.4 3.6-8 8-8l200 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L104 32z'
      
    ]
  };

  

  
  

  var faArrowDownLeft = {
    prefix: 'fal',
    iconName: 'arrow-down-left',
    icon: [
      384,
      512,
      [],
      'e091',
      
      'M48 416c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16l0 185.4L324.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 384 272 384c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 416z'
      
    ]
  };

  

  
  

  var faStreetView = {
    prefix: 'fal',
    iconName: 'street-view',
    icon: [
      512,
      512,
      [],
      'f21d',
      
      'M256 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 256 0a64 64 0 1 0 0 128zM192 280s0 0 0 0l0-56c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 56s0 0 0 0c-14.4 2.1-25.6 13.8-27.2 28.3l-8.9 84.5c-.4 4.1-3.9 7.2-8 7.2l-40 0c-4.1 0-7.5-3.1-8-7.2l-8.9-84.5c-1.5-14.5-12.7-26.2-27.2-28.3zm-32-56l0 56c0 16.1 11.9 29.4 27.3 31.7l8.9 84.5c2.1 20.4 19.3 35.8 39.8 35.8l40 0c20.5 0 37.6-15.5 39.8-35.8l8.9-84.5c15.5-2.3 27.3-15.6 27.3-31.7l0-56c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM126.6 383.7c8.7-1.7 14.4-10.1 12.7-18.7s-10.1-14.4-18.7-12.7c-33.2 6.4-61.8 15.3-82.6 26.2C27.6 384 18.5 390.4 11.8 398C4.9 405.6 0 415.1 0 426.2c0 17.6 12.2 31 25.8 40.3c14.1 9.7 33.5 17.8 56 24.4C127.1 504.1 188.7 512 256 512s128.9-7.9 174.2-21.1c22.5-6.6 41.9-14.7 56-24.4c13.6-9.4 25.8-22.7 25.8-40.3c0-11.1-4.9-20.6-11.8-28.3c-6.7-7.5-15.9-13.9-26.2-19.4c-20.8-11-49.4-19.8-82.6-26.2c-8.7-1.7-17.1 4-18.7 12.7s4 17.1 12.7 18.7c31.6 6.1 56.8 14.2 73.6 23.1c8.4 4.5 14 8.7 17.3 12.5c3.2 3.6 3.6 5.9 3.6 6.9c0 1.6-1.3 6.6-11.9 14c-10.2 7-25.9 13.9-46.8 20C379.6 472.3 321.2 480 256 480s-123.6-7.7-165.2-19.8c-20.9-6.1-36.7-13-46.8-20c-10.7-7.3-11.9-12.3-11.9-14c0-1.1 .4-3.3 3.6-6.9c3.3-3.7 8.9-8 17.3-12.5c16.8-8.9 42-17 73.6-23.1z'
      
    ]
  };

  

  
  

  var faFontCase = {
    prefix: 'fal',
    iconName: 'font-case',
    icon: [
      640,
      512,
      [],
      'f866',
      
      'M190.9 42.3C188.6 36.1 182.6 32 176 32s-12.6 4.1-14.9 10.3l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2L76.2 352l199.6 0 45.3 117.7c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-160-416zM263.5 320L88.5 320 176 92.6 263.5 320zM624 160c-8.8 0-16 7.2-16 16l0 34.7C585.4 179.9 549 160 508 160c-68.5 0-124 55.5-124 124l0 72c0 68.5 55.5 124 124 124c41 0 77.4-19.9 100-50.7l0 34.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM416 284c0-50.8 41.2-92 92-92s92 41.2 92 92l0 72c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-72z'
      
    ]
  };

  

  
  

  var faPlugCircleCheck = {
    prefix: 'fal',
    iconName: 'plug-circle-check',
    icon: [
      576,
      512,
      [],
      'e55c',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64c0 83 63.1 151.2 144 159.2l0 96.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96.8c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128l0-64 256 0 0 56.2c9.8-8.1 20.6-15.2 32-21l0-35.2 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0L64 144l-32 0-16 0zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faArrowLeftLong = {
    prefix: 'fal',
    iconName: 'arrow-left-long',
    icon: [
      512,
      512,
      ["long-arrow-left"],
      'f177',
      
      'M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 171.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z'
      
    ]
  };

  
    var faLongArrowLeft = faArrowLeftLong;
  

  
  

  var faTrashSlash = {
    prefix: 'fal',
    iconName: 'trash-slash',
    icon: [
      640,
      512,
      [],
      'e2b3',
      
      'M509.7 96L528 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32.1 0-47 0L407 22.6C398.2 8.5 382.8 0 366.3 0L273.7 0C257.2 0 241.8 8.5 233 22.6L207.1 64l-27 0 40.5 32 257 0L463.9 288.1l30.4 24L509.7 96zM452.9 442.5l-.6 7.8C451.1 467 437.2 480 420.4 480l-200.8 0c-16.8 0-30.7-13-31.9-29.7L171.2 220.1l-34-26.8 18.5 259.3c2.4 33.5 30.3 59.4 63.8 59.4l200.8 0c29.1 0 54-19.5 61.6-46.6l-29.1-23zM273.7 32l92.5 0c5.5 0 10.6 2.8 13.6 7.5L395.1 64 244.9 64l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faChess = {
    prefix: 'fal',
    iconName: 'chess',
    icon: [
      512,
      512,
      [],
      'f439',
      
      'M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L52.6 96C41.2 96 32 105.2 32 116.6c0 2.2 .4 4.4 1.1 6.5L66.7 224 56 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l13.8 0L56.7 352 89 352l13.1-96 51.8 0L167 352l32.3 0-13.1-96 13.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-10.7 0 33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5c0-11.4-9.2-20.6-20.6-20.6L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm11.6 208l-55.2 0-32-96 59.6 0 59.6 0-32 96zm34.6 160L65.8 384c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512l177.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7L65.8 416l124.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L39.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9zM452.5 416L479 467.2c.6 1.2 1 2.6 1 4c0 4.8-3.9 8.8-8.8 8.8l-142.5 0c-4.8 0-8.8-3.9-8.8-8.8c0-1.4 .3-2.8 1-4L347.5 416l105 0zm-105-32c-12 0-22.9 6.7-28.4 17.3l-26.5 51.2c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8l142.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3l-105 0zM304 160c-8.8 0-16 7.2-16 16l0 80c0 3.7 1.3 7.4 3.7 10.2L328 309.8l0 26.2 0 16 32 0 0-16 0-32c0-3.7-1.3-7.4-3.7-10.2L320 250.2l0-58.2 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 58.2-36.3 43.5c-2.4 2.9-3.7 6.5-3.7 10.2l0 32 0 16 32 0 0-16 0-26.2 36.3-43.5c2.4-2.9 3.7-6.5 3.7-10.2l0-80c0-8.8-7.2-16-16-16l-64 0-64 0-64 0z'
      
    ]
  };

  

  
  

  var faGif = {
    prefix: 'fal',
    iconName: 'gif',
    icon: [
      576,
      512,
      [],
      'e190',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 160c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zm48 16l0 80 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-48 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM128 256c0-35.3 28.7-64 64-64c14.4 0 27.7 4.8 38.4 12.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4c-16-12.1-36-19.2-57.6-19.2c-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2c4-3 6.4-7.8 6.4-12.8l0-64c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 39.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faRightToLine = {
    prefix: 'fal',
    iconName: 'right-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-right"],
      'f34c',
      
      'M416 80l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16zM319.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L187.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16L40 304c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L319.2 254.2zM352 256c0-9.5-3.9-18.6-10.8-25.1L209.2 106.5C202 99.8 192.5 96 182.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3L40 176c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.3-3.8 26.5-10.5L341.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1z'
      
    ]
  };

  
    var faArrowAltToRight = faRightToLine;
  

  
  

  var faFireFlame = {
    prefix: 'fal',
    iconName: 'fire-flame',
    icon: [
      384,
      512,
      ["flame"],
      'f6df',
      
      'M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4C125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM187.4 206l0 .6c0 16.1 6.3 31.6 17.5 43.3l8.2 8.5c9.9 10.3 15.5 24.1 15.5 38.4c0 30.5-24.7 55.3-55.3 55.3l-2.5 0c-31.9 0-57.7-25.8-57.7-57.7l0-22.2c-11 12.2-17.1 28.1-17.1 44.7l0 3.2c0 53 43 96 96 96l7.3 0c49 0 88.7-39.7 88.7-88.7c0-27.9-12.2-54.3-33.4-72.4l-44.6-38.1c-9.7-8.3-16.4-19.6-19-31.9c-2.4 6.8-3.6 13.9-3.6 21.1zm9.9-78c13.5 0 24.4 10.9 24.4 24.4l0 20.2c0 7.6 3.3 14.9 9.1 19.8l44.6 38.1c28.3 24.2 44.6 59.5 44.6 96.7C320 393.9 265.9 448 199.3 448l-7.3 0c-70.7 0-128-57.3-128-128l0-3.2c0-27.9 11.8-54.6 32.6-73.3l5.3-4.8c4.8-4.3 10.9-6.7 17.4-6.7c14.3 0 25.9 11.6 25.9 25.9l0 36.4c0 14.2 11.5 25.7 25.7 25.7l2.5 0c12.8 0 23.3-10.4 23.3-23.3c0-6-2.3-11.8-6.5-16.1l-8.2-8.5c-17-17.6-26.4-41.1-26.4-65.5l0-.6c0-13.9 3-27.6 8.9-40.2l10.9-23.6c4-8.6 12.6-14.1 22.1-14.1z'
      
    ]
  };

  
    var faFlame = faFireFlame;
  

  
  

  var faMinus = {
    prefix: 'fal',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faCircle5 = {
    prefix: 'fal',
    iconName: 'circle-5',
    icon: [
      512,
      512,
      [],
      'e0f2',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-7.3 0-13.7 5-15.5 12.1l-24 96c-1.1 4.5-.2 9.3 2.4 13.1s6.9 6.3 11.5 6.7l98.8 10c22.1 2.2 38.8 20.8 38.8 42.9c0 23.8-19.3 43.2-43.2 43.2l-44 0c-16.8 0-32.4-8.3-41.8-22.3l-1.8-2.7c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2l1.8 2.7c15.3 22.8 40.9 36.4 68.3 36.4l44 0c41.5 0 75.2-33.7 75.2-75.2c0-38.6-29.2-70.9-67.6-74.8L204 225.9 220.5 160l99.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0z'
      
    ]
  };

  

  
  

  var faCircleSterling = {
    prefix: 'fal',
    iconName: 'circle-sterling',
    icon: [
      512,
      512,
      [],
      'e5cf',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM259.6 144c-20.2 0-36.5 16.5-36.4 36.7l.3 43.3 48.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48.4 0c-.9 22.5-7.1 44.4-18 64L328 320c8.8 0 16 7.2 16 16s-7.2 16-16 16l-152 0c-5.9 0-11.4-3.3-14.2-8.5s-2.4-11.6 1-16.5l9.2-13.5c11.7-17 18.4-36.9 19.5-57.5L176 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l15.5 0-.3-43.1c-.3-38 30.4-68.9 68.4-68.9c10.6 0 21.1 2.5 30.6 7.2l20.9 10.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-20.9-10.5c-5.1-2.5-10.6-3.8-16.3-3.8z'
      
    ]
  };

  

  
  

  var faBracketRoundRight = {
    prefix: 'fal',
    iconName: 'bracket-round-right',
    icon: [
      192,
      512,
      [],
      '29',
      
      'M33.9 40.4c-4.2 7.8-1.3 17.5 6.4 21.7C80.5 83.8 160 153.4 160 256s-79.5 172.2-119.6 193.9c-7.8 4.2-10.7 13.9-6.4 21.7s13.9 10.7 21.7 6.4C100.8 453.6 192 375.3 192 256S100.8 58.4 55.6 33.9c-7.8-4.2-17.5-1.3-21.7 6.4z'
      
    ]
  };

  

  
  

  var faVirusSlash = {
    prefix: 'fal',
    iconName: 'virus-slash',
    icon: [
      640,
      512,
      [],
      'e075',
      
      'M532.5 288l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 36.4-32.2 59.6-63.3 55.7L259.9 127C293.3 115.8 320 85.2 320 43.5c0 78.4 94.8 117.7 150.2 62.2C414.8 161.2 454.1 256 532.5 256c-29.1 0-52.8 13-68.3 32.3l25.1 19.9c9.9-12 24.8-20.1 43.1-20.1zM107.5 256c29.1 0 52.8-13 68.3-32.3l-25.1-19.9c-9.9 12-24.8 20.1-43.1 20.1L96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-36.4 32.2-59.6 63.3-55.7L380.1 385c-33.4 11.2-60.1 41.8-60.1 83.4c0-78.4-94.8-117.6-150.2-62.2C225.2 350.8 185.9 256 107.5 256zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faDna = {
    prefix: 'fal',
    iconName: 'dna',
    icon: [
      448,
      512,
      [129516],
      'f471',
      
      'M400 0c8.8 0 16 7.2 16 16c0 120.2-94.2 188.6-179.7 250.9l-2.8 2.1c-37.8 27.5-73.9 54-102.9 83.1l187 0c-19.8-19.8-42.8-38.4-67.5-57c3.2-2.3 6.4-4.6 9.7-6.9c5.9-4.2 11.7-8.4 17.6-12.7C349.4 330.4 416 394.9 416 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.5-.2-10.8-.7-16L64.7 480c-.4 5.2-.7 10.5-.7 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-113.2 83.6-180.5 164.8-240C115.6 196.5 32 129.2 32 16C32 7.2 39.2 0 48 0s16 7.2 16 16c0 5.5 .2 10.8 .7 16l318.7 0c.4-5.2 .7-10.5 .7-16c0-8.8 7.2-16 16-16zM377.6 64L70.4 64c6.5 23.4 17.6 44.5 32.2 64l242.9 0c14.6-19.5 25.7-40.6 32.2-64zm-60.1 96l-187 0c26.6 26.7 59.1 51.1 93.5 76.2c34.4-25.1 66.9-49.5 93.5-76.2zM70.4 448l307.3 0c-6.5-23.5-17.6-44.5-32.2-64.1c-.5 0-.9 .1-1.4 .1l-240 0c-.5 0-.9 0-1.4-.1C88 403.5 76.8 424.5 70.4 448z'
      
    ]
  };

  

  
  

  var faTurnLeftUp = {
    prefix: 'fal',
    iconName: 'turn-left-up',
    icon: [
      384,
      512,
      [],
      'e638',
      
      'M256 160l57.3 0c3.7 0 6.7-3 6.7-6.7c0-1.9-.8-3.7-2.2-5L192 35.8 66.2 148.3c-1.4 1.3-2.2 3.1-2.2 5c0 3.7 3 6.7 6.7 6.7l57.3 0c17.7 0 32 14.3 32 32l0 176c0 61.9 50.1 112 112 112l64 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-64 0c-26.5 0-48-21.5-48-48l0-176c0-17.7 14.3-32 32-32zM178 5.3c3.8-3.4 8.8-5.3 14-5.3s10.1 1.9 14 5.3L339.1 124.5c8.2 7.3 12.9 17.8 12.9 28.8c0 21.4-17.3 38.7-38.7 38.7L288 192l-32 0 0 32 0 144c0 8.8 7.2 16 16 16l64 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-64 0c-79.5 0-144-64.5-144-144l0-144 0-32-32 0-25.3 0C49.3 192 32 174.7 32 153.3c0-11 4.7-21.5 12.9-28.8L178 5.3z'
      
    ]
  };

  

  
  

  var faCloudBoltMoon = {
    prefix: 'fal',
    iconName: 'cloud-bolt-moon',
    icon: [
      576,
      512,
      ["thunderstorm-moon"],
      'f76d',
      
      'M387.7 101.7c7.9-27.6 28-50.1 54.2-61.6c-12.8 19-20.3 41.8-20.3 66.3c0 53.9 35.9 99.2 85.1 114.2c-8.2 2.2-16.7 3.4-25.6 3.4c-4.2 0-8.3-.3-12.4-.8c4.9 10.2 8.3 21.2 10 32.8c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9c9.8 5.9 18.7 13.3 26.3 21.8zM112 160c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-22.5 0c5.7 8.5 9 18.7 9 29.7c0 .8 0 1.5-.1 2.3l13.3 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 82.6 210.9 64 176 64c-53 0-96 43-96 96l0 1.3C34.6 168.9 0 208.4 0 256c0 46.9 33.6 85.9 78 94.3c.9-1 1.8-1.9 2.7-2.8l29.1-27.6-10.9 0c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 216l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4l48.3 0-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4l-48.3 0zM265.6 224c-5.1 0-10.1 2-13.8 5.5L102.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6l49.4 0-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L313.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6L249 328l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z'
      
    ]
  };

  
    var faThunderstormMoon = faCloudBoltMoon;
  

  
  

  var faCircleUpRight = {
    prefix: 'fal',
    iconName: 'circle-up-right',
    icon: [
      512,
      512,
      [],
      'e129',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm80 184c0-4.4-3.6-8-8-8l-113.4 0c-3.7 0-6.6 3-6.6 6.6c0 1.8 .7 3.4 1.9 4.7l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6l-59.1 59.1c-3.6 3.6-4.9 9-3.3 13.9c.7 2 1.8 3.8 3.3 5.3l22.1 22.1c1.5 1.5 3.3 2.6 5.3 3.3c4.9 1.6 10.3 .4 13.9-3.3l59.1-59.1c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c1.2 1.2 2.9 1.9 4.7 1.9c3.7 0 6.6-3 6.6-6.6L336 184zm-8-40c22.1 0 40 17.9 40 40l0 113.4c0 21.3-17.3 38.6-38.6 38.6c-10.2 0-20.1-4.1-27.3-11.3L288 310.6l-47.7 47.7c-12.2 12.2-30.3 16.5-46.7 11c-6.7-2.2-12.8-6-17.8-11l-22.1-22.1c-5-5-8.8-11.1-11-17.8c-5.5-16.4-1.2-34.5 11-46.7L201.4 224l-14.1-14.1c-7.2-7.2-11.3-17.1-11.3-27.3c0-21.3 17.3-38.6 38.6-38.6L328 144z'
      
    ]
  };

  

  
  

  var faKeyboardDown = {
    prefix: 'fal',
    iconName: 'keyboard-down',
    icon: [
      576,
      512,
      [],
      'e1c2',
      
      'M64 32C46.3 32 32 46.3 32 64l0 160c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64L64 288c-35.3 0-64-28.7-64-64L0 64zm184 8l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM72 184c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM88 72l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM264 88c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM376 72l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 80l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM160 192c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zM288 473.4L404.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 473.4z'
      
    ]
  };

  

  
  

  var faLeftLong = {
    prefix: 'fal',
    iconName: 'left-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-left"],
      'f30a',
      
      'M160 328l0 49.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L35.8 256 148.3 130.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 49.3c0 17.7 14.3 32 32 32l272 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-272 0c-17.7 0-32 14.3-32 32zM5.3 242C1.9 245.9 0 250.8 0 256s1.9 10.1 5.3 14L124.5 403.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-17.3 0-32 32 0 240 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-240 0-32 0 0-32 0-17.3c0-21.4-17.3-38.7-38.7-38.7c-11 0-21.5 4.7-28.8 12.9L5.3 242z'
      
    ]
  };

  
    var faLongArrowAltLeft = faLeftLong;
  

  
  

  var faMoneyBill1 = {
    prefix: 'fal',
    iconName: 'money-bill-1',
    icon: [
      576,
      512,
      ["money-bill-alt"],
      'f3d1',
      
      'M512 96c17.7 0 32 14.3 32 32l0 32c-35.3 0-64-28.7-64-64l32 0zM128 96l320 0c0 53 43 96 96 96l0 128c-53 0-96 43-96 96l-320 0c0-53-43-96-96-96l0-128c53 0 96-43 96-96zM32 352c35.3 0 64 28.7 64 64l-32 0c-17.7 0-32-14.3-32-32l0-32zm448 64c0-35.3 28.7-64 64-64l0 32c0 17.7-14.3 32-32 32l-32 0zM96 96c0 35.3-28.7 64-64 64l0-32c0-17.7 14.3-32 32-32l32 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM256 208c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm-64 48a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  
    var faMoneyBillAlt = faMoneyBill1;
  

  
  

  var faCropSimple = {
    prefix: 'fal',
    iconName: 'crop-simple',
    icon: [
      512,
      512,
      ["crop-alt"],
      'f565',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 240c0 26.5 21.5 48 48 48l208 0 0-32-208 0c-8.8 0-16-7.2-16-16l0-352zM384 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-240c0-26.5-21.5-48-48-48L160 96l0 32 208 0c8.8 0 16 7.2 16 16l0 352z'
      
    ]
  };

  
    var faCropAlt = faCropSimple;
  

  
  

  var faIndianRupeeSign = {
    prefix: 'fal',
    iconName: 'indian-rupee-sign',
    icon: [
      320,
      512,
      ["indian-rupee","inr"],
      'e1bc',
      
      'M0 48c0-8.8 7.2-16 16-16l96 0 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L202.5 64c28.7 23.2 48.3 57.3 52.6 96l48.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48.9 0c-8 72-69 128-143.1 128l-46.1 0L249.3 451c7.2 5.1 8.9 15.1 3.7 22.3s-15.1 8.9-22.3 3.7L6.7 317C1 313-1.4 305.7 .8 299.1S9 288 16 288l96 0c56.4 0 103.1-41.7 110.9-96L16 192c-8.8 0-16-7.2-16-16s7.2-16 16-16l206.9 0c-7.8-54.3-54.4-96-110.9-96L16 64C7.2 64 0 56.8 0 48z'
      
    ]
  };

  
    var faIndianRupee = faIndianRupeeSign;
  
    var faInr = faIndianRupeeSign;
  

  
  

  var faListTimeline = {
    prefix: 'fal',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      'M213.3 128L416 128l0-64L213.3 64l-32 32 32 32zM190.6 41.4c6-6 14.1-9.4 22.6-9.4L416 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-202.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm181.3 32L416 448l0-64-202.7 0-32 32 32 32zm-22.6-86.6c6-6 14.1-9.4 22.6-9.4L416 352c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-202.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM181.3 256l32 32L480 288l0-64-266.7 0-32 32zm-33.9-11.3l43.3-43.3c6-6 14.1-9.4 22.6-9.4L480 192c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-266.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faMoneyBillsSimple = {
    prefix: 'fal',
    iconName: 'money-bills-simple',
    icon: [
      640,
      512,
      ["money-bills-alt"],
      'e1f4',
      
      'M576 64c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-416 0c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l416 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 368c0 61.9 50.1 112 112 112l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-416 0c-44.2 0-80-35.8-80-80l0-256z'
      
    ]
  };

  
    var faMoneyBillsAlt = faMoneyBillsSimple;
  

  
  

  var faBadgeDollar = {
    prefix: 'fal',
    iconName: 'badge-dollar',
    icon: [
      512,
      512,
      [],
      'f645',
      
      'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm16.9 140.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 20.8c-9.5 1.5-19.2 4.6-27.7 9.7c-14.1 8.3-25.7 22.7-25.6 43.4c.1 19.6 11.4 32.1 24.4 39.9c11.5 6.9 26.1 11.3 38.4 15l1.7 .5c13.8 4.2 24.8 7.7 32.7 12.6c6.9 4.3 9.3 8.4 9.4 14.3c.1 8.1-3.4 13.2-9.5 17c-6.8 4.3-16.9 6.5-27.3 6.2c-13.4-.4-25.8-4.7-40.9-9.8c0 0 0 0 0 0s0 0 0 0c-2.5-.9-5.2-1.8-7.9-2.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2.2 .7 4.6 1.5 6.9 2.4c10.6 3.7 22.7 7.8 35.4 10.1l0 21.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-20.5c10-1.5 20-4.6 28.7-10.1c14.3-8.9 24.9-23.9 24.6-44.6c-.3-19.8-11.3-32.7-24.4-41c-12-7.6-27.4-12.2-40-16l-.4-.1c-13.9-4.2-25-7.6-32.8-12.3c-6.9-4.2-8.9-7.8-8.9-12.7c0-6.8 3.2-11.8 9.9-15.7c7.3-4.3 17.5-6.5 27.1-6.4c11.4 .2 23.7 2.7 36.1 6c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.7-2.3-18.3-4.5-28.1-5.8l0-20.8z'
      
    ]
  };

  

  
  

  var faBallPile = {
    prefix: 'fal',
    iconName: 'ball-pile',
    icon: [
      576,
      512,
      [],
      'f77e',
      
      'M352 96A64 64 0 1 0 224 96a64 64 0 1 0 128 0zm-35.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 416A64 64 0 1 0 32 416a64 64 0 1 0 128 0zm224-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faFaceSmileUpsideDown = {
    prefix: 'fal',
    iconName: 'face-smile-upside-down',
    icon: [
      512,
      512,
      [],
      'e395',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM164.1 186.5C182 165.8 212.6 144 256 144s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6s7.4-15.9 1.6-22.6C349.8 139.9 311.1 112 256 112s-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6zM200.4 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faChartGantt = {
    prefix: 'fal',
    iconName: 'chart-gantt',
    icon: [
      512,
      512,
      [],
      'e0e4',
      
      'M16 32c8.8 0 16 7.2 16 16l0 352c0 26.5 21.5 48 48 48l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 480c-44.2 0-80-35.8-80-80L0 48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm80 80l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTrainSubway = {
    prefix: 'fal',
    iconName: 'train-subway',
    icon: [
      448,
      512,
      ["subway"],
      'f239',
      
      'M208 32l0 192L32 224 32 96c0-35.3 28.7-64 64-64l112 0zm32 0l112 0c35.3 0 64 28.7 64 64l0 128-176 0 0-192zM32 352l0-96 384 0 0 96c0 35.3-28.7 64-64 64L96 416c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96L0 352c0 46 32.4 84.4 75.6 93.8L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L118.6 448l210.7 0 59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352l0-256c0-53-43-96-96-96L96 0zm24 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm232-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSubway = faTrainSubway;
  

  
  

  var faGameConsoleHandheldCrank = {
    prefix: 'fal',
    iconName: 'game-console-handheld-crank',
    icon: [
      576,
      512,
      [],
      'e5b9',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-144 0-176c0-17.7-14.3-32-32-32L64 64zM448 96l0 160 32 0 0-48 0-48c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 48c0 8.8-7.2 16-16 16l-48 0 0 128c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64zM96 128l0 128 256 0 0-128L96 128zm-32 0c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32l0-128zm448 64l32 0 0-32-32 0 0 32zM128 336l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSportsball = {
    prefix: 'fal',
    iconName: 'sportsball',
    icon: [
      512,
      512,
      [],
      'e44b',
      
      'M436.9 52.4l-94.2 94.3c-23.7-27.4-41-60.6-49.2-97.2c41.2-5.3 88.7-4.8 143.5 2.9zM261.9 55c9.5 43.2 29.8 82.4 58.1 114.4l-64 64L138.4 115.8c22.2-19.9 49.1-36.6 81.6-48.7c13-4.8 27-8.9 41.9-12.2zM116.1 138.8L233.4 256l-64 64c-31.6-27.9-70.2-48.1-112.7-57.7c7.5-32.2 19.3-63.5 36.7-92c6.7-11 14.3-21.6 22.8-31.6zm-65.5 155c36.1 8.4 68.9 25.4 96 48.9L52.2 437.2c-6.9-42.8-8.9-93.2-1.5-143.4zM75 459.6l94.3-94.3c23.7 27.4 41 60.6 49.2 97.2c-41.2 5.3-88.7 4.8-143.5-2.9zm175-2.5c-9.5-43.2-29.8-82.4-58.1-114.4l64-64L373.6 396.2c-22.2 19.9-49.1 36.6-81.6 48.7c-13 4.8-27 8.9-41.9 12.2zm145.8-83.8L278.6 256l64-64c31.6 27.9 70.2 48.1 112.8 57.7c-7.5 32.2-19.3 63.5-36.7 92c-6.7 11-14.3 21.6-22.8 31.6zm65.5-155c-36.1-8.4-68.9-25.5-96-48.9l94.5-94.5c6.9 42.8 8.9 93.2 1.5 143.4zm.2-194.4c-103.9-17.4-187-11-252.6 13.3C142.9 61.6 96.7 103.6 66 153.6C5.8 251.8 6.9 378.3 24.4 463.1c2.7 12.9 13 22.9 26.1 25.1c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-2.7-12.9-13-22.9-26.1-25.1z'
      
    ]
  };

  

  
  

  var faSignalBarsFair = {
    prefix: 'fal',
    iconName: 'signal-bars-fair',
    icon: [
      640,
      512,
      ["signal-alt-2"],
      'f692',
      
      'M240 288c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32z'
      
    ]
  };

  
    var faSignalAlt2 = faSignalBarsFair;
  

  
  

  var faDistributeSpacingVertical = {
    prefix: 'fal',
    iconName: 'distribute-spacing-vertical',
    icon: [
      512,
      512,
      [],
      'e366',
      
      'M512 464c0-8.8-7.2-16-16-16L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16zM144 320c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-224 0zm224 32c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l224 0zM496 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l480 0z'
      
    ]
  };

  

  
  

  var faCircleLeft = {
    prefix: 'fal',
    iconName: 'circle-left',
    icon: [
      512,
      512,
      [61840,"arrow-alt-circle-left"],
      'f359',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-400 0c0 9.2 3.5 18 9.7 24.7l84 91c7.2 7.8 17.4 12.3 28.1 12.3c21.1 0 38.3-17.1 38.3-38.3l0-25.7 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-25.7c0-21.1-17.1-38.3-38.3-38.3c-10.7 0-20.9 4.5-28.1 12.3l-84 91c-6.2 6.7-9.7 15.6-9.7 24.7zm33.2 3c-.8-.8-1.2-1.9-1.2-3s.4-2.2 1.2-3l84-91c1.2-1.3 2.9-2 4.6-2c3.5 0 6.3 2.8 6.3 6.3l0 41.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16l0 41.7c0 3.5-2.8 6.3-6.3 6.3c-1.7 0-3.4-.7-4.6-2l-84-91z'
      
    ]
  };

  
    var faArrowAltCircleLeft = faCircleLeft;
  

  
  

  var faCowbellCirclePlus = {
    prefix: 'fal',
    iconName: 'cowbell-circle-plus',
    icon: [
      576,
      512,
      ["cowbell-more"],
      'f8b4',
      
      'M176 32l96 0c8.8 0 16 7.2 16 16l0 48L160 96l0-48c0-8.8 7.2-16 16-16zM128 48l0 48-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416l214.6 0c-2.9-10.3-4.9-21-5.9-32L48 384c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6l32 0 160 0 32 0c7.1 0 13.4 4.7 15.4 11.6l18.2 63.8c9.9-3.7 20.2-6.6 30.8-8.6l-18.3-64C376.3 110.2 357.4 96 336 96l-16 0 0-48c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zM256 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l-32 0c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6L256 448zm64-80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  
    var faCowbellMore = faCowbellCirclePlus;
  

  
  

  var faPlaneArrival = {
    prefix: 'fal',
    iconName: 'plane-arrival',
    icon: [
      640,
      512,
      [128748],
      'f5af',
      
      'M253.3 32c5.8 0 11.1 3.1 13.9 8.2L388.5 255.7c2.1 3.7 5.6 6.4 9.7 7.6l91.5 25.4c15.9 4.4 30.7 12.3 43.2 23.2l26.7 23.1c11.5 9.9 6.7 28.7-8.1 32c-27.1 6-55.3 5.1-82-2.5L170.5 279.5c-1.8-.5-3.5-1.3-5-2.4L70.9 208.7c-4.2-3-6.6-7.8-6.6-12.9L64 100l34.2 7.6c5.7 1.3 10.2 5.5 11.9 11l18.6 62c1.6 5.3 5.7 9.3 11 10.8l101.8 28.3c5.6 1.6 11.6 0 15.6-4.1s5.6-10.1 4-15.7L213.2 32l40.1 0zm41.8-7.5C286.6 9.4 270.6 0 253.3 0L213.2 0C192 0 176.6 20.3 182.4 40.8l40.1 140.4-65.8-18.3-16.1-53.6c-5-16.6-18.6-29.3-35.6-33.1L71 68.7C51 64.3 32 79.5 32 100l.2 95.8c0 15.4 7.4 29.8 19.9 38.8L146.8 303c4.5 3.3 9.6 5.7 15 7.3l4.4-15.4-4.4 15.4 298.8 84.9c31.8 9 65.4 10 97.7 2.9c40.6-8.9 53.6-60.3 22.1-87.5l-26.7-23.1c-16.1-13.9-35.1-24.1-55.6-29.8l-85.1-23.7L295.1 24.5zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480zM176 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPersonFromPortal = {
    prefix: 'fal',
    iconName: 'person-from-portal',
    icon: [
      512,
      512,
      ["portal-exit"],
      'e023',
      
      'M128 256c0 37.2-1.4 69-3.9 96l32.1 0c2.5-27.7 3.8-59.6 3.8-96c0-17-.3-33-.8-48c4 .2 8.1-1.1 11.4-3.9l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L320.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L394 253.2c5.9 20.6 24.7 34.8 46.2 34.8l55.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.9 0c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4l-44.6 39C148.1 46.7 117 0 80 0C35.8 0 0 66.6 0 256S35.8 512 80 512c23.3 0 44.3-18.6 59-64L105 448c-12.3 32-23.5 32-25 32c0 0 0 0 0 0s0 0 0 0c-1.6 0-13.6 0-26.4-35.8C40.9 409.1 32 349.5 32 256s8.9-153.1 21.5-188.2C66.4 32 78.4 32 80 32c0 0 0 0 0 0s0 0 0 0c1.6 0 13.6 0 26.4 35.8C119.1 102.9 128 162.5 128 256zM352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM358.4 170.1L314.3 302.4 286.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1L197.3 384 112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.3 0c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4z'
      
    ]
  };

  
    var faPortalExit = faPersonFromPortal;
  

  
  

  var faCalendarPlus = {
    prefix: 'fal',
    iconName: 'calendar-plus',
    icon: [
      448,
      512,
      [],
      'f271',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zM320 336c0 8.8-7.2 16-16 16l-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 64 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faPersonSkiingNordic = {
    prefix: 'fal',
    iconName: 'person-skiing-nordic',
    icon: [
      576,
      512,
      ["skiing-nordic"],
      'f7ca',
      
      'M320 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 288 56a56 56 0 1 0 112 0zM243.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L117.5 180c-6.7 5.8-7.3 15.9-1.5 22.6c1.5 1.7 3.3 3.1 5.3 4L64.3 476.7c-.2 1.1-.3 2.2-.3 3.3l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l127.7 0c.2 0 .4 0 .6 0l159.3 0c.2 0 .5 0 .7 0L512 512c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 17.7-14.3 32-32 32l-79.8 0 29.5-192 2.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-15.8 0-.5 0-39.6 0c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zM96.4 480L158 187l32.9-28.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L217.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L292.7 480l-125.5 0 52.9-139.2c-10.2-6.4-18.6-14.9-24.8-24.7L133 480l-36.6 0zm303.8-2.4c-.1 .8-.2 1.6-.2 2.4l-73.4 0 36-102c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L362 253.2c5.9 20.6 24.7 34.8 46.2 34.8l21.2 0L400.2 477.6zM326.4 170.1L282.3 302.4 254.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7z'
      
    ]
  };

  
    var faSkiingNordic = faPersonSkiingNordic;
  

  
  

  var faArrowDownRight = {
    prefix: 'fal',
    iconName: 'arrow-down-right',
    icon: [
      384,
      512,
      [],
      'e093',
      
      'M336 416c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 185.4L59.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 384 112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0z'
      
    ]
  };

  

  
  

  var faGrate = {
    prefix: 'fal',
    iconName: 'grate',
    icon: [
      448,
      512,
      [],
      'e193',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 0l56 0 72 0 72 0 56 0c17.7 0 32 14.3 32 32l0 128 0 128c0 17.7-14.3 32-32 32l-56 0-72 0-72 0-56 0c-17.7 0-32-14.3-32-32l0-128 0-128c0-17.7 14.3-32 32-32zm0 32l0 112 40 0 0-112-40 0zm72 112l40 0 0-112-40 0 0 112zm72 0l40 0 0-112-40 0 0 112zm72 0l40 0 0-112-40 0 0 112zm0 32l0 112 40 0 0-112-40 0zm-32 0l-40 0 0 112 40 0 0-112zm-72 0l-40 0 0 112 40 0 0-112zm-72 0l-40 0 0 112 40 0 0-112z'
      
    ]
  };

  

  
  

  var faTrafficCone = {
    prefix: 'fal',
    iconName: 'traffic-cone',
    icon: [
      512,
      512,
      [],
      'f636',
      
      'M248.2 32l15.5 0c3.3 0 6.2 2 7.4 5l49.2 123-128.7 0L240.8 37c1.2-3 4.2-5 7.4-5zm84.9 160l51.2 128-256.7 0 51.2-128 154.3 0zm64 160l51.2 128L63.6 480l51.2-128 282.3 0zM211.1 25.1L29.2 480 16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-13.2 0L300.9 25.1C294.8 10 280.1 0 263.8 0L248.2 0c-16.4 0-31.1 10-37.1 25.1z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleCheck = {
    prefix: 'fal',
    iconName: 'house-medical-circle-check',
    icon: [
      640,
      512,
      [],
      'e511',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l250.8 0c-12.9-9.1-24.5-19.9-34.6-32L144 480c-26.5 0-48-21.5-48-48l0-225.3L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64l-12 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48 32 0 0 48c0 8.8 7.2 16 16 16l28.5 0c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm128 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faAlarmExclamation = {
    prefix: 'fal',
    iconName: 'alarm-exclamation',
    icon: [
      512,
      512,
      [],
      'f843',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 64c-8.8 0-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faTarpDroplet = {
    prefix: 'fal',
    iconName: 'tarp-droplet',
    icon: [
      576,
      512,
      [],
      'e57c',
      
      'M328 113.5s0 0 0 0s0 0 0 0c0-.1-.1-1.1-.6-3.1c-.6-2.3-1.7-5.3-3.2-8.9c-3.2-7.4-7.9-16-13.7-25.3c-7-11.3-15-22.6-22.4-32.6c-7.4 10-15.4 21.3-22.4 32.6c-5.8 9.3-10.5 17.9-13.7 25.3c-1.6 3.6-2.6 6.6-3.2 8.9c-.5 2-.6 3-.6 3.1c0 0 0 0 0 0s0 0 0 0c0 17.7 15.9 35.5 40 35.5s40-17.8 40-35.5zm32 0c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5c0-27.7 39.7-81.3 60.2-107c6.1-7.7 17.5-7.7 23.7 0c20.4 25.7 60.2 79.3 60.2 107zM64 128l129.3 0c1.9 11.5 5.9 22.3 11.5 32L64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l320 0 0-112c0-26.5 21.5-48 48-48l112 0 0-128c0-17.7-14.3-32-32-32l-140.8 0c5.6-9.7 9.6-20.5 11.5-32L512 128c35.3 0 64 28.7 64 64l0 156.1c0 12.7-5.1 24.9-14.1 33.9L446.1 497.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zM423.4 475.3L539.3 359.4c2.1-2.1 3.5-4.6 4.2-7.4L432 352c-8.8 0-16 7.2-16 16l0 111.5c2.8-.7 5.4-2.1 7.4-4.2zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRectangleList = {
    prefix: 'fal',
    iconName: 'rectangle-list',
    icon: [
      576,
      512,
      ["list-alt"],
      'f022',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faDumbbell = {
    prefix: 'fal',
    iconName: 'dumbbell',
    icon: [
      640,
      512,
      [],
      'f44b',
      
      'M208 64c8.8 0 16 7.2 16 16l0 176 0 176c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64 0-224 0-64c0-8.8 7.2-16 16-16l32 0zM128 413.3l0 18.7c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160 128 0 0 160c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-18.7c5 1.8 10.4 2.7 16 2.7l32 0c26.5 0 48-21.5 48-48l0-96 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-96c0-26.5-21.5-48-48-48l-32 0c-5.6 0-11 1-16 2.7L512 80c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 160-128 0 0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 18.7C123 97 117.6 96 112 96L80 96c-26.5 0-48 21.5-48 48l0 96-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 96c0 26.5 21.5 48 48 48l32 0c5.6 0 11-1 16-2.7zM512 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 112 0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-224zM480 368l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-176 0-176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64 0 224zM128 144l0 224c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112 0-112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFaceGrinSquintTears = {
    prefix: 'fal',
    iconName: 'face-grin-squint-tears',
    icon: [
      512,
      512,
      [129315,"grin-squint-tears"],
      'f586',
      
      'M421 91.1c1.3-6.5 2.8-13.3 4.5-19.8c2.3-9.2 4.9-17.3 7.5-23.6c2.3-5.7 4-8.1 4.4-8.7c.1-.1 .1-.2 0-.1c9-9 24.7-9.5 35 .9s9.8 26 .9 35c.1-.1 0 0-.1 0c-.5 .4-3 2-8.7 4.4c-6.4 2.6-14.5 5.1-23.6 7.5c-6.6 1.7-13.3 3.2-19.8 4.5zm-36.9 26c-1 6.4 4.4 11.8 10.8 10.8c25.8-3.5 84-13.6 100.9-30.5c22-22 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9c-16.9 16.9-26.9 75.2-30.5 100.9zM32 256C32 132.3 132.3 32 256 32c31.4 0 61.2 6.4 88.3 18.1c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21C325.9 7.4 291.8 0 256 0C114.6 0 0 114.6 0 256c0 36.4 7.6 71 21.3 102.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C38.7 318.2 32 287.9 32 256zM490.7 153.6c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c12 27.4 18.6 57.7 18.6 89.6c0 123.7-100.3 224-224 224c-32.4 0-63.1-6.9-90.9-19.2c-8.1-3.6-17.5 0-21.1 8.1s0 17.5 8.1 21.1c31.8 14.1 66.9 22 103.9 22c141.4 0 256-114.6 256-256c0-36.4-7.6-71-21.3-102.4zM325.4 325.4c22.1-22 41.4-45.4 57.7-69.5c.7 32.6-11.4 65.6-36.5 90.7s-58 37.2-90.7 36.5c24-16.3 47.4-35.6 69.5-57.7zm79.3-122.7c-4.6-11.9-20.6-11.1-26.7 .2c-18.5 34.3-43.8 68.4-75.2 99.8s-65.5 56.7-99.8 75.2c-11.3 6.1-12.2 22.1-.2 26.7c55.6 21.5 121.4 9.7 166.5-35.5s57-110.9 35.5-166.5zM104.8 284c2.8 8.4 11.9 12.9 20.2 10.1l37.5-12.5L150 319.1c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L203 261.3c1.9-5.7 .4-12.1-3.9-16.4s-10.6-5.8-16.4-3.9l-67.9 22.6c-8.4 2.8-12.9 11.9-10.1 20.2zM294.1 125c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-22.6 67.9c-1.9 5.7-.4 12.1 3.9 16.4s10.6 5.8 16.4 3.9l67.9-22.6c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-37.5 12.5L294.1 125zM71.2 425.4c6.6-1.7 13.3-3.2 19.8-4.5c-1.3 6.5-2.8 13.3-4.5 19.8c-2.3 9.2-4.9 17.3-7.5 23.6c-2.3 5.7-4 8.1-4.4 8.7c-.1 .1-.1 .1 0 .1c-9 9-24.7 9.5-35-.9s-9.8-26-.9-35c-.1 .1 0 0 .1 0c.5-.4 3-2 8.7-4.4c6.4-2.6 14.5-5.1 23.6-7.5zm45.9-41.3c-25.8 3.5-84 13.6-100.9 30.5c-22 22-21.5 57.9 .9 80.3s58.3 22.8 80.3 .9c16.9-16.9 26.9-75.2 30.5-100.9c1-6.4-4.4-11.8-10.8-10.8z'
      
    ]
  };

  
    var faGrinSquintTears = faFaceGrinSquintTears;
  

  
  

  var faReel = {
    prefix: 'fal',
    iconName: 'reel',
    icon: [
      448,
      512,
      [],
      'e238',
      
      'M0 16C0 7.2 7.2 0 16 0L80 0 368 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 64c0 8.8-7.2 16-16 16L80 112c-8.8 0-16-7.2-16-16l0-64L16 32C7.2 32 0 24.8 0 16zM96 32l0 48 256 0 0-48L96 32zM64 160c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 240c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 304c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 368c-8.8 0-16-7.2-16-16zM16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0L80 512l-64 0zm80-80l0 48 256 0 0-48L96 432z'
      
    ]
  };

  

  
  

  var faHardDrive = {
    prefix: 'fal',
    iconName: 'hard-drive',
    icon: [
      512,
      512,
      [128436,"hdd"],
      'f0a0',
      
      'M64 64C46.3 64 32 78.3 32 96l0 168.6c9.4-5.4 20.3-8.6 32-8.6l384 0c11.7 0 22.6 3.1 32 8.6L480 96c0-17.7-14.3-32-32-32L64 64zM32 320l0 96c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L64 288c-17.7 0-32 14.3-32 32zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm320 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faHdd = faHardDrive;
  

  
  

  var faTvMusic = {
    prefix: 'fal',
    iconName: 'tv-music',
    icon: [
      640,
      512,
      [],
      'f8e6',
      
      'M576 32c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l512 0zM64 0C28.7 0 0 28.7 0 64L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 0zM96 496c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-416 0c-8.8 0-16 7.2-16 16zM409.1 98.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-116.9 96-36 0 83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-144c0-5.2-2.6-10.2-6.9-13.2zM384 260c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM256 292c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z'
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fal',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      'M48 192c-8.8 0-16-7.2-16-16L32 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 92.6C103.2 75.5 174.5 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-79.9 0-150-41.8-189.7-104.8C59.8 364.8 67.7 352 80 352c6 0 11.4 3.2 14.7 8.2C128.9 413 188.4 448 256 448c106 0 192-86 192-192s-86-192-192-192c-71.1 0-133.1 38.6-166.3 96l86.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 192z'
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faCookie = {
    prefix: 'fal',
    iconName: 'cookie',
    icon: [
      512,
      512,
      [127850],
      'f563',
      
      'M242.7 48.7c-15.4-2.2-31.1 .6-44.8 7.9l-74 39.5C110.1 103.4 99.1 115 92.2 129L55.5 204.6c-6.8 14.1-9.1 30-6.4 45.4l14.5 82.8c2.7 15.4 10.2 29.6 21.4 40.4l60.3 58.4c11.2 10.9 25.5 17.9 40.9 20l83 11.7c15.4 2.2 31.1-.6 44.8-7.9l74-39.5c13.7-7.3 24.8-18.8 31.7-32.9l36.7-75.5c6.8-14.1 9.1-30 6.4-45.4l-14.6-82.8c-2.7-15.4-10.2-29.6-21.4-40.4L366.6 80.5c-11.2-10.9-25.5-17.9-40.9-20l-83-11.7zM182.8 28.4c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM160 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faOctagonDivide = {
    prefix: 'fal',
    iconName: 'octagon-divide',
    icon: [
      512,
      512,
      [],
      'e203',
      
      'M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3l0 129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7l129 0c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3l0-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7l-129 0zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faCommentArrowUpRight = {
    prefix: 'fal',
    iconName: 'comment-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e145',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 152c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0L172.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 206.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faOctagon = {
    prefix: 'fal',
    iconName: 'octagon',
    icon: [
      512,
      512,
      [128721],
      'f306',
      
      'M161.5 43.7L43.7 161.5C36.2 169 32 179.2 32 189.8l0 132.4c0 10.6 4.2 20.8 11.7 28.3L161.5 468.3c7.5 7.5 17.7 11.7 28.3 11.7l132.4 0c10.6 0 20.8-4.2 28.3-11.7L468.3 350.5c7.5-7.5 11.7-17.7 11.7-28.3l0-132.4c0-10.6-4.2-20.8-11.7-28.3L350.5 43.7C343 36.2 332.8 32 322.2 32L189.8 32c-10.6 0-20.8 4.2-28.3 11.7zM21.1 138.9L138.9 21.1C152.4 7.6 170.7 0 189.8 0L322.2 0c19.1 0 37.4 7.6 50.9 21.1L490.9 138.9c13.5 13.5 21.1 31.8 21.1 50.9l0 132.4c0 19.1-7.6 37.4-21.1 50.9L373.1 490.9c-13.5 13.5-31.8 21.1-50.9 21.1l-132.4 0c-19.1 0-37.4-7.6-50.9-21.1L21.1 373.1C7.6 359.6 0 341.3 0 322.2L0 189.8c0-19.1 7.6-37.4 21.1-50.9z'
      
    ]
  };

  

  
  

  var faBorderBottomRight = {
    prefix: 'fal',
    iconName: 'border-bottom-right',
    icon: [
      448,
      512,
      ["border-style-alt"],
      'f854',
      
      'M448 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 17.7-14.3 32-32 32L32 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c35.3 0 64-28.7 64-64l0-352zM320 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  
    var faBorderStyleAlt = faBorderBottomRight;
  

  
  

  var faCarBuilding = {
    prefix: 'fal',
    iconName: 'car-building',
    icon: [
      640,
      512,
      [],
      'f859',
      
      'M64 32l224 0c17.7 0 32 14.3 32 32l0 101.2c9.4-7.6 20.3-13.4 32-17L352 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 416c0 35.3 28.7 64 64 64l160 0 0-32L64 448c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM264 192l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l41.6 0c3.7-3.7 7.7-7.1 11.9-10.2l18.3-64.2C286.7 201.5 276.5 192 264 192zM88 64C74.7 64 64 74.7 64 88l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 64zm8 64l0-32 32 0 0 32-32 0zm96-40l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM88 192c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm128-32l32 0 0 32-32 0 0-32zM88 320c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM380.2 208l135.6 0c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4l-135.6 0c-28.6 0-53.7 18.9-61.5 46.4zM608 416l0 16-320 0 0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faMessageMusic = {
    prefix: 'fal',
    iconName: 'message-music',
    icon: [
      512,
      512,
      ["comment-alt-music"],
      'f8af',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM345.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-116.9 96-36 0 83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-144c0-5.2-2.6-10.2-6.9-13.2zM320 244c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 276c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z'
      
    ]
  };

  
    var faCommentAltMusic = faMessageMusic;
  

  
  

  var faCameraViewfinder = {
    prefix: 'fal',
    iconName: 'camera-viewfinder',
    icon: [
      512,
      512,
      ["screenshot"],
      'e0da',
      
      'M0 48l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 0C21.5 0 0 21.5 0 48zM216.6 96c-16.7 0-31.6 10.3-37.5 26l-2.3 6L152 128c-30.9 0-56 25.1-56 56l0 144c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-144c0-30.9-25.1-56-56-56l-24.9 0-2.3-6C327 106.3 312 96 295.4 96l-78.7 0zm-7.5 37.2c1.2-3.1 4.2-5.2 7.5-5.2l78.7 0c3.3 0 6.3 2.1 7.5 5.2l6.2 16.4c2.3 6.2 8.3 10.4 15 10.4l36 0c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24l36 0c6.7 0 12.6-4.1 15-10.4l6.2-16.4zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM464 0L368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96zm464 48c26.5 0 48-21.5 48-48l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0z'
      
    ]
  };

  
    var faScreenshot = faCameraViewfinder;
  

  
  

  var faMoneyBillWheat = {
    prefix: 'fal',
    iconName: 'money-bill-wheat',
    icon: [
      512,
      512,
      [],
      'e52a',
      
      'M224 80l0 5.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3zM160 16l0 24c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72l0 24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-8 0-32 0-24c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 16zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 96zm16 96c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM336 85.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3l0 5.3zM288 0c-8.8 0-16 7.2-16 16l0 24c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72l0 24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-8 0-32 0-24c0-44.2-35.8-80-80-80zM448 80l0 5.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3zM384 16l0 24c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72l0 24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-8 0-32 0-24c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM304 189.3l0-5.3c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3zM192 184c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3l0-5.3zm224 5.3l0-5.3c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3zM480 304l0 32c-26.5 0-48-21.5-48-48l32 0c8.8 0 16 7.2 16 16zM32 368c44.2 0 80-35.8 80-80l288 0c0 44.2 35.8 80 80 80l0 32c-44.2 0-80 35.8-80 80l-288 0c0-44.2-35.8-80-80-80l0-32zM432 480c0-26.5 21.5-48 48-48l0 32c0 8.8-7.2 16-16 16l-32 0zM32 432c26.5 0 48 21.5 48 48l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 288c0 26.5-21.5 48-48 48l0-32c0-8.8 7.2-16 16-16l32 0zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faPlusLarge = {
    prefix: 'fal',
    iconName: 'plus-large',
    icon: [
      512,
      512,
      [],
      'e59e',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0 0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224 224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0 0-224z'
      
    ]
  };

  

  
  

  var faBellSchoolSlash = {
    prefix: 'fal',
    iconName: 'bell-school-slash',
    icon: [
      640,
      512,
      [],
      'f5d6',
      
      'M480 208C480 93.1 386.9 0 272 0c-45.8 0-88.1 14.8-122.5 39.9l26.3 20.7C203.4 42.5 236.5 32 272 32c97.2 0 176 78.8 176 176c0 20.8-3.6 40.8-10.3 59.4L464 288.1c10.3-24.7 16-51.7 16-80.1zM96 208c0-14.9 1.8-29.3 5.3-43.1L74.2 143.5C67.6 163.8 64 185.5 64 208c0 59 24.6 112.2 64 150.1l0 89.9c0 35.3 28.7 64 64 64l144 0 16 0 128 0c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4l-72.6 0c5.4-9.4 8.6-20.3 8.6-32l0-34.7-32-25.3 0 59.9c0 17.7-14.3 32-32 32l-16 0-144 0c-17.7 0-32-14.3-32-32l0-64.7C192.3 404 230.8 416 272 416c39.8 0 77-11.2 108.6-30.6L353.5 364c-24.4 12.8-52.1 20-81.5 20c-97.2 0-176-78.8-176-176zm176-80c-3.4 0-6.8 .2-10.1 .6l89.6 70.7C347.2 159.2 313.3 128 272 128zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faBowlingBallPin = {
    prefix: 'fal',
    iconName: 'bowling-ball-pin',
    icon: [
      576,
      512,
      [],
      'e0c3',
      
      'M464 32c22.1 0 40 17.9 40 40l0 4.4c0 6.4-.8 12.8-2.3 19l-9.4 37.4c-2.2 8.9-3.6 18-4.1 27.2l-48.4 0c-.5-9.2-1.9-18.3-4.1-27.2l-9.4-37.4c-1.6-6.2-2.3-12.6-2.3-19l0-4.4c0-22.1 17.9-40 40-40zM432.5 219c3-8.8 5-17.8 6.2-27l50.5 0c1.8 13.4 5.4 26.5 10.8 38.9l30.8 70.4c8.6 19.8 13.1 41.1 13.1 62.7c0 26.2-6.6 51.9-19.1 74.9L502.5 480l-77 0-20.9-38.3c-6.6 9.5-13.9 18.4-21.8 26.8l16.9 31c4.2 7.7 12.3 12.5 21.1 12.5l86.5 0c8.8 0 16.9-4.8 21.1-12.5L553 454.2c15.1-27.7 23-58.7 23-90.2c0-26-5.4-51.7-15.8-75.5l-30.8-70.4c-6.2-14.2-9.4-29.4-9.4-44.9l0-5.5c0-9.2 1.1-18.3 3.3-27.2l9.4-37.4c2.2-8.8 3.3-17.7 3.3-26.8l0-4.4c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 4.4c0 9 1.1 18 3.3 26.8l9.4 37.4c2.2 8.9 3.3 18 3.3 27.2l0 3.5c9.9 14.8 18.1 30.8 24.5 47.7zM208 128a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm-8-224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fal',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      'M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm163-338.5l63.9 127.7c.1 .2 .2 .4 .3 .6l15.8 31.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L470.1 192l-108.2 0-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7c.1-.2 .2-.4 .3-.6L401.7 40.8c2.7-5.4 8.2-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM416 83.8L377.9 160l76.2 0L416 83.8zM352 288l128 0c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 448l94.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 320 352 320c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faCheckDouble = {
    prefix: 'fal',
    iconName: 'check-double',
    icon: [
      448,
      512,
      [],
      'f560',
      
      'M331.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 201.4 91.3 132.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l160-160zm112 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 425.4 27.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0l272-272z'
      
    ]
  };

  

  
  

  var faPeopleDressSimple = {
    prefix: 'fal',
    iconName: 'people-dress-simple',
    icon: [
      512,
      512,
      [],
      'e218',
      
      'M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 64l31.4 0c14.3 0 26.8 9.5 30.8 23.2L213.6 352 42.4 352 81.5 215.2C85.4 201.5 98 192 112.3 192zm0-32c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 64 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 21.6 0c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 64l31.4 0c14.3 0 26.8 9.5 30.8 23.2L469.6 352l-171.2 0 39.1-136.8c3.9-13.7 16.5-23.2 30.8-23.2zm0-32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 64 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z'
      
    ]
  };

  

  
  

  var faVestPatches = {
    prefix: 'fal',
    iconName: 'vest-patches',
    icon: [
      448,
      512,
      [],
      'e086',
      
      'M173.4 69.1l33.4 87.4-17.1 44.8L125.3 32.8c-1.7-.5-3.3-.8-4.9-.8L96 32c-8.8 0-16 7.2-16 16l0 80 0 58.7c0 11.6-3.2 23-9.1 32.9L36.6 276.8c-3 5-4.6 10.7-4.6 16.5L32 464c0 8.8 7.2 16 16 16l113.6 0c2.4 11.8 7.4 22.7 14.4 32L48 512c-26.5 0-48-21.5-48-48L0 293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5L48 128l0-80 0-.3C48.2 21.3 69.6 0 96 0l24.4 0L125 0c6.3 0 12.3 1.8 17.4 5.1C152.6 10 161 17.6 167.1 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C287 17.6 295.4 10 305.6 5.1C310.7 1.8 316.7 0 323 0l4.6 0L352 0c26.5 0 48 21.5 48 48l0 80 0 58.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9L448 464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-167.1c0-7.8 1.4-15.6 4.2-22.9L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9zM322.7 32.8L226.1 285.4c-1.4 3.6-2.1 7.5-2.1 11.4L224 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-170.7c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9l0-58.7 0-80c0-7.7-5.5-14.2-12.8-15.7c-1-.2-2.1-.3-3.2-.3l-24.4 0c-1.6 0-3.2 .3-4.9 .8zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-4.7-107.3L120 257.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 280l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 302.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 280 84.7 267.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM312 240c19.6 0 35.9 14.1 39.3 32.7c18.6 3.4 32.7 19.7 32.7 39.3c0 22.1-17.9 40-40 40l-8 0-48 0c-8.8 0-16-7.2-16-16l0-48 0-8c0-22.1 17.9-40 40-40zm-8 40l0 8 0 32 32 0 8 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-8 0c-8.8 0-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faLaptopBinary = {
    prefix: 'fal',
    iconName: 'laptop-binary',
    icon: [
      640,
      512,
      [],
      'e5e7',
      
      'M128 64l384 0c17.7 0 32 14.3 32 32l0 256 32 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 256 32 0L96 96c0-17.7 14.3-32 32-32zM33.9 416l572.3 0c-5.5 18.5-22.6 32-42.9 32L76.8 448c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384zM200 128c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0zm80 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 48 32 0 0-64c0-8.8-7.2-16-16-16l-16 0zm256 16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 48 32 0 0-64zm-80 24c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40l0 40 32 0 0-40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 40 32 0 0-40z'
      
    ]
  };

  

  
  

  var faTent = {
    prefix: 'fal',
    iconName: 'tent',
    icon: [
      576,
      512,
      [],
      'e57d',
      
      'M278.9 2.8c5.5-3.8 12.7-3.8 18.2 0L517.3 154.7c11.3 7.8 18.7 20 20.4 33.6L571.4 458c3.6 28.6-18.8 54-47.6 54L52.2 512C23.4 512 1 486.7 4.6 458L38.3 188.2c1.7-13.6 9.1-25.8 20.4-33.6L278.9 2.8zM76.9 181c-3.8 2.6-6.2 6.7-6.8 11.2L36.4 462c-1.2 9.5 6.3 18 15.9 18L272 480l0-433.5L76.9 181zM405.4 480L304 288.4 304 480l101.4 0zm36.2 0l82.1 0c9.6 0 17.1-8.4 15.9-18L505.9 192.2c-.6-4.5-3-8.6-6.8-11.2L304 46.5 304 220 441.6 480z'
      
    ]
  };

  

  
  

  var faAlien = {
    prefix: 'fal',
    iconName: 'alien',
    icon: [
      448,
      512,
      [128125],
      'f8f5',
      
      'M224 32C118 32 32 118 32 224c0 56.2 31.2 110.7 72.2 157.4c40.4 46.1 86.7 80.4 108.6 95.4c2.8 1.9 6.6 3.2 11.2 3.2s8.4-1.3 11.2-3.2c21.9-15 68.1-49.3 108.6-95.4C384.8 334.7 416 280.2 416 224c0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 135.3-148.8 247.7-194.7 279.2c-8.6 5.9-18.9 8.8-29.3 8.8s-20.7-2.9-29.3-8.8C148.8 471.7 0 359.3 0 224zm350 16l-14 0c-29.8 0-54.9 20.4-62 48l14 0c29.8 0 54.9-20.4 62-48zm-14-32l32 0c8.8 0 16 7.2 16 16c0 53-43 96-96 96l-32 0c-8.8 0-16-7.2-16-16c0-53 43-96 96-96zM112 240l-14 0c7.1 27.6 32.2 48 62 48l14 0c-7.1-27.6-32.2-48-62-48zm96 64c0 8.8-7.2 16-16 16l-32 0c-53 0-96-43-96-96c0-8.8 7.2-16 16-16l32 0c53 0 96 43 96 96z'
      
    ]
  };

  

  
  

  var faPersonCane = {
    prefix: 'fal',
    iconName: 'person-cane',
    icon: [
      448,
      512,
      [],
      'e53c',
      
      'M248 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 168 56zM144 164l0 156 64 0 0-158.8c-3.4-.8-6.9-1.2-10.5-1.2l-34.2 0c-6.8 0-13.3 1.4-19.3 4zm-32 38.1L62.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L92.7 170.3c13.9-26 41-42.3 70.6-42.3l34.2 0c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8L240 183.9 240 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.8zM368 352c-8.8 0-16 7.2-16 16l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-26.5 21.5-48 48-48s48 21.5 48 48l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCloudRainbow = {
    prefix: 'fal',
    iconName: 'cloud-rainbow',
    icon: [
      576,
      512,
      [],
      'f73e',
      
      'M284.8 196.9C337.4 98.8 440.9 32 560 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C427.8 0 313.1 74.5 255.5 183.9c7.2 4.8 13.9 10.1 20.1 16c3-1.1 6.1-2.1 9.3-3zm155.4 78.9c6 1.5 11.8 3.3 17.5 5.5c21.1-34.4 59-57.3 102.4-57.3c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-99.6 27.1-126.8 68.2c2.7 5 5 10.3 7 15.6zm-51.2-63.7C428.4 161 490.4 128 560 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-82.5 0-155.5 40.2-200.6 102.2c10.5 3.4 20.4 8.1 29.5 13.9zM96 304c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 408c0-55.2-43-100.3-97.3-103.8C407.2 258.7 367.6 224 320 224c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112c0 2.6 .1 5.3 .3 7.9C26.6 327.5 0 364.6 0 408c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104z'
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fal',
    iconName: 'crosshairs',
    icon: [
      512,
      512,
      [],
      'f05b',
      
      'M256 0c8.8 0 16 7.2 16 16l0 32.6C374.1 56.4 455.6 137.9 463.4 240l32.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32.6 0C455.6 374.1 374.1 455.6 272 463.4l0 32.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32.6C137.9 455.6 56.4 374.1 48.6 272L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l32.6 0C56.4 137.9 137.9 56.4 240 48.6L240 16c0-8.8 7.2-16 16-16zM80.7 272c7.6 84.4 74.8 151.7 159.3 159.3l0-47.3c0-8.8 7.2-16 16-16s16 7.2 16 16l0 47.3c84.4-7.6 151.7-74.8 159.3-159.3L384 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l47.3 0C423.7 155.6 356.4 88.3 272 80.7l0 47.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-47.3C155.6 88.3 88.3 155.6 80.7 240l47.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-47.3 0zM256 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMusicMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'music-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e662',
      
      'M352 383.3c89.7-8.1 160-83.5 160-175.3c0-97.2-78.8-176-176-176c-85.6 0-156.9 61.1-172.7 142l-34.1 11.4C140.5 81.1 228.8 0 336 0C450.9 0 544 93.1 544 208c0 51.7-18.8 99-50 135.3L635.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L471.3 366c-32.9 28.2-74.7 46.3-120.7 49.5c.9-4.4 1.3-9 1.3-13.8l0-18.4zM320 198.2c0-21.8-21.4-37.3-42.1-30.4l-160 53.3C104.8 225.5 96 237.8 96 251.5L96 312l0 110.4c-9.4-4.1-20.3-6.4-32-6.4c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-140.5 160-53.3 0 88.2c-9.4-4.1-20.3-6.4-32-6.4c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.6-.1-3.2-.3-4.8c.2-1 .3-2.1 .3-3.2l0-144 0-49.8zm-32 38.3L128 289.8l0-38.3 160-53.3 0 38.3zm-5.9 171.9c-5.5 4.1-14.6 7.7-26.1 7.7s-20.5-3.5-26.1-7.7c-5.5-4.1-5.9-7.4-5.9-8.3s.4-4.2 5.9-8.3c5.5-4.1 14.6-7.7 26.1-7.7s20.5 3.5 26.1 7.7c5.5 4.1 5.9 7.4 5.9 8.3s-.4 4.2-5.9 8.3zm-192 64C84.5 476.5 75.4 480 64 480s-20.5-3.5-26.1-7.7c-5.5-4.1-5.9-7.4-5.9-8.3s.4-4.2 5.9-8.3c5.5-4.1 14.6-7.7 26.1-7.7s20.5 3.5 26.1 7.7c5.5 4.1 5.9 7.4 5.9 8.3s-.4 4.2-5.9 8.3z'
      
    ]
  };

  

  
  

  var faTruck = {
    prefix: 'fal',
    iconName: 'truck',
    icon: [
      640,
      512,
      [9951,128666],
      'f0d1',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l5.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64L384 384l0-320c0-17.7-14.3-32-32-32L64 32zm0 384c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 65.3 0c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2L608 384l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96zM416 224l154.9 0-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6L416 128l0 96zm0 32l0 88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64l5.5 0 0-128-160 0zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faLandmark = {
    prefix: 'fal',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      'M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192l449.7 0c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM256 34.4L477.7 160 34.3 160 256 34.4zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-128-32 0 0 128-80 0 0-128-32 0 0 128-96 0 0-128-32 0 0 128-80 0 0-128-32 0 0 128zM24 432c0 8.8 7.2 16 16 16l432 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L40 416c-8.8 0-16 7.2-16 16zM0 496c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faHouseWindow = {
    prefix: 'fal',
    iconName: 'house-window',
    icon: [
      576,
      512,
      [],
      'e3b3',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48zM240 192c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zm0 32l96 0 0 96-96 0 0-96z'
      
    ]
  };

  

  
  

  var faHoseReel = {
    prefix: 'fal',
    iconName: 'hose-reel',
    icon: [
      640,
      512,
      [],
      'e41a',
      
      'M96 256C96 132.3 196.3 32 320 32s224 100.3 224 224l0 96-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l1.9 0 12 96.1c-7.8 1-13.9 7.7-13.9 15.9c0 8.8 7.2 16 16 16l1.9 0 14.1 0 32 0 14.1 0 1.9 0c8.8 0 16-7.2 16-16c0-8.1-6.1-14.8-13.9-15.9l12-96.1 1.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-96C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c57.6 0 110.8-19 153.6-51.2c7.1-5.3 8.5-15.3 3.2-22.4s-15.3-8.5-22.4-3.2C417 463.3 370.4 480 320 480C196.3 480 96 379.7 96 256zM573.9 384l-12 96-3.8 0-12-96 13.9 0 13.9 0zM464 256a144 144 0 1 1 -288 0 144 144 0 1 1 288 0zM320 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm0 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z'
      
    ]
  };

  

  
  

  var faFamilyPants = {
    prefix: 'fal',
    iconName: 'family-pants',
    icon: [
      512,
      512,
      [],
      'e302',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320l59.6 0c-.7 5.2-1.1 10.6-1.1 16l0 16-48 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c7 0 13.8 .9 20.2 2.6c-1.7 6.9-2.6 14-2.6 21.4c0 3.9 .3 7.8 .8 11.6c-5.7-2.4-11.9-3.6-18.4-3.6l-44.8 0c-25 0-45.8 19.1-47.8 44zM416 352l-48 0 0-16c0-5.4-.4-10.8-1.1-16l59.6 0c18.7 0 33.4-16 31.9-34.7L454.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0c-6.5 0-12.7 1.3-18.4 3.6c.5-3.8 .8-7.7 .8-11.6c0-7.4-.9-14.6-2.6-21.4c6.5-1.7 13.3-2.6 20.2-2.6l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L448 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144zm0-288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48l0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-32c0-26.5-21.5-48-48-48zM208 413.3c-18.6-6.6-32-24.4-32-45.3l0-32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 32c0 20.9-13.4 38.7-32 45.3l0 82.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-82.7z'
      
    ]
  };

  

  
  

  var faPlateUtensils = {
    prefix: 'fal',
    iconName: 'plate-utensils',
    icon: [
      640,
      512,
      [58713],
      'e43b',
      
      'M16 16C7.2 16 0 23.2 0 32L0 176c0 26.5 21.5 48 48 48l16 0 0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256 16 0c26.5 0 48-21.5 48-48l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8-7.2 16-16 16l-16 0L96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160-16 0c-8.8 0-16-7.2-16-16L32 32c0-8.8-7.2-16-16-16zM498 78.9C455.3 39.8 398.4 16 336 16c-54 0-103.9 17.9-144 48l0 41.9C229.4 70 280.1 48 336 48c58.9 0 112 24.5 149.9 63.8c3.1-12 7.2-22.9 12.1-32.9zm24.5 269.4C488.5 416.9 417.7 464 336 464c-73.8 0-138.6-38.4-175.5-96.4c-8.5 6.5-18.3 11.3-29 14C173.7 450.2 249.5 496 336 496c98.4 0 183-59.2 220-144l-12 0c-7.6 0-14.8-1.3-21.5-3.7zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-256 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM608 54.4L608 288l-64 0 0-128c0-61.3 39.4-92.2 64-105.6zM640 288l0-251.1c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160l0 128c0 17.7 14.3 32 32 32l64 0 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 0-16 0-16z'
      
    ]
  };

  

  
  

  var faPrescriptionBottleMedical = {
    prefix: 'fal',
    iconName: 'prescription-bottle-medical',
    icon: [
      384,
      512,
      ["prescription-bottle-alt"],
      'f486',
      
      'M336 32c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L48 96c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l288 0zM48 0C21.5 0 0 21.5 0 48L0 80c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-32 0 0 288c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-288-32 0zm149.3 32c-17.7 0-32 14.3-32 32l0 21.3-21.3 0c-17.7 0-32 14.3-32 32l0 21.3c0 17.7 14.3 32 32 32l21.3 0 0 21.3c0 17.7 14.3 32 32 32l21.3 0c17.7 0 32-14.3 32-32l0-21.3 21.3 0c17.7 0 32-14.3 32-32l0-21.3c0-17.7-14.3-32-32-32l-21.3 0 0-21.3c0-17.7-14.3-32-32-32l-21.3 0zm0 32l21.3 0 0 37.3c0 8.8 7.2 16 16 16l37.3 0 0 21.3-37.3 0c-8.8 0-16 7.2-16 16l0 37.3-21.3 0 0-37.3c0-8.8-7.2-16-16-16l-37.3 0 0-21.3 37.3 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-37.3z'
      
    ]
  };

  
    var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
  

  
  

  var faBraille = {
    prefix: 'fal',
    iconName: 'braille',
    icon: [
      640,
      512,
      [],
      'f2a1',
      
      'M64 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm160 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 256a64 64 0 1 0 128 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 160 96a64 64 0 1 0 128 0zM416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM544 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 512 96a64 64 0 1 0 128 0zM576 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fal',
    iconName: 'calendar-clock',
    icon: [
      576,
      512,
      ["calendar-time"],
      'e0d2',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 .7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7l0-.7L32 192l0 256c0 17.7 14.3 32 32 32l232.2 0c10 12.1 21.7 22.9 34.6 32L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zm48 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faCalendarTime = faCalendarClock;
  

  
  

  var faClockDesk = {
    prefix: 'fal',
    iconName: 'clock-desk',
    icon: [
      448,
      512,
      [],
      'e134',
      
      'M32 224a192 192 0 1 1 384 0A192 192 0 1 1 32 224zM416 339.4L416 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-108.6C71.2 404.5 142.5 448 224 448s152.8-43.5 192-108.6zM0 224L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224C448 100.3 347.7 0 224 0S0 100.3 0 224zM224 96c-8.8 0-16 7.2-16 16l0 112c0 4.2 1.7 8.3 4.7 11.3l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 217.4 240 112c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCalendarCheck = {
    prefix: 'fal',
    iconName: 'calendar-check',
    icon: [
      448,
      512,
      [],
      'f274',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z'
      
    ]
  };

  

  
  

  var faPlaneProp = {
    prefix: 'fal',
    iconName: 'plane-prop',
    icon: [
      576,
      512,
      [],
      'e22b',
      
      'M270 0c-16 0-29.6 11.9-31.7 27.8L235.6 48 224 48c-26.5 0-48 21.5-48 48c0 26.1 20.8 47.3 46.8 48l-4.9 37-67.1 9-3.9-27.6C144 142.6 127.1 128 107.2 128l-22.4 0c-19.9 0-36.8 14.6-39.6 34.3l-6.1 42.9C16.3 211.2 0 231.9 0 256s16.3 44.8 39.1 50.8l6.1 42.9C48 369.4 64.9 384 84.8 384l22.4 0c19.9 0 36.8-14.6 39.6-34.3l3.9-27.6 67.1 9 4.9 37c-26 .6-46.8 21.9-46.8 48c0 26.5 21.5 48 48 48l11.6 0 2.7 20.2C240.4 500.1 254 512 270 512l36 0c16 0 29.6-11.9 31.7-27.8l7-52.2 23.3 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-19.1 0 8.5-64 108.8 0c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-108.8 0-8.5-64 19.1 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-23.3 0-7-52.2C335.6 11.9 322 0 306 0L270 0zM224 400l3.1 0 4.3 32-7.3 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0-320l7.3 0-4.3 32-3.1 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm101.2 96L256 176c-.7 0-1.4 0-2.1 .1l-3.2 .4L270 32l36 0 19.2 144zm0 160L306 480l-36 0L250.7 335.4l3.2 .4c.7 .1 1.4 .1 2.1 .1l69.2 0zM76.9 166.9c.6-3.9 3.9-6.9 7.9-6.9l22.4 0c4 0 7.4 2.9 7.9 6.9l6.2 43.2c1.2 8.7 9.3 14.8 18 13.6L257.1 208l209.3 0c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2l-209.3 0L139.2 288.3c-8.7-1.2-16.7 4.9-18 13.6l-6.2 43.2c-.6 3.9-3.9 6.9-7.9 6.9l-22.4 0c-4 0-7.4-2.9-7.9-6.9l-7.8-54.4c-1-7.1-6.6-12.6-13.7-13.6l-5.6-.7C39.6 275 32 266.3 32 256s7.6-19 17.8-20.4l5.6-.7c7.1-.9 12.7-6.5 13.7-13.6l7.8-54.4z'
      
    ]
  };

  

  
  

  var faNfcSignal = {
    prefix: 'fal',
    iconName: 'nfc-signal',
    icon: [
      512,
      512,
      [],
      'e1fb',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l163 0c-1.6 10.5-2.6 21.2-2.9 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 131c-10.9 1.7-21.6 4-32 6.9L416 96c0-17.7-14.3-32-32-32zm0 64l0 117.3c-11.1 4.8-21.8 10.2-32 16.4L352 128l-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-82.7c0-17.7 14.3-32 32-32l112 0c17.7 0 32 14.3 32 32zM233.9 416L96 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 256 149.3 0c-4.4 10.3-8.2 21-11.3 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm272 16c8.8 0 16 7.2 16 16s-7.2 16-16 16c-114.9 0-208 93.1-208 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-132.5 107.5-240 240-240zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-80c0 8.8-7.2 16-16 16c-61.9 0-112 50.1-112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-79.5 64.5-144 144-144c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faStarSharpHalfStroke = {
    prefix: 'fal',
    iconName: 'star-sharp-half-stroke',
    icon: [
      576,
      512,
      ["star-sharp-half-alt"],
      'e28d',
      
      'M272 93.9l0 282.3L163.5 460.6l43.8-143.9c2-6.5-.4-13.6-5.9-17.6l-126-91L224 208c7 0 13.1-4.5 15.2-11.1L272 93.9zm32 282.3l0-282.3 32.8 102.9c2.1 6.6 8.3 11.1 15.2 11.1l148.7 0-126 91c-5.5 4-7.9 11.1-5.9 17.6l43.8 143.9L304 376.2zM288 0c-11.7 0-22.1 7.6-25.7 18.8L212.3 176 58.6 176C43.9 176 32 187.9 32 202.6c0 8.5 4.1 16.6 11 21.6l130.3 94.1-50.8 167c-4.1 13.3 5.9 26.8 19.8 26.8c4.6 0 9.1-1.5 12.7-4.4L288 404.3 420.9 507.6c3.6 2.8 8.1 4.4 12.7 4.4c13.9 0 23.9-13.4 19.8-26.8l-50.8-167L533 224.1c6.9-5 11-13 11-21.6c0-14.7-11.9-26.6-26.6-26.6l-153.7 0-50-157.2C310.1 7.6 299.7 0 288 0z'
      
    ]
  };

  
    var faStarSharpHalfAlt = faStarSharpHalfStroke;
  

  
  

  var faWater = {
    prefix: 'fal',
    iconName: 'water',
    icon: [
      576,
      512,
      [],
      'f773',
      
      'M133.8 106.8C150.3 118 171.1 128 192 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 118 363.1 128 384 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 145.9 414.3 160 384 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 145.9 222.3 160 192 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 160.1 0 152 0 142.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zm0 288C150.3 406 171.1 416 192 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 406 363.1 416 384 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 433.9 414.3 448 384 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 433.9 222.3 448 192 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 448.1 0 440 0 430.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM192 272c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 262 363.1 272 384 272s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 289.9 414.3 304 384 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 289.9 222.3 304 192 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 304.1 0 296 0 286.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 262 171.1 272 192 272z'
      
    ]
  };

  

  
  

  var faWaveform = {
    prefix: 'fal',
    iconName: 'waveform',
    icon: [
      640,
      512,
      [],
      'f8f1',
      
      'M320 0c8 0 14.8 5.9 15.9 13.9l49.3 369.5L432.2 77.6c1.2-7.9 8-13.6 16-13.6s14.6 6 15.7 13.8l34.6 254 29.8-158.8c1.4-7.3 7.6-12.7 15-13s14.1 4.5 16.1 11.6L588.1 272l35.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-7.1 0-13.4-4.7-15.4-11.6l-13.4-46.8L511.7 434.9c-1.4 7.7-8.3 13.2-16.1 13s-14.4-6.1-15.5-13.8L447 191.4l-47.2 307c-1.2 7.9-8 13.6-16 13.6s-14.6-6-15.7-13.9L320 137.1 271.9 498.1c-1.1 7.9-7.7 13.8-15.7 13.9s-14.8-5.7-16-13.6L193 191.4 159.9 434.2c-1.1 7.8-7.6 13.6-15.5 13.8s-14.7-5.3-16.1-13L92.8 245.6 79.4 292.4c-2 6.9-8.2 11.6-15.4 11.6l-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l35.9 0L80.6 171.6c2-7.1 8.7-11.9 16.1-11.6s13.6 5.7 15 13l29.8 158.8 34.6-254c1.1-7.9 7.8-13.8 15.7-13.8s14.7 5.7 16 13.6l47.1 305.9L304.1 13.9C305.2 5.9 312 0 320 0z'
      
    ]
  };

  

  
  

  var faTricycleAdult = {
    prefix: 'fal',
    iconName: 'tricycle-adult',
    icon: [
      640,
      512,
      [],
      'e5c4',
      
      'M304 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l39 0c5.3 0 10.3 2.6 13.3 7L440 226.7l-53.2 70.9c-6.8 9-17.4 14.3-28.7 14.3c-2.8 0-5.6-.3-8.3-1L19.7 232.4c-8.6-2-17.2 3.3-19.3 11.9s3.3 17.2 11.9 19.3l31.9 7.6C17.6 288.2 0 318.1 0 352c0 53 43 96 96 96c18 0 34.8-4.9 49.1-13.5c-.4 .2-.8 .5-1.1 .7c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-8.1-1-16-2.9-23.5l57.3 13.6c5.1 1.2 10.4 1.8 15.7 1.8c21.4 0 41.5-10.1 54.3-27.1l46.6-62.1 18.8 27.8C459.4 300 448 324.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-14.2 0-27.7 3.1-39.8 8.6L382.8 85.1C373.8 71.9 359 64 343 64l-39 0zM480 352c0-16.2 6.1-31.1 16-42.4L530.8 361c5 7.3 14.9 9.2 22.2 4.3s9.2-14.9 4.3-22.2l-34.7-51.3c6.7-2.4 13.9-3.7 21.5-3.7c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM247.1 319.5c5.6 9.5 8.9 20.6 8.9 32.5c0 35.3-28.7 64-64 64c-7.5 0-14.7-1.3-21.3-3.6C184 395.9 192 374.9 192 352c0-17.8-4.9-34.5-13.3-48.8l68.5 16.3zM62.9 106.1c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l23.3 58.3c7.3 18.3 22.6 32.1 41.4 37.7l89.6 26.2c8.5 2.5 17.4-2.4 19.9-10.9s-2.4-17.4-10.9-19.8l-89.6-26.2c-9.4-2.8-17.1-9.7-20.7-18.8L62.9 106.1zM94.4 416C59.8 415.1 32 386.8 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faFileEps = {
    prefix: 'fal',
    iconName: 'file-eps',
    icon: [
      512,
      512,
      [],
      'e644',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM160 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64 0-64zm144-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm117.7-80l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L424 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7c0-25.2 20.4-45.7 45.7-45.7z'
      
    ]
  };

  

  
  

  var faHandHoldingDroplet = {
    prefix: 'fal',
    iconName: 'hand-holding-droplet',
    icon: [
      576,
      512,
      ["hand-holding-water"],
      'f4c1',
      
      'M235.6 121.1C228 132.1 224 145.1 224 158.3l0 1.7c0 35.3 28.7 64 64 64s64-28.7 64-64l0-1.7c0-13.3-4-26.3-11.6-37.2L288 44.8l-52.4 76.3zM209.2 103L275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3l0 1.7c0 53-43 96-96 96s-96-43-96-96l0-1.7c0-19.8 6-39 17.2-55.3zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7L80 400l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  
    var faHandHoldingWater = faHandHoldingDroplet;
  

  
  

  var faSquare4 = {
    prefix: 'fal',
    iconName: 'square-4',
    icon: [
      448,
      512,
      [],
      'e259',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm133.9 97.1c-8.2-3.3-17.5 .7-20.8 8.9l-64 160c-2 4.9-1.4 10.5 1.6 14.9s7.9 7 13.2 7l128 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-104.4 0 55.2-138.1c3.3-8.2-.7-17.5-8.9-20.8z'
      
    ]
  };

  

  
  

  var faBuoyMooring = {
    prefix: 'fal',
    iconName: 'buoy-mooring',
    icon: [
      576,
      512,
      [],
      'e5b6',
      
      'M272 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 49.1c46.7 6.7 85.5 42.3 94.6 89.9l45.8 240.3c-.4 .3-.8 .5-1.2 .8c-8.8 6.1-18.5 11.1-28.5 14.6L397.4 320l-218.9 0-17.3 90.7c-9.9-3.5-19.7-8.5-28.4-14.6c-.4-.3-.8-.6-1.2-.8L177.4 155c9.1-47.6 47.8-83.2 94.6-89.9L272 16zM208.9 161L184.7 288l206.7 0L367.1 161C360 123.4 326.5 96 288 96s-72 27.4-79.1 65zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z'
      
    ]
  };

  

  
  

  var faArrowDown19 = {
    prefix: 'fal',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      'M448 48l0 144 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-121.8-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13zM171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zM428 288a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4c0 0 .1 0 .1 0c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6L429.3 424c-.4 0-.9 0-1.3 0c-46.4 0-84-37.6-84-84z'
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faSleigh = {
    prefix: 'fal',
    iconName: 'sleigh',
    icon: [
      640,
      512,
      [],
      'f7cc',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l16 0 0 192c0 59.6 40.8 109.8 96 124l0 68-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l520 0c39.8 0 72-32.2 72-72l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 22.1-17.9 40-40 40l-120 0 0-64c70.7 0 128-57.3 128-128l0-128 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0-56 0c-22.1 0-40 17.9-40 40l0 35.8c0 28.8-23.4 52.2-52.2 52.2c-72 0-139-37.1-177.1-98.2l-7.2-11.5C179.6 63.4 124 32.4 64 32l-1 0-7 0L32 32 16 32zM416 448l-256 0 0-64 256 0 0 64zm72-320l56 0 0 128c0 53-43 96-96 96l-288 0c-53 0-96-43-96-96L64 64c48.9 .4 94.3 25.7 120.3 67.2l7.2 11.5C235.5 213.2 312.7 256 395.8 256c46.5 0 84.2-37.7 84.2-84.2l0-35.8c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCarOn = {
    prefix: 'fal',
    iconName: 'car-on',
    icon: [
      512,
      512,
      [],
      'e4dd',
      
      'M272 24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80zM188.2 208l135.6 0c14.3 0 26.8 9.5 30.8 23.2L370.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4l-135.6 0c-28.6 0-53.7 18.9-61.5 46.4zM416 416l0 16L96 432l0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48zM144 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0zm400 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faMeteor = {
    prefix: 'fal',
    iconName: 'meteor',
    icon: [
      512,
      512,
      [9732],
      'f753',
      
      'M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8C0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7l-26.1 0L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4 320 32zm154.6 .3c.5-.2 1-.3 1.5-.3c2.1 0 3.8 1.7 3.8 3.8c0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3l50.6 0L338.5 409.8C306.7 453.9 255.6 480 201.3 480C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32l0 57.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM296 312a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM200 184a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM184 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCartArrowUp = {
    prefix: 'fal',
    iconName: 'cart-arrow-up',
    icon: [
      576,
      512,
      [],
      'e3ee',
      
      'M0 16C0 7.2 7.2 0 16 0L53.9 0c22.8 0 42.5 16 47 38.4L145.4 256l321.1 0c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288L152 288l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-304.8 0c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32L16 32C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM304 208l0-121.4-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 86.6 336 208c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faSquareVirus = {
    prefix: 'fal',
    iconName: 'square-virus',
    icon: [
      448,
      512,
      [],
      'e578',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM86.6 230.9c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24s24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24zm62.6-50.7c8.2 28.6-4.9 60.2-30.9 74.7c26 14.5 39.1 46.1 30.9 74.7c28.6-8.2 60.2 4.9 74.7 30.9c14.5-26 46.1-39.1 74.7-30.9c-8.2-28.6 4.9-60.2 30.9-74.7c-26-14.5-39.1-46.1-30.9-74.7c-16.4 4.7-33.9 2.4-48.5-5.4c-10.8-5.7-20.1-14.5-26.2-25.5c-14.5 26-46.1 39.1-74.7 30.9z'
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fal',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      'M191.1 32c-20.7 0-39 13.2-45.5 32.8L135.1 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-71.1 0L366.5 64.8C359.9 45.2 341.6 32 320.9 32L191.1 32zM175.9 74.9c2.2-6.5 8.3-10.9 15.2-10.9l129.9 0c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9l82.7 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l82.7 0c6.9 0 13-4.4 15.2-10.9l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCameraPolaroid = {
    prefix: 'fal',
    iconName: 'camera-polaroid',
    icon: [
      576,
      512,
      [],
      'f8aa',
      
      'M64 448l448 0c17.7 0 32-14.3 32-32l0-44.6c0-6.3-1.9-12.5-5.4-17.8l-1.1-1.6L38.5 352l-1.1 1.6c-3.5 5.3-5.4 11.4-5.4 17.8L32 416c0 17.7 14.3 32 32 32zM516.2 320l-28.1-42.2c-5.3-7.9-8.1-17.1-8.1-26.6L480 96c0-17.7-14.3-32-32-32L128 64c-17.7 0-32 14.3-32 32l0 155.2c0 9.5-2.8 18.7-8.1 26.6L59.8 320l456.4 0zM512 480L64 480c-35.3 0-64-28.7-64-64l0-44.6c0-12.6 3.7-25 10.7-35.5L61.3 260c1.8-2.6 2.7-5.7 2.7-8.9L64 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 155.2c0 3.2 .9 6.2 2.7 8.9l50.6 75.8c7 10.5 10.7 22.9 10.7 35.5l0 44.6c0 35.3-28.7 64-64 64zM416 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-128-8a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM112 384l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCloudMeatball = {
    prefix: 'fal',
    iconName: 'cloud-meatball',
    icon: [
      512,
      512,
      [],
      'f73b',
      
      'M96 117.6c0-47.6 36.5-84.8 80-84.8c31.7 0 59.6 19.7 72.5 48.9c2.2 4.9 6.6 8.4 11.9 9.3s10.7-.9 14.4-4.8c11.7-12.4 27.7-19.9 45.2-19.9c34.6 0 64 29.7 64 68l0 .3c0 4.5 1.9 8.8 5.2 11.9s7.8 4.5 12.3 4.1c2.1-.2 4.3-.3 6.5-.3c39 0 72 33.5 72 76.4s-33 76.4-72 76.4c0 0 0 0 0 0s0 0 0 0l-19.1 0c2.5 7.9 3.7 16.1 3.7 24.2c2.4 2.4 4.7 5 6.8 7.8l8.5 0s0 0 0 0s0 0 0 0c58.2 0 104-49.3 104-108.4c0-56.8-42.3-104.5-97.2-108.2c-7.2-47.2-46.3-84.2-94.8-84.2c-19.3 0-37.3 6-52.3 16.1C247.6 20.7 214.2 .8 176 .8c-62.6 0-112 53-112 116.8c0 3 .1 6 .3 9C26.3 142.9 0 181.9 0 226.8c0 59.1 45.8 108.4 104 108.4c0 0 0 0 0 0s0 0 0 0l8.5 0c2.1-2.7 4.4-5.3 6.8-7.8c0-8.2 1.2-16.4 3.7-24.2l-19.1 0c0 0 0 0 0 0s0 0 0 0c-39 0-72-33.5-72-76.4c0-36.1 23.4-65.7 54-74c8.1-2.2 13.1-10.2 11.5-18.4c-1-5.4-1.6-11-1.6-16.8zM32 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0A48 48 0 1 0 0 400a48 48 0 1 0 96 0zm352 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM240 304c0-8.8 7.2-16 16-16s16 7.2 16 16c0 .5 0 1.1-.1 1.6c-.7 7 3.3 13.6 9.8 16.3s14 .8 18.5-4.6c.3-.4 .7-.8 1.1-1.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-.4 .4-.8 .7-1.2 1.1c-5.4 4.5-7.3 12-4.6 18.5s9.3 10.5 16.3 9.8c.5-.1 1-.1 1.6-.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-.5 0-1.1 0-1.6-.1c-7-.7-13.6 3.3-16.3 9.8s-.8 14 4.6 18.5c.4 .3 .8 .7 1.2 1.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-.4-.4-.7-.8-1.1-1.2c-4.5-5.4-12-7.3-18.5-4.6s-10.5 9.3-9.8 16.3c0 .5 .1 1 .1 1.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.5 0-1.1 .1-1.6c.7-7-3.3-13.6-9.8-16.3s-14-.8-18.5 4.6c-.3 .4-.7 .8-1.1 1.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c.4-.4 .8-.7 1.2-1.1c5.4-4.5 7.3-12 4.6-18.5s-9.3-10.5-16.3-9.8c-.5 0-1 .1-1.6 .1c-8.8 0-16-7.2-16-16s7.2-16 16-16c.5 0 1.1 0 1.6 .1c7 .7 13.6-3.3 16.3-9.8s.8-14-4.6-18.5c-.4-.3-.8-.7-1.2-1.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l8.5-8.5-8.5 8.5c.4 .4 .7 .8 1.1 1.2c4.5 5.4 12 7.3 18.5 4.6s10.5-9.3 9.8-16.3c0-.5-.1-1-.1-1.6zm144 80c0-18.4-10.4-34.4-25.5-42.4c5-16.4 1.1-35.1-11.9-48.1s-31.6-17-48.1-11.9c-8.1-15.2-24-25.5-42.4-25.5s-34.4 10.4-42.4 25.5c-16.4-5-35.1-1.1-48.1 11.9s-17 31.6-11.9 48.1c-15.2 8.1-25.5 24-25.5 42.4s10.4 34.4 25.5 42.4c-5 16.4-1.1 35.1 11.9 48.1s31.6 17 48.1 11.9c8.1 15.2 24 25.5 42.4 25.5s34.4-10.4 42.4-25.5c16.4 5 35.1 1.1 48.1-11.9s17-31.6 11.9-48.1c15.2-8.1 25.5-24 25.5-42.4z'
      
    ]
  };

  

  
  

  var faMessageHeart = {
    prefix: 'fal',
    iconName: 'message-heart',
    icon: [
      512,
      512,
      [],
      'e5c9',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM176 173.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 265.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zm72.6-43.3c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4z'
      
    ]
  };

  

  
  

  var faHammerCrash = {
    prefix: 'fal',
    iconName: 'hammer-crash',
    icon: [
      640,
      512,
      [],
      'e414',
      
      'M283.7 379.4l11.9-48.2c10.4 4.3 21.3 5.6 31.9 4.4l-4.4 17.7 71.3-35.9c6.9-3.5 15.2-1.6 19.9 4.5L463 385.2 479.3 307c1.6-7.5 8.3-12.9 15.9-12.7l79.8 1.4-50.9-61.5c-4.9-5.9-4.9-14.5 0-20.4l50.9-61.5-79.8 1.4c-7.7 .1-14.4-5.2-15.9-12.7L463 62.8l-30.4 39.5c-5.4-6.3-12.1-11.6-20-15.6l-6.1-3 52.3-68c3.8-5 10.2-7.2 16.2-5.8s10.8 6.2 12.1 12.3l20.8 99.3 101.4-1.8c6.2-.1 12 3.4 14.7 9.1s1.9 12.3-2.1 17.1L557.3 224 622 302.1c4 4.8 4.8 11.5 2.1 17.1s-8.5 9.2-14.7 9.1l-101.4-1.8-20.8 99.3c-1.3 6.1-6 10.9-12.1 12.3s-12.4-.9-16.2-5.8L397 351.8l-90.6 45.7c-5.6 2.8-12.3 2.1-17.2-1.8s-7.1-10.3-5.6-16.4zM72 48L32 128 320 272l64-128L192 48 72 48zM43.4 33.7C48.8 22.8 59.9 16 72 16l120 0c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-97.9-48.9s0 0 0 0l-28.6-14.3s0 0 0 0l-28.6-14.3s0 0 0 0L122 208.8s0 0 0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80zM5.1 442.5L107.6 237.4l28.6 14.3L33.7 456.9c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L164.9 266l28.6 14.3L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.3 5.1 442.5z'
      
    ]
  };

  

  
  

  var faFishingRod = {
    prefix: 'fal',
    iconName: 'fishing-rod',
    icon: [
      448,
      512,
      [],
      'e3a8',
      
      'M280.4 32c-4 0-7.9 .6-11.7 1.8L204.2 53.6C130.4 76.3 80 144.5 80 221.8L80 288l8 0c22.1 0 40 17.9 40 40l0 144c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40L0 328c0-22.1 17.9-40 40-40l8 0 0-66.2C48 130.5 107.6 49.9 194.8 23L259.3 3.2C266.1 1.1 273.2 0 280.4 0C319.9 0 352 32.1 352 71.6l0 64.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64.4C320 49.7 302.3 32 280.4 32zm48.5 145.7c4.5-2.3 9.8-2.3 14.3 0c17.9 8.9 43.7 27.1 65.2 53.4C430 257.5 448 292.9 448 336c0 33.5-15.1 80.9-58.2 115.8l23.5 35.3c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-128 0c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l23.5-35.3C239.1 416.9 224 369.5 224 336c0-43.1 18-78.5 39.6-104.9c21.5-26.3 47.4-44.4 65.2-53.4zM256 336c0 27.3 13.9 70 56.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2L301.9 480l68.2 0-15.4-23.1c-4.9-7.4-2.9-17.3 4.4-22.2C402.1 406 416 363.3 416 336c0-33.7-14-62.3-32.4-84.7c-15.6-19-33.8-33-47.6-41.1c-13.8 8.1-32 22.1-47.6 41.1C270 273.7 256 302.3 256 336zM88 320l-48 0c-4.4 0-8 3.6-8 8l0 144c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-144c0-4.4-3.6-8-8-8zm272-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fal',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 96-32 0zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faSlashBack = {
    prefix: 'fal',
    iconName: 'slash-back',
    icon: [
      320,
      512,
      [],
      '5c',
      
      'M7.8 2.3c-7.6 4.5-10 14.4-5.5 22l288 480c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-21.9L29.7 7.8c-4.5-7.6-14.4-10-22-5.5z'
      
    ]
  };

  

  
  

  var faUserDoctor = {
    prefix: 'fal',
    iconName: 'user-doctor',
    icon: [
      448,
      512,
      ["user-md"],
      'f0f0',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm48 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32-45.3l0-34.7 1.2 0 93.6 0c5.8 0 11.5 .3 17.2 1l0 33.3c-23.1 6.9-40 28.3-40 53.7l0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24c0-25.4-16.9-46.8-40-53.7l0-25.8c55.6 20 95.5 73 96 135.5L32 480c.5-68.2 48.2-125.3 112-140.2l0 30.9c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3zm1.2-66.7C79.3 304 0 383.3 0 481.2c0 17 13.8 30.8 30.8 30.8l386.4 0c17 0 30.8-13.8 30.8-30.8C448 383.3 368.7 304 270.8 304l-93.6 0z'
      
    ]
  };

  
    var faUserMd = faUserDoctor;
  

  
  

  var faMeterBolt = {
    prefix: 'fal',
    iconName: 'meter-bolt',
    icon: [
      640,
      512,
      [],
      'e1e9',
      
      'M480 256c0 5.7-.2 11.4-.6 17l32.3-30.6C504.6 107.4 392.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c69.2 0 132-27.5 178.1-72.1c-12.4-.8-23.7-5.8-32.4-13.7C362.5 459.7 311.6 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm95.7 232l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4l48.3 0-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4l-48.3 0zM585.6 224c-5.1 0-10.1 2-13.8 5.5L422.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6l49.4 0-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L633.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6L569 328l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z'
      
    ]
  };

  

  
  

  var faHouseChimneyBlank = {
    prefix: 'fal',
    iconName: 'house-chimney-blank',
    icon: [
      576,
      512,
      [],
      'e3b0',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3 512 56c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24l0 23.4L298.6 4zM416 107.6L416 64l64 0 0 100.1-64-56.5zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faHouseHeart = {
    prefix: 'fal',
    iconName: 'house-heart',
    icon: [
      576,
      512,
      ["home-heart"],
      'f4c9',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48zM208 285.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L288 377.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM237.3 224c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z'
      
    ]
  };

  
    var faHomeHeart = faHouseHeart;
  

  
  

  var faFileXmark = {
    prefix: 'fal',
    iconName: 'file-xmark',
    icon: [
      384,
      512,
      ["file-times"],
      'f317',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm52.7 260.7c-6.2 6.2-6.2 16.4 0 22.6L169.4 336l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 358.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 336l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faFileTimes = faFileXmark;
  

  
  

  var faMountain = {
    prefix: 'fal',
    iconName: 'mountain',
    icon: [
      512,
      512,
      [127956],
      'f6fc',
      
      'M480 424.1c0 13.2-10.7 23.9-23.9 23.9L55.9 448C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L140.2 244.8 195.5 314c3.1 3.9 7.8 6.1 12.7 6s9.6-2.4 12.6-6.4L264 256l114.9 0 97.5 155.4c2.4 3.8 3.7 8.2 3.7 12.7zM358.8 224L256 224c-5 0-9.8 2.4-12.8 6.4l-35.6 47.5-49.4-61.8L252.4 66c.8-1.3 2.2-2 3.6-2s2.9 .8 3.6 2l99.1 158zM55.9 480l400.2 0c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z'
      
    ]
  };

  

  
  

  var faHourglass = {
    prefix: 'fal',
    iconName: 'hourglass',
    icon: [
      384,
      512,
      [9203,62032,"hourglass-empty"],
      'f254',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l16 0 0 41.6c0 49.4 22.8 96 61.8 126.3L165.9 256 93.8 312.1C54.8 342.4 32 389.1 32 438.4L32 480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 288 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-41.6c0-49.4-22.8-96-61.8-126.3L218.1 256l72.2-56.1c39-30.3 61.8-76.9 61.8-126.3L352 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L336 0 48 0 16 0zM320 32l0 41.6c0 39.5-18.2 76.8-49.4 101L192 235.7l-78.6-61.1C82.2 150.4 64 113.1 64 73.6L64 32l256 0zM192 276.3l78.6 61.1c31.2 24.2 49.4 61.5 49.4 101l0 41.6L64 480l0-41.6c0-39.5 18.2-76.8 49.4-101L192 276.3z'
      
    ]
  };

  
    var faHourglassEmpty = faHourglass;
  

  
  

  var faNfcTrash = {
    prefix: 'fal',
    iconName: 'nfc-trash',
    icon: [
      640,
      512,
      [],
      'e1fd',
      
      'M64 64l320 0c17.7 0 32 14.3 32 32l0 104.2 2.5-7.4c4.8-14.3 15.9-25.2 29.5-30.1L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l317.6 0-2.3-32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zM384 208l0-80c0-17.7-14.3-32-32-32L240 96c-17.7 0-32 14.3-32 32l0 82.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 80 32 0zM352 384L96 384l0-256 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l256 0c9.7 0 18.4-4.3 24.3-11.1L369.1 304 352 304l0 80zM240 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm208.8-53.1L436.5 240 400 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 128 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-36.5 0-12.4-37.1C573 196.4 566.9 192 560 192l-96 0c-6.9 0-13 4.4-15.2 10.9zM470.2 240l5.3-16 72.9 0 5.3 16-83.6 0zm-69 64.1l12.7 178.2C415.1 499 429 512 445.8 512l132.4 0c16.8 0 30.7-13 31.9-29.7l12.7-178.2-32.1 0L578.2 480l-132.4 0L433.2 304.1l-32.1 0z'
      
    ]
  };

  

  
  

  var faTruckFieldUn = {
    prefix: 'fal',
    iconName: 'truck-field-un',
    icon: [
      640,
      512,
      [],
      'e58e',
      
      'M96 64C78.3 64 64 78.3 64 96l0 32 0 160 0 64 5.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64L352 352l0-128 0-32 0-96c0-17.7-14.3-32-32-32L96 64zM0 160c0-17.7 14.3-32 32-32l0-32c0-35.3 28.7-64 64-64l224 0c32.6 0 59.6 24.4 63.5 56l53.4 0c17.7 0 33.9 9.7 42.3 25.2L521.6 192l22.4 0c35.3 0 64 28.7 64 64l0 96 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0-96 0c0 53-43 96-96 96s-96-43-96-96l-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-64c-17.7 0-32-14.3-32-32l0-96zm384-40l0 72 101.2 0L451 128.4c-2.8-5.2-8.2-8.4-14.1-8.4L384 120zm0 232l5.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l5.5 0 0-96c0-17.7-14.3-32-32-32l-31.7 0c-.2 0-.4 0-.6 0L384 224l0 128zM253.3 135.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 240A64 64 0 1 0 96 384a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faPuzzlePieceSimple = {
    prefix: 'fal',
    iconName: 'puzzle-piece-simple',
    icon: [
      640,
      512,
      ["puzzle-piece-alt"],
      'e231',
      
      'M176 96c-8.8 0-16 7.2-16 16l0 88.8c0 21.6-17.5 39.2-39.2 39.2c-16.2 0-28.4-9.9-35.6-19.6C78.8 211.8 71.1 208 64 208c-7.1 0-14.7 3.8-21.1 12.3S32 241.5 32 256s4.4 27.1 10.9 35.7S56.9 304 64 304c7.1 0 14.8-3.8 21.2-12.4c7.2-9.7 19.4-19.6 35.6-19.6c21.6 0 39.2 17.5 39.2 39.2l0 88.8c0 8.8 7.2 16 16 16l93.7 0C252 403.1 240 383.1 240 360c0-41.7 37.9-72 80-72s80 30.3 80 72c0 23.1-12 43.1-29.7 56l93.7 0c8.8 0 16-7.2 16-16l0-88.8c0-21.6 17.5-39.2 39.2-39.2c16.2 0 28.4 9.9 35.6 19.6c6.4 8.6 14.1 12.4 21.2 12.4c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-7.1 0-14.8 3.8-21.2 12.4c-7.2 9.7-19.4 19.6-35.6 19.6c-21.7 0-39.2-17.5-39.2-39.2l0-88.8c0-8.8-7.2-16-16-16l-93.7 0C388 108.8 400 128.9 400 152c0 41.7-37.9 72-80 72s-80-30.3-80-72c0-23.1 12-43.2 29.7-56L176 96zm-48 16c0-26.5 21.5-48 48-48l97.5 0C290.3 64 304 77.7 304 94.5c0 11.9-6.8 21.3-14.6 26.7c-11.2 7.7-17.4 19-17.4 30.8c0 20.2 19.4 40 48 40s48-19.8 48-40c0-11.8-6.3-23.1-17.4-30.8c-7.8-5.4-14.6-14.8-14.6-26.7C336 77.7 349.7 64 366.6 64L464 64c26.5 0 48 21.5 48 48l0 88.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7c11-14.7 27.4-25.3 46.8-25.3c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2l0 88.8c0 26.5-21.5 48-48 48l-97.4 0c-16.9 0-30.6-13.7-30.6-30.6c0-11.9 6.8-21.3 14.6-26.7c11.2-7.7 17.4-19 17.4-30.8c0-20.2-19.4-40-48-40s-48 19.8-48 40c0 11.8 6.3 23.1 17.4 30.8c7.8 5.4 14.6 14.8 14.6 26.7c0 16.9-13.7 30.6-30.5 30.6L176 448c-26.5 0-48-21.5-48-48l0-88.8c0-4-3.2-7.2-7.2-7.2c-2.3 0-6.1 1.6-10 6.7C99.9 325.4 83.5 336 64 336c-19.4 0-35.8-10.5-46.7-25.1S0 276.8 0 256s6.3-40.2 17.3-54.9S44.6 176 64 176c19.5 0 35.9 10.6 46.8 25.3c3.8 5.2 7.7 6.7 10 6.7c4 0 7.2-3.2 7.2-7.2l0-88.8z'
      
    ]
  };

  
    var faPuzzlePieceAlt = faPuzzlePieceSimple;
  

  
  

  var faTreeDeciduous = {
    prefix: 'fal',
    iconName: 'tree-deciduous',
    icon: [
      512,
      512,
      [127795,"tree-alt"],
      'f400',
      
      'M177.7 95.6c-.9 4.5-3.8 8.4-7.8 10.6s-8.8 2.7-13.1 1.2c-6.5-2.2-13.5-3.5-20.8-3.5c-35.3 0-64 28.7-64 64c0 13.2 4 25.4 10.8 35.6c2.8 4.1 3.5 9.3 1.9 14s-5.2 8.4-9.9 10C49.9 236.3 32 260.1 32 288c0 35.3 28.7 64 64 64l144 0 0-32 0-64 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 0 64 0 32 144 0c35.3 0 64-28.7 64-64c0-27.9-17.9-51.7-42.8-60.4c-4.7-1.6-8.3-5.3-9.9-10s-.9-9.9 1.9-14C436 193.4 440 181.2 440 168c0-35.3-28.7-64-64-64c-7.3 0-14.3 1.2-20.8 3.5c-4.3 1.5-9.1 1-13.1-1.2s-6.8-6.1-7.8-10.6C326.8 59.3 294.5 32 256 32s-70.8 27.3-78.3 63.6zM240 384L96 384c-53 0-96-43-96-96c0-35.3 19.1-66.2 47.5-82.8c-4.8-11.4-7.5-24-7.5-37.2c0-53 43-96 96-96c5.1 0 10.1 .4 14.9 1.2C166.7 30.4 207.8 0 256 0s89.3 30.4 105.1 73.2c4.9-.8 9.9-1.2 14.9-1.2c53 0 96 43 96 96c0 13.2-2.7 25.7-7.5 37.2C492.9 221.8 512 252.7 512 288c0 53-43 96-96 96l-144 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112z'
      
    ]
  };

  
    var faTreeAlt = faTreeDeciduous;
  

  
  

  var faIndent = {
    prefix: 'fal',
    iconName: 'indent',
    icon: [
      448,
      512,
      [],
      'f03c',
      
      'M0 64c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 80C7.2 80 0 72.8 0 64zM192 192c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 112l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM0 448c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 464c-8.8 0-16-7.2-16-16zM32 211.8l0 88.4L85.7 256 32 211.8zm89 31.8c7.8 6.4 7.8 18.3 0 24.7L26.2 346.4C15.7 355 0 347.6 0 334.1L0 177.9c0-13.5 15.7-20.9 26.2-12.4L121 243.6z'
      
    ]
  };

  

  
  

  var faCommentMusic = {
    prefix: 'fal',
    iconName: 'comment-music',
    icon: [
      512,
      512,
      [],
      'f8b0',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm89.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-116.9 96-36 0 83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5l0-144c0-5.2-2.6-10.2-6.9-13.2zM320 276c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 308c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z'
      
    ]
  };

  

  
  

  var faRugbyBall = {
    prefix: 'fal',
    iconName: 'rugby-ball',
    icon: [
      512,
      512,
      [],
      'e3c6',
      
      'M336 16l32 0c70.7 0 128 57.3 128 128l0 32c0 176.7-143.3 320-320 320l-32 0C73.3 496 16 438.7 16 368l0-32C16 159.3 159.3 16 336 16zm27.9 32L336 48c-77.3 0-147.5 30.4-199.2 80c-3 2.9-5.9 5.8-8.8 8.8C78.4 188.5 48 258.7 48 336l0 31.9c3.5-10.8 8-22.1 13.5-33.6c23.1-48.3 64-104.5 117.2-157.6S288 82.6 336.3 59.5C345.7 55 355 51.2 363.9 48zM143.1 464c.3 0 .6 0 .9 0l32 0c77.3 0 147.5-30.4 199.2-80c3-2.9 5.9-5.8 8.8-8.8c49.6-51.7 80-121.9 80-199.2l0-28.8c-3.2 9.2-7.1 18.6-11.7 28.2c-23.1 48.3-64 104.5-117.2 157.6S225.8 427.2 177.5 450.2c-11.8 5.6-23.3 10.3-34.3 13.8zM79.2 432.5c4.6 4.6 13.1 7.9 28.2 6.6c15-1.3 34.1-7.1 56.3-17.7c44.3-21.1 97.5-59.7 148.8-110.9s89.8-104.5 110.9-148.8c10.6-22.2 16.4-41.3 17.7-56.3c1.3-15.1-2-23.6-6.6-28.2s-13.1-7.9-28.2-6.6c-15 1.3-34.1 7.1-56.3 17.7c-44.3 21.1-97.5 59.7-148.8 110.9s-89.8 104.5-110.9 148.8C79.8 370.3 74 389.4 72.7 404.4c-1.3 15.1 2 23.6 6.6 28.2z'
      
    ]
  };

  

  
  

  var faMessageMedical = {
    prefix: 'fal',
    iconName: 'message-medical',
    icon: [
      512,
      512,
      ["comment-alt-medical"],
      'f7f4',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM240 96c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  
    var faCommentAltMedical = faMessageMedical;
  

  
  

  var faReflectHorizontal = {
    prefix: 'fal',
    iconName: 'reflect-horizontal',
    icon: [
      512,
      512,
      [],
      'e664',
      
      'M256 0c8.8 0 16 7.2 16 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-480c0-8.8 7.2-16 16-16zM32 384L160 256 32 128l0 256zM0 128c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S0 396.9 0 384L0 128zm480 0L352 256 480 384l0-256zm12.2-29.6c12 5 19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9z'
      
    ]
  };

  

  
  

  var faParachuteBox = {
    prefix: 'fal',
    iconName: 'parachute-box',
    icon: [
      512,
      512,
      [],
      'f4cd',
      
      'M256.1 0L256 0C86.6 0 8.7 114.4 .7 208c-.8 8.8 6.5 16 15.3 16l33.1 0L165 346.7c-3.2 6.4-5 13.7-5 21.3l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-7.7-1.8-14.9-5-21.3L462.9 224l33.1 0c8.8 0 16.1-7.2 15.3-16c-8-93.6-85.8-208-255.2-208zM418.9 224L324.1 324.4c-6.1-2.8-12.9-4.4-20.1-4.4l-32 0 0-96 95.5 0 32.1 0 19.3 0zM240 224l0 96-32 0c-7.2 0-14 1.6-20.1 4.4L93.1 224l19.3 0 32 0 95.5 0zm0 128l32 0 32 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l32 0zM35.2 192C46.4 135.7 86.8 73.5 165.5 46.2c-29.9 35-50 87-53.1 145.8l-77.2 0zM180.5 79.1C202.5 47.4 229.7 32 256 32s53.5 15.4 75.5 47.1c19.6 28.3 33.4 67.8 36 112.9l-223.1 0c2.7-45.1 16.4-84.5 36-112.9zM476.8 192l-77.2 0c-3.1-58.8-23.1-110.8-53.1-145.8C425.2 73.5 465.6 135.7 476.8 192z'
      
    ]
  };

  

  
  

  var faCircleNodes = {
    prefix: 'fal',
    iconName: 'circle-nodes',
    icon: [
      512,
      512,
      [],
      'e4e2',
      
      'M376.2 121.7s0 0 0 0c7 4 15.2 6.3 23.8 6.3c2.6 0 5.2-.2 7.6-.6c0 0 0 0 0 0C430.5 123.7 448 103.9 448 80c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 .7 0 1.3 0 2c0 0 0 0 0 0c.5 11.4 4.9 21.7 11.9 29.7c0 0 0 0 0 0c3.5 4 7.6 7.4 12.2 10zm-5.9 32.6c-15.2-6.1-28.2-16.8-37.1-30.3L158.7 193.7c.8 4.6 1.3 9.4 1.3 14.3c0 14.4-3.8 27.9-10.5 39.6l138 120.8c13-9.9 29.2-16 46.7-16.3l36-197.7zm-4.5 203.4C395.2 369.5 416 398.3 416 432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-14.4 3.8-27.9 10.5-39.6l-138-120.8C115 281.9 98.2 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c27.9 0 52.5 14.3 66.8 36L321.3 94.3c-.8-4.6-1.3-9.4-1.3-14.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 43.6-34.9 79.1-78.3 80l-36 197.7zm-246-122.9c.7-1 1.3-2 1.9-3.1c4-7 6.3-15.1 6.3-23.8c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c8.5 0 16.6-2.2 23.5-6.2c0 0 0 0 0 0c6.5-3.7 12.1-8.8 16.3-15zM291.4 414.2c-2.2 5.5-3.4 11.5-3.4 17.8c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-14 0-26.6 6-35.3 15.5c-2.7 2.9-5 6.1-6.9 9.6c-.9 1.6-1.7 3.4-2.4 5.1c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faCircleWifiCircleWifi = {
    prefix: 'fal',
    iconName: 'circle-wifi-circle-wifi',
    icon: [
      640,
      512,
      ["circle-wifi-group"],
      'e67e',
      
      'M256 32c102.1 0 188.3 68.3 215.2 161.7c8.1-1.1 16.4-1.7 24.8-1.7c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25c-7.4-8-14-16.8-19.8-26.1c-27.7 12.2-58.3 19-90.5 19C132.3 480 32 379.7 32 256S132.3 32 256 32zM411.2 203.6C370.1 166.5 315.7 144 256 144s-114.1 22.6-155.2 59.6c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2C157.6 195.4 204.5 176 256 176s98.4 19.4 133.8 51.4l.2 .1c8.1-6.1 16.8-11.6 26-16.3c-.8-2.8-2.4-5.5-4.7-7.6zM341.8 273c-22.7-20.5-52.8-33-85.8-33s-63.1 12.5-85.8 33c-6.6 5.9-7.1 16-1.1 22.6s16 7.1 22.6 1.1c17-15.4 39.6-24.8 64.4-24.8s47.3 9.4 64.4 24.8c3.7 3.3 8.4 4.6 12.9 4c3.4-8.2 7.3-16 11.9-23.5c-.8-1.5-1.9-3-3.3-4.2zM256 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-184c23.6 0 45 8.9 61.3 23.5c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6C556.8 308 527.8 296 496 296s-60.8 12-82.7 31.7c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2C451 336.9 472.4 328 496 328zm20 104a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm-46.7-37.7c7.1-6.4 16.4-10.3 26.7-10.3s19.6 3.9 26.7 10.3c6.6 5.9 16.7 5.4 22.6-1.1s5.4-16.7-1.1-22.6C531.4 359 514.5 352 496 352s-35.4 7-48.1 18.5c-6.6 5.9-7.1 16-1.1 22.6s16 7.1 22.6 1.1z'
      
    ]
  };

  
    var faCircleWifiGroup = faCircleWifiCircleWifi;
  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fal',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      'M480 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176c0 44.2-35.8 80-80 80L54.6 304 155.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272 432 272c26.5 0 48-21.5 48-48l0-176z'
      
    ]
  };

  

  
  

  var faBorderNone = {
    prefix: 'fal',
    iconName: 'border-none',
    icon: [
      448,
      512,
      [],
      'f850',
      
      'M32 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-240a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM320 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-432a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faCircleSmall = {
    prefix: 'fal',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      'M288 256A128 128 0 1 0 32 256a128 128 0 1 0 256 0zM0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faBottleBaby = {
    prefix: 'fal',
    iconName: 'bottle-baby',
    icon: [
      512,
      512,
      [],
      'e673',
      
      'M256 0c26.5 0 48 21.5 48 48c18.5 9.2 30.5 27.6 31.9 48c.1 1.3 .1 2.5 .1 3.8l0 8.4c9.8 8.8 16 21.6 16 35.8l0 16 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-48 0-96 0-20.4c0-38.2 15.2-74.8 42.2-101.8L160 160l0-16c0-14.2 6.2-27 16-35.8l0-8.4c0-1.3 0-2.5 .1-3.8c1.3-20.4 13.4-38.8 31.9-48c0-26.5 21.5-48 48-48zM128 416l0 32c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-164.4c0-29.7-11.8-58.2-32.8-79.2L338.7 192 320 192l-128 0-18.7 0-12.5 12.5c-21 21-32.8 49.5-32.8 79.2l0 4.4 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 64 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0zM303.7 96c-1.2-8.3-6.4-15.6-14-19.4C278.8 71.2 272 60.1 272 48c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 12.1-6.8 23.2-17.7 28.6c-7.6 3.8-12.8 11.1-14 19.4l95.4 0zM208 128c-8.8 0-16 7.2-16 16l0 16 128 0 0-16c0-8.8-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faLitecoinSign = {
    prefix: 'fal',
    iconName: 'litecoin-sign',
    icon: [
      384,
      512,
      [],
      'e1d3',
      
      'M96 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 179.5-51.9 13C3.5 242.6-1.7 251.3 .5 259.9s10.8 13.8 19.4 11.6l44.1-11L64 440c0 22.1 17.9 40 40 40l264 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-264 0c-4.4 0-8-3.6-8-8l0-187.5 179.9-45c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L96 219.5 96 48z'
      
    ]
  };

  

  
  

  var faH6 = {
    prefix: 'fal',
    iconName: 'h6',
    icon: [
      640,
      512,
      [],
      'e413',
      
      'M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 256 0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 256 0 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160L32 240 32 80zM505.4 67.1c-7.1-5.2-17.2-3.6-22.4 3.5L383.3 207.8C363 235.7 352 269.4 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6l56.1-77.2c5.2-7.1 3.6-17.2-3.5-22.4zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  

  
  

  var faCircleY = {
    prefix: 'fal',
    iconName: 'circle-y',
    icon: [
      512,
      512,
      [],
      'e12f',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM156 149.5c-5.8-6.7-15.9-7.3-22.6-1.5s-7.3 15.9-1.5 22.6L240 294l0 90c0 8.8 7.2 16 16 16s16-7.2 16-16l0-90L380 170.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5L256 263.7 156 149.5z'
      
    ]
  };

  

  
  

  var faAppleCore = {
    prefix: 'fal',
    iconName: 'apple-core',
    icon: [
      384,
      512,
      [],
      'e08f',
      
      'M196.6 96C229.4 96 256 69.4 256 36.6l0-4.6-4.6 0C218.6 32 192 58.6 192 91.4l0 4.6 4.6 0zm-18.3 32c-10.1 0-18.3-8.2-18.3-18.3l0-18.3C160 40.9 200.9 0 251.4 0l18.3 0C279.8 0 288 8.2 288 18.3l0 18.3c0 50.5-40.9 91.4-91.4 91.4l-18.3 0zM128 480c13.2 0 32-2.7 45.3-5c12.3-2.2 25-2.2 37.3 0c13.3 2.3 32.1 5 45.3 5c19.7 0 41.8-8.8 62.6-27.3C280 415 256 362.3 256 304c0-55.6 21.8-106.1 57.3-143.4c-3-.4-6.1-.6-9.3-.6c-21 0-48.7 8.4-71.1 17.1c-26.2 10.2-55.6 10.2-81.9 0C128.7 168.4 101 160 80 160c-3.2 0-6.3 .2-9.3 .6C106.2 197.9 128 248.4 128 304c0 58.3-24 111-62.6 148.7C86.2 471.2 108.3 480 128 480zM29.9 462.4c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.2 0-37.4-3.2-50.8-5.5c-8.7-1.5-17.6-1.5-26.3 0c-13.5 2.4-34.6 5.5-50.8 5.5c-34.9 0-69.8-18.3-98.1-49.6z'
      
    ]
  };

  

  
  

  var faArrowUp91 = {
    prefix: 'fal',
    iconName: 'arrow-up-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-up-alt"],
      'f887',
      
      'M428 168a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c.4 0 .9 0 1.3 0l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5C504.4 161.8 512 141.2 512 120c0 0-.1 0-.1 0c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM448 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L416 448l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-144z'
      
    ]
  };

  
    var faSortNumericUpAlt = faArrowUp91;
  

  
  

  var faPersonPinball = {
    prefix: 'fal',
    iconName: 'person-pinball',
    icon: [
      640,
      512,
      [],
      'e21d',
      
      'M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm8 168l0 55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6l0-140.4c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28l0 19.4c0 .2 0 .4 0 .6zm96 168.4l-96-66L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 280.2c0-.3 0-.7 0-1L0 204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256l29.7 0 316.4-60.8L481.6 71.5c-1.1-3.3-1.6-6.7-1.6-10.1L480 32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 160 0 208 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-384 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96 0-112-15.3 0c-10.9 0-21-5.5-26.9-14.7L112 214.5l0 128.1L146.1 366c8.7 6 13.9 15.8 13.9 26.4L160 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-103.6zM608 178.8L608 32l-96 0 0 29.4 42.6 127.7L608 178.8zM608 384l0-172.6L224 285.2l0 98.8 384 0zM288 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faLungs = {
    prefix: 'fal',
    iconName: 'lungs',
    icon: [
      640,
      512,
      [129729],
      'f604',
      
      'M320 0c8.8 0 16 7.2 16 16l0 164.1c0 21.9 11.2 42.2 29.6 54L384 245.8l0-80.4C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398l0-76.4L416 342l0 56c0 29.4 20 55 48.5 62.1l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7c31.5 0 57-25.5 57-57l0-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1c-20.6 0-37.3 16.7-37.3 37.3l0 100.8 88.6 56.4c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L416 304.1l-32-20.4-35.5-22.6c-11.5-7.3-21.1-16.9-28.5-27.9c-7.3 11-16.9 20.6-28.5 27.9L256 283.7l-32 20.4-71.4 45.4c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1L224 266.1l0-100.8c0-20.6-16.7-37.3-37.3-37.3c-11.8 0-22.8 5.5-29.5 15.1c-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416l0 7c0 31.5 25.5 57 57 57c4.7 0 9.3-.6 13.8-1.7l72.7-18.2C204 453 224 427.4 224 398l0-56 32-20.4 0 76.4c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3l0 80.4 18.4-11.7c18.5-11.7 29.6-32.1 29.6-54L304 16c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faRibbon = {
    prefix: 'fal',
    iconName: 'ribbon',
    icon: [
      448,
      512,
      [127895],
      'f4d6',
      
      'M228 0c-1.3 0-2.6 0-4 0c0 0 0 0 0 .1c-13.3 .2-29.2 .7-38.3 1.4s-17 1.7-23.5 2.6c-18.3 2.7-33.3 13.3-43.6 26.7L70.8 92.9c-14.8 19.2-22.8 42.7-22.8 67c0 27.9 10.6 54.8 29.7 75.1L332.3 506.9c5.4 5.8 14.3 6.7 20.9 2.2l80-56c3.8-2.6 6.2-6.8 6.7-11.3s-1-9.1-4.1-12.5L172.4 139.5c-2.8-3-4.3-7-4.3-11.1c0-9.1 7.4-16.5 16.5-16.5l39.5 0 16 0 23.5 0c9.1 0 16.5 7.4 16.5 16.5c0 4.1-1.5 8-4.3 11.1l-30 33 21.6 23.8 32.1-35.3c8.1-8.9 12.6-20.5 12.6-32.6c0-26.8-21.7-48.5-48.5-48.5L240 80l-16 0-39.5 0c-26.8 0-48.5 21.7-48.5 48.5c0 12.1 4.5 23.7 12.6 32.6L399.9 437.3l-53.7 37.6L101.1 213.2c-13.5-14.4-21-33.5-21-53.2c0-17.2 5.7-33.9 16.1-47.5l47.7-62.1c6.3-8.2 14.4-13.3 23-14.6c5.8-.9 12.9-1.7 21.4-2.4c9-.7 26.1-1.3 39.7-1.4c12.1 .1 22.8 .6 31.9 1.4c8.5 .7 15.6 1.6 21.4 2.4c8.6 1.3 16.7 6.4 23 14.6l47.7 62.1c10.5 13.6 16.1 30.3 16.1 47.5c0 19.8-7.5 38.8-21 53.2L314.3 248l21.6 23.8L370.3 235c19.1-20.4 29.7-47.2 29.7-75.1c0-24.2-8-47.8-22.8-67L329.5 30.9c-10.3-13.4-25.3-24-43.6-26.7c-6.5-1-14.3-1.9-23.5-2.6C253.5 .8 243.4 .2 232 .1c0 0 0 0 0-.1c-1.3 0-2.6 0-4 0zM112.5 319L12.2 429.2c-3.1 3.4-4.6 8-4.1 12.5s3 8.7 6.7 11.3l80 56c6.5 4.6 15.4 3.6 20.9-2.2l86.4-92.2-21.9-23.4-78.3 83.7L48.2 437.3l86.3-94.9L112.5 319z'
      
    ]
  };

  

  
  

  var faLockA = {
    prefix: 'fal',
    iconName: 'lock-a',
    icon: [
      448,
      512,
      [],
      'e422',
      
      'M224 32c53 0 96 43 96 96l0 64-192 0 0-64c0-53 43-96 96-96zM96 128l0 64-16 0c-44.2 0-80 35.8-80 80L0 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80l-16 0 0-64C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224l288 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48zm49.7 200.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 400l92.2 0 19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5L238.4 265c-.8-1.6-1.8-3-3.1-4.3c-1.4-1.4-3.1-2.6-5-3.4c-2.1-.9-4.2-1.3-6.4-1.3s-4.3 .4-6.4 1.3c-1.8 .8-3.5 1.9-5 3.4c-1.3 1.3-2.3 2.7-3 4.3L129.7 424.8zM193.9 368L224 307.8 254.1 368l-60.2 0z'
      
    ]
  };

  

  
  

  var faArrowRightToCity = {
    prefix: 'fal',
    iconName: 'arrow-right-to-city',
    icon: [
      640,
      512,
      [],
      'e4b3',
      
      'M320 48c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 160c0 8.8 7.2 16 16 16l64 0 32 0c8.8 0 16 7.2 16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-26.5-21.5-48-48-48l-16 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-32 0 0-144c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 448c0 8.8 7.2 16 16 16s16-7.2 16-16l0-448zm32 48l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zm96 160c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zM480 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zM384 192c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zM352 352l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zM155.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L201.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l185.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  

  
  

  var faChartLineDown = {
    prefix: 'fal',
    iconName: 'chart-line-down',
    icon: [
      512,
      512,
      [128201],
      'f64d',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM320 336c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4L331.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L224 265.4 123.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0L320 214.6 425.4 320 336 320c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fal',
    iconName: 'paperclip',
    icon: [
      448,
      512,
      [128206],
      'f0c6',
      
      'M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5c-21.3-26.6-19.2-65 4.9-89.1L276.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5c13 16.2 37.2 17.6 51.9 2.9L380.7 172.7c29.1-29.1 29.1-76.3 0-105.4z'
      
    ]
  };

  

  
  

  var faBinRecycle = {
    prefix: 'fal',
    iconName: 'bin-recycle',
    icon: [
      576,
      512,
      [],
      'e5f7',
      
      'M536 64c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-24.1 0L64.1 96 40 96c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l496 0zM0 88c0 20.3 15.1 37 34.6 39.6l0 .4L59.1 421.3c2.8 33.2 30.5 58.7 63.8 58.7l330.2 0c33.3 0 61-25.5 63.8-58.7L541.3 128l0-.4C560.9 125 576 108.3 576 88l0-16c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72L0 88zM91 418.7L66.8 128l442.4 0L485 418.7c-1.4 16.6-15.2 29.3-31.9 29.3l-330.2 0c-16.6 0-30.5-12.8-31.9-29.3zM288 192c5 0 9.7 2.4 12.6 6.4l31 42.1c5 6.7 14.3 8.5 21.4 4.1c7.9-4.9 9.9-15.6 4.4-23.1l-31-42.1c-9-12.2-23.2-19.4-38.4-19.4s-29.4 7.2-38.4 19.4l-31 42.1c-5.5 7.5-3.5 18.1 4.4 23.1c7.1 4.4 16.4 2.7 21.4-4.1l31-42.1c3-4 7.6-6.4 12.6-6.4zm-86.1 77.1c-7.1-4.4-16.4-2.7-21.4 4.1L153 310.5c-5.8 7.9-9 17.5-9 27.4c0 25.5 20.6 46.1 46.1 46.1l65.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.9 0c-7.8 0-14.1-6.3-14.1-14.1c0-3 1-5.9 2.8-8.4l27.6-37.4c5.5-7.5 3.5-18.1-4.4-23.1zM304 368c0 8.8 7.2 16 16 16l65.9 0c25.5 0 46.1-20.6 46.1-46.1c0-9.8-3.1-19.4-9-27.4l-27.6-37.4c-5-6.7-14.3-8.5-21.4-4.1c-7.9 4.9-9.9 15.6-4.4 23.1l27.6 37.4c1.8 2.4 2.7 5.4 2.7 8.4c0 7.8-6.3 14.1-14.1 14.1L320 352c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faAnglesUp = {
    prefix: 'fal',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      'M234.7 68.1c-6.1-5.5-15.3-5.5-21.4 0l-160 144c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2L224 101.5 373.3 235.9c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6l-160-144zm160 336l-160-144c-6.1-5.5-15.3-5.5-21.4 0l-160 144c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2L224 293.5 373.3 427.9c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6z'
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faFaceTissue = {
    prefix: 'fal',
    iconName: 'face-tissue',
    icon: [
      512,
      512,
      [],
      'e39c',
      
      'M256 32C132.3 32 32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224S379.7 32 256 32zm39.1 306.7c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 371.2l-39.1 26.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l48-32zM136.5 190.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7zm246.2-21.5c4 7.9 .7 17.5-7.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2zM223.8 306.6l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5s5.3 8.8 4.5 13.9zM79.9 354.1c6.2 3.6 9.3 10.8 7.6 17.8L70 442l70.1-17.5c7-1.7 14.2 1.4 17.8 7.6l9.7 17 20.9-125.6L62.9 344.4l17 9.7z'
      
    ]
  };

  

  
  

  var faDollyEmpty = {
    prefix: 'fal',
    iconName: 'dolly-empty',
    icon: [
      576,
      512,
      [],
      'f473',
      
      'M8 16C8 7.2 15.2 0 24 0L88.9 0c20.7 0 39 13.2 45.5 32.8L241.3 353.3c4.8-.9 9.7-1.3 14.7-1.3c34.1 0 63.2 21.3 74.7 51.4L554.5 321c8.3-3.1 17.5 1.2 20.5 9.5s-1.2 17.5-9.5 20.5L335.9 435.6C334 478.1 299 512 256 512c-44.2 0-80-35.8-80-80c0-27.8 14.1-52.2 35.6-66.6L104.1 42.9C101.9 36.4 95.8 32 88.9 32L24 32C15.2 32 8 24.8 8 16zM304 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fal',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9l0-39.9c0-17.7-14.3-32-32-32L64 96zM32 207.6L32 384c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-176.4L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z'
      
    ]
  };

  

  
  

  var faTruckLadder = {
    prefix: 'fal',
    iconName: 'truck-ladder',
    icon: [
      640,
      512,
      [],
      'e657',
      
      'M16 32l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 96c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 192c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-96C7.2 64 0 56.8 0 48s7.2-16 16-16zM304 64l-64 0 0 96 64 0 0-96zm-96 0l-64 0 0 96 64 0 0-96zm-96 0L48 64l0 96 64 0 0-96zm272 72c0-22.1 17.9-40 40-40l58.7 0c12.7 0 24.9 5.1 33.9 14.1L625.9 219.3c9 9 14.1 21.2 14.1 33.9L640 368c0 26.5-21.5 48-48 48l-16 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l336 0 0-88zm32 88l169.4 0-91.3-91.3c-3-3-7.1-4.7-11.3-4.7L424 128c-4.4 0-8 3.6-8 8l0 88zm192 32L48 256c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l21.5 0c8.8 0 16-7.2 16-16l0-112zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faHeadSide = {
    prefix: 'fal',
    iconName: 'head-side',
    icon: [
      512,
      512,
      [],
      'f6e9',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fal',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      'M82.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8C80 88.8 87.4 96 96 96s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L96 49.7 82.5 70.9zm-27-17.1L86.2 5.4C88.3 2 92 0 96 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26zM384 256l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-96 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-96 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-17.7 0-32 14.3-32 32l0 80c13.3 0 26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4C81.9 342.7 89 336 96 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4C209.9 342.7 217 336 224 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4c6-5.7 13-12.3 19.8-12.4c7.2-.2 15.1 6.8 21.8 12.5c2.8 2.4 5.3 4.6 7.5 6c10.3 6.7 22.7 12.4 35.2 13.3l0-79.9c0-17.7-14.3-32-32-32zM32 400l0 80 384 0 0-80.1c-21.1-.9-39.8-10.2-52.6-18.5c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C73.8 390 54.6 400 32 400zM64 224l16 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 96 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 96 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32L0 288c0-35.3 28.7-64 64-64zM224 49.7L210.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8c0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L224 49.7zM214.2 5.4C216.3 2 220 0 224 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26L214.2 5.4zM338.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8c0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L352 49.7 338.5 70.9zm-27-17.1L342.2 5.4C344.3 2 348 0 352 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26z'
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faSquare1 = {
    prefix: 'fal',
    iconName: 'square-1',
    icon: [
      448,
      512,
      [],
      'e256',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm168 98.2c-4.9-2.9-11-2.9-16-.1l-56 32c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6L208 171.6 208 352l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-208c0-5.7-3-11-8-13.8z'
      
    ]
  };

  

  
  

  var faComment = {
    prefix: 'fal',
    iconName: 'comment',
    icon: [
      512,
      512,
      [61669,128489],
      'f075',
      
      'M256 64C125.8 64 32 148.6 32 240c0 37.1 15.5 70.6 40 100c5.2 6.3 8.4 14.8 7.4 23.9c-3.1 27-11.4 52.5-25.7 76.3c-.5 .9-1.1 1.8-1.6 2.6c11.1-2.9 22.2-7 32.7-11.5L91.2 446l-6.4-14.7c17-7.4 33-16.7 48.4-27.4c8.5-5.9 19.4-7.5 29.2-4.2C193 410.1 224.1 416 256 416c130.2 0 224-84.6 224-176s-93.8-176-224-176zM0 240C0 125.2 114.5 32 256 32s256 93.2 256 208s-114.5 208-256 208c-36 0-70.5-6.7-103.8-17.9c-.2-.1-.5 0-.7 .1c-16.9 11.7-34.7 22.1-53.9 30.5C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.8s-1.1-12.8 3.4-17.4c8.1-8.2 15.2-18.2 21.7-29c11.7-19.6 18.7-40.6 21.3-63.1c0 0-.1-.1-.1-.2C19.6 327.1 0 286.6 0 240z'
      
    ]
  };

  

  
  

  var faEllipsisStrokeVertical = {
    prefix: 'fal',
    iconName: 'ellipsis-stroke-vertical',
    icon: [
      192,
      512,
      ["ellipsis-v-alt"],
      'f39c',
      
      'M96 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96A64 64 0 1 1 96 32a64 64 0 1 1 0 128zm32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 256zm96 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 416z'
      
    ]
  };

  
    var faEllipsisVAlt = faEllipsisStrokeVertical;
  

  
  

  var faBracketsCurly = {
    prefix: 'fal',
    iconName: 'brackets-curly',
    icon: [
      576,
      512,
      [],
      'f7ea',
      
      'M144 32c-44.2 0-80 35.8-80 80l0 53.5c0 12.7-5.1 24.9-14.1 33.9L4.7 244.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l45.3 45.3c9 9 14.1 21.2 14.1 33.9L64 400c0 44.2 35.8 80 80 80l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-26.5 0-48-21.5-48-48l0-53.5c0-21.2-8.4-41.6-23.4-56.6L38.6 256l33.9-33.9c15-15 23.4-35.4 23.4-56.6L96 112c0-26.5 21.5-48 48-48l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm288 0l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c26.5 0 48 21.5 48 48l0 53.5c0 21.2 8.4 41.6 23.4 56.6L537.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6l0 53.5c0 26.5-21.5 48-48 48l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c44.2 0 80-35.8 80-80l0-53.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9l0-53.5c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faCircleYen = {
    prefix: 'fal',
    iconName: 'circle-yen',
    icon: [
      512,
      512,
      [],
      'e5d0',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM165.2 148.2c6.5-5.9 16.7-5.5 22.6 1.1l68.2 75 68.2-75c5.9-6.5 16.1-7 22.6-1.1s7 16.1 1.1 22.6L271 255.2l1 0 0 .8 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 17c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-.8 1 0-76.8-84.5c-5.9-6.5-5.5-16.7 1.1-22.6z'
      
    ]
  };

  

  
  

  var faCoffeeBean = {
    prefix: 'fal',
    iconName: 'coffee-bean',
    icon: [
      448,
      512,
      [],
      'e13e',
      
      'M390.6 110.9c21.2 27.9 29.6 65.9 23.5 108.9c-7 49.3-33.2 102.9-78.3 148s-98.7 71.3-148 78.3c-40.4 5.8-76.5-1.4-103.8-19.8c.1-.1 .1-.3 .2-.4c16.5-34.5 37.5-72.2 57.4-92.3c29.7-29.9 59.7-44.9 91.8-61l.5-.3s0 0 0 0c32-15.9 66.1-32.9 99.7-66.8c22.8-22.9 42.6-61.6 56.9-94.7zM365.9 87.1c-.6 1.4-1.2 2.9-1.8 4.4c-14.5 34.5-33.5 71.8-53.1 91.5c-29.7 29.9-59.7 44.9-91.8 61l-.5 .3c-32 15.9-66.1 32.9-99.7 66.8C96.7 333.4 75.5 371 59.4 403.6c-22.6-28.1-31.8-67.1-25.5-111.4c7-49.3 33.2-102.9 78.3-148s98.7-71.3 148-78.3c41.4-5.9 78.1 1.7 105.7 21.1zM392.3 67C315.9 4.6 183.9 27.3 89.6 121.6c-98.9 98.9-119 239.2-44.9 313.5c0 0 .1 .1 .1 .1c7.5 7.5 15.8 14.1 24.5 19.7c.4 .3 .8 .5 1.2 .8c77.8 48.6 199.4 23.2 287.8-65.3c99-99 119-239.4 44.8-313.6c-3.5-3.5-7.1-6.8-10.9-9.8z'
      
    ]
  };

  

  
  

  var faInboxes = {
    prefix: 'fal',
    iconName: 'inboxes',
    icon: [
      512,
      512,
      [],
      'e1bb',
      
      'M34.7 192l-1.4 3.4c-.8 2-1.2 4-1.2 6.2L32 272c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-70.4c0-2.1-.4-4.2-1.2-6.2l-1.4-3.4-73.6 0c-6.1 0-11.6 3.4-14.3 8.8l-14.3 28.6C367 245.7 350.4 256 332.2 256l-152.4 0c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8l-73.6 0zM48 160l60.2 0c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8l152.4 0c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5l60.2 0L414.8 41.8l29-12.1-29 12.1c-2.5-6-8.3-9.8-14.8-9.8L112 32c-6.5 0-12.3 3.9-14.8 9.8L48 160zM3.7 183.1l64-153.6C75.1 11.7 92.6 0 112 0L400 0c19.4 0 36.9 11.7 44.3 29.5l64 153.6c2.4 5.8 3.7 12.1 3.7 18.5l0 70.4c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-70.4c0-6.3 1.3-12.6 3.7-18.5zM114.3 384L48 384c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-66.3 0c-6.1 0-11.6 3.4-14.3 8.8L369 421.5l-28.6-14.3 14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5l66.3 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l66.3 0c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8l140.2 0c6.1 0 11.6-3.4 14.3-8.8L369 421.5c-8.1 16.3-24.8 26.5-42.9 26.5l-140.2 0c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8z'
      
    ]
  };

  

  
  

  var faBookSection = {
    prefix: 'fal',
    iconName: 'book-section',
    icon: [
      448,
      512,
      ["book-law"],
      'e0c1',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM224.7 254.1c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9c7.9 2.5 12.3 10.9 9.9 18.8c-2.5 7.9-11 12.3-18.8 9.9c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8c0 0 0 0 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8c2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26l-7-1.8zM222 185.9c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26c0 0-8.8-2.3-9.7-2.6z'
      
    ]
  };

  
    var faBookLaw = faBookSection;
  

  
  

  var faStretcher = {
    prefix: 'fal',
    iconName: 'stretcher',
    icon: [
      640,
      512,
      [],
      'f825',
      
      'M27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L145.9 232.6c15 15 35.4 23.4 56.6 23.4L624 256c8.8 0 16-7.2 16-16s-7.2-16-16-16l-95.8 0-.4 0-319.6 0-.4 0-5.3 0c-12.7 0-24.9-5.1-33.9-14.1L27.3 68.7zM224 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-8.8-1.8-17.3-5-24.9l53-40.6 53 40.6c-3.2 7.7-5 16.1-5 24.9c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.9 0-28.6 5.1-39.5 13.6l-46.2-35.3L491.6 288l-52.7 0L368 342.2 297.1 288l-52.7 0 97.2 74.4-46.2 35.3C284.6 389.1 270.9 384 256 384c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faTag = {
    prefix: 'fal',
    iconName: 'tag',
    icon: [
      448,
      512,
      [127991],
      'f02b',
      
      'M32 229.5L32 80c0-8.8 7.2-16 16-16l149.5 0c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3L262.6 428.1c-12.5 12.5-32.8 12.5-45.3 0l-176-176L18.7 274.7l22.6-22.6c-6-6-9.4-14.1-9.4-22.6zm-32 0c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80L0 229.5zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faSteeringWheel = {
    prefix: 'fal',
    iconName: 'steering-wheel',
    icon: [
      512,
      512,
      [],
      'f622',
      
      'M240 384l0 95.4C134.4 472 49.1 391.4 34.3 288l106.2 0c2.2 4.2 5.1 8.1 8.6 11.6l73.1 73.1c5.2 5.2 11.4 9 17.9 11.3zm32 0c6.6-2.3 12.7-6.1 17.9-11.3L363 299.6c3.5-3.5 6.3-7.4 8.6-11.6l106.2 0C462.9 391.4 377.6 472 272 479.4l0-95.4zM376.1 256c-.8-4-2.2-8-4.1-11.8l-12.8-25.7C351 202.3 334.4 192 316.2 192l-120.4 0c-18.2 0-34.8 10.3-42.9 26.5L140 244.2c-1.9 3.8-3.3 7.8-4.1 11.8L32 256C32 132.3 132.3 32 256 32s224 100.3 224 224l-103.9 0zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM181.5 232.8c2.7-5.4 8.3-8.8 14.3-8.8l120.4 0c6.1 0 11.6 3.4 14.3 8.8l12.8 25.7c3.1 6.2 1.9 13.6-3 18.5l-73.1 73.1c-6.2 6.2-16.4 6.2-22.6 0L171.6 277c-4.9-4.9-6.1-12.3-3-18.5l12.8-25.7z'
      
    ]
  };

  

  
  

  var faPlaneLock = {
    prefix: 'fal',
    iconName: 'plane-lock',
    icon: [
      640,
      512,
      [],
      'e558',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7l0 52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6l0 56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6l0 42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2c0 0 0 0 0 0L256 480.6l105.7 30.2s0 0 0 0c2.1 .6 4.2 1 6.3 1.1l0-32.6L260.4 448.6c-2.9-.8-5.9-.8-8.8 0L144 479.4l0-39.4 57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8l0-56.2c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9l0-61.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7l0 61.7c0 5.7 3.1 11 8.1 13.9l106.9 61.1c2.5-10.7 6.5-20.8 11.9-30.1L336 162.1l0-52.5c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm80 376l0-37.1 48 13.7 0-.6c0-11 2.8-21.4 7.7-30.4l-67.3-19.2c-4.8-1.4-10-.4-14 2.6s-6.4 7.8-6.4 12.8l0 66.3c0 5 2.4 9.8 6.4 12.8L368 440l0-40-32-24zM528 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faTruckFire = {
    prefix: 'fal',
    iconName: 'truck-fire',
    icon: [
      640,
      512,
      [],
      'e65a',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l48 0 0 64L48 96C21.5 96 0 117.5 0 144L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l16 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-96 0 0-64 240 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 0zM352 32l0 64-64 0 0-64 64 0zm0 96l32 0 0 128L32 256l0-112c0-8.8 7.2-16 16-16l16 0 32 0 256 0zm64 0l64 0 64 0 48 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64l-138.9 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L48 384c-8.8 0-16-7.2-16-16l0-80 360 0c13.3 0 24-10.7 24-24l0-136zM256 32l0 64-64 0 0-64 64 0zm-96 0l0 64L96 96l0-64 64 0zM480 192l64 0 0 64-64 0 0-64zm-8-32c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faSatellite = {
    prefix: 'fal',
    iconName: 'satellite',
    icon: [
      512,
      512,
      [128752],
      'f7bf',
      
      'M224 35.3l62.3 62.3L185.7 198.3 123.3 136 224 35.3zM309 75L241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l47.6 47.6c-45.3-3.8-92 10.2-128.7 42.3c-3.8 3.3-5.9 8-5.9 13l0 .5c0 4.9 1.9 9.6 5.4 13L116.7 372.7l-16 16c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l16-16L242.6 498.6c3.5 3.5 8.1 5.4 13 5.4l.5 0c5 0 9.8-2.2 13-5.9c32.1-36.7 46.1-83.3 42.3-128.7L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75zM414.3 225.7L476.7 288 376 388.7l-62.3-62.3L414.3 225.7zm26.1-71.3L292 302.8c-7.9-14.9-18.1-28.9-30.7-41.5l-10.6-10.6c-12.5-12.5-26.5-22.8-41.5-30.7L357.7 71.6c4.9-4.9 11.5-7.6 18.3-7.6s13.5 2.7 18.3 7.6l46.1 46.1c4.9 4.9 7.6 11.5 7.6 18.3s-2.7 13.5-7.6 18.3zM238.7 283.9c49 49 54.8 125.7 15.7 181.2L46.8 257.6c55.5-39.1 132.2-33.3 181.2 15.7l10.6 10.6zM80 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faChessClockFlip = {
    prefix: 'fal',
    iconName: 'chess-clock-flip',
    icon: [
      640,
      512,
      ["chess-clock-alt"],
      'f43e',
      
      'M400 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64L64 128c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0-64 0zM96 80c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16zm480 80c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l512 0zM464 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM119.4 247.4A80 80 0 1 1 232.6 360.6 80 80 0 1 1 119.4 247.4zM255.2 383.2A112 112 0 1 0 96.8 224.8 112 112 0 1 0 255.2 383.2zM464 240c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16zM221.3 281.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9z'
      
    ]
  };

  
    var faChessClockAlt = faChessClockFlip;
  

  
  

  var faFilePlusMinus = {
    prefix: 'fal',
    iconName: 'file-plus-minus',
    icon: [
      384,
      512,
      [],
      'e177',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48zM128 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faUserVisor = {
    prefix: 'fal',
    iconName: 'user-visor',
    icon: [
      448,
      512,
      [],
      'e04c',
      
      'M224 224c41.8 0 77.4-26.7 90.5-64l-181.1 0c13.2 37.3 48.7 64 90.5 64zm0 32c-60.6 0-111.3-42.1-124.6-98.6C88 152.5 80 141.2 80 128l0-32c0-17.7 14.3-32 32-32l1.1 0C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64l1.1 0c17.7 0 32 14.3 32 32l0 32c0 13.2-8 24.5-19.4 29.4C335.3 213.9 284.6 256 224 256zM152.4 64l143.1 0C278 44.4 252.4 32 224 32s-54 12.4-71.6 32zm25.8 272c-80 0-145 64.3-146.3 144l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM336 96L112 96l0 32 224 0 0-32zm-7.1 341.4c-9.5 0-22.5 11.4-31.7 19.5c-2.6 2.2-4.8 4.2-6.6 5.6c-2.8 2-6.8 .1-6.5-3.5c3.9-36.5 15.9-66.5 35.7-89.5c1.5-1.8 4.9-1.9 6.1 .1c18.9 24.6 29 55 30.1 90.2c0 3.9-4.9 5.7-7.3 2.5c-12.2-17.3-17.6-23-19.9-25z'
      
    ]
  };

  

  
  

  var faLiraSign = {
    prefix: 'fal',
    iconName: 'lira-sign',
    icon: [
      320,
      512,
      [8356],
      'f195',
      
      'M80 152c0-48.6 39.4-88 88-88l7.1 0c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2L168 32C101.7 32 48 85.7 48 152l0 72-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 22.1c0 14-.8 28-2.4 41.9L16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l24.5 0c-7.3 35.6-19.9 70.1-37.4 102.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L42.1 448c14.4-30.6 24.8-62.9 31-96L240 352c8.8 0 16-7.2 16-16s-7.2-16-16-16L77.8 320c1.5-13.9 2.2-27.9 2.2-41.9L80 256l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224l0-72z'
      
    ]
  };

  

  
  

  var faChild = {
    prefix: 'fal',
    iconName: 'child',
    icon: [
      320,
      512,
      [],
      'f1ae',
      
      'M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM73.9 240.2c1.9-3.1 3.9-6 6.1-8.9L80 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 96 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-264.7c2.2 2.8 4.2 5.8 6.1 8.9l44.3 72.2c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-44.3-72.2C249.2 184 206.3 160 160 160s-89.2 24-113.4 63.5L2.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3l44.3-72.2zM208 352l-96 0 0-147.9c14.5-7.8 31-12.1 48-12.1s33.5 4.3 48 12.1L208 352z'
      
    ]
  };

  

  
  

  var faWashingMachine = {
    prefix: 'fal',
    iconName: 'washing-machine',
    icon: [
      448,
      512,
      ["washer"],
      'f898',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM325.7 351c-7 .7-14.3 1-21.7 1c-41.8 0-72.9-20.8-95.7-36l-2.1-1.4c-25-16.7-41.3-26.6-62.2-26.6c-9.8 0-20.6 1.6-31.4 4c-.4 3.9-.6 7.9-.6 12c0 61.9 50.1 112 112 112c45.1 0 84-26.6 101.7-65zm9.5-33.4c.5-4.4 .8-8.9 .8-13.5c0-61.9-50.1-112-112-112c-45.3 0-84.4 27-102 65.7c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304z'
      
    ]
  };

  
    var faWasher = faWashingMachine;
  

  
  

  var faBookSparkles = {
    prefix: 'fal',
    iconName: 'book-sparkles',
    icon: [
      448,
      512,
      ["book-spells"],
      'f6b8',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l368 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-320c0-26.5-21.5-48-48-48L64 0zM384 416l0 64L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l336 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 384zM265.9 170.9l-16.5 38.6-38.6 16.5c-19.4 8.3-19.4 35.8 0 44.1l38.6 16.5 16.5 38.6c8.3 19.4 35.8 19.4 44.1 0l16.5-38.6 38.6-16.5c19.4-8.3 19.4-35.8 0-44.1l-38.6-16.5-16.5-38.6c-8.3-19.4-35.8-19.4-44.1 0zM288 200.6l11.7 27.3c1.6 3.8 4.6 6.8 8.4 8.4L335.4 248l-27.3 11.7c-3.8 1.6-6.8 4.6-8.4 8.4L288 295.4l-11.7-27.3c-1.6-3.8-4.6-6.8-8.4-8.4L240.6 248l27.3-11.7c3.8-1.6 6.8-4.6 8.4-8.4L288 200.6zM153 121.8l7-14 7 14c1.5 3.1 4.1 5.6 7.2 7.2l14 7-14 7c-3.1 1.5-5.6 4.1-7.2 7.2l-7 14-7-14c-1.5-3.1-4.1-5.6-7.2-7.2l-14-7 14-7c3.1-1.5 5.6-4.1 7.2-7.2zm28.5-42.7c-8.8-17.7-34.1-17.7-42.9 0l-11.8 23.6-23.6 11.8c-17.7 8.8-17.7 34.1 0 42.9l23.6 11.8 11.8 23.6c8.8 17.7 34.1 17.7 42.9 0l11.8-23.6 23.6-11.8c17.7-8.8 17.7-34.1 0-42.9l-23.6-11.8L181.5 79.2z'
      
    ]
  };

  
    var faBookSpells = faBookSparkles;
  

  
  

  var faSquareArrowDownRight = {
    prefix: 'fal',
    iconName: 'square-arrow-down-right',
    icon: [
      448,
      512,
      [],
      'e262',
      
      'M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM168 352c-8.8 0-16-7.2-16-16s7.2-16 16-16l97.4 0L132.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 297.4 288 192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144c0 8.8-7.2 16-16 16l-136 0z'
      
    ]
  };

  

  
  

  var faFilmSlash = {
    prefix: 'fal',
    iconName: 'film-slash',
    icon: [
      640,
      512,
      [],
      'e179',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480L448 438.6l0 9.4-256 0 0-96 0-96 0-16-32 0-64 0 0-64 0-15.3L64 135.4 64 416c0 35.3 28.7 64 64 64l372.4 0zM139.6 32L192 73.4l0-9.4 256 0 0 96 0 96 0 16 32 0 64 0 0 64 0 15.3 32 25.3L576 96c0-35.3-28.7-64-64-64L139.6 32zM160 448l-32 0c-17.7 0-32-14.3-32-32l0-48 64 0 0 80zM96 272l64 0 0 64-64 0 0-64zm384-96l64 0 0 64-64 0 0-64zm0-32l0-80 32 0c17.7 0 32 14.3 32 32l0 48-64 0z'
      
    ]
  };

  

  
  

  var faBusSchool = {
    prefix: 'fal',
    iconName: 'bus-school',
    icon: [
      512,
      512,
      [],
      'f5dd',
      
      'M256 32c105.1 0 146.3 31.1 158.8 47c.4 .6 1.2 2.1 1.2 5.3l0 43.7L96 128l0-43.7c0-3.3 .8-4.5 1-4.8C110.9 63.2 158.3 32 256 32zM96 245.5L96 160l144 0 0 80-112 0c-11.2 0-22 1.9-32 5.5zM272 240l0-80 144 0 0 85.5c-10-3.5-20.8-5.5-32-5.5l-112 0zm176 24.4l0-180.2c0-7.7-1.8-17.1-8.1-25.1C419.2 32.9 366.9 0 256 0C152.4 0 94.5 33 72.6 58.8C65.8 66.9 64 76.6 64 84.3l0 180.2C44.4 282 32 307.6 32 336l0 56c0 22.3 13.1 41.6 32 50.6L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 320 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-53.4c18.9-9 32-28.3 32-50.6l0-56c0-28.4-12.4-54-32-71.6zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 336c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 56c0 13.3-10.7 24-24 24L88 416c-13.3 0-24-10.7-24-24l0-56zM192 80c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm480 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  

  
  

  var faClipboardUser = {
    prefix: 'fal',
    iconName: 'clipboard-user',
    icon: [
      384,
      512,
      [],
      'f7f3',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM192 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64l64 0c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faFaceFearful = {
    prefix: 'fal',
    iconName: 'face-fearful',
    icon: [
      512,
      512,
      [],
      'e375',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48l8.4 0c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2l-151.6 0c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32l-8.4 0c-29 0-53.2 20.6-58.6 48l125.7 0c-5.5-27.4-29.6-48-58.6-48zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  

  
  

  var faLocationExclamation = {
    prefix: 'fal',
    iconName: 'location-exclamation',
    icon: [
      384,
      512,
      ["map-marker-exclamation"],
      'f608',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM168 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faMapMarkerExclamation = faLocationExclamation;
  

  
  

  var faTableRows = {
    prefix: 'fal',
    iconName: 'table-rows',
    icon: [
      512,
      512,
      ["rows"],
      'e292',
      
      'M32 96c0-17.7 14.3-32 32-32l64 0 0 176 0 32 0 176-64 0c-17.7 0-32-14.3-32-32L32 96zM160 272l320 0 0 144c0 17.7-14.3 32-32 32l-288 0 0-176zm320-32l-320 0 0-176 288 0c17.7 0 32 14.3 32 32l0 144zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z'
      
    ]
  };

  
    var faRows = faTableRows;
  

  
  

  var faHatCowboySide = {
    prefix: 'fal',
    iconName: 'hat-cowboy-side',
    icon: [
      640,
      512,
      [],
      'f8c1',
      
      'M416.6 64.2L195.1 107c-7.1 1.4-12.4 7.3-12.9 14.6l-5 70.6c36.3 1.7 71.2 15.2 99.4 38.4L307.5 256l155.3 0L428.2 72.1c-.9-4.7-5-8.1-9.8-8.1c-.6 0-1.3 .1-1.9 .2zM145 193.7l5.3-74.4c1.5-21.7 17.4-39.6 38.8-43.7L410.5 32.8c2.6-.5 5.3-.8 8-.8c20.2 0 37.5 14.4 41.2 34.2l25 133.5c3.4 1.6 7.2 3.4 11.4 5.5c15.5 7.7 36.2 19.1 57 33.7c20.7 14.5 42.2 32.6 58.5 53.9C628.1 314 640 339.4 640 368c0 44.2-35.8 80-80 80l-47.7 0c-.2 0-.4 0-.6 0L496 448l-32 0L60.8 448C27.2 448 0 420.8 0 387.2l0-26.1c0-85.2 63-155.7 145-167.4zM525.3 416l34.7 0c26.5 0 48-21.5 48-48c0-19.4-8.1-38-21.7-55.7c-13.7-17.7-32.2-33.7-51.5-47.1c-14.9-10.5-29.9-19.2-42.7-26L525.3 416zm-34.2-8.8L468.7 288l-122.4 0L491.1 407.2zM32 361.1l0 26.1C32 403.1 44.9 416 60.8 416l390.6 0L256.2 255.3c-24.5-20.2-55.3-31.3-87.1-31.3C93.4 224 32 285.4 32 361.1z'
      
    ]
  };

  

  
  

  var faDiscDrive = {
    prefix: 'fal',
    iconName: 'disc-drive',
    icon: [
      512,
      512,
      [],
      'f8b5',
      
      'M96 64l320 0c17.7 0 32 14.3 32 32l0 352L64 448 64 96c0-17.7 14.3-32 32-32zM480 448l0-352c0-35.3-28.7-64-64-64L96 32C60.7 32 32 60.7 32 96l0 352-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 416 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zM256 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faPhoneVolume = {
    prefix: 'fal',
    iconName: 'phone-volume',
    icon: [
      512,
      512,
      ["volume-control-phone"],
      'f2a0',
      
      'M272 0C404.5 0 512 107.5 512 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-80c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16zm73 174.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z'
      
    ]
  };

  
    var faVolumeControlPhone = faPhoneVolume;
  

  
  

  var faSealQuestion = {
    prefix: 'fal',
    iconName: 'seal-question',
    icon: [
      512,
      512,
      [],
      'e243',
      
      'M86.6 198.6c6-6 9.4-14.1 9.4-22.6l0-64c0-8.8 7.2-16 16-16l64 0c8.5 0 16.6-3.4 22.6-9.4l52.7-52.7c1.2-1.2 2.9-1.9 4.7-1.9s3.4 .7 4.7 1.9l52.7 52.7c6 6 14.1 9.4 22.6 9.4l64 0c8.8 0 16 7.2 16 16l0 64c0 8.5 3.4 16.6 9.4 22.6l52.7 52.7c1.2 1.2 1.9 2.9 1.9 4.7s-.7 3.4-1.9 4.7l-52.7 52.7c-6 6-9.4 14.1-9.4 22.6l0 64c0 8.8-7.2 16-16 16l-64 0c-8.5 0-16.6 3.4-22.6 9.4l-52.7 52.7c-1.2 1.2-2.9 1.9-4.7 1.9s-3.4-.7-4.7-1.9l-52.7-52.7c-6-6-14.1-9.4-22.6-9.4l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.5-3.4-16.6-9.4-22.6L33.9 260.7c-1.2-1.2-1.9-2.9-1.9-4.7s.7-3.4 1.9-4.7l52.7-52.7zM64 112l0 64L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3L64 336l0 64c0 26.5 21.5 48 48 48l64 0 52.7 52.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L336 448l64 0c26.5 0 48-21.5 48-48l0-64 52.7-52.7c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L283.3 11.3C276.1 4.1 266.2 0 256 0s-20.1 4.1-27.3 11.3L176 64l-64 0c-26.5 0-48 21.5-48 48zm104.7 57.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9l57.1 0c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3l0 29.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-19.7 37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3l-57.1 0c-25.5 0-47.7 17.2-54.2 41.8zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fal',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M32 256c0 123.7 100.3 224 224 224c31.4 0 61.4-6.5 88.5-18.2c4.2 8.8 9.9 17.1 17.3 24.4c.7 .7 1.4 1.4 2.1 2C331.1 503.5 294.5 512 256 512C114.6 512 0 397.4 0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56c10.9 0 21.1 3.1 29.7 8.5c3.5 2.2 6.8 4.8 9.7 7.7c0 0 0 0 0 0l.2 .2L139 64.9c-2.8-6.1-6.6-11.7-11.3-16.4c0 0 0 0 0 0c4.9 4.9 8.6 10.5 11.3 16.4c0 0 0 0 0 0c3.2 7 5 14.8 5 23.1c0 30.9-25.1 56-56 56c-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256zM394.3 471.5s0 0 0 0c-3.5-2.2-6.8-4.8-9.9-7.9l-.1-.1c-4.9-4.9-8.6-10.5-11.3-16.4c0 0 0 0 0 0c-3.2-7-5-14.9-5-23.1c0-30.9 25.1-56 56-56c8.2 0 16 1.8 23.1 5c20.9-34 32.9-74.1 32.9-117C480 132.3 379.7 32 256 32c-31.4 0-61.4 6.5-88.5 18.2c-4.2-8.8-10-17.1-17.3-24.4c-.7-.7-1.4-1.4-2.1-2C180.9 8.5 217.5 0 256 0C397.4 0 512 114.6 512 256c0 50.9-14.9 98.4-40.5 138.3c5.4 8.6 8.5 18.8 8.5 29.7c0 30.9-25.1 56-56 56c-10.9 0-21.1-3.1-29.7-8.5zM112 88A24 24 0 1 0 64 88a24 24 0 1 0 48 0zM365.5 189.7c-4.2 1.5-8.8 2.3-13.5 2.3c-22.1 0-40-17.9-40-40c0-3.6 .5-7.1 1.4-10.4C296.1 132.9 276.6 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-24.3-6.8-47-18.5-66.3zM389 167.1c17 25.4 27 56 27 88.9c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c28.3 0 54.9 7.4 78 20.3c5.4-2.7 11.5-4.3 18-4.3c22.1 0 40 17.9 40 40c0 5.3-1 10.4-3 15.1zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM424 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBookTanakh = {
    prefix: 'fal',
    iconName: 'book-tanakh',
    icon: [
      448,
      512,
      ["tanakh"],
      'f827',
      
      'M384 0c35.3 0 64 28.7 64 64l0 384s0 0 0 0c0 35.3-28.7 64-64 64L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-66.7C13.4 406.7 0 388.9 0 368L0 48C0 21.5 21.5 0 48 0L384 0zM64 416l0 64 320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32L48 32c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l336 0zM146.7 232l-13.9 24 27.7 0-13.9-24zm-13.9-24l-27.7-48c-6.2-10.7 1.5-24 13.9-24l55.4 0 27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48 55.4 0c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24l-55.4 0-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48L119 280c-12.3 0-20-13.3-13.9-24l27.7-48zm27.7 0l27.7 48 55.4 0 27.7-48-27.7-48-55.4 0-27.7 48zm0-48l-27.7 0 13.9 24 13.9-24zm41.6-24l27.7 0L216 112l-13.9 24zm69.3 24l13.9 24 13.9-24-27.7 0zm13.9 72l-13.9 24 27.7 0-13.9-24zm-55.4 48l-27.7 0L216 304l13.9-24z'
      
    ]
  };

  
    var faTanakh = faBookTanakh;
  

  
  

  var faTableCellsLarge = {
    prefix: 'fal',
    iconName: 'table-cells-large',
    icon: [
      512,
      512,
      ["th-large"],
      'f009',
      
      'M272 64l0 176 208 0 0-144c0-17.7-14.3-32-32-32L272 64zm-32 0L64 64C46.3 64 32 78.3 32 96l0 144 208 0 0-176zM32 272l0 144c0 17.7 14.3 32 32 32l176 0 0-176L32 272zM272 448l176 0c17.7 0 32-14.3 32-32l0-144-208 0 0 176zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faThLarge = faTableCellsLarge;
  

  
  

  var faCloudDrizzle = {
    prefix: 'fal',
    iconName: 'cloud-drizzle',
    icon: [
      512,
      512,
      [],
      'f738',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM64 376c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40zM160 448c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48z'
      
    ]
  };

  

  
  

  var faPeoplePantsSimple = {
    prefix: 'fal',
    iconName: 'people-pants-simple',
    icon: [
      512,
      512,
      [],
      'e21a',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320l84.9 0c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L192 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-6.2 172l-4.1 49.3C308.1 304 322.8 320 341.6 320l84.9 0c18.7 0 33.4-16 31.9-34.7L454.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0c-25 0-45.8 19.1-47.8 44zm-31.9-2.7c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L448 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z'
      
    ]
  };

  

  
  

  var faFlowerTulip = {
    prefix: 'fal',
    iconName: 'flower-tulip',
    icon: [
      512,
      512,
      [127799],
      'f801',
      
      'M268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4L189.5 66.7 121.2 18.9c-4.9-3.4-11.3-3.8-16.6-1.1S96 26 96 32l0 128c0 70.7 57.3 128 128 128l16 0 0 108.6C200.8 331.5 129.5 288 48 288l-20 0c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512l44 0 16 0 16 0 44 0c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28l-20 0c-81.5 0-152.8 43.5-192 108.6L272 288l16 0c70.7 0 128-57.3 128-128l0-128c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L322.5 66.7 268 5.4zM256 256l-32 0c-53 0-96-43-96-96l0-97.3 54.8 38.4c6.7 4.7 15.7 3.6 21.1-2.5l52-58.5 52 58.5c5.4 6.1 14.5 7.1 21.1 2.5L384 62.7l0 97.3c0 53-43 96-96 96l-32 0zM196 480c-89.2 0-161.8-71.3-164-160l16 0c95.1 0 174.1 69.2 189.3 160L196 480zm120 0l-41.3 0c15.2-90.8 94.2-160 189.3-160l16 0c-2.1 88.7-74.7 160-164 160z'
      
    ]
  };

  

  
  

  var faBusinessTime = {
    prefix: 'fal',
    iconName: 'business-time',
    icon: [
      640,
      512,
      ["briefcase-clock"],
      'f64a',
      
      'M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 32.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7l0-32.7c0-17.7-14.3-32-32-32l-80 0-224 0-80 0c-17.7 0-32 14.3-32 32l0 96 144 0 32 0 144 0 8.2 0c-8.1 9.8-15.2 20.6-21 32L208 288l0 48 114.9 0c-1.9 10.4-2.9 21.1-2.9 32l-112 0c-17.7 0-32-14.3-32-32l0-48L32 288l0 128c0 17.7 14.3 32 32 32l275.2 0c5.9 11.4 12.9 22.2 21 32L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faBriefcaseClock = faBusinessTime;
  

  
  

  var faCommentDollar = {
    prefix: 'fal',
    iconName: 'comment-dollar',
    icon: [
      512,
      512,
      [],
      'f651',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 104c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0s0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z'
      
    ]
  };

  

  
  

  var faPersonDress = {
    prefix: 'fal',
    iconName: 'person-dress',
    icon: [
      320,
      512,
      ["female"],
      'f182',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM119.2 241.7c7.9 4 11.1 13.6 7.2 21.5L73.9 368l38.1 0 96 0 38.1 0L193.7 263.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6l-48 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-64 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-48 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM99 196.6L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9C88.3 148.6 122.7 128 160 128s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L221 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6z'
      
    ]
  };

  
    var faFemale = faPersonDress;
  

  
  

  var faDreidel = {
    prefix: 'fal',
    iconName: 'dreidel',
    icon: [
      448,
      512,
      [],
      'f792',
      
      'M443.3 36.7c6.2 6.2 6.2 16.4 0 22.6L321.9 180.7l73.4 73.4c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7L64 480c-35.3 0-64-28.7-64-64L0 269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l73.4 73.4L420.7 36.7c6.2-6.2 16.4-6.2 22.6 0zm-240 70.6c-6.2-6.2-16.4-6.2-22.6 0l-57.4 57.4 192 192 57.4-57.4c6.2-6.2 6.2-16.4 0-22.6L203.3 107.3zm89.4 272l-192-192L41.4 246.6c-6 6-9.4 14.1-9.4 22.6L32 416c0 17.7 14.3 32 32 32l146.7 0c8.5 0 16.6-3.4 22.6-9.4l59.3-59.3z'
      
    ]
  };

  

  
  

  var faOtter = {
    prefix: 'fal',
    iconName: 'otter',
    icon: [
      640,
      512,
      [129446],
      'f700',
      
      'M145.7 211.4l-12.9 6.4c-8.1 4.1-17.1 6.2-26.2 6.2C74.2 224 48 197.8 48 165.4L48 144c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80l0 21.4c0 32.4-26.2 58.6-58.6 58.6c-9.1 0-18.1-2.1-26.2-6.2l-12.9-6.4c-9-4.5-19.6-4.5-28.6 0zM16 144l0 21.4c0 19.1 5.9 36.8 16 51.4L32 240l0 16.6C32 380 132 480 255.4 480l159.5 0C539.2 480 640 379.2 640 254.9c0-90.7-64-168.8-153-186.6l-19.9-4c-8.3-1.7-16.4 3.4-18.6 11.6s2.4 16.6 10.4 19.3l21.6 7.2c37.9 12.6 63.4 48.1 63.4 88c0 16.4-6 31.4-16 42.9l0-41.3c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 0 0 0 0 0l-72.1 0 .1 0 8 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-8 0c-20.9 0-40.4 6.2-56.7 16.8c.5-3.7 .7-7.6 .7-11.4l0-21.4c0-5.4-.4-10.8-1.1-16l1.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-10.8 0c-18-37.8-56.5-64-101.2-64l-64 0C83.3 32 44.8 58.2 26.8 96L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l1.1 0c-.7 5.2-1.1 10.6-1.1 16zm96 144c-24.6 0-44.9-18.6-47.7-42.5c12.6 6.7 27 10.5 42.3 10.5c14.1 0 27.9-3.3 40.5-9.6L160 240l12.9 6.4c12.6 6.3 26.5 9.6 40.5 9.6c16.7 0 32.3-4.5 45.7-12.3c8.3 25.7 32.4 44.3 60.9 44.3l56.4 0c-15.2 17-24.4 39.4-24.4 64l-82.7 0c1.8-5 2.7-10.4 2.7-16c0-26.5-21.5-48-48-48l-112 0zm207.8-32c-11.8-.1-22.2-6.6-27.6-16.2c9.9-27.9 36.6-47.8 67.8-47.8l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0c-19.4 0-35.5 13.7-39.2 32l-1 0zM528 333.7l0-59.3c28.7-17 48-48.3 48-84.1c0-13.3-2.1-26.3-6.1-38.5c23.9 27.9 38.1 64 38.1 103C608 361.5 521.5 448 414.9 448l-159.5 0c-87.6 0-161.4-58.9-184.2-139.2C83.1 315.9 97.1 320 112 320l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0 144 0c8.8 0 16-7.2 16-16l0-16c0-35.3 28.5-63.9 63.7-64l.3 0s0 0 0 0c8.8 0 16-7.2 16-16l0-16c0-20.9 13.4-38.7 32-45.3l0 123c0 16.1-8 31-21.4 39.9l-19.5 13c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l19.5-13c22.3-14.8 35.6-39.8 35.6-66.6zM112 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-72-16c-13.3 0-24 10.7-24 24l0 8c0 6.1 3.4 11.6 8.8 14.3l16 8c4.5 2.3 9.8 2.3 14.3 0l16-8c5.4-2.7 8.8-8.3 8.8-14.3l0-8c0-13.3-10.7-24-24-24l-16 0z'
      
    ]
  };

  

  
  

  var faUserSecret = {
    prefix: 'fal',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      'M169.1 37.7c-5.8 6.6-12 17.3-18.1 31.9c-6.1 14.5-11.3 31-15.5 47.2c24.4 6.4 54 11.2 88.6 11.2c33.4 0 63.3-5.2 88.3-12.1c-4.2-15.9-9.3-32-15.3-46.3c-6.1-14.6-12.4-25.3-18.1-31.9c-4-4.6-6.3-5.6-7-5.7c-4.8 0-7.3 .6-8.5 1c-1 .3-1.9 .8-3.6 1.8c-.1 .1-.4 .3-.7 .5C255.7 37.9 242.2 48 224 48s-31.7-10.1-35.1-12.7c0 0 0 0 0 0c-.3-.3-.6-.4-.7-.5c-1.6-1.1-2.5-1.5-3.6-1.8c-1.1-.4-3.6-1-8.5-1c-.6 .2-3 1.2-7 5.7zM272 0c34.2 0 57 54.9 70.8 106c.8-.3 1.6-.6 2.4-.9c14.8-5.7 26.5-11.4 34.3-15.7c3.9-2.1 6.9-3.9 8.9-5c1-.6 1.7-1 2.2-1.3l.5-.3c2.6-1.7 5.6-2.7 9-2.7c8.8 0 16 7.2 16 16c0 5.7-3 10.7-7.4 13.5c0 0 0 0 0 0l-.8 .5c-.7 .4-1.6 1-2.8 1.7c-2.4 1.4-5.8 3.5-10.3 5.8c-8.9 4.8-21.7 11.1-37.9 17.3C324.4 147.4 278.4 160 224 160c-58.3 0-104.3-12.5-135.9-25.1c-15.8-6.3-28-12.7-36.3-17.5c-4.2-2.4-7.4-4.5-9.6-6c-1.1-.7-2-1.3-2.6-1.8l-.7-.5-.1-.1c-4-2.9-6.7-7.6-6.7-13c0-8.8 7.2-16 16-16c3.6 0 6.9 1.2 9.6 3.2l.4 .3c.4 .3 1 .7 1.8 1.3c1.7 1.1 4.4 2.8 7.9 4.9c7.2 4.2 18 9.8 32.2 15.5c1.6 .6 3.3 1.3 5 1.9C118.7 55.7 141.5 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0zm-.3 32s.1 0 .2 0c-.1 0-.2 0-.2 0zm-95.6 0c.1 0 .2 0 .2 0s-.1 0-.2 0zM100 224c-2.6-10.2-4-21-4-32c0-6.7 .5-13.3 1.5-19.7c9.6 3.1 19.9 6.1 31.1 8.8c-.4 3.6-.6 7.2-.6 10.9c0 53 43 96 96 96s96-43 96-96c0-4-.2-7.9-.7-11.7c11.1-2.8 21.5-5.8 31-9c1.1 6.8 1.7 13.7 1.7 20.8c0 11-1.4 21.8-4 32l71.2 0c7.1 0 12.8 5.7 12.8 12.8c0 2.1-.5 4.1-1.5 6l-45.7 86.8C423.6 364.8 448 415.5 448 472l0 8c0 17.7-14.3 32-32 32l-143.6 0c-.2 0-.5 0-.7 0l-95.3 0c-.2 0-.5 0-.7 0L32 512c-17.7 0-32-14.3-32-32l0-8c0-56.5 24.4-107.2 63.2-142.4L17.5 242.8c-1-1.8-1.5-3.9-1.5-6c0-7.1 5.7-12.8 12.8-12.8l71.2 0zm234.8 32c-22.1 38.3-63.5 64-110.9 64s-88.7-25.7-110.9-64l-52.5 0 30.9 58.7c6.8 12.9 4 28.8-6.8 38.6C52.3 382.7 32 424.9 32 472l0 8 122.8 0-26.2-91.6c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l20.3 70.9L201.8 384l-9.8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-9.8 0 22.2 66.5 20.3-70.9c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8L293.2 480 416 480l0-8c0-47.1-20.3-89.3-52.7-118.6c-10.8-9.8-13.6-25.7-6.8-38.6L387.4 256l-52.5 0zM244.5 480L224 418.6 203.5 480l40.9 0zM144 184.4c10.1 2 20.8 3.6 32 4.9l0 8.7c0 7 5.7 12.7 12.7 12.7c5.5 0 10.3-3.5 12-8.7l3.5-10.5c6.5 .3 13.1 .5 19.8 .5c6.7 0 13.3-.2 19.8-.5l3.5 10.5c1.7 5.2 6.6 8.7 12 8.7c7 0 12.7-5.7 12.7-12.7l0-9c11.2-1.4 21.8-3.2 32-5.3l0 14.3c0 24.7-20 44.7-44.7 44.7c-14.1 0-27-6.6-35.3-17.3c-8.3 10.7-21.2 17.3-35.3 17.3c-24.7 0-44.7-20-44.7-44.7l0-13.6z'
      
    ]
  };

  

  
  

  var faRv = {
    prefix: 'fal',
    iconName: 'rv',
    icon: [
      640,
      512,
      [],
      'f7be',
      
      'M224 24c0-13.3 10.7-24 24-24L360 0c13.3 0 24 10.7 24 24l0 8 112 0c61.9 0 112 50.1 112 112l0 8c0 22.1-17.9 40-40 40l-18.4 0L628 254.7c7.6 6.1 12 15.3 12 25L640 384c0 17.7-14.3 32-32 32l-33.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16L400 416l-145.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L18.7 329.4C6.7 317.4 0 301.1 0 284.1L0 96C0 60.7 28.7 32 64 32l160 0 0-8zM64 64C46.3 64 32 78.3 32 96l0 188.1c0 8.5 3.4 16.6 9.4 22.6l73.6 73.6C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32l144 0 0-208c0-8.8 7.2-16 16-16l168 0c4.4 0 8-3.6 8-8l0-8c0-44.2-35.8-80-80-80L384 64l-32 0 0-32-96 0 0 32-32 0L64 64zM176 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-64 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l48 0 0-96-192 0 0 96 16 0zM416 192l0 64 162.4 0-80-64L416 192zM128 224l160 0 0-64-160 0 0 64zM96 152c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24l0-80z'
      
    ]
  };

  

  
  

  var faClockElevenThirty = {
    prefix: 'fal',
    iconName: 'clock-eleven-thirty',
    icon: [
      512,
      512,
      [],
      'e348',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400l0-139.2-61.3-92c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4l64 96c1.8 2.6 2.7 5.7 2.7 8.9l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faExpandWide = {
    prefix: 'fal',
    iconName: 'expand-wide',
    icon: [
      512,
      512,
      [],
      'f320',
      
      'M144 64c8.8 0 16 7.2 16 16s-7.2 16-16 16L32 96l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 80c0-8.8 7.2-16 16-16l128 0zM0 304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 448c-8.8 0-16-7.2-16-16L0 304zM496 64c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112L368 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0zM480 304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-112z'
      
    ]
  };

  

  
  

  var faBriefcaseArrowRight = {
    prefix: 'fal',
    iconName: 'briefcase-arrow-right',
    icon: [
      512,
      512,
      [],
      'e2f2',
      
      'M176 32l160 0c8.8 0 16 7.2 16 16l0 48L160 96l0-48c0-8.8 7.2-16 16-16zM128 48l0 48L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-48c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zm16 80l224 0 80 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l80 0zm155.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 272 144 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l185.4 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z'
      
    ]
  };

  

  
  

  var faSuitcaseMedical = {
    prefix: 'fal',
    iconName: 'suitcase-medical',
    icon: [
      512,
      512,
      ["medkit"],
      'f0fa',
      
      'M176 32l160 0c8.8 0 16 7.2 16 16l0 48L160 96l0-48c0-8.8 7.2-16 16-16zM128 48l0 48L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-48c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zm256 80l0 320-256 0 0-320 16 0 224 0 16 0zM96 128l0 320-32 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l32 0zM416 448l0-320 32 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-32 0zM240 176c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  
    var faMedkit = faSuitcaseMedical;
  

  
  

  var faO = {
    prefix: 'fal',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      'M224 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z'
      
    ]
  };

  

  
  

  var faBookBible = {
    prefix: 'fal',
    iconName: 'book-bible',
    icon: [
      448,
      512,
      ["bible"],
      'f647',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM224 72l32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 80c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-80-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32zm0 32l0 48c0 8.8-7.2 16-16 16l-48 0 0 32 48 0c8.8 0 16 7.2 16 16l0 96 32 0 0-96c0-8.8 7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16l0-48-32 0z'
      
    ]
  };

  
    var faBible = faBookBible;
  

  
  

  var faMessagesQuestion = {
    prefix: 'fal',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      'M202.7 288L352 288c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 16 55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320l-149.3 0-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-16 0-32-32 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64l0-32 32 0 0 32c0 17.7 14.3 32 32 32l117.3 0c6.9 0 13.7 2.2 19.2 6.4L512 464l0-16c0-17.7 14.3-32 32-32l32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-128 0 0-32 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 32 0 16c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448zM184.3 70.3c-16.4 0-31 10.3-36.4 25.7l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4l41.3 0c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9l0 9.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-.3L247.4 152c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7l-41.3 0zM208 250.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3z'
      
    ]
  };

  

  
  

  var faGamepadModern = {
    prefix: 'fal',
    iconName: 'gamepad-modern',
    icon: [
      640,
      512,
      [63676,127918,"gamepad-alt"],
      'e5a2',
      
      'M216 352l208 0c14.7 0 27.5 10 31 24.2l3.6 14.3c8.4 33.8 38.8 57.4 73.6 57.4c41.9 0 75.8-33.9 75.8-75.8l0-2.8c0-4.5-.4-8.9-1.1-13.3L574.1 165.3c-7-40.7-32.2-71.3-66.5-79.9C464.1 74.5 401.1 64 320 64s-144.1 10.5-187.6 21.4C98 93.9 72.8 124.5 65.9 165.3L33.1 356.1c-.8 4.4-1.1 8.8-1.1 13.3l0 2.8c0 41.9 33.9 75.8 75.8 75.8c34.8 0 65.1-23.7 73.6-57.4l3.6-14.3c3.6-14.2 16.4-24.2 31-24.2zm211.6 46.3L424 384l-208 0-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2l0-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7l0 2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM208 160l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGamepadAlt = faGamepadModern;
  

  
  

  var faCurlingStone = {
    prefix: 'fal',
    iconName: 'curling-stone',
    icon: [
      576,
      512,
      [129356,"curling"],
      'f44a',
      
      'M192 112c0-26.5 21.5-48 48-48l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L240 32c-44.2 0-80 35.8-80 80l0 48c-35.3 0-64 28.7-64 64l0 1.1C41.7 232.9 0 279.6 0 336l0 32c0 61.9 50.1 112 112 112l352 0c61.9 0 112-50.1 112-112l0-32c0-56.4-41.7-103.1-96-110.9l0-1.1c0-35.3-28.7-64-64-64l-224 0 0-48zM448 224l-320 0c0-17.7 14.3-32 32-32l16 0 240 0c17.7 0 32 14.3 32 32zM112 448c-44.2 0-80-35.8-80-80l512 0c0 44.2-35.8 80-80 80l-352 0zM32 336c0-44.2 35.8-80 80-80l352 0c44.2 0 80 35.8 80 80L32 336z'
      
    ]
  };

  
    var faCurling = faCurlingStone;
  

  
  

  var faTankWater = {
    prefix: 'fal',
    iconName: 'tank-water',
    icon: [
      448,
      512,
      [],
      'e452',
      
      'M269.6 64L384 64c17.7 0 32 14.3 32 32l0 256c-20.9 0-41.7-10-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9c-10.2-9.5-25.9-9.5-36.1 0c-6.1 5.6-12.5 11-19.8 15.9C265.6 342.1 244.9 352 224 352s-41.7-9.9-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9c-10.2-9.5-25.9-9.5-36.1 0c-6.1 5.6-12.5 11-19.8 15.9C73.6 342.1 52.9 352 32 352L32 96c0-17.7 14.3-32 32-32l114.4 0 6.1-10 13.6-22L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L249.9 32l13.6 22 6.1 10zM32 384c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C166.4 369.9 193.7 384 224 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C358.5 369.9 385.7 384 416 384l0 32c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-32zM236.4 70.7C233.7 66.5 229 64 224 64s-9.7 2.5-12.4 6.7l-47.2 70.8c-8.1 12.1-12.4 26.3-12.4 40.9l0 1.7c0 39.8 32.2 72 72 72s72-32.2 72-72l0-1.7c0-14.5-4.3-28.8-12.4-40.9L236.4 70.7zm-12.4 39l33 49.5c4.6 6.8 7 14.9 7 23.1l0 1.7c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-1.7c0-8.2 2.4-16.3 7-23.1l33-49.5z'
      
    ]
  };

  

  
  

  var faImageLandscape = {
    prefix: 'fal',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      'M512 96c17.7 0 32 14.3 32 32l0 256c0 6.1-1.7 11.8-4.6 16.6L377 197.6c-12.8-16-37.2-16-50 0L244.4 300.9l-27.3-37.5c-12.3-17-37.4-17.7-50.6-1.4L45.3 410C37.3 404.2 32 394.7 32 384l0-256c0-17.7 14.3-32 32-32l448 0zm-1.3 320l-317.4 0 63-78.8L352 217.6 510.7 416zM160.1 448L512 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l95.9 0 .3 0zm-7.8-32l-70.5 0L191.3 282.2l32.4 44.6L152.3 416zM144 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faArrowUpToDottedLine = {
    prefix: 'fal',
    iconName: 'arrow-up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a1',
      
      'M363.3 292.7l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 214.6 208 320l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 0-105.4L340.7 315.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm384 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM152 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM344 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSiren = {
    prefix: 'fal',
    iconName: 'siren',
    icon: [
      448,
      512,
      [],
      'e02d',
      
      'M363.8 320l32.2 0L375 152.1C371 120 343.8 96 311.5 96l-175 0C104.2 96 77 120 73 152.1L52 320l32.2 0 20.5-164c2-16 15.6-28 31.8-28l175 0c16.1 0 29.8 12 31.8 28l20.5 164zm-185.6 0l13.8-110c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L145.9 320l32.2 0zM48 384l352 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L48 448c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM0 400l0 32c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fal',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z'
      
    ]
  };

  

  
  

  var faBagShoppingMinus = {
    prefix: 'fal',
    iconName: 'bag-shopping-minus',
    icon: [
      448,
      512,
      [],
      'e650',
      
      'M224 32c35.3 0 64 28.7 64 64l0 32-128 0 0-32c0-35.3 28.7-64 64-64zM128 96l0 32-80 0c-26.5 0-48 21.5-48 48L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-240c0-26.5-21.5-48-48-48l-80 0 0-32c0-53-43-96-96-96s-96 43-96 96zM48 160l96 0 160 0 96 0c8.8 0 16 7.2 16 16l0 240c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-240c0-8.8 7.2-16 16-16zm96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faTableCells = {
    prefix: 'fal',
    iconName: 'table-cells',
    icon: [
      512,
      512,
      ["th"],
      'f00a',
      
      'M352 64l0 96 128 0 0-64c0-17.7-14.3-32-32-32l-96 0zm-32 0L192 64l0 96 128 0 0-96zM160 64L64 64C46.3 64 32 78.3 32 96l0 64 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l96 0c17.7 0 32-14.3 32-32l0-64-128 0 0 96zM480 320l0-128-128 0 0 128 128 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM192 320l128 0 0-128-128 0 0 128z'
      
    ]
  };

  
    var faTh = faTableCells;
  

  
  

  var faCircleSort = {
    prefix: 'fal',
    iconName: 'circle-sort',
    icon: [
      512,
      512,
      ["sort-circle"],
      'e030',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192l114.7 0L256 134.6 198.6 192zM148.7 315.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96zM256 377.4L313.4 320l-114.7 0L256 377.4z'
      
    ]
  };

  
    var faSortCircle = faCircleSort;
  

  
  

  var faUpRightFromSquare = {
    prefix: 'fal',
    iconName: 'up-right-from-square',
    icon: [
      512,
      512,
      ["external-link-alt"],
      'f35d',
      
      'M320 33c0-18.2 14.8-33 33-33L480 0c17.7 0 32 14.3 32 32l0 127c0 18.2-14.8 33-33 33c-8.7 0-17.1-3.5-23.3-9.7L404 130.6 235.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L381.4 108 329.7 56.3C323.5 50.1 320 41.7 320 33zm33-1c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L478.3 159.7c.2 .2 .4 .3 .7 .3c.5 0 1-.4 1-1l0-127L353 32zM0 96C0 60.7 28.7 32 64 32l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 64C46.3 64 32 78.3 32 96l0 352c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faExternalLinkAlt = faUpRightFromSquare;
  

  
  

  var faCherries = {
    prefix: 'fal',
    iconName: 'cherries',
    icon: [
      640,
      512,
      [],
      'e0ec',
      
      'M288 16l8.2-13.7c-4.7-2.8-10.5-3-15.4-.6s-8.2 7.3-8.7 12.7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 .1l0 .3-.1 1.2c-.1 1.1-.3 2.8-.6 5c-.6 4.4-1.5 10.8-2.8 18.7c-2.7 16-7.1 38.2-13.9 63c-13.8 50.2-37 109.3-74.4 150.5c-.2 .2-.3 .3-.4 .5C163.8 241.9 133.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-32 192-176c0-112-96-112-96-112c-21.3 0-40.2 5.8-55.6 12.9c25.7-40.5 42.3-86.8 53-125.7C292.6 85.1 297.2 61.8 300 45l.2-1.2c1 .7 2 1.5 3.1 2.3c14.5 11 33.7 27.1 53 47.8c36.2 39 71 92.5 75.3 156.9c-13.2-9.1-33.5-20.4-58.3-24.9c12.6 11.5 23.6 26.5 31.3 45.5c4.6 2.7 8.7 5.5 12.1 8c18.4 13.7 44.3 13.7 62.7 0c13.5-10 37-23.4 64.4-23.5c0 0 .1 0 .1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C590 273.9 608 291.3 608 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-14.6 0-42.6-4-71.1-15.9c-7 9.2-14.8 17.4-23 24.8C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-35 0-63.7 15.6-80.3 27.3c-4.1-75.9-44.8-137.1-83.9-179.2c-20.8-22.3-41.5-39.7-57-51.5c-7.8-5.9-14.3-10.4-18.9-13.5c-2.3-1.5-4.1-2.7-5.4-3.5c-.6-.4-1.1-.7-1.5-.9l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 16zm-.3 243.2s0 0 0 0c.2 0 .7 0 1.5 .1c1.5 .1 4 .4 7.1 1c6.3 1.2 14.3 3.6 22 8.1c13.1 7.6 30.5 24 30.5 67.6c0 57.7-27.7 91.3-61.3 112.1c-35.5 22-76.8 28.7-95.5 28.7s-60-6.8-95.5-28.7C62.9 427.3 35.2 393.7 35.2 336c0-43.6 17.5-60 30.5-67.6c7.7-4.5 15.7-6.9 22-8.1c3.1-.6 5.5-.9 7.1-1c.8-.1 1.3-.1 1.5-.1c0 0 0 0 0 0c19.6 .1 37.2 7.1 50.9 15.1c6.7 3.9 12 7.9 15.6 10.8c1.8 1.4 3 2.5 3.8 3.2c.4 .3 .6 .6 .7 .7c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c13.7 13.5 35.8 13.5 49.5 0c0 0 0 0 0 0c0 0 0 0 0 0c.1-.1 .3-.3 .7-.7c.8-.7 2-1.8 3.8-3.2c3.5-2.9 8.8-6.8 15.6-10.8c13.6-8 31.3-15.1 50.9-15.1z'
      
    ]
  };

  

  
  

  var faFileVideo = {
    prefix: 'fal',
    iconName: 'file-video',
    icon: [
      384,
      512,
      [],
      'f1c8',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 288l0 24 0 48 0 24L96 384l0-96 112 0zm32 96l0-.4 58.1 23.2c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2l0-112c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L240 288.4l0-.4c0-17.7-14.3-32-32-32L96 256c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l112 0c17.7 0 32-14.3 32-32zm48-15.6l-48-19.2 0-26.3 48-19.2 0 64.7z'
      
    ]
  };

  

  
  

  var faUsersViewfinder = {
    prefix: 'fal',
    iconName: 'users-viewfinder',
    icon: [
      640,
      512,
      [],
      'e595',
      
      'M32 32l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L24 0C10.7 0 0 10.7 0 24L0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm576 0l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-104c0-13.3-10.7-24-24-24L512 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0zM128 480l-96 0 0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 488c0 13.3 10.7 24 24 24l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm480 0l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l104 0c13.3 0 24-10.7 24-24l0-104c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32l-158.4 0c3.7-18.3 19.8-32 39.2-32l80 0zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72l-40 0-40 0zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24l56 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-56 0c-30.9 0-56 25.1-56 56l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-30.9-25.1-56-56-56l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0z'
      
    ]
  };

  

  
  

  var faGalaxy = {
    prefix: 'fal',
    iconName: 'galaxy',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M144 184c0-83.9 68.1-152 152-152l12.8 0C272 59.2 246.6 98.6 236.7 142.5c-1.4 6 .9 12.3 5.8 16.1s11.5 4.5 17.1 1.7C280.1 149.9 303.3 144 328 144c83.9 0 152 68.1 152 152l0 12.8c-27.2-36.9-66.6-62.2-110.5-72.1c-6-1.4-12.3 .9-16.2 5.8s-4.5 11.5-1.7 17.1C362.1 280.1 368 303.3 368 328c0 83.9-68.1 152-152 152l-12.8 0c36.9-27.2 62.2-66.6 72.1-110.5c1.4-6-.9-12.3-5.8-16.2s-11.5-4.5-17.1-1.7C231.9 362.1 208.7 368 184 368c-83.9 0-152-68.1-152-152l0-12.8c27.2 36.9 66.6 62.2 110.5 72.1c6 1.4 12.3-.9 16.1-5.8s4.5-11.5 1.7-17.1C149.9 231.9 144 208.7 144 184zM296 0C194.4 0 112 82.4 112 184c0 17.2 2.4 33.9 6.8 49.7C94.5 222.6 73.1 205.4 57 183.2L48.1 171c-5-6.9-13-11-21.5-11C11.9 160 0 171.9 0 186.6L0 216C0 317.6 82.4 400 184 400c17.2 0 33.9-2.4 49.7-6.8c-11.1 24.3-28.4 45.7-50.6 61.8l9.4 12.9L183.2 455 171 463.9c-6.9 5-11 13-11 21.5c0 14.7 11.9 26.6 26.6 26.6l29.4 0c101.6 0 184-82.4 184-184c0-17.2-2.4-33.9-6.8-49.7c24.3 11.1 45.7 28.4 61.8 50.6l8.9 12.2c5 6.9 13 11 21.5 11c14.7 0 26.6-11.9 26.6-26.6l0-29.4c0-101.6-82.4-184-184-184c-17.2 0-33.9 2.4-49.7 6.8c11.1-24.3 28.4-45.7 50.6-61.8L341 48.1c6.9-5 11-13 11-21.5C352 11.9 340.1 0 325.4 0L296 0zM256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fal',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      'M304 32c8.8 0 16 7.2 16 16l0 272c0 88.4-71.6 160-160 160S0 408.4 0 320l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 70.7 57.3 128 128 128s128-57.3 128-128l0-272c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHighDefinition = {
    prefix: 'fal',
    iconName: 'high-definition',
    icon: [
      576,
      512,
      ["rectangle-hd"],
      'e1ae',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM320 176l0 160c0 8.8 7.2 16 16 16l48 0c53 0 96-43 96-96s-43-96-96-96l-48 0c-8.8 0-16 7.2-16 16zm64 16c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128 32 0zM144 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 96 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-96 0 0-64z'
      
    ]
  };

  
    var faRectangleHd = faHighDefinition;
  

  
  

  var faRestroom = {
    prefix: 'fal',
    iconName: 'restroom',
    icon: [
      640,
      512,
      [],
      'f7bd',
      
      'M144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM112 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L30.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L60.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L208 202.2 208 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zM496 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 496 0zM455.2 241.7c7.9 4 11.1 13.6 7.2 21.5L409.9 368l38.1 0 96 0 38.1 0L529.7 263.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6l-48 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-64 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-48 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM435 196.6l-52.9 98.9c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9C424.3 148.6 458.7 128 496 128s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L557 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6zM336 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-480c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faDiceD6 = {
    prefix: 'fal',
    iconName: 'dice-d6',
    icon: [
      448,
      512,
      [],
      'f6d1',
      
      'M220.1 35.6L47.9 136.2l176 101.2L400 133l-172-97.5 11.6-20.4L228.1 35.5c-2.5-1.4-5.5-1.4-8 .1zM32 164l0 202.6c0 2.9 1.6 5.6 4.1 7L208 469.9l0-204.6L32 164zM240 469.9l171.9-96.3c2.5-1.4 4.1-4.1 4.1-7l0-205.8L240 265.1l0 204.8zM203.9 7.9c12.3-7.2 27.5-7.3 39.9-.3L427.7 112c12.5 7.1 20.3 20.4 20.3 34.8l0 219.9c0 14.5-7.8 27.8-20.5 34.9l-184 103c-12.1 6.8-26.9 6.8-39.1 0l-184-103C7.8 394.4 0 381.1 0 366.6L0 150.1c0-14.2 7.5-27.4 19.8-34.5L203.9 7.9z'
      
    ]
  };

  

  
  

  var faAlignLeft = {
    prefix: 'fal',
    iconName: 'align-left',
    icon: [
      448,
      512,
      [],
      'f036',
      
      'M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z'
      
    ]
  };

  

  
  

  var faTemperatureSun = {
    prefix: 'fal',
    iconName: 'temperature-sun',
    icon: [
      640,
      512,
      ["temperature-hot"],
      'f76a',
      
      'M336 101.1l-18.1-3L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l69 48.3c-3.2-13.7-4.9-27.9-5-42.6l-54.8-38.4c-5.5-3.9-12.8-3.9-18.4 0l-59.2 41.4-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l34.6 5.8 0-32.4zM208 264a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-88-56a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM400 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L400 96zM464 0c-53 0-96 43-96 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C335.7 293.1 320 328.8 320 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L560 96c0-53-43-96-96-96zM432 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-210c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faTemperatureHot = faTemperatureSun;
  

  
  

  var faCupStrawSwoosh = {
    prefix: 'fal',
    iconName: 'cup-straw-swoosh',
    icon: [
      384,
      512,
      [],
      'e364',
      
      'M202.4 36.4C207.8 15 227 0 249 0l23 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-23 0c-7.3 0-13.7 5-15.5 12.1l-21 83.9L368 128c8.8 0 16 7.2 16 16s-7.2 16-16 16l-175.6 0c-.2 0-.5 0-.7 0L16 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l163.5 0 22.9-91.6zM60.3 468l-23-276 32.1 0L83.9 365.1c29-3.7 48.3-10.6 62.3-18.6c17.1-9.8 27.6-22 39.1-36.1l2-2.5c10.8-13.4 23.2-28.6 42.5-41c19.3-12.3 44.4-21.2 80.6-24.9l4.2-50 32.1 0-23 276c-2.1 24.9-22.9 44-47.8 44l-167.7 0c-25 0-45.8-19.1-47.8-44zM307.7 274.5c-29 3.6-47.5 10.9-60.7 19.4c-14.8 9.5-24.2 21.1-35.5 35l-1.4 1.7c-11.8 14.5-25.4 30.7-48 43.7C143.4 385 119.4 392.9 86.5 397l5.7 68.3c.7 8.3 7.6 14.7 15.9 14.7l167.7 0c8.3 0 15.3-6.4 15.9-14.7l15.9-190.9z'
      
    ]
  };

  

  
  

  var faArrowLeftFromBracket = {
    prefix: 'fal',
    iconName: 'arrow-left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e668',
      
      'M4.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16L54.6 272 155.3 372.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128zM336 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c44.2 0 80 35.8 80 80l0 288c0 44.2-35.8 80-80 80l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-96 0z'
      
    ]
  };

  

  
  

  var faRuler = {
    prefix: 'fal',
    iconName: 'ruler',
    icon: [
      512,
      512,
      [128207],
      'f545',
      
      'M51.9 390.6c-12.5-12.5-12.5-32.8 0-45.3l39.4-39.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L305.9 91.3l39.4-39.4c12.5-12.5 32.8-12.5 45.3 0l69.5 69.5c12.5 12.5 12.5 32.8 0 45.3L166.6 460.1c-12.5 12.5-32.8 12.5-45.3 0L51.9 390.6zm46.9 92.1c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z'
      
    ]
  };

  

  
  

  var faPersonCircleXmark = {
    prefix: 'fal',
    iconName: 'person-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e543',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91L224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z'
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fal',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z'
      
    ]
  };

  

  
  

  var faLeafMaple = {
    prefix: 'fal',
    iconName: 'leaf-maple',
    icon: [
      512,
      512,
      [127809],
      'f6f6',
      
      'M336.9 7.4C334 2.9 329.1 .1 323.7 0s-10.4 2.4-13.5 6.8L248.6 94.5 248 60.6c-.1-4.9-2.4-9.5-6.3-12.4s-8.9-4-13.7-2.8L179.3 57.9 140.9 13.1c-2.9-3.4-7.1-5.4-11.5-5.6s-8.8 1.5-11.9 4.6L70.1 59 18 52.5c-5.3-.7-10.5 1.3-14 5.3S-.8 67.3 .5 72.4L42.9 234.8 5.7 266.2c-4.1 3.4-6.2 8.7-5.6 14s3.8 10 8.5 12.4L132 357.4 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L154.6 380l64.7 123.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 14-5.6l31.4-37.2 162.4 42.4c5.1 1.3 10.6 0 14.6-3.5s6-8.7 5.3-14l-5.6-44.4c-.6-4.9 1.1-9.8 4.5-13.2l41.4-41.9c3.1-3.2 4.8-7.5 4.6-11.9s-2.2-8.6-5.6-11.5l-44.8-38.4L466.6 284c1.2-4.7 .2-9.8-2.8-13.7s-7.5-6.2-12.4-6.3l-33.9-.6 87.7-61.6c4.7-3.3 7.3-8.9 6.7-14.7s-4.2-10.7-9.5-13.1l-41.1-18.1c-7.6-3.3-11.3-11.9-8.7-19.7L481.2 51c1.9-5.6 .5-11.9-3.6-16.2s-10.3-6-16-4.3L379.9 53.9c-6.8 1.9-14.1-.8-17.9-6.8L336.9 7.4zM178.3 356.3L316.2 218.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L155.7 333.7 44.5 275.3l19-16.1c9.4-8 13.4-20.6 10.3-32.5L37.4 87.2l36.4 4.6c4.9 .6 9.8-1.1 13.2-4.5L127.8 47l33.7 39.3c4 4.6 10.2 6.6 16.1 5.1l38.7-9.9 1.2 62.6c.1 6.9 4.7 13 11.3 15s13.8-.4 17.8-6.1l76-108.1L335 64.2c11.4 18 33.3 26.3 53.7 20.5l52.5-15-18.9 56.2c-7.9 23.5 3.4 49.2 26.1 59.2l15.2 6.7L359.1 265.4c-5.7 4-8.1 11.2-6.1 17.8s8.1 11.2 15 11.3l62.6 1.2-9.9 38.7c-1.5 5.9 .5 12.2 5.1 16.1L465 384.2l-29.3 29.6c-10.4 10.5-15.4 25.1-13.5 39.7l2.6 21L285.3 438.2c-11.9-3.1-24.6 .9-32.5 10.3l-16.1 19L178.3 356.3z'
      
    ]
  };

  

  
  

  var faRepublican = {
    prefix: 'fal',
    iconName: 'republican',
    icon: [
      640,
      512,
      [],
      'f75e',
      
      'M0 176C0 96.5 64.5 32 144 32l224 0c79.5 0 144 64.5 144 144l0 96 0 64 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64c0 61.9-50.1 112-112 112c-32.2 0-61.2-13.6-81.7-35.4C440.8 465 422.1 480 400 480l-64 0c-26.5 0-48-21.5-48-48l0-48-128 0 0 48c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48L0 272l0-96zM480 288L32 288l0 144c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32 0-48zm0-32l0-80c0-61.9-50.1-112-112-112L144 64C82.1 64 32 114.1 32 176l0 80 448 0zM160 144l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zm128 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faHandsClapping = {
    prefix: 'fal',
    iconName: 'hands-clapping',
    icon: [
      512,
      512,
      [],
      'e1a8',
      
      'M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM215.1 18.7c-7.4 4.9-9.3 14.8-4.4 22.2l32 48c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-32-48c-4.9-7.4-14.8-9.3-22.2-4.4zm209.8 0c-7.4-4.9-17.3-2.9-22.2 4.4l-32 48c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l32-48c4.9-7.4 2.9-17.3-4.4-22.2zM153.9 152c4.8 0 9.3 1.9 12.7 5.3L292.7 283.3c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 129.6C352 416.2 288.2 480 209.6 480c-37.8 0-74-15-100.7-41.7L75.3 404.7l-16-16s0 0 0 0l-22-22c-3.4-3.4-5.3-7.9-5.3-12.7C32 344 40 336 49.9 336c4.8 0 9.3 1.9 12.7 5.2c0 0 0 0 0 0l38.1 38.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L85.3 318.6s0 0 0 0l-48-48c-3.4-3.4-5.3-7.9-5.3-12.7C32 248 40 240 49.9 240c4.8 0 9.3 1.9 12.7 5.3l86.1 86.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L85.3 222.6s0 0 0 0l-24-24c-3.4-3.4-5.3-7.9-5.3-12.7C56 176 64 168 73.9 168c4.8 0 9.3 1.9 12.7 5.3l32 32s0 0 0 0l78.1 78.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-78.1-78.1s0 0 0 0c-3.4-3.4-5.2-7.9-5.2-12.7c0-9.9 8-17.9 17.9-17.9zM31.1 211.7C12.9 219.1 0 237 0 257.9c0 13.2 5.3 25.9 14.6 35.3l15 15C12.2 316.1 0 333.6 0 353.9c0 13.2 5.3 25.9 14.6 35.3l22 22s0 0 0 0l16 16s0 0 0 0l33.6 33.6C119 493.6 163.4 512 209.6 512C305.9 512 384 433.9 384 337.6L384 208c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 25.4-98.7-98.7c-9.4-9.4-22.1-14.6-35.3-14.6c-20.4 0-37.9 12.2-45.7 29.7C99 140.9 86.7 136 73.9 136C46.4 136 24 158.4 24 185.9c0 9.1 2.5 18 7.1 25.7zM360.8 478.1c-11.7 12.6-25 23.7-39.5 33.1c5.4 .5 10.9 .8 16.4 .8C433.9 512 512 433.9 512 337.6L512 208c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 25.4 0 45.3 4.7 4.7c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 129.6c0 70.7-51.6 129.4-119.2 140.5z'
      
    ]
  };

  

  
  

  var faSnowflakes = {
    prefix: 'fal',
    iconName: 'snowflakes',
    icon: [
      640,
      512,
      [],
      'f7cf',
      
      'M507.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L513.4 56 484.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L536 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L558.6 56l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L536 33.4 507.3 4.7zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 73.4L171.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 134.6l0 93.7-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3S72 100.2 74.3 108.7l13.4 50.1L24.1 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4L8.1 362.1C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7L74.3 403.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L208 283.7l0 93.7-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 422.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4l0-93.7 81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7L426.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L240 228.3l0-93.7 59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4 240 16zM532.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L561.4 264l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L584 286.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L606.6 264l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L584 241.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faCircleAmpersand = {
    prefix: 'fal',
    iconName: 'circle-ampersand',
    icon: [
      512,
      512,
      [],
      'e0f8',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 184c0-13.3 10.7-24 24-24l16.8 0c12.8 0 23.2 10.4 23.2 23.2c0 10.2-5 19.8-13.5 25.6l-21.8 15-22.1-23.3c-4.3-4.5-6.6-10.4-6.6-16.6zm68.7 51.2c17.1-11.8 27.3-31.2 27.3-52c0-30.5-24.7-55.2-55.2-55.2L232 128c-30.9 0-56 25.1-56 56c0 14.4 5.5 28.2 15.4 38.6l18.6 19.5-38.7 26.6C154.2 280.5 144 300 144 320.8c0 34.9 28.3 63.2 63.2 63.2l36 0c23.3 0 45.1-11.2 58.6-30.2l6.3-8.8 32.4 34c6.1 6.4 16.2 6.6 22.6 .6s6.6-16.2 .6-22.6L327 318.5l38-53.2c5.1-7.2 3.5-17.2-3.7-22.3s-17.2-3.5-22.3 3.7l-34.5 48.2-45.4-47.7 17.5-12.1zm-87.1 59.9l42.9-29.5 53.2 55.8-9.8 13.8c-7.5 10.5-19.6 16.8-32.5 16.8l-36 0C190 352 176 338 176 320.8c0-10.3 5.1-19.9 13.5-25.7z'
      
    ]
  };

  

  
  

  var faCampfire = {
    prefix: 'fal',
    iconName: 'campfire',
    icon: [
      512,
      512,
      [],
      'f6ba',
      
      'M279.7 73c8.2-.1 15.9-3.7 21.3-9.9l8.2-9.4c14.8 14.4 30.1 33.7 41.7 54.9c12.3 22.3 20 45.5 20 66.1c0 28.8-10.1 54.9-27 75.1c.5-3.6 .8-7.3 .8-11.1c0-52.2-58-100.4-79.4-116.5c-4.7-3.5-11-3.5-15.7 0c-21.5 16.1-79.4 64.4-79.4 116.5c0 5.3 .6 10.6 1.6 15.6c-19.1-20.7-30.7-48.6-30.7-79.6c0-25.9 11.2-53 28.3-79c16.5-25 37.7-47.7 57.2-65.6c.2 .2 .4 .3 .6 .5c1.6 1.4 3.3 3.3 5.7 6l1.5 1.8s0 0 0 0s0 0 0 0c1.9 2.2 4.3 5 6.5 7.3L258 63.8c5.6 6 13.5 9.3 21.7 9.1zM256 290.9c-1.2 0-2.4 0-3.6-.1c-31.4-2.4-53.1-26.5-53.1-52.2c0-15.8 9.2-34.3 24.9-53.2c11-13.2 23.5-24.5 33.3-32.6c9.8 8 22.2 19.3 33.3 32.6c15.7 18.9 24.9 37.4 24.9 53.2c0 24.6-20 47.8-49.2 51.8c-3.4 .3-6.9 .5-10.4 .5zM112 174.7c0 78.9 60.8 142.6 139 145.2c2.1 .1 4.3 .2 6.4 .2c4 0 7.9-.2 11.7-.7C342.7 312.8 400 250.8 400 174.7c0-27.3-9.9-55.4-23.6-80.1C362.7 69.7 344.7 47 326.9 30.4c-5-4.7-11.5-7.1-17.9-7.1c-3.4 0-6.8 .6-10 1.9c-3.3 1.3-6.4 3.4-8.8 6.2l-11 12.5L262.1 25.8c-1-1-1.9-2.1-2.9-3.2c-.8-.9-1.7-1.9-2.5-2.9c0 0 0 0 0 0s0 0 0 0C248.6 10.4 239.9 .3 227.2 0c-6.5-.2-13.1 2.1-18.3 6.8c-21.1 19.2-45 44.4-63.8 72.9c-18.7 28.3-33.1 61-33.1 95zM224.8 28.7c0 0 .1 0 .1 0c-.1 0-.1 0-.1 0zM21.9 289.1c-8.2-3.3-17.5 .7-20.8 8.9s.7 17.5 8.9 20.8L212.9 400 10.1 481.1c-8.2 3.3-12.2 12.6-8.9 20.8s12.6 12.2 20.8 8.9L256 417.2l234.1 93.6c8.2 3.3 17.5-.7 20.8-8.9s-.7-17.5-8.9-20.8L299.1 400l202.9-81.1c8.2-3.3 12.2-12.6 8.9-20.8s-12.6-12.2-20.8-8.9L256 382.8 21.9 289.1z'
      
    ]
  };

  

  
  

  var faHandsHolding = {
    prefix: 'fal',
    iconName: 'hands-holding',
    icon: [
      640,
      512,
      [],
      'f4c2',
      
      'M128 128c0-35.3-28.7-64-64-64S0 92.7 0 128L0 344.2c0 29.7 11.8 58.2 32.8 79.2l83.9 83.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L55.4 400.8c-15-15-23.4-35.4-23.4-56.6L32 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 124.3c0 27.1 10.8 53.1 29.9 72.2l10.7 10.8s0 0 0 0l44 44s0 0 0 0l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-44-44c-9.2-9.2-9.2-24.2 0-33.4s24.2-9.2 33.4 0L284 370.6c12.8 12.8 20 30.2 20 48.3l0 77.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-77.1c0-18.1 7.2-35.5 20-48.3l91.3-91.3c9.2-9.2 24.2-9.2 33.4 0s9.2 24.2 0 33.4c0 0 0 0 0 0l-44 44s0 0 0 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16 44-44 10.8-10.8c19.2-19.2 29.9-45.1 29.9-72.2L544 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 216.2c0 21.2-8.4 41.6-23.4 56.6l-83.9 83.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l83.9-83.9c21-21 32.8-49.5 32.8-79.2L640 128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 124.3c0 4.6-.4 9.1-1.3 13.5c-2.1-3.2-4.6-6.3-7.4-9.1c-21.7-21.7-56.9-21.7-78.6 0L333.4 348c-5.1 5.1-9.6 10.6-13.4 16.6c-3.8-5.9-8.3-11.5-13.4-16.6l-91.3-91.3c-21.7-21.7-56.9-21.7-78.6 0c-2.8 2.8-5.3 5.9-7.4 9.1c-.9-4.4-1.3-8.9-1.3-13.5L128 128z'
      
    ]
  };

  

  
  

  var faHeadphones = {
    prefix: 'fal',
    iconName: 'headphones',
    icon: [
      512,
      512,
      [127911],
      'f025',
      
      'M32.6 271.6C41 155.5 137.8 64 256 64s215 91.5 223.4 207.6C466.1 261.8 449.7 256 432 256c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80l0-32 0-32 0-48C512 146.6 397.4 32 256 32S0 146.6 0 288l0 48 0 32 0 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48c-17.7 0-34.1 5.8-47.4 15.6zM32 336c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48l0-32 0-32zm448 0l0 32 0 32c0 26.5-21.5 48-48 48c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16c26.5 0 48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faTengeSign = {
    prefix: 'fal',
    iconName: 'tenge-sign',
    icon: [
      384,
      512,
      [8376,"tenge"],
      'f7d7',
      
      'M0 48c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 64C7.2 64 0 56.8 0 48zM0 176c0-8.8 7.2-16 16-16l176 0 176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0 0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272L16 192c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faTenge = faTengeSign;
  

  
  

  var faSquare7 = {
    prefix: 'fal',
    iconName: 'square-7',
    icon: [
      448,
      512,
      [],
      'e25c',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 32l160 0c5.7 0 11 3 13.8 8s2.9 11 .1 16l-128 224c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8L276.4 160 144 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faLampFloor = {
    prefix: 'fal',
    iconName: 'lamp-floor',
    icon: [
      384,
      512,
      [],
      'e015',
      
      'M96 32L32 192l320 0L288 32 96 32zM66.3 20.1C71.1 8 82.9 0 96 0L288 0c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1L32 224c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM80 480l96 0 0-224 32 0 0 224 96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0L80 512c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSunCloud = {
    prefix: 'fal',
    iconName: 'sun-cloud',
    icon: [
      640,
      512,
      [127780],
      'f763',
      
      'M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-50.9c-11-.4-21.6-2.6-31.4-6.5l-5 27.3-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.9l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-17.1 24.8c4-.4 8.2-.7 12.3-.7c8.6 0 17 1 25.1 2.8l20.1-29.2c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1c-2.5-8.5-3.8-17.6-3.8-26.9c0-1.9 .1-3.7 .2-5.5c-10.1 3.6-20.9 5.5-32.2 5.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 1.9-.1 3.7-.2 5.5c3.2-1.1 6.4-2.1 9.7-2.9c4.9-11 11.5-21.1 19.5-29.9C368.6 171.1 317.3 128 256 128zm208 96c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224zm0 32c26.5 0 48 21.5 48 48l0 .8c0 6.5 3.9 12.4 9.9 14.9s13 1.1 17.5-3.6c7.3-7.4 17.4-12 28.6-12c22.1 0 40 17.9 40 40s-17.9 40-40 40l-184 0c-17.7 0-32-14.3-32-32s14.3-32 32-32c3.8 0 7.4 .6 10.7 1.8c5 1.8 10.6 1 14.9-2.2s6.7-8.2 6.5-13.5c0-.7 0-1.4 0-2.1c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faDivide = {
    prefix: 'fal',
    iconName: 'divide',
    icon: [
      448,
      512,
      [247,10135],
      'f529',
      
      'M224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenDollar = {
    prefix: 'fal',
    iconName: 'envelope-open-dollar',
    icon: [
      512,
      512,
      [],
      'f657',
      
      'M392 32L120 32c-13.3 0-24 10.7-24 24l0 166.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6L64 56C64 25.1 89.1 0 120 0L392 0c30.9 0 56 25.1 56 56l0 142.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5 416 56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3l0 189c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-189c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35l0 189c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 259zM272 88l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c0 0 0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7L240 88c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCubes = {
    prefix: 'fal',
    iconName: 'cubes',
    icon: [
      576,
      512,
      [],
      'f1b3',
      
      'M293.4 32.8c-3.5-1.2-7.3-1.2-10.8 0l-104 37.1c-2.3 .8-4.4 2.2-6.1 3.9L288 118 403.4 73.8c-1.7-1.7-3.7-3-6.1-3.9l-104-37.1zM168 212.8l.1 0L272 249.9l0-103.8L168 106.3l0 106.5zm136 37.1l103.9-37.1 .1 0 0-106.5L304 146.2l0 103.8zM440 85l0 127.8 .1 0 104 37.1c19.1 6.8 31.9 24.9 31.9 45.2l0 126.2c0 19.4-11.7 36.9-29.6 44.4l-104 43c-11.8 4.9-25 4.9-36.7 0L288 460.1 170.4 508.8c-11.8 4.9-25 4.9-36.7 0l-104-43C11.7 458.3 0 440.8 0 421.4L0 295.2c0-20.3 12.8-38.4 31.9-45.2l104-37.1 .1 0L136 85c0-20.3 12.8-38.4 31.9-45.2l104-37.1c10.4-3.7 21.8-3.7 32.3 0l104 37.1C427.2 46.6 440 64.7 440 85zM272 308.2L160 348.6l0 129.8 112-46.3 0-123.9zM41.9 436.2L128 471.8l0-123.7L32 308.9l0 112.5c0 6.5 3.9 12.3 9.9 14.8zM416 478.4l0-129.8L304 308.2l0 123.9 112 46.3zm32-6.6l86.1-35.6c6-2.5 9.9-8.3 9.9-14.8l0-112.5-96 39.2 0 123.7zM157.4 243c-3.5-1.2-7.3-1.2-10.8 0L44.6 279.4l99.8 40.8 114.1-41.1L157.4 243zm261.2 0L317.5 279.1l114.1 41.1 99.8-40.8L429.4 243c-3.5-1.2-7.3-1.2-10.8 0z'
      
    ]
  };

  

  
  

  var faSquareR = {
    prefix: 'fal',
    iconName: 'square-r',
    icon: [
      448,
      512,
      [],
      'e27c',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 32l80 0c44.2 0 80 35.8 80 80c0 34.8-22.2 64.4-53.2 75.4l50.5 75.7c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L231.4 288 160 288l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96 0-112c0-17.7 14.3-32 32-32zm80 128c26.5 0 48-21.5 48-48s-21.5-48-48-48l-80 0 0 96 80 0z'
      
    ]
  };

  

  
  

  var faBillboard = {
    prefix: 'fal',
    iconName: 'billboard',
    icon: [
      640,
      512,
      [],
      'e5cd',
      
      'M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L240 32l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L80 32C53.5 32 32 53.5 32 80l0 272-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 240 0 0 104c0 8.8 7.2 16 16 16s16-7.2 16-16l0-104 240 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-272c0-26.5-21.5-48-48-48L432 32l0-16zM320 352L64 352 64 80c0-8.8 7.2-16 16-16l128 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 160 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 128 0c8.8 0 16 7.2 16 16l0 272-256 0z'
      
    ]
  };

  

  
  

  var fa0 = {
    prefix: 'fal',
    iconName: '0',
    icon: [
      320,
      512,
      [],
      '30',
      
      'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 64C89.3 64 32 121.3 32 192l0 128c0 70.7 57.3 128 128 128s128-57.3 128-128l0-128c0-70.7-57.3-128-128-128z'
      
    ]
  };

  

  
  

  var faShirt = {
    prefix: 'fal',
    iconName: 'shirt',
    icon: [
      640,
      512,
      [128085,"t-shirt","tshirt"],
      'f553',
      
      'M211.4 0c-27.7 0-54.5 9.6-76 27.1L56.3 91.9 12.9 127.4c-13.7 11.2-15.7 31.4-4.5 45l70.9 86.7c11.2 13.7 31.4 15.7 45 4.5L160 234.4 160 456c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-221.6 35.6 29.1c13.7 11.2 33.8 9.2 45-4.5l70.9-86.7c11.2-13.7 9.2-33.8-4.5-45L583.7 91.9 504.6 27.1C483.1 9.6 456.3 0 428.6 0l-6.3 0c-1.3 0-2.5 .1-3.7 .2c-.8-.1-1.7-.2-2.6-.2L224 0c-.9 0-1.7 .1-2.6 .2c-1.2-.1-2.4-.2-3.7-.2l-6.3 0zm40.7 32l135.8 0C378 60 351.3 80 320 80s-58-20-67.9-48zM155.7 51.9C171.4 39 191.1 32 211.4 32l6.3 0s0 0 0 0c0 0 .2 .1 .4 .3c.5 .4 1 1.2 1.3 2.2C231.1 79.1 271.7 112 320 112s88.9-32.9 100.6-77.5c.3-1 .8-1.8 1.3-2.2c.2-.2 .4-.2 .4-.3c0 0 0 0 0 0l6.3 0c20.3 0 40 7 55.7 19.9l79.2 64.8 43.3 35.5-70.9 86.7-43.3-35.5-18.4-15.1c-4.8-3.9-11.4-4.7-17-2.1s-9.1 8.3-9.1 14.5L448 456c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-255.3c0-6.2-3.6-11.8-9.1-14.5s-12.2-1.8-17 2.1l-18.4 15.1-43.3 35.5L33.2 152.1l43.3-35.5 79.2-64.8z'
      
    ]
  };

  
    var faTShirt = faShirt;
  
    var faTshirt = faShirt;
  

  
  

  var faClockSix = {
    prefix: 'fal',
    iconName: 'clock-six',
    icon: [
      512,
      512,
      [],
      'e352',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faHose = {
    prefix: 'fal',
    iconName: 'hose',
    icon: [
      448,
      512,
      [],
      'e419',
      
      'M288 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-1.9 96.1-12c1 7.8 7.7 13.9 15.9 13.9c8.8 0 16-7.2 16-16l0-1.9L448 80l0-32 0-14.1 0-1.9c0-8.8-7.2-16-16-16c-8.1 0-14.8 6.1-15.9 13.9L320 17.9l0-1.9c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 48zm32-61.9l96 12 0 3.8-96 12L320 64l0-13.9zM48 448l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16s7.2-16 16-16zM12.2 432C4.6 440.5 0 451.7 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48l-248 0c-30.9 0-56-25.1-56-56s25.1-56 56-56l104 0 0-32L152 80c-48.6 0-88 39.4-88 88s39.4 88 88 88l248 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-248 0C85.7 288 32 234.3 32 168S85.7 48 152 48l104 0 0-32L152 16C68.1 16 0 84.1 0 168c0 48.8 23 92.2 58.7 120L48 288c-26.5 0-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32C4.6 376.5 0 387.7 0 400s4.6 23.5 12.2 32zM152 320l248 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16l104 0zM48 384l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 416c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPhoneXmark = {
    prefix: 'fal',
    iconName: 'phone-xmark',
    icon: [
      576,
      512,
      [],
      'e227',
      
      'M388.7 4.7c6.2-6.2 16.4-6.2 22.6 0L464 57.4 516.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L486.6 80l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 102.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L441.4 80 388.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM361 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C215.5 494.5 32 300.7 32 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L361 286.7zM480 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C66.6 57 64 60.2 64 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z'
      
    ]
  };

  

  
  

  var faGuitars = {
    prefix: 'fal',
    iconName: 'guitars',
    icon: [
      512,
      512,
      [],
      'f8bf',
      
      'M80 32l0 51.2c0 6.3 1.9 12.5 5.4 17.8L112 140.8l0 36C57.7 183 16 219.7 16 264c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-5.4-9.4-9.3-19.7-11.6-30.6c-16.3 12-38.8 20.1-66.2 20.1c-59.5 0-96-38.1-96-72c0-14.1 5.6-27.9 16.5-40c20.9-23.2 21.3-58 6.2-82c-4.5-7.1-6.7-14.5-6.7-22c0-21.6 22.4-49.2 64-54.9l0 65.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-65.7c41.6 5.7 64 33.4 64 54.9c0 7.5-2.2 14.9-6.7 22c-15.1 23.9-14.7 58.8 6.2 82c.4 .5 .9 1 1.3 1.5c1.9-4.6 3.9-8.9 5.7-13l.3-.7c3.7-8.4 6.9-15.6 9.5-22c-3-10.1-1.5-21.8 4.1-30.7c1.1-1.7 2.1-3.5 3.1-5.3c-.9-4.9-2.7-10.7-5.7-19.2l-.5-1.4c-3.7-10.7-9.3-26.7-9.3-44.6l0-23c-17.4-17.3-42.9-29.4-72-32.7l0-36 26.6-39.9c3.5-5.3 5.4-11.4 5.4-17.8L176 32c0-17.7-14.3-32-32-32L112 0C94.3 0 80 14.3 80 32zm64 288a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM128 107.2l-16-24L112 32l32 0 0 51.2-16 24zM344.9 50.8C347.3 39.8 357 32 368.2 32l3.8 0c10.9 0 20 9 20 20.2c0 10.9-8.9 19.8-19.6 19.8C361.2 72 352 81.2 352 92.4l0 57-17.4-19.9c-3.3-3.8-4.7-8.9-3.6-13.9l13.9-64.8zm-34.4 99.8L352 198l0 42-8 0c-43.3 0-57.3-29.2-61.8-48.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16l0 40.6c0 12.4 4 24 8 35.5c4 11.6 8 23.3 8 35.9c0 20-9.3 40.9-19 62.5c-10.3 23.2-21 47.1-21 71.7c0 40.8 33 73.8 73.8 73.8l140.4 0c40.8 0 73.8-33 73.8-73.8c0-24.5-10.7-48.5-21-71.7c-9.6-21.6-19-42.5-19-62.5c0-12 4-22.9 8.1-33.8c0 0 0 0 0 0c4-10.7 7.9-21.4 7.9-33l0-29.3c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5c-5.7 14-20.8 32.5-60.5 32.5l-8 0 0-48 0-89.3c23-5.3 40-26.1 40-50.5C424 23.6 400.8 0 372 0l-3.8 0c-26.3 0-49.1 18.4-54.6 44.1L299.7 109c-3.2 14.8 .8 30.3 10.8 41.7zm54.3 121.1c1 .2 2.1 .3 3.2 .3s2.2-.1 3.2-.3l20.8 0c24.2 0 44-5.6 59.5-15.6c-.4 1.1-.8 2.2-1.2 3.3l-.4 1.2c-3.8 10.1-9.5 25.6-9.5 43.4c0 27 12 53.8 20.9 73.6l1.8 4.1c10.5 23.5 17.3 40.6 17.3 56.5c0 23.3-18.9 42.1-42.1 42.1l-140.4 0c-23.3 0-42.1-18.9-42.1-42.1c0-15.9 6.8-33 17.3-56.5l1.8-4.1c8.9-19.9 20.9-46.6 20.9-73.6c0-18-5.5-34-9.3-44.8l-.4-1.3c-.7-1.9-1.3-3.7-1.8-5.3c15.1 11.9 35 19.2 59.9 19.2l20.8 0zM320 352c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faScrollOld = {
    prefix: 'fal',
    iconName: 'scroll-old',
    icon: [
      576,
      512,
      [],
      'f70f',
      
      'M80 64c-26.5 0-48 21.5-48 48l0 72c0 4.4 3.6 8 8 8l56 0 0 32-56 0c-22.1 0-40-17.9-40-40l0-72C0 67.8 35.8 32 80 32l320 0c44.2 0 80 35.8 80 80l0 176-32 0 0-32-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-16c0-26.5-21.5-48-48-48L144 64c10 13.4 16 30 16 48l0 112 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 144c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48c0-22.1 18-40 40-40l.6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .5 0 .4 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .6 0 .5 0 .6 0 .6 0 .6 0 .6 0c22.1 0 40 17.9 40 40l0 56c0 39.8-32.2 72-72 72l-296 0c-44.2 0-80-35.8-80-80l0-160 0-128c0-26.5-21.5-48-48-48zM272 448l232 0c22.1 0 40-17.9 40-40l0-56c0-4.4-3.6-8-8-8l-.6 0-.6 0-.6 0-.6 0-.5 0-.6 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.4 0-.5 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.2 0 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40-.2 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0c-4.4 0-8 3.6-8 8l0 48c0 18-6 34.6-16 48z'
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fal',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      'M448 304c0 61.9-50.1 112-112 112l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c44.2 0 80-35.8 80-80l0-24.6c-9.4 5.4-20.3 8.6-32 8.6l-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 80zM416 192l0-32c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32zM192 304c0 61.9-50.1 112-112 112l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c44.2 0 80-35.8 80-80l0-24.6c-9.4 5.4-20.3 8.6-32 8.6l-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 80zM160 192l0-32c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32z'
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faPenClipSlash = {
    prefix: 'fal',
    iconName: 'pen-clip-slash',
    icon: [
      640,
      512,
      ["pen-alt-slash"],
      'e20f',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L378.3 67.7 365.3 54.6c-25-25-65.5-25-90.5 0l-47 47 25.3 20 44.3-44.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1L293 153.1l25.3 20L378.3 113 463 197.7l-50.1 50.1 25.3 20L556.7 149.3zM321.8 338.9l-50.9 50.9c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4l40.9-40.9-25.3-20-38.3 38.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L347 358.9l-25.3-20zm127.6-297c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L485.7 175 401 90.3l48.4-48.4z'
      
    ]
  };

  
    var faPenAltSlash = faPenClipSlash;
  

  
  

  var faPoo = {
    prefix: 'fal',
    iconName: 'poo',
    icon: [
      512,
      512,
      [128169],
      'f2fe',
      
      'M224 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l5.8 5.8c8.7 8.7 13.5 20.4 13.5 32.7l0 8.9c0 20.6-16.7 37.3-37.3 37.3l-17.8 0-.9 0c-48.6 0-88 39.4-88 88c0 7.2 .9 14.3 2.5 21.1C56.4 233.2 32 265.7 32 304c0 16 4.3 31 11.7 43.9C17.6 363.2 0 391.5 0 424c0 48.6 39.4 88 88 88l336 0c48.6 0 88-39.4 88-88c0-32.5-17.6-60.8-43.7-76.1C475.7 335 480 320 480 304c0-38.3-24.4-70.8-58.5-82.9c1.7-6.8 2.5-13.8 2.5-21.1c0-35-20.4-65.1-49.9-79.3C363 52.2 303.6 0 232 0l-8 0zm40 65.8c0-10.7-2.2-21.2-6.3-30.8c46.1 10.8 81.3 50.2 85.8 98.4c.6 6.3 4.8 11.6 10.7 13.6c22 7.6 37.8 28.4 37.8 53c0 9.1-2.2 17.7-6 25.2c-2.4 4.7-2.3 10.2 .2 14.8s7.1 7.7 12.3 8.3c27.9 3.2 49.5 26.9 49.5 55.6c0 15.3-6.2 29.2-16.2 39.4c-4 4-5.5 9.9-4.1 15.4s5.7 9.8 11.2 11.3c23.7 6.5 41 28.3 41 54c0 30.9-25.1 56-56 56L88 480c-30.9 0-56-25.1-56-56c0-25.7 17.4-47.4 41-54c5.5-1.5 9.7-5.8 11.2-11.3s-.1-11.3-4.1-15.4C70.2 333.2 64 319.3 64 304c0-28.7 21.7-52.4 49.5-55.6c5.2-.6 9.8-3.7 12.3-8.3s2.6-10.1 .2-14.8c-3.8-7.6-6-16.1-6-25.2c0-30.9 25.1-56 56-56l.9 0 17.8 0C233 144 264 113 264 74.7l0-8.9zM192 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM172.3 352c-15.6 0-28.3 12.7-28.3 28.3c0 5.5 1.6 11.5 5.6 16.6C159 408.8 194.4 448 256 448s97-39.2 106.4-51.1c4-5.1 5.6-11.1 5.6-16.6c0-15.6-12.7-28.3-28.3-28.3l-167.4 0zM256 416c-38.2 0-63.3-19.8-75.1-32l150.3 0c-11.8 12.2-36.9 32-75.1 32z'
      
    ]
  };

  

  
  

  var faFaceMelting = {
    prefix: 'fal',
    iconName: 'face-melting',
    icon: [
      640,
      512,
      [129760],
      'e483',
      
      'M544 256c0 21.5-3 42.3-8.7 62c-6.5 22.7-2.1 46.4 9.5 64.6c.6 .9 1.2 1.9 1.9 2.8c-29 6.1-50.7 31.8-50.7 62.6c0 11.7 3.1 22.6 8.6 32L320 480l-218.7 0c7.3-9.4 12.9-19.6 16.7-28.9c11.5-27.7 16.2-65.6 1.3-95.4c-15-30-23.4-63.8-23.4-99.8C96 132.3 196.3 32 320 32s224 100.3 224 224zM16 512l25.4 0L320 512l240 0c8.8 0 16-7.2 16-16s-7.2-16-16-16c-17.7 0-32-14.3-32-32s14.3-32 32-32l44.1 0 19.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.9 0c-27.7 0-45.6-30.6-38-57.2c6.5-22.5 9.9-46.2 9.9-70.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 41 9.6 79.7 26.7 114c18.4 37-8 110-49.3 110L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16zM249.3 212.2a24 24 0 1 0 12.4-46.4 24 24 0 1 0 -12.4 46.4zm183.9 24.4a24 24 0 1 0 -46.4-12.4 24 24 0 1 0 46.4 12.4zm-220 46.7c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z'
      
    ]
  };

  

  
  

  var faBookMedical = {
    prefix: 'fal',
    iconName: 'book-medical',
    icon: [
      448,
      512,
      [],
      'f7e6',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM224 96l32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32zm0 32l0 48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-48 0 0 32 48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16l0-48-32 0z'
      
    ]
  };

  

  
  

  var faArrowDownSmallBig = {
    prefix: 'fal',
    iconName: 'arrow-down-small-big',
    icon: [
      576,
      512,
      ["sort-size-down-alt"],
      'f88d',
      
      'M171.3 475.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4 176 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zm-32 0l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm32 352l0-128c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48l0 128z'
      
    ]
  };

  
    var faSortSizeDownAlt = faArrowDownSmallBig;
  

  
  

  var faGaugeSimple = {
    prefix: 'fal',
    iconName: 'gauge-simple',
    icon: [
      512,
      512,
      ["gauge-simple-med","tachometer-average"],
      'f629',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faGaugeSimpleMed = faGaugeSimple;
  
    var faTachometerAverage = faGaugeSimple;
  

  
  

  var faTrash = {
    prefix: 'fal',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M177.7 32l92.5 0c5.5 0 10.6 2.8 13.6 7.5L299.1 64 148.9 64l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0L177.7 0C161.2 0 145.8 8.5 137 22.6L111.1 64 64.1 64 32 64 16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l18.3 0L59.8 452.6C62.1 486.1 90 512 123.6 512l200.8 0c33.6 0 61.4-25.9 63.8-59.4L413.7 96 432 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32.1 0-47.1 0zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480l-200.8 0c-16.8 0-30.7-13-31.9-29.7L66.4 96l315.3 0z'
      
    ]
  };

  

  
  

  var faHandFingersCrossed = {
    prefix: 'fal',
    iconName: 'hand-fingers-crossed',
    icon: [
      384,
      512,
      [],
      'e1a3',
      
      'M189.8 4.4c-28.5-12.1-61.3 1.3-73.4 29.8L112 44.6l-4.4-10.5C95.5 5.7 62.7-7.6 34.2 4.4S-7.6 49.3 4.4 77.8L51.2 188.4 28.4 242.2 15.6 272.6C5.8 285.8 0 302.2 0 320l0 32c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-40 0-64 0-8c0-3.2-.9-6.1-2.5-8.6C374.4 208.6 353.2 192 328 192c-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-30.9 0-56 25.1-56 56l0 1.7-19.2-45.4L219.6 77.8c12.1-28.5-1.3-61.3-29.8-73.4zm-34.4 225l4.5 10.6-8.9 0 4.5-10.6zM68.6 147.3L33.9 65.4c-5.2-12.2 .5-26.3 12.8-31.5s26.3 .5 31.5 12.8L94.6 85.7 68.6 147.3zM80 240c-5.7 0-11.3 .6-16.6 1.7L145.9 46.6c5.2-12.2 19.2-17.9 31.5-12.8s17.9 19.2 12.8 31.5L116.2 240 80 240zm168-32c13.3 0 24 10.7 24 24l0 16 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24c0 0 0 0 0 0l0-64c0-13.3 10.7-24 24-24zm32.5 133.6C290.4 357.5 308 368 328 368c8.4 0 16.4-1.9 23.5-5.2C346.1 428.4 291 480 224 480l-64 0C89.3 480 32 422.7 32 352l0-32c0-26.5 21.5-48 48-48l88 0c13.2 0 24 10.7 24 24c0 0 0 0 0 0c0 13.3-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c12.1 0 23.3-3.8 32.5-10.4zM352 312c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64z'
      
    ]
  };

  

  
  

  var faCloudWord = {
    prefix: 'fal',
    iconName: 'cloud-word',
    icon: [
      640,
      512,
      [],
      'e138',
      
      'M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96l-368 0C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8zM512 368c0-8.8-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16zM240 352l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM128 304c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faPhoneArrowDownLeft = {
    prefix: 'fal',
    iconName: 'phone-arrow-down-left',
    icon: [
      512,
      512,
      ["phone-arrow-down","phone-incoming"],
      'e223',
      
      'M507.3 27.3L342.6 192l89.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 89.4L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z'
      
    ]
  };

  
    var faPhoneArrowDown = faPhoneArrowDownLeft;
  
    var faPhoneIncoming = faPhoneArrowDownLeft;
  

  
  

  var faOrnament = {
    prefix: 'fal',
    iconName: 'ornament',
    icon: [
      384,
      512,
      [],
      'f7b8',
      
      'M192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm45.3 32c1.8-5 2.7-10.4 2.7-16c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 5.6 1 11 2.7 16L128 64c-17.7 0-32 14.3-32 32l0 48 0 9.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3l0-9.7 0-48c0-17.7-14.3-32-32-32l-18.7 0zm24.6 112c23 11.2 43 27.7 58.2 48L64 224c15.2-20.3 35.2-36.8 58.2-48l5.8 0 128 0 5.8 0zM192 96l64 0 0 48-128 0 0-48 64 0zM32 320c0-22.8 4.8-44.4 13.3-64l293.4 0c8.6 19.6 13.3 41.2 13.3 64s-4.7 44.4-13.3 64L45.3 384C36.8 364.4 32 342.8 32 320zM192 480c-52.3 0-98.8-25.1-128-64l256 0c-29.2 38.9-75.7 64-128 64z'
      
    ]
  };

  

  
  

  var faFileXml = {
    prefix: 'fal',
    iconName: 'file-xml',
    icon: [
      512,
      512,
      [],
      'e654',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM192 368c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L227.2 432l17.2 25.8C252 469.1 256 482.4 256 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L208 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L188.8 432l-17.2-25.8C164 394.9 160 381.6 160 368c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 496l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM299.7 352.6c6.9-1.9 14.3 1 18 7.2L352 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-2.9-13.7-7.8L320 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4z'
      
    ]
  };

  

  
  

  var faCarSideBolt = {
    prefix: 'fal',
    iconName: 'car-side-bolt',
    icon: [
      640,
      512,
      [],
      'e344',
      
      'M126.8 94.2L87.6 192l72.4 0 0 32-96 0c-17.7 0-32 14.3-32 32l0 112 33.3 0c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80l130.7 0c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80l33.3 0 0-48c0-53-43-96-96-96l-64 0 0-32 30.7 0-88-110c-9.1-11.4-22.9-18-37.5-18L171.3 64c-19.6 0-37.3 11.9-44.6 30.2zM52.8 193L97.1 82.3C109.2 51.9 138.6 32 171.3 32l181.9 0c24.3 0 47.3 11 62.5 30L519.9 192.2C586.9 196.3 640 252 640 320l0 48c0 17.7-14.3 32-32 32l-33.3 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80l-130.7 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80L32 400c-17.7 0-32-14.3-32-32L0 256c0-31.5 22.8-57.7 52.8-63zM418 368c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zM96 384c0 5.5 .7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48c-1.3 5.1-2 10.5-2 16zM347.3 123.3L278.6 192l89.4 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 224 240 224c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBrightness = {
    prefix: 'fal',
    iconName: 'brightness',
    icon: [
      512,
      512,
      [],
      'e0c9',
      
      'M240 104c0 8.8 7.2 16 16 16s16-7.2 16-16l0-88c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 88zm16 88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 160c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16zM0 256c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm408-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l88 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-88 0zM75 437c6.2 6.2 16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L75 414.4c-6.2 6.2-6.2 16.4 0 22.6zM352.2 137.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L437 97.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-62.2 62.2zM75 75c-6.2 6.2-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L97.6 75c-6.2-6.2-16.4-6.2-22.6 0zM374.8 352.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L414.4 437c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2z'
      
    ]
  };

  

  
  

  var faBoxCircleCheck = {
    prefix: 'fal',
    iconName: 'box-circle-check',
    icon: [
      576,
      512,
      [],
      'e0c4',
      
      'M240 64l102.4 0c12.6 0 24.1 7.4 29.2 19l34.2 77L240 160l0-96zm0 128l112 0 64 0 16 0 16 0 0-2.4c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l232.2 0c-8.1-9.8-15.2-20.6-21-32L64 448c-17.7 0-32-14.3-32-32l0-224 176 0 32 0zm-32-32L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19L208 64l0 96zm224 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faShowerDown = {
    prefix: 'fal',
    iconName: 'shower-down',
    icon: [
      384,
      512,
      ["shower-alt"],
      'e24d',
      
      'M192 0c8.8 0 16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0L48 224l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0C32 109 95.1 40.8 176 32.8L176 16c0-8.8 7.2-16 16-16zm0 64C121.3 64 64 121.3 64 192l256 0c0-70.7-57.3-128-128-128zm50.7 388.9c-1.8 2.8-2.7 6.1-2.7 9.4l0 1.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-1.7c0-3.3-.9-6.6-2.7-9.4L256 431.6l-13.3 21.3zm-27.1-17l28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4l0 1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-1.7c0-9.3 2.6-18.5 7.6-26.4zM320 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4l0 1.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-1.7c0-3.3-.9-6.6-2.7-9.4L320 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4l0 1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM114.7 452.9c-1.8 2.8-2.7 6.1-2.7 9.4l0 1.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-1.7c0-3.3-.9-6.6-2.7-9.4L128 431.6l-13.3 21.3zm-27.1-17l28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4l0 1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-1.7c0-9.3 2.6-18.5 7.6-26.4zM192 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4l0 1.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-1.7c0-3.3-.9-6.6-2.7-9.4L192 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4l0 1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM50.7 324.9c-1.8 2.8-2.7 6.1-2.7 9.4l0 1.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-1.7c0-3.3-.9-6.6-2.7-9.4L64 303.6 50.7 324.9zm-27.1-17l28.2-45.1C54.4 258.6 59 256 64 256s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4l0 1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-1.7c0-9.3 2.6-18.5 7.6-26.4z'
      
    ]
  };

  
    var faShowerAlt = faShowerDown;
  

  
  

  var faPersonDigging = {
    prefix: 'fal',
    iconName: 'person-digging',
    icon: [
      576,
      512,
      ["digging"],
      'f85e',
      
      'M256 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM440.1 322.2L373.9 439.8c-2.8 5-8.2 8.2-13.9 8.2l-46.1 0-16 32 235.5 0L440.1 322.2zm-26.1-18.9c5.3-9.4 15.2-15.2 26-15.2c10.6 0 20.3 5.6 25.7 14.7L564 468.9c2.6 4.4 4 9.4 4 14.5c0 15.8-12.8 28.6-28.6 28.6l-246.5 0c-16 0-28.9-13-28.9-28.9c0-4.5 1-8.9 3.1-12.9l18.2-36.4c5.4-10.8 16.5-17.7 28.6-17.7l36.8 0 13.8-24.5L24.3 206c-7.8-4.2-10.6-14-6.4-21.7s14-10.6 21.7-6.4l33.6 18.3 13.1-24c14.9-27.4 44.4-43.6 75.6-41.5l13.9 .9c45.9 3.1 85.3 33.9 99.3 77.8l36.2 113.7-3.4 1.1 72.3 39.4 34-60.4zm-142.3 1.3l-27.2-85.4c-10-31.3-38.1-53.4-70.9-55.6l-13.9-.9c-18.7-1.2-36.4 8.5-45.3 24.9l-13.1 24 170.4 92.9zM57.6 289.3c4.6-2 9.8-1.7 14.1 .7l127.5 70.9c15.2 8.5 24.7 24.5 24.7 42l0 93.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-93.2c0-5.8-3.2-11.2-8.2-14L74.5 328.1 31.5 499.9c-2.1 8.6-10.8 13.8-19.4 11.6S-1.7 500.7 .5 492.1l48-192c1.2-4.8 4.6-8.8 9.2-10.8z'
      
    ]
  };

  
    var faDigging = faPersonDigging;
  

  
  

  var faMouseField = {
    prefix: 'fal',
    iconName: 'mouse-field',
    icon: [
      512,
      512,
      [],
      'e5a8',
      
      'M379.4 36.6c6.2-3 13.2-4.6 20.6-4.6c26.5 0 48 21.5 48 48c0 9.6-2.8 18.6-7.7 26.1c-12.5-5.5-26-8.9-40.3-9.8l0-.3c0-22.4-7.7-43-20.6-59.4zm88.2 86.2C475.4 110.4 480 95.7 480 80c0-44.2-35.8-80-80-80c-16.9 0-32.7 5.3-45.6 14.3C339.7 5.2 322.5 0 304 0c-53.1 0-96 43.4-96 96.3c0 25.7 10.2 49.8 27.5 67.5C155.8 180.6 96 251.3 96 336c0 18 6 34.6 16 48l-48 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l400 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l112 0 168 0 12.1 0c24.2 0 43.9-19.7 43.9-43.9c0-18.9-12.1-35.7-30-41.6l-12.8-4.3L378.8 272l85.2 0c26.5 0 48-21.5 48-48l0-8c0-37.6-17.3-71.2-44.4-93.2zM176 384c-26.5 0-48-21.5-48-48c0-79.5 64.5-144 144-144l16 0c7.7 0 14.4-5.5 15.7-13.1s-2.9-15.1-10.1-17.8l-12.1-4.5c-24.9-9.3-41.5-33.4-41.5-60.2C240 60.9 268.7 32 304 32c35.3 0 64 28.7 64 64l0 16c0 8.8 7.2 16 16 16l8 0c48.6 0 88 39.4 88 88l0 8c0 8.8-7.2 16-16 16l-96 0c-6.5 0-12.4 4-14.9 10.1l-26.4 66-33.7-11.2c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l76.9 25.6c4.9 1.6 8.1 6.2 8.1 11.3c0 6.6-5.3 11.9-11.9 11.9L344 384l-168 0zM336 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zm96 108a20 20 0 1 0 -40 0 20 20 0 1 0 40 0z'
      
    ]
  };

  

  
  

  var faCoffeePot = {
    prefix: 'fal',
    iconName: 'coffee-pot',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M80 64c-26.5 0-48 21.5-48 48l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96C0 67.8 35.8 32 80 32l42.4 0 5.6 0 325.6 0C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9l0 8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480L158 480c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344l0-8c0-65.4 32.7-123.2 82.7-157.9L98.3 69.1c-.7-1.6-1.3-3.4-1.7-5.1L80 64zm365 0L131 64l49.8 112 214.4 0L445 64zM416 208l-256 0s0 0 0 0c-26.4 19.9-46.5 47.7-56.7 80l369.4 0c-10.1-32.3-30.2-60.1-56.7-80c0 0 0 0 0 0zm63.2 112L96.8 320c-.5 5.3-.8 10.6-.8 16l0 8c0 42.6 27.2 78.8 46.8 98.8c2.7 2.8 7.7 5.2 15.2 5.2L418 448c7.5 0 12.5-2.4 15.2-5.2c19.6-20 46.8-56.2 46.8-98.8l0-8c0-5.4-.3-10.7-.8-16z'
      
    ]
  };

  

  
  

  var faPenFancy = {
    prefix: 'fal',
    iconName: 'pen-fancy',
    icon: [
      512,
      512,
      [10002,128395],
      'f5ac',
      
      'M392.1 48.7C401.7 38.1 415.3 32 429.6 32C457.4 32 480 54.6 480 82.4c0 14.3-6.1 27.9-16.7 37.5L256.6 306 206 255.4 392.1 48.7zM429.6 0c-23.4 0-45.6 9.9-61.3 27.3L175.1 242 98.9 265.4c-19.8 6.1-35.4 21.3-41.9 40.9L2.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L205.6 455c19.6-6.5 34.9-22.1 40.9-41.9L270 336.9 484.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C512 36.9 475.1 0 429.6 0zM237.9 332.5L216 403.7c-3 9.9-10.7 17.7-20.5 20.9L67.2 467.4 134.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L44.6 444.8 87.4 316.5c3.3-9.8 11.1-17.4 20.9-20.5l71.2-21.9 58.4 58.4z'
      
    ]
  };

  

  
  

  var faChartKanban = {
    prefix: 'fal',
    iconName: 'chart-kanban',
    icon: [
      448,
      512,
      [],
      'e64f',
      
      'M368 448c-8.8 0-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16l-32 0zm-48-16c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 352zM80 384l-32 0c-8.8 0-16-7.2-16-16L32 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16zM48 416l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48zM240 256l-32 0c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16zm-32 32l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48z'
      
    ]
  };

  

  
  

  var faHatWizard = {
    prefix: 'fal',
    iconName: 'hat-wizard',
    icon: [
      512,
      512,
      [],
      'f6e8',
      
      'M408.6 368L348.2 227c-9.3-21.6-10.3-45.9-2.8-68.2l37.3-112L246.5 124.6c-29.6 16.9-53 42.8-66.8 73.9L104.4 368l-35 0 81.1-182.5c16.6-37.4 44.7-68.4 80.2-88.7l165-94.3C398.5 .9 401.7 0 405 0c10.5 0 19 8.5 19 19l0 1.7c0 2.2-.4 4.4-1.1 6.5L375.7 168.9c-5 14.9-4.3 31 1.9 45.4L443.4 368l-34.8 0zM480 456c0-13.3-10.7-24-24-24L56 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24zM56 400l400 0c30.9 0 56 25.1 56 56s-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56s25.1-56 56-56zM288 176l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zM240 304l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0-32 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSquareKanban = {
    prefix: 'fal',
    iconName: 'square-kanban',
    icon: [
      448,
      512,
      [],
      'e488',
      
      'M64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 288c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16zm176 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192zm-80-80c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faGarageCar = {
    prefix: 'fal',
    iconName: 'garage-car',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59L640 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-320.1c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272-384 0 0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272zm156.9 75.1L238.4 344l163.3 0-14.6-44.9c-2.1-6.6-8.3-11.1-15.2-11.1l-103.7 0c-6.9 0-13.1 4.5-15.2 11.1zm164.6-9.9l20.6 63.6c15.6 9.9 25.9 27.4 25.9 47.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-224 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-19.8 10.3-37.3 25.9-47.2l20.6-63.6c6.4-19.8 24.9-33.2 45.7-33.2l103.7 0c20.8 0 39.2 13.4 45.7 33.2zM208 448l224 0 0-48c0-13.3-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24l0 48zm24-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTextWidth = {
    prefix: 'fal',
    iconName: 'text-width',
    icon: [
      448,
      512,
      [],
      'f035',
      
      'M32 32C14.3 32 0 46.3 0 64l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 176 0 0 192-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-192 176 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-17.7-14.3-32-32-32L32 32zM4.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400l338.7 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 368 54.6 368l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80z'
      
    ]
  };

  

  
  

  var faPersonBooth = {
    prefix: 'fal',
    iconName: 'person-booth',
    icon: [
      576,
      512,
      [],
      'f756',
      
      'M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM32 223.4c0 .2 0 .4 0 .6l0 55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6l0-140.4c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28l0 19.4zm0 103L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 280.2c0-.3 0-.7 0-1L0 204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256l63.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-63.3 0c-10.9 0-21-5.5-26.9-14.7L112 214.5l0 128.1L146.1 366c8.7 6 13.9 15.8 13.9 26.4L160 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-103.6-96-66zM256 32c-8.8 0-16 7.2-16 16l0 176-32 0 0-176c0-26.5 21.5-48 48-48l24 0L528 0c26.5 0 48 21.5 48 48l0 336 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-56.6c-9.4 5.4-20.3 8.6-32 8.6c-15.1 0-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14s-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14c-35.3 0-64-28.7-64-64l0-2.9c0-10.8 2.2-21.6 6.5-31.5L335 255 268.1 32 256 32zm45.5 0l65.8 219.4c1.1 3.6 .9 7.5-.6 10.9l-42.8 99.9c-2.6 6-3.9 12.4-3.9 18.9l0 2.9c0 17.7 14.3 32 32 32c11.1 0 20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3s20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3c17.7 0 32-14.3 32-32l0-336c0-8.8-7.2-16-16-16L301.5 32zM240 320l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176 32 0z'
      
    ]
  };

  

  
  

  var faBanBug = {
    prefix: 'fal',
    iconName: 'ban-bug',
    icon: [
      512,
      512,
      ["debug"],
      'f7f9',
      
      'M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm79.5-167.1c.3-2.9 .5-5.9 .5-8.9l0-5.9 46 5.8c8.8 1.1 16.8-5.1 17.9-13.9s-5.1-16.8-13.9-17.9l-50-6.2 0-21.4 51.9-13c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-44.1 11 0-3.5c0-7.4-1-14.7-2.9-21.5l43.8-29.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-40.8 27.2C303.7 139.7 281.2 128 256 128c-28.6 0-53.7 15-67.8 37.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l-89.8-89.8zM304 281.4l-92.2-92.2C219.1 172 236.2 160 256 160c26.5 0 48 21.5 48 48l0 23.7 0 .5 0 47.7c0 0 0 0 0 .1l0 1.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 265.9l-50 6.2c-8.8 1.1-15 9.1-13.9 17.9s9.1 15 17.9 13.9l46-5.8 0 5.9c0 7.4 1 14.7 2.9 21.5l-43.8 29.2c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l40.8-27.2C208.3 372.3 230.8 384 256 384c17 0 32.8-5.3 45.8-14.4l-23.2-23.2c-6.7 3.6-14.4 5.6-22.5 5.6c-26.5 0-48-21.5-48-48l0-23.7c0-.2 0-.4 0-.7l0-3.8-32-32 0 22z'
      
    ]
  };

  
    var faDebug = faBanBug;
  

  
  

  var faBridgeWater = {
    prefix: 'fal',
    iconName: 'bridge-water',
    icon: [
      576,
      512,
      [],
      'e4ce',
      
      'M544 96L32 96l0 80.1c53.3 1.9 96 45.7 96 99.5l0 85.5c-9.9-5.7-21-8.6-32-8.6l0-76.9C96 238.2 65.8 208 28.4 208C12.7 208 0 195.3 0 179.6L0 96C0 78.3 14.3 64 32 64l512 0c17.7 0 32 14.3 32 32l0 83.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6l0 76.9c-11 0-22.1 2.8-32 8.6l0-85.5c0-53.8 42.7-97.6 96-99.5L544 96zM192 384.5s0 0 0 0L192 272c0-53 43-96 96-96s96 43 96 96l0 112.5c-10.4 0-21.3-2.2-32-6.1L352 272c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 106.4c-10.3 3.8-21.1 6.1-32 6.1zm0 63.5c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z'
      
    ]
  };

  

  
  

  var faVentDamper = {
    prefix: 'fal',
    iconName: 'vent-damper',
    icon: [
      640,
      512,
      [],
      'e465',
      
      'M512 96L128 96c-17.7 0-32 14.3-32 32l0 16 0 224 0 16c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-16 0-224 0-16c0-17.7-14.3-32-32-32zM48 128l16 0c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l16 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-16 0c0 35.3-28.7 64-64 64l-384 0c-35.3 0-64-28.7-64-64l-16 0c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48zM592 352c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-16 0 0 192 16 0zM48 352l16 0 0-192-16 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16zM176 160l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFileFragment = {
    prefix: 'fal',
    iconName: 'file-fragment',
    icon: [
      384,
      512,
      [],
      'e697',
      
      'M352 448c0 17.7-14.3 32-32 32l-96 0 0 32 96 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0C28.7 0 0 28.7 0 64L0 288l32 0L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256zm-.5-288L240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM32 352l128 0 0 128L32 480l0-128zM0 352L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L32 320c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faMosquitoNet = {
    prefix: 'fal',
    iconName: 'mosquito-net',
    icon: [
      640,
      512,
      [],
      'e52c',
      
      'M161.7 440.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c1.1-2.2 1.7-4.7 1.7-7.2l0-41.4 20-20 0 38c0 24.3 19.7 44 44 44s44-19.7 44-44l0-38 30.9 30.9c3-3.7 6.6-6.9 10.6-9.5c-12.9-8.6-21.5-23.3-21.5-40c0-2.1 .1-4.2 .4-6.2L332 277.4l0-24.7 28.2 24.5c6.1-9.1 15.2-15.9 25.9-19.2l.2-.6-51.8-45.1 86.3 12.9c3.6-.9 7.3-1.3 11.2-1.3c8.9 0 17.2 2.4 24.3 6.6l25.8 3.8c8.2-6.5 18.6-10.5 29.9-10.5c16.7 0 31.4 8.5 40 21.5c2.1-3.1 4.5-6 7.3-8.6c-12.9-16.9-32.2-28.6-54.7-31.4L344.7 181.6l49.6-41.3c5.1-4.2 7-11.1 4.9-17.4L385.3 81.2l29-58.1c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-32 64c-1.9 3.8-2.2 8.2-.9 12.2l12.5 37.6L332 150.5l0-12.6c0-21.5-15.4-39.4-35.8-43.2l0-31c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2l0 31c-20.4 3.8-35.8 21.7-35.8 43.2l0 12.6-33.4-27.8 12.5-37.6c1.3-4 1-8.4-.9-12.2l-32-64c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l29 58.1-13.9 41.7c-2.1 6.2-.1 13.1 4.9 17.4l49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L244 252.7l0 24.7-47.3 47.3c-3 3-4.7 7.1-4.7 11.3l0 44.2-30.3 60.6zm-43.5-121c-.6 .5-1.1 1-1.6 1.5c-31.2 31.2-84.6 9.1-84.6-35c0-25 18.6-46 43.4-49.1l.8-.1 165.4-24.7L118.2 319.8zM528 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-48 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 48-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 48-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-48 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-48 0 0-16zm0 48l48 0 0 48-48 0 0-48zm0 80l48 0 0 48-48 0 0-48zm-80-32l0-48 48 0 0 48-48 0zm0 80l0-48 48 0 0 48-48 0zM272 360.6l0-222.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 222.7c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faRocketLaunch = {
    prefix: 'fal',
    iconName: 'rocket-launch',
    icon: [
      512,
      512,
      [128640],
      'e027',
      
      'M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C215.6 146.3 269 86.7 321.1 58.1c53.5-29.4 111.4-29.4 154.6-21.8c7.6 43.2 7.7 101.1-21.8 154.6C425.3 243 365.7 296.4 243.4 326.5c-6-12.4-14.1-23.9-24.1-33.8zM256 381.3c0-8.2-.8-16.3-2.4-24.3c37.8-9.5 70.4-21.3 98.4-34.7l0 80.1c0 12.1-6.8 23.2-17.7 28.6L256 470.1l0-88.9zm128 21.1l0-97.4C515.7 225.1 520.5 102.5 506.7 28.1c-2.2-11.6-11.2-20.7-22.8-22.8C409.5-8.5 286.9-3.7 207 128l-97.4 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l114.7 0c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2zm-229-144c-7.9-1.6-16.1-2.4-24.3-2.4l-88.9 0L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7l80.1 0c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-11 11-29.4 19.4-52.6 24.9c-20.6 4.9-42.1 6.8-59 7.4c.6-17 2.5-38.4 7.4-59c5.5-23.2 13.9-41.6 24.9-52.6c21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngine = {
    prefix: 'fal',
    iconName: 'starfighter-twin-ion-engine',
    icon: [
      576,
      512,
      ["starfighter-alt"],
      'e038',
      
      'M16 32c8.8 0 16 7.2 16 16l0 149.1 116.4-19.4C175.8 128.9 228.1 96 288 96s112.2 32.9 139.6 81.7L544 197.1 544 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 154.4 0 13.6 0 80 0 13.6L576 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-149.1L427.6 334.3C400.2 383.1 347.9 416 288 416s-112.2-32.9-139.6-81.7L32 314.9 32 464c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 309.6 0 296l0-80 0-13.6L0 48c0-8.8 7.2-16 16-16zM448 256c0 15.1-2.1 29.6-6 43.4l102-17 0-52.9-102-17c3.9 13.8 6 28.4 6 43.4zM32 282.4l102 17c-3.9-13.8-6-28.4-6-43.4s2.1-29.6 6-43.4l-102 17 0 52.9zM416 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM226 272l-34 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l34 0c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8l0-34c0-8.8 7.2-16 16-16s16 7.2 16 16l0 34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5l34 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34 0c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8l0 34c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-34c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5zm62 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faStarfighterAlt = faStarfighterTwinIonEngine;
  

  
  

  var faDiceSix = {
    prefix: 'fal',
    iconName: 'dice-six',
    icon: [
      448,
      512,
      [9861],
      'f526',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngineAdvanced = {
    prefix: 'fal',
    iconName: 'starfighter-twin-ion-engine-advanced',
    icon: [
      640,
      512,
      ["starfighter-alt-advanced"],
      'e28e',
      
      'M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L36.7 145.9c-3 3-4.7 7.1-4.7 11.3l0 40.4 148.6-20.3C208.1 128.8 260.2 96 320 96s111.9 32.8 139.4 81.4L608 197.7l0-40.4c0-4.2-1.7-8.3-4.7-11.3L484.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L625.9 123.3c9 9 14.1 21.2 14.1 33.9l0 44.8 0 14 0 80 0 14 0 44.8c0 12.7-5.1 24.9-14.1 33.9L507.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L603.3 366.1c3-3 4.7-7.1 4.7-11.3l0-40.4L459.4 334.6C431.9 383.2 379.8 416 320 416s-111.9-32.8-139.4-81.4L32 314.3l0 40.4c0 4.2 1.7 8.3 4.7 11.3L155.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L14.1 388.7c-9-9-14.1-21.2-14.1-33.9L0 310l0-14 0-80 0-14 0-44.8c0-12.7 5.1-24.9 14.1-33.9L132.7 4.7zm341.1 207c4.1 14.1 6.2 29 6.2 44.3s-2.2 30.3-6.2 44.3L608 282l0-52.1L473.8 211.7zM32 282l134.2 18.3c-4.1-14.1-6.2-29-6.2-44.3s2.2-30.3 6.2-44.3L32 230 32 282zM320 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-16-66c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5l-34 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l34 0c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8l0-34c0-8.8 7.2-16 16-16s16 7.2 16 16l0 34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5l34 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34 0c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8l0 34c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-34zm16-30a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
  

  
  

  var faShieldVirus = {
    prefix: 'fal',
    iconName: 'shield-virus',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm76.8 311.4C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM172.5 240a83.5 83.5 0 1 1 167.1 0 83.5 83.5 0 1 1 -167.1 0zm67.5 8a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 24a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faConveyorBeltBoxes = {
    prefix: 'fal',
    iconName: 'conveyor-belt-boxes',
    icon: [
      640,
      512,
      ["conveyor-belt-alt"],
      'f46f',
      
      'M304 32c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16L96 48c0-8.8 7.2-16 16-16l192 0zM112 0C85.5 0 64 21.5 64 48l0 192c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48L112 0zM528 96c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l96 0zM432 64c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-96 0zM608 416c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64s28.7-64 64-64l448 0c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faConveyorBeltAlt = faConveyorBeltBoxes;
  

  
  

  var faLaptopMobile = {
    prefix: 'fal',
    iconName: 'laptop-mobile',
    icon: [
      640,
      512,
      ["phone-laptop"],
      'f87a',
      
      'M128 32l320 0c17.7 0 32 14.3 32 32l0 32 32 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384L352 384l0-32L76.8 352c-20.3 0-37.4-13.5-42.9-32L64 320l32 0 256 0 0-32L96 288 96 64c0-17.7 14.3-32 32-32zM608 464c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 288zM432 512l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48z'
      
    ]
  };

  
    var faPhoneLaptop = faLaptopMobile;
  

  
  

  var faDoorClosed = {
    prefix: 'fal',
    iconName: 'door-closed',
    icon: [
      576,
      512,
      [128682],
      'f52a',
      
      'M416 32c17.7 0 32 14.3 32 32l0 416-320 0 0-416c0-17.7 14.3-32 32-32l256 0zm64 448l0-416c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 416-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 32 0 320 0 32 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0zM408 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faDialLow = {
    prefix: 'fal',
    iconName: 'dial-low',
    icon: [
      576,
      512,
      [],
      'e15d',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 360c-65.3 0-119.1-48.9-127-112l127 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-127 0c7.9-63.1 61.7-112 127-112c70.7 0 128 57.3 128 128s-57.3 128-128 128zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm440 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fal',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      'M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3l0 129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7l129 0c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3l0-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7l-129 0zM256 128c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fal',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      'M448 48c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L416 192l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-144zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM428 392a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c.4 0 .9 0 1.3 0l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5C504.4 385.8 512 365.2 512 344c0 0-.1 0-.1 0c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84z'
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faPipeCircleCheck = {
    prefix: 'fal',
    iconName: 'pipe-circle-check',
    icon: [
      640,
      512,
      [],
      'e436',
      
      'M16 96c8.8 0 16 7.2 16 16l0 16 224 0 192 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 48.7c-11 1-21.7 3-32 5.9l0-38.6-192 0L32 160l0 192 288.7 0c-.5 5.3-.7 10.6-.7 16s.2 10.7 .7 16L32 384l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32L0 144l0-32c0-8.8 7.2-16 16-16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faUserGear = {
    prefix: 'fal',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480l319 0c15.6 13.1 36.9 13.7 53 4.8l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-1.6 13.7 3.2 26.6 11.6 36.1c-14.5-4.8-30-7.4-46.2-7.4l-91.4 0c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM463.3 238.4c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5C386.3 320.7 392 337 392 351.7s-5.7 31-18.5 42.4l17.2 30.5c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7l33.7 0c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6C510.8 268 499.9 255 497 238.4l-33.7 0zm43.5-32c11.8 0 21.4 9.6 21.4 21.4l0 1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 301.7c5.7 10.2 2.3 23.1-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29l-26.4 46.9c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18l0 1.6c0 11.8-9.6 21.4-21.4 21.4l-53.4 0c-11.7 0-21.3-9.5-21.3-21.3l0-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.8-14.7-4.2-21.2-.3l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 401.7c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2l0-1.4c0-11.7 9.5-21.3 21.3-21.3l53.4 0zM424.1 351.7a56 56 0 1 1 112.1 0 56 56 0 1 1 -112.1 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faPuzzle = {
    prefix: 'fal',
    iconName: 'puzzle',
    icon: [
      512,
      512,
      [],
      'e443',
      
      'M320 0c-17.7 0-32 14.3-32 32l0 24c0 17.7 14.3 32 32 32l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-17.7 0-32 14.3-32 32l0 24c0 17.7 14.3 32 32 32l32 0c0 26.5 21.5 48 48 48s48-21.5 48-48l32 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L320 0zm0 32l128 0c17.7 0 32 14.3 32 32l0 112-48 0c-8.8 0-16 7.2-16 16l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-24 16 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-16 0 0-24zM64 64C28.7 64 0 92.7 0 128L0 288 0 448c0 35.3 28.7 64 64 64l160 0 160 0c35.3 0 64-28.7 64-64l0-144c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32l-32 0 0-176c0-17.7-14.3-32-32-32L64 64zM208 96l0 176-32 0 0-16c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 16-48 0 0-144c0-17.7 14.3-32 32-32l144 0zM80 304c17.7 0 32-14.3 32-32l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 17.7 14.3 32 32 32l32 0 0 32-16 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l16 0 0 48L64 480c-17.7 0-32-14.3-32-32l0-144 48 0zM240 432c0-17.7-14.3-32-32-32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c17.7 0 32-14.3 32-32l0-32 32 0 0 16c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16 48 0 0 144c0 17.7-14.3 32-32 32l-144 0 0-48z'
      
    ]
  };

  

  
  

  var faSquareHeart = {
    prefix: 'fal',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm99.9 68.9c27.8-28.2 71.9-29.7 101.5-4.6c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9c29.6-25.1 73.7-23.6 101.5 4.6c29.4 29.8 29.4 78.2 0 108L246.5 376.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 272.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L224 353.3 325.3 250.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0l-29.1 29.6c-6.3 6.4-16.5 6.4-22.8 0l-29.1-29.6z'
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSquare5 = {
    prefix: 'fal',
    iconName: 'square-5',
    icon: [
      448,
      512,
      [],
      'e25a',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm176 32l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-99.5 0L172 225.9l80.4 8.1c38.4 3.9 67.6 36.2 67.6 74.8c0 41.5-33.7 75.2-75.2 75.2l-44 0c-27.4 0-53-13.7-68.3-36.4l-1.8-2.7c-4.9-7.3-3-17.3 4.4-22.2s17.3-3 22.2 4.4l1.8 2.7c9.3 13.9 25 22.3 41.8 22.3l44 0c23.8 0 43.2-19.3 43.2-43.2c0-22.2-16.8-40.7-38.8-42.9l-98.8-10c-4.6-.5-8.8-2.9-11.5-6.7s-3.6-8.6-2.4-13.1l24-96c1.8-7.1 8.2-12.1 15.5-12.1z'
      
    ]
  };

  

  
  

  var faHouseBlank = {
    prefix: 'fal',
    iconName: 'house-blank',
    icon: [
      576,
      512,
      ["home-blank"],
      'e487',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM96 206.7L96 432c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7z'
      
    ]
  };

  
    var faHomeBlank = faHouseBlank;
  

  
  

  var faLightbulbSlash = {
    prefix: 'fal',
    iconName: 'lightbulb-slash',
    icon: [
      640,
      512,
      [],
      'f673',
      
      'M438.3 258.1c-3.3 4.7-6.9 9.7-10.7 15l25.2 19.9c4-5.5 8-11 11.8-16.6c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C260.6 0 208 29.4 176.2 74.5l25.2 19.9C227.3 56.7 270.8 32 320 32c79.5 0 144 64.5 144 144c0 30.6-9.5 58.8-25.7 82.1zM226.5 114.3l25.2 19.9C265.8 111.3 291.1 96 320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39 0-73.4 20-93.5 50.3zm-25.4 143l-52.6-41.6c5.1 22.1 14.3 42.5 26.9 60.5c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l32.4 0c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1c0 0 0 0 0 0c-4.9-6.7-9.5-13-13.6-19l-.5-.7zM274.7 448l90.5 0c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM240 432c0 44.2 35.8 80 80 80s80-35.8 80-80l0-5.3c0-5.9-4.8-10.7-10.7-10.7l-138.7 0c-5.9 0-10.7 4.8-10.7 10.7l0 5.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faBooksMedical = {
    prefix: 'fal',
    iconName: 'books-medical',
    icon: [
      576,
      512,
      [],
      'f7e8',
      
      'M192 464c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-48 96 0 0 48zm-16 48c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2l64 0c26.5 0 48-21.5 48-48l0-48 0-16 0-16 0-190.2 51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C464 9.9 438.6-5.2 413.9 1.6L354.3 18.1c-3.5 1-6.8 2.3-9.9 4C335.9 8.8 321 0 304 0L240 0c-12.3 0-23.5 4.6-32 12.2C199.5 4.6 188.3 0 176 0L112 0C85.5 0 64 21.5 64 48l0 48 0 16 0 16 32 0 80 0 16 0 0 48 32 0 0-48 96 0 0 256-96 0 0-48-32 0 0 48-16 0-80 0-32 0 0 16 0 16 0 48c0 26.5 21.5 48 48 48l64 0zM352 64.8l0-1.3c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L352.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6c0 0 0 0 0 0L320 96l-96 0 0-48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16.2zM240 480c-8.8 0-16-7.2-16-16l0-48 96 0 0 48c0 8.8-7.2 16-16 16l-64 0zM192 48l0 48L96 96l0-48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16zm269.7 80.7l59.8 230.5-87.3 24.2L374.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2zM80 160c-17.7 0-32 14.3-32 32l0 16-16 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l16 0 0 16c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-16 16 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-16 0 0-16c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32c0 8.8 7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16l-32 0 0-32 32 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-32z'
      
    ]
  };

  

  
  

  var faKeyboardBrightness = {
    prefix: 'fal',
    iconName: 'keyboard-brightness',
    icon: [
      640,
      512,
      [],
      'e1c0',
      
      'M115.3 172.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88zM304 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128zm132.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l88-88c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-88 88zM0 400c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faHeadSideVirus = {
    prefix: 'fal',
    iconName: 'head-side-virus',
    icon: [
      512,
      512,
      [],
      'e064',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm293.8 63.2C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM307.5 208c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c6.6 7.8 14.8 13.9 24 18.1c10.9 5 23 7.3 35.1 6.3c-1.8 22.3 7.4 44.6 24.5 59.1zM208 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 24a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faRectangleCode = {
    prefix: 'fal',
    iconName: 'rectangle-code',
    icon: [
      512,
      512,
      [],
      'e322',
      
      'M448 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM293.4 172c-6.6 5.9-7.2 16-1.3 22.6L346.6 256 292 317.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM220 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L165.4 256 220 194.6z'
      
    ]
  };

  

  
  

  var faTrafficLightSlow = {
    prefix: 'fal',
    iconName: 'traffic-light-slow',
    icon: [
      320,
      512,
      [],
      'f639',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 70.7 57.3 128 128 128s128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0-136a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faKiwiFruit = {
    prefix: 'fal',
    iconName: 'kiwi-fruit',
    icon: [
      448,
      512,
      [],
      'e30c',
      
      'M416 176c0-25.2-15.9-52.4-50.9-74.9C330.4 78.8 280.6 64 224 64s-106.4 14.8-141.1 37.1C47.9 123.6 32 150.8 32 176s15.9 52.4 50.9 74.9C117.6 273.2 167.4 288 224 288s106.4-14.8 141.1-37.1c35-22.5 50.9-49.7 50.9-74.9zm32 0l0 80c0 123.7-100.3 224-224 224S0 379.7 0 256l0-80C0 96.5 100.3 32 224 32s224 64.5 224 144zm-32 74.2C376.8 292 305.5 320 224 320s-152.8-28-192-69.8l0 5.8c0 106 86 192 192 192s192-86 192-192l0-5.8zM280 176c0 13.3-25.1 24-56 24s-56-10.7-56-24s25.1-24 56-24s56 10.7 56 24zM240 88l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16zm-84.7 12.7l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm160 0c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zM96 160l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM171.3 235.3l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm128-22.6l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM240 240l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faPawClaws = {
    prefix: 'fal',
    iconName: 'paw-claws',
    icon: [
      512,
      512,
      [],
      'f702',
      
      'M313.7 8.8c-4 7.9-.7 17.5 7.2 21.5c8.5 4.2 21.6 15.4 31.8 34c-30-3.5-62.2 21.7-75.2 60.5c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1c0 0 0 0 0 0c0-69.9-37.9-112.8-64.8-126.3c-7.9-4-17.5-.7-21.5 7.2zM307.9 135c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1c-3.5-10.3-4-24.7 1.2-40.2zM205.4 175.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1s4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8c-13-38.8-45.2-64-75.2-60.5c10.2-18.6 23.3-29.8 31.8-34c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C149.9 15.2 112 58.1 112 128c0 0 0 0 0 0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5zm-122.1 54c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1C85.9 205.6 61.7 191.1 40.2 192c10.4-28.1 28.3-44.4 39-49.7c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C37.9 127.2 0 170.1 0 240c0 0 0 0 0 0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3zM256 288c25.7 0 108.2 25.4 156.8 156.3c2.1 5.7 3.2 12.2 3.2 19.4l0 4.4c0 6.6-5.3 11.9-11.9 11.9c-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5c-6.6 0-11.9-5.3-11.9-11.9l0-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 313.4 230.3 288 256 288zm0-32c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5l0 4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 506c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9l0-4.4c0-10.4-1.6-20.7-5.2-30.5C390.4 291.9 297.3 256 256 256zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3c-.9-7.7 .8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4c0 0 0 0 0 0c0-69.9-37.9-112.8-64.8-126.3c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5c10.7 5.3 28.6 21.6 39 49.7c-21.5-1-45.7 13.6-60.2 38.5z'
      
    ]
  };

  

  
  

  var faBorderInner = {
    prefix: 'fal',
    iconName: 'border-inner',
    icon: [
      448,
      512,
      [],
      'f84e',
      
      'M224 480c-8.8 0-16-7.2-16-16l0-192L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0 0-192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0 0 192c0 8.8-7.2 16-16 16zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM8 64a24 24 0 1 1 48 0A24 24 0 1 1 8 64zm288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faToothbrush = {
    prefix: 'fal',
    iconName: 'toothbrush',
    icon: [
      576,
      512,
      [129701],
      'f635',
      
      'M64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c24.8 0 45.1-9.9 57.7-28.9c6.6-10.1 10.1-21.2 11.9-31.6c14.8 3.6 27.9 9.7 37.9 17.8C408.3 95.7 416 109.4 416 128c0 35.3-28.7 64-64 64L64 192zM0 160c0 35.3 28.7 64 64 64l288 0c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48L64 96C28.7 96 0 124.7 0 160zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 64 0 64 0 64 0 64 0 64 0 192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-32 0 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-32 0 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-32 0 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-32 0 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176-32 0 0-176z'
      
    ]
  };

  

  
  

  var faCalendarCirclePlus = {
    prefix: 'fal',
    iconName: 'calendar-circle-plus',
    icon: [
      576,
      512,
      [],
      'e470',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l266.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256 320 0 64 0 16 0 16 0 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faRampLoading = {
    prefix: 'fal',
    iconName: 'ramp-loading',
    icon: [
      448,
      512,
      [],
      'f4d4',
      
      'M96 32l256 0c17.7 0 32 14.3 32 32l0 277.7 32 58.7L416 64c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 336.4 32-58.7L64 64c0-17.7 14.3-32 32-32zm67.1 256c-17.6 0-33.8 9.6-42.2 25.1L38.7 464.8C27.2 486.1 42.6 512 66.9 512l314.3 0c24.2 0 39.7-25.9 28.1-47.2L327.1 313.1c-8.4-15.5-24.6-25.1-42.2-25.1l-121.9 0zM149 328.4c2.8-5.2 8.2-8.4 14.1-8.4l121.9 0c5.9 0 11.3 3.2 14.1 8.4L381.1 480 66.9 480 149 328.4z'
      
    ]
  };

  

  
  

  var faNarwhal = {
    prefix: 'fal',
    iconName: 'narwhal',
    icon: [
      640,
      512,
      [],
      'f6fe',
      
      'M630.6 1.4c8 3.7 11.6 13.1 7.9 21.2L562.2 190.6C609 222.3 640 275.6 640 336c0 97.2-78.8 176-176 176l-224 0c-88.4 0-160-71.6-160-160l0-23.7L80 280l0-15.7L34.1 232.2C12.7 217.2 0 192.8 0 166.7L0 112c0-6 3.3-11.4 8.6-14.2s11.7-2.3 16.6 1.1L96 148.5l70.8-49.6c4.9-3.4 11.3-3.8 16.6-1.1s8.6 8.2 8.6 14.2l0 54.7c0 26.1-12.7 50.6-34.1 65.5L112 264.3l0 15.7 0 48.3c0 13.1 10.6 23.7 23.7 23.7c5.4 0 10.6-1.8 14.8-5.2L323.1 208.7c39.4-31.6 89.1-48.7 139.6-48.7c25.4 0 49.6 5.4 71.5 15L609.4 9.4c3.7-8 13.1-11.6 21.2-7.9zM464 480c79.5 0 144-64.5 144-144c0-79.2-65.5-144-145.4-144c-43.3 0-85.9 14.8-119.6 41.7L170.5 371.8c-9.9 7.9-22.1 12.2-34.8 12.2c-7.3 0-14.2-1.4-20.6-3.9C127.9 437.3 178.9 480 240 480l224 0zm40-208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 166.7c0 15.7 7.6 30.3 20.5 39.3L96 236.5 139.5 206c12.8-9 20.5-23.7 20.5-39.3l0-23.9-54.8 38.4c-5.5 3.9-12.8 3.9-18.4 0L32 142.7l0 23.9z'
      
    ]
  };

  

  
  

  var faTableLayout = {
    prefix: 'fal',
    iconName: 'table-layout',
    icon: [
      512,
      512,
      [],
      'e290',
      
      'M448 64c17.7 0 32 14.3 32 32l0 64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 128 0 0 256-96 0c-17.7 0-32-14.3-32-32zm160 32l0-256 288 0 0 224c0 17.7-14.3 32-32 32l-256 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  

  
  

  var faChildReaching = {
    prefix: 'fal',
    iconName: 'child-reaching',
    icon: [
      384,
      512,
      [],
      'e59d',
      
      'M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM112 188c-27.8-14.9-51.4-37.4-67.5-65.8L34.1 103.9c-4.4-7.7-1.7-17.5 6-21.8s17.5-1.7 21.8 6l10.4 18.3c24.4 43 70.1 69.6 119.5 69.6c48.9 0 94.1-26 118.7-68.2l11.6-19.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9l-11.6 19.9c-16 27.5-39.1 49.4-66.2 63.9L272 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-96 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-308zm32 13.1L144 352l96 0 0-151c-15.4 4.6-31.6 7-48.1 7c-16.4 0-32.5-2.4-47.9-6.9z'
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fal',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM299.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L201.4 336l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 358.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L246.6 336l52.7-52.7z'
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faComputerMouseScrollwheel = {
    prefix: 'fal',
    iconName: 'computer-mouse-scrollwheel',
    icon: [
      384,
      512,
      ["mouse-alt"],
      'f8cd',
      
      'M352 352l0-192c0-70.7-57.3-128-128-128l-64 0C89.3 32 32 89.3 32 160l0 192c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128zM0 160C0 71.6 71.6 0 160 0l64 0c88.4 0 160 71.6 160 160l0 192c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 160zm208-48l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faMouseAlt = faComputerMouseScrollwheel;
  

  
  

  var faPhone = {
    prefix: 'fal',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      'M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z'
      
    ]
  };

  

  
  

  var faFaceGrinTears = {
    prefix: 'fal',
    iconName: 'face-grin-tears',
    icon: [
      640,
      512,
      [128514,"grin-tears"],
      'f588',
      
      'M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2zm19.5 200c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512s171.3-47.7 216.6-119.5c4.7-7.5 2.5-17.4-5-22.1s-17.4-2.5-22.1 5C469.8 438.3 399.8 480 320 480s-149.8-41.7-189.5-104.5zM320 354.1c31.2 0 61.4-2.9 89.9-8.3c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3zm142.8-30.7c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7zm-242.4-129c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 161.9 258.8 152 240 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 161.9 418.8 152 400 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm180.1 39.7c7.5 1.2 15.4 2.7 23 4.4c9.2 2.1 17.3 4.4 23.5 6.8c5 1.9 7.3 3.3 8 3.7c.1 .1 .2 .1 .2 .1l0 0c7.2 7.3 9.2 23.4-3.6 36.2c-12.8 12.8-28.8 10.8-36.2 3.6c0 0 0 0 0 0s0-.1-.1-.2c-.4-.6-1.8-2.9-3.7-7.9c-2.4-6.3-4.7-14.4-6.7-23.6c-1.7-7.6-3.2-15.5-4.4-23.1zm-35.5-24.2c2.9 26 11.1 84.8 27.7 101.4c21.6 21.6 58.1 19.9 81.5-3.5s25.1-60 3.5-81.5c-16.6-16.6-75.3-24.9-101.4-27.7c-6.5-.8-12.1 4.9-11.3 11.3zM88 282.6c-2.1 9.2-4.3 17.3-6.7 23.6c-1.9 5-3.3 7.3-3.7 7.9c-.1 .1-.1 .2-.1 .2s0 0 0 0c-7.3 7.2-23.4 9.1-36.2-3.6s-10.8-28.8-3.6-36.2c0 0 0 0 0 0s0 0 0 0s.1 0 .2-.1c.6-.4 2.9-1.8 8-3.7c6.3-2.4 14.4-4.7 23.5-6.8c7.6-1.7 15.5-3.2 23-4.4c-1.2 7.5-2.7 15.4-4.4 23.1zm12.2 54.2c16.6-16.6 24.8-75.4 27.7-101.4c.8-6.5-4.9-12.1-11.3-11.3c-26.1 2.8-84.8 11.1-101.4 27.7c-21.6 21.6-19.9 58.1 3.5 81.5s60 25.1 81.5 3.5z'
      
    ]
  };

  
    var faGrinTears = faFaceGrinTears;
  

  
  

  var faSpinnerThird = {
    prefix: 'fal',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      'M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1c17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9c-3.9 8-1.3 17.7 6.4 22.1z'
      
    ]
  };

  

  
  

  var faLungsVirus = {
    prefix: 'fal',
    iconName: 'lungs-virus',
    icon: [
      640,
      512,
      [],
      'e067',
      
      'M320 0c8.8 0 16 7.2 16 16l0 130.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7L304 16c0-8.8 7.2-16 16-16zm96 181.8c-11-1.3-22.4 1.3-32 7.7l0-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c12.2 1.4 24.9-2 35-10c7 5.5 15.2 9.7 24.2 11.9l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7c31.5 0 57-25.5 57-57l0-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1c-20.6 0-37.3 16.7-37.3 37.3l0 16.5zM234.8 458.2c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3l0 24.1c-9.6-6.4-21-8.9-32-7.7l0-16.5c0-20.6-16.7-37.3-37.3-37.3c-11.8 0-22.8 5.5-29.5 15.1c-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416l0 7c0 31.5 25.5 57 57 57c4.7 0 9.3-.6 13.8-1.7l72.7-18.2c9.1-2.3 17.3-6.4 24.2-11.9c10.2 8 22.8 11.4 35 10zm187-59c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2zM403.5 320a83.5 83.5 0 1 0 -167.1 0 83.5 83.5 0 1 0 167.1 0zM304 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 72a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faUsersBetweenLines = {
    prefix: 'fal',
    iconName: 'users-between-lines',
    icon: [
      640,
      512,
      [],
      'e591',
      
      'M0 16C0 7.2 7.2 0 16 0L624 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 32C7.2 32 0 24.8 0 16zM0 496c0-8.8 7.2-16 16-16l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16zM147.2 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 320l-96 0c-35.3 0-64 28.7-64 64l224 0c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96l96 0c53 0 96 43 96 96c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 320l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l88 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-88 0c-17.7 0-32 14.3-32 32zm480-32l-88 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l88 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faChildDress = {
    prefix: 'fal',
    iconName: 'child-dress',
    icon: [
      320,
      512,
      [],
      'e59c',
      
      'M160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM96 400l-24 0c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9L98 225.8 28.6 313.9c-5.5 6.9-15.5 8.1-22.5 2.7S-2 301 3.4 294.1l74.3-94.2c18.8-23.9 47.1-38.3 77.3-39.8c1.2-.1 2.5-.1 3.7-.1l1.3 0 1.3 0c1.2 0 2.5 0 3.7 .1c30.2 1.5 58.4 15.9 77.3 39.8l74.3 94.2c5.5 6.9 4.3 17-2.7 22.5s-17 4.3-22.5-2.7L222 225.8l41.5 154c1.3 4.8 .3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3l-24 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-64 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm60.8-207.9c-10.1 .8-18.7 7.8-21.4 17.7L92.9 368l134.2 0L184.5 209.8c-2.7-9.9-11.3-16.9-21.4-17.7c-1.1 0-2.1-.1-3.2-.1s-2.1 0-3.2 .1z'
      
    ]
  };

  

  
  

  var faCardClub = {
    prefix: 'fal',
    iconName: 'card-club',
    icon: [
      384,
      512,
      [],
      'e3e9',
      
      'M320 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM208 331.9c7.5 2.7 15.6 4.1 24 4.1c39.8 0 72-32.2 72-72c0-28.3-16.3-52.7-40-64.5c-.3-39.5-32.4-71.5-72-71.5s-71.7 32-72 71.5C96.3 211.3 80 235.7 80 264c0 39.8 32.2 72 72 72c8.4 0 16.5-1.4 24-4.1l0 20.1-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-20.1zM152 200c0-22.1 17.9-40 40-40s40 17.9 40 40c0 2.5-.2 4.9-.6 7.2c-1.5 8.1 3.5 16 11.4 18.3c16.9 4.7 29.2 20.2 29.2 38.5c0 22.1-17.9 40-40 40c-11.2 0-21.3-4.6-28.6-12c-3-3.1-7.1-4.8-11.4-4.8s-8.4 1.7-11.4 4.8c-7.3 7.4-17.4 12-28.6 12c-22.1 0-40-17.9-40-40c0-18.3 12.3-33.8 29.2-38.5c8-2.2 12.9-10.1 11.4-18.3c-.4-2.3-.6-4.7-.6-7.2z'
      
    ]
  };

  

  
  

  var faRulerTriangle = {
    prefix: 'fal',
    iconName: 'ruler-triangle',
    icon: [
      512,
      512,
      [128208],
      'f61c',
      
      'M32 45.3L32 448c0 17.7 14.3 32 32 32l402.7 0c7.3 0 13.3-5.9 13.3-13.3c0-3.5-1.4-6.9-3.9-9.4l-39.4-39.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4L116.7 97.9 91.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L94.1 75.3 54.6 35.9c-2.5-2.5-5.9-3.9-9.4-3.9C37.9 32 32 37.9 32 45.3zm45.3-32L498.7 434.7c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3L64 512c-35.3 0-64-28.7-64-64L0 45.3C0 20.3 20.3 0 45.3 0c12 0 23.5 4.8 32 13.3zm44.6 228c6-2.5 12.9-1.1 17.4 3.5l128 128c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-128 0c-8.8 0-16-7.2-16-16l0-128c0-6.5 3.9-12.3 9.9-14.8zM144 294.6l0 73.4 73.4 0L144 294.6z'
      
    ]
  };

  

  
  

  var faHousePersonLeave = {
    prefix: 'fal',
    iconName: 'house-person-leave',
    icon: [
      640,
      512,
      ["house-leave","house-person-depart"],
      'e00f',
      
      'M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9 64 352c0 35.3 28.7 64 64 64l208.8 0L354 398.8l7.4-14.8-9.4 0-32 0-192 0c-17.7 0-32-14.3-32-32l0-191.5L240 37.1 358.2 138.4c8.3-7.2 17.2-13.6 26.7-19.2L250.4 3.9zM192 192l64 0 0 64-64 0 0-64zm-8-32c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0zM496 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 464 56a56 56 0 1 0 112 0zM437.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L529.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L560.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L507.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5z'
      
    ]
  };

  
    var faHouseLeave = faHousePersonLeave;
  
    var faHousePersonDepart = faHousePersonLeave;
  

  
  

  var faLeftFromBracket = {
    prefix: 'fal',
    iconName: 'left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e66c',
      
      'M32.8 257.8c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L164.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L32.8 257.8zM0 256c0 9.5 3.9 18.6 10.8 25.1L142.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L10.8 230.9C3.9 237.4 0 246.5 0 256zM336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c44.2 0 80-35.8 80-80l0-288c0-44.2-35.8-80-80-80l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-96 0z'
      
    ]
  };

  

  
  

  var faMarsDouble = {
    prefix: 'fal',
    iconName: 'mars-double',
    icon: [
      640,
      512,
      [9891],
      'f227',
      
      'M304 48c0-8.8 7.2-16 16-16l112 0c8.8 0 16 7.2 16 16l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-73.4L311.3 191.4C336.7 221.9 352 261.2 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c42.8 0 82.1 15.3 112.6 40.7L393.4 64 320 64c-8.8 0-16-7.2-16-16zM176 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM469.4 190.1c4.5-5.6 7.8-12.3 9.5-19.6L585.4 64 512 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0c8.8 0 16 7.2 16 16l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-73.4-100 100c22.6 30.6 36 68.4 36 109.4c0 101.6-82.4 184-184 184c-20.7 0-40.5-3.4-59.1-9.7c10.1-7.6 19.5-16.2 28.1-25.5c10 2.1 20.3 3.2 30.9 3.2c83.9 0 152-68.1 152-152c0-38.3-14.1-73.3-37.5-100l-5.1-5.9z'
      
    ]
  };

  

  
  

  var faLocationCrosshairs = {
    prefix: 'fal',
    iconName: 'location-crosshairs',
    icon: [
      512,
      512,
      ["location"],
      'f601',
      
      'M256 0c8.8 0 16 7.2 16 16l0 48.7c93.3 7.7 167.6 82.1 175.3 175.3l48.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48.7 0c-7.7 93.3-82.1 167.6-175.3 175.3l0 48.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48.7C146.7 439.6 72.4 365.3 64.7 272L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l48.7 0C72.4 146.7 146.7 72.4 240 64.7L240 16c0-8.8 7.2-16 16-16zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm224 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faLocation = faLocationCrosshairs;
  

  
  

  var faChessQueenPiece = {
    prefix: 'fal',
    iconName: 'chess-queen-piece',
    icon: [
      256,
      512,
      ["chess-queen-alt"],
      'f446',
      
      'M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm67.8 41.4c6.5 1.2 11.6 6.2 12.8 12.7C187.4 92.9 200.4 104 216 104c5.6 0 10.7-1.4 15.3-3.9c6.1-3.3 13.7-2.3 18.8 2.5s6.3 12.4 3.2 18.7L201.9 224l6.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-15.3 0 4.4 96-32 0-4.4-96-65.4 0-4.4 96-32 0 4.4-96L48 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l6.1 0L2.8 121.3C-.3 115.1 1 107.5 6 102.7s12.6-5.9 18.8-2.5c4.5 2.5 9.7 3.9 15.3 3.9c15.6 0 28.6-11.1 31.4-25.9c1.3-6.5 6.3-11.5 12.8-12.7s13 1.7 16.5 7.3C106.4 81.9 116.5 88 128 88s21.6-6.1 27.3-15.2c3.5-5.6 10-8.5 16.5-7.3zM89.9 224l76.2 0 44.1-88.3c-19.2-1.7-35.9-11.9-46.4-26.7c-10.2 6.9-22.5 11-35.8 11s-25.6-4-35.8-11c-10.6 14.8-27.3 25-46.4 26.7L89.9 224zM190.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4L39.4 512C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1l124.4 0zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4l177.1 0c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416z'
      
    ]
  };

  
    var faChessQueenAlt = faChessQueenPiece;
  

  
  

  var faBiohazard = {
    prefix: 'fal',
    iconName: 'biohazard',
    icon: [
      576,
      512,
      [9763],
      'f780',
      
      'M147.2 6.4c3-4 7.8-6.4 12.8-6.4l.9 0c4.6 0 8.9 1.9 11.9 5.3s4.5 7.9 4 12.4c-3.5 30.8 4.4 62.5 22.7 86.3c18 23.3 47 40 88.5 40s70.4-16.6 88.5-40c18.4-23.7 26.2-55.5 22.7-86.3c-.5-4.5 .9-9.1 4-12.4s7.4-5.3 11.9-5.3l.9 0c5 0 9.8 2.4 12.8 6.4C450.9 35.8 464 72.4 464 112c0 18.6-2.9 36.5-8.2 53.3c15.5 3.9 30.6 10 45.1 18.3c34.3 19.8 59.4 49.4 73.9 83.3c2 4.6 1.7 9.9-.9 14.3l-.5 .8c-2.3 3.9-6.1 6.7-10.6 7.7s-9.1-.1-12.8-2.8c-24.9-18.4-56.3-27.5-86.1-23.4c-29.2 4-58.1 20.7-78.8 56.6s-20.8 69.3-9.6 96.6c11.4 27.8 35 50.4 63.3 62.8c4.2 1.8 7.4 5.3 8.8 9.7s.9 9.1-1.3 13l-.5 .8c-2.5 4.4-6.9 7.3-11.9 7.9c-36.5 4.4-74.8-2.5-109.1-22.3c-13.8-8-26.1-17.5-36.9-28.3c-10.7 10.8-23.1 20.4-36.9 28.3c-34.3 19.8-72.5 26.8-109.1 22.3c-5-.6-9.4-3.5-11.9-7.9l-.5-.8c-2.3-3.9-2.8-8.7-1.3-13s4.6-7.8 8.8-9.7c28.4-12.4 51.9-35 63.3-62.8c11.2-27.3 11.1-60.7-9.6-96.6s-49.6-52.7-78.8-56.6c-29.8-4-61.1 5.1-86.1 23.4c-3.7 2.7-8.3 3.7-12.8 2.8s-8.3-3.7-10.6-7.7l-.5-.8c-2.5-4.4-2.8-9.6-.9-14.3c14.4-33.8 39.6-63.5 73.9-83.3c14.5-8.3 29.6-14.4 45.1-18.3c-5.3-16.8-8.2-34.7-8.2-53.3c0-39.6 13.1-76.2 35.2-105.6zm2.2 66.5C145.9 85.3 144 98.4 144 112c0 21 4.5 40.9 12.5 58.8c2.1 4.6 1.8 9.9-.6 14.3s-6.9 7.4-11.9 8.1c-18.1 2.4-36.1 8.3-52.9 18.1C79.4 218.1 69 226.3 60 235.5c18.2-4.9 37.4-6.4 56.3-3.8c39.4 5.3 76.8 28.2 102.3 72.3s26.6 87.9 11.5 124.7c-7.3 17.7-18.1 33.5-31.5 46.9c12.5-3.2 24.8-8.1 36.5-14.9c16-9.2 29.5-21 40.4-34.6c3-3.8 7.6-6 12.5-6s9.4 2.2 12.5 6c10.9 13.5 24.4 25.4 40.4 34.6c11.7 6.8 24 11.7 36.5 14.9c-13.3-13.3-24.2-29.2-31.5-46.9c-15.1-36.8-14-80.6 11.5-124.7s62.9-67 102.3-72.3c19-2.6 38.1-1.1 56.3 3.8c-9-9.2-19.4-17.4-31.2-24.2c-16.8-9.7-34.8-15.6-52.9-18.1c-5-.7-9.4-3.7-11.9-8.1s-2.7-9.7-.6-14.3c8-17.9 12.5-37.9 12.5-58.9c0-13.6-1.9-26.7-5.4-39.1c-4.9 18.2-13.1 35.5-24.9 50.7C377.5 155.1 339 176 288 176s-89.5-20.9-113.8-52.4c-11.7-15.1-20-32.5-24.9-50.7zm5.1 358.6c-40.1-33.6-67.4-82.1-73.3-136.9c9-1.8 18.1-2.2 26.7-1.1c1.8 .2 3.7 .6 5.5 1c5.6 43.9 27.3 82.7 59 110.3l-.1 .3c-3.9 9.6-10.1 18.6-17.9 26.4zM288 96c-15.9 0-31.3 2.1-45.9 6.1c-7.6-4.6-13.7-10.4-18.5-16.6c-2.2-2.9-4.2-6-6.1-9.2C239.5 68.3 263.3 64 288 64s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2c-4.8 6.2-10.9 12-18.5 16.6c-14.6-3.9-30-6.1-45.9-6.1zM462.6 294.5c1.8-.4 3.7-.7 5.5-1c8.6-1.2 17.7-.8 26.7 1.1c-5.9 54.9-33.2 103.3-73.3 136.9c-7.8-7.8-13.9-16.8-17.9-26.4l-.1-.3c31.7-27.6 53.5-66.4 59.1-110.3zM288 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faWebAwesome = {
    prefix: 'fal',
    iconName: 'web-awesome',
    icon: [
      640,
      512,
      [],
      'e682',
      
      'M340.2 52a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm-42 47.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52c0 20.9-12.4 39-30.2 47.2L448 192l104.4-20.9c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48l-1.8 3.9L481 442.3c-10.3 23-33.2 37.7-58.4 37.7l-205.2 0c-25.2 0-48-14.8-58.4-37.7L48.1 195.9 46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1L192 192 298.1 99.1zM48.2 192l-.2 0-.1 0 .1 0 .2 0zm406.1 31.4c-9.8 2-19.9-.7-27.3-7.3L320 122.5 213.1 216.1c-7.5 6.6-17.6 9.2-27.3 7.3l-99-19.8L188.2 429.1c5.2 11.5 16.6 18.9 29.2 18.9l205.2 0c12.6 0 24-7.4 29.2-18.9L553.3 203.6l-99 19.8zM592 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM64 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faBalloon = {
    prefix: 'fal',
    iconName: 'balloon',
    icon: [
      384,
      512,
      [],
      'e2e3',
      
      'M205.6 405.8s0 0 0 0s0 0 0 0s0 0 0 0L192 415.3l-13.6-9.5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.2-.2-1.1-.8c-1-.7-2.6-1.9-4.6-3.4c-4-3-9.9-7.6-17-13.5c-14.2-11.8-33.1-28.8-51.8-49.4C65 295.9 32 243.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 51.6-33 103.9-71.7 146.5c-18.8 20.6-37.6 37.6-51.8 49.4c-7.1 5.9-12.9 10.5-17 13.5c-2 1.5-3.6 2.7-4.6 3.4l-1.1 .8-.2 .2s0 0 0 0zM192 439.6l3.4 6.8L212.2 480l-40.4 0 16.8-33.7 3.4-6.8zM0 192C0 320 160 432 160 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l102.1 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L224 432s160-112 160-240C384 86 298 0 192 0S0 86 0 192zm112-16c0-35.3 28.7-64 64-64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faSensorOn = {
    prefix: 'fal',
    iconName: 'sensor-on',
    icon: [
      640,
      512,
      [],
      'e02b',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 96c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zM600.2 93.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-21.9-5.5l-80 48c-7.6 4.5-10 14.4-5.5 22s14.4 10 21.9 5.5l80-48zM528 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm-7.8 130.3c-7.6-4.5-17.4-2.1-21.9 5.5s-2.1 17.4 5.5 21.9l80 48c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-80-48z'
      
    ]
  };

  

  
  

  var faMessagesDollar = {
    prefix: 'fal',
    iconName: 'messages-dollar',
    icon: [
      640,
      512,
      ["comments-alt-dollar"],
      'f652',
      
      'M183.5 294.4L128 336l0-16c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-149.3 0c-6.9 0-13.7 2.2-19.2 6.4zM202.7 320L352 320c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 256c0 35.3 28.7 64 64 64l32 0 0 32 0 16c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320zM256 384c0 35.3 28.7 64 64 64l117.3 0 81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3l0-16 0-32 32 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-128 0 0 32 128 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32l0 16-55.5-41.6c-5.5-4.2-12.3-6.4-19.2-6.4L320 416c-17.7 0-32-14.3-32-32l0-32-32 0 0 32zM224 79.1c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 10.5c-6 1.3-12.1 3.4-17.6 6.6c-11.1 6.4-20.9 17.8-20.8 34.7c.1 16.2 9.8 26.2 19.9 32.2c8.8 5.1 19.7 8.4 28.4 10.9l1.4 .4c10.1 3 17.4 5.3 22.5 8.4c4.2 2.5 4.5 4.1 4.5 5.9c0 3.5-1.2 5.7-4.6 7.7c-4 2.4-10.4 3.9-17.3 3.7c-9-.3-17.3-3-28.2-6.6c0 0 0 0 0 0s0 0 0 0c-1.8-.6-3.8-1.2-5.8-1.9c-8.4-2.7-17.4 1.9-20.2 10.3s1.9 17.4 10.3 20.2c1.6 .5 3.2 1 4.9 1.6c0 0 0 0 0 0c6.6 2.2 14.3 4.8 22.5 6.5l0 10.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.3c6.4-1.3 12.7-3.5 18.4-7c11.4-6.9 20.2-18.8 20-35.5c-.2-16.2-9.6-26.5-19.8-32.8c-9.2-5.6-20.7-9-29.6-11.6l-.5-.2c-10.2-3-17.6-5.2-22.7-8.2c-4.1-2.4-4.1-3.6-4.1-4.6l0-.1c0-2.5 .9-4.5 4.8-6.8c4.4-2.5 11-4 17.4-3.9c7.7 .1 16.2 1.8 25 4c8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-5.2-1.3-10.9-2.7-16.8-3.6l0-10.4z'
      
    ]
  };

  
    var faCommentsAltDollar = faMessagesDollar;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fal',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M464 192c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faUserMusic = {
    prefix: 'fal',
    iconName: 'user-music',
    icon: [
      640,
      512,
      [],
      'f8eb',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480l257.4 0c2.5 12.2 8.2 23 16.1 32L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c43.5 0 83.3 15.6 114.3 41.4l0 40.2c-1.5 0-2.9 0-4.4 .1C352.8 355.3 313.5 336 269.7 336l-91.4 0c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm501.9 39.8c20.7-6.9 42.1 8.5 42.1 30.4l0 49.8 0 144c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4l0-88.2L448 323.5 448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4L416 312l0-60.5c0-13.8 8.8-26 21.9-30.4l160-53.3zM448 289.8l160-53.3 0-38.3L448 251.5l0 38.3zM608 400c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3zM416 464c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3z'
      
    ]
  };

  

  
  

  var faFacePensive = {
    prefix: 'fal',
    iconName: 'face-pensive',
    icon: [
      512,
      512,
      [],
      'e384',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 384l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM81.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5 .7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z'
      
    ]
  };

  

  
  

  var faHandsPraying = {
    prefix: 'fal',
    iconName: 'hands-praying',
    icon: [
      640,
      512,
      ["praying-hands"],
      'f684',
      
      'M283.4 32c-6.8 0-13.2 3.4-17.1 9L179.5 168.4C166.8 187 160 209 160 231.5l0 50.3c0 20-12.4 37.9-31.1 44.9L21.6 367c-8.3 3.1-17.5-1.1-20.6-9.4s1.1-17.5 9.4-20.6l107.2-40.2c6.2-2.3 10.4-8.3 10.4-15l0-50.3c0-28.9 8.7-57.2 25-81.1L239.9 23C249.7 8.6 266 0 283.4 0c14.2 0 27.2 5.7 36.6 14.8C329.5 5.7 342.4 0 356.6 0c17.4 0 33.7 8.6 43.5 23L487 150.4c16.3 23.9 25 52.2 25 81.1l0 50.3c0 6.7 4.1 12.6 10.4 15L629.6 337c8.3 3.1 12.5 12.3 9.4 20.6s-12.3 12.5-20.6 9.4L511.1 326.8c-18.7-7-31.1-24.9-31.1-44.9l0-50.3c0-22.5-6.8-44.5-19.5-63.1L373.7 41c-3.8-5.6-10.2-9-17.1-9C345.2 32 336 41.2 336 52.6l0 6.3c0 5.3 1.6 10.5 4.5 15l51.3 76.9c15.8 23.7 24.2 51.4 24.2 79.9l0 1.2 0 72c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 74.2c0 48.9 31.7 92.1 78.3 106.8l214.5 67.8c8.4 2.7 13.1 11.6 10.4 20.1s-11.6 13.1-20.1 10.4L404.6 443.5c-37.5-11.8-67.4-38-84.6-71.3c-17.2 33.3-47.2 59.5-84.6 71.3L20.8 511.3c-8.4 2.7-17.4-2-20.1-10.4s2-17.4 10.4-20.1L225.7 413c46.6-14.7 78.3-57.9 78.3-106.8l0-74.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-72 0-1.2c0-28.4 8.4-56.2 24.2-79.9L299.5 74c3-4.4 4.5-9.6 4.5-15l0-6.3c0-11.4-9.2-20.6-20.6-20.6zM320 100.8l-45.2 67.8c-1.8 2.7-3.5 5.5-5 8.3c3.3-.6 6.7-.9 10.2-.9c15.7 0 29.8 6.4 40 16.8c10.2-10.4 24.3-16.8 40-16.8c3.5 0 6.9 .3 10.2 .9c-1.6-2.8-3.2-5.6-5-8.3L320 100.8z'
      
    ]
  };

  
    var faPrayingHands = faHandsPraying;
  

  
  

  var faHandScissors = {
    prefix: 'fal',
    iconName: 'hand-scissors',
    icon: [
      512,
      512,
      [],
      'f257',
      
      'M4.2 284.4c-2.4-33 22.4-61.8 55.5-64.2l72.8-5.3-76.3-21c-32-8.8-50.7-41.8-41.9-73.8s41.8-50.7 73.8-41.9l177.4 48.8c1.8-2.9 3.8-5.7 5.8-8.4L288 96c15.1-20.1 38.8-32 64-32l19.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L520 336c0 70.7-57.3 128-128 128l-40 0-40 0-8 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-2.2 .1-4.3 .3-6.4L68.4 339.8c-33 2.4-61.8-22.4-64.2-55.5zM62 252.1c-15.4 1.1-27 14.5-25.9 30s14.5 27 30 25.9L229.3 296c5.9-.4 11.6 2.4 14.7 7.5s3.3 11.4 .3 16.5c-2.7 4.7-4.3 10.2-4.3 16c0 14.7 10 27.2 23.6 30.9c4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8 .6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8c0 17.7 14.3 32 32 32l8 0 40 0 40 0c53 0 96-43 96-96l0-119.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C450.6 118.6 412.7 96 371.5 96L352 96c-15.1 0-29.3 7.1-38.4 19.2L297 137.4l51.6 15.3c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8L206.6 144 79.4 109c-14.9-4.1-30.3 4.7-34.4 19.6s4.7 30.3 19.6 34.4l165.8 45.6c7.5 2.1 12.4 9.2 11.7 17s-7 13.8-14.8 14.4L62 252.1z'
      
    ]
  };

  

  
  

  var faDrumSteelpan = {
    prefix: 'fal',
    iconName: 'drum-steelpan',
    icon: [
      576,
      512,
      [],
      'f56a',
      
      'M544 160c0-19.9-16.1-43.9-64.8-64.5C454.6 85.1 424.5 77 390.3 71.6c-21.4 61.1-16.2 121.3 21.2 173c25.5-5.2 48.4-11.9 67.7-20.1C527.9 203.9 544 179.9 544 160zM348.3 174.5C333.1 182.9 311.5 192 288 192s-45.1-9.1-60.3-17.5c-4.2 26.2-13.5 51.7-28.6 75.9c27.5 3.7 57.4 5.6 88.8 5.6s61.3-2 88.8-5.6c-15-24.2-24.4-49.7-28.6-75.9zm-2.6-36.1c.4-23.5 4.5-47.4 12.2-71C335.8 65.2 312.4 64 288 64s-47.8 1.2-69.9 3.4c7.7 23.6 11.8 47.5 12.2 71c3.3 2.3 7.4 5 12.2 7.6C255.6 153.5 272 160 288 160s32.4-6.5 45.5-13.9c4.7-2.7 8.9-5.3 12.2-7.7zM96.8 224.5c19.3 8.2 42.2 14.9 67.7 20.1c37.5-51.8 42.6-112 21.2-173C151.5 77 121.4 85.1 96.8 95.5C48.1 116.1 32 140.1 32 160s16.1 43.9 64.8 64.5zM576 160l0 184c0 47.6-38.6 81.6-89.5 102.9C434.7 468.6 364.4 480 288 480s-146.7-11.4-198.5-33.1C38.6 425.6 0 391.6 0 344L0 160C0 80 128.9 32 288 32s288 48 288 128zm-32 62.8C496.1 264.4 399.5 288 288 288s-208.1-23.6-256-65.2L32 344c0 27.4 22.3 53.4 69.9 73.4C148.5 436.9 214.2 448 288 448s139.5-11.1 186.2-30.6c47.6-19.9 69.8-46 69.8-73.4l0-121.2z'
      
    ]
  };

  

  
  

  var faHandPointer = {
    prefix: 'fal',
    iconName: 'hand-pointer',
    icon: [
      448,
      512,
      [],
      'f25a',
      
      'M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 132.2c0 6.3 3.7 12 9.5 14.6s12.5 1.5 17.2-2.7c5.7-5.1 13.1-8.1 21.3-8.1c16.8 0 30.7 13 31.9 29.5c.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2c16.8 0 30.7 13 31.9 29.5c.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2c17.7 0 32 14.3 32 32l0 32 0 16 0 64c0 44.2-35.8 80-80 80l-64 0-16 0-50.3 0c-36.1 0-70.3-16.3-93.1-44.3L37.4 343.1c-8.4-10.3-6.8-25.4 3.5-33.8s25.4-6.8 33.8 3.5l25 30.7c4.3 5.3 11.4 7.3 17.8 5s10.6-8.3 10.6-15.1L128 56zM152 0C121.1 0 96 25.1 96 56l0 232.8c-20-20.5-52.7-22.7-75.3-4.3C-3.3 304-7 339.3 12.5 363.3l75.2 92.5c28.9 35.5 72.2 56.2 118 56.2l50.3 0 16 0 64 0c61.9 0 112-50.1 112-112l0-64 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2l0-106c0-30.9-25.1-56-56-56zm72 320c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  

  
  

  var faBacterium = {
    prefix: 'fal',
    iconName: 'bacterium',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      'M415.4 20.4c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-6 20.9c-11.7-1.1-23.8-.4-35.8 2.4c-13.7 3.2-26.9 6.8-39.5 10.8l-8.6-20c-3.5-8.1-12.9-11.9-21-8.4s-11.9 12.9-8.4 21l7.8 18.2c-27.3 10.9-51.7 23.8-73.5 38L189.3 79.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l10.8 16.2c-24.5 19-45 39.8-62.1 61.1L98 163.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5L92.4 200c-3.7 5.5-7.1 10.9-10.4 16.4c-10.4 17.4-19.8 36-27.5 55.4l-16.5-6.6c-8.2-3.3-17.5 .7-20.8 8.9s.7 17.5 8.9 20.8L43.9 302c-5.5 18.4-9.4 37.2-11.4 55.9c-.9 9.7-.5 19.3 1 28.5l-21.9 6.2C3.1 395-1.8 403.9 .6 412.4s11.3 13.4 19.8 11l22.8-6.5c10.9 22.5 29.2 40.9 51.9 51.9l-6.5 22.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l6.3-21.9c2.7 .4 5.4 .8 8.2 1c26.6 2.4 51.9-4.7 72.5-18.5l14.3 14.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13.1-13.1c13.6-16.4 22.7-36.8 25.2-59.4c1.1-7.5 3.2-15 5.9-22.2l20.5 8.8c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21l-18.8-8.1c10.8-17.2 28.2-37.7 58.4-54.3l2.7 9.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-3.9-13.8c9.1-3.3 19-6.2 29.7-8.7c17.6-4.1 33.3-12.1 46.4-22.9l13.1 13.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L461 206.4c15.4-23 22.3-51.7 17.5-80.7l21.9-6.3c8.5-2.4 13.4-11.3 11-19.8s-11.3-13.4-19.8-11l-22.8 6.5c-12.3-25.4-33.6-44.8-59-55.1l5.6-19.7zm-74.9 216c-.3 .1-.6 .1-.9 .2c-1.7 .5-3.2 1.2-4.6 2.2c-47.2 21.1-73.2 51-88.4 76.4c-10.1 16.9-19.5 37.7-22.9 60.1c-.1 .5-.1 .9-.2 1.4c-4.7 43.3-43.3 74.9-86.8 71c-43.9-4-76.3-42.8-72.4-86.7c4.6-43.8 21.7-89.1 45.1-128.1C149.4 166.1 222.8 95.4 350 66c43.1-9.9 86 16.9 95.9 60s-16.9 86-60 95.9c-16.9 3.9-32 8.8-45.5 14.4zM264 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 320a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96z'
      
    ]
  };

  

  
  

  var faChartDiagram = {
    prefix: 'fal',
    iconName: 'chart-diagram',
    icon: [
      512,
      512,
      [],
      'e695',
      
      'M96 64C78.3 64 64 78.3 64 96s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64zM32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-144 0 0 24 6.6 6.6 42.7 42.7L328 240l56 0c44.2 0 80 35.8 80 80l0 32 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-32c0-26.5-21.5-48-48-48l-56 0-6.6 6.6-42.7 42.7L272 328l0 24 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-24-6.6-6.6-42.7-42.7L184 272l-56 0c-26.5 0-48 21.5-48 48l0 32 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-32c0-44.2 35.8-80 80-80l56 0 6.6-6.6 42.7-42.7L240 184l0-24L96 160c-35.3 0-64-28.7-64-64zM48 384l-16 0 0 64 64 0 0-64-16 0-32 0zm192 0l-16 0 0 64 64 0 0-64-16 0-32 0zm192 0l-16 0 0 64 64 0 0-64-16 0-32 0zM213.3 256L256 298.7 298.7 256 256 213.3 213.3 256z'
      
    ]
  };

  

  
  

  var faGridDividers = {
    prefix: 'fal',
    iconName: 'grid-dividers',
    icon: [
      512,
      512,
      [],
      'e3ad',
      
      'M0 16C0 7.2 7.2 0 16 0L496 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 32C7.2 32 0 24.8 0 16zM64 128l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM64 416l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM288 128l-64 0 0 64 64 0 0-64zM224 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 320l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM448 128l-64 0 0 64 64 0 0-64zM384 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 320l0 64 64 0 0-64-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM16 288l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 320c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHandHoldingDollar = {
    prefix: 'fal',
    iconName: 'hand-holding-dollar',
    icon: [
      576,
      512,
      ["hand-holding-usd"],
      'f4c0',
      
      'M304 24l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.3 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3C224 71.1 234.9 57.7 247.9 50c7.5-4.4 15.8-7.2 24.1-8.7L272 24c0-8.8 7.2-16 16-16s16 7.2 16 16zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7L80 400l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  
    var faHandHoldingUsd = faHandHoldingDollar;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fal',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFaceGrinSquint = {
    prefix: 'fal',
    iconName: 'face-grin-squint',
    icon: [
      512,
      512,
      [128518,"grin-squint"],
      'f585',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z'
      
    ]
  };

  
    var faGrinSquint = faFaceGrinSquint;
  

  
  

  var faSquareLeft = {
    prefix: 'fal',
    iconName: 'square-left',
    icon: [
      448,
      512,
      [11013,"arrow-alt-square-left"],
      'f351',
      
      'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM80 256c0-9.2 3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3c21.1 0 38.3 17.1 38.3 38.3l0 25.7 80 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-80 0 0 25.7c0 21.1-17.1 38.3-38.3 38.3c-10.7 0-20.9-4.5-28.1-12.3l-84-91C83.5 274 80 265.2 80 256zm33.2 3l84 91c1.2 1.3 2.9 2 4.6 2c3.5 0 6.3-2.8 6.3-6.3l0-41.7c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-41.7c0-3.5-2.8-6.3-6.3-6.3c-1.7 0-3.4 .7-4.6 2l-84 91c-.8 .8-1.2 1.9-1.2 3s.4 2.2 1.2 3z'
      
    ]
  };

  
    var faArrowAltSquareLeft = faSquareLeft;
  

  
  

  var faDiamond = {
    prefix: 'fal',
    iconName: 'diamond',
    icon: [
      512,
      512,
      [9830],
      'f219',
      
      'M250.3 34.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0l-216-216c-3.1-3.1-3.1-8.2 0-11.3l216-216zm33.9-22.6c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z'
      
    ]
  };

  

  
  

  var faUserNurseHairLong = {
    prefix: 'fal',
    iconName: 'user-nurse-hair-long',
    icon: [
      448,
      512,
      [],
      'e45e',
      
      'M128 144l0-67.1 96-42 96 42 0 67.1-192 0zM96 76.9L96 144l0 16c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2C37.5 259.9 32 270.9 32 282.7C32 303.3 48.7 320 69.3 320l58.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.7 0c-2.9 0-5.3-2.4-5.3-5.3c0-1.7 .8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.3C129.5 274.6 173.3 304 224 304s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.3l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3c0 2.9-2.4 5.3-5.3 5.3L320 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l58.7 0c20.6 0 37.3-16.7 37.3-37.3c0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 228.4 352 195.3 352 160l0-16 0-67.1c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176s0 0 0 0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48l21.5 0c35.5 0 68.3-18.3 87-48l70.7 0zm-112.8 0c-12.4 10.2-28.2 16-44.8 16l-33 0c-.9-5.2-1.3-10.5-1.3-16c0 0 0 0 0 0l79.2 0zM130.8 382l59.3 59.3c18.7 18.7 49.1 18.7 67.9 0L317.2 382c52.8 1.8 95.4 43.5 98.6 95.9l-383.6 0c3.2-52.4 45.9-94.1 98.6-95.9zm20-25.3c-4.3-4.3-10.2-6.8-16.4-6.8C60.2 349.9 0 410.1 0 484.3c0 14.1 11.5 25.6 25.6 25.6l396.8 0c14.1 0 25.6-11.5 25.6-25.6c0-74.2-60.2-134.4-134.4-134.4c-6.1 0-12 2.4-16.4 6.8l-61.9 61.9c-6.2 6.2-16.4 6.2-22.6 0l-61.9-61.9zM208 56l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faAlbumCirclePlus = {
    prefix: 'fal',
    iconName: 'album-circle-plus',
    icon: [
      576,
      512,
      [],
      'e48c',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l211.2 0c5.9 11.4 12.9 22.2 21 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7L416 96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faScarf = {
    prefix: 'fal',
    iconName: 'scarf',
    icon: [
      512,
      512,
      [129507],
      'f7c1',
      
      'M221.4 32c-17.3 0-33.3 9.4-41.8 24.5l-41.5 73.8C131.5 142 128 155.3 128 168.8c0 20.9 8.3 40.9 23 55.6l161 161L385.4 312l-44.7-44.7L210.3 137c-15.1-15.1-4.4-41 17-41L304 96c8.8 0 16 7.2 16 16s-7.2 16-16 16l-57.4 0L352 233.4l9-9c14.7-14.7 23-34.8 23-55.6c0-13.5-3.5-26.8-10.1-38.6L332.4 56.5C323.9 41.4 307.9 32 290.6 32l-69.1 0zM416 168.8c0 29.3-11.7 57.5-32.4 78.2l-9 9 44.7 44.7 8 8s0 0 0 0l3.3 3.3 76.7 76.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L408 334.6 382.6 360l76.7 76.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L360 382.6 334.6 408l76.7 76.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L312 430.6l-3.3-3.3s0 0 0 0l-8-8L128.4 247C107.7 226.3 96 198.1 96 168.8c0-19 4.9-37.7 14.2-54.2l41.5-73.8C165.9 15.6 192.5 0 221.4 0l69.1 0c28.9 0 55.6 15.6 69.7 40.8l41.5 73.8c9.3 16.6 14.2 35.2 14.2 54.2zM4.7 388.7L114.7 278.6l22.6 22.6L27.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48L162.7 326.6l22.6 22.6L75.3 459.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48L210.7 374.6l22.6 22.6L123.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faPlantWilt = {
    prefix: 'fal',
    iconName: 'plant-wilt',
    icon: [
      512,
      512,
      [],
      'e5aa',
      
      'M288 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 33.1c-38.4 5.7-64 32.2-64 73.9c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-41.7-25.6-68.3-64-73.9L448 96c0-53-43-96-96-96s-96 43-96 96l0 65.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112l0 17.1c-38.4 5.7-64 32.2-64 73.9C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-41.7-25.6-68.3-64-73.9L96 240c0-44.2 35.8-80 80-80s80 35.8 80 80l0 40 0 216c0 8.8 7.2 16 16 16s16-7.2 16-16l0-216 0-40 0-144zm128 65.7l0 30.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-30.3c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 5.8-3.3 18.8-13.5 36.5c-8.3 14.5-20.1 30-34.5 44.3c-14.4-14.3-26.2-29.9-34.5-44.3c-10.2-17.7-13.5-30.7-13.5-36.5c0-15.8 5.3-25.6 11.9-31.6c4.6-4.2 11.2-7.8 20.1-9.8zM43.9 299.5c4.6-4.2 11.2-7.8 20.1-9.8l0 30.6c0 8.8 7.2 16 16 16s16-7.2 16-16l0-30.6c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 5.8-3.3 18.8-13.5 36.5c-8.3 14.5-20.1 30-34.5 44.3C65.6 397.6 53.8 382 45.5 367.6C35.3 349.8 32 336.9 32 331.1c0-15.8 5.3-25.6 11.9-31.6z'
      
    ]
  };

  

  
  

  var faCommentDots = {
    prefix: 'fal',
    iconName: 'comment-dots',
    icon: [
      512,
      512,
      [62075,128172,"commenting"],
      'f4ad',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM128 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCommenting = faCommentDots;
  

  
  

  var faCalendarArrowUp = {
    prefix: 'fal',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM208 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 294.6 208 416z'
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faSortUp = {
    prefix: 'fal',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      'M154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1L39.1 192c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2L154.4 66.2zm-22-23.3L12.3 156.4C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224l241.7 0c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.5L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareL = {
    prefix: 'fal',
    iconName: 'square-l',
    icon: [
      448,
      512,
      [],
      'e275',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 48l0 208 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0c-17.7 0-32-14.3-32-32l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faTennisBall = {
    prefix: 'fal',
    iconName: 'tennis-ball',
    icon: [
      512,
      512,
      [127934],
      'f45e',
      
      'M256.6 480c-4.5-58.4 15.6-118.4 60.3-163.1s104.6-64.8 163.1-60.3l0-.6C480 132.3 379.7 32 256 32l-.6 0c4.5 58.4-15.6 118.4-60.3 163.1S90.4 259.9 32 255.4l0 .6c0 123.7 100.3 224 224 224l.6 0zm31.9-2.3c97.7-14.2 174.9-91.4 189.1-189.1c-49.5-3.8-100.3 13.2-138.1 51s-54.8 88.6-51 138.1zM223.5 34.3C125.8 48.6 48.6 125.8 34.3 223.5c49.5 3.8 100.3-13.2 138.1-51s54.8-88.6 51-138.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faFaceTongueMoney = {
    prefix: 'fal',
    iconName: 'face-tongue-money',
    icon: [
      512,
      512,
      [],
      'e39d',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm96 32c-17.1 0-33.2 14.3-31 33.7c4.8 43.9 27.4 82.4 60.3 108.2l4.3 3.4C169.7 478 208.9 512 256 512s86.3-34 94.5-78.7l4.3-3.4c32.9-25.8 55.4-64.3 60.3-108.2c2.1-19.4-13.9-33.7-31-33.7l-32 0-32 0-128 0-32 0-32 0zm160 32l32 0 0 32 0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 0-32 32 0 64 0zm-159 0l31 0 0 68.7c-16.6-18.8-27.8-42.5-31-68.7zm254 0c-3.3 26.1-14.4 49.9-31 68.7l0-68.7 31 0zM192 104c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8c0 0 0 0 0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7l0-9.8zM336 88c-8.8 0-16 7.2-16 16l0 9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8c0 0 0 0 0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7l0-9.8c0-8.8-7.2-16-16-16zM267.2 347.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6l0 6.8c-4.3 .8-8.7 2.4-12.7 5.2c-5.6 4-9.5 9.8-10.8 17.2c-.9 5.3-.5 10.6 1.7 15.4c2.2 4.8 5.7 8.2 9.3 10.6c6.3 4.2 14.5 6.5 20.4 8.1l.8 .2c7.2 2 11.5 3.3 14.1 5.1c1.9 1.3 1.6 4.6-.4 5.8c0 0 0 0 0 0c-.9 .5-2.8 1.1-6.6 1.1c-7.6-.1-16.9-2.9-24-5.2c-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4l0 7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6l0-6.5c3.6-.6 7.3-1.8 10.8-3.8c6.8-4 11.2-10.5 12.7-18.9c.9-5.3 .5-10.6-1.7-15.4c-2.2-4.8-5.7-8.2-9.3-10.6c-5.4-3.6-11.7-5.2-17.9-6.8c-6.2-1.6-12.3-3.2-17.5-6.6c-1.8-1.2-1.8-3.9 .2-5.2c.7-.5 2.3-1.2 5.3-1.5c6.1-.6 14 .7 20.2 2.3c6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2l0-7.2z'
      
    ]
  };

  

  
  

  var faUserPoliceTie = {
    prefix: 'fal',
    iconName: 'user-police-tie',
    icon: [
      448,
      512,
      [],
      'e334',
      
      'M230.9 .8l144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2L368 109.3l0 1.6c0 15.6-7.6 31.8-23.2 40.1c-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9l0-1.6L57.4 86.6C49.1 78.4 46 66.3 49.3 55.1s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3l0 8.2c0 5.8 2.8 10 6.2 11.8c11.9 6.3 30.3 13.8 58.4 18C163.8 121.1 160 98.9 160 83.2c0-6.5 4-12.4 10.1-14.9l48-19.2c3.8-1.5 8.1-1.5 11.9 0l48 19.2C284 70.8 288 76.7 288 83.2c0 15.7-3.8 37.9-16.5 57.5c28.1-4.2 46.5-11.7 58.4-18c3.4-1.8 6.2-6 6.2-11.8l0-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-6.1 0 18.4 36.9 51.6-68.7C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6L240 512l-32 0L25.6 512C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7L198.1 384l-6.1 0c-8.8 0-16-7.2-16-16zm48 35.8l-22.9 45.7 2.9 3.8L224 480s0 0 0 0s0 0 0 0l20-26.7 2.9-3.8L224 403.8zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480L184 480zm80 0l151.8 0c-2.9-46.5-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9 .1-5.8 .3-8.7c9.1 4.3 19.6 8.5 31.8 12.1c1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zm128-49.7c20.5-11.3 28.9-31.3 31.3-48.5L224 81.2 192.7 93.7c2.3 17.3 10.8 37.3 31.3 48.5z'
      
    ]
  };

  

  
  

  var faFileUser = {
    prefix: 'fal',
    iconName: 'file-user',
    icon: [
      384,
      512,
      [],
      'f65c',
      
      'M320 480l-16 0 0-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l0 16-16 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zm-48-16l0 16-160 0 0-16c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faScaleUnbalanced = {
    prefix: 'fal',
    iconName: 'scale-unbalanced',
    icon: [
      640,
      512,
      ["balance-scale-left"],
      'f515',
      
      'M527.8 10.9c2.8 8.4-1.7 17.4-10.1 20.2L383.5 75.9c-4.6 24.4-23.1 43.9-46.9 50.1l0 354 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-208 0c-8.8 0-16-7.2-16-16l0-370c-10.3-2.6-19.6-7.8-27.2-14.7L133.7 159.2c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L259.7 83.5c-2-6.1-3-12.7-3-19.5c0-35.3 28.7-64 64-64c28 0 51.8 18 60.5 43L507.6 .8C516-2 525 2.6 527.8 10.9zM440.7 330.3C457.8 343.1 482.9 352 512 352s54.2-8.9 71.3-21.7C600.4 317.5 608 302.2 608 288l-192 0 0-1.6c0 0 0 .1 0 .1l0 1.6c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 256l171.3 0L512 115.3zM384 288l0-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2C492.8 85.2 502.1 80 512 80s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6l0 1.6c0 53-57.3 96-128 96s-128-43-128-96zM32 416c0 14.2 7.6 29.5 24.7 42.3C73.8 471.1 98.9 480 128 480s54.2-8.9 71.3-21.7C216.4 445.5 224 430.2 224 416L32 416l0-1.6c0 0 0 .1 0 .1l0 1.6zm10.3-32l171.3 0L128 243.3 42.3 384zM128 512C57.3 512 0 469 0 416l0-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6l0 1.6c0 53-57.3 96-128 96zM320.7 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faBalanceScaleLeft = faScaleUnbalanced;
  

  
  

  var faFaceKissClosedEyes = {
    prefix: 'fal',
    iconName: 'face-kiss-closed-eyes',
    icon: [
      512,
      512,
      [],
      'e37d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm276.7 48.5c-10.8-5.3-25.3-9.2-38.6-11c-7.4-1-12.6-7.9-11.6-15.4s7.9-12.6 15.4-11.6c15.2 2.1 32.7 6.6 46.8 13.6c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4l-.2 .1 .2 .1c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4c-14.1 6.9-31.6 11.4-46.8 13.6c-7.4 1-14.3-4.1-15.4-11.6s4.1-14.3 11.6-15.4c13.3-1.9 27.8-5.8 38.6-11c5.4-2.7 9.2-5.3 11.5-7.7c2.7-2.9 2.7-4.7 0-7.6c-2.3-2.4-6.1-5.1-11.5-7.7c-10.7-5.3-25.1-9.1-38.3-11c-6.7-.8-12-6.7-12-13.5c0-6.8 5.3-12.7 12-13.5c13.2-1.9 27.6-5.8 38.3-11c5.4-2.7 9.2-5.3 11.5-7.7c2.7-2.9 2.7-4.7 0-7.6c-2.3-2.4-6.1-5.1-11.5-7.7zm-65.5-70.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z'
      
    ]
  };

  

  
  

  var faVihara = {
    prefix: 'fal',
    iconName: 'vihara',
    icon: [
      640,
      512,
      [],
      'f6a7',
      
      'M309.8 3.7l-26.3 21c-33.9 27.1-72.3 48-113.5 61.8l-31 10.3c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l10.9-3.6 0 47.2c-28.9 33.7-67.6 57.6-110.7 68.4l-4.8 1.2c-1.3 .3-2.5 .7-3.6 1.3c-2.1 1.1-4 2.6-5.4 4.4s-2.5 4-3 6.3c-.4 1.8-.5 3.6-.3 5.5s.8 3.6 1.6 5.2c1.1 2.1 2.6 4 4.4 5.4s4 2.5 6.3 3c1.2 .3 2.5 .4 3.9 .4L96 272l0 61.6c-14.7 31.3-38.9 57.3-69.2 74.1L8.5 417.9c-.6 .3-1.2 .7-1.7 1.1c-1.9 1.3-3.5 3-4.6 5s-1.9 4.1-2.1 6.4c-.2 1.9-.1 3.8 .4 5.7s1.3 3.6 2.4 5.2c1.3 1.9 3 3.5 5 4.6s4.1 1.9 6.4 2.1c.7 .1 1.3 .1 2 .1L64 448l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 128 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 128 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 47.7 0c.7 0 1.4 0 2-.1c2.3-.2 4.5-1 6.4-2.1s3.6-2.7 5-4.6c1.1-1.6 1.9-3.3 2.4-5.2s.6-3.8 .4-5.7c-.2-2.3-1-4.5-2.1-6.4s-2.7-3.6-4.6-5c-.6-.4-1.1-.7-1.7-1.1l-18.3-10.2c-30.3-16.8-54.5-42.8-69.2-74.1l0-61.6 47.7 0c1.3 0 2.6-.1 3.9-.4c2.3-.5 4.5-1.6 6.3-3s3.4-3.3 4.4-5.4c.8-1.6 1.4-3.4 1.6-5.2s.1-3.7-.3-5.5c-.5-2.3-1.6-4.5-3-6.3s-3.3-3.4-5.4-4.4c-1.1-.6-2.4-1-3.6-1.3l-4.8-1.2c-43.2-10.8-81.8-34.7-110.7-68.4l0-47.2 10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L470 86.5c-41.2-13.7-79.6-34.6-113.5-61.8l-26.3-21c-1.1-.9-2.2-1.6-3.4-2.2C324.7 .5 322.3 0 320 0s-4.7 .5-6.8 1.5c-1.2 .6-2.4 1.3-3.4 2.2zM128 352l192 0 192 0 5.4 0c12.5 24.8 30 46.6 51.3 64L320 416 71.3 416c21.3-17.4 38.8-39.2 51.3-64l5.4 0zm0-32l0-48 192 0 192 0 0 48-192 0-192 0zm64-160l0-47.3c40.3-14.9 77.9-36.1 111.5-62.9L320 36.5l16.5 13.2c33.6 26.8 71.2 48.1 111.5 62.9l0 47.3-128 0-128 0zm128 80l-191.9 0c20.8-13 39.7-29.2 55.9-48l136 0 136 0c16.2 18.8 35.1 35 55.9 48L320 240z'
      
    ]
  };

  

  
  

  var faFloppyDisk = {
    prefix: 'fal',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      'M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.2c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6L416 416c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM96 64l192 0 0 96L96 160l0-96zM0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-245.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faShop = {
    prefix: 'fal',
    iconName: 'shop',
    icon: [
      640,
      512,
      ["store-alt"],
      'f54f',
      
      'M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0l391 0c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2L576 224l0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272L96 224l0 128 256 0 0-80 0-16 32 0 0 16 0 192c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-240-25.8 0C17.1 224 0 206.9 0 185.8zM80 192l480 0 41.8 0c3.4 0 6.2-2.8 6.2-6.2c0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3l-391 0c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5 .9-.8 1.9-.8 3c0 3.4 2.8 6.2 6.2 6.2L80 192zM96 464c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-80L96 384l0 80z'
      
    ]
  };

  
    var faStoreAlt = faShop;
  

  
  

  var faPrescription = {
    prefix: 'fal',
    iconName: 'prescription',
    icon: [
      448,
      512,
      [],
      'f5b1',
      
      'M31.1 0C13.9 0 0 13.9 0 31.1L0 208l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 105.4 0 128 128L132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 374.6 420.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L310.6 352 443.3 219.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L288 329.4 182.4 223.8C241.3 220.5 288 171.7 288 112C288 50.1 237.9 0 176 0L31.1 0zM144 192s0 0 0 0L32 192 32 32l144 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-32 0z'
      
    ]
  };

  

  
  

  var faWalker = {
    prefix: 'fal',
    iconName: 'walker',
    icon: [
      448,
      512,
      [],
      'f831',
      
      'M178.8 32L320 32c26.5 0 48 21.5 48 48l0 112-264.6 0L132 69.1C137.1 47.4 156.5 32 178.8 32zM368 224l0 162c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-306c0-44.2-35.8-80-80-80L178.8 0c-37.2 0-69.5 25.6-77.9 61.8L.4 492.4c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9L96 223.6l0 .4 272 0zm48 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faScreencast = {
    prefix: 'fal',
    iconName: 'screencast',
    icon: [
      576,
      512,
      [],
      'e23e',
      
      'M512 64L64 64C46.3 64 32 78.3 32 96l0 96.1c-2.7-.1-5.3-.1-8-.1L0 192 0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-224 0 0-24c0-2.7 0-5.3-.1-8L512 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32zM16 224c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 336c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faDiploma = {
    prefix: 'fal',
    iconName: 'diploma',
    icon: [
      640,
      512,
      ["scroll-ribbon"],
      'f5ea',
      
      'M253.2 80.8C245 70.2 232.4 64 219 64l-3 0c-22.1 0-40 17.9-40 40s17.9 40 40 40l40 0 45.8 0L253.2 80.8zm-97 63.2c-7.7-11.4-12.1-25.2-12.1-40c0-39.8 32.2-72 72-72l3 0c23.3 0 45.3 10.8 59.5 29.3L320 115.2l41.5-53.9C375.7 42.8 397.7 32 421 32l3 0c39.8 0 72 32.2 72 72c0 14.8-4.5 28.6-12.1 40l60.1 0c65.1 .3 96 71.5 96 128c0 56.9-24.1 119.2-81 140.7c-10.5 4-22.5 4.2-33.4 1.8L400 386.6l0 77.4c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7L320 449.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6l0-77.4L114.4 414.5l-6.9-31.2L240 353.8 240 176l-24 0L96.1 176c-18.9 .1-33.9 9.9-45.5 28.1C38.5 223.1 32 248.8 32 272c0 50.8 21.4 96.1 60.3 110.8c3.5 1.3 9.1 1.8 15.1 .5l6.9 31.2c-10.9 2.4-22.9 2.2-33.4-1.8C24.1 391.2 0 328.9 0 272c0-56.5 30.9-127.7 96-128l60.1 0zM400 176l0 177.8 132.6 29.5c6 1.3 11.6 .9 15.1-.5c38.9-14.7 60.3-60 60.3-110.8c0-23.2-6.5-48.9-18.6-67.9c-11.6-18.2-26.6-28-45.5-28.1L424 176l-24 0zm24-32c22.1 0 40-17.9 40-40s-17.9-40-40-40l-3 0c-13.4 0-26 6.2-34.1 16.8L338.2 144l45.8 0 40 0zm-88 32l-32 0-32 0 0 262.1 40.8-20.4c4.5-2.3 9.8-2.3 14.3 0L368 438.1 368 176l-32 0z'
      
    ]
  };

  
    var faScrollRibbon = faDiploma;
  

  
  

  var faShirtTankTop = {
    prefix: 'fal',
    iconName: 'shirt-tank-top',
    icon: [
      384,
      512,
      [],
      'e3c9',
      
      'M96 16C96 7.2 88.8 0 80 0S64 7.2 64 16c0 134.3-29.3 192.6-45.6 214.6C9.5 242.5 0 259.2 0 278.2L0 456c0 30.9 25.1 56 56 56l272 0c30.9 0 56-25.1 56-56l0-177.8c0-19-9.5-35.7-18.4-47.6C349.3 208.6 320 150.3 320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 53-43 96-96 96s-96-43-96-96l0-48zM86.5 136.5C109.6 170 148.2 192 192 192s82.4-22 105.5-55.5c10.7 59.8 28.4 94.1 42.4 113.1c7.6 10.2 12.1 20 12.1 28.6L352 456c0 13.3-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24l0-177.8c0-8.6 4.6-18.4 12.1-28.6c14-19 31.7-53.3 42.4-113.1z'
      
    ]
  };

  

  
  

  var faChessBishopPiece = {
    prefix: 'fal',
    iconName: 'chess-bishop-piece',
    icon: [
      256,
      512,
      ["chess-bishop-alt"],
      'f43b',
      
      'M96 32l32 0 32 0c8.8 0 16 7.2 16 16c0 6-3.3 11.2-8.1 13.9c4 4.2 8.2 8.8 12.4 13.8C201.4 101.1 224 138.7 224 184c0 16.6-4.4 30.1-10.8 40.9C219.5 227 224 233 224 240c0 8.8-7.2 16-16 16l-11.9 0 9.6 96-32.2 0-9.6-96-71.8 0-9.6 96-32.2 0 9.6-96L48 256c-8.8 0-16-7.2-16-16c0-7 4.5-13 10.8-15.1C36.4 214.1 32 200.6 32 184c0-45.3 22.6-82.9 43.7-108.2c4.2-5 8.4-9.7 12.4-13.8C83.3 59.2 80 54 80 48c0-8.8 7.2-16 16-16zm75.5 192c10.2-7.5 20.5-19.8 20.5-40c0-18.9-5.2-36.6-13-52.4l-31.7 31.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l37-37c-2-2.6-3.9-5.1-5.9-7.5C146.4 85.1 137 76.2 130 70.1c-.7-.6-1.4-1.2-2-1.7c-.6 .5-1.3 1.1-2 1.7c-7 6.1-16.4 15-25.7 26.2C81.4 118.9 64 149.3 64 184c0 20.2 10.3 32.5 20.5 40l87.1 0zm45.9 175.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4L39.4 512C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1l124.4 0c11.1 0 21.4 5.7 27.2 15.1zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4l177.1 0c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416z'
      
    ]
  };

  
    var faChessBishopAlt = faChessBishopPiece;
  

  
  

  var faFaceFrown = {
    prefix: 'fal',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faDryer = {
    prefix: 'fal',
    iconName: 'dryer',
    icon: [
      448,
      512,
      [],
      'f861',
      
      'M384 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm64 96A24 24 0 1 0 80 96a24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 296c-56.4 0-103.1-41.7-110.9-96l62.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-62.9 0c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112zM80 304a144 144 0 1 0 288 0A144 144 0 1 0 80 304z'
      
    ]
  };

  

  
  

  var faWindowMaximize = {
    prefix: 'fal',
    iconName: 'window-maximize',
    icon: [
      512,
      512,
      [128470],
      'f2d0',
      
      'M64 64C46.3 64 32 78.3 32 96l0 96 448 0 0-96c0-17.7-14.3-32-32-32L64 64zM32 224l0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-192L32 224zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faHouseChimney = {
    prefix: 'fal',
    iconName: 'house-chimney',
    icon: [
      576,
      512,
      [63499,"home-lg"],
      'e3af',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4 384 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 136.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1L480 64l-64 0 0 43.6 64 56.5zM96 206.7L96 432c0 26.5 21.5 48 48 48l64 0 0-160c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 160 64 0c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7zM336 320l-96 0 0 160 96 0 0-160z'
      
    ]
  };

  
    var faHomeLg = faHouseChimney;
  

  
  

  var faArrowUpLeftFromCircle = {
    prefix: 'fal',
    iconName: 'arrow-up-left-from-circle',
    icon: [
      512,
      512,
      [],
      'e09e',
      
      'M176 0L16 0C7.2 0 0 7.2 0 16L0 176c0 8.8 7.2 16 16 16s16-7.2 16-16L32 54.6 300.7 323.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 32 176 32c8.8 0 16-7.2 16-16s-7.2-16-16-16zM288 64c-8.8 0-16 7.2-16 16s7.2 16 16 16c106 0 192 86 192 192s-86 192-192 192S96 394 96 288c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z'
      
    ]
  };

  

  
  

  var faHeartCircleXmark = {
    prefix: 'fal',
    iconName: 'heart-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e501',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBus = {
    prefix: 'fal',
    iconName: 'bus',
    icon: [
      576,
      512,
      [128653],
      'f207',
      
      'M288 32C170.1 32 113.2 70.2 97.2 90c-.4 .5-1.2 1.9-1.2 5.1L96 128l384 0 0-32.8c0-3.1-.8-4.9-1.3-5.6C463.9 70.1 414.8 32 288 32zM96 256l176 0 0-96L96 160l0 96zm208 0l176 0 0-96-176 0 0 96zM96 384c0 17.7 14.3 32 32 32l239.2 0 80.8 0c17.7 0 32-14.3 32-32l0-96L96 288l0 96zM72.3 69.9C96.5 40.1 164.2 0 288 0C420.6 0 481.2 40 504.2 70.2c6 7.9 7.8 17.2 7.8 25L512 384c0 23.7-12.9 44.4-32 55.4l0 56.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-80.8 0L128 448l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-56.6C76.9 428.4 64 407.7 64 384L64 95.2c0-7.7 1.8-17.2 8.3-25.3zM136 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM240 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 144l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm544 0l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faPump = {
    prefix: 'fal',
    iconName: 'pump',
    icon: [
      640,
      512,
      [],
      'e442',
      
      'M76.9 0c-8.8 0-16 7.2-16 16s7.2 16 16 16L96 32l0 176-64 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32L0 384l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 288 0 0-32L32 368l0-128 80 0c8.8 0 16-7.2 16-16l0-192 128 0 0 192c0 8.8 7.2 16 16 16l48 0 0-32-32 0 0-176 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L272 0 112 0 76.9 0zM449.6 133.4c5.3-3.5 11.4-5.4 17.8-5.4L576 128c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-108.6 0c-6.3 0-12.5-1.9-17.8-5.4l-51.4-34.3c-8.9-5.9-14.2-15.9-14.2-26.6l0-219.5c0-10.7 5.3-20.7 14.2-26.6l51.4-34.3zM431.9 501.3c10.5 7 22.9 10.7 35.5 10.7L576 512c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L467.4 96c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3l0 219.5c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSignal = {
    prefix: 'fal',
    iconName: 'signal',
    icon: [
      640,
      512,
      [128246,"signal-5","signal-perfect"],
      'f012',
      
      'M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480zM448 96c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16s16-7.2 16-16l0-384c0-8.8-7.2-16-16-16zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288zM192 288c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faSignal5 = faSignal;
  
    var faSignalPerfect = faSignal;
  

  
  

  var faFileCode = {
    prefix: 'fal',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm91.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L118.6 336l36.7-36.7zm144 25.4l-48-48c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 336l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faToiletPaperBlankUnder = {
    prefix: 'fal',
    iconName: 'toilet-paper-blank-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse-alt"],
      'e29f',
      
      'M58.2 75.2C42.3 104.3 32 145.5 32 192s10.3 87.7 26.2 116.8C74.4 338.5 94.1 352 112 352l225.3 0c-7.2-8.2-13.6-17.7-19.2-27.9C299.2 289.5 288 242.8 288 192s11.2-97.5 30.1-132.1c5.6-10.2 12-19.6 19.2-27.9L112 32C94.1 32 74.4 45.5 58.2 75.2zM400 32c-17.9 0-37.6 13.5-53.8 43.2C330.3 104.3 320 145.5 320 192s10.3 87.7 26.2 116.8C362.4 338.5 382.1 352 400 352s37.6-13.5 53.8-43.2C469.7 279.7 480 238.5 480 192s-10.3-87.7-26.2-116.8C437.6 45.5 417.9 32 400 32zm80 432l0-136.4c-18.6 32.3-46.1 56.4-80 56.4l-288 0c-35.1 0-63.4-25.9-81.9-59.9C11.2 289.5 0 242.8 0 192S11.2 94.5 30.1 59.9C48.6 25.9 76.9 0 112 0L400 0c35.1 0 63.4 25.9 81.9 59.9C500.8 94.5 512 141.2 512 192l0 272c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-48 32 0 0 48c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16zM400 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16z'
      
    ]
  };

  
    var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
  

  
  

  var faFloppyDisks = {
    prefix: 'fal',
    iconName: 'floppy-disks',
    icon: [
      512,
      512,
      [],
      'e183',
      
      'M128 352c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-213.5c0-8.5-3.4-16.6-9.4-22.6L396.1 41.4c-3.4-3.4-7.6-6-12.1-7.6l0 78.2c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-80c-17.7 0-32 14.3-32 32l0 288zM352 32L192 32l0 80 160 0 0-80zM192 0L373.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L512 352c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64l32 0zM32 112l0 256c0 61.9 50.1 112 112 112l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0C64.5 512 0 447.5 0 368L0 112c0-8.8 7.2-16 16-16s16 7.2 16 16zM296 304a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-112a72 72 0 1 1 0 144 72 72 0 1 1 0-144z'
      
    ]
  };

  

  
  

  var faTowerObservation = {
    prefix: 'fal',
    iconName: 'tower-observation',
    icon: [
      512,
      512,
      [],
      'e586',
      
      'M248.8 1.7c4.5-2.3 9.8-2.3 14.3 0l176 88c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-8.8-4.4 0 78.1c0 26.5-21.5 48-48 48l-7.8 0 39.6 237.4c.1 .9 .2 1.8 .2 2.6l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c0-.9 .1-1.7 .2-2.6L151.8 240l-7.8 0c-26.5 0-48-21.5-48-48l0-78.1-8.8 4.4c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l176-88zM256 33.9l-128 64 0 30.1 256 0 0-30.1-128-64zM128 160l0 32c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-32-256 0zM359.4 480L256 391.4 152.6 480l206.8 0zM184 240c0 .9-.1 1.7-.2 2.6l-6.5 39.1L256 349.2l78.7-67.5-6.5-39.1c-.1-.9-.2-1.8-.2-2.6l-144 0zm-12.9 78.6L151 439.2l80.4-68.9-60.3-51.7zm109.5 51.7L361 439.2 340.9 318.6l-60.3 51.7z'
      
    ]
  };

  

  
  

  var faPen = {
    prefix: 'fal',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6 159.6 428.9c-7.6 7.6-16.9 13.1-27.2 16.1L39.6 472.4l27.3-92.8c3-10.3 8.6-19.6 16.1-27.2L318.4 117zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17z'
      
    ]
  };

  

  
  

  var faUserSlash = {
    prefix: 'fal',
    iconName: 'user-slash',
    icon: [
      640,
      512,
      [],
      'f506',
      
      'M448 128C448 57.3 390.7 0 320 0C266.1 0 219.9 33.4 201.1 80.6l26.6 21C239.2 61.4 276.1 32 320 32c53 0 96 43 96 96c0 35.9-19.7 67.2-48.9 83.7l26.6 21C426.6 209.5 448 171.2 448 128zm52.4 352L128 480c1.2-79.7 66.2-144 146.3-144l43.8 0-40.5-32-3.2 0C175.8 304 96 383.8 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c7 0 13.4-2.4 18.5-6.5L500.4 480zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faManhole = {
    prefix: 'fal',
    iconName: 'manhole',
    icon: [
      512,
      512,
      [],
      'e1d6',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM201.6 122.6C215.8 135.9 235 144 256 144s40.2-8.1 54.4-21.4C363 144.1 400 195.8 400 256s-37 111.9-89.6 133.4C296.2 376.1 277 368 256 368s-40.2 8.1-54.4 21.4C149 367.9 112 316.2 112 256s37-111.9 89.6-133.4zm-1-33.7C130.5 112.1 80 178.2 80 256s50.5 143.9 120.6 167.1c7.1 2.4 14.6-1.4 19.6-7C229 406.2 241.8 400 256 400s27 6.2 35.8 16.1c5 5.6 12.4 9.4 19.6 7C381.5 399.9 432 333.8 432 256s-50.5-143.9-120.6-167.1c-7.1-2.4-14.6 1.4-19.6 7C283 105.8 270.2 112 256 112s-27-6.2-35.8-16.1c-5-5.6-12.4-9.4-19.6-7zM176 192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48-112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faHexagon = {
    prefix: 'fal',
    iconName: 'hexagon',
    icon: [
      512,
      512,
      [11043],
      'f312',
      
      'M16 224c-11.4 19.8-11.4 44.2 0 64l92.3 159.8c11.4 19.8 32.6 32 55.4 32l184.6 0c22.9 0 44-12.2 55.4-32L496 288c11.4-19.8 11.4-44.2 0-64L403.7 64.2c-11.4-19.8-32.6-32-55.4-32l-184.6 0c-22.9 0-44 12.2-55.4 32L16 224zm27.7 48c-5.7-9.9-5.7-22.1 0-32L136 80.2c5.7-9.9 16.3-16 27.7-16l184.6 0c11.4 0 22 6.1 27.7 16L468.3 240c5.7 9.9 5.7 22.1 0 32L376 431.8c-5.7 9.9-16.3 16-27.7 16l-184.6 0c-11.4 0-22-6.1-27.7-16L43.7 272z'
      
    ]
  };

  

  
  

  var faFileShield = {
    prefix: 'fal',
    iconName: 'file-shield',
    icon: [
      576,
      512,
      [],
      'e4f0',
      
      'M320 480c1.3 0 2.6-.1 3.9-.2c7.9 8.6 16.6 16.9 26.3 24.7c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 43.2-32 12.8 0-27.8-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0zm31.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM320.1 301.4c1.3 53 22.6 129.5 95.9 170L416 263l-95.9 38.4zm223.9 0L448 263l0 208.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z'
      
    ]
  };

  

  
  

  var faPersonMilitaryToPerson = {
    prefix: 'fal',
    iconName: 'person-military-to-person',
    icon: [
      512,
      512,
      [],
      'e54c',
      
      'M176 33.1l0 13.7-88 0 0-1.9 88-11.7zM180.8 .2L76.8 14.1C64.9 15.6 56 25.8 56 37.9l0 16.9c0 13.3 10.7 24 24 24l104 0c13.3 0 24-10.7 24-24L208 24C208 9.5 195.2-1.7 180.8 .2zM352 96.6a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM320 256.5c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 31.8-128 0 0-31.8zm-32 0l0 31.8c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-31.8c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zm-171.5-32l43.5 0c17.7 0 32 14.3 32 32l0 13.2-75.5-45.2zm44.2 63.8l-96.8 0 0-31.8c0-8.2 3.1-15.6 8.1-21.3l88.7 53.1zM96 192.5c-35.3 0-64 28.7-64 64l0 31.8c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-31.8c0-35.3-28.7-64-64-64l-64 0zM64 96.6c0 35.3 28.7 63.9 64 63.9s64-28.6 64-63.9l-32 0c0 17.6-14.3 31.9-32 31.9s-32-14.3-32-31.9l-32 0zm82.6 259.6c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6l40.5 35.9L16 416.1c-8.8 0-16 7.2-16 16s7.2 16 16 16l149.9 0-40.5 35.9c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l72-63.9c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-72-63.9zm218.8 0l-72 63.9c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l72 63.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6l-40.5-35.9 149.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-149.9 0 40.5-35.9c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z'
      
    ]
  };

  

  
  

  var faAudioDescription = {
    prefix: 'fal',
    iconName: 'audio-description',
    icon: [
      576,
      512,
      [],
      'f29e',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm192 64c6.1 0 11.6 3.4 14.3 8.8l80 160c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L238.1 304l-92.2 0-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l80-160c2.7-5.4 8.3-8.8 14.3-8.8zm30.1 112L192 211.8 161.9 272l60.2 0zM304 176c0-8.8 7.2-16 16-16l64 0c53 0 96 43 96 96s-43 96-96 96l-64 0c-8.8 0-16-7.2-16-16l0-160zm32 16l0 128 48 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-48 0z'
      
    ]
  };

  

  
  

  var faArrowsMinimize = {
    prefix: 'fal',
    iconName: 'arrows-minimize',
    icon: [
      512,
      512,
      ["compress-arrows"],
      'e0a5',
      
      'M36.7 36.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4 192 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144c0 8.8-7.2 16-16 16L64 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l105.4 0L36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6zm416 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 192 448 192c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0c-8.8 0-16-7.2-16-16l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 105.4L452.7 36.7zM48 304c0-8.8 7.2-16 16-16l144 0c8.8 0 16 7.2 16 16l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-105.4L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 320 64 320c-8.8 0-16-7.2-16-16zm240 0c0-8.8 7.2-16 16-16l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-105.4 0L475.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 342.6 320 448c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144z'
      
    ]
  };

  
    var faCompressArrows = faArrowsMinimize;
  

  
  

  var faBootHeeled = {
    prefix: 'fal',
    iconName: 'boot-heeled',
    icon: [
      512,
      512,
      [],
      'e33f',
      
      'M37 0C16.5 0 0 16.5 0 37c0 3.5 .5 7 1.5 10.3C6.5 65.1 32 158.5 32 232c0 15.4-3.7 37.3-9 60C17.9 314.4 11.6 336.3 7 351.5C2.6 366 0 381.3 0 396.9L0 432l0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-46.5 118.9 52.8c14.3 6.4 29.8 9.7 45.5 9.7L464 512l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-34.3c0-24.2-13.7-46.4-35.4-57.2L300.2 316.2C273.1 302.7 256 275 256 244.7L256 40c0-22.1-17.9-40-40-40L112 0 37 0zM96 32l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 88 0c4.4 0 8 3.6 8 8l0 204.7c0 42.4 24 81.2 61.9 100.2L430.3 417c10.8 5.4 17.7 16.5 17.7 28.6l0 34.3-155.6 0c-11.2 0-22.3-2.3-32.5-6.9L134.5 417.4c-2-.9-4.3-1.4-6.5-1.4l-16 0-80 0 0-19.1c0-12.1 2-24.2 5.6-36.1c4.7-15.5 11.3-38.2 16.6-61.6c5.3-23 9.8-47.9 9.8-67.2C64 153.5 37.2 56.2 32.2 38.5c-.2-.6-.2-1.1-.2-1.6c0-2.7 2.2-5 5-5l59 0zm0 448l-64 0 0-32 64 0 0 32z'
      
    ]
  };

  

  
  

  var faTicketAirline = {
    prefix: 'fal',
    iconName: 'ticket-airline',
    icon: [
      640,
      512,
      ["ticket-perforated-plane","ticket-plane"],
      'e29a',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-49.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4l0-49.6c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 66.4c0 8-8 13.6-16 13.6c-26.5 0-48 21.5-48 48s21.5 48 48 48c8 0 16 5.6 16 13.6l0 66.4c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm464 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM217.8 218.9c1.6 4.9 .8 10.2-2.2 14.4s-7.8 6.6-13 6.6L160 240c-5 0-9.8-2.4-12.8-6.4L128 208l-3.5 0 10.1 40.2c1.3 5.1 1.3 10.4 0 15.5L124.5 304l3.5 0 19.2-25.6c3-4 7.8-6.4 12.8-6.4l42.7 0c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L198.2 352l20 0c2.8 0 5.5-1.5 6.9-4l39.7-68.1c2.9-4.9 8.1-7.9 13.8-7.9l40.3 0c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13l-40.3 0c-5.7 0-11-3-13.8-7.9L225.1 164c-1.4-2.5-4.1-4-6.9-4l-20 0 19.6 58.9zM187.1 128l31.1 0c14.2 0 27.4 7.6 34.6 19.8L287.9 208l31.1 0c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2c-14.4 14.4-33.8 22.4-54.1 22.4l-31.1 0-35.1 60.2c-7.2 12.3-20.3 19.8-34.6 19.8l-31.1 0c-16.4 0-27.9-16-22.8-31.6L180.5 304 168 304l-14.4 19.2c-6 8.1-15.5 12.8-25.6 12.8l-13.8 0c-15.6 0-27.1-14.7-23.3-29.8L103.5 256 91 205.8c-3.8-15.1 7.7-29.8 23.3-29.8l13.8 0c10.1 0 19.6 4.7 25.6 12.8L168 208l12.5 0-16.1-48.4c-5.2-15.5 6.4-31.6 22.8-31.6z'
      
    ]
  };

  
    var faTicketPerforatedPlane = faTicketAirline;
  
    var faTicketPlane = faTicketAirline;
  

  
  

  var faHeat = {
    prefix: 'fal',
    iconName: 'heat',
    icon: [
      448,
      512,
      [],
      'e00c',
      
      'M176 32c8.8 0 16 7.2 16 16l0 96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6C174.6 232.8 160 189 160 144l0-96c0-8.8 7.2-16 16-16zM16 96c8.8 0 16 7.2 16 16l0 45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4l0 45.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-45.9c0-34.7-10.3-68.7-29.6-97.6L34.9 273.2C12.2 239.1 0 198.9 0 157.9L0 112c0-8.8 7.2-16 16-16zm336 16l0 45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4l0 45.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-45.9c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C332.2 239.1 320 198.9 320 157.9l0-45.9c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFaceSadCry = {
    prefix: 'fal',
    iconName: 'face-sad-cry',
    icon: [
      512,
      512,
      [128557,"sad-cry"],
      'f5b3',
      
      'M384 439.8L384 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 186.4c-29.1 13.8-61.6 21.6-96 21.6s-66.9-7.7-96-21.6L160 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 167.8C70 399.4 32 332.1 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 76.1-38 143.4-96 183.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24zm-32-88c-35.3 0-64 28.7-64 64l0 24c0 35.3 28.7 64 64 64s64-28.7 64-64l0-24c0-35.3-28.7-64-64-64z'
      
    ]
  };

  
    var faSadCry = faFaceSadCry;
  

  
  

  var faEye = {
    prefix: 'fal',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  

  
  

  var faBusSimple = {
    prefix: 'fal',
    iconName: 'bus-simple',
    icon: [
      448,
      512,
      ["bus-alt"],
      'f55e',
      
      'M33.2 90C49.2 70.2 106.1 32 224 32c126.8 0 175.9 38.1 190.7 57.5c.6 .8 1.3 2.5 1.3 5.6l0 .8L32 96l0-.8c0-3.2 .8-4.6 1.2-5.1zM32 128l384 0 0 128L32 256l0-128zM416 288l0 96c0 17.7-14.3 32-32 32l-80.8 0L64 416c-17.7 0-32-14.3-32-32l0-96 384 0zM224 0C100.2 0 32.5 40.1 8.3 69.9C1.8 77.9 0 87.4 0 95.2L0 384c0 23.7 12.9 44.4 32 55.4L32 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 239.2 0 80.8 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-56.6c19.1-11.1 32-31.7 32-55.4l0-288.8c0-7.8-1.8-17-7.8-25C417.2 40 356.6 0 224 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faBusAlt = faBusSimple;
  

  
  

  var faChestnut = {
    prefix: 'fal',
    iconName: 'chestnut',
    icon: [
      448,
      512,
      [127792],
      'e3f6',
      
      'M328.7 163.3c-14.2-14.2-29.7-27.3-46.4-41c-2.8-2.3-5.6-4.5-8.4-6.9c0 0 0 0 0 0c-13.9-11.4-28.5-23.3-42.5-36c-2.5-2.3-5-4.6-7.4-7c-2.4 2.3-4.8 4.7-7.4 7c-14 12.7-28.6 24.6-42.5 36c0 0 0 0 0 0c-2.8 2.3-5.6 4.6-8.4 6.9c-16.6 13.7-32.2 26.8-46.4 41C72.8 209.8 32 270 32 352l384 0c0-82-40.8-142.2-87.3-188.7zM37.5 384c13.2 37.3 48.7 64 90.5 64l192 0c41.8 0 77.4-26.7 90.5-64L37.5 384zM351.3 140.7C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128l-192 0C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2z'
      
    ]
  };

  

  
  

  var faTape = {
    prefix: 'fal',
    iconName: 'tape',
    icon: [
      576,
      512,
      [],
      'f4db',
      
      'M224 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM339.4 448C404.5 408.8 448 337.5 448 256C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-220.6 0zM224 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faBasketShopping = {
    prefix: 'fal',
    iconName: 'basket-shopping',
    icon: [
      576,
      512,
      ["shopping-basket"],
      'f291',
      
      'M327.9 2.2c-7.6 4.5-10.2 14.2-5.8 21.9l98 167.9-264.3 0 98-167.9c4.5-7.6 1.9-17.4-5.8-21.9s-17.4-1.9-21.9 5.8L118.8 192 65 192l-33 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0L99.9 463.5C107 492 132.6 512 162 512L414 512c29.4 0 55-20 62.1-48.5L536 224l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-33 0-53.8 0L349.8 7.9c-4.5-7.6-14.2-10.2-21.9-5.8zM73 224l430 0L445.1 455.8C441.5 470 428.7 480 414 480L162 480c-14.7 0-27.5-10-31-24.2L73 224zm151 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm64-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm96 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  
    var faShoppingBasket = faBasketShopping;
  

  
  

  var faHouseMedicalFlag = {
    prefix: 'fal',
    iconName: 'house-medical-flag',
    icon: [
      640,
      512,
      [],
      'e514',
      
      'M480 16l0 16 144 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-144 0 0 320-32 0 0-320 0-32 0-96 0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 160l0-96L480 64l0 96 128 0zM281.6 35.2L416 136l0 40L272 68 96 200l0 240c0 22.1 17.9 40 40 40l272 0c2.7 0 5.4-.3 8-.8l0 32.4c-2.6 .3-5.3 .4-8 .4l-272 0c-39.8 0-72-32.2-72-72l0-216L25.6 252.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l256-192c5.7-4.3 13.5-4.3 19.2 0zM256 176l32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32zm0 32l0 48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-48 0 0 32 48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16l0-48-32 0z'
      
    ]
  };

  

  
  

  var faMobileButton = {
    prefix: 'fal',
    iconName: 'mobile-button',
    icon: [
      384,
      512,
      [],
      'f10b',
      
      'M96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L96 32zM32 64C32 28.7 60.7 0 96 0L288 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTerminal = {
    prefix: 'fal',
    iconName: 'terminal',
    icon: [
      576,
      512,
      [],
      'f120',
      
      'M5.1 59.7c-6.5-6-6.9-16.1-.8-22.6s16.1-6.9 22.6-.8l224 208c3.3 3 5.1 7.3 5.1 11.7s-1.9 8.7-5.1 11.7l-224 208c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6L216.5 256 5.1 59.7zM240 448l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCircleSortUp = {
    prefix: 'fal',
    iconName: 'circle-sort-up',
    icon: [
      512,
      512,
      ["sort-circle-up"],
      'e032',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192l114.7 0L256 134.6 198.6 192zM148.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 377.4l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96z'
      
    ]
  };

  
    var faSortCircleUp = faCircleSortUp;
  

  
  

  var faBanSmoking = {
    prefix: 'fal',
    iconName: 'ban-smoking',
    icon: [
      512,
      512,
      [128685,"smoking-ban"],
      'f54d',
      
      'M86.7 109.3L201.4 224l32 32 32 32 32 32L402.7 425.3C363.4 459.4 312.1 480 256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7zM278.6 256L384 256l0 32-73.4 0-32-32zm64 64l57.4 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-153.4 0L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L342.6 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM220.1 288L128 288l0-32 60.1 0-32-32L112 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l140.1 0-32-32z'
      
    ]
  };

  
    var faSmokingBan = faBanSmoking;
  

  
  

  var faCartFlatbed = {
    prefix: 'fal',
    iconName: 'cart-flatbed',
    icon: [
      640,
      512,
      ["dolly-flatbed"],
      'f474',
      
      'M0 16C0 7.2 7.2 0 16 0L80 0c26.5 0 48 21.5 48 48l0 320c0 8.8 7.2 16 16 16l80 0 288 0 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56.6 0c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32l-177.1 0c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32L144 416c-26.5 0-48-21.5-48-48L96 48c0-8.8-7.2-16-16-16L16 32C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 64l-80 0c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16l-80 0 0 128c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L400 164l-54.4 40.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.3-8.8-14.3l0-128zm32 0l0 96 38.4-28.8c5.7-4.3 13.5-4.3 19.2 0L448 160l0-96-96 0zM240 32l320 0c26.5 0 48 21.5 48 48l0 192c0 26.5-21.5 48-48 48l-320 0c-26.5 0-48-21.5-48-48l0-192c0-26.5 21.5-48 48-48z'
      
    ]
  };

  
    var faDollyFlatbed = faCartFlatbed;
  

  
  

  var faCircleR = {
    prefix: 'fal',
    iconName: 'circle-r',
    icon: [
      512,
      512,
      [],
      'e120',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32l0 112 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 71.4 0 59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80l-80 0zm80 128l-80 0 0-96 80 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faArrowUpRight = {
    prefix: 'fal',
    iconName: 'arrow-up-right',
    icon: [
      384,
      512,
      [],
      'e09f',
      
      'M336 96c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-185.4L59.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128 112 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0z'
      
    ]
  };

  

  
  

  var faDolphin = {
    prefix: 'fal',
    iconName: 'dolphin',
    icon: [
      512,
      512,
      [],
      'e168',
      
      'M176 32l49.1 0c40.5 0 78.7 9.4 112.7 26.2c4 2 8.5 2.2 12.7 .7c32.4-12.1 73.2-24.6 105.2-26.6c-.8 3.3-2.2 7.6-4.2 13c-7.2 18.6-20.2 42.3-31.2 61.1c-3.4 5.8-2.8 13.1 1.5 18.3C458.1 168.8 480 225.2 480 286.9c0 54.4-33.6 100.9-81.2 119.9C409.7 391.3 416 372.4 416 352c0-46.5-33-85.2-76.8-94.1c-4.7-1-9.6 .3-13.3 3.3s-5.9 7.6-5.9 12.4l0 51.4c0 6.1-4.9 11-11 11c-2.9 0-5.6-1.1-7.7-3.1l-73.8-72.3c-3-2.9-7-4.6-11.2-4.6l-.3 0-40 0L50.2 256c-10 0-18.2-8.1-18.2-18.2c0-6.5 3.4-12.4 9-15.7l25.1-14.6c6.9-4.1 9.8-12.6 6.7-20c-5.6-13.4-8.8-28-8.8-43.5C64 82.1 114.1 32 176 32zm280.6-6.3s0 0 0 .1c0-.1 0-.1 0-.1zM320 416l-38.1 0-1-2.1C261.9 376 223.1 352 180.7 352l-4.7 0c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l4.7 0c42.4 0 81.2-24 100.2-61.9l1-2.1 38.1 0 30.9 0c89 0 161.1-72.1 161.1-161.1c0-65.3-21.8-125.6-58.6-173.8c10-17.5 21-38.4 27.9-56.2c3.9-10.2 7.4-21.4 7.3-30.9c0-4.8-1-11.5-5.6-17.3C477.9 2.3 470.6 0 464 0c-37 0-83.5 13.9-118.3 26.5C309 9.5 268.2 0 225.1 0L176 0C96.5 0 32 64.5 32 144c0 14.8 2.2 29.1 6.4 42.6l-13.5 7.9C9.5 203.5 0 220 0 237.8C0 265.5 22.5 288 50.2 288L176 288l33.8 0 69.1 67.7c8 7.9 18.8 12.3 30.1 12.3c23.7 0 43-19.2 43-43l0-28.5c19.1 11.1 32 31.8 32 55.4c0 35.3-28.7 64-64 64zM203.6 387.3c20.9 6.2 38.6 20.8 48.7 40.9l1.9 3.8-1.9 3.8c-10 20.1-27.8 34.7-48.7 40.9l18.8-37.5c2.3-4.5 2.3-9.8 0-14.3l-18.8-37.5zM152 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faArrowsToLine = {
    prefix: 'fal',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      'M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 137.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM0 256c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16zm235.3 68.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6 240 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-121.4-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z'
      
    ]
  };

  

  
  

  var faFaucetDrip = {
    prefix: 'fal',
    iconName: 'faucet-drip',
    icon: [
      512,
      512,
      [128688],
      'e006',
      
      'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L80 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 0 48-18.7 0c-12.7 0-24.9 5.1-33.9 14.1L121.4 160 16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7l34.7 0 34.7 0c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7l48 0c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48l-60.8 0c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8L16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l116.1 0c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48l52.1 0c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144l-41.4 0-33.9-33.9c-9-9-21.2-14.1-33.9-14.1L240 112l0-48 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L240 32l0-16zM448 431.6l13.3 21.3c1.8 2.8 2.7 6.1 2.7 9.4l0 1.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-1.7c0-3.3 .9-6.6 2.7-9.4L448 431.6zm-12.2-40.8l-28.2 45.1c-4.9 7.9-7.6 17-7.6 26.4l0 1.7c0 26.5 21.5 48 48 48s48-21.5 48-48l0-1.7c0-9.3-2.6-18.5-7.6-26.4l-28.2-45.1c-2.6-4.2-7.3-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z'
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fal',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      'M464 96c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-144 0 0-96 144 0zM48 96l240 0 0 96L48 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0-32C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64zM464 320c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-272 0 0-96 272 0zM48 320l112 0 0 96L48 416c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 288z'
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faNfcSymbol = {
    prefix: 'fal',
    iconName: 'nfc-symbol',
    icon: [
      512,
      512,
      [],
      'e531',
      
      'M367.2 475.6c5.1 4.9 12.9 5.8 19 2.2C462.2 433.9 513.1 349.8 513.1 256s-50.9-177.9-126.8-221.8c-7.6-4.4-17.4-1.8-21.9 5.8s-1.8 17.4 5.8 21.9C436.4 100.1 481.1 173.8 481.1 256c0 78-40.2 148.2-100.8 187.9L203 276.4c-6.4-6.1-16.5-5.8-22.6 .6s-5.8 16.5 .6 22.6l186.2 176zM145.9 36.4c-5.1-4.9-12.9-5.8-19-2.3C50.9 78.1 0 162.2 0 256s50.9 177.9 126.8 221.8c7.6 4.4 17.4 1.8 21.9-5.8s1.8-17.4-5.8-21.9C76.7 411.9 32 338.2 32 256c0-77.9 40.2-148.2 100.8-187.9L309 235.6c6.4 6.1 16.5 5.8 22.6-.6s5.8-16.5-.6-22.6L145.9 36.4z'
      
    ]
  };

  

  
  

  var faSquareChevronUp = {
    prefix: 'fal',
    iconName: 'square-chevron-up',
    icon: [
      448,
      512,
      ["chevron-square-up"],
      'f32c',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm235.3 68.7l112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 198.6 123.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l112-112c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faChevronSquareUp = faSquareChevronUp;
  

  
  

  var faHouseSignal = {
    prefix: 'fal',
    iconName: 'house-signal',
    icon: [
      576,
      512,
      [],
      'e012',
      
      'M325.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6s-15.8 7.5-22.6 1.7L512 187.9 512 352c0 35.3-28.7 64-64 64l-169.9 0c-3.1-11-6.9-21.7-11.3-32L448 384c17.7 0 32-14.3 32-32l0-191.5L336 37.1 192 160.5l0 123.8c-10.1-8.3-20.8-15.9-32-22.7l0-73.7-37.6 32.2c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM304 176l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 64 0 0-64-64 0zM16 256c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 368c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceRaisedEyebrow = {
    prefix: 'fal',
    iconName: 'face-raised-eyebrow',
    icon: [
      512,
      512,
      [],
      'e388',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm29.4-118.5l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5c10.7-10.7 28.5-8.9 36.9 3.7zM112 160c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm64 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faFaceZipper = {
    prefix: 'fal',
    iconName: 'face-zipper',
    icon: [
      512,
      512,
      [],
      'e3a5',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9c-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c32.4 0 63.5-6 92.1-17.1c8.2-3.2 12.4-12.4 9.2-20.7s-12.4-12.4-20.7-9.2c-25 9.6-52.1 14.9-80.6 14.9C132.3 480 32 379.7 32 256zm192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32zm48-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM160 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32zm40.4-128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm34.7 84.7l-22.5 22.5c-9.6 9.6-12.1 24.1-6.3 36.3l29.2 61.8c21.7 45.9 82.3 56.4 118.2 20.5s25.4-96.5-20.5-118.2l-61.8-29.2c-12.2-5.8-26.7-3.2-36.3 6.3zm84.4 51.8c25.9 12.2 31.8 46.4 11.6 66.6s-54.4 14.3-66.6-11.6l-29.2-61.8 22.5-22.5 61.8 29.2zm1 40c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0l-16 16c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0l16-16z'
      
    ]
  };

  

  
  

  var faCardDiamond = {
    prefix: 'fal',
    iconName: 'card-diamond',
    icon: [
      384,
      512,
      [],
      'e3ea',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm203.3 84.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM192 329.4L265.4 256 192 182.6 118.6 256 192 329.4z'
      
    ]
  };

  

  
  

  var faSquareParking = {
    prefix: 'fal',
    iconName: 'square-parking',
    icon: [
      448,
      512,
      [127359,"parking"],
      'f540',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM176 288l80 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-80 0 0 128zm80 32l-80 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-152c0-13.3 10.7-24 24-24l88 0c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  
    var faParking = faSquareParking;
  

  
  

  var faUserRobot = {
    prefix: 'fal',
    iconName: 'user-robot',
    icon: [
      448,
      512,
      [],
      'e04b',
      
      'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0c-44.2 0-80 35.8-80 80l0 96c0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80l0-96c0-44.2-35.8-80-80-80l-64 0 0-48zM96 144c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c-26.5 0-48-21.5-48-48l0-96zM16 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM160 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm192 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM96 384l256 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16l-32 0 0-32c0-17.7-14.3-32-32-32l-48 0-64 0-112 0c-17.7 0-32 14.3-32 32l0 32-32 0c-8.8 0-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64zm112 64l0 32-32 0 0-32 32 0zm-96 0l32 0 0 32-32 0 0-32zm112 64l64 0 48 0 32 0 32 0c26.5 0 48-21.5 48-48l0-16c0-53-43-96-96-96L96 352c-53 0-96 43-96 96l0 16c0 26.5 21.5 48 48 48l32 0 32 0 48 0 64 0zm16-64l32 0 0 32-32 0 0-32zm96 0l0 32-32 0 0-32 32 0z'
      
    ]
  };

  

  
  

  var faFaceMehBlank = {
    prefix: 'fal',
    iconName: 'face-meh-blank',
    icon: [
      512,
      512,
      [128566,"meh-blank"],
      'f5a4',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faMehBlank = faFaceMehBlank;
  

  
  

  var faForwardFast = {
    prefix: 'fal',
    iconName: 'forward-fast',
    icon: [
      512,
      512,
      [9197,"fast-forward"],
      'f050',
      
      'M496 64c-8.8 0-16 7.2-16 16l0 135.8L301.4 70.2c-5-4-11.2-6.2-17.6-6.2C268.4 64 256 76.4 256 91.8l0 150.1L45.4 70.2c-5-4-11.2-6.2-17.6-6.2C12.4 64 0 76.4 0 91.8L0 420.2C0 435.6 12.4 448 27.8 448c6.4 0 12.6-2.2 17.6-6.2L256 270.1l0 150.1c0 15.4 12.4 27.8 27.8 27.8c6.4 0 12.6-2.2 17.6-6.2L480 296.2 480 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-161.9 0-28.2L512 80c0-8.8-7.2-16-16-16zM478.7 256L288 411.4l0-310.7L478.7 256zM32 100.6L222.7 256 32 411.4l0-310.7z'
      
    ]
  };

  
    var faFastForward = faForwardFast;
  

  
  

  var faWineGlass = {
    prefix: 'fal',
    iconName: 'wine-glass',
    icon: [
      320,
      512,
      [127863],
      'f4e3',
      
      'M49.6 160l220.8 0 3.2 35.6C279.7 262.4 227.1 320 160 320S40.3 262.4 46.4 195.6L49.6 160zm2.9-32l8.7-96 197.6 0 8.7 96-215 0zM29.4 29.1L14.5 192.7C7.2 272.8 65.9 342.7 144 351.1L144 480l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-128.9c78.1-8.5 136.8-78.3 129.5-158.5L290.6 29.1C289.1 12.6 275.3 0 258.8 0L61.2 0C44.7 0 30.9 12.6 29.4 29.1z'
      
    ]
  };

  

  
  

  var faTags = {
    prefix: 'fal',
    iconName: 'tags',
    icon: [
      512,
      512,
      [],
      'f02c',
      
      'M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9L0 80C0 53.5 21.5 32 48 32l156.1 0zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7L48 64c-8.8 0-16 7.2-16 16l0 156.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faArrowTurnRight = {
    prefix: 'fal',
    iconName: 'arrow-turn-right',
    icon: [
      512,
      512,
      [],
      'e635',
      
      'M379.3 363.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 240 80 240c-26.5 0-48 21.5-48 48l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 288c0-44.2 35.8-80 80-80l377.4 0L356.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6l-128 128z'
      
    ]
  };

  

  
  

  var faHeadSideMedical = {
    prefix: 'fal',
    iconName: 'head-side-medical',
    icon: [
      512,
      512,
      [],
      'f809',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zM224 96c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 80l0-48 32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z'
      
    ]
  };

  

  
  

  var faFileCircleMinus = {
    prefix: 'fal',
    iconName: 'file-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ed',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faUserTieHairLong = {
    prefix: 'fal',
    iconName: 'user-tie-hair-long',
    icon: [
      448,
      512,
      [],
      'e460',
      
      'M320 128c0-5.5-.5-10.8-1.3-16l-30.1 0c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3L320 288c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.7 0c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3l58.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-58.7 0C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7l18.6 0C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64l28.9 0c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM180.4 477.9L124.7 357.2C71.5 372.9 32.6 421.9 32 480l149.4 0c-.3-.7-.7-1.4-1-2.1zM416 480c-.6-58.1-39.5-107.1-92.7-122.8L267.6 477.9c-.3 .7-.7 1.4-1 2.1L416 480zM131.8 322.7c6.8-1.3 13.4 2.5 16.3 8.8L180.1 401l21.7-65-9.8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-9.8 0 21.7 65 32.1-69.5c2.9-6.3 9.5-10 16.3-8.8c75 13.8 131.8 79.6 131.8 158.6c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-79 56.8-144.7 131.8-158.6zM248.3 443.4L224 370.6l-24.3 72.8 9.7 21.1c5.7 12.4 23.3 12.4 29.1 0l9.7-21.1z'
      
    ]
  };

  

  
  

  var faTeethOpen = {
    prefix: 'fal',
    iconName: 'teeth-open',
    icon: [
      576,
      512,
      [],
      'f62f',
      
      'M96 64l384 0c35.3 0 64 28.7 64 64l0 64c0 17.7-14.3 32-32 32l0-32c0-35.3-28.7-64-64-64c-14 0-27 4.5-37.6 12.2C399.5 114.2 373.9 96 344 96c-22.6 0-42.8 10.4-56 26.7C274.8 106.4 254.6 96 232 96c-29.9 0-55.5 18.2-66.4 44.2C155 132.5 142 128 128 128c-35.3 0-64 28.7-64 64l0 32c-17.7 0-32-14.3-32-32l0-64c0-35.3 28.7-64 64-64zM416 224l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32-64 0zm-112 0l0-56c0-22.1 17.9-40 40-40s40 17.9 40 40l0 24 0 32-80 0zm-72-96c22.1 0 40 17.9 40 40l0 56-80 0 0-32 0-24c0-22.1 17.9-40 40-40zM176 256l112 0 112 0 96 0 16 0c35.3 0 64-28.7 64-64l0-64c0-53-43-96-96-96L96 32C43 32 0 75 0 128l0 64c0 35.3 28.7 64 64 64l16 0 96 0zm-16-64l0 32-64 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zM480 448L96 448c-35.3 0-64-28.7-64-64l0-32c0-17.7 14.3-32 32-32l0 32c0 35.3 28.7 64 64 64c16.8 0 32-6.5 43.5-17c12.8 19.9 35.1 33 60.5 33c22.6 0 42.8-10.4 56-26.7c13.2 16.3 33.4 26.7 56 26.7c25.4 0 47.7-13.2 60.5-33c11.4 10.6 26.7 17 43.5 17c35.3 0 64-28.7 64-64l0-32c17.7 0 32 14.3 32 32l0 32c0 35.3-28.7 64-64 64zM272 360c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-8 0-32 80 0 0 40zm16-72l-112 0-96 0-16 0c-35.3 0-64 28.7-64 64l0 32c0 53 43 96 96 96l384 0c53 0 96-43 96-96l0-32c0-35.3-28.7-64-64-64l-16 0-96 0-112 0zm128 32l64 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32zm-32 32l0 8c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-40 80 0 0 32zm-224 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32 64 0 0 32z'
      
    ]
  };

  

  
  

  var faCommentMedical = {
    prefix: 'fal',
    iconName: 'comment-medical',
    icon: [
      512,
      512,
      [],
      'f7f5',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-16 96c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 80l0-48 32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z'
      
    ]
  };

  

  
  

  var faPanorama = {
    prefix: 'fal',
    iconName: 'panorama',
    icon: [
      640,
      512,
      [],
      'e209',
      
      'M45.6 64C38.1 64 32 70.1 32 77.6l0 356.7c0 7.5 6.1 13.6 13.6 13.6c1.6 0 3-.2 4.5-.7c2.5-.8 7.1-2.3 13.6-4.3l3.4-4.6L198.4 263.5c12.8-17.1 38.4-17.1 51.2 0L280 304l78.4-104.5c12.8-17.1 38.4-17.1 51.2 0L588.8 438.4l7.1 9.5c6.8-.8 12.1-6.5 12.1-13.5l0-356.7c0-7.5-6.1-13.6-13.6-13.6c-1.6 0-3 .2-4.5 .7C573.6 70.2 467.1 104 320 104S66.4 70.2 50.2 64.7c-1.5-.5-3-.7-4.5-.7zM546.1 434.9L384 218.7 292.8 340.3l-53.3 71.1c25.1-2.1 52-3.4 80.5-3.4c98.6 0 179 15.2 226.1 26.9zM196 415.9l64-85.3-36-48L113.3 430.3c22.7-5 50.6-10.2 82.8-14.4zM60.4 477.6c-4.7 1.6-9.7 2.4-14.7 2.4C20.4 480 0 459.6 0 434.4L0 77.6C0 52.4 20.4 32 45.6 32c5.1 0 10 .8 14.7 2.4C74.6 39.2 177.6 72 320 72s245.4-32.8 259.6-37.6c4.7-1.6 9.7-2.4 14.7-2.4C619.6 32 640 52.4 640 77.6l0 356.7c0 25.2-20.4 45.6-45.6 45.6c-5 0-10-.8-14.7-2.4C565.4 472.8 462.4 440 320 440s-245.4 32.8-259.6 37.6zM112 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faClipboardQuestion = {
    prefix: 'fal',
    iconName: 'clipboard-question',
    icon: [
      384,
      512,
      [],
      'e4e3',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM104.7 233.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9l57.1 0c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3l0 29.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-19.7 37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3l-57.1 0c-25.5 0-47.7 17.2-54.2 41.8zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCartCircleCheck = {
    prefix: 'fal',
    iconName: 'cart-circle-check',
    icon: [
      640,
      512,
      [],
      'e3f1',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2l129.5 0c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16l-129.5 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l187.2 0c5.9-11.4 12.9-22.2 21-32l-214.8 0L106.1 64l433.4 0L507.4 192.4c10.9 .7 21.5 2.4 31.7 5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faRoute = {
    prefix: 'fal',
    iconName: 'route',
    icon: [
      512,
      512,
      [],
      'f4d7',
      
      'M452.1 164.2c-11.7 18.7-25 36.5-36.1 50.4c-11.1-13.9-24.4-31.7-36.1-50.4C362.1 135.7 352 111.2 352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15.2-10.1 39.7-27.9 68.2zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 38.7 35 91.9 62.7 128L336 224c-44.2 0-80 35.8-80 80s35.8 80 80 80l96 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-266 0c-9.4 12.3-18.6 23.2-26.4 32L432 512c44.2 0 80-35.8 80-80s-35.8-80-80-80l-96 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l76.9 0c5.1 1.1 10.7-.6 14.5-5zM132.2 417.2C120.5 435 107.1 451.7 96 464.6C84.9 451.7 71.5 435 59.8 417.2C41.9 390.3 32 367 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15-9.9 38.3-27.8 65.2zm-7.6 63.1C152.9 446.7 192 392.8 192 352c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c1.6-1.7 3.3-3.6 5.1-5.6c1.8-2 3.8-4.2 5.8-6.6c2.2-2.5 4.4-5.1 6.7-7.9zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTruckField = {
    prefix: 'fal',
    iconName: 'truck-field',
    icon: [
      640,
      512,
      [],
      'e58d',
      
      'M320 64c17.7 0 32 14.3 32 32l0 96 0 32 0 128-101.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L64 352l0-64 0-160 0-32c0-17.7 14.3-32 32-32l224 0zM32 128c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0c0 53 43 96 96 96s96-43 96-96l96 0 32 0c0 53 43 96 96 96s96-43 96-96l32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-96c0-35.3-28.7-64-64-64l-22.4 0-42.4-78.8C470.8 97.7 454.5 88 436.9 88l-53.4 0c-3.9-31.6-30.9-56-63.5-56L96 32C60.7 32 32 60.7 32 96l0 32zm352 64l0-72 52.9 0c5.9 0 11.3 3.2 14.1 8.4L485.2 192 384 192zm5.5 160l-5.5 0 0-128 127.7 0c.2 0 .4 0 .6 0l31.7 0c17.7 0 32 14.3 32 32l0 96-5.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64zM96 384a64 64 0 1 1 128 0A64 64 0 1 1 96 384zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faBasketShoppingPlus = {
    prefix: 'fal',
    iconName: 'basket-shopping-plus',
    icon: [
      576,
      512,
      [],
      'e653',
      
      'M322.2 24.1c-4.5-7.6-1.9-17.4 5.8-21.9s17.4-1.9 21.9 5.8L457.2 192l53.8 0 33 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L40 224l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 33 0 53.8 0L226.2 7.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9L155.9 192l264.3 0-98-167.9zM503 224L73 224l57.9 231.8c3.6 14.2 16.4 24.2 31 24.2L414 480c14.7 0 27.5-10 31-24.2L503 224zM192 352c0-8.8 7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faUserCrown = {
    prefix: 'fal',
    iconName: 'user-crown',
    icon: [
      448,
      512,
      [],
      'f6a4',
      
      'M238.7 4.4C234.3 1.5 229.2 0 224 0s-10.3 1.5-14.7 4.4L176.9 26.1c-5.4 3.6-12.4 3.6-17.8 0L124 2.7C121.4 .9 118.3 0 115.2 0L112 0c-8.8 0-16 7.2-16 16l0 112 0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16 0-112c0-8.8-7.2-16-16-16l-3.2 0c-3.2 0-6.2 .9-8.9 2.7L288.9 26.1c-5.4 3.6-12.4 3.6-17.8 0L238.7 4.4zM320 112l-192 0 0-68.2 13.4 8.9c16.1 10.7 37.1 10.7 53.3 0L224 33.1l29.4 19.6c16.1 10.7 37.1 10.7 53.3 0L320 43.8l0 68.2zM128 144l192 0c0 53-43 96-96 96s-96-43-96-96zm40 192l112 0c75.1 0 136 60.9 136 136l0 8L32 480l0-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-92.8-75.2-168-168-168l-112 0z'
      
    ]
  };

  

  
  

  var faFaceClouds = {
    prefix: 'fal',
    iconName: 'face-clouds',
    icon: [
      640,
      512,
      [],
      'e47d',
      
      'M99.8 54.9C97.2 60.4 91.6 64 85.4 64L64 64C46.3 64 32 78.3 32 96s14.3 32 32 32l152 0c22.1 0 40-17.9 40-40s-17.9-40-40-40c-8.7 0-16.6 2.7-23.2 7.4c-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C162.9 39.5 150.3 32 136 32c-15.9 0-29.7 9.3-36.2 22.9zM136 0c20.3 0 38.6 8.4 51.6 21.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72L64 160C28.7 160 0 131.3 0 96S28.7 32 64 32l12.1 0C89 12.7 111 0 136 0zM288.3 1.9C298.7 .7 309.3 0 320 0C461.4 0 576 114.6 576 256c0 7.3-.3 14.5-.9 21.7c-9.4-6-20-10.2-31.3-12.2c.1-3.1 .2-6.3 .2-9.4C544 132.3 443.7 32 320 32c-3.6 0-7.1 .1-10.7 .2C304 21 296.9 10.8 288.3 1.9zM96 256c0 90.7 54 168.9 131.6 204.1c4 15.5 11.2 29.7 20.9 41.8C141.9 470.9 64 372.6 64 256c0-22.1 2.8-43.5 8.1-64l33.2 0c-6 20.3-9.3 41.8-9.3 64zm120.4-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 304c-35.3 0-64 28.7-64 64c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48s21.5 48 48 48l224 0c26.5 0 48-21.5 48-48c0-24.7-18.6-45-42.5-47.7c-4.4-.5-8.4-2.8-11-6.3s-3.7-8-2.9-12.4c.3-1.8 .5-3.7 .5-5.6c0-17.7-14.3-32-32-32c-9.2 0-17.6 3.9-23.4 10.2c-3.4 3.7-8.4 5.5-13.4 5s-9.5-3.4-12-7.8C459.9 316.6 439.4 304 416 304zm-94.9 49.4c7-46.1 46.8-81.4 94.9-81.4c28.7 0 54.5 12.6 72 32.5c9.4-5.4 20.3-8.5 32-8.5c33.9 0 61.6 26.3 63.9 59.6C616.4 365.8 640 396.1 640 432c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80c0-39.1 28-71.6 65.1-78.6z'
      
    ]
  };

  

  
  

  var faAnchorCircleExclamation = {
    prefix: 'fal',
    iconName: 'anchor-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ab',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 256-32 0c-79.5 0-144-64.5-144-144l0-25.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6 64 336c0 97.2 78.8 176 176 176l48 0 48 0c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8l-32 0 0-256 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faFiles = {
    prefix: 'fal',
    iconName: 'files',
    icon: [
      448,
      512,
      [],
      'e178',
      
      'M160 384c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l144 0 0 80c0 17.7 14.3 32 32 32l80 0c0 .3 0 .5 0 .8L416 352c0 17.7-14.3 32-32 32l-224 0zM336 57.5L390 112l-54 0 0-54.5zM160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-207.2c0-12.7-5-24.8-13.9-33.8l-96-96.8C329.1 5.1 316.8 0 304 0L160 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 384c0 70.7 57.3 128 128 128l208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-208 0c-53 0-96-43-96-96l0-272z'
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fal',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-352 0c0 9.6 4 18.7 11 25.2l102.8 95.5c5.1 4.7 11.8 7.3 18.7 7.3c15.2 0 27.5-12.3 27.5-27.5l0-201c0-15.2-12.3-27.5-27.5-27.5c-6.9 0-13.6 2.6-18.7 7.3L171 230.8c-7 6.5-11 15.6-11 25.2zm32.7 1.7c-.5-.4-.7-1.1-.7-1.7s.3-1.3 .7-1.7L288 165.8l0 180.3-95.3-88.4z'
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faTrashXmark = {
    prefix: 'fal',
    iconName: 'trash-xmark',
    icon: [
      448,
      512,
      [],
      'e2b4',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64l47.1 0L416 64l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-18.3 0L388.2 452.6C385.9 486.1 358 512 324.4 512l-200.8 0c-33.6 0-61.4-25.9-63.8-59.4L34.3 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32.1 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480l200.8 0c16.8 0 30.7-13 31.9-29.7L381.6 96 66.4 96zm82.3 116.7c6.2-6.2 16.4-6.2 22.6 0L224 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faCat = {
    prefix: 'fal',
    iconName: 'cat',
    icon: [
      576,
      512,
      [128008],
      'f6be',
      
      'M352 33l0 111c0 44.2 35.8 80 80 80s80-35.8 80-80l0-111c0-.5-.4-1-1-1c-.3 0-.5 .1-.7 .3L472 70.6c-6 6-14.1 9.4-22.6 9.4l-34.7 0c-8.5 0-16.6-3.4-22.6-9.4L353.7 32.3c-.2-.2-.4-.3-.7-.3c-.5 0-1 .4-1 1zm1-33c8.7 0 17.1 3.5 23.3 9.7L414.6 48l34.7 0L487.7 9.7C493.9 3.5 502.3 0 511 0c18.2 0 33 14.8 33 33l0 111c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-111c0-18.2 14.8-33 33-33zM128 299.2c33.8-61.5 92.1-108.2 162.9-126.2c2.2 10.6 5.5 20.9 9.9 30.5C200.2 228.2 128 318.7 128 424l0 8c0 26.5 21.5 48 48 48l128 0c0 0 0 0 0 0l42.6 0c2.9 0 5.3-2.4 5.3-5.3c0-14.7-11.9-26.7-26.7-26.7L288 448c-8.8 0-16-7.2-16-16c0 0 0 0 0 0l0-40c0-22.1-17.9-40-40-40l-8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0c39.8 0 72 32.2 72 72l0 4.4L421.4 292c3-2.6 6.7-4 10.5-4l.1 0 .1 0c2.2 0 4.4 .5 6.4 1.4c5.7 2.6 9.4 8.3 9.4 14.6l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-184.2c11.4-4 22.1-9.4 32-16.1L512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-124.4-86.1 76.5c30.3 2.3 54.1 27.6 54.1 58.5c0 20.6-16.7 37.3-37.3 37.3L304 512l-128 0-.1 0c-44.1-.1-79.9-35.9-79.9-80l0-8 0-247.5c0-24.2-18-44.6-42-47.6l-7.9-1c-8.8-1.1-15-9.1-13.9-17.9s9.1-15 17.9-13.9l7.9 1c40 5 70.1 39 70.1 79.4l0 122.7zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTruckFront = {
    prefix: 'fal',
    iconName: 'truck-front',
    icon: [
      512,
      512,
      [],
      'e2b7',
      
      'M80 32C53.5 32 32 53.5 32 80l0 168.4c10.8-9.7 23.9-17 38.3-21l31.3-88.8c9-25.6 33.2-42.7 60.4-42.7L350 96c27.1 0 51.3 17.1 60.4 42.7l31.3 88.8c14.4 4 27.4 11.3 38.3 21L480 80c0-26.5-21.5-48-48-48L80 32zM32 320l0 48c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-48c0-35.3-28.7-64-64-64L96 256c-35.3 0-64 28.7-64 64zM0 320L0 80C0 35.8 35.8 0 80 0L432 0c44.2 0 80 35.8 80 80l0 240 0 48c0 26.2-12.6 49.4-32 64l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-49.6c-5.2 1-10.5 1.6-16 1.6L80 448c-5.5 0-10.8-.6-16-1.6L64 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64C12.6 417.4 0 394.2 0 368l0-48zm105.4-96l301.1 0-26.3-74.7C375.7 136.6 363.6 128 350 128L162 128c-13.6 0-25.7 8.6-30.2 21.3L105.4 224zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSquareQuarters = {
    prefix: 'fal',
    iconName: 'square-quarters',
    icon: [
      448,
      512,
      [],
      'e44e',
      
      'M55.7 65.1L224 233.4 392.3 65.1c-2.6-.7-5.4-1.1-8.3-1.1L64 64c-2.9 0-5.6 .4-8.3 1.1zM33.1 87.7C32.4 90.4 32 93.1 32 96l0 320c0 2.9 .4 5.6 1.1 8.3L201.4 256 33.1 87.7zM55.7 446.9c2.6 .7 5.4 1.1 8.3 1.1l320 0c2.9 0 5.6-.4 8.3-1.1L224 278.6 55.7 446.9zm359.2-22.6c.7-2.6 1.1-5.4 1.1-8.3l0-320c0-2.9-.4-5.6-1.1-8.3L246.6 256 414.9 424.3zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faFileDoc = {
    prefix: 'fal',
    iconName: 'file-doc',
    icon: [
      512,
      512,
      [],
      'e5ed',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM176 352l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 128l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z'
      
    ]
  };

  

  
  

  var faArrowDownFromDottedLine = {
    prefix: 'fal',
    iconName: 'arrow-down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e090',
      
      'M235.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 425.4 208 320l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144 0 105.4L340.7 324.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faPhoneFlip = {
    prefix: 'fal',
    iconName: 'phone-flip',
    icon: [
      512,
      512,
      [128381,"phone-alt"],
      'f879',
      
      'M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64c0 0 0 0 0 0c0 236.7-183.5 430.5-416 446.9c-4.5 .3-9.1 .6-13.7 .8c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4c0 0 0 0 0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM64.3 480C293.9 479.8 480 293.7 480 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0-3.8-2.6-7-6.3-7.8l-112-24c-3.7-.8-7.5 1.2-9 4.7l-48 112c-1.4 3.3-.5 7.1 2.3 9.3l40.6 33.2c12.2 9.9 15.3 27.2 7.4 40.8c-29.5 50.9-71.9 93.3-122.7 122.7c-13.6 7.9-30.9 4.7-40.8-7.4l-33.2-40.6c-2.3-2.8-6.1-3.7-9.3-2.3l-112 48c-3.5 1.5-5.5 5.3-4.7 9l24 112c.8 3.7 4.1 6.3 7.8 6.3c.1 0 .2 0 .3 0z'
      
    ]
  };

  
    var faPhoneAlt = faPhoneFlip;
  

  
  

  var faBridge = {
    prefix: 'fal',
    iconName: 'bridge',
    icon: [
      576,
      512,
      [],
      'e4c8',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 128 0 128 0 128 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0L352 32 224 32 96 32 16 32zM464 64l0 64-96 0 0-64 96 0zM336 64l0 64-96 0 0-64 96 0zM208 64l0 64-96 0 0-64 96 0zM16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c35.3 0 64 28.7 64 64l0 96c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-96c0-35.3 28.7-64 64-64l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-53 0-96 43-96 96l0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96c0-53-43-96-96-96s-96 43-96 96l0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96c0-53-43-96-96-96l-16 0z'
      
    ]
  };

  

  
  

  var faHatCowboy = {
    prefix: 'fal',
    iconName: 'hat-cowboy',
    icon: [
      640,
      512,
      [],
      'f8c0',
      
      'M249.7 64c4.3 .2 6.7 1.1 8.2 1.8c2.1 1 4.3 2.6 8.5 6.3c.6 .5 1.2 1.1 1.9 1.7c0 0 0 0 0 0C276.7 81.3 293 96 320 96s43.3-14.7 51.7-22.2c.7-.6 1.3-1.2 1.9-1.7c4.2-3.7 6.4-5.2 8.5-6.3c1.5-.7 3.9-1.6 8.2-1.8c.5 .4 1.2 1 2.3 1.9c3.9 3.7 8.8 10.5 14.4 21c11.1 21 21.4 50.4 30.2 81.7c8.7 30.9 15.5 62 20.2 85.5c.8 4 1.5 7.9 2.2 11.4c10.8-3.7 21-7.6 30.3-11.7C476.4 184.2 441.4 32 392 32c-21.3 0-31.6 9.1-41.2 17.6C342.3 57 334.4 64 320 64s-22.3-7-30.8-14.4C279.6 41.1 269.3 32 248 32c-49.3 0-84.4 152.2-97.9 221.9c9.4 4.1 19.5 8 30.3 11.7c.7-3.5 1.4-7.3 2.2-11.3c4.7-23.5 11.5-54.6 20.2-85.5C211.6 137.4 221.9 108 233 87c5.6-10.5 10.6-17.3 14.4-21c1-1 1.8-1.6 2.3-1.9zm139.9-.5s0 0 .1 .1c-.1 0-.1-.1-.1-.1zm-139.3 .1c.1 0 .1-.1 .1-.1s0 0-.1 .1zm-239 156c-9.5 5.9-13.5 17.9-9.9 28.5c13.5 37.7 38.4 72.3 66.1 100.6C116.4 398.9 196.4 448 320 448s203.7-49.1 252.6-99.2c27.7-28.3 52.5-62.9 66.1-100.6c3.6-10.6-.4-22.6-9.9-28.5c-9.5-5.9-21.7-4.5-29.6 3.3c-20.4 19.4-45.3 34.8-70.1 47.7C481.8 295.2 411.6 320 320.1 320s-161.9-24.8-209-49.3C86.3 257.8 61.3 242.4 40.9 223c-7.9-7.9-20.2-9.2-29.6-3.3zm533.1 80.6c14.9-7.7 30.5-16.6 45.5-27.1c-11.3 18.7-25.4 36.4-41.1 52.4c-43.3 44.4-115.1 89.2-228.8 89.2c-113.7 0-185.4-44.8-228.7-89.2c-15.6-16-29.8-33.7-41.1-52.4c15 10.4 30.6 19.3 45.5 27.1c51.1 26.6 126.7 53 224.4 53s173.2-26.5 224.3-53z'
      
    ]
  };

  

  
  

  var faWarehouseFull = {
    prefix: 'fal',
    iconName: 'warehouse-full',
    icon: [
      640,
      512,
      ["warehouse-alt"],
      'f495',
      
      'M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59L640 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-320.1c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272-384 0 0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272zM352 400l0 80 80 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-80 0zm-32 80l0-80-128 0 0 64c0 8.8 7.2 16 16 16l112 0zm0-176c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 64 128 0 0-64zm112 64c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 32 0 32 32 0 48 0z'
      
    ]
  };

  
    var faWarehouseAlt = faWarehouseFull;
  

  
  

  var faCodeBranch = {
    prefix: 'fal',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      
      'M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4l0 115.2c20.3-20.7 48.7-33.6 80-33.6l96 0c44.2 0 80-35.8 80-80l0-1.6c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4l0 1.6c0 61.9-50.1 112-112 112l-96 0c-44.2 0-80 35.8-80 80l0 1.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4l0-1.6 0-193.6C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faObjectSubtract = {
    prefix: 'fal',
    iconName: 'object-subtract',
    icon: [
      512,
      512,
      [],
      'e49e',
      
      'M64 32l32 0L96 0 64 0C28.7 0 0 28.7 0 64L0 96l32 0 0-32c0-17.7 14.3-32 32-32zm160 0l0-32L128 0l0 32 96 0zM32 128L0 128l0 96 32 0 0-96zm0 128L0 256l0 32c0 35.3 28.7 64 64 64l32 0 0-32-32 0c-17.7 0-32-14.3-32-32l0-32zm96 96l32 0 32 0 32 0 0-32-32 0-32 0-32 0 0 32zm32 32l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0 0 32 64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-64-32 0zM352 192l0-32 0-32-32 0 0 32 0 32 0 32 32 0 0-32zm0-128c0-35.3-28.7-64-64-64L256 0l0 32 32 0c17.7 0 32 14.3 32 32l0 32 32 0 0-32zM256 320l0 32 32 0c35.3 0 64-28.7 64-64l0-32-32 0 0 32c0 17.7-14.3 32-32 32l-32 0z'
      
    ]
  };

  

  
  

  var faHouseWater = {
    prefix: 'fal',
    iconName: 'house-water',
    icon: [
      576,
      512,
      ["house-flood"],
      'f74f',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 158c9.9-5.7 20.9-8.6 32-8.6l0-177.7L288 37.3 480 206.7l0 177.7c11.1 0 22.1 2.9 32 8.6l0-158 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM208 208l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm128 0l0 96-96 0 0-96 96 0zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z'
      
    ]
  };

  
    var faHouseFlood = faHouseWater;
  

  
  

  var faPopcorn = {
    prefix: 'fal',
    iconName: 'popcorn',
    icon: [
      448,
      512,
      [127871],
      'f819',
      
      'M178.9 22.9c-8-4.4-17.1-6.9-26.9-6.9c-25.5 0-47 17-53.8 40.3C70 59.2 48 83 48 112c0 4.4 .5 8.6 1.5 12.7C34.5 131.3 23 144.2 18.3 160l35.8 0c4.4-4.9 10.8-8 17.9-8c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8c-3-4-4.8-9-4.8-14.4c0-13.3 10.7-24 24-24c1.7 0 3.3 .2 4.8 .5c4.7 1 9.6-.3 13.4-3.3s5.9-7.7 5.8-12.5l0-.7C128 58.7 138.8 48 152 48c8.1 0 15.2 4 19.6 10.1c3.7 5.3 10.2 7.8 16.5 6.4s11.1-6.4 12.3-12.8C202.4 40.5 212.2 32 224 32s21.6 8.5 23.6 19.7c1.1 6.3 6 11.4 12.3 12.8s12.8-1.1 16.5-6.4C280.8 52 287.9 48 296 48c13.2 0 24 10.7 24 23.9l0 .7c0 4.8 2.1 9.4 5.8 12.5s8.6 4.3 13.4 3.3c1.5-.3 3.2-.5 4.8-.5c13.3 0 24 10.7 24 24c0 3.5-.7 6.8-2.1 9.7c-2.1 4.7-1.8 10 .7 14.5s7 7.4 12.1 8c9.2 1 16.9 7.4 19.9 15.8l32.8 0c-2.7-19-14.9-34.9-31.7-42.7c.2-1.7 .2-3.5 .2-5.3c0-29-22-52.8-50.2-55.7C343 33 321.5 16 296 16c-9.7 0-18.9 2.5-26.9 6.9C258.9 9 242.5 0 224 0s-34.9 9-45.1 22.9zM33.2 224l64.9 0 30 210.3c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1L130.4 224l77.6 0 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 77.6 0L288.2 429.7c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l30-210.3 64.9 0L346.9 468.3c-1.9 6.9-8.2 11.7-15.4 11.7l-215 0c-7.2 0-13.5-4.8-15.4-11.7L33.2 224zM224 192l-111.7 0-.5 0-83.6 0C12.6 192 0 204.6 0 220.2c0 2.5 .3 5.1 1 7.5L70.2 476.8C76 497.6 94.9 512 116.5 512l215 0c21.6 0 40.5-14.4 46.2-35.2L447 227.7c.7-2.5 1-5 1-7.5c0-15.6-12.6-28.2-28.2-28.2l-83.6 0-.5 0L224 192z'
      
    ]
  };

  

  
  

  var faFaceHandOverMouth = {
    prefix: 'fal',
    iconName: 'face-hand-over-mouth',
    icon: [
      512,
      512,
      [129762],
      'e378',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm144.4-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-95 125.3L248 318.6s0 0 0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c0 0 0 0 0 0l-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34s0 0 0 0s0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5c0 0 0 0 0 0l-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3l0 11.7 0 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4s0 0 0 0l51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6c0 0 0 0 0 0l-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 53.6 0 32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0z'
      
    ]
  };

  

  
  

  var faCircleK = {
    prefix: 'fal',
    iconName: 'circle-k',
    icon: [
      512,
      512,
      [],
      'e113',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.1-356.5c6.4-6.1 6.5-16.3 .4-22.6s-16.3-6.5-22.6-.4L192 260.8 192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 154.5 0 69.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-62.7 44.6-43.1 86.6 115.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4l-89-118.6 87.3-84.3z'
      
    ]
  };

  

  
  

  var faArrowRightFromArc = {
    prefix: 'fal',
    iconName: 'arrow-right-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b1',
      
      'M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM362.6 116c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6L453.9 240 176 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l277.9 0L341.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128z'
      
    ]
  };

  

  
  

  var faTypewriter = {
    prefix: 'fal',
    iconName: 'typewriter',
    icon: [
      512,
      512,
      [],
      'f8e7',
      
      'M128 32c-17.7 0-32 14.3-32 32l0 96-32 0 0-96C64 28.7 92.7 0 128 0L356.1 0c17 0 33.3 6.7 45.3 18.7l27.9 27.9c12 12 18.7 28.3 18.7 45.3l0 68.1-32 0 0-68.1c0-8.5-3.4-16.6-9.4-22.6L378.7 41.4c-6-6-14.1-9.4-22.6-9.4L128 32zM32 224l0 64 32 0 384 0 32 0 0-64-114.7 0L352 237.3c-12 12-28.3 18.7-45.3 18.7l-101.5 0c-17 0-33.3-6.7-45.3-18.7l22.6-22.6c6 6 14.1 9.4 22.6 9.4l101.5 0c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4L480 192c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 128c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-128c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l114.7 0c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3L160 237.3 146.7 224 32 224zm32 96l0 128c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-128L64 320zm96 96l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  

  
  

  var faCanFood = {
    prefix: 'fal',
    iconName: 'can-food',
    icon: [
      384,
      512,
      [129387],
      'e3e6',
      
      'M336 432l0-146.4c-12.8 6.5-27.7 11.9-43.7 16.2c-6.5 1.7-13.3 3.3-20.4 4.7c-1.3 43-36.6 77.6-80 77.6s-78.7-34.5-80-77.6c-7-1.4-13.8-3-20.4-4.7c-16-4.3-30.8-9.7-43.7-16.2L48 432c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C111.4 473.1 149.3 480 192 480s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1c6.1-5.8 7.6-10.3 7.6-13.3zm0-183.7l0-120.7c-7.4 4.7-15.9 8.9-24.9 12.5C279.8 152.6 237.7 160 192 160s-87.8-7.4-119.1-19.9c-9.1-3.6-17.5-7.8-24.9-12.5l0 120.7c11.7 8.5 29.3 16.4 51.9 22.5c5.6 1.5 11.4 2.9 17.5 4.1C129.1 245.1 158.1 224 192 224s62.9 21.1 74.5 50.9c6.1-1.2 11.9-2.6 17.5-4.1c22.7-6.1 40.3-14 51.9-22.5zM48 80c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C111.4 121.1 149.3 128 192 128s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1C334.5 87.5 336 83 336 80s-1.5-7.5-7.6-13.3c-6.1-5.8-15.9-11.8-29.2-17.1C272.6 38.9 234.7 32 192 32s-80.6 6.9-107.2 17.6C71.4 54.9 61.7 60.9 55.6 66.7C49.5 72.5 48 77 48 80zm320 0l0 352 0 8c0 39.8-78.8 72-176 72s-176-32.2-176-72l0-8L16 80l0-8C16 32.2 94.8 0 192 0s176 32.2 176 72l0 8zM192 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faBorderCenterH = {
    prefix: 'fal',
    iconName: 'border-center-h',
    icon: [
      448,
      512,
      [],
      'f89c',
      
      'M16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-384a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBookBookmark = {
    prefix: 'fal',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      
      'M0 64C0 28.7 28.7 0 64 0L176 0 336 0l64 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM320 32L192 32l0 174.7 54-43.2c5.8-4.7 14.1-4.7 20 0l54 43.2L320 32zM160 32L64 32C46.3 32 32 46.3 32 64l0 328.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-48 0 0 208c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4l0-208zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416z'
      
    ]
  };

  

  
  

  var faHandshakeSlash = {
    prefix: 'fal',
    iconName: 'handshake-slash',
    icon: [
      640,
      512,
      [],
      'e060',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 368l0-208c0-17.7-14.3-32-32-32l-48 0-32 0 0 32 0 178.7 32 25.3L560 160l48 0 0 208c0 8.8-7.2 16-16 16l-6.6 0L617 409c13.8-8.4 23-23.6 23-41zM403.3 403.3L371 377.8c-.2 1.1-.2 2.2-.2 3.3c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-12.4-12.4-28.9-19.8-46.3-20.9l0-146.8L54.6 128 32 128c-17.7 0-32 14.3-32 32L0 368c0 26.5 21.5 48 48 48l16 0c26.5 0 48-21.5 48-48l0-15.7c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c1.2 .3 2.5 .5 3.8 .7zM196.4 240l-2.8-2.2c.2 .8 .4 1.5 .6 2.2l2.3 0zM292.3 99l-30.9 29.2 25.4 20 27.5-26C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7l0-38.1L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35zm-54.9 .2L272.6 64l-8.7 0c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6c3.1-1 6.2-1.9 9.3-2.7zm121.4 79.1l-15.6 14.4L366.3 211l18-14.6c2.4-5.6 1.5-12.4-2.9-17.2c-6-6.5-16.1-6.9-22.6-.9zM80 160l0 208c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-208 48 0z'
      
    ]
  };

  

  
  

  var faPlaneDeparture = {
    prefix: 'fal',
    iconName: 'plane-departure',
    icon: [
      640,
      512,
      [128747],
      'f5b0',
      
      'M158.7 105.4c11.5-5.2 24.5-5.7 36.4-1.4L375 170c4.2 1.5 8.8 1.3 12.8-.8l88-45c15.8-8.1 33.3-12.3 51-12.3l61 0c12.7 0 21.1 13.1 15.8 24.6c-15.4 33.4-41.7 60.5-74.6 77L255.6 350.3c-2.2 1.1-4.7 1.7-7.2 1.7l-139.2 0c-4.2 0-8.3-1.7-11.3-4.7L34.1 283.5l23.7-13.6c4.4-2.5 9.8-2.8 14.4-.7l57.2 25.4c4.4 2 9.5 1.8 13.8-.4l115-58.8c5.1-2.6 8.5-7.8 8.7-13.6s-2.6-11.2-7.5-14.3L121.9 122.2l-6.6-14.6 6.6 14.6 36.9-16.8zM206.1 74c-19.7-7.2-41.5-6.4-60.6 2.3L108.6 93.1c-23.3 10.6-25.4 42.8-3.6 56.3l113.5 70.5-83 42.4L85.3 240l-6.1 13.7L85.3 240c-14-6.2-30-5.4-43.3 2.2L18.2 255.7c-18.3 10.5-21.7 35.5-6.8 50.4l63.8 63.8c9 9 21.2 14.1 33.9 14.1l139.2 0c7.5 0 14.8-1.7 21.5-5.1L543.3 242.2c39.4-19.7 70.9-52.2 89.3-92.2c15.1-32.7-8.8-70-44.8-70l-61 0c-22.8 0-45.2 5.4-65.5 15.8l-81.8 41.8L206.1 74zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480z'
      
    ]
  };

  

  
  

  var faBuoy = {
    prefix: 'fal',
    iconName: 'buoy',
    icon: [
      576,
      512,
      [],
      'e5b5',
      
      'M192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l12.3 0L147 304l-51 0c-17.7 0-32 14.3-32 32l0 16c0 13.3 1.8 26.1 5.2 38.3c10-4.6 20.9-6.5 31.7-5.7C97.7 374.3 96 363.4 96 352l0-16 384 0 0 16c0 11.4-1.7 22.3-4.8 32.6c10.8-.8 21.7 1.1 31.7 5.7c3.4-12.2 5.2-25.1 5.2-38.3l0-16c0-17.7-14.3-32-32-32l-51 0L371.7 32 384 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L192 0zM339 32l9.8 46.4-60.8 76-60.8-76L237 32l102 0zM218.7 119l48.8 61L183.8 284.6 218.7 119zM288 205.6L366.7 304l-157.4 0L288 205.6zm104.2 79L308.5 180l48.8-61 34.9 165.7zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faImageUser = {
    prefix: 'fal',
    iconName: 'image-user',
    icon: [
      512,
      512,
      [],
      'e1b8',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM299.4 320l-86.9 0c-18.6 0-34 14-36.3 32l159.4 0c-2.2-18-17.6-32-36.3-32zm-86.9-32l43.4 0 43.4 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z'
      
    ]
  };

  

  
  

  var faTicketsPerforated = {
    prefix: 'fal',
    iconName: 'tickets-perforated',
    icon: [
      640,
      512,
      [],
      'e63f',
      
      'M160 64l416 0c17.7 0 32 14.3 32 32l0 47.5c-23.7 11.8-40 36.2-40 64.5s16.3 52.8 40 64.5l0 47.5c0 17.7-14.3 32-32 32l-416 0c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32zm452.2 77.5l-.1 0c0 0 0 0 .1 0c0 0 0 0 0 0zm0 132.9l-.1 0c0 0 .1 0 .1 0zM96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-56c0-8.8-7.4-15.7-15.6-19.1C610.1 238.8 600 224.6 600 208s10.1-30.8 24.4-36.9c8.1-3.4 15.6-10.3 15.6-19.1l0-56c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm400 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 368c0 61.9 50.1 112 112 112l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-416 0c-44.2 0-80-35.8-80-80l0-256z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fal',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faFileImage = {
    prefix: 'fal',
    iconName: 'file-image',
    icon: [
      384,
      512,
      [128443],
      'f1c5',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM181.3 368.9c-2.9 4.3-7.7 7-12.9 7.1s-10.1-2.2-13.2-6.4l-14.4-19.3L99 416l186.2 0L219.7 311.3l-38.4 57.6zM219.9 272c8 0 15.5 4.1 19.8 11l76 121.5c2.8 4.5 4.3 9.7 4.3 15.1c0 15.7-12.7 28.4-28.4 28.4L92.4 448C76.7 448 64 435.3 64 419.6c0-5.4 1.5-10.7 4.4-15.2l51.8-81.4c4.3-6.8 11.9-10.9 19.9-10.9c7.4 0 14.4 3.5 18.9 9.4l8.1 10.9 33.3-49.9c4.3-6.5 11.6-10.4 19.4-10.4z'
      
    ]
  };

  

  
  

  var faRupeeSign = {
    prefix: 'fal',
    iconName: 'rupee-sign',
    icon: [
      448,
      512,
      [8360,"rupee"],
      'f156',
      
      'M0 80C0 53.5 21.5 32 48 32l64 0c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2l-80 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 304 0 80zM32 288l80 0c61.9 0 112-50.1 112-112s-50.1-112-112-112L48 64c-8.8 0-16 7.2-16 16l0 208zm264.8-27.6c-1.5 9.7-.4 16.5 1.8 21.6c2.2 5.1 5.9 9.7 11.5 14c12.1 9.2 29.9 15.2 51.4 22.6l.1 0c20 6.8 43.6 14.8 60.7 28.8c8.9 7.3 16.6 16.6 21.2 28.4c4.6 11.9 5.7 25.3 3.4 40.3c-3.9 25.5-19 44-40.2 54.2c-20.6 9.9-46.3 11.8-72.8 7.2l-.1 0c-9-1.6-20.6-5.5-31-9.3c-7-2.5-14.2-5.3-20.2-7.6c0 0 0 0 0 0c-3-1.2-5.8-2.2-8.1-3.1c-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4c2.7 1 5.7 2.2 8.8 3.4c0 0 0 0 0 0c5.8 2.2 12.3 4.7 19.1 7.2c10.5 3.8 19.8 6.8 25.9 7.9c22 3.9 40.4 1.7 53.3-4.5c12.3-5.9 20.2-15.7 22.5-30.3c1.6-10.6 .6-18.2-1.6-23.9c-2.2-5.7-6-10.7-11.6-15.2c-11.8-9.7-29.5-16-50.8-23.3l-2.8-1c-19.2-6.5-41.4-14-57.7-26.5c-9-6.8-16.8-15.6-21.6-27c-4.8-11.5-6.1-24.4-3.9-38.9c3.7-23.9 19-42 39.7-52.6c20.5-10.4 46.3-13.6 73.3-8.8c7.7 1.4 31 6.4 39.4 8.9c8.5 2.5 13.3 11.4 10.7 19.9s-11.4 13.3-19.9 10.7c-6.7-2-28.7-6.8-35.8-8.1c-21.4-3.8-40-.9-53.2 5.8c-13 6.6-20.7 16.8-22.6 28.9z'
      
    ]
  };

  
    var faRupee = faRupeeSign;
  

  
  

  var faDiagramNested = {
    prefix: 'fal',
    iconName: 'diagram-nested',
    icon: [
      448,
      512,
      [],
      'e157',
      
      'M144 64c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-32 0-32 0-32 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l96 0zM112 224l32 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l32 0 0 96c0 44.2 35.8 80 80 80l96 0 0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 32-96 0c-26.5 0-48-21.5-48-48l0-96zM288 368l0-32c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32 0-32z'
      
    ]
  };

  

  
  

  var faVectorPolygon = {
    prefix: 'fal',
    iconName: 'vector-polygon',
    icon: [
      448,
      512,
      [],
      'e2c7',
      
      'M408 64c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zM360 32c-22.1 0-40 17.9-40 40l0 8L128 80l0-8c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l8 0 0 192-8 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-8 192 0 0 8c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-43.7 0-25.4-42.3c8.1-7.3 13.2-17.9 13.2-29.7l0-48c0-11.8-5.1-22.3-13.2-29.7L364.3 160l43.7 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM307.7 320l25.4 42.3c-8.1 7.3-13.2 17.9-13.2 29.7l0 8-192 0 0-8c0-22.1-17.9-40-40-40l-8 0 0-192 8 0c22.1 0 40-17.9 40-40l0-8 192 0 0 8c0 11.8 5.1 22.3 13.2 29.7L307.7 192 264 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l43.7 0zM40 384l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm320 0l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zM264 224l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zM88 64c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0z'
      
    ]
  };

  

  
  

  var faBugs = {
    prefix: 'fal',
    iconName: 'bugs',
    icon: [
      576,
      512,
      [],
      'e4d0',
      
      'M156.7 102.8l34-80.6c3.4-8.1-.4-17.5-8.5-21s-17.5 .4-21 8.5L128 88.6 94.7 9.8c-3.4-8.1-12.8-12-21-8.5s-12 12.8-8.5 21l34 80.6c-13.8 7-24.8 18.8-30.6 33.2l-31.5 0-5.4-27.1C30 100.2 21.5 94.6 12.9 96.3S-1.4 106.5 .3 115.1l8 40C9.8 162.6 16.4 168 24 168l40 0 0 49.8-45.1 15c-5.7 1.9-9.9 6.9-10.8 12.9l-8 56c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l6.6-46.2 30.9-10.3C79.3 272.3 101.8 288 128 288s48.7-15.7 58.6-38.3l30.9 10.3 6.6 46.2c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1l-8-56c-.9-6-5-11-10.8-12.9l-45.1-15 0-49.8 40 0c7.6 0 14.2-5.4 15.7-12.9l8-40c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6L218.9 136l-31.5 0c-5.8-14.4-16.8-26.2-30.6-33.2zM160 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64zm332.3 55.4l69.7-52.8c7-5.3 8.4-15.4 3.1-22.4s-15.4-8.4-22.4-3.1l-68.2 51.6 10.6-84.9c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-10.8 86.8c-15.4-.9-30.8 3.9-43.1 13.4l-27.3-15.8 8.9-26.2c2.8-8.4-1.7-17.5-10-20.3s-17.5 1.7-20.3 10l-13.1 38.6c-2.4 7.2 .6 15.2 7.2 19l34.6 20-24.9 43.1L308 323.1c-5.9-1.2-12.1 1-15.8 5.8l-34.9 44.5c-5.5 7-4.2 17 2.7 22.5s17 4.2 22.5-2.7l28.8-36.7 32 6.5c-2.7 24.5 8.9 49.4 31.6 62.4s50 10.7 69.9-3.8L466.4 446 449 489.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l21.1-52.5c2.3-5.6 1.1-12-2.9-16.6l-31.5-35.5 24.9-43.1 34.6 20c6.6 3.8 15 2.4 20-3.3l26.9-30.6c5.8-6.6 5.2-16.7-1.5-22.6s-16.7-5.2-22.6 1.5l-18.3 20.8-27.3-15.8c2.2-15.4-1.4-31.1-9.9-44.1zM434.6 386c-8.8 15.3-28.4 20.5-43.7 11.7s-20.6-28.4-11.7-43.7l32-55.4c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7l-32 55.4z'
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fal',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [128295],
      'f0ad',
      
      'M480 160c0-10.7-1.3-21.1-3.8-31l-48.9 48.9c-9 9-21.2 14.1-33.9 14.1L368 192c-26.5 0-48-21.5-48-48l0-25.4c0-12.7 5.1-24.9 14.1-33.9L383 35.8c-9.9-2.5-20.3-3.8-31-3.8c-70.7 0-128 57.3-128 128c0 9.2 1 18.1 2.8 26.7c3.2 15.2-.6 32.4-13.1 44.9L45.8 399.4C37 408.3 32 420.3 32 432.8C32 458.9 53.1 480 79.2 480c12.5 0 24.5-5 33.4-13.8L280.5 298.3c12.4-12.4 29.7-16.3 44.9-13.1c8.6 1.8 17.5 2.8 26.7 2.8c70.7 0 128-57.3 128-128zm32 0c0 88.4-71.6 160-160 160c-11.4 0-22.6-1.2-33.3-3.5c-5.6-1.2-11.5 .3-15.6 4.4L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L191.1 208.9c4.1-4.1 5.6-10 4.4-15.6c-2.3-10.7-3.5-21.9-3.5-33.3C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3l0 25.4c0 8.8 7.2 16 16 16l25.4 0c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowTurnLeft = {
    prefix: 'fal',
    iconName: 'arrow-turn-left',
    icon: [
      512,
      512,
      [],
      'e632',
      
      'M132.7 363.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 240 432 240c26.5 0 48 21.5 48 48l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-44.2-35.8-80-80-80L54.6 208 155.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l128 128z'
      
    ]
  };

  

  
  

  var faTransporter6 = {
    prefix: 'fal',
    iconName: 'transporter-6',
    icon: [
      512,
      512,
      [],
      'e2a7',
      
      'M48 0C39.2 0 32 7.2 32 16l0 16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32l0-16C64 7.2 56.8 0 48 0zM464 352c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm32 224c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faUtilityPole = {
    prefix: 'fal',
    iconName: 'utility-pole',
    icon: [
      512,
      512,
      [],
      'e2c3',
      
      'M208 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64 80 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 15.8 0 .3 0L480 96l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 17.7-14.3 32-32 32l-42.5 0L304 231.8 304 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-271.8 0-.3 0-95.9-32 0 0 95.9 0 .3L240 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-264.2L74.5 128 32 128C14.3 128 0 113.7 0 96L0 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 47.9 0 .3 0L96 96l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 80 0 0-64zm-81.4 96L208 191.3l0-63.3-81.4 0zM304 191.3L385.4 128 304 128l0 63.3zM272 32l-32 0 0 64 32 0 0-64z'
      
    ]
  };

  

  
  

  var faBurger = {
    prefix: 'fal',
    iconName: 'burger',
    icon: [
      512,
      512,
      ["hamburger"],
      'f805',
      
      'M256 64c94.4 0 172.9 68.1 189 157.8l0 .1c0 .1-.1 .2-.3 .3c-.7 .8-2.4 1.7-4.7 1.7L72 224c-2.4 0-4-1-4.7-1.7c-.1-.1-.2-.2-.3-.3l0-.1C83.1 132.1 161.6 64 256 64zM440 256c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2C31.6 237.9 49.9 256 72 256l368 0zM128 448c-35.3 0-64-28.7-64-64l384 0c0 35.3-28.7 64-64 64l-256 0zM32 384c0 53 43 96 96 96l256 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L64 352c-17.7 0-32 14.3-32 32zM16 304c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 288c-8.8 0-16 7.2-16 16zM160 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faHamburger = faBurger;
  

  
  

  var faStaff = {
    prefix: 'fal',
    iconName: 'staff',
    icon: [
      512,
      512,
      [],
      'f71b',
      
      'M284.2 44.2l-7.2 14.3c-11.9 23.7-2.2 52.5 21.5 64.4s52.5 2.2 64.4-21.5c1.7-3.4 5.1-5.5 8.8-5.5L400 96c8.8 0 16 7.2 16 16l0 47.7c0 7.1-4.7 13.4-11.6 15.4L234.8 223.6c-13.1 3.7-25 10.7-34.6 20.4l-39.4 39.4c-3 3-7.1 4.7-11.3 4.7L112 288c-8.8 0-16 7.2-16 16l0 37.5c0 4.2-1.7 8.3-4.7 11.3L14.1 430.1c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0L262.2 317.7c1.9-1.9 4.3-3.3 6.9-4.1l85.5-24.4c4.1-1.2 8.5-.7 12.3 1.5l32.8 18.5c7.7 4.3 17.5 1.6 21.8-6.1l19-33.6c2.1-3.7 5.5-6.4 9.5-7.5l3.9-1.1c34.3-9.8 58-41.2 58-76.9L512 80c0-44.2-35.8-80-80-80L355.8 0c-30.3 0-58 17.1-71.6 44.2zM355.8 32L432 32c26.5 0 48 21.5 48 48l0 103.9c0 21.4-14.2 40.3-34.8 46.2l-3.9 1.1c-12.1 3.5-22.4 11.6-28.6 22.6l-11.1 19.7-18.9-10.7c-11.2-6.3-24.4-7.9-36.8-4.4l-85.5 24.4c-7.8 2.2-15 6.4-20.8 12.2L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l77.3-77.3c9-9 14.1-21.2 14.1-33.9l0-21.5 21.5 0c12.7 0 24.9-5.1 33.9-14.1l39.4-39.4c5.8-5.8 12.9-10 20.8-12.2l169.6-48.5c20.6-5.9 34.8-24.7 34.8-46.2l0-47.7c0-26.5-21.5-48-48-48l-28.2 0c-15.9 0-30.4 9-37.5 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l7.2-14.3C321 42.3 337.6 32 355.8 32z'
      
    ]
  };

  

  
  

  var faChartRadar = {
    prefix: 'fal',
    iconName: 'chart-radar',
    icon: [
      512,
      512,
      [],
      'e0e7',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM312 160c0 17.8-8.3 33.6-21.2 43.9l24.1 60.3c1.7-.2 3.4-.2 5.1-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56c-29.2 0-53.2-22.3-55.8-50.8l-54.7-10.9c-9.4 17.7-28 29.8-49.5 29.8c-30.9 0-56-25.1-56-56s25.1-56 56-56c6.8 0 13.4 1.2 19.4 3.5L211 193.3c-6.9-9.3-11-20.8-11-33.3c0-30.9 25.1-56 56-56s56 25.1 56 56zM270.5 293.8c3.6-6.9 8.7-12.9 14.7-17.7l-24.1-60.3c-1.7 .2-3.4 .2-5.1 .2c-6.8 0-13.4-1.2-19.4-3.5L205 254.7c5.9 8 9.8 17.7 10.8 28.2l54.7 10.9zM256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-184-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faLockHashtag = {
    prefix: 'fal',
    iconName: 'lock-hashtag',
    icon: [
      448,
      512,
      [],
      'e423',
      
      'M128 128l0 64 192 0 0-64c0-53-43-96-96-96s-96 43-96 96zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 16 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 272c0-44.2 35.8-80 80-80l16 0zM32 272l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L80 224c-26.5 0-48 21.5-48 48zm144-32c8.8 0 16 7.2 16 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16zm16 144l64 0 0-64-64 0 0 64z'
      
    ]
  };

  

  
  

  var faTurnDownLeft = {
    prefix: 'fal',
    iconName: 'turn-down-left',
    icon: [
      512,
      512,
      [],
      'e331',
      
      'M160 208l0-57.3c0-3.7-3-6.7-6.7-6.7c-1.9 0-3.7 .8-5 2.2L35.8 272 148.3 397.8c1.3 1.4 3.1 2.2 5 2.2c3.7 0 6.7-3 6.7-6.7l0-57.3c0-17.7 14.3-32 32-32l176 0c61.9 0 112-50.1 112-112l0-112c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 112c0 26.5-21.5 48-48 48l-176 0c-17.7 0-32-14.3-32-32zM5.3 286C1.9 282.1 0 277.2 0 272s1.9-10.1 5.3-14L124.5 124.9c7.3-8.2 17.8-12.9 28.8-12.9c21.4 0 38.7 17.3 38.7 38.7l0 25.3 0 32 32 0 144 0c8.8 0 16-7.2 16-16l0-112c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 112c0 79.5-64.5 144-144 144l-144 0-32 0 0 32 0 25.3c0 21.4-17.3 38.7-38.7 38.7c-11 0-21.5-4.7-28.8-12.9L5.3 286z'
      
    ]
  };

  

  
  

  var faFileAudio = {
    prefix: 'fal',
    iconName: 'file-audio',
    icon: [
      384,
      512,
      [],
      'f1c7',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM258 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-18.3 67c-5.9-6.6-16-7.1-22.6-1.3s-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7zm-56.9-43.8c-5.6-2.6-12.3-1.8-17 2.2L122.2 288 80 288c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l42.2 0 43.6 36.3c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5l0-144c0-6.2-3.6-11.9-9.2-14.5zM160 298.2l0 75.7-21.8-18.1c-2.9-2.4-6.5-3.7-10.2-3.7l-32 0 0-32 32 0c3.7 0 7.4-1.3 10.2-3.7L160 298.2z'
      
    ]
  };

  

  
  

  var faPool8Ball = {
    prefix: 'fal',
    iconName: 'pool-8-ball',
    icon: [
      512,
      512,
      [],
      'e3c5',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm368-64a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm37.3 14.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.5-4 22-10.7 30.2zM256 192a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faTruckClock = {
    prefix: 'fal',
    iconName: 'truck-clock',
    icon: [
      640,
      512,
      ["shipping-timed"],
      'f48c',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l5.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64L384 384l0-320c0-17.7-14.3-32-32-32L64 32zm0 384c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 65.3 0c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2L608 384l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96zM416 128l0 96 154.9 0-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6L416 128zm0 128l0 88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64l5.5 0 0-128-160 0zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM208 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 64l0 32 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faShippingTimed = faTruckClock;
  

  
  

  var faCartCirclePlus = {
    prefix: 'fal',
    iconName: 'cart-circle-plus',
    icon: [
      640,
      512,
      [],
      'e3f3',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2l129.5 0c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16l-129.5 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l187.2 0c5.9-11.4 12.9-22.2 21-32l-214.8 0L106.1 64l433.4 0L507.4 192.4c10.9 .7 21.5 2.4 31.7 5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm136-88a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faClipboardCheck = {
    prefix: 'fal',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm91.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faFlatbreadStuffed = {
    prefix: 'fal',
    iconName: 'flatbread-stuffed',
    icon: [
      576,
      512,
      [129369],
      'e40c',
      
      'M256.8 32l59.9 32.9c11.7 6.4 25.1 9 38.4 7.5l51.5-6.1 17.9-17.9c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3L101.8 371l-.2-7.1c-.3-13.3-4.7-26.3-12.7-37L48 272.1l42.8-53.3c8.4-10.4 13.3-23.2 14-36.5l3.8-68.3 67.1-13.3c13.1-2.6 25-9.2 34.2-19L256.8 32zM426.7 136.7l36.6-36.6c29.7 39.8 48.8 87 48.8 139.9c0 132.5-107.5 240-240 240c-52.9 0-100.1-19.1-139.9-48.8l79.6-79.6 86-86 86-86 43-43zm56.1-63.6c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM232 144c-66.3 0-120 53.7-120 120c0 27.2 9.1 52.3 24.3 72.5l22.9-22.9C149.6 299.4 144 282.4 144 264c0-48.6 39.4-88 88-88c18.4 0 35.4 5.6 49.5 15.3l22.9-22.9C284.3 153.1 259.2 144 232 144z'
      
    ]
  };

  

  
  

  var faOctagonCheck = {
    prefix: 'fal',
    iconName: 'octagon-check',
    icon: [
      512,
      512,
      [],
      'e426',
      
      'M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3l0 129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7l129 0c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3l0-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7l-129 0zM363.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faWallet = {
    prefix: 'fal',
    iconName: 'wallet',
    icon: [
      512,
      512,
      [],
      'f555',
      
      'M80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-224c0-44.2-35.8-80-80-80L112 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48L80 448c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32zM384 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fal',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm630.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM27.3 507.3l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm608 0c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32l-158.4 0c3.7-18.3 19.8-32 39.2-32l80 0zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72l-40 0-40 0zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24l56 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-56 0c-30.9 0-56 25.1-56 56l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-30.9-25.1-56-56-56l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0z'
      
    ]
  };

  

  
  

  var faVolumeHigh = {
    prefix: 'fal',
    iconName: 'volume-high',
    icon: [
      640,
      512,
      [128266,"volume-up"],
      'f028',
      
      'M151.6 188L288 66.7l0 378.6L151.6 324c-2.9-2.6-6.7-4-10.6-4l-85 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l85 0c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM409.6 179.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8zm42-69.2c-5.6 6.8-4.7 16.9 2.1 22.5C489.4 161.9 512 206.3 512 256s-22.6 94.1-58.2 123.4c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1C516.8 368.9 544 315.6 544 256s-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1zm86.7-73.6c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6c55.3 47 90.4 117 90.4 195.2s-35.1 148.2-90.4 195.2c-6.7 5.7-7.6 15.8-1.8 22.6s15.8 7.6 22.6 1.8C600.5 422.8 640 344 640 256s-39.5-166.8-101.6-219.6z'
      
    ]
  };

  
    var faVolumeUp = faVolumeHigh;
  

  
  

  var faCloudSlash = {
    prefix: 'fal',
    iconName: 'cloud-slash',
    icon: [
      640,
      512,
      [],
      'e137',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 352c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8C384.1 61.5 331.5 32 272 32c-35.5 0-68.6 10.5-96.2 28.6l26.8 21.2C223.2 70.5 246.8 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 15.1-3.5 29.4-9.7 42.2l25.6 20.2C634.1 395.9 640 374.6 640 352zM101.3 164.9c-2.9 11.3-4.6 23.1-5.1 35.2C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144l356.4 0-40.5-32L144 448C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8c.2-4.9 .7-9.7 1.4-14.4l-28.2-22.2z'
      
    ]
  };

  

  
  

  var faInboxOut = {
    prefix: 'fal',
    iconName: 'inbox-out',
    icon: [
      512,
      512,
      [128228,"inbox-arrow-up"],
      'f311',
      
      'M272 54.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6 240 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-249.4zM48 352l66.3 0c6.1 0 11.6 3.4 14.3 8.8L143 389.5c8.1 16.3 24.8 26.5 42.9 26.5l140.2 0c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3L369 389.5l14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8l66.3 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm306.7-5.5l-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8l-140.2 0c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5L48 320c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-66.3 0c-18.2 0-34.8 10.3-42.9 26.5z'
      
    ]
  };

  
    var faInboxArrowUp = faInboxOut;
  

  
  

  var faClockOneThirty = {
    prefix: 'fal',
    iconName: 'clock-one-thirty',
    icon: [
      512,
      512,
      [],
      'e34f',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400l0-139.2 61.3-92c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-1.8 2.6-2.7 5.7-2.7 8.9l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faMobileScreenButton = {
    prefix: 'fal',
    iconName: 'mobile-screen-button',
    icon: [
      384,
      512,
      ["mobile-alt"],
      'f3cd',
      
      'M288 32c17.7 0 32 14.3 32 32l0 256L64 320 64 64c0-17.7 14.3-32 32-32l192 0zm32 320l0 96c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-96 256 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faMobileAlt = faMobileScreenButton;
  

  
  

  var faSlider = {
    prefix: 'fal',
    iconName: 'slider',
    icon: [
      512,
      512,
      [],
      'e252',
      
      'M352 128c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l32 0zM320 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l32 0c35.3 0 64-28.7 64-64l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-35.3-28.7-64-64-64l-32 0zM0 256c0 8.8 7.2 16 16 16l208 0 0-32L16 240c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faCircleUp = {
    prefix: 'fal',
    iconName: 'circle-up',
    icon: [
      512,
      512,
      [61467,"arrow-alt-circle-up"],
      'f35b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-9.2 0-18 3.5-24.7 9.7l-91 84c-7.8 7.2-12.3 17.4-12.3 28.1c0 21.1 17.1 38.3 38.3 38.3l25.7 0 0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 25.7 0c21.1 0 38.3-17.1 38.3-38.3c0-10.7-4.5-20.9-12.3-28.1l-91-84c-6.7-6.2-15.6-9.7-24.7-9.7zm-3 33.2c.8-.8 1.9-1.2 3-1.2s2.2 .4 3 1.2l91 84c1.3 1.2 2 2.9 2 4.6c0 3.5-2.8 6.3-6.3 6.3L304 240c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16l-41.7 0c-3.5 0-6.3-2.8-6.3-6.3c0-1.7 .7-3.4 2-4.6l91-84z'
      
    ]
  };

  
    var faArrowAltCircleUp = faCircleUp;
  

  
  

  var faBadgeCheck = {
    prefix: 'fal',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faSatelliteDish = {
    prefix: 'fal',
    iconName: 'satellite-dish',
    icon: [
      512,
      512,
      [128225],
      'f7c0',
      
      'M208 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c150.2 0 272 121.8 272 272c0 8.8 7.2 16 16 16s16-7.2 16-16C512 136.1 375.9 0 208 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c97.2 0 176 78.8 176 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9-93.1-208-208-208zM32 304c0-24.5 5-47.7 13.9-68.8L276.8 466.1C255.7 475 232.5 480 208 480c-97.2 0-176-78.8-176-176zm33.5-94.5c-14-14-37.3-12.1-45.7 5.8C7.1 242.2 0 272.3 0 304C0 418.9 93.1 512 208 512c31.7 0 61.8-7.1 88.7-19.8c17.9-8.4 19.8-31.8 5.8-45.7L195.3 339.3l24-24c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7l-24 24L65.5 209.5zM224 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faForkKnife = {
    prefix: 'fal',
    iconName: 'fork-knife',
    icon: [
      576,
      512,
      ["utensils-alt"],
      'f2e6',
      
      'M64 9.7L273.7 234.4 251.1 257 42.9 34C38.5 49 32 77.1 32 112c0 41 12.6 72.2 36.6 104.6c21 28.3 50.1 56.9 87.3 93.2c0 0 0 0 0 0s0 0 0 0c6.6 6.4 13.4 13.1 20.5 20.1c0 0 0 0 0 0l.1 .1 .8 .8-22.6 22.6-.8-.8c-6.8-6.7-13.5-13.3-20-19.6c0 0 0 0 0 0s0 0 0 0c-37-36.2-68.3-66.8-91-97.4C15.6 198.8 0 161.1 0 112C0 69.6 8.6 36.2 13.6 20.4C17.6 7.6 29.4 0 41.7 0C50.2 0 58.2 3.5 64 9.7zM484.3 506.9L316.6 327.3l22.6-22.6L507.7 485.1c6 6.5 5.7 16.6-.8 22.6s-16.6 5.7-22.6-.8zM468.9 6.5c5.2 7.1 3.7 17.1-3.4 22.4L351.1 112.7c-3.1 2.3-6.1 4.8-8.8 7.6l-1.6 1.6C327.5 135.2 320 153.2 320 172s7.5 36.8 20.8 50.1l13.1 13.1C367.2 248.5 385.2 256 404 256s36.8-7.5 50.1-20.8l1.6-1.6c2.7-2.7 5.3-5.7 7.6-8.8l83.8-114.3c5.2-7.1 15.2-8.7 22.4-3.4s8.7 15.2 3.4 22.4L489.1 243.8c-3.3 4.4-6.9 8.6-10.7 12.5l-1.6 1.6C457.5 277.2 431.3 288 404 288c-25 0-49.1-9.1-67.8-25.5L91.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L313.5 239.8C297.1 221.1 288 197 288 172c0-27.3 10.8-53.5 30.1-72.8l1.6-1.6c3.9-3.9 8.1-7.5 12.5-10.7L446.5 3.1c7.1-5.2 17.1-3.7 22.4 3.4zM508 37.5c5.8 6.7 5.1 16.8-1.5 22.6l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l128-112c6.6-5.8 16.8-5.1 22.6 1.5zM538.5 68c6.6 5.8 7.3 15.9 1.5 22.6l-112 128c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l112-128c5.8-6.7 15.9-7.3 22.6-1.5z'
      
    ]
  };

  
    var faUtensilsAlt = faForkKnife;
  

  
  

  var faBasketball = {
    prefix: 'fal',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      'M290.7 477.3c-1.8-9.5-2.7-19.3-2.7-29.3c0-38.4 13.5-73.7 36.1-101.3l78.6 78.6c-31 26.9-69.5 45.4-112 52zm-32 2.7c-.9 0-1.8 0-2.7 0c-56.1 0-107.4-20.6-146.7-54.7L256 278.6 301.4 324C273.1 357.5 256 400.7 256 448c0 10.9 .9 21.6 2.7 32zM324 301.4L278.6 256 425.3 109.3C459.4 148.6 480 199.9 480 256c0 .9 0 1.8 0 2.7c-10.4-1.7-21.1-2.7-32-2.7c-47.3 0-90.5 17.1-124 45.4zm22.7 22.7C374.3 301.5 409.6 288 448 288c10 0 19.8 .9 29.3 2.7c-6.6 42.5-25.1 81-52 112l-78.6-78.6zM256 233.4L210.6 188C238.9 154.5 256 111.3 256 64c0-10.9-.9-21.6-2.7-32c.9 0 1.8 0 2.7 0c56.1 0 107.4 20.6 146.7 54.7L256 233.4zm-68.1-68.1L109.3 86.7c31-26.9 69.5-45.4 112-52C223.1 44.2 224 54 224 64c0 38.4-13.5 73.7-36.1 101.3zm-22.6 22.6C137.7 210.5 102.4 224 64 224c-10 0-19.8-.9-29.3-2.7c6.6-42.5 25.1-81 52-112l78.6 78.6zM32 253.3c10.4 1.7 21.1 2.7 32 2.7c47.3 0 90.5-17.1 124-45.4L233.4 256 86.7 402.7C52.6 363.4 32 312.1 32 256c0-.9 0-1.8 0-2.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faTrademark = {
    prefix: 'fal',
    iconName: 'trademark',
    icon: [
      640,
      512,
      [8482],
      'f25c',
      
      'M0 112c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 96c-8.8 0-16 7.2-16 16zM112 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272-32 0 0 272zM316.3 101.8c-4.3-5.2-11.4-7.1-17.7-4.8s-10.6 8.3-10.6 15l0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-243.8L451.7 314.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L608 156.2 608 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288c0-6.7-4.2-12.8-10.6-15s-13.4-.4-17.7 4.8L464 279 316.3 101.8z'
      
    ]
  };

  

  
  

  var faCircleDashed = {
    prefix: 'fal',
    iconName: 'circle-dashed',
    icon: [
      512,
      512,
      [],
      'e105',
      
      'M18.8 232c8.2 0 15.1-6.2 16.5-14.3C41 184.4 54.1 153.6 72.8 127c4.7-6.7 4.3-16-1.5-21.8C64.6 98.5 53.5 99 48 106.7c-22.5 31.4-38.2 68-44.6 107.7C1.8 223.8 9.3 232 18.8 232zM127 72.8c26.5-18.7 57.3-31.8 90.6-37.6C225.8 33.9 232 27 232 18.8c0-9.5-8.2-17-17.5-15.4C174.7 9.8 138.1 25.5 106.7 48c-7.7 5.5-8.2 16.6-1.5 23.3c5.8 5.8 15.1 6.3 21.8 1.5zM280 493.2c0 9.5 8.2 17 17.5 15.4c39.7-6.5 76.4-22.1 107.7-44.6c7.7-5.5 8.2-16.6 1.5-23.3c-5.8-5.8-15.1-6.3-21.8-1.5c-26.5 18.7-57.3 31.8-90.6 37.6c-8.1 1.4-14.3 8.2-14.3 16.5zM439.2 385c-4.7 6.7-4.3 16 1.5 21.8c6.7 6.7 17.8 6.2 23.3-1.5c22.5-31.4 38.2-68 44.6-107.7c1.5-9.4-5.9-17.5-15.4-17.5c-8.2 0-15.1 6.2-16.5 14.3c-5.7 33.3-18.8 64.1-37.6 90.6zM105.2 440.7c-6.7 6.7-6.2 17.8 1.5 23.3c31.4 22.5 68 38.2 107.7 44.6c9.4 1.5 17.5-5.9 17.5-15.4c0-8.2-6.2-15.1-14.3-16.5c-33.3-5.7-64.1-18.8-90.6-37.6c-6.7-4.7-16-4.3-21.8 1.5zM48 405.3c5.5 7.7 16.6 8.2 23.3 1.5c5.8-5.8 6.3-15.1 1.5-21.8C54.1 358.4 41 327.6 35.3 294.3C33.9 286.2 27 280 18.8 280c-9.5 0-17 8.2-15.4 17.5C9.8 337.3 25.5 373.9 48 405.3zm358.8-334c6.7-6.7 6.2-17.8-1.5-23.3c-31.4-22.5-68-38.2-107.7-44.6C288.2 1.8 280 9.3 280 18.8c0 8.2 6.2 15.1 14.3 16.5C327.6 41 358.4 54.1 385 72.8c6.7 4.7 16 4.3 21.8-1.5zM439.2 127c18.7 26.5 31.8 57.3 37.6 90.6c1.4 8.1 8.2 14.3 16.5 14.3c9.5 0 17-8.2 15.4-17.5c-6.5-39.7-22.1-76.4-44.6-107.7c-5.5-7.7-16.6-8.2-23.3-1.5c-5.8 5.8-6.3 15.1-1.5 21.8z'
      
    ]
  };

  

  
  

  var faPlaneSlash = {
    prefix: 'fal',
    iconName: 'plane-slash',
    icon: [
      640,
      512,
      [],
      'e069',
      
      'M347.6 359.4L283.3 471.9c-2.8 5-8.2 8.1-13.9 8.1l-56.2 0 44.5-155.6c1.4-4.8 .4-10-2.6-14s-7.8-6.4-12.8-6.4L160 304c-5 0-9.8 2.4-12.8 6.4L104 368l-39.4 0L95.4 260.4c.8-2.9 .8-5.9 0-8.8L64.6 144l10.2 0L43 118.8c-6.7 5.5-11 13.9-11 23.2c0 2.8 .4 5.6 1.2 8.3L63.4 256 33.2 361.7c-.8 2.7-1.2 5.5-1.2 8.2c0 16.6 13.4 30 30 30l42 0c10.1 0 19.6-4.7 25.6-12.8L168 336l53.1 0L182.4 471.2c-5.8 20.4 9.5 40.8 30.8 40.8l56.2 0c17.2 0 33.1-9.2 41.7-24.2L373 379.4l-25.4-20.1zM182.4 40.8l9.2 32.4 43 33.9L213.2 32l56.2 0c5.7 0 11 3.1 13.9 8.1l13.9-7.9-13.9 7.9 91.4 159.9c2.9 5 8.2 8.1 13.9 8.1l109.7 0c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2l-14.2 0 37.1 29.3c15.2-3.4 31.2-9.7 45.1-18C586.4 303.1 608 282.9 608 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-100.5 0L311.1 24.2C302.6 9.2 286.7 0 269.4 0L213.2 0C192 0 176.6 20.3 182.4 40.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faInterrobang = {
    prefix: 'fal',
    iconName: 'interrobang',
    icon: [
      320,
      512,
      [8253],
      'e5ba',
      
      'M48 160c0-53 43-96 96-96l32 0c53 0 96 43 96 96c0 25.2-11.9 48.9-32 64l-60.8 45.6c-1.1 .8-2.2 1.7-3.2 2.5L176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 180 0 4 0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8 0-4c0-17.6 8.3-34.2 22.4-44.8l60.8-45.6C287.4 228.4 304 195.3 304 160c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 8.8 7.2 16 16 16s16-7.2 16-16zM160 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faUserAstronaut = {
    prefix: 'fal',
    iconName: 'user-astronaut',
    icon: [
      448,
      512,
      [],
      'f4fb',
      
      'M368 176A144 144 0 1 0 80 176a144 144 0 1 0 288 0zM48 176a176 176 0 1 1 352 0A176 176 0 1 1 48 176zM16 112c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm432 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 482.3c0-64.2 33.9-120.4 84.7-151.8c8.6 7.8 17.9 14.8 27.7 21.1C65.4 375.4 32.9 423.8 32 480l64 0 0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32 64 0c-.9-56.2-33.4-104.6-80.5-128.4c9.8-6.3 19.1-13.3 27.7-21.1c50.8 31.4 84.7 87.6 84.7 151.8c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM288 480l32 0 0-32c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16l0 32 32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16zM205.3 162.7l21.2 6c3.3 .9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5l6 21.2zM160 128c-17.7 0-32 14.3-32 32l0 16c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-16c0-17.7-14.3-32-32-32l-128 0zM96 160c0-35.3 28.7-64 64-64l128 0c35.3 0 64 28.7 64 64l0 16c0 61.9-50.1 112-112 112l-32 0c-61.9 0-112-50.1-112-112l0-16z'
      
    ]
  };

  

  
  

  var faRecycle = {
    prefix: 'fal',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      'M193.7 35C206.9 13.3 230.5 0 256 0s49.1 13.3 62.3 35l77.8 127.8 11.1-54c1.8-8.7 10.2-14.2 18.9-12.4s14.2 10.2 12.4 18.9l-19.4 94.4c-.9 4.5-3.7 8.3-7.7 10.6s-8.7 2.8-13 1.3L307 191.2c-8.4-2.8-12.9-11.8-10.1-20.2s11.8-12.9 20.2-10.1l50.5 16.8L291 51.7C283.5 39.4 270.3 32 256 32s-27.5 7.4-35 19.7l-31.1 51.2c-4.6 7.5-14.4 9.9-21.9 5.4c-7.6-4.6-10-14.5-5.4-22L193.7 35zM435.2 257.8c7.5-4.5 17.3-2.1 21.9 5.4l46 75.6c5.8 9.5 8.9 20.3 8.9 31.4c.3 34.1-27.3 61.9-61.4 61.9l-184.5 0 40.5 36c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3l-72-64c-3.4-3-5.4-7.4-5.4-12s2-8.9 5.4-12l72-64c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L266.1 400l184.6 0c16.3 0 29.5-13.3 29.4-29.6c0-5.3-1.5-10.5-4.3-15l-46-75.6c-4.6-7.6-2.2-17.5 5.4-22zm-300-.2l-10-48.4L36.3 355.3c-2.8 4.5-4.2 9.7-4.3 15C31.9 386.7 45.1 400 61.4 400l82.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-82.7 0C27.3 432-.3 404.2 0 370.1c.1-11.1 3.2-21.9 8.9-31.4l92.4-151.9L45 205.5c-8.4 2.8-17.4-1.8-20.2-10.1S26.6 178 35 175.2l91.4-30.4c4.3-1.4 9.1-1 13 1.3s6.7 6.2 7.7 10.6l19.4 94.4c1.8 8.7-3.8 17.1-12.4 18.9s-17.1-3.8-18.9-12.4z'
      
    ]
  };

  

  
  

  var faBackwardFast = {
    prefix: 'fal',
    iconName: 'backward-fast',
    icon: [
      512,
      512,
      [9198,"fast-backward"],
      'f049',
      
      'M16 64c8.8 0 16 7.2 16 16l0 135.8L210.6 70.2c5-4 11.2-6.2 17.6-6.2C243.6 64 256 76.4 256 91.8l0 150.1L466.6 70.2c5-4 11.2-6.2 17.6-6.2C499.6 64 512 76.4 512 91.8l0 328.4c0 15.4-12.4 27.8-27.8 27.8c-6.4 0-12.6-2.2-17.6-6.2L256 270.1l0 150.1c0 15.4-12.4 27.8-27.8 27.8c-6.4 0-12.6-2.2-17.6-6.2L32 296.2 32 432c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 270.1l0-28.2L0 80c0-8.8 7.2-16 16-16zM33.3 256L224 411.4l0-310.7L33.3 256zM480 100.6L289.3 256 480 411.4l0-310.7z'
      
    ]
  };

  
    var faFastBackward = faBackwardFast;
  

  
  

  var faSword = {
    prefix: 'fal',
    iconName: 'sword',
    icon: [
      512,
      512,
      [128481],
      'f71c',
      
      'M507.3 4.7C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L174.6 234.7l22.6 22.6L396.8 57.8c7.1-7.1 16.2-11.8 26.1-13.4l53.7-8.9-8.9 53.7c-1.6 9.9-6.3 19-13.4 26L254.6 314.7l22.6 22.6L476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zm-392 216c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-5.3 5.3-6.2 13.6-2.2 19.9l49.1 77.2L74.7 382.6l-31.6-6.3c-5.2-1-10.7 .6-14.5 4.4l-24 24c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l24-24c3.8-3.8 5.4-9.2 4.4-14.5l-6.3-31.6 32.9-32.9 77.2 49.1c6.3 4 14.6 3.1 19.9-2.2l32-32c6.2-6.2 6.2-16.4 0-22.6l-176-176zm26.2 122.7L92.4 266.2 104 254.6 257.4 408l-11.6 11.6-77.2-49.1c-6.3-4-14.6-3.1-19.9 2.2l-48 48c-3.8 3.8-5.4 9.2-4.4 14.5l6.3 31.6L96 473.4 38.6 416l6.6-6.6 31.6 6.3c5.2 1 10.7-.6 14.5-4.4l48-48c5.3-5.3 6.2-13.6 2.2-19.9z'
      
    ]
  };

  

  
  

  var faCartCircleExclamation = {
    prefix: 'fal',
    iconName: 'cart-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e3f2',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2l129.5 0c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16l-129.5 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l187.2 0c5.9-11.4 12.9-22.2 21-32l-214.8 0L106.1 64l433.4 0L507.4 192.4c10.9 .7 21.5 2.4 31.7 5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm136-88a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faLeftToBracket = {
    prefix: 'fal',
    iconName: 'left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e66d',
      
      'M192.8 257.8c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L324.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L192.8 257.8zM160 256c0 9.5 3.9 18.6 10.8 25.1L302.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L170.8 230.9c-6.9 6.5-10.8 15.6-10.8 25.1zm16 192l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fal',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faSquarePollHorizontal = {
    prefix: 'fal',
    iconName: 'square-poll-horizontal',
    icon: [
      448,
      512,
      ["poll-h"],
      'f682',
      
      'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM256 160c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16zm80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0zM192 352c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faPollH = faSquarePollHorizontal;
  

  
  

  var faHouseFloodWaterCircleArrowRight = {
    prefix: 'fal',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e50f',
      
      'M310.4 86.4c-3.6-10.3-8.1-20.2-13.4-29.6l78-54c5.5-3.8 12.7-3.8 18.2 0l208 144c7.3 5 9.1 15 4 22.3s-15 9.1-22.3 4L560 157.3l0 119.3c-2.4-1.6-4.6-3.3-6.8-5.1c-7.5-6.3-16.2-10.7-25.2-13l0-123.3L384 35.5l-73.6 51zM224 368c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C374.3 358 395.1 368 416 368s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C473.5 385.9 446.3 400 416 400s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C281.5 385.9 254.3 400 224 400s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C40 400.1 32 392 32 382.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C182.3 358 203.1 368 224 368zm-58.2 90.8C182.3 470 203.1 480 224 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C374.3 470 395.1 480 416 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C473.5 497.9 446.3 512 416 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C281.5 497.9 254.3 512 224 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C40 512.1 32 504 32 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM144 0a144 144 0 1 1 0 288A144 144 0 1 1 144 0zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160 80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faMoneyBillTrendUp = {
    prefix: 'fal',
    iconName: 'money-bill-trend-up',
    icon: [
      512,
      512,
      [],
      'e529',
      
      'M352 16c0 8.8 7.2 16 16 16l57.4 0L287.2 170.2 186.4 83.9c-6-5.1-14.8-5.1-20.8 0l-112 96c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L176 117.1l101.6 87.1c6.3 5.4 15.8 5.1 21.7-.8L448 54.6l0 57.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L368 0c-8.8 0-16 7.2-16 16zM480 304l0 32c-26.5 0-48-21.5-48-48l32 0c8.8 0 16 7.2 16 16zM112 288l288 0c0 44.2 35.8 80 80 80l0 32c-44.2 0-80 35.8-80 80l-288 0c0-44.2-35.8-80-80-80l0-32c44.2 0 80-35.8 80-80zM432 480c0-26.5 21.5-48 48-48l0 32c0 8.8-7.2 16-16 16l-32 0zM32 432c26.5 0 48 21.5 48 48l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 288c0 26.5-21.5 48-48 48l0-32c0-8.8 7.2-16 16-16l32 0zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faMoneyBillTransfer = {
    prefix: 'fal',
    iconName: 'money-bill-transfer',
    icon: [
      640,
      512,
      [],
      'e528',
      
      'M548.7 27.3L585.4 64l-45.3 0-15.5 0L384 64l-.3 0L96 64c-35.3 0-64 28.7-64 64l0 220.1 14.1-14.1L64 316.1 64 192c53 0 96-43 96-96l364.3 0 15.8 0 45.3 0-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM128 96c0 35.3-28.7 64-64 64l0-32c0-17.7 14.3-32 32-32l32 0zM54.6 448l45.3 0s0 0 0 0L544 448c35.3 0 64-28.7 64-64l0-220.1-14.1 14.1L576 195.9 576 320s0 0 0 0c-53 0-96 43-96 96l-223.6 0-.4 0L54.6 416l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 448zM576 352s0 0 0 0l0 32c0 17.7-14.3 32-32 32l-32 0c0-35.3 28.7-64 64-64zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faElevator = {
    prefix: 'fal',
    iconName: 'elevator',
    icon: [
      512,
      512,
      [],
      'e16d',
      
      'M155.3 4.7l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 38.6 91.3 91.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0zm160 0L368 57.4 420.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 160zM0 192c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zm184 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM144 384c-17.7 0-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32l-32 0zm160 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faTally3 = {
    prefix: 'fal',
    iconName: 'tally-3',
    icon: [
      640,
      512,
      [],
      'e296',
      
      'M128 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zM400 48l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faHouseChimneyHeart = {
    prefix: 'fal',
    iconName: 'house-chimney-heart',
    icon: [
      576,
      512,
      [],
      'e1b2',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4 384 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 136.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1L480 64l-64 0 0 43.6 64 56.5zM96 206.7L96 432c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7zM237.3 256c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7L288 377.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6zM176 285.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z'
      
    ]
  };

  

  
  

  var faTableTree = {
    prefix: 'fal',
    iconName: 'table-tree',
    icon: [
      512,
      512,
      [],
      'e293',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64 80 0 368 0 0-64c0-17.7-14.3-32-32-32L64 64zm64 128l0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-5.6 0-11-1-16-2.7l0 50.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-26.5 0-48-21.5-48-48l0-96 0-48-64 0 0 224c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-224-352 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 272c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm80 80l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fal',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      'M352 128c0-53 43-96 96-96s96 43 96 96l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80C576 57.3 518.7 0 448 0S320 57.3 320 128l0 64L80 192c-44.2 0-80 35.8-80 80L0 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80l-16 0 0-64zm-16 96l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l256 0z'
      
    ]
  };

  

  
  

  var faSolarPanel = {
    prefix: 'fal',
    iconName: 'solar-panel',
    icon: [
      640,
      512,
      [],
      'f5ba',
      
      'M221.2 0l16.1 0L402.7 0l16.1 0L533.5 0c26.9 0 50 19.1 55 45.6L613.2 176l3 16L639 312.6c1 5.1 1 10.2 1 15.4c0 30.9-25.1 56-56 56l-148 0-16.1 0L336 384l0 96 96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-96-83.9 0L204 384 56 384c-30.9 0-56-25.1-56-56c0-5.2 0-10.3 1-15.4L23.8 192l3-16L51.5 45.6C56.5 19.1 79.6 0 106.5 0L221.2 0zM304 352l32 0 81.2 0L404.7 208l-169.4 0L222.8 352l81.2 0zM250.5 32L238.1 176l163.9 0L389.5 32 250.5 32zM436.8 208l12.5 144L584 352c13.3 0 24-10.7 24-24c0-5.6-.1-7.8-.4-9.5L586.7 208l-149.9 0zM434 176l146.6 0L557.1 51.5C554.9 40.2 545 32 533.5 32L421.6 32 434 176zM203.2 208L53.3 208 32.4 318.5c-.3 1.7-.4 3.9-.4 9.5c0 13.3 10.7 24 24 24l134.7 0 12.5-144zm2.8-32L218.4 32 106.5 32C95 32 85.1 40.2 82.9 51.5L59.4 176 206 176z'
      
    ]
  };

  

  
  

  var faShieldDog = {
    prefix: 'fal',
    iconName: 'shield-dog',
    icon: [
      512,
      512,
      [],
      'e573',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM200 128l-21.3 0c-32.4 0-58.7 26.3-58.7 58.7l0 29.3c0 22.6 13.4 42.1 32.7 50.9l-15 29.9c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L186.4 271c26-4.9 45.6-27.7 45.6-55l0-56 60.2 0c6.1 0 11.6 3.4 14.3 8.8l7.2 14.3c2.7 5.4 8.2 8.8 14.3 8.8l56 0 0 16c0 35.3-28.7 64-64 64l-48 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 32 0c53 0 96-43 96-96l0-16c0-17.7-14.3-32-32-32l-46.1 0-2.7-5.5C327 138.3 310.4 128 292.2 128L232 128l-16 0-16 0zM175.7 240c-13.1-.1-23.7-10.8-23.7-24l0-29.3c0-10.9 6.6-20.3 16-24.4c3.3-1.4 6.9-2.2 10.7-2.2l21.3 0 0 32 0 24c0 13.2-10.6 23.9-23.7 24l-.5 0zM272 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShutters = {
    prefix: 'fal',
    iconName: 'shutters',
    icon: [
      512,
      512,
      [],
      'e449',
      
      'M32 32C14.3 32 0 46.3 0 64L0 96c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 32zm0 32l448 0 0 32L32 96l0-32zM.9 453c-.6 2-.9 4.1-.9 6.1C0 470.7 9.3 480 20.9 480l470.3 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-21.2-69-33.5 0 19.7 64L35.9 448l19.7-64-33.5 0L.9 453zM22.2 256L.9 325c-.6 2-.9 4.1-.9 6.1C0 342.7 9.3 352 20.9 352l470.3 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-21.2-69-33.5 0 19.7 64L35.9 320l19.7-64-33.5 0zm453.9-64L35.9 192l9.8-32-33.5 0L.9 197c-.6 2-.9 4.1-.9 6.1C0 214.7 9.3 224 20.9 224l470.3 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37-33.5 0 9.8 32z'
      
    ]
  };

  

  
  

  var faBitcoinSign = {
    prefix: 'fal',
    iconName: 'bitcoin-sign',
    icon: [
      320,
      512,
      [],
      'e0b4',
      
      'M64 16C64 7.2 71.2 0 80 0s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48.3c53.7 4.1 96 49 96 103.7c0 31.3-13.9 59.4-35.8 78.5C291.8 261.2 320 299.3 320 344c0 57.4-46.6 104-104 104l-24 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-22.3 0C18.7 448 0 429.3 0 406.3L0 272l0-32L0 101.6C0 80.8 16.8 64 37.6 64L64 64l0-48zM176 416l40 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-32 0L32 272l0 134.3c0 5.4 4.4 9.7 9.7 9.7L80 416l96 0zm0-320L80 96 37.6 96c-3.1 0-5.6 2.5-5.6 5.6L32 240l152 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-8 0z'
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fal',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      'M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 432c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 96zM416 67.5L341.3 192l149.4 0L416 67.5zM307.6 186L391.8 45.7C396.9 37.2 406.1 32 416 32s19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1l-173.9 0c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9zM320 432l0-96c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCube = {
    prefix: 'fal',
    iconName: 'cube',
    icon: [
      512,
      512,
      [],
      'f1b2',
      
      'M261.5 35.1c-3.6-1.3-7.5-1.3-11 0L44.1 110.7 256 194l211.9-83.2L261.5 35.1zM32 385.7c0 6.7 4.2 12.7 10.5 15L240 473.1l0-251L32 140.3l0 245.3zm240 87.4l197.5-72.4c6.3-2.3 10.5-8.3 10.5-15l0-245.3L272 222l0 251zM239.5 5c10.7-3.9 22.4-3.9 33 0l208 76.3c18.9 6.9 31.5 24.9 31.5 45.1l0 259.3c0 20.1-12.6 38.1-31.5 45.1L272.5 507c-10.7 3.9-22.4 3.9-33 0l-208-76.3C12.6 423.8 0 405.8 0 385.7L0 126.3c0-20.1 12.6-38.1 31.5-45.1L239.5 5z'
      
    ]
  };

  

  
  

  var faHandsHoldingDollar = {
    prefix: 'fal',
    iconName: 'hands-holding-dollar',
    icon: [
      640,
      512,
      ["hands-usd"],
      'f4c5',
      
      'M320 0c8.8 0 16 7.2 16 16l0 16.8c11 1.2 21.6 3.7 31.2 6.3c8.5 2.3 13.5 11.1 11.2 19.7s-11.1 13.5-19.7 11.2c-12.1-3.3-24-5.8-35-5.9c-9.2-.1-19.1 2.1-26.1 6.3c-6.4 3.9-9.6 8.8-9.6 15.8c0 5.1 2 8.7 8.7 12.8c7.6 4.7 18.3 8.1 31.9 12.3l.4 .1c12.3 3.8 27.3 8.5 39.1 16.1c12.9 8.3 23.6 21.3 23.8 40.9c.3 20.6-9.9 35.6-24 44.5c-9.7 6.2-20.9 9.5-32 10.6l0 16.5c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-18.6c-11-2.4-21.3-6-30.4-9.3c-2.3-.8-4.6-1.6-6.7-2.4c-8.4-2.9-12.8-12-10-20.3s12-12.8 20.3-10c2.6 .9 5.2 1.8 7.7 2.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c14.7 5.1 26.8 9.3 39.7 9.8c10 .3 19.7-1.9 26.2-6.1c5.8-3.7 9.3-8.9 9.2-17.1c-.1-6.1-2.6-10.2-9.2-14.4c-7.6-4.9-18.2-8.4-31.7-12.6l-1.7-.5c-11.9-3.7-26.3-8.1-37.5-15.1c-12.8-7.9-23.7-20.4-23.8-39.9c-.1-20.6 11.1-34.9 25-43.3c7.1-4.3 15-7.2 22.9-8.9l0-18c0-8.8 7.2-16 16-16zM64 64c35.3 0 64 28.7 64 64l0 124.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5L512 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6L608 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16s0 0 0 0l44-44s0 0 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3l0 77.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16s0 0 0 0l-44-44s0 0 0 0l-10.7-10.8C106.8 305.4 96 279.4 96 252.3L96 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2L0 128C0 92.7 28.7 64 64 64z'
      
    ]
  };

  
    var faHandsUsd = faHandsHoldingDollar;
  

  
  

  var faToiletPaperXmark = {
    prefix: 'fal',
    iconName: 'toilet-paper-xmark',
    icon: [
      512,
      512,
      [],
      'e5b3',
      
      'M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32l225.3 0c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9L112 352c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6L480 464c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-48-32 0 0 48c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-272c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0L112 0C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384l288 0c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM227.3 132.7c-6.2-6.2-16.4-6.2-22.6 0L168 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L145.4 192l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L168 214.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faWifiSlash = {
    prefix: 'fal',
    iconName: 'wifi-slash',
    icon: [
      640,
      512,
      [],
      'f6ac',
      
      'M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1zm394.7 230l-54.7-43.2c70 5.6 133 36.3 179.9 83.1c6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-28.4-28.3-63.5-50-102.6-62.5zM208.5 249.5c-25.8 12.5-49.1 29.2-69.2 49.2c-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19-18.9 40.6-35.2 64.2-48.3l27.6 21.8zM201.7 81.1L171.5 57.2C218 40.9 267.9 32 320 32c122.9 0 234.3 49.5 315.3 129.7c6.3 6.2 6.3 16.3 .1 22.6s-16.3 6.3-22.6 .1C537.6 110 434.2 64 320 64c-41.1 0-80.8 6-118.3 17.1zM48.8 123.4l26 20.5C57.9 156.2 42 169.8 27.3 184.4c-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4 .1-22.6c13.8-13.7 28.5-26.5 44-38.3zM268.2 453.5a64 64 0 1 1 103.7-75 64 64 0 1 1 -103.7 75zM352 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faSquareInfo = {
    prefix: 'fal',
    iconName: 'square-info',
    icon: [
      448,
      512,
      [8505,"info-square"],
      'f30f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm200 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-16 64l40 0c8.8 0 16 7.2 16 16l0 112 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-96-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faInfoSquare = faSquareInfo;
  

  
  

  var faTemperatureQuarter = {
    prefix: 'fal',
    iconName: 'temperature-quarter',
    icon: [
      320,
      512,
      ["temperature-1","thermometer-1","thermometer-quarter"],
      'f2ca',
      
      'M160 32c-35.3 0-64 28.7-64 64l0 156.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9L224 96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96l0 156.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5L64 96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-34c0-8.8 7.2-16 16-16s16 7.2 16 16l0 34c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature1 = faTemperatureQuarter;
  
    var faThermometer1 = faTemperatureQuarter;
  
    var faThermometerQuarter = faTemperatureQuarter;
  

  
  

  var faR = {
    prefix: 'fal',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      'M48 32C21.5 32 0 53.5 0 80L0 272 0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 135.4 0L290.7 472.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L205.4 287.3C269.8 280.6 320 226.2 320 160c0-70.7-57.3-128-128-128L48 32zM176 256L32 256 32 80c0-8.8 7.2-16 16-16l144 0c53 0 96 43 96 96s-43 96-96 96l-16 0z'
      
    ]
  };

  

  
  

  var faLockKeyhole = {
    prefix: 'fal',
    iconName: 'lock-keyhole',
    icon: [
      448,
      512,
      ["lock-alt"],
      'f30d',
      
      'M224 32c53 0 96 43 96 96l0 64-192 0 0-64c0-53 43-96 96-96zM96 128l0 64-16 0c-44.2 0-80 35.8-80 80L0 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80l-16 0 0-64C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224l288 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z'
      
    ]
  };

  
    var faLockAlt = faLockKeyhole;
  

  
  

  var faDiamondHalf = {
    prefix: 'fal',
    iconName: 'diamond-half',
    icon: [
      512,
      512,
      [],
      'e5b7',
      
      'M227.7 11.7C235.5 3.9 245.8 0 256 0l0 32 0 448 0 32c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM224 451.3l0-390.6L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L224 451.3z'
      
    ]
  };

  

  
  

  var faKitchenSet = {
    prefix: 'fal',
    iconName: 'kitchen-set',
    icon: [
      576,
      512,
      [],
      'e51a',
      
      'M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128l67.6 0c6.6-18.6 24.4-32 45.3-32l96 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-96 0c-20.9 0-38.7-13.4-45.3-32l-67.6 0zM272 320l16 0 32 0 0-32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 32 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 112c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-112-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 0l96 0 0-32-96 0 0 32zm-32 32l0 112c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-112-160 0zM496 128l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM192 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 144a80 80 0 1 1 160 0A80 80 0 1 1 64 144zM0 496c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16zM160 352l0 32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zm0-32l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80c0-8.8 7.2-16 16-16l80 0 16 0 16 0zm-32 64l0-32-64 0 0 64 64 0 0-32z'
      
    ]
  };

  

  
  

  var faAppleWhole = {
    prefix: 'fal',
    iconName: 'apple-whole',
    icon: [
      448,
      512,
      [127822,127823,"apple-alt"],
      'f5d1',
      
      'M228.6 96L224 96l0-4.6C224 58.6 250.6 32 283.4 32l4.6 0 0 4.6C288 69.4 261.4 96 228.6 96zm-18.3 32l18.3 0c50.5 0 91.4-40.9 91.4-91.4l0-18.3C320 8.2 311.8 0 301.7 0L283.4 0C232.9 0 192 40.9 192 91.4l0 18.3c0 10.1 8.2 18.3 18.3 18.3zM32 288c0-33.8 8-67.7 22.8-92c14.2-23.5 33-36 57.2-36c21 0 48.7 8.4 71.1 17.1c26.2 10.2 55.6 10.2 81.9 0C287.3 168.4 315 160 336 160c24.3 0 43 12.5 57.2 36C408 220.3 416 254.2 416 288c0 57.5-18 106.6-43.6 140.8C346.4 463.5 315 480 288 480c-13.2 0-32-2.7-45.3-5c-12.3-2.2-25-2.2-37.3 0c-13.3 2.3-32.1 5-45.3 5c-27 0-58.4-16.5-84.4-51.2C50 394.6 32 345.5 32 288zM160 512c16.2 0 37.4-3.2 50.8-5.5c8.7-1.5 17.6-1.5 26.3 0c13.5 2.4 34.6 5.5 50.8 5.5c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512z'
      
    ]
  };

  
    var faAppleAlt = faAppleWhole;
  

  
  

  var faCircleEuro = {
    prefix: 'fal',
    iconName: 'circle-euro',
    icon: [
      512,
      512,
      [],
      'e5ce',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 16l24.2 0c-.7-5-1-10.1-1-15.2c0-5.7 .4-11.3 1.2-16.8L128 240c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.2 0c18.2-37.9 56.9-64 101.7-64l41.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-41.1 0c-26.3 0-49.6 12.6-64.4 32l88.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-103.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2L288 272c8.8 0 16 7.2 16 16s-7.2 16-16 16l-89.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-41.1 0c-45.4 0-84.5-26.8-102.4-65.5L128 304c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faToiletPaperSlash = {
    prefix: 'fal',
    iconName: 'toilet-paper-slash',
    icon: [
      640,
      512,
      [],
      'e072',
      
      'M581.2 319.4C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0L464 0 160 0c-14.1 0-27.5 6.1-39.5 17l25.7 20.3c5.6-4 10.4-5.3 13.8-5.3l272.3 0c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 11.3-.1 22.1-.4 32.7l31.2 24.6c.8-18 1.2-37 1.2-57.3c0-88.4 35.8-160 80-160s80 71.6 80 160c0 65.6-19.7 122-48 146.7l25.4 20c11.5-11.3 20.8-25.3 27.8-39.3zM368.6 375.9c-8.3 43.2-18.1 71.7-24.8 87.8c-4.3 10.3-14.5 16.3-25.9 16.3L48 480s0 0 0 0c.2-.3 .4-.6 .5-.9c24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-10.4 .4-20.5 1.3-30.3L67.8 138.4c-2.5 17-3.8 35-3.8 53.6c0 80.2-.4 180.8-36.2 257.3c-2.3 4.9-4.7 9.6-7.3 14.3c0 0 0 0 0 .1c-2.8 4.7-4.3 10-4.5 15.4c-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512l269.9 0c22.3 0 45.4-12.1 55.4-36.1c6.6-15.9 15.5-41.4 23.4-77.9l-28.1-22.2zM481.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faRabbit = {
    prefix: 'fal',
    iconName: 'rabbit',
    icon: [
      512,
      512,
      [128007],
      'f708',
      
      'M324.1 20.8c6.5 9.4 12.1 19.2 16.9 29.5c3.5-4.4 7.2-8.6 11.2-12.6l3.1-3.1c1.7-1.7 4-2.6 6.4-2.6c4.5 0 8.3 3.3 8.9 7.7l.7 4.9c3.3 22.7 1.2 45.6-5.6 66.8c-12.9-4.8-26.7-7.4-40.7-7.5c-6.3-33.2-22.5-64.4-47.4-89l-3.1-3.1L263.3 23.3l11.3-11.4C266.9 4.3 256.5 0 245.7 0C225.3 0 208 15 205.1 35.2l-.7 4.9c-7.6 53 8.6 106.2 43.6 145.9l0 37.6c-62.8 17.5-113.6 63.7-137.4 123.6C99.5 340.1 86.2 336 72 336c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.4 0 24.1-3.1 34.3-8.7c13.7 24.2 39.6 40.5 69.3 40.7l.3 0c0 0 .1 0 .1 0l128 0c26.5 0 48-21.5 48-48c0-25.9-20.5-47-46.2-48l21-22.2 55.9 94.6c13.5 22.8 42.9 30.4 65.7 16.9s30.4-42.9 16.9-65.7L380.5 296l7.3 0c42.1 0 76.3-34.1 76.3-76.3c0-22.9-10.3-44.6-28.1-59.1L399 130.5c-1.5-1.2-3.1-2.5-4.7-3.6c9.8-27.4 13-57.1 8.7-86.8l-.7-4.9C399.4 15 382.1 0 361.7 0c-10.8 0-21.2 4.3-28.9 11.9L329.7 15c-1.9 1.9-3.8 3.9-5.6 5.8zM96.4 439.7C89.6 444.9 81.2 448 72 448c-22.1 0-40-17.9-40-40s17.9-40 40-40c11.2 0 21.4 4.6 28.6 12.1c-3 14.2-4.6 28.9-4.6 43.9l0 8c0 2.6 .1 5.2 .4 7.7zm140.4-400c.6-4.4 4.4-7.7 8.9-7.7c2.4 0 4.7 .9 6.3 2.6l3.1 3.1c23.4 23.2 37.3 53.5 40.3 85.2c.4 4.6 2.8 8.7 6.5 11.4s8.4 3.7 12.9 2.7c3.1-.7 6.3-1 9.6-1c19.8 0 39 6.8 54.3 19.3l36.9 30.1c10.3 8.4 16.3 21 16.3 34.3c0 24.4-19.8 44.3-44.3 44.3l-35.3 0c-5.7 0-11 3.1-13.9 8.1s-2.8 11.1 .1 16.1l99.1 167.7c4.5 7.6 2 17.4-5.6 21.9s-17.4 2-21.9-5.6L343.6 359.3c-2.6-4.3-7-7.2-12-7.8s-10 1.2-13.4 4.9L257 421c-4.4 4.6-5.6 11.5-3.1 17.3s8.3 9.7 14.7 9.7l35.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c0 0 0 0 0 0l-.2 0c-26.4-.1-47.8-21.6-47.8-48l0-8c0-84.6 59.7-155.3 139.3-172.2c7.4-1.6 12.7-8.1 12.7-15.7l0-55.7 0-.4c0-4.1-1.5-8.1-4.4-11.2c-31.3-33.1-46-78.8-39.5-124.2l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faValueAbsolute = {
    prefix: 'fal',
    iconName: 'value-absolute',
    icon: [
      512,
      512,
      [],
      'f6a6',
      
      'M16 32C7.2 32 0 39.2 0 48L0 464c0 8.8 7.2 16 16 16s16-7.2 16-16L32 48c0-8.8-7.2-16-16-16zM171.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256l-84.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-84.7-84.7zM512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416z'
      
    ]
  };

  

  
  

  var faAngel = {
    prefix: 'fal',
    iconName: 'angel',
    icon: [
      576,
      512,
      [],
      'f779',
      
      'M384 64.2c0 .1-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2s0 .1 0 .2zM288 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM45.3 480C38 480 32 474 32 466.7c0-2.1 .5-4.1 1.4-5.9l39.8-79.7c4.4-8.9 6.8-18.7 6.8-28.6l0-.9c0-9.9-2.3-19.7-6.8-28.6L54.9 286.2c-4.5-9-6.9-19.1-6.9-29.3c0-35.8 29-64.9 64.2-64.9c17 0 33.3 6.8 45.4 18.8l67 67c-12 9.3-22.1 21.4-29.1 35.5L112 480l-66.7 0zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3l0 .9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3L96 512l35.8 0 312.4 0 35.8 0 50.7 0c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3l0-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm97.7 15.9l67-67c12-12 28.4-18.8 45.4-18.8c35.1 0 64.2 29.1 64.2 64.9c0 10.2-2.4 20.3-6.9 29.3l-18.4 36.7c-4.4 8.9-6.8 18.7-6.8 28.6l0 .9c0 9.9 2.3 19.7 6.8 28.6l39.8 79.7c.9 1.8 1.4 3.9 1.4 5.9c0 7.3-6 13.3-13.3 13.3L464 480 380.6 313.2c-7.1-14.1-17.1-26.2-29.1-35.5zm.5 49.8L428.2 480l-280.4 0L224 327.6c12.1-24.2 36.9-39.6 64-39.6s51.9 15.3 64 39.6z'
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fal',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      'M512 352l-352 0c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l117.5 0c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1L512 128c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32zM349.3 77.3L322.7 50.7c-12-12-28.3-18.7-45.3-18.7L160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L394.5 96c-17 0-33.3-6.7-45.3-18.7zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 352c0 70.7 57.3 128 128 128l336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-336 0c-53 0-96-43-96-96l0-240z'
      
    ]
  };

  

  
  

  var faGaugeCirclePlus = {
    prefix: 'fal',
    iconName: 'gauge-circle-plus',
    icon: [
      640,
      512,
      [],
      'e498',
      
      'M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18.1 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fal',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-80l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faBottleWater = {
    prefix: 'fal',
    iconName: 'bottle-water',
    icon: [
      320,
      512,
      [],
      'e4c5',
      
      'M128 80l64 0 0-48-64 0 0 48zM96 83.4L96 80l0-56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 56 0 3.4c7.6 2.1 14.9 5 21.8 8.9l6.2 3.4c27.1 15.1 44 43.7 44 74.8c0 15.9-4.3 30.8-11.9 43.5c7.5 12.2 11.9 26.6 11.9 42c0 18-6 34.6-16 48c10 13.4 16 30 16 48c0 14.6-3.9 28.2-10.7 40c6.8 11.8 10.7 25.4 10.7 40c0 44.2-35.8 80-80 80l-112 0c-44.2 0-80-35.8-80-80c0-14.6 3.9-28.2 10.7-40C27.9 380.2 24 366.6 24 352c0-18 6-34.6 16-48c-10-13.4-16-30-16-48c0-15.4 4.4-29.8 11.9-42C28.3 201.3 24 186.4 24 170.5c0-31.1 16.8-59.7 44-74.8l6.2-3.4c6.9-3.8 14.3-6.8 21.8-8.9zM121.6 112c-11.1 0-22.1 2.8-31.8 8.3l-6.2 3.4C66.5 133.1 56 151 56 170.5c0 10 2.7 19.3 7.4 27.2c6.1 10.2 5.9 23-.3 33.1C58.6 238.1 56 246.7 56 256c0 10.8 3.6 20.8 9.6 28.8c8.6 11.4 8.6 27.1 0 38.4c-6 8-9.6 17.9-9.6 28.8c0 8.8 2.3 17 6.4 24c5.7 9.9 5.7 22.1 0 32c-4.1 7-6.4 15.2-6.4 24c0 26.5 21.5 48 48 48l112 0c26.5 0 48-21.5 48-48c0-8.8-2.3-17-6.4-24c-5.7-9.9-5.7-22.1 0-32c4.1-7 6.4-15.2 6.4-24c0-10.8-3.6-20.8-9.6-28.8c-8.6-11.4-8.6-27.1 0-38.4c6-8 9.6-17.9 9.6-28.8c0-9.3-2.6-17.9-7.1-25.2c-6.3-10.1-6.4-22.9-.3-33.1c4.7-8 7.4-17.2 7.4-27.2c0-19.4-10.5-37.3-27.5-46.8l-6.2-3.4c-9.7-5.4-20.7-8.3-31.8-8.3l-6.4 0-64 0-6.4 0zM112 224l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 368c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceSurprise = {
    prefix: 'fal',
    iconName: 'face-surprise',
    icon: [
      512,
      512,
      [128558,"surprise"],
      'f5c2',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faSurprise = faFaceSurprise;
  

  
  

  var faArrowRightToArc = {
    prefix: 'fal',
    iconName: 'arrow-right-to-arc',
    icon: [
      512,
      512,
      [],
      'e4b2',
      
      'M480 256C480 132.3 379.7 32 256 32c-8.8 0-16-7.2-16-16s7.2-16 16-16C397.4 0 512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM202.6 116l144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272 16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l277.9 0L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3z'
      
    ]
  };

  

  
  

  var faUserShakespeare = {
    prefix: 'fal',
    iconName: 'user-shakespeare',
    icon: [
      448,
      512,
      [],
      'e2c2',
      
      'M304 160l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48c0 40.1 29.5 73.3 68 79.1l0-15.1c0-6.6 5.4-12 12-12s12 5.4 12 12l0 15.1c38.5-5.8 68-39 68-79.1zM114.1 90.5C124.1 38.9 169.5 0 224 0s99.9 38.9 109.9 90.5c11 8.8 18.1 22.3 18.1 37.5l0 9.5c0 9.5 2.8 18.7 8.1 26.6l16.7 25.1c4.7 7.1 7.2 15.4 7.2 23.8c0 23.7-19.2 43-43 43l-59.3 0c-16.9 10.2-36.6 16-57.7 16s-40.9-5.8-57.7-16L107 256c-23.7 0-43-19.2-43-43c0-8.5 2.5-16.8 7.2-23.8l16.7-25.1c5.3-7.9 8.1-17.1 8.1-26.6l0-9.5c0-15.2 7.1-28.7 18.1-37.5zm219.7 91.9c-3.1 15.2-9.3 29.3-17.8 41.7l25.1 0c6.1 0 11-4.9 11-11c0-2.2-.6-4.3-1.8-6.1l-16.4-24.6zM132.1 224c-8.6-12.3-14.8-26.4-17.8-41.7L97.8 206.9c-1.2 1.8-1.8 3.9-1.8 6.1c0 6.1 4.9 11 11 11l25.1 0zM176 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM0 481.3c0-69.5 44-128.8 105.7-151.4c13.6-24.9 40-41.8 70.3-41.8l48 0 48 0c30.4 0 56.8 16.9 70.3 41.8C404 352.5 448 411.8 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3zM176 320c-26.5 0-48 21.5-48 48l0 3.6c1.6-.8 3.3-1.5 5.1-2.3c17.6-7.6 42.5-15 74.9-16.9l0-32.5-32 0zm64 32.5c32.5 1.9 57.3 9.3 74.9 16.9c1.8 .8 3.5 1.5 5.1 2.3l0-3.6c0-26.5-21.5-48-48-48l-32 0 0 32.5zM224 384c-35.8 0-61.6 7.5-78.2 14.7c-8.3 3.6-14.4 7.1-18.2 9.7c-1.9 1.3-3.3 2.3-4.1 2.9c-.4 .3-.7 .5-.8 .7l-.1 .1c-4.7 4.1-11.4 5.2-17.1 2.6C99.7 412 96 406.3 96 400l0-30.3C58.1 391.9 32.5 432.9 32 480l176 0c0-8.8 7.2-16 16-16s16 7.2 16 16l176 0c-.5-47.1-26-88.1-64-110.3l0 30.3c0 6.3-3.7 12-9.5 14.6c-5.7 2.6-12.4 1.5-17.1-2.6c0 0 0 0 0 0s0 0 0 0l-.1-.1-.3-.2-.6-.4c-.8-.6-2.2-1.6-4.1-2.9c-3.8-2.5-9.9-6.1-18.2-9.7C285.6 391.5 259.8 384 224 384zm-16 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMartiniGlassCitrus = {
    prefix: 'fal',
    iconName: 'martini-glass-citrus',
    icon: [
      576,
      512,
      ["cocktail"],
      'f561',
      
      'M432 256c-21.7 0-42-6.2-59.2-16.9l-23.1 23.1C373 278.5 401.4 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C369.3 0 316 40.1 296.2 96l34.6 0c18-37.8 56.5-64 101.2-64c61.9 0 112 50.1 112 112s-50.1 112-112 112zM16 128c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4L192 342.6 192 480l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-137.4L411.3 155.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9L16 128zm345.4 32L208 313.4 54.6 160l306.7 0z'
      
    ]
  };

  
    var faCocktail = faMartiniGlassCitrus;
  

  
  

  var faBracketsRound = {
    prefix: 'fal',
    iconName: 'brackets-round',
    icon: [
      512,
      512,
      ["parentheses"],
      'e0c5',
      
      'M151.6 62.1C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4s1.3 17.5-6.4 21.7zm208.8 0c-7.8-4.2-10.7-13.9-6.4-21.7s13.9-10.7 21.7-6.4C420.8 58.4 512 136.7 512 256s-91.2 197.6-136.4 222.1c-7.8 4.2-17.5 1.3-21.7-6.4s-1.3-17.5 6.4-21.7C400.5 428.2 480 358.6 480 256s-79.5-172.2-119.6-193.9z'
      
    ]
  };

  
    var faParentheses = faBracketsRound;
  

  
  

  var faArrowLeftLongToLine = {
    prefix: 'fal',
    iconName: 'arrow-left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d4',
      
      'M0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80zM132.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 624 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-441.4 0L299.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z'
      
    ]
  };

  

  
  

  var faPawSimple = {
    prefix: 'fal',
    iconName: 'paw-simple',
    icon: [
      448,
      512,
      ["paw-alt"],
      'f701',
      
      'M152 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm31.2 73.2c7.7-15.5 23.5-25.2 40.8-25.2s33.1 9.8 40.8 25.2l33.8 67.5c8.3 16.5 23.1 25.9 36.8 30c28.1 8.4 48.6 34.4 48.6 65.2c0 37.6-30.4 68-68 68c-14.4 0-27.7-4.5-38.7-12.1c-16-11.1-36.5-14.7-53.3-14.7s-37.3 3.6-53.3 14.7c-11 7.6-24.3 12.1-38.7 12.1c-37.6 0-68-30.4-68-68c0-30.8 20.4-56.8 48.6-65.2c13.7-4.1 28.6-13.5 36.8-30l33.8-67.5zm-62.4 53.2c-3.4 6.9-10 11.5-17.3 13.7C62.1 296.4 32 334.7 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-45.3-30.1-83.6-71.4-95.9c-7.4-2.2-13.9-6.8-17.3-13.7l-33.8-67.5c-13.2-26.3-40-42.9-69.5-42.9s-56.3 16.6-69.5 42.9l-33.8 67.5zM272 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 240 88a56 56 0 1 0 112 0zm40 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM32 200a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 0 200a56 56 0 1 0 112 0z'
      
    ]
  };

  
    var faPawAlt = faPawSimple;
  

  
  

  var faHouseCrack = {
    prefix: 'fal',
    iconName: 'house-crack',
    icon: [
      576,
      512,
      [],
      'e3b1',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-119.4 0-50.4-75.6 82.7-55.1c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l82.2 82.2-79.8 53.2c-7.4 4.9-9.3 14.8-4.4 22.2L274.1 480 144 480c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faLeftToLine = {
    prefix: 'fal',
    iconName: 'left-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-left"],
      'f34b',
      
      'M32 432L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16zm96.8-174.2c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L260.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L128.8 257.8zM96 256c0 9.5 3.9 18.6 10.8 25.1L238.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L106.8 230.9C99.9 237.4 96 246.5 96 256z'
      
    ]
  };

  
    var faArrowAltToLeft = faLeftToLine;
  

  
  

  var faHexagonMinus = {
    prefix: 'fal',
    iconName: 'hexagon-minus',
    icon: [
      512,
      512,
      ["minus-hexagon"],
      'f307',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM160 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faMinusHexagon = faHexagonMinus;
  

  
  

  var faDumpsterFire = {
    prefix: 'fal',
    iconName: 'dumpster-fire',
    icon: [
      640,
      512,
      [],
      'f794',
      
      'M423.4 32L288 32s0 0 0 0s0 0 0 0L152.3 32c-.2 0-.4 0-.6 0L57 32c-14.7 0-27.5 10-31 24.2L.9 156.6c-.6 2.3-.9 4.6-.9 6.9C0 179.2 12.8 192 28.5 192l5.3 0L66 192l61.7 0 .6 0L288 192l49.5 0c7.5-10.7 15.7-21.4 24.5-32l-58 0 0-96 106.4 0 7.5 39.6c9.4-6.1 20.5-8.6 31.2-7.3L443 64l76 0 15.4 61.5c11.4-2.8 23.7-1.2 34.2 4.7l-18.5-74C546.5 42 533.7 32 519 32l-95 0c-.2 0-.4 0-.6 0zM337.6 448c-8.8-9.8-16.5-20.6-23.2-32L92.3 416 69.8 224l-32.2 0 3.8 32L16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l29.1 0L64 448.9 64 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 241.6 0zM272 64l0 96-124.7 0 18-96L272 64zM132.7 64l-18 96-66.5 0-.4 0L33 160 57 64l75.7 0zm314.4 97.1l47.4 49.8c3.1 3.2 7.4 5 11.9 5s8.7-2 11.7-5.4l21-23.7c16.6 15.9 33.7 37.3 46.7 60.7c13.7 24.6 22.2 50 22.2 72.6c0 33.5-12.7 63.9-33.6 86.6c1-5.2 1.6-10.7 1.6-16.2c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 280.1 384 333.2 384 390.6c0 5.7 .6 11.2 1.6 16.6c-21-22.8-33.6-53.3-33.6-87c0-28.4 12.4-58.2 31.4-86.7c18.4-27.5 42-52.6 63.7-72.3zM480 448c-2.4 0-4.7-.1-7-.2c-33.7-3.2-57-29.4-57-57.3c0-17.4 10.1-37.7 27.4-58.5c12.1-14.5 25.8-27 36.6-35.8c10.7 8.8 24.5 21.3 36.6 35.8c17.3 20.7 27.4 41.1 27.4 58.5c0 27.8-23.2 54-56.9 57.3c-2.4 .1-4.7 .2-7.1 .2zM320 320.2c0 85.6 65.7 155 150.9 159.6c3 .3 6 .4 9.1 .4c3.1 0 6.2-.1 9.2-.4C573.6 475 640 405.7 640 320.2c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-11.2-10.4-28.5-10.4-39.7-.1c-.4 .4-.8 .7-1.1 1.2l-12.3 13.8-37.9-39.9c-.3-.3-.5-.5-.8-.8c-11.1-10.1-28.1-10.1-39.3-.1c-23.4 21.1-50 48.9-70.9 80.2C336 246.8 320 282.8 320 320.2z'
      
    ]
  };

  

  
  

  var faCircleArrowDownLeft = {
    prefix: 'fal',
    iconName: 'circle-arrow-down-left',
    icon: [
      512,
      512,
      [],
      'e0f9',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm56-160l-136 0c-8.8 0-16-7.2-16-16l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 105.4L324.7 164.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 320l97.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z'
      
    ]
  };

  

  
  

  var faHouseUser = {
    prefix: 'fal',
    iconName: 'house-user',
    icon: [
      576,
      512,
      ["home-user"],
      'e1b0',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM96 206.7L96 432c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 392l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-39.8 32.2-72 72-72l80 0c39.8 0 72 32.2 72 72l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  
    var faHomeUser = faHouseUser;
  

  
  

  var faMarsAndVenus = {
    prefix: 'fal',
    iconName: 'mars-and-venus',
    icon: [
      512,
      512,
      [9893],
      'f224',
      
      'M352 16c0 8.8 7.2 16 16 16l73.4 0-75.6 75.6C337.1 80.6 298.5 64 256 64C167.6 64 96 135.6 96 224c0 83 63.1 151.2 144 159.2l0 32.8-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32.8c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16L368 0c-8.8 0-16 7.2-16 16zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  

  
  

  var faFileChartPie = {
    prefix: 'fal',
    iconName: 'file-chart-pie',
    icon: [
      384,
      512,
      [],
      'f65a',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM176 224l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16c0-61.9-50.1-112-112-112c-8.8 0-16 7.2-16 16zm32 17.6c31.3 6.4 56 31.1 62.4 62.4L208 304l0-62.4zm-56-21C105.7 234.4 72 277.3 72 328c0 61.9 50.1 112 112 112c50.7 0 93.6-33.7 107.4-80l-34 0c-12.3 28.3-40.5 48-73.3 48c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-34z'
      
    ]
  };

  

  
  

  var faHeart = {
    prefix: 'fal',
    iconName: 'heart',
    icon: [
      512,
      512,
      [9829,10084,61578,128153,128154,128155,128156,128420,129293,129294,129505],
      'f004',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2L443 275.5c23.6-22 37-52.8 37-85.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 36-13.1 70.6-36.6 97.5c-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5z'
      
    ]
  };

  

  
  

  var faFaceNauseated = {
    prefix: 'fal',
    iconName: 'face-nauseated',
    icon: [
      512,
      512,
      [],
      'e381',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM175.6 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-26.9-60.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM146.2 272.6c4.4-7.6 14.2-10.3 21.9-5.8c19.5 11.3 33.8 30.5 38.4 53.3l99.2 0c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3l-99.2 0c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9z'
      
    ]
  };

  

  
  

  var faBookCircleArrowUp = {
    prefix: 'fal',
    iconName: 'book-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e0bd',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l262.6 0c-2.9-10.3-4.9-21-5.9-32L64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l336 0c8.8 0 16 7.2 16 16l0 163.2c10.1-5.2 20.8-9.4 32-12.6L448 48c0-26.5-21.5-48-48-48L64 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faShirtRunning = {
    prefix: 'fal',
    iconName: 'shirt-running',
    icon: [
      384,
      512,
      [],
      'e3c8',
      
      'M80 0c8.8 0 16 7.2 16 16l0 48c0 53 43 96 96 96s96-43 96-96l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16c0 134.3 29.3 192.6 45.6 214.6c8.9 12 18.4 28.6 18.4 47.6L384 456c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 278.2c0-19 9.5-35.7 18.4-47.6C34.7 208.6 64 150.3 64 16C64 7.2 71.2 0 80 0zM44.1 249.6c-7.6 10.2-12.1 20-12.1 28.6l0 118.1L310.6 195l1.4-1c-5.5-15.9-10.5-34.9-14.6-57.5C274.4 170 235.8 192 192 192s-82.4-22-105.5-55.5c-10.7 59.8-28.4 94.1-42.4 113.1zM32 435.7L32 456c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-177.8c0-8.6-4.6-18.4-12.1-28.6c-4.8-6.5-10-14.7-15.2-25.2L41.4 429 32 435.7z'
      
    ]
  };

  

  
  

  var faSignPostsWrench = {
    prefix: 'fal',
    iconName: 'sign-posts-wrench',
    icon: [
      640,
      512,
      [],
      'e626',
      
      'M64 64L48 64c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l284 0c4.4 11.3 9.9 22 16.5 32L96 416l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-16 0c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l16 0 0-16C64 7.2 71.2 0 80 0s16 7.2 16 16l0 16 384 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c26.5 0 48 21.5 48 48l0 83.2c-10.1-5.2-20.8-9.4-32-12.6L544 80c0-8.8-7.2-16-16-16l-16 0-32 0L96 64 64 64zM464 201.3l0 86.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-86.7c0-5.3 2.6-10.3 7.1-13.3s10-3.6 14.9-1.6c52.7 21.4 90 73.1 90 133.5c0 42.7-18.6 81-48 107.3l0 68.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-76.1c0-4.9 2.2-9.4 6-12.5c25.6-20.6 42-52.1 42-87.4c0-38-19-71.7-48-91.9l0 59.9c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-59.9c-29 20.2-48 53.9-48 91.9c0 35.4 16.4 66.9 42 87.4c3.8 3 6 7.6 6 12.5l0 76.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-68.7C370.6 401 352 362.7 352 320c0-60.5 37.3-112.2 90-133.5c4.9-2 10.5-1.4 14.9 1.6s7.1 7.9 7.1 13.3z'
      
    ]
  };

  

  
  

  var faGridRound4 = {
    prefix: 'fal',
    iconName: 'grid-round-4',
    icon: [
      448,
      512,
      [],
      'e5dd',
      
      'M44.8 56a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zm44.8 98.7a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM65.6 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM185.1 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM304.5 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z'
      
    ]
  };

  

  
  

  var faFaceThermometer = {
    prefix: 'fal',
    iconName: 'face-thermometer',
    icon: [
      576,
      512,
      [],
      'e39a',
      
      'M288 32C164.3 32 64 132.3 64 256s100.3 224 224 224c95.3 0 176.7-59.5 209.1-143.4c3.2-8.2 12.4-12.4 20.7-9.2s12.4 12.4 9.2 20.7C490 444 396.9 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c83.8 0 158.1 40.2 204.8 102.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2C426.3 67.2 361.3 32 288 32zM402.5 396.1c-6.7 5.8-16.8 5.1-22.6-1.6C362 373.8 331.4 352 288 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5c13.5 0 26 1.7 37.5 4.6L477 179.4c19.6-18.8 50.6-18.4 69.8 .7c19.8 19.8 19.4 52.1-.9 71.4L408 382.9c.3 4.8-1.5 9.8-5.5 13.2zm-43.9-58.9c11.3 5.9 21.1 13 29.6 20.3l8.4-8-5.1-5.1c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0L414 333l15.4-14.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3L358.5 337.2zM208.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faPlugCircleBolt = {
    prefix: 'fal',
    iconName: 'plug-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e55b',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64c0 83 63.1 151.2 144 159.2l0 96.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96.8c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128l0-64 256 0 0 56.2c9.8-8.1 20.6-15.2 32-21l0-35.2 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0L64 144l-32 0-16 0zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z'
      
    ]
  };

  

  
  

  var faTrophyStar = {
    prefix: 'fal',
    iconName: 'trophy-star',
    icon: [
      576,
      512,
      ["trophy-alt"],
      'f2eb',
      
      'M400 32L176 32c-9 0-15.4 7.3-15.1 15c6.2 163.9 44.9 239.2 76.1 273.5c15.5 17.1 29.9 24.8 39.3 28.3c4.8 1.8 8.5 2.6 10.6 3c.5 .1 .9 .1 1.2 .2c.3 0 .7-.1 1.2-.2c2.1-.3 5.8-1.1 10.6-3c9.4-3.5 23.8-11.3 39.3-28.3c31.2-34.2 69.8-109.6 76.1-273.5c.3-7.8-6.2-15-15.1-15zM176 0L400 0c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8L528 64c26 0 49.3 21.6 46.2 49.7c-10.1 94-61.9 158.2-118.1 199.9c-55.9 41.4-117.1 61.3-149.3 66.9l-.1-.3c-.9 .3-1.8 .6-2.7 .8l0 98.9 96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0-112 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-98.9c-.9-.3-1.8-.5-2.7-.8l-.1 .3c-32.2-5.7-93.4-25.5-149.3-66.9C63.7 272 11.9 207.7 1.8 113.7C-1.3 85.6 22 64 48 64l81.6 0c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM377.8 323.2c19.2-9.1 39.6-20.7 59.2-35.3c51.1-37.9 96.4-94.8 105.4-177.6c.8-7-5.1-14.3-14.4-14.3l-83.8 0c-9.8 116.5-37.2 185.9-66.4 227.2zM131.8 96L48 96c-9.3 0-15.2 7.3-14.4 14.3C42.5 193.2 87.9 250.1 139 287.9c19.6 14.6 40 26.2 59.2 35.3C169 281.9 141.5 212.5 131.8 96zm177.8-.5L322.1 121l28.2 4.1c19.7 2.9 27.5 27.1 13.3 40.9l-20.4 19.9 4.8 28.1c3.4 19.6-17.2 34.6-34.8 25.3L288 226.1l-25.2 13.3c-17.6 9.3-38.2-5.7-34.8-25.3l4.8-28.1-20.4-19.9c-14.2-13.9-6.4-38.1 13.3-40.9l28.2-4.1 12.6-25.6c8.8-17.8 34.2-17.8 43 0zm-28.8 43.5c-3.5 7.1-10.3 12-18.1 13.1l-16.3 2.4L258.1 166c5.7 5.5 8.2 13.5 6.9 21.2l-2.8 16.3 14.6-7.7c7-3.7 15.3-3.7 22.3 0l14.6 7.7L311 187.2c-1.3-7.8 1.2-15.7 6.9-21.2l11.8-11.5-16.3-2.4c-7.8-1.1-14.6-6-18.1-13.1L288 124.2l-7.3 14.8z'
      
    ]
  };

  
    var faTrophyAlt = faTrophyStar;
  

  
  

  var faCircleThreeQuarters = {
    prefix: 'fal',
    iconName: 'circle-three-quarters',
    icon: [
      512,
      512,
      [],
      'e125',
      
      'M256 288c-17.7 0-32-14.3-32-32l0-221.7C115.5 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.5 221.7-192L256 288zM224.1 2C241.6-.2 256 14.3 256 32l0 192 0 32 32 0 192 0c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z'
      
    ]
  };

  

  
  

  var faArrowsToEye = {
    prefix: 'fal',
    iconName: 'arrows-to-eye',
    icon: [
      640,
      512,
      [],
      'e4bf',
      
      'M43.3 20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L105.4 128 48 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 57.4L43.3 20.7zm553.4 0L512 105.4 512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-57.4 0 84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM320 368c-77.3 0-132.6-65-156.7-112c24.1-47 79.4-112 156.7-112s132.6 65 156.7 112C452.6 303 397.3 368 320 368zm0-256c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM596.7 491.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L534.6 384l57.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-57.4 84.7 84.7zm-576-22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L128 406.6l0 57.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0L20.7 468.7zM272 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fal',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      'M64.7 34.6L160 107.9l0 52.1-52.1 0L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3l0-64c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l64 0c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7L368 160c-8.8 0-16-7.2-16-16l0-25.4c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4l0 25.4c0 26.9 21.8 48.6 48.6 48.6l25.4 0c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z'
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faHandHorns = {
    prefix: 'fal',
    iconName: 'hand-horns',
    icon: [
      384,
      512,
      [],
      'e1a9',
      
      'M88 32c13.3 0 24 10.7 24 24l0 144 0 40-32 0c-5.5 0-10.8 .6-16 1.6L64 56c0-13.3 10.7-24 24-24zm56 117.4L144 56c0-30.9-25.1-56-56-56S32 25.1 32 56l0 200C12.6 270.6 0 293.8 0 320l0 32c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-112 0-120c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 61.4c-7.3-3.5-15.4-5.4-24-5.4c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zm0 50.6c0-13.3 10.7-24 24-24s24 10.7 24 24l0 31.9c0 0 0 0 0 .1l0 13.4c-7.3-3.5-15.4-5.4-24-5.4l-24 0 0-40zm80 72l0-40c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24l0 8 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24c0 0 0 0 0 0l0-24zm-112 0s0 0 0 0l32 0s0 0 0 0l24 0c13.2 0 24 10.7 24 24c0 0 0 0 0 0c0 13.3-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56l0-56 0-8 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120 0 112c0 70.7-57.3 128-128 128l-64 0C89.3 480 32 422.7 32 352l0-32c0-26.5 21.5-48 48-48l32 0z'
      
    ]
  };

  

  
  

  var faFaceSleepy = {
    prefix: 'fal',
    iconName: 'face-sleepy',
    icon: [
      512,
      512,
      [],
      'e38e',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c31.9 0 62.2-6.7 89.6-18.6c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1C327 504.4 292.4 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 23.6-3.2 46.5-9.2 68.3c-2.4 8.5-11.2 13.5-19.7 11.2s-13.5-11.2-11.2-19.7c5.2-19 8.1-39 8.1-59.7C480 132.3 379.7 32 256 32zm64.3 285c1.4-7.5 8-13 15.7-13c27.8 0 70.8 13.3 106.7 36.6C478.5 363.7 512 399.9 512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-16.2-.1-39.4-7.2-61.5c-6.9-21.5-20.2-41.1-46.7-51.7c-7.1-2.8-11.2-10.3-9.8-17.9zm76 34.8c4.7 8.1 8.3 16.5 11 25c8.8 27.2 8.8 54.9 8.8 70.8l0 .5c0 17.7 14.3 32 32 32s32-14.3 32-32c0-31.9-22.5-59.7-54.7-80.6c-9.4-6.1-19.3-11.3-29.1-15.7zm-87.3 78c-16.2-6.1-34-9.4-52.9-9.4c-18.8 0-36.7 3.4-52.9 9.4c-11.2 4.2-23.6 2.3-32.4-4.5c-4.5-3.5-8.4-8.6-10-15.1c-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5c-1.6 6.5-5.5 11.6-10 15.1c-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2c18.5-6.4 38.6-9.8 59.6-9.8c21 0 41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z'
      
    ]
  };

  

  
  

  var faTarp = {
    prefix: 'fal',
    iconName: 'tarp',
    icon: [
      576,
      512,
      [],
      'e57b',
      
      'M32 384l0-256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32l0 128-112 0c-26.5 0-48 21.5-48 48l0 112L64 416c-17.7 0-32-14.3-32-32zm391.4 27.3c-2.1 2.1-4.6 3.5-7.4 4.2L416 304c0-8.8 7.2-16 16-16l111.5 0c-.7 2.8-2.1 5.4-4.2 7.4L423.4 411.3zM576 128c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l348.1 0c12.7 0 24.9-5.1 33.9-14.1L561.9 318.1c9-9 14.1-21.2 14.1-33.9L576 128zM96 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faHammerBrush = {
    prefix: 'fal',
    iconName: 'hammer-brush',
    icon: [
      640,
      512,
      [],
      'e620',
      
      'M144 0C64.5 0 0 64.5 0 144l0 24c0 5.2 2.6 10.2 6.9 13.2s9.8 3.7 14.7 1.8l51.9-19.5c7.9 10.1 18.2 17.9 29.9 22.8L97.5 448c-.8 35.1 27.4 64 62.5 64s63.3-28.9 62.5-64l-5.9-258.9c16.3-4.7 30.7-14.9 40.4-29.1l62.9 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-62.9 0C243.4 12.1 220.8 0 196.2 0L144 0zM320 64l0 64-72 0c-6.1 0-11.6 3.4-14.3 8.8C226.6 151 212.1 160 196.2 160l-64.4 0c-15.9 0-30.4-9-37.5-23.2c-3.7-7.3-12.3-10.7-19.9-7.8L32 144.9l0-.9C32 82.1 82.1 32 144 32l52.2 0c15.9 0 30.4 9 37.5 23.2c2.7 5.4 8.3 8.8 14.3 8.8l72 0zM184.7 192l5.8 256.7c.4 17.1-13.4 31.3-30.6 31.3s-30.9-14.1-30.6-31.3L135.3 192l49.4 0zM528 220.3l11.5 9.6 57 47.5c3.5 2.9 6.3 6.6 8.3 10.6l-217.6 0c2-4 4.8-7.7 8.3-10.6l57-47.5 11.5-9.6 0-15L464 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 141.3 0 15zM384 320l224 0 0 144c0 8.8-7.2 16-16 16l-112 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-48 0c-8.8 0-16-7.2-16-16l0-144zM560 205.3L560 64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 141.3-57 47.5C360.4 265 352 283 352 302l0 162c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-162c0-19-8.4-37-23-49.2l-57-47.5zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faClockNine = {
    prefix: 'fal',
    iconName: 'clock-nine',
    icon: [
      512,
      512,
      [],
      'e34c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 144c0 8.8-7.2 16-16 16l-112 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-128c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faHandsHoldingHeart = {
    prefix: 'fal',
    iconName: 'hands-holding-heart',
    icon: [
      640,
      512,
      ["hands-heart"],
      'f4c3',
      
      'M195.9 28.9C223.7 .7 267.8-.8 297.3 24.3c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9C372.2-.8 416.3 .7 444.1 28.9c29.4 29.8 29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L320 217.3 421.3 114.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0L331.4 80.9c-6.3 6.4-16.5 6.4-22.8 0L279.5 51.4zM64 64c35.3 0 64 28.7 64 64l0 124.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5L512 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6L608 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16s0 0 0 0l44-44s0 0 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3l0 77.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16s0 0 0 0l-44-44s0 0 0 0l-10.7-10.8C106.8 305.4 96 279.4 96 252.3L96 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2L0 128C0 92.7 28.7 64 64 64z'
      
    ]
  };

  
    var faHandsHeart = faHandsHoldingHeart;
  

  
  

  var faBasketShoppingSimple = {
    prefix: 'fal',
    iconName: 'basket-shopping-simple',
    icon: [
      576,
      512,
      ["shopping-basket-alt"],
      'e0af',
      
      'M322.2 24.1c-4.5-7.6-1.9-17.4 5.8-21.9s17.4-1.9 21.9 5.8L457.2 192l53.8 0 33 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L40 224l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 33 0 53.8 0L226.2 7.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9L155.9 192l264.3 0-98-167.9zM503 224L73 224l57.9 231.8c3.6 14.2 16.4 24.2 31 24.2L414 480c14.7 0 27.5-10 31-24.2L503 224zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faShoppingBasketAlt = faBasketShoppingSimple;
  

  
  

  var faH = {
    prefix: 'fal',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      'M352 256l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 224 32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 320 0z'
      
    ]
  };

  

  
  

  var faLeftFromLine = {
    prefix: 'fal',
    iconName: 'left-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-right"],
      'f348',
      
      'M32.8 257.8c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L164.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L32.8 257.8zM0 256c0 9.5 3.9 18.6 10.8 25.1L142.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L10.8 230.9C3.9 237.4 0 246.5 0 256zM448 432l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  
    var faArrowAltFromRight = faLeftFromLine;
  

  
  

  var faCupStraw = {
    prefix: 'fal',
    iconName: 'cup-straw',
    icon: [
      384,
      512,
      [129380],
      'e363',
      
      'M249 0c-22 0-41.2 15-46.6 36.4L179.5 128 16 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l175.7 0c.2 0 .5 0 .7 0L368 160c8.8 0 16-7.2 16-16s-7.2-16-16-16l-155.5 0 21-83.9C235.2 37 241.6 32 249 32l23 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L249 0zM37.3 192l23 276c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44l23-276-32.1 0L291.8 465.3c-.7 8.3-7.6 14.7-15.9 14.7l-167.7 0c-8.3 0-15.3-6.4-15.9-14.7L69.4 192l-32.1 0z'
      
    ]
  };

  

  
  

  var faMessageSmile = {
    prefix: 'fal',
    iconName: 'message-smile',
    icon: [
      512,
      512,
      ["comment-alt-smile"],
      'f4aa',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM155.9 252.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 302.5 215.7 320 256 320s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3C314.5 274.6 286.8 288 256 288s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z'
      
    ]
  };

  
    var faCommentAltSmile = faMessageSmile;
  

  
  

  var faSpaceStationMoon = {
    prefix: 'fal',
    iconName: 'space-station-moon',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8c0 0 0 0 0 0c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zM256 369.4c104.8 0 169.6-18.7 208.8-32.3C432.3 420.8 351.1 480 256 480s-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM136 160a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faMelonSlice = {
    prefix: 'fal',
    iconName: 'melon-slice',
    icon: [
      512,
      512,
      [],
      'e311',
      
      'M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L322.6 86.8c-3.6 3.6-5.2 8.6-4.5 13.6c1.3 9 2 18.2 2 27.6c0 106-86 192-192 192c-9.4 0-18.6-.7-27.6-2c-5-.7-10 1-13.6 4.5L4.7 404.7c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512l4 0C378.2 512 512 378.2 512 213.2l0-4c0-76.7-30.5-150.2-84.7-204.5zM391 63.7L415.6 39C457 85.8 480 146.3 480 209.1l0 4C480 360.5 360.5 480 213.2 480l-4 0C146.3 480 85.8 457 39 415.6L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232c0-58.3-21.5-111.6-57-152.3zM368.3 86.3C398 121.3 416 166.5 416 216c0 110.5-89.5 200-200 200c-49.5 0-94.7-18-129.7-47.7l17.6-17.6c7.9 .8 16 1.3 24.1 1.3c123.7 0 224-100.3 224-224c0-8.1-.4-16.2-1.3-24.1l17.6-17.6z'
      
    ]
  };

  

  
  

  var faPersonCircleQuestion = {
    prefix: 'fal',
    iconName: 'person-circle-question',
    icon: [
      576,
      512,
      [],
      'e542',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91L224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6l40.5 0c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16l0-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9l-40.5 0c-5.3 0-9.6 4.3-9.6 9.6l0 6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.4z'
      
    ]
  };

  

  
  

  var faCashRegister = {
    prefix: 'fal',
    iconName: 'cash-register',
    icon: [
      512,
      512,
      [],
      'f788',
      
      'M272 32c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l192 0zM80 0C53.5 0 32 21.5 32 48l0 32c0 26.5 21.5 48 48 48l80 0 0 32-72.5 0c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-59.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9L192 160l0-32 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L80 0zM32 448l0-32 448 0 0 32c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32zM456.2 219.5L479.7 384 32.3 384 55.8 219.5C58.1 203.7 71.6 192 87.5 192l337 0c15.9 0 29.4 11.7 31.7 27.5zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faOctagonPlus = {
    prefix: 'fal',
    iconName: 'octagon-plus',
    icon: [
      512,
      512,
      ["plus-octagon"],
      'f301',
      
      'M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3l0 129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7l129 0c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3l0-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7l-129 0zM240 352l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  
    var faPlusOctagon = faOctagonPlus;
  

  
  

  var faSignsPost = {
    prefix: 'fal',
    iconName: 'signs-post',
    icon: [
      512,
      512,
      ["map-signs"],
      'f277',
      
      'M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 168.3 0c4.9 0 9.5 2.2 12.5 6L504 102c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6L272 192l0 32 176 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-176 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112L71.7 384c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6L240 224l0-32L64 192c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l176 0 0-16zM432.6 64L64 64l0 96 368.6 0L471 112 432.6 64zM79.4 256L41 304l38.4 48L448 352l0-96L79.4 256z'
      
    ]
  };

  
    var faMapSigns = faSignsPost;
  

  
  

  var faArrowRight = {
    prefix: 'fal',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z'
      
    ]
  };

  

  
  

  var faSignatureLock = {
    prefix: 'fal',
    iconName: 'signature-lock',
    icon: [
      640,
      512,
      [],
      'e3ca',
      
      'M64 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 3.4c0 26.2-2.4 52.3-7.2 78L59 243.7c-34.8 9.5-59 41.1-59 77.2l0 92.6C0 450.2 29.8 480 66.5 480c24 0 46.2-13 57.9-33.9L151.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l88.6 0c5.6-9.7 13.7-17.8 23.4-23.4l0-8.6-86.1 0 52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3L218.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7l0-3.4c0-53-43-96-96-96s-96 43-96 96l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0 0-32-144 0zM67.4 274.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4L96.5 430.4C90.4 441.3 78.9 448 66.5 448c-19 0-34.5-15.4-34.5-34.5l0-92.6c0-21.6 14.5-40.6 35.4-46.3zM528 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80l0 128-160 0 0-128 160 0z'
      
    ]
  };

  

  
  

  var faTickets = {
    prefix: 'fal',
    iconName: 'tickets',
    icon: [
      640,
      512,
      [],
      'e658',
      
      'M160 64c-17.7 0-32 14.3-32 32l0 47.5c23.7 11.8 40 36.2 40 64.5s-16.3 52.8-40 64.5l0 47.5c0 17.7 14.3 32 32 32l416 0c17.7 0 32-14.3 32-32l0-47.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.8 40-64.5L608 96c0-17.7-14.3-32-32-32L160 64zm452.2 77.5s0 0 0 0c0 0 0 0-.1 0c.1 0 .1 0 .1 0zm0 132.9c0 0-.1 0-.1 0c.1 0 .1 0 .1 0zm-488.4 0l.1 0c-.1 0-.1 0-.1 0zm0-132.9l.1 0c-.1 0-.1 0-.1 0zM160 32l416 0c35.3 0 64 28.7 64 64l0 56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1l0 56c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64l0-56c0-8.8 7.4-15.7 15.6-19.1c14.4-6.1 24.4-20.3 24.4-36.9s-10.1-30.8-24.4-36.9C103.4 167.7 96 160.8 96 152l0-56c0-35.3 28.7-64 64-64zM16 96c8.8 0 16 7.2 16 16l0 256c0 44.2 35.8 80 80 80l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-416 0C50.1 480 0 429.9 0 368L0 112c0-8.8 7.2-16 16-16zm240 64l0 96 224 0 0-96-224 0zm-32 0c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-96z'
      
    ]
  };

  

  
  

  var faMaskVentilator = {
    prefix: 'fal',
    iconName: 'mask-ventilator',
    icon: [
      640,
      512,
      [],
      'e524',
      
      'M160 300.8c0 44.6 21.7 85.6 56.9 112.9c-5.7-13.6-8.9-28.6-8.9-44.3c0-30.2 11.8-69.3 30.3-100.8c9.3-15.9 20.8-30.7 34.2-41.7c13.4-11 29.5-18.8 47.5-18.8c18 0 34 7.9 47.3 18.8s24.8 25.8 34.2 41.7C420 300 432 339.1 432 369.3c0 15.6-3.1 30.4-8.8 43.9C458.1 386 480 345.4 480 300.8c0-42-19.2-103.3-51.6-154.3C395 93.9 355.3 64 320 64c-35.8 0-75.5 30-108.7 82.4C179 197.4 160 258.8 160 300.8zm80 68.5c0 26.6 12.5 50.1 32 64.9l0 40.2c-51.6-12.3-94.5-43.9-119.7-86L83.5 370.3C34.3 357.4 0 312.9 0 262l0-86c0-26.5 21.5-48 48-48l137.1 0C219.8 73.8 267.4 32 320 32c52.1 0 99.7 41.8 134.5 96L592 128c26.5 0 48 21.5 48 48l0 86c0 50.9-34.3 95.4-83.5 108.3l-69 18.2C462.1 430.6 419 462 368 474.3l0-40.3c19.3-14.7 32-38 32-64.7c0-23.3-9.8-56.8-26.1-84.6c-8.1-13.7-17.3-25.3-26.9-33.2s-18.7-11.5-27-11.5c-8.4 0-17.6 3.6-27.2 11.5c-9.6 7.9-18.8 19.4-26.9 33.2C249.7 312.4 240 346 240 369.3zm264.4-18.4l43.9-11.6c35.1-9.2 59.6-41 59.6-77.4l0-86c0-8.8-7.2-16-16-16l-119.1 0C497.4 207.8 512 260.3 512 300.8c0 17.4-2.7 34.3-7.6 50.1zM166.8 160L48 160c-8.8 0-16 7.2-16 16l0 86c0 36.3 24.5 68.1 59.6 77.4l43.9 11.6c-4.9-15.9-7.5-32.7-7.5-50.1c0-40.5 14.4-93 38.8-140.8zM304 320c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192-32 0 0-192z'
      
    ]
  };

  

  
  

  var faSendBack = {
    prefix: 'fal',
    iconName: 'send-back',
    icon: [
      640,
      512,
      [],
      'f87e',
      
      'M192 32c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L64 224c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0zM64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L64 0zM576 288c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l128 0zM448 256c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-128 0zM160 288l0 64c0 35.3 28.7 64 64 64l128 0 0-32-128 0c-17.7 0-32-14.3-32-32l0-64-32 0zM416 96L288 96l0 32 128 0c17.7 0 32 14.3 32 32l0 64 32 0 0-64c0-35.3-28.7-64-64-64zm0 96c0-17.7-14.3-32-32-32l-96 0 0 32 96 0 0 56.4c9.2-8.3 20.1-14.8 32-19l0-37.5zM256 320l0-56.4c-9.2 8.3-20.1 14.8-32 19l0 37.5c0 17.7 14.3 32 32 32l96 0 0-32-96 0z'
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fal',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM240 256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 377.4 240 256z'
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faChartLine = {
    prefix: 'fal',
    iconName: 'chart-line',
    icon: [
      512,
      512,
      ["line-chart"],
      'f201',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z'
      
    ]
  };

  
    var faLineChart = faChartLine;
  

  
  

  var faFrenchFries = {
    prefix: 'fal',
    iconName: 'french-fries',
    icon: [
      384,
      512,
      [127839],
      'f803',
      
      'M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3l0 218.4c-8.5 2.4-19 4.3-32 5.1l0-213.6-32-16 0 229.6c-13-.9-23.5-2.7-32-5.1L144 16c0-5.5 2.9-10.7 7.6-13.6zM279.1 233.8c-1 4-2.9 9-7.1 14.1l0-39.4L299.1 84.5 272 89.9l0-32.6 44.9-9c5.3-1.1 10.8 .6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zM362.6 192l-30.1 0 19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-18.6 92.9c-.8 0-1.7-.1-2.5-.1zM21.4 192c-.9 0-1.7 0-2.5 .1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3s17.1 3.9 18.8 12.6L51.5 192l-30.1 0zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7c-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1l0 35.8L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zM89.2 480l205.7 0 54.3-224-9.8 0c-5.3 16.4-16.3 35.8-38.2 51.6C276.4 325.3 241.1 336 192 336s-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256l-9.8 0L89.2 480zm-31.1 7.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224l32.9 0c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304s112.4-39 118.2-62.5c2.3-9.2 10-17.5 19.5-17.5l32.9 0c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5L89.2 512c-14.8 0-27.6-10.1-31.1-24.5z'
      
    ]
  };

  

  
  

  var faObjectGroup = {
    prefix: 'fal',
    iconName: 'object-group',
    icon: [
      576,
      512,
      [],
      'f247',
      
      'M64 125.3C45.4 118.7 32 100.9 32 80c0-26.5 21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l325.5 0c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48c0 20.9-13.4 38.7-32 45.3l0 261.5c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32l-325.5 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-261.5zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zM496 416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 80A16 16 0 1 0 64 80a16 16 0 1 0 32 0zm80 48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm-16 48l0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm192 64c0-8.8 7.2-16 16-16l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faRingsWedding = {
    prefix: 'fal',
    iconName: 'rings-wedding',
    icon: [
      512,
      512,
      [],
      'f81b',
      
      'M137.9 32l-8 16 24 48L176 96l22.1 0 24-48-8-16-76.2 0zM254.3 55.2l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 64.4-34.5 120.7-86.1 151.3c-8.6-6.9-16.1-15-22.4-24.1C289 375 320 327.1 320 272c0-27.5-7.7-53.3-21.1-75.2C237.3 213.2 192 269.3 192 336c0 27.5 7.7 53.3 21.1 75.2c6 9.8 13.2 18.8 21.3 26.9c0 0 0 0 0 0C260.5 464 296.4 480 336 480c79.5 0 144-64.5 144-144c0-67.9-47-124.9-110.3-140c-4.9-12.4-10.9-24.2-17.9-35.3C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32C116.4 3.4 121.9 0 128 0l96 0c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3zM179.2 416c-12.3-24-19.2-51.2-19.2-80c0-76.7 49.1-142 117.6-166.1C251.5 144 215.6 128 176 128C96.5 128 32 192.5 32 272s64.5 144 144 144c1.1 0 2.1 0 3.2 0z'
      
    ]
  };

  

  
  

  var faBreadLoaf = {
    prefix: 'fal',
    iconName: 'bread-loaf',
    icon: [
      640,
      512,
      [127838],
      'f7eb',
      
      'M64 224c-17.7 0-32-14.3-32-32c0-45.8 30.4-77.3 77.4-98.9C156.4 71.4 211.6 64 240 64s83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16l-48 0-208 0c-8.8 0-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32zm352 32l128 0 0 176c0 8.8-7.2 16-16 16l-114.7 0c1.8-5 2.7-10.4 2.7-16l0-144 0-32zm155.3-31.7c-1.1-.2-2.2-.3-3.3-.3l-96.6 0c5.4-9.4 8.6-20.3 8.6-32c0-64-44-104-96-128l16 0c28.4 0 83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32c-1.6 0-3.2 .1-4.7 .3zM112 480l208 0 48 0 160 0c26.5 0 48-21.5 48-48l0-144 0-32c35.3 0 64-28.7 64-64C640 64 464 32 400 32L272 32l-32 0C176 32 0 64 0 192c0 35.3 28.7 64 64 64l0 32 0 144c0 26.5 21.5 48 48 48z'
      
    ]
  };

  

  
  

  var faFaceRollingEyes = {
    prefix: 'fal',
    iconName: 'face-rolling-eyes',
    icon: [
      512,
      512,
      [128580,"meh-rolling-eyes"],
      'f5a5',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 368l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96c26.5 0 48-21.5 48-48c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48s48-21.5 48-48zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faMehRollingEyes = faFaceRollingEyes;
  

  
  

  var faHexagonVerticalNft = {
    prefix: 'fal',
    iconName: 'hexagon-vertical-nft',
    icon: [
      448,
      512,
      [],
      'e505',
      
      'M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9L0 164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4l0 184.6c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7l0-184.6c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM94.7 170.6l33.1 82.9 0-76.9c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L95.8 259.7l0 76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-80zm112-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faUserCowboy = {
    prefix: 'fal',
    iconName: 'user-cowboy',
    icon: [
      448,
      512,
      [],
      'f8ea',
      
      'M166.4 41.7l-33.3 77.7c25.3 5.2 55.5 8.6 90.9 8.6s65.6-3.4 90.9-8.6L281.6 41.7c-2.5-5.8-8.4-9.7-14.9-9.7c-3.5 0-6.9 1.1-9.7 3.2l-4.3 3.2c-17.1 12.8-40.5 12.8-57.6 0l-4.3-3.2c-2.7-2.1-6.2-3.2-9.7-3.2c-6.5 0-12.4 3.9-14.9 9.7zm-64.7 69.7L137 29.1C144.6 11.4 162.1 0 181.3 0c10.3 0 20.5 3.3 28.9 9.6l4.3 3.2c5.7 4.3 13.5 4.3 19.2 0l4.3-3.2C246.2 3.3 256.4 0 266.7 0c19.1 0 36.7 11.4 44.3 29.1l35.3 82.3c6.4-2 12.3-4.1 17.9-6.3c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9C336.7 202.6 285.4 224 224 224s-112.7-21.4-150.6-49.1C35.8 147.5 10.1 113 .8 85.1c-2.5-7.4 .8-15.6 7.8-19.2s15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7c5.5 2.2 11.5 4.3 17.9 6.3zm-9.5 37.7c33.2 24.3 78 42.9 131.8 42.9s98.5-18.6 131.8-42.9c5.5-4 10.7-8.2 15.5-12.4C335.6 149.9 287.1 160 224 160s-111.6-10.1-147.3-23.4c4.8 4.2 10 8.4 15.5 12.4zM100.7 416c-32.3 0-59.5 24-63.5 56.1l-1 7.9 375.5 0-1-7.9c-4-32-31.2-56.1-63.5-56.1l-246.5 0zm0-32l246.5 0c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36L36.2 512C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1zM224 352c-70 0-126.9-56.2-128-126c10.5 5.2 21.6 10 33.3 14.1C137 285.4 176.5 320 224 320s87-34.6 94.7-79.9c11.7-4.1 22.8-8.8 33.3-14.1c-1.1 69.8-58 126-128 126z'
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fal',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      'M199.1 86.6c-6 6-14.1 9.4-22.6 9.4L112 96c-8.8 0-16 7.2-16 16l0 64.5c0 8.5-3.4 16.6-9.4 22.6L41 244.7c-6.2 6.2-6.2 16.4 0 22.6L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5 64 112c0-26.5 21.5-48 48-48l64.5 0 45.6-45.6c18.7-18.7 49.1-18.7 67.9 0L335.5 64 400 64c26.5 0 48 21.5 48 48l0 64.5 45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5l0 64.5c0 26.5-21.5 48-48 48l-64.5 0-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448 112 448c-26.5 0-48-21.5-48-48l0-64.5L18.4 289.9 41 267.3l45.6 45.6c6 6 9.4 14.1 9.4 22.6L96 400c0 8.8 7.2 16 16 16l64.5 0c8.5 0 16.6 3.4 22.6 9.4L244.7 471c6.2 6.2 16.4 6.2 22.6 0l45.6-45.6c6-6 14.1-9.4 22.6-9.4l64.5 0c8.8 0 16-7.2 16-16l0-64.5c0-8.5 3.4-16.6 9.4-22.6L471 267.3c6.2-6.2 6.2-16.4 0-22.6l-45.6-45.6c-6-6-9.4-14.1-9.4-22.6l0-64.5c0-8.8-7.2-16-16-16l-64.5 0c-8.5 0-16.6-3.4-22.6-9.4L267.3 41c-6.2-6.2-16.4-6.2-22.6 0L199.1 86.6z'
      
    ]
  };

  

  
  

  var faPlaneCircleCheck = {
    prefix: 'fal',
    iconName: 'plane-circle-check',
    icon: [
      640,
      512,
      [],
      'e555',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7l0 52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6l0 56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6l0 42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2c0 0 0 0 0 0L256 480.6l105.7 30.2s0 0 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4l0-39.4 57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8l0-56.2c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9l0-61.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7l0 61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1l0-52.5c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faCircleRight = {
    prefix: 'fal',
    iconName: 'circle-right',
    icon: [
      512,
      512,
      [61838,"arrow-alt-circle-right"],
      'f35a',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm400 0c0-9.2-3.5-18-9.7-24.7l-84-91c-7.2-7.8-17.4-12.3-28.1-12.3c-21.1 0-38.3 17.1-38.3 38.3l0 25.7-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 25.7c0 21.1 17.1 38.3 38.3 38.3c10.7 0 20.9-4.5 28.1-12.3l84-91c6.2-6.7 9.7-15.6 9.7-24.7zm-33.2-3c.8 .8 1.2 1.9 1.2 3s-.4 2.2-1.2 3l-84 91c-1.2 1.3-2.9 2-4.6 2c-3.5 0-6.3-2.8-6.3-6.3l0-41.7c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16l0-41.7c0-3.5 2.8-6.3 6.3-6.3c1.7 0 3.4 .7 4.6 2l84 91z'
      
    ]
  };

  
    var faArrowAltCircleRight = faCircleRight;
  

  
  

  var faEject = {
    prefix: 'fal',
    iconName: 'eject',
    icon: [
      448,
      512,
      [9167],
      'f052',
      
      'M224 96c-4.5 0-8.8 1.9-11.8 5.2l-176 192c-4.3 4.7-5.4 11.4-2.9 17.3s8.3 9.6 14.6 9.6l352 0c6.3 0 12.1-3.7 14.6-9.6s1.4-12.6-2.9-17.3l-176-192c-3-3.3-7.3-5.2-11.8-5.2zm0-32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352L48 352c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64zM16 416l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 448c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faStarship = {
    prefix: 'fal',
    iconName: 'starship',
    icon: [
      640,
      512,
      [],
      'e039',
      
      'M0 112C0 85.5 21.5 64 48 64l160 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-46.8 0 47.6 34.6 60.1-8.2C296.8 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.2-50.8-179-122.4l-60.1-8.2L161.2 352l46.8 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L48 448c-26.5 0-48-21.5-48-48s21.5-48 48-48l58.8 0L163 311.1l-21.5-2.9C115.5 304.6 96 282.3 96 256s19.5-48.6 45.5-52.2l21.5-2.9L106.8 160 48 160c-26.5 0-48-21.5-48-48zM48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 96zm97.9 139.5C135.6 236.9 128 245.7 128 256s7.6 19.1 17.9 20.5l113.5 15.5c-2.2-11.6-3.4-23.7-3.4-35.9s1.2-24.3 3.4-35.9L145.9 235.5zM32 400c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16zm416 16a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm32-160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faSimCards = {
    prefix: 'fal',
    iconName: 'sim-cards',
    icon: [
      448,
      512,
      [],
      'e251',
      
      'M112 368c0 17.7 14.3 32 32 32l240 0c17.7 0 32-14.3 32-32l0-213.5c0-8.5-3.4-16.6-9.4-22.6L316.1 41.4c-6-6-14.1-9.4-22.6-9.4L144 32c-17.7 0-32 14.3-32 32l0 304zM80 64c0-35.3 28.7-64 64-64L293.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L448 368c0 35.3-28.7 64-64 64l-240 0c-35.3 0-64-28.7-64-64L80 64zM16 96c8.8 0 16 7.2 16 16l0 272c0 53 43 96 96 96l240 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-240 0C57.3 512 0 454.7 0 384L0 112c0-8.8 7.2-16 16-16zm160 96l0 16 48 0 0-32-32 0c-8.8 0-16 7.2-16 16zm120 16l56 0 0-16c0-8.8-7.2-16-16-16l-40 0-40 0 0 32 40 0zm0 32l-56 0-64 0 0 32 56 0 40 0 80 0 0-32-56 0zm-8 64l0 32 48 0c8.8 0 16-7.2 16-16l0-16-64 0zm-56 0l-56 0 0 16c0 8.8 7.2 16 16 16l40 0 24 0 0-32-24 0zM192 144l48 0 56 0 40 0c26.5 0 48 21.5 48 48l0 32 0 64 0 32c0 26.5-21.5 48-48 48l-64 0-40 0-40 0c-26.5 0-48-21.5-48-48l0-32 0-64 0-32c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faCommentCode = {
    prefix: 'fal',
    iconName: 'comment-code',
    icon: [
      512,
      512,
      [],
      'e147',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM219.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 240l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z'
      
    ]
  };

  

  
  

  var faHelmetSafety = {
    prefix: 'fal',
    iconName: 'helmet-safety',
    icon: [
      576,
      512,
      ["hard-hat","hat-hard"],
      'f807',
      
      'M240 80l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-64-1.3l0 34.7C109.9 143.7 64 210.5 64 288l0 32-32 0 0-32c0-95.5 59.8-177.1 144-209.3zm224 34.7l0-34.7c83.5 31.9 143 112.4 144 206.9l0 2.4 0 32-32 0 0-34.3c-.9-76.5-46.5-142.3-112-172.3zM537.3 384L38.7 384c-3.7 0-6.7 3-6.7 6.7c0 .4 0 .7 .1 1C58.5 408.5 136.6 448 288 448s229.5-39.5 255.9-56.3c0-.2 .1-.6 .1-1c0-3.7-3-6.7-6.7-6.7zM38.7 352l498.5 0c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.4-13.9 27.3C531.3 437.9 447.1 480 288 480s-243.3-42.1-274.1-61.9C4.7 412.1 0 401.7 0 390.7C0 369.3 17.3 352 38.7 352z'
      
    ]
  };

  
    var faHardHat = faHelmetSafety;
  
    var faHatHard = faHelmetSafety;
  

  
  

  var faToiletPaper = {
    prefix: 'fal',
    iconName: 'toilet-paper',
    icon: [
      640,
      512,
      [129531],
      'f71e',
      
      'M16 479c.2-5.3 1.7-10.6 4.5-15.4c0 0 0 0 0-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192C64 86 107 0 160 0L464 0l32 0c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2c2.1-14.2 4.1-29.6 5.7-46c14.2 25.6 33 41.2 53.6 41.2c44.2 0 80-71.6 80-160s-35.8-160-80-160s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7c-.3 2.5-.5 4.9-.8 7.4c-9 82.3-25.6 133.1-36.3 158.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2c-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2c-5.7 49.5-17.3 100.7-41.6 144.8c-.2 .3-.4 .6-.5 .9c0 0 0 0 0 0l269.9 0c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6L160 32zM496 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faKaaba = {
    prefix: 'fal',
    iconName: 'kaaba',
    icon: [
      576,
      512,
      [128331],
      'f66b',
      
      'M544 112s0 0 0 0L288 192 32 112 288 32l256 80zM22.5 81.5C9.1 85.6 0 98 0 112L0 400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400l0-288c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zM544 191.2L292.8 269.7c-3.1 1-6.4 1-9.5 0L32 191.2l0-45.7 246.5 77c6.2 1.9 12.9 1.9 19.1 0l246.5-77 0 45.7zm0 33.5l0 30.5-20.8 6.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l11.2-3.5L544 400 288 480 32 400l0-111.2 11.2 3.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L32 255.2l0-30.5 241.7 75.5c9.3 2.9 19.3 2.9 28.6 0L544 224.8zm-427.2 57c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z'
      
    ]
  };

  

  
  

  var faSquareList = {
    prefix: 'fal',
    iconName: 'square-list',
    icon: [
      448,
      512,
      [],
      'e489',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fal',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      'M335.4 255.4c-10.9 25.9-26.2 54-43.6 82.1c-34.1 55.3-74.4 108.2-99.9 140c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1C37.4 229 32 207.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 15.6-5.4 37-16.6 63.4zM215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z'
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faTelescope = {
    prefix: 'fal',
    iconName: 'telescope',
    icon: [
      576,
      512,
      [128301],
      'e03e',
      
      'M447.1 35.7l96 166.3-89.2 51.5-96-166.3 89.2-51.5zM344 127.2l65.8 114-37.9 20.5C357.8 239.1 332.7 224 304 224c-44.2 0-80 35.8-80 80c0 12 2.7 23.5 7.4 33.7l-97 52.5c-.1 0-.1 0-.1 0s0 0 0 0c0 0-.1 0-.1 0s-.1 0-.1-.1c0 0 0 0 0 0l-.1-.1L79.5 295.6c0-.1 0-.1 0-.1s0 0 0 0c0 0 0-.1 0-.1s0-.1 .1-.1c0 0 0 0 0 0l.1-.1L344 127.2zm81.7 141.5l.5 .8c8.8 15.3 28.4 20.5 43.7 11.7l89.2-51.5c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L341.9 59.5c-14.1 8.2-19.7 25.5-13.5 40.1L62.6 268.4c-14.5 9.2-19.1 28.2-10.6 43l54.5 94.5c8.7 15 27.7 20.4 42.9 12.1l97-52.4L193.3 489.7c-3.5 8.1 .3 17.5 8.4 21s17.5-.3 21-8.4l52.9-123.5c8.8 3.3 18.4 5.2 28.4 5.2s19.6-1.8 28.4-5.2l52.9 123.5c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-55-128.3c15-14.5 24.3-34.9 24.3-57.4c0-4.2-.3-8.3-.9-12.3l42.6-23.1zM304 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM29.9 352.1c-4.4-7.7-14.2-10.3-21.8-6s-10.3 14.2-6 21.8l32 56c4.4 7.7 14.2 10.3 21.8 6s10.3-14.2 6-21.8l-32-56z'
      
    ]
  };

  

  
  

  var faObjectExclude = {
    prefix: 'fal',
    iconName: 'object-exclude',
    icon: [
      512,
      512,
      [],
      'e49c',
      
      'M64 32l224 0c17.7 0 32 14.3 32 32l0 64 32 0 0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-32-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zm96 352l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0 0 32 64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-64-32 0zm128-32c35.3 0 64-28.7 64-64l-32 0c0 17.7-14.3 32-32 32l-32 0 0 32 32 0zm64-160l0-32-32 0-32 0 0 32 32 0 0 64 32 0 0-64zM224 352l0-32-32 0 0-64-32 0 0 64 0 32 32 0 32 0zM160 224l32 0c0-17.7 14.3-32 32-32l32 0 0-32-32 0c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faPoop = {
    prefix: 'fal',
    iconName: 'poop',
    icon: [
      512,
      512,
      [],
      'f619',
      
      'M209.2 9.9c2.5-6 8.3-9.9 14.8-9.9l8 0c71.6 0 131 52.2 142.1 120.7C403.6 134.9 424 165 424 200c0 7.2-.9 14.3-2.5 21.1C455.6 233.2 480 265.7 480 304c0 16-4.3 31-11.7 43.9C494.4 363.2 512 391.5 512 424c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88c0-32.5 17.6-60.8 43.7-76.1C36.3 335 32 320 32 304c0-38.3 24.4-70.8 58.5-82.9C88.9 214.3 88 207.2 88 200c0-48.6 39.4-88 88-88l.9 0 17.8 0c20.6 0 37.3-16.7 37.3-37.3l0-8.9c0-12.3-4.9-24-13.5-32.7l-5.8-5.8c-4.6-4.6-5.9-11.5-3.5-17.4zM257.7 35c4.1 9.6 6.3 20.1 6.3 30.8l0 8.9c0 38.3-31 69.3-69.3 69.3l-17.8 0-.9 0c-30.9 0-56 25.1-56 56c0 9.1 2.2 17.7 6 25.2c2.4 4.7 2.3 10.2-.2 14.8s-7.1 7.7-12.3 8.3C85.7 251.6 64 275.3 64 304c0 15.3 6.2 29.2 16.2 39.4c4 4 5.5 9.9 4.1 15.4s-5.7 9.8-11.2 11.3c-23.7 6.5-41 28.3-41 54c0 30.9 25.1 56 56 56l336 0c30.9 0 56-25.1 56-56c0-25.7-17.4-47.4-41-54c-5.5-1.5-9.7-5.8-11.2-11.3s.1-11.3 4.1-15.4c10-10.1 16.2-24 16.2-39.4c0-28.7-21.7-52.4-49.5-55.6c-5.2-.6-9.8-3.7-12.3-8.3s-2.6-10.1-.2-14.8c3.8-7.6 6-16.1 6-25.2c0-24.5-15.8-45.4-37.8-53c-5.9-2-10.1-7.4-10.7-13.6C339 85.1 303.8 45.8 257.7 35z'
      
    ]
  };

  

  
  

  var faHandPointRibbon = {
    prefix: 'fal',
    iconName: 'hand-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a6',
      
      'M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8-48 0 0-8zM96 64L32 64c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1l64 0 0 80c-19.4 14.6-32 37.8-32 64l0 32c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-48 0-32 0-24c0-30.9-25.1-56-56-56c-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-9.7 0-18.8 2.5-26.7 6.8C278 160.3 256.9 144 232 144c-8.6 0-16.7 1.9-24 5.4L208 80l0-24c0-30.9-25.1-56-56-56S96 25.1 96 56l0 8zm80 32l0 48L65.3 144l11.2-14c4.7-5.8 4.7-14.1 0-20L65.3 96 176 96zm0 80l0 24 0 40-32 0c-5.5 0-10.8 .6-16 1.6l0-65.6 48 0zm0 96s0 0 0 0l32 0s0 0 0 0l24 0c13.2 0 24 10.7 24 24c0 0 0 0 0 0c0 13.3-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c13.8 0 26.4-5 36.1-13.2C358.4 351.7 374.2 360 392 360c8.6 0 16.7-1.9 24-5.4C414.6 424.1 357.8 480 288 480l-64 0c-70.7 0-128-57.3-128-128l0-32c0-26.5 21.5-48 48-48l32 0zm32-32l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 31.9c0 0 0 0 0 .1l0 13.4c-7.3-3.5-15.4-5.4-24-5.4l-24 0zm80 32l0-40c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24l0 16 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24c0 0 0 0 0 0l0-24zm128 0l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24z'
      
    ]
  };

  

  
  

  var faAlien8bit = {
    prefix: 'fal',
    iconName: 'alien-8bit',
    icon: [
      576,
      512,
      [128126,"alien-monster"],
      'f8f6',
      
      'M128 32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32-64 0 0-16c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32L0 288c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7 14.3 32 32 32l80 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l80 0c17.7 0 32-14.3 32-32l0-64 32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-144c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 16-64 0 0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32l0 32-64 0 0-32c0-17.7-14.3-32-32-32l-32 0c0-17.7-14.3-32-32-32l-32 0zM480 192l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-32 32 0 0 144-48 0c-8.8 0-16 7.2-16 16l0 48-48 0-64 0-160 0-64 0-48 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-144 32 0 0 32 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 80 0c8.8 0 16-7.2 16-16l0-64 0-16 32 0 0 48c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-48 32 0 0 16 0 64c0 8.8 7.2 16 16 16l80 0zM128 96l0-32 32 0 0 16 0 16-32 0zm320 0l-32 0 0-16 0-16 32 0 0 32zM160 448l0-64 32 0 0 16c0 8.8 7.2 16 16 16l32 0 0 32-80 0zm224-48l0-16 32 0 0 64-80 0 0-32 32 0c8.8 0 16-7.2 16-16zM224 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z'
      
    ]
  };

  
    var faAlienMonster = faAlien8bit;
  

  
  

  var faCircleArrowDownRight = {
    prefix: 'fal',
    iconName: 'circle-arrow-down-right',
    icon: [
      512,
      512,
      [],
      'e0fa',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM200 352l136 0c8.8 0 16-7.2 16-16l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 105.4L187.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 320 200 320c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faFaceDisguise = {
    prefix: 'fal',
    iconName: 'face-disguise',
    icon: [
      512,
      512,
      [],
      'e370',
      
      'M480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-16.5 1.8-32.5 5.2-48L72 208c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8l0 25.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-25.2c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6l34.8 0c3.4 15.5 5.2 31.5 5.2 48zM218 229.5l-21.4 35.7c-1.1 .6-1.9 1-2.6 1.3c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 2.5-.1 4.9-.4 7.3c-5.4 3.6-10.1 8.4-13.5 14.1zm75.9 0c-3.5-5.8-8.1-10.6-13.5-14.1c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-.6-.3-1.5-.7-2.6-1.3L294 229.5zM465.3 176l-30.8 0c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-3.5 7c-4.6-2-9.3-3.6-14.2-4.9l0-19c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16.3c-4.4 .4-8.7 1-13 2l-4.7-9.5c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1c-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-4.7 9.5c-4.2-.9-8.6-1.6-13-2L176 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l5.2 10.3C91.5 148 82.7 161.1 77.5 176l-30.8 0C78.9 91.8 160.5 32 256 32s177.1 59.8 209.3 144zm34.1 .4C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c3.3-2.9 5.3-7.2 5.3-11.9c0-7.7-5.4-14.1-12.6-15.6zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4L245.5 246c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faObjectUngroup = {
    prefix: 'fal',
    iconName: 'object-ungroup',
    icon: [
      640,
      512,
      [],
      'f248',
      
      'M0 64c0 29.8 20.4 54.9 48 62l0 100c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64c29.8 0 54.9-20.4 62-48l196 0c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-100c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-29.8 0-54.9 20.4-62 48L126 48C118.9 20.4 93.8 0 64 0C28.7 0 0 28.7 0 64zM322 80c5.8 22.5 23.5 40.2 46 46l0 100c-22.5 5.8-40.2 23.5-46 46l-196 0c-5.8-22.5-23.5-40.2-46-46l0-100c22.5-5.8 40.2-23.5 46-46l196 0zM480 208l-16 0 0 32 16 0 34 0c5.8 22.5 23.5 40.2 46 46l0 100c-22.5 5.8-40.2 23.5-46 46l-196 0c-5.8-22.5-23.5-40.2-46-46l0-34 0-16-32 0 0 16 0 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64c29.8 0 54.9-20.4 62-48l196 0c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-100c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-29.8 0-54.9 20.4-62 48l-34 0zm96 48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM544 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faFaceGrinBeam = {
    prefix: 'fal',
    iconName: 'face-grin-beam',
    icon: [
      512,
      512,
      [128516,"grin-beam"],
      'f582',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zm-242.4-135c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faGrinBeam = faFaceGrinBeam;
  

  
  

  var faBuildingFlag = {
    prefix: 'fal',
    iconName: 'building-flag',
    icon: [
      640,
      512,
      [],
      'e4d5',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zm-96 96l-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-64 0-32 0-64 0-32 0zM64 120c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zM248 96l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zM64 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zm152-32l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zM432 0c8.8 0 16 7.2 16 16l0 16 160 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0 0 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-272 0-32 0-128 0-32 0-16c0-8.8 7.2-16 16-16zm16 192l160 0 0-128L448 64l0 128z'
      
    ]
  };

  

  
  

  var faCircleQ = {
    prefix: 'fal',
    iconName: 'circle-q',
    icon: [
      512,
      512,
      [],
      'e11e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l-50.9-50.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l50.9 50.9C295.9 345.4 276.7 352 256 352c-53 0-96-43-96-96zm224 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c29.6 0 56.8-10 78.5-26.9l22.2 22.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-22.2-22.2C374 312.8 384 285.6 384 256z'
      
    ]
  };

  

  
  

  var faFishFins = {
    prefix: 'fal',
    iconName: 'fish-fins',
    icon: [
      576,
      512,
      [],
      'e4f2',
      
      'M247.8 148c13.4-6.2 20.8-20.8 17.9-35.3L256 64l77.6 58.2c4.9 3.7 10.8 5.9 16.9 6.3c47.2 3.4 88 23.2 120.3 47.5c35.5 26.7 60.8 58.7 73.2 80c-12.4 21.3-37.6 53.3-73.2 80c-32.3 24.2-73.1 44.1-120.3 47.5c-6.1 .4-12 2.6-16.9 6.3L256 448l9.7-48.6c2.9-14.5-4.5-29.1-17.9-35.3c-17.1-7.9-32.7-17.6-46.6-28c-13.8-10.4-26.1-21.6-36.8-32.8c-10.2-10.7-26.5-13-39.3-5.5L32 352l45.8-80.1c5.6-9.8 5.6-21.9 0-31.8L32 160l93.1 54.3c12.8 7.5 29 5.2 39.3-5.5c10.7-11.2 23-22.4 36.8-32.8c13.9-10.5 29.6-20.2 46.6-28zM9.5 137.3C-.8 147.5-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFileContract = {
    prefix: 'fal',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm54.2 253.8L144 349l16.7 55.6c1.7 5.8 6.6 10.1 12.5 11.2s12-1.3 15.6-6.2l17.6-23.4c1-1.4 2.7-2.2 4.4-2.2c2.1 0 4 1.2 4.9 3l10.1 20.1c2.7 5.4 8.3 8.8 14.3 8.8l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-54.1 0-5.6-11.3C237.9 360 224.9 352 210.7 352c-11 0-21.4 4.8-28.5 13.1l-12.6-42.1C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4L80 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l8.2 0c21.2 0 39.9-13.9 46-34.2z'
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fal',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3L172.5 336l-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9L192 363.9l42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z'
      
    ]
  };

  

  
  

  var faFileXls = {
    prefix: 'fal',
    iconName: 'file-xls',
    icon: [
      512,
      512,
      [],
      'e64d',
      
      'M64 480l80 0 0 32-80 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM224 368c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L259.2 432l17.2 25.8C284 469.1 288 482.4 288 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L240 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L220.8 432l-17.2-25.8C196 394.9 192 381.6 192 368c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 128l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16zm88-98.3c0-25.2 20.4-45.7 45.7-45.7l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L432 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l26.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7z'
      
    ]
  };

  

  
  

  var faSackXmark = {
    prefix: 'fal',
    iconName: 'sack-xmark',
    icon: [
      512,
      512,
      [],
      'e56a',
      
      'M310.5 144l-109 0-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32 156.9 32l48.4 70.2 6.7 9.8 87.8 0 6.7-9.8zM0 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 121.9 37.6C111 21.7 122.4 0 141.7 0L370.3 0c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96zM256 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 297.4z'
      
    ]
  };

  

  
  

  var faClockEight = {
    prefix: 'fal',
    iconName: 'clock-eight',
    icon: [
      512,
      512,
      [],
      'e345',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 144c0 5.3-2.7 10.3-7.1 13.3l-96 64c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2L240 247.4 240 112c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBoltLightning = {
    prefix: 'fal',
    iconName: 'bolt-lightning',
    icon: [
      384,
      512,
      [],
      'e0b7',
      
      'M32 30.9C32 13.8 45.9 0 62.9 0L226.2 0C242.7 0 256 13.3 256 29.8c0 3.2-.5 6.4-1.5 9.4L214.2 160l141.6 0c15.6 0 28.2 12.6 28.2 28.2c0 5.7-1.7 11.2-4.9 15.9l-203.2 297c-4.6 6.8-12.3 10.8-20.5 10.8c-16.2 0-28-15.2-24.1-30.9L179.5 288 30.9 288C13.9 288 0 274.1 0 257.1c0-1.5 .1-2.9 .3-4.4L32 30.9zM64 32c0 1.1-.1 2.2-.3 3.3L32.2 256 200 256c4.9 0 9.6 2.3 12.6 6.2s4.1 8.9 2.9 13.7L171.9 450.2 348.6 192 192 192c-5.1 0-10-2.5-13-6.6s-3.8-9.5-2.2-14.4L223.1 32 64 32z'
      
    ]
  };

  

  
  

  var faChartPie = {
    prefix: 'fal',
    iconName: 'chart-pie',
    icon: [
      576,
      512,
      ["pie-chart"],
      'f200',
      
      'M511.3 208L336 208l0-175.3c93.3 7.7 167.6 82.1 175.3 175.3zM320 240l208.5 0c8.4 0 15.4-6.5 15.5-14.9l0-1.1C544 100.3 443.7 0 320 0l-1.1 0C310.5 0 304 7.1 304 15.5L304 224c0 8.8 7.2 16 16 16zm-86.6 70.6L375.3 452.6C344.9 470 309.6 480 272 480C157.1 480 64 386.9 64 272c0-98.3 68.3-180.8 160-202.4L224 288c0 8.5 3.4 16.6 9.4 22.6zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288l0-238.4c0-9.2-7.8-16.6-17-15.4zM489.6 412.3L397.3 320l141.2 0c-8.3 35-25.4 66.6-48.9 92.3zM573.8 305c1.3-9.2-6.1-17-15.4-17l-199.8 0c-14.3 0-21.4 17.2-11.3 27.3L478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3z'
      
    ]
  };

  
    var faPieChart = faChartPie;
  

  
  

  var faPersonCirclePlus = {
    prefix: 'fal',
    iconName: 'person-circle-plus',
    icon: [
      576,
      512,
      [],
      'e541',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91L224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faTaxi = {
    prefix: 'fal',
    iconName: 'taxi',
    icon: [
      512,
      512,
      [128662,"cab"],
      'f1ba',
      
      'M192 48l0 16 128 0 0-16c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM160 64l0-16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 16 .4 0c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 253.2 512 284.3 512 320l0 96 0 16 0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 448l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16 0-16 0-96c0-35.7 19.4-66.8 48.3-83.3l.4-1.3L83 121c10.2-33.8 41.3-57 76.6-57l.4 0zm-.4 32c-21.2 0-39.9 13.9-46 34.2L85.3 224.6c3.5-.4 7.1-.6 10.7-.6l320 0c3.6 0 7.2 .2 10.7 .6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2L159.6 96zM74.7 259.9l-.5-.1C49.6 268.7 32 292.3 32 320l0 96 448 0 0-96c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6L96 256c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faCab = faTaxi;
  

  
  

  var faRoad = {
    prefix: 'fal',
    iconName: 'road',
    icon: [
      576,
      512,
      [128739],
      'f018',
      
      'M185.6 32c-26.9 0-50.9 16.8-60.1 42L8.5 394c-15.3 41.8 15.7 86 60.1 86l438.7 0c44.5 0 75.4-44.2 60.1-86L450.5 74c-9.2-25.2-33.2-42-60.1-42L185.6 32zM155.5 85c4.6-12.6 16.6-21 30.1-21L272 64l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 86.4 0c13.4 0 25.4 8.4 30.1 21L537.4 405c7.6 20.9-7.8 43-30.1 43L304 448l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L68.6 448c-22.2 0-37.7-22.1-30.1-43L155.5 85zM304 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  

  
  

  var faBedBunk = {
    prefix: 'fal',
    iconName: 'bed-bunk',
    icon: [
      576,
      512,
      [],
      'f8f8',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 176 0 431.7 0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48.3 208 0 304 0 0 48.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64.3L576 272l0-96 0-64C576 50.1 525.9 0 464 0L256 0c-17.7 0-32 14.3-32 32l0 128L32 160 32 16zM224 288l0 127.7-192 0L32 192l208 0 304 0 0 64-288 0c-17.7 0-32 14.3-32 32zM544 112l0 48-288 0 0-128 208 0c44.2 0 80 35.8 80 80zM256 288l288 0 0 127.7-288 0L256 288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faLeaf = {
    prefix: 'fal',
    iconName: 'leaf',
    icon: [
      512,
      512,
      [],
      'f06c',
      
      'M132 238.3c23.6-9.3 49.2-14.3 76-14.3l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-28.8 0-56 6.9-80 19.2C129.7 353.2 193.5 416 272 416c0 0 0 0 0 0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128l-104 0c-67.9 0-124.9 47-140 110.3zM96.7 256.3C104.7 166.4 180.1 96 272 96l104 0c35.2 0 66.6-16.2 87.2-41.7l.6-.8c2.3-2.9 4.4-5.8 6.4-8.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6s2.3 7.1 3.4 10.8l.4 1.5c8.8 30.3 13.5 62.8 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-89.4 0-163.2-66.7-174.5-153C57.5 327.3 32 376.7 32 432l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-73.9 38.6-138.9 96.7-175.7z'
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fal',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      'M48 32C21.5 32 0 53.5 0 80L0 248 0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 240 32 80c0-8.8 7.2-16 16-16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 32z'
      
    ]
  };

  

  
  

  var faCloudPlus = {
    prefix: 'fal',
    iconName: 'cloud-plus',
    icon: [
      640,
      512,
      [],
      'e35e',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm32 352l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faAustralSign = {
    prefix: 'fal',
    iconName: 'austral-sign',
    icon: [
      448,
      512,
      [],
      'e0a9',
      
      'M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L132.2 224 16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l102.6 0L91.6 320 16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l62 0L33.3 457.8c-3.4 8.1 .4 17.5 8.5 21s17.5-.4 21-8.5l50-118.2 222.5 0 50 118.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21L370 352l62 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-75.5 0-27.1-64L432 256c8.8 0 16-7.2 16-16s-7.2-16-16-16l-116.2 0L238.7 41.8zM281.1 224l-114.2 0L224 89.1 281.1 224zM153.4 256l141.3 0 27.1 64-195.4 0 27.1-64z'
      
    ]
  };

  

  
  

  var faChessKnightPiece = {
    prefix: 'fal',
    iconName: 'chess-knight-piece',
    icon: [
      320,
      512,
      ["chess-knight-alt"],
      'f442',
      
      'M53.3 96l80.4 0C210.1 96 272 157.9 272 234.3c0 12.7-1.7 25.3-5.2 37.5L244.3 352l33.2 0 20.1-71.5c4.2-15 6.4-30.6 6.4-46.2C304 140.3 227.7 64 133.7 64L45.3 64c-16 0-28.9 12.9-28.9 28.9c0 8.2 3.5 16 9.6 21.5l7.7 6.9c-11.1 14-17.3 31.5-17.3 49.5l-.2 65.1c-.1 26.9 17.6 49.7 42.1 57.3c-6.3 11.7-9.8 25-9.8 38.7L48.2 352l32 0 .2-19.8s0 0 0 0l0-.2c0-15.6 7.4-30.3 19.9-39.7l76.1-46.7c7.5-4.6 9.9-14.5 5.3-22s-14.5-9.9-22-5.3l-36.5 22.4c-1.2 .4-2.3 .9-3.4 1.5L90.3 260c-4.4 2.6-9.4 4-14.5 4c-15.3-.1-27.7-12.6-27.7-27.9l.2-65.1c0-11.7 4.3-23 12.1-31.7l7.6-8.6c5.8-6.6 5.3-16.6-1.3-22.5L53.3 96zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM65.8 416l188.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L39.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L65.8 416zm188.4-32L65.8 384c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512l241.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z'
      
    ]
  };

  
    var faChessKnightAlt = faChessKnightPiece;
  

  
  

  var faPie = {
    prefix: 'fal',
    iconName: 'pie',
    icon: [
      576,
      512,
      [129383],
      'f705',
      
      'M288 80c-94.5 0-176.3 54.6-215.4 134.1c-4.7 9.5-12.3 17.9-22.5 22.9l-9.3 4.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l39.4-19.7c11.8-5.9 25.5-6.7 37.9-2.2l34.8 12.7c21.2 7.7 44.4 7.7 65.6 0L271.6 247c10.6-3.9 22.2-3.9 32.8 0l38.8 14.1c21.2 7.7 44.4 7.7 65.6 0l34.8-12.7c12.4-4.5 26.1-3.7 37.9 2.2l39.4 19.7c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-9.3-4.6c-10.2-5.1-17.8-13.4-22.5-22.9C464.3 134.6 382.5 80 288 80zM43.8 200C88.2 110 180.8 48 288 48s199.8 62 244.2 152c1.9 3.9 4.8 6.8 8.1 8.5l9.3 4.6c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5l-39.4-19.7c-3.9-2-8.5-2.2-12.6-.7l-34.8 12.7c-28.3 10.3-59.2 10.3-87.5 0l-38.8-14.1c-3.5-1.3-7.4-1.3-10.9 0l-38.8 14.1c-28.3 10.3-59.2 10.3-87.5 0l-34.8-12.7c-4.1-1.5-8.7-1.2-12.6 .7L69.5 298.9c-23.7 11.9-52.5 2.2-64.4-21.5s-2.2-52.5 21.5-64.4l9.3-4.6c3.2-1.6 6.1-4.5 8.1-8.5zM58.5 335.4c11.4-.9 22-3 31.8-5.8l23.3 69.9c3.3 9.8 12.4 16.4 22.8 16.4l303.3 0c10.3 0 19.5-6.6 22.8-16.4l23.3-69.9c9.8 2.8 20.4 4.8 31.8 5.8l-24.8 74.3c-7.6 22.9-29 38.3-53.1 38.3l-303.3 0c-24.1 0-45.5-15.4-53.1-38.3L58.5 335.4zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSquareEllipsis = {
    prefix: 'fal',
    iconName: 'square-ellipsis',
    icon: [
      448,
      512,
      [],
      'e26e',
      
      'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM200 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm168-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faVirusCovid = {
    prefix: 'fal',
    iconName: 'virus-covid',
    icon: [
      512,
      512,
      [],
      'e4a8',
      
      'M216 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 40.7c-38.8 3.3-74.1 18.7-102.3 42.4L108.9 86.3s0 0 0 0l17-17c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L46.7 103.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17-17s0 0 0 0l28.8 28.8C91.4 165.9 76 201.2 72.7 240L32 240l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24 40.7 0c3.3 38.8 18.7 74.1 42.4 102.3L86.3 403.1s0 0 0 0l-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17s0 0 0 0l28.8-28.8c28.2 23.7 63.5 39 102.3 42.4l0 40.7-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-40.7c38.8-3.3 74.1-18.7 102.3-42.4l28.8 28.8s0 0 0 0l-17 17c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-17 17s0 0 0 0l-28.8-28.8c23.7-28.2 39-63.5 42.4-102.3l40.7 0 0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24-40.7 0c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8s0 0 0 0l17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L408.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17s0 0 0 0l-28.8 28.8C346.1 91.4 310.8 76 272 72.7L272 32l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L216 0zm40 104a152 152 0 1 1 0 304 152 152 0 1 1 0-304zM192 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faImagePolaroidUser = {
    prefix: 'fal',
    iconName: 'image-polaroid-user',
    icon: [
      448,
      512,
      [],
      'e1b6',
      
      'M336 384l-32 0-160 0-32 0-80 0 0 32c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-32-80 0zm-1.6-32l81.6 0 0-256c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 256 81.6 0c7.4-36.5 39.7-64 78.4-64l32 0 32 0c38.7 0 71 27.5 78.4 64zm-187.7 0l154.5 0c-6.6-18.6-24.4-32-45.3-32l-64 0c-20.9 0-38.7 13.4-45.3 32zM448 96l0 256 0 16 0 16 0 32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-32 0-16 0-16L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64zM256 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faWonSign = {
    prefix: 'fal',
    iconName: 'won-sign',
    icon: [
      512,
      512,
      [8361,"krw","won"],
      'f159',
      
      'M31.3 43.3c-2.6-8.4-11.6-13.2-20-10.6S-1.9 44.3 .7 52.7L63.3 256 16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.1 0 55.6 180.7c2.1 6.8 8.4 11.4 15.6 11.3s13.3-5 15.2-11.8L208 288l96.1 0 48.5 180.2c1.9 6.9 8 11.7 15.2 11.8s13.5-4.5 15.6-11.3L438.9 288l57.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-47.3 0L511.3 52.7c2.6-8.4-2.1-17.4-10.6-20s-17.4 2.1-20 10.6L415.3 256l-86.7 0L271.5 43.8c-1.9-7-8.2-11.8-15.4-11.8s-13.6 4.9-15.4 11.8L183.4 256l-86.7 0L31.3 43.3zM106.6 288l68.2 0L143 406.3 106.6 288zm110-32L256 109.5 295.4 256l-78.9 0zm120.6 32l68.2 0L369 406.3 337.2 288z'
      
    ]
  };

  
    var faKrw = faWonSign;
  
    var faWon = faWonSign;
  

  
  

  var faImagesUser = {
    prefix: 'fal',
    iconName: 'images-user',
    icon: [
      576,
      512,
      [],
      'e1b9',
      
      'M512 64L160 64c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l64 0 0-16c0-44.2 35.8-80 80-80l32 0 32 0c44.2 0 80 35.8 80 80l0 16 64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM448 384l-32 0-160 0-32 0-64 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-64 0zm-32-32l0-16c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 16 160 0zM16 96c8.8 0 16 7.2 16 16l0 240c0 53 43 96 96 96l336 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-336 0C57.3 480 0 422.7 0 352L0 112c0-8.8 7.2-16 16-16zm352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM336 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faCubesStacked = {
    prefix: 'fal',
    iconName: 'cubes-stacked',
    icon: [
      448,
      512,
      [],
      'e4e6',
      
      'M288 64l-64 0 0 64 64 0 0-64zM224 32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM98.7 234.7l32 55.4 55.4-32-32-55.4-55.4 32zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM352 224l-64 0 0 64 64 0 0-64zm-96 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm96 224l64 0 0-64-64 0 0 64zm-32-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm-64 0l-64 0 0 64 64 0 0-64zm-64-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM32 384l0 64 64 0 0-64-64 0zM0 384c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fal',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l121.4 0L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6 480 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L336 0zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faMagnifyingGlassChart = {
    prefix: 'fal',
    iconName: 'magnifying-glass-chart',
    icon: [
      512,
      512,
      [],
      'e522',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM128 224l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64-96l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 64l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faMobileNotch = {
    prefix: 'fal',
    iconName: 'mobile-notch',
    icon: [
      384,
      512,
      ["mobile-iphone"],
      'e1ee',
      
      'M256 32l0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32l-32 0zm-32 0l-64 0 0 16 64 0 0-16zM32 64C32 28.7 60.7 0 96 0L288 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64z'
      
    ]
  };

  
    var faMobileIphone = faMobileNotch;
  

  
  

  var faClothesHanger = {
    prefix: 'fal',
    iconName: 'clothes-hanger',
    icon: [
      640,
      512,
      [],
      'e136',
      
      'M212.2 85.8C220.4 36.3 263.2 0 313.4 0C370.1 0 416 45.9 416 102.6l0 8.1c0 36.1-17.6 70-47.2 90.7l-20.7 14.5L612.5 396.8C629.7 408.5 640 428 640 448.9c0 34.9-28.3 63.1-63.1 63.1L63.1 512C28.3 512 0 483.7 0 448.9c0-20.8 10.3-40.3 27.5-52.1L310.9 202.8l39.5-27.7c21-14.7 33.6-38.8 33.6-64.5l0-8.1c0-39-31.6-70.6-70.6-70.6c-34.5 0-64 25-69.7 59l-3.9 23.6c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l3.9-23.6zM320 235.4L45.6 423.2C37.1 429 32 438.6 32 448.9C32 466.1 45.9 480 63.1 480l513.7 0c17.2 0 31.1-13.9 31.1-31.1c0-10.3-5.1-19.9-13.6-25.7L320 235.4z'
      
    ]
  };

  

  
  

  var faBuildingCircleExclamation = {
    prefix: 'fal',
    iconName: 'building-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4d3',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 202.8c9.1-12.9 19.9-24.5 32-34.6L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm152-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faMoonStars = {
    prefix: 'fal',
    iconName: 'moon-stars',
    icon: [
      512,
      512,
      [],
      'f755',
      
      'M304 0c8.8 0 16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16zM156.6 163.9C85.3 180 32 243.8 32 320.2c0 88.5 71.6 160.2 159.8 160.2c25.7 0 50-6.1 71.5-16.9c-87.6-11.3-155.1-86.4-155.1-177.2c0-47.4 18.4-90.4 48.4-122.4zM0 320.2C0 214.1 85.8 128 191.8 128c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.2c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4C85.8 512.4 0 426.3 0 320.2zM432 160l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faWhiskeyGlass = {
    prefix: 'fal',
    iconName: 'whiskey-glass',
    icon: [
      512,
      512,
      [129347,"glass-whiskey"],
      'f7a0',
      
      'M32 64L60 256l392 0L480 64 32 64zM64.7 288L82 406.9c3.4 23.6 23.7 41.1 47.5 41.1l253 0c23.8 0 44.1-17.5 47.5-41.1L447.3 288 64.7 288zM7.8 43.1C13.9 36 22.7 32 32 32l448 0c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5l-253 0c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z'
      
    ]
  };

  
    var faGlassWhiskey = faWhiskeyGlass;
  

  
  

  var faCode = {
    prefix: 'fal',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      'M405.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480c2.8-8.4-1.7-17.4-10.1-20.2zM172 117.4c-5.9-6.6-16-7.2-22.6-1.3l-144 128C2 247.1 0 251.4 0 256s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L40.1 256 170.6 140c6.6-5.9 7.2-16 1.3-22.6zm296.1 0c-5.9 6.6-5.3 16.7 1.3 22.6L599.9 256 469.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128c-6.6-5.9-16.7-5.3-22.6 1.3z'
      
    ]
  };

  

  
  

  var faFileExclamation = {
    prefix: 'fal',
    iconName: 'file-exclamation',
    icon: [
      384,
      512,
      [],
      'f31a',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM192 224c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16zm24 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faStarHalfStroke = {
    prefix: 'fal',
    iconName: 'star-half-stroke',
    icon: [
      576,
      512,
      ["star-half-alt"],
      'f5c0',
      
      'M202.4 186.5L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2 272 408.1l0-333-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM304 408.2l121.6 65L402.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L373.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L304 75.4l0 332.8zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z'
      
    ]
  };

  
    var faStarHalfAlt = faStarHalfStroke;
  

  
  

  var faMoneyCheck = {
    prefix: 'fal',
    iconName: 'money-check',
    icon: [
      576,
      512,
      [],
      'f53c',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm112 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zM360 176c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-80 0zm-40 8c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-80 0c-22.1 0-40-17.9-40-40l0-48z'
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fal',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M169.1 17.3C183.8 6.3 203.2 0 224 0s40.2 6.3 54.9 17.3S304 44.6 304 64c0 19.5-10.6 35.9-25.3 46.8c-5.2 3.8-6.7 7.7-6.7 10c0 4 3.2 7.2 7.2 7.2l56.8 0c26.5 0 48 21.5 48 48l0 56.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7c11-14.7 27.4-25.3 46.8-25.3c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-21.6 0-39.2-17.5-39.2-39.2c0-16.2 9.9-28.4 19.6-35.6c8.6-6.4 12.4-14.1 12.4-21.2c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1c0 7.1 3.8 14.8 12.4 21.2c9.7 7.2 19.6 19.4 19.6 35.6c0 21.7-17.5 39.2-39.2 39.2L48 512c-26.5 0-48-21.5-48-48L0 343.2C0 321.5 17.5 304 39.2 304c16.2 0 28.4 9.9 35.6 19.6C81.2 332.2 88.9 336 96 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7S103.1 240 96 240c-7.1 0-14.8 3.8-21.2 12.4C67.6 262.1 55.4 272 39.2 272C17.5 272 0 254.5 0 232.8L0 176c0-26.5 21.5-48 48-48l120.8 0c4 0 7.2-3.2 7.2-7.2c0-2.3-1.6-6.1-6.7-10C154.6 99.9 144 83.5 144 64c0-19.4 10.5-35.8 25.1-46.7zm19.2 25.6C179.8 49.3 176 56.9 176 64c0 7.1 3.8 14.8 12.4 21.2c9.7 7.2 19.6 19.4 19.6 35.6c0 21.6-17.5 39.2-39.2 39.2L48 160c-8.8 0-16 7.2-16 16l0 56.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7C60.1 218.6 76.5 208 96 208c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9S115.4 368 96 368c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2L32 464c0 8.8 7.2 16 16 16l120.8 0c4 0 7.2-3.2 7.2-7.2c0-2.3-1.6-6.1-6.7-10c-14.7-11-25.3-27.4-25.3-46.8c0-19.4 10.5-35.8 25.1-46.7s34.1-17.3 54.9-17.3s40.2 6.3 54.9 17.3s25.1 27.3 25.1 46.7c0 19.5-10.6 35.9-25.3 46.8c-5.2 3.8-6.7 7.7-6.7 10c0 4 3.2 7.2 7.2 7.2l56.8 0c8.8 0 16-7.2 16-16l0-120.8c0-21.7 17.5-39.2 39.2-39.2c16.2 0 28.4 9.9 35.6 19.6c6.4 8.6 14.1 12.4 21.2 12.4c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-7.1 0-14.8 3.8-21.2 12.4c-7.2 9.7-19.4 19.6-35.6 19.6c-21.7 0-39.2-17.5-39.2-39.2l0-56.8c0-8.8-7.2-16-16-16l-56.8 0c-21.6 0-39.2-17.5-39.2-39.2c0-16.2 9.9-28.4 19.6-35.6C268.2 78.8 272 71.1 272 64c0-7.1-3.8-14.7-12.3-21.1S238.5 32 224 32s-27.1 4.4-35.7 10.9z'
      
    ]
  };

  

  
  

  var faTrainTrack = {
    prefix: 'fal',
    iconName: 'train-track',
    icon: [
      576,
      512,
      [],
      'e453',
      
      'M207.1 53.2c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L158.5 96 112 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l35.4 0-33.2 96L72 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l31.1 0L69.8 352 32 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l26.8 0L32.9 458.8c-2.9 8.3 1.5 17.5 9.9 20.4s17.5-1.5 20.4-9.9L92.6 384l390.8 0 29.5 85.2c2.9 8.4 12 12.8 20.4 9.9s12.8-12 9.9-20.4L517.2 384l26.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-37.8 0-33.2-96 31.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-42.1 0-33.2-96 35.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-46.5 0L399.1 42.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4L383.7 96 192.3 96l14.8-42.8zM181.2 128l213.5 0L428 224l-280 0 33.2-96zM472.3 352l-368.6 0 33.2-96 302.1 0 33.2 96z'
      
    ]
  };

  

  
  

  var faArrowUpSmallBig = {
    prefix: 'fal',
    iconName: 'arrow-up-small-big',
    icon: [
      576,
      512,
      ["sort-size-up-alt"],
      'f88f',
      
      'M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6 176 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-377.4L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 80l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zm32 352c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16l0 128zm-32 0l0-128c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48z'
      
    ]
  };

  
    var faSortSizeUpAlt = faArrowUpSmallBig;
  

  
  

  var faHandHoldingHeart = {
    prefix: 'fal',
    iconName: 'hand-holding-heart',
    icon: [
      576,
      512,
      [],
      'f4be',
      
      'M163.9 28.9C191.7 .7 235.8-.8 265.3 24.3c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9C340.2-.8 384.3 .7 412.1 28.9c29.4 29.8 29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L288 217.3 389.3 114.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0L299.4 80.9c-6.3 6.4-16.5 6.4-22.8 0L247.5 51.4zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  

  
  

  var faHouseChimneyUser = {
    prefix: 'fal',
    iconName: 'house-chimney-user',
    icon: [
      576,
      512,
      [],
      'e065',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3 512 56c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24l0 23.4L298.6 4zM416 107.6L416 64l64 0 0 100.1-64-56.5zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM248 352l80 0c22.1 0 40 17.9 40 40l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-39.8-32.2-72-72-72l-80 0c-39.8 0-72 32.2-72 72l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-22.1 17.9-40 40-40z'
      
    ]
  };

  

  
  

  var faDryerHeat = {
    prefix: 'fal',
    iconName: 'dryer-heat',
    icon: [
      448,
      512,
      ["dryer-alt"],
      'f862',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 304a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304zm115.3-75.3l4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm80 0l4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faDryerAlt = faDryerHeat;
  

  
  

  var faUpDownLeftRight = {
    prefix: 'fal',
    iconName: 'up-down-left-right',
    icon: [
      512,
      512,
      ["arrows-alt"],
      'f0b2',
      
      'M252.9 33.4L196 96 316 96 259.1 33.4c-.8-.9-1.9-1.4-3.1-1.4s-2.3 .5-3.1 1.4zm29.8-21.5l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8L272 128l0 112 112 0 0 32-112 0 0 112 51.2 0c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8l51.2 0 0-112-112 0 0 51.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 51.2 112 0 0-112-51.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM316 416L196 416l56.9 62.6c.8 .9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4L316 416zM478.6 259.1c.9-.8 1.4-1.9 1.4-3.1s-.5-2.3-1.4-3.1L416 196 416 316l62.6-56.9zm-46.4 85.4c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8l0-134.3c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM33.4 252.9c-.9 .8-1.4 1.9-1.4 3.1s.5 2.3 1.4 3.1L96 316 96 196 33.4 252.9z'
      
    ]
  };

  
    var faArrowsAlt = faUpDownLeftRight;
  

  
  

  var faToggleLargeOn = {
    prefix: 'fal',
    iconName: 'toggle-large-on',
    icon: [
      576,
      512,
      [],
      'e5b1',
      
      'M416 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm0 288l-256 0C71.6 416 0 344.4 0 256S71.6 96 160 96l256 0c88.4 0 160 71.6 160 160s-71.6 160-160 160zm-96-32c-38.9-29.2-64-75.7-64-128s25.1-98.8 64-128l-160 0C89.3 128 32 185.3 32 256s57.3 128 128 128l160 0z'
      
    ]
  };

  

  
  

  var faFileSignature = {
    prefix: 'fal',
    iconName: 'file-signature',
    icon: [
      576,
      512,
      [],
      'f573',
      
      'M320 480c17.7 0 32-14.3 32-32l0-10.7 23.8-5.9c2.8-.7 5.6-1.6 8.2-2.7l0 19.3c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 39.8-32 32 0-43.6-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0zM240 160l111.5 0c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16zM144 349l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l12.6 42.1c7.1-8.3 17.5-13.1 28.5-13.1c14.2 0 27.2 8 33.5 20.7l5.6 11.3 41.7 0 15.7-62.6c2.1-8.4 6.5-16.1 12.6-22.3L473.5 145.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 384.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-2 .5-4.1 .6-6.1 .3L240 416c-6.1 0-11.6-3.4-14.3-8.8L215.6 387c-.9-1.8-2.8-3-4.9-3c-1.7 0-3.3 .8-4.4 2.2l-17.6 23.4c-3.6 4.8-9.7 7.2-15.6 6.2s-10.8-5.4-12.5-11.2L144 349zM518.8 168c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L536.2 208c6.2-6.2 6.2-16.4 0-22.6L518.8 168zM342.5 321.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L488.7 255.4l-40-40L342.5 321.7z'
      
    ]
  };

  

  
  

  var faQuestion = {
    prefix: 'fal',
    iconName: 'question',
    icon: [
      320,
      512,
      [10067,10068,61736],
      '3f',
      
      'M144 64c-53 0-96 43-96 96c0 8.8-7.2 16-16 16s-16-7.2-16-16C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128c0 35.3-16.6 68.4-44.8 89.6l-60.8 45.6C184.3 305.8 176 322.4 176 340l0 12c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-12c0-27.7 13-53.8 35.2-70.4L240 224c20.1-15.1 32-38.8 32-64c0-53-43-96-96-96l-32 0zm-8 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faUserNurseHair = {
    prefix: 'fal',
    iconName: 'user-nurse-hair',
    icon: [
      448,
      512,
      [],
      'e45d',
      
      'M128 144l0-67.1 96-42 96 42 0 67.1-192 0zM96 76.9L96 144l0 16 0 16s0 0 0 0c0 70.7 57.3 128 128 128s128-57.3 128-128c0 0 0 0 0 0l0-16 0-16 0-67.1c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176s0 0 0 0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48l21.5 0c35.5 0 68.3-18.3 87-48l70.7 0zm-112.8 0c-12.4 10.2-28.2 16-44.8 16l-33 0c-.9-5.2-1.3-10.5-1.3-16c0 0 0 0 0 0l79.2 0zM121.1 356.3l69 69c18.7 18.7 49.1 18.7 67.9 0l69-69c51.4 16.8 88.5 64.9 89.1 121.6l-384 0c.6-56.8 37.7-104.9 89.1-121.6zm21.7-23.5c-7.5-7.5-18.3-11-28.4-7.9C48.2 344.9 0 406.4 0 479.2c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-72.8-48.2-134.3-114.4-154.4c-10.1-3.1-20.9 .4-28.4 7.9l-69.8 69.8c-6.2 6.2-16.4 6.2-22.6 0l-69.8-69.8zM208 56l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faClipboardPrescription = {
    prefix: 'fal',
    iconName: 'clipboard-prescription',
    icon: [
      384,
      512,
      [],
      'f5e8',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 208c-8.8 0-16 7.2-16 16l0 80 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 41.4 0 48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 345.4l-31.2-31.2C227.3 305.1 240 286 240 264c0-30.9-25.1-56-56-56l-72 0zm72 80l-8 0-48 0 0-48 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z'
      
    ]
  };

  

  
  

  var faCirclePhone = {
    prefix: 'fal',
    iconName: 'circle-phone',
    icon: [
      512,
      512,
      ["phone-circle"],
      'e11b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.2 144.1c1.9-.4 3.8 .6 4.5 2.3l24 56c.7 1.6 .2 3.5-1.1 4.7l-20.3 16.6c-6.1 5-7.6 13.6-3.7 20.4c14.7 25.4 35.9 46.6 61.4 61.4c6.8 3.9 15.4 2.4 20.4-3.7l16.6-20.3c1.1-1.4 3-1.8 4.7-1.1l56 24c1.8 .8 2.7 2.6 2.3 4.5l-12 56c-.4 1.8-2 3.2-3.9 3.2l-.2 0c-114.7-.1-207.6-93.1-207.7-207.8l0-.2s0 0 0 0s0 0 0 0c0-1.9 1.3-3.5 3.2-3.9l56-12zM352 400l.3 0c16.8-.2 31.3-12 34.9-28.5l12-56c3.6-16.8-5.2-33.9-21-40.6l-56-24c-14.7-6.3-31.9-2.1-42 10.3l-7.5 9.2c-11.9-8.6-22.4-19.1-31-31l9.2-7.5c12.4-10.2 16.6-27.3 10.3-42l-24-56c-6.8-15.8-23.8-24.6-40.6-21l-56 12c-16.5 3.5-28.3 18.1-28.5 34.9l0 .3c0 132.5 107.4 240 240 240z'
      
    ]
  };

  
    var faPhoneCircle = faCirclePhone;
  

  
  

  var faSquareG = {
    prefix: 'fal',
    iconName: 'square-g',
    icon: [
      448,
      512,
      [],
      'e271',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 256c0 53 43 96 96 96c47.6 0 87.1-34.6 94.7-80L256 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c8.8 0 16 7.2 16 16c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3c-17-15.2-39.4-24.4-64-24.4c-53 0-96 43-96 96z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fal',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      'M0 71.5C0 49.7 17.7 32 39.5 32l432.9 0C494.3 32 512 49.7 512 71.5c0 9.2-3.2 18.1-9.1 25.2L320 317.8l0 128.4c0 18.7-15.2 33.9-33.9 33.9c-7.5 0-14.8-2.5-20.8-7.1l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3l0-82.4L9.1 96.7C3.2 89.6 0 80.7 0 71.5zM39.5 64c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 301.8c2.4 2.9 3.7 6.5 3.7 10.2l0 88.2 61 47.4c.3 .3 .7 .4 1.1 .4c1 0 1.9-.8 1.9-1.9L288 312c0-3.7 1.3-7.3 3.7-10.2L478.3 76.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5L39.5 64z'
      
    ]
  };

  

  
  

  var faDownToLine = {
    prefix: 'fal',
    iconName: 'down-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-bottom"],
      'f34a',
      
      'M16 448l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16zm174.2-96.8c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L318.2 219.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L256 208c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L190.2 351.2zM192 384c-9.5 0-18.6-3.9-25.1-10.8L42.5 241.2C35.8 234 32 224.5 32 214.7C32 193.3 49.3 176 70.7 176l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L217.1 373.2c-6.5 6.9-15.6 10.8-25.1 10.8z'
      
    ]
  };

  
    var faArrowAltToBottom = faDownToLine;
  

  
  

  var faRouteHighway = {
    prefix: 'fal',
    iconName: 'route-highway',
    icon: [
      448,
      512,
      [],
      'f61a',
      
      'M232.2 2.3c-5.1-3-11.4-3-16.5 0L194.6 15c-31.9 19.2-71.5 20.7-104.8 4c-17.7-8.9-39.2-3.8-51.1 12.1L14.5 63.3c-10.7 14.2-11.9 33.5-3 49C24.9 135.9 32 162.5 32 189.7L32 203c0 22.4-4.3 44.6-12.6 65.4L8 296.9c-5.3 13.2-8 27.4-8 41.6C0 382.2 25.4 422 65.1 440.3l152.2 70.2c4.3 2 9.2 2 13.4 0l152.2-70.2C422.6 422 448 382.2 448 338.5c0-14.3-2.7-28.4-8-41.6l-11.4-28.5c-8.3-20.8-12.6-43-12.6-65.4l0-13.4c0-27.1 7.1-53.8 20.6-77.4c8.8-15.5 7.6-34.7-3-49L409.3 31.1C397.4 15.2 375.9 10.2 358.2 19c-33.3 16.7-72.8 15.1-104.8-4L232.2 2.3zM211 42.4l13-7.8 13 7.8c41.3 24.8 92.4 26.8 135.5 5.2c3.9-1.9 8.6-.8 11.2 2.6l24.2 32.3c3 4 3.4 9.5 .9 13.9c-11.3 19.7-18.8 41.3-22.4 63.6L61.6 160c-3.6-22.3-11.1-43.8-22.4-63.6c-2.5-4.4-2.2-9.8 .9-13.9L64.3 50.3c2.6-3.5 7.3-4.6 11.2-2.6c43.1 21.6 94.2 19.6 135.5-5.2zM64 192l320 0 0 11c0 26.5 5 52.7 14.9 77.2l11.4 28.5c3.8 9.5 5.7 19.6 5.7 29.8c0 31.2-18.2 59.6-46.5 72.7L224 478.4 78.5 411.2C50.2 398.1 32 369.8 32 338.5c0-10.2 1.9-20.3 5.7-29.8l11.4-28.5C59 255.7 64 229.5 64 203l0-11z'
      
    ]
  };

  

  
  

  var faMemoCircleCheck = {
    prefix: 'fal',
    iconName: 'memo-circle-check',
    icon: [
      576,
      512,
      [],
      'e1d9',
      
      'M320 32L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 134.6c-11.2 3.2-21.9 7.4-32 12.6L352 64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16zm16 80l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7z'
      
    ]
  };

  

  
  

  var faDiamonds4 = {
    prefix: 'fal',
    iconName: 'diamonds-4',
    icon: [
      512,
      512,
      [],
      'e68b',
      
      'M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-74.1 74.1L256 188.1l79.7-79.7L358.3 131l-79.7 79.7c-12.5 12.5-32.8 12.5-45.3 0L153.7 131c-12.5-12.5-12.5-32.8 0-45.3l74.1-74.1c15.6-15.6 40.9-15.6 56.6 0l74.1 74.1c12.5 12.5 12.5 32.8 0 45.3l-22.6-22.6L261.7 34.3zm-50.9 199c12.5 12.5 12.5 32.8 0 45.3L131 358.3c-12.5 12.5-32.8 12.5-45.3 0L11.7 284.3c-15.6-15.6-15.6-40.9 0-56.6l74.1-74.1c12.5-12.5 32.8-12.5 45.3 0l79.7 79.7zM108.4 176.3L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l74.1 74.1L188.1 256l-79.7-79.7zM381 153.7c12.5-12.5 32.8-12.5 45.3 0l74.1 74.1c15.6 15.6 15.6 40.9 0 56.6l-74.1 74.1c-12.5 12.5-32.8 12.5-45.3 0l-79.7-79.7c-12.5-12.5-12.5-32.8 0-45.3L381 153.7zM233.4 301.3c12.5-12.5 32.8-12.5 45.3 0L358.3 381c12.5 12.5 12.5 32.8 0 45.3l-74.1 74.1c-15.6 15.6-40.9 15.6-56.6 0l-74.1-74.1c-12.5-12.5-12.5-32.8 0-45.3l79.7-79.7zM176.3 403.6l74.1 74.1c3.1 3.1 8.2 3.1 11.3 0l74.1-74.1L256 323.9l-79.7 79.7zm227.3-67.9l74.1-74.1c3.1-3.1 3.1-8.2 0-11.3l-74.1-74.1L323.9 256l79.7 79.7z'
      
    ]
  };

  

  
  

  var faPodium = {
    prefix: 'fal',
    iconName: 'podium',
    icon: [
      448,
      512,
      [],
      'f680',
      
      'M288 32l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM178.7 64L168 64c-26.5 0-48 21.5-48 48l0 48 312 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 192c-8.8 0-16-7.2-16-16s7.2-16 16-16l72 0 0-48c0-44.2 35.8-80 80-80l10.7 0C185.3 13.4 203.1 0 224 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-20.9 0-38.7-13.4-45.3-32zM73.5 455.2L47.3 224l32.2 0 25.9 227.6c1.8 16.2 15.5 28.4 31.8 28.4l173.7 0c16.3 0 30-12.2 31.8-28.4L368.5 224l32.2 0L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8l-173.7 0c-32.6 0-59.9-24.4-63.6-56.8z'
      
    ]
  };

  

  
  

  var faDagger = {
    prefix: 'fal',
    iconName: 'dagger',
    icon: [
      384,
      512,
      [],
      'f6cb',
      
      'M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-32 0-32 0-32 0-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48l0-16 16 0 32 0 48 0 48 0 32 0 16 0 0 16c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48l-32 0-32 0-32 0-32 0 0-112zM48 160l16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16zm272 0l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16s-16-7.2-16-16l0-16zM240 397.9c0 4.9-1.5 9.7-4.3 13.8L192 474.1l-43.7-62.4c-2.8-4-4.3-8.8-4.3-13.8L144 192l-32 0 0 205.9c0 11.5 3.5 22.7 10.1 32.1l50.2 71.7c4.5 6.4 11.8 10.2 19.7 10.2s15.2-3.8 19.7-10.2L261.9 430c6.6-9.4 10.1-20.6 10.1-32.1L272 192l-32 0 0 205.9z'
      
    ]
  };

  

  
  

  var faFaceKissWinkHeart = {
    prefix: 'fal',
    iconName: 'face-kiss-wink-heart',
    icon: [
      512,
      512,
      [128536,"kiss-wink-heart"],
      'f598',
      
      'M325.2 469.1C303.4 476.2 280.2 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 25.9-4.4 50.8-12.5 73.9c10.9 1.2 21.2 4.5 30.6 9.5c9-26.2 13.9-54.2 13.9-83.4C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c28.6 0 56.1-4.7 81.8-13.4c-4.9-6.5-8.7-14.1-10.8-22.6l-1.8-7zM222.1 293.5c13.3 1.9 27.8 5.8 38.6 11c5.4 2.7 9.2 5.3 11.5 7.7c2.7 2.9 2.7 4.7 0 7.6c-2.3 2.4-6.1 5.1-11.5 7.7c-10.7 5.3-25.1 9.1-38.3 11c-6.7 .8-12 6.7-12 13.5c0 6.8 5.3 12.7 12 13.5c13.2 1.9 27.6 5.8 38.3 11c5.4 2.7 9.2 5.3 11.5 7.7c2.7 2.9 2.7 4.7 0 7.6c-2.3 2.4-6.1 5.1-11.5 7.7c-10.8 5.3-25.3 9.2-38.6 11c-7.4 1-12.6 7.9-11.6 15.4s7.9 12.6 15.4 11.6c15.2-2.1 32.7-6.6 46.8-13.6c7-3.4 13.9-7.8 19.2-13.4c5.4-5.6 9.8-13.2 9.8-22.5s-4.4-16.9-9.8-22.5c-5.3-5.5-12.2-9.9-19.2-13.4l-.2-.1 .2-.1c7-3.4 13.9-7.8 19.2-13.4c5.4-5.6 9.8-13.2 9.8-22.5s-4.4-16.9-9.8-22.5c-5.3-5.5-12.2-9.9-19.2-13.4c-14.1-6.9-31.6-11.4-46.8-13.6c-7.4-1-14.3 4.1-15.4 11.6s4.1 14.3 11.6 15.4zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm194.8 1.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm70.1 127.5c-7.4-29-36.5-47.3-65.8-39.2c-28.9 8.1-45.1 38.6-37.7 67.4L358 468.1c4.5 17.4 22.3 27.7 39.6 22.9l74.9-21c28.9-8.1 45.1-38.6 37.7-67.4c-7.4-29-36.5-47.3-65.8-39.2l-2.4 .7-.8-3zm-57.1-8.3c10.8-3 22.9 3.5 26.1 16.3l4.8 18.9c1.1 4.2 3.8 7.7 7.5 9.9s8.2 2.7 12.3 1.5l18.1-5.1c10.8-3 22.9 3.5 26.1 16.3c3.3 13-4.2 25.5-15.3 28.6l-74.9 21-20.2-78.8c-3.3-13 4.2-25.5 15.3-28.6z'
      
    ]
  };

  
    var faKissWinkHeart = faFaceKissWinkHeart;
  

  
  

  var faWheatAwnSlash = {
    prefix: 'fal',
    iconName: 'wheat-awn-slash',
    icon: [
      640,
      512,
      [],
      'e338',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm235.7 288l-37 37c1.9-31.2-7.5-62.9-28.2-88.5l-46.7-36.9c-2.8 .7-5.4 2.1-7.6 4.2l-33.9 33.9c-37.5 37.5-37.5 98.3 0 135.8L142.2 411s0 0 0 0L68.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5s0 0 0 0l33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.5-37.2L287 311.4l-25.3-20zM289.2 60.3C270.5 79 261.2 103.5 261.1 128l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.5 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4L555 145.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L478 176.9c-16.1-5.5-33-7.8-49.8-6.7L555 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L405.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L383.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L345.8 26.4c-6.2-6.2-16.4-6.2-22.6 0L289.2 60.3zM130.9 263.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zm181 181c-25 25-65.5 25-90.5 0L187.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z'
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'fal',
    iconName: 'language',
    icon: [
      640,
      512,
      [],
      'f1ab',
      
      'M304 96l0 320L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l240 0zm32 0l240 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-240 0 0-320zm304 32c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256zM174.9 170.1C172.4 164 166.5 160 160 160s-12.4 4-14.9 10.1l-64 160c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9 80.7 0 8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49L187.6 288l-55.1 0L160 219.1zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 41.2 0-.2 .6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7c5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4c19.1-19.4 34.1-42.9 43.6-69l4.2-11.6 4.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-48 0 0-16z'
      
    ]
  };

  

  
  

  var faBreadSlice = {
    prefix: 'fal',
    iconName: 'bread-slice',
    icon: [
      512,
      512,
      [],
      'f7ec',
      
      'M64 224c-17.7 0-32-14.3-32-32c0-44.3 32.4-76.2 84.6-98.6C167.9 71.4 227.5 64 256 64s88.1 7.4 139.4 29.4C447.6 115.8 480 147.7 480 192c0 17.7-14.3 32-32 32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32zm384 64l0-32c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64l0 32 0 144c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-144z'
      
    ]
  };

  

  
  

  var faVectorSquare = {
    prefix: 'fal',
    iconName: 'vector-square',
    icon: [
      448,
      512,
      [],
      'f5cb',
      
      'M408 64c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zM360 32c-22.1 0-40 17.9-40 40l0 8L128 80l0-8c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l8 0 0 192-8 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-8 192 0 0 8c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-8 0 0-192 8 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM80 352l0-192 8 0c22.1 0 40-17.9 40-40l0-8 192 0 0 8c0 22.1 17.9 40 40 40l8 0 0 192-8 0c-22.1 0-40 17.9-40 40l0 8-192 0 0-8c0-22.1-17.9-40-40-40l-8 0zM40 384l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm320 0l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zM40 64l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faMoneyCheckDollar = {
    prefix: 'fal',
    iconName: 'money-check-dollar',
    icon: [
      576,
      512,
      ["money-check-alt"],
      'f53d',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM272 288l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-80c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm-96-56l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c0 0 0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7l0-17.3c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faMoneyCheckAlt = faMoneyCheckDollar;
  

  
  

  var faDiceD4 = {
    prefix: 'fal',
    iconName: 'dice-d4',
    icon: [
      512,
      512,
      [],
      'f6d0',
      
      'M240.1 56.5L35.4 310.6 240.1 465.9l0-409.4zm32 409.2L476.6 310.6 272.1 56.7l0 409.1zM256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0z'
      
    ]
  };

  

  
  

  var faPersonDressBurst = {
    prefix: 'fal',
    iconName: 'person-dress-burst',
    icon: [
      640,
      512,
      [],
      'e544',
      
      'M456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l48 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 64 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 48 0c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368 528 368l-96 0-38.1 0 52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6L222.6 87.2 190.5 17.3zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fal',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c4.5 0 8.9-.5 13.1-1.3l38.1 83.2c-26.6 17.2-45.4 45.4-50.1 78.1L126 288c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48l99.2 0c7.8 54.3 54.4 96 110.9 96c35 0 66.3-16.1 86.8-41.2l91.8 55.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4l-91.8-55.1c5.6-13.3 8.7-28 8.7-43.3c0-18.7-4.6-36.3-12.7-51.8l101.8-73.3c10.8 8.2 24.2 13.1 38.8 13.1c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 9.1 1.9 17.8 5.4 25.7L416.6 226.2c-20.4-21.1-49-34.2-80.6-34.2c-11 0-21.6 1.6-31.7 4.5l-38.5-84.1C279.4 100.7 288 83.4 288 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM576 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM544 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-48a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faWifiExclamation = {
    prefix: 'fal',
    iconName: 'wifi-exclamation',
    icon: [
      640,
      512,
      [],
      'e2cf',
      
      'M336 48l0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240c0-8.8 7.2-16 16-16s16 7.2 16 16zM4.7 161.7C75.4 91.7 169.4 45 274 34.3c-1.3 4.3-2 8.9-2 13.7l0 18.7C177 77.7 91.8 120.6 27.3 184.4c-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4 .1-22.6zM116.7 276c41.3-41.2 95.2-69.9 155.3-80l0 32.5c-51.3 9.7-97.2 34.8-132.7 70.2c-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM368 196c60.1 10.1 114 38.8 155.3 80c6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-35.5-35.4-81.4-60.5-132.7-70.2l0-32.5zm0-148c0-4.7-.7-9.3-2-13.7C470.6 45 564.6 91.7 635.3 161.7c6.3 6.2 6.3 16.3 .1 22.6s-16.3 6.3-22.6 .1C548.2 120.6 463 77.7 368 66.7L368 48zM320 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faKidneys = {
    prefix: 'fal',
    iconName: 'kidneys',
    icon: [
      640,
      512,
      [],
      'f5fb',
      
      'M115.7 352c-33.4 0-52.1-14.3-64.3-35.8C37.8 292.5 32 258.9 32 224c0-39 12.1-89.3 35.6-129c23.5-39.6 54.7-63 92.1-63c39.7 0 77.1 22.4 85.8 52.9c6 21.1-2.7 49.4-25.5 75.1c-28.7 32.4-24.6 71.3-22 95.6c.2 1.6 .3 3.2 .5 4.7c4.9 49.1-33.6 91.6-82.7 91.6zm0 32c68.1 0 121.3-58.9 114.6-126.8l-.3-2.8c-.6-6.1-1.2-12.2-1.6-18.3l18.8 9.4c5.4 2.7 8.8 8.3 8.8 14.3L256 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-236.2c0-18.2-10.3-34.8-26.5-42.9L231.8 202c2.4-7.2 6.2-14.1 12-20.7c26.6-30 42.6-69.3 32.4-105.1C262.2 26.9 207.7 0 159.7 0C53.7 0 0 135.2 0 224c0 74.9 24.3 160 115.7 160zM394.2 86.1c.1-.4 .3-.8 .4-1.2C403.2 54.4 440.6 32 480.3 32c37.4 0 68.5 23.4 92.1 63C595.9 134.7 608 185 608 224c0 34.9-5.8 68.5-19.4 92.2c-12.2 21.4-31 35.8-64.3 35.8c-49.1 0-87.6-42.5-82.7-91.6c.1-1.5 .3-3 .5-4.7c0 0 0 0 0 0s0 0 0 0c2.6-24.3 6.7-63.2-22-95.6c-23.7-26.7-32.4-54.2-25.9-73.9zm-30.4-10c-11.8 35.8 5.8 75.2 32.4 105.1c5.8 6.6 9.6 13.5 12 20.7l-29.7 14.8C362.3 225 352 241.6 352 259.8L352 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-236.2c0-6.1 3.4-11.6 8.8-14.3l18.8-9.4c-.3 6-.9 12.1-1.6 18.3l-.3 2.8C403 325.1 456.2 384 524.3 384C615.7 384 640 298.9 640 224C640 135.2 586.3 0 480.3 0c-48 0-102.5 26.9-116.5 76.2z'
      
    ]
  };

  

  
  

  var faFaceParty = {
    prefix: 'fal',
    iconName: 'face-party',
    icon: [
      640,
      512,
      [],
      'e383',
      
      'M96 256C96 132.3 196.3 32 320 32c91.8 0 170.8 55.3 205.4 134.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C515.2 63.2 425 0 320 0C263.2 0 210.7 18.5 168.2 49.9L21.1 .8C15.2-1.1 8.7 .5 4.4 4.9S-1.2 16 1.1 21.7L70 200.9c-3.9 17.8-6 36.2-6 55.1c0 141.4 114.6 256 256 256c75.8 0 144-33 190.8-85.3c5.9-6.6 5.3-16.7-1.3-22.6c-3-2.7-6.8-4.1-10.6-4.1l-.1 0c-4.4 0-8.7 1.8-11.9 5.3c-41 45.9-100.6 74.7-167 74.7C196.3 480 96 379.7 96 256zM139.8 74.1c-22.6 22.4-41.1 49-54.1 78.5L73.9 121.9c.5-.7 1-1.4 1.4-2.1c10.9-19.6 24.1-37.7 39.3-54.1l25.2 8.4zM81.6 54.7c-8 9.4-15.4 19.3-22.2 29.6L43.1 41.9 81.6 54.7zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm160 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-53.8 69.5c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-10.9 5.4-25.5 9.3-38.8 11.2c-.9 .1-1.8 .3-2.7 .6c-1.7 .6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8 .7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9 .3 1.7 .5 2.7 .6c13.3 1.9 27.9 5.8 38.8 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-11 5.4-25.7 9.3-39.1 11.2c-6.6 .9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4c0-8-3.5-14.8-8-20l180 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-180 0c4.5-5.2 8-12 8-20c0-8.8-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-13.9-6.8-31.2-11.3-46.3-13.4c-6.6-.9-12.6 3.6-13.6 10.2s3.7 12.6 10.2 13.6c13.4 1.9 28.1 5.8 39.1 11.2z'
      
    ]
  };

  

  
  

  var faSparkle = {
    prefix: 'fal',
    iconName: 'sparkle',
    icon: [
      448,
      512,
      [],
      'e5d6',
      
      'M224 32c6.2 0 11.9 3.6 14.5 9.3l63.2 136.9 136.9 63.2c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L301.8 333.8 238.5 470.7c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L146.2 333.8 9.3 270.5C3.6 267.9 0 262.2 0 256s3.6-11.9 9.3-14.5l136.9-63.2L209.5 41.3c2.6-5.7 8.3-9.3 14.5-9.3zm0 54.2L172.8 197c-1.6 3.5-4.4 6.2-7.8 7.8L54.2 256 165 307.2c3.5 1.6 6.2 4.4 7.8 7.8L224 425.8 275.2 315c1.6-3.5 4.4-6.2 7.8-7.8L393.8 256 283 204.8c-3.5-1.6-6.2-4.4-7.8-7.8L224 86.2z'
      
    ]
  };

  

  
  

  var faChartWaterfall = {
    prefix: 'fal',
    iconName: 'chart-waterfall',
    icon: [
      512,
      512,
      [],
      'e0eb',
      
      'M16 32c8.8 0 16 7.2 16 16l0 352c0 26.5 21.5 48 48 48l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 480c-44.2 0-80-35.8-80-80L0 48c0-8.8 7.2-16 16-16zM144 224c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm112-80l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-80c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM448 80l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fal',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M32 48c0 8.8 7.2 16 16 16l16 0 0 128-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L96 48c0-8.8-7.2-16-16-16L48 32c-8.8 0-16 7.2-16 16zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3c9.2 10.5 8.9 26.2-.6 36.3L12.3 453.1c-4.3 4.7-5.5 11.5-3 17.3s8.3 9.6 14.7 9.6l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-67.2 0 60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3c-22.5-25.7-62.1-27.1-86.3-2.9L20.7 316.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fal',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M282.7 192L160 69.2 37.3 192l245.5 0zM8.3 175.7L146.3 37.6C150 34 154.9 32 160 32s10 2 13.6 5.7L311.7 175.7c5.3 5.3 8.3 12.5 8.3 20c0 15.6-12.7 28.3-28.3 28.3L28.3 224C12.7 224 0 211.3 0 195.7c0-7.5 3-14.7 8.3-20zM282.7 320L37.3 320 160 442.8 282.7 320zM8.3 336.3C3 331 0 323.8 0 316.3C0 300.7 12.7 288 28.3 288l263.4 0c15.6 0 28.3 12.7 28.3 28.3c0 7.5-3 14.7-8.3 20L173.6 474.4C170 478 165.1 480 160 480s-10-2-13.7-5.7L8.3 336.3z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faLocust = {
    prefix: 'fal',
    iconName: 'locust',
    icon: [
      576,
      512,
      [],
      'e520',
      
      'M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c106.5 0 194.3 80 206.5 183.2C525.7 232.7 503.9 224 480 224l-50.1 0L382 136.3c-2.6-4.8-7.5-7.9-13-8.3s-10.7 2.1-14 6.5l-45.3 61.4-40.5-60.8c-2.9-4.3-7.7-7-12.9-7.1s-10.1 2.2-13.2 6.4L176 224l-73.9 0C63.4 224 32 255.4 32 294.1c0 27.5 16 52.4 41 63.8l1.9 .9L3.2 454.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l75.9-101.2 51 23.3c4.7 2.2 9.5 4.2 14.4 6l-38.9 52.8c-5.2 7.1-3.7 17.1 3.4 22.4s17.1 3.7 22.4-3.4l45.9-62.3c15.1 3.2 30.5 4.8 46 4.8l32.2 0-22.9 40.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l32-55.9 136.3 0 27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-20.7-41.3c48.5-4.8 86.3-45.8 86.3-95.5l0-.3 0-47.7C576 139.5 468.5 32 336 32l-32 0zM480 256c35.3 0 63.9 28.5 64 63.7l0 .3 0 .1c-.1 35.3-28.7 63.9-64 63.9l-15.7 0c-.1 0-.3 0-.4 0c-.1 0-.2 0-.3 0l-214.9 0c-27.5 0-54.8-5.9-79.8-17.4l-44.6-20.4L192 256l127.8 0 .5 0L480 256zm-328 0L94.5 332.6l-8.3-3.8C72.7 322.6 64 309.1 64 294.1c0-21.1 17.1-38.1 38.1-38.1l49.9 0zm137.2-32L216 224l39.2-52.3 34.4 51.6-.5 .7zm104.2 0l-64.5 0L366 173.7 393.4 224zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFilterCircleXmark = {
    prefix: 'fal',
    iconName: 'filter-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e17b',
      
      'M0 39.5C0 17.7 17.7 0 39.5 0L472.5 0C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5L39.5 32c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 269.8c2.4 2.9 3.7 6.5 3.7 10.2l0 88.2 34 26.4c2.7 18.1 8.3 35.3 16.1 51.2c-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3l0-82.4L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faToiletPaperCheck = {
    prefix: 'fal',
    iconName: 'toilet-paper-check',
    icon: [
      640,
      512,
      [],
      'e5b2',
      
      'M16 479c.2-5.3 1.7-10.6 4.5-15.4c0 0 0 0 0-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192C64 86 107 0 160 0L464 0l32 0c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2c2.1-14.2 4.1-29.6 5.7-46c14.2 25.6 33 41.2 53.6 41.2c44.2 0 80-71.6 80-160s-35.8-160-80-160s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7c-.3 2.5-.5 4.9-.8 7.4c-9 82.3-25.6 133.1-36.3 158.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2c-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2c-5.7 49.5-17.3 100.7-41.6 144.8c-.2 .3-.4 .6-.5 .9c0 0 0 0 0 0l269.9 0c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6L160 32zM496 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16zM307.3 187.3l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 225.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faCircleI = {
    prefix: 'fal',
    iconName: 'circle-i',
    icon: [
      512,
      512,
      [],
      'e111',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 192-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-192 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0-80 0z'
      
    ]
  };

  

  
  

  var faUserGroupCrown = {
    prefix: 'fal',
    iconName: 'user-group-crown',
    icon: [
      640,
      512,
      ["users-crown"],
      'f6a5',
      
      'M224 0c5.2 0 10.3 1.5 14.7 4.4l32.5 21.6c5.4 3.6 12.4 3.6 17.8 0L324 2.7c2.6-1.8 5.7-2.7 8.9-2.7L336 0c8.8 0 16 7.2 16 16l0 112 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16L96 16c0-8.8 7.2-16 16-16l3.2 0c3.2 0 6.2 .9 8.9 2.7l35.1 23.4c5.4 3.6 12.4 3.6 17.8 0L209.3 4.4C213.7 1.5 218.8 0 224 0zm96 43.8l-13.4 8.9c-16.1 10.7-37.1 10.7-53.3 0L224 33.1 194.6 52.7c-16.1 10.7-37.1 10.7-53.3 0L128 43.8l0 68.2 192 0 0-68.2zM224 240c53 0 96-43 96-96l-192 0c0 53 43 96 96 96zM32 472l0 8 384 0 0-8c0-75.1-60.9-136-136-136l-112 0C92.9 336 32 396.9 32 472zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8zM432 256c-27.7 0-53-10.1-72.6-26.7c1.9-2.9 3.6-6 5.3-9c3.6-6.7 6.8-13.7 9.5-21C388.8 214.5 409.3 224 432 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-18 0-34.6 6-48 16l0-37.2C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l128 0c-.7-70.8-58.3-128-129.3-128L440 352c-8.8-11.7-18.8-22.4-29.8-31.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z'
      
    ]
  };

  
    var faUsersCrown = faUserGroupCrown;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fal',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM299.3 363.3l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 240 144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l201.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z'
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faBreadSliceButter = {
    prefix: 'fal',
    iconName: 'bread-slice-butter',
    icon: [
      512,
      512,
      [],
      'e3e1',
      
      'M96 256l0 176c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32-14.3 32-32c0-44.3-32.4-76.2-84.6-98.6C344.1 71.4 284.5 64 256 64s-88.1 7.4-139.4 29.4C64.4 115.8 32 147.7 32 192c0 17.7 14.3 32 32 32s32 14.3 32 32zm352 0l0 32 0 144c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-144 0-32c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zM193.9 276.7c-6.2 6.2-6.2 16.4 0 22.6l50.7 50.7c6.2 6.2 16.4 6.2 22.6 0l50.7-50.7c6.2-6.2 6.2-16.4 0-22.6l-50.7-50.7c-6.2-6.2-16.4-6.2-22.6 0l-50.7 50.7zm96-73.4l50.7 50.7c18.7 18.7 18.7 49.1 0 67.9l-50.7 50.7c-18.7 18.7-49.1 18.7-67.9 0l-50.7-50.7c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7c18.7-18.7 49.1-18.7 67.9 0z'
      
    ]
  };

  

  
  

  var faMoonCloud = {
    prefix: 'fal',
    iconName: 'moon-cloud',
    icon: [
      640,
      512,
      [],
      'f754',
      
      'M446.6 66.8C359 82 291.8 156.8 288.1 248c-9.9-4.1-20.5-6.8-31.6-7.7C264.5 124 361.2 32 479.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.3-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c7.5-7.8 13.8-16.8 18.6-26.7c34.8 36.2 83.7 58.7 137.8 58.7c34.2 0 66.3-9 94.1-24.7c-106.4-9-189.9-98.4-189.9-207.3c0-58.5 24.1-111.4 62.9-149.2zM144 224c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72L64 416c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64zm0 32c-26.5 0-48 21.5-48 48c0 .7 0 1.4 0 2.1c.2 5.3-2.2 10.4-6.5 13.5s-9.8 4-14.9 2.2c-3.3-1.2-6.9-1.8-10.7-1.8c-17.7 0-32 14.3-32 32s14.3 32 32 32l184 0c22.1 0 40-17.9 40-40s-17.9-40-40-40c-11.2 0-21.3 4.6-28.6 12c-4.6 4.7-11.5 6.1-17.5 3.6s-9.9-8.4-9.9-14.9l0-.8c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fal',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 224c0 44.2 35.8 80 80 80l377.4 0L356.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 272 80 272c-26.5 0-48-21.5-48-48L32 48z'
      
    ]
  };

  

  
  

  var faGuitarElectric = {
    prefix: 'fal',
    iconName: 'guitar-electric',
    icon: [
      512,
      512,
      [127928],
      'f8be',
      
      'M391.1 67.8l52.6-35L473.3 55c7.6 5.7 8.3 16.7 1.7 23.4c-6.1 6.1-15.9 6.1-22 0l-9.7-9.7c-6.2-6.2-16.4-6.2-22.6 0L384 105.4l0-24.2c0-5.3 2.7-10.3 7.1-13.3zM352 136c0 .4 0 .9 .1 1.3l-68.2 68.2c-8-10.2-13.4-20.5-12.1-27.7c1.6-8.9 5.8-16.9 9.9-24.7c8.9-16.7 17.2-32.4-3.3-53.1c-15.9-16.1-41.8-16.1-57.7 0l-29.9 30.2c-9.4 9.5-15 21.1-20.6 32.8c0 0 0 0 0 0c-5.6 11.6-11.1 23.1-20.3 32.3c-16.5 16.7-38.1 23.8-59.8 30.8c-21.8 7.1-43.7 14.3-60.6 31.4c-39.3 39.7-39.3 104 0 143.7l79.9 80.8c39.4 39.9 103.5 39.9 142.9 0c17-17.2 24-39.3 31-61.3c6.9-21.9 13.8-43.7 30.5-60.5c8.7-8.8 19.5-13.8 30.3-18.8c10.9-5.1 21.8-10.1 30.6-19l21.6-21.8c15.8-15.9 15.8-41.7 0-57.6c-16.5-16.7-29.8-12.3-44-7.7c-7.2 2.4-14.7 4.8-22.9 4.6c-5.5-.2-14-4.9-22.8-11.9L432 102.6c18.7 17 47.5 16.5 65.6-1.6c20.5-20.5 18-54.3-5.1-71.6L461 5.7C456 2 450 0 443.8 0c-5.6 0-11.2 1.7-15.9 4.8L373.4 41.2C360 50.1 352 65.1 352 81.1l0 54.9zM238.6 172.1c-3 17.4 4.7 32.7 9.4 40.7c5.7 9.7 13.4 18.9 21 26.7c7.7 7.9 16.4 15.4 25.1 21.2c4.3 2.9 9.1 5.8 14.2 8c4.6 2.1 11.7 4.7 20 4.9c11.4 .3 21.1-2.1 27.9-4.1c2.3-.7 4.9-1.5 6.9-2.2c0 0 0 0 0 0s0 0 0 0l1.8-.6c2.4-.8 4-1.2 5.3-1.5l.3-.1c.5 .4 1.1 .9 1.8 1.7c2.8 2.8 2.8 7.5 0 10.3l-21.6 21.8c-3.8 3.9-9.1 6.7-20.8 12.1l-1.4 .7c-10.1 4.7-25.8 11.9-38.8 25c-22.4 22.7-31.5 51.3-37.9 71.8l-.8 2.4c-7.3 23.1-12.4 37.1-22.7 47.6c-26.3 26.6-68.8 26.6-95.1 0L53.4 377.7c-26.3-26.6-26.3-69.8 0-96.5c10.2-10.4 24-15.5 46.9-23l2.4-.8c20.3-6.6 48.7-15.8 71.1-38.4c13.2-13.3 20.9-29.3 26-40.1l.7-1.5c6-12.4 9.4-18.8 14.1-23.6l29.9-30.2c2.8-2.8 7.2-2.8 9.9 0c1.4 1.4 2.2 2.4 2.7 3.1c-.1 .2-.2 .5-.3 .7c-1 2.6-2.2 4.7-4 8.2c0 0 0 0 0 0s0 0 0 0c-1 1.9-2.2 4.1-3.7 7.1c-3.6 6.9-8.4 17.1-10.5 29.2c0 0 0 0 0 0zm130.9 92.3s0 0 .1 .1c-.1 0-.1-.1-.1-.1zM257.8 128s0 0-.1-.1c0 .1 .1 .1 .1 .1zM148.7 276.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm-48 48c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faRectangleAd = {
    prefix: 'fal',
    iconName: 'rectangle-ad',
    icon: [
      576,
      512,
      ["ad"],
      'f641',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm214.6 73.4l72 160c3.6 8.1 0 17.5-8 21.2s-17.5 0-21.2-8L247.3 320l-94.5 0-10.2 22.6c-3.6 8.1-13.1 11.7-21.2 8s-11.7-13.1-8-21.2l72-160c2.6-5.7 8.3-9.4 14.6-9.4s12 3.7 14.6 9.4zM200 215l-32.9 73 65.7 0L200 215zm176 25a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm40-19.9l0-44.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 104 0 56c0 8.8-7.2 16-16 16c-7.6 0-14-5.3-15.6-12.4C404.9 347.4 391 352 376 352c-39.8 0-72-32.2-72-72s32.2-72 72-72c14.8 0 28.6 4.5 40 12.1z'
      
    ]
  };

  
    var faAd = faRectangleAd;
  

  
  

  var faNewspaper = {
    prefix: 'fal',
    iconName: 'newspaper',
    icon: [
      512,
      512,
      [128240],
      'f1ea',
      
      'M160 64c-17.7 0-32 14.3-32 32l0 320c0 11.7-3.1 22.6-8.6 32L432 448c26.5 0 48-21.5 48-48l0-304c0-17.7-14.3-32-32-32L160 64zM64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l0 32c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 304c0 44.2-35.8 80-80 80L64 480zM384 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM160 304c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm32-144l128 0 0-96-128 0 0 96zM160 120c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-112z'
      
    ]
  };

  

  
  

  var faStomach = {
    prefix: 'fal',
    iconName: 'stomach',
    icon: [
      512,
      512,
      [],
      'f623',
      
      'M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 61.9 50.1 112 112 112l20 0c-2.6 10.2-4 21-4 32l0 48c0 44.2-35.8 80-80 80l-64 0C57.5 352 12 391 2 442.6c-1.3 6.2-2 12.6-2 19.1L0 464l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-5.2 .5-10.2 1.4-15.1c3.8-16.7 14.9-31.2 30.6-39c24.8-12.4 56.5-5.7 78.4 15.2C181.3 462.3 246.5 512 320 512c106 0 192-86 192-192l0-96c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64L240 160c-44.2 0-80-35.8-80-80l0-64zm4.5 386c-7.4-7.1-15.9-13.2-25-18l36.4 0c42.8 0 80-24 98.9-59.4c25.6-11.2 43.6-12.6 57.6-10.2c15.3 2.6 27.6 9.7 42.4 18.4l.5 .3c14.1 8.3 30.9 18.1 52.1 20.7c15.2 1.8 31.7-.2 50.4-7.3C465.2 422.2 399.4 480 320 480c-60.3 0-117.5-41.7-155.5-78zM480 310.5c-21.6 11-36.9 12.9-48.7 11.5c-13.9-1.7-25.4-8.1-40.2-16.8l-1.2-.7c-13.9-8.2-30.7-18-52.1-21.6c-15.1-2.5-31.7-1.8-50.7 3.4c.6-4.7 .9-9.4 .9-14.3l0-48c0-53 43-96 96-96s96 43 96 96l0 86.5z'
      
    ]
  };

  

  
  

  var faSnowflake = {
    prefix: 'fal',
    iconName: 'snowflake',
    icon: [
      448,
      512,
      [10052,10054],
      'f2dc',
      
      'M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 73.4L171.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 134.6l0 93.7-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3S72 100.2 74.3 108.7l13.4 50.1L24.2 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4L8.2 362.1C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7L74.3 403.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L208 283.7l0 93.7-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 422.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4l0-93.7 81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7L426.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L240 228.3l0-93.7 59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4 240 16z'
      
    ]
  };

  

  
  

  var faBroomWide = {
    prefix: 'fal',
    iconName: 'broom-wide',
    icon: [
      512,
      512,
      [],
      'e5d1',
      
      'M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144-18.6-18.6c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3l-18.6-18.6 144-144zM299.5 152.8l59.7 59.7c10.1 10.1 12.3 25.7 5.3 38.2l-21.2 38.1L223.2 168.6l38.1-21.2c12.5-6.9 28.1-4.8 38.2 5.3zm-105.4 32L327.2 317.9l-90 162.1L113.9 356.7l41.4-41.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L91.3 334.1 32.1 274.8l162.1-90z'
      
    ]
  };

  

  
  

  var faP = {
    prefix: 'fal',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      'M48 64l128 0c61.9 0 112 50.1 112 112s-50.1 112-112 112L32 288 32 80c0-8.8 7.2-16 16-16zM32 320l144 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L48 32C21.5 32 0 53.5 0 80L0 304 0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144z'
      
    ]
  };

  

  
  

  var faTrashCanClock = {
    prefix: 'fal',
    iconName: 'trash-can-clock',
    icon: [
      576,
      512,
      [],
      'e2aa',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 96.7c-11 1-21.7 3-32 5.9L384 96 64 96l0 336c0 26.5 21.5 48 48 48l184.2 0c10 12.1 21.7 22.9 34.6 32L112 512c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM336 176l0 44.5c-11.7 7.6-22.4 16.6-32 26.7l0-71.2c0-8.8 7.2-16 16-16s16 7.2 16 16zm-192 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSausage = {
    prefix: 'fal',
    iconName: 'sausage',
    icon: [
      512,
      512,
      [],
      'f820',
      
      'M400 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L400 0zM32 400c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM480 160c0 176.7-143.3 320-320 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c106 0 192-86 192-192c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 0c0-53-43-96-96-96s-96 43-96 96c0 88.4-71.6 160-160 160c-53 0-96 43-96 96s43 96 96 96c194.4 0 352-157.6 352-352zm-112 0c-8.8 0-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faFeatherPointed = {
    prefix: 'fal',
    iconName: 'feather-pointed',
    icon: [
      512,
      512,
      ["feather-alt"],
      'f56b',
      
      'M102.2 348.1C89.9 302.4 89.8 224.5 160 154.3c40.6-40.6 98.9-69.8 159.1-89.6C379 44.9 438.2 35.3 477.9 32c0 0 .2 0 .4 .1c.3 .1 .6 .3 1 .7s.6 .7 .7 1c.1 .2 .1 .4 .1 .4c-3.3 39.7-12.9 98.9-32.7 158.7c-3.4 10.5-7.2 20.9-11.2 31.1l-125.5 0 37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L116.1 373.3c-7-8.6-11.6-16.9-13.9-25.2zM116 418.6c11.7 9.9 24.7 18 39.6 22c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c4 14.8 12.1 27.8 22 39.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L116 418.6zm22.7-22.7L182.6 352l175.1 0c-70.2 70.2-148.2 70.1-193.8 57.8c-8.3-2.2-16.6-6.9-25.2-13.9zM385 320l-170.3 0 64-64 143.8 0c-10.8 22.9-23.2 44.6-37.4 64z'
      
    ]
  };

  
    var faFeatherAlt = faFeatherPointed;
  

  
  

  var faMace = {
    prefix: 'fal',
    iconName: 'mace',
    icon: [
      512,
      512,
      [],
      'f6f8',
      
      'M278.3 95.8L288 66.6l9.7 29.2c3.3 10 11.4 17.7 21.5 20.6c36.8 10.6 65.8 39.7 76.4 76.4c2.9 10.1 10.6 18.1 20.6 21.5l29.2 9.7-29.2 9.7c-10 3.3-17.7 11.4-20.6 21.5c-10.6 36.8-39.7 65.8-76.4 76.4c-10.1 2.9-18.1 10.6-21.5 20.6L288 381.4l-9.7-29.2c-3.3-10-11.4-17.7-21.5-20.6c-36.8-10.6-65.8-39.7-76.4-76.4c-2.9-10.1-10.6-18.1-20.6-21.5L130.6 224l29.2-9.7c10-3.3 17.7-11.4 20.6-21.5c10.6-36.8 39.7-65.8 76.4-76.4c10.1-2.9 18.1-10.6 21.5-20.6zM149.7 183.9L74.9 208.8C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l74.7 24.9c5.3 18.4 14.2 35.2 25.8 49.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.1 336.5c14.6 11.6 31.4 20.5 49.8 25.8l24.9 74.7c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l24.9-74.7c47.3-13.7 84.6-51 98.3-98.3l74.7-24.9c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-74.7-24.9c-13.7-47.3-51-84.6-98.3-98.3L303.2 10.9C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9L247.9 85.7c-47.3 13.7-84.6 51-98.3 98.3zM288 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z'
      
    ]
  };

  

  
  

  var faTemperatureArrowDown = {
    prefix: 'fal',
    iconName: 'temperature-arrow-down',
    icon: [
      576,
      512,
      ["temperature-down"],
      'e03f',
      
      'M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L112 96zM176 0C123 0 80 43 80 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L272 96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-34c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zm116.7 43.3l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L448 425.4 448 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faTemperatureDown = faTemperatureArrowDown;
  

  
  

  var faBookmarkSlash = {
    prefix: 'fal',
    iconName: 'bookmark-slash',
    icon: [
      640,
      512,
      [],
      'e0c2',
      
      'M512 48c0-26.5-21.5-48-48-48L176 0c-18.9 0-35.2 10.9-43.1 26.8L160 48.1l0-.1c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 252.8L512 326l0-278zM160 471.4l0-260.2L128 186l0 303.9c0 12.2 9.9 22.1 22.1 22.1c4.4 0 8.6-1.3 12.3-3.7L320 403.2 477.6 508.3c3.6 2.4 7.9 3.7 12.3 3.7c12.2 0 22.1-9.9 22.1-22.1l0-.7-32-25.3 0 7.6L328.9 370.7c-5.4-3.6-12.4-3.6-17.7 0L160 471.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fal',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      'M206.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8l-176 416c-3.4 8.1 .4 17.5 8.5 21s17.5-.4 21-8.5L67.2 384l249.6 0 36.5 86.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21l-176-416zM303.2 352L80.8 352 192 89.1 303.2 352z'
      
    ]
  };

  

  
  

  var faRoadLock = {
    prefix: 'fal',
    iconName: 'road-lock',
    icon: [
      640,
      512,
      [],
      'e567',
      
      'M217.6 32c-26.9 0-50.9 16.8-60.1 42L40.5 394c-15.3 41.8 15.7 86 60.1 86L384 480l0-32-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-203.4 0c-22.2 0-37.7-22.1-30.1-43L187.5 85c4.6-12.6 16.6-21 30.1-21L304 64l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 86.4 0c13.4 0 25.4 8.4 30.1 21l30.8 84.3c9.7-4.2 20.1-7.1 31-8.4L482.5 74c-9.2-25.2-33.2-42-60.1-42L217.6 32zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm192 16c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faInputPipe = {
    prefix: 'fal',
    iconName: 'input-pipe',
    icon: [
      640,
      512,
      [],
      'e1be',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm128 48l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faDeer = {
    prefix: 'fal',
    iconName: 'deer',
    icon: [
      512,
      512,
      [129420],
      'f78e',
      
      'M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 30.9 25.1 56 56 56l8 0 8 0 23.2 0-40 26.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l13.8-9.2-10 35.9L120 176l-16 0-4.8 0c-50.7 0-92.7 39.4-95.8 90L0 319c-.6 8.8 6.2 16.4 15 17s16.4-6.2 17-15l.6-9.9c.7 .8 1.4 1.5 2.2 2.3l3.9 3.9c6 6 9.4 14.1 9.4 22.6l0 4.3c0 3.4-.6 6.9-1.6 10.1l-8.5 25.4c-4.4 13.1-4.4 27.3 0 40.5l21.5 64.4C64.8 501 80.1 512 97.3 512l29.4 0c27.3 0 46.6-26.7 37.9-52.6l-11.6-34.8c-3.6-10.7 .5-22.4 9.8-28.6c15.2-10.1 24.4-26.8 25.3-44.6c21.3 10.9 45 16.6 69 16.6l14.8 0 0 104c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-161c0-3.1 .5-6.2 1.4-9.2L403.9 240l52.5 0c30.7 0 55.6-24.9 55.6-55.6c0-14.7-5.9-28.9-16.3-39.3L440.8 90.2C459.3 81.1 472 62 472 40l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-30.6 0-38.8 0c3.5-7.3 5.4-15.4 5.4-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24zM385.4 96c10.2 0 20 4.1 27.2 11.3l60.4 60.4c4.4 4.4 6.9 10.4 6.9 16.7c0 13-10.6 23.6-23.6 23.6L392 208c-7.1 0-13.3 4.6-15.3 11.4l-22 73.3c-1.8 6-2.7 12.2-2.7 18.4l0 161c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-30.8 0c-23.7 0-46.9-7-66.6-20.2l-13.7-9.2c-5.3-3.5-12.2-3.6-17.6-.1s-8.1 9.8-7.1 16.1l3.7 21.9c1.6 9.7-2.6 19.4-10.8 24.8c-21.4 14.2-30.5 41-22.4 65.3l11.6 34.8c1.7 5.2-2.1 10.5-7.6 10.5l-29.4 0c-3.4 0-6.5-2.2-7.6-5.5L68.2 410.1c-2.2-6.6-2.2-13.7 0-20.2l8.5-25.4c2.2-6.5 3.3-13.4 3.3-20.2l0-4.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-6-6-9.4-14.1-9.4-22.6l0-4.1c0-30.9 25.1-56 56-56l16 0 192.9 0c7.2 0 13.5-4.8 15.4-11.7l20-72.1C353 107.5 368.1 96 385.4 96zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPersonSkiing = {
    prefix: 'fal',
    iconName: 'person-skiing',
    icon: [
      512,
      512,
      [9975,"skiing"],
      'f7c9',
      
      'M424 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 424 0zM1.7 280.8c4-7.9 13.6-11.1 21.5-7.1L236.4 380.9 306.4 297l-95-95c-8-8-12.5-17.9-13.7-28.1l59 28.1L329 274.4c11.7 11.7 12.6 30.4 2 43.1l-65.1 78.2 153.2 77c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 302.3c-7.9-4-11.1-13.6-7.1-21.5zM118.9 65.6L137 74.2l8.7-17.3c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l67.5 32.2 66.8-35.2c27.6-14.5 61.6 .8 69 31.1l18.9 77.6 66.5 31.8 .2 .1c4.9 2.3 8 6.8 8.9 11.8c.5 3.1 .1 6.5-1.3 9.6c0 0 0 0 0 0c-3.8 8-13.4 11.3-21.3 7.5l-.2-.1L151.6 116.6l-9.3 18.6c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6zm150.6 71.7l81.4 38.8-12.8-52.4c-2.5-10.1-13.8-15.2-23-10.4l-45.6 24z'
      
    ]
  };

  
    var faSkiing = faPersonSkiing;
  

  
  

  var faZ = {
    prefix: 'fal',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      'M0 48c0-8.8 7.2-16 16-16l352 0c6.2 0 11.9 3.6 14.5 9.3s1.7 12.3-2.3 17.1L50.5 448 368 448c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L333.5 64 16 64C7.2 64 0 56.8 0 48z'
      
    ]
  };

  

  
  

  var faPinball = {
    prefix: 'fal',
    iconName: 'pinball',
    icon: [
      448,
      512,
      [],
      'e229',
      
      'M352 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM120 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM383.9 448L76.2 348.9c0 0 0 0 0 0c-8.1-2.6-15.2-6.7-21.3-11.8c-27.1-22.7-30.6-63.2-7.9-90.2s63-30.6 90.1-7.9c0 0 0 0 0 0L383 447.2l.5 .4 .4 .3c0 0 0 0 0 .1c0 0 0 0 0 0zm19.8-25.2l-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1c14.9 4.8 30.7-1.8 37.9-15c7.4-12.8 4.2-30.8-8.4-40.6z'
      
    ]
  };

  

  
  

  var faFaceConfused = {
    prefix: 'fal',
    iconName: 'face-confused',
    icon: [
      512,
      512,
      [],
      'e36d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304l11 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-11 0c-61.8 0-121.7 21-169.9 59.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faDemocrat = {
    prefix: 'fal',
    iconName: 'democrat',
    icon: [
      640,
      512,
      [],
      'f747',
      
      'M92.9 0C84.3 0 76 4.6 71.6 12.6c-2.4 4.3-6 11.3-9.2 18.7C59.6 37.9 56 47.5 56 56c0 16 6.9 29.6 14.8 40.1L19.5 155.5C6.9 170 0 188.6 0 207.8l0 5.4C0 254.5 33.5 288 74.7 288c17.5 0 34.4-6.1 47.8-17.3l13.7-11.4L160 330.6l0 5.4 0 128c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48 128 0 0 48c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-128 0-8 0-120c0-4.9-.4-9.7-1.3-14.4c2.9 2.9 5.5 5.8 8 8.7c9.2 10.9 15.9 21.8 20.2 30.1c2.2 4.1 3.7 7.5 4.7 9.8c.5 1.1 .9 2 1.1 2.6l.2 .6c0 0 0 .1 0 .1c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c3 8.3 12.2 12.6 20.5 9.5s12.6-12.2 9.6-20.5L624 240c15-5.5 15-5.5 15-5.5s0 0 0 0s0 0 0 0l0-.1-.1-.3-.4-1c-.3-.9-.8-2-1.5-3.5c-1.3-2.9-3.2-7.1-5.7-12c-5.1-9.8-13-22.8-24.1-35.9c-22.2-26.2-58.3-53.6-111-53.7l-.1 0-218.5 0c-4.3 0-8.5-1.7-11.5-4.8L225.9 81.9c3.6-7.6 6.1-16.3 6.1-25.9c0-8.5-3.6-18.1-6.4-24.7c-3.1-7.4-6.8-14.4-9.2-18.7C212 4.6 203.7 0 195.1 0c-5.8 0-11.4 2-15.8 5.8L144 35.5 108.7 5.8C104.3 2 98.7 0 92.9 0zm403 160c0 0 0 0 .1 0l.2 0c26.4 .1 47.8 21.5 47.8 48l0 112-353.8 0-31-93.1c-1.7-5-5.7-8.9-10.8-10.3s-10.6-.3-14.6 3.1l-31.7 26.4c-7.7 6.4-17.4 9.9-27.4 9.9C51.1 256 32 236.9 32 213.3l0-5.4c0-11.5 4.1-22.7 11.7-31.4l60.4-69.9c5.5-6.3 5.1-15.9-.8-21.8C94.2 75.6 88 65.5 88 56c0 0 0 0 0 0s0-.1 0-.3c0-.2 .1-.5 .1-.9c.1-.8 .4-1.7 .7-2.9c.7-2.4 1.7-5.2 3-8.2c1.1-2.5 2.3-5.1 3.4-7.5l37.5 31.5c3.7 3.1 8.5 4.4 13.3 3.5c.6-.1 1.1-.2 1.7-.3c3-.4 5.7-1.7 8-3.6l37-31.1c1.2 2.4 2.3 4.9 3.4 7.5c1.3 3 2.3 5.8 3 8.2c.3 1.2 .6 2.1 .7 2.9c.1 .4 .1 .7 .1 .9c0 .2 0 .3 0 .3s0 0 0 0c0 6.1-2.5 12.5-7.2 19.1c-4.4 6.3-3.8 14.9 1.6 20.4l48.7 50c9 9.3 21.4 14.5 34.4 14.5l218.4 0zM192 464l0-112 352 0 0 112c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16zm80-256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm96-16c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fal',
    iconName: 'link-simple-slash',
    icon: [
      640,
      512,
      [],
      'e1ce',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM608 256c0-88.4-71.6-160-160-160l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c70.7 0 128 57.3 128 128c0 35.5-14.4 67.6-37.7 90.8l25.3 19.9C591.1 338 608 299 608 256zM456 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-53 0 40.5 32 12.4 0zM196.4 240L184 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l53 0-40.5-32zm-94.7-74.8L76.5 145.3C48.9 174 32 213 32 256c0 88.4 71.6 160 160 160l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-70.7 0-128-57.3-128-128c0-35.5 14.4-67.6 37.7-90.8z'
      
    ]
  };

  

  
  

  var faPickaxe = {
    prefix: 'fal',
    iconName: 'pickaxe',
    icon: [
      512,
      512,
      [],
      'e5bf',
      
      'M474.7 321.8c16.1-78.2-7.8-162.5-65.3-219.8C352.2 45 268.3 21.2 190.5 37.2c61.8 30 118.3 73 164.8 119.5c46.9 46.9 89.3 103.4 119.4 165.1zM138.5 49.6c-13.4-5-13.7-24.5-.5-29.8C237.7-20.6 355.6 3.2 432 79.3C508.6 155.7 532.7 274 492.2 374c-5.4 13.3-24.9 13-29.8-.5C434.7 301.2 387 233.7 332.7 179.3C278.6 125.2 210.8 76.8 138.5 49.6zM10.1 448.5L271.9 167.3c8 6.6 16.1 13.7 24.1 21.1L33.5 470.3c-1 1.1-1.5 2.5-1.5 3.9c0 3.2 2.6 5.7 5.7 5.7c1.5 0 2.8-.6 3.9-1.5L323.6 216c7.4 8 14.5 16.1 21.1 24.1L63.5 501.9c-7 6.5-16.2 10.1-25.7 10.1C16.9 512 0 495.1 0 474.3c0-9.5 3.6-18.7 10.1-25.7zM443.3 20.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faTicketsSimple = {
    prefix: 'fal',
    iconName: 'tickets-simple',
    icon: [
      640,
      512,
      [],
      'e659',
      
      'M128 96c0-17.7 14.3-32 32-32l416 0c17.7 0 32 14.3 32 32l0 47.5c-23.7 11.8-40 36.2-40 64.5s16.3 52.8 40 64.5l0 47.5c0 17.7-14.3 32-32 32l-416 0c-17.7 0-32-14.3-32-32l0-47.5c23.7-11.8 40-36.2 40-64.5s-16.3-52.8-40-64.5L128 96zm484.1 45.6l.1 0c0 0 0 0 0 0l-.1 0zm.1 132.9l-.1 0c0 0 .1 0 .1 0zm-488.4 0l.1 0c-.1 0-.1 0-.1 0zm0-132.9l.1 0c-.1 0-.1 0-.1 0zM96 96l0 56c0 8.8 7.4 15.7 15.6 19.1c14.4 6.1 24.4 20.3 24.4 36.9s-10.1 30.8-24.4 36.9C103.4 248.3 96 255.2 96 264l0 56c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-56c0-8.8-7.4-15.7-15.6-19.1C610.1 238.8 600 224.6 600 208s10.1-30.8 24.4-36.9c8.1-3.4 15.6-10.3 15.6-19.1l0-56c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 368c0 61.9 50.1 112 112 112l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-416 0c-44.2 0-80-35.8-80-80l0-256z'
      
    ]
  };

  

  
  

  var faCommentsDollar = {
    prefix: 'fal',
    iconName: 'comments-dollar',
    icon: [
      640,
      512,
      [],
      'f653',
      
      'M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1s0 0 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5c0 0 0 0 0 0l.1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6l0 13.8c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.2 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2s0 0 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8l0 13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-14.3c-9.7-1.9-18.8-5-26.7-7.7c0 0 0 0 0 0s0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2c0 0 0 0 0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4s0 0 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6l0-13.9c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFaceHushed = {
    prefix: 'fal',
    iconName: 'face-hushed',
    icon: [
      512,
      512,
      [],
      'e37b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faPersonSnowmobiling = {
    prefix: 'fal',
    iconName: 'person-snowmobiling',
    icon: [
      640,
      512,
      ["snowmobile"],
      'f7d1',
      
      'M256 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 176 56zM335.8 74.3c7.6-4.5 17.4-2.1 21.9 5.5l43.8 73 156.8 78.4c10.8 5.4 17.7 16.5 17.7 28.6l0 59.1c0 10.7-5.3 20.7-14.2 26.6l-76.1 50.8 63.1 82c.4 .6 .8 1.2 1.2 1.8l19.5 0 43.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7l-144 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l77.7 0-61.5-80-134.8 0c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l39.2-78.3C76.6 278.8 87.7 272 99.8 272L288 272l36-48-44 0c-5 0-9.8-2.4-12.8-6.4l-33.4-44.5c-6.2-8.2-15.9-13.1-26.2-13.1c-12.9 0-24.6 7.6-29.9 19.4l-19.1 43.1c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l19.1-43.1c10.4-23.4 33.6-38.4 59.1-38.4c20.4 0 39.5 9.6 51.8 25.9L288 192l60 0 22.1-29.4L330.3 96.2c-4.5-7.6-2.1-17.4 5.5-22zM470.3 368L544 318.9l0-59.1L393.6 184.6l-80 106.6c-6 8.1-15.5 12.8-25.6 12.8L99.8 304 75.7 352.1c1.4-.1 2.8-.1 4.3-.1l160 0c18 0 34.6 6 48 16l167.8 0 .3 0 14.2 0zM80 384c-26.5 0-48 21.5-48 48s21.5 48 48 48l160 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L80 384z'
      
    ]
  };

  
    var faSnowmobile = faPersonSnowmobiling;
  

  
  

  var faChurch = {
    prefix: 'fal',
    iconName: 'church',
    icon: [
      640,
      512,
      [9962],
      'f51d',
      
      'M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 0 39.4-115.5 77c-17.8 11.9-28.5 31.9-28.5 53.3L160 480l-96 0c-17.7 0-32-14.3-32-32l0-69.9c0-10.9 5.5-21 14.6-26.9L128 298.6l0-38.1L29.2 324.4C11 336.2 0 356.4 0 378.1L0 448c0 35.3 28.7 64 64 64l120 0s0 0 0 0l72 0 32 0 64 0 32 0 72 0s0 0 0 0l120 0c35.3 0 64-28.7 64-64l0-69.9c0-21.7-11-41.9-29.2-53.7L512 260.5l0 38.1 81.4 52.7c9.1 5.9 14.6 16 14.6 26.9l0 69.9c0 17.7-14.3 32-32 32l-96 0 0-230.3c0-21.4-10.7-41.4-28.5-53.3L336 119.4 336 80l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0 0-32zM448 480l-64 0 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96-64 0 0-230.3c0-10.7 5.3-20.7 14.2-26.6L320 147.2l113.8 75.8C442.7 229 448 239 448 249.7L448 480zm-96-96l0 96-64 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32z'
      
    ]
  };

  

  
  

  var faTableCellsColumnLock = {
    prefix: 'fal',
    iconName: 'table-cells-column-lock',
    icon: [
      640,
      512,
      [],
      'e678',
      
      'M352 64l0 96 128 0 0-64c0-17.7-14.3-32-32-32l-96 0zm-32 0L192 64l0 96 128 0 0-96zM160 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l96 0 0-384zm32 384l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 40.6 0c-5.4 9.4-8.6 20.3-8.6 32l-32 0 0 96zM320 320l0-128-128 0 0 128 128 0zm208-96c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm160 80l-160 0 0 128 160 0 0-128z'
      
    ]
  };

  

  
  

  var faCalendarLinesPen = {
    prefix: 'fal',
    iconName: 'calendar-lines-pen',
    icon: [
      576,
      512,
      [],
      'e472',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l194.8 0c-3.1-8.8-3.7-18.4-1.4-27.8l1.1-4.2L64 480c-17.7 0-32-14.3-32-32l0-256 352 0 32 0 32 0 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM96 272c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm422.8-8l17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40L496.2 264c6.2-6.2 16.4-6.2 22.6 0zM342.5 417.7L448.7 311.5l40 40L382.4 457.7c-2 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zM473.5 241.4L319.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2L382.8 493c8.4-2.1 16.1-6.5 22.3-12.6L558.8 326.6c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z'
      
    ]
  };

  

  
  

  var faGlassCitrus = {
    prefix: 'fal',
    iconName: 'glass-citrus',
    icon: [
      512,
      512,
      [],
      'f869',
      
      'M373.4 255.9C432.7 253.1 480 204 480 144c0-61.9-50.1-112-112-112c-44.7 0-83.2 26.2-101.2 64l-34.6 0C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 79-63.6 143.1-142.3 144l3.7-32.1zM40.9 160c-4.8 0-8.5 4.2-7.9 8.9L43 256l266 0 10-87.1c.5-4.7-3.2-8.9-7.9-8.9L40.9 160zM65.4 451.7C67.3 467.8 81 480 97.2 480l157.4 0c16.3 0 29.9-12.2 31.8-28.3L305.3 288 46.6 288 65.4 451.7zM1.2 172.6C-1.6 148.8 17 128 40.9 128L311 128c23.9 0 42.5 20.8 39.7 44.6L318.3 455.3c-3.7 32.3-31.1 56.7-63.6 56.7L97.2 512c-32.5 0-59.9-24.4-63.6-56.7L1.2 172.6z'
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fal',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 48c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-85 0L135.3 448 240 448c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l85 0L248.7 64 144 64c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faCediSign = {
    prefix: 'fal',
    iconName: 'cedi-sign',
    icon: [
      384,
      512,
      [],
      'e0df',
      
      'M208 0c8.8 0 16 7.2 16 16l0 48c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3c7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96c-1.3 0-2.7 0-4 0L224 416c1.3 0 2.7 0 4 0c37 0 71.1-12 98.5-32.1c7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-51.2C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8L192 16c0-8.8 7.2-16 16-16zM64 256c0 76 54.5 140.1 128 156.1l0-312.3C118.5 115.9 64 180 64 256z'
      
    ]
  };

  

  
  

  var faCouch = {
    prefix: 'fal',
    iconName: 'couch',
    icon: [
      640,
      512,
      [],
      'f4b8',
      
      'M448 64c53 0 96 43 96 96l0 37.5c10-3.5 20.8-5.5 32-5.5l0-32c0-70.7-57.3-128-128-128L192 32C121.3 32 64 89.3 64 160l0 32c11.2 0 22 1.9 32 5.5L96 160c0-53 43-96 96-96l256 0zM96 320l0 96 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-144c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32zM80 480c20.9 0 38.7-13.4 45.3-32l389.5 0c6.6 18.6 24.4 32 45.3 32l32 0c26.5 0 48-21.5 48-48l0-144c0-35.3-28.7-64-64-64s-64 28.7-64 64l-384 0c0-35.3-28.7-64-64-64s-64 28.7-64 64L0 432c0 26.5 21.5 48 48 48l32 0zm48-64l0-96 384 0 0 96-384 0zm416 16l0-16 0-96 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 144c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faMartiniGlassEmpty = {
    prefix: 'fal',
    iconName: 'martini-glass-empty',
    icon: [
      512,
      512,
      ["glass-martini"],
      'f000',
      
      'M33 32c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L256 257.4 479.7 33.7c.2-.2 .3-.4 .3-.7c0-.5-.4-1-1-1L33 32zM240 286.6L9.7 56.3C3.5 50.1 0 41.7 0 33C0 14.8 14.8 0 33 0L479 0c18.2 0 33 14.8 33 33c0 8.7-3.5 17.1-9.7 23.3L272 286.6 272 480l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0-112 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-193.4z'
      
    ]
  };

  
    var faGlassMartini = faMartiniGlassEmpty;
  

  
  

  var faMemo = {
    prefix: 'fal',
    iconName: 'memo',
    icon: [
      384,
      512,
      [],
      'e1d8',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm80 64l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fal',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  

  
  

  var faCommentCheck = {
    prefix: 'fal',
    iconName: 'comment-check',
    icon: [
      512,
      512,
      [],
      'f4ac',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM363.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faHeartHalf = {
    prefix: 'fal',
    iconName: 'heart-half',
    icon: [
      512,
      512,
      [],
      'e1ab',
      
      'M256 451.5l0-.3L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L224 465.1l.3 .2 3.5 3.2 9 8.4c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5l0-12.3 0-4.7zm-32-30.2L69.4 277C45.6 254.7 32 223.6 32 190.9l0-5.8c0-54.2 39.2-100.5 92.7-109.4c35.3-5.9 71.4 5.6 96.7 31l2.6 2.6 0 312z'
      
    ]
  };

  

  
  

  var faTicketPerforated = {
    prefix: 'fal',
    iconName: 'ticket-perforated',
    icon: [
      640,
      512,
      [],
      'e63e',
      
      'M32 128c0-17.7 14.3-32 32-32l512 0c17.7 0 32 14.3 32 32l0 49.6c-36.5 7.4-64 39.7-64 78.4s27.5 71 64 78.4l0 49.6c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-66.4c0-8-8-13.6-16-13.6c-26.5 0-48-21.5-48-48s21.5-48 48-48c8 0 16-5.6 16-13.6l0-66.4c0-35.3-28.7-64-64-64L64 64zm416 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fal',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm32 48l32 0c7.1 0 13.4 4.7 15.4 11.6L158 318.9c1.3 4.6 2 9.3 2 14l0 3.1c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3.1c0-4.7 .7-9.5 2-14l14.7-51.3c2-6.9 8.2-11.6 15.4-11.6zm.7 71.7c-.5 1.7-.7 3.5-.7 5.2l0 3.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-3.1c0-1.8-.2-3.5-.7-5.2L115.9 288l-7.9 0L96.7 327.7z'
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faHouseChimneyCrack = {
    prefix: 'fal',
    iconName: 'house-chimney-crack',
    icon: [
      576,
      512,
      ["house-damage"],
      'f6f1',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4 384 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 136.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235l0 197c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1L480 64l-64 0 0 43.6 64 56.5zM96 206.7L96 432c0 26.5 21.5 48 48 48l130.1 0-47.4-71.1c-4.9-7.4-2.9-17.3 4.4-22.2l79.8-53.2-82.2-82.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-82.7 55.1L312.6 480 432 480c26.5 0 48-21.5 48-48l0-225.3L288 37.3 96 206.7z'
      
    ]
  };

  
    var faHouseDamage = faHouseChimneyCrack;
  

  
  

  var faHeartCircleCheck = {
    prefix: 'fal',
    iconName: 'heart-circle-check',
    icon: [
      576,
      512,
      [],
      'e4fd',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faArchway = {
    prefix: 'fal',
    iconName: 'archway',
    icon: [
      512,
      512,
      [],
      'f557',
      
      'M0 48c0-8.8 7.2-16 16-16l32 0 416 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 384 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0-40 0-56 0c-8.8 0-16-7.2-16-16l0-112c0-53-43-96-96-96s-96 43-96 96l0 112c0 8.8-7.2 16-16 16l-56 0-40 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L32 64 16 64C7.2 64 0 56.8 0 48zM64 64l0 64 384 0 0-64L64 64zm0 96l0 288 24 0 40 0 0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96 40 0 24 0 0-288L64 160z'
      
    ]
  };

  

  
  

  var faClockTwoThirty = {
    prefix: 'fal',
    iconName: 'clock-two-thirty',
    icon: [
      512,
      512,
      [],
      'e35b',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400l0-144c0-5.3 2.7-10.3 7.1-13.3l96-64c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L272 264.6 272 400c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faHashtagLock = {
    prefix: 'fal',
    iconName: 'hashtag-lock',
    icon: [
      576,
      512,
      [],
      'e415',
      
      'M195.6 32.4c8.6 2 14 10.6 12 19.2L186.3 144l127.2 0 23-99.6c2-8.6 10.6-14 19.2-12s14 10.6 12 19.2L346.3 144l85.7 0c8.8 0 16 7.2 16 16c0 .4 0 .8 0 1.1c-15.1 2.2-29.2 7.3-41.7 14.9l-67.4 0L271.6 467.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2L261.7 368l-127.2 0-23 99.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2L101.7 368 16 368c-8.8 0-16-7.2-16-16s7.2-16 16-16l93.1 0L146 176l-98 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l105.4 0 23-99.6c2-8.6 10.6-14 19.2-12zM178.9 176L142 336l127.2 0L306 176l-127.2 0zM464 224c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faBorderOuter = {
    prefix: 'fal',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faArrowsToDot = {
    prefix: 'fal',
    iconName: 'arrows-to-dot',
    icon: [
      512,
      512,
      [],
      'e4be',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4L187.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 137.4 272 16zm16 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm59.3 171.3c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 374.6 240 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0zM84.7 164.7c-6.2 6.2-6.2 16.4 0 22.6L137.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l121.4 0L84.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0zm342.6 0c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L374.6 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-121.4 0 52.7-52.7c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faRestroomSimple = {
    prefix: 'fal',
    iconName: 'restroom-simple',
    icon: [
      640,
      512,
      [],
      'e23a',
      
      'M96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm96 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM57.8 236c2.1-24.9 22.9-44 47.8-44l44.8 0c25 0 45.8 19.1 47.8 44l4.1 49.3c1.6 18.7-13.2 34.7-31.9 34.7l-84.9 0c-18.7 0-33.4-16-31.9-34.7L57.8 236zm-31.9-2.7l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-147.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-8.8 0-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480c0-8.8-7.2-16-16-16zM512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 64l31.4 0c14.3 0 26.8 9.5 30.8 23.2L597.6 352l-171.2 0 39.1-136.8c3.9-13.7 16.5-23.2 30.8-23.2zm0-32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 64 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 21.6 0c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z'
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fal',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      'M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z'
      
    ]
  };

  

  
  

  var faEnvelopeCircleCheck = {
    prefix: 'fal',
    iconName: 'envelope-circle-check',
    icon: [
      640,
      512,
      [],
      'e4e8',
      
      'M64 96l384 0c17.7 0 32 14.3 32 32l0 32.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7l0-32.7c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l296.2 0c-8.1-9.8-15.2-20.6-21-32L64 416c-17.7 0-32-14.3-32-32l0-176.4L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0l17.1-12.5c1-16.2 4.3-31.8 9.4-46.6l-45.4 33.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9 32 128c0-17.7 14.3-32 32-32zM496 224a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 353.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faWave = {
    prefix: 'fal',
    iconName: 'wave',
    icon: [
      576,
      512,
      [],
      'e65b',
      
      'M304 80c-88.4 0-160 71.6-160 160c0 61.9-50.1 112-112 112c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80c0-106 86-192 192-192c64.9 0 122.4 32.3 157.1 81.6c4.2 5.9 3.8 14-.8 19.5s-12.5 7.3-19.1 4.1c-12.4-5.9-26.4-9.2-41.1-9.2c-53 0-96 43-96 96c0 44.2 35.8 80 80 80c0 0 0 0 0 0c20.9 0 41.6-10 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 337.9 414.3 352 384 352c0 0 0 0 0 0c-61.9 0-112-50.1-112-112c0-70.7 57.3-128 128-128c0 0 0 0 0 0c-26.8-20.1-60-32-96-32zM133.8 426.8C150.3 438 171.1 448 192 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9z'
      
    ]
  };

  

  
  

  var faCommentMiddleTop = {
    prefix: 'fal',
    iconName: 'comment-middle-top',
    icon: [
      512,
      512,
      [],
      'e14a',
      
      'M216.9 117.7L256 39.6l39.1 78.1c4.3 8.6 12.3 14.8 21.7 16.9C415.4 156.5 480 227.6 480 304c0 91.3-93.8 176-224 176S32 395.3 32 304c0-76.4 64.6-147.5 163.3-169.4c9.4-2.1 17.4-8.3 21.7-16.9zm44.5-89s0 0 0 0L256 25.9l5.5 2.7s0 0 0 0zm62.2 74.7l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z'
      
    ]
  };

  

  
  

  var faGridRound2 = {
    prefix: 'fal',
    iconName: 'grid-round-2',
    icon: [
      512,
      512,
      [],
      'e5db',
      
      'M128 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 384a96 96 0 1 1 192 0zm96-256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z'
      
    ]
  };

  

  
  

  var faVirus = {
    prefix: 'fal',
    iconName: 'virus',
    icon: [
      512,
      512,
      [],
      'e074',
      
      'M75 75c-12.5 12.5-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5L288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75zm331.2 30.8C350.8 161.2 390.1 256 468.5 256c-78.4 0-117.7 94.8-62.2 150.2c0 0 0 0 0 0C350.8 350.8 256 390 256 468.4c0-78.4-94.8-117.6-150.2-62.2C161.2 350.8 121.9 256 43.5 256c78.4 0 117.7-94.8 62.2-150.2c0 0 0 0 0 0C161.2 161.2 256 121.9 256 43.5c0 78.4 94.8 117.7 150.2 62.2zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBookAtlas = {
    prefix: 'fal',
    iconName: 'book-atlas',
    icon: [
      448,
      512,
      ["atlas"],
      'f558',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l336 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 32C46.3 32 32 46.3 32 64l0 328.6zM176.5 224l-31 0c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8l31 0zM112 208a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16l-31 0c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 131.2c6.6 16.9 11 37.8 12.5 60.8l31 0c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 224l-46.9 0c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32l46.9 0c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z'
      
    ]
  };

  
    var faAtlas = faBookAtlas;
  

  
  

  var faTruckPlow = {
    prefix: 'fal',
    iconName: 'truck-plow',
    icon: [
      640,
      512,
      [],
      'f7de',
      
      'M176 64l94.1 0c5.6 0 10.7 2.9 13.7 7.7L357.2 192 160 192l0-112c0-8.8 7.2-16 16-16zM394.8 192l-5.1-8.3L311 55c-8.7-14.3-24.2-23-41-23L176 32c-26.5 0-48 21.5-48 48l0 112-72 0c-30.9 0-56 25.1-56 56l0 96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96l48 0c0 53 43 96 96 96s96-43 96-96l56.5 0 75.2 90.2c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5L544 362.2l0-10.2 0-138.2 76.3-91.6c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-80 96c-2.4 2.9-3.7 6.5-3.7 10.2l0 144-32.8 0c.5-2.6 .8-5.3 .8-8l0-96c0-30.9-25.1-56-56-56l-29.2 0zM448 330.9C430.8 305 401.4 288 368 288c-41.8 0-77.4 26.7-90.5 64l-58.9 0c-13.2-37.3-48.7-64-90.5-64c-41.7 0-77.1 26.5-90.4 63.6c-3.2-1-5.6-4.1-5.6-7.6l0-96c0-13.3 10.7-24 24-24l368 0c13.3 0 24 10.7 24 24l0 82.9zM64 384a64 64 0 1 1 128 0A64 64 0 1 1 64 384zm304-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faShieldHalved = {
    prefix: 'fal',
    iconName: 'shield-halved',
    icon: [
      512,
      512,
      ["shield-alt"],
      'f3ed',
      
      'M240 38.8l0 433.8C86.8 397.1 48.5 233.2 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6L240 38.8zm32 433.8l0-433.9 173.2 73.5c11.3 4.8 18.9 15.5 18.8 27.6c-.5 93.3-38.8 257.3-192 332.8zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8z'
      
    ]
  };

  
    var faShieldAlt = faShieldHalved;
  

  
  

  var faFaceConfounded = {
    prefix: 'fal',
    iconName: 'face-confounded',
    icon: [
      512,
      512,
      [],
      'e36c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216.9 98.7L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0zM129.3 216.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 256l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 256l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z'
      
    ]
  };

  

  
  

  var faPalletBox = {
    prefix: 'fal',
    iconName: 'pallet-box',
    icon: [
      640,
      512,
      [],
      'e208',
      
      'M464 32c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l64 0 0 112c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3l0-112 64 0zM272 32l96 0 0 80L329.6 83.2c-5.7-4.3-13.5-4.3-19.2 0L272 112l0-80zM176 0c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48L176 0zM0 368c0 8.8 7.2 16 16 16l48 0 0 96-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 240 0 240 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-96 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0-240 0L80 352l-64 0c-8.8 0-16 7.2-16 16zM96 480l0-96 208 0 0 96L96 480zm240 0l0-96 208 0 0 96-208 0z'
      
    ]
  };

  

  
  

  var faGreaterThanEqual = {
    prefix: 'fal',
    iconName: 'greater-than-equal',
    icon: [
      448,
      512,
      [],
      'f532',
      
      'M41.9 62.8c-8.2-3.3-12.1-12.7-8.8-20.9s12.7-12.1 20.9-8.8l352 144c6 2.5 9.9 8.3 9.9 14.8s-3.9 12.3-9.9 14.8l-352 144c-8.2 3.3-17.5-.6-20.9-8.8s.6-17.5 8.8-20.9L357.7 192 41.9 62.8zM432 448c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0z'
      
    ]
  };

  

  
  

  var faSquareArrowUp = {
    prefix: 'fal',
    iconName: 'square-arrow-up',
    icon: [
      448,
      512,
      ["arrow-square-up"],
      'f33c',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm235.3 36.7l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 182.6 240 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-185.4-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faArrowSquareUp = faSquareArrowUp;
  

  
  

  var faBurgerSoda = {
    prefix: 'fal',
    iconName: 'burger-soda',
    icon: [
      640,
      512,
      [],
      'f858',
      
      'M202.4 36.4C207.8 15 227 0 249 0l23 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-23 0c-7.3 0-13.7 5-15.5 12.1l-21 83.9L368 128c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0-95.6 0c-.2 0-.5 0-.7 0L16 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l163.5 0 22.9-91.6zM60.3 468l-23-276 32.1 0L92.2 465.3c.7 8.3 7.6 14.7 15.9 14.7L260 480c3.7 11.9 9.7 22.7 17.5 32c-.6 0-1.1 0-1.7 0l-167.7 0c-25 0-45.8-19.1-47.8-44zM330.9 279.4c-5.7 6.2-9.2 14.6-10.4 24.4l287 0c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4l-305.2 0c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3l277.3 0c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7l-234.7 0c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7l234.7 0c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3l-277.3 0z'
      
    ]
  };

  

  
  

  var faCabinetFiling = {
    prefix: 'fal',
    iconName: 'cabinet-filing',
    icon: [
      448,
      512,
      [128452],
      'f64b',
      
      'M416 240L32 240 32 64c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 176zM0 256l0 16L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-176 0-16 0-16 0-176c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 240l0 16zM416 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-176 384 0 0 176zM160 96c-17.7 0-32 14.3-32 32l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32L160 96zm0 256c-17.7 0-32 14.3-32 32l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32l-128 0z'
      
    ]
  };

  

  
  

  var faListDropdown = {
    prefix: 'fal',
    iconName: 'list-dropdown',
    icon: [
      512,
      512,
      [],
      'e1cf',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64 448 0 0-64c0-17.7-14.3-32-32-32L64 64zM32 192l0 224c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-224L32 192zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 256l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z'
      
    ]
  };

  

  
  

  var faWatchCalculator = {
    prefix: 'fal',
    iconName: 'watch-calculator',
    icon: [
      384,
      512,
      [],
      'f8f0',
      
      'M96 48l0 16 192 0 0-16c0-8.8-7.2-16-16-16L112 32c-8.8 0-16 7.2-16 16zM64 65.6L64 48C64 21.5 85.5 0 112 0L272 0c26.5 0 48 21.5 48 48l0 17.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368L0 144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16L96 448l0 16zM80 96c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L80 96zm16 96l192 0 0-32L96 160l0 32zM64 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L80 224c-8.8 0-16-7.2-16-16l0-64zm64 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faWatchApple = {
    prefix: 'fal',
    iconName: 'watch-apple',
    icon: [
      384,
      512,
      [],
      'e2cb',
      
      'M96 48l0 16 192 0 0-16c0-8.8-7.2-16-16-16L112 32c-8.8 0-16 7.2-16 16zM64 65.6L64 48C64 21.5 85.5 0 112 0L272 0c26.5 0 48 21.5 48 48l0 17.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368L0 144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16L96 448l0 16zM80 96c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L80 96zM192 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56-120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCruzeiroSign = {
    prefix: 'fal',
    iconName: 'cruzeiro-sign',
    icon: [
      448,
      512,
      [],
      'e152',
      
      'M64 256C64 150.1 150.6 64 257.7 64c49.6 0 94.9 18.5 129.2 48.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6c-39.9-35.4-92.7-57-150.4-57C133.2 32 32 132.2 32 256s101.2 224 225.7 224c57.7 0 110.5-21.6 150.4-57c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3C352.6 429.5 307.3 448 257.7 448c-11.5 0-22.7-1-33.7-2.9L224 320c0-26.5 21.5-48 48-48c15.1 0 29.3 7.1 38.4 19.2l4.8 6.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4L336 272c-15.1-20.1-38.8-32-64-32c-18 0-34.6 6-48 16l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80 0 116.7C117.3 410 64 339.1 64 256z'
      
    ]
  };

  

  
  

  var faShelvesEmpty = {
    prefix: 'fal',
    iconName: 'shelves-empty',
    icon: [
      640,
      512,
      [],
      'e246',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 176 0 432l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 576 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-256 0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144L32 160 32 16zm0 176l576 0 0 224L32 416l0-224z'
      
    ]
  };

  

  
  

  var faGarageOpen = {
    prefix: 'fal',
    iconName: 'garage-open',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M313.8 36c4-1.7 8.4-1.7 12.4 0L588.4 146.4c11.9 5 19.6 16.6 19.6 29.5L608 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-320.1c0-25.8-15.4-49-39.2-59L338.6 6.5c-11.9-5-25.3-5-37.3 0L39.2 116.9C15.4 126.9 0 150.1 0 175.9L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-320.1c0-12.9 7.7-24.5 19.6-29.5L313.8 36zM128 192c-17.7 0-32 14.3-32 32l0 272c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 384 0 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-272c0-17.7-14.3-32-32-32l-384 0zm384 64l-384 0 0-32 384 0 0 32zM212.5 320l-10.6 32.8C186.3 362.7 176 380.2 176 400l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 224 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-19.8-10.3-37.3-25.9-47.2L427.5 320l-33.6 0 7.8 24-163.3 0 7.8-24-33.6 0zM432 400l0 48-224 0 0-48c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24zM248 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassArrowsRotate = {
    prefix: 'fal',
    iconName: 'magnifying-glass-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e65e',
      
      'M384 43.3l0 68.7-68.7 0L384 43.3zM392 144c13.3 0 24-10.7 24-24l0-96c0-9.7-5.8-18.5-14.8-22.2S381.9 .2 375 7L337.1 44.9C301.7 16.8 256.8 0 208 0C99 0 9.5 83.9 .7 190.7c-.7 8.8 5.8 16.5 14.6 17.3c.4 0 .8 .1 1.2 .1l.3 0c8.2-.1 15.1-6.4 15.8-14.7C40.1 103 115.7 32 208 32c39.9 0 76.8 13.3 106.3 35.7L279 103c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l96 0zM32 372.7L32 304l68.7 0L32 372.7zM24 272c-13.3 0-24 10.7-24 24l0 96c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l96-96c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8l-96 0zm342 71.3c27.7-32.3 45.6-73.1 49.3-118c.7-8.8-5.8-16.5-14.6-17.3c-.4 0-.8 0-1.2-.1l-.3 0c-8.2 .1-15.1 6.4-15.8 14.7C375.9 313 300.3 384 208 384c-39.9 0-76.8-13.3-106.3-35.7L78.9 371.1C114.3 399.2 159.2 416 208 416c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3z'
      
    ]
  };

  

  
  

  var faFireExtinguisher = {
    prefix: 'fal',
    iconName: 'fire-extinguisher',
    icon: [
      512,
      512,
      [129519],
      'f134',
      
      'M320 96l0-16 0-16L480 32l0 96L320 96zM288 64l-96 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48C104.5 64 55.6 92.3 27 135.1c-7.3 11-13.4 22.9-17.8 35.6c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8c3.6-10.1 8.4-19.7 14.3-28.4C76.5 118.6 115.6 96 160 96l0 33.1c-54.3 7.8-96 54.4-96 110.9l0 208c0 35.3 28.7 64 64 64l96 0c35.3 0 64-28.7 64-64l0-208c0-56.4-41.7-103.1-96-110.9L192 96l96 0s0 0 0 0c0 15.3 10.8 28.4 25.7 31.4l160 32c9.4 1.9 19.1-.6 26.6-6.6s11.7-15.2 11.7-24.7l0-96c0-9.6-4.3-18.7-11.7-24.7s-17.2-8.5-26.6-6.6l-160 32c-15 3-25.7 16.1-25.7 31.4zM176 160c44.2 0 80 35.8 80 80l0 144L96 384l0-144c0-44.2 35.8-80 80-80zm80 288c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-32 160 0 0 32z'
      
    ]
  };

  

  
  

  var faArrowsToDottedLine = {
    prefix: 'fal',
    iconName: 'arrows-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a6',
      
      'M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 137.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm384 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM320 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM128 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm107.3 44.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6 240 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-121.4-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z'
      
    ]
  };

  

  
  

  var faCircleBookOpen = {
    prefix: 'fal',
    iconName: 'circle-book-open',
    icon: [
      512,
      512,
      ["book-circle"],
      'e0ff',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-69.7l0 130 .7-.1c12.3-2.1 29.3-4.2 47.3-4.2c18.4 0 35.4 5.9 48 11.8l0-137.5c-2.4-1-5.3-2.1-8.5-3.2c-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2zM246 364.5l-.1-.1c-.2-.1-.4-.3-.8-.6c-.7-.5-1.8-1.3-3.3-2.3c-2.9-2-7.2-4.6-12.5-7.3C218.7 348.8 205.3 344 192 344c-15.7 0-30.8 1.9-42 3.8c-5.6 1-10.1 1.9-13.3 2.6c-1.6 .4-2.8 .6-3.6 .8l-.9 .2-.2 0s0 0 0 0s0 0 0 0c-4.8 1.3-9.9 .2-13.8-2.8s-6.2-7.7-6.2-12.7l0-160c0-5.9 3.3-11.4 8.5-14.1L128 176c-7.5-14.1-7.5-14.1-7.5-14.1s0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .4-.2c.3-.2 .7-.4 1.2-.6c1.1-.5 2.5-1.2 4.4-2.1c3.7-1.7 9-3.9 15.5-6c12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c5.7 1.9 10.6 3.9 14.2 5.5c3.6-1.6 8.5-3.5 14.2-5.5c12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c6.4 2.2 11.7 4.4 15.5 6c1.9 .8 3.4 1.5 4.4 2.1c.5 .3 .9 .5 1.2 .6l.4 .2 .1 .1c0 0 0 0 0 0s0 0 0 0s0 0 0 0L384 176l7.5-14.1c5.2 2.8 8.5 8.2 8.5 14.1l0 160c0 5-2.3 9.6-6.2 12.7s-9 4.1-13.8 2.8c0 0 0 0 0 0s0 0 0 0l-.2 0-.9-.2c-.8-.2-2-.5-3.6-.8c-3.1-.7-7.7-1.6-13.3-2.6c-11.2-1.9-26.3-3.8-42-3.8c-13.3 0-26.7 4.8-37.4 10.3c-5.2 2.7-9.5 5.3-12.5 7.3c-1.5 1-2.6 1.8-3.3 2.3c-.4 .3-.6 .5-.8 .6l-.1 .1c-.3 .3-.7 .5-1 .8c-.3 .2-.6 .4-.9 .5c-2.3 1.4-5 2.1-7.6 2.2c-.4 0-.8 0-1.3 0c-2.7-.1-5.3-1-7.7-2.4c-.5-.3-1-.7-1.5-1zm26-40.7c12.6-6 29.6-11.8 48-11.8c18.1 0 35 2.1 47.3 4.2l.7 .1 0-130c-2.4-1-5.3-2.1-8.5-3.2c-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2l0 137.5z'
      
    ]
  };

  
    var faBookCircle = faCircleBookOpen;
  

  
  

  var faArrowsRotate = {
    prefix: 'fal',
    iconName: 'arrows-rotate',
    icon: [
      512,
      512,
      [128472,"refresh","sync"],
      'f021',
      
      'M69.4 210.6C89.8 126.5 165.6 64 256 64c71.1 0 133.1 38.6 166.3 96L368 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l80.7 0 15.3 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 60.6C408.8 75.5 337.5 32 256 32C149.6 32 60.5 106.2 37.7 205.6C35.5 215.2 43.1 224 53 224c7.9 0 14.6-5.7 16.5-13.4zm373.2 90.9C422.2 385.5 346.4 448 256 448c-71.1 0-133.1-38.6-166.3-96l54.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80.9 0-15.1 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-60.2C103.4 436.6 174.7 480 256 480c106.4 0 195.5-74.2 218.3-173.6c2.2-9.6-5.4-18.4-15.3-18.4c-7.9 0-14.6 5.7-16.5 13.4z'
      
    ]
  };

  
    var faRefresh = faArrowsRotate;
  
    var faSync = faArrowsRotate;
  

  
  

  var faBorderTop = {
    prefix: 'fal',
    iconName: 'border-top',
    icon: [
      448,
      512,
      [],
      'f855',
      
      'M0 48c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 64C7.2 64 0 56.8 0 48zM56 160A24 24 0 1 1 8 160a24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-144 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 352a24 24 0 1 1 48 0A24 24 0 1 1 8 352zm432 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-144 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 448a24 24 0 1 1 48 0A24 24 0 1 1 8 448zm432 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM152 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM296 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faMugTea = {
    prefix: 'fal',
    iconName: 'mug-tea',
    icon: [
      576,
      512,
      [],
      'f875',
      
      'M144 96L64 96l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-80 0-176-32 0L176 96l0 40.5 36.5 30.4C219.8 173 224 182 224 191.5l0 64.5c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64.5c0-9.5 4.2-18.5 11.5-24.6L144 136.5 144 96zm16-32l192 0 32 0 80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0 0 64c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96c0-17.7 14.3-32 32-32l96 0zM464 96l-48 0 0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80zM128 256l64 0 0-64.5-32-26.7-32 26.7 0 64.5z'
      
    ]
  };

  

  
  

  var faBurgerFries = {
    prefix: 'fal',
    iconName: 'burger-fries',
    icon: [
      640,
      512,
      [],
      'e0cd',
      
      'M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3l0 218.4c-8.5 2.4-19 4.3-32 5.1l0-213.6-32-16 0 229.6c-13-.9-23.5-2.7-32-5.1L144 16c0-5.5 2.9-10.7 7.6-13.6zM279.1 233.8c-1 4-2.9 9-7.1 14.1l0-39.4L299.1 84.5 272 89.9l0-32.6 44.9-9c5.3-1.1 10.8 .6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zm88.7-55.6c-10.2 4.1-19.5 8.8-28.1 13.7l-7.2 0 19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-15.8 79.1zM192 304c27.6 0 48.8-3.7 65.2-9.5c-.9 6.3-1.2 12.4-1.2 18.1c0 5.3 .7 10.3 2.1 15.2c-18.6 5.3-40.4 8.2-66.1 8.2c-49.1 0-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256l-9.8 0L89.2 480 260 480c3.7 11.9 9.7 22.7 17.6 32L89.2 512c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224l32.9 0c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304zM21.4 192c-.9 0-1.7 0-2.5 .1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3s17.1 3.9 18.8 12.6L51.5 192l-30.1 0zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7c-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1l0 35.8L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zm210.7 23.9c-5.7 6.2-9.2 14.6-10.4 24.4l287 0c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4l-305.2 0c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3l277.3 0c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7l-234.7 0c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7l234.7 0c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3l-277.3 0z'
      
    ]
  };

  

  
  

  var faGuaraniSign = {
    prefix: 'fal',
    iconName: 'guarani-sign',
    icon: [
      384,
      512,
      [],
      'e19a',
      
      'M176 0c-8.8 0-16 7.2-16 16l0 50.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3l0 50.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c106 0 192-86 192-192c0-8.8-7.2-16-16-16l-176 0 0-144c43.6 0 83.1 17.4 112 45.7c6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6C291.8 85 244.3 64 192 64l0-48c0-8.8-7.2-16-16-16zM160 99.2l0 313.6C87 398 32 333.4 32 256s55-142 128-156.8zM192 416l0-144 159.2 0c-8 80.9-76.2 144-159.2 144z'
      
    ]
  };

  

  
  

  var faGingerbreadMan = {
    prefix: 'fal',
    iconName: 'gingerbread-man',
    icon: [
      448,
      512,
      [],
      'f79d',
      
      'M144 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.5-7.7 39.2-20.4 53.3c-4.2 4.7-5.3 11.4-2.7 17.2s8.3 9.5 14.6 9.5l72.4 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-7 0c-32.4 0-50.3 37.7-29.7 62.8l41.7 50.7c16.8 20.5 13.9 50.7-6.6 67.6s-50.7 13.9-67.6-6.6l-45.3-55c-15.4-18.7-43.9-18.7-59.3 0l-45.3 55c-16.8 20.5-47.1 23.4-67.6 6.6S58.1 422 74.9 401.5l41.7-50.7C137.3 325.7 119.4 288 87 288l-7 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l72.4 0c6.3 0 12-3.7 14.6-9.5s1.5-12.5-2.7-17.2C151.7 151.2 144 132.5 144 112zM224 0C162.1 0 112 50.1 112 112c0 17.2 3.9 33.4 10.8 48L80 160c-44.2 0-80 35.8-80 80s35.8 80 80 80l7 0c5.4 0 8.4 6.3 4.9 10.5L50.2 381.2c-28.1 34.1-23.2 84.5 10.9 112.6l9.1-11.1-9.1 11.1c34.1 28.1 84.5 23.2 112.6-10.9l45.3-55c2.6-3.1 7.3-3.1 9.9 0l45.3 55c28.1 34.1 78.5 39 112.6 10.9s39-78.5 10.9-112.6l-41.7-50.7c-3.4-4.2-.5-10.5 4.9-10.5l7 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-42.8 0c6.9-14.6 10.8-30.8 10.8-48C336 50.1 285.9 0 224 0zM192 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCommentQuestion = {
    prefix: 'fal',
    iconName: 'comment-question',
    icon: [
      512,
      512,
      [],
      'e14b',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM168.7 153.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9l57.1 0c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3l0 29.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-19.7 37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3l-57.1 0c-25.5 0-47.7 17.2-54.2 41.8zM280 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faAlicorn = {
    prefix: 'fal',
    iconName: 'alicorn',
    icon: [
      640,
      512,
      [],
      'f6b0',
      
      'M335.5 148.1c-.5 1.9-1.3 3.6-2.5 5.2c-1.4 1.9-3.1 3.4-5 4.5s-4.1 1.8-6.4 2.1c-3.2 .3-6.6-.3-9.6-2L169.9 76.6c7 52.2 32.2 91.2 57.8 118.4c15.1 16 30.1 27.8 41.4 35.5c5.6 3.9 10.3 6.7 13.5 8.6c1.6 .9 2.8 1.6 3.6 2l.9 .5 .2 .1s0 0 0 0s0 0 0 0c7.9 4 11.1 13.6 7.1 21.5s-13.6 11.1-21.5 7.2L280 256c-7.2 14.3-7.2 14.3-7.2 14.3s0 0 0 0s0 0 0 0l-.1-.1-.4-.2c-.3-.2-.7-.4-1.3-.7c-1.1-.6-2.6-1.4-4.5-2.5c-3.8-2.2-9.2-5.5-15.5-9.9c-12.7-8.7-29.6-22-46.6-40C170.4 180.9 136 125.2 136 48c0-5.7 3-11 8-13.8s11-2.9 16-.1l146.4 83.7C318.7 50.8 377.4 0 448 0l24 0 8 0 5.8 0L544 0c8.8 0 16 7.2 16 16c0 7-4.5 13-10.8 15.1c7.3 9.5 12.5 20.6 15 32.9l66.5 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-65.2 21.7 4.7 49.4c2.3 23.9-9.2 47.1-29.6 59.9c-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5-7.4 0 0 40c0 .7-.1 1.5-.1 2.2c.1 1.9 .1 3.9 .1 5.8c0 30.9-12.4 58.4-32 78.4L416 472c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-124.4-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7l-33.2 0c-18 0-33.7-12-38.5-29.3L89.6 434.1c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4 .3-.8 .3-1.3c0-.4-.1-.8-.2-1.2L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-41.3 31.3-75.2 71.4-79.5c9-19.8 25.6-35.4 46-43.1c3.4 10.4 7.4 20.4 11.8 29.8C109.8 170.2 96 188.8 96 210.7c0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5c0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9l33.2 0c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8c0-4.6-.4-9.2-1.1-13.7c-.9-5.3 .9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4 .3 2.8 .6 4.3 .8c7.7 1.3 13.3 8 13.3 15.8L336 472c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-160.4c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7c-.1-1.5 0-3.1 .3-4.5l0-52.8c0-8.8 7.2-16 16-16l32 0c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2c10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4L480 32l-8 0-24 0c-61.8 0-111.9 50-112 111.7c0 1.5-.1 2.9-.5 4.4zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faAlarmPlus = {
    prefix: 'fal',
    iconName: 'alarm-plus',
    icon: [
      512,
      512,
      [],
      'f844',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 80c-8.8 0-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faMattressPillow = {
    prefix: 'fal',
    iconName: 'mattress-pillow',
    icon: [
      640,
      512,
      [],
      'e525',
      
      'M256 96l0 320L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l192 0zm32 0l288 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-288 0 0-320zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm112 96c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l64 0zm-64-32c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0z'
      
    ]
  };

  

  
  

  var faMemoPad = {
    prefix: 'fal',
    iconName: 'memo-pad',
    icon: [
      448,
      512,
      [],
      'e1da',
      
      'M32 128l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320L32 128zm0-32l384 0 0-32c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 32zM448 64l0 32 0 16 0 16 0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128l0-16L0 96 0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64zM112 192l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faRabbitRunning = {
    prefix: 'fal',
    iconName: 'rabbit-running',
    icon: [
      576,
      512,
      ["rabbit-fast"],
      'f709',
      
      'M449.3 148.5c14.6 2.1 28.7 6.6 41.8 13.5c-.7-35-15-69-40.8-94.2l-1.4-1.4c-1.9-1.9-4.7-2.7-7.3-2.2l-1.6 .3c-2.3 .4-4.2 1.9-5.3 3.9c-7.5-7.7-15.6-14.7-24.3-21.1c5.8-7.3 14.1-12.4 23.5-14.2l1.6-.3c13-2.5 26.4 1.5 35.8 10.8l1.4 1.4c37.1 36.4 55 87.5 49.4 138.2l23.7 17.7c19 14.2 30.2 36.5 30.2 60.3c0 41.5-33.7 75.2-75.2 75.2l-94.2 0-32 32 49.4 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-117.5 0c-21.2 0-41.6-8.4-56.6-23.4L237 427.9l-66.4 44.3c-22.1 14.7-51.9 8.7-66.6-13.3s-8.7-51.9 13.3-66.6l50.4-33.6-55-55c-9.8-9.8-17.6-21.2-23.1-33.7c-5.7 1.4-11.6 2.2-17.7 2.2c-39.8 0-72-32.2-72-72s32.2-72 72-72c16.3 0 31.3 5.4 43.3 14.5c20.1-18.9 47.1-30.5 76.9-30.5l9 0c17.3 0 34.4 3.7 50.2 10.9L319 153.9c-5-10.7-8.8-22.1-11.3-33.9l-7.4-34.4c-3.9-18.4 6.6-36.8 24.4-42.7c7.2-2.4 15-2.5 22.3-.3c50.3 15.1 89 55.3 102.3 105.9zM81 239.3c-.7-4.9-1-9.8-1-14.8c0-20.7 5.6-40 15.3-56.7c-6.6-4.7-14.6-7.5-23.3-7.5c-22.1 0-40 17.9-40 40s17.9 40 40 40c3.1 0 6.1-.4 9-1zM135.1 419c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L214 404.9l-23.1-23.1L135.1 419zM334.8 73.3c-2.4 .8-3.8 3.2-3.2 5.7l7.4 34.4c5.7 26.7 19.7 50.6 39.8 68.5c5.9 5.3 7 14.1 2.7 20.7s-12.8 9.1-20 5.8l-123.3-56c-11.6-5.3-24.2-8-36.9-8l-9 0c-44.3 0-80.2 35.9-80.2 80.2c0 21.3 8.4 41.7 23.5 56.7L272.6 418.2c9 9 21.2 14.1 33.9 14.1l117.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-88 0c-6.5 0-12.3-3.9-14.8-9.9c-.8-1.9-1.2-3.8-1.2-5.8l-2.5-34.7c-2.8-39.5-29.7-73.2-67.5-84.9l-30.7-9.4c-8.4-2.6-13.2-11.6-10.6-20s11.6-13.2 20-10.6l30.7 9.4c50.5 15.5 86.3 60.5 90 113.2l0 .5L388.7 309c3-3 7.1-4.7 11.3-4.7l100.8 0c23.9 0 43.2-19.3 43.2-43.2c0-13.6-6.4-26.5-17.4-34.6l-37.3-27.9c-15.6-11.7-34.3-18.3-53.6-19.3c-7.1-.3-13.1-5.3-14.8-12.2l-2.1-8.7c-10-40.7-40.8-73.2-81-85.2c-1-.3-2-.3-2.9 0zM480 224.3a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faRabbitFast = faRabbitRunning;
  

  
  

  var faHandshakeSimpleSlash = {
    prefix: 'fal',
    iconName: 'handshake-simple-slash',
    icon: [
      640,
      512,
      ["handshake-alt-slash"],
      'e05f',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM368.5 212.8l11.9-11c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-15.6 14.4 25.4 20.1zm-81.7-64.5l27.5-26C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.9 2.4 6.5 3.8 10.3 3.8l94.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-88.7 0L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-30.9 29.2 25.4 20zm-58.7-46.4c3.1-1 6.2-1.9 9.3-2.7L272.6 64l-8.7 0c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6zM54.6 128L48 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l47.1 0L54.6 128zm139 109.8c.2 .8 .4 1.5 .6 2.2l2.3 0-2.8-2.2zM370.4 377.3c1.5 9.3-1.1 19.1-7.8 26.6c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-13.5-13.5-31.8-21.1-50.9-21.1L48 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l59.4 0c10.6 0 20.8 4.2 28.3 11.7l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6.5-7.3 11-15.6 13.6-24.4l-29.7-23.5zm132.5-58.5l40.5 32 48.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-89.1 0z'
      
    ]
  };

  
    var faHandshakeAltSlash = faHandshakeSimpleSlash;
  

  
  

  var faCatSpace = {
    prefix: 'fal',
    iconName: 'cat-space',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M448 288c-70.7 0-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7l0 84.7c0 53 43 96 96 96s96-43 96-96l0-84.7c19.9 22.6 32 52.2 32 84.7c0 70.7-57.3 128-128 128zm0-256c25.4 0 49.2 7.4 69.1 20.2L482.4 80l-68.8 0L378.9 52.2C398.8 39.4 422.6 32 448 32zm64 274.7c56.5-24.7 96-81.1 96-146.7C608 71.6 536.4 0 448 0S288 71.6 288 160c0 4.6 .2 9.1 .6 13.6C218.8 192.1 161.5 238.4 128 299.2l0-122.7c0-40.3-30-74.4-70.1-79.4l-7.9-1C41.2 95 33.2 101.2 32.1 110s5.1 16.8 13.9 17.9l7.9 1c24 3 42 23.4 42 47.6L96 424l0 8c0 44.2 35.8 80 80 80c0 0 0 0 0 0l128 0 42.7 0c20.6 0 37.3-16.7 37.3-37.3c0-25.8-16.7-47.7-39.8-55.6L416 379.2l0 84.8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-157.3zm-32 10.1L480 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-5.7-3-10.9-7.9-13.8s-10.9-3-15.9-.2L304 404.8l0-12.8c0-39.8-32.2-72-72-72l-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l8 0c22.1 0 40 17.9 40 40l0 40s0 0 0 0c0 8.8 7.2 16 16 16l37.3 0c14.7 0 26.7 11.9 26.7 26.7c0 2.9-2.4 5.3-5.3 5.3L304 480c0 0 0 0 0 0l-128 0c-26.5 0-48-21.5-48-48l0-8c0-103.1 69.2-192 166.5-218.8C314 271.5 375.3 320 448 320c11 0 21.7-1.1 32-3.2zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zM384 97.3l14 11.2c2.8 2.3 6.4 3.5 10 3.5l80 0c3.6 0 7.2-1.2 10-3.5l14-11.2 0 62.7c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-62.7zM416 168a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDrawCircle = {
    prefix: 'fal',
    iconName: 'draw-circle',
    icon: [
      512,
      512,
      [],
      'f5ed',
      
      'M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm58.5-6c-10 22.4-32.4 38-58.5 38s-48.6-15.6-58.5-38C147.4 107.6 107.6 147.4 90 197.5c22.4 10 38 32.4 38 58.5s-15.6 48.6-38 58.5c17.7 50.1 57.4 89.9 107.5 107.5c10-22.4 32.4-38 58.5-38s48.6 15.6 58.5 38c50.1-17.7 89.9-57.4 107.5-107.5c-22.4-10-38-32.4-38-58.5s15.6-48.6 38-58.5C404.4 147.4 364.6 107.6 314.5 90zM454.1 192.3c32.5 3.1 57.9 30.4 57.9 63.7s-25.4 60.7-57.9 63.7c-20.5 63.6-70.7 113.9-134.3 134.3C316.7 486.6 289.3 512 256 512s-60.7-25.4-63.7-57.9C128.7 433.6 78.4 383.3 57.9 319.7C25.4 316.7 0 289.3 0 256s25.4-60.7 57.9-63.7C78.4 128.7 128.7 78.4 192.3 57.9C195.3 25.4 222.7 0 256 0s60.7 25.4 63.7 57.9c63.6 20.5 113.9 70.7 134.3 134.3zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faEnvelopeOpen = {
    prefix: 'fal',
    iconName: 'envelope-open',
    icon: [
      512,
      512,
      [62135],
      'f2b6',
      
      'M241.6 36.8L45 182.4c-8.1 6-13 15.6-13 25.7l0 3.2 10.2 8.3L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L469.8 219.6l10.2-8.3 0-3.2c0-10.1-4.8-19.7-13-25.7L270.4 36.8c-4.2-3.1-9.2-4.8-14.4-4.8s-10.3 1.7-14.4 4.8zM32 252.7L32 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-195.3L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L32 252.7zM222.5 11C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L486.1 156.7c16.3 12.1 25.9 31.1 25.9 51.4L512 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 208.1c0-20.3 9.6-39.4 25.9-51.4L222.5 11z'
      
    ]
  };

  

  
  

  var faListTree = {
    prefix: 'fal',
    iconName: 'list-tree',
    icon: [
      512,
      512,
      [],
      'e1d2',
      
      'M32 112l32 0 0-32L32 80l0 32zM0 72C0 58.7 10.7 48 24 48l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-8 0 0 96 64 0 0-8c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-8-64 0 0 112c0 8.8 7.2 16 16 16l48 0 0-8c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-8-48 0c-26.5 0-48-21.5-48-48l0-128 0-112-8 0c-13.3 0-24-10.7-24-24L0 72zM160 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16zM288 256c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm0 160c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zM160 432l32 0 0-32-32 0 0 32zm0-192l0 32 32 0 0-32-32 0z'
      
    ]
  };

  

  
  

  var faLollipop = {
    prefix: 'fal',
    iconName: 'lollipop',
    icon: [
      512,
      512,
      [127853,"lollypop"],
      'e424',
      
      'M192 352c-27 0-52.4-6.7-74.7-18.5c8.7 1.6 17.6 2.5 26.7 2.5l16 0c75.1 0 136-60.9 136-136l0-8c0-57.4-46.6-104-104-104S88 134.6 88 192c0 35.3 28.7 64 64 64s64-28.7 64-64l0-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-39.8 32.2-72 72-72s72 32.2 72 72l0 8c0 57.4-46.6 104-104 104l-16 0C82.1 304 32 253.9 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM0 192C0 298 86 384 192 384c47.3 0 90.5-17.1 124-45.4L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L338.6 316c28.3-33.5 45.4-76.7 45.4-124C384 86 298 0 192 0S0 86 0 192z'
      
    ]
  };

  
    var faLollypop = faLollipop;
  

  
  

  var faSignalStrong = {
    prefix: 'fal',
    iconName: 'signal-strong',
    icon: [
      640,
      512,
      ["signal-4"],
      'f68f',
      
      'M464 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16s16-7.2 16-16l0-384zM320 192c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  
    var faSignal4 = faSignalStrong;
  

  
  

  var faUserLargeSlash = {
    prefix: 'fal',
    iconName: 'user-large-slash',
    icon: [
      640,
      512,
      ["user-alt-slash"],
      'f4fa',
      
      'M541 512l-40.5-32L96 480c.7-70.8 58.3-128 129.3-128l113 0-40.5-32-72.5 0C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7L541 512zM464 144C464 64.5 399.5 0 320 0C265.6 0 218.2 30.2 193.7 74.8l25.6 20.2C237.5 57.7 275.7 32 320 32c61.9 0 112 50.1 112 112c0 34.9-15.9 66-40.9 86.6l25.6 20.2C445.7 224.4 464 186.3 464 144zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faUserAltSlash = faUserLargeSlash;
  

  
  

  var faChalkboard = {
    prefix: 'fal',
    iconName: 'chalkboard',
    icon: [
      576,
      512,
      ["blackboard"],
      'f51b',
      
      'M64 88c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24l0 328 32 0 0-328c0-30.9-25.1-56-56-56L88 32C57.1 32 32 57.1 32 88l0 328 32 0L64 88zM224 400l0 48L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0 0-48c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zm48-16l96 0c8.8 0 16 7.2 16 16l0 40-128 0 0-40c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faBlackboard = faChalkboard;
  

  
  

  var faMeterDroplet = {
    prefix: 'fal',
    iconName: 'meter-droplet',
    icon: [
      640,
      512,
      [],
      'e1ea',
      
      'M256 480c49.7 0 95.5-16.2 132.7-43.5c2.8 10.8 6.9 21.1 12 30.7C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1l-3.8 7.1C447 102.5 359.7 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zM176 144l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm89.4 218.4c-6.2 11.6-9.4 24.5-9.4 37.6c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.1-3.2-26.1-9.4-37.6L528 230 457.4 362.4zm-28.2-15.1l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z'
      
    ]
  };

  

  
  

  var faChildren = {
    prefix: 'fal',
    iconName: 'children',
    icon: [
      640,
      512,
      [],
      'e4e1',
      
      'M192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm416 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 416 64zm64 128c-11.6 0-22.6 3.4-32 9.6L448 352l64 0 0-150.4c-9.4-6.2-20.4-9.6-32-9.6zM448 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-252.7-42.4 69.1c-4.6 7.5-14.5 9.9-22 5.3s-9.9-14.5-5.3-22L403.2 203c16.4-26.7 45.5-43 76.8-43s60.4 16.3 76.8 43l56.8 92.6c4.6 7.5 2.3 17.4-5.3 22s-17.4 2.3-22-5.3L544 243.3 544 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-64 0 0 112zM96 400l-24 0c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9l38-141.2L45.3 312.8c-4.9 7.4-14.8 9.4-22.2 4.5s-9.4-14.8-4.5-22.2L79.8 203c16.8-25.3 44.4-41.1 74.5-42.9c1.4-.1 2.9-.2 4.4-.2l1.3 0 1.3 0c1.5 0 2.9 .1 4.4 .2c30.1 1.8 57.7 17.6 74.5 42.9l61.1 92.1c4.9 7.4 2.9 17.3-4.5 22.2s-17.3 2.9-22.2-4.5l-49.2-74.2 38 141.2c1.3 4.8 .3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3l-24 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-64 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm60.5-207.9c-10 .9-18.4 7.9-21.1 17.7L92.9 368l134.2 0L184.5 209.8c-2.6-9.8-11.1-16.8-21.1-17.7c-1.2-.1-2.3-.1-3.5-.1s-2.3 0-3.5 .1z'
      
    ]
  };

  

  
  

  var faWreath = {
    prefix: 'fal',
    iconName: 'wreath',
    icon: [
      448,
      512,
      [],
      'f7e2',
      
      'M334.9 73.3c-16.3 4.8-33.6-3.9-39.3-20C291.2 40.9 279.3 32 265.4 32c-7.9 0-15.1 2.8-20.7 7.6c-11.9 10.1-29.5 10.1-41.4 0c-5.6-4.8-12.8-7.6-20.7-7.6c-13.9 0-25.8 8.9-30.2 21.3c-5.7 16.1-22.9 24.8-39.3 20c-2.9-.8-5.9-1.3-9.1-1.3c-17.7 0-32 14.3-32 32c0 3.2 .5 6.3 1.3 9.1c4.8 16.3-3.9 33.6-20 39.3C40.9 156.8 32 168.7 32 182.6c0 7.9 2.8 15.1 7.6 20.7c10.1 11.9 10.1 29.5 0 41.4c-4.8 5.6-7.6 12.8-7.6 20.7c0 13.9 8.9 25.8 21.3 30.2c16.1 5.7 24.8 22.9 20 39.3c-.8 2.9-1.3 5.9-1.3 9.1c0 17.7 14.3 32 32 32l.5 0c-5.4 8.2-8.5 18.1-8.5 28.7l0 2.9c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5l0-2.9c0-10.6-3.1-20.4-8.5-28.7l.5 0c17.7 0 32-14.3 32-32c0-3.2-.5-6.3-1.3-9.1c-4.8-16.3 3.9-33.6 20-39.3c12.5-4.4 21.3-16.3 21.3-30.2c0-7.9-2.8-15.1-7.6-20.7c-10.1-11.9-10.1-29.5 0-41.4c4.8-5.6 7.6-12.8 7.6-20.7c0-13.9-8.9-25.8-21.3-30.2c-16.1-5.7-24.8-22.9-20-39.3c.8-2.9 1.3-5.9 1.3-9.1c0-17.7-14.3-32-32-32c-3.2 0-6.3 .5-9.1 1.3zM235.2 458L288 477.8l0-59.6L235.2 438c-7.2 2.7-15.2 2.7-22.5 0L160 418.2l0 59.6L212.8 458c7.2-2.7 15.2-2.7 22.5 0zM128 411.1c0-15 12.1-27.1 27.1-27.1c3.2 0 6.5 .6 9.5 1.7L224 408l59.4-22.3c3-1.1 6.3-1.7 9.5-1.7c15 0 27.1 12.1 27.1 27.1l0 73.8c0 15-12.1 27.1-27.1 27.1c-3.2 0-6.5-.6-9.5-1.7L224 488l-59.4 22.3c-3 1.1-6.3 1.7-9.5 1.7c-15 0-27.1-12.1-27.1-27.1l0-73.8zm55.5-227.6c-.3 15.1-6.3 29.6-16.8 40.5c10.4 10.9 16.4 25.4 16.8 40.5c15.1 .3 29.6 6.3 40.5 16.8c10.9-10.4 25.4-16.4 40.5-16.8c.3-15.1 6.3-29.6 16.8-40.5c-10.4-10.9-16.4-25.4-16.8-40.5c-8.1-.2-16-2-23.3-5.2c-6.3-2.8-12.2-6.7-17.2-11.6c-10.9 10.4-25.4 16.4-40.5 16.8zM203 142.4c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1z'
      
    ]
  };

  

  
  

  var faCloudArrowDown = {
    prefix: 'fal',
    iconName: 'cloud-arrow-down',
    icon: [
      640,
      512,
      [62337,"cloud-download","cloud-download-alt"],
      'f0ed',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 299.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 329.4 304 176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 153.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80z'
      
    ]
  };

  
    var faCloudDownload = faCloudArrowDown;
  
    var faCloudDownloadAlt = faCloudArrowDown;
  

  
  

  var faHouseLock = {
    prefix: 'fal',
    iconName: 'house-lock',
    icon: [
      640,
      512,
      [],
      'e510',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l248.6 0c-5.4-9.4-8.6-20.3-8.6-32l-16 0 0-160c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 160-64 0c-26.5 0-48-21.5-48-48l0-225.3L288 37.3 456.4 185.9c8.6-7.1 18.2-13 28.7-17.4L298.6 4zM336 480l-96 0 0-160 96 0 0 160zM528 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fal',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      'M507.3 271.3c6.1-6.1 6.3-15.9 .4-22.2l-96-104c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6L459.5 244 54.6 244l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 276l402.7 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z'
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faObjectsAlignCenterVertical = {
    prefix: 'fal',
    iconName: 'objects-align-center-vertical',
    icon: [
      512,
      512,
      [],
      'e3bd',
      
      'M176 64c8.8 0 16 7.2 16 16l0 176 0 176c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-176s0 0 0 0s0 0 0 0L96 80c0-8.8 7.2-16 16-16l64 0zm48 176l0-160c0-26.5-21.5-48-48-48l-64 0C85.5 32 64 53.5 64 80l0 160-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160 64 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-96c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 96-64 0zm96 16l0-112c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 112 0 112c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-112z'
      
    ]
  };

  

  
  

  var faSquareDown = {
    prefix: 'fal',
    iconName: 'square-down',
    icon: [
      448,
      512,
      [11015,"arrow-alt-square-down"],
      'f350',
      
      'M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 400c-9.2 0-18-3.5-24.7-9.7l-91-84c-7.8-7.2-12.3-17.4-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3l25.7 0 0-80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 80 25.7 0c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm3-33.2l91-84c1.3-1.2 2-2.9 2-4.6c0-3.5-2.8-6.3-6.3-6.3L272 272c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-41.7 0c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2z'
      
    ]
  };

  
    var faArrowAltSquareDown = faSquareDown;
  

  
  

  var faFilePowerpoint = {
    prefix: 'fal',
    iconName: 'file-powerpoint',
    icon: [
      384,
      512,
      [],
      'f1c4',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm64 240c-8.8 0-16 7.2-16 16l0 112 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 56 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-72 0zm72 112l-56 0 0-80 56 0c22.1 0 40 17.9 40 40s-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faFileWord = {
    prefix: 'fal',
    iconName: 'file-word',
    icon: [
      384,
      512,
      [],
      'f1c2',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm39.2 235.1c-2.7-8.4-11.7-13.1-20.1-10.4s-13.1 11.7-10.4 20.1l56 176c2.2 6.8 8.5 11.3 15.6 11.1s13.2-4.9 15.1-11.8L192 300.8l32.6 119.4c1.9 6.8 8 11.6 15.1 11.8s13.4-4.4 15.6-11.1l56-176c2.7-8.4-2-17.4-10.4-20.1s-17.4 2-20.1 10.4L241.2 359.5 207.4 235.8c-1.9-7-8.2-11.8-15.4-11.8s-13.5 4.8-15.4 11.8L142.8 359.5 103.2 235.1z'
      
    ]
  };

  

  
  

  var faLeft = {
    prefix: 'fal',
    iconName: 'left',
    icon: [
      448,
      512,
      ["arrow-alt-left"],
      'f355',
      
      'M32 258.3l0-4.6c0-4.4 1.8-8.6 5-11.6L186.8 99.5c2.3-2.2 5.4-3.5 8.7-3.5c6.9 0 12.6 5.6 12.6 12.6l0 83.4c0 8.8 7.2 16 16 16l176 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-176 0c-8.8 0-16 7.2-16 16l0 83.4c0 6.9-5.6 12.6-12.6 12.6c-3.2 0-6.3-1.2-8.7-3.5L37 269.9c-3.2-3-5-7.2-5-11.6zM195.4 64C184 64 173 68.4 164.7 76.3L14.9 219C5.4 228 0 240.6 0 253.7l0 4.6C0 271.4 5.4 284 14.9 293L164.7 435.7C173 443.6 184 448 195.4 448c24.6 0 44.6-20 44.6-44.6l0-67.4 160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0 0-67.4C240 84 220 64 195.4 64z'
      
    ]
  };

  
    var faArrowAltLeft = faLeft;
  

  
  

  var faWavesSine = {
    prefix: 'fal',
    iconName: 'waves-sine',
    icon: [
      640,
      512,
      [],
      'e65d',
      
      'M240 121.2c-14.4 24-26.5 53.4-38.1 85.4c-5.2-15.2-10.8-30.6-16.7-45.8c8.3-20.2 17.3-39.2 27.3-56C237.1 63.8 270.7 32 320 32s82.9 31.8 107.4 72.8c24.3 40.5 42.2 93.8 59.4 145l.4 1.2c17.6 52.5 34.6 102.7 56.9 139.9c22.2 37 47.2 57.2 80 57.2c8.8 0 16 7.2 16 16s-7.2 16-16 16c-49.3 0-82.9-31.8-107.4-72.8c-24.3-40.5-42.2-93.8-59.4-145c0 0 0 0 0 0l-.4-1.2c-17.6-52.5-34.6-102.7-56.9-139.9C377.8 84.2 352.8 64 320 64s-57.8 20.2-80 57.2zm-89.3 230c-8.3 20.2-17.3 39.2-27.3 56C98.9 448.2 65.3 480 16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16c32.8 0 57.8-20.2 80-57.2c14.4-24 26.5-53.4 38.1-85.4c5.2 15.2 10.8 30.6 16.7 45.8zM400 390.8c14.4-24 26.5-53.4 38.1-85.4c5.2 15.2 10.8 30.6 16.7 45.8c-8.3 20.2-17.3 39.2-27.3 56C402.9 448.2 369.3 480 320 480s-82.9-31.8-107.4-72.8c-24.3-40.5-42.2-93.8-59.4-145c0 0 0 0 0 0l-.4-1.2C135.2 208.6 118.3 158.4 96 121.2C73.8 84.2 48.8 64 16 64C7.2 64 0 56.8 0 48s7.2-16 16-16c49.3 0 82.9 31.8 107.4 72.8c24.3 40.5 42.2 93.8 59.4 145l.4 1.2c17.6 52.5 34.6 102.7 56.9 139.9c22.2 37 47.2 57.2 80 57.2s57.8-20.2 80-57.2zM544 121.2c-14.4 24-26.5 53.4-38.1 85.4c-5.2-15.2-10.8-30.6-16.7-45.8c8.3-20.2 17.3-39.2 27.3-56C541.1 63.8 574.7 32 624 32c8.8 0 16 7.2 16 16s-7.2 16-16 16c-32.8 0-57.8 20.2-80 57.2z'
      
    ]
  };

  

  
  

  var faCircle6 = {
    prefix: 'fal',
    iconName: 'circle-6',
    icon: [
      512,
      512,
      [],
      'e0f3',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm43.7-378.9c-6-6.5-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1 .8-22.6zM256 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faChessKingPiece = {
    prefix: 'fal',
    iconName: 'chess-king-piece',
    icon: [
      256,
      512,
      ["chess-king-alt"],
      'f440',
      
      'M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L52.6 96C41.2 96 32 105.2 32 116.6c0 2.2 .4 4.4 1.1 6.5L66.7 224 56 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l13.8 0L56.7 352 89 352l13.1-96 51.8 0L167 352l32.3 0-13.1-96 13.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-10.7 0 33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5c0-11.4-9.2-20.6-20.6-20.6L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm11.6 208l-55.2 0-32-96 59.6 0 59.6 0-32 96zm34.6 160L65.8 384c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512l177.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7L65.8 416l124.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L39.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9z'
      
    ]
  };

  
    var faChessKingAlt = faChessKingPiece;
  

  
  

  var faTombstoneBlank = {
    prefix: 'fal',
    iconName: 'tombstone-blank',
    icon: [
      448,
      512,
      [129702,"tombstone-alt"],
      'f721',
      
      'M384 192l0 256 32 0 0-256C416 86 330 0 224 0S32 86 32 192l0 256 32 0 0-256c0-88.4 71.6-160 160-160s160 71.6 160 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480z'
      
    ]
  };

  
    var faTombstoneAlt = faTombstoneBlank;
  

  
  

  var faFaceSmileWink = {
    prefix: 'fal',
    iconName: 'face-smile-wink',
    icon: [
      512,
      512,
      [128521,"smile-wink"],
      'f4da',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z'
      
    ]
  };

  
    var faSmileWink = faFaceSmileWink;
  

  
  

  var faProjector = {
    prefix: 'fal',
    iconName: 'projector',
    icon: [
      640,
      512,
      [],
      'f8d6',
      
      'M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM267.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zm320 22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM288 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0c0-36-11.9-69.3-32-96l32 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-16 0-16 0c20.1-26.7 32-60 32-96zm0 128c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-64 0c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32L64 192c-35.3 0-64 28.7-64 64L0 384c0 35.3 28.7 64 64 64l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 224 0c26.7 20.1 60 32 96 32c37.3 0 71.6-12.7 98.8-34.1c-.9 .7-1.8 1.4-2.8 2.1l32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM80 416l-16 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l224 0c-20.1 26.7-32 60-32 96s11.9 69.3 32 96L80 416zm16-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faText = {
    prefix: 'fal',
    iconName: 'text',
    icon: [
      448,
      512,
      [],
      'f893',
      
      'M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L240 64l0 384 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-384L32 64l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 64z'
      
    ]
  };

  

  
  

  var faCircleDownLeft = {
    prefix: 'fal',
    iconName: 'circle-down-left',
    icon: [
      512,
      512,
      [],
      'e107',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM176 328c0 4.4 3.6 8 8 8l113.4 0c3.7 0 6.6-3 6.6-6.6c0-1.8-.7-3.4-1.9-4.7l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6l59.1-59.1c3.6-3.6 4.9-9 3.3-13.9c-.7-2-1.8-3.8-3.3-5.3l-22.1-22.1c-1.5-1.5-3.3-2.6-5.3-3.3c-4.9-1.6-10.3-.4-13.9 3.3l-59.1 59.1c-6.2 6.2-16.4 6.2-22.6 0l-25.4-25.4c-1.2-1.2-2.9-1.9-4.7-1.9c-3.7 0-6.6 3-6.6 6.6L176 328zm8 40c-22.1 0-40-17.9-40-40l0-113.4c0-21.3 17.3-38.6 38.6-38.6c10.2 0 20.1 4.1 27.3 11.3L224 201.4l47.7-47.7c12.2-12.2 30.3-16.5 46.7-11c6.7 2.2 12.8 6 17.8 11l22.1 22.1c5 5 8.8 11.1 11 17.8c5.5 16.4 1.2 34.5-11 46.7L310.6 288l14.1 14.1c7.2 7.2 11.3 17.1 11.3 27.3c0 21.3-17.3 38.6-38.6 38.6L184 368z'
      
    ]
  };

  

  
  

  var faWatch = {
    prefix: 'fal',
    iconName: 'watch',
    icon: [
      384,
      512,
      [8986],
      'f2e1',
      
      'M128 32l128 0c17.7 0 32 14.3 32 32l0 25.7C259.8 73.3 227 64 192 64s-67.8 9.3-96 25.7L96 64c0-17.7 14.3-32 32-32zM64 112l1 0C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144l-1 0 0 48c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-48-1 0c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144l1 0 0-48c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 48zM288 422.3l0 25.7c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-25.7c28.2 16.3 61 25.7 96 25.7s67.8-9.4 96-25.7zM32 256a160 160 0 1 1 320 0A160 160 0 1 1 32 256zm176-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 5.3 2.7 10.3 7.1 13.3l48 32c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L208 247.4l0-71.4z'
      
    ]
  };

  

  
  

  var faTextSlash = {
    prefix: 'fal',
    iconName: 'text-slash',
    icon: [
      640,
      512,
      ["remove-format"],
      'f87d',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM390.4 64l149.1 0-11 44.1c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l11-44.1c5-20.2-10.2-39.8-31-39.8l-383 0c-4.7 0-9.2 1-13.3 2.9L180.1 64l177.1 0L325.1 178.5 352.3 200 390.4 64zM287.7 312L249.6 448 176 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-53.1 0 32.1-114.5L287.7 312z'
      
    ]
  };

  
    var faRemoveFormat = faTextSlash;
  

  
  

  var faChartLineUpDown = {
    prefix: 'fal',
    iconName: 'chart-line-up-down',
    icon: [
      512,
      512,
      [],
      'e5d7',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM368 96l57.4 0L288 233.4l-68.7-68.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 198.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0L448 118.6l0 57.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0 288l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 57.4-68.7-68.7-22.6 22.6L425.4 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faCloudBolt = {
    prefix: 'fal',
    iconName: 'cloud-bolt',
    icon: [
      512,
      512,
      [127785,"thunderstorm"],
      'f76c',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-24 0 0 23.4c2.6 2.6 5 5.5 7.1 8.6l16.9 0c57.4 0 104-46.6 104-104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l53.8 0 33.8-32L104 288c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zm95.7 264l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4l48.3 0-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4l-48.3 0zm20.5 130.5L361.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6L297 328l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5c-5.1 0-10.1 2-13.8 5.5L150.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6l49.4 0-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5z'
      
    ]
  };

  
    var faThunderstorm = faCloudBolt;
  

  
  

  var faMessageCheck = {
    prefix: 'fal',
    iconName: 'message-check',
    icon: [
      512,
      512,
      ["comment-alt-check"],
      'f4a2',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM363.3 147.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 241.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  
    var faCommentAltCheck = faMessageCheck;
  

  
  

  var faHandHoldingSeedling = {
    prefix: 'fal',
    iconName: 'hand-holding-seedling',
    icon: [
      576,
      512,
      [],
      'f4bf',
      
      'M125.1 0L144 0c88.4 0 160 71.6 160 160l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-29.1 0C161.8 176 96 110.2 96 29.1C96 13 109 0 125.1 0zM144 32l-16 0c1.5 62.1 52.4 112 114.9 112l28.1 0C263.1 80.9 209.3 32 144 32zM336 176l0-16c0-5.4-.2-10.7-.7-16C396.8 142.8 446.4 93.4 448 32l-16 0c-45.7 0-85.8 23.9-108.4 59.9c-4.3-11.4-9.7-22.3-16-32.5C336.9 23.2 381.7 0 432 0l18.9 0C467 0 480 13 480 29.1c0 80.2-64.2 145.3-144 146.9zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7L80 400l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  

  
  

  var faPhoneArrowRight = {
    prefix: 'fal',
    iconName: 'phone-arrow-right',
    icon: [
      512,
      512,
      [],
      'e5be',
      
      'M411.3 4.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 128 304 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l153.4 0L388.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z'
      
    ]
  };

  

  
  

  var faSquareDollar = {
    prefix: 'fal',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm240 24l0 23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1l0-24.5c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fal',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      'M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4 112 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 464c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L304 80z'
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCandyCane = {
    prefix: 'fal',
    iconName: 'candy-cane',
    icon: [
      512,
      512,
      [],
      'f786',
      
      'M348 97.5c4.2-1 8.5-1.5 12.9-1.5c9.4 0 18.2 2.3 25.9 6.5l46.2-46.2C413 41.1 388.1 32 361 32c-11.3 0-22.5 1.6-33.2 4.7L348 97.5zm61.5 27.6c4.1 7.7 6.5 16.6 6.5 25.9l0 5.6c0 1.7-.1 3.4-.2 5.1l61.6 20.5c1.7-8.3 2.7-16.9 2.7-25.6l0-5.6c0-27.1-9.1-52.1-24.3-72.1l-46.2 46.2zm57.3 87.4l-62-20.7c-4.6 6.4-10.4 12-17.3 16.3l-57.8 36.1 60.4 37.7 31.3-19.6c19.7-12.3 35.3-29.7 45.4-49.9zM359.9 300.8l-60.4-37.7-77 48.1 60.4 37.7 77-48.1zm-107.2 67l-60.4-37.7-73 45.6 60.4 37.7 73-45.6zM149.5 432.3L89.1 394.6 47 420.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2l68.5-42.8zM298.4 49.8c-.2 .1-.3 .2-.5 .3L271 66.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2l14.3-8.9L298.4 49.8zM361 128c-4.3 0-8.6 1.2-12.2 3.5l-26.8 16.8c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23C304.9 8 332.7 0 361 0c83.4 0 151 67.6 151 151l0 5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L370.5 180.9c8.4-5.2 13.5-14.4 13.5-24.3l0-5.6c0-12.7-10.3-23-23-23z'
      
    ]
  };

  

  
  

  var faSquare9 = {
    prefix: 'fal',
    iconName: 'square-9',
    icon: [
      448,
      512,
      [],
      'e25e',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 288a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-3.7 31.9l-39.1 36.3c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8l82.7-76.8c22-20.4 34.4-49 34.4-78.9c0-53-43-96-96-96s-96 43-96 96c0 51.8 41 94 92.3 95.9z'
      
    ]
  };

  

  
  

  var faBowlFood = {
    prefix: 'fal',
    iconName: 'bowl-food',
    icon: [
      512,
      512,
      [],
      'e4c6',
      
      'M203.8 98.2C213.9 77.5 233.8 64 256 64s42.1 13.5 52.2 34.2c2 4.1 5.6 7.2 10 8.4s9.1 .6 12.9-1.9C340 99.2 350.2 96 361 96c27.8 0 52.1 21.2 57.8 51c1.5 7.7 8.3 13.2 16.1 13c.4 0 .7 0 1.1 0c23.3 0 44 20.5 44 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-39.4-27.5-73.5-64.9-79.2C435 91.6 401.5 64 361 64c-11.4 0-22.3 2.2-32.3 6.2C312.2 47.2 286 32 256 32s-56.2 15.2-72.7 38.2c-10-4-20.9-6.2-32.3-6.2c-40.5 0-74 27.6-86.1 64.8C27.5 134.5 0 168.6 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16c0-27.5 20.7-48 44-48c.4 0 .7 0 1.1 0c7.8 .2 14.7-5.3 16.1-13c5.7-29.8 30-51 57.8-51c10.8 0 21 3.2 29.8 8.7c3.8 2.4 8.6 3.1 12.9 1.9s8-4.3 10-8.4zM129.3 425.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288l447.8 0c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 438.4 366.5 448 352 448l-192 0c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 256z'
      
    ]
  };

  

  
  

  var faGroupArrowsRotate = {
    prefix: 'fal',
    iconName: 'group-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e4f6',
      
      'M207.3 36.7c2.5 8.5-2.3 17.4-10.8 19.9c-14.2 4.2-27.8 10-40.6 17c2.6 7 4 14.5 4 22.4c0 35.3-28.7 64-64 64c-7.9 0-15.4-1.4-22.4-4c-7 12.8-12.7 26.4-17 40.6c-2.5 8.5-11.4 13.3-19.9 10.8s-13.3-11.4-10.8-19.9c5.2-17.6 12.4-34.3 21.3-50C37.7 126.3 32 111.8 32 96c0-35.3 28.7-64 64-64c15.8 0 30.3 5.7 41.5 15.3c15.6-8.9 32.4-16.1 50-21.3c8.5-2.5 17.4 2.3 19.9 10.8zm97.3 0c2.5-8.5 11.4-13.3 19.9-10.8c17.6 5.2 34.3 12.4 50 21.3C385.7 37.7 400.2 32 416 32c35.3 0 64 28.7 64 64c0 15.8-5.7 30.3-15.3 41.5c8.9 15.6 16.1 32.4 21.3 50c2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8c-4.2-14.2-10-27.8-17-40.6c-7 2.6-14.5 4-22.4 4c-35.3 0-64-28.7-64-64c0-7.9 1.4-15.4 4-22.4c-12.8-7-26.4-12.7-40.6-17c-8.5-2.5-13.3-11.4-10.8-19.9zm-268 268c8.5-2.5 17.4 2.3 19.9 10.8c4.2 14.2 10 27.8 17 40.6c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64c0 7.9-1.4 15.4-4 22.4c12.8 7 26.4 12.7 40.6 17c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8c-17.6-5.2-34.3-12.4-50-21.3C126.3 474.3 111.8 480 96 480c-35.3 0-64-28.7-64-64c0-15.8 5.7-30.3 15.3-41.5c-8.9-15.6-16.1-32.4-21.3-50c-2.5-8.5 2.3-17.4 10.8-19.9zm438.6 0c8.5 2.5 13.3 11.4 10.8 19.9c-5.2 17.6-12.4 34.3-21.3 50c9.5 11.2 15.3 25.7 15.3 41.5c0 35.3-28.7 64-64 64c-15.8 0-30.3-5.7-41.5-15.3c-15.6 8.9-32.4 16.1-50 21.3c-8.5 2.5-17.4-2.3-19.9-10.8s2.3-17.4 10.8-19.9c14.2-4.2 27.8-10 40.6-17c-2.6-7-4-14.5-4-22.4c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4c7-12.8 12.7-26.4 17-40.6c2.5-8.5 11.4-13.3 19.9-10.8zM96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM144.8 168.8c0-8.8 7.2-16 16-16l45.6 0c14.6 0 26.4 11.8 26.4 26.4l0 45.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-13.3c-10 12.4-16 28.1-16 45.3c0 28 15.9 52.2 39.3 64.2c7.9 4 11 13.7 7 21.5s-13.7 11-21.5 7c-33.6-17.2-56.7-52.2-56.7-92.6c0-27.6 10.8-52.8 28.4-71.4c.2-.2 .4-.4 .6-.6l-21 0c-8.8 0-16-7.2-16-16zm208 192l-45.6 0c-14.6 0-26.4-11.8-26.4-26.4l0-45.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 11.7c10-12.4 16-28.1 16-45.3c0-28-15.9-52.2-39.3-64.2c-7.9-4-11-13.7-7-21.5s13.7-11 21.5-7c33.6 17.2 56.7 52.2 56.7 92.7c0 27.6-10.8 52.8-28.4 71.4c-.8 .8-1.6 1.6-2.5 2.2l22.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z'
      
    ]
  };

  

  
  

  var faFileJpg = {
    prefix: 'fal',
    iconName: 'file-jpg',
    icon: [
      512,
      512,
      [],
      'e646',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM208 512c-26.5 0-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 26.5-21.5 48-48 48zm96-160l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm80-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z'
      
    ]
  };

  

  
  

  var faFlashlight = {
    prefix: 'fal',
    iconName: 'flashlight',
    icon: [
      640,
      512,
      [128294],
      'f8b8',
      
      'M401.8 325.4l31.5 21c24 16 50.8 27.1 78.7 32.9l0-246.7c-28 5.8-54.7 16.9-78.7 32.9l-31.5 21-8.1 5.4-9.7 0L48 192c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l336 0 9.7 0 8.1 5.4zM544 383.6c4.5 .3 9 .4 13.5 .4l34.5 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-34.5 0c-4.5 0-9 .1-13.5 .4l0 255.2zM0 304l0-96c0-26.5 21.5-48 48-48l336 0 31.5-21c42.1-28 91.5-43 142-43L592 96c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-34.5 0c-50.5 0-100-15-142-43L384 352 48 352c-26.5 0-48-21.5-48-48zm224-48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faCircleArrowLeft = {
    prefix: 'fal',
    iconName: 'circle-arrow-left',
    icon: [
      512,
      512,
      ["arrow-circle-left"],
      'f0a8',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM228.7 148.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 368 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-185.4 0 68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faArrowCircleLeft = faCircleArrowLeft;
  

  
  

  var faBoxesPacking = {
    prefix: 'fal',
    iconName: 'boxes-packing',
    icon: [
      640,
      512,
      [],
      'e4c7',
      
      'M592 32L304 32c-8.8 0-16 7.2-16 16l0 80-32 0 0-80c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-210.7 0c1.8-5 2.7-10.4 2.7-16l0-16 208 0c8.8 0 16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zM555.3 316.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 302.6 496 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-129.4-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64zM352 192L32 192l0 64 32 0 256 0 32 0 0-64zM0 256l0-64c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 192c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-192c-17.7 0-32-14.3-32-32zm64 32l0 192 256 0 0-192L64 288zm80 32l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faLeftRight = {
    prefix: 'fal',
    iconName: 'left-right',
    icon: [
      512,
      512,
      [8596,"arrows-alt-h"],
      'f337',
      
      'M502.3 231.3c6.2 6.7 9.7 15.6 9.7 24.7s-3.5 18-9.7 24.7l-84 91c-7.2 7.8-17.4 12.3-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3l0-25.7-192 0 0 25.7c0 21.1-17.1 38.3-38.3 38.3c-10.7 0-20.9-4.5-28.1-12.3l-84-91C3.5 274 0 265.2 0 256s3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3c21.1 0 38.3 17.1 38.3 38.3l0 25.7 192 0 0-25.7c0-21.1 17.1-38.3 38.3-38.3c10.7 0 20.9 4.5 28.1 12.3l84 91zM480 256c0-1.1-.4-2.2-1.2-3l-84-91c-1.2-1.3-2.8-2-4.6-2c-3.5 0-6.3 2.8-6.3 6.3l0 41.7c0 8.8-7.2 16-16 16l-224 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-8.8 0-16-7.2-16-16l0-41.7c0-3.5-2.8-6.3-6.3-6.3c-1.7 0-3.4 .7-4.6 2l-84 91c-.8 .8-1.2 1.9-1.2 3s.4 2.2 1.2 3l84 91c1.2 1.3 2.9 2 4.6 2c3.5 0 6.3-2.8 6.3-6.3l0-41.7c0-8.8 7.2-16 16-16c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l224 0c8.8 0 16 7.2 16 16l0 41.7c0 3.5 2.8 6.3 6.3 6.3c1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3z'
      
    ]
  };

  
    var faArrowsAltH = faLeftRight;
  

  
  

  var faClockSeven = {
    prefix: 'fal',
    iconName: 'clock-seven',
    icon: [
      512,
      512,
      [],
      'e350',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 139.2-61.3 92c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c1.8-2.6 2.7-5.7 2.7-8.9l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSeedling = {
    prefix: 'fal',
    iconName: 'seedling',
    icon: [
      512,
      512,
      [127793,"sprout"],
      'f4d8',
      
      'M480 32c0 95.3-69.4 174.4-160.5 189.4c2.7 10.2 4.7 20.7 6.1 31.4C431.4 234.9 512 142.9 512 32c0-17.7-14.3-32-32-32L448 0C367 0 296 43 256.6 107.5c7.8 8.3 15.1 17.2 21.8 26.4C310.7 73.3 374.5 32 448 32l32 0zM64 96c106 0 192 86 192 192l-32 0C118 288 32 202 32 96l32 0zM32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320l32 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-16 0-16C288 164.3 187.7 64 64 64L32 64z'
      
    ]
  };

  
    var faSprout = faSeedling;
  

  
  

  var faArrowsDownToPeople = {
    prefix: 'fal',
    iconName: 'arrows-down-to-people',
    icon: [
      640,
      512,
      [],
      'e4b9',
      
      'M128 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 129.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L128 145.4 128 16zm292.7 92.7c6.2-6.2 16.4-6.2 22.6 0L480 145.4 480 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 129.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zM336 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208l48 0 0-110.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5L296 400zm122.4-15.6L376 315.5l0 84.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-84.5-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5l0 68.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-68.5L45.6 480.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352l24.5 0c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 270.4 280 256 307.8 256l24.5 0c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2l24.5 0c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5l0 68.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-68.5-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 385.5l0 94.5 48 0 0-94.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192l48 0 0-94.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5l0 94.5z'
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fal',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M326.3 9.8C304 3.4 280.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-24.4-3.4-48-9.8-70.3l-22.8 25.4c-1.1 1.2-2.1 2.3-3.3 3.4c2.5 13.5 3.8 27.3 3.8 41.5c0 123.7-100.3 224-224 224S32 379.7 32 256S132.3 32 256 32c14.2 0 28.1 1.3 41.5 3.8c1.1-1.1 2.2-2.2 3.4-3.3L326.3 9.8zM274.6 97.1c-6.1-.7-12.3-1.1-18.6-1.1C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-6.3-.4-12.5-1.1-18.6c-2.7-.2-5.4-.5-8.1-.9l-25-4.2c1.4 7.7 2.2 15.6 2.2 23.7c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c8.1 0 16 .8 23.7 2.2l-4.2-25c-.5-2.7-.8-5.4-.9-8.1zm66.9 96.1l70.4 11.7c16.3 2.7 32.8-3.1 43.8-15.5L499.6 140c11.7-13.1 5.8-33.9-11-38.9L428.9 83.2 410.9 23.4c-5-16.8-25.8-22.7-38.9-11L322.6 56.3c-12.3 11-18.2 27.5-15.5 43.8l11.7 70.4-74.2 74.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l74.2-74.2zm27.8-27.8l51.3-51.3 46.8 14-35.6 40c-3.7 4.1-9.2 6.1-14.6 5.2l-47.9-8zm28.6-73.9l-51.3 51.3-8-47.9c-.9-5.4 1-10.9 5.2-14.6l40-35.6 14 46.8z'
      
    ]
  };

  

  
  

  var faFerry = {
    prefix: 'fal',
    iconName: 'ferry',
    icon: [
      576,
      512,
      [],
      'e4ea',
      
      'M224 0c-17.7 0-32 14.3-32 32l-68 0c-17.1 0-28.7 17.4-22.2 33.2L114.7 96 112 96c-26.5 0-48 21.5-48 48l0 151.1c0 8.7 2.4 17.2 6.8 24.7l43.4 72.4c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-21.9L108.3 320l359.5 0-33.5 55.8c-4.5 7.6-2.1 17.4 5.5 21.9s17.4 2.1 21.9-5.5l43.4-72.4c4.5-7.5 6.8-16 6.8-24.7L512 144c0-26.5-21.5-48-48-48l-2.7 0 12.8-30.8c6.6-15.8-5-33.2-22.2-33.2l-68 0c0-17.7-14.3-32-32-32L224 0zM416 288l-256 0 0-96 256 0 0 96zm32 0l0-112c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16l0 112-32 0 0-144c0-8.8 7.2-16 16-16l16 0 320 0 16 0c8.8 0 16 7.2 16 16l0 144-32 0zM426.7 96L149.3 96 136 64l56 0 32 0 0-32 128 0 0 32 32 0 56 0L426.7 96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faTrianglePersonDigging = {
    prefix: 'fal',
    iconName: 'triangle-person-digging',
    icon: [
      640,
      512,
      ["construction"],
      'f85d',
      
      'M320 32c2.8 0 5.4 1.4 6.8 3.8l264.5 432c1.5 2.5 1.6 5.6 .2 8.1s-4.1 4.1-7 4.1L56 480c-2.9 0-5.6-1.6-7-4.1s-1.4-5.6 .2-8.1l264-432c1.5-2.4 4-3.8 6.8-3.8zm34.1-12.9C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512l528.5 0c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-37 48c9.9 0 18.6 6.6 21.2 16.2l5.9 21.8-46.5-26.8 1.8-2.4c4.2-5.5 10.7-8.8 17.6-8.8zm66.5 60.7l-14.4-52.9C320.7 256.3 299.3 240 275 240c-17 0-33 8-43.2 21.6l-12.6 16.8c-2.7 3.7-3.8 8.3-2.9 12.8s3.7 8.4 7.7 10.6l155.9 89.9-9.6 16c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1l96 0c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-21.9 36.6-54.8-31.6zm-124.6-12l-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2L272 392.9l0 23.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8zM451.7 400l-39.5 0L432 367.1 451.7 400z'
      
    ]
  };

  
    var faConstruction = faTrianglePersonDigging;
  

  
  

  var faCircleEnvelope = {
    prefix: 'fal',
    iconName: 'circle-envelope',
    icon: [
      512,
      512,
      ["envelope-circle"],
      'e10c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96l192 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32zm192 48.5l0-16.5-192 0 0 16.5 88.5 47.1c2.3 1.2 4.9 1.9 7.5 1.9s5.2-.6 7.5-1.9L352 208.5zm0 36.2l-73.4 39.1c-7 3.7-14.7 5.6-22.6 5.6s-15.6-1.9-22.6-5.6L160 244.8l0 75.2 192 0 0-75.2z'
      
    ]
  };

  
    var faEnvelopeCircle = faCircleEnvelope;
  

  
  

  var faInboxFull = {
    prefix: 'fal',
    iconName: 'inbox-full',
    icon: [
      512,
      512,
      [],
      'e1ba',
      
      'M32 327.9L32 416c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-88.1c0-2.6-.3-5.2-1-7.8l0-.1-101.1 0-23.2 46.3c-5.4 10.8-16.5 17.7-28.6 17.7l-140.2 0c-12.1 0-23.2-6.8-28.6-17.7L134.1 320 33 320l0 .1c-.6 2.5-1 5.1-1 7.8zM421.1 88.2C417.5 74 404.7 64 390 64L122 64c-14.7 0-27.5 10-31 24.2L41 288l93.1 0c12.1 0 23.2 6.8 28.6 17.7L185.9 352l140.2 0 23.2-46.3c5.4-10.8 16.5-17.7 28.6-17.7l93.1 0L421.1 88.2zM0 416l0-88.1c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32L390 32c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5l0 88.1c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM176 144l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPig = {
    prefix: 'fal',
    iconName: 'pig',
    icon: [
      640,
      512,
      [128022],
      'f706',
      
      'M484.2 32c-4.4 0-8.7 .7-12.9 1.9L416.6 50.8C399.7 56 385.5 66.4 375.5 80L240 80C162.6 80 98 135 83.2 208l-35.8 0c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240L80 240l0 16c0 53.4 29.1 100 72.2 124.8L180 458.8c4.5 12.7 16.6 21.2 30.1 21.2l45.9 0c17.7 0 32-14.3 32-32l0-32 32 0 48 0 0 32c0 17.7 14.3 32 32 32l45.9 0c13.5 0 25.6-8.5 30.1-21.2L494 408.5c25.9-9 48.8-25.5 65.3-47.7c.3-.4 .6-.6 .8-.7l.1 0c0 0 .1 0 .1 0l39.8 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-18.7 0c-5.2-3.5-9.9-7.7-14.1-12.3c25-13.7 40.9-40 40.9-68.9C608 97.3 590.7 80 569.3 80L528 80l0-4.2C528 51.6 508.4 32 484.2 32zm40.9 80l44.1 0c3.7 0 6.7 3 6.7 6.7c0 18.6-11 35.3-28 42.7c-9-11.5-19.1-22-30.2-31.2c3.1-5.7 5.6-11.8 7.3-18.2zM480.7 64.5c1.1-.3 2.3-.5 3.5-.5c6.5 0 11.8 5.3 11.8 11.8l0 14.3c0 12.5-4.5 24.1-12 33.3c-2.8 3.4-4.1 7.8-3.6 12.2s2.9 8.4 6.5 11c17.9 13 33.5 29.3 45.8 48.5c8.2 12.7 18.9 23.5 31.3 31.9c5.4 3.6 11.4 5.1 17.1 5.1l18.9 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-39.8 0c-11.1 0-20.7 5.7-26.6 13.7c-14 18.8-33.8 32.3-56.3 38.5c-5 1.4-9 5.1-10.8 10L445.9 448 400 448l0-48c0-8.8-7.2-16-16-16l-64 0-48 0c-8.8 0-16 7.2-16 16l0 48-45.9 0-29.9-83.7c-1.4-3.8-4.1-7-7.7-8.8c-36-18.7-60.5-56.2-60.5-99.5l0-16c0-70.7 57.3-128 128-128l140.5 0c1.1 0 2.2 0 3.4 0c5.9 .1 11.4-3 14.3-8.2c5.9-10.6 15.7-18.8 27.9-22.5l54.7-16.8zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faVest = {
    prefix: 'fal',
    iconName: 'vest',
    icon: [
      448,
      512,
      [],
      'e085',
      
      'M96 0l18 0 6.4 0c20.5 0 36.7 13 46.7 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C290.9 13 307.1 0 327.6 0L334 0l18 0c26.5 0 48 21.5 48 48l0 80 0 58.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9L448 464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-167.1c0-7.8 1.4-15.6 4.2-22.9L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9l33.4 87.4-17.1 44.8L128.9 42.3C126.6 36.1 120.6 32 114 32L96 32c-8.8 0-16 7.2-16 16l0 80 0 58.7c0 11.6-3.2 23-9.1 32.9L36.6 276.8c-3 5-4.6 10.7-4.6 16.5l0 132.1 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-.8 .8-1.6 1.4-2.4 2C35.1 475.5 41 480 48 480l113.6 0c2.4 11.8 7.4 22.7 14.4 32L48 512c-26.5 0-48-21.5-48-48L0 293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5L48 128l0-80C48 21.5 69.5 0 96 0zM368 48c0-8.8-7.2-16-16-16l-18 0c-6.6 0-12.6 4.1-14.9 10.3l-93 243.1c-1.4 3.6-2.1 7.5-2.1 11.4L224 464c0 8.8 7.2 16 16 16l160 0c7 0 12.9-4.5 15.1-10.7c-.9-.6-1.7-1.2-2.4-2l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 425.4l0-132.1c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9l0-58.7 0-80z'
      
    ]
  };

  

  
  

  var faArrowsTurnRight = {
    prefix: 'fal',
    iconName: 'arrows-turn-right',
    icon: [
      448,
      512,
      [],
      'e4c0',
      
      'M292 5.5c5.8-6.7 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84L112 144c-44.2 0-80 35.8-80 80l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-61.9 50.1-112 112-112l277.4 0-96-84c-6.6-5.8-7.3-15.9-1.5-22.6zm-96 256c5.8-6.6 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84L80 400c-26.5 0-48 21.5-48 48l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-44.2 35.8-80 80-80l213.4 0-96-84c-6.7-5.8-7.3-15.9-1.5-22.6z'
      
    ]
  };

  

  
  

  var faObjectsAlignRight = {
    prefix: 'fal',
    iconName: 'objects-align-right',
    icon: [
      512,
      512,
      [],
      'e3bf',
      
      'M512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480zM352 176c0 8.8-7.2 16-16 16L48 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 64zm32-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zM352 400c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 64zm32-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fal',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l72.2 0-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5L191.7 100 326.2 204.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6l0 74.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16L416 0zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160zM192 224c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM406.6 393.4a35.9 35.9 0 1 1 50.7-50.7 35.9 35.9 0 1 1 -50.7 50.7zm-10 32.6c21.6 13.2 49.1 13.2 70.7 0l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3z'
      
    ]
  };

  

  
  

  var faTransporter4 = {
    prefix: 'fal',
    iconName: 'transporter-4',
    icon: [
      512,
      512,
      [],
      'e2a5',
      
      'M208 16c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-48 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM464 128c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM48 352c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zm80 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faPalette = {
    prefix: 'fal',
    iconName: 'palette',
    icon: [
      512,
      512,
      [127912],
      'f53f',
      
      'M480 258.3c-.1 14.1-13.8 29.7-38.1 29.7L344 288c-44.2 0-80 35.8-80 80c0 5.6 .6 11.2 1.7 16.6c2.9 13.8 8.9 27.3 13.2 37c.8 1.7 1.5 3.3 2.1 4.8c5 11.6 6.9 18.2 6.9 23.5c0 19.2-12.3 29.6-22.7 30c-3.1 .1-6.2 .2-9.3 .2C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 .8 0 1.6 0 2.3zm32 .3c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM152 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCloudArrowUp = {
    prefix: 'fal',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 244.7l80-80c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 214.6 336 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-153.4-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faFontAwesome = {
    prefix: 'fal',
    iconName: 'font-awesome',
    icon: [
      512,
      512,
      [62501,62694,"font-awesome-flag","font-awesome-logo-full"],
      'f2b4',
      
      'M64 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.5 64c5.4-9.4 8.6-20.3 8.6-32C128 28.7 99.3 0 64 0S0 28.7 0 64c0 23.7 12.9 44.4 32 55.4l0 8.6 0 288 0 32 0 64 32 0 0-64 405.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L119.4 96zM64 128l397 0L402.8 259c-3.7 8.3-3.7 17.7 0 26L461 416 64 416l0-288z'
      
    ]
  };

  
    var faFontAwesomeFlag = faFontAwesome;
  
    var faFontAwesomeLogoFull = faFontAwesome;
  

  
  

  var faGasPumpSlash = {
    prefix: 'fal',
    iconName: 'gas-pump-slash',
    icon: [
      640,
      512,
      [],
      'f5f4',
      
      'M352 362.8L352 480l-224 0 0-294L96 160.7 96 480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 224 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-91.9-32-25.3zM144.6 36c4.6-2.5 9.8-4 15.4-4l160 0c17.7 0 32 14.3 32 32l0 135.7L384 225l0-161c0-35.3-28.7-64-64-64L160 0c-15.9 0-30.4 5.8-41.6 15.3L144.6 36zM576 157.1c0-17.9-7.5-35.1-20.8-47.2L474.8 36.2c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L480 84.4l0 75.6c0 35.3 28.7 64 64 64l0 127.3 32 25.3 0-219.4zm-64-43.4l21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6l0 34.9c-17.7 0-32-14.3-32-32l0-46.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faCrutch = {
    prefix: 'fal',
    iconName: 'crutch',
    icon: [
      512,
      512,
      [],
      'f7f7',
      
      'M292.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0zM196.6 164.8L162.4 199c-11.2 11.2-18.8 25.4-21.9 40.9l-24.4 122c-1.9 9.3-6.4 17.8-13.1 24.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L125.6 409c6.7-6.7 15.2-11.3 24.5-13.1l122-24.4c15.5-3.1 29.7-10.7 40.9-21.9l34.3-34.3 94.1-94.1-22.6-22.6L336 281.4 230.6 176l82.7-82.7L290.7 70.6l-94 94-.1 .1-.1 .1zM208 198.6L313.4 304l-23 23c-6.7 6.7-15.2 11.3-24.5 13.1L148.4 363.6l23.5-117.5c1.9-9.3 6.4-17.8 13.1-24.5l23-23z'
      
    ]
  };

  

  
  

  var faSquareALock = {
    prefix: 'fal',
    iconName: 'square-a-lock',
    icon: [
      576,
      512,
      [],
      'e44d',
      
      'M64 64l320 0c17.7 0 32 14.3 32 32l0 74.8c9.9-4.7 20.7-8 32-9.6L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.6 0 96L0 416c0 35.3 28.7 64 64 64l256 0 0-32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zm174.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L145.9 336l156.2 0L320 371.8l0-19.8c0-12.2 3.4-23.5 9.3-33.2l-91-181.9zM224 179.8L286.1 304l-124.2 0L224 179.8zM464 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faUserVneckHairLong = {
    prefix: 'fal',
    iconName: 'user-vneck-hair-long',
    icon: [
      448,
      512,
      [],
      'e463',
      
      'M320 128c0-5.5-.5-10.8-1.3-16l-30.1 0c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3L320 288c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.7 0c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3l58.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-58.7 0C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7l18.6 0C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64l28.9 0c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM185.6 418.1l-48-64C77.9 365.2 32.6 417.3 32 480l384 0c-.6-62.7-45.9-114.8-105.6-125.8l-48 64c-19.2 25.6-57.6 25.6-76.8 0zM143.7 321c5.3-.6 10.5 1.9 13.7 6.2l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2C385.1 329.7 448 398.2 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3C0 398.2 62.9 329.7 143.7 321z'
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fal',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352c-9.6 0-18.7 4-25.2 11L135.3 273.8c-4.7 5.1-7.3 11.8-7.3 18.7c0 15.2 12.3 27.5 27.5 27.5l201 0c15.2 0 27.5-12.3 27.5-27.5c0-6.9-2.6-13.6-7.3-18.7L281.2 171c-6.5-7-15.6-11-25.2-11zm-1.7 32.7c.4-.5 1.1-.7 1.7-.7s1.3 .3 1.7 .7L346.2 288l-180.3 0 88.4-95.3z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faHydra = {
    prefix: 'fal',
    iconName: 'hydra',
    icon: [
      640,
      512,
      [],
      'e686',
      
      'M440 32c12.1 0 23.9 3.9 33.6 11.2l32 24c4 3 6.4 7.8 6.4 12.8c0 8.8-7.2 16-16 16l-32.9 0c-26.2 0-45.5 24.7-39.1 50.1l14.2 57c6.1 24.6 6.8 50.2 1.8 75.1l-7.8 38.7c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l7.7-38.7c5.9-29.5 5.2-59.9-2.1-89.1l-14.2-57c-1.3-5.3 2.7-10.3 8.1-10.3l32.9 0c26.5 0 48-21.5 48-48c0-15.1-7.1-29.3-19.2-38.4l-32-24C477.6 6.2 459 0 440 0c-48.6 0-88 39.4-88 88l0 40 0 19.6c0 33.4-27.1 60.4-60.4 60.4l-13 0c-44.4 0-85.1 25.1-104.9 64.8l-13.4 26.8c-6.2 12.5-19 20.4-33 20.4c-28.9 0-46.6-31.8-31.2-56.4l15.7-25.1C124.4 218.3 109.9 192 86 192c-8.1 0-15.8 3.2-21.5 8.9L37.8 227.5C13.6 251.8 0 284.6 0 318.9C0 390.2 57.8 448 129.1 448l30.9 0 0 32c0 17.7 14.3 32 32 32l51.5 0c14.7 0 27.5-10 31-24.2l9.9-39.8 39 0 9.9 39.8c3.6 14.2 16.4 24.2 31 24.2l51.5 0c17.7 0 32-14.3 32-32l0-32.6c54-5.8 96-51.5 96-107l0-33.2c0-1.8 1.4-3.2 3.2-3.2l44.8 0c26.5 0 48-21.5 48-48c0-15.1-7.1-29.3-19.2-38.4l-32-24C573.6 182.2 555 176 536 176c-12.9 0-25.2 2.8-36.2 7.8c.1 1.2 .3 2.5 .6 3.8c2.4 9.7 4.2 19.5 5.4 29.3c8.7-5.6 19.1-8.9 30.3-8.9c12.1 0 23.9 3.9 33.6 11.2l32 24c4 3 6.4 7.8 6.4 12.8c0 8.8-7.2 16-16 16l-44.8 0c-19.4 0-35.2 15.8-35.2 35.2l0 33.2c0 41.8-33.9 75.6-75.6 75.6l-4.4 0c-8.8 0-16 7.2-16 16l0 48-51.5 0-13-51.9C349.7 421 343.3 416 336 416l-64 0c-7.3 0-13.7 5-15.5 12.1l-13 51.9L192 480l0-48c0-8.8-7.2-16-16-16l-46.9 0C75.5 416 32 372.5 32 318.9c0-25.8 10.2-50.5 28.5-68.7l16.9-16.9L69 246.7C40.3 292.5 73.3 352 127.3 352c26.1 0 49.9-14.7 61.6-38.1l13.4-26.8c14.5-28.9 44-47.2 76.3-47.2l13 0c51 0 92.4-41.4 92.4-92.4l0-19.6 0-40c0-30.9 25.1-56 56-56zM260.9 177.1c5.8-.7 11.7-1.1 17.7-1.1l13 0c1.6 0 3.2-.1 4.7-.4c-3.9-17.7-19.7-31.6-39.4-31.6L224 144c-8.8 0-16-7.2-16-16c0-5 2.4-9.8 6.4-12.8l32-24C256.1 83.9 267.9 80 280 80c15.7 0 29.8 6.4 40 16.8l0-8.8c0-9.8 1.2-19.4 3.4-28.6C310.6 52.2 295.8 48 280 48c-19 0-37.6 6.2-52.8 17.6l-32 24C183.1 98.7 176 112.9 176 128c0 26.5 21.5 48 48 48l32.9 0c1.5 0 2.9 .4 4.1 1.1z'
      
    ]
  };

  

  
  

  var faUfoBeam = {
    prefix: 'fal',
    iconName: 'ufo-beam',
    icon: [
      576,
      512,
      [],
      'e048',
      
      'M141.3 166.7l11.3-11.4c-11.3 11.4-11.3 11.4-11.3 11.4s0 0 0 0s0 0 0 0l.1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.6c1.6 1.3 3.8 3 6.7 5.1c5.8 4 14.5 9.1 26.3 14.1C200.7 198.4 236.7 208 288 208s87.3-9.6 110.9-19.6c11.8-5 20.4-10.1 26.3-14.1c2.9-2 5.1-3.7 6.7-5.1c.8-.7 1.4-1.2 1.9-1.6l.6-.5 .2-.2 .1-.1c0 0 0 0 0 0s0 0 0 0l-11.3-11.4 11.3 11.4c2.7-2.7 4.3-6.2 4.7-9.9c.7-8.1 .8-16 .2-23.7c30.2 8 55.1 18.1 73.1 29.4c23.1 14.4 31.2 28.3 31.2 39.1c0 7.9-4.2 17.4-16 27.9c-11.8 10.5-29.7 20.7-53.3 29.5c-47 17.7-113 29-186.7 29s-139.7-11.3-186.7-29c-23.6-8.9-41.5-19-53.3-29.5c-11.8-10.5-16-20-16-27.9c0-10.9 8.2-24.7 31.2-39.1c18-11.3 42.9-21.4 73.1-29.4c-.6 7.7-.5 15.6 .2 23.7c.3 3.7 2 7.3 4.7 9.9zm2.3-68.3c-38.9 8.9-72.5 21.4-97.3 36.9C20.1 151.7 0 173.9 0 201.6c0 20.3 11 37.8 26.7 51.8c15.7 14 37.6 25.9 63.3 35.6c51.4 19.4 121.4 31 198 31s146.5-11.7 198-31c25.7-9.7 47.5-21.6 63.3-35.6c15.7-14 26.7-31.5 26.7-51.8c0-27.7-20.1-49.9-46.3-66.3c-24.8-15.5-58.4-28-97.3-36.9C412.1 39.7 353.1 0 288 0S163.9 39.7 143.5 98.4zM288 32c66.9 0 122 50.8 119.9 115.3l-.8 .6c-4.2 2.9-10.9 6.9-20.7 11.1C366.9 167.2 335.2 176 288 176s-78.9-8.8-98.4-17.1c-9.8-4.2-16.5-8.2-20.7-11.1l-.8-.6C166 82.8 221.1 32 288 32zM103.8 338c-7.7-4.3-17.5-1.5-21.8 6.2L2 488.2C-2.3 496 .5 505.7 8.2 510s17.5 1.5 21.8-6.2l80-144c4.3-7.7 1.5-17.5-6.2-21.8zm368.5 0c-7.7 4.3-10.5 14-6.2 21.8l80 144c4.3 7.7 14 10.5 21.8 6.2s10.5-14 6.2-21.8l-80-144c-4.3-7.7-14-10.5-21.8-6.2zM288 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faSmog = {
    prefix: 'fal',
    iconName: 'smog',
    icon: [
      640,
      512,
      [],
      'f75f',
      
      'M176 0C96.5 0 32 64.5 32 144s64.5 144 144 144l123.3 0c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32l27.3 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM64 144C64 82.1 114.1 32 176 32c31.4 0 59.7 12.9 80.1 33.7c3.1 3.2 7.4 4.9 11.9 4.8s8.7-2.1 11.6-5.5c17.6-20.2 43.5-33 72.4-33c41 0 76.1 25.7 89.8 62c1.6 4.1 4.8 7.4 8.8 9.1s8.7 1.6 12.7-.2c10-4.5 21-7 32.7-7c44.2 0 80 35.8 80 80s-35.8 80-80 80l-33.6 0c-4.2 0-8.2 1.6-11.2 4.6c-17.3 17-41 27.4-67.2 27.4s-49.9-10.4-67.2-27.4c-3-2.9-7-4.6-11.2-4.6L176 256c-61.9 0-112-50.1-112-112zM80 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 384zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faBlindsRaised = {
    prefix: 'fal',
    iconName: 'blinds-raised',
    icon: [
      512,
      512,
      [],
      'f8fd',
      
      'M32 0C14.3 0 0 14.3 0 32L0 64C0 81.7 14.3 96 32 96l96 0 0 322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0zm0 32l448 0 0 32L32 64l0-32zm96 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM35.9 160l9.8-32-33.5 0L.9 165c-.6 2-.9 4.1-.9 6.1C0 182.7 9.3 192 20.9 192L96 192l0-32-60.1 0zm0 96l9.8-32-33.5 0L.9 261c-.6 2-.9 4.1-.9 6.1C0 278.7 9.3 288 20.9 288L96 288l0-32-60.1 0zM192 256l0 32 299.1 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37-33.5 0 9.8 32L192 256zm0-96l0 32 299.1 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37-33.5 0 9.8 32L192 160z'
      
    ]
  };

  

  
  

  var faMoneyBills = {
    prefix: 'fal',
    iconName: 'money-bills',
    icon: [
      640,
      512,
      [],
      'e1f3',
      
      'M576 64c17.7 0 32 14.3 32 32l0 32c-35.3 0-64-28.7-64-64l32 0zM224 64l288 0c0 53 43 96 96 96l0 96c-53 0-96 43-96 96l-288 0c0-53-43-96-96-96l0-96c53 0 96-43 96-96zM128 288c35.3 0 64 28.7 64 64l-32 0c-17.7 0-32-14.3-32-32l0-32zm416 64c0-35.3 28.7-64 64-64l0 32c0 17.7-14.3 32-32 32l-32 0zM192 64c0 35.3-28.7 64-64 64l0-32c0-17.7 14.3-32 32-32l32 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 368c0 61.9 50.1 112 112 112l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-416 0c-44.2 0-80-35.8-80-80l0-256z'
      
    ]
  };

  

  
  

  var faFaceTired = {
    prefix: 'fal',
    iconName: 'face-tired',
    icon: [
      512,
      512,
      [128555,"tired"],
      'f5c8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c24.2 0 48.2 3.4 71.4 10c-3.5-5.1-7.7-10.3-12.6-15.2c-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2c23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2c9.8 9.8 17.8 20.8 23.4 31.5c5.5 10.4 9.3 21.8 9.3 32.4c0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4c5.6-10.7 13.6-21.6 23.4-31.5c19.5-19.5 47.9-36.2 81.3-36.2zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z'
      
    ]
  };

  
    var faTired = faFaceTired;
  

  
  

  var faHouseLaptop = {
    prefix: 'fal',
    iconName: 'house-laptop',
    icon: [
      640,
      512,
      ["laptop-house"],
      'e066',
      
      'M229.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6c-3.1 3.7-7.6 5.6-12.1 5.6l-.2 0c-3.7 0-7.3-1.3-10.3-3.9L416 187.9l0 36.1-32 0 0-63.5L240 37.1 96 160.5 96 352c0 17.7 14.3 32 32 32l144 0 0 32-144 0c-35.3 0-64-28.7-64-64l0-164.1L26.4 220.1c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM352 256l192 0c26.5 0 48 21.5 48 48l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-26.5 21.5-48 48-48zM272 480l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM208 176l64 0c17.7 0 32 14.3 32 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-64 0 0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z'
      
    ]
  };

  
    var faLaptopHouse = faHouseLaptop;
  

  
  

  var faBurst = {
    prefix: 'fal',
    iconName: 'burst',
    icon: [
      512,
      512,
      [],
      'e4dc',
      
      'M146.5 211.2c3.3-9.6 1.8-20.1-3.9-28.4L54.9 54.9l127.9 87.7c8.3 5.7 18.9 7.2 28.4 3.9s17-10.8 20.1-20.4L256 50l26.9 83c2.7 8.3 8.6 15.1 16.4 18.9s16.8 4.3 25 1.3l54.3-19.8-19.8 54.3c-3 8.2-2.5 17.2 1.3 25s10.6 13.7 18.9 16.4L462 256l-79.6 25.8c-9 2.9-16.2 9.6-19.8 18.4s-3.1 18.6 1.3 27l40.9 77.8L327.1 364c-8.4-4.4-18.2-4.9-27-1.3s-15.5 10.8-18.4 19.8L256 462l-25.8-79.6c-2.9-9-9.6-16.2-18.4-19.8s-18.6-3.1-27 1.3l-77.8 40.9L148 327.1c4.4-8.4 4.9-18.2 1.3-27s-10.8-15.5-19.8-18.4L50 256l76.1-24.7c9.6-3.1 17.2-10.6 20.4-20.1zM173.4 97.3L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5L97.3 173.4l18.9 27.5L84.5 211.2l-67.9 22C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l72.2 23.4 30.9 10L104.6 341 66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3L171 407.4l28.7-15.1 10 30.9 23.4 72.2c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l23.4-72.2 10-30.9L341 407.4l71.9 37.8c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L407.4 341l-15.1-28.7 30.9-10 72.2-23.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-76.1-24.6-30.5-9.9 11-30.1 14.7-40.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-40.4 14.7-30.1 11-9.9-30.5-24.6-76C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-22 67.9-10.3 31.7L173.4 97.3z'
      
    ]
  };

  

  
  

  var faIntegral = {
    prefix: 'fal',
    iconName: 'integral',
    icon: [
      320,
      512,
      [],
      'f667',
      
      'M216 32c-22.1 0-40 17.9-40 40l0 368c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 22.1 17.9 40 40 40s40-17.9 40-40l0-368c0-39.8 32.2-72 72-72s72 32.2 72 72l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24c0-22.1-17.9-40-40-40z'
      
    ]
  };

  

  
  

  var faDiamondTurnRight = {
    prefix: 'fal',
    iconName: 'diamond-turn-right',
    icon: [
      512,
      512,
      ["directions"],
      'f5eb',
      
      'M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm65 137c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 240 232 240c-13.3 0-24 10.7-24 24l0 56c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-56c0-30.9 25.1-56 56-56l97.4 0-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faDirections = faDiamondTurnRight;
  

  
  

  var faSubscript = {
    prefix: 'fal',
    iconName: 'subscript',
    icon: [
      512,
      512,
      [],
      'f12c',
      
      'M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l39.2 0L157 256 55.2 416 16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-39.2 0L195 256 296.8 96 336 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4C74.6 66.8 69.5 64 64 64L16 64zM464 336c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L432 480l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-144z'
      
    ]
  };

  

  
  

  var faGlobeSnow = {
    prefix: 'fal',
    iconName: 'globe-snow',
    icon: [
      448,
      512,
      [],
      'f7a3',
      
      'M416 224c0 49.2-18.5 94-48.9 128l40.7 0c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128l40.7 0C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM240 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-27.3 44.7l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 198.6l0 34.7-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 278.6l0 73.4 32 0 0-73.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 233.4l0-34.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM360 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM50.3 391.8l-46.2 77C1.4 473.2 0 478.3 0 483.5C0 499.2 12.8 512 28.5 512l390.9 0c15.8 0 28.5-12.8 28.5-28.5c0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8L64 384c-5.6 0-10.8 2.9-13.7 7.8zM73.1 416l301.9 0 38.4 64L34.7 480l38.4-64z'
      
    ]
  };

  

  
  

  var faScaleUnbalancedFlip = {
    prefix: 'fal',
    iconName: 'scale-unbalanced-flip',
    icon: [
      640,
      512,
      ["balance-scale-right"],
      'f516',
      
      'M112.2 10.9c-2.8 8.4 1.7 17.4 10.1 20.2L256.5 75.9c4.6 24.4 23.1 43.9 46.9 50.1l0 354-192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l208 0c8.8 0 16-7.2 16-16l0-370c10.3-2.6 19.6-7.8 27.2-14.7l143.8 47.9c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L380.3 83.5c2-6.1 3-12.7 3-19.5c0-35.3-28.7-64-64-64c-28 0-51.8 18-60.5 43L132.4 .8C124-2 115 2.6 112.2 10.9zm87.1 319.3C182.2 343.1 157.1 352 128 352s-54.2-8.9-71.3-21.7C39.6 317.5 32 302.2 32 288l192 0 0-1.6c0 0 0 .1 0 .1l0 1.6c0 14.2-7.6 29.5-24.7 42.3zM128 115.3L213.7 256 42.3 256 128 115.3zM256 288l0-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2C147.2 85.2 137.9 80 128 80s-19.2 5.2-24.3 13.7l-92 151.2C4 257.4 0 271.8 0 286.4L0 288c0 53 57.3 96 128 96s128-43 128-96zM608 416c0 14.2-7.6 29.5-24.7 42.3C566.2 471.1 541.1 480 512 480s-54.2-8.9-71.3-21.7C423.6 445.5 416 430.2 416 416l192 0 0-1.6c0 0 0 .1 0 .1l0 1.6zm-10.3-32l-171.3 0L512 243.3 597.7 384zM512 512c70.7 0 128-43 128-96l0-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2c-5.2-8.5-14.4-13.7-24.3-13.7s-19.2 5.2-24.3 13.7l-92 151.2C388 385.4 384 399.8 384 414.4l0 1.6c0 53 57.3 96 128 96zM319.3 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faBalanceScaleRight = faScaleUnbalancedFlip;
  

  
  

  var faChartFft = {
    prefix: 'fal',
    iconName: 'chart-fft',
    icon: [
      512,
      512,
      [],
      'e69e',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM270.6 89.5c-2.7-6-8.8-9.8-15.4-9.5s-12.3 4.7-14.4 10.9L164.5 320 112 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c6.9 0 13-4.4 15.2-10.9l67-200.9 47.2 106.3c2.6 5.8 8.3 9.5 14.6 9.5l71.4 0 59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-64-96c-3-4.5-8-7.1-13.3-7.1l-69.6 0L270.6 89.5z'
      
    ]
  };

  

  
  

  var faAddressCard = {
    prefix: 'fal',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM112 368c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM352 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faTrashCanPlus = {
    prefix: 'fal',
    iconName: 'trash-can-plus',
    icon: [
      448,
      512,
      [],
      'e2ac',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zM208 384l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faRegistered = {
    prefix: 'fal',
    iconName: 'registered',
    icon: [
      512,
      512,
      [174],
      'f25d',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176l0 96 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 71.4 0 59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80l-64 0c-26.5 0-48 21.5-48 48zm32 80l0-80c0-8.8 7.2-16 16-16l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-80 0z'
      
    ]
  };

  

  
  

  var faGaugeLow = {
    prefix: 'fal',
    iconName: 'gauge-low',
    icon: [
      512,
      512,
      ["tachometer-alt-slow"],
      'f627',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-18.6 7.9-35.3 20.5-47L129.9 151.6c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  
    var faTachometerAltSlow = faGaugeLow;
  

  
  

  var faBomb = {
    prefix: 'fal',
    iconName: 'bomb',
    icon: [
      512,
      512,
      [128163],
      'f1e2',
      
      'M464 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM301.1 130.9c-8.8 8.8-21.8 11.7-33.5 7.5C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-21-3.7-41.1-10.4-59.7c-4.2-11.7-1.3-24.7 7.5-33.5L384 208l-80-80-2.9 2.9zm-22.6-22.6l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l28.7 28.7 17.4-17.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-17.4 17.4 28.7 28.7c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 192c-57.4 0-104 46.6-104 104l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-75.1 60.9-136 136-136l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0z'
      
    ]
  };

  

  
  

  var faTemperatureEmpty = {
    prefix: 'fal',
    iconName: 'temperature-empty',
    icon: [
      320,
      512,
      ["temperature-0","thermometer-0","thermometer-empty"],
      'f2cb',
      
      'M96 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112S48 429.9 48 368c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L96 96zM160 0C107 0 64 43 64 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C31.7 293.1 16 328.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L256 96c0-53-43-96-96-96zM128 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 368a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faTemperature0 = faTemperatureEmpty;
  
    var faThermometer0 = faTemperatureEmpty;
  
    var faThermometerEmpty = faTemperatureEmpty;
  

  
  

  var faHillAvalanche = {
    prefix: 'fal',
    iconName: 'hill-avalanche',
    icon: [
      576,
      512,
      [],
      'e507',
      
      'M191.7 48c-24.3 0-44.5 18.2-47.5 41.8L448 394.2c17.9 17.9 46.6 18.9 65.6 2.2l4.2-3.7c19.4-17 19.6-47.2 .5-64.5c-14.3-12.9-35.4-14.8-51.7-4.5l-3 1.9c-7.5 4.7-17.3 2.4-22-5.1s-2.4-17.4 5.1-22.1l3-1.9c28.4-17.8 65.2-14.6 90.1 7.9c33.3 30.2 32.9 82.7-.8 112.3l-4.2 3.7c-31.7 27.8-79.5 26.2-109.3-3.6L116.5 107.3c-3.3-3.3-4.9-7.8-4.7-12.2c.4-43.8 36-79.2 79.9-79.2c16.9 0 32.6 5.3 45.5 14.3c14.6-9 31.9-14.3 50.3-14.3c53 0 95.9 43 95.9 96c0 4.2-.3 8.3-.8 12.4c29.1 16.5 48.7 47.7 48.7 83.6c0 21.6-7.1 41.6-19.2 57.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c8-10.7 12.8-24 12.8-38.4c0-27.1-16.8-50.3-40.6-59.6c-7.6-3-11.8-11.3-9.6-19.2c1.5-5.4 2.3-11.2 2.3-17.2c0-35.4-28.6-64-63.9-64c-15.5 0-29.7 5.5-40.7 14.7c-6.3 5.3-15.6 4.9-21.5-.9C216.6 53.2 204.8 48 191.7 48zM415.2 64a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zm31.9 96a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zM54.6 96.1L415.3 457.4c20.1 20.2 5.8 54.6-22.6 54.6L64 512c-35.3 0-64-28.7-64-64L0 118.7C0 90.2 34.5 75.9 54.6 96.1zM32 448c0 17.7 14.3 32 32 32l328.6 0L32 118.7 32 448z'
      
    ]
  };

  

  
  

  var faPlaneEngines = {
    prefix: 'fal',
    iconName: 'plane-engines',
    icon: [
      576,
      512,
      [9992,"plane-alt"],
      'f3de',
      
      'M576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-96.9 0-11.1-18.7c15-5.8 25.6-20.3 25.6-37.3l0-16c0-22.1-17.9-40-40-40l-41 0L274.4 15.7C268.7 6 258.2 0 246.9 0L170.7 0c-16 0-27.6 15.4-23 30.8l15.2-4.5-15.2 4.5 43 145.2L136 176 97.6 124.8C91.6 116.7 82.1 112 72 112l-42 0c-16.6 0-30 13.4-30 30c0 2.8 .4 5.6 1.2 8.3l21.5 75.1C9.5 229.4 0 241.6 0 256s9.5 26.6 22.6 30.6L1.2 361.7C.4 364.4 0 367.2 0 370c0 16.6 13.4 30 30 30l42 0c10.1 0 19.6-4.7 25.6-12.8L136 336l54.7 0-43 145.2c-4.6 15.4 7 30.8 23 30.8l76.2 0c11.3 0 21.8-6 27.5-15.7L303 448l41 0c22.1 0 40-17.9 40-40l0-16c0-17-10.6-31.6-25.6-37.3L369.4 336l96.9 0c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256zM341 384l3 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-22 0 19-32zm3-256l-3 0L322 96l22 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8zm122.3 80c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2l-106 0c-5.7 0-10.9 3-13.8 7.8L246.9 480l-65.5 0 46.1-155.5c1.4-4.8 .5-10.1-2.5-14.1s-7.8-6.4-12.8-6.4L128 304c-5 0-9.8 2.4-12.8 6.4L72 368l-39.4 0L63.4 260.4c.8-2.9 .8-5.9 0-8.8L32.6 144 72 144l43.2 57.6c3 4 7.8 6.4 12.8 6.4l84.1 0c5 0 9.8-2.4 12.8-6.4s4-9.3 2.5-14.1L181.4 32l65.5 0 99.6 168.2c2.9 4.9 8.1 7.8 13.8 7.8l106 0z'
      
    ]
  };

  
    var faPlaneAlt = faPlaneEngines;
  

  
  

  var faClockEightThirty = {
    prefix: 'fal',
    iconName: 'clock-eight-thirty',
    icon: [
      512,
      512,
      [],
      'e346',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400l0-114.1-71.1 47.4c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l96-64c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fal',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      'M48 96c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L48 96zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zM224 96c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-48 0zm-48 16c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z'
      
    ]
  };

  

  
  

  var faLocationPinLock = {
    prefix: 'fal',
    iconName: 'location-pin-lock',
    icon: [
      512,
      512,
      [],
      'e51f',
      
      'M192 477.6c16.8-21.1 40.2-51.4 64-85.5l0 54.8c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-10.9 1.8-21.3 5.2-30.9 9.9C340.6 92.8 273.4 32 192 32C103.6 32 32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140zM144 192a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm208-48c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faStrawberry = {
    prefix: 'fal',
    iconName: 'strawberry',
    icon: [
      512,
      512,
      [],
      'e32b',
      
      'M495.4 20.4c-11.5 40.2-38.5 68.5-66.7 92.3c34.5 3.5 59.9 20.6 71.2 29.6c8.4 6.7 12.1 16.5 12.1 25.8c0 9.2-3.7 19-11.8 25.7c-9.2 7.6-29 21.9-54.1 27.8c-4-5-8.3-9.9-12.9-14.5l-15-15c1.9 .1 3.8 .1 5.9 .1c23.9 0 45.4-14.5 55.8-23c0 0 0 0 0-.1c.1-.1 .2-.4 .2-.9c0-.4-.1-.7-.1-.8C469.7 159.1 446.4 144 416 144c-14.7 0-22.9 1.8-26.9 3.2c-1.6 .6-2.6 1-2.9 1.2c-2.4 1.9-5.1 3.1-8 3.5l-18-18c.4-2.9 1.5-5.6 3.5-8c.2-.4 .7-1.3 1.2-2.9c1.3-4 3.2-12.2 3.2-26.9c0-30.4-15.1-53.7-23.2-63.9c-.1 0-.4-.1-.8-.1c-.5 0-.8 .1-.9 .2c0 0 0 0-.1 0c-8.5 10.4-23 32-23 55.8c0 2 0 4 .1 5.9l-15-15c-4.6-4.6-9.5-8.9-14.5-12.9c5.9-25.2 20.2-44.9 27.8-54.1C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1c10 12.5 29.8 42.4 30.2 82.7c29.8-24.3 54.6-48.1 64.6-83.1c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zm-206 88L403.6 222.6l6.9 6.9c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l6.9 6.9zM32 336c0 61.3 11.8 94.5 30.6 113.4S114.7 480 176 480c166.1 0 240-88.5 240-160c0-24.6-9.4-49.1-28.1-67.9l-128-128c-18.7-18.7-43.1-28.1-67.7-28.1C120.7 96 32 170 32 336zM189.5 154.5c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm47.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm96.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm24-80c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 90.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-192-80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-23.3 53.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7z'
      
    ]
  };

  

  
  

  var faArrowLeftFromLine = {
    prefix: 'fal',
    iconName: 'arrow-left-from-line',
    icon: [
      448,
      512,
      [8612,"arrow-from-right"],
      'f344',
      
      'M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 160 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0L54.6 240 155.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128zM416 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352z'
      
    ]
  };

  
    var faArrowFromRight = faArrowLeftFromLine;
  

  
  

  var faSpa = {
    prefix: 'fal',
    iconName: 'spa',
    icon: [
      576,
      512,
      [],
      'f5bb',
      
      'M371.3 219.5c9-6.5 18.5-12.6 28.2-18.1c-27.1-93.1-79.8-147.8-97.5-164.1c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.7 16.4-70.4 71.1-97.5 164.1c9.7 5.5 19.1 11.6 28.2 18.1C225.7 140 267.2 89.6 288 68.3c20.8 21.3 62.3 71.7 83.3 151.2zM192 469.1c24.1 7.1 49.5 10.9 75.9 10.9l40.2 0c26.4 0 51.8-3.8 75.9-10.9c111-32.7 192-135.4 192-257c0-11.1-9.1-20.1-20.2-20.1c-64.5 0-124.1 21.6-171.8 57.9c-43.6 33.2-77.4 78.7-96 131.2c-18.6-52.6-52.4-98.1-96-131.2C144.2 213.6 84.6 192 20.2 192C9.1 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-34.4C103.7 403.8 37.3 322.6 32.3 224.3c61.5 2.9 117.4 28 159.7 67.4c43 40.1 72 94.9 78.6 156.3c-27.3 0-53.8-4.7-78.6-13.3zm192 0c-24.8 8.6-51.2 13.3-78.6 13.3C312 386.6 341 331.7 384 291.7c42.3-39.4 98.2-64.4 159.7-67.4c-5 98.3-71.4 179.5-159.7 210.4z'
      
    ]
  };

  

  
  

  var faScroll = {
    prefix: 'fal',
    iconName: 'scroll',
    icon: [
      576,
      512,
      [128220],
      'f70e',
      
      'M32 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 288c0 44.2 35.8 80 80 80l296 0c39.8 0 72-32.2 72-72l0-56c0-22.1-18-40-40-40l-.6 0-.6 0-.6 0-.6 0-.5 0-.6 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.4 0-.5 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0c-22.1 0-40 17.9-40 40l0 48c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-288c0-18-6-34.6-16-48l256 0c26.5 0 48 21.5 48 48l0 176 32 0 0-176c0-44.2-35.8-80-80-80L80 32C35.8 32 0 67.8 0 112l0 72c0 22.1 17.9 40 40 40l56 0 0-32-56 0c-4.4 0-8-3.6-8-8l0-72zM504 448l-232 0c10-13.4 16-30 16-48l0-48c0-4.4 3.6-8 8-8l.6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .5 0 .4 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .6 0 .5 0 .6 0 .6 0 .6 0 .6 0c4.4 0 8 3.6 8 8l0 56c0 22.1-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faSquareF = {
    prefix: 'fal',
    iconName: 'square-f',
    icon: [
      448,
      512,
      [],
      'e270',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 32l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0 0 80 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112 0-96c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faBoxOpen = {
    prefix: 'fal',
    iconName: 'box-open',
    icon: [
      640,
      512,
      [],
      'f49e',
      
      'M80.4 49.5L320 77.2 559.6 49.5c14.1-1.6 27.5 6.2 33.1 19.2l32 74.7c9.8 22.9-3.5 49.1-27.8 54.7L437.7 234.8c-18.9 4.4-38.6-3.1-49.9-18.9L320 120.9l-67.9 95.1c-11.3 15.8-30.9 23.2-49.9 18.9L43 198c-24.3-5.6-37.6-31.8-27.8-54.7l32-74.7c5.6-13 19-20.8 33.1-19.2zM76.7 81.3l-32 74.7c-2 4.6 .7 9.8 5.6 10.9l159.2 36.7c6.3 1.5 12.9-1 16.6-6.3l65.1-91.2L76.7 81.3zM544 236.7l32-9.1 0 151c0 22-15 41.2-36.4 46.6l-208 52c-7.6 1.9-15.6 1.9-23.3 0l-208-52C79 419.7 64 400.6 64 378.5l0-151 32 9.1 0 141.8c0 7.3 5 13.7 12.1 15.5L304 443l0-235c0-8.8 7.2-16 16-16s16 7.2 16 16l0 235 195.9-49c7.1-1.8 12.1-8.2 12.1-15.5l0-141.8zM348.8 106.1l65.1 91.2c3.8 5.3 10.3 7.7 16.6 6.3l159.2-36.7c4.9-1.1 7.5-6.4 5.6-10.9l-32-74.7L348.8 106.1z'
      
    ]
  };

  

  
  

  var faKerning = {
    prefix: 'fal',
    iconName: 'kerning',
    icon: [
      640,
      512,
      [],
      'f86f',
      
      'M454.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l240-480zm-424 81.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l144 288c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l144-288c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L160 364.2 30.3 104.8zm320 302.3L385.9 336l188.2 0 35.6 71.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-144-288c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-144 288c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2zM480 147.8L558.1 304l-156.2 0L480 147.8z'
      
    ]
  };

  

  
  

  var faLightEmergencyOn = {
    prefix: 'fal',
    iconName: 'light-emergency-on',
    icon: [
      640,
      512,
      [],
      'e420',
      
      'M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm-112 0l0 128 32 0 0-128c0-88.4-71.6-160-160-160s-160 71.6-160 160l0 128 32 0 0-128c0-70.7 57.3-128 128-128s128 57.3 128 128zM128 400c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16l0-32zm-32 0l0 32c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-352 0c-26.5 0-48 21.5-48 48zM320 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSquareArrowUpRight = {
    prefix: 'fal',
    iconName: 'square-arrow-up-right',
    icon: [
      448,
      512,
      ["external-link-square"],
      'f14c',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zm64 32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM168 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l97.4 0L132.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 214.6 288 320c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16l-136 0z'
      
    ]
  };

  
    var faExternalLinkSquare = faSquareArrowUpRight;
  

  
  

  var faBanjo = {
    prefix: 'fal',
    iconName: 'banjo',
    icon: [
      512,
      512,
      [129685],
      'f8a3',
      
      'M445.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 61.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5L406.6 72l39-39zM376.4 60.5l-15 67.5-62.4 62.4c-25.2-20.8-56.6-34.4-90.9-37.7l0-8.8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8.8c-34.4 3.2-65.8 16.9-90.9 37.7l-6.2-6.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l6.2 6.2C41.6 238.2 28 269.6 24.8 304L16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l8.8 0c3.2 34.4 16.9 65.8 37.7 90.9l-6.2 6.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l6.2-6.2c25.2 20.8 56.6 34.4 90.9 37.7l0 8.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.8c34.4-3.2 65.8-16.9 90.9-37.7l6.2 6.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-6.2-6.2c20.8-25.2 34.4-56.6 37.7-90.9l8.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8.8 0c-3.2-34.4-16.9-65.8-37.7-90.9L384 150.6l67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3L380.7 52.7c-2.2 2.2-3.6 4.9-4.3 7.8zM192 184a136 136 0 1 1 0 272 136 136 0 1 1 0-272zM124.7 316.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faFileImport = {
    prefix: 'fal',
    iconName: 'file-import',
    icon: [
      512,
      512,
      ["arrow-right-to-file"],
      'f56f',
      
      'M480 448c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-80-32 0 0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 192 32 0 0-192c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256zm-.5-288L368 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM283.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 304 16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l313.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  
    var faArrowRightToFile = faFileImport;
  

  
  

  var faCommentPen = {
    prefix: 'fal',
    iconName: 'comment-pen',
    icon: [
      512,
      512,
      ["comment-edit"],
      'f4ae',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm60.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zM207.1 271.1l60.7-60.7 17.8 17.8L224.8 289c-2.1 2.1-4.6 3.5-7.4 4.2L198 298l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 157l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63c-17.4-17.4-45.7-17.4-63.1 0z'
      
    ]
  };

  
    var faCommentEdit = faCommentPen;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fal',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM363.3 283.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L240 329.4 240 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 185.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faCameraRetro = {
    prefix: 'fal',
    iconName: 'camera-retro',
    icon: [
      512,
      512,
      [128247],
      'f083',
      
      'M192 112L64 112c-17.7 0-32 14.3-32 32l0 80 113.1 0c22.1-38.3 63.5-64 110.9-64s88.7 25.7 110.9 64L480 224l0-128c0-17.7-14.3-32-32-32L277.3 64c-6.9 0-13.7 2.2-19.2 6.4l-46.9 35.2c-5.5 4.2-12.3 6.4-19.2 6.4zM32 256l0 160c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-160-100 0c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32L32 256zM0 416L0 144c0-35.3 28.7-64 64-64l128 0 46.9-35.2C250 36.5 263.5 32 277.3 32L448 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM352 288a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM64 48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 64c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFilterCircleDollar = {
    prefix: 'fal',
    iconName: 'filter-circle-dollar',
    icon: [
      576,
      512,
      ["funnel-dollar"],
      'f662',
      
      'M0 39.5C0 17.7 17.7 0 39.5 0L472.5 0C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5L39.5 32c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 269.8c2.4 2.9 3.7 6.5 3.7 10.2l0 88.2 34 26.4c2.7 18.1 8.3 35.3 16.1 51.2c-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3l0-82.4L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM408.8 335.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z'
      
    ]
  };

  
    var faFunnelDollar = faFilterCircleDollar;
  

  
  

  var faBinaryLock = {
    prefix: 'fal',
    iconName: 'binary-lock',
    icon: [
      640,
      512,
      [],
      'e33d',
      
      'M313.4 3c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L288 192l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176c0-5.1-2.5-10-6.6-13zM89.4 291c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L64 480l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176c0-5.1-2.5-10-6.6-13zM80 0C35.8 0 0 35.8 0 80l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80L80 0zM32 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64zM192 368l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80l-32 0c-44.2 0-80 35.8-80 80zm80-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm256-96c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fal',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M315.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm0 192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM128.7 283.1c10.4-1.5 19.4-8.1 24.1-17.5l39.1-79.4L231 265.5c4.7 9.5 13.7 16 24.1 17.5l87.5 12.7-63.4 61.9c-7.5 7.3-11 17.9-9.2 28.3l15 87.3-78.2-41.2c-9.3-4.9-20.5-4.9-29.8 0L98.8 473.3l15-87.3c1.8-10.4-1.7-20.9-9.2-28.3L41.2 295.8l87.5-12.7zm84.7-125.6c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z'
      
    ]
  };

  

  
  

  var faPersonSkating = {
    prefix: 'fal',
    iconName: 'person-skating',
    icon: [
      448,
      512,
      ["skating"],
      'f7c5',
      
      'M392 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm280.4-10.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4L272 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l88.8 0c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4zM274.7 144L112 144c-8.8 0-16-7.2-16-16s7.2-16 16-16l204.2 0c28.6 0 51.8 23.2 51.8 51.8c0 18.2-9.5 35-25.1 44.4l-90.1 54L310.6 320c6 6 9.4 14.1 9.4 22.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-70.5-70.5c-11.2-11.2-17.5-26.4-17.5-42.3c0-18.8 8.9-36.5 23.9-47.8L274.7 144zm49.9 1.9c-.9 1.1-1.9 2.1-3 2.9l-78.5 58.9c-7 5.2-11.1 13.5-11.1 22.2c0 2.4 .3 4.7 .9 6.9l93.5-56.1c5.9-3.6 9.6-10 9.6-16.9c0-7.9-4.7-14.8-11.4-17.9zM180.8 276.6c3.9 6.6 8.7 12.8 14.2 18.3l6.4 6.4-94.1 94.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96.1-96.1z'
      
    ]
  };

  
    var faSkating = faPersonSkating;
  

  
  

  var faSuitcase = {
    prefix: 'fal',
    iconName: 'suitcase',
    icon: [
      512,
      512,
      [129523],
      'f0f2',
      
      'M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm240 32l-224 0-16 0 0 320 256 0 0-320-16 0zM64 128c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l32 0 0-320-32 0zM448 448c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0 0 320 32 0z'
      
    ]
  };

  

  
  

  var faReplyAll = {
    prefix: 'fal',
    iconName: 'reply-all',
    icon: [
      576,
      512,
      ["mail-reply-all"],
      'f122',
      
      'M202.8 59.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1L24.8 178.4c-17.5 15.9-17.5 43.3 0 59.2L181.2 379.8c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L46.3 213.9c-3.5-3.2-3.5-8.7 0-11.8L202.8 59.8zM320 160l80 0c79.5 0 144 64.5 144 144c0 46.1-15.9 79.7-34.1 103.2c1.3-7.1 2.1-14.8 2.1-23.2c0-70.7-57.3-128-128-128l-64 0c0 0 0 0 0 0l-8 0c-13.3 0-24 10.7-24 24l0 8 0 16 0 48L128 208 288 64l0 48 0 16 0 8c0 13.3 10.7 24 24 24l8 0zm0 160l0-16 0-16 32 0 32 0c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176l-48 0-32 0 0-16 0-16 0-32c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C99.8 190.3 96 198.9 96 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-32z'
      
    ]
  };

  
    var faMailReplyAll = faReplyAll;
  

  
  

  var faCrystalBall = {
    prefix: 'fal',
    iconName: 'crystal-ball',
    icon: [
      448,
      512,
      [],
      'e362',
      
      'M416 224c0 49.2-18.5 94-48.9 128l40.7 0c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128l40.7 0C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM64 384c-5.6 0-10.8 2.9-13.7 7.8l-46.2 77C1.4 473.2 0 478.3 0 483.5C0 499.2 12.8 512 28.5 512l390.9 0c15.8 0 28.5-12.8 28.5-28.5c0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8L64 384zM34.7 480l38.4-64 301.9 0 38.4 64L34.7 480zM288 144c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16zM144 96c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCertificate = {
    prefix: 'fal',
    iconName: 'certificate',
    icon: [
      512,
      512,
      [],
      'f0a3',
      
      'M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8l12.3-48.6 35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6L400.6 146c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3L366 400.6c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8l-12.3 48.6-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1L97.8 414.2 111.4 366c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15L39.8 313.9l36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8 146 111.4c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256 30.5 278.3 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3L256 458.5l22.3 22.9L301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6L458.5 256l22.9-22.3L504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-31.2 8.8-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L278.3 30.5 256 53.5 233.7 30.5 211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z'
      
    ]
  };

  

  
  

  var faTentArrowDownToLine = {
    prefix: 'fal',
    iconName: 'tent-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e57e',
      
      'M243.8 117.2c-5.9-6.5-16.1-7-22.6-1.1L160 171.8 160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 155.8L66.8 116.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6l88 80c6.1 5.5 15.4 5.5 21.5 0l88-80c6.5-5.9 7-16.1 1.1-22.6zM0 496c0 8.8 7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480c-8.8 0-16 7.2-16 16zM393.5 131.1c-5.7-4.2-13.4-4.2-19 0L201 259.3c-10.1 7.5-16.9 18.7-18.9 31.1l-22 139c-1.4 8.7 4.6 16.9 13.3 18.3s16.9-4.6 18.3-13.3l22-139.1c.7-4.1 2.9-7.9 6.3-10.4L368 175.7l0 112.1c0 .2 0 .3 0 .5L368 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-91.2 66.7 100c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L400 283.2l0-107.4L547.9 285.1c3.4 2.5 5.6 6.2 6.3 10.4l22 139.1c1.4 8.7 9.6 14.7 18.3 13.3s14.7-9.6 13.3-18.3l-22-139c-2-12.4-8.7-23.6-18.9-31.1L393.5 131.1z'
      
    ]
  };

  

  
  

  var faArrowDownLong = {
    prefix: 'fal',
    iconName: 'arrow-down-long',
    icon: [
      384,
      512,
      ["long-arrow-down"],
      'f175',
      
      'M180.7 507.3c6.2 6.2 16.4 6.2 22.6 0l144-144c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4 208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 441.4L59.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144z'
      
    ]
  };

  
    var faLongArrowDown = faArrowDownLong;
  

  
  

  var faUpToBracket = {
    prefix: 'fal',
    iconName: 'up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66e',
      
      'M222.2 192.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 324.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L288 336c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 192.8zM224 160c-9.5 0-18.6 3.9-25.1 10.8L74.5 302.8C67.8 310 64 319.5 64 329.3c0 21.4 17.3 38.7 38.7 38.7l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 170.8c-6.5-6.9-15.6-10.8-25.1-10.8zM32 176l0-96c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-44.2-35.8-80-80-80L80 0C35.8 0 0 35.8 0 80l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faUserTie = {
    prefix: 'fal',
    iconName: 'user-tie',
    icon: [
      448,
      512,
      [],
      'f508',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l9.8 0-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-79-56.8-144.7-131.8-158.6c-6.8-1.3-13.4 2.5-16.3 8.8L267.9 401l-21.7-65 9.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0-32 0zm17.5 160.5l-9.7-21.1L224 370.6l24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3 .7 .7 1.4 1 2.1L32 480c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480l-149.4 0c.3-.7 .7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z'
      
    ]
  };

  

  
  

  var faSquarePersonConfined = {
    prefix: 'fal',
    iconName: 'square-person-confined',
    icon: [
      448,
      512,
      [],
      'e577',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm296 96c30.9 0 56 25.1 56 56l0 112c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1L240 343.6l0-95.6c0-30.9 25.1-56 56-56zm24 168l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24zM232 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'
      
    ]
  };

  

  
  

  var faViruses = {
    prefix: 'fal',
    iconName: 'viruses',
    icon: [
      640,
      512,
      [],
      'e076',
      
      'M78.9 327.8l15.2-15.2c30.2-30.2 81.9-8.8 81.9 33.9l0 21.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-21.5c0-42.8 51.7-64.2 81.9-33.9l15.2 15.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-15.2-15.2c-30.2-30.2-8.8-81.9 33.9-81.9l21.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-21.5 0c-42.8 0-64.2-51.7-33.9-81.9l15.2-15.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.9 71.4C259.7 101.7 208 80.3 208 37.5L208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 21.5c0 42.8-51.7 64.2-81.9 33.9L78.9 56.2c-6.2-6.2-16.4-6.3-22.6 0s-6.2 16.4 0 22.6L71.4 94.1c30.2 30.2 8.8 81.9-33.9 81.9L16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l21.5 0c42.8 0 64.2 51.7 33.9 81.9L56.2 305.1c-6.2 6.2-6.3 16.4 0 22.6s16.4 6.2 22.6 0zm7-135.8c22.8-17.4 34.9-46.6 31.1-75c28.5 3.8 57.6-8.3 75-31.1c8.4 11 19.5 19.5 32 24.9c13.4 5.8 28.3 8.1 43 6.1c-3.8 28.5 8.3 57.6 31.1 75c-22.8 17.4-34.9 46.6-31.1 75c-28.5-3.8-57.6 8.3-75 31.1c-17.4-22.8-46.6-34.9-75-31.1c3.8-28.5-8.3-57.6-31.1-75zm82.1 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm101.8 95.2C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM579.5 368c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c8.5 10 19.7 17.3 32 21.3c8.7 2.8 17.9 3.9 27.1 3.2c-1.8 22.3 7.4 44.6 24.5 59.1z'
      
    ]
  };

  

  
  

  var faBatteryExclamation = {
    prefix: 'fal',
    iconName: 'battery-exclamation',
    icon: [
      576,
      512,
      [],
      'e0b0',
      
      'M208 96L80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l136.6 0c-5.4-9.4-8.6-20.3-8.6-32L80 384c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l128 0 0-32zM432 416c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80l-96 0 0 32 96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c0 11.7-3.1 22.6-8.6 32L432 416zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM272 96c-8.8 0-16 7.2-16 16l0 184c0 8.8 7.2 16 16 16s16-7.2 16-16l0-184c0-8.8-7.2-16-16-16zm24 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSterlingSign = {
    prefix: 'fal',
    iconName: 'sterling-sign',
    icon: [
      320,
      512,
      [163,"gbp","pound-sign"],
      'f154',
      
      'M80 152c0-48.6 39.4-88 88-88l7.1 0c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2L168 32C101.7 32 48 85.7 48 152l0 104-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l31.9 0C46.3 346.2 31 403.1 3.1 454.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L42.1 448c23.5-50.1 36.4-104.6 37.8-160L240 288c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 256l0-104z'
      
    ]
  };

  
    var faGbp = faSterlingSign;
  
    var faPoundSign = faSterlingSign;
  

  
  

  var faSmoke = {
    prefix: 'fal',
    iconName: 'smoke',
    icon: [
      640,
      512,
      [],
      'f760',
      
      'M160 32c-53 0-96 43-96 96c0 28.1 12 53.3 31.2 70.8c-11.2 3.2-21.9 7.5-32.1 12.8C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-9.1 5.8-17.5 12.4-25.3 19.8C384.1 81.8 354.1 64 320 64c-20.8 0-40 6.6-55.7 17.8c-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C224.5 50 194.3 32 160 32zM144 256C82.1 256 32 306.1 32 368s50.1 112 112 112l320 0c44.2 0 80-35.8 80-80s-35.8-80-80-80c-11.7 0-22.7 2.5-32.7 7c-4 1.8-8.6 1.9-12.7 .2s-7.3-5-8.8-9.1c-13.7-36.3-48.8-62-89.8-62c-28.9 0-54.8 12.8-72.4 33c-2.9 3.4-7.1 5.4-11.6 5.5s-8.8-1.6-11.9-4.8C203.7 268.9 175.4 256 144 256zM0 368c0-79.5 64.5-144 144-144c34.5 0 66.2 12.1 90.9 32.3C257.5 236.2 287.3 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112l-320 0C64.5 512 0 447.5 0 368zM608 224c0-53-43-96-96-96c-41.3 0-76.6 26.1-90.1 62.8c-2 5.4-6.7 9.3-12.4 10.3s-11.4-1.2-15-5.7C376.8 173.8 350 160 320 160c-38.7 0-72.1 22.9-87.3 56c-9.2-5.4-18.9-9.9-29-13.6C224 158.5 268.4 128 320 128c31.4 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9c-5.5-9.2-11.9-17.8-19.2-25.6C592.6 283.9 608 255.7 608 224z'
      
    ]
  };

  

  
  

  var faMaskSnorkel = {
    prefix: 'fal',
    iconName: 'mask-snorkel',
    icon: [
      576,
      512,
      [],
      'e3b7',
      
      'M560 32c8.8 0 16 7.2 16 16l0 112-32 0 0-112c0-8.8 7.2-16 16-16zM448 480c53 0 96-43 96-96l0-192 32 0 0 192c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53 43 96 96 96zM64 96c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l79.7 0c14.3 0 26.8-9.5 30.8-23.2l3.4-11.7c13.3-46.4 79-46.4 92.3 0l3.4 11.7c3.9 13.7 16.5 23.2 30.8 23.2l79.7 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l320 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-79.7 0c-28.6 0-53.7-18.9-61.5-46.4l-3.4-11.7c-4.4-15.5-26.3-15.5-30.8 0l-3.4 11.7c-7.9 27.5-33 46.4-61.5 46.4L64 288c-35.3 0-64-28.7-64-64l0-96z'
      
    ]
  };

  

  
  

  var faImageSlash = {
    prefix: 'fal',
    iconName: 'image-slash',
    icon: [
      640,
      512,
      [],
      'e1b7',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 96c0-35.3-28.7-64-64-64L139.6 32l40.5 32L512 64c17.7 0 32 14.3 32 32l0 169.4-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0l-31 31 25.3 20 28.4-28.4c3.1-3.1 8.2-3.1 11.3 0L544 310.6l0 40.7 32 25.3L576 96zM297.6 319.8l-9.6 9.6-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0L96 329.4l0-168.7L64 135.4 64 416c0 35.3 28.7 64 64 64l372.4 0-40.5-32-245.3 0L322.8 339.8l-25.3-20zM265.4 352l-96 96L128 448c-17.7 0-32-14.3-32-32l0-41.4 90.3-90.3c3.1-3.1 8.2-3.1 11.3 0L265.4 352z'
      
    ]
  };

  

  
  

  var faPersonWalkingDashedLineArrowRight = {
    prefix: 'fal',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
      640,
      512,
      [],
      'e553',
      
      'M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zM416 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM538.2 163.7c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5L579.8 240 384 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l195.8 0-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80zM400 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32zm-16 80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faStocking = {
    prefix: 'fal',
    iconName: 'stocking',
    icon: [
      384,
      512,
      [],
      'f7d5',
      
      'M96 32l256 0 0 48L96 80l0-48zM64 32l0 48c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32L96 0C78.3 0 64 14.3 64 32zm64 206.9l0-94.9-32 0 0 94.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5L352 144l-32 0 0 171.5c0 32.1-16 62.1-42.7 79.9L173.2 464.7c-14.9 9.9-32.4 15.3-50.4 15.3C72.7 480 32 439.3 32 389.2l0-2.2c0-31.1 15.6-60.2 41.4-77.4l26.1-17.4c17.8-11.9 28.5-31.9 28.5-53.3z'
      
    ]
  };

  

  
  

  var faTeddyBear = {
    prefix: 'fal',
    iconName: 'teddy-bear',
    icon: [
      576,
      512,
      [],
      'e3cf',
      
      'M160 64c0 12.5 7.2 23.4 17.8 28.7c6.9 3.4 10.3 11.2 8.3 18.6c-1.3 4.8-2.1 10.4-2.1 16.7c0 51.3 44.7 96 104 96s104-44.7 104-96c0-6.4-.8-11.9-2.1-16.7c-2-7.4 1.5-15.2 8.3-18.6C408.8 87.4 416 76.5 416 64c0-17.7-14.3-32-32-32c-15.1 0-27.8 10.5-31.2 24.7c-2 8.6-10.5 13.9-19.1 12C319 65.3 303 64 288 64s-31 1.3-45.7 4.6c-8.6 1.9-17.1-3.4-19.1-12C219.8 42.5 207.1 32 192 32c-17.7 0-32 14.3-32 32zM192 0c24.8 0 46.4 14.2 57 34.8c13.3-2 26.6-2.8 39-2.8s25.7 .8 39 2.8C337.6 14.2 359.2 0 384 0c35.3 0 64 28.7 64 64c0 20.6-9.8 38.9-24.9 50.6c.6 4.3 .9 8.8 .9 13.4c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-4.6 .3-9.1 .9-13.4C137.8 102.9 128 84.6 128 64c0-35.3 28.7-64 64-64zm96 184c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM56 190c27.6-22.1 67.9-17.6 90 10l10.8 13.5c67.3 84.1 195.1 84.1 262.4 0L430 200c22.1-27.6 62.4-32.1 90-10s32.1 62.4 10 90l-10.8 13.5c-27 33.7-59.5 59.8-95.1 78.2l0 12.3 26 0c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 35.7-15.5 70.2-25.3 88.7c-8.1 15.3-24 23.3-39.9 23.3L464 512c0 0-.1 0-.1 0l-351.8 0c0 0-.1 0-.1 0l-46.9 0c-15.9 0-31.8-8-39.9-23.3C15.5 470.2 0 435.7 0 400c0-35.3 28.7-64 64-64c29.8 0 54.9 20.4 62 48l26 0 0-12.3c-35.6-18.4-68.2-44.5-95.1-78.2L46 280c-22.1-27.6-17.6-67.9 10-90zm55.9 290c0 0 .1 0 .1 0l96 0 0-16c0-26.5-21.5-48-48-48c0 0 0 0 0 0l-48 0c-8.8 0-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 27.6 12.4 56.4 21.5 73.7c1.9 3.6 6.1 6.3 11.6 6.3l46.8 0zM184 387.7c4 1.3 7.9 2.8 11.6 4.7C205.7 359.7 236.1 336 272 336l32 0c35.9 0 66.3 23.7 76.4 56.3c3.7-1.8 7.6-3.4 11.6-4.7l0-25.9c0-6.2 3.6-11.8 9.2-14.5c34.9-16.5 66.8-41.1 93-73.8L505 260c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-10.8 13.5c-80.1 100.1-232.3 100.1-312.3 0L121 220c-11-13.8-31.2-16-45-5s-16 31.2-5 45l10.8 13.5c26.2 32.7 58.1 57.3 93 73.8c5.6 2.6 9.2 8.3 9.2 14.5l0 25.9zM224 416c10 13.4 16 30 16 48l0 16 96 0 0-16c0-18 6-34.6 16-48c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48zm192 0c-26.5 0-48 21.5-48 48l0 16 96 0c0 0 .1 0 .1 0l46.8 0c5.5 0 9.7-2.7 11.6-6.3c9.2-17.3 21.5-46.1 21.5-73.7c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16l-48 0s0 0 0 0zM240 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faVolcano = {
    prefix: 'fal',
    iconName: 'volcano',
    icon: [
      512,
      512,
      [127755],
      'f770',
      
      'M213 58.7c-2.5 5-7.4 8.3-12.9 8.8s-11-2-14.3-6.4c-5.9-7.9-15.2-13-25.8-13c-17.7 0-32 14.3-32 32s14.3 32 32 32c9.7 0 18.3-4.3 24.2-11.1c3.1-3.6 7.7-5.6 12.4-5.5s9.2 2.3 12.2 6l46.7 58.4c.1 .2 .3 .2 .5 .2s.4-.1 .5-.2l46.7-58.4c3-3.7 7.4-5.9 12.2-6s9.3 1.9 12.4 5.5c5.9 6.8 14.5 11.1 24.2 11.1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-10.6 0-19.9 5.1-25.8 13c-3.3 4.5-8.7 6.9-14.3 6.4s-10.5-3.8-12.9-8.8C291.1 42.8 274.8 32 256 32s-35.1 10.8-43 26.7zM256 0c23.9 0 45.3 10.5 60 27.1c10.3-7 22.6-11.1 36-11.1c35.3 0 64 28.7 64 64s-28.7 64-64 64c-12.5 0-24.2-3.6-34.1-9.8l-36.4 45.6c-6.2 7.7-15.6 12.3-25.5 12.3s-19.3-4.5-25.5-12.3l-36.4-45.6c-9.9 6.2-21.5 9.8-34.1 9.8c-35.3 0-64-28.7-64-64s28.7-64 64-64c13.4 0 25.8 4.1 36 11.1C210.7 10.5 232.1 0 256 0zM32 459.8C32 471 41 480 52.2 480l407.7 0c11.1 0 20.2-9 20.2-20.2c0-4.9-1.8-9.7-5.1-13.4L387 347.5 362 385c-6.3 9.4-16.8 15-28 15c-8.9 0-17.5-3.6-23.8-9.9l-34.5-34.5C263.1 343.1 246 336 228.3 336c-13.2 0-26.1 3.9-37.1 11.2l-17.8 11.9c-8.7 5.8-18.9 8.9-29.3 8.9s-20.6-3.1-29.3-8.9L37.1 446.4c-3.3 3.7-5.1 8.5-5.1 13.4zm303.4-92.6L365 322.8l-40.3-45.3c-12.1-13.7-29.6-21.5-47.8-21.5l-41.8 0c-18.3 0-35.7 7.8-47.8 21.5l-50.8 57.1c2.4 .9 4.9 1.4 7.5 1.4c4.1 0 8.1-1.2 11.6-3.5l17.8-11.9c16.3-10.8 35.4-16.6 54.9-16.6c26.2 0 51.4 10.4 70 29l34.5 34.5c.3 .3 .8 .5 1.2 .5c.6 0 1.1-.3 1.4-.8zm13.3-111l34.7 39.1s0 0 0 0l22 24.7s0 0 0 0l93.5 105.2c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2L52.2 512C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l74.6-84 21.5-24.1 54.1-60.8c18.2-20.5 44.3-32.2 71.8-32.2l41.8 0c27.4 0 53.5 11.7 71.8 32.2z'
      
    ]
  };

  

  
  

  var faLariSign = {
    prefix: 'fal',
    iconName: 'lari-sign',
    icon: [
      384,
      512,
      [],
      'e1c8',
      
      'M144 32c8.8 0 16 7.2 16 16l0 50.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7L224 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 58.9c62.8 22.2 110.7 76.2 124.2 142.7c1.8 8.7-3.8 17.1-12.5 18.9s-17.1-3.8-18.9-12.5c-10.5-51.6-45.7-94.1-92.8-114.7L256 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-140.8c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2L160 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-130.7C71.5 166 32 222.4 32 288c0 88.4 71.6 160 160 160l176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-176 0L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l69.8 0C34.1 413.6 0 354.8 0 288c0-83.6 53.4-154.7 128-181.1L128 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faUserPolice = {
    prefix: 'fal',
    iconName: 'user-police',
    icon: [
      448,
      512,
      [],
      'e333',
      
      'M217.1 .8l-144 32C61.7 35.3 52.5 43.8 49.3 55.1s-.2 23.3 8.1 31.6L80 109.3l0 1.6c0 15.6 7.6 31.8 23.2 40.1c22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1l0-1.6 22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32c-4.6-1-9.3-1-13.9 0zM224 32L368 64 340.7 91.3c-3 3-4.7 7.1-4.7 11.3l0 8.2c0 5.8-2.8 10-6.2 11.8c-11.9 6.3-30.3 13.8-58.4 18C284.2 121.1 288 98.9 288 83.2c0-6.5-4-12.4-10.1-14.9l-48-19.2c-3.8-1.5-8.1-1.5-11.9 0l-48 19.2C164 70.8 160 76.7 160 83.2c0 15.7 3.8 37.9 16.5 57.5c-28.1-4.2-46.5-11.7-58.4-18c-3.4-1.8-6.2-6-6.2-11.8l0-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64 224 32zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-9.1 4.3-19.6 8.5-31.8 12.1C318.1 246.9 275.9 288 224 288s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1c-.2 2.9-.3 5.8-.3 8.7zm128-49.7C203.5 131 195.1 111 192.7 93.7L224 81.2l31.3 12.5C252.9 111 244.5 131 224 142.3zM191.4 429.5c18.4 17 46.7 17 65.1 0L305.8 384l7.8 0c54.4 0 98.9 42.4 102.2 96L336 480l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16L32.2 480c3.3-53.6 47.8-96 102.2-96l7.8 0 49.3 45.5zM320.3 512l102.1 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352l-7.8 0c-8 0-15.8 3-21.7 8.5L234.9 406c-6.1 5.7-15.6 5.7-21.7 0l-49.3-45.5c-5.9-5.5-13.7-8.5-21.7-8.5l-7.8 0C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512l294.1 0c.1 0 .2 0 .3 0s.2 0 .3 0z'
      
    ]
  };

  

  
  

  var faCircleChevronUp = {
    prefix: 'fal',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM379.3 276.7l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 198.6 356.7 299.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faUpRight = {
    prefix: 'fal',
    iconName: 'up-right',
    icon: [
      384,
      512,
      [],
      'e2be',
      
      'M312 128c4.4 0 8 3.6 8 8l0 201.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-61.4-61.4c-6.2-6.2-16.4-6.2-22.6 0L112 393.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L54.6 368c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16L167.3 223.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-61.4-61.4c-1.2-1.2-1.9-2.9-1.9-4.7c0-3.7 3-6.6 6.6-6.6L312 128zm40 8c0-22.1-17.9-40-40-40L110.6 96C89.3 96 72 113.3 72 134.6c0 10.2 4.1 20.1 11.3 27.3L133.4 212 32 313.4C21.8 323.6 16 337.5 16 352s5.8 28.4 16 38.6L57.4 416c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16L236 314.6l50.1 50.1c7.2 7.2 17.1 11.3 27.3 11.3c21.3 0 38.6-17.3 38.6-38.6L352 136z'
      
    ]
  };

  

  
  

  var faFileMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'file-magnifying-glass',
    icon: [
      384,
      512,
      ["file-search"],
      'f865',
      
      'M240 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-8.4 78.3C215.9 409.4 196.7 416 176 416c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l45.1 45.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.1-45.1zM352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z'
      
    ]
  };

  
    var faFileSearch = faFileMagnifyingGlass;
  

  
  

  var faGearComplex = {
    prefix: 'fal',
    iconName: 'gear-complex',
    icon: [
      512,
      512,
      [],
      'e5e9',
      
      'M215 62.8l4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8C232.9 32.9 244.4 32 256 32s23.1 .9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8L297 62.8c2.9 14.4 13.2 25.2 25.5 30.3c0 0 0 0 0 0l1.5 .6c0 0 0 0 0 0c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3c9.1 6.7 17.7 14 25.6 21.9l.8 .8s0 0 0 0c7.9 8 15.3 16.5 21.9 25.6c-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5c0 0 0 0 0 0l.6 1.5c0 0 0 0 0 0c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5 .3 2.8 1 3.8 1.9c1.7 11.1 2.6 22.4 2.6 34l0 .4c0 11.6-.9 22.9-2.6 34c-1.1 1-2.4 1.6-3.8 1.9L449.2 297c-14.4 2.9-25.2 13.2-30.3 25.5c0 0 0 0 0 0l-.6 1.5c0 0 0 0 0 0c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1c-13.6 18.5-29.9 34.9-48.4 48.4c-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3c0 0 0 0 0 0l-1.5 .6c0 0 0 0 0 0c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8c-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8L215 449.2c-2.9-14.4-13.2-25.2-25.5-30.3c0 0 0 0 0 0l-1.5-.6c0 0 0 0 0 0c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2 .8-2.6 1.3-4.1 1.3c-18.5-13.6-34.9-29.9-48.4-48.4c.1-1.4 .5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5c0 0 0 0 0 0l-.6-1.5c0 0 0 0 0 0c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9C32.9 279.1 32 267.6 32 256s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9L62.8 215c14.4-2.9 25.2-13.2 30.3-25.5c0 0 0 0 0 0l.6-1.5c0 0 0 0 0 0c5.2-12.3 4.8-27.3-3.3-39.5L76.6 127.7c-.8-1.2-1.3-2.6-1.3-4.1c6.7-9.1 14-17.7 22-25.7l.8-.8s0 0 0 0c8-7.9 16.6-15.3 25.7-22c1.4 .1 2.8 .5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3c0 0 0 0 0 0l1.5-.6c0 0 0 0 0 0c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7c-2 .3-3.9 1-5.6 2.1c-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9c0 0 0 0 0 0c0 0 0 0-.1 0l-1.7 .7s0 0 0 0c0 0 0 0-.1 0c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6c-1.9 .5-3.8 1.3-5.4 2.5C96.6 55.2 85.6 64.4 75.4 74.5c0 0 0 0 0 0l-.8 .8c0 0 0 0 0 0C64.4 85.6 55.2 96.6 46.9 108.3c-1.2 1.6-2 3.5-2.5 5.4c-2.6 10.6-.8 22.1 5.6 31.7l13.8 20.6c1.5 2.2 2 5.7 .4 9.4c0 0 0 0 0 .1l-.7 1.7s0 0 0 0c0 0 0 0 0 .1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6c-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6c5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6 .5 5.4 2.6 6.9 6.3c0 0 0 0 0 .1l.7 1.7c0 0 0 0 0 .1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7c.5 1.9 1.3 3.8 2.5 5.4c16.8 23.8 37.6 44.6 61.5 61.5c1.6 1.2 3.5 2 5.4 2.5c10.6 2.6 22.1 .8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4c0 0 0 0 .1 0l1.7 .7c0 0 0 0 .1 0c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4c1.7 1 3.6 1.7 5.6 2.1c14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1c9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9c0 0 0 0 .1 0l1.7-.7c0 0 0 0 .1 0c3.7-1.5 7.1-1 9.4 .4L366.5 462c9.6 6.4 21.2 8.2 31.7 5.6c1.9-.5 3.8-1.3 5.4-2.5c23.8-16.8 44.6-37.6 61.5-61.4c1.2-1.6 2-3.5 2.5-5.4c2.6-10.6 .8-22.1-5.6-31.7l-13.8-20.6c-1.5-2.2-2-5.7-.4-9.4c0 0 0 0 0-.1l.7-1.7c0 0 0 0 0-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6c1-1.7 1.7-3.6 2.1-5.6c2.4-14 3.7-28.5 3.7-43.2c0 0 0 0 0 0l0-.4s0 0 0 0c0-14.7-1.3-29.1-3.7-43.2c-.3-2-1-3.9-2.1-5.6c-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3c0 0 0 0 0-.1l-.7-1.7c0 0 0 0 0-.1c-1.5-3.7-1-7.1 .4-9.4L462 145.5c6.4-9.6 8.2-21.2 5.6-31.7c-.5-1.9-1.3-3.8-2.5-5.4c-8.3-11.7-17.5-22.7-27.6-32.9c0 0 0 0 0 0l-.9-.9c0 0 0 0 0 0c-10.1-10.1-21.1-19.3-32.9-27.6c-1.6-1.2-3.5-2-5.4-2.5c-10.6-2.6-22.1-.8-31.7 5.6L345.9 63.7c-2.2 1.5-5.7 2-9.4 .4c0 0 0 0-.1 0l-1.7-.7c0 0 0 0-.1 0c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4c-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faUniversalAccess = {
    prefix: 'fal',
    iconName: 'universal-access',
    icon: [
      512,
      512,
      [],
      'f29a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM129.7 200.8c-4 7.9-.7 17.5 7.2 21.5l21.1 10.5c16 8 32.8 14 50.1 17.8l0 67.7-15.7 78.4c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6L237.1 336l37.8 0 13.4 67.1c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L304 318.4l0-67.7c17.3-3.9 34.1-9.9 50.1-17.8l21.1-10.5c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-21.1 10.5c-26 13-54.7 19.8-83.8 19.8s-57.8-6.8-83.8-19.8l-21.1-10.5c-7.9-4-17.5-.7-21.5 7.2zM240 255.4c5.3 .4 10.7 .6 16 .6s10.7-.2 16-.6l0 48.6-32 0 0-48.6z'
      
    ]
  };

  

  
  

  var faAperture = {
    prefix: 'fal',
    iconName: 'aperture',
    icon: [
      512,
      512,
      [],
      'e2df',
      
      'M256 480c-6.1 0-12.1-.2-18.1-.7L316 344l13.8-23.9c0 0 .1-.1 .1-.1l18.5-32 67 116.1 3.3 5.8C377.9 453.1 320.1 480 256 480zm73.9-288L464 192l6.7 0c6 20.3 9.3 41.8 9.3 64c0 47.3-14.6 91.1-39.7 127.3L362.2 248l-13.7-23.7-.1-.3-18.5-32zm-55.2-32l-.2 0-37 0 67-116.1 3.4-5.8C374.6 53.9 429.7 99.5 458.4 160l-156.3 0-27.5 0zM256 32c6.1 0 12.1 .2 18.1 .7L196 168l-13.9 24-18.5 32s0 0 0 0l-67-116.1-3.3-5.8C134.1 58.9 191.9 32 256 32zM32 256c0-47.3 14.6-91.1 39.7-127.3L149.8 264l32.3 56L48 320l-6.7 0c-6-20.3-9.3-41.8-9.3-64zM204.1 473.9C137.4 458.1 82.3 412.5 53.6 352l156.3 0 64.7 0-67 116.1-3.4 5.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm46.1-207.9c-5.7 9.8-16.3 15.9-27.7 15.9l-36.9 0c-11.4 0-22-6.1-27.7-16l-18.5-32c-5.7-9.9-5.7-22.1 0-32l18.5-32c5.7-9.9 16.2-15.9 27.5-16l37.3 0c11.3 .1 21.7 6.1 27.4 15.8l18.7 32.4c5.6 9.8 5.6 21.9 0 31.7l-.1 .1-18.5 32-.1 .1z'
      
    ]
  };

  

  
  

  var faHelicopterSymbol = {
    prefix: 'fal',
    iconName: 'helicopter-symbol',
    icon: [
      512,
      512,
      [],
      'e502',
      
      'M477.7 224l32.3 0C495.6 108.2 403.8 16.4 288 2l0 32.3c98.1 14 175.7 91.6 189.7 189.7zM510 288l-32.3 0c-14 98.1-91.6 175.7-189.7 189.7l0 32.3c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-32.3C125.9 463.7 48.3 386.1 34.3 288L2 288zm0-64l32.3 0C48.3 125.9 125.9 48.3 224 34.3L224 2C108.2 16.4 16.4 108.2 2 224zm174-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 160 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96-160 0 0-96z'
      
    ]
  };

  

  
  

  var faTreeLarge = {
    prefix: 'fal',
    iconName: 'tree-large',
    icon: [
      448,
      512,
      [],
      'f7dd',
      
      'M224 0c4.8 0 9.3 2.2 12.4 5.9L377.7 178.6c4.1 5 6.3 11.2 6.3 17.6c0 15.3-12.4 27.8-27.8 27.8l-18.9 0 72.6 90.8c4 4.9 6.1 11.1 6.1 17.4c0 15.4-12.5 27.8-27.8 27.8l-21.3 0 76 107.6c3.4 4.7 5.2 10.4 5.2 16.2c0 15.5-12.6 28.1-28.1 28.1L288 512l-128 0L28.1 512C12.6 512 0 499.4 0 483.9c0-5.8 1.8-11.5 5.2-16.2L81.1 360l-21.3 0C44.5 360 32 347.5 32 332.2c0-6.3 2.2-12.5 6.1-17.4L110.7 224l-18.9 0C76.4 224 64 211.6 64 196.2c0-6.4 2.2-12.6 6.3-17.6L211.6 5.9c3-3.7 7.6-5.9 12.4-5.9zM160 480l128 0 124.4 0L322.9 353.2c-3.4-4.9-3.9-11.3-1.1-16.6s8.2-8.6 14.2-8.6l43.5 0-88-110c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1l43.3 0L224 41.3 100.7 192l43.3 0c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-88 110 43.5 0c6 0 11.5 3.3 14.2 8.6s2.3 11.7-1.1 16.6L35.6 480 160 480z'
      
    ]
  };

  

  
  

  var faBatteryBolt = {
    prefix: 'fal',
    iconName: 'battery-bolt',
    icon: [
      576,
      512,
      [],
      'f376',
      
      'M80 384l66.4 0c1 12.1 6.2 23.4 14.4 32L80 416c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l196 0-33.8 32L80 128c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48zm156 32l33.8-32L432 384c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-66.4 0c-1-12.1-6.2-23.4-14.4-32L432 96c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80l-196 0zM560 192c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM191.7 264l48.3 0c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L320.3 248 272 248c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L191.7 264zm20.5 130.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L215 296l-49.4 0c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L299.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5c14.7 0 24.4 15.2 18.2 28.5L297 216l49.4 0c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L212.2 394.5z'
      
    ]
  };

  

  
  

  var faSquareArrowDownLeft = {
    prefix: 'fal',
    iconName: 'square-arrow-down-left',
    icon: [
      448,
      512,
      [],
      'e261',
      
      'M64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm280-64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-97.4 0L315.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 297.4 160 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16l136 0z'
      
    ]
  };

  

  
  

  var faFaceLaughBeam = {
    prefix: 'fal',
    iconName: 'face-laugh-beam',
    icon: [
      512,
      512,
      [128513,"laugh-beam"],
      'f59a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80l-231.4 0c18.6 47.2 63.7 80 115.7 80zM126.5 288l259.1 0c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm30-99.5c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faLaughBeam = faFaceLaughBeam;
  

  
  

  var faBinBottles = {
    prefix: 'fal',
    iconName: 'bin-bottles',
    icon: [
      640,
      512,
      [],
      'e5f5',
      
      'M384 16c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM352 192l-32 0c0-35.3-28.7-64-64-64l-128 0c-35.3 0-64 28.7-64 64l-32 0c0-53 43-96 96-96l128 0c24.9 0 47.6 9.5 64.6 25c19.3 17.6 31.4 42.9 31.4 71zm223.1 0l-32.5 0c-.9-3.3-2.2-6.4-4-9.2c-6.9-10.7-6.8-24.5 .4-35.1c3-4.4 4.7-9.7 4.7-15.5c0-10.8-6.2-20.6-16-25.2l-13.1-6.2c-6.7-3.2-14.1-4.8-21.5-4.8l-90.6 0c-7.4 0-14.8 1.6-21.5 4.8L367.6 107c-3.8 1.8-7.1 4.4-9.7 7.6c-6.5-8.5-14.1-16.2-22.5-22.9c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c11-5.1 23-7.8 35.1-7.8l90.6 0C505 64 517 66.7 528 71.8L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5zm2.6 32l18.6 0 9.8 0 17.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-17.9 0L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7l-369.7 0c-40.6 0-74.7-30.4-79.5-70.7L33.9 256 16 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l17.9 0 9.8 0 18.6 0 515.3 0zM66.1 256L87.5 437.6c2.8 24.2 23.3 42.4 47.7 42.4l369.7 0c24.3 0 44.8-18.2 47.7-42.4L573.9 256 66.1 256zM160 0l64 0c17.7 0 32 14.3 32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16-64 0 0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faMarker = {
    prefix: 'fal',
    iconName: 'marker',
    icon: [
      512,
      512,
      [],
      'f5a1',
      
      'M330.3 97L353 74.3l20.7-20.7c23.4-23.4 61.3-23.4 84.7 0s23.4 61.3 0 84.7L293.7 303 209 218.3 330.3 97zm-144 144L271 325.7l-64.2 64.2c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L186.3 241zM307.7 74.3L285.1 97 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L481 161c35.9-35.9 35.9-94.1 0-129.9S386.9-4.8 351 31L330.3 51.7 317.3 38.6c-25-25-65.5-25-90.5 0l-94 94s0 0 0 0c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l94.1-94.1c9.1-9.1 22.3-11.6 33.6-7.4c4.2 1.5 8.2 4 11.6 7.4l13.1 13.1z'
      
    ]
  };

  

  
  

  var faKazoo = {
    prefix: 'fal',
    iconName: 'kazoo',
    icon: [
      640,
      512,
      [],
      'f8c7',
      
      'M416 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM523.3 352c22.8-25.5 36.7-59.1 36.7-96c0-37.3-14.2-71.2-37.4-96.8c.2 .3 .5 .5 .7 .8l52.7 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-52.7 0s0 0 0 0zM482 384l94 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-94 0c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16l-121.5 0c-2.9 0-5.8 .4-8.6 1.2C196 135.9 77 169.6 23 185.3C9.4 189.3 0 201.8 0 216l0 80c0 14.2 9.4 26.7 23 30.7c53.9 15.7 173 49.4 196.8 56.1c2.8 .8 5.7 1.2 8.6 1.2L350 384c19.8 10.2 42.2 16 66 16s46.3-5.8 66-16zM308.7 352l-80.2 0c-24-6.8-142.7-40.3-196.4-56l0-80c53.7-15.7 172.4-49.2 196.4-56l80.2 0c-22.8 25.5-36.7 59.1-36.7 96s13.9 70.5 36.7 96zm56-147.3c-6.2 6.2-6.2 16.4 0 22.6L393.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 278.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L438.6 256l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L416 233.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faIdBadge = {
    prefix: 'fal',
    iconName: 'id-badge',
    icon: [
      384,
      512,
      [],
      'f2c1',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm0-144c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faNeuter = {
    prefix: 'fal',
    iconName: 'neuter',
    icon: [
      384,
      512,
      [9906],
      'f22c',
      
      'M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3L176 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144.7z'
      
    ]
  };

  

  
  

  var faPersonShelter = {
    prefix: 'fal',
    iconName: 'person-shelter',
    icon: [
      512,
      512,
      [],
      'e54f',
      
      'M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-326.9L256 34.7 480 169.1 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-336c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5l24.5 0c4 0 8 .5 11.8 1.5L280 368l-48 0 0-102.5zM232 400l48 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-204.5 42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232l-24.5 0c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2L200 291.5 200 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  

  
  

  var faIcicles = {
    prefix: 'fal',
    iconName: 'icicles',
    icon: [
      512,
      512,
      [],
      'f7ad',
      
      'M0 36.6C0 16.4 16.4 0 36.6 0L474.1 0C495 0 512 17 512 37.9c0 2.4-.2 4.8-.7 7.2L423.7 499c-1.5 7.5-8.1 13-15.8 13s-14.3-5.5-15.7-13.1l-58.5-312-30.2 121c-1.8 7-8.1 12-15.3 12.1s-13.7-4.7-15.6-11.7l-22-79.4L215.7 403.1c-1.5 7.5-8.1 12.9-15.7 12.9s-14.2-5.4-15.7-12.9L148.1 222.2l-28.9 86.8C117 315.6 110.9 320 104 320s-13-4.4-15.2-10.9L1.9 48.2C.6 44.5 0 40.6 0 36.6zM36.6 32c-2.6 0-4.6 2.1-4.6 4.6c0 .5 .1 1 .2 1.5L104 253.4l32.8-98.5c2.3-6.9 8.9-11.4 16.2-10.9s13.3 5.7 14.7 12.8L200 318.4l32.3-161.6c1.5-7.3 7.7-12.6 15.1-12.9s14 4.6 16 11.7l23.8 85.6 33.3-133.2c1.8-7.3 8.5-12.3 16-12.1s13.9 5.7 15.2 13l56.5 301.3L479.9 39c.1-.4 .1-.7 .1-1.1c0-3.3-2.6-5.9-5.9-5.9L36.6 32z'
      
    ]
  };

  

  
  

  var faCarWrench = {
    prefix: 'fal',
    iconName: 'car-wrench',
    icon: [
      512,
      512,
      ["car-mechanic"],
      'f5e3',
      
      'M88 40c22 0 41 12.6 50.2 31.1l4.4 8.9 9.9 0 207 0 9.9 0 4.4-8.9C383 52.6 402 40 424 40c25.4 0 46.8 16.9 53.7 40L432 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l45.7 0c-6.9 23.1-28.3 40-53.7 40c-22 0-41-12.6-50.2-31.1l-4.4-8.9-9.9 0-207 0-9.9 0-4.4 8.9C129 139.4 110 152 88 152c-25.4 0-46.8-16.9-53.7-40L80 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L34.3 80C41.2 56.9 62.6 40 88 40zM0 96c0 48.6 39.4 88 88 88c30.9 0 58.1-15.9 73.8-40l188.5 0c15.7 24.1 42.9 40 73.8 40c48.6 0 88-39.4 88-88s-39.4-88-88-88c-30.9 0-58.1 15.9-73.8 40L161.8 48C146.1 23.9 118.9 8 88 8C39.4 8 0 47.4 0 96zM188.2 208l135.6 0c14.3 0 26.8 9.5 30.8 23.2L370.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4l-135.6 0c-28.6 0-53.7 18.9-61.5 46.4zM416 416l0 16L96 432l0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48zM144 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCarMechanic = faCarWrench;
  

  
  

  var faChopsticks = {
    prefix: 'fal',
    iconName: 'chopsticks',
    icon: [
      640,
      512,
      [],
      'e3f7',
      
      'M43.6 464.5L333.7 42.7C339 36.1 346.9 32 355.7 32C371.1 32 384 44.7 384 61c0 6.7-2.2 12.8-5.9 17.7L43.6 464.5zM355.7 0c-19.4 0-36.5 9.2-47.5 23.4l-.3 .4-.3 .4L6.2 462.4c-10 13.4-7.7 32.4 5.5 42.9c13.3 10.6 32.5 8.3 43-4.8L402.6 99.3l.3-.3 .3-.4C411.2 88.2 416 75.1 416 61c0-33.5-26.8-61-60.3-61zM174.6 467.9L560.4 102.7c5-4.2 11.5-6.7 18.6-6.7c16.2 0 29 12.9 29 28.6c0 8.5-3.7 16.1-9.8 21.4L174.6 467.9zM579 64c-15.1 0-29 5.5-39.6 14.5l-.3 .3-.3 .3L138.5 458c-12.7 11.1-14.1 30.4-3 43.3c11 12.8 30.3 14.3 43.2 3.7L618 171.2l.3-.3 .3-.3c13-11.1 21.4-27.6 21.4-46C640 91 612.5 64 579 64z'
      
    ]
  };

  

  
  

  var faCalendarCircleMinus = {
    prefix: 'fal',
    iconName: 'calendar-circle-minus',
    icon: [
      576,
      512,
      [],
      'e46f',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l266.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256 320 0 64 0 16 0 16 0 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faPlateWheat = {
    prefix: 'fal',
    iconName: 'plate-wheat',
    icon: [
      512,
      512,
      [],
      'e55a',
      
      'M224 112l0 5.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3zM160 48l0 24c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-24c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 64zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 144zm16 96c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM336 117.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3l0 5.3zM288 32c-8.8 0-16 7.2-16 16l0 24c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-24c0-44.2-35.8-80-80-80zm160 80l0 5.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3zM384 48l0 24c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-24c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM304 253.3l0-5.3c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3zM352 168c-44.2 0-80 35.8-80 80l0 24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-24c0-8.8-7.2-16-16-16zM192 248c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3l0-5.3zm64-64c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80l0 24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-24zm160 69.3l0-5.3c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3zM464 168c-44.2 0-80 35.8-80 80l0 24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-24c0-8.8-7.2-16-16-16zM129.8 441.1c-5.5-9.5-15.5-15.6-26.5-16C64 423.6 32.5 391.5 32 352l448 0c-.5 39.5-32 71.6-71.3 73.1c-11 .4-21 6.5-26.5 16c-2.4 4.2-6.9 6.9-11.9 6.9l-228.6 0c-5 0-9.5-2.7-11.9-6.9zM31 320c-17.1 0-31 13.9-31 31c0 57.3 45.3 103.9 102.1 106.1c7.9 13.7 22.7 22.9 39.6 22.9l228.6 0c17 0 31.8-9.2 39.6-22.9C466.7 454.9 512 408.2 512 351c0-17.1-13.9-31-31-31L31 320z'
      
    ]
  };

  

  
  

  var faCompassDrafting = {
    prefix: 'fal',
    iconName: 'compass-drafting',
    icon: [
      512,
      512,
      ["drafting-compass"],
      'f568',
      
      'M320 96A64 64 0 1 0 192 96a64 64 0 1 0 128 0zm-21.7 86.2c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8L142.2 307.4C176.1 325.6 214.8 336 256 336c88.8 0 166.4-48.2 207.9-120c4.4-7.6 14.2-10.3 21.9-5.8s10.3 14.2 5.8 21.9c-47 81.3-134.9 136-235.6 136c-47 0-91.1-11.9-129.7-32.8L29.9 503.9c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l97-169.8c-32.1-22.7-59-52.1-78.7-86.2c-4.4-7.6-1.8-17.4 5.8-21.9s17.4-1.8 21.9 5.8c16.9 29.2 39.8 54.6 67 74.3l72.5-126.9C170.5 146.1 160 122.3 160 96c0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l48.4 84.7c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-46.7-81.7zM409 375.9c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6l73.1 128c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L409 375.9z'
      
    ]
  };

  
    var faDraftingCompass = faCompassDrafting;
  

  
  

  var faArrowUpToBracket = {
    prefix: 'fal',
    iconName: 'arrow-up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66a',
      
      'M363.3 292.7l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 214.6 208 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-281.4L340.7 315.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM32 176l0-96c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-44.2-35.8-80-80-80L80 0C35.8 0 0 35.8 0 80l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faPhoneRotary = {
    prefix: 'fal',
    iconName: 'phone-rotary',
    icon: [
      512,
      512,
      [9742],
      'f8d3',
      
      'M32 142.4L32 192l72.9 0L86.6 224 32 224c-17.7 0-32-14.3-32-32l0-50.7c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1l0 50.7c0 17.7-14.3 32-32 32l-54.6 0-18.3-32 72.9 0 0-49.6C453 120.1 373.2 64 256 64S59 120.1 32 142.4zm0-1.1s0 0 0 0s0 0 0 0zM32 401c0-11.1 2.9-22.1 8.4-31.8l101.1-177c10.5-18.4 29.5-30.4 50.4-32l0-32.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32.2c21 1.7 39.9 13.6 50.4 32l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8l0 31c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-31zM304 192l-96 0-10.9 0c-11.5 0-22.1 6.2-27.8 16.1L68.2 385.1C65.5 390 64 395.4 64 401l0 31c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-31c0-5.6-1.5-11-4.2-15.9l-101.1-177c-5.7-10-16.3-16.1-27.8-16.1L304 192zM208 320a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  

  
  

  var faHeadSideHeadphones = {
    prefix: 'fal',
    iconName: 'head-side-headphones',
    icon: [
      512,
      512,
      [],
      'f8c2',
      
      'M176 38l0 62.6c10.1-3 20.9-4.6 32-4.6s21.9 1.6 32 4.6L240 32l-16 0c-16.6 0-32.7 2.1-48 6zM144 49.4C77.9 79.7 32 146.5 32 224c0 45.4 15.7 87.1 42.1 120C86.5 359.5 96 379.3 96 401.4L96 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-94.6c0-12.8-5.5-25.7-14.9-37.4C18.4 325.6 0 276.9 0 224C0 100.3 100.3 0 224 0l16 0c78.6 0 150.8 47.3 182.7 115.3c3.8 8.1 7.3 16 10.8 23.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.9 13.2 11.6 26 18.2 38.7c10.3 19.6 21.7 36.8 36.9 50.3l3.2 2.8c12.8 11.4 20.2 27.8 20.2 45c0 33.2-26.9 60.2-60.2 60.2l-3.8 0 0 48c0 35.3-28.7 64-64 64l-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l80 0c17.7 0 32-14.3 32-32l0-64c0-8.8 7.2-16 16-16l19.8 0c15.6 0 28.2-12.6 28.2-28.2c0-8-3.4-15.7-9.5-21.1l-3.2-2.8c-19.2-17.1-32.8-38.1-44-59.4c-7-13.5-13.5-28-19.8-42c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.4-7.5-6.6-14.9-9.9-21.7C371.5 81.4 325.2 45.6 272 35.1l0 81c29 20.2 48 53.9 48 91.9c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-38.1 19-71.7 48-91.9l0-66.7zM288 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fal',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128zm32 0l0 128 128 0 0-128-128 0z'
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faBat = {
    prefix: 'fal',
    iconName: 'bat',
    icon: [
      576,
      512,
      [],
      'f6b5',
      
      'M366.3 187.7c8.9 4.5 19.3 4.6 28.3 .4l71.8-34.2c3.1-1.5 6.8-.7 9 1.9C519.7 207.5 544 273.2 544 341.2l0 7L507.6 330c-22.4-11.2-49.7-3.3-62.6 18.2l-19.3 32.2-22.1-22.1c-20.5-20.5-54.3-18.3-72 4.7L288 419.5l-43.5-56.6c-17.7-23-51.5-25.2-72-4.7l-22.1 22.1-19.3-32.2c-12.9-21.5-40.2-29.5-62.6-18.2L32 348.2l0-7c0-68 24.3-133.7 68.6-185.4c2.2-2.6 5.9-3.4 9-1.9l71.8 34.2c9 4.3 19.4 4.1 28.3-.4s15.1-12.9 16.9-22.6L240.3 92l15.3 10.2c9.6 6.4 20.9 9.8 32.4 9.8s22.8-3.4 32.4-9.8L335.7 92l13.7 73.1c1.8 9.8 8.1 18.1 16.9 22.6zM358.2 77s0 0 0 0l-9.9-14.9L358.2 77s0 0 0 0zm16.6 49.7L362.2 59.5c-1.3-6.7-7.1-11.5-13.9-11.5c-2.8 0-5.5 .8-7.8 2.4L302.7 75.6c-4.3 2.9-9.4 4.4-14.7 4.4s-10.3-1.5-14.7-4.4L235.6 50.4c-2.3-1.5-5-2.4-7.8-2.4c-6.8 0-12.6 4.8-13.9 11.5l-12.6 67.2-6.1 32.5L165.3 145 123.4 125c-16.2-7.7-35.5-3.6-47.1 10C27.1 192.4 0 265.6 0 341.2l0 37.6c0 9.7 10.2 16 18.9 11.7l63.8-31.9c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63.8 31.9c8.7 4.3 18.9-2 18.9-11.7l0-37.6c0-75.6-27.1-148.8-76.3-206.2c-11.6-13.6-30.9-17.7-47.1-10L410.7 145l-29.9 14.2-6.1-32.5z'
      
    ]
  };

  

  
  

  var faMoneySimpleFromBracket = {
    prefix: 'fal',
    iconName: 'money-simple-from-bracket',
    icon: [
      640,
      512,
      [],
      'e313',
      
      'M80 32C53.5 32 32 53.5 32 80l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 80C0 35.8 35.8 0 80 0L560 0c44.2 0 80 35.8 80 80l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-26.5-21.5-48-48-48L80 32zM496 96c8.8 0 16 7.2 16 16l0 344c0 30.9-25.1 56-56 56l-272 0c-30.9 0-56-25.1-56-56l0-344c0-8.8 7.2-16 16-16s16 7.2 16 16l0 344c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-344c0-8.8 7.2-16 16-16zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z'
      
    ]
  };

  

  
  

  var faHandHoldingCircleDollar = {
    prefix: 'fal',
    iconName: 'hand-holding-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e621',
      
      'M272 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM272 0a144 144 0 1 1 0 288A144 144 0 1 1 272 0zM248.8 111.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.1-11.6-10.5-20s11.6-13.1 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z'
      
    ]
  };

  

  
  

  var faSquareDashedCirclePlus = {
    prefix: 'fal',
    iconName: 'square-dashed-circle-plus',
    icon: [
      576,
      512,
      [],
      'e5c2',
      
      'M112 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L88 64c-30.9 0-56 25.1-56 56l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24C0 71.4 39.4 32 88 32l24 0zM0 304l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm16 48c8.8 0 16 7.2 16 16l0 24c0 30.9 25.1 56 56 56l24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-48.6 0-88-39.4-88-88l0-24c0-8.8 7.2-16 16-16zM433.3 192.6c-9.1 .8-17.3-6.1-17.3-15.3l0-57.3c0-30.9-25.1-56-56-56l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0c48.6 0 88 39.4 88 88l0 57.4c0 8.1-6.7 14.6-14.7 15.2zM160 464c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM272 64l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fal',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faChair = {
    prefix: 'fal',
    iconName: 'chair',
    icon: [
      448,
      512,
      [129681],
      'f6c0',
      
      'M192 32l0 192-32 0 0-186.5C122.7 50.6 96 86.2 96 128l0 96-32 0 0-96C64 57.3 121.3 0 192 0l64 0c70.7 0 128 57.3 128 128l0 96-32 0 0-96c0-41.8-26.7-77.4-64-90.5L288 224l-32 0 0-192-64 0zM64 288L32 352l384 0-32-64L64 288zM35.4 273.7C40.8 262.8 51.9 256 64 256l320 0c12.1 0 23.2 6.8 28.6 17.7l32 64c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112L64 384l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l32-64z'
      
    ]
  };

  

  
  

  var faEuroSign = {
    prefix: 'fal',
    iconName: 'euro-sign',
    icon: [
      320,
      512,
      [8364,"eur","euro"],
      'f153',
      
      'M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32L16 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l25.3 0C68.8 412.5 154.5 480 256 480l49 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-49 0c-83.6 0-154.7-53.4-181.1-128L272 320c8.8 0 16-7.2 16-16s-7.2-16-16-16L66.7 288c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32L272 224c8.8 0 16-7.2 16-16s-7.2-16-16-16L74.9 192C101.3 117.4 172.4 64 256 64l49 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-49 0C154.5 32 68.8 99.5 41.3 192L16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l18.3 0z'
      
    ]
  };

  
    var faEur = faEuroSign;
  
    var faEuro = faEuroSign;
  

  
  

  var faEthernet = {
    prefix: 'fal',
    iconName: 'ethernet',
    icon: [
      512,
      512,
      [],
      'f796',
      
      'M128 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-80 0-96 0-96 0-96 0-80 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32l32 0 0-32zm224 0L160 96l0 48c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-48 0 0 192 64 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 64 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 64 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 64 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 64 0 0-192-48 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-48z'
      
    ]
  };

  

  
  

  var fa360Degrees = {
    prefix: 'fal',
    iconName: '360-degrees',
    icon: [
      640,
      512,
      [],
      'e2dc',
      
      'M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l111.3 0L35.4 214.2c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9l32 0c44.2 0 80 35.8 80 80l0 16c0 44.2-35.8 80-80 80l-5.5 0c-12.7 0-24.9-5.1-33.9-14.1L27.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l13.3 13.3c15 15 35.4 23.4 56.6 23.4l5.5 0c61.9 0 112-50.1 112-112l0-16c0-61.6-49.8-111.6-111.3-112L172.6 89.8c3.8-4.8 4.4-11.4 1.7-16.9s-8.3-9-14.4-9L16 64zm432 80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 224c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-224zM576 368l0-224c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80s80-35.8 80-80zM256 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112l0 112 0 .2 0 79.8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96c0-44.2-35.8-80-80-80c-18 0-34.6 6-48 16l0-32zm48 48c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faTablets = {
    prefix: 'fal',
    iconName: 'tablets',
    icon: [
      640,
      512,
      [],
      'f490',
      
      'M603.9 261.3c-3.4 4.1-6.9 8.1-10.8 11.9s-7.8 7.4-11.9 10.8c-62.8 51.5-155.7 47.9-214.4-10.8s-62.3-151.6-10.8-214.4c3.4-4.1 6.9-8.1 10.8-11.9s7.8-7.4 11.9-10.8c62.8-51.5 155.7-47.9 214.4 10.8s62.3 151.6 10.8 214.4zM570.5 69.5c-46.2-46.2-118.8-49.7-169-10.6L581.1 238.5c39.1-50.2 35.5-122.8-10.6-169zm-12 191.6L378.9 81.5c-39.1 50.2-35.5 122.8 10.6 169s118.8 49.7 169 10.6zM319.2 336c.5 5.3 .8 10.6 .8 16s-.3 10.7-.8 16c-8 80.9-76.2 144-159.2 144S8.8 448.9 .8 368c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16C8.8 255.1 77 192 160 192s151.2 63.1 159.2 144zM160 224C94.7 224 40.9 272.9 33 336l254 0c-7.9-63.1-61.7-112-127-112zm0 256c65.3 0 119.1-48.9 127-112L33 368c7.9 63.1 61.7 112 127 112z'
      
    ]
  };

  

  
  

  var faLocationArrowUp = {
    prefix: 'fal',
    iconName: 'location-arrow-up',
    icon: [
      448,
      512,
      [],
      'e63a',
      
      'M224 70.3L68 441.7 214.8 338.9c5.5-3.9 12.8-3.9 18.4 0L380 441.7 224 70.3zM198.2 49.2C202.5 38.8 212.7 32 224 32s21.5 6.8 25.8 17.2L413.7 439.3c1.5 3.6 2.3 7.5 2.3 11.4l0 1.2c0 15.6-12.6 28.2-28.2 28.2c-5.8 0-11.4-1.8-16.2-5.1L224 371.5 76.3 474.9c-4.7 3.3-10.4 5.1-16.2 5.1C44.6 480 32 467.4 32 451.8l0-1.2c0-3.9 .8-7.8 2.3-11.4L198.2 49.2z'
      
    ]
  };

  

  
  

  var faArrowUpRightAndArrowDownLeftFromCenter = {
    prefix: 'fal',
    iconName: 'arrow-up-right-and-arrow-down-left-from-center',
    icon: [
      512,
      512,
      [],
      'e0a0',
      
      'M292.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6 480 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16L352 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l105.4 0L292.7 196.7zM219.3 315.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 457.4 32 352c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 496c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 480 219.3 315.3z'
      
    ]
  };

  

  
  

  var faCirclePlay = {
    prefix: 'fal',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7l0-147.5L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCannabis = {
    prefix: 'fal',
    iconName: 'cannabis',
    icon: [
      512,
      512,
      [],
      'f55f',
      
      'M269.3 7.1c-3-4.4-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1c-14.2 21.2-33.8 60-48 104.1c-10.3 31.7-18.1 67.2-18.7 101.4C124.5 176.5 61.4 156.8 27.1 150c-5.2-1-10.7 .6-14.4 4.4s-5.4 9.2-4.4 14.5c7.1 35.4 28.1 101.4 66.7 153.5c-21.4 8.8-40.3 19.5-52.8 26.6c0 0 0 0 0 0c-2.2 1.2-4.2 2.4-6 3.4c-5.1 2.8-8.2 8.2-8.2 14s3.2 11.2 8.2 14c14.1 7.8 41.4 22.7 72.2 33.1c20.7 7 44.6 12.7 67.8 11.8l-12.7 33c-2.3 6.1-.8 13 4 17.4s11.7 5.6 17.6 2.9l75-34.2 0 51.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-51.7 75 34.2c5.9 2.7 12.9 1.6 17.6-2.9s6.3-11.3 4-17.4l-12.7-33c23.2 .9 47.1-4.8 67.8-11.8c30.7-10.5 58.1-25.3 72.2-33.1c5.1-2.8 8.2-8.2 8.2-14s-3.2-11.2-8.2-14c-13-7.2-35.1-18.7-60.8-27.3c40-52.5 61.5-120.2 68.7-156.1c1.1-5.2-.6-10.7-4.4-14.5s-9.2-5.4-14.4-4.4c-34.3 6.8-97.4 26.5-148.9 62.6c-.6-34.2-8.4-69.8-18.7-101.4c-14.2-44-33.8-82.9-48-104.1zM272 409.1l0-73.1c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 73.1-52.5 24 8.8-22.8c2.3-5.8 .9-12.4-3.5-16.9s-10.9-6-16.8-3.9c-20.8 7.4-48.7 3.3-77.2-6.4c-14.9-5-29-11.3-41-17.2c14.3-7.5 31.1-15.5 48.7-21c5.2-1.6 9.2-5.8 10.7-11s.1-10.9-3.5-14.9C79.1 280.5 57 226.4 45.9 187.5c41 11.6 98.7 35.2 137.7 72.3c5 4.8 12.5 5.8 18.6 2.5s9.4-10.1 8.2-16.9c-6.6-37.5 1.2-82.7 14.8-124.5c9.2-28.3 20.6-54.1 30.9-73.5c10.3 19.4 21.7 45.1 30.9 73.5c13.5 41.8 21.4 87 14.8 124.5c-1.2 6.8 2.1 13.6 8.2 16.9s13.6 2.2 18.6-2.5c39-37.1 96.7-60.7 137.7-72.3C454.6 227.7 431.4 284 395 322.7c-3.9 4.2-5.3 10.2-3.6 15.7s6.2 9.7 11.8 10.9c17.9 4 35.2 10.6 49.8 17.2c-11.8 5.7-25.4 11.7-39.7 16.6c-28.5 9.7-56.4 13.8-77.2 6.4c-5.9-2.1-12.5-.6-16.8 3.9s-5.7 11.1-3.5 16.9l8.8 22.8-52.5-24z'
      
    ]
  };

  

  
  

  var faTruckRampCouch = {
    prefix: 'fal',
    iconName: 'truck-ramp-couch',
    icon: [
      640,
      512,
      ["truck-couch"],
      'f4dd',
      
      'M352 80c0-44.2 35.8-80 80-80L624 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L432 32c-26.5 0-48 21.5-48 48l0 299.1 35.8-9.8 .5-.1C433.6 322.4 476.8 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112c-60.7 0-110.1-48.2-111.9-108.4L20.2 511.4c-8.5 2.3-17.3-2.7-19.6-11.2s2.7-17.3 11.2-19.6l340.6-92.8c-.3-1.2-.4-2.5-.4-3.7l0-304zM608 400a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM225.7 128.2c36.4-9.8 73.6 4.8 94.3 33.7l0 75.5c-3.1-.4-6.3-.3-9.5 .6c-11.1 3-18.3 13.3-17.8 24.3c.8 15.1-9.1 28.6-23.7 32.5L127.6 332.8c-14.6 3.9-29.9-2.9-36.8-16.3c-5-9.9-16.5-15.2-27.6-12.2c-12.8 3.4-20.4 16.6-17 29.4l13.5 50.3c1.1 4.3 5.5 6.8 9.8 5.7l24.8-6.6c1.2-.3 2.4-.6 3.6-.8l180.3-48.3c.7-.2 1.5-.4 2.2-.5L320 322.7l0 33.1-2.6 .7-30.9 8.3c0 0 0-.1 0-.1l-30.9 8.3L133.5 405.8 102.6 414l-.1-.2-24.8 6.6c-21.3 5.7-43.3-6.9-49-28.3L15.3 341.9c-3.9-14.7-1.6-29.7 5.3-42l-6.4-24C1.7 229 29.5 180.8 76.5 168.2l149.2-40zm8.3 30.9l-149.2 40c-29.9 8-47.6 38.7-39.6 68.6l2.2 8.3c2.4-1 5-1.9 7.6-2.6c26-7 52.6 5.5 64.3 28.5L260.8 264c-1.3-25.8 15.5-49.9 41.4-56.9c.8-.2 1.6-.4 2.4-.6l-2.1-7.8c-8-29.9-38.7-47.6-68.6-39.6z'
      
    ]
  };

  
    var faTruckCouch = faTruckRampCouch;
  

  
  

  var faAnglesRight = {
    prefix: 'fal',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M443.9 266.7c5.5-6.1 5.5-15.3 0-21.4l-144-160c-5.9-6.6-16-7.1-22.6-1.2s-7.1 16-1.2 22.6L410.5 256 276.1 405.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2l144-160zm-336 160l144-160c5.5-6.1 5.5-15.3 0-21.4l-144-160c-5.9-6.6-16-7.1-22.6-1.2s-7.1 16-1.2 22.6L218.5 256 84.1 405.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faSnowplow = {
    prefix: 'fal',
    iconName: 'snowplow',
    icon: [
      640,
      512,
      [],
      'f7d2',
      
      'M128 32c0-17.7 14.3-32 32-32L298.9 0c19.2 0 36.6 11.4 44.1 29.1l85.1 198.6c2.6 6 3.9 12.4 3.9 18.9l0 41.4 96 0 0-48c0-3.7 1.3-7.4 3.7-10.2l80-96c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L560 245.8l0 148.4 76.3 91.5c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2l-80-96c-2.4-2.9-3.7-6.5-3.7-10.2l0-80-81.6 0c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2L64 168c0-22.1 17.9-40 40-40l24 0 0-96zM400 256l-192 0c-5.3 0-10.3-2.7-13.3-7.1L135.4 160 104 160c-4.4 0-8 3.6-8 8l0 121.1c5.2-.7 10.6-1.1 16-1.1l256 0c11.1 0 21.9 1.6 32 4.6l0-36.6zM160 139.2L216.6 224l175.2 0L313.6 41.7c-2.5-5.9-8.3-9.7-14.7-9.7L160 32l0 107.2zM368 320l-256 0c-44.2 0-80 35.8-80 80s35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80zM120 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faAlignSlash = {
    prefix: 'fal',
    iconName: 'align-slash',
    icon: [
      640,
      512,
      [],
      'f846',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM528 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-43.9 0 40.5 32 3.4 0zm0-128c8.8 0 16-7.2 16-16s-7.2-16-16-16l-206 0 40.5 32L528 208zm-372.1 0l-40.5-32-3.4 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l43.9 0zM528 48L159.8 48l40.5 32L528 80c8.8 0 16-7.2 16-16s-7.2-16-16-16zM318 336l-40.5-32L112 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l206 0zm121.6 96L112 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l368.2 0-40.5-32z'
      
    ]
  };

  

  
  

  var faOctagonXmark = {
    prefix: 'fal',
    iconName: 'octagon-xmark',
    icon: [
      512,
      512,
      ["times-octagon","xmark-octagon"],
      'f2f0',
      
      'M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3l0 129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7l129 0c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3l0-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7l-129 0zM180.7 180.7c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faTimesOctagon = faOctagonXmark;
  
    var faXmarkOctagon = faOctagonXmark;
  

  
  

  var faMonument = {
    prefix: 'fal',
    iconName: 'monument',
    icon: [
      384,
      512,
      [],
      'f5a6',
      
      'M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.2 5.9 4.6 9.4l32 272c1 8.8-5.2 16.7-14 17.8s-16.7-5.2-17.8-14L256.8 103.4 192 38.6l-64.8 64.8L95.9 369.9c-1 8.8-9 15.1-17.8 14s-15.1-9-14-17.8l32-272c.4-3.6 2-6.9 4.6-9.4l80-80zM144 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zM40 416l304 0c22.1 0 40 17.9 40 40l0 16c0 22.1-17.9 40-40 40L40 512c-22.1 0-40-17.9-40-40l0-16c0-22.1 17.9-40 40-40zm-8 40l0 16c0 4.4 3.6 8 8 8l304 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8L40 448c-4.4 0-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faRefrigerator = {
    prefix: 'fal',
    iconName: 'refrigerator',
    icon: [
      384,
      512,
      [],
      'e026',
      
      'M288 32c35.3 0 64 28.7 64 64l0 64-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L32 160l0-64c0-35.3 28.7-64 64-64l192 0zM256 192l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 64 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256 224 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0z'
      
    ]
  };

  

  
  

  var faMinimize = {
    prefix: 'fal',
    iconName: 'minimize',
    icon: [
      512,
      512,
      ["compress-arrows-alt"],
      'f78c',
      
      'M507.3 27.3l-108 108 47.1 47.1c6 6 8.4 14.6 6.3 22.8l-.2 .6c-2.7 10.7-12.3 18.2-23.3 18.2L312 224c-13.3 0-24-10.7-24-24l0-117.3c0-11 7.5-20.6 18.2-23.3l.6-.2c8.2-2 16.8 .4 22.8 6.3l47.1 47.1 108-108c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM4.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l108 108 47.1-47.1c6-6 14.6-8.4 22.8-6.3l.6 .2C216.5 62.1 224 71.7 224 82.7L224 200c0 13.3-10.7 24-24 24L82.7 224c-11 0-20.6-7.5-23.3-18.2l-.2-.6c-2-8.2 .4-16.8 6.3-22.8l47.1-47.1L4.7 27.3zm502.6 480c-6.2 6.2-16.4 6.2-22.6 0l-108-108-47.1 47.1c-6 6-14.6 8.4-22.8 6.3l-.6-.2c-10.7-2.7-18.2-12.3-18.2-23.3L288 312c0-13.3 10.7-24 24-24l117.3 0c11 0 20.6 7.5 23.3 18.2l.2 .6c2 8.2-.4 16.8-6.3 22.8l-47.1 47.1 108 108c6.2 6.2 6.2 16.4 0 22.6zM4.7 484.7l108-108L65.6 329.6c-6-6-8.4-14.6-6.3-22.8l.2-.6C62.1 295.5 71.7 288 82.7 288L200 288c13.3 0 24 10.7 24 24l0 117.3c0 11-7.5 20.6-18.2 23.3l-.6 .2c-8.2 2-16.8-.4-22.8-6.3l-47.1-47.1-108 108c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM410.7 192L320 101.3l0 90.7 90.7 0zM192 101.3L101.3 192l90.7 0 0-90.7zM410.7 320L320 320l0 90.7L410.7 320zM192 410.7l0-90.7-90.7 0L192 410.7z'
      
    ]
  };

  
    var faCompressArrowsAlt = faMinimize;
  

  
  

  var faSmoking = {
    prefix: 'fal',
    iconName: 'smoking',
    icon: [
      640,
      512,
      [128684],
      'f48d',
      
      'M464 0c-8.8 0-16 7.2-16 16l0 27c0 46.7 18.5 91.4 51.5 124.5l21 21c15 15 23.4 35.4 23.4 56.6l0 27c0 8.8 7.2 16 16 16s16-7.2 16-16l0-27c0-29.7-11.8-58.2-32.8-79.2l-21-21C495.2 117.8 480 81.2 480 43l0-27c0-8.8-7.2-16-16-16zM624 288c8.8 0 16-7.2 16-16l0-27c0-46.7-18.5-91.4-51.5-124.5l-21-21C552.4 84.5 544 64.2 544 43l0-27c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 27c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 27c0 8.8 7.2 16 16 16zM64 384l128 0 0 96L64 480c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm160 0l256 0 0 96-256 0 0-96zM64 512l144 0 288 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-288 0L64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64zM560 352c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faDolly = {
    prefix: 'fal',
    iconName: 'dolly',
    icon: [
      576,
      512,
      ["dolly-box"],
      'f472',
      
      'M24 0C15.2 0 8 7.2 8 16s7.2 16 16 16l64.9 0c6.9 0 13 4.4 15.2 10.9L211.6 365.4C190.1 379.8 176 404.2 176 432c0 44.2 35.8 80 80 80c43 0 78-33.9 79.9-76.4L565.5 351c8.3-3.1 12.5-12.3 9.5-20.5s-12.3-12.5-20.5-9.5L330.7 403.4C319.2 373.3 290.1 352 256 352c-5 0-9.9 .5-14.7 1.3L134.5 32.8C127.9 13.2 109.6 0 88.9 0L24 0zM256 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm96.8-201.1c3 8.3 12.2 12.6 20.5 9.6s12.6-12.2 9.6-20.5l-19.2-52.6 60.1-21.9 54.7 150.4L328.2 302.5 273.5 152.2l60.1-21.9 19.2 52.6zM243.4 163.1l54.7 150.4c6 16.6 24.4 25.2 41 19.1l150.4-54.7c16.6-6 25.2-24.4 19.1-41L453.9 86.5c-6-16.6-24.4-25.2-41-19.1L262.5 122.1c-16.6 6-25.2 24.4-19.1 41z'
      
    ]
  };

  
    var faDollyBox = faDolly;
  

  
  

  var faGem = {
    prefix: 'fal',
    iconName: 'gem',
    icon: [
      512,
      512,
      [128142],
      'f3a5',
      
      'M128 32c-5.2 0-10.1 2.5-13.1 6.8l-112 160c-4.3 6.2-3.7 14.6 1.4 20.1l240 256c3 3.2 7.2 5.1 11.7 5.1s8.6-1.8 11.7-5.1l240-256c5.2-5.5 5.8-13.9 1.4-20.1l-112-160c-3-4.3-7.9-6.8-13.1-6.8L128 32zm.9 42.7L222.7 192l-176 0L128.9 74.7zM52.9 224L256 224l203.1 0L256 440.6 52.9 224zm412.3-32l-176 0L383.1 74.7 465.3 192zM350.7 64L256 182.4 161.3 64l189.4 0z'
      
    ]
  };

  

  
  

  var faHandshake = {
    prefix: 'fal',
    iconName: 'handshake',
    icon: [
      640,
      512,
      [],
      'f2b5',
      
      'M263.9 64c-33.9 0-66.7 12-92.6 33.7L144 120.7l0 39.1c2.7-.5 5.3-1.7 7.4-3.5l40.5-34c13.3-11.2 28.9-19 45.5-23.1L272.6 64l-8.7 0zM112 352.5c8.1 1.3 15.7 5 21.6 10.8l46.1 44.6 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c19.2 4 40-.8 55.7-14.8c11.3-10.1 18.2-23.2 20.6-37l52.2 0 0 17.2c0 26.5 21.5 48 48 48l16 0c26.5 0 48-21.5 48-48l0-208c0-17.7-14.3-32-32-32l-48 0-32 0 0 32 0 158.8-54.9 0c-3.1-8.7-8.1-17-15.1-24l-85.6-85.6 8.1-7.5c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-76.1 70.2c-13.2 12.2-33.6 12.4-47 .4c-15.4-13.7-15.7-37.5-.8-51.6l79.4-75C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7l0-38.1L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-79.4 75c-28.6 27-27.9 72.7 1.5 98.8c25.8 22.9 64.7 22.5 90-.8l44.5-41 86.5 86.5c13 13 12.4 34.3-1.4 46.5c-10.9 9.7-26.7 10.6-38.6 3c-5-3.3-11.4-3.4-16.6-.5s-8.3 8.6-8 14.6c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-.3 .3-30.7-29.7c-11.9-11.5-27.4-18.5-43.8-20L112 160l0-32-32 0-48 0c-17.7 0-32 14.3-32 32L0 368c0 26.5 21.5 48 48 48l16 0c26.5 0 48-21.5 48-48l0-15.5zM80 160l0 208c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-208 48 0zm528 0l0 208c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-208 48 0z'
      
    ]
  };

  

  
  

  var faHeadSideMask = {
    prefix: 'fal',
    iconName: 'head-side-mask',
    icon: [
      576,
      512,
      [],
      'e063',
      
      'M78.7 150.2L276.5 272l11.5 0 223.7 0c-.9-6.6-4.1-12.7-9.2-17.2l-3.2-2.8c-32.6-29-50-70.3-65.4-106.9c0 0 0 0 0 0s0 0 0 0c-2.4-5.8-4.8-11.4-7.2-16.9C402.1 71.5 345.6 32 280 32l-24 0C176.1 32 107.6 80.8 78.7 150.2zm-10 31.4C65.6 195.3 64 209.4 64 224c0 45.4 15.7 87.1 42.1 120c12.5 15.5 21.9 35.3 21.9 57.4l0 94.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-94.6c0-12.8-5.5-25.7-14.9-37.4C50.4 325.6 32 276.9 32 224C32 100.3 132.3 0 256 0l24 0c78.8 0 146.5 47.5 176.1 115.3c2.7 6.1 5.2 12.1 7.7 18.1c0 0 0 0 0 0s0 0 0 0c15.7 37.1 30.1 70.9 56.8 94.6l3.2 2.8c11.9 10.6 19.1 25.4 20.1 41.2l.1 0c0 10.6-1.5 21.2-4.4 31.4l-.2 .6L493.3 465.6c-7.8 27.5-33 46.4-61.5 46.4L288 512c-17.7 0-32-14.3-32-32l0-176 0-7.1L68.7 181.7zM376 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 480l143.7 0c14.3 0 26.8-9.5 30.8-23.2l4.8-16.8L368 440c-8.8 0-16-7.2-16-16s7.2-16 16-16l108.4 0 9.1-32L368 376c-8.8 0-16-7.2-16-16s7.2-16 16-16l126.7 0 11.4-40L288 304l0 176z'
      
    ]
  };

  

  
  

  var faLemon = {
    prefix: 'fal',
    iconName: 'lemon',
    icon: [
      448,
      512,
      [127819],
      'f094',
      
      'M368 64c-5.8 0-11.2 1-16.2 2.8c-18.9 6.8-44.1 12.9-70.1 7.1c-60.7-13.5-128.7 11-178.8 61s-74.5 118.1-61 178.8c5.8 26-.3 51.2-7.1 70.1C33 388.8 32 394.2 32 400c0 26.5 21.5 48 48 48c5.8 0 11.2-1 16.2-2.8c18.9-6.8 44.1-12.9 70.1-7.1c60.7 13.5 128.7-11 178.8-61s74.5-118.1 61-178.8c-5.8-26 .3-51.2 7.1-70.1c1.8-5 2.8-10.5 2.8-16.2c0-26.5-21.5-48-48-48zm0-32c44.2 0 80 35.8 80 80c0 9.5-1.7 18.6-4.7 27.1c-6 16.7-9.8 35-5.9 52.4c16.4 73.7-13.7 152.4-69.6 208.3s-134.7 86-208.3 69.6c-17.3-3.9-35.7-.1-52.4 5.9c-8.4 3-17.6 4.7-27.1 4.7c-44.2 0-80-35.8-80-80c0-9.5 1.7-18.6 4.7-27.1c6-16.7 9.8-35 5.9-52.4C-5.8 246.9 24.3 168.2 80.2 112.2s134.7-86 208.3-69.6c17.3 3.9 35.7 .1 52.4-5.9c8.4-3 17.6-4.7 27.1-4.7zM246.7 134.5L228.3 143c-51.8 23.9-93.4 65.5-117.3 117.3l-8.5 18.4c-3.7 8-13.2 11.5-21.2 7.8s-11.5-13.2-7.8-21.2l8.5-18.4c27.1-58.7 74.3-105.9 133-133l18.4-8.5c8-3.7 17.5-.2 21.2 7.8s.2 17.5-7.8 21.2z'
      
    ]
  };

  

  
  

  var faTick = {
    prefix: 'fal',
    iconName: 'tick',
    icon: [
      192,
      512,
      [],
      'e32f',
      
      'M56.6 256.9C60.9 275.1 77.2 288 96 288s35.1-12.9 39.4-31.1L165.9 129c1.4-6 2.1-12.1 2.1-18.2l0-6.8c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 6.8c0 6.1 .7 12.3 2.1 18.2L56.6 256.9zM56 104c0-22.1 17.9-40 40-40s40 17.9 40 40l0 6.8c0 3.6-.4 7.3-1.3 10.8L104.3 249.5c-.9 3.8-4.3 6.5-8.3 6.5s-7.4-2.7-8.3-6.5L57.3 121.6c-.8-3.5-1.3-7.2-1.3-10.8l0-6.8z'
      
    ]
  };

  

  
  

  var faSquareA = {
    prefix: 'fal',
    iconName: 'square-a',
    icon: [
      448,
      512,
      [],
      'e25f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c6.1 0 11.6 3.4 14.3 8.8l112 224c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 320l-140.2 0-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l112-224c2.7-5.4 8.3-8.8 14.3-8.8zm0 51.8L169.9 288l108.2 0L224 179.8z'
      
    ]
  };

  

  
  

  var faTableColumns = {
    prefix: 'fal',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      'M448 64c17.7 0 32 14.3 32 32l0 64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 208 0 0 256L64 448c-17.7 0-32-14.3-32-32zm240 32l0-256 208 0 0 224c0 17.7-14.3 32-32 32l-176 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faRotateLeft = {
    prefix: 'fal',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      'M94.7 360.2c-3.2-5-8.7-8.2-14.7-8.2c-12.3 0-20.3 12.8-13.7 23.2C106 438.2 176.1 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7L78.6 56c-5.1-5.1-12.1-8-19.3-8C44.2 48 32 60.2 32 75.3L32 176c0 8.8 7.2 16 16 16l100.7 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-36-36C165.5 81.1 208.7 64 256 64c106 0 192 86 192 192s-86 192-192 192c-67.6 0-127.1-35-161.3-87.8zM64 86.6L137.4 160 64 160l0-73.4z'
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faSquareBinary = {
    prefix: 'fal',
    iconName: 'square-binary',
    icon: [
      448,
      512,
      [],
      'e69b',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 120l0 48c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-32 0c-22.1 0-40 17.9-40 40zm40-8l32 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zM264 280c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-32 0zm-8 40c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-48zM120 296c0 8.8 7.2 16 16 16l8 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-24 0c-8.8 0-16 7.2-16 16zM280 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l8 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-24 0z'
      
    ]
  };

  

  
  

  var faMartiniGlass = {
    prefix: 'fal',
    iconName: 'martini-glass',
    icon: [
      512,
      512,
      [127864,"glass-martini-alt"],
      'f57b',
      
      'M32 33c0-.5 .4-1 1-1L479 32c.5 0 1 .4 1 1c0 .3-.1 .5-.3 .7l-94.4 94.4c-.4 0-.9-.1-1.3-.1l-256 0c-.4 0-.9 0-1.3 .1L32.3 33.7c-.2-.2-.3-.4-.3-.7zM158.6 160l194.7 0L256 257.4 158.6 160zM9.7 56.3L240 286.6 240 480l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-193.4L502.3 56.3c6.2-6.2 9.7-14.6 9.7-23.3c0-18.2-14.8-33-33-33L33 0C14.8 0 0 14.8 0 33c0 8.7 3.5 17.1 9.7 23.3z'
      
    ]
  };

  
    var faGlassMartiniAlt = faMartiniGlass;
  

  
  

  var faBracketSquareRight = {
    prefix: 'fal',
    iconName: 'bracket-square-right',
    icon: [
      192,
      512,
      [],
      '5d',
      
      'M192 80c0-26.5-21.5-48-48-48L48 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48-21.5 48-48l0-352z'
      
    ]
  };

  

  
  

  var faArrowUpFromGroundWater = {
    prefix: 'fal',
    iconName: 'arrow-up-from-ground-water',
    icon: [
      576,
      512,
      [],
      'e4b5',
      
      'M288 352c8.8 0 16-7.2 16-16l0-281.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6 272 336c0 8.8 7.2 16 16 16zM64 192c-35.3 0-64 28.7-64 64L0 425c5.3-3.1 11.2-5.4 17.5-6.9c4.8-1.1 9.7-2.8 14.5-4.8L32 256c0-17.7 14.3-32 32-32l128 0 0-32L64 192zM576 425l0-169c0-35.3-28.7-64-64-64l-128 0 0 32 128 0c17.7 0 32 14.3 32 32l0 157.3c4.8 2.1 9.7 3.7 14.5 4.8c6.3 1.5 12.1 3.8 17.5 6.9zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faForklift = {
    prefix: 'fal',
    iconName: 'forklift',
    icon: [
      640,
      512,
      [],
      'f47a',
      
      'M160 0c-17.7 0-32 14.3-32 32l0 128-48 0c-44.2 0-80 35.8-80 80L0 384l0 32c0 53 43 96 96 96s96-43 96-96l64 0c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6l0-56.4 0-28.5c0-4.7-1-9.3-3-13.5L306.8 18.5C301.6 7.2 290.2 0 277.8 0L160 0zM128 192l19.5 0 94.8 87.5C248.2 285 256 288 264 288l120 0 0 37.5c-10-3.5-20.8-5.5-32-5.5c-41.8 0-77.4 26.7-90.5 64l-74.9 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4L32 240c0-26.5 21.5-48 48-48l48 0zm136 64L160 160l0-128 117.8 0L382.3 256 264 256zm88 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM96 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-400z'
      
    ]
  };

  

  
  

  var faSquareNfi = {
    prefix: 'fal',
    iconName: 'square-nfi',
    icon: [
      448,
      512,
      [],
      'e576',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM75.7 160.6C68.8 162.5 64 168.8 64 176l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.2 66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 102.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176l0 64 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z'
      
    ]
  };

  

  
  

  var faHouseTsunami = {
    prefix: 'fal',
    iconName: 'house-tsunami',
    icon: [
      576,
      512,
      [],
      'e515',
      
      'M32 200c0-92 78.8-168 177.9-168c20.6 0 40.4 3.3 58.7 9.4c8.4 2.8 17.4-1.8 20.2-10.2s-1.8-17.4-10.2-20.2C257.1 3.9 233.9 0 209.9 0C94.8 0 0 88.8 0 200C0 309.1 74 400 191.2 400c.1 0 .2 0 .3 0c.3 0 .6 0 .9 0c.2 0 .4 0 .6 0c29.9-.3 56.7-14.2 75.1-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368c0 0 0 0 0 0c-66.4-.3-120-53.9-120-120c0-66.2 53.9-120 120.5-120c18.3 0 35.6 4 51 11.3c8 3.7 17.5 .3 21.3-7.7s.3-17.5-7.7-21.3C237.4 101.1 215.5 96 192.5 96C108.3 96 40 164 40 248c0 3 .1 6.1 .3 9.1C34.8 239.3 32 220.1 32 200zm320-56l96-72L543.5 144l.3 141.2c4.9 2.1 9.9 3.8 14.8 4.9c6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6l0 121c1.7 1 3.3 2 4.8 3.1c8.6 5.9 17.8 10.7 27.2 14.2L352 144zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faFolderClosed = {
    prefix: 'fal',
    iconName: 'folder-closed',
    icon: [
      512,
      512,
      [],
      'e185',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 32L32 192l0-96zm0 128l448 0 0 192c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-192zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32z'
      
    ]
  };

  

  
  

  var faCircleSortDown = {
    prefix: 'fal',
    iconName: 'circle-sort-down',
    icon: [
      512,
      512,
      ["sort-circle-down"],
      'e031',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96zM198.6 320l114.7 0L256 377.4 198.6 320zM148.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 134.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z'
      
    ]
  };

  
    var faSortCircleDown = faCircleSortDown;
  

  
  

  var faScrewdriver = {
    prefix: 'fal',
    iconName: 'screwdriver',
    icon: [
      512,
      512,
      [129691],
      'f54a',
      
      'M447.3 34.6l30.1 30.1L404.1 160 352 160l0-52.1 95.3-73.3zM342.7 192c.4 0 .9 0 1.3 0l64 0c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19l0 64c0 .4 0 .9 0 1.3l-78.9 78.9c4.2 3.2 8.3 6.6 12.1 10.5s7.3 7.9 10.5 12.1L342.7 192zM208 304c17.7 17.7 17.7 46.3 0 64L96 480 32 416 144 304c17.7-17.7 46.3-17.7 64 0zm-86.6-22.6l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z'
      
    ]
  };

  

  
  

  var faShieldXmark = {
    prefix: 'fal',
    iconName: 'shield-xmark',
    icon: [
      512,
      512,
      ["shield-times"],
      'e24c',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faShieldTimes = faShieldXmark;
  

  
  

  var faCaretUp = {
    prefix: 'fal',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M154.4 162.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 275.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1L39.1 288c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2L154.4 162.2zm-22-23.3L12.3 252.4C4.4 259.8 0 270.1 0 280.9C0 302.5 17.5 320 39.1 320l241.7 0c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 138.9c-7.4-7-17.3-10.9-27.6-10.9s-20.1 3.9-27.6 10.9z'
      
    ]
  };

  

  
  

  var faDownFromLine = {
    prefix: 'fal',
    iconName: 'down-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-top"],
      'f349',
      
      'M190.2 447.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L318.2 315.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L256 304c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L190.2 447.2zM192 480c-9.5 0-18.6-3.9-25.1-10.8L42.5 337.2C35.8 330 32 320.5 32 310.7C32 289.3 49.3 272 70.7 272l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.4-10.5 26.5L217.1 469.2c-6.5 6.9-15.6 10.8-25.1 10.8zM16 32l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 64C7.2 64 0 56.8 0 48s7.2-16 16-16z'
      
    ]
  };

  
    var faArrowAltFromTop = faDownFromLine;
  

  
  

  var faSquareRing = {
    prefix: 'fal',
    iconName: 'square-ring',
    icon: [
      448,
      512,
      [],
      'e44f',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM160 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var fa3 = {
    prefix: 'fal',
    iconName: '3',
    icon: [
      320,
      512,
      [],
      '33',
      
      'M0 48c0-8.8 7.2-16 16-16l272 0c6.6 0 12.5 4 14.9 10.2s.8 13.1-4 17.6L120.9 224l71.1 0c70.7 0 128 57.3 128 128s-57.3 128-128 128L89.4 480c-36.4 0-69.6-20.5-85.9-53.1l-1.9-3.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l1.9 3.8C43 434.3 65.2 448 89.4 448L192 448c53 0 96-43 96-96s-43-96-96-96L80 256c-6.6 0-12.5-4-14.9-10.2s-.8-13.1 4-17.6L247.1 64 16 64C7.2 64 0 56.8 0 48z'
      
    ]
  };

  

  
  

  var faFileZip = {
    prefix: 'fal',
    iconName: 'file-zip',
    icon: [
      512,
      512,
      [],
      'e5ee',
      
      'M64 480l112 0 0 32L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z'
      
    ]
  };

  

  
  

  var faCow = {
    prefix: 'fal',
    iconName: 'cow',
    icon: [
      640,
      512,
      [128004],
      'f6c8',
      
      'M128 144l0 264c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-55.8 0-.5 0-15.8c0-53 43-96 96-96s96 43 96 96l0 15.8 0 .5 0 55.8c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-168c0-5.5 2.9-10.7 7.6-13.6s10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3l0 62.7c0 3 .9 6 2.5 8.6l37.3 58.6c5.6 8.8 15.3 14.1 25.7 14.1c16.8 0 30.5-13.6 30.5-30.5l0-87.5c0-3.3-1-6.4-2.8-9.1L594.8 274c-1.9-2.7-2.8-5.9-2.8-9.1l0-64.9c0-4.4-3.6-8-8-8c-4 0-7.3 2.9-7.9 6.7c-1.1 6.4-5.9 11.6-12.3 13s-12.9-1.1-16.7-6.5l-51.7-74.7C480.5 108.9 456 96 429.7 96l-30 0c-1.9 26.9-13.4 52.3-32.5 71.4l-3.1 3.1c-24 24-56.6 37.5-90.5 37.5l-3.2 0c-33.9 0-66.5-13.5-90.5-37.5l-3.1-3.1c-16.6-16.6-27.4-37.8-31.2-60.5C134.8 115.7 128 129 128 144zm71.4 .8l3.1 3.1c18 18 42.4 28.1 67.9 28.1l3.2 0c25.5 0 49.9-10.1 67.9-28.1l3.1-3.1c13.2-13.2 21.3-30.4 23.1-48.8L176.4 96c1.8 18.4 9.9 35.6 23.1 48.8zm8.6 231l0 32.2c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-264c0-18 6-34.6 16-48c-26.5 0-48 21.5-48 48l0 80 0 16 0 28.8C64 297.1 41.1 320 12.8 320C5.7 320 0 314.3 0 307.2L0 288c0-23.7 12.9-44.4 32-55.4L32 144c0-44.2 35.8-80 80-80l64 0 253.7 0c36.8 0 71.2 18 92.1 48.2l38.5 55.6c6.6-4.9 14.9-7.8 23.7-7.8c22.1 0 40 17.9 40 40l0 59.9 7.5 10.8c5.6 8 8.5 17.6 8.5 27.3l0 87.5c0 34.5-28 62.5-62.5 62.5c-21.4 0-41.2-10.9-52.7-28.9l-37.3-58.6c-4.9-7.7-7.5-16.6-7.5-25.8l0-52.8-32-16L448 408c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-32.2c-6.6 2-14.6 3.8-24 5.3l0 10.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8.1c-2.6 .1-5.3 .1-8 .1s-5.4 0-8-.1l0 8.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.9c-9.4-1.5-17.4-3.3-24-5.3zm0-33.8c2.1 .8 4.7 1.8 7.7 2.7c11.4 3.5 29.8 7.3 56.3 7.3s44.9-3.8 56.3-7.3c3-.9 5.6-1.9 7.7-2.7l0-6c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 6zm344-22a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMicrophone = {
    prefix: 'fal',
    iconName: 'microphone',
    icon: [
      384,
      512,
      [],
      'f130',
      
      'M256 96l0 160c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-160c0-35.3 28.7-64 64-64s64 28.7 64 64zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 83 63.1 151.2 144 159.2l0 64.8-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64.8c80.9-8 144-76.2 144-159.2l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-48z'
      
    ]
  };

  

  
  

  var faWindowFrame = {
    prefix: 'fal',
    iconName: 'window-frame',
    icon: [
      512,
      512,
      [129695],
      'e04f',
      
      'M240 288l0 192L64 480l0-192 176 0zm32 192l0-192 176 0 0 192-176 0zm208 0l0-416c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 416-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 384 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0zM448 256l-176 0 0-224 144 0c17.7 0 32 14.3 32 32l0 192zM96 32l144 0 0 224L64 256 64 64c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'fal',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      'M64 64C46.3 64 32 78.3 32 96l0 233.4 67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4 480 96c0-17.7-14.3-32-32-32L64 64zM32 374.6L32 416c0 17.7 14.3 32 32 32l41.4 0 96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448 448 448c17.7 0 32-14.3 32-32l0-105.4-90.3-90.3zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faFloppyDiskPen = {
    prefix: 'fal',
    iconName: 'floppy-disk-pen',
    icon: [
      576,
      512,
      [],
      'e182',
      
      'M32 96l0 320c0 17.7 14.3 32 32 32l202.3 0-8 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3l0 49.7-32 32 0-81.7c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6l0 94.2c0 17.7-14.3 32-32 32L96 192c-17.7 0-32-14.3-32-32l0-96C46.3 64 32 78.3 32 96zM96 64l0 96 192 0 0-96L96 64zm80 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM518.8 264.1c-6.2-6.2-16.4-6.2-22.6 0L471.3 289l40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zM342.5 417.8c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49L375 462c2.8-.7 5.4-2.2 7.4-4.2L488.7 351.6l-40-40L342.5 417.8zM473.5 241.5c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.5c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L473.5 241.5z'
      
    ]
  };

  

  
  

  var faBucket = {
    prefix: 'fal',
    iconName: 'bucket',
    icon: [
      448,
      512,
      [],
      'e4cf',
      
      'M96 144c0 8.8-7.2 16-16 16s-16-7.2-16-16C64 64.5 128.5 0 208 0l32 0c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112l-32 0C146.1 32 96 82.1 96 144zM0 208c0-8.8 7.2-16 16-16l8 0 32.2 0 335.5 0 32.2 0 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-12 0L389.3 470c-3 24-23.4 42-47.6 42l-235.3 0c-24.2 0-44.6-18-47.6-42L28 224l-12 0c-8.8 0-16-7.2-16-16zm60.2 16L90.5 466c1 8 7.8 14 15.9 14l235.3 0c8.1 0 14.9-6 15.9-14l30.2-242L60.2 224z'
      
    ]
  };

  

  
  

  var faFrog = {
    prefix: 'fal',
    iconName: 'frog',
    icon: [
      576,
      512,
      [],
      'f52e',
      
      'M368 64c-26.5 0-48 21.5-48 48c0 .6 0 1.1-.1 1.7c-.8 8-7.6 14.3-15.9 14.3l-3.2 0C152.3 128 32 248.3 32 396.8L32 416c0 17.7 14.3 32 32 32l272 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-4.1 0-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6l8.8-8.8c1.7-1.7 3.2-3.4 4.7-5.3c8.9-11.1 13.8-25 13.8-39.4c0-12.5-3.7-24.2-9.9-34c-11.2-17.5-30.9-29.2-53.3-29.2c-16.8 0-32.8 6.7-44.7 18.5l-40.8 40.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l40.8-40.8C207.3 250 231.6 240 256.8 240c20.7 0 39.9 6.6 55.5 17.9c24 17.3 39.7 45.5 39.7 77.3c0 17.4-4.7 34.2-13.5 48.9c25.3 1.3 45.5 22.3 45.5 47.9c0 26.5-21.5 48-48 48L64 480c-35.3 0-64-28.7-64-64l0-19.2C0 234.4 128.6 102.1 289.6 96.2C296.9 59.6 329.2 32 368 32c41.4 0 75.4 31.4 79.6 71.7c38.1 7.3 69.1 18.5 90.1 27.6C562.6 142 576 166.7 576 192c0 25.5-13.4 49.1-35.2 62.2L423.7 324.4 519.8 448l40.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-4.9 0-9.6-2.3-12.6-6.2l-112-144c-2.8-3.6-3.9-8.3-3.1-12.8s3.6-8.4 7.5-10.8l132.6-79.5c12.2-7.3 19.7-20.5 19.7-34.7c0-14.4-7.5-26.4-19-31.4c-21.5-9.3-54.8-21.1-95.7-27.7c-8.2-1.3-14.1-8.7-13.4-17.1c.1-1.3 .2-2.6 .2-3.9c0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMessageLines = {
    prefix: 'fal',
    iconName: 'message-lines',
    icon: [
      512,
      512,
      ["comment-alt-lines"],
      'f4a6',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zm80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  
    var faCommentAltLines = faMessageLines;
  

  
  

  var faCloudExclamation = {
    prefix: 'fal',
    iconName: 'cloud-exclamation',
    icon: [
      640,
      512,
      [],
      'e491',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm48 128c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM296 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fal',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      'M32 112c0 17.7 14.3 32 32 32l176 0 32 0 176 0c17.7 0 32-14.3 32-32l0-71.1-23.5 9.4C433.8 59.3 409.6 64 385.2 64L126.8 64c-24.4 0-48.6-4.7-71.3-13.7L32 40.9 32 112zm208 64L96 176l0 80 144 0 0-80zM64 176c-35.3 0-64-28.7-64-64L0 13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32l258.4 0c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4l0 98.6c0 35.3-28.7 64-64 64l0 80 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208-160 0L96 288l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-80zm352 0l-144 0 0 80 144 0 0-80z'
      
    ]
  };

  

  
  

  var faPanelEws = {
    prefix: 'fal',
    iconName: 'panel-ews',
    icon: [
      512,
      512,
      [],
      'e42e',
      
      'M64 32C46.3 32 32 46.3 32 64l0 225.6C68.5 297 96 329.3 96 368l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-16 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-16 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-20.9-13.4-38.7-32-45.3L32 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 80l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 144l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM208 320l0-64-64 0 0 64 32 0 32 0zm112-64l0 160 64 0 0-160-64 0zm-32 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-160z'
      
    ]
  };

  

  
  

  var faSubtitles = {
    prefix: 'fal',
    iconName: 'subtitles',
    icon: [
      576,
      512,
      [],
      'e60f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM112 256l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 352l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 0l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSunrise = {
    prefix: 'fal',
    iconName: 'sunrise',
    icon: [
      576,
      512,
      [127749],
      'f766',
      
      'M276.7 4.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L304 54.6 304 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-153.4-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM393.5 225.2c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448l-38.9 0 38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8L75.2 391.8 113.9 448l-38.9 0L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448l-33.4 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L164 448c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480l544 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHockeyMask = {
    prefix: 'fal',
    iconName: 'hockey-mask',
    icon: [
      448,
      512,
      [],
      'f6ee',
      
      'M32 240c0-59.7 14.9-111.7 44.7-148.1C105.8 56.5 152.1 32 224 32s118.2 24.5 147.3 59.9C401.1 128.3 416 180.3 416 240c0 95.4-12.4 153.6-39.3 188.4C351.6 460.9 308 480 224 480s-127.6-19.1-152.7-51.6C44.4 393.6 32 335.4 32 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM160 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16 64 0 0 16zm-32 64c35.3 0 64-28.7 64-64l0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 16c0 35.3 28.7 64 64 64zm192-32c-17.7 0-32-14.3-32-32l0-16 64 0 0 16c0 17.7-14.3 32-32 32zm64-32l0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faLacrosseStick = {
    prefix: 'fal',
    iconName: 'lacrosse-stick',
    icon: [
      512,
      512,
      [],
      'e3b5',
      
      'M344 32s0 0 0 0l.2 0 .2 0c28.8 0 62.8 18.4 90 45.6c27.2 27.2 45.6 61.2 45.6 90.1l0 .1 0 .2c0 0 0 0 0 .1c0 44.3-28.4 83.6-70.4 97.6c0 0 0 0 0 0l-.8 .3-1.8 .6c-18.7 6.2-42.9 14.3-64 31.5l-42 34.4c-15.4 12.6-34.7 19.5-54.7 19.5c-47.7 0-86.3-38.7-86.3-86.3c0-19.9 6.9-39.2 19.5-54.7l34.4-42c17.3-21.1 25.4-45.4 31.6-64.2l.8-2.4C260.3 60.4 299.7 32 344 32zM457 55C426.8 24.8 385.1 0 344.3 0L344 0C285.9 0 234.3 37.2 215.9 92.3l-.3 .8s0 0 0 0c-6.6 19.8-13 39.1-26.5 55.6l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 26.9 9 51.7 24.1 71.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L174.7 359.9C194.6 375 219.4 384 246.3 384c27.3 0 53.8-9.4 74.9-26.7l42-34.4c16.5-13.5 35.8-19.9 55.6-26.5l.8-.3c55.1-18.4 92.3-70 92.3-128.1l0-.3c0-40.8-24.8-82.5-55-112.7z'
      
    ]
  };

  

  
  

  var faCustard = {
    prefix: 'fal',
    iconName: 'custard',
    icon: [
      576,
      512,
      [127854],
      'e403',
      
      'M49.8 384l66.3-271.2c7-28.6 32.7-48.8 62.2-48.8l219.5 0c29.5 0 55.2 20.2 62.2 48.8L526.2 384l-32.9 0L452.7 218c-18.1-5.7-37.2-10-52.7-10c-18.7 0-32.3 6.4-49.1 14.4l-.7 .3C333.8 230.6 314.4 240 288 240s-45.8-9.4-62.2-17.2l-.7-.3c-16.7-8-30.4-14.4-49.1-14.4c-15.5 0-34.6 4.4-52.7 10L82.7 384l-32.9 0zM132 182.3c14.7-3.7 30-6.3 44-6.3c26.4 0 45.8 9.4 62.2 17.2l.7 .3c16.7 8 30.4 14.4 49.1 14.4s32.3-6.4 49.1-14.4l.7-.3c16.4-7.9 35.8-17.2 62.2-17.2c14 0 29.3 2.6 44 6.3l-15.1-61.9C425.3 106.1 412.5 96 397.8 96L178.2 96c-14.7 0-27.6 10.1-31.1 24.4L132 182.3zM0 432c0-8.8 7.2-16 16-16l544 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 448c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faMistletoe = {
    prefix: 'fal',
    iconName: 'mistletoe',
    icon: [
      576,
      512,
      [],
      'f7b4',
      
      'M288 0c8.8 0 16 7.2 16 16l0 73.4 91.3 91.3c.2 .2 .4 .5 .6 .7l5.9 1.1 82.9 15.9C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-15.9-82.9-1.1-5.9c-.2-.2-.5-.4-.7-.7L304 134.6l0 142.7 4 5.3 56.8 75.7C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L268 282.7l4-5.3 0-142.7-68.7 68.7c-.2 .2-.5 .4-.7 .7l-1.1 5.9-.4 2.2c-7.9-2.6-16.3-4-25.1-4c-18 0-34.6 5.9-48 16l-30.7 5.9C59.4 237.2 32 270.3 32 309c0 23.8 19.3 43 43 43c14.8 0 28.8-4 40.9-11.2c7.5 8.5 16.8 15.4 27.3 20.2c-19.1 14.5-42.8 23-68.2 23c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l82.9-15.9 5.9-1.1c.2-.2 .4-.5 .7-.7L272 89.4 272 16c0-8.8 7.2-16 16-16zM478.7 229.9l-70.3-13.5 13.5 70.3c7.3 37.9 40.5 65.3 79.1 65.3c23.8 0 43-19.3 43-43c0-38.6-27.4-71.8-65.3-79.1zM236.8 377.6C228.5 388.7 224 402.2 224 416c0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.8-4.5-27.3-12.8-38.4L288 309.3l-51.2 68.3zM368 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM176 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faBowlScoops = {
    prefix: 'fal',
    iconName: 'bowl-scoops',
    icon: [
      448,
      512,
      [127813],
      'e3df',
      
      'M335.3 64.7c-5-.5-10.1-.7-15.3-.7c-7.8 0-15.5 .6-23 1.6C279.4 45.1 253.2 32 224 32s-55.4 13.1-73 33.6c-7.5-1.1-15.2-1.6-23-1.6c-5.2 0-10.3 .2-15.3 .7C134.7 26.1 176.3 0 224 0s89.3 26.1 111.3 64.7zM200 118.2c-7.1 8-13.3 16.7-18.7 26C166.1 134 147.7 128 128 128c-53 0-96 43-96 96L0 224C0 153.3 57.3 96 128 96c26.7 0 51.5 8.2 72 22.2zM448 224l-32 0c0-53-43-96-96-96s-96 43-96 96l-32 0c0-70.7 57.3-128 128-128s128 57.3 128 128zm-2.1 65.9c-8.5 67.9-63.4 119.9-130.5 125.6c-4.1 .3-8.2 .5-12.4 .5l-28.8 0 26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2l-192 0c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L147.2 448l26.7-32L145 416c-4.2 0-8.3-.2-12.4-.5c-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6 .8-9.1 3.9-12.6s7.4-5.4 12-5.4l416 0c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96l28.8 0 32 0 36.3 0 32 0 28.8 0c55.8 0 102.9-41 110.9-96L34.1 288zM198.4 436.5L162.2 480l123.7 0-36.3-43.5L224 405.8l-25.6 30.7z'
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'fal',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM208 352l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faCircleV = {
    prefix: 'fal',
    iconName: 'circle-v',
    icon: [
      512,
      512,
      [],
      'e12a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM158.3 152.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l112 224c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l112-224c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L256 348.2 158.3 152.8z'
      
    ]
  };

  

  
  

  var faFileBinary = {
    prefix: 'fal',
    iconName: 'file-binary',
    icon: [
      384,
      512,
      [],
      'e175',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm48 256c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zM96 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 96-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-112c0-8.8-7.2-16-16-16l-32 0z'
      
    ]
  };

  

  
  

  var faNfcMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'nfc-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e1f9',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l288 0c16.6 12.5 35.8 21.8 56.6 27.1c-7.6 3.2-15.9 4.9-24.6 4.9L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 64c-11 0-21.7 1.1-32 3.2L416 96c0-17.7-14.3-32-32-32zm0 64l0 45.3c-11.4 5-22.2 11.3-32 18.7l0-64-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-82.7c0-17.7 14.3-32 32-32l112 0c17.7 0 32 14.3 32 32zM320 416L96 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 256 205.3 0c5 11.4 11.3 22.2 18.7 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM448 416.2a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 32c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 29.6-10 56.8-26.9 78.5l86.2 86.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-86.2-86.2c-21.7 16.9-48.9 26.9-78.5 26.9z'
      
    ]
  };

  

  
  

  var faWindowRestore = {
    prefix: 'fal',
    iconName: 'window-restore',
    icon: [
      512,
      512,
      [],
      'f2d2',
      
      'M432 32L208 32c-26.5 0-48 21.5-48 48l0 16-32 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-32 16 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48zM320 160L64 160c-17.7 0-32 14.3-32 32l0 64 320 0 0-64c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-160L32 288l0 160zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSailboat = {
    prefix: 'fal',
    iconName: 'sailboat',
    icon: [
      576,
      512,
      [],
      'e445',
      
      'M285.1 6.8c-4-5.7-11.3-8.2-17.9-6.1S256 9 256 16l0 320c0 8.8 7.2 16 16 16l224 0c6 0 11.4-3.3 14.2-8.6s2.3-11.7-1.1-16.6l-224-320zM288 320l0-253.2L465.3 320 288 320zM212.1 96.5c-7-1.9-14.4 1.2-18 7.5l-128 224c-2.8 5-2.8 11 .1 16s8.1 8 13.8 8l128 0c8.8 0 16-7.2 16-16l0-224c0-7.3-4.9-13.6-11.9-15.5zM107.6 320L192 172.2 192 320l-84.4 0zM42.5 416l491.1 0c-13.5 38.1-49.6 64-90.5 64L133 480c-40.9 0-77-25.9-90.5-64zM21.1 384c-10.6 0-18.3 10.1-15.4 20.3l4 14.3C25.3 473.9 75.6 512 133 512L443 512c57.3 0 107.7-38.1 123.2-93.3l4-14.3c2.9-10.2-4.8-20.3-15.4-20.3L21.1 384z'
      
    ]
  };

  

  
  

  var faCassetteBetamax = {
    prefix: 'fal',
    iconName: 'cassette-betamax',
    icon: [
      576,
      512,
      ["betamax"],
      'f8a4',
      
      'M32 160l0 256c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-256L32 160zm0-32l512 0 0-32c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 32zM576 96l0 32 0 16 0 16 0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160l0-16 0-16L0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64zM240 304a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 304a96 96 0 1 1 192 0A96 96 0 1 1 80 304zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-48l0 96 96 0 0-96-96 0zm-32 0c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96z'
      
    ]
  };

  
    var faBetamax = faCassetteBetamax;
  

  
  

  var faCrow = {
    prefix: 'fal',
    iconName: 'crow',
    icon: [
      640,
      512,
      [],
      'f520',
      
      'M25.7 412.7L63.2 384l209.4 0 48.6 118.1c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L307.2 384l12.8 0c16 0 31.4-1.9 46.3-5.6l50.9 123.7c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L396.6 368.1C464.5 338.5 512 270.8 512 192l0-48 128-32c0-44.2-35.8-80-80-80l-72.4 0C470 12.4 444.4 0 416 0c-53 0-96 43-96 96l0 51L52.4 352l-8.6 6.6L6.3 387.3c-7 5.4-8.3 15.4-3 22.4s15.4 8.3 22.4 3zM506.5 64L560 64c18 0 33.7 9.9 41.9 24.5L512 111l0-15c0-11.2-1.9-22-5.5-32zM132.7 330.8l186.7-143C313.6 250 268 302.1 205.9 315.2l-73.2 15.5zM320 352l-133.2 0 25.7-5.5c81.3-17.2 139.5-89 139.5-172.2l0-11.6s0 0 0 0l0-15.8 0-51c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32 0 64c0 88.4-71.6 160-160 160zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var fa00 = {
    prefix: 'fal',
    iconName: '00',
    icon: [
      640,
      512,
      [],
      'e467',
      
      'M144 32C64.5 32 0 96.5 0 176L0 336c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM32 176C32 114.1 82.1 64 144 64s112 50.1 112 112l0 160c0 61.9-50.1 112-112 112S32 397.9 32 336l0-160zM496 32c-79.5 0-144 64.5-144 144l0 160c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM384 176c0-61.9 50.1-112 112-112s112 50.1 112 112l0 160c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-160z'
      
    ]
  };

  

  
  

  var faHexagonDivide = {
    prefix: 'fal',
    iconName: 'hexagon-divide',
    icon: [
      512,
      512,
      [],
      'e1ad',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faUserUnlock = {
    prefix: 'fal',
    iconName: 'user-unlock',
    icon: [
      640,
      512,
      [],
      'e058',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 336c-80 0-145 64.3-146.3 144l352 0c0 11.7 3.1 22.6 8.6 32L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3l0 39c-26.8-33.5-68-55-114.3-55l-91.4 0zM480 272l0 48 32 0 64 0 32 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480l160 0 0-128-160 0 0 128z'
      
    ]
  };

  

  
  

  var faSensorFire = {
    prefix: 'fal',
    iconName: 'sensor-fire',
    icon: [
      640,
      512,
      [],
      'e02a',
      
      'M64 64l320 0c17.7 0 32 14.3 32 32l0 41c9.4-6.9 20.9-9.8 32-8.8L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l273.6 0c-8.8-9.8-16.5-20.6-23.2-32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm255.1 48.9l47.4 49.8c3.1 3.2 7.4 5 11.9 5s8.7-2 11.7-5.4l21-23.7c16.6 15.9 33.7 37.3 46.7 60.7C599.5 304 608 329.4 608 352c0 33.5-12.7 63.9-33.6 86.6c1-5.2 1.6-10.7 1.6-16.2c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 311.9 384 365 384 422.4c0 5.7 .6 11.2 1.6 16.6c-21-22.8-33.6-53.3-33.6-87c0-28.4 12.4-58.2 31.4-86.7c18.4-27.5 42-52.6 63.7-72.3zM480 479.9c-2.4 0-4.7-.1-7-.2c-33.7-3.2-57-29.4-57-57.3c0-17.4 10.1-37.7 27.4-58.5c12.1-14.5 25.8-27 36.6-35.8c10.7 8.8 24.5 21.3 36.6 35.8C533.9 384.7 544 405 544 422.4c0 27.8-23.2 54-56.9 57.3c-2.4 .1-4.7 .2-7.1 .2zM320 352c0 85.6 65.7 155 150.9 159.6c3 .3 6 .4 9.1 .4c3.1 0 6.2-.1 9.2-.4C573.6 506.9 640 437.6 640 352c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-11.2-10.4-28.5-10.4-39.7-.1c-.4 .4-.8 .7-1.1 1.2l-12.3 13.8-37.9-39.9c-.3-.3-.5-.5-.8-.8c-11.1-10.1-28.1-10.1-39.3-.1c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352z'
      
    ]
  };

  

  
  

  var faFaceExhaling = {
    prefix: 'fal',
    iconName: 'face-exhaling',
    icon: [
      576,
      512,
      [],
      'e480',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c40.8 0 78.9-10.9 111.8-29.9c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9C346.2 499.6 302.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C391.7 0 502.7 105.5 511.4 238.9c.6 8.8-6.1 16.4-14.9 17s-16.4-6.1-17-14.9C471.8 124.3 374.7 32 256 32zm.1 376.1a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm60.8-89.6c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm-121.6 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm299.6 49.6c26.1 0 47.4 19.2 51.3 44.1c17.9 10.3 29.9 29.7 29.9 51.9s-12 41.6-29.9 51.8c-3.9 24.9-25.3 44.2-51.3 44.2c-14.2 0-27-5.7-36.4-15c-2.2 .3-4.4 .4-6.6 .4c-27.3 0-49.4-21.1-51.7-47.7l-60.7-18.4c-6.7-2-11.4-8.3-11.4-15.3s4.6-13.3 11.4-15.3l62-18.8c5.5-22.9 25.9-40.1 50.5-40.1l.7 0c9.4-13.2 24.7-21.8 42.2-21.8zm-18.6 44.9c-3 7.7-11.2 11.8-19.2 9.6c-1.6-.5-3.4-.7-5.2-.7c-10.8 0-19.9 8.9-19.9 20.4c0 7-4.6 13.3-11.4 15.3l-21.4 6.5 22.1 6.7c7.8 2.4 12.6 10.3 11.1 18.4c-.2 1.3-.4 2.6-.4 4c0 11.4 9.1 20.4 19.9 20.4c2.5 0 4.8-.4 6.9-1.3c7.1-2.7 15.1 0 19.2 6.4c3.6 5.7 9.8 9.4 16.8 9.4c10.8 0 19.9-8.9 19.9-20.4c0-.4 0-.9 0-1.3c-.4-7.2 4-13.8 10.8-16.1c10.7-3.6 18.5-14 18.5-26.2s-7.8-22.6-18.5-26.2c-6.8-2.3-11.2-8.9-10.8-16.1c0-.4 0-.9 0-1.3c0-11.4-9.1-20.4-19.9-20.4c-8.3 0-15.6 5.2-18.6 12.9z'
      
    ]
  };

  

  
  

  var faTrafficLightGo = {
    prefix: 'fal',
    iconName: 'traffic-light-go',
    icon: [
      320,
      512,
      [],
      'f638',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 70.7 57.3 128 128 128s128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM160 448a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faEyeLowVision = {
    prefix: 'fal',
    iconName: 'eye-low-vision',
    icon: [
      640,
      512,
      ["low-vision"],
      'f2a8',
      
      'M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1zM605.5 268.3c-10.3 24.6-28.3 57-53.9 89l-25.1-19.8C550.1 308 566.8 278.1 576 256c-13.3-32-42.1-80-85.2-120C447.7 96 390.4 64 320 64c-39.8 0-75.4 10.2-106.6 26.3L186.1 68.8C224 46.8 268.8 32 320 32c80.8 0 145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6zM448 256c0 6.3-.5 12.4-1.3 18.5l-30.9-24.4C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4l-30.9-24.4c14.7-5.8 30.6-9.1 47.4-9.1c70.7 0 128 57.3 128 128zM106 163.5l320 256c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 188.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5zM67.5 238c5.5-6.9 15.6-8 22.5-2.5l250 200c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L70 260.5c-6.9-5.5-8-15.6-2.5-22.5zM106 336.3l124 99.2c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 361.3c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5z'
      
    ]
  };

  
    var faLowVision = faEyeLowVision;
  

  
  

  var faUpFromDottedLine = {
    prefix: 'fal',
    iconName: 'up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e456',
      
      'M222.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 196.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L288 208c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 64.8zM224 32c-9.5 0-18.6 3.9-25.1 10.8L74.5 174.8C67.8 182 64 191.5 64 201.3c0 21.4 17.3 38.7 38.7 38.7l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 42.8C242.6 35.9 233.5 32 224 32zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faTrain = {
    prefix: 'fal',
    iconName: 'train',
    icon: [
      448,
      512,
      [128646],
      'f238',
      
      'M352 32c35.3 0 64 28.7 64 64l0 128L32 224 32 96c0-35.3 28.7-64 64-64l256 0zM32 352l0-96 384 0 0 96c0 35.3-28.7 64-64 64L96 416c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96L0 352c0 46 32.4 84.4 75.6 93.8L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L118.6 448l210.7 0 59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352l0-256c0-53-43-96-96-96L96 0zM224 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faLessThanEqual = {
    prefix: 'fal',
    iconName: 'less-than-equal',
    icon: [
      448,
      512,
      [],
      'f537',
      
      'M406.1 62.8c8.2-3.3 12.1-12.7 8.8-20.9s-12.7-12.1-20.9-8.8l-352 144c-6 2.5-9.9 8.3-9.9 14.8s3.9 12.3 9.9 14.8l352 144c8.2 3.3 17.5-.6 20.9-8.7s-.6-17.5-8.8-20.9L90.3 192 406.1 62.8zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448z'
      
    ]
  };

  

  
  

  var faHandsBubbles = {
    prefix: 'fal',
    iconName: 'hands-bubbles',
    icon: [
      576,
      512,
      ["hands-wash"],
      'e05e',
      
      'M400.1 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-192 424c0 3.2-.2 6.4-.5 9.5C239.4 491 284.4 512 334.2 512l129.9 0c26.5 0 48-21.5 48-48c0-6.2-1.2-12.2-3.4-17.7c20.4-5.5 35.4-24.2 35.4-46.3c0-6.2-1.2-12.2-3.4-17.7c20.4-5.5 35.4-24.2 35.4-46.3s-15-40.8-35.4-46.3c2.2-5.5 3.4-11.4 3.4-17.7c0-26.5-21.5-48-48-48l-108.2 0c12.2-13.6 16-33.7 8.1-51.5c-10.8-24.2-39.1-35.1-63.4-24.4l-69.1 30.7c-62.9 27.9-103.4 90.3-103.4 159.1c0 9.6 .8 19.1 2.3 28.3c27.4 16.9 45.7 47.2 45.7 81.8zM0 224.2c-.4 55 25.1 106 67.4 138.8c12.6-6.7 26.9-10.6 42.1-11C61.8 327.7 31.6 278.4 32 224.5l.5-75.7c.1-8.8 7.3-15.9 16.1-15.9s15.9 7.3 15.9 16.1l-.3 46.2c-.1 7.6 5.2 14.1 12.6 15.7s14.9-2.1 18-9L166.2 44.2c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-39.6 87.4c-3.6 8-.1 17.5 8 21.2s17.5 .1 21.2-8l39.6-87.4 13.2-29.1c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2L253.7 83.8l-39.1 86.4c11.1-7.9 23.1-14.8 35.9-20.5c0 0 0 0 0 0l.4-.2 10.2-4.4L282.8 97c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-7.2 15.9 40.4-17.5c2.1-20-8.6-40-27.9-48.7c-5.7-2.6-11.6-4-17.5-4.2c3.4-20.9-7.4-42.2-27.6-51.3S228.8 1.1 215.3 17.4c-4.1-4.2-9-7.8-14.7-10.4C176.5-3.9 148 6.8 137.1 31L92.5 129.5c-7.4-16.7-24.1-28.5-43.6-28.6C22.4 100.7 .7 122.1 .5 148.6L0 224.2zm345.6-46.9c8.1-3.6 17.5 0 21.1 8.1s0 17.5-8.1 21.1l-42.2 18.8c-6.9 3.1-10.7 10.6-9.2 17.9s8.1 12.7 15.7 12.7l173.2 0c8.8 0 16 7.2 16 16c0 8.8-7.1 16-16 16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c0 0 0 0 0 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c0 0 0 0 0 0l-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c0 0 0 0 0 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c0 0 0 0 0 0l-15.9 0-64.1 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0s0 0 0 0c8.8 0 15.9 7.2 15.9 16c0 8.8-7.2 16-16 16l-129.9 0c-78.5 0-142.1-63.6-142.1-142.1c0-56.1 33.1-107 84.4-129.8l69.1-30.7zM80.1 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm272-304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faHandsWash = faHandsBubbles;
  

  
  

  var faChartBar = {
    prefix: 'fal',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      'M16 32c8.8 0 16 7.2 16 16l0 352c0 26.5 21.5 48 48 48l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 480c-44.2 0-80-35.8-80-80L0 48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 80l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faCloudShowersWater = {
    prefix: 'fal',
    iconName: 'cloud-showers-water',
    icon: [
      576,
      512,
      [],
      'e4e4',
      
      'M176.1 99.3C178.6 61.7 209.8 32 248 32c26.4 0 49.4 14.2 62 35.4c2.3 3.8 6 6.5 10.3 7.5s8.9 .1 12.5-2.4c7.7-5.3 17-8.4 27.2-8.4c23 0 42.2 16.1 46.9 37.7c1.6 7.3 8.1 12.6 15.6 12.6l18.6 0c21.5 0 38.9 17.4 38.9 38.9s-17.4 38.9-38.9 38.9l-306.3 0C113.4 192 96 174.6 96 153.1s17.4-38.9 38.9-38.9l25.3 0c8.4 0 15.4-6.6 16-15zM248 0c-50 0-91.7 35.3-101.7 82.3l-11.4 0C95.7 82.3 64 114 64 153.1s31.7 70.9 70.9 70.9l306.3 0c39.1 0 70.9-31.7 70.9-70.9s-31.7-70.9-70.9-70.9l-6.8 0C422.5 52.8 393.7 32 360 32c-11.1 0-21.7 2.3-31.3 6.4C309.6 15 280.6 0 248 0zM141.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480zM472.9 258.7c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2zM253.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zm107.6-22.2c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2z'
      
    ]
  };

  

  
  

  var faSquareCaretUp = {
    prefix: 'fal',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c9.6 0 18.7 4 25.2 11l95.5 102.8c4.7 5.1 7.3 11.8 7.3 18.7c0 15.2-12.3 27.5-27.5 27.5l-201 0C108.3 320 96 307.7 96 292.5c0-6.9 2.6-13.6 7.3-18.7L198.8 171c6.5-7 15.6-11 25.2-11zm-1.7 32.7L133.8 288l180.3 0-88.4-95.3c-.4-.5-1.1-.7-1.7-.7s-1.3 .3-1.7 .7z'
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faTally = {
    prefix: 'fal',
    iconName: 'tally',
    icon: [
      640,
      512,
      ["tally-5"],
      'f69c',
      
      'M128 32c8.8 0 16 7.2 16 16l0 249.8 96-32L240 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 207.1 96-32L368 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 164.5 96-32L496 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.8 74.9-25c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L528 203.5 528 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-249.8-96 32L400 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-207.1-96 32L272 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-164.5-96 32L144 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-121.8-74.9 25c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L112 308.5 112 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faTally5 = faTally;
  

  
  

  var faGridRound5 = {
    prefix: 'fal',
    iconName: 'grid-round-5',
    icon: [
      448,
      512,
      [],
      'e5de',
      
      'M40 64A8 8 0 1 1 24 64a8 8 0 1 1 16 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm8 128a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM136 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM328 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faHandBackFist = {
    prefix: 'fal',
    iconName: 'hand-back-fist',
    icon: [
      448,
      512,
      ["hand-rock"],
      'f255',
      
      'M96 64c0-35.3 28.7-64 64-64c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c35.3 0 64 28.7 64 64l0 80c0 49.6-25.1 93.3-63.2 119.2c-.4 .3-.6 .6-.7 .7c0 .1 0 .1-.1 .1c0 0 0 0 0 0L352 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-135.9c0-11.6 6.3-21.5 14.8-27.4C364.5 312.6 384 278.6 384 240l0-80c0-17.7-14.3-32-32-32c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C315.2 106 302.7 96 288 96c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C251.2 74 238.7 64 224 64c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C187.2 42 174.7 32 160 32c-17.7 0-32 14.3-32 32l0 48 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-57.4L78.1 168.6c-9 9-14.1 21.2-14.1 33.9L64 256c0 44.2 29.9 81.5 70.6 92.6c13.5 3.7 25.4 15.8 25.4 32.1L160 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-115.3s0 0 0 0c0 0-.1-.1-.2-.3c-.3-.4-.8-.8-1.6-1C71.9 364.7 32 315 32 256l0-53.5c0-21.2 8.4-41.6 23.4-56.6L96 105.4 96 64z'
      
    ]
  };

  
    var faHandRock = faHandBackFist;
  

  
  

  var faMarsStrokeRight = {
    prefix: 'fal',
    iconName: 'mars-stroke-right',
    icon: [
      640,
      512,
      [9897,"mars-stroke-h"],
      'f22b',
      
      'M64 256a144 144 0 1 1 288 0A144 144 0 1 1 64 256zm319.3-16C375.2 150.3 299.8 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c91.8 0 167.2-70.3 175.3-160l48.7 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 89.4 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L553.4 240 464 240l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48.7 0z'
      
    ]
  };

  
    var faMarsStrokeH = faMarsStrokeRight;
  

  
  

  var faPersonChalkboard = {
    prefix: 'fal',
    iconName: 'person-chalkboard',
    icon: [
      640,
      512,
      [],
      'e53d',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160l44.7 0 0 160-64 0 0-156c6-2.6 12.5-4 19.3-4zM160 496l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-336 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-80c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-80-32 0 0 80c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 80-76.9 0-63.8 0c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.2 128 496c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faRightLongToLine = {
    prefix: 'fal',
    iconName: 'right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e444',
      
      'M640 80l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 216L48 216c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l272 0c17.7 0 32 14.3 32 32l0 49.3c0 3.7 3 6.7 6.7 6.7c1.9 0 3.7-.8 5-2.2L476.2 256 363.7 130.2c-1.3-1.4-3.1-2.2-5-2.2c-3.7 0-6.7 3-6.7 6.7l0 49.3c0 17.7-14.3 32-32 32zm192 40c0 5.2-1.9 10.1-5.3 14L387.5 403.1c-7.3 8.2-17.8 12.9-28.8 12.9c-21.4 0-38.7-17.3-38.7-38.7l0-17.3 0-32-32 0L48 328c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l240 0 32 0 0-32 0-17.3c0-21.4 17.3-38.7 38.7-38.7c11 0 21.5 4.7 28.8 12.9L506.7 242c3.4 3.8 5.3 8.8 5.3 14z'
      
    ]
  };

  

  
  

  var faSwapArrows = {
    prefix: 'fal',
    iconName: 'swap-arrows',
    icon: [
      640,
      512,
      [],
      'e60a',
      
      'M100.7 20.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L128 70.6 128 360c0 48.6 39.4 88 88 88s88-39.4 88-88l0-208c0-66.3 53.7-120 120-120s120 53.7 120 120l0 289.4 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L512 441.4 512 152c0-48.6-39.4-88-88-88s-88 39.4-88 88l0 208c0 66.3-53.7 120-120 120s-120-53.7-120-120L96 70.6 35.3 131.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88z'
      
    ]
  };

  

  
  

  var faGrid5 = {
    prefix: 'fal',
    iconName: 'grid-5',
    icon: [
      448,
      512,
      [],
      'e199',
      
      'M24 56l16 0 0 16L24 72l0-16zM16 32C7.2 32 0 39.2 0 48L0 80c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L16 32zm8 120l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zM0 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM24 344l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zM0 432l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM120 56l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zM96 144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zM96 336l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM216 72l0-16 16 0 0 16-16 0zM192 48l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zm-24-24l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zm-24-24l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM312 56l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zm-24-24l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zm-24-24l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM408 72l0-16 16 0 0 16-16 0zM384 48l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zm-24-24l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm24 104l16 0 0 16-16 0 0-16zm-8-24c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm8 136l0-16 16 0 0 16-16 0zm-24-24l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faArrowDownToLine = {
    prefix: 'fal',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      'M16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480zM203.3 379.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 329.4 176 224l0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 0 105.4L308.7 228.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128z'
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faRepeat1 = {
    prefix: 'fal',
    iconName: 'repeat-1',
    icon: [
      512,
      512,
      [128258],
      'f365',
      
      'M0 255.2C-.4 264 6.4 271.5 15.2 272s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112L320 112l0 44.4c0 15.2 12.3 27.6 27.6 27.6c6.8 0 13.4-2.5 18.4-7.1l76.7-69c3.4-3 5.3-7.4 5.3-11.9s-1.9-8.9-5.3-11.9L366 15.1C360.9 10.5 354.4 8 347.6 8C332.3 8 320 20.3 320 35.6L320 80 176.2 80C82.4 80 5.1 153.5 .4 247.2l-.4 8zM408.1 96L352 146.5l0-100.9L408.1 96zM512 256.8c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400L192 400l0-44.4c0-15.2-12.3-27.6-27.6-27.6c-6.8 0-13.4 2.5-18.4 7.1l-76.7 69c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l76.7 69c5.1 4.6 11.6 7.1 18.4 7.1c15.2 0 27.6-12.3 27.6-27.6l0-44.4 143.8 0c93.8 0 171.1-73.5 175.8-167.2l.4-8zM103.9 416L160 365.5l0 100.9L103.9 416zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L256 240l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  

  
  

  var faBuildingCircleCheck = {
    prefix: 'fal',
    iconName: 'building-circle-check',
    icon: [
      640,
      512,
      [],
      'e4d2',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 202.8c9.1-12.9 19.9-24.5 32-34.6L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm152-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faBurgerCheese = {
    prefix: 'fal',
    iconName: 'burger-cheese',
    icon: [
      512,
      512,
      [127828,"cheeseburger"],
      'f7f1',
      
      'M445 221.8C428.9 132.1 350.4 64 256 64S83.1 132.1 67 221.8l0 .1c0 .1 .1 .2 .3 .3c.7 .8 2.4 1.7 4.7 1.7l368 0c2.4 0 4-1 4.7-1.7c.1-.1 .2-.2 .3-.3l0-.1zM72 256c-22.1 0-40.4-18.1-36.5-39.8C54.3 111.5 145.9 32 256 32s201.7 79.5 220.5 184.2c3.9 21.7-14.4 39.8-36.5 39.8l-24 0-192 0L72 256zm358.5 96l17.5 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96c0-17.7 14.3-32 32-32l145.5 0 48 32L64 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l-65.5 0 48-32zM160 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 288l192 0c3.2 0 6.2 .9 8.9 2.7L320 348.8l87.1-58.1c2.6-1.8 5.7-2.7 8.9-2.7l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-59.2 0-92 61.3c-5.4 3.6-12.4 3.6-17.8 0l-92-61.3L32 320c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faCheeseburger = faBurgerCheese;
  

  
  

  var faChessBoard = {
    prefix: 'fal',
    iconName: 'chess-board',
    icon: [
      448,
      512,
      [],
      'f43c',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm88 0l64 0 72 0 72 0 64 0c13.3 0 24 10.7 24 24l0 64 0 72 0 72 0 64c0 13.3-10.7 24-24 24l-64 0-72 0-72 0-64 0c-13.3 0-24-10.7-24-24l0-64 0-72 0-72 0-64c0-13.3 10.7-24 24-24zm8 72l40 0 0-40-40 0 0 40zm72 0l40 0 0-40-40 0 0 40zm72 0l40 0 0-40-40 0 0 40zm72 0l40 0 0-40-40 0 0 40zm0 32l0 40 40 0 0-40-40 0zm0 72l0 40 40 0 0-40-40 0zm0 72l0 40 40 0 0-40-40 0zm-32 0l-40 0 0 40 40 0 0-40zm-72 0l-40 0 0 40 40 0 0-40zm-72 0l-40 0 0 40 40 0 0-40zm0-32l0-40-40 0 0 40 40 0zm0-72l0-40-40 0 0 40 40 0zm32 0l40 0 0-40-40 0 0 40zm72 0l40 0 0-40-40 0 0 40zm0 32l0 40 40 0 0-40-40 0zm-32 0l-40 0 0 40 40 0 0-40z'
      
    ]
  };

  

  
  

  var faBringFront = {
    prefix: 'fal',
    iconName: 'bring-front',
    icon: [
      640,
      512,
      [],
      'f857',
      
      'M64 32l128 0c17.7 0 32 14.3 32 32l32 0c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l64 0 0-32-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM448 512l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-64 0 0 32 64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l-32 0c0 35.3 28.7 64 64 64zM416 128c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l192 0zM224 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L224 96zm32 96l128 0 0 128-128 0 0-128zm-32 0l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faUpLeft = {
    prefix: 'fal',
    iconName: 'up-left',
    icon: [
      384,
      512,
      [],
      'e2bd',
      
      'M72 128c-4.4 0-8 3.6-8 8l0 201.4c0 3.7 3 6.6 6.6 6.6c1.8 0 3.4-.7 4.7-1.9l61.4-61.4c6.2-6.2 16.4-6.2 22.6 0L272 393.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6L329.4 368c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16L216.7 223.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l61.4-61.4c1.2-1.2 1.9-2.9 1.9-4.7c0-3.7-3-6.6-6.6-6.6L72 128zm-40 8c0-22.1 17.9-40 40-40l201.4 0c21.3 0 38.6 17.3 38.6 38.6c0 10.2-4.1 20.1-11.3 27.3L250.6 212 352 313.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6L326.6 416c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L148 314.6 97.9 364.7C90.7 371.9 80.9 376 70.6 376C49.3 376 32 358.7 32 337.4L32 136z'
      
    ]
  };

  

  
  

  var faSquareQuote = {
    prefix: 'fal',
    iconName: 'square-quote',
    icon: [
      448,
      512,
      [],
      'e329',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 286.4l0-54.4 0-16 0-16c0-22.1-17.9-40-40-40l-32 0c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l32 0c2.7 0 5.4-.3 8-.8l0 15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4zM176 232c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 16 0 16zm176 0l0-16 0-16c0-22.1-17.9-40-40-40l-32 0c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l32 0c2.7 0 5.4-.3 8-.8l0 15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4l0-54.4zm-32-16l0 16c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 16z'
      
    ]
  };

  

  
  

  var faHoodCloak = {
    prefix: 'fal',
    iconName: 'hood-cloak',
    icon: [
      576,
      512,
      [],
      'f6ef',
      
      'M32 480l.4-.4 .2-.2s0 0 0 0l.1-.1C81.7 427 96 348.2 96 288c0-128 44-192 90-224c46-32 94-32 102-32l124.6 0c-1.2 1-2.7 2.2-4.2 3.5c-4.4 3.6-9.8 8-13.7 11.6c-6.7 6.1-10.5 14.7-10.5 23.8s3.9 17.7 10.6 23.7C438.8 134.2 480 195.8 480 288c0 60.2 14.3 139 63.3 191.3c0 0 0 0 0 0l.1 .1c.2 .2 .4 .4 .6 .6l-128 0 0-160c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 160L32 480zm160 0l0-160c0-53 43-96 96-96s96 43 96 96l0 160-192 0zm381.6 12.2c4.9-11.9 2.2-25.6-6.8-34.7c0 0 0 0 0 0l-.1-.1C525.8 413.8 512 345 512 288c0-87-33.1-150.3-73.1-194.6c-7.4-8.2-15-15.7-22.7-22.6c3.5-3.2 7.4-6.3 11.3-9.5c0 0 0 0 0 0c4.5-3.7 9.1-7.4 13.3-11.4c4-3.7 7.7-7.7 10.7-11.9c4.7-6.5 5.9-15 2.9-22.7C450.8 6.1 441.9 0 432 0L288 0c-9.8 0-66 0-120.3 37.7C111.4 76.9 64 151.8 64 288c0 57.1-13.9 125.9-54.6 169.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8l512 0c12.9 0 24.6-7.8 29.6-19.8z'
      
    ]
  };

  

  
  

  var faGlasses = {
    prefix: 'fal',
    iconName: 'glasses',
    icon: [
      576,
      512,
      [],
      'f530',
      
      'M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L38.1 274.4c31-12 65-18.4 97.6-18.4c40.1 0 82.2 9.6 118.5 27.3c2.6 1.3 4.9 2.9 7 4.7l53.7 0c2.1-1.8 4.4-3.4 7-4.7c36.2-17.8 78.4-27.3 118.5-27.3c32.6 0 66.6 6.3 97.6 18.4L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7c29 0 54.2 19.6 61.5 47.6l50.7 196.6c3 11.8 4.6 23.8 4.6 36l0 39.8c0 .2 0 .3 0 .5l0 15.5c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L304.4 320l-32.9 0-3.4 54.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-39.8 0-.2 0-.2c0-12 1.6-23.9 4.6-35.5L55.3 79.6C62.5 51.6 87.8 32 116.8 32c9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM32 312l0 .2L32 352l0 16c0 44.2 35.8 80 80 80l44.3 0c42.5 0 77.5-33.2 79.9-75.6l0-.2s0 0 0 0L240 312s0 0 0 0c0 0 0 0 0-.1c-31.8-15.5-69-24-104.3-24c-35.1 0-72.2 8.4-103.7 24zm512 0c-31.4-15.6-68.6-24-103.7-24c-35.3 0-72.5 8.5-104.3 24l0 .1s0 0 0 0l3.8 60.2s0 0 0 0l0 .2c2.4 42.4 37.4 75.6 79.9 75.6l44.3 0c44.2 0 80-35.8 80-80l0-56z'
      
    ]
  };

  

  
  

  var faPaintbrushFine = {
    prefix: 'fal',
    iconName: 'paintbrush-fine',
    icon: [
      576,
      512,
      ["paint-brush-alt","paint-brush-fine","paintbrush-alt"],
      'f5a9',
      
      'M534.5 41.4c-12.5-12.5-32.8-12.5-45.3 0L324.6 206l45.3 45.3L534.5 86.6c12.5-12.5 12.5-32.8 0-45.3zM302 228.6l-36.6 36.6s0 0 0 0L224.6 306l45.3 45.3 4.6-4.6s0 0 0 0l36.1-36.1 36.6-36.6L302 228.6zM195.9 322.5c-6.3-1.6-13-2.5-19.9-2.5c-44.2 0-80 35.8-80 80c0 2.8 .1 5.6 .4 8.3c1.7 16.7-3 33.6-12.5 46.7C74.3 468.5 58 480 36.8 480L176 480c44.2 0 80-35.8 80-80c0-6.9-.9-13.5-2.5-19.9l-57.7-57.7zM557.2 109.3L286.3 380.2c1.1 6.4 1.7 13.1 1.7 19.8c0 61.9-50.1 112-112 112L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l4.8 0c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c6.7 0 13.3 .6 19.7 1.7l271-271c25-25 65.5-25 90.5 0s25 65.5 0 90.5z'
      
    ]
  };

  
    var faPaintBrushAlt = faPaintbrushFine;
  
    var faPaintBrushFine = faPaintbrushFine;
  
    var faPaintbrushAlt = faPaintbrushFine;
  

  
  

  var faChessQueen = {
    prefix: 'fal',
    iconName: 'chess-queen',
    icon: [
      512,
      512,
      [9819],
      'f445',
      
      'M256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zm-95.2 0c-14 0-24.5 10-28 21.3c-9 29.4-36.5 50.8-68.8 50.8c-12.1 0-23.4-3-33.4-8.2c-5.6-3-12.6-3.1-18.6 0c-10.1 5.4-13.5 18.2-7.5 28L97.1 352l37.7 0L49.3 215.1c4.8 .7 9.7 1 14.7 1c44.8 0 82.9-28.3 97.5-67.9C181.4 179.3 216.3 200 256 200s74.6-20.7 94.5-51.8c14.7 39.6 52.8 67.9 97.5 67.9c5 0 9.9-.4 14.7-1L377.1 352l37.7 0 92.6-148.2c5.9-9.5 2.8-22.1-7-27.6c-6.1-3.5-13.3-3.4-19.1-.3c-10 5.3-21.4 8.2-33.5 8.2c-32.4 0-59.8-21.4-68.8-50.8c-3.5-11.3-13.9-21.3-28-21.3c-11.3 0-20.6 6.6-25.4 15.2C312 151.6 285.9 168 256 168s-56-16.4-69.8-40.8c-4.8-8.6-14.1-15.2-25.4-15.2zm-31 304l252.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4l-305.1 0c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L129.8 416zm252.4-32l-252.4 0c-11.1 0-21.4 5.7-27.2 15.1L69.9 451.8C66.1 458 64 465.2 64 472.6c0 21.8 17.7 39.4 39.4 39.4l305.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z'
      
    ]
  };

  

  
  

  var faTreasureChest = {
    prefix: 'fal',
    iconName: 'treasure-chest',
    icon: [
      576,
      512,
      [],
      'f723',
      
      'M128 64l0 192 64 0 0-32c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 64 0 0-192L128 64zM320 384l-64 0c-35.3 0-64-28.7-64-64l0-32-64 0 0 160 320 0 0-160-64 0 0 32c0 35.3-28.7 64-64 64zM96 69.5C58.7 82.6 32 118.2 32 160l0 96 64 0L96 69.5zM32 288l0 144c0 8.8 7.2 16 16 16l48 0 0-160-64 0zM480 448l48 0c8.8 0 16-7.2 16-16l0-144-64 0 0 160zm64-192l0-96c0-41.8-26.7-77.4-64-90.5L480 256l64 0zM0 160C0 89.3 57.3 32 128 32l320 0c70.7 0 128 57.3 128 128l0 272c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48L0 160zm320 32l-64 0c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32zm-16 48l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faMessageArrowUpRight = {
    prefix: 'fal',
    iconName: 'message-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e1dd',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM192 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0L172.7 268.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 182.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faFileSlash = {
    prefix: 'fal',
    iconName: 'file-slash',
    icon: [
      640,
      512,
      [],
      'e3a7',
      
      'M512 163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-23 0-43.2 12.2-54.5 30.4L163 50.5C168.1 39.6 179.2 32 192 32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 108.8L512 326l0-162.2zM160 448l0-236.8L128 186l0 262c0 35.3 28.7 64 64 64l256 0c23 0 43.2-12.2 54.5-30.4L477 461.5c-5.1 10.9-16.2 18.5-29 18.5l-256 0c-17.7 0-32-14.3-32-32zM479.5 160L368 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faCoinFront = {
    prefix: 'fal',
    iconName: 'coin-front',
    icon: [
      512,
      512,
      [],
      'e3fc',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm16-272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z'
      
    ]
  };

  

  
  

  var faGaugeCircleBolt = {
    prefix: 'fal',
    iconName: 'gauge-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e496',
      
      'M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18.1 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380 440 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z'
      
    ]
  };

  

  
  

  var faTransporter5 = {
    prefix: 'fal',
    iconName: 'transporter-5',
    icon: [
      512,
      512,
      [],
      'e2a6',
      
      'M464 0c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM48 128c-8.8 0-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0c-8.8 0-16 7.2-16 16zM160 144c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm64 128c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm-32 96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faVolume = {
    prefix: 'fal',
    iconName: 'volume',
    icon: [
      576,
      512,
      [128265,"volume-medium"],
      'f6a8',
      
      'M320 66.7L183.6 188c-2.9 2.6-6.7 4-10.6 4l-85 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l85 0c3.9 0 7.7 1.4 10.6 4L320 445.3l0-378.6zM302.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C338.7 32 352 45.3 352 61.8l0 388.4c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L166.9 352 88 352c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l78.9 0L302.4 39.5zM419.2 182.4c5.3-7.1 15.3-8.5 22.4-3.2C464.9 196.7 480 224.6 480 256s-15.1 59.3-38.4 76.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4C438 295.5 448 276.9 448 256s-10-39.5-25.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4zm87-74.5C548.8 143.1 576 196.4 576 256s-27.2 112.9-69.8 148.1c-6.8 5.6-16.9 4.7-22.5-2.1s-4.7-16.9 2.1-22.5C521.4 350.1 544 305.7 544 256s-22.6-94.1-58.2-123.4c-6.8-5.6-7.8-15.7-2.1-22.5s15.7-7.8 22.5-2.1z'
      
    ]
  };

  
    var faVolumeMedium = faVolume;
  

  
  

  var faDiceTwo = {
    prefix: 'fal',
    iconName: 'dice-two',
    icon: [
      448,
      512,
      [9857],
      'f528',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faGift = {
    prefix: 'fal',
    iconName: 'gift',
    icon: [
      512,
      512,
      [127873],
      'f06b',
      
      'M365.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1 11.1 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-2.9 0zm-130 96l-45-72.1C180.8 41 164.5 32 146.9 32L144 32c-26.5 0-48 21.5-48 48s21.5 48 48 48l80 0 11.1 0zM256 101l38.8-62c15.2-24.2 41.7-39 70.3-39L368 0c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48l32 0c26.5 0 48 21.5 48 48l0 64c0 20.9-13.4 38.7-32 45.3l0 2.7 0 160c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-160 0-2.7C13.4 278.7 0 260.9 0 240l0-64c0-26.5 21.5-48 48-48l32 0C70 114.6 64 98 64 80C64 35.8 99.8 0 144 0l2.9 0c28.6 0 55.2 14.7 70.3 39L256 101zM144 160l-96 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l16 0 176 0 0-96-16 0-80 0zm128 0l0 96 176 0 16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-96 0-80 0-16 0zM240 288L64 288l0 160c0 17.7 14.3 32 32 32l144 0 0-192zm32 192l144 0c17.7 0 32-14.3 32-32l0-160-176 0 0 192z'
      
    ]
  };

  

  
  

  var faMemoCircleInfo = {
    prefix: 'fal',
    iconName: 'memo-circle-info',
    icon: [
      576,
      512,
      [],
      'e49a',
      
      'M320 32L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 134.6c-11.2 3.2-21.9 7.4-32 12.6L352 64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16zm16 80l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm464 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16l0-32c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 48s0 0 0 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faMailboxFlagUp = {
    prefix: 'fal',
    iconName: 'mailbox-flag-up',
    icon: [
      576,
      512,
      [],
      'e5bb',
      
      'M352 208l0-96 0-56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-72 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zM448 96l0-32-64 0 0 32 64 0zM320 64l0 32-85.5 0c32.6 26.4 53.5 66.8 53.5 112l0 176c0 11.7-3.1 22.6-8.6 32L512 416c17.7 0 32-14.3 32-32l0-176c0-32.7-14-62-36.3-82.5c2.7-6.6 4.3-13.9 4.3-21.5l0-15.8c38.6 25.8 64 69.8 64 119.8l0 176c0 35.3-28.7 64-64 64l-288 0L64 448c-35.3 0-64-28.7-64-64L0 208C0 128.5 64.5 64 144 64l176 0zM224 416c17.7 0 32-14.3 32-32l0-176c0-61.9-50.1-112-112-112S32 146.1 32 208l0 176c0 17.7 14.3 32 32 32l160 0zM96 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceDowncastSweat = {
    prefix: 'fal',
    iconName: 'face-downcast-sweat',
    icon: [
      512,
      512,
      [],
      'e371',
      
      'M79.8 68.6c5.4 8.5 9.8 16.4 12.8 23.1c2.6 5.8 3.2 8.8 3.4 9.6l0 .1C96 113.5 84.3 128 64 128s-32-14.5-32-26.7c0 .1 0 .1 0-.1c.2-.7 .8-3.7 3.4-9.5c3-6.7 7.4-14.6 12.8-23.1c5-7.9 10.5-15.8 15.8-23c5.3 7.2 10.8 15.1 15.8 23zM72.5 4.1c-4.3-5.5-12.8-5.5-17.1 0C38.1 25.8 0 76.3 0 101.3C0 133.8 28.7 160 64 160s64-26.2 64-58.7c0-25-37.9-75.5-55.5-97.2zM256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224S32 379.7 32 256c0-20.7 2.8-40.7 8.1-59.7c2.4-8.5-2.6-17.3-11.2-19.7s-17.3 2.6-19.7 11.2C3.2 209.5 0 232.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-43.1 0-83.8 10.7-119.5 29.5c-7.8 4.1-10.8 13.8-6.7 21.6S143.7 62 151.5 57.8C182.7 41.3 218.2 32 256 32zM96 272c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM173.3 411.9c6.6 5.9 16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6C323.8 371.4 295.7 352 256 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6z'
      
    ]
  };

  

  
  

  var faCarBattery = {
    prefix: 'fal',
    iconName: 'car-battery',
    icon: [
      512,
      512,
      ["battery-car"],
      'f5df',
      
      'M64 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm256 0c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM64 160c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L64 160zM0 192c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 192zm368 16c8.8 0 16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16zM96 256l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faBatteryCar = faCarBattery;
  

  
  

  var faDogLeashed = {
    prefix: 'fal',
    iconName: 'dog-leashed',
    icon: [
      576,
      512,
      [129454],
      'f6d4',
      
      'M67.4 6.1C72.9-.8 82.9-2 89.9 3.4L307 174 331.9 24.8C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32l44.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l32 0c26.5 0 48 21.5 48 48l0 16c0 53-43 96-96 96l-42.7 0L432 256l0 200c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-47.3 0-33.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1l0 33.3 0 47.3c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-248c0-.7 0-1.4 .1-2c-.7-.2-1.4-.3-2.1-.5c-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6C54.5 169.7 67.6 176 82 176l14 0 40 0 24 0 97.7 0L70.1 28.6C63.2 23.1 62 13.1 67.4 6.1zM322.9 349.5c8.2 6 13.1 15.6 13.1 25.8l0 80.7c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-194.1c0 0 0 0-.1 0L307.6 208c-.3 0-.7 0-1 0L288 208l0 138.7c2.1-.6 4.2-1.2 6.3-1.9c9.7-3.1 20.4-1.4 28.6 4.6zM256 351.8L256 208l-96 0-24 0-40 0 0 248c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-80.7c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2c2.7 0 5.4-.1 8-.2zM405.8 218.7c2.6-15.4 15.9-26.7 31.6-26.7l42.7 0c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16l-32 0c-8.5 0-16.6-3.4-22.6-9.4L455.4 68.7c-3-3-7.1-4.7-11.3-4.7L400 64c-10.1 0-19.6-4.7-25.6-12.8L362.5 35.4 338.2 181.3c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMugHot = {
    prefix: 'fal',
    iconName: 'mug-hot',
    icon: [
      512,
      512,
      [9749],
      'f7b6',
      
      'M80 0C71.2 0 64 7.2 64 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7C121.5 112.2 128 127.8 128 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9L113.9 59.3C102.5 47.8 96 32.2 96 16C96 7.2 88.8 0 80 0zM32 224l304 0 16 0 0 192c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-192zm352 0l16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-16 0 0-160zm0 192l16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0-16 0L32 192c-17.7 0-32 14.3-32 32L0 416c0 53 43 96 96 96l192 0c53 0 96-43 96-96zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7C249.5 112.2 256 127.8 256 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9L241.9 59.3C230.5 47.8 224 32.2 224 16z'
      
    ]
  };

  

  
  

  var faArrowDownSquareTriangle = {
    prefix: 'fal',
    iconName: 'arrow-down-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-down-alt"],
      'f889',
      
      'M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 176c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 96zm64 147.5L341.3 448l149.4 0L416 323.5zM320 176l0-96c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48zM307.6 442l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1l-173.9 0c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9z'
      
    ]
  };

  
    var faSortShapesDownAlt = faArrowDownSquareTriangle;
  

  
  

  var faSquarePollVertical = {
    prefix: 'fal',
    iconName: 'square-poll-vertical',
    icon: [
      448,
      512,
      ["poll"],
      'f681',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 224c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zM320 288c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faPoll = faSquarePollVertical;
  

  
  

  var faJedi = {
    prefix: 'fal',
    iconName: 'jedi',
    icon: [
      576,
      512,
      [],
      'f669',
      
      'M288 0c8.8 0 16 7.2 16 16l0 264.9 36.1-24.1c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1l-23.9 35.8 42.2 8.4c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8l-42.2 8.4 23.9 35.8c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1L304 359.1l0 71.7c54.3-7.8 96-54.4 96-110.9c0-36.2-17.1-68.3-43.8-88.8c-4.2-3.2-6.5-8.3-6.2-13.6s3.2-10.1 7.8-12.8C397.5 181 424 137.6 424 88c0-20.3-4.5-39.6-12.4-56.9c-3-6.5-1.3-14.1 4-18.8s13.2-5.2 19.1-1.4C510 59.3 560 143.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240C16 143.8 66 59.3 141.3 10.9c6-3.8 13.8-3.3 19.1 1.4s7 12.3 4 18.8C156.5 48.4 152 67.7 152 88c0 49.6 26.5 93 66.2 116.8c4.5 2.7 7.4 7.5 7.8 12.8s-2 10.4-6.2 13.6C193.1 251.7 176 283.8 176 320c0 56.4 41.7 103.1 96 110.9l0-71.7-36.1 24.1c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1l23.9-35.8-42.2-8.4c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l42.2-8.4-23.9-35.8c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1L272 280.9 272 16c0-8.8 7.2-16 16-16zM64.1 153.5l43.2 43.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L53.6 188.2c-2.2 9.9-3.8 20.1-4.7 30.5c.8 .6 1.6 1.2 2.4 2l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L49.2 263.8C61.1 385.2 163.5 480 288 480s226.9-94.8 238.8-216.2l-35.5 35.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l56-56c.7-.7 1.5-1.4 2.4-2c-.9-10.4-2.5-20.5-4.7-30.5l-31.1 31.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l43.2-43.2c-12.7-32.8-32.3-62.1-57.2-86.1C455.6 74.1 456 81 456 88c0 53.6-25.1 101.4-64.2 132.1C416.7 246 432 281.2 432 320c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.8 15.3-74 40.2-99.9C145.1 189.4 120 141.6 120 88c0-7 .4-13.9 1.3-20.6c-24.8 24-44.5 53.3-57.2 86.1z'
      
    ]
  };

  

  
  

  var faTilde = {
    prefix: 'fal',
    iconName: 'tilde',
    icon: [
      448,
      512,
      [63135],
      '7e',
      
      'M96.8 160C61.2 160 32 188.8 32 224l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-53.2 43.9-96 96.8-96c29.4 0 57.6 13.5 75.9 36.7l128 162.8c12.1 15.4 31 24.5 50.7 24.5c35.5 0 64.8-28.8 64.8-64l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 53.2-43.9 96-96.8 96c-29.4 0-57.6-13.5-75.9-36.7l-128-162.9c-12.1-15.4-31-24.5-50.7-24.5z'
      
    ]
  };

  

  
  

  var faMapLocationDot = {
    prefix: 'fal',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      'M366.6 155c6.7-15.9 9.4-27.6 9.4-35c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 7.4 2.7 19 9.4 35c6.5 15.4 15.7 32.4 26.4 49.7c17.1 27.8 36.9 54.7 52.2 74.4c15.3-19.7 35.1-46.6 52.2-74.4c10.7-17.3 19.9-34.3 26.4-49.7zM302.8 312c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120c0 54.6-73.1 151.9-105.2 192zm103.1-89.1c-.8 .3-1.7 .6-2.5 .8c8.2-14.2 15.7-28.7 21.8-42.9l117.9-47.2c15.8-6.3 32.9 5.3 32.9 22.3l0 270.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 448.9l-144 57.6C17.1 512.8 0 501.2 0 484.2L0 213.4c0-9.8 6-18.6 15.1-22.3l123.2-49.3c2.1 10.4 5.4 20.8 9.2 30.8L32 218.8l0 253.5 128-51.2L160 304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 115.9 192 54.9L384 304c0-8.8 7.2-16 16-16s16 7.2 16 16l0 168.4 128-51.2 0-253.5L405.9 222.9zM288 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faBorderTopLeft = {
    prefix: 'fal',
    iconName: 'border-top-left',
    icon: [
      448,
      512,
      ["border-style"],
      'f853',
      
      'M0 448c0 8.8 7.2 16 16 16s16-7.2 16-16L32 96c0-17.7 14.3-32 32-32l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32C28.7 32 0 60.7 0 96L0 448zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-96 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faBorderStyle = faBorderTopLeft;
  

  
  

  var faNotEqual = {
    prefix: 'fal',
    iconName: 'not-equal',
    icon: [
      448,
      512,
      [],
      'f53e',
      
      'M377.1 34.8c7.3 5 9.1 15 4 22.3L321 144l95 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-117.2 0L188.1 336 416 336c8.8 0 16 7.2 16 16s-7.2 16-16 16l-250.1 0L93.2 473.1c-5 7.3-15 9.1-22.3 4s-9.1-15-4-22.3L127 368l-95 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l117.2 0L259.9 176 32 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l250.1 0L354.8 38.9c5-7.3 15-9.1 22.3-4z'
      
    ]
  };

  

  
  

  var faMoneyCheckPen = {
    prefix: 'fal',
    iconName: 'money-check-pen',
    icon: [
      640,
      512,
      ["money-check-edit"],
      'f872',
      
      'M64 96l448 0c17.7 0 32 14.3 32 32l0 69.6c10.2-4 21.1-5.9 32-5.6l0-64c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l266.2 0 8-32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32zm48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-256 0zM96 208c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0c-8.8 0-16 7.2-16 16zm486.8 56l17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40L560.2 264c6.2-6.2 16.4-6.2 22.6 0zM406.5 417.7L512.7 311.5l40 40L446.4 457.7c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zM537.5 241.4L383.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2L446.8 493c8.4-2.1 16.1-6.5 22.3-12.6L622.8 326.6c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z'
      
    ]
  };

  
    var faMoneyCheckEdit = faMoneyCheckPen;
  

  
  

  var faManatSign = {
    prefix: 'fal',
    iconName: 'manat-sign',
    icon: [
      384,
      512,
      [],
      'e1d5',
      
      'M192 32c-8.8 0-16 7.2-16 16l0 48.7C77.4 104.8 0 187.3 0 288L0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-83 63.1-151.2 144-159.2L176 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-335.2c80.9 8 144 76.2 144 159.2l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-100.7-77.4-183.2-176-191.3L208 48c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faSquareK = {
    prefix: 'fal',
    iconName: 'square-k',
    icon: [
      448,
      512,
      [],
      'e274',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm315.1 59.5l-87.3 84.3 89 118.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L204.6 262.2 160 305.3l0 62.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-69.5L128 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 116.8L292.9 132.5c6.4-6.1 16.5-6 22.6 .4s6 16.5-.4 22.6z'
      
    ]
  };

  

  
  

  var faCircleDownRight = {
    prefix: 'fal',
    iconName: 'circle-down-right',
    icon: [
      512,
      512,
      [],
      'e108',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm80 328c0 4.4-3.6 8-8 8l-113.4 0c-3.7 0-6.6-3-6.6-6.6c0-1.8 .7-3.4 1.9-4.7l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6l-59.1-59.1c-3.6-3.6-4.9-9-3.3-13.9c.7-2 1.8-3.8 3.3-5.3l22.1-22.1c1.5-1.5 3.3-2.6 5.3-3.3c4.9-1.6 10.3-.4 13.9 3.3l59.1 59.1c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c1.2-1.2 2.9-1.9 4.7-1.9c3.7 0 6.6 3 6.6 6.6L336 328zm-8 40c22.1 0 40-17.9 40-40l0-113.4c0-21.3-17.3-38.6-38.6-38.6c-10.2 0-20.1 4.1-27.3 11.3L288 201.4l-47.7-47.7c-12.2-12.2-30.3-16.5-46.7-11c-6.7 2.2-12.8 6-17.8 11l-22.1 22.1c-5 5-8.8 11.1-11 17.8c-5.5 16.4-1.2 34.5 11 46.7L201.4 288l-14.1 14.1c-7.2 7.2-11.3 17.1-11.3 27.3c0 21.3 17.3 38.6 38.6 38.6L328 368z'
      
    ]
  };

  

  
  

  var faEngineWarning = {
    prefix: 'fal',
    iconName: 'engine-warning',
    icon: [
      640,
      512,
      ["engine-exclamation"],
      'f5f2',
      
      'M416 80c0 8.8-7.2 16-16 16l-80 0 0 32 16 0 60.6 0c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L144 384c-26.5 0-48-21.5-48-48l0-64-8 0-56 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 56 0 8 0 0-64c0-26.5 21.5-48 48-48l16 0 128 0 0-32-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16zM304 160l-144 0-16 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l28.8 0c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12L448 416c17.7 0 32-14.3 32-32l0-157.7c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4L336 160l-32 0s0 0 0 0s0 0 0 0zm304 64l-32 0 0 192 32 0 0-192zm-32-32l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32zm-272 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16zM280 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faEngineExclamation = faEngineWarning;
  

  
  

  var faTransporter3 = {
    prefix: 'fal',
    iconName: 'transporter-3',
    icon: [
      512,
      512,
      [],
      'e045',
      
      'M480 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM64 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zM144 448c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16s7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-224 0zm16-304c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.1 16-15.9c0 0 0 0 0-.1s0 0 0-.1c0-8.8-7.2-15.9-16-15.9l-288 0c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faBuildingNgo = {
    prefix: 'fal',
    iconName: 'building-ngo',
    icon: [
      384,
      512,
      [],
      'e4d7',
      
      'M320 32L64 32c-11.8 0-22.2 6.4-27.7 16L2 48C9.1 20.4 34.2 0 64 0L320 0c29.8 0 54.9 20.4 62 48l-34.3 0c-5.5-9.6-15.9-16-27.7-16zM0 240l32 0 0 208c0 17.7 14.3 32 32 32l64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0c17.7 0 32-14.3 32-32l0-208 32 0 0 208c0 35.3-28.7 64-64 64l-64 0-32 0-64 0-32 0-64 0c-35.3 0-64-28.7-64-64L0 240zM192 384c-17.7 0-32 14.3-32 32l0 64 64 0 0-64c0-17.7-14.3-32-32-32zM168 80l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-88c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zM61.3 87.1l34.7 52L96 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8 64 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM208 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zM104 240l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32z'
      
    ]
  };

  

  
  

  var faAnchorLock = {
    prefix: 'fal',
    iconName: 'anchor-lock',
    icon: [
      640,
      512,
      [],
      'e4ad',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 256-32 0c-79.5 0-144-64.5-144-144l0-25.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6 64 336c0 97.2 78.8 176 176 176l48 0 48 0c18.3 0 36-2.8 52.6-8c-3-7.4-4.6-15.5-4.6-24l0-8.2c-15 5.3-31.2 8.2-48 8.2l-32 0 0-256 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zM528 224c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80l160 0 0 128-160 0 0-128z'
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fal',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M0 48c0-8.8 7.2-16 16-16l32 0 32 0 152 0c66.3 0 120 53.7 120 120c0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120L80 480l-32 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-192L32 64 16 64C7.2 64 0 56.8 0 48zM64 448l16 0 184 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-32 0L64 272l0 176zm0-208l168 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L80 64 64 64l0 176z'
      
    ]
  };

  

  
  

  var faStroopwafel = {
    prefix: 'fal',
    iconName: 'stroopwafel',
    icon: [
      512,
      512,
      [],
      'f551',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM142.9 120.2l45.3 45.3 45.3-45.3L210.7 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 45.3-45.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-45.3 45.3 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256 437 278.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 45.3 45.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.3-45.3-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-45.3 45.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l45.3-45.3-45.3-45.3L97.6 301.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3-45.3-45.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm45.3 90.5L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zm181 45.3l-45.3-45.3L278.6 256l45.3 45.3L369.1 256zm-67.9 67.9L256 278.6l-45.3 45.3L256 369.1l45.3-45.3zM210.7 188.1L256 233.4l45.3-45.3L256 142.9l-45.3 45.3z'
      
    ]
  };

  

  
  

  var faSignature = {
    prefix: 'fal',
    iconName: 'signature',
    icon: [
      640,
      512,
      [],
      'f5b7',
      
      'M160 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 3.4c0 26.2-2.4 52.3-7.2 78L155 243.7c-34.8 9.5-59 41.1-59 77.2l0 92.6c0 36.7 29.8 66.5 66.5 66.5c24 0 46.2-13 57.9-33.9L247.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-134.1 0 52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3L314.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7l0-3.4c0-53-43-96-96-96s-96 43-96 96l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zm3.4 146.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6c-19 0-34.5-15.4-34.5-34.5l0-92.6c0-21.6 14.5-40.6 35.4-46.3zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0z'
      
    ]
  };

  

  
  

  var faCaduceus = {
    prefix: 'fal',
    iconName: 'caduceus',
    icon: [
      512,
      512,
      [],
      'e681',
      
      'M256 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm15.8 61.3C290.5 86.8 304 69 304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 21 13.5 38.8 32.2 45.3c-.1 .9-.2 1.8-.2 2.7l0 24L181 75.8C170.8 68.1 158.5 64 145.7 64c-15.6 0-30.6 6.2-41.6 17.2L8 177.4c-5.1 5.1-8 12.1-8 19.3C0 211.8 12.2 224 27.3 224l118.8 0c33 0 65.3-9.3 93.3-26.8l.6-.4 0 148.5-39-21.3c-15.4-8.4-25-24.6-25-42.1l0-10c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 10c0 29.3 16 56.2 41.7 70.2l36.9 20.1-20.9 11.4c-25.7 14-41.7 41-41.7 70.2l0 10c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10c0-17.6 9.6-33.7 25-42.1l23-12.5 0 51.4 0 45.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-45.3 0-51.4 23 12.5c15.4 8.4 25 24.6 25 42.1l0 10c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10c0-29.3-16-56.2-41.7-70.2l-20.9-11.4 36.9-20.1c25.7-14 41.7-41 41.7-70.2l0-10c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 10c0 17.6-9.6 33.7-25 42.1l-39 21.3 0-148.5 .6 .4c28 17.5 60.3 26.8 93.3 26.8l118.8 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L407.9 81.2c-11-11-26-17.2-41.6-17.2c-12.7 0-25.1 4.1-35.3 11.8L272 120l0-24c0-.9-.1-1.8-.2-2.7zm113.4 10.5L473.4 192l-107.5 0c-27 0-53.4-7.6-76.3-21.9l-16.9-10.6 77.6-58.2c4.6-3.5 10.3-5.4 16.1-5.4c7.1 0 13.9 2.8 19 7.9zM145.7 96c5.8 0 11.4 1.9 16.1 5.4l77.6 58.2-16.9 10.6c-22.9 14.3-49.3 21.9-76.3 21.9L38.6 192l88.1-88.1c5-5 11.8-7.9 19-7.9z'
      
    ]
  };

  

  
  

  var faSquareO = {
    prefix: 'fal',
    iconName: 'square-o',
    icon: [
      448,
      512,
      [],
      'e278',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faBinarySlash = {
    prefix: 'fal',
    iconName: 'binary-slash',
    icon: [
      640,
      512,
      [],
      'e33e',
      
      'M448 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L416 192l-48 0c-6.3 0-11.8 3.7-14.4 9l29.1 23 49.2 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM320 144l0-64c0-44.2-35.8-80-80-80L208 0c-27.2 0-51.2 13.5-65.6 34.2l25.2 19.9C176.1 40.8 191 32 208 32l32 0c26.5 0 48 21.5 48 48l0 64c0 1.7-.1 3.4-.3 5l27.6 21.8c3-8.4 4.6-17.4 4.6-26.8zm0 224l0 64c0 44.2 35.8 80 80 80l32 0c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9C463.9 471.2 449 480 432 480l-32 0c-26.5 0-48-21.5-48-48l0-64c0-1.7 .1-3.4 .3-5l-27.6-21.8c-3 8.4-4.6 17.4-4.6 26.8zm-96-64c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L192 480l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faUserPen = {
    prefix: 'fal',
    iconName: 'user-pen',
    icon: [
      640,
      512,
      ["user-edit"],
      'f4ff',
      
      'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l290.2 0-1 3.8c-2.4 9.5-1.8 19.3 1.4 28.2l-293 0C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c44.2 0 84.6 16.1 115.8 42.7l-22.7 22.7c-25.3-20.9-57.7-33.4-93.1-33.4l-91.4 0c-80 0-145 64.3-146.3 144zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z'
      
    ]
  };

  
    var faUserEdit = faUserPen;
  

  
  

  var faPrescriptionBottlePill = {
    prefix: 'fal',
    iconName: 'prescription-bottle-pill',
    icon: [
      576,
      512,
      [],
      'e5c0',
      
      'M336 32c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L48 96c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l288 0zM48 0C21.5 0 0 21.5 0 48L0 80c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c11.6 0 22.4-3.1 31.8-8.4c-8.9-7.3-17-15.5-24.3-24.5c-2.4 .6-4.9 .9-7.5 .9L96 480c-17.7 0-32-14.3-32-32l0-32 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-32-32 0zm320 0l-32 0 0 72.2c9.8-8.1 20.6-15.2 32-21l0-51.2zm80 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm36.7-84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fal',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      'M0 48c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 64l0 160c0 70.7 57.3 128 128 128s128-57.3 128-128l0-160-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 160c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 64 16 64C7.2 64 0 56.8 0 48zM0 464c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCirclePlus = {
    prefix: 'fal',
    iconName: 'rectangle-history-circle-plus',
    icon: [
      640,
      512,
      [],
      'e4a3',
      
      'M480 192l0 .7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7l0-.7c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zM448 64L64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0L112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faUmbrellaSimple = {
    prefix: 'fal',
    iconName: 'umbrella-simple',
    icon: [
      512,
      512,
      ["umbrella-alt"],
      'e2bc',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16.5C116.7 40.1 17 134.9 2 256.1C-.2 273.6 14.3 288 32 288l448 0c17.7 0 32.2-14.4 30-31.9C495 134.9 395.3 40.1 272 32.5L272 16zm0 430.6L272 320l-32 0 0 126.6c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7C159.1 498 181.8 512 206.6 512c36.1 0 65.4-29.3 65.4-65.4zM256 64c112.8 0 206.2 83.5 221.7 192L34.3 256C49.8 147.5 143.2 64 256 64z'
      
    ]
  };

  
    var faUmbrellaAlt = faUmbrellaSimple;
  

  
  

  var faBath = {
    prefix: 'fal',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      'M93.3 32C77.1 32 64 45.1 64 61.3L64 256l384 0 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0L64 288l-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L32 61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L113.9 40.6C108.5 35.1 101 32 93.3 32zM32 320l32 0 0 48c0 26.2 12.6 49.4 32 64c0 0 0 0 0 0s0 0 0 0c13.4 10 30 16 48 16l224 0c18 0 34.6-6 48-16c0 0 0 0 0 0s0 0 0 0c19.4-14.6 32-37.8 32-64l0-48 32 0 0 48c0 30.5-12.2 58.2-32 78.4l0 49.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-26.8c-14.5 6.9-30.8 10.8-48 10.8l-224 0c-17.2 0-33.5-3.9-48-10.8L96 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-49.6C44.2 426.2 32 398.5 32 368l0-48zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z'
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faMessages = {
    prefix: 'fal',
    iconName: 'messages',
    icon: [
      640,
      512,
      ["comments-alt"],
      'f4b6',
      
      'M202.7 288L352 288c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 16 55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320l-149.3 0-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-16 0-32-32 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64l0-32 32 0 0 32c0 17.7 14.3 32 32 32l117.3 0c6.9 0 13.7 2.2 19.2 6.4L512 464l0-16c0-17.7 14.3-32 32-32l32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-128 0 0-32 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 32 0 16c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448z'
      
    ]
  };

  
    var faCommentsAlt = faMessages;
  

  
  

  var faWifi = {
    prefix: 'fal',
    iconName: 'wifi',
    icon: [
      640,
      512,
      ["wifi-3","wifi-strong"],
      'f1eb',
      
      'M27.3 184.4C102.4 110 205.8 64 320 64s217.6 46 292.7 120.4c6.3 6.2 16.4 6.2 22.6-.1s6.2-16.4-.1-22.6C554.3 81.5 442.9 32 320 32S85.7 81.5 4.7 161.7c-6.3 6.2-6.3 16.3-.1 22.6s16.3 6.3 22.6 .1zM320 224c70.5 0 134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0C185.6 252.5 249.5 224 320 224zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faWifi3 = faWifi;
  
    var faWifiStrong = faWifi;
  

  
  

  var faFileArrowUp = {
    prefix: 'fal',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 278.6 176 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4z'
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseCircleExclamation = {
    prefix: 'fal',
    iconName: 'house-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e50a',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7 96 432c0 26.5 21.5 48 48 48l64 0 0-160c0-17.7 14.3-32 32-32l96 0c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9L240 320l0 160 16 0 80 0 24.2 0c10 12.1 21.7 22.9 34.6 32L144 512c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faClipboard = {
    prefix: 'fal',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      'M192 32c-22.3 0-41.2 15.3-46.5 36c-1.8 7.1-8.2 12-15.5 12l-18 0c-8.8 0-16 7.2-16 16l0 32 96 0 96 0 0-32c0-8.8-7.2-16-16-16l-18 0c-7.3 0-13.7-4.9-15.5-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48l6.7 0c20.9 0 38.7 13.4 45.3 32l2.7 0c35.3 0 64 28.7 64 64l0 304c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 144c0-35.3 28.7-64 64-64l2.7 0C73.3 61.4 91.1 48 112 48l6.7 0zM320 128c0 17.7-14.3 32-32 32l-96 0-96 0c-17.7 0-32-14.3-32-32l0-16c-17.7 0-32 14.3-32 32l0 304c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-304c0-17.7-14.3-32-32-32l0 16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faHexagonPlus = {
    prefix: 'fal',
    iconName: 'hexagon-plus',
    icon: [
      512,
      512,
      ["plus-hexagon"],
      'f300',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM240 352l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  
    var faPlusHexagon = faHexagonPlus;
  

  
  

  var faTaco = {
    prefix: 'fal',
    iconName: 'taco',
    icon: [
      512,
      512,
      [127790],
      'f826',
      
      'M257.1 61.2l44.1 34.2 17-22-17 22c10.9 8.5 24.4 12.8 38.2 12.4l55.8-1.7c.8 0 1.6 .5 1.8 1.3l15.6 53.6c3.9 13.3 12.2 24.8 23.6 32.5l46.1 31.4c.7 .5 1 1.4 .7 2.1c-1.4 3.8-3.4 8.3-6.3 14.8c-1.9 4.2-4.1 9.1-6.2 14.2c7.6 8.5 14.6 17.4 21.2 26.7c2.7-10 7.3-20.3 11.5-29.7c2.6-5.8 5.1-11.3 6.8-16.2c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7C3.6 241.6 6 247.1 8.7 253c4.2 9.4 8.8 19.6 11.5 29.7c6.5-9.3 13.6-18.2 21.2-26.7c-2.1-5.1-4.3-10-6.2-14.2c-2.9-6.5-4.9-11-6.3-14.8c-.3-.8 0-1.7 .7-2.1l46.1-31.4c11.4-7.8 19.8-19.3 23.6-32.5L115 107.4c.2-.8 1-1.3 1.8-1.3l55.8 1.7c13.8 .4 27.3-4 38.2-12.4l44.1-34.2c.7-.5 1.6-.5 2.2 0zM256 224c123.7 0 224 100.3 224 224L32 448c0-123.7 100.3-224 224-224zM32 480l448 0c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zm80-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faChampagneGlasses = {
    prefix: 'fal',
    iconName: 'champagne-glasses',
    icon: [
      640,
      512,
      [129346,"glass-cheers"],
      'f79f',
      
      'M98.1 186.2C73.2 233.5 95.7 292 146 310.3s105.1-12 116.5-64.3l10.9-50.1L122 140.8 98.1 186.2zm182.1-21.9l19.2-88.6L179.3 32 137 112.2l143.2 52.1zm-210.4 7L150.9 17.1c7.5-14.2 24.2-20.6 39.3-15.2L310.4 45.7c3.6 1.3 6.8 3.2 9.6 5.6c2.8-2.4 6-4.3 9.6-5.6L449.8 1.9c15-5.5 31.8 1 39.3 15.2l81.2 154.2c31.4 59.7 7.4 132.3-50.6 162.6l42 115.4 56.9-20.7c8.3-3 17.5 1.3 20.5 9.6s-1.3 17.5-9.6 20.5l-71.9 26.2L485.6 511c-8.3 3-17.5-1.3-20.5-9.6s1.3-17.5 9.6-20.5l56.9-20.7-42-115.4c-63.9 14.1-129-26.1-143.3-92L320 131.8l-26.2 121c-14.3 65.9-79.4 106.2-143.3 92l-42 115.4L165.4 481c8.3 3 12.6 12.2 9.6 20.5s-12.2 12.6-20.5 9.6L82.5 484.9 10.5 458.7c-8.3-3-12.6-12.2-9.6-20.5s12.2-12.6 20.5-9.6l56.9 20.7 42-115.4c-58-30.3-82-102.9-50.6-162.6zm472.1 14.9L518 140.8 366.6 195.9 377.5 246c11.3 52.3 66.2 82.5 116.5 64.3s72.8-76.7 47.9-124.1zM359.8 164.3L503 112.2 460.7 32 340.6 75.7l19.2 88.6z'
      
    ]
  };

  
    var faGlassCheers = faChampagneGlasses;
  

  
  

  var faMarsStrokeUp = {
    prefix: 'fal',
    iconName: 'mars-stroke-up',
    icon: [
      320,
      512,
      [9896,"mars-stroke-v"],
      'f22a',
      
      'M171.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 54.6l0 73.4-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32.8C63.1 200.8 0 269 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-83-63.1-151.2-144-159.2l0-32.8 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-73.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zM160 480a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  
    var faMarsStrokeV = faMarsStrokeUp;
  

  
  

  var faUserMinus = {
    prefix: 'fal',
    iconName: 'user-minus',
    icon: [
      640,
      512,
      [],
      'f503',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 80l91.4 0c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144zm0-32C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM432 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  

  
  

  var faSignalSlash = {
    prefix: 'fal',
    iconName: 'signal-slash',
    icon: [
      640,
      512,
      [],
      'f695',
      
      'M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 347.9 32 25.3L592 16zM432 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-44.8L432 426l0 70zm32-384c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 150.9 32 25.3L464 112zM304 324.9L304 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-145.8-32-25.3zM192 288c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faRoadCircleXmark = {
    prefix: 'fal',
    iconName: 'road-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e566',
      
      'M157.5 74c9.2-25.2 33.2-42 60.1-42l204.9 0c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21L336 64l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-86.4 0c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43l238.5 0c5.9 11.4 12.9 22.2 21 32l-259.6 0c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208l0 86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z'
      
    ]
  };

  

  
  

  var faStoreSlash = {
    prefix: 'fal',
    iconName: 'store-slash',
    icon: [
      640,
      512,
      [],
      'e071',
      
      'M544 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 54 32 25.3 0-79.3zM385.1 224c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0L141.6 0c-9.7 0-18.8 5-23.9 13.1l-.7 1.1 25.3 19.9 1.3-2.1 352.8 0 56.2 88.9s0 0 0 0c18.7 29.6 .3 66.6-29.2 70.6c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5c-4 0-7.9 .8-11.6 2.2L382.7 224c.8 0 1.6 0 2.3 0zm-220.9-9.5l-29.7-23.4c-3.3 .6-6.7 .9-10.1 .9c-2.6 0-5.2-.2-7.9-.5c-20.7-2.8-35.9-22.1-36.6-43.5l-29-22.9c-12 43.2 14 91.7 61.3 98.1c4 .5 8.1 .8 12.1 .8c14.4 0 27.9-3.5 39.8-9.5zM378.8 384l-40.5-32L128 352l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80 0 16 0 16 0 64c0 35.3 28.7 64 64 64l320 0c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4l-320 0c-17.7 0-32-14.3-32-32l0-64 250.8 0zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faH4 = {
    prefix: 'fal',
    iconName: 'h4',
    icon: [
      640,
      512,
      [],
      'f86a',
      
      'M447.7 83L411.4 272 608 272l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128-216 0c-4.8 0-9.3-2.1-12.3-5.8s-4.3-8.5-3.4-13.2l40-208c1.7-8.7 10.1-14.4 18.7-12.7s14.4 10.1 12.7 18.7zM16 64c8.8 0 16 7.2 16 16l0 160 256 0 0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160L32 272l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 256 0 80c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBadgerHoney = {
    prefix: 'fal',
    iconName: 'badger-honey',
    icon: [
      640,
      512,
      [129441],
      'f6b4',
      
      'M459.8 96c-21 0-41.8 4.9-60.6 14.3c-23.3 11.6-48.9 17.7-74.9 17.7L128 128c-5.3 0-10.5 .4-15.6 1.3C117.1 182.4 161.7 224 216 224l2 0c17.1 0 34-4.2 49.2-12.1l85.6-44.8C391.7 146.7 435 136 479 136l104.9 0c-.7-.4-1.5-.7-2.2-1l-61.1-26.7C502.2 100.2 482.3 96 462.2 96l-2.4 0zM32 224c0 43.2 28.5 79.8 67.8 91.8c8.3 2.6 13.1 11.3 10.7 19.7L99.2 374.9c-1.7 5.9-1.6 12.1 .1 18l13.1 43.7c2 6.8 8.3 11.4 15.3 11.4l21.2 0c10.7 0 18.4-10.3 15.3-20.6L156 399.7c-3.2-10.8-2.6-22.4 1.9-32.7l16-37.3c2.5-5.9 8.3-9.7 14.7-9.7l118.1 0c7.8 0 14.5 5.7 15.8 13.4l16.9 101.3c1.3 7.7 8 13.4 15.8 13.4l23.1 0c9.9 0 17.4-8.9 15.8-18.6L374.2 310.7c-1-5.8 1.3-11.6 5.9-15.2c42.5-33.4 112.3-71.5 187.8-78.4c11.5-1.1 21.7-5.3 28.7-12.4c7.2-7.2 11.3-17.1 11.3-27.3l0-2.2c0-2.4-.2-4.8-.6-7.2l-95.8 0c.3 1.3 .4 2.6 .4 4c0 11-9 20-20 20s-20-9-20-20c0-1.3 .1-2.6 .4-3.9c-36.5 1-72.3 10.3-104.8 27.3L282 240.2c-19.8 10.3-41.7 15.8-64 15.8l-2 0c-68.3 0-124.9-50.4-134.5-116C52 156.4 32 187.9 32 224zM75.7 340.9C58.9 333.3 44 322.3 32 308.7L32 320c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96C0 153.3 57.3 96 128 96l196.2 0c21 0 41.8-4.9 60.6-14.3C408.1 70.1 433.8 64 459.8 64l2.4 0c24.5 0 48.8 5.1 71.2 14.9l61.1 26.7C622.1 117.7 640 145 640 175.2l0 2.2c0 18.7-7.4 36.7-20.7 49.9c-12.1 12.1-27.6 18.7-43.3 21.1l0 23.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-19.1c-53.3 10.6-102.6 36.9-136.6 62.1l18.2 109.1c4.9 29.3-17.7 55.9-47.3 55.9l-23.1 0c-23.5 0-43.5-17-47.3-40.1L293.1 352l-94 0-11.8 27.6c-1.5 3.4-1.7 7.3-.6 10.9l8.3 27.7c9.2 30.8-13.8 61.8-46 61.8l-21.2 0c-21.2 0-39.9-13.9-46-34.2L68.7 402.1c-3.5-11.7-3.6-24.2-.2-36l7.2-25.2z'
      
    ]
  };

  

  
  

  var faHeadset = {
    prefix: 'fal',
    iconName: 'headset',
    icon: [
      512,
      512,
      [],
      'f590',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224l0 144.1c0 26.5-21.5 48-48 48l-82.7-.1c-6.6-18.6-24.4-32-45.3-32l-64 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l64 0c20.9 0 38.7-13.4 45.3-32l82.7 .1c44.2 0 80.1-35.8 80.1-80L512 256C512 114.6 397.4 0 256 0S0 114.6 0 256l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM320 464c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16zM144 224l16 0 0 128-16 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM64 272l0 32c0 44.2 35.8 80 80 80l16 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-16 0c-44.2 0-80 35.8-80 80zm288-48l16 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-16 0 0-128zm16-32l-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l16 0c44.2 0 80-35.8 80-80l0-32c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faColonSign = {
    prefix: 'fal',
    iconName: 'colon-sign',
    icon: [
      384,
      512,
      [],
      'e140',
      
      'M255.6 19.6c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9L212.2 64.6C111.6 72.5 32 154.9 32 256c0 70.8 39 132.4 96.9 165.7l-16.5 70.7c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l14.9-64.1c14.2 5.3 29.1 9 44.6 10.9l-10.7 45.9c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l12.1-51.8c41.1-1.6 79-15.5 109.8-38.2c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4c-23.6 17.3-52.2 28.6-83.3 31.4l69.2-296.5c4.9 2.9 9.6 6 14.1 9.3c7.1 5.2 17.1 3.7 22.4-3.4s3.7-17.1-3.4-22.4c-8-5.9-16.6-11.2-25.5-15.9l15.6-66.8c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9L290.1 73.8c-14.3-4.7-29.4-7.8-45-9.1l10.5-45.1zm-51.1 78l-68 291.2C92.7 360.1 64 311.2 64 256c0-80.3 60.8-147.3 140.5-158.4zM165.9 404.1L237.7 96.3c15.7 .9 30.9 4 45.1 8.9l-72.3 310c-15.6-1.6-30.6-5.4-44.6-11z'
      
    ]
  };

  

  
  

  var faUnlock = {
    prefix: 'fal',
    iconName: 'unlock',
    icon: [
      448,
      512,
      [128275],
      'f09c',
      
      'M128 128c0-53 43-96 96-96c43.5 0 80.2 28.9 92 68.6c2.5 8.5 11.4 13.3 19.9 10.8s13.3-11.4 10.8-19.9C331 38.6 282 0 224 0C153.3 0 96 57.3 96 128l0 64-16 0c-44.2 0-80 35.8-80 80L0 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80l-240 0 0-64zM32 272c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-160z'
      
    ]
  };

  

  
  

  var faSheep = {
    prefix: 'fal',
    iconName: 'sheep',
    icon: [
      640,
      512,
      [128017],
      'f711',
      
      'M544 136c0-39.8-32.2-72-72-72c-36.1 0-66 26.6-71.2 61.2l.1 .1-.1 .1c-.5 3.5-.8 7-.8 10.6l0 72c0 35.3 28.7 64 64 64l16 0c35.3 0 64-28.7 64-64l0-72zM372.5 105.8C385.4 63.1 425.1 32 472 32c44.4 0 82.2 27.8 97.2 66.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 141.9l0 66.1c0 53-43 96-96 96l-16 0c-53 0-96-43-96-96l0-60.8-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9zM448 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 344c9.9 0 18.8-4.5 24.7-11.6c10.1 2.4 20.5 3.6 31.3 3.6c1.1 0 2.2 0 3.4 0c-8.7 21.5-28.8 37.3-52.8 39.7l-25 100C392.2 497 373 512 351 512l-15 0c-26.5 0-48-21.5-48-48l0-40.6c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6l0 40.6c0 26.5-21.5 48-48 48l-15 0c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9C315.1 61.2 329 56 344 56c5.7 0 11.2 .7 16.5 2.1c-6.4 9.2-11.7 19.2-15.8 29.9l-.7 0c-7.6 0-14.4 2.6-19.9 6.9c-13.4 10.6-32.8 8.9-44-4c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3c-3.9 16.1-19.6 26.6-36 24c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8c3.5 14.2-3 29-16 36c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4c16.4-2.5 32 7.9 36 24c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9c13.4-10.6 32.8-8.9 44 4c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4c5.5 4.3 12.3 6.9 19.9 6.9c15 0 27.7-10.4 31.1-24.3c3.9-16.1 19.6-26.6 36-24c1.6 .2 3.2 .4 5 .4zm-72 80c-8.5 0-16.6-1.7-24-4.7l0 44.7c0 8.8 7.2 16 16 16l15 0c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zM131.7 412.7l13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1l15 0c8.8 0 16-7.2 16-16l0-44.7c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3z'
      
    ]
  };

  

  
  

  var faCitrusSlice = {
    prefix: 'fal',
    iconName: 'citrus-slice',
    icon: [
      512,
      512,
      [],
      'e2f5',
      
      'M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-400 400c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512l4 0C378.2 512 512 378.2 512 213.2l0-4c0-76.7-30.5-150.2-84.7-204.5zM278.8 175.8l89.4-89.4c21.5 25.2 36.9 55.9 43.7 89.7l-133 0-.2-.2zM295.6 208l120.3 0c.1 2.7 .2 5.3 .2 8c0 49.5-18 94.7-47.7 129.7l-82.5-82.5c10.7-16.5 14-36.5 9.8-55.2zm50.1 160.3C310.7 398 265.5 416 216 416c-2.7 0-5.3-.1-8-.2l0-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8zM176 412c-33.7-6.9-64.4-22.2-89.7-43.7L176 278.6 176 412zM448 216c0-58.3-21.5-111.6-57-152.3L415.6 39C457 85.8 480 146.3 480 209.1l0 4C480 360.5 360.5 480 213.2 480l-4 0C146.3 480 85.8 457 39 415.6L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232zM256.2 198.5c13.1 15.7 12.2 39.1-2.5 53.8s-38.1 15.6-53.8 2.5l56.3-56.3z'
      
    ]
  };

  

  
  

  var faPepperHot = {
    prefix: 'fal',
    iconName: 'pepper-hot',
    icon: [
      512,
      512,
      [127798],
      'f816',
      
      'M422.9 133.4l11.2 7.5 9.4 9.6C466.1 173.7 480 205.2 480 240c0 3-.1 5.9-.3 8.8C469.4 233.4 452 224 433.2 224L368 224l0-72c0-15.7-6.4-29.8-16.8-40l.8 0c26.3 0 50.6 7.9 70.9 21.4zM512 240c0-43.3-17.2-82.6-45.2-111.4l-.4-.4c1.5-3.3 2.9-6.6 4.2-10c9.4-25.6 10.6-53.8 2.7-80.5c-1.1-3.8-2.4-7.6-3.9-11.3l-6.5-16.3s0 0 0 0s0 0 0 0c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8c0 0 0 0 0 0l6.5 16.3c2.5 6.3 4.3 12.7 5.4 19.2c.9 5.1 1.4 10.3 1.4 15.5c.1 11.6-1.8 23.1-5.8 34c-9-6-18.6-11.1-28.7-15.2C393.5 84.1 373.2 80 352 80c-24.3 0-47.3 5.4-67.9 15.1c-19.3 9-10.5 32.9 10.8 32.9l17.1 0c13.3 0 24 10.7 24 24l0 80c0 13.3 10.7 24 24 24l73.2 0c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.8 .1c5.8-16.5 8.9-34.3 8.9-52.8zM261.7 160L172.4 305.7c-18.1 29.6-47.5 50.5-81.4 58.1l-35.4 7.9C23.1 378.9 0 407.7 0 441c0 39.2 31.8 71 71 71l32.1 0c141.1 0 269.1-68.1 348.9-176.2l-16.2-32.5C362.9 411.3 239.6 480 103.2 480L71 480c-21.6 0-39-17.5-39-39c0-18.3 12.7-34.1 30.6-38.1L97.9 395c42.3-9.4 79-35.6 101.7-72.6L299.2 160l-37.5 0z'
      
    ]
  };

  

  
  

  var faClockTwelve = {
    prefix: 'fal',
    iconName: 'clock-twelve',
    icon: [
      512,
      512,
      [],
      'e358',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faMicrophoneLines = {
    prefix: 'fal',
    iconName: 'microphone-lines',
    icon: [
      384,
      512,
      [127897,"microphone-alt"],
      'f3c9',
      
      'M256 160l0-32-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64s64-28.7 64-64l-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0zm32 16l0 64 0 16c0 53-43 96-96 96s-96-43-96-96L96 96c0-53 43-96 96-96s96 43 96 96l0 16 0 64zM48 192c8.8 0 16 7.2 16 16l0 48c0 70.7 57.3 128 128 128s128-57.3 128-128l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 83-63.1 151.2-144 159.2l0 64.8 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64.8C95.1 407.2 32 339 32 256l0-48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faMicrophoneAlt = faMicrophoneLines;
  

  
  

  var faSignalBarsWeak = {
    prefix: 'fal',
    iconName: 'signal-bars-weak',
    icon: [
      640,
      512,
      ["signal-alt-1"],
      'f691',
      
      'M96 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z'
      
    ]
  };

  
    var faSignalAlt1 = faSignalBarsWeak;
  

  
  

  var faCity = {
    prefix: 'fal',
    iconName: 'city',
    icon: [
      640,
      512,
      [127961],
      'f64f',
      
      'M96 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16 0 16-16 0L64 96c-17.7 0-32 14.3-32 32l0 320c0 17.7 14.3 32 32 32l133.5 0c4.2 11.9 10.7 22.8 19 32L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l0-48C64 7.2 71.2 0 80 0s16 7.2 16 16zM512 192c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32L288 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32l32 0 128 0 128 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0zm0-128l0 64 0 32 32 0 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-128 0-128 0-32 0c-35.3 0-64-28.7-64-64l0-384c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64zM320 392l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm32-8l32 0 0-32-32 0 0 32zM344 64l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zM320 264l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm32-8l32 0 0-32-32 0 0 32zM504 448c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0zm8-64l0 32 32 0 0-32-32 0zm-32-88l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm32-8l32 0 0-32-32 0 0 32zM88 352c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0zm8-64l0 32 32 0 0-32-32 0zM64 200l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm32-8l32 0 0-32-32 0 0 32z'
      
    ]
  };

  

  
  

  var faCodeFork = {
    prefix: 'fal',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4L96 192c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-33.6c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4l0 33.6c0 44.2-35.8 80-80 80l-64 0 0 81.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4l0-81.6-64 0c-44.2 0-80-35.8-80-80l0-33.6C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm64 304a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faHeartCirclePlus = {
    prefix: 'fal',
    iconName: 'heart-circle-plus',
    icon: [
      576,
      512,
      [],
      'e500',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFlatbread = {
    prefix: 'fal',
    iconName: 'flatbread',
    icon: [
      512,
      512,
      [129747],
      'e40b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm363.3-84.7l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBowlHot = {
    prefix: 'fal',
    iconName: 'bowl-hot',
    icon: [
      512,
      512,
      ["soup"],
      'f823',
      
      'M144 0c8.8 0 16 7.2 16 16l0 16c0 20.1 9.5 39.1 25.6 51.2C209.8 101.3 224 129.8 224 160l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-20.1-9.5-39.1-25.6-51.2C142.2 90.7 128 62.2 128 32l0-16c0-8.8 7.2-16 16-16zm.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4c3.3 9.4 12.2 16.1 22.7 16.1l144 0c10.4 0 19.4-6.7 22.7-16.1c2.8-8.1 8.7-14.7 16.5-18.4c61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9L50.9 256c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.2 23.3 224 50.9 224l410.2 0c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-4.9 84.1-55.9 155.1-127.5 189.2C373.3 496.3 352.5 512 328 512l-144 0c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8zM288 16l0 16c0 20.1 9.5 39.1 25.6 51.2C337.8 101.3 352 129.8 352 160l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-20.1-9.5-39.1-25.6-51.2C270.2 90.7 256 62.2 256 32l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faSoup = faBowlHot;
  

  
  

  var faCandy = {
    prefix: 'fal',
    iconName: 'candy',
    icon: [
      640,
      512,
      [127852],
      'e3e7',
      
      'M376.9 405.6C359.2 412.3 340 416 320 416c-4.9 0-9.7-.2-14.4-.6L183.8 171.9c12.8-20.7 30.1-38.2 50.6-51.2L376.9 405.6zm28.6-14.3L263.1 106.4C280.8 99.7 300 96 320 96c4.9 0 9.7 .2 14.4 .6L456.2 340.1c-12.8 20.7-30.1 38.2-50.6 51.2zm-14.2 43.1s0 0 0 0c10-4 19.5-8.8 28.6-14.3c0 0 0 0 0 0c40.9-24.9 71.7-64.7 84.9-111.8l91.9 49c10.5 5.6 23.5 2.7 30.6-6.9c9.1-12.3 3.8-24.5-5.3-35.4c-5.4-6.4-12-12.3-17.9-17.5c0 0 0 0 0 0c-3.2-2.9-6.3-5.6-8.7-8c2.8-1 5.8-2 9-3c8.3-2.7 17.6-5.7 24.6-10.5c6.5-4.5 11.1-10.7 11.1-19.8s-4.6-15.3-11.1-19.8c-7-4.9-16.2-7.8-24.6-10.5c-3.2-1-6.3-2-9-3c2.4-2.4 5.4-5.1 8.7-8c5.9-5.2 12.6-11.2 17.9-17.5c9.2-10.9 14.4-23.1 5.3-35.4c-7.1-9.6-20.1-12.5-30.6-6.9l-91.9 49C485.2 134.3 427.4 80.7 355.5 67.3c0 0 0 0 0 0C344 65.1 332.2 64 320.1 64c0 0 0 0-.1 0c-25.2 0-49.2 4.8-71.3 13.7c0 0 0 0 0 0c-10 4-19.6 8.8-28.6 14.3c0 0 0 0 0 0c-40.9 24.9-71.7 64.7-84.9 111.8l-91.9-49c-10.5-5.6-23.5-2.7-30.6 6.9c-9.1 12.3-3.8 24.5 5.3 35.4c5.4 6.4 12 12.3 17.9 17.5c0 0 0 0 0 0c3.2 2.9 6.3 5.6 8.7 8c-2.8 1-5.8 2-9 3c0 0 0 0 0 0c-8.3 2.7-17.6 5.7-24.6 10.5C4.6 240.7 0 246.9 0 256s4.6 15.3 11.1 19.8c7 4.9 16.2 7.8 24.6 10.5c3.2 1 6.3 2 9 3c-2.4 2.4-5.4 5.1-8.7 8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-5.9 5.2-12.6 11.2-17.9 17.5C8.9 325.8 3.6 338 12.7 350.3c7.1 9.6 20.1 12.5 30.6 6.9l91.9-49c19.6 69.5 77.4 123.1 149.3 136.5c0 0 0 0 0 0c12.1 2.3 24.6 3.4 37.4 3.3c0 0 0 0 0 0c24.5-.2 47.9-5.1 69.4-13.7zm-126-27.9C203.9 384.1 160 325.2 160 256c0-16.2 2.4-31.8 6.9-46.5l98.5 196.9zM374.7 105.6C436.1 127.9 480 186.8 480 256c0 16.2-2.4 31.8-6.9 46.5L374.7 105.6zM512 256c0-6.3-.3-12.4-.9-18.5l54.9-29.3c-3.2 6.5-4.2 14-2.6 21.4c2.3 10.8 10 19.8 20.4 23.7c2.8 1.1 5.6 2 8.1 2.8l.1 0-.1 0c-2.4 .8-5.3 1.7-8.1 2.8c-10.4 3.9-18.1 12.8-20.4 23.7c-1.6 7.3-.6 14.8 2.6 21.4l-54.9-29.3c.6-6.1 .9-12.3 .9-18.5zM128.9 237.5c-.6 6.1-.9 12.3-.9 18.5s.3 12.4 .9 18.5L73.9 303.8c3.2-6.5 4.2-14 2.6-21.4c-2.3-10.8-10-19.8-20.4-23.7c-2.8-1.1-5.6-2-8.1-2.8l-.1 0 .1 0c2.4-.8 5.3-1.7 8.1-2.8c10.4-3.9 18.1-12.8 20.4-23.7c1.6-7.3 .6-14.8-2.6-21.4l54.9 29.3z'
      
    ]
  };

  

  
  

  var faAlbumCollectionCircleUser = {
    prefix: 'fal',
    iconName: 'album-collection-circle-user',
    icon: [
      640,
      512,
      [],
      'e48f',
      
      'M32 16c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 0C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 64c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512l310.3 0c-12.9-9.1-24.5-19.9-34.6-32L84.5 480c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272C34.6 172.1 45.7 160 59.8 160l392.4 0c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2c3.9 0 7.8 .1 11.7 .4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1L59.8 128zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4c-3.9-9.9-6.9-20.2-9-30.8C304.4 410.6 281.7 416 256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9c6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20zM556 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6l56.4 0c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8l-56.4 0c-21.8 0-42.2 9.6-56.1 25.8C394.5 422.1 384 396.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faFolderOpen = {
    prefix: 'fal',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717,128194,128449],
      'f07c',
      
      'M448 160l0 32 32 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 80 0c19.6 0 37.3-11.9 44.6-30.2l64-160c5.9-14.8 4.1-31.5-4.8-44.7S543.9 224 528 224l-400 0c-19.6 0-37.3 11.9-44.6 30.2L32 382.8 32 96c0-17.7 14.3-32 32-32l117.5 0c8.5 0 16.6 3.4 22.6 9.4l22.6-22.6L204.1 73.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1L416 128c17.7 0 32 14.3 32 32zM384 448L64 448c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c2.4-6.1 8.3-10.1 14.9-10.1l400 0c5.3 0 10.3 2.6 13.2 7s3.6 10 1.6 14.9l-64 160C476.4 444 470.5 448 464 448l-80 0z'
      
    ]
  };

  

  
  

  var faFaceLaugh = {
    prefix: 'fal',
    iconName: 'face-laugh',
    icon: [
      512,
      512,
      ["laugh"],
      'f599',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80l-231.4 0c18.6 47.2 63.7 80 115.7 80zM126.5 288l259.1 0c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faLaugh = faFaceLaugh;
  

  
  

  var faChartPieSimple = {
    prefix: 'fal',
    iconName: 'chart-pie-simple',
    icon: [
      512,
      512,
      ["chart-pie-alt"],
      'f64e',
      
      'M256 17.7l0 9.4L256 240c0 8.8 7.2 16 16 16l222.3 0c9.6 0 17.7-7.4 17.7-17.1C512 107 405 0 273.1 0C263.4 0 256 8.1 256 17.7zm32 14.8C390.4 39.8 472.2 121.6 479.5 224L288 224l0-191.5zM192 288c0 17.7 14.3 32 32 32l218.4 0C420.8 411.7 338.3 480 240 480C125.1 480 32 386.9 32 272c0-98.3 68.3-180.8 160-202.4L192 288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8L256 288l-32 0 0-32 0-189.3z'
      
    ]
  };

  
    var faChartPieAlt = faChartPieSimple;
  

  
  

  var faShirtLongSleeve = {
    prefix: 'fal',
    iconName: 'shirt-long-sleeve',
    icon: [
      640,
      512,
      [],
      'e3c7',
      
      'M110.3 73.4C124.3 47.9 151.2 32 180.4 32L192 32l4 0 28.3 0c4.1 49.3 45.3 88 95.7 88s91.6-38.7 95.7-88L444 32l4 0 11.6 0c29.2 0 56 15.9 70.1 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3L608 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-127.6c0-5.4-1.4-10.7-4-15.4L481.2 118c-1.4-2.6-3.1-5.1-5-7.3c-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15L448 456c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-334.8c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4L96 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-127.6c0-16.2 4.1-32.1 11.9-46.3L110.3 73.4zM180.4 0c-40.8 0-78.5 22.2-98.1 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4L0 368c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-127.6 32-58.2L160 456c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-273.7 32 58.2L512 368c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-127.6c0-21.6-5.4-42.8-15.8-61.7L557.8 58C538.1 22.2 500.5 0 459.6 0L448 0l-4 0L407.6 0c-1.5 0-2.9 .1-4.2 .4c-1.1-.2-2.2-.4-3.4-.4L240 0c-1.2 0-2.3 .1-3.4 .4c-1.3-.2-2.8-.4-4.2-.4L196 0l-4 0L180.4 0zm76.1 32l127 0c-3.9 31.6-30.9 56-63.5 56s-59.6-24.4-63.5-56z'
      
    ]
  };

  

  
  

  var faShuttleSpace = {
    prefix: 'fal',
    iconName: 'shuttle-space',
    icon: [
      640,
      512,
      ["space-shuttle"],
      'f197',
      
      'M245.2 448.1L405.3 352l58.7 0c64.7 0 123.5-27.4 164.8-76.3c9.6-11.4 9.6-28 0-39.4C587.5 187.4 528.7 160 464 160l-58.7 0L245.2 63.9C210.4 43 170.6 32 130 32L80 32C53.5 32 32 53.5 32 80l0 48c-17.7 0-32 14.3-32 32L0 352c0 17.7 14.3 32 32 32l0 48c0 26.5 21.5 48 48 48l50 0c40.6 0 80.4-11 115.2-31.9zM64 384l48 0c5.5 0 10.8-.6 16-1.6l0 65.6-48 0c-8.8 0-16-7.2-16-16l0-48zm164.7 36.6c-21.2 12.7-44.5 21.2-68.7 25l0-77.6c5.5-4.2 10.5-9 14.8-14.5c.6-.7 1.2-1.2 1.6-1.4c.2-.1 .3-.1 .3-.1l166.4 0L228.7 420.6zM64 352l-32 0 0-80 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 240l0-80 32 0 48 0c15.3 0 28.9 7.1 37.7 18.3c5.8 7.3 15.2 13.7 27 13.7L464 192c54.9 0 104.4 22.9 139.5 64c-35.1 41.1-84.6 64-139.5 64l-287.3 0c-11.8 0-21.2 6.4-27 13.7C140.9 344.9 127.3 352 112 352l-48 0zm0-224l0-48c0-8.8 7.2-16 16-16l48 0 0 65.6c-5.2-1.1-10.5-1.6-16-1.6l-48 0zm110.8 30.5c-4.3-5.4-9.3-10.3-14.8-14.5l0-77.6c24.2 3.8 47.6 12.3 68.7 25L343.1 160l-166.4 0c0 0-.2 0-.3-.1c-.4-.2-1-.7-1.6-1.4zM464 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faSpaceShuttle = faShuttleSpace;
  

  
  

  var faHouseDay = {
    prefix: 'fal',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M192 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zM276.7 52.7l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9 224 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-164.1 37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5L544 448c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-191.5L400 133.1 544 256.5zM336 304l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm96 0l0 64-64 0 0-64 64 0zM144 176c0-17.7 14.3-32 32-32c13.9 0 25.8 8.9 30.2 21.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C227.6 129.8 203.9 112 176 112c-35.3 0-64 28.7-64 64c0 27.9 17.8 51.6 42.7 60.4c8.3 2.9 17.5-1.4 20.4-9.8s-1.4-17.5-9.8-20.4C152.9 201.8 144 189.9 144 176zm-36.7 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faBedPulse = {
    prefix: 'fal',
    iconName: 'bed-pulse',
    icon: [
      640,
      512,
      ["procedures"],
      'f487',
      
      'M478.3 8.8L505.9 64 624 64c8.8 0 16 7.2 16 16s-7.2 16-16 16L496 96c-6.1 0-11.6-3.4-14.3-8.8L465.6 55 414.9 181.9c-2.3 5.9-7.9 9.8-14.2 10s-12.2-3.2-15-8.8L342.1 96 208 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l144 0c6.1 0 11.6 3.4 14.3 8.8L398.4 137 449.1 10.1c2.3-5.9 7.9-9.8 14.2-10s12.2 3.2 15 8.8zM304 160l34.3 0 16 32L304 192c-8.8 0-16 7.2-16 16l0 144 320 0 0-80c0-44.2-35.8-80-80-80l-82.7 0 12.8-32 69.9 0c61.9 0 112 50.1 112 112l0 96 0 64 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 448l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64L0 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 272 224 0 0-144c0-26.5 21.5-48 48-48zM608 416l0-32-336 0L32 384l0 32 576 0zM192 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 240a80 80 0 1 1 160 0A80 80 0 1 1 64 240z'
      
    ]
  };

  
    var faProcedures = faBedPulse;
  

  
  

  var faFire = {
    prefix: 'fal',
    iconName: 'fire',
    icon: [
      448,
      512,
      [128293],
      'f06d',
      
      'M239.7 109.4c6.1 7.7 15.5 12.1 25.3 12s19.1-4.7 25.1-12.5c8.4-11 16.9-21.7 25.6-31.1c27.8 28.8 52.1 65.5 69.8 101.1c19.6 39.4 30.5 75.7 30.5 97.6C416 388.3 328.8 480 224 480C118 480 32 388.4 32 276.5c0-29.9 14.4-70.8 40.9-115.4c24.7-41.6 59.3-85.3 100.2-124.7c23.5 22.7 45.7 47 66.6 73zm25-20c-6.9-8.6-13.9-17-21-25.2C225.6 43.6 206.7 24 187 5.5c-7.8-7.3-19.9-7.3-27.7-.1c-46.5 43.2-86 92.3-113.9 139.3C17.8 191.2 0 238.1 0 276.5C0 404.1 98.4 512 224 512c124.2 0 224-107.8 224-235.5c0-29.3-13.5-71.1-33.8-111.9c-20.7-41.4-49.9-85-84.5-118c-7.8-7.5-20.1-7.5-28-.1c-5.7 5.4-11.2 11.3-16.5 17.4c-7.3 8.4-14.2 17.2-20.5 25.5zM128 306.8c0-23.7 13-46.3 47.1-89.1c16.8 21.3 46.2 58.7 62.6 79.6c12.5 15.9 36.3 16.3 49.4 1l23.4-27.2c17.8 38.8 9.4 86.6-24.9 110.7C267.1 394 247.7 400 225.7 400c-28.2 0-52.6-9-69.8-24.7c-17-15.5-28-38.4-28-68.5zm72-109.2c-12.7-16.1-37-16.2-49.8-.1C116.8 239.4 96 270.3 96 306.8c0 38.5 14.3 70.2 38.4 92.1c23.9 21.8 56.4 33.1 91.3 33.1c28.5 0 54.1-8 77.7-23.7c0 0 0 0 0 0l.3-.2c51.2-35.7 59.1-104.2 33.9-154.6c-10.7-21.4-37.3-19.7-49.9-5.1l-24.9 29s0 0 0 0c-16.5-21-46-58.5-62.8-79.8z'
      
    ]
  };

  

  
  

  var faStars = {
    prefix: 'fal',
    iconName: 'stars',
    icon: [
      512,
      512,
      [],
      'f762',
      
      'M352 16l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCircleZ = {
    prefix: 'fal',
    iconName: 'circle-z',
    icon: [
      512,
      512,
      [],
      'e130',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l128.9 0L163 358.7c-3.5 4.9-3.9 11.3-1.2 16.6s8.2 8.7 14.2 8.7l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128.9 0L349 153.3c3.5-4.9 3.9-11.3 1.2-16.6s-8.2-8.7-14.2-8.7l-160 0z'
      
    ]
  };

  

  
  

  var faDownToBracket = {
    prefix: 'fal',
    iconName: 'down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e4e7',
      
      'M222.2 319.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 187.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L288 176c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 319.2zM224 352c-9.5 0-18.6-3.9-25.1-10.8L74.5 209.2C67.8 202 64 192.5 64 182.7c0-21.4 17.3-38.7 38.7-38.7l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 341.2c-6.5 6.9-15.6 10.8-25.1 10.8zM32 336l0 96c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSignalStream = {
    prefix: 'fal',
    iconName: 'signal-stream',
    icon: [
      576,
      512,
      [],
      'f8dd',
      
      'M90.3 68.5c6.8 5.7 7.6 15.8 1.9 22.5C54.6 135.6 32 193.1 32 256s22.6 120.4 60.2 165c5.7 6.8 4.8 16.8-1.9 22.5s-16.8 4.8-22.5-1.9C25.5 391.5 0 326.7 0 256S25.5 120.5 67.8 70.4c5.7-6.8 15.8-7.6 22.5-1.9zm395.4 0c6.8-5.7 16.8-4.8 22.5 1.9C550.5 120.5 576 185.3 576 256s-25.5 135.5-67.8 185.6c-5.7 6.8-15.8 7.6-22.5 1.9s-7.6-15.8-1.9-22.5C521.4 376.4 544 318.9 544 256s-22.6-120.4-60.2-165c-5.7-6.8-4.8-16.8 1.9-22.5zM224 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM164.6 154.2C141.7 181.9 128 217.3 128 256s13.7 74.1 36.6 101.8c5.6 6.8 4.7 16.9-2.1 22.5s-16.9 4.7-22.5-2.1C112.5 345 96 302.4 96 256s16.5-89 43.9-122.2c5.6-6.8 15.7-7.8 22.5-2.1s7.8 15.7 2.1 22.5zm271.5-20.4C463.5 167 480 209.6 480 256s-16.5 89-43.9 122.2c-5.6 6.8-15.7 7.8-22.5 2.1s-7.8-15.7-2.1-22.5C434.3 330.1 448 294.7 448 256s-13.7-74.1-36.6-101.8c-5.6-6.8-4.7-16.9 2.1-22.5s16.9-4.7 22.5 2.1z'
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fal',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      'M48 32c8.8 0 16 7.2 16 16l0 400 240 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16L32 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPersonWalking = {
    prefix: 'fal',
    iconName: 'person-walking',
    icon: [
      320,
      512,
      [128694,"walking"],
      'f554',
      
      'M200 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 200 0zM121.5 170.2c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.4 9.6c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4l2.4-9.5c9.8-39 35.4-72.2 70.7-91.5l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L187.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L209.9 393 109.4 305.8C94.9 293.3 89.3 273.4 95 255.2l26.6-85zm36.6-9.9L125.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3zM126.3 375.2L95.5 436.8c-1.5 3.1-3.6 5.9-6 8.3L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z'
      
    ]
  };

  
    var faWalking = faPersonWalking;
  

  
  

  var faRectangleVertical = {
    prefix: 'fal',
    iconName: 'rectangle-vertical',
    icon: [
      384,
      512,
      ["rectangle-portrait"],
      'f2fb',
      
      'M352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384z'
      
    ]
  };

  
    var faRectanglePortrait = faRectangleVertical;
  

  
  

  var faToggleOn = {
    prefix: 'fal',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      'M160 128C89.3 128 32 185.3 32 256s57.3 128 128 128l256 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-256 0zM0 256C0 167.6 71.6 96 160 96l256 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-256 0C71.6 416 0 344.4 0 256zm480 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fal',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 212.7l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 166.6 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-201.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faBedEmpty = {
    prefix: 'fal',
    iconName: 'bed-empty',
    icon: [
      640,
      512,
      [128719],
      'f8f9',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 208 0 336l0 64 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 576 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-64 0-32c0-61.9-50.1-112-112-112L32 192 32 48zM608 320L32 320l0-96 496 0c44.2 0 80 35.8 80 80l0 16zM32 352l576 0 0 32L32 384l0-32z'
      
    ]
  };

  

  
  

  var faPianoKeyboard = {
    prefix: 'fal',
    iconName: 'piano-keyboard',
    icon: [
      576,
      512,
      [127929],
      'f8d5',
      
      'M448 224l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 32 0zM416 333.3l0 82.7-112 0 0-82.7c18.6-6.6 32-24.4 32-45.3l0-64 48 0 0 64c0 20.9 13.4 38.7 32 45.3zM448 416l0-82.7c18.6-6.6 32-24.4 32-45.3l0-64 64 0 0 160c0 17.7-14.3 32-32 32l-64 0zm-16 32l80 0c35.3 0 64-28.7 64-64l0-160 0-16 0-16 0-64c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128l0 64 0 16 0 16L0 384c0 35.3 28.7 64 64 64l80 0 144 0 144 0zM272 416l-112 0 0-82.7c18.6-6.6 32-24.4 32-45.3l0-64 48 0 0 64c0 20.9 13.4 38.7 32 45.3l0 82.7zm-144 0l-64 0c-17.7 0-32-14.3-32-32l0-160 64 0 0 64c0 20.9 13.4 38.7 32 45.3l0 82.7zm16-112c-8.8 0-16-7.2-16-16l0-64 32 0 0 64c0 8.8-7.2 16-16 16zm144 0c-8.8 0-16-7.2-16-16l0-64 32 0 0 64c0 8.8-7.2 16-16 16zM464 192l-64 0-80 0-64 0-80 0-64 0-80 0 0-64c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32l0 64-80 0z'
      
    ]
  };

  

  
  

  var faUserPilotTie = {
    prefix: 'fal',
    iconName: 'user-pilot-tie',
    icon: [
      448,
      512,
      [],
      'e2c1',
      
      'M230.9 .8l144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2L368 109.3l0 1.6c0 15.6-7.6 31.8-23.2 40.1c-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9l0-1.6L57.4 86.6C49.1 78.4 46 66.3 49.3 55.1s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3l0 8.2c0 5.8 2.8 10 6.2 11.8C135.8 132 167.6 144 224 144s88.2-12 105.8-21.3c3.4-1.8 6.2-6 6.2-11.8l0-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-6.1 0 18.4 36.9 51.6-68.7C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6L240 512l-32 0L25.6 512C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7L198.1 384l-6.1 0c-8.8 0-16-7.2-16-16zm48 35.8l-22.9 45.7 2.9 3.8L224 480s0 0 0 0s0 0 0 0l20-26.7 2.9-3.8L224 403.8zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480L184 480zm80 0l151.8 0c-2.9-46.6-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9 .1-5.8 .3-8.7c9.1 4.3 19.6 8.5 31.8 12.1c1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zM183.2 65.7L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z'
      
    ]
  };

  

  
  

  var faWheelchair = {
    prefix: 'fal',
    iconName: 'wheelchair',
    icon: [
      512,
      512,
      [],
      'f193',
      
      'M176 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 176 0a56 56 0 1 0 0 112zm-32.4 96c-2-8.6-10.5-14-19.1-12.1C53.2 212.1 0 275.8 0 352c0 88.4 71.6 160 160 160c69.7 0 128.9-44.5 150.9-106.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8C263.1 444.4 215.7 480 160 480C89.3 480 32 422.7 32 352c0-60.9 42.5-111.9 99.5-124.8c8.6-2 14-10.5 12.1-19.1zm56-51.6c-2-8.6-10.5-14-19.1-12.1s-14 10.5-12.1 19.1l34.3 151.1c5 21.9 24.4 37.4 46.8 37.4l108.6 0 59.6 119.2c1.9 3.8 5.2 6.7 9.3 8s8.4 1 12.2-.9l64-32c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-49.7 24.8L386.7 337.7c-5.4-10.8-16.5-17.7-28.6-17.7l-108.6 0c-7.5 0-13.9-5.2-15.6-12.5L215 224l137 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144.3 0-8.1-35.5z'
      
    ]
  };

  

  
  

  var faTriangleInstrument = {
    prefix: 'fal',
    iconName: 'triangle-instrument',
    icon: [
      576,
      512,
      ["triangle-music"],
      'f8e2',
      
      'M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 49.4c-24.6 4.4-46.5 19-60.1 40.5L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94L450 512c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L443.8 232.1l-23.2 23.2 81.8 129.5c6.3 9.9 9.6 21.4 9.6 33.1c0 34.3-27.8 62-62 62L126 480c-34.3 0-62-27.8-62-62c0-11.7 3.3-23.2 9.6-33.1L238.9 123.1C249.5 106.2 268.1 96 288 96s38.5 10.2 49.1 27.1l48.5 76.8-65.1 65.1c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l59.9-59.9 23.2-23.2 113-113c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L408.8 176.6 364.1 106C350.5 84.4 328.6 69.9 304 65.4L304 16zm16 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  
    var faTriangleMusic = faTriangleInstrument;
  

  
  

  var faCommentPlus = {
    prefix: 'fal',
    iconName: 'comment-plus',
    icon: [
      512,
      512,
      [],
      'f4b2',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM240 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  

  
  

  var faSquareChevronDown = {
    prefix: 'fal',
    iconName: 'square-chevron-down',
    icon: [
      448,
      512,
      ["chevron-square-down"],
      'f329',
      
      'M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM212.7 347.3l-112-112c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 313.4 324.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0z'
      
    ]
  };

  
    var faChevronSquareDown = faSquareChevronDown;
  

  
  

  var faObjectsColumn = {
    prefix: 'fal',
    iconName: 'objects-column',
    icon: [
      448,
      512,
      [],
      'e3c1',
      
      'M48 64c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L48 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM304 256c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-96 0zm-48 16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-160zM144 352l-96 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM48 320l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-96 0zM256 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64z'
      
    ]
  };

  

  
  

  var faViolin = {
    prefix: 'fal',
    iconName: 'violin',
    icon: [
      640,
      512,
      [127931],
      'f8ed',
      
      'M347.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-320 320c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l320-320zm288 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L452.5 164.9c-53.3-45.5-111.2-44.7-152-19C290.6 152 288 164.4 288 176c0 35.3-28.7 64-64 64c-5.2 0-10.2-.6-15.1-1.8c-14.1-3.4-30.2-4-39.8 6.7C143.5 273.3 128 310.8 128 352c0 22.4 4.6 43.7 12.9 63.1l-1.4 .9c-7.2 4.4-11.5 12.2-11.5 20.6c0 6.4 2.6 12.6 7.1 17.1l51.2 51.2c4.5 4.5 10.7 7.1 17.1 7.1c8.4 0 16.2-4.4 20.6-11.5l.9-1.4c19.4 8.3 40.7 12.9 63.1 12.9c41.2 0 78.7-15.5 107-41.1c10.7-9.7 10.1-25.8 6.7-39.8c-1.2-4.8-1.8-9.9-1.8-15.1c0-35.3 28.7-64 64-64c11.6 0 24-2.6 30.1-12.4c25.7-40.9 26.5-98.7-19-152L635.3 27.3zM429.8 187.6L324.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L452.4 210.2c34.2 41.3 32.2 81.8 16.4 109.4l-.4 .1c-1.2 .2-2.6 .3-4.4 .3c-53 0-96 43-96 96c0 7.7 .9 15.3 2.7 22.6c.6 2.4 1 4.6 1.2 6.5c.2 1.6 .2 2.7 .1 3.6C349.5 468.2 320.1 480 288 480c-16.3 0-31.8-3-46.1-8.6l40.4-65.7c5.8-9.5 4.4-21.7-3.5-29.5l-15.1-15.1c-7.9-7.9-20.1-9.3-29.5-3.5l-65.7 40.4C163 383.8 160 368.3 160 352c0-32.1 11.8-61.5 31.4-83.9c.8-.1 2 0 3.6 .1c1.9 .2 4.1 .6 6.5 1.2c7.3 1.8 14.8 2.7 22.6 2.7c53 0 96-43 96-96c0-1.7 .1-3.2 .3-4.4l.1-.4c27.6-15.8 68.1-17.9 109.4 16.4zM496 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM544 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM245.6 388.2l6.1 6.1-49.8 80.9-37.3-37.3 80.9-49.8z'
      
    ]
  };

  

  
  

  var faBurrito = {
    prefix: 'fal',
    iconName: 'burrito',
    icon: [
      512,
      512,
      [127791],
      'f7ed',
      
      'M242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 38-26.5 69.8-62 78L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L33.9 433.9C12.2 412.2 0 382.7 0 352s12.2-60.2 33.9-81.9L242 62zm44-15.9C307.5 78.8 320 117.9 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c42.1 0 81.2 12.5 113.9 33.9c8.7-8.7 14.1-20.7 14.1-34c0-8.8-2.3-16.9-6.4-24c-2.9-5-2.9-11.1 0-16c4.1-7 6.4-15.2 6.4-24c0-22.8-15.9-41.9-37.2-46.8c-6-1.4-10.6-6-12-12C425.9 47.9 406.8 32 384 32c-8.8 0-16.9 2.3-24 6.4c-5 2.9-11.1 2.9-16 0c-7-4.1-15.2-6.4-24-6.4c-13.3 0-25.3 5.4-33.9 14.1zM56.6 411.3l44.1 44.1C116.4 471.2 137.8 480 160 480s43.6-8.8 59.3-24.6L431.7 243c-23.9-12.2-51-19-79.7-19c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-28.3 0-55.4-5.7-80-15.9c0 22.2 8.9 43.5 24.6 59.3zm0-118.6c-7.9 7.9-14 17.1-18.2 27.2C60.8 330.2 85.7 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-28.7-6.9-55.8-19-79.7L56.6 292.7z'
      
    ]
  };

  

  
  

  var faCommentMinus = {
    prefix: 'fal',
    iconName: 'comment-minus',
    icon: [
      512,
      512,
      [],
      'f4b1',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM160 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  

  
  

  var faBinaryCircleCheck = {
    prefix: 'fal',
    iconName: 'binary-circle-check',
    icon: [
      640,
      512,
      [],
      'e33c',
      
      'M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L288 192l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L64 480l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM0 80l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80L80 0C35.8 0 0 35.8 0 80zM80 32l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80l0 64c0 44.2 35.8 80 80 80l32 0c24 0 45.6-10.6 60.2-27.3c-7.4-8.3-14-17.3-19.7-27C336 471.1 321.1 480 304 480l-32 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l32 0c7.6 0 14.9 1.8 21.3 5c2.6-10.5 6.2-20.7 10.7-30.3c-9.8-4.3-20.6-6.6-32-6.6l-32 0zm224-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faPanelFire = {
    prefix: 'fal',
    iconName: 'panel-fire',
    icon: [
      640,
      512,
      [],
      'e42f',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l250.4 0c6.6 11.4 14.4 22.2 23.2 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 32.2c-11.1-1-22.6 1.9-32 8.8l0-41c0-17.7-14.3-32-32-32zM327.2 239.5c-2.3 .4-4.7 .5-7.2 .5l-192 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l192 0c26.5 0 48 21.5 48 48l0 24.9c-15.5 17.9-29.3 36.3-40.8 54.5zM112 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM112 160l0 32c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zm335.1 32.9c-21.7 19.8-45.3 44.8-63.7 72.3c-19 28.5-31.4 58.3-31.4 86.7c0 33.7 12.7 64.2 33.6 87c-1.1-5.4-1.6-10.9-1.6-16.6c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0C512.2 311.9 576 365 576 422.4c0 5.5-.5 10.9-1.6 16.2C595.3 415.9 608 385.5 608 352c0-22.6-8.5-48-22.2-72.6c-13-23.4-30.1-44.9-46.7-60.7l-21 23.7c-3 3.3-7.2 5.3-11.7 5.4s-8.8-1.7-11.9-5l-47.4-49.8zM480 479.9c2.4 0 4.8-.1 7.1-.2c33.7-3.3 56.9-29.4 56.9-57.3c0-17.4-10.1-37.7-27.4-58.5c-12.1-14.5-25.8-27-36.6-35.8c-10.7 8.8-24.5 21.3-36.6 35.8C426.1 384.7 416 405 416 422.4c0 27.9 23.3 54 57 57.3c2.3 .1 4.7 .2 7 .2zM320 352c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c11.1-10.1 28.2-10 39.3 .1c.3 .3 .6 .5 .8 .8l37.9 39.9L518 194.3c.4-.4 .7-.8 1.1-1.2c11.2-10.3 28.5-10.3 39.7 .1c19.7 18.3 39.8 43.2 55 70.6C629 291.1 640 322 640 352c0 85.6-66.4 154.9-150.8 159.6c-3 .3-6.1 .4-9.2 .4c-3.1 0-6.1-.1-9.1-.4C385.7 507 320 437.6 320 352z'
      
    ]
  };

  

  
  

  var faBoltSlash = {
    prefix: 'fal',
    iconName: 'bolt-slash',
    icon: [
      640,
      512,
      [],
      'e0b8',
      
      'M351.4 362.3L236.6 463.6 290 313.9 263.5 293 197.2 478.7c-5.8 16.2 6.2 33.3 23.5 33.3c6.1 0 11.9-2.2 16.5-6.2L376.9 382.4l-25.5-20.2zM216.7 256l-46.6 0L192 236.5l-25.5-20.1-29.8 26.5c-5.5 4.9-8.7 11.9-8.7 19.3c0 14.3 11.6 25.8 25.8 25.8l103.4 0-40.5-32zm72.5-105.9L403.3 48.7 350 198.1 376.5 219 442.8 33.3C448.6 17.1 436.6 0 419.4 0c-6.1 0-12 2.2-16.5 6.3L263.7 130l25.5 20.1zM485 224l-102.2 0 40.5 32 48.5 0-22.9 20.2 25.5 20.2 28.4-25.1c5.8-5.1 9.1-12.5 9.1-20.3c0-14.9-12.1-27-27-27zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faCodeSimple = {
    prefix: 'fal',
    iconName: 'code-simple',
    icon: [
      576,
      512,
      [],
      'e13d',
      
      'M203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256 203.3 91.3zm169.4 0L537.4 256 372.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faFaceLaughSquint = {
    prefix: 'fal',
    iconName: 'face-laugh-squint',
    icon: [
      512,
      512,
      ["laugh-squint"],
      'f59b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80l-231.4 0c18.6 47.2 63.7 80 115.7 80zM126.5 288l259.1 0c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm2.9-135.2c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 192l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 192l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z'
      
    ]
  };

  
    var faLaughSquint = faFaceLaughSquint;
  

  
  

  var faPalletBoxes = {
    prefix: 'fal',
    iconName: 'pallet-boxes',
    icon: [
      640,
      512,
      [57863,"palette-boxes","pallet-alt"],
      'f483',
      
      'M304 32L112 32c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM112 0L304 0c26.5 0 48 21.5 48 48l0 192c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0zM528 128l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM432 96l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM0 368c0-8.8 7.2-16 16-16l64 0 240 0 240 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 96 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0-240 0L80 512l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-96-48 0c-8.8 0-16-7.2-16-16zM96 480l208 0 0-96L96 384l0 96zm240 0l208 0 0-96-208 0 0 96z'
      
    ]
  };

  
    var faPaletteBoxes = faPalletBoxes;
  
    var faPalletAlt = faPalletBoxes;
  

  
  

  var faBarsSort = {
    prefix: 'fal',
    iconName: 'bars-sort',
    icon: [
      448,
      512,
      [],
      'e0ae',
      
      'M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 256c-8.8 0-16-7.2-16-16zM192 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faChessKnight = {
    prefix: 'fal',
    iconName: 'chess-knight',
    icon: [
      448,
      512,
      [9822],
      'f441',
      
      'M96 35.8c0-2.1 1.7-3.8 3.8-3.8l130.8 0C315.3 32 384 100.7 384 185.4c0 8.8-.8 17.6-2.3 26.3L357.3 352l32.5 0 23.5-134.9c1.8-10.5 2.7-21.1 2.7-31.8C416 83 333 0 230.6 0L99.8 0C80 0 64 16 64 35.8c0 13.6 7.7 25.9 19.8 32l1.3 .6c-13.5 14.7-21.1 33.9-21.1 54l-.3 104.4c-.1 23.2 11.1 45 30 58.5l1.9 1.4c4.5 3.2 9.3 5.8 14.3 7.8l-6.9 5c-17.8 13-30.4 31.6-35.8 52.5l33.7 0c4.4-10.5 11.5-19.7 21-26.6l53.8-39.1 89.9-65.4c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5l-89.9 65.4c-12.7 9.2-29.8 9.3-42.6 .2l-1.9-1.4c-10.4-7.5-16.6-19.5-16.6-32.4l.3-104.4c0-12.7 5.1-24.8 14.1-33.8l13.3-13.3c3.6-3.6 5.3-8.8 4.5-13.9s-4-9.4-8.6-11.7L98.1 39.2c-1.3-.6-2.1-1.9-2.1-3.4zM366.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L55.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L81.8 416l284.4 0zM81.8 384c-11.1 0-21.4 5.7-27.2 15.1L21.9 451.8C18.1 458 16 465.2 16 472.6C16 494.3 33.7 512 55.4 512l337.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1L81.8 384zM148 168a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faFarm = {
    prefix: 'fal',
    iconName: 'farm',
    icon: [
      576,
      512,
      ["barn-silo"],
      'f864',
      
      'M48 480c-8.8 0-16-7.2-16-16l0-272 123.7 0 17.1-32L32 160l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 12 3-5.7c6.1-11.5 15.6-20.8 27.1-26.7C212.5 39.5 166.9 0 112 0C50.1 0 0 50.1 0 112L0 464c0 26.5 21.5 48 48 48l96 0c-7-9.3-12-20.2-14.4-32L48 480zM380.8 68.1c-8.2-3.6-17.5-3.6-25.7 0l-116.5 51c-6.6 2.9-12 7.9-15.4 14.3L163.8 244.9c-2.5 4.6-3.8 9.8-3.8 15.1l0 204c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-204c0-5.3-1.3-10.4-3.8-15.1L512.7 133.4c-3.4-6.4-8.8-11.4-15.4-14.3l-116.5-51zM368 97.5l116.5 51L544 260l0 204c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16l0-204 59.5-111.6L368 97.5zM416 480l-96 0 0-64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64zM336 224l64 0 0 64-64 0 0-64zm0-32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0z'
      
    ]
  };

  
    var faBarnSilo = faFarm;
  

  
  

  var faSquareT = {
    prefix: 'fal',
    iconName: 'square-t',
    icon: [
      448,
      512,
      [],
      'e280',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm112 48l112 0 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0 0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTvRetro = {
    prefix: 'fal',
    iconName: 'tv-retro',
    icon: [
      512,
      512,
      [128250],
      'f401',
      
      'M154.4 3.9c-6.7-5.8-16.8-5-22.6 1.7s-5 16.8 1.7 22.6L212.7 96 80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-256c0-44.2-35.8-80-80-80L299.3 96l79.2-67.9c6.7-5.8 7.5-15.9 1.7-22.6s-15.8-7.5-22.6-1.7L256 90.9 154.4 3.9zM256 128l176 0c26.5 0 48 21.5 48 48l0 256c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l176 0s0 0 0 0zm80 64c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l224 0zM112 160c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-224 0zm320 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faScannerImage = {
    prefix: 'fal',
    iconName: 'scanner-image',
    icon: [
      576,
      512,
      [],
      'f8f3',
      
      'M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5L492.2 288 64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-24 0-40 0-8.4c0-30.3-17.1-58-44.2-71.6L55.2 33.7zM544 352l0 40 0 24c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32zM104 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSnooze = {
    prefix: 'fal',
    iconName: 'snooze',
    icon: [
      448,
      512,
      [128164,"zzz"],
      'f880',
      
      'M176 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L304 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L214.6 128l89.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L265.4 32 176 32zM0 240c0-8.8 7.2-16 16-16l192 0c6.1 0 11.6 3.4 14.3 8.8s2.1 11.9-1.5 16.8L48 480l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8L176 256 16 256c-8.8 0-16-7.2-16-16zm304-16l128 0c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L337.3 384l94.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L398.7 256 304 256c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faZzz = faSnooze;
  

  
  

  var faBlockQuestion = {
    prefix: 'fal',
    iconName: 'block-question',
    icon: [
      448,
      512,
      [],
      'e3dd',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm88 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM88 368a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136.7 177.8c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 276.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faPlayPause = {
    prefix: 'fal',
    iconName: 'play-pause',
    icon: [
      640,
      512,
      [],
      'e22f',
      
      'M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zM288 256L96 416 96 96 288 256zM116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96l0 320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fal',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M480 24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 40-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0 0-40zM288 128c-7.5 0-15 1.6-21.8 4.7L48.8 230.1C38.6 234.7 32 244.8 32 256s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9L309.8 132.7c-6.9-3.1-14.3-4.7-21.8-4.7zm-8.8 33.9c2.8-1.2 5.7-1.9 8.8-1.9s6 .6 8.8 1.9l210 94.1-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 256l210-94.1zM94.7 337.5L48.8 358.1C38.6 362.7 32 372.8 32 384s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9l-45.9-20.6-39.1 17.5L506.7 384l-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 384l64.5-28.9L94.7 337.5z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faArrowUpAZ = {
    prefix: 'fal',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      'M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l94.7 0L339.5 454c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-94.7 0L492.5 314c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1l-128 0zM416 32c-6.1 0-11.6 3.4-14.3 8.8L337.8 168.6c-.1 .2-.2 .4-.3 .6l-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L361.9 192l108.2 0 11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7c-.1-.2-.2-.4-.3-.6L430.3 40.8c-2.7-5.4-8.2-8.8-14.3-8.8zM377.9 160L416 83.8 454.1 160l-76.2 0z'
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faUserGroup = {
    prefix: 'fal',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144l91.4 0zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zm431 208c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-4.4 0-8.8 .2-13.2 .5c11.3 9.4 21.6 19.9 30.7 31.5l43.9 0c71 0 128.6 57.2 129.3 128l-128 0c0 .8 0 1.5 0 2.3c0 10.8-2.8 20.9-7.6 29.7l136.9 0zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8c-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z'
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faBooks = {
    prefix: 'fal',
    iconName: 'books',
    icon: [
      512,
      512,
      [128218],
      'f5db',
      
      'M128 416l0 48c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-48 96 0zm-16 96c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2l64 0c26.5 0 48-21.5 48-48l0-48 0-16 0-16 0-190.2 51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C400 9.9 374.6-5.2 349.9 1.6L290.3 18.1c-3.5 1-6.8 2.3-9.9 4C271.9 8.8 257 0 240 0L176 0c-12.3 0-23.5 4.6-32 12.2C135.5 4.6 124.3 0 112 0L48 0C21.5 0 0 21.5 0 48L0 96l0 16 0 16L0 384l0 16 0 16 0 48c0 26.5 21.5 48 48 48l64 0zM288 64.8l0-1.3c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L288.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6c0 0 0 0 0 0L256 96l-96 0 0-48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16.2zM176 480c-8.8 0-16-7.2-16-16l0-48 96 0 0 48c0 8.8-7.2 16-16 16l-64 0zM128 128l0 256-96 0 0-256 96 0zm0-80l0 48L32 96l0-48c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16zM256 384l-96 0 0-256 96 0 0 256zM397.7 128.7l59.8 230.5-87.3 24.2L310.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2z'
      
    ]
  };

  

  
  

  var faStarExclamation = {
    prefix: 'fal',
    iconName: 'star-exclamation',
    icon: [
      576,
      512,
      [],
      'f2f3',
      
      'M202.4 186.5L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2l122.6-65.5c9.4-5 20.7-5 30.2 0l122.6 65.5L402.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L373.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L287.9 42.3 226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7zM450.2 507.4c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5zM288 128c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM264 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faArrowUpToArc = {
    prefix: 'fal',
    iconName: 'arrow-up-to-arc',
    icon: [
      512,
      512,
      [],
      'e617',
      
      'M256 32c123.7 0 224 100.3 224 224c0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256c0 8.8 7.2 16 16 16s16-7.2 16-16C32 132.3 132.3 32 256 32zM396 309.4l-128-144c-3-3.4-7.4-5.4-12-5.4s-8.9 2-12 5.4l-128 144c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 218.1 240 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-277.9L372 330.6c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6z'
      
    ]
  };

  

  
  

  var faWeightScale = {
    prefix: 'fal',
    iconName: 'weight-scale',
    icon: [
      512,
      512,
      ["weight"],
      'f496',
      
      'M112 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0c0-28.8-6.9-56-19.2-80L448 96c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32l35.2 0C86.9 120 80 147.2 80 176c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-56.2 0zM320 224c0-20.6-9.7-39-24.9-50.7l23.6-55c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4l-23.6 55c-3.2-.5-6.4-.7-9.7-.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faWeight = faWeightScale;
  

  
  

  var faHandBackPointUp = {
    prefix: 'fal',
    iconName: 'hand-back-point-up',
    icon: [
      448,
      512,
      [],
      'e1a2',
      
      'M136 0C105.1 0 80 25.1 80 56l0 200.6c-3.2 2-6.4 4.2-9.5 6.5L48 280c-20.1 15.1-32 38.8-32 64l0 19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2L304 512c61.9 0 112-50.1 112-112l0-8 0-88c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-8.5 0-16.6 1.7-24 4.7L192 56c0-30.9-25.1-56-56-56zM112 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 157.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3c15.6 0 28.6 11.2 31.4 25.9c1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32l0 88 0 8c0 44.2-35.8 80-80 80l-135.7 0c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C70.6 442.6 48 404.7 48 363.5L48 344c0-15.1 7.1-29.3 19.2-38.4L80 296l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-78.3 0-1.7 0-208z'
      
    ]
  };

  

  
  

  var faFlowerDaffodil = {
    prefix: 'fal',
    iconName: 'flower-daffodil',
    icon: [
      512,
      512,
      [9880],
      'f800',
      
      'M200 0c-48.6 0-88 39.4-88 88c0 21.3 7.6 40.8 20.1 56c-12.6 15.2-20.1 34.7-20.1 56c0 48.6 39.4 88 88 88c14.4 0 28-3.5 40-9.6l0 118.2C200.8 331.5 129.5 288 48 288l-20 0c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512l44 0 16 0 16 0 44 0c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28l-20 0c-81.5 0-152.8 43.5-192 108.6l0-118.2c12 6.1 25.6 9.6 40 9.6c48.6 0 88-39.4 88-88c0-21.3-7.6-40.8-20.1-56c12.6-15.2 20.1-34.7 20.1-56c0-48.6-39.4-88-88-88c-21.3 0-40.8 7.6-56 20.1C240.8 7.6 221.3 0 200 0zM144 88c0-30.9 25.1-56 56-56c17.6 0 33.3 8.1 43.6 20.8c3 3.8 7.6 5.9 12.4 5.9s9.4-2.2 12.4-5.9C278.7 40.1 294.4 32 312 32c30.9 0 56 25.1 56 56c0 17.6-8.1 33.3-20.8 43.6c-3.8 3-5.9 7.6-5.9 12.4s2.2 9.4 5.9 12.4c12.7 10.3 20.8 26 20.8 43.6c0 30.9-25.1 56-56 56c-17.6 0-33.3-8.1-43.6-20.8c-3-3.8-7.6-5.9-12.4-5.9s-9.4 2.2-12.4 5.9c-10.3 12.7-26 20.8-43.6 20.8c-30.9 0-56-25.1-56-56c0-17.6 8.1-33.3 20.8-43.6c3.8-3 5.9-7.6 5.9-12.4s-2.2-9.4-5.9-12.4C152.1 121.3 144 105.6 144 88zM32 320l16 0c95.1 0 174.1 69.2 189.3 160L196 480c-89.2 0-161.8-71.3-164-160zM480 320c-2.1 88.7-74.7 160-164 160l-41.3 0c15.2-90.8 94.2-160 189.3-160l16 0zM288 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCalendarRange = {
    prefix: 'fal',
    iconName: 'calendar-range',
    icon: [
      448,
      512,
      [],
      'e0d6',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zm0 176c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0c8.8 0 16 7.2 16 16zM240 416L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zM96 272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faTableCellsLock = {
    prefix: 'fal',
    iconName: 'table-cells-lock',
    icon: [
      640,
      512,
      [],
      'e679',
      
      'M352 64l0 96 128 0 0-64c0-17.7-14.3-32-32-32l-96 0zm-32 0L192 64l0 96 128 0 0-96zM160 64L64 64C46.3 64 32 78.3 32 96l0 64 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 40.6 0c-5.4 9.4-8.6 20.3-8.6 32l-32 0 0 96zM192 320l128 0 0-128-128 0 0 128zm336-96c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm160 80l-160 0 0 128 160 0 0-128z'
      
    ]
  };

  

  
  

  var faFilePrescription = {
    prefix: 'fal',
    iconName: 'file-prescription',
    icon: [
      384,
      512,
      [],
      'f572',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm48 224c-8.8 0-16 7.2-16 16l0 80 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 41.4 0 48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 406.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 384l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 361.4l-31.2-31.2C227.3 321.1 240 302 240 280c0-30.9-25.1-56-56-56l-72 0zm72 80l-8 0-48 0 0-48 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z'
      
    ]
  };

  

  
  

  var faXmarksLines = {
    prefix: 'fal',
    iconName: 'xmarks-lines',
    icon: [
      640,
      512,
      [],
      'e59a',
      
      'M16 32l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 64C7.2 64 0 56.8 0 48s7.2-16 16-16zm0 416l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16zM228.7 164.7c6.2-6.2 16.4-6.2 22.6 0L320 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 256l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6zM118.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L96 278.6 27.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L73.4 256 4.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L118.6 256zm334.1-91.3c6.2-6.2 16.4-6.2 22.6 0L544 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L566.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L544 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 256l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faWeightHanging = {
    prefix: 'fal',
    iconName: 'weight-hanging',
    icon: [
      512,
      512,
      [],
      'f5cd',
      
      'M208 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 48c10-13.4 16-30 16-48c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 18 6 34.6 16 48l-72 0c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-72 0zm-64 32l136 0c7.3 0 13.7 5 15.5 12.1l72 288c1.2 4.8 .1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2L48 480c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l72-288c1.8-7.1 8.2-12.1 15.5-12.1l136 0z'
      
    ]
  };

  

  
  

  var faCrown = {
    prefix: 'fal',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      'M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40l.7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106zM117.9 421.7L78.8 206.4l62.3 49.9c31.8 25.5 79 15.1 97.2-21.4L288 135.6l49.7 99.4c18.2 36.4 65.4 46.8 97.2 21.4l62.3-49.9L458.1 421.7c-2.8 15.2-16 26.3-31.5 26.3l-277.2 0c-15.5 0-28.7-11.1-31.5-26.3z'
      
    ]
  };

  

  
  

  var faLeftLongToLine = {
    prefix: 'fal',
    iconName: 'left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e41e',
      
      'M0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80zM320 216l272 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-272 0c-17.7 0-32 14.3-32 32l0 49.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L163.8 256 276.3 130.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 49.3c0 17.7 14.3 32 32 32zM128 256c0 5.2 1.9 10.1 5.3 14L252.5 403.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-17.3 0-32 32 0 240 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-240 0-32 0 0-32 0-17.3c0-21.4-17.3-38.7-38.7-38.7c-11 0-21.5 4.7-28.8 12.9L133.3 242c-3.4 3.8-5.3 8.8-5.3 14z'
      
    ]
  };

  

  
  

  var faMicrochip = {
    prefix: 'fal',
    iconName: 'microchip',
    icon: [
      512,
      512,
      [],
      'f2db',
      
      'M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-16 0c-35.3 0-64 28.7-64 64l0 16-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 16c0 35.3 28.7 64 64 64l16 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 16 0c35.3 0 64-28.7 64-64l0-16 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-16c0-35.3-28.7-64-64-64l-16 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48zM416 128l0 256c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32zm-256 0c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-192 0zm192 32l0 192-192 0 0-192 192 0z'
      
    ]
  };

  

  
  

  var faTemperatureHigh = {
    prefix: 'fal',
    iconName: 'temperature-high',
    icon: [
      512,
      512,
      [],
      'f769',
      
      'M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L112 96zM176 0C123 0 80 43 80 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L272 96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-210c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faTrashCanXmark = {
    prefix: 'fal',
    iconName: 'trash-can-xmark',
    icon: [
      448,
      512,
      [],
      'e2ae',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm84.7 116.7c6.2-6.2 16.4-6.2 22.6 0L224 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faFolderUser = {
    prefix: 'fal',
    iconName: 'folder-user',
    icon: [
      512,
      512,
      [],
      'e18e',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM256 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64l64 0c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z'
      
    ]
  };

  

  
  

  var faPeopleCarryBox = {
    prefix: 'fal',
    iconName: 'people-carry-box',
    icon: [
      640,
      512,
      ["people-carry"],
      'f4ce',
      
      'M136 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 136 0zM67.8 343.4l25.9 20.3L30.6 502.6c-3.7 8-13.1 11.6-21.2 7.9s-11.6-13.1-7.9-21.2l66.4-146zM96 193.2l0 87c0 5 2.3 9.7 6.2 12.7L128 312.7l0-133.3c-4.5-2.2-9.6-3.4-14.8-3.4c-9.5 0-17.2 7.7-17.2 17.2zm87.8 82.1L160 227.8l0 109.6 29 22.3c6.1 4.7 10.4 11.5 11.9 19.1l22.8 114.1c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6L169.5 385 82.7 318.3c-11.8-9.1-18.7-23.1-18.7-38l0-87C64 166 86 144 113.2 144c24.9 0 47.7 14.1 58.9 36.4L212.4 261l11.6 7.7L224 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 108.8 11.6-7.7 40.3-80.7c11.1-22.3 33.9-36.4 58.9-36.4c27.2 0 49.2 22 49.2 49.2l0 87c0 14.9-6.9 29-18.7 38L470.5 385 447.7 499.1c-1.7 8.7-10.2 14.3-18.8 12.6s-14.3-10.2-12.6-18.8l22.8-114.1c1.5-7.6 5.7-14.4 11.9-19.1l29-22.3 0-109.6-23.8 47.6c-2.5 5-6.2 9.2-10.9 12.3l-44.5 29.6c-3.7 2.5-8.1 3.2-12.2 2.3c-1.5 .2-3.1 .3-4.7 .3l-128 0c-1.6 0-3.2-.1-4.7-.3c-4.1 .9-8.4 .1-12.2-2.3l-44.5-29.6c-4.6-3.1-8.4-7.3-10.9-12.3zM504 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 504 0zm68.2 343.4l66.4 146c3.7 8 .1 17.5-7.9 21.2s-17.5 .1-21.2-7.9L546.3 363.7l25.9-20.3zM544 193.2c0-9.5-7.7-17.2-17.2-17.2c-5.2 0-10.3 1.2-14.8 3.4l0 133.3 25.8-19.8c3.9-3 6.2-7.7 6.2-12.7l0-87zM256 160l0 128 128 0 0-128-128 0z'
      
    ]
  };

  
    var faPeopleCarry = faPeopleCarryBox;
  

  
  

  var faClockTenThirty = {
    prefix: 'fal',
    iconName: 'clock-ten-thirty',
    icon: [
      512,
      512,
      [],
      'e355',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400l0-144c0-5.3-2.7-10.3-7.1-13.3l-96-64c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2L240 264.6 240 400c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faCloudsMoon = {
    prefix: 'fal',
    iconName: 'clouds-moon',
    icon: [
      640,
      512,
      [],
      'f745',
      
      'M384 160c0-57.7 38-106.5 90.3-122.5c-21.2 25.7-33.9 58.8-33.9 94.8c0 72.3 51.4 132.7 119.7 146.1c-14.9 6.2-31.3 9.6-48.5 9.6c-19.9 0-38.7-4.6-55.5-12.7c2.5 6.8 4.5 13.8 5.8 21.1c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160c0 11.5 1.2 22.7 3.5 33.4c12.9 2 25.2 5.9 36.6 11.4c-5.2-14-8-29.1-8-44.8zm-48.1 96c35.3 0 64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8c-1 4.8 .3 9.7 3.4 13.4s7.7 5.8 12.6 5.8l.7 0c.2 0 .4 0 .6 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-.8 0-1.6 0-2.3 0l-.3 0-.2 0-266.6 0-.2 0-.3 0c-.6 0-1.2 0-1.8 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l.2 0c0 0 0 0 0 0l8.3 0c5.7 0 11-3 13.9-8s2.9-11.1 0-16c-4.1-7-6.4-15.2-6.4-24c0-26.5 21.5-48 48-48c15.7 0 29.6 7.5 38.4 19.2c3.6 4.8 9.7 7.2 15.7 6.1s10.8-5.4 12.5-11.3c7.8-26.6 32.4-46 61.4-46zm96 64c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4c-13-9.1-28.7-14.4-45.8-14.4c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 432c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.7 0l266.1 0c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.6-34.6-87-80-94.7l0-1.3zM320 192.1s0 0 0 0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c0 0 0 0 0 0l34.8 0c5.7-12 13.4-22.8 22.8-32l-56.1 0c-.5 0-.9 0-1.4 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c1.8 0 3.6 .1 5.3 .3c16.8 2.2 32.3-9 35.6-25.6c4.3-22.1 23.8-38.7 47.1-38.7c20.4 0 38 12.8 44.9 30.9c6.2 16.2 24.1 24.6 40.5 18.8c3.3-1.1 6.8-1.8 10.6-1.8c17.7 0 32 14.3 32 32c0 .3 0 .6 0 .9c0 2.9-.3 5.8-.7 8.6c10.3-4.2 21.3-7.2 32.7-8.6l0-.9z'
      
    ]
  };

  

  
  

  var faCircle8 = {
    prefix: 'fal',
    iconName: 'circle-8',
    icon: [
      512,
      512,
      [],
      'e0f5',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 128c37.6 0 68 30.4 68 68c0 20.2-8.8 38.4-22.9 50.9C331.9 260.7 344 282.9 344 308c0 42-34 76-76 76l-24 0c-42 0-76-34-76-76c0-25.1 12.1-47.3 30.9-61.1c-14-12.5-22.9-30.6-22.9-50.9c0-37.6 30.4-68 68-68l24 0zM244 232s0 0 0 0l24 0c19.9 0 36-16.1 36-36s-16.1-36-36-36l-24 0c-19.9 0-36 16.1-36 36s16.1 36 36 36zm24 32l-24 0c-24.3 0-44 19.7-44 44s19.7 44 44 44l24 0c24.3 0 44-19.7 44-44s-19.7-44-44-44z'
      
    ]
  };

  

  
  

  var faHeartPulse = {
    prefix: 'fal',
    iconName: 'heart-pulse',
    icon: [
      512,
      512,
      ["heartbeat"],
      'f21e',
      
      'M244 130.6c3 3.4 7.4 5.4 12 5.4s8.9-2 12-5.4l12-13.5 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3l0 3.5c0 23.8-7.3 46.7-20.5 66c-1.1-.2-2.3-.4-3.5-.4l-84.2 0c-6.1 0-11.6-3.4-14.3-8.8l-23.2-46.3c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-48.9 97.9L198.6 169.4c-2.6-5.8-8.4-9.5-14.8-9.4s-12.1 4-14.5 9.8l-31.8 76.3c-2.5 6-8.3 9.8-14.8 9.8L56 256c-1.2 0-2.4 .1-3.5 .4C39.3 237.1 32 214.2 32 190.4l0-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 12 13.5zM429.6 288s0 0 0 0l45.8 0c0 0 0 0 .1-.1C498.9 261 512 226.4 512 190.4l0-3.5c0-69.6-49.8-129.3-118.3-141.8c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9l0 3.5c0 36 13.1 70.6 36.6 97.5c0 0 0 0 .1 .1l45.8 0s0 0 0 0l40.2 0c19.4 0 36.9-11.7 44.3-29.5l17.6-42.2 56.8 126.3c2.5 5.6 8.1 9.3 14.3 9.4s11.9-3.3 14.6-8.8L320 243.8l8.8 17.7c8.1 16.3 24.8 26.5 42.9 26.5l57.8 0zM69.8 320L231.2 470.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L442.2 320l-47 0L259 446.8c-.8 .7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L116.8 320l-47 0z'
      
    ]
  };

  
    var faHeartbeat = faHeartPulse;
  

  
  

  var faInboxIn = {
    prefix: 'fal',
    iconName: 'inbox-in',
    icon: [
      512,
      512,
      [128229,"inbox-arrow-down"],
      'f310',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 249.4-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4 272 16zM48 352l66.3 0c6.1 0 11.6 3.4 14.3 8.8L143 389.5c8.1 16.3 24.8 26.5 42.9 26.5l140.2 0c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3L369 389.5l14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8l66.3 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm306.7-5.5l-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8l-140.2 0c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5L48 320c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-66.3 0c-18.2 0-34.8 10.3-42.9 26.5z'
      
    ]
  };

  
    var faInboxArrowDown = faInboxIn;
  

  
  

  var faThumbtackSlash = {
    prefix: 'fal',
    iconName: 'thumbtack-slash',
    icon: [
      640,
      512,
      ["thumb-tack-slash"],
      'e68f',
      
      'M297.8 320L160 320l6.2-25c5.3-21.2 15.4-40.2 29-55.9l-25.1-19.8c-16.3 19.2-28.5 42.3-34.9 68l-6.2 25c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3l144 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 2.3 0-40.5-32zM213.5 64l-1.9 24.9 30.3 23.9 6-78.3c.1-.8 .1-1.6 .1-2.5l144 0c0 .8 0 1.6 .1 2.5l12.1 156.9c.7 9.7 5.9 18.6 13.9 24c27 18.3 47.3 46.2 55.6 79.6l.3 1 37.5 29.6c.8-4.4 .7-9-.5-13.4l-6.2-25c-10.3-41.3-35.4-75.7-68.7-98.3L426.5 64 424 32l24 0c2.9 0 5.6-.8 7.9-2.1c4.8-2.8 8.1-7.9 8.1-13.9c0-8.8-7.2-16-16-16L424 0 216 0 192 0c-8.8 0-16 7.2-16 16c0 5.9 3.2 11.1 8.1 13.9c2.3 1.3 5 2.1 7.9 2.1l24 0-2.5 32zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faThumbTackSlash = faThumbtackSlash;
  

  
  

  var faPassport = {
    prefix: 'fal',
    iconName: 'passport',
    icon: [
      448,
      512,
      [],
      'f5ab',
      
      'M384 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 400c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm33.3-192l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 288l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0zm0-32l-39.1 0c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 96l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0zM224 320a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fal',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      'M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3l0 64.7-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64.7z'
      
    ]
  };

  

  
  

  var faCommentSmile = {
    prefix: 'fal',
    iconName: 'comment-smile',
    icon: [
      512,
      512,
      [],
      'f4b4',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM155.9 284.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 334.5 215.7 352 256 352s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3C314.5 306.6 286.8 320 256 320s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z'
      
    ]
  };

  

  
  

  var faSquareRight = {
    prefix: 'fal',
    iconName: 'square-right',
    icon: [
      448,
      512,
      [10145,"arrow-alt-square-right"],
      'f352',
      
      'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM368 256c0 9.2-3.5 18-9.7 24.7l-84 91c-7.2 7.8-17.4 12.3-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3l0-25.7-80 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l80 0 0-25.7c0-21.1 17.1-38.3 38.3-38.3c10.7 0 20.9 4.5 28.1 12.3l84 91c6.2 6.7 9.7 15.6 9.7 24.7zm-33.2-3l-84-91c-1.2-1.3-2.9-2-4.6-2c-3.5 0-6.3 2.8-6.3 6.3l0 41.7c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 41.7c0 3.5 2.8 6.3 6.3 6.3c1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3s-.4-2.2-1.2-3z'
      
    ]
  };

  
    var faArrowAltSquareRight = faSquareRight;
  

  
  

  var faVideoPlus = {
    prefix: 'fal',
    iconName: 'video-plus',
    icon: [
      576,
      512,
      [],
      'f4e1',
      
      'M320 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-47.2 0-161.6 0-47.2c0-35.3-28.7-64-64-64L64 64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2l0-243.6c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6l0 36.5 118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2l0 243.6c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9l0 36.5zM208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64z'
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fal',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M319.2 257.8c.5-.5 .8-1.1 .8-1.8s-.3-1.4-.8-1.8L187.3 129.8c-1.2-1.2-2.9-1.8-4.6-1.8c-3.7 0-6.7 3-6.7 6.7l0 57.3c0 8.8-7.2 16-16 16L40 208c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l120 0c8.8 0 16 7.2 16 16l0 57.3c0 3.7 3 6.7 6.7 6.7c1.7 0 3.3-.6 4.6-1.8L319.2 257.8zM352 256c0 9.5-3.9 18.6-10.8 25.1L209.2 405.5c-7.2 6.8-16.7 10.5-26.5 10.5c-21.4 0-38.7-17.3-38.7-38.7l0-41.3L40 336c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40l104 0 0-41.3c0-21.4 17.3-38.7 38.7-38.7c9.9 0 19.3 3.8 26.5 10.5L341.2 230.9c6.9 6.5 10.8 15.6 10.8 25.1zM336 448l96 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c44.2 0 80 35.8 80 80l0 288c0 44.2-35.8 80-80 80l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faFireHydrant = {
    prefix: 'fal',
    iconName: 'fire-hydrant',
    icon: [
      384,
      512,
      [],
      'e17f',
      
      'M192 0c8.8 0 16 7.2 16 16l0 17c57.9 7.2 103.8 53.1 111 111l17 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l17 0C72.2 86.1 118.1 40.2 176 33l0-17c0-8.8 7.2-16 16-16zm0 64c-47.6 0-87.1 34.6-94.7 80l189.3 0c-7.6-45.4-47.1-80-94.7-80zM32 496c0-8.8 7.2-16 16-16l16 0 0-80-16 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l16 0 0-32 32 0 0 48 0 128 0 96 192 0 0-96 0-128 0-48 32 0 0 32 16 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-16 0 0 80 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0L80 512l-32 0c-8.8 0-16-7.2-16-16zM320 368l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM64 368l0-96-16 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l16 0zm160-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faFilePng = {
    prefix: 'fal',
    iconName: 'file-png',
    icon: [
      512,
      512,
      [],
      'e666',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM318.3 360.8L352 428.2l0-60.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 7.4-5.1 13.9-12.3 15.6s-14.7-1.8-18-8.4L320 435.8l0 60.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.4 5.1-13.9 12.3-15.6s14.7 1.8 18 8.4zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z'
      
    ]
  };

  

  
  

  var faApostrophe = {
    prefix: 'fal',
    iconName: 'apostrophe',
    icon: [
      192,
      512,
      [],
      '27',
      
      'M78.7 320.1c-8.8 .7-15.3 8.5-14.6 17.3s8.5 15.4 17.3 14.6l8-.7c58-4.8 102.7-53.4 102.7-111.6l0-79.7 0-32 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l64 0c11.7 0 22.6-3.1 32-8.6l0 24.2c0 41.6-31.9 76.3-73.4 79.7l-8 .7zM160 160c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 32 0 32z'
      
    ]
  };

  

  
  

  var faPersonBreastfeeding = {
    prefix: 'fal',
    iconName: 'person-breastfeeding',
    icon: [
      448,
      512,
      [],
      'e53a',
      
      'M176 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM103.3 273.9c20.8-31.2 55.7-49.9 93.2-49.9l68.1 0c30.9 0 60.5 12.8 81.6 35.3l55.5 59.1c14.6 15.6 14.4 39.9-.4 55.2l-76.8 79.2c-6.2 6.3-6 16.5 .3 22.6s16.5 6 22.6-.3l76.8-79.2c26.8-27.6 27.1-71.4 .8-99.4l-55.5-59.1c-27.2-29-65.2-45.4-105-45.4l-68.1 0c-48.1 0-93.1 24.1-119.8 64.1L23 336.7C-1.5 373.4 12.6 423.4 52.7 442l148.6 68.6c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L66.1 412.9C43.8 402.6 36 374.8 49.6 354.4l53.7-80.5zM192 320c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.4c0 6 1.7 11.9 4.9 17c26.3 42.1 72.4 67.6 122 67.6l1.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-1.1 0c-38.6 0-74.4-19.9-94.9-52.6l0-43.4zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faGaugeMax = {
    prefix: 'fal',
    iconName: 'gauge-max',
    icon: [
      512,
      512,
      ["tachometer-alt-fastest"],
      'f626',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-35.3 28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  
    var faTachometerAltFastest = faGaugeMax;
  

  
  

  var faBuildingWheat = {
    prefix: 'fal',
    iconName: 'building-wheat',
    icon: [
      640,
      512,
      [],
      'e4db',
      
      'M320 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l256 0zM192 384c17.7 0 32 14.3 32 32l0 64-64 0 0-64c0-17.7 14.3-32 32-32zM64 512l64 0 32 0 64 0 32 0 64 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64zM88 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96zm8 64l0-32 32 0 0 32-32 0zm128-40l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM88 224c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm128-40l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm368-64l-16 0c-33.4 0-62.8 17-80 42.9C510.8 209 481.4 192 448 192l-16 0c-8.8 0-16 7.2-16 16l0 16c0 24.6 9.2 47 24.4 64l-8.4 0c-8.8 0-16 7.2-16 16l0 16c0 24.6 9.2 47 24.4 64l-8.4 0c-8.8 0-16 7.2-16 16l0 16c0 53 43 96 96 96l16 0 16 0c53 0 96-43 96-96l0-16c0-8.8-7.2-16-16-16l-8.4 0c15.2-17 24.4-39.4 24.4-64l0-16c0-8.8-7.2-16-16-16l-8.4 0c15.2-17 24.4-39.4 24.4-64l0-16c0-8.8-7.2-16-16-16zm-80 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64c0 0 0 0 0 0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm16 32l8.4 0c-3.1 3.4-5.9 7.1-8.4 10.9c-2.6-3.8-5.4-7.5-8.4-10.9l8.4 0zm0 106.9c-2.6-3.8-5.4-7.5-8.4-10.9l8.4 0 8.4 0c-3.1 3.4-5.9 7.1-8.4 10.9zM544 384s0 0 0 0c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm32 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64c0 0 0 0 0 0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zM528 32c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16zm64 48c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16zM448 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48z'
      
    ]
  };

  

  
  

  var faCircleE = {
    prefix: 'fal',
    iconName: 'circle-e',
    icon: [
      512,
      512,
      [],
      'e109',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32l0 96 0 96c0 17.7 14.3 32 32 32l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0 0-80 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-80 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleCurrency = {
    prefix: 'fal',
    iconName: 'chart-pie-simple-circle-currency',
    icon: [
      640,
      512,
      [],
      'e604',
      
      'M288 224l106.8 0c-12.9 9.1-24.5 19.9-34.6 32L272 256c-8.8 0-16-7.2-16-16l0-222.3C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5L288 224zm-32 64l83.2 0c-5.2 10.1-9.4 20.8-12.6 32L224 320c-17.7 0-32-14.3-32-32l0-218.4C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 256l0 32 32 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm25.4 169.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-9.3 9.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l9.3-9.3c-13.2-21.6-13.2-49.1 0-70.7l-9.3-9.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l9.3 9.3c21.6-13.2 49.1-13.2 70.7 0l9.3-9.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-9.3 9.3c13.2 21.6 13.2 49.1 0 70.7l9.3 9.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-9.3-9.3z'
      
    ]
  };

  

  
  

  var faLayerMinus = {
    prefix: 'fal',
    iconName: 'layer-minus',
    icon: [
      576,
      512,
      ["layer-group-minus"],
      'f5fe',
      
      'M408 64l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L408 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM266.2 132.7c6.9-3.1 14.3-4.7 21.8-4.7s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l217.4-97.5zM288 160c-3 0-6 .6-8.8 1.9L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1c-2.8-1.2-5.7-1.9-8.8-1.9zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9z'
      
    ]
  };

  
    var faLayerGroupMinus = faLayerMinus;
  

  
  

  var faLightbulbExclamation = {
    prefix: 'fal',
    iconName: 'lightbulb-exclamation',
    icon: [
      384,
      512,
      [],
      'f671',
      
      'M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9l32.4 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l32.4 0c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1c0 0 0 0 0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM146.7 448l90.5 0c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80l0-5.3c0-5.9-4.8-10.7-10.7-10.7l-138.7 0c-5.9 0-10.7 4.8-10.7 10.7l0 5.3zM192 96c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faMessageArrowUp = {
    prefix: 'fal',
    iconName: 'message-arrow-up',
    icon: [
      512,
      512,
      ["comment-alt-arrow-up"],
      'e1dc',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM272 304l0-153.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 150.6 240 304c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  
    var faCommentAltArrowUp = faMessageArrowUp;
  

  
  

  var faPaperPlaneTop = {
    prefix: 'fal',
    iconName: 'paper-plane-top',
    icon: [
      512,
      512,
      ["paper-plane-alt","send"],
      'e20a',
      
      'M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272L32 448 442.7 272 120 272zm322.7-32L32 64l88 176 322.7 0z'
      
    ]
  };

  
    var faPaperPlaneAlt = faPaperPlaneTop;
  
    var faSend = faPaperPlaneTop;
  

  
  

  var faPersonSeatReclined = {
    prefix: 'fal',
    iconName: 'person-seat-reclined',
    icon: [
      512,
      512,
      [],
      'e21f',
      
      'M160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM63.8 141.4L98.4 349.2c6.4 38.6 39.8 66.8 78.9 66.8L288 416c8.8 0 16 7.2 16 16s-7.2 16-16 16l-110.7 0c-54.8 0-101.5-39.6-110.5-93.6L32.2 146.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2zm120.4 98.5l11.1 66.7c1.3 7.7 8 13.4 15.8 13.4l42 0-12.9-77.2-.1-.4-1.9-11.6c-2.2-13.2-13.6-22.9-27-22.9c-16.9 0-29.8 15.2-27 31.9zm27-63.9c28.5 0 52.9 20.2 58.3 48l66.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-61.1 0 10.7 64 33.2 0c26.7 0 50.6 16.5 59.9 41.5L410 445l50.2-12.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-64 16c-7.9 2-16-2.3-18.9-9.9l-36.3-96.9c-4.7-12.5-16.6-20.8-30-20.8l-46.5 0c-.2 0-.4 0-.6 0l-60.6 0c-23.5 0-43.5-17-47.3-40.1l-11.1-66.7c-6-36.2 21.9-69.2 58.6-69.2z'
      
    ]
  };

  

  
  

  var faHourglassClock = {
    prefix: 'fal',
    iconName: 'hourglass-clock',
    icon: [
      576,
      512,
      [],
      'e41b',
      
      'M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-41.6c0-49.4 22.8-96 61.8-126.3L165.9 256 93.8 199.9C54.8 169.6 32 122.9 32 73.6L32 32 16 32C7.2 32 0 24.8 0 16S7.2 0 16 0L48 0 336 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 41.6c0 49.4-22.8 96-61.8 126.3L218.1 256l52.8 41.1c-4.5 10.3-8.1 21.1-10.6 32.3L192 276.3l-78.6 61.1C82.2 361.6 64 398.9 64 438.4L64 480l232.2 0c10 12.1 21.7 22.9 34.6 32L48 512l-32 0zM192 235.7l78.6-61.1c31.2-24.3 49.4-61.5 49.4-101L320 32 64 32l0 41.6c0 39.5 18.2 76.8 49.4 101L192 235.7zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faBlenderPhone = {
    prefix: 'fal',
    iconName: 'blender-phone',
    icon: [
      576,
      512,
      [],
      'f6b6',
      
      'M226.8 32L535 32 519 96 368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l143 0-16 64-127 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l119 0L455 352l-201.6 0L226.8 32zM487.1 355.4L566.1 39.8C571.1 19.6 555.8 0 535 0L226.8 0c-18.7 0-33.4 16-31.9 34.7l26.6 319.5c-35.3 8.3-61.5 40-61.5 77.9l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-32c0-36.1-24-66.7-56.9-76.6zM240 384l224 0c26.5 0 48 21.5 48 48l0 32c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-32c0-26.5 21.5-48 48-48zm136 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM120.1 116.7L95 114.2c-15.5-1.5-29.9 8.4-34 23.5c-9.6 35.5-9.6 73 0 108.6c4.1 15.1 18.5 25 34 23.5l25.1-2.5 21.8 53.5L96.3 350C10.6 261.5 10.6 122.5 96.3 34l45.6 29.2-21.8 53.5zm45-76.6L108.4 3.8C99-2.2 86-.9 78.1 6.8C-26 109.1-26 274.9 78.1 377.2c7.9 7.8 20.9 9.1 30.3 3.1l56.7-36.4c9.6-6.1 13.4-17.9 9.2-28.3l-26.9-66.1c-3.9-9.7-13.9-15.6-24.5-14.6l-31.1 3c-8.2-30-8.2-61.8 0-91.8l31 3c10.6 1 20.5-4.9 24.5-14.6l26.9-66.1c4.2-10.4 .4-22.2-9.2-28.3z'
      
    ]
  };

  

  
  

  var faUserHairBuns = {
    prefix: 'fal',
    iconName: 'user-hair-buns',
    icon: [
      448,
      512,
      [],
      'e3d3',
      
      'M314.5 96l-32 0c-12.7 0-24.9-5.1-33.9-14.1L235.3 68.7c-6.2-6.2-16.4-6.2-22.6 0L199.4 81.9c-9 9-21.2 14.1-33.9 14.1l-32 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zm5.5 32l0 16c0 53-43 96-96 96s-96-43-96-96l0-16 37.5 0c21.2 0 41.6-8.4 56.6-23.4l1.9-1.9 1.9 1.9c15 15 35.4 23.4 56.6 23.4l37.5 0zM224 272c46.7 0 87.5-25 109.9-62.3c8.7 8.8 20.8 14.3 34.1 14.3c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48c-10.6 0-20.4 3.4-28.3 9.2C319.2 29.9 275.1 0 224 0s-95.2 29.9-115.7 73.2C100.4 67.4 90.6 64 80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48c13.4 0 25.4-5.5 34.1-14.3C136.5 247 177.3 272 224 272zm128-96l0-32 0-16 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16zM168 336l112 0c75.1 0 136 60.9 136 136l0 8L32 480l0-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-92.8-75.2-168-168-168l-112 0zM96 144l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 0 16z'
      
    ]
  };

  

  
  

  var faHourglassStart = {
    prefix: 'fal',
    iconName: 'hourglass-start',
    icon: [
      384,
      512,
      ["hourglass-1"],
      'f251',
      
      'M0 496c0 8.8 7.2 16 16 16l32 0 288 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-41.6c0-49.4-22.8-96-61.8-126.3L218.1 256l72.2-56.1c39-30.3 61.8-76.9 61.8-126.3L352 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L336 0 48 0 16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l16 0 0 41.6c0 49.4 22.8 96 61.8 126.3L165.9 256 93.8 312.1C54.8 342.4 32 389.1 32 438.4L32 480l-16 0c-8.8 0-16 7.2-16 16zm64-16l0-41.6c0-39.5 18.2-76.8 49.4-101L192 276.3l78.6 61.1c31.2 24.2 49.4 61.5 49.4 101l0 41.6L64 480zm49.4-305.4C97.3 162.1 84.6 146 76.1 128l231.7 0c-8.5 18-21.1 34.1-37.3 46.6L192 235.7l-78.6-61.1zM66 96c-1.3-7.3-2-14.8-2-22.4L64 32l256 0 0 41.6c0 7.6-.7 15.1-2 22.4L66 96z'
      
    ]
  };

  
    var faHourglass1 = faHourglassStart;
  

  
  

  var faFamily = {
    prefix: 'fal',
    iconName: 'family',
    icon: [
      512,
      512,
      [],
      'e300',
      
      'M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320l59.6 0c-.7 5.2-1.1 10.6-1.1 16l0 16-48 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c7 0 13.8 .9 20.2 2.6c-1.7 6.9-2.6 14-2.6 21.4c0 3.9 .3 7.8 .8 11.6c-5.7-2.4-11.9-3.6-18.4-3.6l-44.8 0zM416 384l-49.6 0c1-5.2 1.6-10.5 1.6-16l0-16 101.6 0L430.5 215.2C426.6 201.5 414 192 399.7 192l-31.4 0c-11.5 0-21.8 6.1-27.5 15.6c2.1-7.5 3.2-15.4 3.2-23.6c0-6.3-.7-12.5-1.9-18.4c8.1-3.6 17-5.6 26.2-5.6l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48l0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-32c0-26.5-21.5-48-48-48zM208 413.3c-18.6-6.6-32-24.4-32-45.3l0-32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 32c0 20.9-13.4 38.7-32 45.3l0 82.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-82.7z'
      
    ]
  };

  

  
  

  var faShopLock = {
    prefix: 'fal',
    iconName: 'shop-lock',
    icon: [
      640,
      512,
      [],
      'e4a5',
      
      'M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0l391 0c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-5.4-9.3-12.1-17.8-19.8-25.2c1.6-1.1 2.7-3 2.7-5.2c0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3l-391 0c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5 .9-.8 1.9-.8 3c0 3.4 2.8 6.2 6.2 6.2L80 192l369.6 0c-9.4 9.2-17.1 20-22.8 32L96 224l0 128 256 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 79.6 0 .4 0 112.3c-.2 26.4-21.6 47.7-48 47.7l-224 0c-26.5 0-48-21.5-48-48l0-240-25.8 0C17.1 224 0 206.9 0 185.8zM96 464c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-80L96 384l0 80zM528 224c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faIntersection = {
    prefix: 'fal',
    iconName: 'intersection',
    icon: [
      384,
      512,
      [8898],
      'f668',
      
      'M16 480c8.8 0 16-7.2 16-16l0-240c0-88.4 71.6-160 160-160s160 71.6 160 160l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240c0-106-86-192-192-192S0 118 0 224L0 464c0 8.8 7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faVirusCovidSlash = {
    prefix: 'fal',
    iconName: 'virus-covid-slash',
    icon: [
      640,
      512,
      [],
      'e4a9',
      
      'M503.3 272l40.7 0 0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24-40.7 0c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8s0 0 0 0l17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L472.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17s0 0 0 0l-28.8 28.8C410.1 91.4 374.8 76 336 72.7L336 32l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L280 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 40.7c-29 2.5-56.2 11.7-79.8 26.2l27.2 21.5C272 109.9 295.3 104 320 104c83.9 0 152 68.1 152 152c0 12.1-1.4 23.9-4.1 35.2l27.2 21.5c4.2-13 7-26.6 8.2-40.7zM168 256c0-12.1 1.4-23.9 4.1-35.2l-27.2-21.5c-4.2 13-7 26.6-8.2 40.7L96 240l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24 40.7 0c3.3 38.8 18.7 74.1 42.4 102.3l-28.8 28.8s0 0 0 0l-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17s0 0 0 0l28.8-28.8c28.2 23.7 63.5 39 102.3 42.4l0 40.7-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-40.7c29-2.5 56.2-11.8 79.8-26.2l-27.2-21.5C368 402.1 344.7 408 320 408c-83.9 0-152-68.1-152-152zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faServer = {
    prefix: 'fal',
    iconName: 'server',
    icon: [
      512,
      512,
      [],
      'f233',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96zM64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 320zM0 352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64zm304 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBadgeSheriff = {
    prefix: 'fal',
    iconName: 'badge-sheriff',
    icon: [
      448,
      512,
      [],
      'f8a2',
      
      'M224 0c-35.3 0-64 28.7-64 64c0 14.7 5 28.3 13.4 39.1l-18.9 32.4-35.2 .1c-5.4-9.3-13.3-17.4-23.3-23.1C65.4 94.9 26.3 105.4 8.6 136S1.4 205.8 32 223.4c12.3 7.1 25.9 9.6 39 8.2L84.9 256 71 280.4c-13.1-1.4-26.7 1.1-39 8.2C1.4 306.2-9.1 345.4 8.6 376s56.8 41.1 87.4 23.4l-8-13.9 8 13.9c10-5.8 17.8-13.8 23.3-23.1l35.2 .1 18.9 32.4C165 419.7 160 433.3 160 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-14.7-5-28.3-13.4-39.1l18.9-32.4 35.2-.1c5.4 9.3 13.3 17.4 23.3 23.1c30.6 17.7 69.8 7.2 87.4-23.4s7.2-69.8-23.4-87.4c-12.3-7.1-25.9-9.6-39-8.2L363.1 256 377 231.6c13.1 1.4 26.7-1.1 39-8.2c30.6-17.7 41.1-56.8 23.4-87.4s-56.8-41.1-87.4-23.4c-10 5.8-17.8 13.8-23.3 23.1l-35.2-.1-18.9-32.4C283 92.3 288 78.7 288 64c0-35.3-28.7-64-64-64zM192 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 9.9-4.4 18.7-11.5 24.6c-6 5-7.5 13.6-3.6 20.3l24.9 42.8c5.7 9.8 16.2 15.8 27.5 15.9l45.4 .2c6.8 0 12.8-4.2 15.1-10.6c2.5-6.9 7.3-12.9 14.1-16.9c15.3-8.8 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-8.2 4.8-17.7 5.4-26.1 2.7c-7.2-2.4-15.1 .6-18.9 7.2l-19.7 34.5c-5.6 9.8-5.6 21.9 0 31.8L355 306.4c3.8 6.6 11.7 9.6 18.9 7.2c8.4-2.8 17.8-2.1 26.1 2.7c15.3 8.8 20.6 28.4 11.7 43.7s-28.4 20.6-43.7 11.7c-6.8-3.9-11.6-10-14.1-16.9c-2.3-6.4-8.3-10.6-15.1-10.6l-45.4 .2c-11.3 0-21.8 6.1-27.5 15.9L241 403.1c-3.9 6.7-2.4 15.3 3.6 20.3c7 5.9 11.5 14.7 11.5 24.6c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-9.9 4.4-18.7 11.5-24.6c6-5 7.5-13.6 3.6-20.3l-24.9-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-45.4-.2c-6.8 0-12.8 4.2-15.1 10.6c-2.5 6.9-7.3 12.9-14.1 16.9c-15.3 8.8-34.9 3.6-43.7-11.7s-3.6-34.9 11.7-43.7c8.2-4.7 17.7-5.4 26.1-2.7c7.2 2.4 15.1-.6 18.9-7.2l19.7-34.5c5.6-9.8 5.6-21.9 0-31.8L93 205.6c-3.8-6.6-11.7-9.6-18.9-7.2c-8.4 2.8-17.8 2.1-26.1-2.7c-15.3-8.8-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c6.8 3.9 11.6 10 14.1 16.9c2.3 6.4 8.3 10.6 15.1 10.6l45.4-.2c11.3 0 21.8-6.1 27.5-15.9l-13.8-8.1 13.8 8.1L207 108.9c3.9-6.7 2.4-15.3-3.6-20.3C196.4 82.7 192 73.9 192 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z'
      
    ]
  };

  

  
  

  var faGridRound = {
    prefix: 'fal',
    iconName: 'grid-round',
    icon: [
      448,
      512,
      [],
      'e5da',
      
      'M96 96A32 32 0 1 1 32 96a32 32 0 1 1 64 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM96 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z'
      
    ]
  };

  

  
  

  var faSlidersSimple = {
    prefix: 'fal',
    iconName: 'sliders-simple',
    icon: [
      512,
      512,
      [],
      'e253',
      
      'M80 320a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm78.4 32L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-337.6 0c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c38.7 0 71 27.5 78.4 64zM384 144a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-30.4-16C361 91.5 393.3 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-38.7 0-71-27.5-78.4-64L16 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l337.6 0z'
      
    ]
  };

  

  
  

  var faWindTurbine = {
    prefix: 'fal',
    iconName: 'wind-turbine',
    icon: [
      512,
      512,
      [],
      'f89b',
      
      'M314.5 436c17.2 27.9 60.2 12.2 55.4-20.2L343.2 235 430.2 74.2c15.6-28.8-19.5-58.3-45.2-37.9L241.7 149.8 59 154.9c-32.7 .9-40.7 46-10.2 58.1l170 67.3L256 341l0 140.9-90.4 0c-8.3 0-15.1 6.7-15.1 15.1s6.7 15.1 15.1 15.1l105.4 0 105.4 0c8.3 0 15.1-6.7 15.1-15.1s-6.7-15.1-15.1-15.1l-90.4 0 0-92L314.5 436zm-1-196.6l26.7 180.8L244.3 264.5c-3.4-5.5-8.5-9.8-14.6-12.2L59.8 185l182.7-5.1c6.5-.2 12.8-2.5 17.9-6.5L403.7 59.8 316.7 220.6c-3.1 5.7-4.2 12.3-3.3 18.7zm-27.3-13.5a15.1 15.1 0 1 0 -30.1 0 15.1 15.1 0 1 0 30.1 0z'
      
    ]
  };

  

  
  

  var faShopSlash = {
    prefix: 'fal',
    iconName: 'shop-slash',
    icon: [
      640,
      512,
      ["store-alt-slash"],
      'e070',
      
      'M0 185.8C0 206.9 17.1 224 38.2 224L64 224l0 240c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-75.9L338.3 352 96 352l0-128 80.2 0-40.5-32L80 192l-41.8 0c-3.4 0-6.2-2.8-6.2-6.2c0-1 .3-2.1 .8-3l27.4-50.3L34.7 112.3 4.7 167.4C1.6 173.1 0 179.4 0 185.8zM139.6 32l376 0c5.9 0 11.2 3.2 14 8.3l77.7 142.4c.5 .9 .8 1.9 .8 3c0 3.4-2.8 6.2-6.2 6.2L560 192l-217.8 0 40.5 32L544 224l0 127.3 32 25.3L576 224l25.8 0c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0l-391 0c-7 0-13.8 1.5-20 4.3l35 27.7zM96 464l0-80 256 0 0 80c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faStoreAltSlash = faShopSlash;
  

  
  

  var faSquare6 = {
    prefix: 'fal',
    iconName: 'square-6',
    icon: [
      448,
      512,
      [],
      'e25b',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-96 64c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1 .8-22.6s-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9z'
      
    ]
  };

  

  
  

  var faPersonSkiLift = {
    prefix: 'fal',
    iconName: 'person-ski-lift',
    icon: [
      512,
      512,
      ["ski-lift"],
      'f7c8',
      
      'M256 0c8.8 0 16 7.2 16 16l0 194.8c-1.9 .3-3.7 .6-5.6 1.1L240 218.5 240 16c0-8.8 7.2-16 16-16zM104.8 177.7c7.9-4 17.5-.7 21.5 7.2l42.3 84.5L274.2 243c15.1-3.8 29.8 7.7 29.8 23.3l0 136.5 150.7-59.7c15.3-6 25.3-20.8 25.3-37.2l0-1.9c0-8.8 7.2-16 16-16s16 7.2 16 16l0 1.9c0 29.5-18 56.1-45.5 66.9l-348.6 138c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8L272 415.5l0-139-95.7 23.9c-14.6 3.6-29.7-3.3-36.4-16.7L97.7 199.2c-4-7.9-.7-17.5 7.2-21.5zM9.1 161.6c8-3.8 17.5-.5 21.3 7.5L103.3 321c10 20.9 33.5 31.6 55.9 25.5l36.5-10c8.5-2.3 17.3 2.7 19.6 11.2s-2.7 17.3-11.2 19.6l-36.5 10c-37.3 10.2-76.5-7.7-93.2-42.6L1.6 182.9c-3.8-8-.5-17.5 7.5-21.3zM128 88A24 24 0 1 0 80 88a24 24 0 1 0 48 0zM48 88a56 56 0 1 1 112 0A56 56 0 1 1 48 88z'
      
    ]
  };

  
    var faSkiLift = faPersonSkiLift;
  

  
  

  var faNfcLock = {
    prefix: 'fal',
    iconName: 'nfc-lock',
    icon: [
      576,
      512,
      [],
      'e1f8',
      
      'M384 64L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l256 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 65.1c-11.3 1.6-22.1 4.9-32 9.6L416 96c0-17.7-14.3-32-32-32zm0 64l0 65.6c-19.8 20.2-32 47.9-32 78.4l0-144-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-82.7c0-17.7 14.3-32 32-32l112 0c17.7 0 32 14.3 32 32zM96 384l224 0 0 32L96 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 256zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm240-16c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm160 80l-160 0 0 128 160 0 0-128z'
      
    ]
  };

  

  
  

  var faCannon = {
    prefix: 'fal',
    iconName: 'cannon',
    icon: [
      640,
      512,
      [],
      'e642',
      
      'M266.5 422.2c-10.4 6.3-18.8 11.1-24.6 14.1c-55.3 27.5-122.5 5.1-150.1-50.2s-5.3-122.5 49.9-150.2c23.1-11.1 92.7-37.4 172.4-66.3c78.9-28.6 165-58.9 218.6-77.7c15-5.2 31.6 1.4 38.8 15.9l30.7 61.4c7.2 14.5 2.6 31.8-10.6 40.6c-23.5 15.8-54.2 36.3-87.7 58.5c7.4 7.7 13.9 16.3 19.5 25.5c32.9-21.9 62.9-41.9 86-57.4c26.7-17.9 35.7-52.7 21.4-81.5L600.2 93.5c-14.4-28.7-47.7-42.4-78-31.8C414.8 99.3 177.1 183.2 127.6 207.2C77 232.5 47.8 283.5 48 336.5l-12.6 6.3C3.8 358.6-9.1 397 6.8 428.6S61 473 92.6 457.2l12.6-6.3c42.3 31.9 100.6 39.1 151.2 13.8c6.1-3.2 14.8-8.1 25.4-14.5c-6.1-8.7-11.2-18.2-15.3-28.1zM80.7 427.4l-2.4 1.2c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l2.4-1.2c2.5 10.3 6.2 20.4 11.1 30.2s10.8 18.9 17.5 27zM320 368a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm192 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM400 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFilesMedical = {
    prefix: 'fal',
    iconName: 'files-medical',
    icon: [
      448,
      512,
      [],
      'f7fd',
      
      'M384 384c17.7 0 32-14.3 32-32l0-207.2c0-.3 0-.5 0-.8l-80 0c-17.7 0-32-14.3-32-32l0-80L160 32c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l224 0zm6-272L336 57.5l0 54.5 54 0zM96 64c0-35.3 28.7-64 64-64L304 0c12.8 0 25.1 5.1 34.1 14.2l96 96.8c8.9 9 13.9 21.1 13.9 33.8L448 352c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64L96 64zM16 96c8.8 0 16 7.2 16 16l0 272c0 53 43 96 96 96l208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-208 0C57.3 512 0 454.7 0 384L0 112c0-8.8 7.2-16 16-16zm245.3 64l21.3 0c17.7 0 32 14.3 32 32l0 21.3 21.3 0c17.7 0 32 14.3 32 32l0 21.3c0 17.7-14.3 32-32 32l-21.3 0 0 21.3c0 17.7-14.3 32-32 32l-21.3 0c-17.7 0-32-14.3-32-32l0-21.3-21.3 0c-17.7 0-32-14.3-32-32l0-21.3c0-17.7 14.3-32 32-32l21.3 0 0-21.3c0-17.7 14.3-32 32-32zm0 32l0 37.3c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-37.3 0 0 21.3 37.3 0c8.8 0 16 7.2 16 16l0 37.3 21.3 0 0-37.3c0-8.8 7.2-16 16-16l37.3 0 0-21.3-37.3 0c-8.8 0-16-7.2-16-16l0-37.3-21.3 0z'
      
    ]
  };

  

  
  

  var faPegasus = {
    prefix: 'fal',
    iconName: 'pegasus',
    icon: [
      576,
      512,
      [],
      'f703',
      
      'M333 153.3c1.1-1.5 1.9-3.3 2.5-5.2c.4-1.4 .6-2.9 .5-4.4C336.1 82 386.2 32 448 32l24 0 8 0 5.8 0c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1l-32 0c-8.8 0-16 7.2-16 16l0 52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9L384 472c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-137.3c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L202.2 291.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1l-33.2 0c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-21.8 13.8-40.5 33.2-47.6c-4.4-9.4-8.4-19.3-11.8-29.8c-20.4 7.7-37 23.3-46 43.1C31.3 180.8 0 214.7 0 256l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3l33.2 0c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6 304 472c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-153.6c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2l0-40 7.4 0 1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16L485.8 0 480 0l-8 0L448 0C377.4 0 318.7 50.8 306.4 117.8L159.9 34.1c-5-2.8-11-2.8-16 .1s-8 8.1-8 13.8c0 77.2 34.4 132.9 68.3 169c16.9 18 33.9 31.2 46.6 40c6.4 4.4 11.7 7.7 15.5 9.9c1.9 1.1 3.4 2 4.5 2.5c.5 .3 1 .5 1.3 .7l.4 .2 .1 .1c0 0 0 0 0 0s0 0 0 0L280 256l-7.2 14.3c7.9 4 17.5 .7 21.5-7.2s.8-17.5-7.1-21.5c0 0 0 0 0 0s0 0 0 0l-.2-.1-.9-.5c-.8-.4-2-1.1-3.6-2c-3.2-1.8-7.8-4.7-13.5-8.6c-11.3-7.8-26.4-19.5-41.4-35.5c-25.6-27.2-50.8-66.2-57.8-118.4l142.2 81.2c3 1.7 6.4 2.4 9.6 2c2.3-.2 4.5-1 6.4-2.1s3.6-2.6 5-4.5zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faArrowRightToBracket = {
    prefix: 'fal',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      'M347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c44.2 0 80-35.8 80-80l0-288c0-44.2-35.8-80-80-80l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-96 0z'
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faComputerMouse = {
    prefix: 'fal',
    iconName: 'computer-mouse',
    icon: [
      384,
      512,
      [128433,"mouse"],
      'f8cc',
      
      'M192 224L32 224l0 128c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128l0-128-160 0zm192-32l0 16 0 16 0 128c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 224l0-16 0-16 0-32C0 71.6 71.6 0 160 0l16 0 16 0 16 0 16 0c88.4 0 160 71.6 160 160l0 32zM208 32l0 160 144 0 0-32c0-70.7-57.3-128-128-128l-16 0zm-32 0l-16 0C89.3 32 32 89.3 32 160l0 32 144 0 0-160z'
      
    ]
  };

  
    var faMouse = faComputerMouse;
  

  
  

  var faCalendarStar = {
    prefix: 'fal',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM245.5 231.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3L224 260.2l18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z'
      
    ]
  };

  

  
  

  var faPersonToPortal = {
    prefix: 'fal',
    iconName: 'person-to-portal',
    icon: [
      512,
      512,
      ["portal-enter"],
      'e022',
      
      'M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM179.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L224.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L298 253.2c5.9 20.6 24.7 34.8 46.2 34.8l55.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.9 0c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L218.3 302.4 190.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1L101.3 384 16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.3 0c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM458.5 444.2C445.6 480 433.6 480 432 480c0 0 0 0 0 0s0 0 0 0c-1.6 0-13.6 0-26.4-35.8c-9.4-26.3-16.8-66.4-19.9-124.2l-32 0c7.3 140.7 39.7 192 78.4 192c44.2 0 80-66.6 80-256S476.2 0 432 0c-41.6 0-75.8 59-79.6 224l32 0c1.8-75.3 10.1-125.3 21.2-156.2C418.4 32 430.4 32 432 32c0 0 0 0 0 0s0 0 0 0c1.6 0 13.6 0 26.4 35.8C471.1 102.9 480 162.5 480 256s-8.9 153.1-21.5 188.2z'
      
    ]
  };

  
    var faPortalEnter = faPersonToPortal;
  

  
  

  var faSlash = {
    prefix: 'fal',
    iconName: 'slash',
    icon: [
      640,
      512,
      [],
      'f715',
      
      'M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1z'
      
    ]
  };

  

  
  

  var faLasso = {
    prefix: 'fal',
    iconName: 'lasso',
    icon: [
      576,
      512,
      [],
      'f8c8',
      
      'M576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105l-87 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l87 0c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 320c141.4 0 256-64.5 256-144S429.4 32 288 32S32 96.5 32 176s114.6 144 256 144z'
      
    ]
  };

  

  
  

  var faCircleQuarterStroke = {
    prefix: 'fal',
    iconName: 'circle-quarter-stroke',
    icon: [
      512,
      512,
      [],
      'e5d3',
      
      'M480 256C480 132.3 379.7 32 256 32l0 176c0 26.5-21.5 48-48 48L32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zM224 34.3C125.9 48.3 48.3 125.9 34.3 224L208 224c8.8 0 16-7.2 16-16l0-173.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faLocationXmark = {
    prefix: 'fal',
    iconName: 'location-xmark',
    icon: [
      384,
      512,
      ["map-marker-times","map-marker-xmark"],
      'f60e',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM116.7 116.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 192l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L192 214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 192l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faMapMarkerTimes = faLocationXmark;
  
    var faMapMarkerXmark = faLocationXmark;
  

  
  

  var faSpellCheck = {
    prefix: 'fal',
    iconName: 'spell-check',
    icon: [
      576,
      512,
      [],
      'f891',
      
      'M126.7 9.7C124.2 3.8 118.4 0 112 0s-12.2 3.8-14.7 9.7l-96 224c-3.5 8.1 .3 17.5 8.4 21s17.5-.3 21-8.4L54 192l116 0 23.3 54.3c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-96-224zM156.3 160l-88.6 0L112 56.6 156.3 160zM256 16l0 112 0 112c0 8.8 7.2 16 16 16l104 0c39.8 0 72-32.2 72-72c0-31.1-19.7-57.6-47.3-67.6C410.3 104.1 416 88.7 416 72c0-39.8-32.2-72-72-72L272 0c-8.8 0-16 7.2-16 16zm88 96l-56 0 0-80 56 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-56 32l56 0 32 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-88 0 0-80zM571.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L352 473.4 251.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l208-208z'
      
    ]
  };

  

  
  

  var faOctopus = {
    prefix: 'fal',
    iconName: 'octopus',
    icon: [
      640,
      512,
      [],
      'e688',
      
      'M192 160l0 3.3c0 7.5 .6 15.1 1.9 22.5c0 0 0 0 0 0l15.6 89.7 12.8 73.6c1.1 6.3 1.7 12.7 1.7 19.1l0 3.9c0 17.1-4 33.3-11.1 47.7l24.4-14c25.2-14.4 53.7-22 82.7-22s57.5 7.6 82.7 22l24.4 14C420 405.5 416 389.3 416 372.2l0-3.9c0-6.4 .6-12.8 1.7-19.1l12.8-73.6 15.6-89.7c1.3-7.4 1.9-15 1.9-22.5l0-3.3c0-70.7-57.3-128-128-128s-128 57.3-128 128zM452.4 336.3l-3.2 18.3c-.8 4.5-1.2 9.1-1.2 13.7l0 3.9c0 41.2 32.9 74.7 73.8 75.8c.8 0 1.6 0 2.5 0c36.3-.2 67.4-26.1 74.1-61.8l10-53.1c1.6-8.7 10-14.4 18.7-12.8s14.4 10 12.8 18.7l-10 53.1c-9.5 50.6-53.5 87.4-104.9 87.9c0 0 0 0 0 0l-.6 0-.5 0c-.9 0-1.8 0-2.7 0c-36.1-.6-71.5-10.4-102.9-28.3l-31.3-17.9C366.5 422.1 343.4 416 320 416s-46.5 6.1-66.8 17.7l-31.3 17.9c-31.4 17.9-66.8 27.7-102.9 28.3c-.9 0-1.8 0-2.7 0l-.5 0-.6 0s0 0 0 0c-51.4-.5-95.4-37.3-104.9-87.9L.3 338.9c-1.6-8.7 4.1-17 12.8-18.7s17 4.1 18.7 12.8l10 53.1c6.7 35.7 37.8 61.6 74.1 61.8c.8 0 1.6 0 2.5 0c40.9-1.1 73.8-34.6 73.8-75.8l0-3.9c0-4.6-.4-9.1-1.2-13.7l-3.2-18.3c-11.3 9.7-26.1 15.7-42.4 15.7c-31.3 0-58.3-22.3-64.1-53.1l-4.8-25.1C70.8 244.9 45.5 224 16 224c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.8 0 83.3 31.8 91.7 75.9l4.8 25.1c3 15.7 16.7 27.1 32.7 27.1c20.7 0 36.3-18.6 32.8-39c0 0 0 0 0 0l-15.6-89.7-.3-1.7c-1.4-8.1-2.1-16.3-2.1-24.6l0-1.7 0-3.3C160 71.6 231.6 0 320 0s160 71.6 160 160l0 3.3 0 1.7c0 8.2-.7 16.5-2.1 24.6l-.3 1.7L462 281s0 0 0 0c-3.5 20.4 12.1 39 32.8 39c16 0 29.7-11.4 32.7-27.1l4.8-25.1c8.4-44 46.9-75.9 91.7-75.9c8.8 0 16 7.2 16 16s-7.2 16-16 16c-29.5 0-54.8 20.9-60.3 49.9l-4.8 25.1c-5.9 30.8-32.8 53.1-64.1 53.1c-16.3 0-31.1-5.9-42.4-15.7zM272 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faCoffinCross = {
    prefix: 'fal',
    iconName: 'coffin-cross',
    icon: [
      384,
      512,
      [],
      'e051',
      
      'M35.6 136c-2.3 2.6-3.6 6-3.6 9.5c0 1.4 .2 2.7 .6 4L128.1 480l127.9 0 95.5-330.6c.4-1.3 .6-2.6 .6-4c0-3.5-1.3-6.9-3.6-9.5l-91-104-131 0-91 104zM11.5 114.9l91-104C108.5 4 117.3 0 126.5 0l131 0c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1l-127.9 0c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM208 112l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faGoalNet = {
    prefix: 'fal',
    iconName: 'goal-net',
    icon: [
      640,
      512,
      [],
      'e3ab',
      
      'M32 112c0-26.5 21.5-48 48-48l480 0c26.5 0 48 21.5 48 48l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-44.2-35.8-80-80-80L80 32C35.8 32 0 67.8 0 112L0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zm144 0c-8.8 0-16 7.2-16 16l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-64 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-64 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-64 0 0-64c0-8.8-7.2-16-16-16zm16 112l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zM192 384l0-64 64 0 0 64-64 0zm96 0l0-64 64 0 0 64-64 0zm96 0l0-64 64 0 0 64-64 0z'
      
    ]
  };

  

  
  

  var faXRay = {
    prefix: 'fal',
    iconName: 'x-ray',
    icon: [
      512,
      512,
      [],
      'f497',
      
      'M0 48c0-8.8 7.2-16 16-16l32 0 416 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 384 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0L48 480l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L32 64 16 64C7.2 64 0 56.8 0 48zM64 64l0 384 384 0 0-384L64 64zM256 96c8.8 0 16 7.2 16 16l0 32 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 32 96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0 0 53.5 45.1-17.4c7-2.7 14.4-4.1 21.9-4.1l2.2 0c32.5 0 58.8 26.3 58.8 58.8c0 13.2-4.4 25.9-12.5 36.3l-18.2 23.2c-12.7 16.2-32.2 25.7-52.9 25.7l-120.8 0c-20.6 0-40.1-9.5-52.9-25.7l-18.2-23.2C116.4 356.8 112 344 112 330.8c0-32.5 26.3-58.8 58.8-58.8l2.1 0c7.5 0 14.9 1.4 21.9 4.1L240 293.5l0-53.5-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-32-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-8.8 7.2-16 16-16zM144 330.8c0 6 2 11.8 5.7 16.5l18.2 23.2c6.7 8.5 16.9 13.5 27.7 13.5l120.8 0c10.8 0 21-5 27.7-13.5l18.2-23.2c3.7-4.7 5.7-10.5 5.7-16.5c0-14.8-12-26.8-26.8-26.8l-2.2 0c-3.6 0-7.1 .7-10.4 1.9l-55.3 21.3c-11.1 4.3-23.4 4.3-34.5 0l-55.3-21.3c-3.3-1.3-6.9-1.9-10.4-1.9l-2.1 0C156 304 144 316 144 330.8zM192 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowDownFromBracket = {
    prefix: 'fal',
    iconName: 'arrow-down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e667',
      
      'M235.3 507.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 457.4 208 176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 281.4L340.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM32 176c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 80C0 35.8 35.8 0 80 0L368 0c44.2 0 80 35.8 80 80l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80l0 96z'
      
    ]
  };

  

  
  

  var faDiagramVenn = {
    prefix: 'fal',
    iconName: 'diagram-venn',
    icon: [
      640,
      512,
      [],
      'e15a',
      
      'M224 448C118 448 32 362 32 256S118 64 224 64c21.5 0 42.1 3.5 61.4 10C228.8 114.7 192 181 192 256s36.8 141.3 93.4 182c-19.3 6.5-39.9 10-61.4 10zM415.3 240l-190.7 0c1.4-16.7 4.9-32.8 10.3-48l170.2 0c5.4 15.2 8.9 31.3 10.3 48zM224.7 272l190.7 0c-1.4 16.7-4.9 32.8-10.3 48l-170.2 0c-5.4-15.2-8.9-31.3-10.3-48zm25 80l140.6 0c-16.9 29.1-41.2 53.5-70.3 70.3c-29.1-16.9-53.5-41.2-70.3-70.3zm0-192c16.9-29.1 41.2-53.5 70.3-70.3c29.1 16.9 53.5 41.2 70.3 70.3l-140.6 0zM224 480c34.4 0 66.9-7.7 96-21.6c29.1 13.8 61.6 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480zM416 64c106 0 192 86 192 192s-86 192-192 192c-21.5 0-42.1-3.5-61.4-10C411.2 397.3 448 331 448 256s-36.8-141.3-93.4-182c19.3-6.5 39.9-10 61.4-10z'
      
    ]
  };

  

  
  

  var faFileLock = {
    prefix: 'fal',
    iconName: 'file-lock',
    icon: [
      576,
      512,
      [],
      'e3a6',
      
      'M384 192l-32 0-32 0-80 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 28.1zM240 160l111.5 0c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16zm224 64c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faEar = {
    prefix: 'fal',
    iconName: 'ear',
    icon: [
      384,
      512,
      [128066],
      'f5f0',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192l0 176c0 61.9 50.1 112 112 112s112-50.1 112-112c0-16.4 8.2-32.2 22.5-41.4C322.8 298.1 352 248.5 352 192zm32 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368L0 192C0 86 86 0 192 0S384 86 384 192zm-272 0l0 6.3c0 10.7 5.3 20.7 14.2 26.6l8.9 5.9c15.5 10.4 24.9 27.8 24.9 46.5c0 16.6-7.4 32.3-20.1 42.9l-33.7 28c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5l33.7-28c5.4-4.5 8.6-11.2 8.6-18.3c0-8-4-15.4-10.6-19.9l-8.9-5.9C90.7 239.7 80 219.7 80 198.3l0-6.3c0-61.9 50.1-112 112-112s112 50.1 112 112l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faPlaneCircleExclamation = {
    prefix: 'fal',
    iconName: 'plane-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e556',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7l0 52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6l0 56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6l0 42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2c0 0 0 0 0 0L256 480.6l105.7 30.2s0 0 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4l0-39.4 57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8l0-56.2c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9l0-61.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7l0 61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1l0-52.5c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faWindow = {
    prefix: 'fal',
    iconName: 'window',
    icon: [
      512,
      512,
      [],
      'f40e',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFaceAstonished = {
    prefix: 'fal',
    iconName: 'face-astonished',
    icon: [
      512,
      512,
      [],
      'e36b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-32zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faPipeSmoking = {
    prefix: 'fal',
    iconName: 'pipe-smoking',
    icon: [
      640,
      512,
      [],
      'e3c4',
      
      'M586.6 32c-35.2 0-68.4 16.6-89.5 44.7L395 212.5c18.2 15.5 22.4 42.4 8.9 62.8L296 439.8C266.5 484.9 216.2 512 162.3 512l-2.3 0C71.6 512 0 440.4 0 352l0-72c0-30.9 25.1-56 56-56l144 0c28.4 0 51.9 21.2 55.5 48.6l49.5-66c14.9-19.9 42.5-25 63.5-12.1l103-137C498.7 21.3 541.3 0 586.6 0L624 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-37.4 0zm-256 193.8L252.8 329.6c-4.1 5.5-11.3 7.8-17.9 5.6S224 326.9 224 320l0-40c0-13.3-10.7-24-24-24L56 256c-13.3 0-24 10.7-24 24l0 72c0 70.7 57.3 128 128 128l2.3 0c43.1 0 83.4-21.7 107-57.8L377.2 257.8c4.8-7.3 2.8-17.2-4.5-22.1l-20.4-13.6c-7.1-4.7-16.6-3.1-21.7 3.7z'
      
    ]
  };

  

  
  

  var faFileInvoiceDollar = {
    prefix: 'fal',
    iconName: 'file-invoice-dollar',
    icon: [
      384,
      512,
      [],
      'f571',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm144 99.6l0 13.6c8.3 1.1 16.3 2.7 23.7 4.5c8.6 2 13.9 10.7 11.9 19.3s-10.7 13.9-19.3 11.9c-11.2-2.6-22.2-4.6-32.5-4.8c-8.7-.1-17.9 1.7-24.3 5.1c-6.1 3.2-7.4 6.3-7.4 9.4c0 1.5 .2 3.6 6.6 7c7 3.7 16.8 6.4 29.4 9.8l.5 .1c11.3 3 25.2 6.8 36.1 12.9c11.8 6.6 23.1 17.7 23.4 35.9c.3 18.9-10.6 31.7-23.6 38.9c-7.5 4.1-15.9 6.6-24.4 7.9l0 13.5c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-14.1c-10.9-1.9-21.2-5-30.3-7.8c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.2-1.3-6.2-1.9c-8.5-2.5-13.3-11.4-10.8-19.9s11.4-13.3 19.9-10.8c2.4 .7 4.8 1.4 7.1 2.1c13.6 4.1 24.8 7.5 36.8 7.9c9.4 .3 18.5-1.6 24.4-4.9c5.4-3 7.2-6.2 7.1-10.4c0-2.4-.8-4.9-7-8.4c-6.9-3.9-16.8-6.7-29.2-10l-1.6-.4c-11-3-24.2-6.5-34.6-12.1c-11.5-6.2-23.3-16.9-23.4-35.1c-.1-19 11.9-31.3 24.5-37.9c7.3-3.8 15.4-6.2 23.4-7.5l0-13.7c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faScalpelLineDashed = {
    prefix: 'fal',
    iconName: 'scalpel-line-dashed',
    icon: [
      576,
      512,
      ["scalpel-path"],
      'f61e',
      
      'M441.4 32c-11.4 0-22.2 5-29.5 13.7L234.4 256l98.2 0c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5l0-4C480 49.3 462.7 32 441.4 32zm-54-6.9C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6l0 4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17L200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320l45.3 0L59.7 474.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320l32.2 0c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L169.4 320zM304 480c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm64 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faScalpelPath = faScalpelLineDashed;
  

  
  

  var faHandsBound = {
    prefix: 'fal',
    iconName: 'hands-bound',
    icon: [
      640,
      512,
      [],
      'e4f9',
      
      'M16.8 48C16.8 21.2 38.7-.4 65.5 0c26 .4 47.2 23.7 47.2 49.7L112 154.7 173.9 228c7.1 8.4 20.1-1.8 13.6-10.7l-28.6-39.2c-13.4-18.5-13.1-44.6 2.5-61.4c25.5-27.4 60.5-15.2 74.4 4l42.3 58.4c16.6 22.1 25.6 49.1 25.6 76.9l0 96.1 32.2 0 0-96.1c0-27.7 9-54.7 25.6-76.9l42.3-58.4c13.9-19.2 48.9-31.4 74.4-4c15.6 16.7 15.9 42.9 2.5 61.4l-28.6 39.2c-6.5 9 6.5 19.1 13.6 10.7l61.9-73.4-.7-104.9c0-26 21.2-49.4 47.2-49.7c26.8-.4 48.7 21.2 48.7 48l.8 138.2c0 11-3.7 21.5-10.5 30L506.4 349.9c-.5 .7-1.1 1.4-1.6 2.1l23.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l22.9 0c-.5-.7-1-1.4-1.6-2.1L26.5 216.2c-6.7-8.5-10.5-19-10.5-30L16.8 48zM170.2 352l101.7 0-.1-96.1c0-20.6-6.7-41.1-19.5-58L210 139.6c-5.4-7.4-15.4-8.7-22.3-3.5c-7.9 5.6-8.4 15.7-3.5 22.2l30.5 42.2c.2 .2 .5 .5 .5 .8c26.1 39.7-33.8 86.7-70.7 42.4L87.4 175.2c-4.8-5.8-7.5-13.1-7.4-20.7l.6-105.9c0-22.4-32-21.7-32-.7L48 186.2c0 3.6 1.2 7.2 3.5 10L158.3 329.9c5 6.2 9 13.9 11.9 22.1zm311.2-22.1L588.3 196.2c2.2-2.7 3.5-6.4 3.5-10l-.7-138.3c0-21-32-21.6-32 .7l.6 105.9c0 7.5-2.6 14.9-7.4 20.7l-57.1 68.5c-36.8 44.4-96.8-2.6-70.7-42.4c0-.2 .2-.5 .5-.8l30.5-42.2c4.9-6.5 4.4-16.6-3.5-22.2c-7-5.2-17-3.9-22.3 3.5l-42.3 58.4c-12.7 16.9-19.5 37.4-19.5 58l-.1 96.1 101.7 0c2.9-8.2 6.9-15.9 11.9-22.1zM112 416l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-96 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-96 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faClockThree = {
    prefix: 'fal',
    iconName: 'clock-three',
    icon: [
      512,
      512,
      [],
      'e356',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144c0 8.8 7.2 16 16 16l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSpider = {
    prefix: 'fal',
    iconName: 'spider',
    icon: [
      512,
      512,
      [128375],
      'f717',
      
      'M158.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L83.6 101c-8.9 17.9-5.9 39.5 7.8 54.1l71.1 76.5L60.8 204.9c-5.2-1.4-9.4-5.3-11.1-10.4L31.2 138.9c-2.8-8.4-11.9-12.9-20.2-10.1S-2 140.7 .8 149.1l18.5 55.6C24.5 220 37 231.8 52.7 235.9L129.1 256 52.7 276.1C37 280.2 24.5 292 19.3 307.4L.8 362.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l18.5-55.6c1.7-5.1 5.9-9 11.1-10.4l84-22.1L85 368.7c-9.4 13.1-11.5 30.1-5.7 45.1l33.8 87.9c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-33.8-87.9c-1.9-5-1.2-10.7 1.9-15L144.1 341c2.6 59.5 51.7 107 111.9 107s109.3-47.5 111.9-107L401 387.3c3.1 4.4 3.8 10 1.9 15l-33.8 87.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l33.8-87.9c5.8-15.1 3.6-32-5.7-45.1L367.2 285l84 22.1c5.2 1.4 9.4 5.3 11.1 10.4l18.5 55.6c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-18.5-55.6c-5.1-15.4-17.7-27.1-33.3-31.2L382.9 256l76.5-20.1c15.7-4.1 28.2-15.9 33.3-31.2l18.5-55.6c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-18.5 55.6c-1.7 5.1-5.9 9-11.1 10.4L349.6 231.7l71.1-76.5c13.6-14.7 16.7-36.2 7.8-54.1L382.3 8.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l46.1 92.2c3 6 2 13.2-2.6 18L336 199.3l0-47.3c0-32.2-19-59.9-46.3-72.6c-7.7-3.6-16.8-.5-20.8 6.9L256 110.3 243.1 86.3c-4-7.5-13.2-10.5-20.8-6.9C195 92.1 176 119.8 176 152l0 47.3-61.2-65.9c-4.5-4.9-5.6-12.1-2.6-18l46.1-92.2zm130.4 93.8c9.4 8.8 15.2 21.3 15.2 35.1l0 104s0 0 0 0l0 .4c0 4.6 1.9 8.9 5.3 12C325.7 283 336 304.3 336 328l0 8c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-8c0-23.7 10.3-45 26.7-59.6c3.4-3 5.3-7.4 5.3-12l0-.4s0 0 0 0l0-104c0-13.8 5.9-26.3 15.2-35.1l18.7 34.7c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l18.7-34.7z'
      
    ]
  };

  

  
  

  var faBracketCurlyRight = {
    prefix: 'fal',
    iconName: 'bracket-curly-right',
    icon: [
      256,
      512,
      [],
      '7d',
      
      'M192 112c0-44.2-35.8-80-80-80L48 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c26.5 0 48 21.5 48 48l0 53.5c0 21.2 8.4 41.6 23.4 56.6L217.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6l0 53.5c0 26.5-21.5 48-48 48l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c44.2 0 80-35.8 80-80l0-53.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9l0-53.5z'
      
    ]
  };

  

  
  

  var faFileDashedLine = {
    prefix: 'fal',
    iconName: 'file-dashed-line',
    icon: [
      640,
      512,
      ["page-break"],
      'f877',
      
      'M480 448c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-96-32 0 0 96c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-96-32 0 0 96zm0-256l0 64 32 0 0-92.1c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 192 32 0 0-192c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0zm-.5-32L368 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM48 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 288zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  
    var faPageBreak = faFileDashedLine;
  

  
  

  var faArrowUpFromSquare = {
    prefix: 'fal',
    iconName: 'arrow-up-from-square',
    icon: [
      512,
      512,
      [],
      'e09c',
      
      'M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-104 104c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6 240 320c0 8.8 7.2 16 16 16s16-7.2 16-16l0-265.4 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-104-104zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32z'
      
    ]
  };

  

  
  

  var faBinBottlesRecycle = {
    prefix: 'fal',
    iconName: 'bin-bottles-recycle',
    icon: [
      640,
      512,
      [],
      'e5f6',
      
      'M384 16c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L400 0c-8.8 0-16 7.2-16 16zM352 192c0-28.1-12.1-53.4-31.4-71c-17.1-15.5-39.7-25-64.6-25L128 96c-53 0-96 43-96 96l32 0c0-35.3 28.7-64 64-64l128 0c35.3 0 64 28.7 64 64l32 0zm223.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-11-5.1-23-7.8-35.1-7.8l-90.6 0c-12.1 0-24.1 2.7-35.1 7.8L354.1 78c-7.2 3.4-13.5 8-18.6 13.6c8.4 6.7 16 14.4 22.5 22.9c2.6-3.2 5.9-5.8 9.7-7.6l13.2-6.2c6.7-3.2 14.1-4.8 21.5-4.8l90.6 0c7.4 0 14.8 1.6 21.5 4.8l13.1 6.2c9.8 4.6 16 14.4 16 25.2c0 5.8-1.7 11.1-4.7 15.5c-7.1 10.6-7.2 24.4-.4 35.1c1.8 2.8 3.2 5.9 4 9.2l32.5 0zm21.2 32l-18.6 0L62.3 224l-18.6 0-9.8 0L16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l17.9 0L55.7 441.3c4.7 40.3 38.9 70.7 79.5 70.7l369.7 0c40.6 0 74.7-30.4 79.5-70.7L606.1 256l17.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-17.9 0-9.8 0zM87.5 437.6L66.1 256l507.8 0L552.5 437.6c-2.8 24.2-23.3 42.4-47.7 42.4l-369.7 0c-24.3 0-44.8-18.2-47.7-42.4zM319.9 320c4.6 0 9 2.3 11.5 6.2l8.5 12.9c4.8 7.3 14.5 9.4 21.8 4.8c7.6-4.8 9.8-14.9 4.9-22.4l-8.5-12.9c-8.5-12.9-22.8-20.6-38.2-20.6c-15.3 0-29.6 7.7-38.1 20.4l-7.6 11.4c-5 7.5-2.8 17.7 4.8 22.4c7.3 4.6 17 2.5 21.8-4.7l7.6-11.4c2.6-3.8 6.9-6.1 11.5-6.1zm-59.4 48.4c-7.3-4.6-17-2.5-21.8 4.7l-7.9 11.9c-4.4 6.7-6.8 14.5-6.8 22.5c0 22.4 18.2 40.6 40.6 40.6l25.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.2 0c-4.7 0-8.6-3.8-8.6-8.6c0-1.7 .5-3.3 1.4-4.7l7.9-11.9c5-7.5 2.8-17.7-4.8-22.4zM337.7 432c0 8.8 7.2 16 16 16l20.9 0c22.4 0 40.6-18.2 40.6-40.6c0-7.9-2.3-15.7-6.7-22.4l-6.6-10.1c-4.8-7.3-14.5-9.4-21.8-4.8c-7.6 4.8-9.8 14.9-4.9 22.4l6.6 10.1c.9 1.4 1.4 3.1 1.4 4.7c0 4.8-3.9 8.6-8.6 8.6l-20.9 0c-8.8 0-16 7.2-16 16zM160 0c-17.7 0-32 14.3-32 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 64 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16c0-17.7-14.3-32-32-32L160 0z'
      
    ]
  };

  

  
  

  var faGripLinesVertical = {
    prefix: 'fal',
    iconName: 'grip-lines-vertical',
    icon: [
      192,
      512,
      [],
      'f7a5',
      
      'M32 32c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16L48 48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faMobileRetro = {
    prefix: 'fal',
    iconName: 'mobile-retro',
    icon: [
      320,
      512,
      [],
      'e527',
      
      'M256 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l192 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 160l0 64L96 224l0-64 128 0zM96 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z'
      
    ]
  };

  

  
  

  var faPersonRunning = {
    prefix: 'fal',
    iconName: 'person-running',
    icon: [
      448,
      512,
      [127939,"running"],
      'f70c',
      
      'M280 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 280 0zM140.6 116.4c12.7-3.2 26.1-3.2 38.8 0L274 140c16.6 4.2 29.8 16.9 34.5 33.4l20.3 71c2 6.9 8.2 11.6 15.4 11.6l55.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-55.9 0c-21.4 0-40.3-14.2-46.2-34.8l-13.6-47.7L247.2 317.1c-.2 .5-.3 .9-.5 1.3l37.5 21.1c13.6 7.6 19.7 23.9 14.5 38.5L255.1 501.3c-2.9 8.3-12.1 12.7-20.4 9.8s-12.7-12.1-9.8-20.4l43.5-123.3-93.3-52.5c-20-11.3-29.3-35.2-22-57l35.4-106.2-16.9-4.2c-7.6-1.9-15.6-1.9-23.3 0l-1.5 .4c-7.4 1.8-14.2 5.4-20 10.4L74.5 204c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l52.4-45.8c9.6-8.4 21-14.3 33.3-17.4l1.5-.4zm79.1 43.1L183.5 268c-2.4 7.3 .7 15.2 7.3 19l27.5 15.4 44.1-132.3-42.7-10.7zM101.3 384L130 314.1c5.9 10 14.1 18.7 24.1 25.4l-23.3 56.6c-4.9 12-16.6 19.8-29.6 19.8L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l85.3 0z'
      
    ]
  };

  
    var faRunning = faPersonRunning;
  

  
  

  var faShuffle = {
    prefix: 'fal',
    iconName: 'shuffle',
    icon: [
      512,
      512,
      [128256,"random"],
      'f074',
      
      'M427.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 112 400 112l-56 0c-20.1 0-39.1 9.5-51.2 25.6L244 202.7l20 26.7 54.4-72.5c6-8.1 15.5-12.8 25.6-12.8l56 0 57.4 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80zM124.8 361.6c-3 4-7.8 6.4-12.8 6.4l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c15.1 0 29.3-7.1 38.4-19.2L204 309.3l-20-26.7-59.2 78.9zM404.7 475.3c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 368 400 368l-56 0c-10.1 0-19.6-4.7-25.6-12.8l-168-224C141.3 119.1 127.1 112 112 112l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c5 0 9.8 2.4 12.8 6.4l168 224C304.9 390.5 323.9 400 344 400l56 0 57.4 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faRandom = faShuffle;
  

  
  

  var faPeanuts = {
    prefix: 'fal',
    iconName: 'peanuts',
    icon: [
      640,
      512,
      [129372],
      'e431',
      
      'M297.7 160.7c4.7-18.7 3.4-38.9-5.1-57.9L269.9 51.9c-7.5-16.9-27.4-24.5-44.3-17L174.7 57.6c-11.1 4.9-20.7 11.8-28.5 20.1c0 0 0 0 0 0c-7.8 8.2-14.2 18-18.5 29.3l-.1 .4s0 0 0 0c-4.3 11.3-6.1 22.8-5.8 34.1c0 0 0 0 0 0c.2 6.2 1 12.5 2.5 18.7l.1 .2 .1 .2c4.9 21.3 9.1 50.3-1.8 78.6s-33.4 47-51.3 59.6l-.2 .1-.2 .1c-5.3 3.6-10.1 7.7-14.3 12.2c0 0 0 0 0 0c-7.8 8.2-14.2 18.1-18.6 29.5c-4.4 11.4-6.2 23-5.9 34.3c0 0 0 0 0 0c.3 11.3 2.8 22.9 7.7 34l22.7 50.9c7.4 16.6 26.5 24.2 43.2 17.5c4.4 10 10.3 19.2 17.3 27.3l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.5 50.6c-2.9 8.4-5.1 17.1-6.7 26c-3.9 19.7-9.2 34.7-17.3 45.3zm-42.3 89.1l-.2 0c-8.2 1.5-16 3.8-23.5 6.9c0 0 0 0 0 0c-13.7 5.6-26.5 14-37.7 25.2c-11.2 11.2-19.5 24-25.2 37.6c0 0 0 0 0 0c-5.7 13.6-8.8 28.6-8.8 44.4l0 68c0 26.5 21.5 48 48 48l68 0c32.4 0 61.6-13.2 82.7-34.6c0 0 0 0 0 0c10.8-11 19-23.6 24.5-37c0 0 0 0 0 0c3.1-7.5 5.4-15.3 6.9-23.5l0-.2 0-.2c5.1-25.9 14.4-58.5 39-83.1s57.2-33.9 83.1-39l.2 0 .2 0c8.2-1.5 16-3.8 23.5-6.9c0 0 0 0 0 0c13.7-5.6 26.5-14 37.7-25.2c11.2-11.2 19.5-24 25.2-37.6c0 0 0 0 0 0c5.7-13.6 8.8-28.6 8.8-44.4l0-68c0-26.5-21.5-48-48-48l-68 0c-32.4 0-61.6 13.2-82.7 34.6c0 0 0 0 0 0c-10.8 11-19 23.6-24.5 37c0 0 0 0 0 0c-3.1 7.5-5.4 15.3-6.9 23.5l0 .2-.1 .2c-5.1 25.9-14.4 58.5-39 83.1s-57.2 33.9-83.1 39l-.2 0zm126.1 218C354.7 495.1 317.3 512 276 512l-68 0c-44.2 0-80-35.8-80-80l0-68c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30c7.1-17.1 17.5-33.2 31.3-47.2C413.3 16.9 450.7 0 492 0l68 0c44.2 0 80 35.8 80 80l0 68c0 20.1-4 39.2-11.2 56.7c-7.2 17.5-17.9 33.8-32.1 48c-14.2 14.2-30.6 24.9-48.1 32.1c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2zM544 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-64 64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-224 224a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 416a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM544 172.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 352a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0z'
      
    ]
  };

  

  
  

  var faTransporter1 = {
    prefix: 'fal',
    iconName: 'transporter-1',
    icon: [
      512,
      512,
      [],
      'e043',
      
      'M256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM464 128c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zM48 320c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zm80 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM320 193.1l0 94.9-32 0 0-111.8c-1.6-.2-3.1-.2-4.7-.2l-54.6 0c-1.6 0-3.2 .1-4.7 .2L224 288l-32 0 0-94.9c-.5 .6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7l54.6 0c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9zM176 320l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faArrowUpLeft = {
    prefix: 'fal',
    iconName: 'arrow-up-left',
    icon: [
      384,
      512,
      [],
      'e09d',
      
      'M48 96c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-185.4L324.7 411.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 128 272 128c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 96z'
      
    ]
  };

  

  
  

  var faSquarePhoneHangup = {
    prefix: 'fal',
    iconName: 'square-phone-hangup',
    icon: [
      448,
      512,
      ["phone-square-down"],
      'e27a',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zm64 32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM81.1 246.7c78.8-72.9 207-72.9 285.7 0c.8 .7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7c-37-11.9-77.4-11.9-114.3 0c-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9L80.4 250.4c-.4-.7-.5-1.2-.4-1.8s.3-1.2 1.1-1.9zm307.5-23.5c-91-84.3-238.2-84.3-329.2 0c-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9c0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1 .5-.1 .7c-1.8 16.6 8.5 31.3 23.3 36.9L327 317.5c16.6 6.3 36.4 .6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z'
      
    ]
  };

  
    var faPhoneSquareDown = faSquarePhoneHangup;
  

  
  

  var faShieldSlash = {
    prefix: 'fal',
    iconName: 'shield-slash',
    icon: [
      640,
      512,
      [],
      'e24b',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM418 414.9c-23.5 22.9-51.8 43.3-85.4 59.4c-7.9 3.8-17.2 3.8-25.1 0C169.2 408.2 122.9 270.7 113.8 174.7L80.1 148.2c2.6 100.7 45.8 274.7 213.5 355c16.7 8 36.1 8 52.8 0c38.6-18.5 70.6-41.9 97-68.2l-25.4-20zM295 7.8L174 59.2l28.6 22.6L307.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.2 45.8-9.6 108.6-37.1 169.6l25.8 20.4c32.5-68.7 43-139.7 43.3-189.8c.1-26.2-16.3-47.9-38.3-57.2L345 7.8c-16-6.8-34-6.8-50 0z'
      
    ]
  };

  

  
  

  var faCircleU = {
    prefix: 'fal',
    iconName: 'circle-u',
    icon: [
      512,
      512,
      [],
      'e127',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 61.9 50.1 112 112 112s112-50.1 112-112l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-128z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMax = {
    prefix: 'fal',
    iconName: 'gauge-simple-max',
    icon: [
      512,
      512,
      ["tachometer-fastest"],
      'f62b',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerFastest = faGaugeSimpleMax;
  

  
  

  var faPlaneTail = {
    prefix: 'fal',
    iconName: 'plane-tail',
    icon: [
      512,
      512,
      [],
      'e22c',
      
      'M47.7 32l46.4 0c12.5 0 24.4 4.8 33.4 13.5L345 256l-80.6 0c-7 0-13.9 .9-20.6 2.7L85.9 300.8 32 51.4C29.9 41.4 37.5 32 47.7 32zM.7 58.1L55 309l-6.7 1.8C19.8 318.4 0 344.2 0 373.7c0 27.3 17 51.7 42.7 61.1l197.1 72.3c8.8 3.2 18.1 4.9 27.5 4.9L496 512c8.8 0 16-7.2 16-16s-7.2-16-16-16l-228.6 0c-5.6 0-11.2-1-16.5-2.9L53.7 404.8C40.7 400 32 387.6 32 373.7c0-15 10.1-28.1 24.6-32L252 289.6c4-1.1 8.2-1.6 12.4-1.6L496 288c8.8 0 16-7.2 16-16s-7.2-16-16-16l-105.7 0 .4-.4-11.5-11.1L149.7 22.5C134.8 8.1 114.9 0 94.1 0L47.7 0C17.1 0-5.7 28.2 .7 58.1zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faShapes = {
    prefix: 'fal',
    iconName: 'shapes',
    icon: [
      512,
      512,
      ["triangle-circle-square"],
      'f61f',
      
      'M411.4 175.5c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2l-192 0c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM288 32L192 192l192 0L288 32zM472 304l-144 0c-4.4 0-8 3.6-8 8l0 144c0 4.4 3.6 8 8 8l144 0c4.4 0 8-3.6 8-8l0-144c0-4.4-3.6-8-8-8zM328 272l144 0c22.1 0 40 17.9 40 40l0 144c0 22.1-17.9 40-40 40l-144 0c-22.1 0-40-17.9-40-40l0-144c0-22.1 17.9-40 40-40zM224 384A96 96 0 1 0 32 384a96 96 0 1 0 192 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z'
      
    ]
  };

  
    var faTriangleCircleSquare = faShapes;
  

  
  

  var faChargingStation = {
    prefix: 'fal',
    iconName: 'charging-station',
    icon: [
      576,
      512,
      [],
      'f5e7',
      
      'M256 32c17.7 0 32 14.3 32 32l0 416L64 480 64 64c0-17.7 14.3-32 32-32l160 0zM32 64l0 416-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 224 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-192 16 0c26.5 0 48 21.5 48 48l0 48c0 35.3 28.7 64 64 64s64-28.7 64-64l0-113.6c36.5-7.4 64-39.7 64-78.4l0-48c0-8.8-7.2-16-16-16l-16 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-16 0c-8.8 0-16 7.2-16 16l0 48c0 38.7 27.5 71 64 78.4L480 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-44.2-35.8-80-80-80l-16 0 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64zm432 96l64 0 16 0 0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32 16 0zM204.8 121.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-72 96c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8l80 0-52.8 70.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l72-96c3.6-4.8 4.2-11.3 1.5-16.8s-8.3-8.8-14.3-8.8l-80 0 52.8-70.4z'
      
    ]
  };

  

  
  

  var faMaximize = {
    prefix: 'fal',
    iconName: 'maximize',
    icon: [
      512,
      512,
      ["expand-arrows-alt"],
      'f31e',
      
      'M50.2 196.5l.6 .2c8.2 2 16.8-.4 22.8-6.3l47.1-47.1L233.4 256 120.7 368.7 73.6 321.6c-6-6-14.6-8.4-22.8-6.3l-.6 .2C39.5 318.1 32 327.7 32 338.7L32 456c0 13.3 10.7 24 24 24l117.3 0c11 0 20.6-7.5 23.3-18.2l.2-.6c2-8.2-.4-16.8-6.3-22.8l-47.1-47.1L256 278.6 368.7 391.3l-47.1 47.1c-6 6-8.4 14.6-6.3 22.8l.2 .6c2.7 10.7 12.3 18.2 23.3 18.2L456 480c13.3 0 24-10.7 24-24l0-117.3c0-11-7.5-20.6-18.2-23.3l-.6-.2c-8.2-2-16.8 .4-22.8 6.3l-47.1 47.1L278.6 256 391.3 143.3l47.1 47.1c6 6 14.6 8.4 22.8 6.3l.6-.2c10.7-2.7 18.2-12.3 18.2-23.3L480 56c0-13.3-10.7-24-24-24L338.7 32c-11 0-20.6 7.5-23.3 18.2l-.2 .6c-2 8.2 .4 16.8 6.3 22.8l47.1 47.1L256 233.4 143.3 120.7l47.1-47.1c6-6 8.4-14.6 6.3-22.8l-.2-.6C193.9 39.5 184.3 32 173.3 32L56 32C42.7 32 32 42.7 32 56l0 117.3c0 11 7.5 20.6 18.2 23.3zM64 154.7L64 64l90.7 0L64 154.7zM154.7 448L64 448l0-90.7L154.7 448zM448 154.7L357.3 64 448 64l0 90.7zM357.3 448L448 357.3l0 90.7-90.7 0z'
      
    ]
  };

  
    var faExpandArrowsAlt = faMaximize;
  

  
  

  var faLightbulbGear = {
    prefix: 'fal',
    iconName: 'lightbulb-gear',
    icon: [
      576,
      512,
      [],
      'e5fd',
      
      'M336 176c0 13.7-1.9 27-5.5 39.5c3.3 1 6.5 2.3 9.5 4l0-.9c0-17.8 10.2-35.6 28-43.3C367.6 78.4 289 0 192 0C94.8 0 16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l32.4 0c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1c0 0 0 0 0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM258.5 443c-5.1-8.8-9.3-17.8-12.8-27l-123 0c-5.9 0-10.7 4.8-10.7 10.7l0 5.3c0 44.2 35.8 80 80 80c35.2 0 65.1-22.8 75.8-54.4c-3.3-4.7-6.4-9.5-9.4-14.6zM192 96c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM146.7 448l90.5 0c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM399.3 239.8l33.7 0c3 16.6 13.9 29.5 26.5 36.7c12.9 7.4 30 9.9 45.9 3.6l17.2 30.5c-12.8 11.4-18.5 27.7-18.5 42.4s5.7 31 18.5 42.4L505.3 426c-15.9-6.3-32.9-3.7-45.9 3.6c-12.6 7.2-23.5 20.2-26.5 36.7l-33.7 0c-3.1-16.6-14-29.5-26.6-36.7c-13-7.4-30-9.9-46-3.7l-17.2-30.5c12.8-11.4 18.5-27.7 18.5-42.4s-5.7-31-18.5-42.4l17.2-30.5c15.9 6.3 33 3.7 46-3.7c12.6-7.2 23.6-20.1 26.6-36.7zm43.5-32l-53.4 0c-11.7 0-21.3 9.5-21.3 21.3l0 1.4c0 7.6-4.6 14.4-11.3 18.2c-6.6 3.7-14.7 4.2-21.2 .3l-1.6-1c-10.7-6.3-24.4-2.6-30.5 8.2L277 303.1c-5.7 10.2-2.3 23.1 7.8 29c7.3 4.3 11.2 12.6 11.2 21s-3.9 16.7-11.2 21c-10 5.9-13.5 18.8-7.8 29L303.5 450c6.1 10.8 19.9 14.5 30.5 8.2l1.6-1c6.5-3.9 14.6-3.4 21.2 .3c6.6 3.8 11.3 10.6 11.3 18.2l0 1.4c0 11.7 9.5 21.3 21.3 21.3l53.4 0c11.8 0 21.4-9.6 21.4-21.4l0-1.6c0-7.5 4.6-14.2 11.1-18c6.5-3.7 14.5-4.2 21-.3l1.8 1c10.7 6.3 24.4 2.6 30.5-8.2L555 403.1c5.7-10.2 2.3-23-7.8-29c-7.3-4.3-11.2-12.6-11.2-21s3.9-16.7 11.2-21c10-5.9 13.5-18.8 7.8-29l-26.4-46.9c-6.1-10.8-19.9-14.5-30.5-8.2l-1.8 1c-6.5 3.8-14.5 3.4-21-.3c-6.5-3.7-11.1-10.4-11.1-18l0-1.6c0-11.8-9.6-21.4-21.4-21.4zM416.1 409.1a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-24-56a24 24 0 1 1 48.1 0 24 24 0 1 1 -48.1 0z'
      
    ]
  };

  

  
  

  var faCactus = {
    prefix: 'fal',
    iconName: 'cactus',
    icon: [
      512,
      512,
      [127797],
      'f8a7',
      
      'M320 464c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-144 0-32 0-32 0-32 0-128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 256 0 32 0 32 0 32 0 16zm32-112l0-256c0-53-43-96-96-96s-96 43-96 96l0 128-48 0c-8.8 0-16-7.2-16-16l0-64c0-26.5-21.5-48-48-48S0 117.5 0 144l0 64c0 61.9 50.1 112 112 112l48 0 0 144c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-16 48 0c61.9 0 112-50.1 112-112l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64c0 8.8-7.2 16-16 16l-48 0zm0 32l48 0c26.5 0 48-21.5 48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 44.2-35.8 80-80 80l-48 0 0-32zM112 288c-44.2 0-80-35.8-80-80l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5 21.5 48 48 48l48 0 0 32-48 0zM256 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSignalBarsGood = {
    prefix: 'fal',
    iconName: 'signal-bars-good',
    icon: [
      640,
      512,
      ["signal-alt-3"],
      'f693',
      
      'M416 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16s16 7.2 16 16l0 288zM400 128c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48zM256 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160zM240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM96 432l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z'
      
    ]
  };

  
    var faSignalAlt3 = faSignalBarsGood;
  

  
  

  var faClockFourThirty = {
    prefix: 'fal',
    iconName: 'clock-four-thirty',
    icon: [
      512,
      512,
      [],
      'e34b',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400l0-114.1 71.1 47.4c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-96-64c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1l0 144c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faArrowPointer = {
    prefix: 'fal',
    iconName: 'arrow-pointer',
    icon: [
      320,
      512,
      ["mouse-pointer"],
      'f245',
      
      'M0 426L0 55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1l-136.4 0 61.1 137.5c3.6 8.1 0 17.5-8.1 21.1s-17.5 0-21.1-8.1l-61-137.2L38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22zM32 72l0 328 86.4-100.8c6.1-7.1 15-11.2 24.3-11.2L272 288 32 72z'
      
    ]
  };

  
    var faMousePointer = faArrowPointer;
  

  
  

  var faClockSevenThirty = {
    prefix: 'fal',
    iconName: 'clock-seven-thirty',
    icon: [
      512,
      512,
      [],
      'e351',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400l0-91.2-34.7 52c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l64-96c3.9-5.9 11.2-8.5 17.9-6.4s11.4 8.3 11.4 15.3l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faVenusMars = {
    prefix: 'fal',
    iconName: 'venus-mars',
    icon: [
      640,
      512,
      [9892],
      'f228',
      
      'M176 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM352 176c0 91.8-70.3 167.2-160 175.3l0 64.7 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64.7C70.3 343.2 0 267.8 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c9.7-5.1 19-10.9 27.8-17.4C325.6 368.5 361 384 400 384c79.5 0 144-64.5 144-144s-64.5-144-144-144c-10.5 0-20.7 1.1-30.6 3.3c-4.1-10.2-8.9-20.1-14.5-29.4C369.3 66 384.4 64 400 64c42.8 0 82.1 15.3 112.6 40.7L585.4 32 496 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L624 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-72.7 72.7C560.7 157.9 576 197.2 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z'
      
    ]
  };

  

  
  

  var faBox = {
    prefix: 'fal',
    iconName: 'box',
    icon: [
      448,
      512,
      [128230],
      'f466',
      
      'M342.4 64L240 64l0 96 165.9 0L371.7 83c-5.1-11.6-16.6-19-29.2-19zM416 192l-176 0-32 0L32 192l0 224c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-224zM42.1 160L208 160l0-96L105.6 64c-12.6 0-24.1 7.4-29.2 19L42.1 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38l236.8 0z'
      
    ]
  };

  

  
  

  var faPageCaretDown = {
    prefix: 'fal',
    iconName: 'page-caret-down',
    icon: [
      384,
      512,
      ["file-caret-down"],
      'e429',
      
      'M352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l181.5 0c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6L352 448zM64 512l256 0c35.3 0 64-28.7 64-64l0-309.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64zM180.2 346.8c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2l-139.6 0c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6zM140.4 256l103.3 0L192 312.3 140.4 256z'
      
    ]
  };

  
    var faFileCaretDown = faPageCaretDown;
  

  
  

  var faCross = {
    prefix: 'fal',
    iconName: 'cross',
    icon: [
      384,
      512,
      [10013,128327],
      'f654',
      
      'M128 40c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 88 88 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-88 0 0 216c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-216-88 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l88 0 0-88zm40-8c-4.4 0-8 3.6-8 8l0 104c0 8.8-7.2 16-16 16L40 160c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l104 0c8.8 0 16 7.2 16 16l0 232c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-232c0-8.8 7.2-16 16-16l104 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-104 0c-8.8 0-16-7.2-16-16l0-104c0-4.4-3.6-8-8-8l-48 0z'
      
    ]
  };

  

  
  

  var faRepeat = {
    prefix: 'fal',
    iconName: 'repeat',
    icon: [
      512,
      512,
      [128257],
      'f363',
      
      'M15.2 272C6.4 271.5-.4 264 0 255.2l.4-8C5.1 153.5 82.4 80 176.2 80L320 80l0-44.4C320 20.3 332.3 8 347.6 8c6.8 0 13.4 2.5 18.4 7.1l76.7 69c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-76.7 69c-5.1 4.6-11.6 7.1-18.4 7.1c-15.2 0-27.6-12.3-27.6-27.6l0-44.4-143.8 0c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zM352 146.5L408.1 96 352 45.5l0 100.9zM496.8 240c8.8 .4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2L192 432l0 44.4c0 15.2-12.3 27.6-27.6 27.6c-6.8 0-13.4-2.5-18.4-7.1l-76.7-69c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l76.7-69c5.1-4.6 11.6-7.1 18.4-7.1c15.2 0 27.6 12.3 27.6 27.6l0 44.4 143.8 0c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2zM160 365.5L103.9 416 160 466.5l0-100.9z'
      
    ]
  };

  

  
  

  var faDialMin = {
    prefix: 'fal',
    iconName: 'dial-min',
    icon: [
      576,
      512,
      [],
      'e161',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM276.7 276.7l-89.8 89.8c-39.1-50.2-35.5-122.9 10.6-169c50-50 131-50 181 0s50 131 0 181c-46.2 46.2-118.8 49.7-169 10.6l89.8-89.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fal',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M226.5 168.8L287.9 42.3l61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0L150.2 473.2l23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z'
      
    ]
  };

  

  
  

  var faDiamondExclamation = {
    prefix: 'fal',
    iconName: 'diamond-exclamation',
    icon: [
      512,
      512,
      [],
      'e405',
      
      'M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faSignalBars = {
    prefix: 'fal',
    iconName: 'signal-bars',
    icon: [
      640,
      512,
      ["signal-alt","signal-alt-4","signal-bars-strong"],
      'f690',
      
      'M576 464l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16zM512 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 416c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-416zM416 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 288c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-288zM256 464l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16zM240 256c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32z'
      
    ]
  };

  
    var faSignalAlt = faSignalBars;
  
    var faSignalAlt4 = faSignalBars;
  
    var faSignalBarsStrong = faSignalBars;
  

  
  

  var faSprayCanSparkles = {
    prefix: 'fal',
    iconName: 'spray-can-sparkles',
    icon: [
      512,
      512,
      ["air-freshener"],
      'f5d0',
      
      'M128 32l0 64L96 96l0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64-32 0 0-64-64 0zM96 160c-35.3 0-64 28.7-64 64l0 216c0 22.1 17.9 40 40 40l176 0c22.1 0 40-17.9 40-40l0-216c0-35.3-28.7-64-64-64L96 160zM0 224c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 216c0 39.8-32.2 72-72 72L72 512c-39.8 0-72-32.2-72-72L0 224zm208 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 320a80 80 0 1 1 160 0A80 80 0 1 1 80 320zM336 0c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zM480 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 192l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64-96l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faAirFreshener = faSprayCanSparkles;
  

  
  

  var faCommentText = {
    prefix: 'fal',
    iconName: 'comment-text',
    icon: [
      512,
      512,
      [],
      'e14d',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0-64 0z'
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fal',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      'M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391s0 0 0 0l25.1-25.1c-2.2-2.2-5.2-3.8-8.4-4.4L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c.6 3.3 2.2 6.2 4.4 8.4L391 121s0 0 0 0L371.1 13.1zM256 128c-70.7 0-128 57.3-128 128c0 35.3 14.3 67.3 37.5 90.5l22.6-22.6C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96c26.5 0 50.5 10.7 67.9 28.1l22.6-22.6C323.4 142.3 291.3 128 256 128zm248 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM160 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm160 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM344 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCameraRotate = {
    prefix: 'fal',
    iconName: 'camera-rotate',
    icon: [
      640,
      512,
      [],
      'e0d8',
      
      'M255.1 32c-20.7 0-39 13.2-45.5 32.8L199.1 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-71.1 0L430.5 64.8C423.9 45.2 405.6 32 384.9 32L255.1 32zM239.9 74.9c2.2-6.5 8.3-10.9 15.2-10.9l129.9 0c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9l82.7 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l82.7 0c6.9 0 13-4.4 15.2-10.9l14-42.1zM416 272c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 25.4-14.1-14.1C368.5 185.8 344.7 176 320 176c-39 0-73.3 19.9-93.3 50.1c-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C267.7 222.2 292.2 208 320 208c16.2 0 31.8 6.5 43.3 17.9L377.4 240 352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zM224 304c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-25.4 14.1 14.1C271.5 390.2 295.3 400 320 400c39 0 73.3-19.9 93.3-50.1c4.9-7.4 2.9-17.3-4.5-22.2s-17.3-2.9-22.2 4.5C372.3 353.8 347.8 368 320 368c-16.2 0-31.8-6.5-43.3-17.9L262.6 336l25.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z'
      
    ]
  };

  

  
  

  var faUniformMartialArts = {
    prefix: 'fal',
    iconName: 'uniform-martial-arts',
    icon: [
      640,
      512,
      [],
      'e3d1',
      
      'M176 0c-.9 0-1.8 .1-2.7 .2C135.2 2.6 100.8 24.3 82.2 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4L0 368c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 0-47.6 32-58.2L160 288l32 0 0-166.8c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4L96 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-127.6c0-16.2 4.1-32.1 11.9-46.3L110.3 73.4C123.8 49 149 33.3 176.7 32.1c.4 0 .7 0 1.1-.1l52.3 0 72 144-56 112 35.8 0 52.4-104.8L409.9 32l52.3 0c.4 0 .7 .1 1.1 .1c27.7 1.3 53 16.9 66.4 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3L608 368c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-127.6c0-5.4-1.4-10.7-4-15.4L481.2 118c-1.4-2.6-3.1-5.1-5-7.3c-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15L448 288l32 0 0-105.7 32 58.2 0 47.6 0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-127.6c0-21.6-5.4-42.8-15.8-61.7L557.8 58c-18.5-33.7-53-55.4-91.1-57.8c-.9-.1-1.8-.2-2.7-.2L400 0 240 0 176 0zm89.9 32l108.2 0L320 140.2 265.9 32zM448 384l0 72c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-72-32 0 0 72c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-72-32 0zM144 336c0 8.8 7.2 16 16 16l130.1 0-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352 480 352c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0-160 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faFaceWeary = {
    prefix: 'fal',
    iconName: 'face-weary',
    icon: [
      512,
      512,
      [],
      'e3a1',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c24.2 0 48.2 3.4 71.4 10c-3.5-5.1-7.7-10.3-12.6-15.2c-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2c23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2c9.8 9.8 17.8 20.8 23.4 31.5c5.5 10.4 9.3 21.8 9.3 32.4c0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4c5.6-10.7 13.6-21.6 23.4-31.5c19.5-19.5 47.9-36.2 81.3-36.2zM211.3 164.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faEggFried = {
    prefix: 'fal',
    iconName: 'egg-fried',
    icon: [
      512,
      512,
      [],
      'f7fc',
      
      'M461.1 182.8c31.6 42.6 22.6 102.7-19.9 134.3c-13.4 9.9-28.4 15.8-43.8 18c-23.8 3.3-49.1 13.4-70.9 26.8c-21.6 13.3-42.8 31.8-55.7 54.1C235.5 477.2 157.2 498.2 96 462.9S13.8 349.2 49.1 288c28.1-48.6 42.7-116.9 47.2-168.4c2-22.3 11.7-44 29.1-60.8c38.2-36.7 99-35.5 135.7 2.7c17.9 18.6 42.8 36.8 68.2 51.6s53.5 27.6 78.5 33.9c20.6 5.3 39.6 17.4 53.3 35.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 336a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 240a128 128 0 1 0 256 0A128 128 0 1 0 96 240zm88 0c0-22.1 17.9-40 40-40c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faCircleBookmark = {
    prefix: 'fal',
    iconName: 'circle-bookmark',
    icon: [
      512,
      512,
      ["bookmark-circle"],
      'e100',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 176c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 158.7-54-43.2c-5.8-4.7-14.1-4.7-20 0l-54 43.2L192 176zm16-48c-26.5 0-48 21.5-48 48l0 192c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4l0-192c0-26.5-21.5-48-48-48l-96 0z'
      
    ]
  };

  
    var faBookmarkCircle = faCircleBookmark;
  

  
  

  var faBellExclamation = {
    prefix: 'fal',
    iconName: 'bell-exclamation',
    icon: [
      448,
      512,
      [],
      'f848',
      
      'M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM200 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40-176l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBan = {
    prefix: 'fal',
    iconName: 'ban',
    icon: [
      512,
      512,
      [128683,"cancel"],
      'f05e',
      
      'M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faCancel = faBan;
  

  
  

  var faScalpel = {
    prefix: 'fal',
    iconName: 'scalpel',
    icon: [
      512,
      512,
      [],
      'f61d',
      
      'M200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6l0 4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17L200 288zM411.9 45.7L234.4 256l98.2 0c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5l0-4C480 49.3 462.7 32 441.4 32c-11.4 0-22.2 5-29.5 13.7zM4.7 484.7L169.4 320l45.3 0L59.7 474.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320l32.2 0c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4z'
      
    ]
  };

  

  
  

  var faPersonCircleMinus = {
    prefix: 'fal',
    iconName: 'person-circle-minus',
    icon: [
      576,
      512,
      [],
      'e540',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91L224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCircleThreeQuartersStroke = {
    prefix: 'fal',
    iconName: 'circle-three-quarters-stroke',
    icon: [
      512,
      512,
      [],
      'e5d4',
      
      'M477.7 288L272 288c-26.5 0-48-21.5-48-48l0-205.7C115.4 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.4 221.7-192zm2.3-32C480 132.3 379.7 32 256 32l0 208c0 8.8 7.2 16 16 16l208 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faHouseFlag = {
    prefix: 'fal',
    iconName: 'house-flag',
    icon: [
      640,
      512,
      [],
      'e50d',
      
      'M464 0c-8.8 0-16 7.2-16 16l0 16 0 32 0 96 0 32 0 320 32 0 0-320 144 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L480 32l0-16c0-8.8-7.2-16-16-16zm16 160l0-96 128 0 0 96-128 0zm-64-24L281.6 35.2c-5.7-4.3-13.5-4.3-19.2 0l-256 192c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L64 224l0 216c0 39.8 32.2 72 72 72l272 0c2.7 0 5.4-.2 8-.4l0-32.4c-2.6 .5-5.3 .8-8 .8l-64 0 0-128c0-17.7-14.3-32-32-32l-80 0c-17.7 0-32 14.3-32 32l0 128-64 0c-22.1 0-40-17.9-40-40l0-240L272 68 416 176l0-40zM312 352l0 128-80 0 0-128 80 0z'
      
    ]
  };

  

  
  

  var faChartArea = {
    prefix: 'fal',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM297.4 214.6c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l39.6-39.6 62 72.3c2.5 2.9 3.9 6.6 3.9 10.4l0 94.2-320 0 0-108.1c0-4.2 1.7-8.3 4.7-11.3L224 141.3l73.4 73.4zm0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9L96 352c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-94.2c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-16.9 16.9L320 192l-22.6-22.6z'
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faMoneyBillWave = {
    prefix: 'fal',
    iconName: 'money-bill-wave',
    icon: [
      576,
      512,
      [],
      'f53a',
      
      'M32 184c35.3 0 64-28.7 64-64l0-.5c-18.5-1.4-37.1-4.4-55.8-9.5c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 .1L32 184zm0 192l0 46.3c0 6.8 3.7 10.4 6.2 11.3C57.3 440.8 76.5 445 96 446.8l0-6.8c0-35.3-28.7-64-64-64zm0-32c53 0 96 43 96 96l0 8c44.7-1 91.1-11.7 141.3-24.5c4.3-1.1 8.6-2.2 13-3.3c51.8-13.3 108-27.6 165.7-28.6c.2-52.8 43.1-95.6 96-95.6l0-128c-53 0-96-43-96-96l0-8c-44.7 1-91.1 11.7-141.3 24.5c-4.3 1.1-8.6 2.2-13 3.3c-51.8 13.3-108 27.6-165.7 28.6c-.2 52.8-43.1 95.6-96 95.6l0 128zm503.8 58c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0l0-.1 0-71.5c-35.3 0-64 28.7-64 64l0 .5c18.5 1.4 37.1 4.4 55.8 9.5zM480 72c0 35.3 28.7 64 64 64l0-46.3c0-6.8-3.7-10.4-6.2-11.3C518.7 71.2 499.5 67 480 65.2l0 6.8zM0 422.3L0 112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3l0 309.9c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z'
      
    ]
  };

  

  
  

  var faPizzaSlice = {
    prefix: 'fal',
    iconName: 'pizza-slice',
    icon: [
      512,
      512,
      [],
      'f818',
      
      'M167.5 32.8c-6.1-.4-12.4 3.7-14.4 11.1l-10 37.6C295 96.1 415.9 217 430.5 368.9l37.6-10c7.4-2 11.5-8.3 11.1-14.4C467.7 177.7 334.3 44.3 167.5 32.8zM38.6 473.4l360.5-96.1c-11-140.9-123.5-253.4-264.4-264.4L38.6 473.4zM4.7 507.3c-4-4-5.6-9.9-4.1-15.4L122.2 35.6C127.7 14.9 146.9-.7 169.7 .9C352.5 13.5 498.5 159.5 511.1 342.3c1.6 22.8-14 41.9-34.7 47.5L20.1 511.5c-5.5 1.5-11.4-.1-15.4-4.1zM176 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTruckBolt = {
    prefix: 'fal',
    iconName: 'truck-bolt',
    icon: [
      640,
      512,
      [],
      'e3d0',
      
      'M352 32c17.7 0 32 14.3 32 32l0 320-133.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l288 0zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-148.2c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352zM416 128l65.3 0c4.7 0 9.1 2 12.1 5.6L570.9 224 416 224l0-96zm0 216.4l0-88.4 160 0 0 128-5.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM251.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l89.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-89.4 0 68.7-68.7z'
      
    ]
  };

  

  
  

  var faSignPosts = {
    prefix: 'fal',
    iconName: 'sign-posts',
    icon: [
      576,
      512,
      [],
      'e625',
      
      'M48 64c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-16 0-32 0L96 64 64 64 48 64zM512 32l16 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-16 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80L96 416l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-16 0c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l16 0 0-16C64 7.2 71.2 0 80 0s16 7.2 16 16l0 16 384 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16z'
      
    ]
  };

  

  
  

  var faMailbox = {
    prefix: 'fal',
    iconName: 'mailbox',
    icon: [
      576,
      512,
      [128234],
      'f813',
      
      'M32 208l0 176c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-176c0-61.9-50.1-112-112-112S32 146.1 32 208zm256 0l0 176c0 11.7-3.1 22.6-8.6 32L512 416c17.7 0 32-14.3 32-32l0-176c0-61.9-50.1-112-112-112L234.5 96c32.6 26.4 53.5 66.8 53.5 112zM64 448c-35.3 0-64-28.7-64-64L0 208C0 128.5 64.5 64 144 64l288 0c79.5 0 144 64.5 144 144l0 176c0 35.3-28.7 64-64 64l-288 0L64 448zm48-256l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0l96 0 56 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-72-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96l32 0 0-64-32 0 0 64z'
      
    ]
  };

  

  
  

  var faChartLineUp = {
    prefix: 'fal',
    iconName: 'chart-line-up',
    icon: [
      512,
      512,
      [],
      'e0e5',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zm288 96c0 8.8 7.2 16 16 16l89.4 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0L448 182.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faBuildingLock = {
    prefix: 'fal',
    iconName: 'building-lock',
    icon: [
      576,
      512,
      [],
      'e4d6',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 208c0-30.5 12.2-58.2 32-78.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm152-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm208-64c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm-80 48l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80l0 128-160 0 0-128 160 0z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCircleUser = {
    prefix: 'fal',
    iconName: 'rectangle-history-circle-user',
    icon: [
      640,
      512,
      [],
      'e4a4',
      
      'M480 192l0 .7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7l0-.7c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zM448 64L64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0L112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM556 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6l56.4 0c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8l-56.4 0c-21.8 0-42.2 9.6-56.1 25.8C394.5 422.1 384 396.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faPersonDressFairy = {
    prefix: 'fal',
    iconName: 'person-dress-fairy',
    icon: [
      640,
      512,
      [],
      'e607',
      
      'M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM304.3 192c-14.3 0-26.8 9.5-30.8 23.2L234.4 352l171.2 0L366.5 215.2C362.6 201.5 350 192 335.7 192l-31.5 0zm0-32l31.5 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L384 384l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-64 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-9.3 5.3-17.8 12.1-24.9 20.1C185.4 101.7 113.1 64 32 64l0 48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5c6.8 5.3 8.1 15 3 22l-9.1 12.4C108.5 373.6 96 409.3 96 448l16 0c39.2 0 75.4-12.8 104.7-34.5c2.4 .7 4.8 1.2 7.3 1.6l0 32.1C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM407.7 160.5c-7.1-8.1-15.5-14.9-24.9-20.1C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0c-41.2 0-79.7-12-112-32.7l0-32.1c2.5-.4 5-1 7.3-1.6C452.6 435.2 488.8 448 528 448l16 0c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4c-5.1-7-3.7-16.7 3-22l12.1-9.5C572.3 256.6 608 188.5 608 112l0-48c-81.1 0-153.4 37.7-200.3 96.5z'
      
    ]
  };

  

  
  

  var faTabletButton = {
    prefix: 'fal',
    iconName: 'tablet-button',
    icon: [
      448,
      512,
      [],
      'f10a',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fal',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      'M356.9 120.3c-74.4-75-194.9-75-269.3 0s-74.4 196.5 0 271.4s194.9 75 269.3 0c6.2-6.3 16.3-6.3 22.5 0s6.2 16.4 0 22.7c-86.8 87.5-227.5 87.5-314.4 0s-86.8-229.4 0-316.9s227.5-87.5 314.4 0c6.2 6.3 6.2 16.4 0 22.7s-16.3 6.3-22.5 0z'
      
    ]
  };

  

  
  

  var faLocationArrow = {
    prefix: 'fal',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      'M224 224L48 224 400 80 256 432l0-176c0-17.7-14.3-32-32-32zm-32 32l32 0 0 32 0 144c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l144 0z'
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fal',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM240 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faFaceSmileTear = {
    prefix: 'fal',
    iconName: 'face-smile-tear',
    icon: [
      512,
      512,
      [],
      'e393',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm194.3-1.5c5.1-7.7 10.7-15.1 16.2-22c5.5 6.9 11 14.3 16.2 22c11.4 17.1 15.8 29 15.8 34.9c0 12.2-11.7 26.7-32 26.7s-32-14.5-32-26.7c0-5.9 4.4-17.8 15.8-34.9zm7.7-62.3c-1.6 2-3.3 4.1-5.2 6.3c-18.9 23-50.3 61.2-50.3 90.8c0 32.5 28.7 58.7 64 58.7s64-26.2 64-58.7c0-29.2-30.8-66.9-49.6-90c0 0 0 0 0 0s0 0 0 0c-2.1-2.6-4.1-5-5.8-7.2c-4.3-5.5-12.8-5.5-17.1 0zM200.4 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRoadBridge = {
    prefix: 'fal',
    iconName: 'road-bridge',
    icon: [
      640,
      512,
      [],
      'e563',
      
      'M576 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32l-80 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-80 0c-17.7 0-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32l80 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 80 0zm0-32L384 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64zM480 192c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l272 0 0-32-48 0 0-64 48 0 0-32L16 96zM264 288c-48.6 0-88 39.4-88 88l0 88c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-88c0-48.6-39.4-88-88-88l-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l8 0c30.9 0 56 25.1 56 56l0 88c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-88c0-30.9 25.1-56 56-56l24 0 0-32-24 0zM208 128l0 64-96 0 0-64 96 0z'
      
    ]
  };

  

  
  

  var faCalendarPen = {
    prefix: 'fal',
    iconName: 'calendar-pen',
    icon: [
      448,
      512,
      ["calendar-edit"],
      'f333',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zM295.6 257.9c-6.2-6.2-16.4-6.2-22.6 0l-12.2 12.2 29.1 29.1L302.1 287c6.2-6.2 6.2-16.4 0-22.6l-6.4-6.4zm-28.4 63.9l-29.1-29.1L150 381l-8.6 37.7L179 410l88.2-88.2zm-16.9-86.5c18.7-18.7 49.1-18.7 67.9 0l6.4 6.4c18.7 18.7 18.7 49.1 0 67.9l-123 123c-4.3 4.3-9.6 7.2-15.5 8.6L136 452.7c-17.3 4-32.7-11.5-28.8-28.8l11.5-50.2c1.3-5.9 4.3-11.2 8.6-15.5l123-123z'
      
    ]
  };

  
    var faCalendarEdit = faCalendarPen;
  

  
  

  var faFolderImage = {
    prefix: 'fal',
    iconName: 'folder-image',
    icon: [
      512,
      512,
      [],
      'e18a',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zm88 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 352l-248.7 0 44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 277.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7c-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2c0 15.6 12.6 28.2 28.2 28.2l263.7 0c15.5 0 28.1-12.6 28.1-28.1c0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2c-10 0-19.4 4.7-25.5 12.7z'
      
    ]
  };

  

  
  

  var faPersonHalfDress = {
    prefix: 'fal',
    iconName: 'person-half-dress',
    icon: [
      320,
      512,
      [],
      'e548',
      
      'M160.5 80c-.2 0-.3 0-.5 0c-13.3 0-24-10.7-24-24c0-11.6 8.2-21.2 19.1-23.5c.4-.1 .7-.1 1.1-.2c1.2-.2 2.5-.3 3.8-.3c13.3 0 24 10.7 24 24c0 10.7-7 19.8-16.7 22.9c-1.5 .5-3 .8-4.6 1c-.7 .1-1.5 .1-2.2 .1zM173 110.5c24.7-5.8 43-28 43-54.5c0-30.9-25.1-56-56-56c0 0 0 0 0 0c-5.9 0-11.6 .9-16.9 2.6C120.4 9.8 104 31 104 56c0 30.9 25.1 56 56 56c2.9 0 5.8-.2 8.6-.7c1.5-.2 2.9-.5 4.3-.8zM192 320l0 32s0 0 0 0l0 64s0 0 0 0l0 80c0 8.8 7.2 16 16 16c1 0 2-.1 2.9-.3c1.1-.2 2.2-.5 3.3-1c5.7-2.4 9.8-8.1 9.8-14.7l0-293.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-10.8-20.2-29.6-34.6-51.3-39.9l0 33.7s0 0 0 0l0 156s0 0 0 0zm-65.7-56.8c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l48 0 0 96c0 8.8 7.2 16 16 16c0 0 0 0 0 0c0 0 0 0 0 0c0 0-.1 0-.1 0c0 0 0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0c8.8 0 16-7.2 16-16l0-96 32 0 0-32-48 0-38.1 0 52.4-104.8zM160 128s0 0 0 0c-37.3 0-71.7 20.6-89.3 53.5L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L99 196.6c12-22.5 35.5-36.6 61-36.6c0 0 0 0 0 0l0-32z'
      
    ]
  };

  

  
  

  var faFileChartColumn = {
    prefix: 'fal',
    iconName: 'file-chart-column',
    icon: [
      384,
      512,
      ["file-chart-line"],
      'f659',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zM112 368c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z'
      
    ]
  };

  
    var faFileChartLine = faFileChartColumn;
  

  
  

  var faSynagogue = {
    prefix: 'fal',
    iconName: 'synagogue',
    icon: [
      640,
      512,
      [128333],
      'f69b',
      
      'M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166l0 78.1 53.3-48c6.1-5.5 15.3-5.5 21.4 0l69.4 62.5c10.1 9.1 15.9 22.1 15.9 35.7L640 448c0 35.3-28.7 64-64 64l-112 0-80 0-32 0-64 0-32 0-80 0L64 512c-35.3 0-64-28.7-64-64L0 294.3c0-13.6 5.8-26.6 15.9-35.7l69.4-62.5c6.1-5.5 15.3-5.5 21.4 0l53.3 48 0-78.1c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM480 480l96 0c17.7 0 32-14.3 32-32l0-153.7c0-4.5-1.9-8.9-5.3-11.9L544 229.5l-58.7 52.8c-3.4 3-5.3 7.4-5.3 11.9L480 480zM448 166c0-14.2-6.3-27.8-17.3-36.9L320 36.8 209.3 129.1C198.3 138.2 192 151.7 192 166l0 128.3L192 480l64 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 64 0 0-185.7L448 166zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 64 0 0-96zM160 294.3c0-4.5-1.9-8.9-5.3-11.9L96 229.5 37.3 282.4c-3.4 3-5.3 7.4-5.3 11.9L32 448c0 17.7 14.3 32 32 32l96 0 0-185.7zM351.5 138.8l26-.2c17-.2 27.5 18.4 18.6 32.9L383.4 192 396 212.6c8.9 14.5-1.6 33-18.6 32.9l-26-.2-12.9 21.9c-8.3 14.2-28.9 14.2-37.3 0l-12.9-21.9-26 .2c-17 .2-27.5-18.4-18.6-32.9L256.6 192 244 171.4c-8.9-14.5 1.6-33 18.6-32.9l26 .2 12.9-21.9c8.3-14.2 28.9-14.2 37.3 0l12.9 21.9zM308 159.3c-2.5 4.2-7 6.8-11.9 6.7l-23.7-.2 11.7 19.1c2.7 4.4 2.7 9.9 0 14.2l-11.7 19.1 23.7-.2c4.9 0 9.4 2.5 11.9 6.7l12 20.5 12-20.5c2.5-4.2 7-6.8 11.9-6.7l23.7 .2-11.7-19.1c-2.7-4.4-2.7-9.9 0-14.2l11.7-19.1-23.7 .2c-4.9 0-9.4-2.5-11.9-6.7l-12-20.5-12 20.5z'
      
    ]
  };

  

  
  

  var faGlobe = {
    prefix: 'fal',
    iconName: 'globe',
    icon: [
      512,
      512,
      [127760],
      'f0ac',
      
      'M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7l-172 0c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320l183.4 0c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64l-183.4 0c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160l172 0c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64l90.8 0c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64L380 192zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3l83.8 0zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160l83.7 0zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64l90.8 0c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64l-90.8 0zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3l-83.8 0c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3l-83.7 0c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z'
      
    ]
  };

  

  
  

  var faPersonDolly = {
    prefix: 'fal',
    iconName: 'person-dolly',
    icon: [
      512,
      512,
      [],
      'f4d0',
      
      'M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM60 176c7 0 13.8 1.5 20 4.2l0 139.3L39.1 292.2c-4.5-3-7.1-8-7.1-13.3L32 204c0-15.5 12.5-28 28-28zm52 38.5l37.8 58.8c5.9 9.2 16 14.7 26.9 14.7l51.8 0L254 393.7c-18 11.3-30 31.4-30 54.3c0 35.3 28.7 64 64 64c33.8 0 61.5-26.2 63.8-59.5l148-37c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L346 421c-10.2-21.9-32.3-37-58-37c-1.1 0-2.3 0-3.4 .1L231.6 164.2c-2.1-8.6-10.7-13.9-19.3-11.8s-13.9 10.7-11.8 19.3L220.8 256l-44 0-47.8-74.4C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60l0 74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8l0-126.3zM256 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM441.2 322.3l-91.5 22.9-22.9-91.5 91.5-22.9 22.9 91.5zm31-7.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8z'
      
    ]
  };

  

  
  

  var faLocationCrosshairsSlash = {
    prefix: 'fal',
    iconName: 'location-crosshairs-slash',
    icon: [
      640,
      512,
      ["location-slash"],
      'f603',
      
      'M395.5 397.1C373 409.2 347.3 416 320 416c-88.4 0-160-71.6-160-160c0-14 1.8-27.7 5.2-40.7l-27-21.3c-5 14.6-8.2 30-9.6 46L80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l48.7 0c7.7 93.3 82.1 167.6 175.3 175.3l0 48.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48.7c31.6-2.6 61-12.9 86.4-28.9l-27-21.3zM304 64.7c-31.6 2.6-61 12.9-86.4 28.9l27 21.3C267 102.8 292.7 96 320 96c88.4 0 160 71.6 160 160c0 14-1.8 27.7-5.2 40.7l27 21.3c5-14.6 8.2-30 9.6-46l48.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48.7 0C503.6 146.7 429.3 72.4 336 64.7L336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48.7zM320 352c5.6 0 11.2-.5 16.5-1.4l-55.7-44c-.3-.2-.6-.5-.9-.7l-55.7-44c3 50.3 44.8 90.1 95.8 90.1zM303.5 161.4l55.7 44c.3 .2 .6 .5 .9 .7l55.7 44C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faLocationSlash = faLocationCrosshairsSlash;
  

  
  

  var faSteak = {
    prefix: 'fal',
    iconName: 'steak',
    icon: [
      576,
      512,
      [129385],
      'f824',
      
      'M368 32c-31 0-57 9.9-77.4 28.9L268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5l21.8 23.4c-18.4 17.1-29.1 39-36.5 55.9c-4.3 9.8-7.8 18.3-11 26l-1.1 2.6c-9.5 23-17.5 42.4-35.9 60.7c-24.6 24.6-52.8 39.8-77.6 52.4c-2.8 1.4-5.5 2.8-8.2 4.2c0 0 0 0 0 0s0 0 0 0c-22.2 11.2-40.9 20.7-57.8 34.3C44.4 311.4 32 332.3 32 360c0 61.4 53 90.2 88.4 102.4C159.3 475.8 205.2 480 240 480c74 0 147.9-28.1 203.5-69.5C497.9 370 544 309.5 544 240c0-52.2-20.6-102.6-50.5-140C464.1 63.3 419.7 32 368 32zM352 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM121.9 297.7c28.3-11.9 65.5-27.6 106.8-69c23.4-23.4 35.6-52.6 47.2-81.3l.1-.2s0 0 0 0c2.4-5.9 4.8-11.9 7.3-17.6c7.1-16.3 15.7-32.9 29-45.3c14-13 32-20.3 55.6-20.3c38.6 0 74.7 23.8 100.5 56c26 32.5 43.5 75.9 43.5 120c0 55.2-37.2 107.3-87.6 144.8C373.6 422.6 306.3 448 240 448c-32.9 0-74.9-4.1-109.2-15.9C97.5 420.7 64 399 64 360c0-7.5 1.1-15.6 4.7-23.6c3.7-8.3 9.1-13.9 13.5-17.7c10.2-8.6 24.2-14.6 37.6-20.2l.8-.3s0 0 0 0l1.2-.5s0 0 0 0zm12.4 29.5l-1.2 .5c-15.2 6.4-24.3 10.5-30.2 15.5C98.6 346.8 96 351 96 360c0 16.7 14.1 31.2 45.2 41.9C170.9 412.1 209 416 240 416c58.6 0 119.4-22.6 165.3-56.8C451.7 324.6 480 280.8 480 240c0-35.9-14.5-72.5-36.5-100c-22.2-27.8-50.1-44-75.5-44c-16.3 0-26.3 4.7-33.9 11.7c-8.2 7.6-14.6 19-21.5 34.7c-2.3 5.3-4.6 11-7.1 17c-11.4 28.1-25.6 63.2-54.3 91.9c-45.8 45.8-87.7 63.5-117 75.8z'
      
    ]
  };

  

  
  

  var faBullhorn = {
    prefix: 'fal',
    iconName: 'bullhorn',
    icon: [
      512,
      512,
      [128226,128363],
      'f0a1',
      
      'M448 44.2c0-36.2-44.2-53.8-69-27.5L355.1 41.9c-47.8 50.4-113 80.7-182.4 84.5L143.6 128 64 128c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 104c0 30.9 25.1 56 56 56l16 0c30.9 0 56-25.1 56-56l0-100.6c62.1 7.9 119.8 37 163.1 82.8L379 463.3c24.9 26.2 69 8.6 69-27.5l0-391.5zM160 352.9L160 456c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-104 47.6 0 16.4 .9zM402.2 38.7c5-5.3 13.8-1.7 13.8 5.5l0 391.5c0 7.2-8.8 10.8-13.8 5.5l-23.8-25.1C336.5 372 282.7 341.6 224 328.5l0-177.1c58.7-13.1 112.5-43.4 154.4-87.6l23.8-25.1zM192 156.9l0 166.3c-5.8-.7-11.6-1.1-17.5-1.5L144.9 320l-.4 0-.4 0-80 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l80 0 .4 0 .4 0 29.7-1.6c5.8-.3 11.7-.8 17.5-1.5zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faBoxCheck = {
    prefix: 'fal',
    iconName: 'box-check',
    icon: [
      448,
      512,
      [],
      'f467',
      
      'M240 64l102.4 0c12.6 0 24.1 7.4 29.2 19l34.2 77L240 160l0-96zm0 128l176 0 0 224c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-224 176 0 32 0zm-32-32L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19L208 64l0 96zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM331.3 251.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faTamale = {
    prefix: 'fal',
    iconName: 'tamale',
    icon: [
      320,
      512,
      [129748],
      'e451',
      
      'M296.4 304l23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L23.6 304l.4 0 28.8 0L28.8 447.5c-.2 1 .2 2 .9 2.8c12.8 12.6 32.4 21.3 56.8 26.5c24.2 5.2 50.4 6.4 73.4 6.4s49.2-1.2 73.4-6.4c24.5-5.2 44.1-13.9 56.8-26.5c.7-.8 1.1-1.8 .9-2.8L267.2 304l28.8 0 .4 0zM319.6 69.3L296.4 208l-.4 0-28.8 0L291.2 64.5c.2-1-.2-2-.9-2.8c-12.8-12.6-32.4-21.3-56.8-26.5c-24.2-5.2-50.4-6.4-73.4-6.4s-49.2 1.2-73.4 6.4c-24.5 5.2-44 13.9-56.8 26.5c-.7 .8-1.1 1.8-.9 2.8L52.8 208 24 208l-.4 0L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM8 256c0-8.8 7.2-16 16-16l136 0 136 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-104 0 28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272 24 272c-8.8 0-16-7.2-16-16zM160 56c8.8 0 16 7.2 16 16l0 136-16 0-16 0 0-136c0-8.8 7.2-16 16-16zm9.6 292.8c1.9 2.6 4.1 4.9 6.4 7l0 84.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-84.2c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8zM95.9 78.6L107.7 208l-32.1 0L64.1 81.4c-.8-8.8 5.7-16.6 14.5-17.4s16.6 5.7 17.4 14.5zM83.2 358.4c5.8 4.3 12.2 7.1 18.8 8.6l-6 66.5c-.8 8.8-8.6 15.3-17.4 14.5s-15.3-8.6-14.5-17.4l7.7-84.4c3 4.6 6.8 8.8 11.5 12.2zm153.6 0c4.6-3.5 8.5-7.6 11.5-12.2l7.7 84.4c.8 8.8-5.7 16.6-14.5 17.4s-16.6-5.7-17.4-14.5L218 367c6.6-1.4 13-4.2 18.8-8.6zM212.3 208L224.1 78.6c.8-8.8 8.6-15.3 17.4-14.5s15.3 8.6 14.5 17.4L244.4 208l-32.1 0z'
      
    ]
  };

  

  
  

  var faHatSanta = {
    prefix: 'fal',
    iconName: 'hat-santa',
    icon: [
      640,
      512,
      [],
      'f7a7',
      
      'M357.9 243.4L396.2 320l35.8 0-45.5-90.9c-1.7-3.3-2.5-7-2.5-10.7l0-2.3c0-13.3 10.7-24 24-24l4.1 0c2.6 0 5.1 .4 7.6 1.2l39.5 13.2c1.6-2.1 3.3-4.1 5.2-6c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L76.8 320l34.5 0 68.1-170.3C200.1 97.9 250.2 64 305.9 64c40.1 0 78.2 17.7 104 48.3l51.9 61.3-32-10.7c-5.7-1.9-11.7-2.9-17.7-2.9l-4.1 0c-30.9 0-56 25.1-56 56l0 2.3c0 8.7 2 17.3 5.9 25zM448 384c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0zM64 352c-35.3 0-64 28.7-64 64s28.7 64 64 64l384 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L64 352zm524.7-83.3a40.6 40.6 0 1 1 -57.4-57.4 40.6 40.6 0 1 1 57.4 57.4zm-82.4-82.4c-7.8 7.8-10 18.9-6.8 28.7C490.3 219.5 484 229 484 240s6.3 20.5 15.5 25.1c-3.2 9.7-1 20.9 6.8 28.7s18.9 10 28.7 6.8C539.5 309.7 549 316 560 316s20.5-6.3 25.1-15.5c9.7 3.2 20.9 1 28.7-6.8s10-18.9 6.8-28.7C629.7 260.5 636 251 636 240s-6.3-20.5-15.5-25.1c3.2-9.7 1-20.9-6.8-28.7s-18.9-10-28.7-6.8C580.5 170.3 571 164 560 164s-20.5 6.3-25.1 15.5c-9.7-3.2-20.9-1-28.7 6.8z'
      
    ]
  };

  

  
  

  var faArrowLeftToBracket = {
    prefix: 'fal',
    iconName: 'arrow-left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e669',
      
      'M164.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 240 496 240c8.8 0 16 7.2 16 16s-7.2 16-16 16l-281.4 0L315.3 372.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128zM176 448c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 64c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l96 0z'
      
    ]
  };

  

  
  

  var faKey = {
    prefix: 'fal',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      
      'M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6c-5.4-1.2-11 .4-14.9 4.3L257.4 352 208 352c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 48-96 0 0-81.4L194.8 235.8c4.2-4.2 5.7-10.5 3.9-16.2c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3L0 496c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-48 40 0c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faWavePulse = {
    prefix: 'fal',
    iconName: 'wave-pulse',
    icon: [
      640,
      512,
      ["heart-rate"],
      'f5f8',
      
      'M319.6 0c7.5-.2 14.1 4.9 15.9 12.1l84 336 37.6-93.9c7.3-18.2 24.9-30.2 44.6-30.2L624 224c8.8 0 16 7.2 16 16s-7.2 16-16 16l-122.3 0c-6.5 0-12.4 4-14.9 10.1l-56 139.9c-2.6 6.4-9 10.5-15.9 10s-12.8-5.4-14.4-12.1l-78.7-315-82 410.2c-1.5 7.3-7.8 12.7-15.3 12.9s-14.1-4.9-15.9-12.1L150.5 268.1C148.8 261 142.4 256 135 256L16 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l119 0c22 0 41.2 15 46.6 36.4l40.7 162.7 82-410.2C305.8 5.5 312.1 .2 319.6 0z'
      
    ]
  };

  
    var faHeartRate = faWavePulse;
  

  
  

  var faHighlighter = {
    prefix: 'fal',
    iconName: 'highlighter',
    icon: [
      576,
      512,
      [],
      'f591',
      
      'M176 296.6l0-48c0-5.2 2.5-10 6.7-13l27-19.4L343.7 350.4l-19.4 27c-3 4.2-7.8 6.7-13 6.7l-48 0c-8.5 0-16.6 3.4-22.6 9.4L197 437.1c-3.1 3.1-8.2 3.1-11.3 0l-62.8-62.8c-3.1-3.1-3.1-8.2 0-11.3l43.7-43.7c6-6 9.4-14.1 9.4-22.6zM523.8 99.5L362.6 324 236 197.4 460.5 36.2c3.8-2.7 8.4-4.2 13-4.2c5.9 0 11.6 2.4 15.8 6.5l32.2 32.2c4.2 4.2 6.5 9.9 6.5 15.8c0 4.7-1.5 9.2-4.2 13zM263.4 416l48 0c15.5 0 30-7.4 39-20L549.8 118.2C556.4 109 560 97.9 560 86.5c0-14.4-5.7-28.2-15.9-38.4L511.9 15.9C501.7 5.7 487.9 0 473.5 0C462.1 0 451 3.6 441.8 10.2L164 209.6c-12.6 9-20 23.5-20 39l0 48-43.7 43.7c-11.4 11.4-14.5 27.9-9.3 42l-84 84c-4.5 4.5-7 10.6-7 17L0 488c0 13.3 10.7 24 24 24l100.7 0c6.4 0 12.5-2.5 17-7l36-36c14.2 5.2 30.7 2.1 42-9.3L263.4 416zm-111 33l-31 31-82.7 0L111 407.6 152.4 449z'
      
    ]
  };

  

  
  

  var faSquareCaretLeft = {
    prefix: 'fal',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-9.6 4-18.7 11-25.2l102.8-95.5c5.1-4.7 11.8-7.3 18.7-7.3c15.2 0 27.5 12.3 27.5 27.5l0 201c0 15.2-12.3 27.5-27.5 27.5c-6.9 0-13.6-2.6-18.7-7.3L139 281.2c-7-6.5-11-15.6-11-25.2zm32.7 1.7L256 346.2l0-180.3-95.3 88.4c-.5 .4-.7 1.1-.7 1.7s.3 1.3 .7 1.7z'
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faLightSwitch = {
    prefix: 'fal',
    iconName: 'light-switch',
    icon: [
      384,
      512,
      [],
      'e017',
      
      'M176 48l0-16L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l112 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 112 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L208 32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM128 368c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96-128 0 0 96zm0-224l0 96 128 0 0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224z'
      
    ]
  };

  

  
  

  var faBuildingUser = {
    prefix: 'fal',
    iconName: 'building-user',
    icon: [
      640,
      512,
      [],
      'e4da',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 329.4c9.2-10.2 20-18.9 32-25.6l0-95.9L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c3.2 0 6.4-.2 9.5-.7c-5.5-9.2-8.9-19.9-9.4-31.3c0 0 0 0-.1 0l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm152-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm192-16a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM384 477.1c0-33.7 27.4-61.1 61.1-61.1l101.8 0c33.7 0 61.1 27.4 61.1 61.1c0 1.6-1.3 2.9-2.9 2.9l-218.2 0c-1.6 0-2.9-1.3-2.9-2.9zM445.1 384c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1L496 384l-50.9 0z'
      
    ]
  };

  

  
  

  var faVanShuttle = {
    prefix: 'fal',
    iconName: 'van-shuttle',
    icon: [
      640,
      512,
      [128656,"shuttle-van"],
      'f5b6',
      
      'M32 88l0 104 128 0 0-128L56 64C42.7 64 32 74.7 32 88zm0 136l0 104c0 13.3 10.7 24 24 24l13.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l13.5 0c13.3 0 24-10.7 24-24l0-104-240 0-192 0L32 224zm160-32l160 0 0-128L192 64l0 128zm192 0l204.1 0L477.6 69.3c-3-3.4-7.4-5.3-11.9-5.3L384 64l0 128zM584 384l-8 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-8 0c-30.9 0-56-25.1-56-56L0 88C0 57.1 25.1 32 56 32l120 0 192 0 97.7 0c13.6 0 26.6 5.8 35.7 15.9L627.7 188.2c7.9 8.8 12.3 20.3 12.3 32.1L640 328c0 30.9-25.1 56-56 56zm-40 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faShuttleVan = faVanShuttle;
  

  
  

  var faDumpster = {
    prefix: 'fal',
    iconName: 'dumpster',
    icon: [
      576,
      512,
      [],
      'f793',
      
      'M423.4 32L288 32s0 0 0 0s0 0 0 0L152.3 32c-.2 0-.4 0-.6 0L57 32c-14.7 0-27.5 10-31 24.2L.9 156.6c-.6 2.3-.9 4.6-.9 6.9C0 179.2 12.8 192 28.5 192l5.3 0L66 192l61.7 0 .6 0L288 192l159.7 0 .6 0 61.7 0 32.2 0 5.3 0c15.7 0 28.5-12.8 28.5-28.5c0-2.3-.3-4.7-.9-6.9L550.1 56.2C546.5 42 533.7 32 519 32l-95 0c-.2 0-.4 0-.6 0zM37.5 224l3.8 32L16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l29.1 0L64 448.9 64 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 384 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-15.1L530.9 288l29.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.3 0 3.8-32-32.2 0L483.7 416 92.3 416 69.8 224l-32.2 0zm490.2-64l-66.5 0L443 64l76 0 24 96-14.8 0-.4 0zM410.4 64l18.2 96L304 160l0-96 106.4 0zM272 64l0 96-124.7 0 18-96L272 64zM132.7 64l-18 96-66.5 0-.4 0L33 160 57 64l75.7 0z'
      
    ]
  };

  

  
  

  var faArrowDownToArc = {
    prefix: 'fal',
    iconName: 'arrow-down-to-arc',
    icon: [
      512,
      512,
      [],
      'e4ae',
      
      'M256 480c123.7 0 224-100.3 224-224c0-8.8 7.2-16 16-16s16 7.2 16 16c0 141.4-114.6 256-256 256S0 397.4 0 256c0-8.8 7.2-16 16-16s16 7.2 16 16c0 123.7 100.3 224 224 224zM396 202.6l-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 293.9 240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 277.9L372 181.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6z'
      
    ]
  };

  

  
  

  var faLightEmergency = {
    prefix: 'fal',
    iconName: 'light-emergency',
    icon: [
      448,
      512,
      [],
      'e41f',
      
      'M352 320l0-128c0-70.7-57.3-128-128-128S96 121.3 96 192l0 128-32 0 0-128c0-88.4 71.6-160 160-160s160 71.6 160 160l0 128-32 0zM48 384c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L48 384zm0-32l352 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM160 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faToiletPaperUnder = {
    prefix: 'fal',
    iconName: 'toilet-paper-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse"],
      'e2a0',
      
      'M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32l225.3 0c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9L112 352c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6L480 464c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-48-32 0 0 48c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-272c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0L112 0C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384l288 0c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM96 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faToiletPaperReverse = faToiletPaperUnder;
  

  
  

  var faSchoolCircleCheck = {
    prefix: 'fal',
    iconName: 'school-circle-check',
    icon: [
      640,
      512,
      [],
      'e56b',
      
      'M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96 576 96c35.3 0 64 28.7 64 64l0 106.8c-9.1-12.9-19.9-24.5-32-34.6l0-72.2c0-17.7-14.3-32-32-32l-112 0c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7L64 128c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l192 0 0-96c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32l0 96 32 0 32 0 8.2 0c10 12.1 21.7 22.9 34.6 32L384 512l-32 0-64 0-32 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l107.2 0 140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 32 0 0-64-32 0zM96 352c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64zm64 0l-32 0 0 64 32 0 0-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faComma = {
    prefix: 'fal',
    iconName: 'comma',
    icon: [
      192,
      512,
      [],
      '2c',
      
      'M136 352.3c0-17.8-14.4-32.3-32.3-32.3c-16.1 0-29.7 11.8-31.9 27.7l-18 125.8c-.5 3.4 2.2 6.5 5.7 6.5c1.9 0 3.7-1 4.8-2.6l66-101.9c3.8-5.8 5.8-12.6 5.8-19.5l0-3.7zm32 0l0 3.7c0 13.1-3.8 25.9-10.9 36.9l-66 101.9C84.2 505.5 72.3 512 59.5 512c-23 0-40.6-20.3-37.3-43l18-125.8c4.5-31.7 31.6-55.2 63.6-55.2c35.5 0 64.3 28.8 64.3 64.3z'
      
    ]
  };

  

  
  

  var faSensor = {
    prefix: 'fal',
    iconName: 'sensor',
    icon: [
      448,
      512,
      [],
      'e028',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 48l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fal',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z'
      
    ]
  };

  

  
  

  var faRotateReverse = {
    prefix: 'fal',
    iconName: 'rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e631',
      
      'M85.9 301.2c-2-7.6-8.6-13.2-16.5-13.2c-10 0-17.6 8.9-15.2 18.6C76.8 397 158.6 464 256 464c59.8 0 113.7-25.3 151.7-65.7L433.4 424c5.1 5.1 12.1 8 19.3 8c15.1 0 27.3-12.2 27.3-27.3L480 304c0-8.8-7.2-16-16-16l-100.7 0c-15.1 0-27.3 12.2-27.3 27.3c0 7.2 2.9 14.2 8 19.3l41 41C352.9 410.3 307 432 256 432c-81.6 0-150.2-55.5-170.1-130.8zM127 136.3C159.1 101.7 205 80 256 80c81.6 0 150.2 55.5 170.1 130.8c2 7.6 8.6 13.2 16.5 13.2c10 0 17.6-8.9 15.2-18.6C435.2 115 353.4 48 256 48c-59.8 0-113.7 25.3-151.7 65.7L78.6 88c-5.1-5.1-12.1-8-19.3-8C44.2 80 32 92.2 32 107.3L32 208c0 8.8 7.2 16 16 16l100.7 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-41-41zM64 192l0-73.4L137.4 192 64 192zM448 320l0 73.4L374.6 320l73.4 0z'
      
    ]
  };

  

  
  

  var faBadgePercent = {
    prefix: 'fal',
    iconName: 'badge-percent',
    icon: [
      512,
      512,
      [],
      'f646',
      
      'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm91.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBridgeCircleExclamation = {
    prefix: 'fal',
    iconName: 'bridge-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ca',
      
      'M48 32l80 0 128 0 128 0 128 0 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0-128 0-128 0-128 0-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64L48 64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM496 64l-96 0 0 64 96 0 0-64zM368 64l-96 0 0 64 96 0 0-64zM240 64l-96 0 0 64 96 0 0-64zM48 240l16 0c53 0 96 43 96 96l0 96c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-96c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64l0 96c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-96c0-35.3-28.7-64-64-64l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPenClip = {
    prefix: 'fal',
    iconName: 'pen-clip',
    icon: [
      512,
      512,
      ["pen-alt"],
      'f305',
      
      'M385.4 41.9c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L421.7 175 337 90.3l48.4-48.4zM291.7 90.3L99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L492.7 149.3c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0L314.3 67.7 301.3 54.6c-25-25-65.5-25-90.5 0L100.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L233.4 77.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1zM314.3 113L399 197.7 206.9 389.8c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L314.3 113z'
      
    ]
  };

  
    var faPenAlt = faPenClip;
  

  
  

  var faH3 = {
    prefix: 'fal',
    iconName: 'h3',
    icon: [
      640,
      512,
      [],
      'f315',
      
      'M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 256 0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 256 0 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160L32 240 32 80zM400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0L421 228.4c-4.7 4.5-6.3 11.5-3.8 17.5s8.3 10.1 14.9 10.1l96 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-72.6 0c-19.6 0-36.2-14.1-39.5-33.4l-.2-1.2c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l.2 1.2c5.8 34.7 35.8 60.2 71 60.2l72.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-56 0L611 91.6c4.7-4.5 6.3-11.5 3.8-17.5S606.5 64 600 64L400 64z'
      
    ]
  };

  

  
  

  var faBowlChopsticksNoodles = {
    prefix: 'fal',
    iconName: 'bowl-chopsticks-noodles',
    icon: [
      512,
      512,
      [],
      'e2ea',
      
      'M499.1 31.7c8.7-1.7 14.3-10.2 12.6-18.8S501.5-1.4 492.9 .3L192 60.5l0 32.6L499.1 31.7zM192 148.2l0 32.1L497.1 160c8.8-.6 15.5-8.2 14.9-17s-8.2-15.5-17-14.9L192 148.2zm-32 34.2l0-32.1 0-50.8 0-32.6L160 32c0-8.8-7.2-16-16-16c-8.8 0-16 7.1-16 16L128 224s0 0 0 0l-32 0 0-37.3 0-32.1 0-42.3s0 0 0 0l0-32.6s0 0 0 0L96 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 38.1L12.9 96.3C4.2 98-1.4 106.5 .3 115.1s10.2 14.3 18.8 12.6l44.9-9 0 38L14.9 160c-8.8 .6-15.5 8.2-14.9 17s8.2 15.5 17 14.9L64 188.8 64 224l-13.1 0C23.3 224 1.4 247.3 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2c7.6 21.9 28.4 37.6 52.9 37.6l144 0c24.5 0 45.3-15.7 52.9-37.6c71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8L160 224l0-41.6zm1.3 281.4c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9l410.2 0c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1l-144 0c-10.4 0-19.4-6.7-22.7-16.1z'
      
    ]
  };

  

  
  

  var faPizza = {
    prefix: 'fal',
    iconName: 'pizza',
    icon: [
      576,
      512,
      [127829],
      'f817',
      
      'M344.2 389.5C318.9 406.2 288.6 416 256 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5l-99.6 99.6c-18.7 18.7-18.7 49.1 0 67.9l99.6 99.6zm24.9-20.4L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L369.1 142.9l22.6-22.6 33.9-33.9C432 80 432 69.9 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c64.9 0 124.2-24.2 169.4-64c6.6-5.8 6.6-16 .3-22.3l-33.9-33.9-22.6-22.6zm-1.9 43.4l22.9 22.9C352.7 463.4 306.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c50.3 0 96.7 16.6 134.2 44.6L367.2 99.5C335.9 77.1 297.5 64 256 64C150 64 64 150 64 256s86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm132.2-22.4l-22.9-22.9C498.9 335.9 512 297.5 512 256s-13.1-79.9-35.5-111.2l22.9-22.9c28 37.4 44.6 83.8 44.6 134.2s-16.6 96.7-44.6 134.2zM480 256c0 32.6-9.8 62.9-26.5 88.2L365.3 256l88.2-88.2C470.2 193.1 480 223.4 480 256zm32 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L433.1 369.1l22.6 22.6 33.9 33.9c6.2 6.2 16.4 6.3 22.3-.3zM160 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fal',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      'M48 32C21.5 32 0 53.5 0 80L0 256 0 432c0 26.5 21.5 48 48 48l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 448c-8.8 0-16-7.2-16-16l0-160 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 240 32 80c0-8.8 7.2-16 16-16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 32z'
      
    ]
  };

  

  
  

  var faLambda = {
    prefix: 'fal',
    iconName: 'lambda',
    icon: [
      448,
      512,
      [],
      'f66e',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l123.5 0c6.2 0 11.9 3.6 14.5 9.3l7.6 16.5-.3-.1-160 368c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3L179.4 128.3 328.9 452.1c7.8 17 24.9 27.9 43.6 27.9l59.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-59.5 0c-6.2 0-11.9-3.6-14.5-9.3L183.1 59.9c-7.8-17-24.9-27.9-43.6-27.9L16 32z'
      
    ]
  };

  

  
  

  var faWandMagicSparkles = {
    prefix: 'fal',
    iconName: 'wand-magic-sparkles',
    icon: [
      576,
      512,
      ["magic-wand-sparkles"],
      'e2ca',
      
      'M458.3 34.9c3.1-3.1 8.2-3.1 11.3 0l39.4 39.4c3.1 3.1 3.1 8.2 0 11.3L388.7 206.1l-50.7-50.7L458.3 34.9zM66.9 426.3L315.3 177.9l50.7 50.7L117.7 477.1c-3.1 3.1-8.2 3.1-11.3 0L66.9 437.7c-3.1-3.1-3.1-8.2 0-11.3zM435.7 12.3L44.3 403.7c-15.6 15.6-15.6 40.9 0 56.6l39.4 39.4c15.6 15.6 40.9 15.6 56.6 0L531.7 108.3c15.6-15.6 15.6-40.9 0-56.6L492.3 12.3c-15.6-15.6-40.9-15.6-56.6 0zM128 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48zM464 320c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16zM252.2 16c0-6.7-5.4-12.2-12.2-12.2s-12.2 5.4-12.2 12.2l0 19.8-19.8 0c-6.7 0-12.2 5.4-12.2 12.2s5.4 12.2 12.2 12.2l19.8 0 0 19.8c0 6.7 5.4 12.2 12.2 12.2s12.2-5.4 12.2-12.2l0-19.8 19.8 0c6.7 0 12.2-5.4 12.2-12.2s-5.4-12.2-12.2-12.2l-19.8 0 0-19.8z'
      
    ]
  };

  
    var faMagicWandSparkles = faWandMagicSparkles;
  

  
  

  var faGauge = {
    prefix: 'fal',
    iconName: 'gauge',
    icon: [
      512,
      512,
      ["dashboard","gauge-med","tachometer-alt-average"],
      'f624',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faDashboard = faGauge;
  
    var faGaugeMed = faGauge;
  
    var faTachometerAltAverage = faGauge;
  

  
  

  var faVial = {
    prefix: 'fal',
    iconName: 'vial',
    icon: [
      512,
      512,
      [129514],
      'f492',
      
      'M292.7 4.7c6.2-6.2 16.4-6.2 22.6 0l32 32 128 128 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 198.6l-84.7 84.7L181.8 480.8c-20 20-47.1 31.2-75.3 31.2C47.7 512 0 464.3 0 405.5c0-28.2 11.2-55.3 31.2-75.3l69.5-69.5L313.4 48 292.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM336 70.6L150.6 256l210.7 0 80-80L336 70.6zM329.4 288l-210.7 0L53.8 352.8c-14 14-21.8 32.9-21.8 52.7c0 41.1 33.4 74.5 74.5 74.5c19.8 0 38.7-7.8 52.7-21.8L329.4 288z'
      
    ]
  };

  

  
  

  var faSquareBolt = {
    prefix: 'fal',
    iconName: 'square-bolt',
    icon: [
      448,
      512,
      [],
      'e265',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM159.7 264l48.3 0c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L288.3 248 240 248c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L159.7 264zM281.6 112c14.7 0 24.4 15.2 18.2 28.5L265 216l49.4 0c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L180.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L183 296l-49.4 0c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L267.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z'
      
    ]
  };

  

  
  

  var faLeafOak = {
    prefix: 'fal',
    iconName: 'leaf-oak',
    icon: [
      512,
      512,
      [],
      'f6f7',
      
      'M300 0c-33.3 0-61.7 23.9-67.3 56.7l-1.4 8.2L217.9 54.8c-23.9-18-57.5-15.7-78.7 5.5c-13.4 13.4-19.7 32.3-17 51l6.7 47.1c-21.5-5.4-44.9 1.3-60.2 18.8l-6.6 7.5C42.9 206.6 38.8 238 51.9 264.1L64.3 289c7.8 15.6 11.8 32.7 11.8 50.1l0 74.1L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L102 432.6l67.6 0c17.4 0 34.5 4 50.1 11.8l24.9 12.4c26.1 13.1 57.5 9 79.5-10.2l7.5-6.6c17.5-15.3 24.2-38.7 18.8-60.2l47.1 6.7c18.7 2.7 37.6-3.6 51-17c21.2-21.2 23.5-54.8 5.5-78.7l-10.1-13.4 8.2-1.4c32.8-5.7 56.7-34.1 56.7-67.3c0-22.9-11.4-44.2-30.4-56.9L468 145l5.4-24.8c5.2-23.7-2-48.5-19.2-65.6S412.3 30.1 388.6 35.3l-24.8 5.4-6.9-10.3C344.2 11.4 322.9 0 300 0zM134 400.6L315.3 219.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L108.1 381.2l0-42.1c0-22.4-5.2-44.4-15.2-64.4L80.5 249.8c-7.2-14.5-5-31.9 5.7-44.1l6.6-7.5c9.4-10.7 25.3-12.8 37.2-4.9c15.5 10.3 35.9-2.5 33.3-21l-9.4-65.6c-1.3-8.8 1.7-17.6 8-23.9c9.9-9.9 25.6-11 36.8-2.6l23.9 18c14.3 10.8 35 2.6 38.1-15.1l3.6-21.1C267.2 44.7 282.3 32 300 32c12.2 0 23.5 6.1 30.2 16.2l6.9 10.3c7.3 11 20.6 16.3 33.5 13.5l24.8-5.4c13.1-2.9 26.7 1.1 36.1 10.6s13.4 23.1 10.6 36.1l-5.4 24.8c-2.8 12.9 2.5 26.2 13.5 33.5l10.3 6.9c10.1 6.7 16.2 18.1 16.2 30.2c0 17.7-12.7 32.8-30.2 35.8l-21.1 3.6c-17.7 3.1-25.9 23.8-15.1 38.1l18 23.9c8.4 11.2 7.3 26.9-2.6 36.8c-6.3 6.3-15.1 9.2-23.9 8l-65.6-9.4c-18.4-2.6-31.3 17.8-21 33.3c7.9 11.9 5.8 27.8-4.9 37.2l-7.5 6.6c-12.2 10.7-29.6 12.9-44.1 5.7L234 415.8c-20-10-42-15.2-64.4-15.2l-35.6 0z'
      
    ]
  };

  

  
  

  var faMarsStroke = {
    prefix: 'fal',
    iconName: 'mars-stroke',
    icon: [
      512,
      512,
      [9894],
      'f229',
      
      'M368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0L384 105.4 347.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L361.4 128l-40.7 40.7C290.1 143.3 250.8 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L384 150.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 480 54.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L368 0zM64 304a144 144 0 1 1 288 0A144 144 0 1 1 64 304z'
      
    ]
  };

  

  
  

  var faCircleParking = {
    prefix: 'fal',
    iconName: 'circle-parking',
    icon: [
      512,
      512,
      ["parking-circle"],
      'f615',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 32l80 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-80 0 0 128zm80 32l-80 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-152c0-13.3 10.7-24 24-24l88 0c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  
    var faParkingCircle = faCircleParking;
  

  
  

  var faCrutches = {
    prefix: 'fal',
    iconName: 'crutches',
    icon: [
      640,
      512,
      [],
      'f7f8',
      
      'M443.3 4.7l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM290.4 199l34.2-34.2 .1-.1 .1-.1 94-94 22.6 22.6L358.6 176 464 281.4l82.7-82.7 22.6 22.6-94.1 94.1L441 349.6c-11.2 11.2-25.4 18.8-40.9 21.9l-122 24.4c-9.3 1.9-17.8 6.4-24.5 13.1l-98.3 98.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L231 386.4c6.7-6.7 11.3-15.2 13.1-24.5l24.4-122c3.1-15.5 10.7-29.7 21.9-40.9zM313 221.6c-6.7 6.7-11.3 15.2-13.1 24.5L276.4 363.6l117.5-23.5c9.3-1.9 17.8-6.4 24.5-13.1l23-23L336 198.6l-23 23zM196.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L198.6 48l98.7 98.7-22.6 22.6L176 70.6 70.6 176 176 281.4l66.7-66.7c-2.4 6.1-4.2 12.4-5.5 18.9l-8 39.9L198.6 304 219 324.4l-6.2 31.2c-.3 1.4-.8 2.8-1.4 4.1c-4.4-2.9-8.5-6.3-12.3-10.1l-34.3-34.3L48 198.6 27.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192zM384.5 407.2l21.9-4.4c5.1-1 10.1-2.4 15-4.1l85.9 85.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L386.4 409c-.6-.6-1.2-1.2-1.9-1.8z'
      
    ]
  };

  

  
  

  var faChartSimple = {
    prefix: 'fal',
    iconName: 'chart-simple',
    icon: [
      448,
      512,
      [],
      'e473',
      
      'M240 64c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16l32 0zM208 32c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0zM80 256c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l32 0zM48 224c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0zm320-96l32 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16zm-48 16l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faBagSeedling = {
    prefix: 'fal',
    iconName: 'bag-seedling',
    icon: [
      512,
      512,
      [],
      'e5f2',
      
      'M89 96l334 0 12.6 50.3c8.2 33 12.4 66.9 12.4 100.9l0 17.7c0 34-4.2 67.9-12.4 100.9L423 416 89 416 76.4 365.7C68.2 332.7 64 298.9 64 264.8l0-17.7c0-34 4.2-67.9 12.4-100.9L89 96zM430.9 64L81.1 64 64.8 39.5c-.5-.8-.8-1.7-.8-2.7c0-2.7 2.2-4.8 4.8-4.8l374.3 0c2.7 0 4.8 2.2 4.8 4.8c0 1-.3 1.9-.8 2.7L430.9 64zM81.1 448l349.7 0 16.3 24.5c.5 .8 .8 1.7 .8 2.7c0 2.7-2.2 4.8-4.8 4.8L68.8 480c-2.7 0-4.8-2.2-4.8-4.8c0-1 .3-1.9 .8-2.7L81.1 448zM38.2 57.3l20 30L45.4 138.5C36.5 174 32 210.5 32 247.2l0 17.7c0 36.6 4.5 73.1 13.4 108.7l12.8 51.2-20 30c-4 6.1-6.2 13.2-6.2 20.4C32 495.5 48.5 512 68.8 512l374.3 0c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4l-20-30 12.8-51.2c8.9-35.5 13.4-72 13.4-108.7l0-17.7c0-36.6-4.5-73.1-13.4-108.7L453.8 87.3l20-30c4-6.1 6.2-13.2 6.2-20.4C480 16.5 463.5 0 443.2 0L68.8 0C48.5 0 32 16.5 32 36.8c0 7.3 2.2 14.4 6.2 20.4zM272 319c63.1-7.9 112-61.7 112-127l0-1.6c0-16.8-13.6-30.4-30.4-30.4l-8.9 0c-37.2 0-68.9 17.9-88.7 44.5c-19.8-26.6-51.5-44.5-88.7-44.5l-8.9 0c-16.8 0-30.4 13.6-30.4 30.4l0 1.6c0 65.3 48.9 119.1 112 127l0 33c0 8.8 7.2 16 16 16s16-7.2 16-16l0-33zm-32-32.3c-45.4-7.6-80-47.1-80-94.7l7.3 0c33.6 0 61 20.5 72.7 48.4l0 46.2zm32 0l0-46.2c11.7-27.9 39.1-48.4 72.7-48.4l7.3 0c0 47.6-34.6 87.1-80 94.7z'
      
    ]
  };

  

  
  

  var faPenCircle = {
    prefix: 'fal',
    iconName: 'pen-circle',
    icon: [
      512,
      512,
      [],
      'e20e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm331.5-92.7c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L245.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L286.2 140.7z'
      
    ]
  };

  

  
  

  var faRadiation = {
    prefix: 'fal',
    iconName: 'radiation',
    icon: [
      512,
      512,
      [],
      'f7b9',
      
      'M117.4 80L174.6 179c-11.9 12.6-20.9 27.9-26 45L34.3 224c8.3-58.2 39-109.2 83.2-144zm55.4 384.1L230 365c8.4 2 17.1 3 26 3s17.6-1 26-3l57.2 99.1C313.5 474.3 285.4 480 256 480s-57.5-5.7-83.2-15.9zM394.6 80c44.2 34.8 74.9 85.9 83.2 144l-114.4 0c-5.1-17.1-14.1-32.4-26-45L394.6 80zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faPlaneUpSlash = {
    prefix: 'fal',
    iconName: 'plane-up-slash',
    icon: [
      640,
      512,
      [],
      'e22e',
      
      'M464 461.4l-32-25.3 0 3.8 0 8 0 31.4L324.4 448.6c-2.9-.8-5.9-.8-8.8 0L208 479.4l0-39.4 57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L96 346.8l0-56.2c0-5.7 3.1-11 8.1-13.9l73.1-41.7L150 213.6 88.2 248.9c-15 8.5-24.2 24.5-24.2 41.7l0 56.2c0 21.3 20.3 36.6 40.8 30.8L240 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6l0 42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2c0 0 0 0 0 0L320 480.6l105.7 30.2s0 0 0 0c2.7 .8 5.5 1.2 8.2 1.2c16.6 0 30-13.4 30-30l0-20.5zm-223.6-360L272 126.4l0-16.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C311 33.7 315.9 32 320 32c9.1 0 20.9 8.2 31.8 26.3C362.1 75.5 368 96.1 368 109.7l0 61.7c0 5.7 3.1 11 8.1 13.9l159.9 91.4c5 2.8 8.1 8.2 8.1 13.9l0 50.5 27.6 21.8c2.8-4.7 4.4-10.2 4.4-16.2l0-56.2c0-17.2-9.2-33.1-24.2-41.7L400 162.1l0-52.5c0-20.6-8.1-46.8-20.8-67.9C367.1 21.6 346.9 0 320 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4c-11.1 18.3-19 40.6-20.8 59.7zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faMug = {
    prefix: 'fal',
    iconName: 'mug',
    icon: [
      576,
      512,
      [],
      'f874',
      
      'M64 96l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-256-16 0L64 96zm352 0l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0zm0 192l0 64c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96c0-17.7 14.3-32 32-32l304 0 16 0 80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0z'
      
    ]
  };

  

  
  

  var faMicrochipAi = {
    prefix: 'fal',
    iconName: 'microchip-ai',
    icon: [
      512,
      512,
      [],
      'e1ec',
      
      'M160 0c8.8 0 16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 16 0c35.3 0 64 28.7 64 64l0 16 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 64 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 16c0 35.3-28.7 64-64 64l-16 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-16 0c-35.3 0-64-28.7-64-64l0-16-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-64-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-16c0-35.3 28.7-64 64-64l16 0 0-48c0-8.8 7.2-16 16-16zM128 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L128 96zm94.7 89.6l56 128c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304l-63.1 0-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l56-128c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272l35.1 0L208 231.9zM352 192l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFileWaveform = {
    prefix: 'fal',
    iconName: 'file-waveform',
    icon: [
      448,
      512,
      ["file-medical-alt"],
      'f478',
      
      'M416 448c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-64-32 0 0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L318.1 14.1c-9-9-21.2-14.1-33.9-14.1L128 0C92.7 0 64 28.7 64 64l0 224 32 0L96 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256zm-.5-288L304 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L411.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM270.3 264.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8L189.3 369.7l-32.5-43.3c-3-4-7.8-6.4-12.8-6.4L16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l120 0 43.2 57.6c3.3 4.4 8.7 6.8 14.2 6.3s10.4-3.8 12.9-8.8L256 307.8l17.7 35.4c2.7 5.4 8.3 8.8 14.3 8.8l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-54.1 0-27.6-55.2z'
      
    ]
  };

  
    var faFileMedicalAlt = faFileWaveform;
  

  
  

  var faCreditCardBlank = {
    prefix: 'fal',
    iconName: 'credit-card-blank',
    icon: [
      576,
      512,
      [],
      'f389',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceAnxiousSweat = {
    prefix: 'fal',
    iconName: 'face-anxious-sweat',
    icon: [
      576,
      512,
      [],
      'e36a',
      
      'M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5l0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM211.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM283.8 304l8.4 0c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2l-151.6 0c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm67 80c-5.5-27.4-29.6-48-58.6-48l-8.4 0c-29 0-53.2 20.6-58.6 48l125.7 0z'
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fal',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-156.1 0c-17 0-33.3-6.7-45.3-18.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4L64 64zM0 96C0 60.7 28.7 32 64 32l124.1 0c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4L448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faObjectsAlignTop = {
    prefix: 'fal',
    iconName: 'objects-align-top',
    icon: [
      512,
      512,
      [],
      'e3c0',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 0zM176 160c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l64 0zm-64-32c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-64 0zm288 32c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l64 0zm-64-32c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0z'
      
    ]
  };

  

  
  

  var faFileCad = {
    prefix: 'fal',
    iconName: 'file-cad',
    icon: [
      512,
      512,
      [],
      'e672',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm232 0l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 32l0 96 16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0zm-160 8c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 56 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-56zm32 40l32 0 0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 40z'
      
    ]
  };

  

  
  

  var faTrashPlus = {
    prefix: 'fal',
    iconName: 'trash-plus',
    icon: [
      448,
      512,
      [],
      'e2b2',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64l47.1 0L416 64l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-18.3 0L388.2 452.6C385.9 486.1 358 512 324.4 512l-200.8 0c-33.6 0-61.4-25.9-63.8-59.4L34.3 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32.1 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480l200.8 0c16.8 0 30.7-13 31.9-29.7L381.6 96 66.4 96zM208 384l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fal',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm144-96l0 .7c0 1-.8 3.4-4.1 5.3c-3.2 1.8-5.5 1.4-6.5 .8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6 .3c.9 .5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6 .3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5 .8c3.3 1.9 4.1 4.3 4.1 5.3l0 .7c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-.7c0-1 .8-3.4 4.1-5.3c3.2-1.8 5.5-1.4 6.5-.8l.6 .3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6 .3c-.9 .5-3.3 1-6.5-.8c-3.3-1.9-4.1-4.3-4.1-5.3l0-.7c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 .7c0 15.1 9.4 26.8 20 33c10.7 6.2 25.5 8.3 38.5 .8l.6-.3 16 27.7-.6 .3c-13 7.5-18.5 21.4-18.5 33.8s5.5 26.3 18.5 33.8l.6 .3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5 .8c-10.6 6.2-20 17.9-20 33l0 .7-32 0 0-.7c0-15.1-9.4-26.8-20-33c-10.7-6.2-25.5-8.3-38.5-.8l-.6 .3-16-27.7 .6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7 .6 .3c13 7.5 27.8 5.4 38.5-.8c10.6-6.2 20-17.9 20-33l0-.7 32 0zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faArrowUpFromBracket = {
    prefix: 'fal',
    iconName: 'arrow-up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e09a',
      
      'M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-281.4L340.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-96z'
      
    ]
  };

  

  
  

  var faHandPointDown = {
    prefix: 'fal',
    iconName: 'hand-point-down',
    icon: [
      384,
      512,
      [],
      'f0a7',
      
      'M64 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-40-32 0c-5.5 0-10.8-.6-16-1.6L64 456zm48-216s0 0 0 0l32 0s0 0 0 0l24 0c13.2 0 24-10.7 24-24c0 0 0 0 0 0c0-13.3-10.7-24-24-24l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c15.7 0 29.8 6.4 40 16.8c10.2-10.4 24.3-16.8 40-16.8c13.8 0 26.4 5 36.1 13.2C294.4 160.3 310.2 152 328 152c8.6 0 16.7 1.9 24 5.4C350.6 87.9 293.8 32 224 32l-64 0C89.3 32 32 89.3 32 160l0 32c0 26.5 21.5 48 48 48l32 0zm32 32l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-31.9c0 0 0 0 0-.1l0-13.4c-7.3 3.5-15.4 5.4-24 5.4l-24 0zm0 90.6l0 93.4c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-200C12.6 241.4 0 218.2 0 192l0-32C0 71.6 71.6 0 160 0l64 0c88.4 0 160 71.6 160 160l0 48 0 32 0 24c0 30.9-25.1 56-56 56c-12.1 0-23.3-3.8-32.5-10.4C285.6 325.5 268 336 248 336c-9.7 0-18.8-2.5-26.7-6.8C214 351.7 192.9 368 168 368c-8.6 0-16.7-1.9-24-5.4zM224 240l0 40c0 13.2 10.8 24 24 24c13.3 0 24-10.7 24-24l0-16 0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 0 0 0 0 0l0 24zm128 0l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24z'
      
    ]
  };

  

  
  

  var faRaccoon = {
    prefix: 'fal',
    iconName: 'raccoon',
    icon: [
      512,
      512,
      [],
      'e613',
      
      'M283.2 57.1L266.6 77.6c24.6-12.4 53.5-4.7 69.4 15.5c15.9-20.2 44.8-27.9 69.4-15.5L388.8 57.1C375.9 41.2 356.5 32 336 32s-39.9 9.2-52.8 25.1zM336 162.6c-2.6 3.4-5.7 6.5-9.1 9.2l-36.7 29.4c2.2 1.3 4.4 2.7 6.5 4.1L312 215.4c.3-13 10.9-23.4 24-23.4s23.7 10.4 24 23.4l15.3-10.2c2.1-1.4 4.3-2.8 6.6-4.1l-36.7-29.4c-3.4-2.7-6.5-5.8-9.1-9.2zm79.1 24.2l34.4-10.3c8.6-2.6 14.5-10.5 14.5-19.5c0-2.8-.6-5.5-1.7-8.1l-69.6-41.8c-14.4-8.6-32.9-.4-36.2 16c-1.8 8.9 1.5 18 8.6 23.7l50 40zm-108.2-40c7.1-5.7 10.4-14.8 8.6-23.7c-3.3-16.4-21.9-24.7-36.2-16l-69.6 41.8c-1.1 2.5-1.7 5.3-1.7 8.1c0 9 5.9 16.9 14.5 19.5l34.4 10.3 50-40zM336 0c16 0 31.5 3.8 45.3 10.9l44.1-9.8c3.2-.7 6.5-1.1 9.7-1.1l1.3 0c24 0 43.5 19.5 43.5 43.5c0 4.7-.8 9.3-2.2 13.8L463.9 98.8l20.3 25c7.6 9.3 11.7 21 11.7 33c0 23.1-15.2 43.5-37.3 50.2l-35.8 10.7c-10.6 3.2-20.6 7.9-29.8 14l-18.8 12.6C362.9 252 349.6 256 336 256s-26.9-4-38.2-11.6L279 231.9c-9.2-6.1-19.2-10.9-29.8-14l-35.8-10.7c-22.2-6.6-37.3-27-37.3-50.2c0-12 4.1-23.7 11.7-33l20.3-25L194.2 57.3c-1.5-4.4-2.2-9.1-2.2-13.8C192 19.5 211.5 0 235.5 0l1.3 0c3.3 0 6.5 .4 9.7 1.1l44.1 9.8C304.5 3.8 320 0 336 0zM239.6 32.3c-.9-.2-1.8-.3-2.8-.3l-1.3 0c-6.4 0-11.5 5.2-11.5 11.5c0 1.2 .2 2.5 .6 3.6L232 69.4 258.4 37l.3-.4-19.1-4.2zm174 4.6L440 69.4l7.4-22.2c.4-1.2 .6-2.4 .6-3.6c0-6.4-5.2-11.5-11.5-11.5l-1.3 0c-.9 0-1.9 .1-2.8 .3l-19.1 4.2 .3 .4zM128 267.1c14-16.8 30.6-31.4 49.1-43.1c7.9 6.1 17 10.8 27 13.8l9.3 2.8C153.5 268.6 112 329.5 112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.5 1.9-32.6 5.6-48L32 352l0 48c0 44.2 35.8 80 80 80l208 0c0-17.7-14.3-32-32-32l-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0c35.3 0 64 28.7 64 64l96 0c0-17.7-14.3-32-32-32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c35.3 0 64 28.7 64 64l0 16c0 8.8-7.2 16-16 16l-352 0C50.1 512 0 461.9 0 400L0 96C0 60.7 28.7 32 64 32s64 28.7 64 64l0 171.1zm320 27.2c0-17-6.9-33.1-18.9-44.8c1-.3 2-.6 2.9-.9l30.4-9.1c11.3 15.9 17.6 35 17.6 54.9c0 31.4-15.6 60.7-41.5 78.4L427.6 380c-18.8 12.7-43.9 10.3-60-5.7c-21.1-21.1-17.6-56.2 7.2-72.8l16.3-10.8c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-16.3 10.8c-8 5.3-9.1 16.7-2.3 23.5c5.2 5.2 13.3 6 19.4 1.8l10.8-7.3c17.2-11.7 27.5-31.1 27.5-51.9zM95.9 320l.1-.1L96 256l-64 0 0 64 63.9 0zM96 160l-64 0 0 64 64 0 0-64zm0-32l0-32c0-17.7-14.3-32-32-32S32 78.3 32 96l0 32 64 0zM304.4 374.2c-16.1 16.1-41.3 18.5-60.2 5.7L199 349.2c-7.3-5-9.2-14.9-4.3-22.2s14.9-9.2 22.2-4.3l45.3 30.7c6.1 4.2 14.3 3.4 19.6-1.9c6.8-6.8 5.8-18.2-2.3-23.7L244.3 304c-7.3-5-9.2-14.9-4.3-22.2s14.9-9.2 22.2-4.3l35.3 23.9c24.6 16.7 28 51.7 6.9 72.8zM272 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faOption = {
    prefix: 'fal',
    iconName: 'option',
    icon: [
      640,
      512,
      [],
      'e318',
      
      'M178 107.7c-6.1-7.4-15.2-11.7-24.8-11.7L16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l137.3 0c19.2 0 37.4 8.6 49.5 23.5L462 404.3c6.1 7.4 15.2 11.7 24.8 11.7L624 416c8.8 0 16 7.2 16 16s-7.2 16-16 16l-137.3 0c-19.2 0-37.4-8.6-49.5-23.5L178 107.7zM624 64c8.8 0 16 7.2 16 16s-7.2 16-16 16L432 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0z'
      
    ]
  };

  

  
  

  var faBacon = {
    prefix: 'fal',
    iconName: 'bacon',
    icon: [
      576,
      512,
      [129363],
      'f7e5',
      
      'M566.6 105.4c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-27.5 24.3-48.4 54.6-69 84.7l-.5 .7C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C107 310.7 169.8 247 225.6 165.9c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96zM68.1 420.1l4.8-2.4c122.1-61.1 168.8-129 211.7-191.4l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c29.9-26.4 67.7-48.5 121.2-64.9L448 32c-56 16-94 38-123.5 64S274 152 252 184C193.2 269.6 126.2 336.9 32 384l36.1 36.1zm23.8 23.8L128 480c125.8-62.9 174.5-133.7 217.8-196.8c22.3-32.5 45-65 74.7-91.2C450 166 488 144 544 128L508.9 92.9l-8.5 2.4c-54 15.4-89.8 36.3-117.3 60.6c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3c-43.3 63.1-93 135.4-219 199.6z'
      
    ]
  };

  

  
  

  var faTrashList = {
    prefix: 'fal',
    iconName: 'trash-list',
    icon: [
      640,
      512,
      [],
      'e2b1',
      
      'M164.2 39.5L148.9 64l118.3 0L251.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-60.5 0c-5.5 0-10.6 2.8-13.6 7.5zM279 22.6L304.9 64l47.1 0L384 64l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-18.3 0L356.2 452.6C353.9 486.1 326 512 292.4 512l-168.8 0c-33.6 0-61.4-25.9-63.8-59.4L34.3 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32.1 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l60.5 0c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480l168.8 0c16.8 0 30.7-13 31.9-29.7L349.6 96 66.4 96zM464 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM448 400c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faMessageCaptions = {
    prefix: 'fal',
    iconName: 'message-captions',
    icon: [
      512,
      512,
      ["comment-alt-captions"],
      'e1de',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  
    var faCommentAltCaptions = faMessageCaptions;
  

  
  

  var faSushi = {
    prefix: 'fal',
    iconName: 'sushi',
    icon: [
      576,
      512,
      [127843,"nigiri"],
      'e48a',
      
      'M535.2 288.7L430.5 253.9l59.3-100.4c17.4 20.9 29.7 46.3 34.7 74.7l10.7 60.5zM375.6 96.2c33.9 1.8 65.3 14.3 90.6 34.3L399.4 243.6l-66.2-22c-9.1-3-18.4-5.2-27.8-6.5L375.6 96.2zM268.8 214.1c-13 1.1-25.9 3.9-38.5 8.2L133.2 256 227.7 96l110.9 0L268.8 214.1zM86.4 272.2L41 287.9l10.5-59.7c12.4-70.1 69.2-122.7 138.4-131L86.4 272.2zM209.1 64C115.9 64 36.2 130.9 20 222.6L9.5 282.4c-4.2 24 18.9 43.8 42 35.8l189.4-65.6c26.6-9.2 55.5-9.4 82.3-.5l202 67.1c23 7.6 45.8-12.1 41.6-35.9L556 222.6C539.8 130.9 460.1 64 366.9 64L209.1 64zM32 352.9c.5 52.6 43.3 95.1 96 95.1c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c18.8 0 36.4-5.4 51.2-14.8c2.9-1.8 6.6-1.8 9.5 0c14.8 9.4 32.4 14.8 51.2 14.8c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c52.5 0 95.1-42.1 96-94.4c-8.4 .7-17.1-.2-25.8-3.1l-6.2-2 0 3.5c0 35.3-28.7 64-64 64c-11.6 0-22.4-3.1-31.7-8.4c-12.6-7.2-28-7.2-40.6 0c-9.3 5.3-20.1 8.4-31.7 8.4c-12.6 0-24.3-3.6-34.1-9.8c-13.4-8.4-30.4-8.4-43.7 0c-9.9 6.2-21.5 9.8-34.1 9.8c-11.6 0-22.4-3.1-31.7-8.4c-12.6-7.2-28-7.2-40.6 0c-9.3 5.3-20.1 8.4-31.7 8.4c-35.3 0-64-28.7-64-64l0-4.3-5.3 1.8c-9 3.1-18 4.1-26.7 3.4z'
      
    ]
  };

  
    var faNigiri = faSushi;
  

  
  

  var faBullseye = {
    prefix: 'fal',
    iconName: 'bullseye',
    icon: [
      512,
      512,
      [],
      'f140',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faArrowLeftToLine = {
    prefix: 'fal',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      'M0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432zM100.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L150.6 272 256 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0-105.4 0L251.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128z'
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faLocationSmile = {
    prefix: 'fal',
    iconName: 'location-smile',
    icon: [
      384,
      512,
      ["map-marker-smile"],
      'f60d',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM128 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM125.3 247.1C132.1 257.3 156 280 192 280s59.9-22.7 66.7-32.9c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2c-11 16.5-43.9 47.1-93.3 47.1s-82.3-30.6-93.3-47.1c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4z'
      
    ]
  };

  
    var faMapMarkerSmile = faLocationSmile;
  

  
  

  var faHelmetUn = {
    prefix: 'fal',
    iconName: 'helmet-un',
    icon: [
      512,
      512,
      [],
      'e503',
      
      'M240 32c114.9 0 208 93.1 208 208l0 16-192 0c-6.9 0-13 4.4-15.2 10.9L212.5 352 77.2 352c-25 0-45.2-20.2-45.2-45.2L32 240C32 125.1 125.1 32 240 32zm96 419.4l-93.6-88.1L267.5 288l68.5 0 0 163.4zM368 480l0-192 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16C480 107.5 372.5 0 240 0S0 107.5 0 240l0 66.8C0 349.4 34.6 384 77.2 384l140.4 0L349 507.7c3 2.8 6.9 4.3 11 4.3l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.2 34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.2-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z'
      
    ]
  };

  

  
  

  var faUmbrellaBeach = {
    prefix: 'fal',
    iconName: 'umbrella-beach',
    icon: [
      576,
      512,
      [127958],
      'f5ca',
      
      'M471.6 99.4c46.8 45.1 72.2 109 68.3 174.7l-86.3-31.4c15.2-43.2 21.6-89 18.9-134.8c-.2-2.9-.5-5.7-.9-8.5zM402.8 54.3c21.7 10.1 36.3 31.4 37.7 55.6c2.5 41.4-3.3 82.8-17 121.9l-167.6-61c14.6-38.8 36.9-74.2 65.3-104.3c17.5-18.5 44.1-25.2 68.2-17.3c1.1 .4 2.2 .8 3.3 1.2c3.4 1.2 6.7 2.5 10 3.9zm-3.1-35.4c-109.8-38-228.4 3.2-292.6 94c-11.1 15.7-2.8 36.8 15.3 43.4l92.4 33.6s0 0 0 0L245 200.9l167.6 61 30.1 10.9s0 0 0 0l89.1 32.4c18.1 6.6 38-4.2 39.6-23.4c9-108.1-52-213.2-155.6-256.9c-2.4-1.1-4.9-2.1-7.4-3l-5.9-2.1c-.9-.3-1.8-.6-2.7-.9zM305.9 37c-2.7 2.3-5.4 4.8-7.9 7.5c-31.5 33.3-56 72.5-72.2 115.4l-89.6-32.6C176.5 73 239.2 40.1 305.9 37zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-306.6 0 77.8-213.7-30.1-10.9L219.4 480 16 480z'
      
    ]
  };

  

  
  

  var faBrainArrowCurvedRight = {
    prefix: 'fal',
    iconName: 'brain-arrow-curved-right',
    icon: [
      640,
      512,
      ["mind-share"],
      'f677',
      
      'M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c20.5 11.8 35.2 32.5 39.1 56.7c-15.4 5.6-27.7 17.3-34.2 32.3c0-1.6 .3-3.2 .8-4.7c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48l0 352c0 25.6 20 46.5 45.2 47.9c5 11.8 10.9 22.1 17 30.8c-4.6 .8-9.4 1.3-14.2 1.3c-26.2 0-49.4-12.6-64-32zM526.7 232L635.3 340.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L526.6 472c-5.1 5.1-12 8-19.1 8c-15.1 .1-27.5-12.2-27.5-27.3l0-52.7-16 0c-35.3 0-64 28.7-64 64l0 32c0 6.4-3.8 12.2-9.8 14.7s-12.8 1.2-17.4-3.2C358.2 493.3 336 459.4 336 416c0-61.9 50.1-112 112-112l32 0 0-52.6c0-15 12.1-27.2 27.2-27.3c7.3 0 14.3 2.8 19.5 8zM512 320c0 8.8-7.2 16-16 16l-48 0c-44.2 0-80 35.8-80 80c0 8.5 1.2 16.6 3 24c10.7-41.4 48.2-72 93-72l32 0c8.8 0 16 7.2 16 16l0 57.4L601.4 352 512 262.6l0 57.4z'
      
    ]
  };

  
    var faMindShare = faBrainArrowCurvedRight;
  

  
  

  var fa6 = {
    prefix: 'fal',
    iconName: '6',
    icon: [
      320,
      512,
      [],
      '36',
      
      'M288 320c0-70.7-57.3-128-128-128C90.3 192 33.7 247.7 32 316.9c0 1 0 2 0 3.1c0 70.7 57.3 128 128 128s128-57.3 128-128zM126.8 163.5c10.7-2.3 21.8-3.5 33.2-3.5c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-2 0-3.9 .1-5.9C1.5 276.2 16 239.9 41.2 211.5L196 37.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6L126.8 163.5z'
      
    ]
  };

  

  
  

  var faCreditCardFront = {
    prefix: 'fal',
    iconName: 'credit-card-front',
    icon: [
      576,
      512,
      [],
      'f38a',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 304c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM400 144l64 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-64 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-64 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faBatteryLow = {
    prefix: 'fal',
    iconName: 'battery-low',
    icon: [
      576,
      512,
      ["battery-1"],
      'e0b1',
      
      'M432 128c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L80 384c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l352 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-160c0-44.2-35.8-80-80-80L80 96zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm-448 0l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-96c0-26.5-21.5-48-48-48s-48 21.5-48 48z'
      
    ]
  };

  
    var faBattery1 = faBatteryLow;
  

  
  

  var faAlignJustify = {
    prefix: 'fal',
    iconName: 'align-justify',
    icon: [
      448,
      512,
      [],
      'f039',
      
      'M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zM0 192c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16zM16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z'
      
    ]
  };

  

  
  

  var faFanTable = {
    prefix: 'fal',
    iconName: 'fan-table',
    icon: [
      448,
      512,
      [],
      'e004',
      
      'M416 224A192 192 0 1 0 32 224a192 192 0 1 0 384 0zm32 0c0 118.3-91.8 215.2-208 223.4l0 32.6 128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0L80 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0 0-32.6C91.8 439.2 0 342.3 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-55.4-99.7c-32.8 13.2-48.6 50.5-35.4 83.3c9.3 23 30.4 37.7 53.6 39.8c5.8 .5 10.9 4.2 13.2 9.6s1.5 11.6-2.1 16.2l-47.9 61.4c-2.7 3.5-2.1 8.5 1.4 11.2c27.9 21.8 68.1 16.8 89.8-11c15.3-19.5 17.4-45.2 7.6-66.3c-2.5-5.3-1.8-11.6 1.7-16.3s9.3-7.1 15.1-6.3l77.1 10.8c4.4 .6 8.4-2.4 9-6.8c4.9-35-19.5-67.4-54.5-72.3c-24.6-3.5-47.9 7.5-61.3 26.5c-3.4 4.8-9.1 7.3-14.9 6.7s-10.8-4.5-13-9.9L179 112.7c-1.7-4.1-6.3-6.1-10.4-4.4zm60 41.6c19.9-15.9 46-23.9 73.3-20c52.5 7.4 89.1 55.9 81.7 108.4c-3.1 21.9-23.3 37.1-45.2 34L285.8 265c3.8 25.2-2.3 51.8-19.3 73.5c-32.6 41.8-93 49.2-134.8 16.5c-17.4-13.6-20.5-38.7-6.9-56.1L157.6 257c-23.7-9.3-43.7-27.9-54-53.4c-19.9-49.2 3.9-105.1 53-125c20.5-8.3 43.8 1.6 52.1 22.1L228.6 150z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fal',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 441.9c0 12.2-9.9 22.1-22.1 22.1c-4.4 0-8.6-1.3-12.3-3.7L192 403.2 34.4 508.3c-3.6 2.4-7.9 3.7-12.3 3.7C9.9 512 0 502.1 0 489.9L0 48zM48 32c-8.8 0-16 7.2-16 16l0 423.4L183.1 370.7c5.4-3.6 12.4-3.6 17.8 0L352 471.4 352 48c0-8.8-7.2-16-16-16L48 32z'
      
    ]
  };

  

  
  

  var faSemicolon = {
    prefix: 'fal',
    iconName: 'semicolon',
    icon: [
      192,
      512,
      [],
      '3b',
      
      'M64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 32 128a64 64 0 1 0 128 0zM128 350.4c0 5.6-1.5 11.1-4.5 15.9L55.4 477.9c-.8 1.3-2.3 2.1-3.8 2.1c-2.8 0-4.9-2.5-4.4-5.2L70.5 343.9C73 330.1 85 320 99 320c16 0 29 13 29 29l0 1.5zm32 0l0-1.5c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.2-60 50.2L15.7 469.1c-4 22.3 13.2 42.9 35.9 42.9c12.7 0 24.5-6.6 31.1-17.4L150.8 383c6-9.8 9.2-21.1 9.2-32.6z'
      
    ]
  };

  

  
  

  var faSquareExclamation = {
    prefix: 'fal',
    iconName: 'square-exclamation',
    icon: [
      448,
      512,
      ["exclamation-square"],
      'f321',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faExclamationSquare = faSquareExclamation;
  

  
  

  var faTrainSubwayTunnel = {
    prefix: 'fal',
    iconName: 'train-subway-tunnel',
    icon: [
      512,
      512,
      ["subway-tunnel"],
      'e2a3',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240C512 114.6 397.4 0 256 0S0 114.6 0 256L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240zm336-48l0 48-96 0 0-96 48 0c26.5 0 48 21.5 48 48zM240 288l32 0 96 0 0 80c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-80 96 0zm0-128l0 96-96 0 0-48c0-26.5 21.5-48 48-48l48 0zm-48-32c-44.2 0-80 35.8-80 80l0 160c0 32.8 19.8 61 48 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.6 448l114.7 0 59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4l0-160c0-44.2-35.8-80-80-80l-128 0zm8 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm136-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSubwayTunnel = faTrainSubwayTunnel;
  

  
  

  var faSquareUp = {
    prefix: 'fal',
    iconName: 'square-up',
    icon: [
      448,
      512,
      [11014,"arrow-alt-square-up"],
      'f353',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 16c9.2 0 18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3L288 272l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-25.7 0C113.1 272 96 254.9 96 233.7c0-10.7 4.5-20.9 12.3-28.1l91-84c6.7-6.2 15.6-9.7 24.7-9.7zm-3 33.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3l41.7 0c8.8 0 16 7.2 16 16l0 96c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-96c0-8.8 7.2-16 16-16l41.7 0c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2s-2.2 .4-3 1.2z'
      
    ]
  };

  
    var faArrowAltSquareUp = faSquareUp;
  

  
  

  var faFaceHoldingBackTears = {
    prefix: 'fal',
    iconName: 'face-holding-back-tears',
    icon: [
      512,
      512,
      [129401],
      'e482',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM320.6 116.4c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2zM180.4 96.6c8.5 2.4 13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6l0 32 0 16 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7l0 6.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11zM208 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 208c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32zm160 32c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm1.9 129.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C328.9 410.3 298.8 432 256 432s-72.9-21.7-90.1-41.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C203 384.4 224.9 400 256 400s53-15.6 65.9-30.5z'
      
    ]
  };

  

  
  

  var faBowlSoftServe = {
    prefix: 'fal',
    iconName: 'bowl-soft-serve',
    icon: [
      512,
      512,
      [],
      'e46b',
      
      'M256 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7L164 64c-37.6 0-68 30.4-68 68c0 10.2 2.3 19.9 6.3 28.6C62.7 165.4 32 199.1 32 240c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80c0-41.4-31.4-75.4-71.7-79.6c4.9-9.7 7.7-20.8 7.7-32.4C416 57.3 358.7 0 288 0L256 0zm32 49.3c0-6-1.1-11.8-3.3-17.3l3.3 0c53 0 96 43 96 96c0 13.1-6.3 24.7-16 32l-88 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l92.9 0 11.1 0 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l16 0 8.3 0 31.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-26.6 0c-8.2-6.6-13.4-16.7-13.4-28c0-19.9 16.1-36 36-36l77.3 0C267.1 96 288 75.1 288 49.3zM64 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 57.4 46.6 104 104 104l46.1 0-20.4 40.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6l160 0c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6L329.9 448l46.1 0c57.4 0 104-46.6 104-104l0-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 8c0 39.8-32.2 72-72 72l-72 0c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L310.1 480l-108.2 0 20.4-40.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6l-72 0c-39.8 0-72-32.2-72-72l0-8z'
      
    ]
  };

  

  
  

  var faBaguette = {
    prefix: 'fal',
    iconName: 'baguette',
    icon: [
      640,
      512,
      [129366],
      'e3d8',
      
      'M591.9 74.8c-29.4-44.1-89-56-133.1-26.6l-79.2 52.8 47.8 47.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352.4 119l-88 58.7 51 51c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.5-55.5-88 58.7 54.2 54.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L122 272.6 74.7 304.1c-44.1 29.4-56 89-26.6 133.1s89 56 133.1 26.6l384-256c44.1-29.4 56-89 26.6-133.1zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z'
      
    ]
  };

  

  
  

  var faBarcodeRead = {
    prefix: 'fal',
    iconName: 'barcode-read',
    icon: [
      576,
      512,
      [],
      'f464',
      
      'M48 32c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 48C0 21.5 21.5 0 48 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 32zm96 96c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm48 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm224 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zM272 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zM544 48c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c26.5 0 48 21.5 48 48l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zM48 480l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-26.5 0-48-21.5-48-48l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8 7.2 16 16 16zm496-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 26.5-21.5 48-48 48l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faArrowUpBigSmall = {
    prefix: 'fal',
    iconName: 'arrow-up-big-small',
    icon: [
      576,
      512,
      ["sort-size-up"],
      'f88e',
      
      'M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6 176 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-377.4L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 432c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64zm-32 0l0-64c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48zM352 80l0 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L368 64c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128z'
      
    ]
  };

  
    var faSortSizeUp = faArrowUpBigSmall;
  

  
  

  var faMoneyBill = {
    prefix: 'fal',
    iconName: 'money-bill',
    icon: [
      576,
      512,
      [],
      'f0d6',
      
      'M480 96c0 35.3 28.7 64 64 64l0-32c0-17.7-14.3-32-32-32l-32 0zm-32 0L128 96c0 53-43 96-96 96l0 128c53 0 96 43 96 96l320 0c0-53 43-96 96-96l0-128c-53 0-96-43-96-96zM32 384c0 17.7 14.3 32 32 32l32 0c0-35.3-28.7-64-64-64l0 32zm512-32c-35.3 0-64 28.7-64 64l32 0c17.7 0 32-14.3 32-32l0-32zM64 96c-17.7 0-32 14.3-32 32l0 32c35.3 0 64-28.7 64-64L64 96zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faHandPointUp = {
    prefix: 'fal',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      'M64 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144 0 40-32 0c-5.5 0-10.8 .6-16 1.6L64 56zm48 216s0 0 0 0l32 0s0 0 0 0l24 0c13.2 0 24 10.7 24 24c0 0 0 0 0 0c0 13.3-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c13.8 0 26.4-5 36.1-13.2C294.4 351.7 310.2 360 328 360c8.6 0 16.7-1.9 24-5.4C350.6 424.1 293.8 480 224 480l-64 0C89.3 480 32 422.7 32 352l0-32c0-26.5 21.5-48 48-48l32 0zm32-32l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 31.9c0 0 0 0 0 .1l0 13.4c-7.3-3.5-15.4-5.4-24-5.4l-24 0zm0-90.6L144 56c0-30.9-25.1-56-56-56S32 25.1 32 56l0 200C12.6 270.6 0 293.8 0 320l0 32c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-48 0-32 0-24c0-30.9-25.1-56-56-56c-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zM224 272l0-40c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24l0 16 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24c0 0 0 0 0 0l0-24zm128 0l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24z'
      
    ]
  };

  

  
  

  var faSquareJ = {
    prefix: 'fal',
    iconName: 'square-j',
    icon: [
      448,
      512,
      [],
      'e273',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm304 48l0 144c0 53-43 96-96 96s-96-43-96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-144c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBagShoppingPlus = {
    prefix: 'fal',
    iconName: 'bag-shopping-plus',
    icon: [
      448,
      512,
      [],
      'e651',
      
      'M160 96l0 32 128 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 32l0-32c0-53 43-96 96-96s96 43 96 96l0 32 80 0c26.5 0 48 21.5 48 48l0 240c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 176c0-26.5 21.5-48 48-48l80 0zm16 32l-96 0c-8.8 0-16 7.2-16 16l0 240c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-240c0-8.8-7.2-16-16-16l-96 0-160 0zM128 320c0-8.8 7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faSquareDashed = {
    prefix: 'fal',
    iconName: 'square-dashed',
    icon: [
      448,
      512,
      [],
      'e269',
      
      'M88 32l24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L88 64c-30.9 0-56 25.1-56 56l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24C0 71.4 39.4 32 88 32zM16 192c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm416 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm0-32c-8.8 0-16-7.2-16-16l0-24c0-30.9-25.1-56-56-56l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0c48.6 0 88 39.4 88 88l0 24c0 8.8-7.2 16-16 16zm16 208l0 24c0 48.6-39.4 88-88 88l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0c30.9 0 56-25.1 56-56l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 368l0 24c0 30.9 25.1 56 56 56l24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-48.6 0-88-39.4-88-88l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0zM160 48c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceFrownOpen = {
    prefix: 'fal',
    iconName: 'face-frown-open',
    icon: [
      512,
      512,
      [128550,"frown-open"],
      'f57a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm22 192.1c-22.4-9.5-47.7-14.8-74.5-14.8c-26.8 0-52 5.3-74.4 14.8c-11.2 4.7-23.8 3.1-32.8-3.6c-9.7-7.2-14.9-20.4-9-33.9c19.2-44.1 64.2-74.7 116.2-74.7c52 0 97 30.6 116.2 74.7c5.9 13.6 .8 26.7-9 33.9c-9 6.6-21.5 8.3-32.8 3.5zm-74.4-80.2c-36.9 0-68.5 20.3-83.9 49.5c25.6-10.4 54-16.1 83.9-16.1c29.9 0 58.4 5.8 84 16.1c-15.4-29.2-47.1-49.5-84-49.5z'
      
    ]
  };

  
    var faFrownOpen = faFaceFrownOpen;
  

  
  

  var faFileVector = {
    prefix: 'fal',
    iconName: 'file-vector',
    icon: [
      384,
      512,
      [],
      'e64c',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM272 384l0-96 16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 16-96 0 0-16c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l16 0 0 96-16 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-16 96 0 0 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0zm-128 0l0-96 96 0 0 96-96 0z'
      
    ]
  };

  

  
  

  var faTally1 = {
    prefix: 'fal',
    iconName: 'tally-1',
    icon: [
      640,
      512,
      [],
      'e294',
      
      'M128 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPooStorm = {
    prefix: 'fal',
    iconName: 'poo-storm',
    icon: [
      448,
      512,
      ["poo-bolt"],
      'f75a',
      
      'M173.8 6.7c3-4.2 7.9-6.7 13-6.7C257.3 0 326.2 46 335 119.6c28.9 13.3 49 42.5 49 76.4c0 3.5-.2 7-.6 10.4C421.1 220.7 448 257.2 448 300c0 55.2-44.8 100-100 100l-8.9 0 12.1-11.5c6.7-6.3 11.5-14.2 14.3-22.8C394.6 358 416 331.5 416 300c0-33-23.5-60.5-54.6-66.7c-4.5-.9-8.4-3.7-10.7-7.7s-2.8-8.8-1.3-13.1c1.7-5.2 2.7-10.7 2.7-16.5c0-23.4-15.5-43.2-36.8-49.7c-6.5-2-11-7.9-11.3-14.7c-2-50.8-42.9-88.8-94.2-97.6c.4 1.4 .8 2.7 1.3 4.1c2.3 7.8 5 17.8 5 25.4c0 34.8-17.7 55.5-35.3 66.9c-8.5 5.5-17 8.8-23.2 10.7c-3 .9-5.6 1.6-7.5 2c-1.5 .6-3.2 1-4.9 1.1C117.7 145.6 96 168.3 96 196c0 5.8 .9 11.4 2.7 16.5c1.5 4.4 1 9.1-1.3 13.1s-6.2 6.8-10.7 7.7C55.5 239.5 32 267 32 300c0 32 22.2 58.9 52 66.1c-2.6 6.4-4 13.3-4 20.3c0 4.1 .5 8 1.3 11.9C35 389.5 0 348.8 0 300c0-42.8 26.9-79.3 64.6-93.6c-.4-3.4-.6-6.9-.6-10.4c0-43.7 33.4-79.6 76.1-83.6c.5-.1 1.1-.2 1.6-.3l.2 0c.2 0 .6-.1 1.2-.2c1.1-.2 2.8-.7 5-1.3c4.3-1.3 9.8-3.5 15.3-7c10.4-6.7 20.7-18.2 20.7-40c0-2.2-1.2-7.8-3.7-16.2c-2.3-7.6-5.1-15.6-7.1-21.5l-.1-.2s0 0 0 0c0 0 0 0 0 0c-.6-1.6-1.1-3.1-1.5-4.3c-1.7-4.9-.9-10.3 2.1-14.5zM159.7 376l48.3 0c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L288.3 360 240 360c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L159.7 376zm20.5 130.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L183 408l-49.4 0c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L267.8 229.5c3.7-3.5 8.7-5.5 13.8-5.5c14.7 0 24.4 15.2 18.2 28.5L265 328l49.4 0c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L180.2 506.5z'
      
    ]
  };

  
    var faPooBolt = faPooStorm;
  

  
  

  var faCapsules = {
    prefix: 'fal',
    iconName: 'capsules',
    icon: [
      576,
      512,
      [],
      'f46b',
      
      'M32 240l160 0 0-96c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 96zM0 256L0 144C0 82.1 50.1 32 112 32s112 50.1 112 112l0 24.2c3-32.2 19.3-63 47.3-83c50.7-36.2 120.5-23.6 156 28.1L555.7 300.6c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8l0 66.4 0 112c0 61.9-50.1 112-112 112S0 429.9 0 368L0 256zm192 16L32 272l0 96c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96zM398.6 413.6c25.5 37.1 75.1 45.8 111 20.1c36.3-26 45.5-77.6 19.7-115.1l-52.7-76.8-2.2 1.6L344.4 334.6l54.2 79.1zm57.5-196.4l2.5-1.7-57.7-84.2c-25.5-37.1-75.1-45.8-111-20.1c-36.3 26-45.5 77.6-19.7 115.1l56.1 81.8 129.8-90.9z'
      
    ]
  };

  

  
  

  var faDonut = {
    prefix: 'fal',
    iconName: 'donut',
    icon: [
      512,
      512,
      [127849,"doughnut"],
      'e406',
      
      'M32 208c0-29.2 19-60.4 59.9-86C132.4 96.7 190.3 80 256 80c3.1 0 6.2 0 9.3 .1l-20.6 20.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l39.8-39.8c44.4 6.1 83.3 20 112.9 38.5C461 147.6 480 178.8 480 208l0 15c-.6 8.5-3.7 16.5-8.8 23.2c-5.3 6.8-12.4 11.9-20.6 14.5l-.3 .1-.3 .1c-6.6 2.5-12.6 6-17.9 10.5c-.1-3.9-1.7-7.8-4.7-10.8l-32-32c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c3.6 3.6 8.6 5.1 13.3 4.6c-7.7 9.5-17.5 17.2-28.7 22.3c-12.6 5.9-26.6 8.3-40.4 7.2l-.6 0-.6 0c-15.9-.2-31.7 2.9-46.4 9c0 0 0 0 0 0l-.1 0c-14.2 6.1-29.6 9.1-45 9c0 0 0 0 0 0l-.3 0c-15.5 .1-30.8-2.9-45.1-9l-.1 0c-14.7-6.1-30.5-9.2-46.4-9l-.6 0-.6 0c-13.9 1.1-27.8-1.4-40.4-7.2c-12.5-5.8-23.4-14.8-31.5-26.1c-7-10.6-17.2-18.8-29.1-23.2l-.4-.1-.4-.1c-8.2-2.6-15.3-7.7-20.6-14.5c-5.2-6.7-8.2-14.8-8.8-23.2L32 208zm0 73.4c5.9 4.1 12.3 7.3 19.2 9.6c5.5 2.1 10.2 6 13.4 10.9l.2 .3 .2 .3c11.3 15.9 26.6 28.5 44.2 36.7c17.5 8.1 36.7 11.6 55.9 10.2c11.4 0 22.7 2.2 33.2 6.6c18.2 7.7 37.9 11.6 57.7 11.5c19.8 .2 39.4-3.7 57.6-11.5c10.5-4.4 21.8-6.6 33.2-6.6c19.2 1.5 38.4-2 55.9-10.1c17.7-8.2 32.9-20.8 44.2-36.6l.2-.3 .2-.3c3.2-5 7.9-8.8 13.4-10.9c6.9-2.3 13.3-5.5 19.2-9.6l0 22.5c0 29.2-19 60.4-59.9 86c-40.5 25.3-98.4 42-164.1 42s-123.6-16.7-164.1-42C51 364.4 32 333.2 32 304l0-22.6zM256 48C114.6 48 0 119.6 0 208l0 96c0 88.4 114.6 160 256 160s256-71.6 256-160l0-96c0-88.4-114.6-160-256-160zM208 191.9c0 0 0-.1 .1-.3c.1-.3 .4-.9 1.1-1.7c1.5-1.7 4.2-4 8.7-6.2c8.9-4.5 22.4-7.7 38.1-7.7s29.2 3.2 38.1 7.7c4.5 2.2 7.2 4.5 8.7 6.2c.7 .8 1 1.4 1.1 1.7c.1 .2 .1 .3 .1 .3s0 .1 0 .1l0 .1c0 0 0 .1-.1 .3c-.1 .3-.4 .9-1.1 1.7c-1.5 1.7-4.2 4-8.7 6.2c-8.9 4.5-22.4 7.7-38.1 7.7s-29.2-3.2-38.1-7.7c-4.5-2.2-7.2-4.5-8.7-6.2c-.7-.8-1-1.4-1.1-1.7c-.1-.2-.1-.3-.1-.3c0 0 0 0 0-.1s0 0 0 0l0-.1zm-4.4-36.9C190.3 161.7 176 173.8 176 192s14.3 30.3 27.6 36.9c14.2 7.1 32.8 11.1 52.4 11.1s38.2-3.9 52.4-11.1c13.3-6.6 27.6-18.8 27.6-36.9s-14.3-30.3-27.6-36.9C294.2 147.9 275.6 144 256 144s-38.2 3.9-52.4 11.1zm-32.3-15.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224-6.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm91.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z'
      
    ]
  };

  
    var faDoughnut = faDonut;
  

  
  

  var faDongSign = {
    prefix: 'fal',
    iconName: 'dong-sign',
    icon: [
      384,
      512,
      [],
      'e169',
      
      'M304 32c-8.8 0-16 7.2-16 16l0 16-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 107.3c-23.5-26.6-57.8-43.3-96-43.3c-70.7 0-128 57.3-128 128s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3l0 27.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 0-192 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16zM96 288a96 96 0 1 1 192 0A96 96 0 1 1 96 288zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448z'
      
    ]
  };

  

  
  

  var faTemperatureHalf = {
    prefix: 'fal',
    iconName: 'temperature-half',
    icon: [
      320,
      512,
      [127777,"temperature-2","thermometer-2","thermometer-half"],
      'f2c9',
      
      'M160 32c-35.3 0-64 28.7-64 64l0 156.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9L224 96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96l0 156.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5L64 96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-98c0-8.8 7.2-16 16-16s16 7.2 16 16l0 98c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature2 = faTemperatureHalf;
  
    var faThermometer2 = faTemperatureHalf;
  
    var faThermometerHalf = faTemperatureHalf;
  

  
  

  var faCommentImage = {
    prefix: 'fal',
    iconName: 'comment-image',
    icon: [
      512,
      512,
      [],
      'e148',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM184 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104.2 16c.1 0 .2 .1 .3 .1L379.4 288l-246.1 0L175 240.3c.1-.2 .4-.3 .6-.3c.2 0 .5 .1 .6 .3l19 25.3c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.4c.1-.1 .2-.2 .3-.2zm0-32c-10.2 0-19.8 4.8-25.9 13L208 229.3l-6.2-8.2c-6.2-8.3-15.9-13.1-26.2-13.1c-9.5 0-18.4 4.1-24.7 11.2l-48.1 55c-4.4 5-6.8 11.5-6.8 18.2c0 15.3 12.4 27.6 27.6 27.6l264.6 0c15.4 0 27.8-12.4 27.8-27.8c0-6.4-2.2-12.6-6.2-17.5L313.3 156c-6.2-7.6-15.4-12-25.1-12z'
      
    ]
  };

  

  
  

  var faEscalator = {
    prefix: 'fal',
    iconName: 'escalator',
    icon: [
      640,
      512,
      [],
      'e171',
      
      'M264 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 184 56zm211.3 91.8C409.9 135 428.6 128 448 128l112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-81.9 0L244.7 492.2C230.1 505 211.4 512 192 512L80 512c-44.2 0-80-35.8-80-80s35.8-80 80-80l81.9 0L395.3 147.8zM448 160c-11.6 0-22.9 4.2-31.6 11.9L178.5 380c-2.9 2.6-6.7 4-10.5 4l-88 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l112 0c11.6 0 22.9-4.2 31.6-11.9L461.5 260c2.9-2.6 6.7-4 10.5-4l88 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-112 0zM307.9 181.7l-24.6 21.5C275.6 187.1 259.1 176 240 176c-26.5 0-48 21.5-48 48l0 59.2-32 28 0-87.2c0-44.2 35.8-80 80-80c28.7 0 53.8 15.1 67.9 37.7z'
      
    ]
  };

  

  
  

  var faCarWash = {
    prefix: 'fal',
    iconName: 'car-wash',
    icon: [
      448,
      512,
      [],
      'f5e6',
      
      'M76.3 92.5C74.7 93.9 71 96 64 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C78.4 71.7 80 78.3 80 80c0 8.4-2.6 11.4-3.7 12.5zM64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zM240 80c0 8.4-2.6 11.4-3.7 12.5C234.7 93.9 231 96 224 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C238.4 71.7 240 78.3 240 80zm32 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48s48-16 48-48zM156.2 208l135.6 0c14.3 0 26.8 9.5 30.8 23.2L338.8 288c-.9 0-1.9 0-2.8 0l-224 0c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zM94.7 222.4L73 298.1C48.6 311.8 32 338 32 368l0 48 0 16 0 32 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 320 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32 0-16 0-48c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4l-135.6 0c-28.6 0-53.7 18.9-61.5 46.4zM384 416l0 16L64 432l0-16 0-48c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 48zM112 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 80c0 8.4-2.6 11.4-3.7 12.5C394.7 93.9 391 96 384 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C398.4 71.7 400 78.3 400 80zm32 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48z'
      
    ]
  };

  

  
  

  var faNotesMedical = {
    prefix: 'fal',
    iconName: 'notes-medical',
    icon: [
      512,
      512,
      [],
      'f481',
      
      'M128 96c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 197.5c0 8.5-3.4 16.6-9.4 22.6l-58.5 58.5c-6 6-14.1 9.4-22.6 9.4L160 384c-17.7 0-32-14.3-32-32l0-256zM96 96l0 256c0 35.3 28.7 64 64 64l197.5 0c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3L480 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM320 496c0-8.8-7.2-16-16-16l-176 0c-53 0-96-43-96-96l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 384c0 70.7 57.3 128 128 128l176 0c8.8 0 16-7.2 16-16zM272 112c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  

  
  

  var faSlotMachine = {
    prefix: 'fal',
    iconName: 'slot-machine',
    icon: [
      640,
      512,
      [],
      'e3ce',
      
      'M416 416l0 32c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-32 320 0zm23.4 64c5.4-9.4 8.6-20.3 8.6-32l0-32c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 32C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l0 32c0 35.3 28.7 64 64 64l256 0 144 0c44.2 0 80-35.8 80-80l0-210.7c18.6-6.6 32-24.4 32-45.3c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 20.9 13.4 38.7 32 45.3L576 432c0 26.5-21.5 48-48 48l-88.6 0zM576 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 64l0 32L96 96l0-32c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32zm32 64c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L64 384c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l384 0zM112 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l40.9 0L113 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9l-64 0zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40.9 0L233 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9l-64 0zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40.9 0L353 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9l-64 0z'
      
    ]
  };

  

  
  

  var faWineGlassCrack = {
    prefix: 'fal',
    iconName: 'wine-glass-crack',
    icon: [
      320,
      512,
      ["fragile"],
      'f4bb',
      
      'M149.2 32L61.2 32 46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32l-75.1 0 23.2 58.1c3.1 7.7-.3 16.5-7.7 20.3L155 132.4l48.3 48.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-3.6-3.6-5.3-8.8-4.5-13.9s4-9.4 8.6-11.7l50.8-25.4L149.2 32zM160.3 0l98.4 0c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5L176 480l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-128.9C65.9 342.7 7.2 272.8 14.5 192.7L29.4 29.1C30.9 12.6 44.7 0 61.2 0l98.4 0c.2 0 .5 0 .7 0z'
      
    ]
  };

  
    var faFragile = faWineGlassCrack;
  

  
  

  var faG = {
    prefix: 'fal',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      'M224 64C118 64 32 150 32 256s86 192 192 192c98.5 0 179.8-74.3 190.7-169.9c.2-1.5-.3-2.8-1.4-4c-1.2-1.2-3.1-2.2-5.3-2.2l-165.7 0c-8.8 0-16-7.2-16-16s7.2-16 16-16L408 240c21.5 0 41.3 17.9 38.5 41.8C433.7 393.4 339 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3C318 82.5 273.2 64 224 64z'
      
    ]
  };

  

  
  

  var faWhistle = {
    prefix: 'fal',
    iconName: 'whistle',
    icon: [
      640,
      512,
      [],
      'f460',
      
      'M93.4 115.3C79.5 128.1 67.6 143 58 159.4c-14.8-2.8-26-15.8-26-31.4c0-17.7 14.3-32 32-32c13.2 0 24.5 7.9 29.4 19.3zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6l2 0c9 0 17.6-3.8 23.7-10.5l63.3-69.6c4.6-5.1 7.2-11.7 7.2-18.5c0-8.4-3.9-16.4-10.5-21.6l-127-100.4c-5.2-4.1-12.4-4.6-18.2-1.2l-19.3 11.6c-10.3 6.2-23.4 5.5-33-1.7c-9.7-7.3-14-19.8-10.8-31.5l6.5-24c1.7-6.2-.5-12.8-5.5-16.8l-69.8-55.2C322.4 84.8 286.4 70 248.6 65.5c-.6-.1-1.1-.1-1.7-.1c-7.5-.9-15.2-1.4-22.9-1.4c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM354.6 348.5C325.6 389.4 277.9 416 224 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c6.5 0 12.9 .4 19.1 1.1c.8 .1 1.6 .2 2.3 .2c31.7 3.9 61.9 16.5 87.2 36.4l61.5 48.7-3.8 13.8c-6.6 24.4 2.3 50.3 22.5 65.5c20 15 47.2 16.4 68.6 3.5l9.9-5.9L606 349.9 545.8 416l-2 0L395.5 338.6c-14.2-7.4-31.6-3.2-40.9 9.9zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fal',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 167.6 71.6 96 160 96l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0C89.3 128 32 185.3 32 256s57.3 128 128 128l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c88.4 0 160 71.6 160 160zM152 240l272 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-272 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faMonitorWaveform = {
    prefix: 'fal',
    iconName: 'monitor-waveform',
    icon: [
      576,
      512,
      ["monitor-heart-rate"],
      'f611',
      
      'M64 64C46.3 64 32 78.3 32 96l0 160 144 0c5.3 0 10.3 2.7 13.3 7.1l30.8 46.2 53-139c2.3-5.9 7.8-10 14.2-10.3s12.3 3.1 15.1 8.8L345.9 256l86.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-6.1 0-11.6-3.4-14.3-8.8L290 215.7l-51 134c-2.1 5.6-7.2 9.5-13.2 10.2s-11.8-2-15.1-7L167.4 288 32 288l0 128c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faMonitorHeartRate = faMonitorWaveform;
  

  
  

  var faQ = {
    prefix: 'fal',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      'M32 256c0 106 86 192 192 192c42.6 0 81.9-13.9 113.8-37.3L227.9 282.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7l109.7 128C395.4 355 416 307.9 416 256c0-106-86-192-192-192S32 150 32 256zM358.7 435c-37.5 28.2-84.1 45-134.7 45C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 61.7-24.9 117.5-65.2 158l61.4 71.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L358.7 435z'
      
    ]
  };

  

  
  

  var faHorse = {
    prefix: 'fal',
    iconName: 'horse',
    icon: [
      576,
      512,
      [128014],
      'f6f0',
      
      'M336 144c0 8.8-7.2 16-16 16l-88 0-40 0-45.3 0c-28 0-50.7 22.7-50.7 50.7c0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5c0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9l33.2 0c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8c0-4.6-.4-9.2-1.1-13.7c-.9-5.3 .9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4 .3 2.8 .6 4.3 .8c7.7 1.3 13.3 8 13.3 15.8L336 472c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-160.4c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7c-.1-1.5 0-3.1 .3-4.5l0-52.8c0-8.8 7.2-16 16-16l32 0c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2c10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4L480 32l-8 0-24 0c-61.9 0-112 50.1-112 112zM549.2 31.1c8.9 11.6 14.8 25.7 16.3 41.3l7.7 80.8c2.3 23.9-9.2 47.1-29.6 59.9c-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5-7.4 0 0 40c0 .7-.1 1.5-.1 2.2c.1 1.9 .1 3.9 .1 5.8c0 30.9-12.4 58.4-32 78.4L416 472c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-124.4-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7l-33.2 0c-18 0-33.7-12-38.5-29.3L89.6 434.1c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4 .3-.8 .3-1.3c0-.4-.1-.8-.2-1.2L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-41.3 31.3-75.2 71.4-79.5c13-28.6 41.8-48.5 75.3-48.5l45.3 0 40 0 72.9 0c8-72 69-128 143.1-128l24 0 8 0 5.8 0L544 0c8.8 0 16 7.2 16 16c0 7-4.5 13-10.8 15.1zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faDialMed = {
    prefix: 'fal',
    iconName: 'dial-med',
    icon: [
      576,
      512,
      [],
      'e15f',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm16 232l0-127c63.1 7.9 112 61.7 112 127c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-65.3 48.9-119.1 112-127l0 127c0 8.8 7.2 16 16 16s16-7.2 16-16zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fal',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z'
      
    ]
  };

  

  
  

  var faBellOn = {
    prefix: 'fal',
    iconName: 'bell-on',
    icon: [
      640,
      512,
      [128365],
      'f8fa',
      
      'M606.3 8.8c4 7.9 .7 17.5-7.2 21.5l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2zM304 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3l-359.4 0C115.8 416 96 396.2 96 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8c30.9-30.9 48.3-72.8 48.3-116.6l0-29.1c0-83 63.1-151.2 144-159.2L304 16zm16 48c-70.7 0-128 57.3-128 128l0 29.1c0 52.2-20.7 102.3-57.7 139.2l-2.8 2.8c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM289.8 458.7c4.4 12.5 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C371.6 494.2 347.9 512 320 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM0 176c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zm544-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM40.8 30.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32z'
      
    ]
  };

  

  
  

  var faFilters = {
    prefix: 'fal',
    iconName: 'filters',
    icon: [
      640,
      512,
      [],
      'e17e',
      
      'M231.1 32C209.5 32 192 49.5 192 71.1c0 9.7 3.6 19.1 10.2 26.3L352 262.2l0 97.7c0 10.2 4.9 19.9 13.2 25.9L445 443.8c3.8 2.7 8.3 4.2 13 4.2c12.2 0 22-9.9 22-22l0-163.8L629.8 97.4c6.5-7.2 10.2-16.6 10.2-26.3C640 49.5 622.5 32 600.9 32L231.1 32zM224 71.1c0-3.9 3.2-7.1 7.1-7.1l369.8 0c3.9 0 7.1 3.2 7.1 7.1c0 1.8-.7 3.5-1.8 4.8l-154 169.4c-2.7 2.9-4.2 6.8-4.2 10.8l0 150.4-64-46.5L384 256c0-4-1.5-7.8-4.2-10.8L225.8 75.8c-1.2-1.3-1.8-3-1.8-4.8zM164.5 96L39.1 96C17.5 96 0 113.5 0 135.1c0 9.7 3.6 19.1 10.2 26.3L160 326.2l0 65.7c0 10.2 4.9 19.9 13.2 25.9L253 475.8c3.8 2.7 8.3 4.2 13 4.2c12.2 0 22-9.9 22-22l0-131.8L320 291l0-16.4L305.8 259l-45.7 50.3c-2.7 2.9-4.2 6.8-4.2 10.8l0 118.4-64-46.5 0-71.9c0-4-1.5-7.8-4.2-10.8L33.8 139.8c-1.2-1.3-1.8-3-1.8-4.8c0-3.9 3.2-7.1 7.1-7.1l147.7 0-8.3-9.1c-6.1-6.7-10.8-14.5-14-22.9z'
      
    ]
  };

  

  
  

  var faMugMarshmallows = {
    prefix: 'fal',
    iconName: 'mug-marshmallows',
    icon: [
      512,
      512,
      [],
      'f7b7',
      
      'M357.7 103c6.6 6.6 10.3 15.6 10.3 25l-32 0c0-.9-.3-1.7-1-2.3L277.2 67.8c-2.4-2.4-5.7-3.8-9.2-3.8s-6.7 1.4-9.2 3.8L201 125.7c-.6 .6-1 1.5-1 2.3l-32 0c0-9.4 3.7-18.3 10.3-25l57.9-57.9C244.6 36.7 256.1 32 268 32s23.4 4.7 31.8 13.2L357.7 103zM64 80l0 48-32 0 0-48c0-26.5 21.5-48 48-48l124.1 0-32 32L80 64c-8.8 0-16 7.2-16 16zM32 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192-16 0-208 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 192zm0-224l80 0 224 0 16 0 48 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 192c0-17.7 14.3-32 32-32zM384 352l16 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-16 0 0 160z'
      
    ]
  };

  

  
  

  var faHorseSaddle = {
    prefix: 'fal',
    iconName: 'horse-saddle',
    icon: [
      576,
      512,
      [],
      'f8c3',
      
      'M336 144c0-61.9 50.1-112 112-112l24 0 8 0 5.8 0c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1l-32 0c-8.8 0-16 7.2-16 16l0 52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9L384 472c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-137.3c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L256 304l0-49.3c45.4-7.6 80-47.1 80-94.7l0-16zm-96 80c-35.3 0-64-28.7-64-64l16 0 40 0 72 0c0 35.3-28.7 64-64 64zm-16 30.7l0 42.1-21.8-4.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1l-33.2 0c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-27.1 21.3-49.2 48-50.6c0 47.5 34.6 87 80 94.6zM192 128l-32 0-13.3 0c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3l33.2 0c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6 304 472c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-153.6c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2l0-40 7.4 0 1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16L485.8 0 480 0l-8 0L448 0C373.9 0 312.8 56 304.9 128L232 128l-40 0zM496 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faJoint = {
    prefix: 'fal',
    iconName: 'joint',
    icon: [
      640,
      512,
      [],
      'f595',
      
      'M448 16l0 27c0 42.4 16.9 83.1 46.9 113.1l21 21c18 18 28.1 42.4 28.1 67.9l0 27c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-27c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43l0-27c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 272l0-27c0-42.4-16.9-83.1-46.9-113.1l-21-21C522.1 92.9 512 68.4 512 43l0-27c0-8.8 7.2-16 16-16s16 7.2 16 16l0 27c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8l0 27c0 8.8-7.2 16-16 16s-16-7.2-16-16zM116.1 452.3c51.8 14 117 27.7 171.9 27.7l35.2 0-71.5-85.8-6.6-7.9c-43.9 4.5-90.2 14.9-129.1 25.3c-22.9 6.2-45.6 12.8-67.8 20.3c22.3 7.4 45 14.2 67.8 20.3zM284.8 384l71.5 85.7 8.5 10.2 118.3 0-71.5-85.8L403.2 384 288 384c-1 0-2.1 0-3.2 0zm160 0l71.5 85.8 8.5 10.2 75.2 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-155.2 0zM15.8 409.5c30.1-11 61.1-20.3 92-28.6C160.3 366.7 228.8 352 288 352l312 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-312 0c-59.2 0-127.7-14.7-180.2-28.8c-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z'
      
    ]
  };

  

  
  

  var faBracketRound = {
    prefix: 'fal',
    iconName: 'bracket-round',
    icon: [
      192,
      512,
      ["parenthesis"],
      '28',
      
      'M158.1 40.4c4.2 7.8 1.3 17.5-6.4 21.7C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4z'
      
    ]
  };

  
    var faParenthesis = faBracketRound;
  

  
  

  var faIgloo = {
    prefix: 'fal',
    iconName: 'igloo',
    icon: [
      576,
      512,
      [],
      'f7ae',
      
      'M576 320l0 32 0 64c0 35.3-28.7 64-64 64l-128 0-192 0L64 480c-35.3 0-64-28.7-64-64l0-96C0 160.9 128.9 32 288 32s288 128.9 288 288zm-32 32l-64 0-32 0-64 0 0 96 128 0c17.7 0 32-14.3 32-32l0-64zm0-32c0-46.6-12.5-90.3-34.2-128L480 192l0 128 64 0zM352 192l-32 0-192 0 0 128 69.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l69.5 0 0-128-96 0zM96 352l-64 0 0 64c0 17.7 14.3 32 32 32l128 0 0-96-64 0-32 0zm0-32l0-128-29.8 0C44.5 229.7 32 273.4 32 320l64 0zM487.9 160C453.8 117.5 406.4 86.1 352 72.1l0 87.9 135.9 0zM320 66c-10.5-1.3-21.2-2-32-2c-80.8 0-152.9 37.5-199.9 96L320 160l0-94zM288 288c-35.3 0-64 28.7-64 64l0 96 128 0 0-96c0-35.3-28.7-64-64-64z'
      
    ]
  };

  

  
  

  var faSchool = {
    prefix: 'fal',
    iconName: 'school',
    icon: [
      640,
      512,
      [127979],
      'f549',
      
      'M328.9 2.7c-5.4-3.6-12.4-3.6-17.8 0L171.2 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l192 0 32 0 64 0 32 0 192 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L468.8 96 328.9 2.7zM384 384c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96L64 480c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l112 0c3.2 0 6.2-.9 8.9-2.7L320 35.2l135.1 90.1c2.6 1.8 5.7 2.7 8.9 2.7l112 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-192 0 0-96zm-32 96l-64 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96zM96 192l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 64-32 0 0-64 32 0zm320-32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 64-32 0 0-64zM96 352l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 64-32 0 0-64 32 0zm320-32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 64-32 0 0-64zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm16-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16z'
      
    ]
  };

  

  
  

  var faBriefcaseBlank = {
    prefix: 'fal',
    iconName: 'briefcase-blank',
    icon: [
      512,
      512,
      [],
      'e0c8',
      
      'M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm240 32l-224 0-80 0c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-80 0z'
      
    ]
  };

  

  
  

  var faChartCandlestick = {
    prefix: 'fal',
    iconName: 'chart-candlestick',
    icon: [
      512,
      512,
      [],
      'e0e2',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zm288 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2l0 80c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2l0-80c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8l0-48zM176 64c-8.8 0-16 7.2-16 16l0 48c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2l0 112c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2l0-112c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8l0-48c0-8.8-7.2-16-16-16zm144 72l0 80c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8zm104 88l16 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-8-32c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2l0 48c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2l0-48c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48zM184 160c4.4 0 8 3.6 8 8l0 112c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-112c0-4.4 3.6-8 8-8l16 0z'
      
    ]
  };

  

  
  

  var faRoadBarrier = {
    prefix: 'fal',
    iconName: 'road-barrier',
    icon: [
      640,
      512,
      [],
      'e562',
      
      'M16 32c8.8 0 16 7.2 16 16l0 32 576 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 32 0 160 0 32 0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160L32 304l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 304l0-32L0 112 0 80 0 48c0-8.8 7.2-16 16-16zM608 272l0-160-38.1 0-80 160L608 272zM32 272l38.1 0 80-160L32 112l0 160zM406.1 112l-92.2 0-80 160 92.2 0 80-160zm35.8 0l-80 160 92.2 0 80-160-92.2 0zm-256 0l-80 160 92.2 0 80-160-92.2 0z'
      
    ]
  };

  

  
  

  var faMortarPestle = {
    prefix: 'fal',
    iconName: 'mortar-pestle',
    icon: [
      512,
      512,
      [],
      'f5a7',
      
      'M478.2 35c0 0 0 0 0 0c-1.3-1.7-3.2-2.7-5.4-2.9c0 0 0 0 0 0L476.3 .3 472.8 32s0 0 0 0c-2-.2-4 .3-5.6 1.5l-.3 .2s0 0 0 0L292.6 160l-54.6 0L448.2 7.9c8.3-6.2 18.4-8.7 28.1-7.6c10.2 1.1 20 6.1 26.9 14.7c2.9 3.6 5.1 7.6 6.6 11.8c2 5.7 2.7 11.7 2.1 17.6c-1 9.7-5.6 19-13.4 25.8L398.1 160l-47.9 0L477 46.3l.3-.3s0 0 0 0c1.5-1.3 2.4-3.1 2.7-5.2c.1-1.2 0-2.4-.4-3.5c0 0 0 0 0 0c-.3-.8-.7-1.6-1.3-2.3zM64 224l0 32c0 69.4 35.3 122.2 102.6 146.1c9.7 3.5 17.2 11.4 20.1 21.4s.7 20.7-5.8 28.7c-6.6 8.3-11.9 17.7-15.4 27.8l181.1 0c-3.6-10.1-8.8-19.5-15.4-27.8c-6.4-8.1-8.6-18.8-5.8-28.7s10.3-17.9 20.1-21.4C412.7 378.2 448 325.4 448 256l0-32L64 224zM352 480s0 0 0 0c.1 0 .1 0 0 0zm-192 0c-.1 0-.1 0 0 0c0 0 0 0 0 0zM512 208c0 8.8-7.2 16-16 16l-16 0 0 32c0 71.6-32.7 130.1-93.8 163c-9.4 5-19.4 9.5-30.1 13.3c6.8 8.5 12.5 17.8 16.9 27.9c2.9 6.5 5.2 13.2 7 20.2c4.4 17.1-10.4 31.7-28.1 31.7l-192 0c-17.7 0-32.4-14.6-28.1-31.7c1.8-7 4.1-13.7 7-20.2c4.5-10 10.2-19.4 16.9-27.9c-10.7-3.8-20.7-8.2-30.1-13.3C64.7 386.1 32 327.6 32 256l0-32-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 448 0 16 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fal',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm82.3 195.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faUserAlien = {
    prefix: 'fal',
    iconName: 'user-alien',
    icon: [
      448,
      512,
      [],
      'e04a',
      
      'M224 32C154.6 32 96 91.1 96 167c0 39.5 21.1 78.5 49.8 112.7c28.3 33.6 60.7 58.7 76 69.6c.1 .1 .8 .5 2.2 .5s2.1-.4 2.2-.5c15.2-10.9 47.7-35.9 76-69.6C330.9 245.5 352 206.5 352 167c0-75.9-58.6-135-128-135zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm62.1 185.2c12.8 12.5 25.1 23.2 35.8 31.7l-27.4 0C80 384 35.5 426.4 32.2 480l383.6 0c-3.3-53.6-47.8-96-102.2-96l-27.4 0c10.6-8.6 23-19.3 35.8-31.7C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 415 55.7 356.6 126.1 352.3zm23-175.4l48 16c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-48-16c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1zm160 30.4l-48 16c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2z'
      
    ]
  };

  

  
  

  var faSnowman = {
    prefix: 'fal',
    iconName: 'snowman',
    icon: [
      512,
      512,
      [9731,9924],
      'f7d0',
      
      'M256 0C194.1 0 144 50.1 144 112c0 17.6 4.1 34.2 11.3 49c-5.7 7.3-10.7 15.2-14.7 23.6L96 169.8 96 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 47.1L21.1 144.8C12.7 142 3.6 146.6 .8 154.9s1.7 17.4 10.1 20.2L130.4 215c-1.6 8.1-2.4 16.4-2.4 25c0 14 2.2 27.4 6.4 40C110.5 308 96 344.3 96 384c0 41.2 15.6 78.8 41.2 107.2c13.7 15.2 33.2 20.8 51 20.8l135.7 0c17.8 0 37.3-5.7 51-20.8c25.6-28.4 41.2-66 41.2-107.2c0-39.7-14.5-76-38.4-104c4.1-12.6 6.4-26.1 6.4-40c0-8.5-.8-16.9-2.4-25l119.5-39.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1L448 159.1l0-47.1c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 57.8-44.6 14.9c-4.1-8.4-9-16.4-14.7-23.6c7.2-14.8 11.3-31.5 11.3-49C368 50.1 317.9 0 256 0zM176 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 15.6-4.5 30.2-12.2 42.5c-3.9 6.2-3.1 14.2 1.9 19.5C342 191.2 352 214.4 352 240c0 13.3-2.7 25.9-7.5 37.3c-2.5 5.9-1.2 12.8 3.3 17.4C370.2 317.8 384 349.3 384 384c0 33-12.5 63-32.9 85.7c-5.9 6.6-15.6 10.3-27.2 10.3l-135.7 0c-11.6 0-21.3-3.7-27.2-10.3C140.4 447 128 417 128 384c0-34.7 13.8-66.2 36.3-89.3c4.5-4.6 5.8-11.5 3.3-17.4c-4.8-11.5-7.5-24.1-7.5-37.3c0-25.6 10-48.8 26.3-66c5-5.3 5.8-13.3 1.9-19.5C180.5 142.2 176 127.6 176 112zm96 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 43.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9l0-3.2c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 3.2z'
      
    ]
  };

  

  
  

  var faWheatAwnCircleExclamation = {
    prefix: 'fal',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e598',
      
      'M491.2 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.8 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L319.9 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L281.9 26.4c-6.2-6.2-16.4-6.2-22.6 0L225.4 60.3c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0L44.4 241.3C7 278.8 7 339.6 44.4 377.1L78.4 411s0 0 0 0L4.9 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L101 433.6s0 0 0 0l33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c8.3-.5 16.5-2 24.4-4.6c-2-10.5-3-21.4-3-32.4l0-.7c-23.6 10.9-52.5 6.6-72-12.9l-33.9-33.9c31.8-31.8 80.3-36.6 117.1-14.5c4.5-12 10.3-23.4 17.2-33.9c-3.5-2.3-6.9-5-10-8.1L304.6 230c29.8-29.8 74.5-35.9 110.3-18.2c11.6-6.1 24.1-10.9 37-14.2c-2.5-2-5-3.8-7.6-5.6l46.8-46.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-54.3 54.4c-16.1-5.5-33-7.8-49.8-6.7L491.2 43.3zM191.8 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM248 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L248 173.4c-25-25-25-65.5 0-90.5zM89.7 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L67.1 354.4c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181L248 444.9c-25 25-65.5 25-90.5 0L123.6 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faGunSquirt = {
    prefix: 'fal',
    iconName: 'gun-squirt',
    icon: [
      576,
      512,
      [],
      'e19d',
      
      'M128 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16C43 64 0 107 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l104 0c14.7 0 27.5-10 31-24.2L225 352l63 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-55 0 16-64 199 0c35.6 0 66.6-19.3 83.2-48l4.8 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-4.8 0C514.6 83.3 483.6 64 448 64L128 64l0-16zM112 96l336 0c26.2 0 48.8 15.8 58.7 38.4c2.5 5.8 8.3 9.6 14.7 9.6l14.7 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-14.7 0c-6.4 0-12.1 3.8-14.7 9.6C496.8 208.2 474.2 224 448 224l-191 0-33 0L96 224c-35.3 0-64-28.7-64-64s28.7-64 64-64l16 0zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM64 448l48-192 104 0L168 448 64 448z'
      
    ]
  };

  

  
  

  var faPiano = {
    prefix: 'fal',
    iconName: 'piano',
    icon: [
      512,
      512,
      [],
      'f8d4',
      
      'M432 384l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-96 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-48 0 0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64-48 0zm-16-32l64 0 0-24.4c0-12.1-6.8-23.2-17.7-28.6l-58.4-29.2c-31.8-15.9-51.9-48.4-51.9-84C352 100.8 283.2 32 198.3 32L192 32C103.6 32 32 103.6 32 192l0 160 64 0 64 0 64 0 128 0 64 0zm96-24.4l0 24.4 0 16 0 16 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64 0-16 0-16L0 192C0 86 86 0 192 0l6.3 0C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z'
      
    ]
  };

  

  
  

  var faPepper = {
    prefix: 'fal',
    iconName: 'pepper',
    icon: [
      512,
      512,
      [129745],
      'e432',
      
      'M195.7 5.8c5.7-6.8 15.7-7.7 22.5-2L208 16C218.2 3.7 218.2 3.7 218.3 3.7s0 0 0 0s0 0 0 0c0 0 0 0 .1 .1l.2 .2 .6 .5c.5 .4 1.1 1 1.9 1.7c1.6 1.5 3.7 3.6 6.2 6.3c5 5.5 11.7 13.5 18.3 23.9c10.6 16.8 21.2 40 25 69c19.5-9.3 42.2-12.2 64.7-6.5c10.5 2.6 20.1 6.9 28.7 12.4c21.5-13.8 48.5-19.1 75.3-12.4c51.4 12.9 82.7 65 69.8 116.4l-56 224c-12.9 51.4-65 82.7-116.4 69.8c-10.5-2.6-20.1-6.9-28.7-12.4c-5.7 3.7-11.8 6.7-18.3 9.2c-10.6 4-22 6.1-33.7 6.1c-11.7 0-23.1-2.1-33.7-6.1c-6.5-2.4-12.6-5.5-18.3-9.2c-8.6 5.5-18.3 9.8-28.7 12.4C123.8 522 71.7 490.7 58.9 439.3l-56-224C-10 163.8 21.3 111.7 72.7 98.9c26.8-6.7 53.8-1.4 75.3 12.4c7.5-4.9 15.9-8.7 24.9-11.4c.8-.2 1.5-.4 2.3-.6c.5-.1 1.1-.3 1.6-.4c21.2-5.3 42.6-3.1 61.2 4.9c-3.6-20.9-11.5-37.7-19.5-50.3c-5.4-8.5-10.8-15-14.7-19.3c-2-2.1-3.6-3.7-4.6-4.7c-.5-.5-.9-.9-1.2-1.1l-.2-.2c-6.8-5.7-7.7-15.7-2-22.5zM123.4 134.1c-12.9-6.1-28-8-42.9-4.2c-34.3 8.6-55.1 43.3-46.6 77.6l56 224c8.6 34.3 43.3 55.1 77.6 46.6c10-2.5 18.8-7.2 26.1-13.4c6-5.1 14.8-5.1 20.8 0c5.5 4.7 12 8.6 19.1 11.3c0 0 0 0 0 0c7.1 2.7 14.7 4.1 22.5 4.1c0 0 0 0 0 0c7.8 0 15.4-1.4 22.4-4.1c0 0 0 0 0 0c7.1-2.7 13.6-6.5 19.1-11.3c6-5.1 14.8-5.1 20.8 0c7.3 6.2 16.1 10.9 26.1 13.4c34.3 8.6 69-12.3 77.6-46.6l56-224c8.6-34.3-12.3-69-46.6-77.6c-20.9-5.2-41.9 .4-57.1 13.4c-6 5.1-14.8 5.1-20.8 0c-7.3-6.2-16.1-10.9-26.1-13.4c-22.4-5.6-44.9 1.3-60.3 16.4c-6.2 6.1-16.2 6.1-22.4 0c-15.4-15.1-38-22-60.3-16.4c0 0 0 0 0 0c-34.3 8.6-55.1 43.3-46.6 77.6L175.5 358c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L106.9 215.3c-7.3-29.3-.3-58.8 16.5-81.1zM256 512s0 0 0 0l0-16 0 16s0 0 0 0z'
      
    ]
  };

  

  
  

  var faTruckMedical = {
    prefix: 'fal',
    iconName: 'truck-medical',
    icon: [
      640,
      512,
      [128657,"ambulance"],
      'f0f9',
      
      'M352 32c17.7 0 32 14.3 32 32l0 320-133.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l288 0zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-148.2c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352zM416 128l65.3 0c4.7 0 9.1 2 12.1 5.6L570.9 224 416 224l0-96zm0 216.4l0-88.4 160 0 0 128-5.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM192 64c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48z'
      
    ]
  };

  
    var faAmbulance = faTruckMedical;
  

  
  

  var faApartment = {
    prefix: 'fal',
    iconName: 'apartment',
    icon: [
      576,
      512,
      [],
      'e468',
      
      'M128 128l-64 0c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l128 0 32 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 32 0 128 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32L192 32c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32zM320 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zm-96 96l-32 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l32 0 32 0 0-32c0-35.3 28.7-64 64-64L384 0c35.3 0 64 28.7 64 64l0 64 0 32 32 0 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-128 0-32 0-16 0-96 0-16 0zm288-88c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48zm-32-8l0-32-32 0 0 32 32 0zM136 384l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24zm-8-64l-32 0 0 32 32 0 0-32zm384-24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48zm-32-8l0-32-32 0 0 32 32 0zM136 256l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24zm-8-64l-32 0 0 32 32 0 0-32zm208 72c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48zm-32-8l0-32-32 0 0 32 32 0zm8-96l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24zm-8-64l-32 0 0 32 32 0 0-32z'
      
    ]
  };

  

  
  

  var faTriangle = {
    prefix: 'fal',
    iconName: 'triangle',
    icon: [
      512,
      512,
      [9650],
      'f2ec',
      
      'M235.5 75.8c4.2-7.3 12-11.8 20.5-11.8s16.2 4.5 20.5 11.8l201 344.6c1.6 2.8 2.5 6 2.5 9.3c0 10.2-8.2 18.4-18.4 18.4L50.4 448C40.2 448 32 439.8 32 429.6c0-3.3 .9-6.4 2.5-9.3l201-344.6zM207.9 59.6L6.9 404.2C2.4 411.9 0 420.7 0 429.6C0 457.4 22.6 480 50.4 480l411.2 0c27.8 0 50.4-22.6 50.4-50.4c0-8.9-2.4-17.7-6.9-25.4L304.1 59.6C294.1 42.5 275.8 32 256 32s-38.1 10.5-48.1 27.6z'
      
    ]
  };

  

  
  

  var faFileMov = {
    prefix: 'fal',
    iconName: 'file-mov',
    icon: [
      512,
      512,
      [],
      'e647',
      
      'M64 480l16 0 0 32-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM157.7 359.8L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM448 368l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z'
      
    ]
  };

  

  
  

  var faHeadSideCoughSlash = {
    prefix: 'fal',
    iconName: 'head-side-cough-slash',
    icon: [
      640,
      512,
      [],
      'e062',
      
      'M224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 7.4-2.8 14.1-7.4 19.1l25.2 19.9c8.9-10.5 14.3-24.1 14.3-38.9c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0c-34.8 0-67.7 7.9-97.1 22.1l28.5 22.5C176.8 36.4 199.9 32 224 32zM31.3 109.7C11.4 143.1 0 182.2 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224c0-34.3 9-66.5 24.7-94.3l-25.4-20zM528.5 339.1l33.7 26.6c8.1-3.8 13.8-12.1 13.8-21.7c0-13.3-10.7-24-24-24c-11.6 0-21.2 8.2-23.5 19.1zm63.6 50.2l32 25.3c9.2-3.3 15.8-12.2 15.8-22.6c0-13.3-10.7-24-24-24c-12.3 0-22.5 9.3-23.9 21.3zM432 426l-23.6-18.7-66.5-5.5c-3.3-.3-5.8-3-5.8-6.4c0-3.2 2.3-5.9 5.5-6.3l37.1-5.3-34.7-27.4-7 1c-18.9 2.7-33 18.9-33 38c0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456l-72 0c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8 56 0c30.9 0 56-25.1 56-56l0-6zM640 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faPear = {
    prefix: 'fal',
    iconName: 'pear',
    icon: [
      512,
      512,
      [],
      'e20c',
      
      'M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L453.1 81.5C470 103.2 480 130.4 480 160c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c29.6 0 56.8 10 78.5 26.9L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zm-118.6 96l18.9-18.9C391.9 70.6 372.7 64 352 64c-23.1 0-44.2 8.1-60.7 21.6c-37.1 30.3-86.9 65.8-139.7 79.5c-26.6 6.9-51.8 20.8-72.8 41.7c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c20.9-20.9 34.8-46.1 41.7-72.8c13.7-52.8 49.2-102.6 79.5-139.7C439.9 204.2 448 183.1 448 160c0-20.7-6.6-39.9-17.7-55.6l-18.9 18.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM304 336c0 53-43 96-96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faStaffSnake = {
    prefix: 'fal',
    iconName: 'staff-snake',
    icon: [
      384,
      512,
      ["rod-asclepius","rod-snake","staff-aesculapius"],
      'e579',
      
      'M296 48l-88 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-56 0L64 48C28.7 48 0 76.7 0 112s28.7 64 64 64l8 0c39.8 0 72-32.2 72-72l0-24 32 0 0 112 0 32 0 64-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-32-16 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l48 0 0 96-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 2.7 0 45.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-45.3 0-2.7 0-32 0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l0 32c44.2 0 80-35.8 80-80s-35.8-80-80-80l-32 0 0-64 0-32 0-112 88 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-56 0 0 32 56 0c48.6 0 88-39.4 88-88s-39.4-88-88-88zM112 80l0 24c0 22.1-17.9 40-40 40l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0zM72 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faRodAsclepius = faStaffSnake;
  
    var faRodSnake = faStaffSnake;
  
    var faStaffAesculapius = faStaffSnake;
  

  
  

  var faSpiderBlackWidow = {
    prefix: 'fal',
    iconName: 'spider-black-widow',
    icon: [
      512,
      512,
      [],
      'f718',
      
      'M151.2 1.7c7.9 4 11.1 13.6 7.2 21.5l-46.1 92.2c-3 6-2 13.2 2.6 18L176 199.3l0-47.3c0-32.2 19-59.9 46.3-72.6c7.7-3.6 16.8-.5 20.8 6.9L256 110.3l12.9-23.9c4-7.5 13.2-10.5 20.8-6.9C317 92.1 336 119.8 336 152l0 47.3 61.2-65.9c4.5-4.9 5.6-12.1 2.6-18L353.7 23.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2L428.4 101c8.9 17.9 5.9 39.5-7.8 54.1l-71.1 76.5 101.6-26.7c5.2-1.4 9.4-5.3 11.1-10.4l18.5-55.6c2.8-8.4 11.9-12.9 20.2-10.1s12.9 11.9 10.1 20.2l-18.5 55.6c-5.1 15.4-17.7 27.1-33.3 31.2L382.9 256l76.5 20.1c15.7 4.1 28.2 15.9 33.3 31.2l18.5 55.6c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-18.5-55.6c-1.7-5.1-5.9-9-11.1-10.4l-84-22.1L427 368.7c9.4 13.1 11.5 30.1 5.7 45.1l-33.8 87.9c-3.2 8.2-12.4 12.4-20.7 9.2s-12.4-12.4-9.2-20.7l33.8-87.9c1.9-5 1.2-10.7-1.9-15L367.9 341c-2.6 59.5-51.7 107-111.9 107s-109.3-47.5-111.9-107L111 387.3c-3.1 4.4-3.8 10-1.9 15l33.8 87.9c3.2 8.2-.9 17.5-9.2 20.7s-17.5-.9-20.7-9.2L79.2 413.8c-5.8-15.1-3.6-32 5.7-45.1L144.8 285l-84 22.1c-5.2 1.4-9.4 5.3-11.1 10.4L31.2 373.1c-2.8 8.4-11.9 12.9-20.2 10.1S-2 371.3 .8 362.9l18.5-55.6C24.5 292 37 280.2 52.7 276.1L129.1 256 52.7 235.9C37 231.8 24.5 220 19.3 204.6L.8 149.1c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1l18.5 55.6c1.7 5.1 5.9 9 11.1 10.4l101.6 26.7L91.4 155.1c-13.6-14.7-16.7-36.2-7.8-54.1L129.7 8.8c4-7.9 13.6-11.1 21.5-7.2zM270.1 151.6c-2.8 5.2-8.2 8.4-14.1 8.4s-11.3-3.2-14.1-8.4l-18.7-34.7c-9.4 8.8-15.2 21.3-15.2 35.1l0 104s0 0 0 0l0 .4c0 4.6-1.9 8.9-5.3 12C186.3 283 176 304.3 176 328l0 8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-8c0-23.7-10.3-45-26.7-59.6c-3.4-3-5.3-7.4-5.3-12l0-.4s0 0 0 0l0-104c0-13.8-5.9-26.3-15.2-35.1l-18.7 34.7zM218.4 307.2c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12l56 0c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12l-56 0c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z'
      
    ]
  };

  

  
  

  var faCircleD = {
    prefix: 'fal',
    iconName: 'circle-d',
    icon: [
      512,
      512,
      [],
      'e104',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160l-64 0 0-192 64 0c53 0 96 43 96 96s-43 96-96 96zM190.8 128c-17 0-30.8 13.8-30.8 30.8l0 194.5c0 17 13.8 30.8 30.8 30.8l65.2 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-65.2 0z'
      
    ]
  };

  

  
  

  var faHammerWar = {
    prefix: 'fal',
    iconName: 'hammer-war',
    icon: [
      384,
      512,
      [],
      'f6e4',
      
      'M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 37.2L36.7 32.4C17.7 29.5 0 44.7 0 64L0 256c0 19.3 17.7 34.5 36.7 31.6l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6l0-192c0-19.3-17.7-34.5-36.7-31.6L208 53.2 208 16zm0 283.1l-16-2.4-16 2.4L176 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-196.9zM32 255.8L32 64.2c0 0 .1-.1 .1-.1s.1-.1 .1-.1L182.5 86.6c6.3 .9 12.7 .9 19 0L351.8 64c0 0 .1 .1 .1 .1s.1 .1 .1 .1l0 191.5c0 0-.1 .1-.1 .1c0 0 0 0-.1 0s0 0-.1 0L201.5 233.4c-6.3-.9-12.7-.9-19 0L32.2 256c0 0-.1-.1-.1-.1s-.1-.1-.1-.1z'
      
    ]
  };

  

  
  

  var faBicycle = {
    prefix: 'fal',
    iconName: 'bicycle',
    icon: [
      640,
      512,
      [128690],
      'f206',
      
      'M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l38.3 0 50.5 96-169.4 0-33.7-56.2c-2.9-4.8-8.1-7.8-13.7-7.8l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l54.9 0L197 178.2l-26.5 53.1c-13.3-4.7-27.6-7.2-42.5-7.2C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112l65 0c5.9 0 11.2-3.2 14-8.3l83.4-152.9 21.2 40.3C405.6 270.2 384 308.6 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L368.4 44.8C364.3 36.9 356.1 32 347.2 32L304 32zM453.8 275.7l44.1 83.8c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-31.1 14.8-58.8 37.8-76.3zM156 260.2l-40 80.1c-6.4 12.8 2.9 27.8 17.2 27.8l89.5 0c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96s43-96 96-96c9.8 0 19.2 1.5 28 4.2zM153.9 336l62.7-125.3L291.7 336l-137.9 0zm88.8-144L389 192 319.3 319.8 242.7 192z'
      
    ]
  };

  

  
  

  var faBangladeshiTakaSign = {
    prefix: 'fal',
    iconName: 'bangladeshi-taka-sign',
    icon: [
      384,
      512,
      [],
      'e2e6',
      
      'M50 32.1C41.2 31 33.2 37.2 32.1 46S37.2 62.8 46 63.9l7.9 1c24 3 42 23.4 42 47.6L96 192l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 176c0 44.2 35.8 80 80 80l32 0c97.2 0 176-78.8 176-176l0-32c0-44.2-35.8-80-80-80l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c26.5 0 48 21.5 48 48l0 32c0 79.5-64.5 144-144 144l-32 0c-26.5 0-48-21.5-48-48l0-176 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-79.5c0-40.3-30-74.4-70.1-79.4l-7.9-1z'
      
    ]
  };

  

  
  

  var faCalendars = {
    prefix: 'fal',
    iconName: 'calendars',
    icon: [
      512,
      512,
      [],
      'e0d7',
      
      'M208 0c8.8 0 16 7.2 16 16l0 48 160 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 64 0 160c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-160 0-64c0-35.3 28.7-64 64-64l32 0 0-48c0-8.8 7.2-16 16-16zM160 96c-17.7 0-32 14.3-32 32l0 32 352 0 0-32c0-17.7-14.3-32-32-32L160 96zm320 96l-352 0 0 160c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-160zM32 208l0 176c0 53 43 96 96 96l240 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-240 0C57.3 512 0 454.7 0 384L0 208c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faCircleArrowUpRight = {
    prefix: 'fal',
    iconName: 'circle-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e0fc',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 160l136 0c8.8 0 16 7.2 16 16l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-105.4L187.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 192 200 192c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faLeafyGreen = {
    prefix: 'fal',
    iconName: 'leafy-green',
    icon: [
      576,
      512,
      [129388],
      'e41d',
      
      'M233.8 27c-38-36.5-98.4-36-135.8 1.5C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1l0 35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6l0-39.3c-3.3-5-7-9.6-11.3-13.9L58.3 296.7c-4.4-4.4-6.9-10.4-6.9-16.6l0-35.7c0-21.1-8.5-39.3-14.3-51.2c-9.4-19.2-6-42.9 9.8-58.7L25.2 112.6 47 134.4c1.3-1.3 2.7-2.5 4-3.6C72.8 113.2 95.1 90.1 110.5 64c2.7-4.6 6.1-8.9 10.1-13c25.4-25.4 66.6-25.4 92.1 0l14.7-14.7L212.6 51.1c1.7 1.7 3.2 3.4 4.6 5.1c2.8-6.9 6.2-13.6 10.1-19.8c2-3.2 4.2-6.4 6.4-9.4zM68.7 507.3c6.2 6.2 16.4 6.2 22.6 0c0 0 0 0 0 0l40.6-40.6c12-12 28.3-18.7 45.3-18.7l68.4 0c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7l43 0c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3l0 43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3l0 68.4c0 17-6.7 33.3-18.7 45.3L68.7 484.7c-6.2 6.2-6.2 16.4 0 22.6zM182.6 416L283.3 315.3 342.6 256l89.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-57.4 0 68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96L288 265.4l0-57.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4-96 96 0-62.9c0-8.5 3.4-16.6 9.4-22.6l10.5-10.5c18-18 28.1-42.4 28.1-67.9l0-43c0-8.5 3.4-16.6 9.4-22.6l29.1-29.1c16.4-16.4 24-37.1 29-51.5C284.1 58 308 40 336 40c2.3 0 4.6 .1 6.8 .4c31.7 3.3 68.1 2.7 101.2-5.8c6.4-1.6 13-2.5 20-2.5c44.2 0 80 35.8 80 80c0 6.9-.9 13.6-2.5 20c-8.5 33.1-9.2 69.5-5.8 101.2c.2 2.2 .4 4.5 .4 6.8c0 28-18 51.9-43.2 60.6c-14.4 4.9-35.2 12.6-51.5 29l-29.1 29.1c-6 6-14.1 9.4-22.6 9.4l-43 0c-25.5 0-49.9 10.1-67.9 28.1l-10.5 10.5c-6 6-14.1 9.4-22.6 9.4l-62.9 0z'
      
    ]
  };

  

  
  

  var faSquid = {
    prefix: 'fal',
    iconName: 'squid',
    icon: [
      512,
      512,
      [129425],
      'e450',
      
      'M244.6 4.7c3.5-3.5 8.3-5.2 13.2-4.6L391.1 15.8C419.3 9.3 450.4 4.3 484.9 1c15-1.4 27.6 11.2 26.2 26.2c-3.3 34.4-8.4 65.6-14.8 93.8l15.7 133.2c.6 4.9-1.1 9.8-4.6 13.2s-8.4 5.1-13.3 4.5l-57-7.1c-7.3 10.7-14.9 20.4-22.8 29.1c-43.9 48.9-94.7 68.2-136.9 72.9l40.1 40.1c6.1 6.1 15.9 6.3 22.2 .4l66.8-62c18.9-17.6 48.3-17 66.6 1.2l34.2 34.2c6 6 6.3 15.5 .7 21.9l-11 12.5c-30.5 34.8-84.1 36.6-116.8 3.9l-2.9-2.9-15.9 14.7c-18.9 17.6-48.3 17-66.6-1.2l-50.3-50.3-30.1 20.7 38.1 38.1c18.7 18.7 18.7 49.1 0 67.9l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c6.2-6.2 6.2-16.4 0-22.6l-42.3-42.3L153.3 442c-5.8 4-9.1 10.5-9 17.5c.2 11.4 9.5 20.5 20.8 20.5l11.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-11.7 0c-28.9 0-52.4-23.1-52.8-52c-.3-17.7 8.3-34.4 22.9-44.4l29.5-20.3-48.1-48.1L95.9 377.4C86.2 391.6 70.2 400 53 400C24.2 400 .9 376.7 .9 347.9L.9 336c0-8.8 7.2-16 16-16s16 7.2 16 16l0 11.9c0 11.1 9 20.1 20.1 20.1c6.6 0 12.8-3.3 16.6-8.7l24.1-35L51.3 281.9c-6.2-6.2-16.4-6.2-22.6 0l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c18.7-18.7 49.1-18.7 67.9 0l38.1 38.1 20.7-30.1L82.5 217.1c-18.3-18.3-18.8-47.7-1.2-66.6L96 134.6l-2.9-2.9C60.3 99 62.1 45.4 96.9 14.9L109.5 4c6.3-5.5 15.9-5.2 21.8 .7l34.2 34.2c18.3 18.3 18.8 47.7 1.2 66.6l-62 66.8c-5.9 6.3-5.7 16.1 .4 22.2l40.1 40.1c4.7-42.2 24-93 72.9-136.9c8.8-7.9 18.5-15.5 29.1-22.8l-7.1-57c-.6-4.9 1.1-9.8 4.5-13.3zm32.6 52.1c11.8-6.3 24.5-12.2 38.2-17.7l-41-4.8 2.8 22.5zM135.1 320.5l56.4 56.4 45.2-31.1c9.5-6.5 20.2-9.5 30.6-10.3c36.3-2.6 82.7-18 123.2-63.1c39.6-44.1 74.6-117.8 87.7-238.7C357.3 46.9 283.6 81.9 239.5 121.5C194.4 162 179 208.4 176.4 244.7c-.7 10.3-3.8 21.1-10.3 30.6l-31.1 45.2zm320.1-85.7l22.6 2.8-4.8-41c-5.5 13.7-11.4 26.4-17.7 38.2zM117.8 111.2l25.5-27.5c5.9-6.3 5.7-16.1-.4-22.2L119.3 37.9 118 39c-20.9 18.3-22 50.4-2.3 70.1l2.1 2.1zm283 283l2.1 2.1c19.6 19.6 51.8 18.6 70.1-2.3l1.1-1.3-23.6-23.6c-6.1-6.1-15.9-6.3-22.2-.4l-27.5 25.5zM208.9 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fal',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      'M432 32c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16zm0 288c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16zM136.8 216.4L54.2 254.6l82.6 38.1c6.9 3.2 12.4 8.7 15.6 15.6l38.1 82.6 38.1-82.6c3.2-6.9 8.7-12.4 15.6-15.6l82.6-38.1-82.6-38.1c-6.9-3.2-12.4-8.7-15.6-15.6l-38.1-82.6-38.1 82.6c-3.2 6.9-8.7 12.4-15.6 15.6zM123.4 321.8L9.3 269.1C3.6 266.5 0 260.8 0 254.6s3.6-11.9 9.3-14.5l114.1-52.7L176 73.3c2.6-5.7 8.3-9.3 14.5-9.3s11.9 3.6 14.5 9.3l52.7 114.1L371.8 240c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L257.8 321.8 205.1 435.8c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L123.4 321.8z'
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fal',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      'M9.8 33.3c8.1-3.4 17.5 .4 21 8.5L192 422.9 353.3 41.8c3.4-8.1 12.8-11.9 21-8.5s11.9 12.8 8.5 21l-176 416c-2.5 5.9-8.3 9.8-14.7 9.8s-12.2-3.8-14.7-9.8L1.3 54.2c-3.4-8.1 .4-17.5 8.5-21z'
      
    ]
  };

  

  
  

  var faObjectsAlignBottom = {
    prefix: 'fal',
    iconName: 'objects-align-bottom',
    icon: [
      512,
      512,
      [],
      'e3bb',
      
      'M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512zM176 352c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l64 0zm-64 32c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0l64 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-64 0zm288-32c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l64 0zm-64 32c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-64 0z'
      
    ]
  };

  

  
  

  var faBasketballHoop = {
    prefix: 'fal',
    iconName: 'basketball-hoop',
    icon: [
      640,
      512,
      [],
      'f435',
      
      'M35.1 201.9C51.5 170.8 135.3 32 320 32s268.5 138.8 284.9 169.9c2.1 4 3.1 8.4 3.1 13l0 116.3c0 12.6-7.4 24.1-19 29.2l-79.2 35.2-5 37.2L602 389.7c23.1-10.3 38-33.2 38-58.5l0-116.3c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9L0 331.2c0 25.3 14.9 48.2 38 58.5l97.2 43.2-5-37.2L51 360.4c-11.6-5.1-19-16.6-19-29.2l0-116.3c0-4.6 .9-9 3.1-13zM192 176c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32 32 0 0-32c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 32 32 0 0-32zm-48 64l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l18 0 30.1 226.1c.8 6.2 5.2 11.4 11.3 13.2s12.6-.1 16.7-4.8l48.3-55.7 56.3 56.5c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l56.3-56.5 48.3 55.7c4.1 4.8 10.6 6.7 16.7 4.8s10.4-7 11.3-13.2L494 272l18 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-15.8 0c-.2 0-.3 0-.5 0L448 240l-47.9 0-.2 0-31.9 0-.1 0-95.9 0-.1 0-31.9 0-.2 0L192 240l-31.7 0c-.2 0-.3 0-.5 0L144 240zm34.3 32l54.4 0 1.4 1.7-48.6 53.1L178.3 272zM279 272l81.9 0 2.1 2.2-43 49.6-43-49.6L279 272zm128.3 0l54.4 0-7.3 54.7-48.6-53.1 1.4-1.7zM320 473.3l-46.6-46.8L320 372.7l46.6 53.8L320 473.3zm-69.3-69.5l-48.1-48.3L255.2 298l43.6 50.3-48.1 55.5zm-21 24.2l-26.5 30.6-8.8-66.1 35.3 35.5zm159.6-24.2l-48.1-55.5L384.8 298l52.6 57.5-48.1 48.3zm21 24.2l35.3-35.5-8.8 66.1-26.5-30.6z'
      
    ]
  };

  

  
  

  var faTooth = {
    prefix: 'fal',
    iconName: 'tooth',
    icon: [
      448,
      512,
      [129463],
      'f5c9',
      
      'M132 64c14.7 0 29 4.8 40.8 13.6l41.6 31.2 21.3 16c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-5.4-4 16.3-13.9c13-11.1 29.5-17.2 46.6-17.2c39.5 0 71.6 32.1 71.6 71.6l0 3c0 11.6-2.7 23-7.9 33.4L354 216.3c-6.2 12.3-10.5 25.5-13 39.1L307.4 443.6 279.3 331.2C272.9 305.8 250.1 288 224 288s-48.9 17.8-55.3 43.2L140.6 443.6 107 255.4c-2.4-13.6-6.8-26.7-13-39.1L71.9 172c-5.2-10.4-7.9-21.8-7.9-33.4l0-6.6c0-37.6 30.4-68 68-68zm91.3 11.5L192 52c-17.3-13-38.4-20-60-20C76.8 32 32 76.8 32 132l0 6.6c0 16.6 3.9 32.9 11.3 47.7l22.2 44.3c4.8 9.6 8.2 19.8 10.1 30.4l34.6 193.6c2.6 14.7 15.4 25.4 30.4 25.4c14.1 0 26.5-9.6 29.9-23.4l29.4-117.7c2.8-11.1 12.8-18.9 24.2-18.9s21.5 7.8 24.2 18.9l29.4 117.7c3.4 13.7 15.8 23.4 29.9 23.4c14.9 0 27.7-10.7 30.4-25.4L372.5 261c1.9-10.6 5.3-20.8 10.1-30.4l22.2-44.3c7.4-14.8 11.3-31.1 11.3-47.7l0-3C416 78.4 369.6 32 312.4 32c-24.7 0-48.6 8.8-67.4 24.9L223.3 75.5z'
      
    ]
  };

  

  
  

  var faFaceGrinWide = {
    prefix: 'fal',
    iconName: 'face-grin-wide',
    icon: [
      512,
      512,
      [128515,"grin-alt"],
      'f581',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  
    var faGrinAlt = faFaceGrinWide;
  

  
  

  var faPills = {
    prefix: 'fal',
    iconName: 'pills',
    icon: [
      576,
      512,
      [],
      'f484',
      
      'M112 64c44.2 0 80 35.8 80 80l0 112L32 256l0-112c0-44.2 35.8-80 80-80zM32 368l0-80 160 0 0 80c0 44.2-35.8 80-80 80s-80-35.8-80-80zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-224c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 448c-70.7 0-128-57.3-128-128c0-29.6 10-56.8 26.9-78.5L494.5 421.1C472.8 438 445.6 448 416 448zM337.5 218.9C359.2 202 386.4 192 416 192c70.7 0 128 57.3 128 128c0 29.6-10 56.8-26.9 78.5L337.5 218.9zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faArrowDownLeftAndArrowUpRightToCenter = {
    prefix: 'fal',
    iconName: 'arrow-down-left-and-arrow-up-right-to-center',
    icon: [
      512,
      512,
      [],
      'e092',
      
      'M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 169.4 320 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-105.4 0L507.3 27.3zM4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 342.6 192 448c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16L64 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l105.4 0L4.7 484.7z'
      
    ]
  };

  

  
  

  var faHryvniaSign = {
    prefix: 'fal',
    iconName: 'hryvnia-sign',
    icon: [
      384,
      512,
      [8372,"hryvnia"],
      'f6f2',
      
      'M99.7 86.1C121.3 71.7 146.7 64 172.6 64L231 64c40.3 0 73 32.7 73 73c0 21.4-9.3 41.3-25 55L16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l204.2 0L106 281.1c-4.1 2.1-8.1 4.4-11.8 6.9L16 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l47.6 0C53.6 336.2 48 355.2 48 375c0 58 47 105 105 105l58.4 0c32.3 0 63.8-9.5 90.6-27.4l10.9-7.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-10.9 7.2c-21.6 14.4-46.9 22.1-72.9 22.1L153 448c-40.3 0-73-32.7-73-73c0-21.4 9.3-41.3 25-55l263 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-204.2 0L278 230.9c4.1-2.1 8.1-4.4 11.8-6.9l78.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-47.6 0c10-16.2 15.6-35.2 15.6-55c0-58-47-105-105-105l-58.4 0c-32.3 0-63.8 9.5-90.6 27.4L71.1 66.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l10.9-7.2z'
      
    ]
  };

  
    var faHryvnia = faHryvniaSign;
  

  
  

  var faI = {
    prefix: 'fal',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l128 0 0 384L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0 0-384 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 32 16 32z'
      
    ]
  };

  

  
  

  var faUserHelmetSafety = {
    prefix: 'fal',
    iconName: 'user-helmet-safety',
    icon: [
      448,
      512,
      [128119,"user-construction","user-hard-hat"],
      'f82c',
      
      'M176 60.8c-28.7 16.6-48 47.6-48 83.2l192 0c0-35.5-19.3-66.6-48-83.2L272 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-19.2zM271.2 25C318.5 43.8 352 90 352 144l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c0-54 33.5-100.2 80.8-119C180 10.7 192.7 0 208 0l32 0c15.3 0 28 10.7 31.2 25zM224 320c-65.3 0-119.1-48.9-127-112l32.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l32.3 0c-7.9 63.1-61.7 112-127 112zM415.8 480c-3.3-53.6-47.8-96-102.2-96l-179.2 0C80 384 35.5 426.4 32.2 480l383.6 0zM0 486.4C0 412.2 60.2 352 134.4 352l89.6 0 89.6 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4z'
      
    ]
  };

  
    var faUserConstruction = faUserHelmetSafety;
  
    var faUserHardHat = faUserHelmetSafety;
  

  
  

  var faDialHigh = {
    prefix: 'fal',
    iconName: 'dial-high',
    icon: [
      576,
      512,
      [],
      'e15c',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 248l127 0c-7.9 63.1-61.7 112-127 112c-70.7 0-128-57.3-128-128s57.3-128 128-128c65.3 0 119.1 48.9 127 112l-127 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm160-16a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faGlassEmpty = {
    prefix: 'fal',
    iconName: 'glass-empty',
    icon: [
      384,
      512,
      [],
      'e191',
      
      'M40.1 32c-4.7 0-8.4 4-8 8.7l34.6 410C68.1 467.3 81.9 480 98.6 480l186.8 0c16.6 0 30.5-12.7 31.9-29.3l34.6-410c.4-4.7-3.3-8.7-8-8.7L40.1 32zM.2 43.4C-1.7 20 16.7 0 40.1 0L343.8 0c23.4 0 41.8 20 39.9 43.4l-34.6 410c-2.8 33.1-30.5 58.6-63.8 58.6L98.6 512c-33.3 0-61-25.5-63.8-58.6L.2 43.4z'
      
    ]
  };

  

  
  

  var faDroneFront = {
    prefix: 'fal',
    iconName: 'drone-front',
    icon: [
      640,
      512,
      ["drone-alt"],
      'f860',
      
      'M144 96c8.8 0 16 7.2 16 16l0 16 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-16c0-8.8 7.2-16 16-16zm352 0c8.8 0 16 7.2 16 16l0 16 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-16c0-8.8 7.2-16 16-16zM128 256l0-64 32 0 0 55.1 12.6 7.9 50.6-33.7C251.9 202.2 285.5 192 320 192s68.1 10.2 96.8 29.3L467.4 255l12.6-7.9 0-55.1 32 0 0 64c0 5.5-2.8 10.6-7.5 13.6l-58.1 36.3 7.7 9.2c16.8 20.1 26 45.5 26 71.7l0 13.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-13.2c0-18.7-6.6-36.8-18.5-51.2L419 323l-42.5 26.6c-2.5 1.6-5.5 2.4-8.5 2.4l-96 0c-3 0-5.9-.8-8.5-2.4L221 323l-10.5 12.6c-12 14.4-18.5 32.5-18.5 51.2l0 13.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-13.2c0-26.2 9.2-51.6 26-71.7l7.7-9.2-58.1-36.3c-4.7-2.9-7.5-8.1-7.5-13.6zm309.6 17.6l-38.5-25.7C375.7 232.3 348.1 224 320 224s-55.6 8.3-79.1 23.9l-38.5 25.7L276.6 320l86.8 0 74.2-46.4z'
      
    ]
  };

  
    var faDroneAlt = faDroneFront;
  

  
  

  var faStairs = {
    prefix: 'fal',
    iconName: 'stairs',
    icon: [
      576,
      512,
      [],
      'e289',
      
      'M416 48c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L448 64l0 112c0 8.8-7.2 16-16 16l-128 0 0 144c0 8.8-7.2 16-16 16l-128 0 0 112c0 8.8-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-112c0-8.8 7.2-16 16-16l128 0 0-144c0-8.8 7.2-16 16-16l128 0 0-112z'
      
    ]
  };

  

  
  

  var faToiletPaperUnderSlash = {
    prefix: 'fal',
    iconName: 'toilet-paper-under-slash',
    icon: [
      640,
      512,
      ["toilet-paper-reverse-slash"],
      'e2a1',
      
      'M500.4 480L240 480c-8.8 0-16-7.2-16-16l0-48-32 0 0 48c0 26.5 21.5 48 48 48l288 0c3.9 0 7.7-.5 11.3-1.3L500.4 480zM544 327.6l0 23.7 32 25.3L576 192c0-50.8-11.2-97.5-30.1-132.1C527.4 25.9 499.1 0 464 0L176 0c-19.3 0-36.5 7.8-51.1 20.4l25.8 20.4c8.5-6 17.1-8.8 25.3-8.8l225.3 0c-7.2 8.2-13.6 17.7-19.2 27.9C363.2 94.5 352 141.2 352 192c0 2.6 0 5.2 .1 7.8l33.9 26.7c-1.3-11.1-1.9-22.6-1.9-34.5c0-46.5 10.3-87.7 26.2-116.8C426.4 45.5 446.1 32 464 32s37.6 13.5 53.8 43.2C533.7 104.3 544 145.5 544 192s-10.3 87.7-26.2 116.8c-3 5.4-6 10.3-9.2 14.6l25.1 19.8c3.7-4.9 7.1-10.2 10.2-15.7zM64 192c0 50.8 11.2 97.5 30.1 132.1c18.6 34 46.8 59.9 81.9 59.9l202.8 0-40.5-32L176 352c-17.9 0-37.6-13.5-53.8-43.2C106.3 279.7 96 238.5 96 192c0-10.3 .5-20.4 1.5-30.1L68.2 138.8c-2.8 17-4.2 34.8-4.2 53.2zm400 48c-6.4 0-11.9-11.3-14.5-27.6c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
  

  
  

  var faDrawSquare = {
    prefix: 'fal',
    iconName: 'draw-square',
    icon: [
      448,
      512,
      [],
      'f5ef',
      
      'M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96c29.8 0 54.9 20.4 62 48l196 0c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 29.8-20.4 54.9-48 62l0 196c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64c-29.8 0-54.9-20.4-62-48l-196 0c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-196C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32zm62 368l196 0c5.8-22.5 23.5-40.2 46-46l0-196c-22.5-5.8-40.2-23.5-46-46l-196 0c-5.8 22.5-23.5 40.2-46 46l0 196c22.5 5.8 40.2 23.5 46 46zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFilePlus = {
    prefix: 'fal',
    iconName: 'file-plus',
    icon: [
      384,
      512,
      [],
      'f319',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM176 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64z'
      
    ]
  };

  

  
  

  var faStamp = {
    prefix: 'fal',
    iconName: 'stamp',
    icon: [
      512,
      512,
      [],
      'f5bf',
      
      'M310.4 129.8c6.1-9.8 9.6-21.3 9.6-33.8c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 12.5 3.5 24 9.6 33.8c9.5 15.2 22.4 37.9 22.4 65.1c0 51.4-41.7 93.1-93.1 93.1L112 288c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-18.9 0c-51.4 0-93.1-41.7-93.1-93.1c0-27.1 12.9-49.9 22.4-65.1zm27.2 16.9c-9.2 14.8-17.5 30.8-17.5 48.2c0 33.8 27.4 61.1 61.1 61.1l18.9 0c61.9 0 112 50.1 112 112c0 26.5-21.5 48-48 48L48 416c-26.5 0-48-21.5-48-48c0-61.9 50.1-112 112-112l18.9 0c33.8 0 61.1-27.4 61.1-61.1c0-17.4-8.3-33.4-17.5-48.2C165.3 132 160 114.6 160 96c0-53 43-96 96-96s96 43 96 96c0 18.6-5.3 36-14.5 50.7zM64 456l0 8c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 26.5-21.5 48-48 48L80 512c-26.5 0-48-21.5-48-48l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSaltShaker = {
    prefix: 'fal',
    iconName: 'salt-shaker',
    icon: [
      384,
      512,
      [129474],
      'e446',
      
      'M352 453.2c0-1.6-.1-3.2-.4-4.7L305.8 192 78.2 192 32.4 448.5c-.3 1.6-.4 3.1-.4 4.7C32 468 44 480 58.8 480l266.4 0c14.8 0 26.8-12 26.8-26.8zM300.1 160l-7.9-44.1C283.5 67.3 241.3 32 192 32s-91.5 35.3-100.2 83.9L83.9 160l216.1 0zm25.1 352L58.8 512C26.3 512 0 485.7 0 453.2c0-3.5 .3-6.9 .9-10.3L60.3 110.3C71.7 46.5 127.2 0 192 0s120.3 46.5 131.7 110.3l59.4 332.6c.6 3.4 .9 6.9 .9 10.3c0 32.5-26.3 58.8-58.8 58.8zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM151.9 242l-24 192c-1.1 8.8-9.1 15-17.9 13.9s-15-9.1-13.9-17.9l24-192c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9zm112-4l24 192c1.1 8.8-5.1 16.8-13.9 17.9s-16.8-5.1-17.9-13.9l-24-192c-1.1-8.8 5.1-16.8 13.9-17.9s16.8 5.1 17.9 13.9z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleDollar = {
    prefix: 'fal',
    iconName: 'chart-mixed-up-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e5d9',
      
      'M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l72.2 0-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5L191.7 100 326.2 204.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6l0 74.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16L416 0zM192 448c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 8.8-7.2 16-16 16zm0-224c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM408.1 339c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1z'
      
    ]
  };

  

  
  

  var faICursor = {
    prefix: 'fal',
    iconName: 'i-cursor',
    icon: [
      256,
      512,
      [],
      'f246',
      
      'M0 14.9C-.6 23.7 6 31.3 14.9 32l8 .6C73.1 36.1 112 77.9 112 128.3L112 240l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 111.7c0 50.4-38.9 92.2-89.2 95.8l-8 .6C6 480.7-.6 488.3 0 497.1S8.3 512.6 17.1 512l8-.6c44.6-3.2 82.5-29 102.9-65.7c20.4 36.7 58.3 62.5 102.9 65.7l8 .6c8.8 .6 16.5-6 17.1-14.8s-6-16.5-14.8-17.1l-8-.6c-50.2-3.6-89.2-45.4-89.2-95.8L144 272l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-111.7c0-50.4 38.9-92.2 89.2-95.8l8-.6c8.8-.6 15.4-8.3 14.8-17.1S247.7-.6 238.9 0l-8 .6c-44.6 3.2-82.5 29-102.9 65.7C107.6 29.6 69.7 3.8 25.1 .6l-8-.6C8.3-.6 .7 6 0 14.9z'
      
    ]
  };

  

  
  

  var faSquareArrowUpLeft = {
    prefix: 'fal',
    iconName: 'square-arrow-up-left',
    icon: [
      448,
      512,
      [],
      'e263',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm280 64c8.8 0 16 7.2 16 16s-7.2 16-16 16l-97.4 0L315.3 324.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6 160 320c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144c0-8.8 7.2-16 16-16l136 0z'
      
    ]
  };

  

  
  

  var fa5 = {
    prefix: 'fal',
    iconName: '5',
    icon: [
      320,
      512,
      [],
      '35',
      
      'M48.5 44.1C50.3 37 56.7 32 64 32l208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L76.5 64l-40 160L192 224c70.7 0 128 57.3 128 128s-57.3 128-128 128L84.5 480c-33.3 0-63.8-18.8-78.7-48.6l-4.1-8.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.1 8.2c9.5 19 28.9 31 50.1 31L192 448c53 0 96-43 96-96s-43-96-96-96L16 256c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l48-192z'
      
    ]
  };

  

  
  

  var faLandMineOn = {
    prefix: 'fal',
    iconName: 'land-mine-on',
    icon: [
      640,
      512,
      [],
      'e51b',
      
      'M320 0c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zM192 400l32 0 192 0 32 0s0 0 0 0l32.8 0c6.3 0 12.1 3.7 14.6 9.5L526.8 480l-413.5 0 31.3-70.5c2.6-5.8 8.3-9.5 14.6-9.5l32.8 0s0 0 0 0zm32-32l0-32c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 32-192 0zm224 0l0-32c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 32-32 0-.8 0c-19 0-36.2 11.2-43.9 28.5L84 467c-9.4 21.2 6.1 45 29.2 45l413.5 0c23.2 0 38.6-23.8 29.2-45l-31.3-70.5C517 379.2 499.8 368 480.8 368l-.8 0-32 0s0 0 0 0zM57.6 131.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4l128 96c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-128-96zm547.2 3.2c-5.3-7.1-15.3-8.5-22.4-3.2l-128 96c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l128-96c7.1-5.3 8.5-15.3 3.2-22.4z'
      
    ]
  };

  

  
  

  var faTricycle = {
    prefix: 'fal',
    iconName: 'tricycle',
    icon: [
      512,
      512,
      [],
      'e5c3',
      
      'M272 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.3 0C372.1 64 384 75.9 384 90.7c0 8.4-4 16.3-10.7 21.3l-42.7 32-27.2 0c-58.4 0-113.2 24.5-152.1 66.1L117.9 160l10.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l31.4 0 51 76.5c-2.7 4-5.2 8.1-7.6 12.3l-4.2 7.4c-2.2-.1-4.4-.2-6.6-.2C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-48-30.1-88.9-72.5-104.8C183 209.2 240.8 176 303.4 176l20.1 0 14.2 56.6C289.9 251.2 256 297.6 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-5.2 0-10.3 .3-15.3 .9l-14.6-58.5 38.4-28.8c14.8-11.1 23.5-28.5 23.5-46.9C416 58.3 389.7 32 357.3 32L272 32zm73.5 232l23 91.9c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-23-91.8c2.5-.2 4.9-.3 7.4-.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-39.3 23.7-73.1 57.5-88zM112 288a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faFaceZany = {
    prefix: 'fal',
    iconName: 'face-zany',
    icon: [
      512,
      512,
      [],
      'e3a4',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm272-64c-26.5 0-48-21.5-48-48c0-3.9 .5-7.7 1.4-11.4C261 143.9 271.5 152 284 152c15.5 0 28-12.5 28-28c0-12.5-8.1-23-19.4-26.6c3.6-.9 7.5-1.4 11.4-1.4c26.5 0 48 21.5 48 48s-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM144 184a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm24-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-4.5 166.7c-2.3 6.2-3.5 12.9-3.5 19.9l0 5.4c0 53 43 96 96 96s96-43 96-96l0-5.4c0-2.3-.1-4.6-.4-6.9c57.3-37.6 82-108 64.4-173.2c-3.7-13.7-19.6-18.7-31.8-11.6L159.8 348.5c-12.3 7.1-15.8 23.4-5.8 33.4c3.1 3.1 6.2 6 9.5 8.8zm175.4-17c-10.8-13.2-27.1-21.6-45.5-21.6l-2 0c-13.3 0-25.6 4.6-35.4 12.5c-9.7-7.9-22.1-12.5-35.4-12.5l-2 0c-.3 0-.6 0-.9 0l170.5-98.4c6.9 46-11.6 92.6-49.3 120.1zM291.4 384l2 0c14.7 0 26.6 11.9 26.6 26.6l0 5.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-5.4c0-14.7 11.9-26.6 26.6-26.6l2 0c6.7 0 12.8 2.7 17.2 7.2l.2 .3c1.6 1.7 3 3.6 4.1 5.8c.9 1.8 1.6 3.7 2 5.7c2.8 12.6 20.8 12.6 23.6 0c.4-2 1.1-3.9 2-5.7c1.1-2.1 2.5-4.1 4.1-5.8l.2-.3c4.4-4.5 10.6-7.2 17.2-7.2z'
      
    ]
  };

  

  
  

  var faSquareRss = {
    prefix: 'fal',
    iconName: 'square-rss',
    icon: [
      448,
      512,
      ["rss-square"],
      'f143',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-150.2-121.8-272-272-272zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176z'
      
    ]
  };

  
    var faRssSquare = faSquareRss;
  

  
  

  var faOctagonMinus = {
    prefix: 'fal',
    iconName: 'octagon-minus',
    icon: [
      512,
      512,
      ["minus-octagon"],
      'f308',
      
      'M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3l0 129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7l129 0c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3l0-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7l-129 0zM160 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faMinusOctagon = faOctagonMinus;
  

  
  

  var faDiceFive = {
    prefix: 'fal',
    iconName: 'dice-five',
    icon: [
      448,
      512,
      [9860],
      'f523',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRoadCircleCheck = {
    prefix: 'fal',
    iconName: 'road-circle-check',
    icon: [
      640,
      512,
      [],
      'e564',
      
      'M157.5 74c9.2-25.2 33.2-42 60.1-42l204.9 0c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21L336 64l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-86.4 0c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43l238.5 0c5.9 11.4 12.9 22.2 21 32l-259.6 0c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208l0 86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faFaceRelieved = {
    prefix: 'fal',
    iconName: 'face-relieved',
    icon: [
      512,
      512,
      [],
      'e389',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm187.3 92.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 389.2 298.9 408 256 408s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm82.4-131.5c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z'
      
    ]
  };

  

  
  

  var faEclipse = {
    prefix: 'fal',
    iconName: 'eclipse',
    icon: [
      640,
      512,
      [],
      'f749',
      
      'M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.6-52.2c-10.3-4.5-20.2-9.9-29.6-15.9l-7 38-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 7 38.1c9.4-6.1 19.3-11.4 29.6-15.9l-9.6-52.2zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c-6.5-9-12.3-18.4-17.3-28.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96c7.6 0 15 .9 22.1 2.6c5-9.9 10.8-19.4 17.3-28.4c-12.4-4-25.7-6.2-39.4-6.2zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z'
      
    ]
  };

  

  
  

  var faAlarmClock = {
    prefix: 'fal',
    iconName: 'alarm-clock',
    icon: [
      512,
      512,
      [9200],
      'f34e',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 5 2.4 9.8 6.4 12.8l64 48c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4L272 296l0-120z'
      
    ]
  };

  

  
  

  var faEarDeaf = {
    prefix: 'fal',
    iconName: 'ear-deaf',
    icon: [
      512,
      512,
      ["deaf","deafness","hard-of-hearing"],
      'f2a4',
      
      'M507.3 27.3l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-320 320l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM240 96C160.5 96 96 160.5 96 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176s176 78.8 176 176c0 51.3-21.9 97.4-56.9 129.6c-4.8 4.4-7.1 9.7-7.1 14.4c0 70.7-57.3 128-128 128l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c53 0 96-43 96-96c0-15.4 7.4-28.7 17.5-38c28.6-26.3 46.5-64.1 46.5-106c0-79.5-64.5-144-144-144zm0 64c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80z'
      
    ]
  };

  
    var faDeaf = faEarDeaf;
  
    var faDeafness = faEarDeaf;
  
    var faHardOfHearing = faEarDeaf;
  

  
  

  var faClockThreeThirty = {
    prefix: 'fal',
    iconName: 'clock-three-thirty',
    icon: [
      512,
      512,
      [],
      'e357',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400l0-144c0-8.8 7.2-16 16-16l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceGrinWink = {
    prefix: 'fal',
    iconName: 'face-grin-wink',
    icon: [
      512,
      512,
      ["grin-wink"],
      'f58c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z'
      
    ]
  };

  
    var faGrinWink = faFaceGrinWink;
  

  
  

  var faHatWitch = {
    prefix: 'fal',
    iconName: 'hat-witch',
    icon: [
      576,
      512,
      [],
      'f6e7',
      
      'M96 384l34.9 0 80.9-185c13.8-31.5 37.3-57.7 67.2-74.8L436.8 34.1c2.4-1.4 5.2-2.1 7.9-2.1l1.5 0c3.8 0 7.5 1.4 10.4 3.9l82.5 70.7c3.1 2.7 4.9 6.5 4.9 10.6c0 2.2-.5 4.3-1.5 6.3L516.7 175l-1.1-4.3C509.4 145.6 486.9 128 461 128c-18.8 0-36.4 9.4-46.9 25.1l-14.3 21.5c-10.3 15.5-15.8 33.6-15.8 52.2c0 13.2 2.8 26.2 8.1 38.2L445 384l35 0L421.4 252c-3.5-7.9-5.4-16.5-5.4-25.2c0-12.3 3.6-24.3 10.4-34.5l14.3-21.5c4.5-6.8 12.1-10.8 20.2-10.8c11.2 0 20.9 7.6 23.6 18.4l7.1 28.3c2.5 10.2 11.7 17.3 22.2 17.3c8.7 0 16.6-4.9 20.5-12.6l36.8-73.6c3.2-6.4 4.9-13.4 4.9-20.6c0-13.4-5.9-26.2-16.1-34.9L477.5 11.6C468.8 4.1 457.7 0 446.2 0l-1.5 0c-8.4 0-16.6 2.2-23.8 6.3L263.2 96.5c-35.8 20.5-64.1 51.9-80.6 89.7L96 384zM52.8 448l470.4 0c-24.5 15.2-61.9 32-107.2 32l-256 0c-45.3 0-82.7-16.8-107.2-32zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512l256 0c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6L22.6 416zM304 352c8.8 0 16 7.2 16 16l0 16 32 0 0-16c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 16 32 0 0-16c0-8.8 7.2-16 16-16l32 0z'
      
    ]
  };

  

  
  

  var faCoffeeBeans = {
    prefix: 'fal',
    iconName: 'coffee-beans',
    icon: [
      512,
      512,
      [],
      'e13f',
      
      'M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-22.6-22.6c-33 33-103.4 32.3-158.4-22.6c-40.6-40.6-51.6-89.6-41.3-125.8c3.9 6.2 8 12 12.3 17.1c27.7 32.7 61.1 44.7 90.6 55.2l1 .3c30.1 10.8 56.2 20.4 78.2 46.3c6.4 7.5 12.6 17.8 18.4 28.7l-.7 .7zm6.3-49.7c-27.7-32.7-61.1-44.7-90.6-55.2l-1-.3c-30.1-10.8-56.2-20.4-78.2-46.3c-6.4-7.5-12.6-17.8-18.4-28.7l.7-.7c33-33 103.4-32.3 158.4 22.6c40.6 40.6 51.6 89.6 41.3 125.8c-3.9-6.2-8-12-12.3-17.1zM128 480c-46.7 0-96-50.3-96-128c0-57.4 26.9-99.8 59.8-118.1c-1.6 7.1-2.8 14.2-3.4 20.8c-3.6 42.7 11.6 74.8 25 103.1l.4 .9c13.7 28.9 25.4 54.2 22.5 88c-.8 9.8-3.6 21.5-7.3 33.3l-1 0zm39.6-30.7c3.6-42.7-11.6-74.8-25-103.1l-.4-.9c-13.7-28.9-25.4-54.2-22.5-88c.8-9.8 3.6-21.5 7.3-33.3l1 0c46.7 0 96 50.3 96 128c0 57.4-26.9 99.8-59.8 118.1c1.6-7.1 2.8-14.2 3.4-20.8zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z'
      
    ]
  };

  

  
  

  var faMessageSms = {
    prefix: 'fal',
    iconName: 'message-sms',
    icon: [
      512,
      512,
      [],
      'e1e5',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 144 96 160.5 96 180.8zM372.8 144c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9z'
      
    ]
  };

  

  
  

  var faChessBishop = {
    prefix: 'fal',
    iconName: 'chess-bishop',
    icon: [
      320,
      512,
      [9821],
      'f43a',
      
      'M104 0C95.2 0 88 7.2 88 16s7.2 16 16 16l11.6 0C103.6 42.9 89.8 56.7 75.9 72.8C39 115.7 0 177.6 0 248.7c0 53.2 37.2 80 64 92.3L64 352l32 0 0-21.6c0-6.7-4.1-12.7-10.4-15C62.5 306.8 32 288.1 32 248.7c0-59.7 33-114.3 68.1-155c17.4-20.2 34.7-36.4 47.8-47.6c4.7-4 8.8-7.3 12.1-10c3.3 2.6 7.4 6 12.1 10c13.1 11.2 30.4 27.5 47.8 47.6c7.2 8.4 14.3 17.3 21.1 26.7l-76.2 76.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L258.6 148c17.3 30.4 29.4 64.6 29.4 100.7c0 39.4-30.5 58-53.6 66.7c-6.3 2.3-10.4 8.3-10.4 15l0 21.6 32 0 0-10.9c26.8-12.3 64-39.1 64-92.3c0-71.2-39-133-75.9-175.9C230.2 56.7 216.4 42.9 204.4 32L216 32c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 0 104 0zM254.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4L39.4 480c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L65.8 416l188.4 0zm0-32L65.8 384c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512l241.1 0c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z'
      
    ]
  };

  

  
  

  var faSealExclamation = {
    prefix: 'fal',
    iconName: 'seal-exclamation',
    icon: [
      512,
      512,
      [],
      'e242',
      
      'M86.6 198.6c6-6 9.4-14.1 9.4-22.6l0-64c0-8.8 7.2-16 16-16l64 0c8.5 0 16.6-3.4 22.6-9.4l52.7-52.7c1.2-1.2 2.9-1.9 4.7-1.9s3.4 .7 4.7 1.9l52.7 52.7c6 6 14.1 9.4 22.6 9.4l64 0c8.8 0 16 7.2 16 16l0 64c0 8.5 3.4 16.6 9.4 22.6l52.7 52.7c1.2 1.2 1.9 2.9 1.9 4.7s-.7 3.4-1.9 4.7l-52.7 52.7c-6 6-9.4 14.1-9.4 22.6l0 64c0 8.8-7.2 16-16 16l-64 0c-8.5 0-16.6 3.4-22.6 9.4l-52.7 52.7c-1.2 1.2-2.9 1.9-4.7 1.9s-3.4-.7-4.7-1.9l-52.7-52.7c-6-6-14.1-9.4-22.6-9.4l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.5-3.4-16.6-9.4-22.6L33.9 260.7c-1.2-1.2-1.9-2.9-1.9-4.7s.7-3.4 1.9-4.7l52.7-52.7zM64 112l0 64L11.3 228.7C4.1 235.9 0 245.8 0 256s4.1 20.1 11.3 27.3L64 336l0 64c0 26.5 21.5 48 48 48l64 0 52.7 52.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L336 448l64 0c26.5 0 48-21.5 48-48l0-64 52.7-52.7c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L283.3 11.3C276.1 4.1 266.2 0 256 0s-20.1 4.1-27.3 11.3L176 64l-64 0c-26.5 0-48 21.5-48 48zm192 16c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faGrateDroplet = {
    prefix: 'fal',
    iconName: 'grate-droplet',
    icon: [
      576,
      512,
      [],
      'e194',
      
      'M64 64l320 0c17.7 0 32 14.3 32 32l0 88.9c7.8-11.1 19.1-19.1 32-22.7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l280.2 0c-6.6-9.9-12-20.6-16.1-32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zm320 64c0-17.7-14.3-32-32-32l-56 0-72 0-72 0L96 96c-17.7 0-32 14.3-32 32l0 128 0 128c0 17.7 14.3 32 32 32l56 0 72 0 72 0 24.9 0c-.6-5.3-.9-10.6-.9-16c0-5.4 .3-10.7 .9-16l-8.9 0 0-112 40 0 0 32 32-60 0-116zM96 128l40 0 0 112-40 0 0-112zm72 112l0-112 40 0 0 112-40 0zm72 0l0-112 40 0 0 112-40 0zm72 0l0-112 40 0 0 112-40 0zm-32 32l0 112-40 0 0-112 40 0zm-72 0l0 112-40 0 0-112 40 0zm-72 0l0 112-40 0 0-112 40 0zm257.4 90.4L464 230l70.6 132.4c6.2 11.6 9.4 24.5 9.4 37.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-13.1 3.2-26.1 9.4-37.6zm-28.2-15.1C356.5 363.5 352 381.6 352 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L487.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1L365.2 347.3z'
      
    ]
  };

  

  
  

  var faVideoArrowUpRight = {
    prefix: 'fal',
    iconName: 'video-arrow-up-right',
    icon: [
      576,
      512,
      [],
      'e2c9',
      
      'M320 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-47.2 0-161.6 0-47.2c0-35.3-28.7-64-64-64L64 64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2l0-243.6c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6l0 36.5 118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2l0 243.6c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9l0 36.5zM160 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l73.4 0L100.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 214.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-112 0z'
      
    ]
  };

  

  
  

  var faAcorn = {
    prefix: 'fal',
    iconName: 'acorn',
    icon: [
      448,
      512,
      [],
      'f6ae',
      
      'M267.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-3.9 3.9C225.5 23.9 215.1 43.2 210.5 64L96 64C43 64 0 107 0 160l0 16c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-16c0-53-43-96-96-96L243.6 64c3.8-12.3 10.6-23.6 19.8-32.8l3.9-3.9zM352 96c35.3 0 64 28.7 64 64l0 16L32 176l0-16c0-35.3 28.7-64 64-64l256 0zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240l-32 0c-4 70.6-35.5 165.2-143.5 206C116 405.2 84.4 310.6 80.5 240l-32 0z'
      
    ]
  };

  

  
  

  var faFlute = {
    prefix: 'fal',
    iconName: 'flute',
    icon: [
      640,
      512,
      [],
      'f8b9',
      
      'M160 320l416 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-416 0 0 128zm-32 0l0-128-64 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0zM64 160l64 0 16 0 16 0 416 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-416 0-16 0-16 0-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRaygun = {
    prefix: 'fal',
    iconName: 'raygun',
    icon: [
      576,
      512,
      [],
      'e025',
      
      'M39.3 2.6c4.5-3 10.3-3.4 15.2-1.2L195.4 64 272 64c18 0 34.6 6 48 16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96 0 16 32 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 32 0c0-6.1 3.4-11.6 8.8-14.3l96-48c5-2.5 10.9-2.2 15.6 .7s7.6 8.1 7.6 13.6l0 128c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-96-48c-5.4-2.7-8.8-8.3-8.8-14.3l-32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-32 0 0 16 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c-12.4 9.3-27.6 15.1-44.2 15.9l0 .1L172.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9l69-137.9C46.1 283.8 0 235.3 0 176c0-30.5 12.2-58.2 32-78.4L32 16c0-5.4 2.7-10.5 7.3-13.4zM480 176l0 6.1 64 32 0-76.2-64 32 0 6.1zM192.3 96c-.2 0-.5 0-.7 0L112 96c-44.2 0-80 35.8-80 80s35.8 80 80 80l8.2 0L256 256l16 0c26.5 0 48-21.5 48-48l0-32 0-32c0-26.5-21.5-48-48-48l-79.7 0zM64 40.6l0 34.2C78.5 67.9 94.8 64 112 64l4.6 0L64 40.6zM140 288L64 440l80 40 96-192-100 0zM112 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSkeletonRibs = {
    prefix: 'fal',
    iconName: 'skeleton-ribs',
    icon: [
      640,
      512,
      [],
      'e5cb',
      
      'M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-49.9 0c-29.3 0-56.6 16-69.7 42.9c-14.9 30.8-36.9 79.1-55.2 132C111 291.5 96 349.8 96 400l0 11.2c0 38 30.8 68.8 68.8 68.8c9.6 0 19.1-2 27.9-5.9l81.8-36.3c9.5-4.2 19.4-7 29.5-8.5l0 66.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-66.8c10.1 1.5 20 4.3 29.5 8.5l81.8 36.3c8.8 3.9 18.3 5.9 27.9 5.9c38 0 68.8-30.8 68.8-68.8l0-11.2c0-50.2-15-108.5-33.2-161.1c-18.3-52.8-40.3-101.2-55.2-132C442.5 80 415.2 64 385.9 64L336 64l0-48zM304 96l0 82.9L176.2 204.4c13.3-33.2 26.8-62.5 37-83.5c7.4-15.3 23.2-24.9 40.9-24.9L304 96zM162.8 239.7l.3-.1L304 211.5l0 72.5L135.8 333.1c5.7-27.4 14.1-55.9 23.7-83.7c1.1-3.2 2.3-6.5 3.4-9.7zM130 367.9c.8-.1 1.6-.3 2.4-.5l171.5-50 0 79.6c-14.5 1.6-28.9 5.5-42.5 11.5l-81.8 36.3c-4.7 2.1-9.8 3.2-14.9 3.2c-20.3 0-36.8-16.5-36.8-36.8l0-11.2c0-10.3 .7-21 2-32.1zM336 397l0-79.6 171.5 50c.8 .2 1.6 .4 2.5 .5c1.3 11.1 2 21.9 2 32.1l0 11.2c0 20.3-16.5 36.8-36.8 36.8c-5.1 0-10.2-1.1-14.9-3.2l-81.8-36.3c-13.6-6.1-28-9.9-42.5-11.5zm168.2-63.9L336 284l0-72.5 140.9 28.2 .3 .1c1.1 3.2 2.3 6.4 3.4 9.7c9.6 27.7 18 56.2 23.7 83.7zM463.8 204.4L336 178.9 336 96l49.9 0c17.7 0 33.5 9.6 40.9 24.9c10.2 21 23.7 50.3 37 83.5zM0 128L0 240 0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.6 4.9-16.6 12.6-20.4l44.5-22.2c23.8-11.9 38.9-36.3 38.9-63l0-6.4c0-35.3-28.7-64-64-64S0 92.7 0 128zm32 62.1L32 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 6.4c0 14.5-8.2 27.8-21.2 34.3L32 190.1zM576 64c-35.3 0-64 28.7-64 64l0 6.4c0 26.7 15.1 51 38.9 63l44.5 22.2c7.7 3.9 12.6 11.8 12.6 20.4l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256 0-112c0-35.3-28.7-64-64-64zM565.2 168.7c-13-6.5-21.2-19.8-21.2-34.3l0-6.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 62.1-42.8-21.4z'
      
    ]
  };

  

  
  

  var faThoughtBubble = {
    prefix: 'fal',
    iconName: 'thought-bubble',
    icon: [
      512,
      512,
      [],
      'e32e',
      
      'M256 0c-50.7 0-94.4 29.4-115.2 72.1c-1.6-.1-3.2-.1-4.8-.1C60.9 72 0 132.9 0 208s60.9 136 136 136c10.8 0 21.2-1.3 31.3-3.6C187.8 366.9 219.9 384 256 384s68.2-17.1 88.7-43.6c10.1 2.4 20.5 3.6 31.3 3.6c75.1 0 136-60.9 136-136s-60.9-136-136-136c-1.6 0-3.2 0-4.8 .1C350.4 29.4 306.7 0 256 0zM166 94.5C179.6 58 214.8 32 256 32s76.4 26 90 62.5c2.6 7 9.6 11.2 17 10.3c4.3-.5 8.6-.8 13-.8c57.4 0 104 46.6 104 104s-46.6 104-104 104c-11.5 0-22.6-1.9-32.9-5.3c-7.1-2.4-14.8 .5-18.7 6.9C310.3 336.6 284.9 352 256 352s-54.3-15.4-68.4-38.5c-3.9-6.4-11.6-9.2-18.7-6.9c-10.3 3.4-21.4 5.3-32.9 5.3C78.6 312 32 265.4 32 208s46.6-104 104-104c4.4 0 8.8 .3 13 .8c7.4 .9 14.4-3.3 17-10.3zM144 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 0A32 32 0 1 0 0 480a32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faUpToDottedLine = {
    prefix: 'fal',
    iconName: 'up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e457',
      
      'M222.2 160.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 292.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L288 304c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 160.8zM224 128c-9.5 0-18.6 3.9-25.1 10.8L74.5 270.8C67.8 278 64 287.5 64 297.3c0 21.4 17.3 38.7 38.7 38.7l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 138.9c-6.5-6.9-15.6-10.8-25.1-10.8zM416 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM296 60a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM224 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM104 60a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z'
      
    ]
  };

  

  
  

  var faFaceGrinTongue = {
    prefix: 'fal',
    iconName: 'face-grin-tongue',
    icon: [
      512,
      512,
      [128539,"grin-tongue"],
      'f589',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm144.4-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM352 416l0-32.6c20.2-15.7 36.4-36.2 46.9-59.9c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c10.4 23.6 26.6 44.1 46.8 59.8l0 32.7c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z'
      
    ]
  };

  
    var faGrinTongue = faFaceGrinTongue;
  

  
  

  var faPeriod = {
    prefix: 'fal',
    iconName: 'period',
    icon: [
      192,
      512,
      [],
      '2e',
      
      'M96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faBridgeCircleXmark = {
    prefix: 'fal',
    iconName: 'bridge-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4cb',
      
      'M48 32l80 0 128 0 128 0 128 0 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0-128 0-128 0-128 0-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64L48 64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM496 64l-96 0 0 64 96 0 0-64zM368 64l-96 0 0 64 96 0 0-64zM240 64l-96 0 0 64 96 0 0-64zM48 240l16 0c53 0 96 43 96 96l0 96c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-96c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64l0 96c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-96c0-35.3-28.7-64-64-64l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faFaceKiss = {
    prefix: 'fal',
    iconName: 'face-kiss',
    icon: [
      512,
      512,
      [128535,"kiss"],
      'f596',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm276.7 40.5c-10.8-5.3-25.3-9.2-38.6-11c-7.4-1-12.6-7.9-11.6-15.4s7.9-12.6 15.4-11.6c15.2 2.1 32.7 6.6 46.8 13.6c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4l-.2 .1 .2 .1c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4c-14.1 6.9-31.6 11.4-46.8 13.6c-7.4 1-14.3-4.1-15.4-11.6s4.1-14.3 11.6-15.4c13.3-1.9 27.8-5.8 38.6-11c5.4-2.7 9.2-5.3 11.5-7.7c2.7-2.9 2.7-4.7 0-7.6c-2.3-2.4-6.1-5.1-11.5-7.7c-10.7-5.3-25.1-9.1-38.3-11c-6.7-.8-12-6.7-12-13.5c0-6.8 5.3-12.7 12-13.5c13.2-1.9 27.6-5.8 38.3-11c5.4-2.7 9.2-5.3 11.5-7.7c2.7-2.9 2.7-4.7 0-7.6c-2.3-2.4-6.1-5.1-11.5-7.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faKiss = faFaceKiss;
  

  
  

  var faWindowFrameOpen = {
    prefix: 'fal',
    iconName: 'window-frame-open',
    icon: [
      512,
      512,
      [],
      'e050',
      
      'M272 32l144 0c17.7 0 32 14.3 32 32l0 192-176 0 0-224zM480 288l0-32 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 192 0 32 32 0 384 0 32 0zM240 256L64 256 64 64c0-17.7 14.3-32 32-32l144 0 0 224zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 416 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-160-32 0 0 160L64 480l0-160-32 0 0 160-16 0z'
      
    ]
  };

  

  
  

  var faLightbulbCfl = {
    prefix: 'fal',
    iconName: 'lightbulb-cfl',
    icon: [
      320,
      512,
      [],
      'e5a6',
      
      'M176 57.7C176 22 142.5-4.1 107.9 4.5L41.5 21.1C17.1 27.2 0 49.2 0 74.3c0 16 6.8 30.1 17.3 40C6.6 124.4 0 138.7 0 154.3c0 16 6.8 30.1 17.3 40C6.6 204.4 0 218.7 0 234.3c0 35.7 33.5 61.8 68.1 53.2l63.7-15.9 .1 0 64-16s0 0 0 0l63.8-15.9c14.4-3.6 28.3 7.3 28.3 22.1c0 10.5-7.1 19.6-17.3 22.1l-82.6 20.7C181 306.3 176 312.7 176 320l0 32-32 0 0-42.5-32 8 0 34.5-16 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l48 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 48 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-16 0 0-19.5 70.5-17.6c24.4-6.1 41.5-28 41.5-53.2c0-16-6.8-30.1-17.3-40c10.8-10.1 17.3-24.4 17.3-40c0-16-6.8-30.1-17.3-40c10.8-10.1 17.3-24.4 17.3-40c0-35.7-33.5-61.8-68.1-53.2L175.1 67.7c.6-3.3 .9-6.6 .9-10zM96 384l95.9 0 .1 0 .1 0 31.9 0 0 64L96 448l0-64zM270.7 203.8L124.1 240.5 60.3 256.4C45.9 260 32 249.1 32 234.3c0-10.5 7.1-19.6 17.3-22.1l18.6-4.6 .2-.1 191.7-47.9c14.3-3.5 28.2 7.4 28.2 22.2c0 10.5-7.1 19.6-17.3 22.1zm-136.2-93L259.7 79.6C274.1 76 288 86.9 288 101.7c0 10.5-7.1 19.6-17.3 22.1l-18.6 4.6-.2 .1L60.2 176.5C45.8 179.9 32 169.1 32 154.3c0-10.5 7.1-19.6 17.3-22.1L68 127.5c0 0 0 0 .1 0l66.4-16.6c0 0 0 0 .1 0zm-7.8-31c0 0 0 0 0 0L60.3 96.4s0 0 0 0C45.9 100 32 89.1 32 74.3c0-10.5 7.1-19.6 17.3-22.1l66.4-16.6C130.1 32 144 42.9 144 57.7c0 10.4-7.1 19.6-17.2 22.1z'
      
    ]
  };

  

  
  

  var faCommentArrowDown = {
    prefix: 'fal',
    iconName: 'comment-arrow-down',
    icon: [
      512,
      512,
      [],
      'e143',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 137.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 281.4 272 144z'
      
    ]
  };

  

  
  

  var faCameraWeb = {
    prefix: 'fal',
    iconName: 'camera-web',
    icon: [
      448,
      512,
      ["webcam"],
      'f832',
      
      'M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM357.5 403.9C412.4 363 448 297.7 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 73.7 35.6 139 90.5 179.9L37 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4l336 0c9.1 0 17.5-5.2 21.5-13.4s3.1-18-2.5-25.2l-53.5-69.5zm-27.1 17.3L375.8 480 72.2 480l45.3-58.9C149.2 438.3 185.5 448 224 448s74.8-9.7 106.5-26.9zM224 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faWebcam = faCameraWeb;
  

  
  

  var faSquareM = {
    prefix: 'fal',
    iconName: 'square-m',
    icon: [
      448,
      512,
      [],
      'e276',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm125.1 38.8L224 276.1l98.9-141.3c4-5.7 11.3-8.2 17.9-6.1s11.2 8.3 11.2 15.3l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-173.2L237.1 313.2c-3 4.3-7.9 6.8-13.1 6.8s-10.1-2.5-13.1-6.8L128 194.8 128 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1z'
      
    ]
  };

  

  
  

  var faFaceScream = {
    prefix: 'fal',
    iconName: 'face-scream',
    icon: [
      640,
      512,
      [],
      'e38b',
      
      'M543.2 274.5c.5-6.1 .8-12.3 .8-18.5C544 132.3 443.7 32 320 32S96 132.3 96 256c0 6.2 .3 12.4 .8 18.5c-10.5-2.5-21.4-3.2-32.2-1.9c-.4-5.5-.5-11-.5-16.6C64 114.6 178.6 0 320 0S576 114.6 576 256c0 5.6-.2 11.1-.5 16.6c-10.8-1.3-21.7-.6-32.2 1.9zM407.6 462.2c-2.7 12.2-4.9 24.5-6.4 36.6C375.7 507.4 348.4 512 320 512c-28.4 0-55.6-4.6-81.1-13.1c-1.5-12.2-3.6-24.4-6.4-36.6C259.4 473.7 288.9 480 320 480c31.1 0 60.7-6.3 87.6-17.8zM224.3 164.4c-13.1 5.8-26.4 17.1-36.1 33c-9.7 15.9-13.3 32.2-12.1 45.3c1.2 13 6.9 21.7 14.7 26c8.1 4.4 19.5 4.7 32.7-1.1c13.1-5.8 26.4-17.1 36.1-33c9.7-15.9 13.3-32.2 12.1-45.3c-1.2-13-6.9-21.7-14.7-26c-8.1-4.4-19.5-4.7-32.7 1.1zm-12.9-29.3c19.4-8.6 41.8-10.4 61 .1c19.4 10.6 29.3 30.3 31.2 51.2c1.9 20.8-3.8 43.9-16.6 64.9c-12.8 21-30.9 37-50.5 45.6c-19.4 8.6-41.8 10.4-61-.1c-19.4-10.6-29.3-30.3-31.2-51.2c-1.9-20.8 3.8-43.9 16.6-64.9c12.8-21 30.9-37 50.5-45.6zm204.2 29.3c-13.2-5.8-24.6-5.5-32.7-1.1c-7.9 4.3-13.5 13-14.7 26c-1.2 13.1 2.4 29.4 12.1 45.3c9.7 15.9 23 27.2 36.1 33c13.2 5.8 24.6 5.5 32.7 1.1c7.9-4.3 13.5-13 14.7-26c1.2-13.1-2.4-29.4-12.1-45.3c-9.7-15.9-23-27.2-36.1-33zm12.9-29.3c19.5 8.6 37.7 24.6 50.5 45.6c12.8 21 18.5 44.1 16.6 64.9c-1.9 20.9-11.8 40.6-31.2 51.2c-19.2 10.5-41.5 8.7-61 .1c-19.5-8.6-37.7-24.6-50.5-45.6c-12.8-21-18.5-44.1-16.6-64.9c1.9-20.9 11.8-40.6 31.2-51.2c19.2-10.5 41.5-8.7 61-.1zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-32zM113.6 317.8s0 0 0 0c29.4 24.5 52.9 60.4 69 97.8c13.7 31.8 22.5 65.7 24.8 96.4l-32.1 0c-2.3-26-9.9-55.5-22.1-83.8c-14.8-34.3-35.6-65.4-60-85.8c-9.1-7.5-22.5-8.7-32.9-2c0 0 0 0 0 0c-8 5.2-12.2 13.7-12.2 22.4c0 5 1.4 10.1 4.4 14.6c0 0 0 0 0 0C77.7 415.6 95 463.4 97.9 512l-32.1 0c-2.8-41.8-18-83.5-40-116.9c-6.6-9.9-9.8-21.2-9.8-32.3c0-19.2 9.5-38 26.9-49.2c0 0 0 0 0 0c22.5-14.5 51.3-12 70.8 4.2zm500.6 77.3c-22.1 33.4-37.2 75.1-40 116.9l-32.1 0c2.9-48.6 20.2-96.4 45.4-134.6c0 0 0 0 0 0c2.8-4.2 4.2-8.8 4.4-13.4c.4-9.1-3.9-18.2-12.2-23.6c0 0 0 0 0 0c-10.4-6.7-23.9-5.6-32.9 2c-24.4 20.4-45.3 51.5-60.1 85.8C474.7 456.5 467 486 464.7 512l-32.1 0c2.3-30.7 11.1-64.6 24.8-96.4c16.1-37.4 39.6-73.2 69-97.8c0 0 0 0 0 0c19.5-16.2 48.3-18.8 70.8-4.2c0 0 0 0 0 0c18.2 11.8 27.7 31.8 26.8 52c-.5 10.2-3.7 20.5-9.7 29.6z'
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fal',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      'M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 176l0-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm64 147.5L490.7 448l-149.4 0L416 323.5zM320 176c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96zM307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1l173.9 0c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442z'
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faFieldHockeyStickBall = {
    prefix: 'fal',
    iconName: 'field-hockey-stick-ball',
    icon: [
      512,
      512,
      [127953,"field-hockey"],
      'f44c',
      
      'M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4c-5.3 0-10.5-4.7-10.5-11c0-1.6 .4-3.1 .9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1 .3-84.4 32.7l-17 38.5C4.8 334 .7 352.9 .6 371.8C0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7L500.3 100.9zM474.2 82.4l-54 76.7-51.2-38.4 52.9-75.1C432 31.1 452 27.7 466.4 37.8S484.3 68 474.2 82.4zM401.7 185.3L226.1 434.6c-19.9 28.2-52.2 45-86.7 45.1C79.9 480 32.1 431 32.6 372c.1-14.6 3.2-29.1 9.1-42.5l17-38.5c7.1-16.2 26-23.5 42.2-16.3s23.5 26 16.3 42.2l-17 38.5c-2.4 5.3-3.6 11.2-3.7 17.1c-.2 23.9 19.2 43.3 42.6 43.2c13.8 0 26.7-6.8 34.6-18L350.5 146.9l51.2 38.4zM432 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faFieldHockey = faFieldHockeyStickBall;
  

  
  

  var faSquare2 = {
    prefix: 'fal',
    iconName: 'square-2',
    icon: [
      448,
      512,
      [],
      'e257',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm185 78.4L171 187.7c-6.4 6.1-16.6 5.7-22.6-.7s-5.7-16.6 .7-22.6l14.1-13.2c15.8-14.9 36.8-23 58.5-22.7C267.3 129 304 166.3 304 212c0 22.2-8.8 43.4-24.5 59.1L198.6 352 304 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-144 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L256.9 248.5c9.7-9.7 15.1-22.8 15.1-36.5c0-28.2-22.7-51.2-50.9-51.6c-13.4-.2-26.3 4.8-36.1 14z'
      
    ]
  };

  

  
  

  var faSaxophone = {
    prefix: 'fal',
    iconName: 'saxophone',
    icon: [
      640,
      512,
      [127927],
      'f8dc',
      
      'M521.9 32c-20.8 0-40.8 8.1-55.7 22.6L221.1 292.3c-2.3 2.3-5.4 3.5-8.7 3.5c-6.9 0-12.5-5.6-12.5-12.5l0-4.5c0-2.3 .5-4.7 1.4-6.8l49-112.1 21.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L48 128l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l12.3 0L3.6 277.2C1.2 288.6 0 300.2 0 311.8l0 5.6C0 407.2 72.8 480 162.6 480c48.8 0 94.9-21.9 125.8-59.6L522.8 133.9c3-3.7 7.6-5.9 12.4-5.9l77.5 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L606.1 55.4c-15-15-35.4-23.4-56.6-23.4l-27.6 0zM61 160l154.6 0-43.4 99.3c-2.7 6.2-4.1 12.9-4.1 19.6l0 4.5c0 24.6 19.9 44.5 44.5 44.5c11.6 0 22.7-4.5 31-12.5L488.5 77.5c9-8.7 20.9-13.5 33.4-13.5l27.6 0c12.7 0 24.9 5.1 33.9 14.1L601.4 96l-66.2 0c-14.4 0-28 6.5-37.2 17.6L263.6 400.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 448 32 389.5 32 317.4l0-5.6c0-9.4 1-18.8 2.9-28L61 160zm43 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faStopwatch = {
    prefix: 'fal',
    iconName: 'stopwatch',
    icon: [
      448,
      512,
      [9201],
      'f2f2',
      
      'M128 16c0-8.8 7.2-16 16-16L304 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64.6c49.4 3.8 94 24.8 127.7 57l37-37c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-38.2 38.2C416 212.6 432 256.4 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-109.5 84.6-199.2 192-207.4L208 32l-64 0c-8.8 0-16-7.2-16-16zM48 304a176 176 0 1 0 352 0A176 176 0 1 0 48 304zm192-96l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faBlinds = {
    prefix: 'fal',
    iconName: 'blinds',
    icon: [
      512,
      512,
      [],
      'f8fb',
      
      'M0 32C0 14.3 14.3 0 32 0L480 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L160 96l0 162.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L128 96 32 96C14.3 96 0 81.7 0 64L0 32zm480 0L32 32l0 32 448 0 0-32zM96 192l0 32-75.1 0C9.3 224 0 214.7 0 203.1c0-2.1 .3-4.1 .9-6.1l21.2-69 33.5 0L35.9 192 96 192zm96 32l0-32 284.1 0-19.7-64 33.5 0 21.2 69c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9L192 224zM65.6 288c-1 5.2-1.6 10.5-1.6 16s.6 10.8 1.6 16l-44.7 0C9.3 320 0 310.7 0 299.1c0-2.1 .3-4.1 .9-6.1l11.4-37 33.5 0-9.8 32 29.7 0zm156.8 32c1-5.2 1.6-10.5 1.6-16s-.6-10.8-1.6-16l253.7 0-9.8-32 33.5 0 11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9l-268.7 0zM144 384l332.1 0-9.8-32 33.5 0 11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9L20.9 416C9.3 416 0 406.7 0 395.1c0-2.1 .3-4.1 .9-6.1l11.4-37 33.5 0-9.8 32L144 384zm322.2 64l33.5 0 11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9L20.9 512C9.3 512 0 502.7 0 491.1c0-2.1 .3-4.1 .9-6.1l11.4-37 33.5 0-9.8 32 440.1 0-9.8-32zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fal',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      'M0 88C0 39.4 39.4 0 88 0s88 39.4 88 88l0 56 160 0 0-56c0-48.6 39.4-88 88-88s88 39.4 88 88s-39.4 88-88 88l-56 0 0 160 56 0c48.6 0 88 39.4 88 88s-39.4 88-88 88s-88-39.4-88-88l0-56-160 0 0 56c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88l56 0 0-160-56 0C39.4 176 0 136.6 0 88zm144 56l0-56c0-30.9-25.1-56-56-56S32 57.1 32 88s25.1 56 56 56l56 0zm32 192l160 0 0-160-160 0 0 160zm-32 32l-56 0c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56l0-56zm224 0l0 56c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56l-56 0zm0-224l56 0c30.9 0 56-25.1 56-56s-25.1-56-56-56s-56 25.1-56 56l0 56z'
      
    ]
  };

  

  
  

  var faPopsicle = {
    prefix: 'fal',
    iconName: 'popsicle',
    icon: [
      320,
      512,
      [],
      'e43e',
      
      'M288 160c0-70.7-57.3-128-128-128S32 89.3 32 160l0 176c0 8.8 7.2 16 16 16l96 0 0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160 96 0c8.8 0 16-7.2 16-16l0-176zM144 384l-96 0c-26.5 0-48-21.5-48-48L0 160C0 71.6 71.6 0 160 0s160 71.6 160 160l0 176c0 26.5-21.5 48-48 48l-96 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112z'
      
    ]
  };

  

  
  

  var faBookArrowUp = {
    prefix: 'fal',
    iconName: 'book-arrow-up',
    icon: [
      448,
      512,
      [],
      'e0ba',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l112 0 0-32L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l112 0 0-32L64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l336 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-96 0 0 32 80 0 0 64-80 0 0 32 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-320c0-26.5-21.5-48-48-48L64 0zm68.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 182.6 224 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-313.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z'
      
    ]
  };

  

  
  

  var faCircleMicrophone = {
    prefix: 'fal',
    iconName: 'circle-microphone',
    icon: [
      512,
      512,
      ["microphone-circle"],
      'e116',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-96zm64-32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32zM144 224c8.8 0 16 7.2 16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 65.3-48.9 119.1-112 127l0 17c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17c-63.1-7.9-112-61.7-112-127l0-16c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faMicrophoneCircle = faCircleMicrophone;
  

  
  

  var faSpiderWeb = {
    prefix: 'fal',
    iconName: 'spider-web',
    icon: [
      576,
      512,
      [128376],
      'f719',
      
      'M141.6 18.4c2.7-7.3 10.3-11.5 17.9-10.1l73.6 13.8c37 6.9 75 6.9 112 0L418.8 8.3c7.6-1.4 15.2 2.8 17.9 10.1l30.7 81.8c12 32 29.3 61.7 51.1 87.9l48.1 57.7c4.9 5.9 4.9 14.6 0 20.5L518.5 324c-21.8 26.2-39.1 55.9-51.1 87.9l-30.7 81.8c-2.7 7.3-10.3 11.5-17.9 10.1l-73.6-13.8c-37-6.9-75-6.9-112 0l-73.6 13.8c-7.6 1.4-15.2-2.8-17.9-10.1l-30.7-81.8c-12-32-29.3-61.7-51.1-87.9L11.7 266.2c-4.9-5.9-4.9-14.6 0-20.5L59.8 188c21.8-26.2 39.1-55.9 51.1-87.9l30.7-81.8zm17.8 43.7l-18.5 49.2c-13.2 35.3-32.3 68.1-56.5 97.1L58.2 240l70.5 0 2.6-2.9c25.4-29.1 45.1-62.7 57.9-99.1l5.2-14.7-35-61.2zM187 46l34.2 59.9c44.1 12 90.5 12 134.6 .2L390 46.2l-39 7.3c-40.9 7.7-82.9 7.7-123.8 0L187 46zM418.5 60.9l-35.2 61.7 5.4 15.4c12.8 36.4 32.5 70 57.9 99.1l2.6 2.9 71 0-26.2-31.5c-24.1-29-43.2-61.8-56.5-97.1L418.5 60.9zM520.1 272L449 272l-1.1 1.3c-26.2 30-46.3 64.8-59.1 102.5l-5 14.6 34.7 60.7 18.9-50.5c13.2-35.3 32.3-68.1 56.5-97.1L520.1 272zM390 465.8l-32.2-56.4c-44.2-14.3-91.6-15.5-136.5-3.4L187 466l40.2-7.5c40.9-7.7 82.9-7.7 123.8 0l39 7.3zM159.4 449.9l35-61.2-5.2-14.8c-12.8-36.4-32.5-70-57.9-99.1l-2.4-2.8-70.7 0 26.2 31.5c24.1 29 43.2 61.8 56.5 97.1l18.5 49.3zM170.2 272c18.6 24.5 33.7 51.5 45 80.1L261 272l-90.8 0zm72.3 96.8c30.9-4.7 62.4-4.1 93.1 1.8l-47.1-82.4-46 80.6zm120.2-15.3c11.1-29.2 26.3-56.6 45-81.6l-91.6 0 46.6 81.6zM407.7 240c-18.8-24.7-34-51.9-45.3-80.9L316.1 240l91.6 0zm-73.1-96.8c-30.5 4.9-61.6 4.8-92.1-.1l46.1 80.6 46-80.5zM215.2 159.8c-11.3 28.7-26.4 55.7-45.1 80.2l90.9 0-45.8-80.2z'
      
    ]
  };

  

  
  

  var faHandSpock = {
    prefix: 'fal',
    iconName: 'hand-spock',
    icon: [
      576,
      512,
      [128406],
      'f259',
      
      'M217.4 1.9c29.9-8.1 60.6 9.6 68.7 39.4l41.3 152.7L353.2 68.7c6.2-30.3 35.8-49.8 66.1-43.6s49.8 35.8 43.6 66.1l-2.5 12c12.3-7 27.2-9.3 41.9-5.4c29.9 7.9 47.8 38.5 39.9 68.4L481 398.6c-17.3 65.8-76.2 112-144 113.4c-.3 0-.7 0-1 0l-2.1 0-15.3 0c-58.8 0-115.8-20.9-160.6-59L51.7 362.7c-23.6-20-26.4-55.4-6.4-78.9l12 10.2-12-10.2c20-23.6 55.4-26.4 78.9-6.4l31.5 26.8-49-150.8c-9.6-29.4 6.5-61 35.9-70.6c13.3-4.3 27-3.4 39 1.6l-3.7-13.7c-8.1-29.9 9.6-60.6 39.4-68.7zM335.3 480c.2 0 .3 0 .5 0c53.8-.8 100.6-37.4 114.3-89.6l61.1-232.3c3.4-12.8-4.3-25.9-17.1-29.3s-25.9 4.3-29.3 17.1L430.5 276.1c-1.8 7-8.2 11.9-15.5 11.9l-5.8 0c-4.8 0-9.4-2.2-12.4-5.9s-4.2-8.6-3.3-13.3L431.5 84.8c2.7-13-5.7-25.7-18.7-28.3s-25.7 5.7-28.3 18.7L345.1 266.4c-1.5 7.3-7.8 12.5-15.2 12.8s-14-4.7-15.9-11.8L255.2 49.7c-3.5-12.8-16.6-20.4-29.4-16.9s-20.4 16.6-16.9 29.4l55.6 205.6c1.3 4.8 .3 9.9-2.7 13.9s-7.7 6.3-12.7 6.3l-2.7 0c-6.9 0-13.1-4.5-15.2-11.1L182.8 128.6c-4.1-12.6-17.6-19.5-30.2-15.4s-19.5 17.6-15.4 30.2l66.5 204.5c2.2 6.8-.4 14.3-6.3 18.2s-13.8 3.5-19.3-1.1l-74.5-63.3c-10.1-8.6-25.2-7.4-33.8 2.7s-7.4 25.2 2.7 33.8l106.2 90.3c39.1 33.2 88.6 51.4 139.9 51.4l15.3 0 1.4 0z'
      
    ]
  };

  

  
  

  var faCircleCamera = {
    prefix: 'fal',
    iconName: 'circle-camera',
    icon: [
      512,
      512,
      ["camera-circle"],
      'e103',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.2 142.5L191.7 160l-7.7 0c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l144 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-7.7 0-7.5-17.5c-3.8-8.8-12.5-14.5-22.1-14.5l-69.4 0c-9.6 0-18.3 5.7-22.1 14.5zM226.6 160l58.9 0 9.6 22.3c2.5 5.9 8.3 9.7 14.7 9.7l18.3 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l18.3 0c6.4 0 12.2-3.8 14.7-9.7l9.6-22.3zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faCameraCircle = faCircleCamera;
  

  
  

  var faFacePersevering = {
    prefix: 'fal',
    iconName: 'face-persevering',
    icon: [
      512,
      512,
      [],
      'e385',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM129.3 232.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 272l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 272l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faGaugeSimpleLow = {
    prefix: 'fal',
    iconName: 'gauge-simple-low',
    icon: [
      512,
      512,
      ["tachometer-slow"],
      'f62c',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-18.6 7.9-35.3 20.5-47L129.9 151.6c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerSlow = faGaugeSimpleLow;
  

  
  

  var faFaceSaluting = {
    prefix: 'fal',
    iconName: 'face-saluting',
    icon: [
      640,
      512,
      [129761],
      'e484',
      
      'M368.8 32.6c-10.1-.8-20.1-.8-30-.3c-8.8 .5-16.4-6.2-16.9-15.1s6.2-16.4 15-16.9c11.2-.6 22.7-.6 34.2 .3c141 10.6 246.7 133.4 236.1 274.4s-133.4 246.7-274.4 236.1C221.7 503 132.5 424.8 104.9 323c-2.3-8.5 2.7-17.3 11.3-19.6s17.3 2.7 19.6 11.3C159.9 403.7 238 472.1 335.3 479.4c123.4 9.3 230.9-83.3 240.1-206.6s-83.3-230.9-206.6-240.1zM235 345.2c5.2-7.2 15.2-8.8 22.3-3.6c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3zm37.3-160.6a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM257.5 89.4l-38 23.9c5.2 3.6 9.8 8.3 13.4 14.1c14 22.5 7.2 52.2-15.2 66.3l-64 40.1c0 0 0 0 0 0l-.1 .1-29 18.2C80.9 279.4 23.2 259.8 5.2 211.5c-13.6-36.4 .2-77.3 33.1-97.9L206.7 7.8c22.4-14.1 52-7.2 66 15.3s7.2 52.2-15.2 66.3zm-17-27.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L54.7 140.4c-20 12.5-28.4 37.3-20.1 59.4c11 29.3 46 41.2 72.6 24.6l93.3-58.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L128 173.7l0-41.3L240.5 62.1z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fal',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z'
      
    ]
  };

  

  
  

  var faSquareI = {
    prefix: 'fal',
    iconName: 'square-i',
    icon: [
      448,
      512,
      [],
      'e272',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 32l80 0 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 192 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-192-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCalendarCircleExclamation = {
    prefix: 'fal',
    iconName: 'calendar-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e46e',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l266.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256 320 0 64 0 16 0 16 0 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faPlug = {
    prefix: 'fal',
    iconName: 'plug',
    icon: [
      384,
      512,
      [128268],
      'f1e6',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96 32 0 0-96zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64c0 83 63.1 151.2 144 159.2l0 96.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96.8c80.9-8 144-76.2 144-159.2l0-64 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0L64 144l-32 0-16 0zM192 368c-70.7 0-128-57.3-128-128l0-64 256 0 0 64c0 70.7-57.3 128-128 128z'
      
    ]
  };

  

  
  

  var faHouseCircleXmark = {
    prefix: 'fal',
    iconName: 'house-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e50b',
      
      'M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7 96 432c0 26.5 21.5 48 48 48l64 0 0-160c0-17.7 14.3-32 32-32l96 0c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9L240 320l0 160 16 0 80 0 24.2 0c10 12.1 21.7 22.9 34.6 32L144 512c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z'
      
    ]
  };

  

  
  

  var faWorm = {
    prefix: 'fal',
    iconName: 'worm',
    icon: [
      512,
      512,
      [],
      'e599',
      
      'M432 192l0-27.8-27.5-3.9-31.1-4.4c-30.7-4.4-53.4-30.6-53.4-61.6C320 59.9 347.9 32 382.3 32l40.1 0C454.2 32 480 57.8 480 89.6l0 70.4 0 48 0 148c0 68.5-55.5 124-124 124s-124-55.5-124-124l0-36c0-44.2-35.8-80-80-80c-39.8 0-72 32.2-72 72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-66.3 53.7-120 120-120c70.7 0 128 57.3 128 128l0 36c0 42 34 76 76 76s76-34 76-76l0-164zM382.3 0C330.2 0 288 42.2 288 94.3c0 46.9 34.5 86.7 80.9 93.3L400 192l0 164c0 24.3-19.7 44-44 44s-44-19.7-44-44l0-36c0-88.4-71.6-160-160-160C68.1 160 0 228.1 0 312L0 456c0 30.9 25.1 56 56 56s56-25.1 56-56l0-144c0-22.1 17.9-40 40-40c26.5 0 48 21.5 48 48l0 36c0 86.2 69.8 156 156 156s156-69.8 156-156l0-148 0-48 0-70.4C512 40.1 471.9 0 422.4 0L382.3 0zM408 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFaceShush = {
    prefix: 'fal',
    iconName: 'face-shush',
    icon: [
      512,
      512,
      [],
      'e38c',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 45.8-13.7 88.4-37.3 123.9c-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C496.3 357 512 308.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 83.8 40.2 158.1 102.4 204.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4C67.2 394.3 32 329.3 32 256zM200.4 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm160 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM164.7 228.7c-6.2 6.2-6.2 16.4 0 22.6c10.3 10.3 24.7 20.8 43.3 28l0 28.4c-32.5 10.2-56 40.5-56 76.3l0 48c0 44.2 35.8 80 80 80l56 0 1.5 0c28.5 0 55.5-12.7 73.7-34.5l25.6-30.7c17-20.4 14.2-50.6-6.1-67.6c-11.6-9.7-26.4-12.9-40.1-10.2c-4.4-23.2-18.8-42.8-38.6-54.2l0-35.4c18.6-7.2 33.1-17.7 43.3-28c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-5.3 5.3-12.2 10.8-20.7 15.4l0-4.1c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 4.1c-8.5-4.7-15.4-10.1-20.7-15.4c-6.2-6.2-16.4-6.2-22.6 0zM256 224c8.8 0 16 7.2 16 16l0 64-32 0 0-64c0-8.8 7.2-16 16-16zM217.2 378l76.7 69.7c7.9-1.1 15.1-5 20.2-11.2l25.6-30.7c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L338.7 457c-12.2 14.6-30.2 23-49.2 23l-1.5 0-56 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-8.8-7.2-16-16-16l-32 0c-6.7 0-12.5 4.1-14.8 10z'
      
    ]
  };

  

  
  

  var faFlaskRoundPotion = {
    prefix: 'fal',
    iconName: 'flask-round-potion',
    icon: [
      448,
      512,
      ["flask-potion"],
      'f6e1',
      
      'M160 32l128 0 0 125.7c0 18.2 10.1 33.7 24.4 42C364.8 230.3 400 287 400 351.9c-55.6-1.3-87.4-15.5-115.7-30.1c-2.9-1.5-5.7-3-8.6-4.5C248.3 302.9 220 288 176 288c-47 0-83.5 12.8-108.4 25.8c-6.6 3.5-12.4 6.9-17.4 10.2c8.5-53 40.6-98.1 85.4-124.2c14.3-8.3 24.4-23.9 24.4-42L160 32zM397.1 383.8c-6.3 34.7-22.8 65.8-46.3 90.2c-3.1 3.2-8.8 5.9-17 5.9l-219.6 0c-8.2 0-13.9-2.7-17-5.9c-27.6-28.6-45.5-66.5-48.7-108.5c1-.6 1.9-1.4 2.8-2.2c0 0 0 0 0 0s0 0 0 0l.2-.2c.3-.2 .7-.6 1.3-1.2c1.2-1.1 3.2-2.7 5.8-4.7c5.2-4 13.2-9.5 23.8-15C103.5 331.2 135 320 176 320c35.8 0 57.7 11.4 85.1 25.8c2.8 1.4 5.6 2.9 8.5 4.4c30.6 15.8 66.7 31.9 127.5 33.6zM51.3 363.4s0 0 0 0s0 0 0 0c0 0 0 0 0 0zm0 0s0 0 0 0s0 0 0 0zM320 157.7L320 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L304 0 144 0 112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 125.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z'
      
    ]
  };

  
    var faFlaskPotion = faFlaskRoundPotion;
  

  
  

  var faPi = {
    prefix: 'fal',
    iconName: 'pi',
    icon: [
      448,
      512,
      [],
      'f67e',
      
      'M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l112 0 0 155c0 61.8-21 121.7-59.6 169.9l-.9 1.1c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l.9-1.1C136.5 387 160 320 160 251l0-155 160 0 0 286.6c0 36.1 29.3 65.4 65.4 65.4c24.8 0 47.4-14 58.5-36.2l2.3-4.7c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-2.3 4.7c-5.7 11.3-17.2 18.5-29.9 18.5C367 416 352 401 352 382.6L352 96l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 64z'
      
    ]
  };

  

  
  

  var faOm = {
    prefix: 'fal',
    iconName: 'om',
    icon: [
      512,
      512,
      [128329],
      'f679',
      
      'M356.7 4.7c6.2-6.2 16.4-6.2 22.6 0l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40zM350.6 56L368 73.4 385.4 56 368 38.6 350.6 56zM144 128c-14.4 0-27.7 4.8-38.4 12.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4c16-12.1 36-19.2 57.6-19.2c53 0 96 43 96 96c0 24.6-9.2 47-24.4 64l.2 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0c17 0 33.2-6.7 45.2-18.7l19-19c16.8-16.8 39.6-26.2 63.3-26.2c49.4 0 89.5 40.1 89.5 89.5L512 392c0 48.6-39.4 88-88 88l-16 0c-48.6 0-88-39.4-88-88l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 30.9 25.1 56 56 56l16 0c30.9 0 56-25.1 56-56l0-110.5c0-31.8-25.8-57.5-57.5-57.5c-15.3 0-29.9 6.1-40.7 16.9l-19 19c-18 18-42.4 28.1-67.8 28.1l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.1 0c29.6 23.1 48.7 57.1 48.7 96c0 72.6-66.5 128-144 128S0 456.6 0 384c0-8.8 7.2-16 16-16s16 7.2 16 16c0 51.1 48.1 96 112 96s112-44.9 112-96s-48.1-96-112-96l-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l.3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0c35.3 0 64-28.7 64-64s-28.7-64-64-64zM292.5 94.1c15.9 20 43.4 33.9 75.5 33.9s59.6-13.9 75.5-33.9c5.5-6.9 15.6-8.1 22.5-2.6s8.1 15.6 2.6 22.5C446.1 142.2 409.1 160 368 160s-78.1-17.8-100.5-46.1c-5.5-6.9-4.3-17 2.6-22.5s17-4.3 22.5 2.6z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftDown = {
    prefix: 'fal',
    iconName: 'arrow-turn-left-down',
    icon: [
      384,
      512,
      [],
      'e633',
      
      'M331.3 379.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4 208 80c0-26.5 21.5-48 48-48l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L256 0c-44.2 0-80 35.8-80 80l0 377.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faFolderBookmark = {
    prefix: 'fal',
    iconName: 'folder-bookmark',
    icon: [
      512,
      512,
      [],
      'e186',
      
      'M32 96l0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0 0 176c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7L336 289.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6l0-187c-3.3-2.3-6.5-4.8-9.4-7.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4L64 64C46.3 64 32 78.3 32 96zm352 32l-92.1 0c-1.3 0-2.6 0-3.9-.1l0 150.2 40.8-20.4c4.5-2.3 9.8-2.3 14.3 0L384 278.1 384 128zm16-32l48 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l124.1 0c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4L400 96z'
      
    ]
  };

  

  
  

  var faTurnRight = {
    prefix: 'fal',
    iconName: 'turn-right',
    icon: [
      512,
      512,
      [],
      'e639',
      
      'M352 304l0 57.3c0 3.7 3 6.7 6.7 6.7c1.9 0 3.7-.8 5-2.2L476.2 240 363.7 114.2c-1.3-1.4-3.1-2.2-5-2.2c-3.7 0-6.7 3-6.7 6.7l0 57.3c0 17.7-14.3 32-32 32l-176 0C82.1 208 32 258.1 32 320l0 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-112c0-26.5 21.5-48 48-48l176 0c17.7 0 32 14.3 32 32zm154.7-78c3.4 3.8 5.3 8.8 5.3 14s-1.9 10.1-5.3 14L387.5 387.1c-7.3 8.2-17.8 12.9-28.8 12.9c-21.4 0-38.7-17.3-38.7-38.7l0-25.3 0-32-32 0-144 0c-8.8 0-16 7.2-16 16l0 112c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 320c0-79.5 64.5-144 144-144l144 0 32 0 0-32 0-25.3C320 97.3 337.3 80 358.7 80c11 0 21.5 4.7 28.8 12.9L506.7 226z'
      
    ]
  };

  

  
  

  var faPrintMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'print-magnifying-glass',
    icon: [
      640,
      512,
      ["print-search"],
      'f81a',
      
      'M160 160l0-96c0-17.7 14.3-32 32-32l229.5 0c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6l0 69.5 32 0 0-69.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0L192 0c-35.3 0-64 28.7-64 64l0 96 32 0zm-32 64l192 0c9.1-12.1 19.9-22.9 32-32l-224 0c-35.3 0-64 28.7-64 64l0 128c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7 14.3 32 32 32l320 0c15.8 0 29-11.5 31.6-26.6L498.2 472c-5.9 1.9-12 3.6-18.2 4.8l0 3.2-32 0-288 0 0-128 131.2 0c-2.1-10.3-3.2-21-3.2-32l-128 0c-17.7 0-32 14.3-32 32l0 32-32 0 0-128c0-17.7 14.3-32 32-32zm320 .1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  
    var faPrintSearch = faPrintMagnifyingGlass;
  

  
  

  var faUtensilsSlash = {
    prefix: 'fal',
    iconName: 'utensils-slash',
    icon: [
      640,
      512,
      [],
      'e464',
      
      'M151.8 18.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.5 3L148.4 39l3.4-20.3zM197 77.3l3-60.5C200.4 8 193.6 .5 184.8 0S168.5 6.4 168 15.2L166.1 53 197 77.3zm56.4 44.5L248 15.2C247.5 6.4 240-.4 231.2 0s-15.6 8-15.2 16.8L220 95.5l33.4 26.3zM129.3 187L96.1 160.8c-.1 1.5-.1 3-.1 4.5L96 176c0 44.2 35.8 80 80 80l16 0 0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-234.2L176.2 224l-.2 0c-22.7 0-41.8-15.8-46.7-37zM320 174.5l0-9.2c0-4.4-.4-8.8-1.1-13.2L295.8 13.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l21.5 128.7L320 174.5zM544 351.3l0-15.3 0-16 0-288c0-17.7-14.3-32-32-32C496 0 384 32 384 176l0 49 32 25.3 0-74.2c0-62.5 23.8-97.7 47-117.8c12-10.4 24.4-17.2 34.5-21.3c7.6-3.1 12.6-4.2 14.3-4.6l.2-.1L512 320l-7.6 0L544 351.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faPersonBikingMountain = {
    prefix: 'fal',
    iconName: 'person-biking-mountain',
    icon: [
      640,
      512,
      [128693,"biking-mountain"],
      'f84b',
      
      'M416 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 336 56zM130 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8l0 12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4l12 0c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8l0-12c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4l-12 0zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5l12 0c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36l0 12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5l-12 0c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6C9.2 411.5 0 397.8 0 382l0-12c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM189.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zM498 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8l0 12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4l12 0c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8l0-12c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4l-12 0zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5l12 0c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36l0 12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5l-12 0c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6c-13.3-6.5-22.5-20.1-22.5-36l0-12c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM557.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zM330.2 166.7c-6-5.4-15-5.5-21.1-.3L250 217.1c-8 6.8-7.3 19.4 1.3 25.3l93.7 64.4c4.3 3 6.9 7.9 6.9 13.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-87.6-86.8-59.7c-26-17.9-28-55.5-4-76l59.1-50.6c18.3-15.7 45.4-15.4 63.3 .8L406.1 192l73.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-4 0-7.8-1.5-10.7-4.1l-59.1-53.2zM169.3 166l69.9-63.1-3.7-3.5c-11.8-11-29.9-11.6-42.3-1.3l-49.6 41.2L169.3 166zm104.3-51l-94.4 85.2c-6.4 5.8-16.3 5.4-22.3-.8l-48.3-50.3c-6.4-6.7-5.8-17.5 1.3-23.4l62.8-52.2c24.8-20.6 61.1-19.5 84.7 2.6l16.4 15.4c6.8 6.4 6.7 17.3-.2 23.5z'
      
    ]
  };

  
    var faBikingMountain = faPersonBikingMountain;
  

  
  

  var faHand = {
    prefix: 'fal',
    iconName: 'hand',
    icon: [
      512,
      512,
      [9995,129306,"hand-paper"],
      'f256',
      
      'M264 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56l0 200.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512l8.5 0c97.2 0 176-78.8 176-176l0-184c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4L400 88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C310 16.3 288.9 0 264 0zM184 64c13.3 0 24 10.7 24 24c0 0 0 0 0 .1L208 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0 0 0 0 0-.1L240 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 0 0 0 0 .1L288 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-152.1C320 74.7 330.8 64 344 64c13.3 0 24 10.7 24 24l0 64c0 0 0 0 0 .1l0 87.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-88.1c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24l0 184c0 79.5-64.5 144-144 144l-8.5 0c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8L160 88c0-13.3 10.7-24 24-24z'
      
    ]
  };

  
    var faHandPaper = faHand;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fal',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M32 224C32 118 118 32 224 32l16 0c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7c0 0 0 0 0 0s0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7c0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0L224 0C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm171.1-99.8c4.1-7.3 12-12.2 20.9-12.2s16.8 4.9 20.9 12.2c4.3 7.6 13.9 10.4 21.6 6.2c2.8-1.5 6-2.4 9.5-2.4c7 0 13.2 3.6 16.8 9.1c3.4 5.2 9.5 8 15.7 7.1c1.1-.2 2.3-.3 3.5-.3c13.3 0 24 10.7 24 24s-10.7 24-24 24l-43.3 0c-5.4 0-10.4 2.7-13.4 7.2s-3.4 10.2-1.3 15.2c1.3 2.9 2 6.2 2 9.6c0 11.6-8.2 21.3-19.2 23.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5c25.6-5.2 44.8-27.8 44.8-54.9l24 0c30.9 0 56-25.1 56-56c0-30.4-24.2-55.2-54.5-56c-9.5-9.9-22.8-16-37.5-16c-4 0-7.8 .4-11.5 1.3C254.3 86.6 239.9 80 224 80s-30.3 6.6-40.5 17.3C179.8 96.4 176 96 172 96c-22.2 0-41.1 13.9-48.6 33.4C98.6 135.1 80 157.4 80 184c0 19.2 9.7 36.1 24.3 46.2c3.1 28 26.8 49.8 55.7 49.8l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.3c0-5.4-2.7-10.4-7.2-13.4s-10.2-3.4-15.2-1.3c-2.9 1.3-6.2 2-9.6 2c-13.3 0-24-10.7-24-24c0-.7 0-1.3 .1-2c.6-6.8-3.3-13.3-9.6-16c-8.6-3.7-14.5-12.2-14.5-22c0-13.3 10.7-24 24-24l.2 0c8.2 0 15-6.1 15.9-14.2c1.1-10 9.6-17.8 19.9-17.8c3.5 0 6.7 .9 9.5 2.4c7.7 4.2 17.3 1.4 21.6-6.2z'
      
    ]
  };

  

  
  

  var faCucumber = {
    prefix: 'fal',
    iconName: 'cucumber',
    icon: [
      512,
      512,
      [129362],
      'e401',
      
      'M195.9 451.9l256-256c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0l-256 256c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0zm21.8 23.4c-50 49.2-130.5 48.9-180.2-.8c-50-50-50-131 0-181l95.2-95.2c-7-9.4-6.2-22.7 2.3-31.2s21.9-9.3 31.2-2.3L293.5 37.5c50-50 131-50 181 0c49.7 49.7 50 130.2 .8 180.2c7 9.4 6.2 22.7-2.3 31.3s-21.8 9.3-31.2 2.3L251.3 441.7c7 9.4 6.2 22.7-2.3 31.2s-21.9 9.3-31.3 2.3zM128 308a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm204-84a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm12-108a20 20 0 1 1 40 0 20 20 0 1 1 -40 0z'
      
    ]
  };

  

  
  

  var faPoliceBox = {
    prefix: 'fal',
    iconName: 'police-box',
    icon: [
      384,
      512,
      [],
      'e021',
      
      'M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32C78.3 32 64 46.3 64 64l0 .8C45.7 68.5 32 84.6 32 104l0 376-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-376c0-19.4-13.7-35.5-32-39.2l0-.8c0-17.7-14.3-32-32-32l-80 0 0-16zm112 88l0 376L64 480l0-376c0-4.4 3.6-8 8-8l8 0c8.8 0 16-7.2 16-16l0-16 96 0 96 0 0 16c0 8.8 7.2 16 16 16l8 0c4.4 0 8 3.6 8 8zM112 328l0-48 48 0 0 48-48 0zM88 272l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm24-120l20 0 0 20-20 0 0-20zm28 0l20 0 0 20-20 0 0-20zm0 28l20 0 0 20-20 0 0-20zm-8 20l-20 0 0-20 20 0 0 20zm-28-72c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0zm120 72l0-20 20 0 0 20-20 0zm28 0l0-20 20 0 0 20-20 0zm0-28l0-20 20 0 0 20-20 0zm-8-20l0 20-20 0 0-20 20 0zm-44-8l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faFlaskVial = {
    prefix: 'fal',
    iconName: 'flask-vial',
    icon: [
      640,
      512,
      [],
      'e4f3',
      
      'M224 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0 192 0 64 0 32 0 16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l16 0 0 320c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-14.2 3-28.3 8.8-41.2C157.7 410.5 143.5 416 128 416c-35.3 0-64-28.7-64-64l0-160 128 0 0 160c0 4-.4 7.8-1 11.6l33-53.7L224 32zM64 32l128 0 0 128L64 160 64 32zM304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 187.5L201.8 411.6c-6.4 10.4-9.8 22.3-9.8 34.5c0 36.4 29.5 65.9 65.9 65.9l316.2 0c36.4 0 65.9-29.5 65.9-65.9c0-12.2-3.4-24.1-9.8-34.5L512 219.5 512 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L304 0zM480 32l0 192c0 3 .8 5.9 2.4 8.4L536.3 320l-240.6 0 53.9-87.6c1.6-2.5 2.4-5.4 2.4-8.4l0-192 128 0zM229 428.4L276 352l280 0 47 76.4c3.3 5.3 5 11.5 5 17.8c0 18.7-15.2 33.9-33.9 33.9l-316.2 0c-18.7 0-33.9-15.2-33.9-33.9c0-6.3 1.7-12.4 5-17.8z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fal',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z'
      
    ]
  };

  

  
  

  var faFacePleading = {
    prefix: 'fal',
    iconName: 'face-pleading',
    icon: [
      512,
      512,
      [],
      'e386',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280.1 410.7c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM331.6 96.6c8.5-2.4 17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8zM191.4 116.4l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm240-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-272 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fal',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64l117.3 0c54.2 0 98.4 42.5 101.2 96l-319.7 0c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112l-84 0c2.6 10.2 4 21 4 32l80 0zm-336 0c0-11 1.4-21.8 4-32l-84 0C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80l80 0z'
      
    ]
  };

  

  
  

  var faCircleF = {
    prefix: 'fal',
    iconName: 'circle-f',
    icon: [
      512,
      512,
      [],
      'e10e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32l0 96 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-80 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0z'
      
    ]
  };

  

  
  

  var faRight = {
    prefix: 'fal',
    iconName: 'right',
    icon: [
      448,
      512,
      [11157,"arrow-alt-right"],
      'f356',
      
      'M416 253.7l0 4.6c0 4.4-1.8 8.6-5 11.6L261.2 412.5c-2.3 2.2-5.4 3.5-8.7 3.5c-6.9 0-12.6-5.6-12.6-12.6l0-83.4c0-8.8-7.2-16-16-16L48 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l176 0c8.8 0 16-7.2 16-16l0-83.4c0-6.9 5.6-12.6 12.6-12.6c3.2 0 6.3 1.2 8.7 3.5L411 242.1c3.2 3 5 7.2 5 11.6zM252.6 448c11.4 0 22.5-4.4 30.7-12.3L433.1 293c9.5-9.1 14.9-21.6 14.9-34.8l0-4.6c0-13.1-5.4-25.7-14.9-34.8L283.3 76.3C275 68.4 264 64 252.6 64C228 64 208 84 208 108.6l0 67.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0 0 67.4c0 24.6 20 44.6 44.6 44.6z'
      
    ]
  };

  
    var faArrowAltRight = faRight;
  

  
  

  var faPersonRays = {
    prefix: 'fal',
    iconName: 'person-rays',
    icon: [
      512,
      512,
      [],
      'e54d',
      
      'M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0zm502.6 0c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zM27.3 507.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm480 0c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM232 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM243.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM224 496l0-144 64 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-293.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L339.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.7 16.3-70.6 42.3L113.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L192 202.1 192 496c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faReplyClock = {
    prefix: 'fal',
    iconName: 'reply-clock',
    icon: [
      640,
      512,
      ["reply-time"],
      'e239',
      
      'M496 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256A144 144 0 1 0 496 0a144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-5.7 0-11.4-.3-17-.8c.6 5.5 1 11.1 1 16.8c0 46.1-15.9 79.7-34 103.2c1.3-7.1 2-14.8 2-23.2c0-70.7-57.3-128-128-128l-96 0-8 0c-13.3 0-24 10.7-24 24l0 8 0 16 0 48L32 240 192 96l0 48 0 16 0 8c0 13.3 10.7 24 24 24l8 0 102.6 0c-2.9-10.3-4.9-21-5.9-32L256 160l-32 0 0-16 0-16 0-32c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-32 0-16 0-16 32 0 64 0c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336z'
      
    ]
  };

  
    var faReplyTime = faReplyClock;
  

  
  

  var faMitten = {
    prefix: 'fal',
    iconName: 'mitten',
    icon: [
      448,
      512,
      [],
      'f7b5',
      
      'M0 144.2C0 64.6 65.1 0 144.6 0C208 0 264.4 41.5 282.8 102.3l24.6 81.3c15.3-15 36-23.6 57.9-23.6l1.8 0c44.7 0 80.9 36.2 80.9 80.9c0 18.6-6.4 36.6-18.1 51l-61.8 76L328 368c.6-1.7 1.5-3.3 2.6-4.7L405 271.8c7.1-8.7 11-19.6 11-30.9c0-27-21.9-48.9-48.9-48.9l-1.8 0c-17.6 0-34 9.1-43.2 24.1l-7 11.4c-3.3 5.4-9.4 8.3-15.7 7.5s-11.4-5.2-13.3-11.2L252.2 111.6C237.9 64.4 194 32 144.6 32C82.6 32 32 82.4 32 144.2c0 9.2 1.1 18.3 3.3 27.2L84.5 368l-33 0L4.3 179.2C1.4 167.7 0 156 0 144.2zM64 432l0 48 288 0 0-48L64 432zm-32 0c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-48z'
      
    ]
  };

  

  
  

  var faArrowDownZA = {
    prefix: 'fal',
    iconName: 'arrow-down-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-desc","sort-alpha-down-alt"],
      'f881',
      
      'M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 32l128 0c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 192l94.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 64 352 64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 256c6.1 0 11.6 3.4 14.3 8.8l63.9 127.7c.1 .2 .2 .4 .3 .6l15.8 31.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L470.1 448l-108.2 0-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7c.1-.2 .2-.4 .3-.6l63.9-127.7c2.7-5.4 8.2-8.8 14.3-8.8zM377.9 416l76.2 0L416 339.8 377.9 416z'
      
    ]
  };

  
    var faSortAlphaDesc = faArrowDownZA;
  
    var faSortAlphaDownAlt = faArrowDownZA;
  

  
  

  var faBagShopping = {
    prefix: 'fal',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      'M160 96l0 32 128 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64l-80 0c-8.8 0-16 7.2-16 16l0 240c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-240c0-8.8-7.2-16-16-16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-128 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80zm0-32l0-32c0-53 43-96 96-96s96 43 96 96l0 32 80 0c26.5 0 48 21.5 48 48l0 240c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 176c0-26.5 21.5-48 48-48l80 0z'
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faHandHeart = {
    prefix: 'fal',
    iconName: 'hand-heart',
    icon: [
      512,
      512,
      [],
      'f4bc',
      
      'M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8c30.9 0 56 25.1 56 56l0 13.4c7.3-3.5 15.4-5.4 24-5.4c30.9 0 56 25.1 56 56l0 184c0 97.2-78.8 176-176 176l-8.5 0c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L128 288.8 128 88c0-30.9 25.1-56 56-56c9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 239.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3l8.5 0c79.5 0 144-64.5 144-144l0-184c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9l0 88.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-87.9c0 0 0 0 0-.1l0-64c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9L320 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-151.9c0 0 0 0 0-.1l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 23.9c0 0 0 0 0 .1l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-151.9c0 0 0 0 0-.1zm13.7 250.8c0 5.8 2.3 11.4 6.5 15.4L288 412.4l59.8-58.1c4.2-4 6.5-9.6 6.5-15.4c0-11.9-9.6-21.5-21.5-21.5l-1.5 0c-6 0-11.7 2.3-16 6.5l-16.1 15.6c-6.2 6-16.1 6-22.3 0l-16.1-15.6c-4.3-4.2-10.1-6.5-16-6.5l-1.5 0c-11.9 0-21.5 9.6-21.5 21.5zm21.5-53.5l1.5 0c14.3 0 28.1 5.6 38.4 15.6l4.9 4.8 4.9-4.8c10.3-10 24-15.6 38.4-15.6l1.5 0c29.5 0 53.5 23.9 53.5 53.5c0 14.4-5.8 28.3-16.2 38.4l-70.9 69c-6.2 6-16.1 6-22.3 0l-70.9-69c-10.4-10.1-16.2-23.9-16.2-38.4c0-29.5 23.9-53.5 53.5-53.5z'
      
    ]
  };

  

  
  

  var faTruckContainerEmpty = {
    prefix: 'fal',
    iconName: 'truck-container-empty',
    icon: [
      640,
      512,
      [],
      'e2b5',
      
      'M448 160c0-17.7 14.3-32 32-32l56 0c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8l0 5.3 0 48 0 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80l-160 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48L448 368l0-112 0-16 0-16 0-64zm144 64l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4l-56 0 0 64 112 0zm16 32l-128 0 0 80c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9l0-56 0-48zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faCalendarExclamation = {
    prefix: 'fal',
    iconName: 'calendar-exclamation',
    icon: [
      448,
      512,
      [],
      'f334',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zM200 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40-160l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faSink = {
    prefix: 'fal',
    iconName: 'sink',
    icon: [
      512,
      512,
      [],
      'e06d',
      
      'M272 80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 208-80 0 0-16c0-26.5-21.5-48-48-48l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16 7.2 16 16l0 16L16 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 112 0 112 0 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-26.5 0-48 21.5-48 48l0 16-80 0 0-208zM32 352l0 48c0 61.9 50.1 112 112 112l224 0c61.9 0 112-50.1 112-112l0-48-32 0 0 48c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-48-32 0z'
      
    ]
  };

  

  
  

  var faSunset = {
    prefix: 'fal',
    iconName: 'sunset',
    icon: [
      576,
      512,
      [127751],
      'f767',
      
      'M299.3 219.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 169.4 272 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 153.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm94.2 5.9c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448l-38.9 0 38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8L75.2 391.8 113.9 448l-38.9 0L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448l-33.4 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L164 448c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480l544 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faMicroscope = {
    prefix: 'fal',
    iconName: 'microscope',
    icon: [
      512,
      512,
      [128300],
      'f610',
      
      'M192 0c-17.7 0-32 14.3-32 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-128c88.4 0 160 71.6 160 160s-71.6 160-160 160l-80 0L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0 80 0 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-101.8 0c51.7-34.4 85.8-93.2 85.8-160c0-106-86-192-192-192l0-64c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32L192 0zm0 32l32 0 0 16c0 8.8 7.2 16 16 16l16 0 0 224-96 0 0-224 16 0c8.8 0 16-7.2 16-16l0-16zM160 368c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM96 432c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faHourglassHalf = {
    prefix: 'fal',
    iconName: 'hourglass-half',
    icon: [
      384,
      512,
      ["hourglass-2"],
      'f252',
      
      'M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-41.6c0-49.4 22.8-96 61.8-126.3L165.9 256 93.8 199.9C54.8 169.6 32 122.9 32 73.6L32 32 16 32C7.2 32 0 24.8 0 16S7.2 0 16 0L48 0 336 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 41.6c0 49.4-22.8 96-61.8 126.3L218.1 256l72.2 56.1c39 30.3 61.8 76.9 61.8 126.3l0 41.6 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0L48 512l-32 0zm304-32l0-41.6c0-7.6-.7-15.1-2-22.4L66 416c-1.3 7.3-2 14.8-2 22.4L64 480l256 0zM113.4 337.4C97.3 349.9 84.6 366 76.1 384l231.7 0c-8.5-18-21.1-34.1-37.3-46.6L192 276.3l-78.6 61.1zM192 235.7l78.6-61.1c5.7-4.5 11-9.3 15.8-14.6L97.6 160c4.8 5.3 10.1 10.2 15.8 14.6L192 235.7zM307.9 128c7.9-16.8 12.1-35.4 12.1-54.4L320 32 64 32l0 41.6c0 19.1 4.2 37.6 12.1 54.4l231.7 0z'
      
    ]
  };

  
    var faHourglass2 = faHourglassHalf;
  

  
  

  var faCircleCalendar = {
    prefix: 'fal',
    iconName: 'circle-calendar',
    icon: [
      512,
      512,
      ["calendar-circle"],
      'e102',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 96c8.8 0 16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c26.5 0 48 21.5 48 48l0 16 0 32 0 112c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-112 0-32 0-16c0-26.5 21.5-48 48-48l16 0 0-16c0-8.8 7.2-16 16-16zm-48 80l0 16 192 0 0-16c0-8.8-7.2-16-16-16l-32 0-96 0-32 0c-8.8 0-16 7.2-16 16zm192 48l-192 0 0 112c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-112z'
      
    ]
  };

  
    var faCalendarCircle = faCircleCalendar;
  

  
  

  var faCircleW = {
    prefix: 'fal',
    iconName: 'circle-w',
    icon: [
      512,
      512,
      [],
      'e12c',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 170.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4l72 208c2.3 6.5 8.4 10.8 15.3 10.8s13-4.6 15.1-11.1L256 236.5l48.8 152.4c2.1 6.6 8.2 11 15.1 11.1s13.1-4.3 15.3-10.8l72-208c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L320.6 333.4 271.2 179.1C269.1 172.5 263 168 256 168s-13.1 4.5-15.2 11.1L191.4 333.4 135.1 170.8z'
      
    ]
  };

  

  
  

  var faHeartCircleMinus = {
    prefix: 'fal',
    iconName: 'heart-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ff',
      
      'M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3l0 3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4l0-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9l0 3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1l0-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faWaveSine = {
    prefix: 'fal',
    iconName: 'wave-sine',
    icon: [
      640,
      512,
      [8767],
      'f899',
      
      'M31.4 244.2s0 0 0 0s0 0 0 0c0 0 0 0 0-.1l.1-.3 .4-1.3c.3-1.2 .9-3 1.6-5.2c1.5-4.6 3.7-11.2 6.7-19.1c6-15.9 15.2-37 27.6-58C93.2 117 129.1 80 176 80c36.5 0 61.1 19.2 80.8 52.2c20.2 33.9 33.7 79.7 47.9 128.3l.4 1.3c13.7 47 28.2 96.6 50.7 134.4c23.3 39 56.8 67.8 108.2 67.8c65.1 0 109.2-51 135.8-95.9c13.6-23 23.5-45.9 29.9-63c3.2-8.6 5.6-15.7 7.3-20.8c.8-2.5 1.4-4.5 1.8-5.9c.2-.7 .4-1.2 .5-1.6l.1-.5 0-.1c0 0 0 0 0 0s0 0 0 0L624 272l15.4 4.2c2.3-8.5-2.7-17.3-11.2-19.6s-17.3 2.7-19.6 11.2c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 .1l-.1 .3-.4 1.3c-.3 1.2-.9 3-1.6 5.2c-1.5 4.6-3.7 11.2-6.7 19.1c-6 15.9-15.2 37-27.6 58C546.8 395 510.9 432 464 432c-36.5 0-61.1-19.2-80.8-52.2c-20.2-33.9-33.7-79.7-47.9-128.3l-.4-1.3c-13.7-47-28.2-96.6-50.7-134.4C260.9 76.8 227.5 48 176 48C110.9 48 66.8 99 40.2 143.9c-13.6 23-23.5 45.9-29.9 63C7 215.4 4.6 222.5 3 227.6c-.8 2.5-1.4 4.5-1.8 5.9c-.2 .7-.4 1.2-.5 1.6l-.1 .5 0 .1c0 0 0 0 0 0s0 0 0 0L16 240 .6 235.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleDollar = {
    prefix: 'fal',
    iconName: 'display-chart-up-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e5e6',
      
      'M64 32l448 0c17.7 0 32 14.3 32 32l0 134.6c11.2 3.2 21.9 7.4 32 12.6L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l149.1 0-10.7 64L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 34.8 0c-12.9-9.1-24.5-19.9-34.6-32l-19.1 0L288 480l-53.1 0 10.7-64 42.4 0 38.6 0c-2.9-10.3-4.9-21-5.9-32l-88.5 0c-.2 0-.4 0-.6 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM480 192.7l0-80.7c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6l0 48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.8 335.4c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z'
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fal',
    iconName: 'share-nodes',
    icon: [
      448,
      512,
      ["share-alt"],
      'f1e0',
      
      'M448 112c0 44.2-35.8 80-80 80c-22.9 0-43.6-9.6-58.1-25l-151 75.5c.8 4.4 1.1 8.9 1.1 13.5s-.4 9.1-1.1 13.5l151 75.5c14.6-15.4 35.2-25 58.1-25c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-9.7 1.7-19 4.9-27.7L147.2 299.5c-14.3 22-39 36.5-67.2 36.5c-44.2 0-80-35.8-80-80s35.8-80 80-80c28.2 0 52.9 14.5 67.2 36.5l145.7-72.9c-3.2-8.6-4.9-17.9-4.9-27.7c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faKnife = {
    prefix: 'fal',
    iconName: 'knife',
    icon: [
      512,
      512,
      ["utensil-knife"],
      'f2e4',
      
      'M448 9.7C453.8 3.5 461.8 0 470.3 0c12.3 0 24.1 7.6 28.2 20.4c5 15.9 13.6 49.2 13.6 91.6c0 49.1-15.6 86.8-42.9 123.7c-22.7 30.6-54 61.2-91 97.4c-6.5 6.4-13.2 12.9-20 19.6l-9.8 9.8c-13.9 13.9-32.7 21.7-52.3 21.7s-38.4-7.8-52.3-21.7l-42-42L27.7 506.9c-6 6.5-16.2 6.8-22.6 .8s-6.8-16.2-.8-22.6L189.6 286.5 448 9.7zM223.5 297.1l42.8 42.8c7.9 7.9 18.5 12.3 29.7 12.3s21.8-4.4 29.7-12.3l9.9-9.9 .1-.1s0 0 0 0c7.1-7 13.9-13.7 20.5-20.1c37.2-36.4 66.3-64.9 87.3-93.2C467.4 184.2 480 153 480 112c0-34.9-6.5-63-10.9-78L223.5 297.1z'
      
    ]
  };

  
    var faUtensilKnife = faKnife;
  

  
  

  var faLightbulbOn = {
    prefix: 'fal',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9l32.4 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l32.4 0c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1c0 0 0 0 0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32l90.5 0c-6.6 18.6-24.4 32-45.3 32zm-80-53.3l0 5.3c0 44.2 35.8 80 80 80s80-35.8 80-80l0-5.3c0-5.9-4.8-10.7-10.7-10.7l-138.7 0c-5.9 0-10.7 4.8-10.7 10.7z'
      
    ]
  };

  

  
  

  var faMessageMiddleTop = {
    prefix: 'fal',
    iconName: 'message-middle-top',
    icon: [
      512,
      512,
      ["comment-middle-top-alt"],
      'e1e2',
      
      'M343.5 128L448 128c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l104.5 0c9.5 0 18.5-4.2 24.6-11.5L256 41l62.9 75.5C325 123.8 334 128 343.5 128zM268.3 26.3s0 0 0 0L256 16l12.3 10.2s0 0 0 0zM168.5 96L64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L343.5 96 268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z'
      
    ]
  };

  
    var faCommentMiddleTopAlt = faMessageMiddleTop;
  

  
  

  var faCarSide = {
    prefix: 'fal',
    iconName: 'car-side',
    icon: [
      640,
      512,
      [128663],
      'f5e4',
      
      'M171.3 64L224 64l0 16 0 96 0 16L87.6 192l39.1-97.8C134.1 75.9 151.7 64 171.3 64zM256 192l0-16 0-96 0-16 97.2 0c14.6 0 28.4 6.6 37.5 18l88 110L256 192zm263.9 .2L415.7 62c-15.2-19-38.2-30-62.5-30L171.3 32c-32.7 0-62.1 19.9-74.3 50.3L52.8 193C22.8 198.3 0 224.5 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-68-53.1-123.7-120.1-127.8zM542 400c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16zM385.3 368l-130.7 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80L32 368l0-112c0-17.7 14.3-32 32-32l448 0c53 0 96 43 96 96l0 48-33.3 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80zM160 448c-29.8 0-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16c-7.1 27.6-32.2 48-62 48z'
      
    ]
  };

  

  
  

  var faSquareSliders = {
    prefix: 'fal',
    iconName: 'square-sliders',
    icon: [
      448,
      512,
      ["sliders-h-square"],
      'f3f0',
      
      'M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 80c0-8.8 7.2-16 16-16l48 0 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 40 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-48 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM96 336c0-8.8 7.2-16 16-16l112 0 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 40 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-112 0c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  
    var faSlidersHSquare = faSquareSliders;
  

  
  

  var faPenToSquare = {
    prefix: 'fal',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      'M454.6 45.3l12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171L417.4 152l-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1L180.5 281c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4 .4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1L489.4 125.3c25-25 25-65.5 0-90.5L477.3 22.6c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144L0 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64z'
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faSackDollar = {
    prefix: 'fal',
    iconName: 'sack-dollar',
    icon: [
      512,
      512,
      [128176],
      'f81d',
      
      'M201.5 144l109 0 5.3 3.4C370.6 182.5 480 268.3 480 416c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64c0-147.7 109.4-233.5 164.3-268.6l5.3-3.4zm98.4-32l-87.8 0-6.7-9.8L156.9 32l198.1 0-48.4 70.2-6.7 9.8zM152.6 138.5C91.2 183.7 0 273.4 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-142.6-91.2-232.3-152.6-277.5c-9.7-7.1-18.6-13.2-26.4-18.1L351.2 94l38.9-56.4C401 21.7 389.6 0 370.3 0L141.7 0C122.4 0 111 21.7 121.9 37.6L160.8 94 179 120.4c-7.7 4.9-16.7 11-26.4 18.1zM272 216c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z'
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fal',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M479.4 240L384 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l95.4 0C471.6 383 383 471.6 272 479.4l0-95.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 95.4C129 471.6 40.4 383 32.6 272l95.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-95.4 0C40.4 129 129 40.4 240 32.6l0 95.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-95.4C383 40.4 471.6 129 479.4 240zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faBridgeLock = {
    prefix: 'fal',
    iconName: 'bridge-lock',
    icon: [
      640,
      512,
      [],
      'e4cc',
      
      'M48 32l80 0 128 0 128 0 128 0 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0-16 0-128 0-128 0-128 0-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64L48 64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM320 240c40.6 0 75.4 25.3 89.4 60.9C394 312.6 384 331.2 384 352l0-16c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-96c0-35.3-28.7-64-64-64l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c53 0 96 43 96 96l0 96c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-96c0-53 43-96 96-96zM496 64l-96 0 0 64 96 0 0-64zM368 64l-96 0 0 64 96 0 0-64zM240 64l-96 0 0 64 96 0 0-64zM528 224c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faFolderArrowUp = {
    prefix: 'fal',
    iconName: 'folder-arrow-up',
    icon: [
      512,
      512,
      ["folder-upload"],
      'e054',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM272 246.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 246.6 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4z'
      
    ]
  };

  
    var faFolderUpload = faFolderArrowUp;
  

  
  

  var faSquareSmall = {
    prefix: 'fal',
    iconName: 'square-small',
    icon: [
      320,
      512,
      [],
      'e27e',
      
      'M256 128c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L64 384c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32l192 0zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 96z'
      
    ]
  };

  

  
  

  var faBackpack = {
    prefix: 'fal',
    iconName: 'backpack',
    icon: [
      448,
      512,
      [127890],
      'f5d4',
      
      'M192 32l64 0c8.8 0 16 7.2 16 16l0 16-96 0 0-16c0-8.8 7.2-16 16-16zM144 48l0 16-16 0C57.3 64 0 121.3 0 192L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256c0-70.7-57.3-128-128-128l-16 0 0-16c0-26.5-21.5-48-48-48L192 0c-26.5 0-48 21.5-48 48zm16 48l128 0 32 0c53 0 96 43 96 96l0 256c0 17.7-14.3 32-32 32l-16 0 0-112 0-48c0-35.3-28.7-64-64-64l-160 0c-35.3 0-64 28.7-64 64l0 48 0 112-16 0c-17.7 0-32-14.3-32-32l0-256c0-53 43-96 96-96l32 0zM112 480l0-96 224 0 0 96-224 0zm32-320c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zM336 352l-224 0 0-32c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 32z'
      
    ]
  };

  

  
  

  var faArrowsCross = {
    prefix: 'fal',
    iconName: 'arrows-cross',
    icon: [
      448,
      512,
      [],
      'e0a2',
      
      'M288 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l105.4 0L4.7 452.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6 416 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16L288 32zM27.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L173.1 227.7l22.6-22.6L27.3 36.7zm225 270.2L393.4 448 288 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0c8.8 0 16-7.2 16-16l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 105.4L274.9 284.3l-22.6 22.6z'
      
    ]
  };

  

  
  

  var faTree = {
    prefix: 'fal',
    iconName: 'tree',
    icon: [
      448,
      512,
      [127794],
      'f1bb',
      
      'M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L72 145.4c-5.1 5.1-8 12.1-8 19.3C64 179.8 76.2 192 91.3 192l17.9 0L38.7 274.3c-4.3 5-6.7 11.4-6.7 18C32 307.6 44.4 320 59.7 320l17.5 0L6.7 402.3c-4.3 5-6.7 11.4-6.7 18C0 435.6 12.4 448 27.7 448L160 448l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0 132.3 0c15.3 0 27.7-12.4 27.7-27.7c0-6.6-2.4-13-6.7-18L370.8 320l17.5 0c15.3 0 27.7-12.4 27.7-27.7c0-6.6-2.4-13-6.7-18L338.8 192l17.9 0c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L235.3 4.7zM240 416l0-208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 208-48 0L37.1 416l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3l-42.9 0 87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3l-41.4 0L224 38.6 345.4 160 304 160c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1L378.9 288 336 288c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1L410.9 416 288 416l-48 0z'
      
    ]
  };

  

  
  

  var faCommentsQuestionCheck = {
    prefix: 'fal',
    iconName: 'comments-question-check',
    icon: [
      640,
      512,
      [],
      'e14f',
      
      'M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144s-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5c-3.5-.7-7.1-.2-10.2 1.4c-6.1 3.1-12 6-18 8.7c-28.4 12.9-60.2 23.1-91.5 26c14.9-19 26.8-39.7 37.6-59.9c3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110c-11.7 21-24 40.6-39.5 57.5c0 0 0 0 0 0l-.1 .1c-6.5 7-8.2 17.1-4.4 25.8C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.9-2.2 9.6-4.5 14.3-6.8c15.3 2.8 30.9 4.6 47 4.6c114.9 0 208-78.9 208-176S322.9 0 208 0zM447.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6c-4.8 5-5.8 12.5-2.5 18.6c10.9 20.2 22.7 40.8 37.6 59.9c-31.3-3-63.2-13.2-91.5-26c-6-2.7-11.9-5.6-18-8.7c-3.2-1.6-6.8-2.1-10.2-1.4c-15.6 3.1-30.9 5-46.3 5c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6c4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.7 2-18.9-4.4-25.8l-.1-.1s0 0 0 0c-15.5-17-27.8-36.5-39.5-57.5c26.2-29.9 46-65.8 46-110c0-94.4-87.8-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3zM539.3 266c-6.2-6.2-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L431.4 374c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3c6.2-6.2 6.2-16.4 0-22.6zm-391.4-162l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4l41.3 0c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9l0 9.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-.3L247.4 160c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7l-41.3 0c-16.4 0-31 10.3-36.4 25.7zM230.7 236a22.7 22.7 0 1 0 -45.3 0 22.7 22.7 0 1 0 45.3 0z'
      
    ]
  };

  

  
  

  var faHouseFloodWater = {
    prefix: 'fal',
    iconName: 'house-flood-water',
    icon: [
      576,
      512,
      [],
      'e50e',
      
      'M297.1 2.8c-5.5-3.8-12.7-3.8-18.2 0l-208 144c-7.3 5-9.1 15-4 22.3s15 9.1 22.3 4L112 157.3l0 101.2c7.3 1.9 14.4 5.1 20.9 9.6c3.6 2.5 7.3 4.8 11.1 6.8l0-139.8L288 35.5l144 99.7L432 275c3.8-2.1 7.6-4.4 11.2-6.8c6.5-4.5 13.5-7.8 20.8-9.6l0-101.2 22.9 15.8c7.3 5 17.2 3.2 22.3-4s3.2-17.2-4-22.3l-208-144zM133.8 346.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 368.1 0 374.4 0 382.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 385.9 161.7 400 192 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368s-41.7-9.9-58.2-21.2zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faMapLocation = {
    prefix: 'fal',
    iconName: 'map-location',
    icon: [
      576,
      512,
      ["map-marked"],
      'f59f',
      
      'M376 120c0 7.4-2.7 19-9.4 35c-6.5 15.4-15.7 32.4-26.4 49.7c-17.1 27.8-36.9 54.7-52.2 74.4c-15.3-19.7-35.1-46.6-52.2-74.4c-10.7-17.3-19.9-34.3-26.4-49.7c-6.7-15.9-9.4-27.6-9.4-35c0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0C334.9 271.9 408 174.6 408 120zm-4.6 103.6c.9-.2 1.7-.4 2.5-.8L544 167.6l0 253.5L416 472.4 416 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 170.8L192 419.9 192 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 117.2L32 472.4l0-253.5 115.5-46.2c-3.9-10-7.2-20.4-9.2-30.8L15.1 191.1C6 194.8 0 203.6 0 213.4L0 484.2c0 17 17.1 28.6 32.9 22.3l144-57.6 218.7 62.5c3.4 1 7 .8 10.3-.5l155-62c9.1-3.6 15.1-12.5 15.1-22.3l0-270.8c0-17-17.1-28.6-32.9-22.3L425.2 180.7c-6.1 14.2-13.6 28.8-21.8 42.9z'
      
    ]
  };

  
    var faMapMarked = faMapLocation;
  

  
  

  var faBlanket = {
    prefix: 'fal',
    iconName: 'blanket',
    icon: [
      448,
      512,
      [],
      'f498',
      
      'M32 128l0 184.4C49 297.2 71.4 288 96 288l296 0c8.6 0 16.7 1.9 24 5.4L416 128c0-35.3-28.7-64-64-64L96 64c-35.3 0-64 28.7-64 64zM0 384L0 128C0 75 43 32 96 32l256 0c53 0 96 43 96 96l0 216c0 30.9-25.1 56-56 56L96 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l296 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 320c-35.3 0-64 28.7-64 64s28.7 64 64 64l336 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 480c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faGlobePointer = {
    prefix: 'fal',
    iconName: 'globe-pointer',
    icon: [
      512,
      512,
      [],
      'e60e',
      
      'M317.9 422.7C296.4 465.6 272.7 480 256 480c-7.9 0-17.3-3.2-27.3-11l-6.9 18.6c-2.9 7.8-7.7 14.7-13.9 19.9c15.6 3 31.6 4.5 48.1 4.5c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 16.4 1.5 32.5 4.5 48.1c5.3-6.2 12.1-11 19.9-13.9l9.6-3.5c-1.4-10-2.1-20.2-2.1-30.6c0-22.2 3.2-43.7 9.3-64l90.8 0c-2.5 19.2-3.9 39.3-4 60l32.2-11.9c.5-16.7 1.9-32.8 4.1-48.1l183.4 0c2.8 20.2 4.3 41.7 4.3 64s-1.5 43.8-4.3 64l-64.1 0-11.8 32 70.2 0c-5.9 27-14.2 50.9-24.1 70.7zM194.1 89.3C215.6 46.4 239.3 32 256 32s40.4 14.4 61.9 57.3c9.9 19.8 18.2 43.7 24.1 70.7l-172 0c5.9-27 14.2-50.9 24.1-70.7zM384 256c0-22.1-1.4-43.5-4-64l90.8 0c6 20.3 9.3 41.8 9.3 64s-3.2 43.7-9.3 64L380 320c2.6-20.5 4-41.9 4-64zm-9.3-96c-9.6-47.6-26.2-88-47.2-116.3c57.8 19.5 105 61.8 130.9 116.3l-83.8 0zM53.6 160c25.9-54.5 73.1-96.9 130.9-116.3c-21 28.3-37.5 68.8-47.2 116.3l-83.7 0zM374.7 352l83.8 0c-25.9 54.5-73.1 96.9-130.9 116.3c21-28.3 37.6-68.8 47.2-116.3zM271 261.5c2.2-5.9 .7-12.4-3.7-16.8s-11-5.9-16.8-3.7l-215 79.2c-6.2 2.3-10.3 8.1-10.5 14.7s3.8 12.6 9.9 15.1l74 30.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L131.5 403.1l30.5 74c2.5 6.1 8.5 10 15.1 9.9s12.4-4.3 14.7-10.5l79.2-215zM143.3 360L85.1 336 229 283 176 426.9l-24-58.2c-1.6-3.9-4.8-7.1-8.7-8.7z'
      
    ]
  };

  

  
  

  var faHotTubPerson = {
    prefix: 'fal',
    iconName: 'hot-tub-person',
    icon: [
      512,
      512,
      ["hot-tub"],
      'f593',
      
      'M240 0c-8.8 0-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C307.7 128.4 320 151.4 320 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L288.8 77.3C268.3 63.6 256 40.6 256 16c0-8.8-7.2-16-16-16zM32 336l0-16 0-32 240 0c.5 0 1 0 1.6-.1c1.3 0 2.5 .1 3.8 .1L448 288c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-112zm170.7-80L32 256c0-35.3 28.7-64 64-64c13.8 0 27.3 4.5 38.4 12.8L202.7 256zM0 272l0 48 0 16L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-170.7 0c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96l0 16zM384 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C435.7 128.4 448 151.4 448 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L416.8 77.3C396.3 63.6 384 40.6 384 16zM112 336c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zM32 64a32 32 0 1 1 64 0A32 32 0 1 1 32 64zm96 0A64 64 0 1 0 0 64a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faHotTub = faHotTubPerson;
  

  
  

  var faHouseNight = {
    prefix: 'fal',
    iconName: 'house-night',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M127 1c-4.9-.7-9.9-1-15-1C50.1 0 0 50.1 0 112s50.1 112 112 112c30.6 0 58.4-12.3 78.6-32.2c.7-.6 1.3-1.3 1.9-2c2.9-3 5.7-6.2 8.2-9.5c2.3-3 4.5-6.2 6.5-9.5c3.9-6.2-3.2-13.3-10.4-12c-2.4 .4-4.9 .8-7.5 .9c-1.8 .1-3.6 .2-5.4 .2c-2.2 0-4.3-.1-6.5-.3c-.4 0-.8-.1-1.2-.1C140.2 155.8 112 125.2 112 88c0-20.8 8.8-39.5 22.9-52.7c.3-.3 .6-.5 .9-.8c2.9-2.7 6.1-5.1 9.4-7.2c2.1-1.4 4.3-2.6 6.6-3.7c6.6-3.3 8-13.2 1.1-15.9c-3.6-1.4-7.2-2.6-10.9-3.6c-4-1.1-8.1-2-12.3-2.7c-.9-.1-1.8-.3-2.7-.4zM80 88c0 43.9 27.1 81.4 65.5 96.7C135.3 189.4 124 192 112 192c-44.2 0-80-35.8-80-80c0-38.4 27.1-70.5 63.3-78.2C85.6 49.5 80 68.1 80 88zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9 224 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-164.1 37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5L544 448c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-191.5L400 133.1 544 256.5zM336 304l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm96 0l0 64-64 0 0-64 64 0zM256 0c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16zM96 320c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faRectanglePro = {
    prefix: 'fal',
    iconName: 'rectangle-pro',
    icon: [
      640,
      512,
      ["pro"],
      'e235',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64l48 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-96c0-8.8 7.2-16 16-16zm48 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0 64 32 0zm96-80c0-8.8 7.2-16 16-16l48 0c35.3 0 64 28.7 64 64c0 23.2-12.4 43.6-30.9 54.8l35.7 47.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L304 288l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-96zm32 80l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0 64zm208-96c44.2 0 80 35.8 80 80l0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-32c0-44.2 35.8-80 80-80zm-48 80l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z'
      
    ]
  };

  
    var faPro = faRectanglePro;
  

  
  

  var faMonkey = {
    prefix: 'fal',
    iconName: 'monkey',
    icon: [
      576,
      512,
      [128018],
      'f6fb',
      
      'M160 416c0-82.3 44.3-154.2 110.4-193.1c4.7 9.7 10.5 18.7 17.1 27.1C230.4 283.2 192 345.1 192 416l0 64 224 0 0-48c0-44.2-35.8-80-80-80l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c31.3 0 59.7 12.9 80 33.6l0-33.6 0-16.9c14.7-1.6 28.7-5.5 41.7-11.2l79.2 84.1c25.1 26.7 39.1 62 39.1 98.7l0 21.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-21.2c0-28.5-10.9-56-30.4-76.8L448 328.3 448 432l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0-32 0-224 0-32 0-16 0C64.5 512 0 447.5 0 368L0 103.3C0 46.2 46.2 0 103.3 0c49 0 88.7 39.7 88.7 88.7l0 7.3c0 53-43 96-96 96l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c35.3 0 64-28.7 64-64l0-7.3C160 57.4 134.6 32 103.3 32C63.9 32 32 63.9 32 103.3L32 368c0 61.9 50.1 112 112 112l16 0 0-64zM480 160l0-16 0-32c0 20.8-13.2 38.4-31.6 45.1c-4.7 1.7-8.4 5.9-8.4 10.9c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-5-3.7-9.2-8.4-10.9C333.2 150.4 320 132.8 320 112l0 32 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM336 64s0 0 0 0l128 0s0 0 0 0c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32zm64 208c-56.4 0-103.1-41.7-110.9-96l-1.1 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l20.1 0C328.3 19 361.9 0 400 0s71.7 19 91.9 48L512 48c35.3 0 64 28.7 64 64s-28.7 64-64 64l-1.1 0c-7.8 54.3-54.4 96-110.9 96zM544 112c0-17.7-14.3-32-32-32l-4.6 0c3 10.1 4.6 20.9 4.6 32l0 32c17.7 0 32-14.3 32-32zM288 144l0-32c0-11.1 1.6-21.9 4.6-32L288 80c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSignalBarsSlash = {
    prefix: 'fal',
    iconName: 'signal-bars-slash',
    icon: [
      640,
      512,
      ["signal-alt-slash"],
      'f694',
      
      'M448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 23.7L384 225l0-49c0-8.8 7.2-16 16-16s16 7.2 16 16l0 74.2 32 25.3 0-99.5zM384 464l0-75.9-32-25.3L352 464c0 26.5 21.5 48 48 48s48-21.5 48-48l0-25.4-32-25.3 0 50.7c0 8.8-7.2 16-16 16s-16-7.2-16-16zM288 312.3l-66.6-52.6C204.1 267 192 284.1 192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-151.7zm256 39L544 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 328.6 32 25.3L608 48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 278 32 25.3zM256 304l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16zM96 432l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  
    var faSignalAltSlash = faSignalBarsSlash;
  

  
  

  var faGasPump = {
    prefix: 'fal',
    iconName: 'gas-pump',
    icon: [
      512,
      512,
      [9981],
      'f52f',
      
      'M256 32c17.7 0 32 14.3 32 32l0 128L64 192 64 64c0-17.7 14.3-32 32-32l160 0zm32 192l0 256L64 480l0-256 224 0zM32 64l0 416-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 32 0 224 0 32 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-192 16 0c26.5 0 48 21.5 48 48l0 48c0 35.3 28.7 64 64 64s64-28.7 64-64l0-226.9c0-17.9-7.5-35.1-20.8-47.2L410.8 36.2c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L416 84.4l0 75.6c0 35.3 28.7 64 64 64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-44.2-35.8-80-80-80l-16 0 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64zM480 192c-17.7 0-32-14.3-32-32l0-46.3 21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6l0 34.9z'
      
    ]
  };

  

  
  

  var faArrowDownFromLine = {
    prefix: 'fal',
    iconName: 'arrow-down-from-line',
    icon: [
      384,
      512,
      [8615,"arrow-from-top"],
      'f345',
      
      'M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 425.4 176 320l0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 0 105.4L308.7 324.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM16 64C7.2 64 0 56.8 0 48s7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 64z'
      
    ]
  };

  
    var faArrowFromTop = faArrowDownFromLine;
  

  
  

  var faLock = {
    prefix: 'fal',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M128 128l0 64 192 0 0-64c0-53-43-96-96-96s-96 43-96 96zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 16 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 272c0-44.2 35.8-80 80-80l16 0zM32 272l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L80 224c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faPaintbrush = {
    prefix: 'fal',
    iconName: 'paintbrush',
    icon: [
      576,
      512,
      [128396,"paint-brush"],
      'f1fc',
      
      'M295.7 360c-5.4 0-10.6-.5-15.7-1.5c0 0 0 0 0-.1c-1.3-.3-2.6-.6-3.9-.9l-57.7-57.7c-.3-1.3-.6-2.6-.9-3.9c0 0 0 0-.1 0c-1-5.1-1.5-10.3-1.5-15.7c0-25.5 12.2-49.5 32.8-64.5L493.1 38.1c12.7-9.3 30.3-7.9 41.4 3.2s12.5 28.7 3.3 41.4L360.2 327.2c-15 20.6-39 32.8-64.5 32.8zm-42.2 20.1c.3 1.3 .6 2.6 .9 4c1 5.1 1.6 10.4 1.6 15.9c0 44.2-35.8 80-80 80L36.8 480C58 480 74.3 468.5 84 455.1c9.5-13.1 14.2-30 12.5-46.7c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80c5.4 0 10.7 .5 15.9 1.6c1.3 .3 2.7 .6 4 .9l57.7 57.7zm34.2 11.6c2.6 .2 5.3 .3 8 .3c35.7 0 69.3-17.1 90.4-46L563.7 101.6c18.5-25.5 15.8-60.6-6.5-82.9s-57.4-25-82.9-6.5L230 190c-28.9 21-46 54.6-46 90.3c0 2.7 .1 5.4 .3 8c-2.7-.2-5.5-.3-8.3-.3c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.8-.1-5.5-.3-8.3z'
      
    ]
  };

  
    var faPaintBrush = faPaintbrush;
  

  
  

  var faSnowBlowing = {
    prefix: 'fal',
    iconName: 'snow-blowing',
    icon: [
      640,
      512,
      [],
      'f761',
      
      'M192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 41.4-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L160 166.6l0 61.7-53.4-30.8L90.7 138.3c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l7.6 28.3L31.6 154.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 256 90.6 286.8 31.4 271c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6L15.6 330.1C7.9 334.6 5.3 344.3 9.7 352s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2L160 283.7l0 61.7-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 390.6l0 41.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-41.4 20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 345.4l0-61.7 53.4 30.8 15.9 59.2c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-7.6-28.3 35.8 20.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-35.8-20.7 28.3-7.6c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-59.2 15.9L208 256l53.4-30.8L320.6 241c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-28.3-7.6 35.8-20.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-35.8 20.7 7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2L192 228.3l0-61.7 43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 121.4 192 80zm288 0c0 8.8 7.2 16 16 16l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-64 0c-8.8 0-16 7.2-16 16zm0 352c0 8.8 7.2 16 16 16l64 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faFutbol = {
    prefix: 'fal',
    iconName: 'futbol',
    icon: [
      512,
      512,
      [9917,"futbol-ball","soccer-ball"],
      'f1e3',
      
      'M299.3 475.8c.1-.8 .2-1.7 .4-2.6l21.7-85.8c1.5-5.9 1.4-12.4-2.2-17.3l-3.9-5.3c-6.6-9.1-18.5-12.2-29.7-12.2l-59.2 0c-11.3 0-23.1 3.1-29.8 12.2l-3.9 5.3c-3.6 4.9-3.7 11.4-2.2 17.3l21.7 85.8c.2 .9 .4 1.7 .4 2.6c14 2.7 28.5 4.2 43.3 4.2s29.3-1.4 43.3-4.2zm35.3-10c38.3-14.3 71.6-38.9 96.6-70.2l-72.5-4.8c-1.4-.1-2.8 .3-4 1.2s-2 2.1-2.3 3.4l-17.8 70.5zM451.7 365.1c13.9-24.9 23.2-52.7 26.7-82.3c-.8-.3-1.5-.7-2.3-1.2l-74.9-47.1c-5.1-3.2-11.3-5.1-17.1-3.3l-6.3 2c-10.7 3.5-17.3 13.8-20.8 24.5L338.8 314c-3.5 10.7-4.2 22.9 2.4 32l3.9 5.3c3.6 4.9 9.7 7 15.8 7.4l88.3 5.9c.9 .1 1.7 .2 2.6 .4zm28.1-119c-1.8-41.9-15.1-80.7-36.9-113.6l-27 67.5c-.5 1.3-.6 2.7-.2 4.1c0 0 0 .1 0 .1s0 .1 0 .1c.4 1.3 1.3 2.4 2.5 3.2l61.5 38.7zM420.2 103.6c-19.7-21.2-43.4-38.6-70-50.9c-.6 .6-1.2 1.3-1.9 1.8l-68 56.6c-4.7 3.9-8.4 9.2-8.4 15.3l0 6.6c0 11.2 7.8 20.7 16.9 27.3l47.9 34.8c9.1 6.6 20.5 11.1 31.2 7.6l6.3-2c5.8-1.9 9.7-7.1 11.9-12.7l32.9-82.1c.3-.8 .7-1.6 1.1-2.3zM315.7 40.1c-19-5.3-39.1-8.1-59.7-8.1s-40.7 2.8-59.7 8.1l55.8 46.5c1.1 .9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4l55.8-46.5zm-154 12.7c-26.6 12.3-50.3 29.7-70 50.9c.4 .7 .8 1.5 1.1 2.3l32.9 82.1c2.3 5.6 6.2 10.8 11.9 12.7l6.3 2c10.7 3.5 22.1-1 31.2-7.6l47.9-34.8c9.1-6.6 16.9-16.1 16.9-27.3l0-6.6c0-6.1-3.7-11.4-8.4-15.3l-68-56.6c-.7-.6-1.3-1.2-1.9-1.8zM69.1 132.5C47.4 165.3 34 204.2 32.2 246.1l61.5-38.7c1.2-.7 2.1-1.9 2.5-3.2c0 0 0-.1 0-.1s0-.1 0-.1c.4-1.3 .4-2.8-.2-4.1l-27-67.4zM33.6 282.8c3.5 29.6 12.8 57.4 26.7 82.3c.8-.2 1.7-.3 2.6-.4l88.3-5.9c6.1-.4 12.2-2.5 15.8-7.4l3.9-5.3c6.6-9.1 5.9-21.3 2.4-32l-18.3-56.3c-3.5-10.7-10.1-21.1-20.8-24.5l-6.3-2c-5.8-1.9-12 0-17.1 3.3L35.9 281.6c-.7 .5-1.5 .9-2.3 1.2zM80.8 395.6c25 31.4 58.3 55.9 96.6 70.2l-17.8-70.5c-.3-1.4-1.2-2.6-2.3-3.4s-2.6-1.2-4-1.2l-72.5 4.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm241.9-69.7L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8c-8.4-6.1-19.8-6.1-28.2 0z'
      
    ]
  };

  
    var faFutbolBall = faFutbol;
  
    var faSoccerBall = faFutbol;
  

  
  

  var faJug = {
    prefix: 'fal',
    iconName: 'jug',
    icon: [
      448,
      512,
      [],
      'f8c6',
      
      'M176 85l0-53 96 0 0 53c0 14.2 4.7 28.1 13.5 39.3L363.8 225c13.1 16.9 20.2 37.6 20.2 58.9l0 4.1L64 288l0-4.1c0-21.3 7.1-42.1 20.2-58.9l78.3-100.7C171.3 113.1 176 99.3 176 85zM128 16c0 8.8 7.2 16 16 16l0 53c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6L32 304l0 96 0 48c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-48 0-96 0-20.1c0-21.8-5.6-43.1-16-61.9c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-23.6 0-44.2 12.8-55.3 31.8l-18-23.1C306.4 99 304 92.1 304 85l0-53c8.8 0 16-7.2 16-16s-7.2-16-16-16L272 0 176 0 144 0c-8.8 0-16 7.2-16 16zM378.3 191.5l-26.2-33.7c1.1-16.7 15-29.8 31.9-29.8c17.7 0 32 14.3 32 32s-14.3 32-32 32c-2 0-3.9-.2-5.7-.5zM64 384l0-64 320 0 0 64L64 384zm0 32l320 0 0 32c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-32z'
      
    ]
  };

  

  
  

  var faFolderPlus = {
    prefix: 'fal',
    iconName: 'folder-plus',
    icon: [
      512,
      512,
      [],
      'f65e',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM240 384c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  

  
  

  var faCampground = {
    prefix: 'fal',
    iconName: 'campground',
    icon: [
      576,
      512,
      [9978],
      'f6bb',
      
      'M394.3 3.7c6.8 5.7 7.7 15.8 2 22.5L308.9 130.4 532.8 397.2C540 405.8 544 416.7 544 428l0 36c0 26.5-21.5 48-48 48l-208 0L80 512c-26.5 0-48-21.5-48-48l0-36c0-11.3 4-22.2 11.2-30.9L267.1 130.4 179.7 26.3c-5.7-6.8-4.8-16.9 2-22.5s16.9-4.8 22.5 2L288 105.5 371.7 5.7c5.7-6.8 15.8-7.7 22.5-2zM67.7 417.7c-2.4 2.9-3.7 6.5-3.7 10.3l0 36c0 8.8 7.2 16 16 16l49.9 0 1.5-1.9 144-184c3-3.9 7.7-6.1 12.6-6.1s9.6 2.3 12.6 6.1l144 184 1.5 1.9 49.9 0c8.8 0 16-7.2 16-16l0-36c0-3.8-1.3-7.4-3.7-10.3L288 155.3 67.7 417.7zM170.6 480L288 480l117.4 0L288 330 170.6 480z'
      
    ]
  };

  

  
  

  var faClockNineThirty = {
    prefix: 'fal',
    iconName: 'clock-nine-thirty',
    icon: [
      512,
      512,
      [],
      'e34d',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400l0-144c0-8.8-7.2-16-16-16l-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 128c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faWatchFitness = {
    prefix: 'fal',
    iconName: 'watch-fitness',
    icon: [
      384,
      512,
      [],
      'f63e',
      
      'M96 48l0 16 192 0 0-16c0-8.8-7.2-16-16-16L112 32c-8.8 0-16 7.2-16 16zM64 65.6L64 48C64 21.5 85.5 0 112 0L272 0c26.5 0 48 21.5 48 48l0 17.6c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368L0 144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16L96 448l0 16zM80 96c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L80 96zm32 125.3c0 7.8 3.1 15.2 8.6 20.7L192 313.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM141.3 160c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleXmark = {
    prefix: 'fal',
    iconName: 'house-medical-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e513',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l250.8 0c-12.9-9.1-24.5-19.9-34.6-32L144 480c-26.5 0-48-21.5-48-48l0-225.3L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64l-12 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3l0-48 32 0 0 48c0 8.8 7.2 16 16 16l28.5 0c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-121.4 0l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z'
      
    ]
  };

  

  
  

  var faUpToLine = {
    prefix: 'fal',
    iconName: 'up-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-top"],
      'f34d',
      
      'M16 64l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16zm174.2 96.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L318.2 292.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L256 304c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L190.2 160.8zM192 128c-9.5 0-18.6 3.9-25.1 10.8L42.5 270.8C35.8 278 32 287.5 32 297.3C32 318.7 49.3 336 70.7 336l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L217.1 138.8c-6.5-6.9-15.6-10.8-25.1-10.8z'
      
    ]
  };

  
    var faArrowAltToTop = faUpToLine;
  

  
  

  var faEgg = {
    prefix: 'fal',
    iconName: 'egg',
    icon: [
      384,
      512,
      [129370],
      'f7fb',
      
      'M192 464c-85.2 0-160-84.3-160-176c0-50.8 14.7-113.1 43.5-161.7C104.2 77.9 143.4 48 192 48s87.8 29.9 116.5 78.3C337.3 174.9 352 237.2 352 288c0 91.7-74.8 176-160 176zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM170.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z'
      
    ]
  };

  

  
  

  var faFaceDizzy = {
    prefix: 'fal',
    iconName: 'face-dizzy',
    icon: [
      512,
      512,
      ["dizzy"],
      'f567',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 96a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faDizzy = faFaceDizzy;
  

  
  

  var faClipboardMedical = {
    prefix: 'fal',
    iconName: 'clipboard-medical',
    icon: [
      384,
      512,
      [],
      'e133',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 208c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0zm0 80l0-48 32 0 0 48c0 8.8 7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 48-32 0 0-48c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z'
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fal',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faBorderCenterV = {
    prefix: 'fal',
    iconName: 'border-center-v',
    icon: [
      448,
      512,
      [],
      'f89d',
      
      'M208 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416zM56 448A24 24 0 1 0 8 448a24 24 0 1 0 48 0zm384 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM56 352A24 24 0 1 0 8 352a24 24 0 1 0 48 0zm384 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM392 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM56 160A24 24 0 1 0 8 160a24 24 0 1 0 48 0zm336 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM56 256A24 24 0 1 0 8 256a24 24 0 1 0 48 0zM392 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM8 64a24 24 0 1 0 48 0A24 24 0 1 0 8 64zM296 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM344 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM296 448a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM152 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 448a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faGamepad = {
    prefix: 'fal',
    iconName: 'gamepad',
    icon: [
      640,
      512,
      [],
      'f11b',
      
      'M192 96C103.6 96 32 167.6 32 256s71.6 160 160 160l256 0c88.4 0 160-71.6 160-160s-71.6-160-160-160L192 96zM0 256C0 150 86 64 192 64l256 0c106 0 192 86 192 192s-86 192-192 192l-256 0C86 448 0 362 0 256zm208-64l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCartPlus = {
    prefix: 'fal',
    iconName: 'cart-plus',
    icon: [
      576,
      512,
      [],
      'f217',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2L496 384c8.8 0 16-7.2 16-16s-7.2-16-16-16l-304.8 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l314.6 0c29.4 0 55-20 62.1-48.5L575.5 51.9c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6L497.6 231.8C494 246 481.2 256 466.5 256l-321.1 0L100.9 38.4C96.3 16 76.7 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM240 128c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faUserBeardBolt = {
    prefix: 'fal',
    iconName: 'user-beard-bolt',
    icon: [
      576,
      512,
      [],
      'e689',
      
      'M80 105.3C80 47.1 127.1 0 185.3 0l78.5 0C321.3 0 368 46.7 368 104.2c0 3.3 .6 6.5 1.7 9.6l25.7 70.6c3.1 8.5 4.6 17.4 4.6 26.4c0 26.3-13.1 49.5-33.2 63.4c.8 4.5 1.2 9.1 1.2 13.8c0 44.2-35.8 80-80 80c-4.5 0-8.9-.4-13.2-1.1C263.1 382.2 244.7 392 224 392s-39.1-9.8-50.8-25.1c-4.3 .7-8.7 1.1-13.2 1.1c-44.2 0-80-35.8-80-80c0-4.7 .4-9.3 1.2-13.8C61.1 260.3 48 237.1 48 210.8c0-9 1.6-17.9 4.6-26.4l26-71.5c.9-2.4 1.3-5 1.3-7.6zM112.6 96l34.2 0c24.7 0 48.5-9.8 65.9-27.3c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7C252.8 86.2 276.5 96 301.3 96l34.3 0c-4.1-36-34.7-64-71.8-64l-78.5 0c-37.3 0-68.1 27.9-72.7 64zM320 128l-18.7 0c-28.2 0-55.3-9.5-77.3-26.7c-21.9 17.2-49.1 26.7-77.3 26.7L128 128l0 16c0 24.8 9.4 47.4 24.9 64.5l5.2-5.2C175.5 185.8 199.3 176 224 176s48.5 9.8 65.9 27.3l5.2 5.2c15.5-17 24.9-39.7 24.9-64.5l0-16zM82.7 195.3c-1.8 5-2.7 10.2-2.7 15.5c0 18.2 10.8 34 26.4 41.1c7.5 3.5 11.2 12.1 8.4 19.9c-1.8 5-2.8 10.5-2.8 16.2c0 26.5 21.5 48 48 48c5.4 0 10.6-.9 15.5-2.5c7.7-2.6 16.1 .9 19.6 8.3c5.2 10.8 16.2 18.3 28.9 18.3s23.8-7.4 28.9-18.3c3.5-7.3 11.9-10.9 19.6-8.3c4.8 1.6 10 2.5 15.5 2.5c26.5 0 48-21.5 48-48c0-5.7-1-11.1-2.8-16.2c-2.8-7.8 .9-16.5 8.4-19.9c15.6-7.2 26.4-22.9 26.4-41.1c0-5.3-.9-10.5-2.7-15.5L351.3 157c-6.5 64.6-61.1 115-127.3 115s-120.8-50.4-127.3-115L82.7 195.3zm187.1 33.1l-2.5-2.5C255.8 214.5 240.2 208 224 208s-31.8 6.5-43.3 17.9l-2.5 2.5c13.6 7.4 29.2 11.6 45.8 11.6s32.2-4.2 45.8-11.6zM399.7 376l48.3 0c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L528.3 360 480 360c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L399.7 376zM521.6 224c14.7 0 24.4 15.2 18.2 28.5L505 328l49.4 0c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L420.2 506.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L423 408l-49.4 0c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L507.8 229.5c3.7-3.5 8.7-5.5 13.8-5.5zM0 481.3c0-53.9 26.4-101.6 67-130.9c6 9 13.3 17 21.6 23.9C54.8 397.4 32.4 436.1 32 480l323.6 0c-2.6 11.1-1.5 22.2 2.7 32L30.7 512C13.8 512 0 498.2 0 481.3z'
      
    ]
  };

  

  
  

  var faSquarePhoneFlip = {
    prefix: 'fal',
    iconName: 'square-phone-flip',
    icon: [
      448,
      512,
      ["phone-square-alt"],
      'f87b',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zm64 32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM273 140.1l64 16c1.8 .4 3 2 3 3.9c0 114.9-97.1 212-212 212c-1.8 0-3.4-1.3-3.9-3l-16-64c-.5-2 .6-4.1 2.6-4.8l48-16c1.4-.5 3-.1 4.1 1l24.4 24.4c5 5 12.6 6.1 18.8 2.8c31.5-16.7 57.7-42.9 74.4-74.4c3.3-6.2 2.1-13.8-2.8-18.8l-24.4-24.4c-1.1-1.1-1.4-2.7-1-4.1l16-48c.7-2 2.7-3.1 4.8-2.6zm-35.1-7.5l-16 48c-4.3 12.9-.9 27.2 8.7 36.8l15.7 15.7c-11.5 18.1-27 33.6-45.1 45.1l-15.7-15.7c-9.6-9.6-23.9-13-36.8-8.7l-48 16c-17.8 5.9-28.1 24.6-23.5 42.9l16 64c4 16 18.4 27.3 34.9 27.3c132.5 0 244-111.5 244-244c0-16.5-11.2-30.9-27.3-34.9l-64-16c-18.2-4.6-36.9 5.7-42.9 23.5zm30.4 35.3l-4.5 13.6c-1.9 5.7-.4 12.1 3.9 16.4l2.3 2.3c4.2 4.2 10.3 5.7 16 4s9.9-6.4 11.1-12.2s2-11.7 2.5-17.6c.7-8.1-4.7-15.4-12.7-17.1s-15.9 2.9-18.4 10.6zM149.5 295.7l-13.6 4.5c-7.7 2.6-12.3 10.5-10.6 18.4s9 13.4 17.1 12.7c6-.5 11.8-1.4 17.6-2.5s10.5-5.4 12.2-11s.2-11.8-4-16l-2.3-2.3c-4.3-4.3-10.6-5.8-16.4-3.9z'
      
    ]
  };

  
    var faPhoneSquareAlt = faSquarePhoneFlip;
  

  
  

  var faTreePalm = {
    prefix: 'fal',
    iconName: 'tree-palm',
    icon: [
      576,
      512,
      [127796],
      'f82b',
      
      'M115.7 128c.7-.7 1.4-1.5 2.2-2.2c20.7-20.7 42.4-35.1 64.1-44.5c8.1-3.5 17.5 .2 21 8.3s-.2 17.5-8.3 21c-17.7 7.7-36.1 19.7-54.1 37.8c-3.6 3.6-6.9 7.1-10 10.7l-1.3 1.5c-51.1 60.1-42 123.1-21.3 156.1L244 180.7c3.2-3.2 7.5-4.9 12-4.7c0 0 0 0 0 0l176 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 78.1 0C532.8 135.5 490 80 400 80c-31.6 0-57.2 6.8-77.4 17.2c-7.2 3.7-16 1.4-20.6-5.3C281.2 60.9 241 32 176 32C86 32 43.2 87.5 33.9 128l81.7 0zM544 208l-96 0-106.9 0c8 23.6 15.1 49.1 21 75.4c14.3 64.4 21.4 135.3 15.4 200.1C375.9 500 361.9 512 345.9 512l-100.1 0c-21.7 0-36.7-21-30.8-41.3c27.4-94.3 34-166.1 30.8-216.1c-.6-10-1.7-19.1-3-27.4L129.1 340.8c-11.8 11.8-34.2 13.9-46-3.3C56.3 297.9 44.6 227.5 89.6 160L32 160c-16.7 0-34-14.3-30.1-34.9C12.3 70.1 67.6 0 176 0c68.6 0 116.2 28.1 144.4 63c22.6-9.4 49.1-15 79.6-15c108.4 0 163.7 70.1 174.1 125.1C578 193.7 560.7 208 544 208zm-272.3 0c2.8 13 4.9 27.8 5.9 44.5c3.5 54.5-3.8 130-32 227.1c0 .1 0 .1 0 .1s0 0 0 .1c0 0 0 .1 .1 .2c0 0 0 0 0 0l99.9 0c5.5-60.6-1.1-127.9-14.8-189.7c-6.5-29.4-14.6-57.2-23.7-82.3l-35.5 0z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fal',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M48 112l0-32 32 0 0 32-32 0zM16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L176 80zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zM48 240l32 0 0 32-32 0 0-32zm-8-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 224l0-32 32 0 0 32-32 0zM16 392l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faFilmSimple = {
    prefix: 'fal',
    iconName: 'film-simple',
    icon: [
      512,
      512,
      ["film-alt"],
      'f3a0',
      
      'M128 352l0 96 256 0 0-96 0-96 0-96 0-96L128 64l0 96 0 96 0 96zM96 368l-64 0 0 48c0 17.7 14.3 32 32 32l32 0 0-80zm0-32l0-64-64 0 0 64 64 0zm0-96l0-64-64 0 0 64 64 0zm0-96l0-80L64 64C46.3 64 32 78.3 32 96l0 48 64 0zM416 272l0 64 64 0 0-64-64 0zm0 96l0 80 32 0c17.7 0 32-14.3 32-32l0-48-64 0zm0-128l64 0 0-64-64 0 0 64zm0-96l64 0 0-48c0-17.7-14.3-32-32-32l-32 0 0 80zM64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z'
      
    ]
  };

  
    var faFilmAlt = faFilmSimple;
  

  
  

  var faAbacus = {
    prefix: 'fal',
    iconName: 'abacus',
    icon: [
      576,
      512,
      [129518],
      'f640',
      
      'M512 64c17.7 0 32 14.3 32 32l0 96-96 0 0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 64 0zm-96 64l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-128 0 0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 128 0 0 64zm-160 0l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-96 0 0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 96 0 0 64zm-128 0l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-96 0 0-96c0-17.7 14.3-32 32-32l64 0 0 64zM32 416l0-192 96 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64-64 0c-17.7 0-32-14.3-32-32zm128-32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 96 0 0 64-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64-96 0 0-64zm128-64l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-64 128 0 0 128-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 64-128 0 0-64 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32zm160 64l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-128 96 0 0 192c0 17.7-14.3 32-32 32l-64 0 0-64zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  

  
  

  var faHockeySticks = {
    prefix: 'fal',
    iconName: 'hockey-sticks',
    icon: [
      640,
      512,
      [],
      'f454',
      
      'M301.4 288l-34.9 0L129.8 23.3c-4.1-7.9-1-17.5 6.9-21.6s17.5-1 21.6 6.9L302 286.9l-.6 1.1zm75 64L393 320l191 0c30.9 0 56 25.1 56 56l0 80c0 30.9-25.1 56-56 56l-162.8 0c-23.9 0-45.9-13.4-56.9-34.6l-26.4-51 18-34.9 36.8 71.2c5.5 10.6 16.5 17.3 28.4 17.3l90.8 0 0-128-135.6 0zM544 352l0 128 40 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-40 0zM503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6L56 512c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l264.9 0L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352L128 352l0 128 90.8 0c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l40 0 0-128-40 0z'
      
    ]
  };

  

  
  

  var faFaceAnguished = {
    prefix: 'fal',
    iconName: 'face-anguished',
    icon: [
      512,
      512,
      [],
      'e369',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48l8.4 0c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2l-151.6 0c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32l-8.4 0c-29 0-53.2 20.6-58.6 48l125.7 0c-5.5-27.4-29.6-48-58.6-48zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faGhost = {
    prefix: 'fal',
    iconName: 'ghost',
    icon: [
      384,
      512,
      [128123],
      'f6e2',
      
      'M242.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l29.3-33.4c11.6-13.3 32.1-14 44.5-1.5l2.3 2.3c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6L384 192C384 86 298 0 192 0S0 86 0 192L0 457.4C0 469.9 10.1 480 22.6 480c6 0 11.8-2.4 16-6.6l2.3-2.3c12.5-12.5 32.9-11.8 44.5 1.5L114.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l26.6-30.5c12.7-14.6 35.4-14.6 48.2 0L242.7 506zM32 438.1L32 192c0-88.4 71.6-160 160-160s160 71.6 160 160l0 246.1c-25.1-14-57.6-9.3-77.6 13.4L256 472.5l-15.8-18.1c-25.5-29.1-70.8-29.1-96.3 0L128 472.5l-18.4-21.1C89.6 428.7 57.1 424 32 438.1zM152 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faHeading = {
    prefix: 'fal',
    iconName: 'heading',
    icon: [
      448,
      512,
      ["header"],
      'f1dc',
      
      'M0 48c0-8.8 7.2-16 16-16l64 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 64l0 160 256 0 0-160-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 176 0 208 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-192L96 256l0 192 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-208L64 64 16 64C7.2 64 0 56.8 0 48z'
      
    ]
  };

  
    var faHeader = faHeading;
  

  
  

  var faTrainTunnel = {
    prefix: 'fal',
    iconName: 'train-tunnel',
    icon: [
      512,
      512,
      [],
      'e454',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224l0 240c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240C512 114.6 397.4 0 256 0S0 114.6 0 256L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240zm336-48l0 48-224 0 0-48c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48zM144 368l0-80 224 0 0 80c0 26.5-21.5 48-48 48c0 0 0 0 0 0l-128 0s0 0 0 0c-26.5 0-48-21.5-48-48zm16 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.6 448l114.7 0 59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4l0-160c0-44.2-35.8-80-80-80l-128 0c-44.2 0-80 35.8-80 80l0 160c0 32.8 19.8 61 48 73.4zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faSquareParkingSlash = {
    prefix: 'fal',
    iconName: 'square-parking-slash',
    icon: [
      640,
      512,
      ["parking-slash"],
      'f617',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM497.4 477.6L459.9 448 160 448c-17.7 0-32-14.3-32-32l0-230L96 160.7 96 416c0 35.3 28.7 64 64 64l320 0c6 0 11.9-.8 17.4-2.4zM142.6 34.4L180.1 64 480 64c17.7 0 32 14.3 32 32l0 230 32 25.3L544 96c0-35.3-28.7-64-64-64L160 32c-6 0-11.9 .8-17.4 2.4zm97.4 240l0 29.6 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 0-32 0-20.4-32-25.3zm197.7-7c6.6-13 10.3-27.8 10.3-43.4c0-53-43-96-96-96l-88 0c-.9 0-1.8 0-2.7 .1L301.7 160l50.3 0c35.3 0 64 28.7 64 64c0 8.1-1.5 15.8-4.2 22.9l25.9 20.4z'
      
    ]
  };

  
    var faParkingSlash = faSquareParkingSlash;
  

  
  

  var faPesetaSign = {
    prefix: 'fal',
    iconName: 'peseta-sign',
    icon: [
      384,
      512,
      [],
      'e221',
      
      'M72.7 32C50.2 32 32 50.2 32 72.7L32 160l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 112 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 144 0c74.1 0 135.2-56 143.1-128l16.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16.9 0c-8-72-69-128-143.1-128L72.7 32zM318.9 160L64 160l0-87.3c0-4.8 3.9-8.7 8.7-8.7L208 64c56.4 0 103.1 41.7 110.9 96zM64 192l254.9 0c-7.8 54.3-54.4 96-110.9 96L64 288l0-96z'
      
    ]
  };

  

  
  

  var faSandwich = {
    prefix: 'fal',
    iconName: 'sandwich',
    icon: [
      512,
      512,
      [129386],
      'f81f',
      
      'M480 96l0 64L32 160l0-64 448 0zM32 64C14.3 64 0 78.3 0 96l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 64zM0 352l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-88 0c-2.2 0-4.5 .5-6.5 1.4L320 350.5l-65.5-29.1c-2-.9-4.3-1.4-6.5-1.4L32 320c-17.7 0-32 14.3-32 32zm244.6 0l68.9 30.6c4.1 1.8 8.9 1.8 13 0L395.4 352l84.6 0 0 64L32 416l0-64 212.6 0zM16 288c10.5 0 20.9-2.6 30.5-5.8c8.5-2.9 17.2-6.6 25.6-10.1c0 0 0 0 0 0l3.2-1.3C94.6 262.6 111.7 256 128 256c20.4 0 36.7 6.7 56.6 14.8c19.5 8 42.2 17.2 71.4 17.2s51.8-9.2 71.4-17.2c19.9-8.1 36.2-14.8 56.6-14.8c16.3 0 33.4 6.6 52.8 14.7l3.2 1.3c8.3 3.5 17.1 7.2 25.6 10.1c9.6 3.2 20 5.8 30.5 5.8c8.8 0 16-7.2 16-16s-7.2-16-16-16c-5.5 0-12.1-1.4-20.3-4.2c-7.3-2.5-14.9-5.7-23.4-9.3l-3.2-1.3C430.6 233.4 407.7 224 384 224c-26.8 0-48.2 8.8-67 16.5l-1.8 .7c-19.6 8-37 14.8-59.3 14.8s-39.7-6.8-59.3-14.8l-1.8-.7c-18.8-7.7-40.2-16.5-67-16.5c-23.7 0-46.6 9.4-65.2 17.3l-3.2 1.3c-8.5 3.6-16.1 6.8-23.4 9.3C28.1 254.6 21.5 256 16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faBookOpenCover = {
    prefix: 'fal',
    iconName: 'book-open-cover',
    icon: [
      640,
      512,
      ["book-open-alt"],
      'e0c0',
      
      'M544 373.8l0-340.3L336 62.1l0 353.3 208-41.6zM304 415.4l0-353.3L96 33.5l0 340.3 208 41.6zM539.6 1.8C558.9-.8 576 14.1 576 33.5l0 340.3c0 15.3-10.8 28.4-25.7 31.4L332.6 448.7c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4L64 33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32l0 32L32 160l0 258.6 281.7 56.3c4.1 .8 8.4 .8 12.6 0L608 418.6 608 160l0-94.5 0-32c17.4 0 32 14.1 32 32l0 353.1c0 15.3-10.8 28.4-25.7 31.4L332.6 506.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6L0 65.5z'
      
    ]
  };

  
    var faBookOpenAlt = faBookOpenCover;
  

  
  

  var faShredder = {
    prefix: 'fal',
    iconName: 'shredder',
    icon: [
      512,
      512,
      [],
      'f68a',
      
      'M96 64l0 128 320 0 0-101.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4L128 32c-17.7 0-32 14.3-32 32zM64 192L64 64C64 28.7 92.7 0 128 0L357.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3L448 192c35.3 0 64 28.7 64 64l0 96c0 17.7-14.3 32-32 32L32 384c-17.7 0-32-14.3-32-32l0-96c0-35.3 28.7-64 64-64zm0 32c-17.7 0-32 14.3-32 32l0 96 448 0 0-96c0-17.7-14.3-32-32-32L64 224zm344 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 496l0-80 32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0l0-80 32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0l0-80 32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0l0-80 32 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faSquareCheck = {
    prefix: 'fal',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM331.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 297.4 308.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faLuchadorMask = {
    prefix: 'fal',
    iconName: 'luchador-mask',
    icon: [
      448,
      512,
      ["luchador","mask-luchador"],
      'f455',
      
      'M288 480l-128 0C89.3 480 32 422.7 32 352l0-128C32 118 118 32 224 32s192 86 192 192l0 128c0 70.7-57.3 128-128 128zM224 0C100.3 0 0 100.3 0 224L0 352c0 88.4 71.6 160 160 160l128 0c88.4 0 160-71.6 160-160l0-128C448 100.3 347.7 0 224 0zM160 352l35.3 0 57.4 0 35.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7l13.3 0c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48l-32 0c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80l-32 0c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80l13.3 0c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3l-11.3 0-6 0-.6 0-21.5 0-.6 0-6 0-11.3 0zM96 208c0-8.8 7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16l-32 0c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16c0-26.5 21.5-48 48-48l32 0z'
      
    ]
  };

  
    var faLuchador = faLuchadorMask;
  
    var faMaskLuchador = faLuchadorMask;
  

  
  

  var faCommentLines = {
    prefix: 'fal',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      'M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM144 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faKeySkeletonLeftRight = {
    prefix: 'fal',
    iconName: 'key-skeleton-left-right',
    icon: [
      640,
      512,
      [],
      'e3b4',
      
      'M608 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128c0 0 0 0 0 0l-96 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l212 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128zM32 384a96 96 0 1 0 192 0A96 96 0 1 0 32 384zM0 384c0-70.7 57.3-128 128-128s128 57.3 128 128c0 0 0 0 0 0l96 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 8.8-7.2 16-16 16l-212 0c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z'
      
    ]
  };

  

  
  

  var faAsterisk = {
    prefix: 'fal',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      'M192 32c8.8 0 16 7.2 16 16l0 178.9 151.4-96.4c7.5-4.7 17.3-2.5 22.1 4.9s2.5 17.3-4.9 22.1L221.8 256l154.8 98.5c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L208 285.1 208 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-178.9L24.6 381.5c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1L162.2 256 7.4 157.5c-7.5-4.7-9.7-14.6-4.9-22.1s14.6-9.7 22.1-4.9L176 226.9 176 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHandsHoldingChild = {
    prefix: 'fal',
    iconName: 'hands-holding-child',
    icon: [
      640,
      512,
      [],
      'e4fa',
      
      'M336 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 96c-2.9 0-5.7 .2-8.5 .7L307.8 208l24.4 0-3.7-63.3c-2.8-.4-5.6-.7-8.5-.7zM304 272.9c-.5 8.8-8.1 15.6-16.9 15s-15.6-8.1-15-16.9l6.4-108.3L251.3 190c-6.2 6.3-16.4 6.3-22.6 0s-6.3-16.4 0-22.6l29.6-29.7C274.6 121.2 296.8 112 320 112s45.4 9.2 61.7 25.6l29.6 29.7c6.2 6.3 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-27.1-27.2L368 271.1c.5 8.8-6.2 16.4-15 16.9s-16.4-6.2-16.9-15L334.1 240l-28.2 0L304 272.9zM64 64c35.3 0 64 28.7 64 64l0 124.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5L512 128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6L608 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16s0 0 0 0l44-44s0 0 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3l0 77.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16s0 0 0 0l-44-44s0 0 0 0l-10.7-10.8C106.8 305.4 96 279.4 96 252.3L96 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2L0 128C0 92.7 28.7 64 64 64z'
      
    ]
  };

  

  
  

  var faAnkh = {
    prefix: 'fal',
    iconName: 'ankh',
    icon: [
      320,
      512,
      [9765],
      'f644',
      
      'M64 128c0 48.2 25.8 88.6 55 118.7c14.4 14.8 28.8 26.4 39.7 34.2l1.3 .9 1.3-.9c10.9-7.8 25.3-19.3 39.7-34.2c29.2-30.1 55-70.5 55-118.7c0-53-43-96-96-96s-96 43-96 96zm52.1 160C79.1 255.9 32 200.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 72.8-47.1 127.9-84.1 160L304 288c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0 0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176L16 320c-8.8 0-16-7.2-16-16s7.2-16 16-16l100.1 0z'
      
    ]
  };

  

  
  

  var faWheatAwn = {
    prefix: 'fal',
    iconName: 'wheat-awn',
    icon: [
      512,
      512,
      ["wheat-alt"],
      'e2cd',
      
      'M491 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L319.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L281.8 26.4c-6.2-6.2-16.4-6.2-22.6 0L225.2 60.3c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0L44.3 241.3c-37.5 37.5-37.5 98.3 0 135.8L78.2 411s0 0 0 0L4.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5s0 0 0 0l33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.6-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4L491 145.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L414 176.9c-16.1-5.5-33-7.8-49.8-6.7L491 43.3zM191.6 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5L180 150.8l11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM247.9 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zM89.5 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L66.9 354.4c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181l-22.6 22.6c-25 25-65.5 25-90.5 0L123.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5l-22.6 22.6c-25 25-65.5 25-90.5 0l-33.9-33.9c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5l-22.6 22.6c-25 25-65.5 25-90.5 0L304.4 230c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3z'
      
    ]
  };

  
    var faWheatAlt = faWheatAwn;
  

  
  

  var faCompress = {
    prefix: 'fal',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      'M160 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112L16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L16 320zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-112zM304 320c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faCircleN = {
    prefix: 'fal',
    iconName: 'circle-n',
    icon: [
      512,
      512,
      [],
      'e118',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM189 134.7c-4-5.7-11.3-8.1-17.9-5.9S160 137 160 144l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-174.1L323 377.3c4 5.7 11.3 8.1 17.9 5.9s11.1-8.3 11.1-15.2l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 174.1L189 134.7z'
      
    ]
  };

  

  
  

  var faAlbum = {
    prefix: 'fal',
    iconName: 'album',
    icon: [
      448,
      512,
      [128189],
      'f89f',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCloudSunRain = {
    prefix: 'fal',
    iconName: 'cloud-sun-rain',
    icon: [
      640,
      512,
      [127782],
      'f743',
      
      'M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm87.3 297.7c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c3.9-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zM304 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0c0 0 0 0 0 0l.2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0-266.6 0c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1l266.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96z'
      
    ]
  };

  

  
  

  var faSwords = {
    prefix: 'fal',
    iconName: 'swords',
    icon: [
      512,
      512,
      [9876],
      'f71d',
      
      'M130.7 278.6l-15.4 15.4-12.7-12.7c-12.5-12.5-32.8-12.5-45.3 0l-16 16c-9.4 9.4-12 23.5-6.6 35.6l23.1 51.9L9.4 433.4c-12.5 12.5-12.5 32.8 0 45.3l24 24c12.5 12.5 32.8 12.5 45.3 0l48.5-48.5L179 477.2c12.1 5.4 26.3 2.7 35.6-6.6l16-16c12.5-12.5 12.5-32.8 0-45.3l-12.7-12.7 15.4-15.4-22.6-22.6-15.4 15.4-57.4-57.4 15.4-15.4-22.6-22.6zm227.9-67.9l22.6 22.6L491.1 123.5c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6L418.1 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l22.6 22.6L411.1 43.5c2.6-2.6 6.1-4.3 9.9-4.6l57.3-5.2L473.1 91c-.3 3.7-2 7.2-4.6 9.9L358.6 210.7zM64 320l16-16L208 432l-16 16-62-27.5c-6-2.7-13.1-1.4-17.8 3.3L56 480 32 456l56.2-56.2c4.7-4.7 6-11.8 3.3-17.8L64 320zM38.9 91L33.7 33.7 91 38.9c3.7 .3 7.2 2 9.9 4.6L354.7 297.4l22.6-22.6L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4 .1C12.7-.4 8 1.3 4.7 4.7S-.4 12.7 .1 17.4L7 93.9c1 11.2 5.9 21.7 13.9 29.6L274.7 377.4l22.6-22.6L43.5 100.9c-2.6-2.6-4.3-6.1-4.6-9.9zM409.4 281.4l-128 128c-12.5 12.5-12.5 32.8 0 45.3l16 16c9.4 9.4 23.5 12 35.6 6.6l51.9-23.1 48.5 48.5c12.5 12.5 32.8 12.5 45.3 0l24-24c12.5-12.5 12.5-32.8 0-45.3l-48.5-48.5L477.2 333c5.4-12.1 2.7-26.3-6.6-35.6l-16-16c-12.5-12.5-32.8-12.5-45.3 0zM432 304l16 16-27.5 62c-2.7 6.1-1.4 13.1 3.3 17.8L480 456l-24 24-56.2-56.2c-4.7-4.7-11.8-6-17.8-3.3L320 448l-16-16L432 304z'
      
    ]
  };

  

  
  

  var faCommentSlash = {
    prefix: 'fal',
    iconName: 'comment-slash',
    icon: [
      640,
      512,
      [],
      'f4b3',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm377.6 400C378.1 411.5 350 416 320 416c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4l6.4 14.7-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6c14.3-23.8 22.6-49.3 25.7-76.3c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100c0-22.9 5.9-45.3 16.7-66.1L87 153.6C72.2 179.9 64 209.2 64 240c0 46.6 19.6 87.1 47.4 120.5l.1 .1c0 0 0 0 0 .1c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C249.5 441.3 284 448 320 448c40.6 0 78.9-7.7 113-21.3l-29.4-23.2zM320 32c-51.1 0-98.6 12.1-138.6 33.1L209.2 87C241.3 72.5 278.8 64 320 64c130.2 0 224 84.6 224 176c0 31-10.8 61.2-30.1 87.5l25.3 20C562.6 316.1 576 279.3 576 240C576 125.2 461.5 32 320 32z'
      
    ]
  };

  

  
  

  var faBoxTaped = {
    prefix: 'fal',
    iconName: 'box-taped',
    icon: [
      448,
      512,
      ["box-alt"],
      'f49a',
      
      'M264 32l-80 0-78.4 0C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38L264 32zm24 128L270 64l72.4 0c12.6 0 24.1 7.4 29.2 19l34.2 77L304 160l-16 0zm-32.6 0l-62.9 0 18-96 26.9 0 18 96zm.6 32l0 64-64 0 0-64 64 0zm-96 0l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64 16 0 112 0 0 224c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-224 112 0 16 0zm0-32l-16 0L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19L178 64l-18 96z'
      
    ]
  };

  
    var faBoxAlt = faBoxTaped;
  

  
  

  var faXmarkToSlot = {
    prefix: 'fal',
    iconName: 'xmark-to-slot',
    icon: [
      576,
      512,
      ["times-to-slot","vote-nay"],
      'f771',
      
      'M144 64c-8.8 0-16 7.2-16 16l0 304 320 0 0-304c0-8.8-7.2-16-16-16L144 64zM480 80l0 304 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-32 0-320 0-32 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48zM48 320l16 0 0 32-16 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0-32 16 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM212.7 148.7c6.2-6.2 16.4-6.2 22.6 0L288 201.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L310.6 224l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 246.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 224l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faTimesToSlot = faXmarkToSlot;
  
    var faVoteNay = faXmarkToSlot;
  

  
  

  var faVolumeLow = {
    prefix: 'fal',
    iconName: 'volume-low',
    icon: [
      448,
      512,
      [128264,"volume-down"],
      'f027',
      
      'M151.6 188L288 66.7l0 378.6L151.6 324c-2.9-2.6-6.7-4-10.6-4l-85 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l85 0c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM409.6 179.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8z'
      
    ]
  };

  
    var faVolumeDown = faVolumeLow;
  

  
  

  var faFeather = {
    prefix: 'fal',
    iconName: 'feather',
    icon: [
      512,
      512,
      [129718],
      'f52d',
      
      'M325.6 163.8L96 393.4 96 330c0-59.4 23.6-116.4 65.6-158.4L265.4 67.9c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l5.5 5.5c23 23 35.9 54.1 35.9 86.6c0 22.8-6.3 44.9-18 64l-151.3 0 37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-47 92.2l156.1 0-64 64-156.1 0 64-64zm60.1 96c-41.8 41-98.1 64-156.8 64l-63.3 0 64-64 156.1 0zM64 330l0 95.3L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448l95.3 0c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z'
      
    ]
  };

  

  
  

  var faSquareCode = {
    prefix: 'fal',
    iconName: 'square-code',
    icon: [
      448,
      512,
      [],
      'e267',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM261.4 172c-6.6 5.9-7.2 16-1.3 22.6L314.6 256 260 317.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM188 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L133.4 256 188 194.6z'
      
    ]
  };

  

  
  

  var faDisplayChartUp = {
    prefix: 'fal',
    iconName: 'display-chart-up',
    icon: [
      576,
      512,
      [],
      'e5e3',
      
      'M512 32c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-167.7 0c-.2 0-.4 0-.6 0l-111.5 0c-.2 0-.4 0-.6 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l448 0zM64 416l149.1 0-10.7 64L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 72 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.4 0-10.7-64L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64 84.9 0 10.7 64-106.2 0zM368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6l0 57.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faChartScatter3d = {
    prefix: 'fal',
    iconName: 'chart-scatter-3d',
    icon: [
      512,
      512,
      [],
      'e0e8',
      
      'M272 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 232.6L37.7 451.8c-6.7 5.7-7.6 15.8-1.9 22.6s15.8 7.6 22.5 1.9L256 309 453.7 476.2c6.7 5.7 16.8 4.9 22.6-1.9s4.9-16.8-1.9-22.6L272 280.6 272 48zM384 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256A24 24 0 1 0 8 256a24 24 0 1 0 48 0zM256 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faHanukiah = {
    prefix: 'fal',
    iconName: 'hanukiah',
    icon: [
      640,
      512,
      [128334],
      'f6e6',
      
      'M336 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 80l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 96c8.8 0 16 7.2 16 16l0 240 48 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 32 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 32 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 173.3c18.6-6.6 32-24.4 32-45.3l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 44.2-35.8 80-80 80l-192 0 0 96 160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-176 0-176 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0 0-96-192 0c-44.2 0-80-35.8-80-80l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 20.9 13.4 38.7 32 45.3L96 176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 32 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 32 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 48 0 0-240c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFaceCowboyHat = {
    prefix: 'fal',
    iconName: 'face-cowboy-hat',
    icon: [
      512,
      512,
      [],
      'e36e',
      
      'M168.1 118.9c5.7-17.2 13-35.7 21.4-51.9c6.9-13.2 13.7-23.2 19.8-29.4c3.5-3.5 5.7-4.9 6.7-5.4c.8 .4 2.2 1.3 4.2 3c20.3 17.8 51.2 17.8 71.5 0c2-1.8 3.4-2.6 4.2-3c1 .5 3.2 1.8 6.7 5.4c6.1 6.2 12.9 16.2 19.8 29.4c8.4 16.2 15.7 34.8 21.4 51.9c-27.7 5.9-57.2 9.1-87.9 9.1s-60.2-3.2-87.9-9.1zM296 0c-8.9 0-17.4 4.2-25.4 11.2c-8.2 7.2-21.1 7.2-29.3 0C233.4 4.2 224.9 0 216 0c-34.2 0-63 62.1-79 110.9C106.5 101.7 78.9 89 55.2 73.6l-.3-.2c-1-.6-2-1.3-2.9-1.9c-2.3-1.6-4.6-3.2-6.9-4.8C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7c1.1 3.5 2.4 7 3.8 10.4c.4 1 .8 2 1.3 3l.2 .4C61.5 169.9 150.8 224 256 224s194.5-54.1 227-129.4l.2-.4c.4-1 .9-2 1.3-3c1.4-3.4 2.7-6.9 3.8-10.4C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8c-2.3 1.6-4.6 3.2-6.9 4.8c-1 .6-1.9 1.3-2.9 1.9l-.3 .2C433.1 89 405.5 101.7 375 110.9C359 62.1 330.2 0 296 0zM256 192c-69.9 0-129-26.2-166.1-64.1C138.7 148.5 195.7 160 256 160s117.3-11.5 166.1-32.1C385 165.8 325.9 192 256 192zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-8.6 6.2-17.6 12-27 17.2C423.7 242.9 432 272.5 432 304c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-31.5 8.3-61.1 22.8-86.7c-9.4-5.3-18.5-11-27-17.2zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 386.1c25.9 0 51-2.6 74.9-7.4c-19.5 23.7-46.5 37.4-74.9 37.4s-55.4-13.7-74.9-37.4c23.9 4.8 49 7.4 74.9 7.4zm124.5-29.6c4.8-12.1-7.8-22.5-20.2-18.5c-31.7 10.3-67.1 16.1-104.4 16.1s-72.7-5.8-104.4-16.1c-12.3-4-24.9 6.4-20.2 18.5c21.3 54 69 91.6 124.5 91.6s103.3-37.6 124.5-91.6z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fal',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 64 0 367l0 33 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-104 96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56l0-40zm0 73L140.7 61.8c30.7-7.7 63.1-4.1 91.4 10c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1 0 278-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359 32 89z'
      
    ]
  };

  

  
  

  var faArrowUpToLine = {
    prefix: 'fal',
    iconName: 'arrow-up-to-line',
    icon: [
      384,
      512,
      ["arrow-to-top"],
      'f341',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32zM203.3 132.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 182.6 176 288l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-105.4L308.7 283.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128z'
      
    ]
  };

  
    var faArrowToTop = faArrowUpToLine;
  

  
  

  var faSquirrel = {
    prefix: 'fal',
    iconName: 'squirrel',
    icon: [
      512,
      512,
      [],
      'f71a',
      
      'M144 32C82.1 32 32 82.1 32 144s50.1 112 112 112c15.7 0 30.2 8.5 37.7 22.3c9.6 17.3 5.2 37-4.3 50.5c-11 15.6-17.4 34.6-17.4 55.2c0 53 43 96 96 96l112 0c35.3 0 64-28.7 64-64s-28.7-64-64-64c-6.7 0-13.2 1-19.2 2.9c-8.4 2.6-17.4-2-20.1-10.5s2-17.4 10.5-20.1c9.1-2.9 18.8-4.4 28.8-4.4c11.2 0 22 1.9 32 5.5l0-85.5c0-8.8 7.2-16 16-16l11.5 0c21.2 0 40.6-12 50.1-31l2-4.1-.3-3.4C476 152.9 448.5 128 415.6 128L400 128c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c49.1 .2 90.2 37.5 95.1 86.4l.8 8c.3 3-.3 6-1.6 8.7l-4.1 8.2c-14.2 28.5-42.7 46.9-74.2 48.5l0 88.6c19.6 17.6 32 43.1 32 71.6c0 24.6-9.2 47-24.4 64l40.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0-112 0c-70.7 0-128-57.3-128-128c0-27.4 8.6-52.8 23.2-73.6c4.5-6.3 4.6-12.8 2.4-16.7c-1.9-3.5-5.7-5.7-9.7-5.7C64.5 288 0 223.5 0 144S64.5 0 144 0s144 64.5 144 144l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-61.9-50.1-112-112-112zM352 80l0 76.2c0 39-7.1 66.6-21.2 91.9c-11.9 21.2-28.6 40.5-48.2 63c0 0 0 0 0 0s0 0 0 0c-2.8 3.2-5.7 6.5-8.6 9.9l-11.2 13C248.5 350.4 240 376.6 240 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-29.6 10.4-63.7 30.6-87l11.2-13c3-3.5 5.9-6.8 8.7-10c19.9-22.9 34.3-39.4 44.4-57.5c11-19.7 17.1-41.6 17.1-76.2L320 80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFireBurner = {
    prefix: 'fal',
    iconName: 'fire-burner',
    icon: [
      640,
      512,
      [],
      'e4f1',
      
      'M287.1 33.1c-21.7 19.8-45.3 44.8-63.7 72.3c-19 28.5-31.4 58.3-31.4 86.7c0 33.7 12.7 64.2 33.6 87c-1.1-5.4-1.6-10.9-1.6-16.6c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0c23.6 17.7 87.4 70.8 87.4 128.2c0 5.5-.5 10.9-1.6 16.2C435.3 256 448 225.7 448 192.2c0-22.6-8.5-48-22.2-72.6c-13-23.4-30.1-44.9-46.7-60.7l-21 23.7c-3 3.3-7.2 5.3-11.7 5.4s-8.8-1.7-11.9-5L287.1 33.1zM320 320c2.4 0 4.8-.1 7.1-.2c33.7-3.3 56.9-29.4 56.9-57.3c0-17.4-10.1-37.7-27.4-58.5c-12.1-14.5-25.8-27-36.6-35.8c-10.8 8.8-24.5 21.3-36.6 35.8c-17.3 20.7-27.4 41.1-27.4 58.5c0 27.9 23.3 54 57 57.3c2.3 .1 4.7 .2 7 .2zM160 192.2c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c11.1-10.1 28.2-10 39.3 .1c.3 .3 .6 .5 .8 .8l37.9 39.9L358 34.5c.4-.4 .7-.8 1.1-1.2c11.2-10.3 28.5-10.3 39.7 .1c19.7 18.3 39.8 43.2 55 70.6C469 131.2 480 162.2 480 192.2c0 85.6-66.4 154.9-150.8 159.6c-3 .3-6.1 .4-9.2 .4c-3.1 0-6.1-.1-9.1-.4c-85.2-4.6-150.9-74-150.9-159.6zM32 272c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 96 512 0 0-96-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 114.7c18.6 6.6 32 24.4 32 45.3l0 32c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-32c0-20.9 13.4-38.7 32-45.3L32 272zm0 160l0 32c0 8.8 7.2 16 16 16l544 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L48 416c-8.8 0-16 7.2-16 16zm160-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRoadSpikes = {
    prefix: 'fal',
    iconName: 'road-spikes',
    icon: [
      640,
      512,
      [],
      'e568',
      
      'M93.3 108L160 208l32 48 0-57.7 0-81.5c0-15.8 20.5-22 29.3-8.9L288 208l32 48 0-57.7 0-81.5c0-15.8 20.5-22 29.3-8.9L416 208l32 48 0-57.7 0-81.5c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7L512 352l-32 0-6.5 0L448 352l-64 0-32 0-6.5 0L320 352l-64 0-32 0-6.5 0L192 352l-96 0-32 0 0-32 0-203.2c0-15.8 20.5-22 29.3-8.9zM512 320l68.2 0L480 169.7l0 86.3 0 64 32 0zm-90.6-46.2L352 169.7l0 86.3 0 64 32 0 64 0 4.2 0-30.8-46.2zm-128 0L224 169.7l0 86.3 0 64 32 0 64 0 4.2 0-30.8-46.2zm-128 0L96 169.7 96 320l96 0 4.2 0-30.8-46.2zM16 416l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 448c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFaceSleeping = {
    prefix: 'fal',
    iconName: 'face-sleeping',
    icon: [
      512,
      512,
      [],
      'e38d',
      
      'M32 256C32 132.3 132.3 32 256 32c33.1 0 64.5 7.2 92.7 20c8 3.7 17.5 .1 21.2-7.9s.1-17.5-7.9-21.2C329.6 8.2 293.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9c-3.7-8-13.1-11.6-21.2-7.9s-11.6 13.1-7.9 21.2c12.8 28.2 20 59.6 20 92.7c0 123.7-100.3 224-224 224S32 379.7 32 256zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm8-256l25.4 0-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zM416 16c0 8.8 7.2 16 16 16l25.4 0L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0L432 0c-8.8 0-16 7.2-16 16zM387.2 238.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm-262.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0z'
      
    ]
  };

  

  
  

  var faMemory = {
    prefix: 'fal',
    iconName: 'memory',
    icon: [
      576,
      512,
      [],
      'f538',
      
      'M32 128c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32c-19.4 14.6-32 37.8-32 64s12.6 49.5 32 64l0 32L32 288l0-32c19.4-14.6 32-37.8 32-64s-12.6-49.5-32-64zM0 248.6L0 304 0 416c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-112 0-55.4c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-7.4c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128l0 7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6zM544 416l-64 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-56 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-56 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-56 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-56 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-64 0 0-96 512 0 0 96zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z'
      
    ]
  };

  

  
  

  var faCircleDollarToSlot = {
    prefix: 'fal',
    iconName: 'circle-dollar-to-slot',
    icon: [
      512,
      512,
      ["donate"],
      'f4b9',
      
      'M256 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352l-8 0c-30.9 0-56 25.1-56 56l0 48c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-48c0-30.9-25.1-56-56-56l-8 0c-8.6 11.5-18.3 22.2-28.8 32l36.8 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l36.8 0c-10.5-9.8-20.2-20.5-28.8-32zM272 104c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7c0 0 0 0 0 0s0 0 0 0l1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1c0 0 0 0 0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17.1c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6c0 0 0 0 0 0s0 0 0 0l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1l0-17.3z'
      
    ]
  };

  
    var faDonate = faCircleDollarToSlot;
  

  
  

  var faSpaceStationMoonConstruction = {
    prefix: 'fal',
    iconName: 'space-station-moon-construction',
    icon: [
      512,
      512,
      ["space-station-moon-alt"],
      'e034',
      
      'M32 256C32 132.3 132.3 32 256 32c61 0 116.3 24.4 156.7 64L368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8C414.1 40.2 339.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c91.2 0 171.3-47.7 216.6-119.5c3.1-4.9 3.3-11.2 .5-16.3s-8.2-8.3-14-8.3L416 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l11.6 0c-41.1 48.9-102.7 80-171.6 80c-95.1 0-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3c119.5 0 187-24.3 223.8-37.6c5-1.8 9.4-3.4 13.3-4.7c1.7-.6 3.2-1.4 4.6-2.4l1.7-1.3c3-2.3 5.1-5.5 5.9-9.1c4.4-18.7 6.7-38.3 6.7-58.3c0-5.7-.2-11.4-.6-17.1c-.6-8.4-7.5-14.9-16-14.9L432 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zm104-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-64 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0z'
      
    ]
  };

  
    var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
  

  
  

  var faPipeSection = {
    prefix: 'fal',
    iconName: 'pipe-section',
    icon: [
      640,
      512,
      [],
      'e438',
      
      'M32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32L0 368l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 576 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 0-224 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-352 0L32 128l0-16zM608 352L32 352l0-192 224 0 352 0 0 192z'
      
    ]
  };

  

  
  

  var faSitemap = {
    prefix: 'fal',
    iconName: 'sitemap',
    icon: [
      576,
      512,
      [],
      'f0e8',
      
      'M320 64c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0-32 0-16 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l64 0zM256 192l16 0 0 48-160 0c-26.5 0-48 21.5-48 48l0 32-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0 0-32c0-8.8 7.2-16 16-16l160 0 0 48-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0 0-48 160 0c8.8 0 16 7.2 16 16l0 32-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0 0-32c0-26.5-21.5-48-48-48l-160 0 0-48 16 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48zM48 352l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm208 0l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm208 0l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHeadphonesSimple = {
    prefix: 'fal',
    iconName: 'headphones-simple',
    icon: [
      512,
      512,
      ["headphones-alt"],
      'f58f',
      
      'M32 288C32 164.3 132.3 64 256 64s224 100.3 224 224l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112C512 146.6 397.4 32 256 32S0 146.6 0 288L0 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112zm128 0l0 160-16 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l16 0zm-16-32c-44.2 0-80 35.8-80 80l0 64c0 44.2 35.8 80 80 80l16 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-16 0zm208 32l16 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-16 0 0-160zm16-32l-16 0c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l16 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80z'
      
    ]
  };

  
    var faHeadphonesAlt = faHeadphonesSimple;
  

  
  

  var faCloudShowersHeavy = {
    prefix: 'fal',
    iconName: 'cloud-showers-heavy',
    icon: [
      512,
      512,
      [],
      'f740',
      
      'M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm120 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm112 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm120 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128z'
      
    ]
  };

  

  
  

  var faTemperatureList = {
    prefix: 'fal',
    iconName: 'temperature-list',
    icon: [
      512,
      512,
      [],
      'e299',
      
      'M80 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 156.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112S32 429.9 32 368c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9L80 96zM144 0C91 0 48 43 48 96l0 156.7c0 4.6-2.2 9.8-6.8 14.5C15.7 293.1 0 328.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5L240 96c0-53-43-96-96-96zM112 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62l0-162c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 162c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM320 48c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L336 32c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faUnlockKeyhole = {
    prefix: 'fal',
    iconName: 'unlock-keyhole',
    icon: [
      448,
      512,
      ["unlock-alt"],
      'f13e',
      
      'M224 32c-53 0-96 43-96 96l0 64 240 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 272c0-44.2 35.8-80 80-80l16 0 0-64C96 57.3 153.3 0 224 0c58 0 107 38.6 122.7 91.4c2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8C304.2 60.9 267.5 32 224 32zM80 224c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L80 224zM264 368l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z'
      
    ]
  };

  
    var faUnlockAlt = faUnlockKeyhole;
  

  
  

  var faSidebarFlip = {
    prefix: 'fal',
    iconName: 'sidebar-flip',
    icon: [
      512,
      512,
      [],
      'e24f',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l224 0 0-384L64 64zm384 0L320 64l0 384 128 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32zm0-32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0zM432 96c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm16 80c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16zm-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0z'
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fal',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM132.7 235.3l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4 155.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faFaceFrownSlight = {
    prefix: 'fal',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM347.9 394.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fal',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 176 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L356.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faSchoolCircleXmark = {
    prefix: 'fal',
    iconName: 'school-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e56d',
      
      'M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96 576 96c35.3 0 64 28.7 64 64l0 106.8c-9.1-12.9-19.9-24.5-32-34.6l0-72.2c0-17.7-14.3-32-32-32l-112 0c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7L64 128c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l192 0 0-96c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32l0 96 32 0 32 0 8.2 0c10 12.1 21.7 22.9 34.6 32L384 512l-32 0-64 0-32 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l107.2 0 140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 32 0 0-64-32 0zM96 352c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64zm64 0l-32 0 0 64 32 0 0-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z'
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fal',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBlock = {
    prefix: 'fal',
    iconName: 'block',
    icon: [
      448,
      512,
      [],
      'e46a',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTrashCanList = {
    prefix: 'fal',
    iconName: 'trash-can-list',
    icon: [
      640,
      512,
      [],
      'e2ab',
      
      'M169.7 32l76.5 0c5.5 0 10.6 2.8 13.6 7.5L275.1 64 140.9 64l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM312.9 64L287 22.6C278.2 8.5 262.8 0 246.3 0L169.7 0C153.2 0 137.8 8.5 129 22.6L103.1 64 64 64 32 64 16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l16 0 0 336c0 44.2 35.8 80 80 80l192 0c44.2 0 80-35.8 80-80l0-336 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32 0-39.1 0zM352 96l0 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48L64 96l288 0zM160 160c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm208-32c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM448 400c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faCommentMiddle = {
    prefix: 'fal',
    iconName: 'comment-middle',
    icon: [
      512,
      512,
      [],
      'e149',
      
      'M216.9 394.3L256 472.4l39.1-78.1c4.3-8.6 12.3-14.8 21.7-16.9C415.4 355.5 480 284.4 480 208c0-91.3-93.8-176-224-176S32 116.7 32 208c0 76.4 64.6 147.5 163.3 169.4c9.4 2.1 17.4 8.3 21.7 16.9zm44.5 89s0 0 0 0l-5.5 2.7 5.5-2.7s0 0 0 0zm62.2-74.7l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z'
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fal',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      'M34.2 261.6c-1.3-1.4-2.2-3.5-2.2-5.6s.8-4.2 2.2-5.6L147.7 130.2c1.3-1.4 3.2-2.2 5.2-2.2c3.9 0 7.1 3.2 7.1 7.1l0 241.7c0 3.9-3.2 7.1-7.1 7.1c-2 0-3.8-.8-5.2-2.2L34.2 261.6zm-23.3 22L124.4 403.7c7.4 7.8 17.7 12.3 28.4 12.3c21.6 0 39.1-17.5 39.1-39.1l0-241.7c0-21.6-17.5-39.1-39.1-39.1c-10.8 0-21.1 4.4-28.4 12.3L10.9 228.4C3.9 235.9 0 245.8 0 256s3.9 20.1 10.9 27.6z'
      
    ]
  };

  

  
  

  var faLightbulb = {
    prefix: 'fal',
    iconName: 'lightbulb',
    icon: [
      384,
      512,
      [128161],
      'f0eb',
      
      'M310.3 258.1C326.5 234.8 336 206.6 336 176c0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19c0 0 0 0 0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-32.4 0c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM192 96c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16zM146.7 448c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32l-90.5 0zM112 432l0-5.3c0-5.9 4.8-10.7 10.7-10.7l138.7 0c5.9 0 10.7 4.8 10.7 10.7l0 5.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faPeopleRobbery = {
    prefix: 'fal',
    iconName: 'people-robbery',
    icon: [
      576,
      512,
      [],
      'e536',
      
      'M400 144c54.3 0 101.9-36.2 116.4-88.5l12.2-43.8c2.4-8.5 11.2-13.5 19.7-11.1s13.5 11.2 11.1 19.7L547.3 64.1c-12.3 44.3-43.4 79.5-83.2 97.9l0 334c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-334c-39.8-18.4-70.9-53.6-83.3-97.9L240.6 20.3c-2.4-8.5 2.6-17.3 11.1-19.7s17.3 2.6 19.7 11.1l12.2 43.8C298.1 107.8 345.7 144 400 144zm32 28.6c-10.4 2.2-21.1 3.4-32 3.4s-21.6-1.2-32-3.4L368 320l64 0 0-147.4zM85.3 144c21.8 0 42.4 10.3 55.5 27.7L192 240l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0c-5 0-9.8-2.4-12.8-6.4l-56-74.7c-7.1-9.4-18.1-14.9-29.9-14.9C64.7 176 48 192.7 48 213.3L48 320l64 0 0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 216c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-282.7C16 175 47 144 85.3 144zM80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM424 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 344 56z'
      
    ]
  };

  

  
  

  var faSquareTerminal = {
    prefix: 'fal',
    iconName: 'square-terminal',
    icon: [
      448,
      512,
      [],
      'e32a',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM83.9 149.6c-5.8 6.7-5 16.8 1.7 22.6L183.4 256 85.6 339.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faCassetteTape = {
    prefix: 'fal',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-33.9 0-23.4-64.4c-6.9-19-24.9-31.6-45.1-31.6l-243.2 0c-20.2 0-38.2 12.6-45.1 31.6L97.9 448 64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM444.1 448l-312.1 0 19.4-53.5c2.3-6.3 8.3-10.5 15-10.5l243.2 0c6.7 0 12.7 4.2 15 10.5L444.1 448zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32s-3.1-22.6-8.6-32l145.1 0c-5.4 9.4-8.6 20.3-8.6 32s3.1 22.6 8.6 32l-145.1 0zM160 288l256 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-256 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faShieldCross = {
    prefix: 'fal',
    iconName: 'shield-cross',
    icon: [
      512,
      512,
      [9960],
      'f712',
      
      'M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0 0-64z'
      
    ]
  };

  

  
  

  var fa8 = {
    prefix: 'fal',
    iconName: '8',
    icon: [
      320,
      512,
      [],
      '38',
      
      'M304 152c0-66.3-53.7-120-120-120l-48 0C69.7 32 16 85.7 16 152c0 41.4 20.9 77.9 52.8 99.4C28.1 270.6 0 312 0 360c0 66.3 53.7 120 120 120l80 0c66.3 0 120-53.7 120-120c0-48-28.1-89.4-68.8-108.6C283.1 229.9 304 193.4 304 152zM184.1 272l15.9 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-80 0c-48.6 0-88-39.4-88-88s39.4-88 88-88l15.9 0c0 0 .1 0 .1 0l48 0c0 0 0 0 .1 0zm0-32c0 0 0 0-.1 0l-48 0c0 0 0 0-.1 0C87.4 240 48 200.6 48 152c0-48.6 39.4-88 88-88l48 0c48.6 0 88 39.4 88 88c0 48.6-39.4 88-87.9 88z'
      
    ]
  };

  

  
  

  var faRulerHorizontal = {
    prefix: 'fal',
    iconName: 'ruler-horizontal',
    icon: [
      640,
      512,
      [],
      'f547',
      
      'M32 320c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-48 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-48 0c-17.7 0-32 14.3-32 32l0 128zm32 64c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l512 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 384z'
      
    ]
  };

  

  
  

  var faCoconut = {
    prefix: 'fal',
    iconName: 'coconut',
    icon: [
      512,
      512,
      [],
      'e2f6',
      
      'M272.5 40c45.4-14 79.7-8.9 98.6 9.9s23.9 53.2 9.9 98.6C367.2 193 336 244 290 290s-97 77.2-141.6 91c-45.4 14-79.7 8.9-98.6-9.9S26 317.9 40 272.5c13.8-44.6 45-95.6 91-141.6s97-77.2 141.6-91zM393.7 27.3C362.4-4.1 312.8-5.9 263.1 9.4c-50.5 15.6-105.8 50-154.8 98.9S25 212.6 9.4 263.1C-5.9 312.8-4.1 362.4 27.2 393.7l42.4 42.4C118.2 484.7 184.1 512 252.9 512C396 512 512 396 512 252.9c0-68.7-27.3-134.6-75.9-183.2L393.7 27.3zM421 100.1c37.9 41.7 59 96.1 59 152.8c0 4.1-.1 8.2-.3 12.2l-20.4-20.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l37.4 37.4c-8.5 36.5-25.9 69.7-49.7 97.1l-45.1-45.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l45.1 45.1c-27.4 23.8-60.5 41.1-97.1 49.7l-37.4-37.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265 479.7c-4 .2-8.1 .3-12.2 .3c-56.6 0-111-21.1-152.8-59c18.5 .1 38.1-3.3 57.8-9.4c50.5-15.6 105.8-50 154.8-98.9s83.4-104.3 98.9-154.8c6.1-19.7 9.4-39.3 9.4-57.8zm-102.7 3.2c3.5 3.5 9.6 17-1.7 48.8c-10.4 29.4-32.9 64.9-66.2 98.2s-68.9 55.9-98.2 66.2c-31.8 11.2-45.4 5.1-48.8 1.7s-9.6-17 1.7-48.8c10.4-29.4 32.9-64.9 66.2-98.2s68.9-55.9 98.2-66.2c31.8-11.2 45.4-5.1 48.8-1.7zm22.6-22.6c-34.4-34.4-120.5-4-192.3 67.9s-102.2 158-67.9 192.3s120.5 4 192.3-67.9s102.2-158 67.9-192.3z'
      
    ]
  };

  

  
  

  var faFilm = {
    prefix: 'fal',
    iconName: 'film',
    icon: [
      512,
      512,
      [127902],
      'f008',
      
      'M128 448l0-96 0-80 256 0 0 80 0 96-256 0zM384 240l-256 0 0-80 0-96 256 0 0 96 0 80zM96 448l-32 0c-17.7 0-32-14.3-32-32l0-48 64 0 0 80zM32 272l64 0 0 64-64 0 0-64zm64-96l0 64-64 0 0-64 64 0zM96 64l0 80-64 0 0-48c0-17.7 14.3-32 32-32l32 0zM416 336l0-64 64 0 0 64-64 0zm0 112l0-80 64 0 0 48c0 17.7-14.3 32-32 32l-32 0zm0-272l64 0 0 64-64 0 0-64zm64-80l0 48-64 0 0-80 32 0c17.7 0 32 14.3 32 32zM448 32L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64z'
      
    ]
  };

  

  
  

  var faSickle = {
    prefix: 'fal',
    iconName: 'sickle',
    icon: [
      512,
      512,
      [],
      'f822',
      
      'M320 0C214 0 128 86 128 192c0 71 38.5 132.9 95.7 166.1c6.3 3.6 14.2 2.6 19.4-2.5l36-36c5.3-5.3 6.2-13.5 2.2-19.9C270.3 282.5 264 262 264 240c0-61.9 50.1-112 112-112c48.1 0 89.1 30.3 105 72.9c2.7 7.2 10.1 11.5 17.7 10.2s13.2-7.8 13.3-15.5c0-1.2 0-2.4 0-3.6C512 86 426 0 320 0zM160 192c0-88.4 71.6-160 160-160c65.7 0 122.1 39.6 146.8 96.2C442 108.1 410.4 96 376 96c-79.5 0-144 64.5-144 144c0 23.6 5.7 45.9 15.8 65.6l-18.3 18.3C187.5 295.1 160 246.7 160 192zM115.3 300.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7L13.2 412.2C4.7 420.6 0 432.1 0 444s4.7 23.4 13.2 31.8l23 23C44.6 507.3 56.1 512 68 512s23.4-4.7 31.8-13.2L184 414.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-64-64-16-16zM35.8 434.8L120 350.6 161.4 392 77.2 476.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8l-23-23c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2z'
      
    ]
  };

  

  
  

  var faRadar = {
    prefix: 'fal',
    iconName: 'radar',
    icon: [
      512,
      512,
      [],
      'e024',
      
      'M32 256C32 132.3 132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7l-34.1 34.1C338.1 95.3 298.8 80 256 80c-72.2 0-134.2 43.5-161.3 105.6c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3c22.2-50.9 73-86.4 132-86.4c34 0 65.2 11.8 89.9 31.5l-34.3 34.3C295.9 166.6 276.7 160 256 160c-53 0-96 43-96 96s43 96 96 96s96-43 96-96c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c11.9 0 23 3.2 32.5 8.9l-43.8 43.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l224-224c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224S32 379.7 32 256zm384-16c-8.8 0-16 7.2-16 16c0 59-35.5 109.8-86.4 132c-8.1 3.5-11.8 13-8.3 21.1s13 11.8 21.1 8.3C388.5 390.2 432 328.2 432 256c0-8.8-7.2-16-16-16zM102.9 305.3c-8.1 3.5-11.8 13-8.3 21.1c17.7 40.6 50.3 73.2 90.9 90.9c8.1 3.5 17.5-.2 21.1-8.3s-.2-17.5-8.3-21.1c-33.2-14.5-59.9-41.2-74.4-74.4c-3.5-8.1-13-11.8-21.1-8.3zM120 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPhotoFilmMusic = {
    prefix: 'fal',
    iconName: 'photo-film-music',
    icon: [
      640,
      512,
      [],
      'e228',
      
      'M544 32L224 32c-17.7 0-32 14.3-32 32l0 169.4L265.4 160c12.5-12.5 32.8-12.5 45.3 0L352 201.4 457.4 96c12.5-12.5 32.8-12.5 45.3 0l53.8 53.8-33.9 11.3L480 118.6 363.3 235.3 278.6 320 384 320l0 32-144 0c0 0 0 0 0 0l-16 0c-35.3 0-64-28.7-64-64l0-16s0 0 0 0l0-208c0-35.3 28.7-64 64-64L544 0c35.3 0 64 28.7 64 64l0 72c-6.7 0-13.5 1.1-20.2 3.3L576 143.2 576 64c0-17.7-14.3-32-32-32zM233.4 320l96-96L288 182.6l-96 96 0 9.4c0 17.7 14.3 32 32 32l9.4 0zM232 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 96l16 0 0 32 0 80 0 128 0 48 0 32 180.6 0c-8.3 8.8-15 19.6-18.3 32L128 448l-16 0-16 0-32 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l32 0 16 0zM32 192l64 0 0-64-32 0c-17.7 0-32 14.3-32 32l0 32zm0 160l0 32c0 17.7 14.3 32 32 32l32 0 0-64-64 0zm64-32l0-96-64 0 0 96 64 0zM640 198.2l0 49.8 0 144c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4l0-88.2L448 323.5 448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4L416 312l0-60.5c0-13.8 8.8-26 21.9-30.4l160-53.3c20.7-6.9 42.1 8.5 42.1 30.4zm-32 38.3l0-38.3L448 251.5l0 38.3 160-53.3zm-5.9 171.9c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7zm-192 64c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7z'
      
    ]
  };

  

  
  

  var faRollerCoaster = {
    prefix: 'fal',
    iconName: 'roller-coaster',
    icon: [
      640,
      512,
      [],
      'e324',
      
      'M144 64c-5.4 0-10.8 .4-16 1.1L128 464c0 8.8-7.2 16-16 16s-16-7.2-16-16L96 74.8C58.2 92.8 32 131.3 32 176l0 288c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 176C0 96.5 64.5 32 144 32l6.6 0c46.2 0 89.7 22.2 116.7 59.7L392.7 265.4c24.8 34.3 64.5 54.6 106.8 54.6l12.4 0c53 0 96-43 96-96l0-5c0-40.9-26.9-75.4-64-86.9L544 272c-6.7 5-15 8-24 8l-8 0 0-151.9c-22.5 .8-44.4 6.8-64 17.5l0 117.7c-9.2-6.3-17.3-14.2-23.9-23.4L416 228.5l0-59.5-21.4 19L373.4 164l26.4-23.5C432.1 111.9 473.8 96 517 96c67.9 0 123 55.1 123 123l0 5 0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-155.3c-23.5 26.6-57.8 43.3-96 43.3l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-113.2c-22.8-2.7-44.6-10.2-64-21.7L416 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-159.7c-6.2-6.2-12-12.9-17.2-20.2L320 219.3 320 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-289-46.7-64.6c-5.1-7-10.9-13.4-17.3-19L224 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-392c-13-5.2-27.1-8-41.4-8L144 64z'
      
    ]
  };

  

  
  

  var faCorn = {
    prefix: 'fal',
    iconName: 'corn',
    icon: [
      512,
      512,
      [127805],
      'f6c7',
      
      'M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-21.9 0-41.2 11-52.7 27.7c7.7 10.3 14.7 21 21 32c0-.2 .1-.4 .1-.6C242.7 99.8 256 88 272 88c3.1 0 6.1 .4 8.9 1.3c7.3 2.1 15.1-1.2 18.6-8C304.9 71 315.7 64 328 64c3.1 0 6.1 .4 8.9 1.3c7.3 2.1 15.1-1.2 18.6-8C360.9 47 371.7 40 384 40c6.9 0 13.2 2.1 18.4 5.8c6.7 4.7 16 3.6 21.3-2.7C429.6 36.3 438.3 32 448 32c17.7 0 32 14.3 32 32c0 9.7-4.3 18.4-11.2 24.3c-6.2 5.4-7.4 14.6-2.6 21.3c3.7 5.2 5.8 11.5 5.8 18.4c0 12.3-7 23.1-17.3 28.4c-6.8 3.5-10.1 11.3-8 18.6c.8 2.8 1.3 5.8 1.3 8.9c0 12.3-7 23.1-17.3 28.4c-6.8 3.5-10.1 11.3-8 18.6c.8 2.8 1.3 5.8 1.3 8.9c0 10.9-5.4 20.5-13.7 26.3c8.7 6.3 17.1 13.4 24.9 21C448 275.6 456 258.7 456 240c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.3 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.3 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM163.3 68.7c-3.9-3.9-9.6-5.5-15-4.3s-9.7 5.3-11.5 10.5l-22 65.9c-.7 2-1.7 3.9-3.1 5.5l-76.1 87C12.7 259.5 0 293.2 0 328.1L0 342c0 36.2 13.6 71.1 38.2 97.7l24 26C89.5 495.2 127.9 512 168 512l10.9 0c38.2 0 74.8-15.2 101.8-42.2l69.5-69.5c1.7-1.7 3.6-2.9 5.8-3.7L437.5 367c5.1-1.9 9-6.2 10.2-11.6s-.4-10.9-4.3-14.8l-29.1-29.1C378.6 276 330.3 256 280 256c-10.8 0-21.6 .9-32.1 2.7c-1.9-69.5-30.3-135.7-79.6-185l-5-5zM216 266l0 1.1c-26.2 9.4-50.2 24.5-70.2 44.5l-94 94C39 387 32 364.8 32 342l0-13.9c0-27.1 9.8-53.3 27.7-73.8l76.1-87c4.2-4.8 7.4-10.4 9.4-16.4l13.5-40.5C195.6 153.7 216 208.8 216 266zM85.7 444l-13-14.1 95.7-95.7C198 304.6 238.1 288 280 288s82 16.6 111.6 46.2l11.3 11.3-57.7 21c-6.6 2.4-12.6 6.2-17.5 11.2l-69.5 69.5c-21 21-49.5 32.8-79.2 32.8L168 480c-31.3 0-61.1-13.1-82.3-36z'
      
    ]
  };

  

  
  

  var faFaceKissBeam = {
    prefix: 'fal',
    iconName: 'face-kiss-beam',
    icon: [
      512,
      512,
      [128537,"kiss-beam"],
      'f597',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm276.7 48.5c-10.8-5.3-25.3-9.2-38.6-11c-7.4-1-12.6-7.9-11.6-15.4s7.9-12.6 15.4-11.6c15.2 2.1 32.7 6.6 46.8 13.6c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4l-.2 .1 .2 .1c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4c-14.1 6.9-31.6 11.4-46.8 13.6c-7.4 1-14.3-4.1-15.4-11.6s4.1-14.3 11.6-15.4c13.3-1.9 27.8-5.8 38.6-11c5.4-2.7 9.2-5.3 11.5-7.7c2.7-2.9 2.7-4.7 0-7.6c-2.3-2.4-6.1-5.1-11.5-7.7c-10.7-5.3-25.1-9.1-38.3-11c-6.7-.8-12-6.7-12-13.5c0-6.8 5.3-12.7 12-13.5c13.2-1.9 27.6-5.8 38.3-11c5.4-2.7 9.2-5.3 11.5-7.7c2.7-2.9 2.7-4.7 0-7.6c-2.3-2.4-6.1-5.1-11.5-7.7zm-120.2-110c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faKissBeam = faFaceKissBeam;
  

  
  

  var faSquareUpRight = {
    prefix: 'fal',
    iconName: 'square-up-right',
    icon: [
      448,
      512,
      [8599,"external-link-square-alt"],
      'f360',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zm64 32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM304 184l0 113.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-25.4-25.4c-6.2-6.2-16.4-6.2-22.6 0l-59.1 59.1c-3.6 3.6-9 4.9-13.9 3.3c-2-.7-3.8-1.8-5.3-3.3l-22.1-22.1c-1.5-1.5-2.6-3.3-3.3-5.3c-1.6-4.9-.4-10.3 3.3-13.9l59.1-59.1c6.2-6.2 6.2-16.4 0-22.6l-25.4-25.4c-1.2-1.2-1.9-2.9-1.9-4.7c0-3.7 3-6.6 6.6-6.6L296 176c4.4 0 8 3.6 8 8zm-8-40l-113.4 0c-21.3 0-38.6 17.3-38.6 38.6c0 10.2 4.1 20.1 11.3 27.3L169.4 224l-47.7 47.7c-12.2 12.2-16.5 30.3-11 46.7c2.2 6.7 6 12.8 11 17.8l22.1 22.1c5 5 11.1 8.8 17.8 11c16.4 5.5 34.5 1.2 46.7-11L256 310.6l14.1 14.1c7.2 7.2 17.1 11.3 27.3 11.3c21.3 0 38.6-17.3 38.6-38.6L336 184c0-22.1-17.9-40-40-40z'
      
    ]
  };

  
    var faExternalLinkSquareAlt = faSquareUpRight;
  

  
  

  var faDropletPercent = {
    prefix: 'fal',
    iconName: 'droplet-percent',
    icon: [
      384,
      512,
      ["humidity"],
      'f750',
      
      'M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7l1.3 0c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM160 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faHumidity = faDropletPercent;
  

  
  

  var faFaceBeamHandOverMouth = {
    prefix: 'fal',
    iconName: 'face-beam-hand-over-mouth',
    icon: [
      512,
      512,
      [129325],
      'e47c',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm111.5-76.1c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 121.9 194.8 112 176 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 121.9 354.8 112 336 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zM265.3 301.3L248 318.6s0 0 0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c0 0 0 0 0 0l-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34s0 0 0 0s0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5c0 0 0 0 0 0l-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3l0 11.7 0 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4s0 0 0 0l51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6c0 0 0 0 0 0l-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 53.6 0 32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0z'
      
    ]
  };

  

  
  

  var faHeartCrack = {
    prefix: 'fal',
    iconName: 'heart-crack',
    icon: [
      512,
      512,
      [128148,"heart-broken"],
      'f7a9',
      
      'M272 126.1l7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3l0 3.5c0 32.3-13.4 63.1-37 85.1L259 446.8c-.8 .7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L69.1 275.5C45.4 253.5 32 222.7 32 190.4l0-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9 0 17.9c0 4.2 1.7 8.3 4.7 11.3l34.2 34.2-79.8 53.2c-3.7 2.5-6.2 6.4-6.9 10.9s.5 8.9 3.3 12.4l64 80c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-53.1-66.4 81.5-54.3c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9L272 137.4l0-11.3zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9l0 3.5c0 36 13.1 70.6 36.6 97.5c3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L464.8 299c3.8-3.5 7.3-7.2 10.7-11C498.9 261 512 226.4 512 190.4l0-3.5c0-69.6-49.8-129.3-118.3-141.8z'
      
    ]
  };

  
    var faHeartBroken = faHeartCrack;
  

  
  

  var faHourglassEnd = {
    prefix: 'fal',
    iconName: 'hourglass-end',
    icon: [
      384,
      512,
      [8987,"hourglass-3"],
      'f253',
      
      'M0 16C0 7.2 7.2 0 16 0L48 0 336 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 41.6c0 49.4-22.8 96-61.8 126.3L218.1 256l72.2 56.1c39 30.3 61.8 76.9 61.8 126.3l0 41.6 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0L48 512l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-41.6c0-49.4 22.8-96 61.8-126.3L165.9 256 93.8 199.9C54.8 169.6 32 122.9 32 73.6L32 32 16 32C7.2 32 0 24.8 0 16zM64 32l0 41.6c0 39.5 18.2 76.8 49.4 101L192 235.7l78.6-61.1c31.2-24.3 49.4-61.5 49.4-101L320 32 64 32zm49.4 305.4c-5.7 4.5-11 9.3-15.8 14.6l188.8 0c-4.8-5.3-10.1-10.2-15.8-14.6L192 276.3l-78.6 61.1zM76.1 384C68.2 400.8 64 419.4 64 438.4L64 480l256 0 0-41.6c0-19.1-4.2-37.6-12.1-54.4L76.1 384z'
      
    ]
  };

  
    var faHourglass3 = faHourglassEnd;
  

  
  

  var faPeopleGroup = {
    prefix: 'fal',
    iconName: 'people-group',
    icon: [
      640,
      512,
      [],
      'e533',
      
      'M128 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM0 280c0 43.3 26.4 80.4 64 96l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-64 0 0-207.6c2.6-.3 5.3-.4 8-.4l48 0c9.3 0 18.1 1.7 26.2 4.9c8.2 3.2 17.5-.9 20.7-9.1s-.9-17.5-9.1-20.7c-11.7-4.6-24.5-7.1-37.8-7.1l-48 0C46.6 176 0 222.6 0 280zm64 59.9C44.7 327 32 304.9 32 280c0-25 12.7-47 32-59.9l0 119.8zM512 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM640 280c0-57.4-46.6-104-104-104l-48 0c-13.3 0-26.1 2.5-37.8 7.1c-8.2 3.2-12.3 12.5-9.1 20.7s12.5 12.3 20.7 9.1c8.1-3.2 16.9-4.9 26.2-4.9l48 0c2.7 0 5.4 .1 8 .4L544 416l-64 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 40c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c37.6-15.7 64-52.7 64-96zm-64 59.9l0-119.8C595.3 233 608 255 608 280c0 24.9-12.7 47-32 59.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zm-80 96c-57.4 0-104 46.6-104 104c0 40.1 22.7 74.9 56 92.3l0 67.7c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-67.7c33.3-17.3 56-52.1 56-92.3c0-57.4-46.6-104-104-104l-32 0zm-48 50.3l0 107.3c-14.7-13.2-24-32.4-24-53.7c0-21.3 9.3-40.5 24-53.7zM288 448l0-222.2c5.1-1.2 10.5-1.8 16-1.8l32 0c5.5 0 10.9 .6 16 1.8L352 448l-64 0zm96-98.3l0-107.3c14.7 13.2 24 32.3 24 53.7c0 21.3-9.3 40.5-24 53.7z'
      
    ]
  };

  

  
  

  var faKeyboardLeft = {
    prefix: 'fal',
    iconName: 'keyboard-left',
    icon: [
      640,
      512,
      [],
      'e1c3',
      
      'M576 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-352 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l352 0zM224 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L224 64zm8 88l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM232 344l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM344 136c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM328 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM440 136c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM424 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM536 136c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM520 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM320 352c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zM107.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256l68.7-68.7z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fal',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 256c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faPrescriptionBottle = {
    prefix: 'fal',
    iconName: 'prescription-bottle',
    icon: [
      384,
      512,
      [],
      'f485',
      
      'M336 32c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L48 96c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l288 0zM48 0C21.5 0 0 21.5 0 48L0 80c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-32 0 0 288c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-32 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-32-32 0z'
      
    ]
  };

  

  
  

  var faSwatchbook = {
    prefix: 'fal',
    iconName: 'swatchbook',
    icon: [
      512,
      512,
      [],
      'f5c3',
      
      'M0 416c0 53 43 96 96 96l360 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-124.3 0L419 232.7c21.9-21.9 21.9-57.3 0-79.2L362.4 97c-21.9-21.9-57.3-21.9-79.2 0L192 188.2 192 56c0-30.9-25.1-56-56-56L56 0C25.1 0 0 25.1 0 56L0 416zm456 64l-284.3 0 128-128L456 352c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24zM396.4 210.1L192 414.5l0-181L305.9 119.6c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9zM96 480c-35.3 0-64-28.7-64-64l0-128 128 0 0 128c0 35.3-28.7 64-64 64zM32 256l0-96 128 0 0 96L32 256zm0-128l0-72c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 72L32 128zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRectangleVerticalHistory = {
    prefix: 'fal',
    iconName: 'rectangle-vertical-history',
    icon: [
      576,
      512,
      [],
      'e237',
      
      'M256 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L256 32zM192 64c0-35.3 28.7-64 64-64L512 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-384zM96 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 384c0 8.8-7.2 16-16 16s-16-7.2-16-16L96 64zM0 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 288c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 112z'
      
    ]
  };

  

  
  

  var faGrillFire = {
    prefix: 'fal',
    iconName: 'grill-fire',
    icon: [
      576,
      512,
      [],
      'e5a4',
      
      'M408 64L40 64c-4.4 0-8 3.6-8 8l0 24c0 106 86 192 192 192c4.7 0 9.4-.2 14-.5c-4.4 10.8-8 21.7-10.5 32.5c-1.2 0-2.4 0-3.6 0c-19.9 0-39.2-2.6-57.6-7.5l-26.1 57.3c4.3 4.2 8.1 8.9 11.1 14.1l75.5 0c1.9 11 4.8 21.7 8.5 32L160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c5.7 0 11.1 .7 16.4 2.1l23.7-52C56 267.9 0 188.5 0 96L0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 24c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c0 0 0 0 0 0c3.3-14.1 5.1-28.8 5.1-44l0-24c0-4.4-3.6-8-8-8zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM442.3 240.3c-9 .2-17.6-3.4-23.7-9.9l-19-19.9c-2.5-2.6-5.2-5.7-7.3-8.1c0 0 0 0 0 0l-1.7-1.9c-2.6-3-4.6-5-6.3-6.6c-.4-.3-.7-.6-1-.8c-21.7 19.8-45.5 44.9-63.9 72.5c-19 28.5-31.4 58.3-31.4 86.7c0 33.7 12.7 64.2 33.6 87c-1.1-5.4-1.6-10.9-1.6-16.6c0-57.4 63.8-110.5 87.4-128.2c5.2-3.9 12.1-3.9 17.3 0c23.6 17.7 87.4 70.8 87.4 128.2c0 5.5-.5 10.9-1.6 16.2C531.3 416 544 385.7 544 352.2c0-22.6-8.5-48-22.2-72.6c-13-23.4-30.1-44.9-46.7-60.7l-9.5 10.7c-5.9 6.7-14.4 10.6-23.4 10.8zM416 480c2.4 0 4.8-.1 7.1-.2c33.7-3.3 56.9-29.4 56.9-57.3c0-17.4-10.1-37.7-27.4-58.5c-12.1-14.5-25.8-27-36.6-35.8c-10.7 8.8-24.5 21.3-36.6 35.8c-17.3 20.7-27.4 41.1-27.4 58.5c0 27.9 23.3 54 57 57.3c2.3 .1 4.7 .2 7 .2zM256 352.2c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c1 1.1 1.9 2.2 2.9 3.3c1 1.2 2.1 2.3 3.1 3.4l19 19.9L454 194.5c2.5-2.9 5.7-5 9-6.5c3.8-1.6 7.9-2.4 11.9-2.4c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C565 291.2 576 322.2 576 352.2c0 85.6-66.4 154.9-150.8 159.6c-3 .3-6.1 .4-9.2 .4c-3.1 0-6.1-.1-9.1-.4c-85.2-4.6-150.9-74-150.9-159.6zM381.6 191.7s0 0 .1 0c-.1 0-.1 0-.1 0z'
      
    ]
  };

  

  
  

  var faJoystick = {
    prefix: 'fal',
    iconName: 'joystick',
    icon: [
      448,
      512,
      [128377],
      'f8c5',
      
      'M304 112a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm32 0c0 56.4-41.7 103.1-96 110.9l0 97.1-32 0 0-97.1c-54.3-7.8-96-54.4-96-110.9C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM416 416c0-17.7-14.3-32-32-32L64 384c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-32zM64 352l320 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM208 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faLaptopCode = {
    prefix: 'fal',
    iconName: 'laptop-code',
    icon: [
      640,
      512,
      [],
      'f5fc',
      
      'M128 64l384 0c17.7 0 32 14.3 32 32l0 256 32 0 0-256c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 256 32 0L96 96c0-17.7 14.3-32 32-32zM33.9 416l572.3 0c-5.5 18.5-22.6 32-42.9 32L76.8 448c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384zM283.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 224l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 224l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z'
      
    ]
  };

  

  
  

  var faTruckUtensils = {
    prefix: 'fal',
    iconName: 'truck-utensils',
    icon: [
      640,
      512,
      [],
      'e628',
      
      'M64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l5.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64L384 384l0-320c0-17.7-14.3-32-32-32L64 32zm0 384c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 65.3 0c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2L608 384l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96zM570.9 224l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6L416 128l0 96 154.9 0zM416 256l0 88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64l5.5 0 0-128-160 0zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 224l0-96 0-30.7c-18.4 4.7-32 21.4-32 41.3l0 85.3 32 0zm0 80l0-48-32 0c-17.7 0-32-14.3-32-32l0-85.3C224 97.4 257.4 64 298.7 64c11.8 0 21.3 9.6 21.3 21.3l0 42.7 0 96 0 32 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16zM160 206.1l0 65.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-65.9c-31.6-7.6-54.4-37.2-52-71.1l4-56.1C80.7 70 88.3 63.4 97.1 64s15.4 8.3 14.8 17.1l-4 56.1C106.5 158.2 123 176 144 176s37.5-17.8 36.1-38.7l-4-56.1c-.6-8.8 6-16.5 14.8-17.1s16.5 6 17.1 14.8l4 56.1c2.4 33.9-20.4 63.5-52 71.1zM160 80l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faFileCircleQuestion = {
    prefix: 'fal',
    iconName: 'file-circle-question',
    icon: [
      576,
      512,
      [],
      'e4ef',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6l40.5 0c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16l0-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9l-40.5 0c-5.3 0-9.6 4.3-9.6 9.6l0 6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.4z'
      
    ]
  };

  

  
  

  var faHeartHalfStroke = {
    prefix: 'fal',
    iconName: 'heart-half-stroke',
    icon: [
      512,
      512,
      ["heart-half-alt"],
      'e1ac',
      
      'M272 126.1l7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3l0 3.5c0 32.3-13.4 63.1-37 85.1L272 434.7l0-308.6zM256.3 448c-.1 0-.2 0-.3 0s-.2 0-.3 0l.5 0zM240 434.7L69.1 275.5C45.4 253.5 32 222.7 32 190.4l0-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9 0 308.6zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9l0 3.5c0 36 13.1 70.6 36.6 97.5c3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L464.8 299c3.8-3.5 7.3-7.2 10.7-11C498.9 261 512 226.4 512 190.4l0-3.5c0-69.6-49.8-129.3-118.3-141.8z'
      
    ]
  };

  
    var faHeartHalfAlt = faHeartHalfStroke;
  

  
  

  var faSquareCaretDown = {
    prefix: 'fal',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      'M64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm224-64c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7c0-15.2-12.3-27.5-27.5-27.5l-201 0C108.3 192 96 204.3 96 219.5c0 6.9 2.6 13.6 7.3 18.7L198.8 341c6.5 7 15.6 11 25.2 11zm-1.7-32.7L133.8 224l180.3 0-88.4 95.3c-.4 .5-1.1 .7-1.7 .7s-1.3-.3-1.7-.7z'
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faCompass = {
    prefix: 'fal',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm92.6-389.1L202.1 171.8c-14.3 4.8-25.6 16-30.4 30.4L122.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l146.5-48.8c14.3-4.8 25.6-16 30.4-30.4l48.8-146.5c8.3-25-15.5-48.8-40.5-40.5zm10.1 30.4L309.9 299.8c-1.6 4.8-5.3 8.5-10.1 10.1L153.3 358.7l48.8-146.5c1.6-4.8 5.3-8.5 10.1-10.1l146.5-48.8zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBird = {
    prefix: 'fal',
    iconName: 'bird',
    icon: [
      512,
      512,
      [],
      'e469',
      
      'M32 192l160 0c35.3 0 64-28.7 64-64l0-24c0-39.8 32.2-72 72-72s72 32.2 72 72l0 96c0 101.6-82.4 184-184 184S32 301.6 32 200l0-8zM0 188.4L0 200C0 306.2 76.7 394.6 177.8 412.6l48.1 90.9c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6L215.8 416l.2 0c19.3 0 37.9-2.5 55.7-7.3l50.2 94.7c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-47.9-90.4C378.6 364.8 432 288.6 432 200l0-14.9 72.2-43.3c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7L425.2 66.8C410.2 27.8 372.3 0 328 0C270.6 0 224 46.6 224 104l0 24c0 17.7-14.3 32-32 32L28.4 160C12.7 160 0 172.7 0 188.4zM464.9 128L432 147.7l0-39.5L464.9 128zM328 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faHelicopter = {
    prefix: 'fal',
    iconName: 'helicopter',
    icon: [
      640,
      512,
      [128641],
      'f533',
      
      'M160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0 0 96-208 0L110.4 83.2C101.3 71.1 87.1 64 72 64L44.8 64c-21 0-36.3 19.9-30.9 40.2l22.7 85.1c3.7 14 13.6 25.6 26.9 31.5l124.6 55.4c1.8 .8 3.4 1.9 4.8 3.3l90.4 90.4c9 9 21.3 14.1 34 14.1l.5 0 .5 0 .5 0 .5 0 .4 0 .4 0 .4 0 .4 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0c30.9 0 56-25.1 56-56l0-56c0-79.5-64.5-144-144-144l-48 0 0-96 192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 0zM72 96c5 0 9.8 2.4 12.8 6.4l38.4 51.2c3 4 7.8 6.4 12.8 6.4l216 0 0 192-.1 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.4 0-.4 0-.4 0-.4 0-.5 0-.5 0-.5 0-.5 0c-4.3 0-8.3-1.7-11.3-4.7l-90.4-90.4c-4.2-4.2-9.1-7.5-14.4-9.9L76.5 191.6c-4.4-2-7.7-5.8-9-10.5L44.8 96 72 96zM384.4 352l-.4 0 0-192 48 0c61.9 0 112 50.1 112 112l0 56c0 13.2-10.8 24-24 24l-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0zM635.3 475.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-8.6 8.6c-12 12-28.3 18.7-45.3 18.7L240 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l318.9 0c25.5 0 49.9-10.1 67.9-28.1l8.6-8.6z'
      
    ]
  };

  

  
  

  var faSquareMinus = {
    prefix: 'fal',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faHouseFire = {
    prefix: 'fal',
    iconName: 'house-fire',
    icon: [
      640,
      512,
      [],
      'e50c',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l230.3 0c-14.2-9.5-27.1-20.9-38.3-33.8l0 1.8-96 0 0-160 51.6 0c2.4-10.6 5.9-21.4 10.3-32L240 288c-17.7 0-32 14.3-32 32l0 160-64 0c-26.5 0-48-21.5-48-48l0-225.3L288 37.3 408.4 143.6c1.4-1.2 2.7-2.5 4.1-3.7c7.7-6.9 17.2-10.8 26.9-11.7L298.6 4zM447.1 193.1l47.4 49.8c3.1 3.2 7.4 5 11.9 5s8.7-2 11.7-5.4l21-23.7c16.6 15.9 33.7 37.3 46.7 60.7c13.7 24.6 22.2 50 22.2 72.6c0 33.5-12.7 63.9-33.6 86.6c1-5.2 1.6-10.7 1.6-16.2c0-57.4-63.8-110.5-87.4-128.2c-5.2-3.9-12.1-3.9-17.3 0C447.8 312.1 384 365.2 384 422.6c0 5.7 .6 11.2 1.6 16.6c-21-22.8-33.6-53.3-33.6-87c0-28.4 12.4-58.2 31.4-86.7c18.4-27.5 42-52.6 63.7-72.3zM480 480c-2.4 0-4.7-.1-7-.2c-33.7-3.2-57-29.4-57-57.3c0-17.4 10.1-37.7 27.4-58.5c12.1-14.5 25.8-27 36.6-35.8c10.7 8.8 24.5 21.3 36.6 35.8c17.3 20.7 27.4 41.1 27.4 58.5c0 27.8-23.2 54-56.9 57.3c-2.4 .1-4.7 .2-7.1 .2zM320 352.2c0 85.6 65.7 155 150.9 159.6c3 .3 6 .4 9.1 .4c3.1 0 6.2-.1 9.2-.4C573.6 507 640 437.7 640 352.2c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-11.2-10.4-28.5-10.4-39.7-.1c-.4 .4-.8 .7-1.1 1.2l-12.3 13.8-37.9-39.9c-.3-.3-.5-.5-.8-.8c-11.1-10.1-28.1-10.1-39.3-.1c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2z'
      
    ]
  };

  

  
  

  var faEmptySet = {
    prefix: 'fal',
    iconName: 'empty-set',
    icon: [
      512,
      512,
      [216,8709],
      'f656',
      
      'M491.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66 66C363.4 52.6 312.1 32 256 32C132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7l66-66zM380 109.4L109.4 380C81.1 346.5 64 303.3 64 256C64 150 150 64 256 64c47.3 0 90.5 17.1 124 45.4zM132 402.6L402.6 132c28.3 33.5 45.4 76.7 45.4 124c0 106-86 192-192 192c-47.3 0-90.5-17.1-124-45.4z'
      
    ]
  };

  

  
  

  var faStarAndCrescent = {
    prefix: 'fal',
    iconName: 'star-and-crescent',
    icon: [
      512,
      512,
      [9770],
      'f699',
      
      'M32 256c0 118.4 91.9 215.4 208.3 223.5C151.1 444.4 88 357.6 88 256S151.1 67.6 240.3 32.5C123.9 40.6 32 137.6 32 256zM349.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c33 0 64.6 6.3 93.6 17.7zm16.6 138.5l.3-.5 3.4-6.9 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 3.4 6.9 .3 .5 22.2 45.1c1.4 2.8 4.1 4.8 7.2 5.3l49.7 7.2 .6 .1 7.7 1.1 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-5.5 5.4-.4 .4-36 35.1c-2.3 2.2-3.3 5.4-2.8 8.5l8.5 49.5 .1 .6 1.3 7.6 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-6.8-3.6-.5-.3-44.5-23.4c-2.8-1.5-6.1-1.5-8.9 0L335 361.7l-.5 .3-6.8 3.6-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 1.3-7.6 .1-.6 8.5-49.5c.5-3.1-.5-6.3-2.8-8.5l-36-35.1-.4-.4-5.5-5.4-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 7.7-1.1 .6-.1 49.7-7.2c3.1-.5 5.8-2.4 7.2-5.3l22.2-45.1zm6.5 59.2c-6.1 12.3-17.8 20.8-31.3 22.8l-25.5 3.7 18.4 18c9.8 9.6 14.3 23.3 12 36.8L341.9 322l22.8-12c12.1-6.4 26.6-6.4 38.7 0l22.8 12-4.4-25.4c-2.3-13.5 2.2-27.3 12-36.8l18.4-18-25.5-3.7c-13.5-2-25.3-10.5-31.3-22.8L384 192.3l-11.4 23.1z'
      
    ]
  };

  

  
  

  var faReply = {
    prefix: 'fal',
    iconName: 'reply',
    icon: [
      512,
      512,
      [61714,"mail-reply"],
      'f3e5',
      
      'M216 160c-13.3 0-24-10.7-24-24l0-8 0-16 0-48L32 208 192 352l0-48 0-16 0-8c0-13.3 10.7-24 24-24l8 0 96 0c70.7 0 128 57.3 128 128c0 8.3-.7 16.1-2 23.2c18.2-23.4 34-57.1 34-103.2c0-79.5-64.5-144-144-144l-112 0-8 0zm8 144l0 16 0 32c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2l0 32 0 16 0 16 32 0 80 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-64 0-32 0 0 16z'
      
    ]
  };

  
    var faMailReply = faReply;
  

  
  

  var faMeat = {
    prefix: 'fal',
    iconName: 'meat',
    icon: [
      512,
      512,
      [127830],
      'f814',
      
      'M288.9 223.1c30 30 65.3 51.2 99.4 60.2c12.2 3.2 25.2 5 38 4.7l-17.3 17.3c-30 30-70.7 46.8-113.1 46.8l-88 0c-26.5 0-48-21.5-48-48l0-88c0-42.4 16.9-83.1 46.9-113.1l17.2-17.2c-.3 12.8 1.5 25.8 4.7 38c9 34.1 30.2 69.4 60.2 99.4zm175.8 17.7c-31.2 31.2-99.7 13.1-153.2-40.3s-71.5-122-40.3-153.2c9.9-9.9 23.5-14.8 39.2-15.2c8.9 .2 18.1 1.6 27.1 3.9c28.9 7.6 59.6 25.9 86.1 52.3s44.7 57.2 52.3 86.1c2.3 8.9 3.7 17.9 3.9 26.8c-.4 15.9-5.3 29.6-15.3 39.6zM347.6 4.8c-12-3.2-24.8-5-37.4-4.7c-25.7-.3-52.7 6.9-74 28.2l-52 52c-36 36-56.2 84.8-56.2 135.8l0 72 0 16 0 2.7c0 4.2-1.7 8.3-4.7 11.3l-2 2c0 0 0 0-.1 0c-.1 0-.5 .1-1.2 .1c-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-16.1-5.3-30.9-14.2-42.9c-1.2-1.7-1.9-3.7-2-5.2c0-.7 .1-1.1 .1-1.2c0 0 0 0 0-.1l2-2c3-3 7.1-4.7 11.3-4.7l2.7 0 16 0 72 0c50.9 0 99.7-20.2 135.7-56.2l52.1-52.1c21.4-21.4 28.6-48.6 28.1-74.5c.2-12.5-1.6-25-4.7-36.9c-9-34.1-30.2-69.4-60.2-99.4s-65.3-51.2-99.4-60.2zM165.9 372c-10.6 14.6-5.7 33.5 2.2 44.1c4.9 6.7 7.9 14.9 7.9 23.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9c10.7 7.9 29.5 12.8 44.1 2.2c6.5 10.5 15.4 19.4 25.9 25.9zm186-211.9c15.3 15.3 34.9 20.4 43.8 11.5s3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8z'
      
    ]
  };

  

  
  

  var faClover = {
    prefix: 'fal',
    iconName: 'clover',
    icon: [
      448,
      512,
      [],
      'e139',
      
      'M171.3 64c-17.1 0-31 13.9-31 31l0 3.3c0 7.9 2 15.7 5.8 22.6L190 200.3c3.4 6.2 2.4 14-2.7 19.1s-12.8 6.1-19.1 2.7L88.9 178.1c-6.9-3.8-14.7-5.8-22.6-5.8l-3.3 0c-17.1 0-31 13.9-31 31c0 8.2 3.3 16.1 9.1 21.9l19.5 19.5c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L41.1 286.8c-5.8 5.8-9.1 13.7-9.1 21.9c0 17.1 13.9 31 31 31l3.3 0c7.9 0 15.7-2 22.6-5.8L168.3 290c6.2-3.4 14-2.4 19.1 2.7s6.1 12.8 2.7 19.1l-43.9 79.4c-3.8 6.9-5.8 14.7-5.8 22.6l0 3.3c0 17.1 13.9 31 31 31c8.2 0 16.1-3.3 21.9-9.1l19.5-19.5c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l19.5 19.5c5.8 5.8 13.7 9.1 21.9 9.1c17.1 0 31-13.9 31-31l0-3.3c0-7.9-2-15.7-5.8-22.6L258 311.7c-3.4-6.2-2.4-14 2.7-19.1s12.8-6.1 19.1-2.7l79.4 43.9c6.9 3.8 14.7 5.8 22.6 5.8l3.3 0c17.1 0 31-13.9 31-31c0-8.2-3.3-16.1-9.1-21.9l-19.5-19.5c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l19.5-19.5c5.8-5.8 9.1-13.7 9.1-21.9c0-17.1-13.9-31-31-31l-3.1 0c-8 0-15.8 2-22.8 5.9L281 222c-6.2 3.5-14 2.4-19-2.6s-6.2-12.7-2.9-19L302 120.9c3.7-6.9 5.7-14.6 5.7-22.4l0-3.5c0-17.1-13.9-31-31-31c-8.2 0-16.1 3.3-21.9 9.1L235.3 92.5c-3 3-7.1 4.7-11.3 4.7s-8.3-1.7-11.3-4.7L193.2 73.1c-5.8-5.8-13.7-9.1-21.9-9.1zm0-32c16.7 0 32.7 6.6 44.5 18.5l8.2 8.2 8.2-8.2C244 38.6 260 32 276.7 32c34.8 0 63 28.2 63 63l0 3.5c0 13.1-3.3 26-9.5 37.6l-16.7 31 30-16.8c11.7-6.6 25-10 38.4-10l3.1 0c34.8 0 63 28.2 63 63c0 16.7-6.6 32.7-18.5 44.5l-8.2 8.2 8.2 8.2C441.4 276 448 292 448 308.7c0 34.8-28.2 63-63 63l-3.3 0c-13.3 0-26.5-3.4-38.1-9.8l-30.8-17 17 30.8c6.5 11.7 9.8 24.8 9.8 38.1l0 3.3c0 34.8-28.2 63-63 63c-16.7 0-32.7-6.6-44.5-18.5l-8.2-8.2-8.2 8.2C204 473.4 188 480 171.3 480c-34.8 0-63-28.2-63-63l0-3.3c0-13.3 3.4-26.5 9.8-38.1l17-30.8-30.8 17c-11.7 6.5-24.8 9.8-38.1 9.8l-3.3 0c-34.8 0-63-28.2-63-63C0 292 6.6 276 18.5 264.2l8.2-8.2-8.2-8.2C6.6 236 0 220 0 203.3c0-34.8 28.2-63 63-63l3.3 0c13.3 0 26.5 3.4 38.1 9.8l30.8 17-17-30.8c-6.5-11.7-9.8-24.8-9.8-38.1l0-3.3c0-34.8 28.2-63 63-63z'
      
    ]
  };

  

  
  

  var faUsersSlash = {
    prefix: 'fal',
    iconName: 'users-slash',
    icon: [
      640,
      512,
      [],
      'e073',
      
      'M191.5 73l30.7 24.2c1.2-5.5 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-12.5 0-24.3 2.9-34.9 8l30.7 24.2c1.4-.1 2.8-.2 4.2-.2c24.1 0 44.1 17.8 47.5 41zM135.6 192L112 192C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80l64.2 0-40.5-32zM413 247.9c2-7.6 3-15.6 3-23.9c0-53-43-96-96-96c-16.2 0-31.4 4-44.8 11.1l29 22.9c5.1-1.3 10.4-2 15.8-2c35.3 0 64 28.7 64 64l0 1 29 22.9zM338.3 352L320 352l-58.7 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c13.5 0 24.7-10 26.4-23.1l-34.5-27.3c1.4 5.9 2.3 12.1 2.6 18.3l-319.7 0c2.8-53.5 47-96 101.2-96l117.3 0 .2 0-40.5-32zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM448 224l80 0c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112l-84 0c2.6 10.2 4 21 4 32zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faStarSharpHalf = {
    prefix: 'fal',
    iconName: 'star-sharp-half',
    icon: [
      576,
      512,
      [],
      'e28c',
      
      'M272 93.9L239.2 196.9C237.1 203.5 231 208 224 208L75.3 208l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6 272 376.2l0-282.3zm-8.3-79.5C266.5 5.8 274.4 0 283.4 0C294.8 0 304 9.2 304 20.6L304 384c0 4.9-2.3 9.6-6.2 12.6l-142.7 111c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176l153.7 0L263.7 14.4z'
      
    ]
  };

  

  
  

  var faPickleball = {
    prefix: 'fal',
    iconName: 'pickleball',
    icon: [
      576,
      512,
      [],
      'e435',
      
      'M363.6 50.7c-25-25-65.6-25-90.6 0L141 182.3 283.5 324.3c-4.5 11.3-7.8 23.2-9.7 35.5l-155.5-155-3.2 3.2c-13.8 13.7-17.9 34.4-10.4 52.3l24.9 59.8c10 23.9 4.5 51.5-13.9 69.8l-63 62.8c-6.3 6.2-6.3 16.3 0 22.6c6.3 6.2 16.4 6.2 22.7 0l63.3-63c18.3-18.2 45.7-23.7 69.6-13.9l58.5 24c3.4 1.4 6.9 2.4 10.5 3c3 11.4 7.3 22.2 12.6 32.4c-11.8 .7-23.9-1.2-35.3-5.8l-58.5-24c-12-4.9-25.7-2.2-34.8 7L98.1 498c-18.8 18.7-49.2 18.7-68 0s-18.8-49.1 0-67.8l63-62.8c9.2-9.2 11.9-22.9 6.9-34.9L75.1 272.7c-12.5-29.9-5.6-64.3 17.3-87.2L250.3 28.1c37.5-37.4 98.4-37.4 135.9 0L499.8 141.3c29.4 29.3 35.8 72.9 19.1 108.4c-8.9-5.8-18.5-10.7-28.5-14.7c10.4-23.5 6-51.9-13.3-71.1L363.6 50.7zm68.4 429.4a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFaceMask = {
    prefix: 'fal',
    iconName: 'face-mask',
    icon: [
      576,
      512,
      [],
      'e37f',
      
      'M444.8 416C404.4 455.6 349 480 288 480s-116.4-24.4-156.8-64l18.2 0c9 18.9 28.3 32 50.6 32l176 0c22.3 0 41.6-13.1 50.6-32l18.2 0zm27.1-32L432 384l0-72c0-3.8-.4-7.5-1.1-11l.6 1.2L512 259.2c-.7 46.4-15.4 89.3-40.1 124.8zm37.9-159.9l-92.9 49.6C406.6 262.8 392.1 256 376 256l-176 0c-16.1 0-30.6 6.8-40.8 17.7L66.2 224.1C81.7 115.5 175.1 32 288 32s206.3 83.5 221.8 192.1zm29.9-15.5C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9c-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6c-3.6-6.8-11.4-9.9-18.5-7.9zM64 259.2l80.4 42.9 .6-1.2c-.7 3.6-1.1 7.3-1.1 11l0 72-39.8 0C79.4 348.5 64.7 305.6 64 259.2zM376 288c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l176 0zM200 328c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16zm0 48c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16zm40-200c8.8 0 16-7.2 16-16s-7.2-16-16-16c-55.4 0-93.6 23-107.3 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C162.9 195.7 193 176 240 176zm180.7 27.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C429.6 167 391.4 144 336 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c47 0 77.1 19.7 84.7 27.3z'
      
    ]
  };

  

  
  

  var faTachographDigital = {
    prefix: 'fal',
    iconName: 'tachograph-digital',
    icon: [
      640,
      512,
      ["digital-tachograph"],
      'f566',
      
      'M64 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm96 32l0 64 224 0 0-64L96 160zm-32 0c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64zm0 208c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faDigitalTachograph = faTachographDigital;
  

  
  

  var faMagnifyingGlassArrowRight = {
    prefix: 'fal',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
      512,
      512,
      [],
      'e521',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm27.3-299.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 192 112 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l153.4 0-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z'
      
    ]
  };

  

  
  

  var faSensorTriangleExclamation = {
    prefix: 'fal',
    iconName: 'sensor-triangle-exclamation',
    icon: [
      640,
      512,
      ["sensor-alert"],
      'e029',
      
      'M64 64l320 0c17.7 0 32 14.3 32 32l0 39.4c9.8-4.8 20.7-7.4 32-7.4l0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l161 0c-.6-4-1-8.1-1-12.3c0-6.7 .9-13.3 2.6-19.7L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zm291.8 36.9C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3l295.4 0c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265zM440 196.7c1.6-2.9 4.7-4.7 8-4.7s6.4 1.8 8 4.7l150.4 265c1 1.9 1.6 3.9 1.6 6.1c0 6.8-5.5 12.3-12.3 12.3l-295.4 0c-6.8 0-12.3-5.5-12.3-12.3c0-2.1 .6-4.2 1.6-6.1L440 196.7zM464 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM448 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faSensorAlert = faSensorTriangleExclamation;
  

  
  

  var faUsersMedical = {
    prefix: 'fal',
    iconName: 'users-medical',
    icon: [
      640,
      512,
      [],
      'f830',
      
      'M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zM64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zM320 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM261.3 384c-54.2 0-98.4 42.5-101.2 96L448 480c0 11.7 3.1 22.6 8.6 32l-301.9 0c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352l117.3 0c4.6 0 9.1 .2 13.5 .7c-5.2 9.3-8.2 19.9-8.2 31.3l0 .1c-1.8-.1-3.5-.1-5.3-.1l-117.3 0zM512 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zm16 224l-80 0c0-11-1.4-21.8-4-32l84 0c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80zm-336 0l-80 0c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112l84 0c-2.6 10.2-4 21-4 32zm320 64l32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32zm0 80c0 8.8-7.2 16-16 16l-48 0 0 32 48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l48 0 0-32-48 0c-8.8 0-16-7.2-16-16l0-48-32 0 0 48z'
      
    ]
  };

  

  
  

  var faMessageImage = {
    prefix: 'fal',
    iconName: 'message-image',
    icon: [
      512,
      512,
      ["comment-alt-image"],
      'e1e0',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm110.5 12.7L208 213.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7c-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2c0 15.6 12.6 28.2 28.2 28.2l263.7 0c15.5 0 28.1-12.6 28.1-28.1c0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2c-10 0-19.4 4.7-25.5 12.7zm-86.3 83.5l19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5L380.3 288l-248.7 0 44.6-63.8z'
      
    ]
  };

  
    var faCommentAltImage = faMessageImage;
  

  
  

  var faUserChef = {
    prefix: 'fal',
    iconName: 'user-chef',
    icon: [
      448,
      512,
      [],
      'e3d2',
      
      'M96 64c0 13.9 8.9 25.8 21.3 30.2c6.4 2.3 10.7 8.3 10.7 15.1l0 34.7 192 0 0-34.7c0-6.8 4.3-12.8 10.7-15.1C343.1 89.8 352 77.9 352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32zM128 0c19.1 0 36.3 8.4 48 21.7C187.7 8.4 204.9 0 224 0s36.3 8.4 48 21.7C283.7 8.4 300.9 0 320 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 40.6 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16 0-40.6C76.9 108.4 64 87.7 64 64C64 28.7 92.7 0 128 0zm96 272c53 0 96-43 96-96l-192 0c0 53 43 96 96 96zM112 372.6c0 7.1-4.7 13.3-11.4 15.3C60.9 399.8 32 436.5 32 480l96 0 0-43.5c0-18.7 10.9-35.7 27.9-43.6l33.4-15.4L112 341.4l0 31.2zM160 480l256 0c0-43.5-28.9-80.2-68.6-92c-6.8-2-11.4-8.3-11.4-15.3l0-27.6L169.3 421.9c-5.7 2.6-9.3 8.3-9.3 14.5l0 43.5zM337.3 309.1l-1.4-3c3-1.4 6.2-2.1 9.5-2.1c12.5 0 22.5 10.1 22.5 22.5l0 34.8c46.9 19 80 65 80 118.7c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32c0-53.7 33.1-99.7 80-118.7l0-34.8c0-12.5 10.1-22.5 22.5-22.5c3.3 0 6.5 .7 9.5 2.1L224 358.3l111.9-52.2 1.4 3zM240 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faTable = {
    prefix: 'fal',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64 448 0 0-64c0-17.7-14.3-32-32-32L64 64zM32 192l0 112 208 0 0-112L32 192zm240 0l0 112 208 0 0-112-208 0zM240 336L32 336l0 80c0 17.7 14.3 32 32 32l176 0 0-112zm32 112l176 0c17.7 0 32-14.3 32-32l0-80-208 0 0 112zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faHyphen = {
    prefix: 'fal',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      'M0 256c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faMustache = {
    prefix: 'fal',
    iconName: 'mustache',
    icon: [
      640,
      512,
      [],
      'e5bc',
      
      'M235 112c-31.7 0-62.2 12.6-84.6 35.1c-31.6 31.6-81.9 34.4-116.8 6.5l-7.5-6c-5.1-4.1-12-4.5-17.5-1.6c-1.4 .7-2.7 1.7-3.8 2.8C1.8 151.6 0 155.6 0 160l0 44C0 312.2 87.8 400 196 400c42.4 0 83.7-13.8 117.6-39.2L320 356l6.4 4.8C360.3 386.2 401.6 400 444 400c108.2 0 196-87.8 196-196l0-44c0-4.4-1.8-8.4-4.6-11.3c-1.1-1.2-2.4-2.1-3.8-2.8c-5.5-2.9-12.4-2.5-17.5 1.6l-7.5 6c-34.9 27.9-85.2 25.1-116.8-6.5C467.2 124.6 436.8 112 405 112l-3.3 0c-25.2 0-49.8 7.5-70.8 21.4l-11 7.3-11-7.3c-21-14-45.6-21.4-70.8-21.4l-3.3 0zm373 78.7l0 13.3c0 90.6-73.4 164-164 164c-35.5 0-70-11.5-98.4-32.8l-16-12c-5.7-4.3-13.5-4.3-19.2 0l-16 12C266 356.5 231.5 368 196 368c-90.6 0-164-73.4-164-164l0-13.3c45.7 24.4 103.1 16.8 140.9-21c16.4-16.4 38.8-25.7 62-25.7l3.3 0c18.9 0 37.3 5.6 53 16.1l19.9 13.3c5.4 3.6 12.4 3.6 17.8 0l19.9-13.3c15.7-10.5 34.1-16.1 53-16.1l3.3 0c23.3 0 45.6 9.2 62 25.7c37.8 37.8 95.3 45.4 140.9 21z'
      
    ]
  };

  

  
  

  var faHockeyPuck = {
    prefix: 'fal',
    iconName: 'hockey-puck',
    icon: [
      512,
      512,
      [],
      'f453',
      
      'M32 184c0 9 4.1 18.9 14.3 29.3c10.2 10.5 25.8 20.7 46.3 29.6c41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 202.9 480 193 480 184s-4.1-18.9-14.3-29.3c-10.2-10.5-25.8-20.7-46.3-29.6C378.4 107.4 320.6 96 256 96s-122.4 11.4-163.3 29.1c-20.5 8.9-36.1 19.1-46.3 29.6C36.1 165.1 32 175 32 184zM0 184c0-19.7 9.3-37.2 23.4-51.7C37.5 117.9 57 105.7 79.9 95.8C125.8 75.9 188.1 64 256 64s130.2 11.9 176.1 31.8c22.9 9.9 42.5 22.2 56.5 36.6c14.1 14.5 23.4 32 23.4 51.7l0 144c0 19.7-9.3 37.2-23.4 51.7c-14.1 14.4-33.6 26.6-56.5 36.6C386.2 436.1 323.9 448 256 448s-130.2-11.9-176.1-31.8c-22.9-9.9-42.5-22.2-56.5-36.6C9.3 365.2 0 347.7 0 328L0 184zm480 59.6c-13 11-29.4 20.6-47.9 28.6C386.2 292.1 323.9 304 256 304s-130.2-11.9-176.1-31.8c-18.6-8-34.9-17.6-47.9-28.6L32 328c0 9 4.1 18.9 14.3 29.3c10.2 10.5 25.8 20.7 46.3 29.6c41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 346.9 480 337 480 328l0-84.4z'
      
    ]
  };

  

  
  

  var faToiletsPortable = {
    prefix: 'fal',
    iconName: 'toilets-portable',
    icon: [
      576,
      512,
      [],
      'e584',
      
      'M64 32l128 0c17.7 0 32 14.3 32 32l0 32L32 96l0-32c0-17.7 14.3-32 32-32zM32 448l0-320 192 0 0 80-24 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l24 0 0 112L32 448zM256 208l0-144c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 192 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 0-32 0-64 0-32zm-32 32l0 64-24 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l24 0zM384 32l128 0c17.7 0 32 14.3 32 32l0 32L352 96l0-32c0-17.7 14.3-32 32-32zM352 448l0-320 192 0 0 80-24 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l24 0 0 112-192 0zM576 208l0-144c0-35.3-28.7-64-64-64L384 0c-35.3 0-64 28.7-64 64l0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 192 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 0-32 0-64 0-32zm-32 32l0 64-24 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l24 0z'
      
    ]
  };

  

  
  

  var faSunPlantWilt = {
    prefix: 'fal',
    iconName: 'sun-plant-wilt',
    icon: [
      640,
      512,
      [],
      'e57a',
      
      'M160.5 0c-5.9 0-11.3 3.2-14.1 8.4l-27.5 51L63.4 42.7c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.6 55.4-51 27.5c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51 27.5L43.5 256.7c-1.7 5.6-.2 11.7 4 15.9s10.3 5.7 15.9 4L118.9 260l27.5 51c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l27.5-51 55.6 16.6c5.6 1.7 11.7 .1 15.9-4s5.7-10.3 4-15.9l-16.6-55.4 51-27.5c5.2-2.8 8.4-8.2 8.4-14.1s-3.2-11.3-8.4-14.1l-51-27.5 16.6-55.4c1.7-5.6 .2-11.7-4-15.9s-10.3-5.7-15.9-4L202.1 59.4l-27.5-51C171.8 3.2 166.4 0 160.5 0zm0 49.7L180.1 86c3.6 6.7 11.4 9.9 18.7 7.7l39.6-11.8-11.9 39.5c-2.2 7.3 1.1 15.1 7.7 18.7l36.3 19.6-36.3 19.6c-6.7 3.6-9.9 11.4-7.7 18.7l11.9 39.5-39.6-11.8c-7.3-2.2-15.1 1.1-18.7 7.7l-19.6 36.3-19.6-36.3c-3.6-6.7-11.4-9.9-18.7-7.7L82.6 237.4l11.9-39.5c2.2-7.3-1.1-15.1-7.7-18.7L50.4 159.7l36.3-19.6c6.7-3.6 9.9-11.4 7.7-18.7L82.6 81.9l39.6 11.8c7.3 2.2 15.1-1.1 18.7-7.7l19.6-36.3zm32.6 111.2a32 32 0 1 0 -63.9 0 32 32 0 1 0 63.9 0zm303.7 .1c0-17.6 14.3-32 32-32s32 14.3 32 32l0 49.5c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.4 15.1 22.3 30.7 36.5 44.1c6.2 5.8 15.8 5.8 22 0c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2l0-49.5c0-35.3-28.6-64-64-64s-64 28.6-64 64l0 43.9c-11.4-7.6-25.2-12.1-39.9-12.1c-39.7 0-71.9 32.2-71.9 71.9l0 9.6c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.5 15.1 22.3 30.7 36.5 44.1c6.2 5.8 15.8 5.8 22 0c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2l0-9.6c0-22.1 17.9-39.9 39.9-39.9s39.9 17.9 39.9 39.9l0 15.9 0 199.5-447.5 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l463.5 0 143.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-127.9 0 0-199.5 0-15.9 0-103.8zM368.9 304.6c10.6 0 18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4zM597 302.9c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4s18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3z'
      
    ]
  };

  

  
  

  var faListMusic = {
    prefix: 'fal',
    iconName: 'list-music',
    icon: [
      512,
      512,
      [],
      'f8c9',
      
      'M489.1 0C501.8 0 512 10.2 512 22.9L512 136c0 6.9-4.5 13.1-11.1 15.2L384 188.9 384 432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c31.3 0 59.7 9.2 80 24l0-320c0-6.9 4.4-13 10.9-15.2L481.9 1.2c2.3-.8 4.8-1.2 7.2-1.2zM332.6 401.5C318.3 391.3 297 384 272 384s-46.3 7.3-60.6 17.5C197.1 411.7 192 422.9 192 432s5.1 20.3 19.4 30.5C225.7 472.7 247 480 272 480s46.3-7.3 60.6-17.5C346.9 452.3 352 441.1 352 432s-5.1-20.3-19.4-30.5zM384 155.3l96-30.9 0-88.8-96 32 0 87.8zM16 64l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80s7.2-16 16-16zm0 128l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 352c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faScissors = {
    prefix: 'fal',
    iconName: 'scissors',
    icon: [
      512,
      512,
      [9984,9986,9988,"cut"],
      'f0c4',
      
      'M508.2 442.4c5.7-6.7 4.9-16.8-1.8-22.6l-152-129.3c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6l152 129.3c6.7 5.7 16.8 4.9 22.6-1.8zM287 235.1l-78.5-66.1c9.9-16.7 15.5-36.2 15.5-56.9C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c29.5 0 56.4-11.4 76.4-30.1L262.2 256l-73.8 62.1c-20-18.7-46.9-30.1-76.4-30.1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-20.8-5.7-40.3-15.5-56.9L506.3 92.2c6.8-5.7 7.6-15.8 1.9-22.5s-15.8-7.6-22.5-1.9L287 235.1zM112 192a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  
    var faCut = faScissors;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fal',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 9.6-4 18.7-11 25.2L206.2 376.7c-5.1 4.7-11.8 7.3-18.7 7.3c-15.2 0-27.5-12.3-27.5-27.5l0-201c0-15.2 12.3-27.5 27.5-27.5c6.9 0 13.6 2.6 18.7 7.3L309 230.8c7 6.5 11 15.6 11 25.2zm-32.7-1.7L192 165.8l0 180.3 95.3-88.4c.5-.4 .7-1.1 .7-1.7s-.3-1.3-.7-1.7z'
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faTombstone = {
    prefix: 'fal',
    iconName: 'tombstone',
    icon: [
      448,
      512,
      [],
      'f720',
      
      'M384 448l0-256c0-88.4-71.6-160-160-160S64 103.6 64 192l0 256-32 0 0-256C32 86 118 0 224 0S416 86 416 192l0 256-32 0zM0 496c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16zM240 144l0 64 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faMarsAndVenusBurst = {
    prefix: 'fal',
    iconName: 'mars-and-venus-burst',
    icon: [
      640,
      512,
      [],
      'e523',
      
      'M528 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0-75.6 75.6C481.1 80.6 442.5 64 400 64c-88.4 0-160 71.6-160 160c0 83 63.1 151.2 144 159.2l0 32.8-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0 0-32.8c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L608 54.6l0 49.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-88c0-8.8-7.2-16-16-16L528 0zM272 224a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM176 8c-6.3 0-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.1 3.4 9.5 4.5 14.5 3.1c-13.9-17.5-24.9-37.4-32-59.1l-31.5-26.1c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l24.2-6c11.2-16.3 24.9-30.8 40.5-43L222.6 87.2 190.5 17.3C187.9 11.6 182.3 8 176 8z'
      
    ]
  };

  

  
  

  var faFaceAngryHorns = {
    prefix: 'fal',
    iconName: 'face-angry-horns',
    icon: [
      640,
      512,
      [],
      'e368',
      
      'M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM552.4 148.6c-12.2-26.4-28.8-50.4-48.8-71c13.1-3 27.6-6.8 42.3-11.2c17.7-5.3 36.2-11.7 53.2-19.1c-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2c-20 20.6-36.6 44.6-48.8 71C65.5 114.3 50.2 76.2 40.9 47.3c17 7.4 35.5 13.8 53.2 19.1zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      
    ]
  };

  

  
  

  var faSignPost = {
    prefix: 'fal',
    iconName: 'sign-post',
    icon: [
      512,
      512,
      [],
      'e624',
      
      'M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 145 0c9.5 0 18.5 4.2 24.6 11.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5l-145 0 0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240L64 256c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l176 0 0-48zM470.3 160L417 96 64 96l0 128 353 0 53.3-64z'
      
    ]
  };

  

  
  

  var faPeopleArrows = {
    prefix: 'fal',
    iconName: 'people-arrows',
    icon: [
      640,
      512,
      ["people-arrows-left-right"],
      'e068',
      
      'M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320l45.2 0c2.3 6.6 6.1 12.7 11.3 17.9L156.1 352 96 352l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-147.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c28.3 0 53.4 14.8 67.7 37.3c-4.3 2.2-8.4 5.1-12 8.8l-12.6 12.6c-7.9-15.9-24.3-26.7-43-26.7l-44.8 0zM160 496l0-140.1 32 32L192 496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm288 0l0-108.1 32-32L480 496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96-144l-60.1 0 14.1-14.1c5.2-5.2 9-11.4 11.3-17.9l45.2 0c18.7 0 33.4-16 31.9-34.7L582.2 236c-2.1-24.9-22.9-44-47.8-44l-44.8 0c-18.7 0-35.1 10.8-43 26.7l-12.6-12.6c-3.6-3.6-7.7-6.5-12-8.8c14.2-22.5 39.3-37.3 67.7-37.3l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L576 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144zM512 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM251.3 251.3L214.6 288l210.7 0-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L425.4 320l-210.7 0 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faPeopleArrowsLeftRight = faPeopleArrows;
  

  
  

  var faAlbumCollectionCirclePlus = {
    prefix: 'fal',
    iconName: 'album-collection-circle-plus',
    icon: [
      640,
      512,
      [],
      'e48e',
      
      'M32 16c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 0C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 64c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512l310.3 0c-12.9-9.1-24.5-19.9-34.6-32L84.5 480c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272C34.6 172.1 45.7 160 59.8 160l392.4 0c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2c3.9 0 7.8 .1 11.7 .4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1L59.8 128zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4c-3.9-9.9-6.9-20.2-9-30.8C304.4 410.6 281.7 416 256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9c6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20zm128 24a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faSquareRoot = {
    prefix: 'fal',
    iconName: 'square-root',
    icon: [
      576,
      512,
      [8730],
      'f697',
      
      'M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4L82.9 264.4c-2.8-5.2-8.2-8.4-14.1-8.4L16 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l52.8 0c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7C311.9 46.1 330.7 32 352.1 32L560 32c8.8 0 16 7.2 16 16s-7.2 16-16 16L352.1 64z'
      
    ]
  };

  

  
  

  var faChessRookPiece = {
    prefix: 'fal',
    iconName: 'chess-rook-piece',
    icon: [
      320,
      512,
      ["chess-rook-alt"],
      'f448',
      
      'M16 112c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 112c0 3.7-1.3 7.4-3.7 10.2l-35.9 43.1 4.4 74.6-32.1 0L232 272.9c-.2-4.1 1.1-8.1 3.7-11.2L272 218.2l0-90.2-48 0 0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-64 0 0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-48 0 0 90.2 36.3 43.6c2.6 3.1 3.9 7.1 3.7 11.2L83.3 352l-32.1 0 4.4-74.6L19.7 234.2c-2.4-2.9-3.7-6.5-3.7-10.2l0-112zm144 96c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4l241.1 0c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L254.2 416 65.8 416 33.1 468.7zM254.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4L39.4 512C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1l188.4 0z'
      
    ]
  };

  
    var faChessRookAlt = faChessRookPiece;
  

  
  

  var faArrowProgress = {
    prefix: 'fal',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      'M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48 112 48C50.1 48 0 98.1 0 160s50.1 112 112 112l288 0c44.2 0 80 35.8 80 80c0 39.5-28.7 72.3-66.3 78.8c-7.5-27-32.3-46.8-61.7-46.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9C469.4 456.1 512 409 512 352c0-61.9-50.1-112-112-112l-288 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l176 0L262.4 99.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1 -.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48l66 0-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432l-66 0zM32 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faFileMp3 = {
    prefix: 'fal',
    iconName: 'file-mp3',
    icon: [
      512,
      512,
      [],
      'e648',
      
      'M64 480l16 0 0 32-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM139.7 352.6c6.9-1.9 14.3 1 18 7.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4zM288 368c0-8.8 7.2-16 16-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48zm144 80l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0c-8.8 0-16-7.2-16-16c0-.6 0-1.1 .1-1.6c.8-8.1 7.6-14.4 15.9-14.4l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48z'
      
    ]
  };

  

  
  

  var faPenRuler = {
    prefix: 'fal',
    iconName: 'pen-ruler',
    icon: [
      512,
      512,
      ["pencil-ruler"],
      'f5ae',
      
      'M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4 417.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L429.8 39.6zM83.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L39.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM82.7 27.3c25-25 65.5-25 90.5 0l70.9 70.9-22.6 22.6L189.7 89l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L167 66.3 150.6 49.9c-12.5-12.5-32.8-12.5-45.3 0L49.9 105.4c-12.5 12.5-12.5 32.8 0 45.3l70.9 70.9L98.2 244.1 27.3 173.3c-25-25-25-65.5 0-90.5L82.7 27.3zm256 457.4l-70.9-70.9 22.6-22.6 70.9 70.9c12.5 12.5 32.8 12.5 45.3 0l55.4-55.4c12.5-12.5 12.5-32.8 0-45.3L445.7 345l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L423 322.3l-31.8-31.8 22.6-22.6 70.9 70.9c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0z'
      
    ]
  };

  
    var faPencilRuler = faPenRuler;
  

  
  

  var faBellConcierge = {
    prefix: 'fal',
    iconName: 'bell-concierge',
    icon: [
      512,
      512,
      [128718,"concierge-bell"],
      'f562',
      
      'M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 48.6C123.8 152.8 32 249.7 32 368l0 16 32 0 0-16c0-106 86-192 192-192s192 86 192 192l0 16 32 0 0-16c0-118.3-91.8-215.2-208-223.4L272 96l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-48 0zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 416z'
      
    ]
  };

  
    var faConciergeBell = faBellConcierge;
  

  
  

  var faMessagePen = {
    prefix: 'fal',
    iconName: 'message-pen',
    icon: [
      512,
      512,
      ["comment-alt-edit","message-edit"],
      'f4a4',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM316.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zM207.1 239.1l60.7-60.7 17.8 17.8L224.8 257c-2.1 2.1-4.6 3.5-7.4 4.2L198 266l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 125l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63c-17.4-17.4-45.7-17.4-63.1 0z'
      
    ]
  };

  
    var faCommentAltEdit = faMessagePen;
  
    var faMessageEdit = faMessagePen;
  

  
  

  var faBadge = {
    prefix: 'fal',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M256 32c-28.3 0-53 15.9-65.4 39.4c-3.6 6.8-11.5 10.1-18.8 7.8c-25.4-7.8-54.1-1.6-74.1 18.4s-26.2 48.7-18.4 74.1c2.3 7.3-1 15.2-7.8 18.8C47.9 203 32 227.7 32 256s15.9 53 39.4 65.4c6.8 3.6 10.1 11.5 7.8 18.8c-7.8 25.4-1.6 54.1 18.4 74.1s48.7 26.2 74.1 18.4c7.3-2.3 15.2 1 18.8 7.8C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4c3.6-6.8 11.5-10.1 18.8-7.8c25.4 7.8 54.1 1.6 74.1-18.4s26.2-48.7 18.4-74.1c-2.3-7.3 1-15.2 7.8-18.8C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4c-6.8-3.6-10.1-11.5-7.8-18.8c7.8-25.4 1.6-54.1-18.4-74.1s-48.7-26.2-74.1-18.4c-7.3 2.3-15.2-1-18.8-7.8C309 47.9 284.3 32 256 32zM168.9 45.6C188 18.1 219.9 0 256 0s68 18.1 87.1 45.6c33-6 68.3 3.8 93.9 29.4s35.3 60.9 29.4 93.9C493.9 188 512 219.9 512 256s-18.1 68-45.6 87.1c6 33-3.8 68.3-29.4 93.9s-60.9 35.3-93.9 29.4C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.3-3.8-93.9-29.4s-35.3-60.9-29.4-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.3 29.4-93.9s60.9-35.3 93.9-29.4z'
      
    ]
  };

  

  
  

  var faSunglasses = {
    prefix: 'fal',
    iconName: 'sunglasses',
    icon: [
      576,
      512,
      [128374],
      'f892',
      
      'M86.3 87.6C89.9 73.7 102.4 64 116.8 64c4.9 0 9.7 1.1 14.1 3.3l22 11c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-22-11c-8.8-4.4-18.5-6.7-28.4-6.7c-29 0-54.2 19.6-61.5 47.6L4.6 276.3C1.6 287.9 0 299.8 0 311.8l0 .2 0 .2L0 352l0 16c0 61.9 50.1 112 112 112l44.3 0c59.4 0 108.5-46.4 111.8-105.8l3.4-54.2 32.9 0 3.4 54.2C311.1 433.6 360.2 480 419.7 480l44.3 0c61.9 0 112-50.1 112-112l0-15.5 0-.5 0-39.8c0-12.1-1.5-24.2-4.6-36L520.7 79.6c-7.2-28-32.5-47.6-61.5-47.6c-9.9 0-19.6 2.3-28.4 6.7l-22 11c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l22-11c4.4-2.2 9.2-3.3 14.1-3.3c14.4 0 26.9 9.7 30.5 23.6l48.2 186.8c-31-12-65-18.4-97.6-18.4c-40.1 0-82.2 9.6-118.5 27.3c-2.6 1.3-4.9 2.9-7 4.7l-53.7 0c-2.1-1.8-4.4-3.4-7-4.7C217.9 265.6 175.8 256 135.7 256c-32.6 0-66.6 6.3-97.6 18.4L86.3 87.6zM32 312.2l0-.2c31.4-15.6 68.6-24 103.7-24c35.3 0 72.5 8.5 104.3 24l0 .1s0 0 0 0l-3.8 60.2s0 0 0 0l0 .2c-2.4 42.4-37.4 75.6-79.9 75.6L112 448c-7.7 0-15.1-1.1-22.1-3.1l9.2-4.6 12-6 24-12 48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-48 24-24 12-12 6-12 6-12 6c-1.4 .7-2.6 1.6-3.7 2.5c-8.1-7.7-14.6-17-19-27.5c.3-.1 .7-.3 1-.5l96-48c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L32 366.1 32 352l0-39.8zM544 368c0 44.2-35.8 80-80 80l-44.3 0c-8.5 0-16.7-1.3-24.3-3.8l91.8-45.9c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-96 48-12 6c-.6 .3-1.1 .6-1.7 1c-7.7-7.7-13.9-17-18-27.4l93.9-47c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-85.6 42.8L336 312s0 0 0 0c0 0 0 0 0-.1c31.8-15.5 69-24 104.3-24c35.1 0 72.2 8.4 103.7 24l0 56z'
      
    ]
  };

  

  
  

  var faTireFlat = {
    prefix: 'fal',
    iconName: 'tire-flat',
    icon: [
      512,
      512,
      [],
      'f632',
      
      'M32 460.2c0 10.9 8.9 19.8 19.8 19.8l80.2 0L380 480l80.2 0c10.9 0 19.8-8.9 19.8-19.8c0-3.1-.7-6.1-2.1-8.8L460.2 416c-5.6-11.1-5.5-23.9-.6-34.7c13-28.4 20.3-60 20.3-93.3C480 164.3 379.7 64 256 64S32 164.3 32 288c0 33.4 7.3 65 20.3 93.3c5 10.8 5 23.6-.6 34.7L34.1 451.4 5.8 437.3l28.3 14.1c-1.4 2.7-2.1 5.8-2.1 8.8zM512 288c0 38.1-8.3 74.2-23.2 106.7c-1 2.2-1 4.8 .1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2c0 28.6-23.2 51.8-51.8 51.8L380 512 132 512l-80.2 0C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8 .1-7C8.3 362.2 0 326.1 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-128 0c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2zm-74.1 34.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zm-70 27.5c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm128-64c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM96 288a160 160 0 1 1 320 0A160 160 0 1 1 96 288zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTreeChristmas = {
    prefix: 'fal',
    iconName: 'tree-christmas',
    icon: [
      448,
      512,
      [127876],
      'f7db',
      
      'M212.3 75c-1.6 4.3-5 7.7-9.4 9.4L171.8 96 203 107.7c4.3 1.6 7.7 5 9.4 9.4L224 148.2 235.7 117c1.6-4.3 5-7.7 9.4-9.4L276.2 96 245 84.3c-4.3-1.6-7.7-5-9.4-9.4L224 43.8 212.3 75zM224 0c10.7 0 20.2 6.6 24 16.6l15.1 40.3L303.4 72c10 3.7 16.6 13.3 16.6 24s-6.6 20.2-16.6 24l-40.3 15.1L248 175.4c-3.7 10-13.3 16.6-24 16.6s-20.2-6.6-24-16.6l-15.1-40.3L144.6 120c-10-3.7-16.6-13.3-16.6-24s6.6-20.2 16.6-24l40.3-15.1L200 16.6C203.8 6.6 213.3 0 224 0zM27.9 307.9l107-157.4 25.1 9.4 2.5 6.8L58.4 320l49.8 0c5.8 0 11.2 3.2 14 8.3s2.6 11.4-.6 16.3L35 480l378 0L326.4 344.6c-3.2-4.9-3.4-11.2-.6-16.3s8.2-8.3 14-8.3l48.8 0L285.3 167.1l2.7-7.2 24.8-9.3L419.4 308.3c2.8 4.2 4.5 9 4.8 14c1 16.1-11.8 29.7-28 29.7l-27.1 0 74.4 116.3c2.9 4.6 4.5 9.9 4.5 15.3c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6c0-5.4 1.6-10.7 4.5-15.3L78.9 352l-27.6 0C35.7 352 23 339.4 23 323.8c0-5.7 1.7-11.2 4.9-15.9zM160 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMotorcycle = {
    prefix: 'fal',
    iconName: 'motorcycle',
    icon: [
      640,
      512,
      [127949],
      'f21c',
      
      'M411.8 96L480 96l0-32-26.6 0L411.8 96zM488 128l-75.8 0L467 232.1c14-5.3 29.2-8.1 45-8.1c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128c0-43.4 21.6-81.8 54.7-104.9l-15-28.5C380.5 247.2 352 296.3 352 352l0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-8c0-92.8-75.2-168-168-168l-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l72 0c41.4 0 79.9 12.6 111.8 34.1l127.4-98L342.3 64 272 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l70.3 0c11.9 0 22.8 6.6 28.3 17.1L385 76.3 436.1 37c4.2-3.2 9.3-5 14.6-5L488 32c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24zM257.5 214.7c36.7 34.7 60.2 83.3 62.4 137.3l.2 0c0-68 35.4-127.8 88.7-161.9l-34.4-65.3L257.5 214.7zM497.8 359.5l-44.1-83.8c-23 17.5-37.8 45.2-37.8 76.3c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-10.5 0-20.5 1.7-29.9 4.8l44.1 83.8c4.1 7.8 1.1 17.5-6.7 21.6s-17.5 1.1-21.6-6.7zM128 256c-53 0-96 43-96 96s43 96 96 96c47.6 0 87.1-34.6 94.7-80l-67 0c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16l67 0c-7.6-45.4-47.1-80-94.7-80zM0 352a128 128 0 1 1 256 0A128 128 0 1 1 0 352z'
      
    ]
  };

  

  
  

  var faChartBullet = {
    prefix: 'fal',
    iconName: 'chart-bullet',
    icon: [
      512,
      512,
      [],
      'e0e1',
      
      'M272 32c8.8 0 16 7.2 16 16l0 16 176 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-176 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16L48 224c-26.5 0-48-21.5-48-48l0-64C0 85.5 21.5 64 48 64l208 0 0-16c0-8.8 7.2-16 16-16zM160 96l0 96 96 0 0-96-96 0zm128 0l0 96 176 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L288 96zM128 96L48 96c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l80 0 0-96zM368 256c8.8 0 16 7.2 16 16l0 16 80 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-80 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16L48 448c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l304 0 0-16c0-8.8 7.2-16 16-16zM224 416l128 0 0-96-128 0 0 96zm160-96l0 96 80 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-80 0zm-192 0L48 320c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l144 0 0-96z'
      
    ]
  };

  

  
  

  var faStarChristmas = {
    prefix: 'fal',
    iconName: 'star-christmas',
    icon: [
      512,
      512,
      [],
      'f7d4',
      
      'M216.9 205.5L256 55.7l39.1 149.8c1.5 5.6 5.8 10 11.4 11.4L456.3 256 306.5 295.1c-5.6 1.5-10 5.8-11.4 11.4L256 456.3 216.9 306.5c-1.5-5.6-5.8-10-11.4-11.4L55.7 256l149.8-39.1c5.6-1.5 10-5.8 11.4-11.4zM256 0c-10.9 0-20.5 7.4-23.2 17.9L188.3 188.3 17.9 232.8C7.4 235.5 0 245.1 0 256s7.4 20.5 17.9 23.2l170.4 44.4 44.4 170.4c2.8 10.6 12.3 17.9 23.2 17.9s20.5-7.4 23.2-17.9l44.4-170.4 170.4-44.4c10.6-2.8 17.9-12.3 17.9-23.2s-7.4-20.5-17.9-23.2L323.7 188.3 279.2 17.9C276.5 7.4 266.9 0 256 0zM443.3 68.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm-374.6 0c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm86.6 310.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm201.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faCircleC = {
    prefix: 'fal',
    iconName: 'circle-c',
    icon: [
      512,
      512,
      [],
      'e101',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM188.1 323.9c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-37.5 37.5-98.3 37.5-135.8 0z'
      
    ]
  };

  

  
  

  var faBoxTissue = {
    prefix: 'fal',
    iconName: 'box-tissue',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      'M208 32c12.6 0 17.5 3.4 20.5 6.2c4.7 4.4 8.4 11.1 14.9 24.1l.7 1.5c5.5 11 13.7 27.5 27.4 40.4c16 15.2 37.1 23.8 64.5 23.8l77.5 0L343.1 304 165 304 97 32l111 0zM120 256l12 48-20 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-22.4 0 19.2-48 12.8-32 36.5-91.2c1.3-3.2 1.9-6.6 1.9-10C448 108 436 96 421.2 96L336 96c-40 0-52-24-64-48S248 0 208 0L92.5 0C76.8 0 64 12.8 64 28.5c0 2.3 .3 4.7 .9 6.9L112 224l8 32zm-33 0l-8-32-31 0c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-19.9 0-12.8 32 32.7 0c8.8 0 16 7.2 16 16l0 112L32 384l0-112c0-8.8 7.2-16 16-16l39 0zM32 416l448 0 0 48c0 8.8-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16l0-48z'
      
    ]
  };

  

  
  

  var faMicrophoneSlash = {
    prefix: 'fal',
    iconName: 'microphone-slash',
    icon: [
      640,
      512,
      [],
      'f131',
      
      'M474.8 296.7c3.4-13 5.2-26.6 5.2-40.7l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 6.3-.5 12.4-1.3 18.5l28.1 22.2zM416 250.2L416 96c0-53-43-96-96-96s-96 43-96 96l0 2.7 32 25.3L256 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 129 32 25.3zM192 236.5l-32-25.3 0 44.8c0 83 63.1 151.2 144 159.2l0 64.8-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64.8c21.3-2.1 41.4-8.4 59.5-18.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128l0-19.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faBinoculars = {
    prefix: 'fal',
    iconName: 'binoculars',
    icon: [
      512,
      512,
      [],
      'f1e5',
      
      'M112 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM192 432c0 8.8-7.2 16-16 16L48 448c-8.8 0-16-7.2-16-16l0-75.1c0-28.8 7.8-57.1 22.7-81.9c16-26.6 26.2-56.3 30.1-87.1L90.5 142c1-8 7.8-14 15.9-14l85.6 0 0 16 0 128 0 160zm32 0l0-144 64 0 0 144c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-75.1c0-34.6-9.4-68.6-27.2-98.3c-13.7-22.8-22.5-48.2-25.8-74.6L453.3 138c-3-24-23.4-42-47.6-42L312 96c-13.3 0-24 10.7-24 24l0 8-64 0 0-8c0-13.3-10.7-24-24-24l-93.6 0c-24.2 0-44.6 18-47.6 42L53 184c-3.3 26.4-12.1 51.8-25.8 74.6C9.4 288.3 0 322.3 0 356.9L0 432c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48zm0-176l0-96 64 0 0 96-64 0zm96 16l0-128 0-16 85.6 0c8.1 0 14.9 6 15.9 14l5.7 45.9c3.9 30.8 14.1 60.5 30.1 87.1c14.8 24.7 22.7 53 22.7 81.9l0 75.1c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-160z'
      
    ]
  };

  

  
  

  var faTruckRamp = {
    prefix: 'fal',
    iconName: 'truck-ramp',
    icon: [
      640,
      512,
      [],
      'f4e0',
      
      'M432 0c-44.2 0-80 35.8-80 80l0 304c0 1.3 .2 2.5 .4 3.7L11.8 480.6C3.3 482.9-1.8 491.7 .6 500.2s11.1 13.6 19.6 11.2L416.1 403.6C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5 .1L384 379.1 384 80c0-26.5 21.5-48 48-48l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L432 0zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faMusicSlash = {
    prefix: 'fal',
    iconName: 'music-slash',
    icon: [
      640,
      512,
      [],
      'f8d1',
      
      'M575.5 376.2c.3-2.7 .5-5.4 .5-8.2l0-231.6c0-.1 0-.3 0-.4c0-.1 0-.2 0-.3L576 23c0-12.7-10.3-23-23-23c-2.3 0-4.6 .3-6.8 1l-311 95.7c-3 .9-5.6 2.7-7.5 5L256 123.9l0-.1L544 35.2l0 89L337 187.9 367.5 212 544 157.7l0 150.7c-17-12.7-39.4-20.4-64-20.4c-5.1 0-10.1 .3-15 1l48 37.9c9.6 4.5 17.2 10.7 22.4 17.7l40.1 31.7zM256 287l-32-25.3 0 110.6c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-145zm-96 97c41.1 0 64 26.7 64 48s-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z'
      
    ]
  };

  

  
  

  var faTableCellsUnlock = {
    prefix: 'fal',
    iconName: 'table-cells-unlock',
    icon: [
      640,
      512,
      [],
      'e692',
      
      'M352 64l0 96 128 0 0-64c0-17.7-14.3-32-32-32l-96 0zm-32 0L192 64l0 96 128 0 0-96zM160 64L64 64C46.3 64 32 78.3 32 96l0 64 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 40.6 0c-5.4 9.4-8.6 20.3-8.6 32l-32 0 0 96zM192 320l128 0 0-128-128 0 0 128zm288-48l0 48 48 0 48 0 32 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480l160 0 0-128-160 0 0 128z'
      
    ]
  };

  

  
  

  var faTrillium = {
    prefix: 'fal',
    iconName: 'trillium',
    icon: [
      448,
      512,
      [],
      'e588',
      
      'M203.3 8.2c11.8-11 29.8-11 41.5 0c12.1 11.3 33.1 32.5 51.2 58.8c17.9 26 34.2 58.9 34.2 93.4c0 9.3-1.2 18.4-3.5 27c10.5 2.3 20.8 6.1 30.5 11.7c0 0 0 0 0 0c29.9 17.2 50.4 47.6 64.2 75.9c13.9 28.7 21.9 57.3 25.7 73.5c3.8 15.8-5.4 31.5-20.9 36.1c-16 4.8-44.9 12.2-76.8 14.6c-31.5 2.3-68.3-.1-98.2-17.2c-10.5-6-19.6-13.6-27.1-22.2c-7.5 8.7-16.6 16.2-27.1 22.2c-29.9 17.2-66.7 19.6-98.2 17.2c-31.9-2.4-60.9-9.8-76.8-14.6C6.3 380-2.9 364.4 .8 348.5c3.8-16.2 11.8-44.8 25.7-73.5c13.7-28.3 34.2-58.8 64.2-75.9c0 0 0 0 0 0c9.8-5.6 20.1-9.5 30.6-11.7c-2.3-8.6-3.5-17.7-3.5-27c0-34.4 16.4-67.4 34.2-93.4c18.1-26.3 39.1-47.5 51.2-58.8zM224 32.6c-11.4 10.7-29.8 29.6-45.6 52.5c-16.5 24-28.6 50.4-28.6 75.2c0 12 2.9 23.3 8.1 33.3c2.6 5 2.4 10.9-.6 15.7s-8.1 7.7-13.7 7.7c-12.6 0-25.4 3.2-37 9.9C84.9 239.4 68 263 55.3 289c-12.1 24.9-19.3 50.2-23 65.4c15.1 4.4 40.8 10.9 68.7 12.9c29.1 2.2 58.2-.6 79.9-13.1c12.8-7.3 22.6-17.9 28.8-30.1c2.7-5.3 8.2-8.7 14.2-8.7s11.5 3.3 14.2 8.7c6.3 12.2 16 22.8 28.8 30.1c21.7 12.5 50.8 15.2 79.9 13.1c27.8-2.1 53.6-8.5 68.7-12.9c-3.7-15.2-10.9-40.5-23-65.4c-12.6-26.1-29.6-49.7-51.3-62.1c-11.6-6.7-24.4-9.8-36.9-9.9c-5.6 0-10.8-2.9-13.7-7.7s-3.1-10.7-.6-15.7c5.2-10 8.1-21.3 8.1-33.3c0-24.9-12.1-51.3-28.6-75.2C253.9 62.3 235.4 43.4 224 32.6zM224 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-6.2 183.2c-8.2 35.9-22.6 61.3-30.9 73.9c-9.1 13.7-28.8 13.7-37.9 0c-8.3-12.5-22.7-38-30.9-73.9c10.3-3.1 20.4-7.2 30-12.5c4.8 24 12.9 42.9 19.8 55.8c6.9-12.9 15-31.7 19.8-55.7c9.7 5.3 19.8 9.4 30 12.5zM9.9 105.4c14.7-1.9 44.2-2.8 82.7 10c-2.6 10.4-4.2 21.2-4.5 32.3c-25.6-9.3-46.4-11.4-60.4-11.3c6.4 11.1 17.2 26.4 35 42.3c-9.1 6.1-17.4 13.1-24.9 20.6C10.4 173.6-2.5 149.3-8 136.3c-5.8-13.8 3-29.1 17.9-31zm375.4 73.3c17.8-16 28.7-31.2 35.1-42.4c-14 0-34.9 2.1-60.4 11.3c-.3-11.1-2-21.9-4.5-32.3c38.5-12.8 68-11.8 82.7-10c14.9 1.9 23.7 17.1 17.9 30.9c-5.5 13-18.4 37.4-45.9 63c-7.5-7.6-15.7-14.6-24.9-20.6z'
      
    ]
  };

  

  
  

  var faBrowsers = {
    prefix: 'fal',
    iconName: 'browsers',
    icon: [
      576,
      512,
      [],
      'e0cb',
      
      'M512 32c17.7 0 32 14.3 32 32l0 32L256 96l0-64 256 0zM160 32l64 0 0 64-96 0 0-32c0-17.7 14.3-32 32-32zM128 352l0-224 112 0 304 0 0 224c0 17.7-14.3 32-32 32l-352 0c-17.7 0-32-14.3-32-32zM160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L160 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 384c0 70.7 57.3 128 128 128l336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-336 0c-53 0-96-43-96-96l0-272z'
      
    ]
  };

  

  
  

  var faSprinklerCeiling = {
    prefix: 'fal',
    iconName: 'sprinkler-ceiling',
    icon: [
      384,
      512,
      [],
      'e44c',
      
      'M0 0L32 0l0 83.8L128 110l0 33.2L11.8 111.4C4.8 109.5 0 103.2 0 96L0 0zM256 110l96-26.2L352 0l32 0 0 96c0 7.2-4.8 13.5-11.8 15.4L256 143.1l0-33.2zM192 32c8.8 0 16 7.2 16 16l0 176 96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0L80 256c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0 0-176c0-8.8 7.2-16 16-16zM144 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 464a16 16 0 1 1 32 0A16 16 0 1 1 0 464z'
      
    ]
  };

  

  
  

  var faGavel = {
    prefix: 'fal',
    iconName: 'gavel',
    icon: [
      512,
      512,
      ["legal"],
      'f0e3',
      
      'M315.3 4.7c6.2 6.2 6.2 16.4 0 22.6L302.6 40 472 209.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24 24-96 96-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 328 184 158.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24 96-96 24-24c6.2-6.2 16.4-6.2 22.6 0zM206.6 136L376 305.4 449.4 232 280 62.6 206.6 136zM144 320L32 432l48 48L192 368l-48-48zm-22.6-22.6c12.5-12.5 32.8-12.5 45.3 0l12.7 12.7 49.8-49.8 22.6 22.6-49.8 49.8 12.7 12.7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112z'
      
    ]
  };

  
    var faLegal = faGavel;
  

  
  

  var faReflectBoth = {
    prefix: 'fal',
    iconName: 'reflect-both',
    icon: [
      512,
      512,
      [],
      'e66f',
      
      'M128 32l256 0L256 160 128 32zM384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S396.9 0 384 0zM32 128L160 256 32 384l0-256zM19.8 98.4C7.8 103.4 0 115.1 0 128L0 384c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9zM480 128l0 256L352 256 480 128zm12.2-29.6c-12-5-25.7-2.2-34.9 6.9l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6zM384 480l-256 0L256 352 384 480zm29.6 12.2c5-12 2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8z'
      
    ]
  };

  

  
  

  var faTrashClock = {
    prefix: 'fal',
    iconName: 'trash-clock',
    icon: [
      576,
      512,
      [],
      'e2b0',
      
      'M177.7 32l92.5 0c5.5 0 10.6 2.8 13.6 7.5L299.1 64 148.9 64l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0L177.7 0C161.2 0 145.8 8.5 137 22.6L111.1 64 64.1 64 32 64 16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l18.3 0L59.8 452.6C62.1 486.1 90 512 123.6 512l200.8 0c2 0 4-.1 6-.3c-12.7-9-24.2-19.7-34.2-31.7l-172.6 0c-16.8 0-30.7-13-31.9-29.7L66.4 96l315.3 0-7.6 105.8c10.5-3.6 21.4-6.3 32.6-8l7-97.8L432 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32.1 0-47.1 0zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faCartCircleArrowUp = {
    prefix: 'fal',
    iconName: 'cart-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e3f0',
      
      'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2l129.5 0c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16l-129.5 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l187.2 0c5.9-11.4 12.9-22.2 21-32l-214.8 0L106.1 64l433.4 0L507.4 192.4c10.9 .7 21.5 2.4 31.7 5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm136-88a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faTentArrowLeftRight = {
    prefix: 'fal',
    iconName: 'tent-arrow-left-right',
    icon: [
      576,
      512,
      [],
      'e57f',
      
      'M482.8 4.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L518.6 80 57.4 80l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112l461.2 0-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80zm-185.3 159c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512l343.1 0c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7l0 112c0 .2 0 .4 0 .5L272 480l-155.6 0c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8L272 207.7zm32 168.5L368.2 480 304 480l0-103.8zm0-60.8l0-107.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1l-53.7 0-.3-.4L304 315.4z'
      
    ]
  };

  

  
  

  var faChfSign = {
    prefix: 'fal',
    iconName: 'chf-sign',
    icon: [
      640,
      512,
      [],
      'e602',
      
      'M0 112C0 67.8 35.8 32 80 32l4.2 0c28 0 53.6 15.8 66.1 40.8c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2C114.6 73 100.1 64 84.2 64L80 64c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l4.2 0c15.9 0 30.4-9 37.5-23.2c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5c-12.5 25-38.1 40.8-66.1 40.8L80 480c-44.2 0-80-35.8-80-80L0 112zM208 32c8.8 0 16 7.2 16 16l0 176 160 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208-160 0 0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zM448 48c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L480 64l0 160 112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0 0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416z'
      
    ]
  };

  

  
  

  var faMicrowave = {
    prefix: 'fal',
    iconName: 'microwave',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      'M512 64c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-16 0L80 416l-16 0c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM480 448l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 384 0zM464 128l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zM128 320l0-160 256 0 0 160-256 0zM96 152l0 176c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24z'
      
    ]
  };

  

  
  

  var faHospitalUser = {
    prefix: 'fal',
    iconName: 'hospital-user',
    icon: [
      576,
      512,
      [],
      'f80d',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l192 0c3.2 0 6.4-.2 9.5-.7c-5.5-9.2-8.9-19.9-9.4-31.3c0 0 0 0-.1 0L64 480c-17.7 0-32-14.3-32-32l0-32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 384l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 288 32 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 272 0 57.4c9.2-10.2 20-18.9 32-25.6l0-31.8 0-64.2L320 64c0-35.3-28.7-64-64-64L64 0zm80 80c-13.3 0-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24l-32 0zm8 56l0-24 16 0 0 24c0 8.8 7.2 16 16 16l24 0 0 16-24 0c-8.8 0-16 7.2-16 16l0 24-16 0 0-24c0-8.8-7.2-16-16-16l-24 0 0-16 24 0c8.8 0 16-7.2 16-16zM384 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM320 477.1c0-33.7 27.4-61.1 61.1-61.1l101.8 0c33.7 0 61.1 27.4 61.1 61.1c0 1.6-1.3 2.9-2.9 2.9l-218.2 0c-1.6 0-2.9-1.3-2.9-2.9zM381.1 384c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1L432 384l-50.9 0z'
      
    ]
  };

  

  
  

  var faFaceFlushed = {
    prefix: 'fal',
    iconName: 'face-flushed',
    icon: [
      512,
      512,
      [128563,"flushed"],
      'f579',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160.4-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 368l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faFlushed = faFaceFlushed;
  

  
  

  var faSquare3 = {
    prefix: 'fal',
    iconName: 'square-3',
    icon: [
      448,
      512,
      [],
      'e258',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 32l144 0c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-78.9 67.6 19.9-.1c44.4-.2 80.6 35.7 80.6 80.2c0 44.3-35.9 80.2-80.2 80.2l-36 0c-27.6 0-53.5-13-70.1-35l-2.5-3.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2l2.5 3.4c10.5 14 27 22.2 44.5 22.2l36 0c26.6 0 48.2-21.6 48.2-48.2c0-26.7-21.7-48.3-48.4-48.2l-63.5 .3c-6.7 0-12.7-4.1-15.1-10.4s-.5-13.4 4.6-17.7L244.7 160 144 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faTrowelBricks = {
    prefix: 'fal',
    iconName: 'trowel-bricks',
    icon: [
      512,
      512,
      [],
      'e58a',
      
      'M32 128L224 32l0 192L32 128zM256 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2l0-80 88 0c0 17.7 14.3 32 32 32l88 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-88 0c-17.7 0-32 14.3-32 32l-88 0 0-80zm208 80c8.8 0 16 7.2 16 16s-7.2 16-16 16l-88 0 0-32 88 0zM288 384l16 0 16 0 160 0 0 8 0 88-224 0 0-96 32 0zm-64 0l0 96L32 480l0-96 192 0zm256-32l-160 0 0-96 160 0 0 96zM288 256l0 64 0 32-32 0L32 352c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-88 0-8 0-128c0-17.7-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faCloud = {
    prefix: 'fal',
    iconName: 'cloud',
    icon: [
      640,
      512,
      [9729],
      'f0c2',
      
      'M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96l-368 0C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8z'
      
    ]
  };

  

  
  

  var faMessageQuestion = {
    prefix: 'fal',
    iconName: 'message-question',
    icon: [
      512,
      512,
      [],
      'e1e3',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM168.7 121.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9l57.1 0c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3l0 29.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-19.7 37.1-18.9c21.5-11 34.9-33.2 34.9-57.2C344 109 315.5 80 280 80l-57.1 0c-25.5 0-47.7 17.2-54.2 41.8zM280 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faPaw = {
    prefix: 'fal',
    iconName: 'paw',
    icon: [
      512,
      512,
      [],
      'f1b0',
      
      'M197.4 143.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1s4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8S174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8s52.1 69.1 84.4 58.5zm-114.1 54c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3s-29.1 51.7-10.2 84.1s54 47.3 78.5 33.3zM256 256c25.7 0 108.2 25.4 156.8 156.3c2.1 5.7 3.2 12.2 3.2 19.4l0 4.4c0 6.6-5.3 11.9-11.9 11.9c-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5c-6.6 0-11.9-5.3-11.9-11.9l0-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 281.4 230.3 256 256 256zm0-32c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5l0 4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 474c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9l0-4.4c0-10.4-1.6-20.8-5.2-30.5C390.4 259.9 297.3 224 256 224zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3c-.9-7.7 .8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3s14.3-70.1-10.2-84.1s-59.7 .9-78.5 33.3zM307.9 103c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1c-3.5-10.3-4-24.7 1.2-40.2zM277.5 92.9c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9z'
      
    ]
  };

  

  
  

  var faTabletScreenButton = {
    prefix: 'fal',
    iconName: 'tablet-screen-button',
    icon: [
      448,
      512,
      ["tablet-alt"],
      'f3fa',
      
      'M384 32c17.7 0 32 14.3 32 32l0 256L32 320 32 64c0-17.7 14.3-32 32-32l320 0zm32 320l0 96c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-96 384 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM248 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faTabletAlt = faTabletScreenButton;
  

  
  

  var faCircleNotch = {
    prefix: 'fal',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      'M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z'
      
    ]
  };

  

  
  

  var faRainbow = {
    prefix: 'fal',
    iconName: 'rainbow',
    icon: [
      640,
      512,
      [127752],
      'f75b',
      
      'M320 64C160.9 64 32 192.9 32 352l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 352C0 175.3 143.3 32 320 32s320 143.3 320 320l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112C608 192.9 479.1 64 320 64zm0 192c-53 0-96 43-96 96l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-70.7 57.3-128 128-128s128 57.3 128 128l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-53-43-96-96-96zM128 352l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-123.7 100.3-224 224-224s224 100.3 224 224l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-106-86-192-192-192s-192 86-192 192z'
      
    ]
  };

  

  
  

  var faEarthAfrica = {
    prefix: 'fal',
    iconName: 'earth-africa',
    icon: [
      512,
      512,
      [127757,"globe-africa"],
      'f57c',
      
      'M480 256c0-16.8-1.8-33.1-5.3-48.8l-47.2-11.8c-4.1-1-8.4 .2-11.3 3.1c-2 2-3.6 4.2-4.9 6.7l-.3 .6c-7.9 15.8-22.1 27.3-38.6 31.9l15.1 15.1c8 8 12.5 18.9 12.5 30.2c0 19.5-13.2 36.5-32 41.4l0 6.2c0 17.3-5.6 34.2-16 48l-25.6 34.1C317.3 424.9 303.1 432 288 432c-26.5 0-48-21.5-48-48l0-48-32 0c-35.3 0-64-28.7-64-64l0-28c0-17.6 8.3-34.2 22.4-44.8l39.4-29.5c8.4-6.3 18.5-9.7 29-9.7c5.2 0 10.3 .8 15.3 2.5l32 10.7c4.3 1.4 9 1.6 13.4 .5l34.3-8.6c3.7-.9 6.3-4.3 6.3-8.1c0-2.8-1.4-5.4-3.7-6.9L306 132.6c-7.6 7.3-17.7 11.4-28.2 11.4c-6.3 0-12.5-1.5-18.2-4.3l-13.2-6.6c-23.9 36.9-83 14.6-74.9-30.2L175 84.3c.4-2 .2-4.1-.4-6.1l-9-27.1C86.9 85.8 32 164.5 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zm-16.5-84.6C430.1 89.6 349.8 32 256 32c-20.9 0-41.2 2.9-60.4 8.2l9.3 27.8c2.4 7.1 2.9 14.6 1.6 22l-3.4 18.7c-1.9 10.2 12 15.2 17.1 6.1c7.4-13.4 24.1-18.5 37.8-11.7l16 8c1.2 .6 2.5 .9 3.8 .9c2.3 0 4.5-.9 6.1-2.5l3.5-3.5c8.5-8.5 21.7-9.8 31.7-3.1L350 123.5c11.2 7.5 18 20.1 18 33.5c0 18.5-12.6 34.6-30.5 39.1l-34.3 8.6c-10.3 2.6-21.2 2.2-31.3-1.2l-32-10.7c-1.7-.6-3.4-.8-5.1-.8c-3.5 0-7 1.1-9.8 3.3l-39.4 29.5c-6 4.5-9.6 11.6-9.6 19.2l0 28c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 48c0 8.8 7.2 16 16 16c5 0 9.8-2.4 12.8-6.4l25.6-34.1c6.2-8.3 9.6-18.4 9.6-28.8l0-12.1c0-11.2 7.6-21 18.5-23.7l5.3-1.3c4.8-1.2 8.2-5.5 8.2-10.5c0-2.9-1.1-5.6-3.2-7.6l-40.2-40.2c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l19.7 0c11.3 0 21.6-6.4 26.7-16.5l.3-.6c2.8-5.6 6.4-10.7 10.9-15.1c10.9-10.9 26.8-15.3 41.7-11.6l28.2 7.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faGlobeAfrica = faEarthAfrica;
  

  
  

  var faElephant = {
    prefix: 'fal',
    iconName: 'elephant',
    icon: [
      640,
      512,
      [128024],
      'f6da',
      
      'M224 111.8C224 67.7 259.7 32 303.8 32c41.5 0 76.1 31.8 79.6 73.2l.7 8.1c.7 8.8 8.5 15.3 17.3 14.6s15.4-8.5 14.6-17.3l-.7-8.1c-1.1-13-4.4-25.4-9.5-36.7C466.1 76.2 512 128.7 512 192l0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-88.4-71.6-160-160-160l-1.9 0c-20.2-19.9-48-32-78.3-32c-30.5 0-58.2 12.3-78.4 32.1C118 35.6 32 123.7 32 232l0 32s0 0 0 0l0 19.1c0 25.4-8.7 50.1-24.5 70L3.5 358C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90L64 264s0 0 0 0l0-32c0-82.4 59.3-150.9 137.4-165.2c-6.1 13.8-9.4 29-9.4 45.1c0 58.2 44.6 106.6 102.5 111.4l8.1 .7c8.8 .7 16.5-5.8 17.3-14.6s-5.8-16.5-14.6-17.3l-8.1-.7c-41.4-3.4-73.2-38-73.2-79.6zM413.4 295.3c-2.9-4.4-7.8-7.3-13.4-7.3c-8.8 0-16 7.2-16 16l0 160c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-80c0-.7 0-1.4-.1-2c.5-3.8-.4-7.8-2.7-11.2c-5.1-7.2-15-9-22.3-4C279.3 377.6 260.4 384 240 384s-39.3-6.4-54.8-17.2c-7.2-5.1-17.2-3.3-22.3 4c-2.4 3.4-3.2 7.4-2.7 11.2c-.1 .7-.1 1.4-.1 2l0 80c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-57.3c14.8 6 31 9.3 48 9.3s33.2-3.3 48-9.3l0 57.3c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-114.4c7.2 7.2 14.7 13.2 22.8 18.1c3 1.9 6.1 3.5 9.2 5l0 10.4c0 53.5 43.4 96.9 96.9 96.9c44.4 0 83.2-30.2 94-73.4l.7-2.7c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-.7 2.7c-7.2 28.9-33.2 49.1-62.9 49.1C509 448 480 419 480 383.1l0-.8c7.7 1.1 15.6 1.7 24 1.7c36.6 0 73.4-10.3 99.4-36.8c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2c-18 18.4-45.3 27.2-76.6 27.2c-20.5 0-35.4-3.6-48.6-11.7c-13.5-8.2-26.6-22-42-45zM480 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSquareB = {
    prefix: 'fal',
    iconName: 'square-b',
    icon: [
      448,
      512,
      [],
      'e264',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 64c0-17.7 14.3-32 32-32l88 0c39.8 0 72 32.2 72 72c0 19.3-7.6 36.8-19.9 49.7C321.6 262.2 336 285.4 336 312c0 39.8-32.2 72-72 72l-104 0c-17.7 0-32-14.3-32-32l0-96 0-96zm160 40c0-22.1-17.9-40-40-40l-88 0 0 80 88 0c22.1 0 40-17.9 40-40zM160 352l104 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-16 0-88 0 0 80z'
      
    ]
  };

  

  
  

  var faCodePullRequestDraft = {
    prefix: 'fal',
    iconName: 'code-pull-request-draft',
    icon: [
      448,
      512,
      [],
      'e3fa',
      
      'M32 80a48 48 0 1 1 96 0A48 48 0 1 1 32 80zm64 78.4c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4l0 195.2C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-195.2zM32 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM400 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM368 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faW = {
    prefix: 'fal',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      'M10.5 33c8.3-3 17.5 1.2 20.5 9.5l135.2 370L272.6 43.6c2-6.8 8.2-11.6 15.4-11.6s13.4 4.7 15.4 11.6L409.8 412.5 545 42.5c3-8.3 12.2-12.6 20.5-9.5s12.6 12.2 9.5 20.5l-152 416c-2.4 6.5-8.7 10.7-15.6 10.5s-12.9-4.9-14.8-11.6L288 105.7 183.4 468.4c-1.9 6.6-7.9 11.3-14.8 11.6s-13.2-4-15.6-10.5L1 53.5C-2.1 45.2 2.2 36 10.5 33z'
      
    ]
  };

  

  
  

  var faGiftCard = {
    prefix: 'fal',
    iconName: 'gift-card',
    icon: [
      576,
      512,
      [],
      'f663',
      
      'M397.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1 11.1 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-2.9 0zm-130 96l-45-72.1C212.8 41 196.5 32 178.9 32L176 32c-26.5 0-48 21.5-48 48s21.5 48 48 48l80 0 11.1 0zM288 101l38.8-62c15.1-24.2 41.7-39 70.3-39L400 0c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48l48 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l48 0c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80l2.9 0c28.6 0 55.2 14.7 70.3 39L288 101zM176 160L64 160c-17.7 0-32 14.3-32 32l0 96 512 0 0-96c0-17.7-14.3-32-32-32l-112 0-77.8 0 58.1 69.8c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2L288 169l-67.7 81.3c-5.7 6.8-15.7 7.7-22.5 2s-7.7-15.7-2-22.5L253.8 160 176 160zM32 320l0 64 512 0 0-64L32 320zM544 448l0-32L32 416l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32z'
      
    ]
  };

  

  
  

  var faTruckMonster = {
    prefix: 'fal',
    iconName: 'truck-monster',
    icon: [
      640,
      512,
      [],
      'f63b',
      
      'M264 32c-4.4 0-8 3.6-8 8l0 88 206.4 0L389.2 37.9c-3-3.7-7.6-5.9-12.4-5.9L264 32zM96 128l128 0 0-88c0-22.1 17.9-40 40-40L376.8 0c14.5 0 28.1 6.5 37.3 17.7L503.6 128l40.4 0c35.3 0 64 28.7 64 64l0 48-1 0c4.4 3.9 8.6 8 12.6 12.2c6.1 6.4 5.8 16.6-.7 22.6s-16.6 5.8-22.6-.7C567.2 243.3 525.8 224 480 224c-56.2 0-105.6 28.9-134.1 72.7c-3 4.5-8 7.3-13.4 7.3l-24.9 0c-5.4 0-10.4-2.7-13.4-7.3C265.6 252.9 216.2 224 160 224c-45.8 0-87.2 19.3-116.4 50.2c-6.1 6.4-16.2 6.7-22.6 .7s-6.7-16.2-.7-22.6c3.7-3.9 7.6-7.7 11.6-11.3L32 192c0-35.3 28.7-64 64-64zM64 217.7c28.2-16.3 61-25.7 96-25.7c64.3 0 121.1 31.6 156 80l8.1 0c34.8-48.4 91.7-80 156-80c35 0 67.8 9.4 96 25.7l0-25.7c0-17.7-14.3-32-32-32l-47.9 0-.3 0L240 160 96 160c-17.7 0-32 14.3-32 32l0 25.7zM154 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8l0 12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4l12 0c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8l0-12c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4l-12 0zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5l12 0c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36l0 12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5l-12 0c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6C33.2 411.5 24 397.8 24 382l0-12c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM213.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zm252.7-97.6c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8l0 12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4l12 0c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8l0-12c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4l-12 0c-3.9 0-7.1 2.7-7.8 6.4zM474 240l12 0c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36l0 12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5l-12 0c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6c-13.3-6.5-22.5-20.1-22.5-36l0-12c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6c6.5-13.3 20.1-22.5 36-22.5zM458.5 376a21.5 21.5 0 1 0 43 0 21.5 21.5 0 1 0 -43 0zM480 429.5a53.5 53.5 0 1 1 0-107 53.5 53.5 0 1 1 0 107z'
      
    ]
  };

  

  
  

  var faScarecrow = {
    prefix: 'fal',
    iconName: 'scarecrow',
    icon: [
      448,
      512,
      [],
      'f70d',
      
      'M224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 32c-36.8 0-69.2-19.1-87.7-48l-74.5 0c4 7 2.3 15.9-4.3 20.8L42.7 192l14.9 11.2c6.5 4.9 8.3 13.8 4.3 20.8l62.6 0c20.2 0 35.3 18.5 31.4 38.3L134.6 368.7l25.5-14.6c4.9-2.8 11-2.8 15.9 0L224 381.6l48.1-27.5c4.9-2.8 11-2.8 15.9 0l25.5 14.6L292.1 262.3c-4-19.8 11.2-38.3 31.4-38.3l62.6 0c-4-7-2.3-15.9 4.3-20.8L405.3 192l-14.9-11.2c-6.5-4.9-8.3-13.8-4.3-20.8l-74.5 0c-18.5 28.9-50.8 48-87.7 48zM328 104c0 8.3-1 16.3-2.8 24l90.8 0c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-92.5 0 28.2 140.9c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3 .9L280 386.4l-48.1 27.5c-4.9 2.8-11 2.8-15.9 0L168 386.4l-48.1 27.5c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1L124.5 256 32 256c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l7.6-11.4L6.4 204.8C2.4 201.8 0 197 0 192s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5l90.8 0c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM176 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 496l0-50.7c10.3 3.7 21.7 3.7 32 0l0 50.7c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faAlarmSnooze = {
    prefix: 'fal',
    iconName: 'alarm-snooze',
    icon: [
      512,
      512,
      [],
      'f845',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm-64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l94.7 0L179.5 358c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-94.7 0L332.5 218c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1l-128 0z'
      
    ]
  };

  

  
  

  var faSprayCan = {
    prefix: 'fal',
    iconName: 'spray-can',
    icon: [
      512,
      512,
      [],
      'f5bd',
      
      'M192 32l0 64 32 0 0-64c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 64 32 0 0-64 64 0zm96 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 72c35.3 0 64 28.7 64 64l0 216c0 22.1-17.9 40-40 40L72 480c-22.1 0-40-17.9-40-40l0-216c0-35.3 28.7-64 64-64l128 0zM96 128c-53 0-96 43-96 96L0 440c0 39.8 32.2 72 72 72l176 0c39.8 0 72-32.2 72-72l0-216c0-53-43-96-96-96L96 128zm64 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM408 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM408 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faShishKebab = {
    prefix: 'fal',
    iconName: 'shish-kebab',
    icon: [
      512,
      512,
      [],
      'f821',
      
      'M352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 14.4-4.8 27.7-12.8 38.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c12.1-16 19.2-36 19.2-57.6c0-53-43-96-96-96s-96 43-96 96c0 12.7 2.5 24.9 7 36.1c5.7 14 4.2 26.1-1.5 31.8l-8.8 8.8-30.1-30.1C272.1 128.1 252.5 120 232 120s-40.1 8.1-54.6 22.6l-18.7 18.7C144.1 175.9 136 195.5 136 216c0 6.2 .7 12.3 2.2 18.2c-5.9-1.4-12-2.2-18.2-2.2c-20.5 0-40.1 8.1-54.6 22.6L46.6 273.4C32.1 287.9 24 307.5 24 328s8.1 40.1 22.6 54.6l30.1 30.1-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72 30.1 30.1C143.9 479.9 163.5 488 184 488s40.1-8.1 54.6-22.6l18.7-18.7C271.9 432.1 280 412.5 280 392c0-6.2-.7-12.3-2.2-18.2c5.9 1.4 12 2.2 18.2 2.2c20.5 0 40.1-8.1 54.6-22.6l18.7-18.7C383.9 320.1 392 300.5 392 280s-8.1-40.1-22.6-54.6l-30.1-30.1 8.8-8.8c19.3-19.3 16.2-47.7 8.6-66.4c-3-7.4-4.7-15.5-4.7-24.1zM181.3 248c-8.5-8.5-13.3-20-13.3-32s4.8-23.5 13.3-32L200 165.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3L346.7 248c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L328 330.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L181.3 248zM69.3 360C60.8 351.5 56 340 56 328s4.8-23.5 13.3-32L88 277.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3L234.7 360c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L216 442.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L69.3 360z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueSquint = {
    prefix: 'fal',
    iconName: 'face-grin-tongue-squint',
    icon: [
      512,
      512,
      [128541,"grin-tongue-squint"],
      'f58a',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm104.5-65.7L171.9 208l-35.4 17.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-64-32c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5zm246.2-21.5c-4-7.9-13.6-11.1-21.5-7.2l-64 32c-5.4 2.7-8.8 8.3-8.8 14.3s3.4 11.6 8.8 14.3l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5L340.2 208l35.4-17.7c7.9-4 11.1-13.6 7.2-21.5zM352 416l0-32.6c20.2-15.7 36.4-36.2 46.9-59.9c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c10.4 23.6 26.6 44.1 46.8 59.8l0 32.7c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z'
      
    ]
  };

  
    var faGrinTongueSquint = faFaceGrinTongueSquint;
  

  
  

  var faArrowDown91 = {
    prefix: 'fal',
    iconName: 'arrow-down-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-desc","sort-numeric-down-alt"],
      'f886',
      
      'M428 64a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4c0 0 .1 0 .1 0c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6L429.3 200c-.4 0-.9 0-1.3 0c-46.4 0-84-37.6-84-84zM267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM448 304l0 144 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-121.8-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13z'
      
    ]
  };

  
    var faSortNumericDesc = faArrowDown91;
  
    var faSortNumericDownAlt = faArrowDown91;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fal',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 352c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7c0-15.2-12.3-27.5-27.5-27.5l-201 0c-15.2 0-27.5 12.3-27.5 27.5c0 6.9 2.6 13.6 7.3 18.7L230.8 341c6.5 7 15.6 11 25.2 11zm1.7-32.7c-.4 .5-1.1 .7-1.7 .7s-1.3-.3-1.7-.7L165.8 224l180.3 0-88.4 95.3z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCalendarImage = {
    prefix: 'fal',
    iconName: 'calendar-image',
    icon: [
      448,
      512,
      [],
      'e0d4',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zM230 265.4c12.5-18.1 39.2-18.4 52.2-.6l96.3 132.4c15.4 21.2 .3 50.8-25.9 50.8L95.1 448c-26 0-41.2-29.4-26-50.6l51-71.3c11.5-16.1 34.7-18 48.7-4l13.1 13.1L230 265.4zM352.6 416L256.3 283.6l-59.2 85.5c-2.7 3.9-7 6.4-11.7 6.8s-9.4-1.3-12.8-4.6L146 344.7 95.1 416l257.5 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCircleM = {
    prefix: 'fal',
    iconName: 'circle-m',
    icon: [
      512,
      512,
      [],
      'e115',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM157.1 134.8c-4-5.7-11.3-8.2-17.9-6.1S128 137 128 144l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-173.2 82.9 118.4c3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8L352 194.8 352 368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-7-4.5-13.2-11.2-15.3s-13.9 .4-17.9 6.1L256 276.1 157.1 134.8z'
      
    ]
  };

  

  
  

  var faDialMax = {
    prefix: 'fal',
    iconName: 'dial-max',
    icon: [
      576,
      512,
      [],
      'e15e',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm90.5 322.5l-.4 .4 .8-.8-.4 .4zM299.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l89.8 89.8c-50.2 39.1-122.8 35.5-169-10.6c-50-50-50-131 0-181s131-50 181 0c46.2 46.2 49.7 118.8 10.6 169l-89.8-89.8zM401.1 401.1A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPersonDrowning = {
    prefix: 'fal',
    iconName: 'person-drowning',
    icon: [
      576,
      512,
      [],
      'e545',
      
      'M144 32c8.8 0 16 7.2 16 16l0 41c0 63.4 41.9 119.2 102.7 137c47.9 14 98.7 14 146.5 0l114.2-33.3c8.5-2.5 17.4 2.4 19.8 10.9s-2.4 17.4-10.9 19.8L418.2 256.7c-16.9 4.9-34.1 8.3-51.5 10.1l-14 111.8c-9.6-3.5-19.1-8.4-28-14.5c-.8-.5-1.5-1-2.3-1.5l11.8-94.2c-27.1-.2-54.2-4.1-80.6-11.7c-5.6-1.6-11.1-3.5-16.4-5.7L218.2 380.3c-8.5 2.6-17.3 4.1-26.2 4.1c-2.2 0-4.5-.1-6.7-.3l22-148.8C158.8 203.7 128 149.2 128 89l0-41c0-8.8 7.2-16 16-16zM320 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 448c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z'
      
    ]
  };

  

  
  

  var faGrapes = {
    prefix: 'fal',
    iconName: 'grapes',
    icon: [
      512,
      512,
      [],
      'e306',
      
      'M447.5 221.1c-4.5-10.7-10.5-20.6-17.9-29.3c21.6-2 40.7-14.9 50.2-22.8c0 0 0 0 0-.1c.1-.1 .2-.4 .2-.9c0-.4-.1-.7-.1-.8C469.7 159.1 446.4 144 416 144c-14.7 0-22.9 1.8-26.9 3.2c-1.6 .6-2.6 1-2.9 1.2c-6.3 5.2-15.6 4.8-21.4-1.1s-6.2-15.2-1.1-21.4c.2-.4 .7-1.3 1.2-2.9c1.3-4 3.2-12.2 3.2-26.9c0-30.4-15.1-53.7-23.2-63.9c-.1 0-.4-.1-.8-.1c-.5 0-.8 .1-.9 .2c0 0 0 0-.1 0c-7.9 9.6-20.8 28.6-22.8 50.2C311.5 75 301.7 69 290.9 64.5c6.1-24.5 20-43.7 27.4-52.7C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1C379.8 24.8 400 55.1 400 96c0 6.3-.3 11.9-.8 16.8c4.9-.5 10.5-.8 16.8-.8c40.9 0 71.2 20.2 83.9 30.2c8.4 6.7 12.1 16.5 12.1 25.8c0 9.2-3.7 19-11.8 25.7c-9 7.4-28.2 21.3-52.7 27.4zM320 456c-18.4 0-35.2-6.9-47.9-18.2c-12.4 25-38.3 42.2-68.1 42.2c-19 0-36.3-7-49.6-18.4C142.6 491.1 113.7 512 80 512c-44.2 0-80-35.8-80-80c0-33.7 20.9-62.6 50.4-74.4C39 344.3 32 327 32 308c0-29.8 17.2-55.7 42.2-68.1C62.9 227.2 56 210.4 56 192c0-39.8 32.2-72 72-72c17.6 0 33.8 6.3 46.3 16.9C186.4 108.1 214.9 88 248 88c44.2 0 80 35.8 80 80c0 6.2-.7 12.2-2 18c5.8-1.3 11.8-2 18-2c44.2 0 80 35.8 80 80c0 33.1-20.1 61.6-48.9 73.7C385.7 350.2 392 366.4 392 384c0 39.8-32.2 72-72 72zM296 168a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 232a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm144 56a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM108 352a44 44 0 1 0 0-88 44 44 0 1 0 0 88zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm124-32a44 44 0 1 0 0-88 44 44 0 1 0 0 88zm156-64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-16-72a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fal',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M480 64L32 64l0 64 32 0 384 0 32 0 0-64zm0 96l-32 0L64 160l-32 0c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32zM160 240c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm288-48l32 0 0 224c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-224 32 0 0 224c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-224z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faFaceSmileHorns = {
    prefix: 'fal',
    iconName: 'face-smile-horns',
    icon: [
      640,
      512,
      [],
      'e391',
      
      'M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM552.4 148.6c-12.2-26.4-28.8-50.4-48.8-71c13.1-3 27.6-6.8 42.3-11.2c17.7-5.3 36.2-11.7 53.2-19.1c-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2c-20 20.6-36.6 44.6-48.8 71C65.5 114.3 50.2 76.2 40.9 47.3c17 7.4 35.5 13.8 53.2 19.1zM205.5 347.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 370.2 363.4 392 320 392s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      
    ]
  };

  

  
  

  var faToggleOff = {
    prefix: 'fal',
    iconName: 'toggle-off',
    icon: [
      576,
      512,
      [],
      'f204',
      
      'M416 128c70.7 0 128 57.3 128 128s-57.3 128-128 128l-256 0C89.3 384 32 326.7 32 256s57.3-128 128-128l256 0zM576 256c0-88.4-71.6-160-160-160L160 96C71.6 96 0 167.6 0 256s71.6 160 160 160l256 0c88.4 0 160-71.6 160-160zm-352 0A64 64 0 1 1 96 256a64 64 0 1 1 128 0zM64 256a96 96 0 1 0 192 0A96 96 0 1 0 64 256z'
      
    ]
  };

  

  
  

  var faDialOff = {
    prefix: 'fal',
    iconName: 'dial-off',
    icon: [
      576,
      512,
      [],
      'e162',
      
      'M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 288l0 127c-63.1-7.9-112-61.7-112-127c0-70.7 57.3-128 128-128s128 57.3 128 128c0 65.3-48.9 119.1-112 127l0-127c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFaceAwesome = {
    prefix: 'fal',
    iconName: 'face-awesome',
    icon: [
      512,
      512,
      ["gave-dandy"],
      'e409',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 208l-80 0 0-16c0-22.1 17.9-40 40-40c.5 0 .9 0 1.4 0c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24c5.2 0 10.1-1.7 14-4.5c1.3 3.9 2 8.1 2 12.5l0 16zm-40-88c-39.8 0-72 32.2-72 72l0 16c0 17.7 14.3 32 32 32l80 0c17.7 0 32-14.3 32-32l0-16c0-39.8-32.2-72-72-72zm236.1 53.1c2.5 5.8 3.9 12.2 3.9 18.9l0 16-96 0 0-16c0-26.5 21.5-48 48-48c2 0 3.9 .1 5.8 .3c-3.6 4.2-5.8 9.7-5.8 15.7c0 13.3 10.7 24 24 24c8.4 0 15.8-4.3 20.1-10.9zM256 192l0 17.9c0 16.6 13.5 30.1 30.1 30.1l99.8 0c16.6 0 30.1-13.5 30.1-30.1l0-17.9c0-44.2-35.8-80-80-80s-80 35.8-80 80zm4.7 224L248 416c-2 0-4 0-5.9-.1c7.2-27.5 32.2-47.9 61.9-47.9c15.9 0 30.5 5.8 41.7 15.5c-2.8 2.7-5.7 5.2-8.7 7.6c-21.5 15.7-47.9 24.9-76.3 24.9zm-50.6-4.2c-51.5-12.9-91.9-54.6-102.3-107.8l281.1 0c-2.8 20.6-10.3 39.6-21.5 55.9C350.4 345 328.3 336 304 336c-46.1 0-84.6 32.5-93.9 75.8zm146.2 4.8c36-26.5 60.7-67.7 65-115.3c1.4-15.7-11-29.3-26.8-29.3L92.8 272c-11.2 0-19.9 9.6-18.9 20.7c8 88 81.7 155.3 170.1 155.3l4.1 0 12.7 0 4.7 0c34.2 0 65.8-11.7 90.9-31.4z'
      
    ]
  };

  
    var faGaveDandy = faFaceAwesome;
  

  
  

  var faSquareV = {
    prefix: 'fal',
    iconName: 'square-v',
    icon: [
      448,
      512,
      [],
      'e284',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm126.3 56.8L224 348.2l97.7-195.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-112 224c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8l-112-224c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2z'
      
    ]
  };

  

  
  

  var faDrumstick = {
    prefix: 'fal',
    iconName: 'drumstick',
    icon: [
      512,
      512,
      [127831],
      'f6d6',
      
      'M192 272l0-96c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144l-96 0c-26.5 0-48-21.5-48-48zm-32-96l0 96c0 3 .2 6 .5 8.9L121.4 320c0 0 0 0-.1 0c-.1 0-.5 .1-1.2 .1c-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-16.1-5.3-30.9-14.2-42.9c-1.2-1.7-1.9-3.7-2-5.2c0-.7 .1-1.1 .1-1.2c0 0 0 0 0-.1c0 0 0 0 0 0l39.1-39.1c2.9 .3 5.9 .5 8.9 .5l96 0c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176zm12.2 138.4c6.4 10.3 15.1 18.9 25.4 25.4L169.3 368c-15 15-9.9 36.5-1.2 48.1c4.9 6.7 7.9 14.9 7.9 23.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9c11.7 8.7 33.2 13.7 48.1-1.2l28.2-28.2z'
      
    ]
  };

  

  
  

  var faBroomBall = {
    prefix: 'fal',
    iconName: 'broom-ball',
    icon: [
      576,
      512,
      ["quidditch","quidditch-broom-ball"],
      'f458',
      
      'M571.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-208 208 45.3 45.3c4.8 4.8 7.4 11.2 7.4 17.9c0 12.4-9 23-21.2 25l-54.7 9.1 1.4 9.8c6.6 46.3-9 93-42 126c-27.8 27.8-65.6 43.5-105 43.5L22.6 512C10.1 512 0 501.9 0 489.4c0-6 2.4-11.8 6.6-16l59.7-59.7 15-15L96 384l-14.7 0c-8.3 0-15.3-5.8-16.9-13.6c-.3-1.2-.4-2.4-.4-3.7c0-29.9 11.9-58.5 33-79.7l10.5-10.5c33.1-33.1 79.7-48.6 126-42l9.8 1.4 9.1-54.7c2-12.2 12.6-21.2 25-21.2c6.7 0 13.2 2.7 17.9 7.4l45.3 45.3 208-208c6.2-6.2 16.4-6.2 22.6 0zm-238 296.6l43.5-7.2-94.9-94.9-7.2 43.5 58.7 58.7zm-79.6-31.6L229 266.2c-36.3-5.2-72.9 7-98.9 33l-10.5 10.5C108 321.3 100.3 336.1 97.3 352c12.4 .5 23.4 8.2 28.2 19.7c5 12 2.2 25.7-6.9 34.9L45.3 480l149.2 0c30.9 0 60.5-12.3 82.4-34.1c25.9-25.9 38.1-62.6 33-98.9l-3.5-24.7-52.6-52.6zM512 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faQuidditch = faBroomBall;
  
    var faQuidditchBroomBall = faBroomBall;
  

  
  

  var faUp = {
    prefix: 'fal',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      'M189.7 64l4.6 0c4.4 0 8.6 1.8 11.6 5L348.5 218.8c2.2 2.3 3.5 5.4 3.5 8.7c0 6.9-5.6 12.6-12.6 12.6L256 240c-8.8 0-16 7.2-16 16l0 176c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-176c0-8.8-7.2-16-16-16l-83.4 0c-6.9 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7L178.1 69c3-3.2 7.2-5 11.6-5zM384 227.4c0-11.4-4.4-22.5-12.3-30.7L229 46.9C220 37.4 207.4 32 194.3 32l-4.6 0C176.6 32 164 37.4 155 46.9L12.3 196.7C4.4 205 0 216 0 227.4C0 252 20 272 44.6 272l67.4 0 0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160 67.4 0c24.6 0 44.6-20 44.6-44.6z'
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faFence = {
    prefix: 'fal',
    iconName: 'fence',
    icon: [
      512,
      512,
      [],
      'e303',
      
      'M64 32c5 0 9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2l0 42.7 64 0 0-42.7c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2l0 42.7 64 0 0-42.7c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2L512 448c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-64 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-64 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 117.3c0-6.9 2.2-13.7 6.4-19.2L51.2 38.4c3-4 7.8-6.4 12.8-6.4zM288 384l0-32 0-160 0-32 0-42.7L256 74.7l-32 42.7L224 448l64 0 0-64zm32-32l64 0 0-160-64 0 0 160zm96 0l0 32 0 64 64 0 0-330.7L448 74.7l-32 42.7L416 352zM192 192l-64 0 0 160 64 0 0-160zm-96 0l0-32 0-42.7L64 74.7 32 117.3 32 448l64 0 0-64 0-32 0-160z'
      
    ]
  };

  

  
  

  var faBlindsOpen = {
    prefix: 'fal',
    iconName: 'blinds-open',
    icon: [
      512,
      512,
      [],
      'f8fc',
      
      'M32 0C14.3 0 0 14.3 0 32L0 64C0 81.7 14.3 96 32 96l96 0 0 162.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 96l320 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0zm0 32l448 0 0 32L32 64l0-32zm96 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0-32-80 0zm176 32l304 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-304 0 0 32zM0 496c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480c-8.8 0-16 7.2-16 16zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c-7-9.3-12-20.2-14.4-32L16 320zm480 32c8.8 0 16-7.2 16-16s-7.2-16-16-16l-273.6 0c-2.4 11.8-7.4 22.7-14.4 32l288 0z'
      
    ]
  };

  

  
  

  var faWebhook = {
    prefix: 'fal',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      'M192 128c0-53 43-96 96-96s96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C416 57.3 358.7 0 288 0S160 57.3 160 128c0 40 18.4 75.8 47.1 99.2L147.3 323c-6.1-1.9-12.6-3-19.3-3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-17.1-6.7-32.6-17.6-44.1L238 238.2c7.2-11.5 3.2-25.5-6.5-32.7C207.5 188.1 192 159.9 192 128zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64-32c0 35.3 28.7 64 64 64c6.7 0 13.2-1 19.3-3l63.5 101.7c7.2 11.5 21.6 14.1 32.2 8.4C416.5 292 431.7 288 448 288c53 0 96 43 96 96s-43 96-96 96c-18.7 0-36.1-5.3-50.9-14.6c-7.5-4.7-17.4-2.4-22.1 5.1s-2.4 17.4 5.1 22.1c19.7 12.3 43 19.5 67.9 19.5c70.7 0 128-57.3 128-128s-57.3-128-128-128c-19.2 0-37.4 4.2-53.8 11.8l-59.8-95.7c10.9-11.5 17.6-27 17.6-44.1c0-35.3-28.7-64-64-64s-64 28.7-64 64zM73.2 305.2c7.2-5.1 9-15 4-22.3s-15-9-22.3-4C21.7 302.1 0 340.5 0 384c0 70.7 57.3 128 128 128c65.3 0 119.1-48.9 127-112l131 0c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48l-138 0c-13.5 0-23.4 10.8-24.2 22.9C220.2 440.7 178.7 480 128 480c-53 0-96-43-96-96c0-32.6 16.2-61.4 41.2-78.8zM480 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faScrollTorah = {
    prefix: 'fal',
    iconName: 'scroll-torah',
    icon: [
      640,
      512,
      ["torah"],
      'f6a0',
      
      'M96 448L96 64c0-17.7-14.3-32-32-32S32 46.3 32 64l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32zM64 0c23.7 0 44.4 12.9 55.4 32l8.6 0 384 0 8.6 0C531.6 12.9 552.3 0 576 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-8.6 0-384 0-8.6 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM576 480c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32zm-64-32l0-384L128 64l0 384 384 0zM172 322.9c0-4.1 1.1-8.2 3.2-11.8l32.3-55-32.3-55c-2.1-3.6-3.2-7.6-3.2-11.8c0-12.9 10.4-23.3 23.3-23.3l65 0 36-61.3c4.6-7.9 13.1-12.7 22.2-12.7s17.6 4.8 22.2 12.7l36 61.3 65 0c12.9 0 23.3 10.4 23.3 23.3c0 4.1-1.1 8.2-3.2 11.8l-32.3 55 32.3 55c2.1 3.6 3.2 7.6 3.2 11.8c0 12.9-10.4 23.3-23.3 23.3l-65 0-36 61.3c-4.6 7.9-13.1 12.7-22.2 12.7s-17.6-4.8-22.2-12.7l-36-61.3-65 0c-12.9 0-23.3-10.4-23.3-23.3zm146.5 59.2l21.1-35.9-42.2 0 21.1 35.9zm-39.9-67.9l79.7 0 34.1-58-34.1-58-79.7 0-34.1 58 34.1 58zm147.9 0L411 287.7l-15.5 26.4 31 0zm0-116.1l-31 0L411 224.5 426.5 198zm-108-67.9L297.4 166l42.2 0-21.1-35.9zM226 224.5L241.5 198l-31 0L226 224.5zm15.5 89.7L226 287.7l-15.5 26.4 31 0z'
      
    ]
  };

  
    var faTorah = faScrollTorah;
  

  
  

  var faDownRight = {
    prefix: 'fal',
    iconName: 'down-right',
    icon: [
      384,
      512,
      [],
      'e16b',
      
      'M312 384c4.4 0 8-3.6 8-8l0-201.4c0-3.7-3-6.6-6.6-6.6c-1.8 0-3.4 .7-4.7 1.9l-61.4 61.4c-6.2 6.2-16.4 6.2-22.6 0L112 118.6c-4.2-4.2-10-6.6-16-6.6s-11.8 2.4-16 6.6L54.6 144c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L167.3 288.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3l-61.4 61.4c-1.2 1.2-1.9 2.9-1.9 4.7c0 3.7 3 6.6 6.6 6.6L312 384zm40-8c0 22.1-17.9 40-40 40l-201.4 0C89.3 416 72 398.7 72 377.4c0-10.2 4.1-20.1 11.3-27.3L133.4 300 32 198.6C21.8 188.4 16 174.5 16 160s5.8-28.4 16-38.6L57.4 96C67.6 85.8 81.5 80 96 80s28.4 5.8 38.6 16L236 197.4l50.1-50.1c7.2-7.2 17.1-11.3 27.3-11.3c21.3 0 38.6 17.3 38.6 38.6L352 376z'
      
    ]
  };

  

  
  

  var faPersonArrowUpFromLine = {
    prefix: 'fal',
    iconName: 'person-arrow-up-from-line',
    icon: [
      640,
      512,
      [],
      'e539',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160l25.4 0c6.8 0 13.3 1.4 19.3 4l0 156-64 0 0-156c6-2.6 12.5-4 19.3-4zM160 480l0-128 64 0 0 128-64 0zm-32 0L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 96 0 384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-368 0 0-277.8 49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L275.3 170.3c-13.9-26-41-42.3-70.6-42.3l-25.4 0c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.1 128 480zM603.3 132.7l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 86.6 480 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-313.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faBowlingPins = {
    prefix: 'fal',
    iconName: 'bowling-pins',
    icon: [
      512,
      512,
      [],
      'f437',
      
      'M128 32c-22.1 0-40 17.9-40 40l0 4.4c0 6.4 .8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2l48.4 0c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19l0-4.4c0-22.1-17.9-40-40-40zM91.9 230.9L61.1 301.4C52.5 321.1 48 342.5 48 364.1c0 26.2 6.6 51.9 19.1 74.9L89.5 480l77 0 22.4-41.1c12.5-23 19.1-48.7 19.1-74.9c0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9l-50.5 0c-1.8 13.4-5.4 26.5-10.8 38.9zM56 72C56 32.2 88.2 0 128 0s72 32.2 72 72l0 4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2l0 5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5c0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5l-86.5 0c-8.8 0-16.9-4.8-21.1-12.5L39 454.2c-15.1-27.7-23-58.7-23-90.2c0-26 5.4-51.7 15.8-75.5l30.8-70.4C68.8 204 72 188.7 72 173.2l0-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4C57.1 94.4 56 85.4 56 76.4L56 72zM384 32c-22.1 0-40 17.9-40 40l0 4.4c0 6.4 .8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2l48.4 0c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19l0-4.4c0-22.1-17.9-40-40-40zM347.9 230.9l-30.8 70.4c-8.6 19.8-13.1 41.1-13.1 62.7c0 26.2 6.6 51.9 19.1 74.9L345.5 480l77 0 22.4-41.1c12.5-23 19.1-48.7 19.1-74.9c0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9l-50.5 0c-1.8 13.4-5.4 26.5-10.8 38.9zM312 72c0-39.8 32.2-72 72-72s72 32.2 72 72l0 4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2l0 5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5c0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5l-86.5 0c-8.8 0-16.9-4.8-21.1-12.5L295 454.2c-15.1-27.7-23-58.7-23-90.2c0-26 5.4-51.7 15.8-75.5l30.8-70.4c6.2-14.2 9.4-29.4 9.4-44.9l0-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4c-2.2-8.8-3.3-17.7-3.3-26.8l0-4.4z'
      
    ]
  };

  

  
  

  var faPencilSlash = {
    prefix: 'fal',
    iconName: 'pencil-slash',
    icon: [
      640,
      512,
      [],
      'e215',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20L382.4 117 459 193.6l-50.6 50.6 25.3 20L559 138.8zM317.2 335.3L240 412.6l0-12.6c0-8.8-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16l-12.6 0 68.2-68.2-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM493.8 39.6l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8c9.4-9.4 24.6-9.4 33.9 0zM135.6 368l24.4 0 0 32c0 8.8 7.2 16 16 16l32 0 0 24.4c-3.7 1.9-7.5 3.5-11.6 4.7l-92.8 27.3 27.3-92.8c1.2-4 2.7-7.9 4.7-11.6z'
      
    ]
  };

  

  
  

  var faUserNinja = {
    prefix: 'fal',
    iconName: 'user-ninja',
    icon: [
      448,
      512,
      [129399],
      'f504',
      
      'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128c-63.6 0-116.3-46.3-126.3-107.1L59.3 187.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 112 36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l45.2 45.2C123 34 169.6 0 224 0c70.7 0 128 57.3 128 128zM211.1 452.9L128.6 344.7C72.9 364.8 33 417.7 32 480l199.7 0-20.2-26.5c-.1-.2-.3-.4-.4-.6zm33.1-9.4L271.9 480 416 480c-1-62.3-40.9-115.2-96.6-135.3l-75.3 98.8zM418.3 512l-154.1 0-.4 0L29.7 512C13.3 512 0 498.7 0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7zM176 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var fa7 = {
    prefix: 'fal',
    iconName: '7',
    icon: [
      320,
      512,
      [],
      '37',
      
      'M0 48c0-8.8 7.2-16 16-16l288 0c5.8 0 11.1 3.1 14 8.2s2.7 11.3-.3 16.2l-256 416c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22L275.4 64 16 64C7.2 64 0 56.8 0 48z'
      
    ]
  };

  

  
  

  var faBlog = {
    prefix: 'fal',
    iconName: 'blog',
    icon: [
      512,
      512,
      [],
      'f781',
      
      'M208 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240c0 8.8 7.2 16 16 16s16-7.2 16-16C480 153.8 358.2 32 208 32zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176zM32 120c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l8 0c61.9 0 112 50.1 112 112s-50.1 112-112 112S32 429.9 32 368l0-248z'
      
    ]
  };

  

  
  

  var faCircle9 = {
    prefix: 'fal',
    iconName: 'circle-9',
    icon: [
      512,
      512,
      [],
      'e0f6',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-3.7 159.9C201 318 160 275.8 160 224c0-53 43-96 96-96s96 43 96 96c0 30-12.5 58.6-34.4 78.9l-82.7 76.8c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6l39.1-36.3z'
      
    ]
  };

  

  
  

  var faSheetPlastic = {
    prefix: 'fal',
    iconName: 'sheet-plastic',
    icon: [
      384,
      512,
      [],
      'e571',
      
      'M352 64l0 256-112 0c-26.5 0-48 21.5-48 48l0 112L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32zm-.5 288c-.7 2.8-2.1 5.4-4.2 7.4L231.4 475.3c-2.1 2.1-4.6 3.5-7.4 4.2L224 368c0-8.8 7.2-16 16-16l111.5 0zM0 448c0 35.3 28.7 64 64 64l156.1 0c12.7 0 24.9-5.1 33.9-14.1L369.9 382.1c9-9 14.1-21.2 14.1-33.9L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM187.3 68.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z'
      
    ]
  };

  

  
  

  var faFaceUnamused = {
    prefix: 'fal',
    iconName: 'face-unamused',
    icon: [
      512,
      512,
      [],
      'e39f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 394.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faMessageArrowDown = {
    prefix: 'fal',
    iconName: 'message-arrow-down',
    icon: [
      512,
      512,
      ["comment-alt-arrow-down"],
      'e1db',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 153.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4 272 112z'
      
    ]
  };

  
    var faCommentAltArrowDown = faMessageArrowDown;
  

  
  

  var faGolfFlagHole = {
    prefix: 'fal',
    iconName: 'golf-flag-hole',
    icon: [
      512,
      512,
      [],
      'e3ac',
      
      'M135.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l224 112c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3L160 249.9l0 61.7c29.6-4.9 62.1-7.6 96-7.6c141.4 0 256 46.6 256 104s-114.6 104-256 104S0 465.4 0 408c0-32.8 37.5-62.1 96-81.2l0 33.8c-3.1 1.1-6.1 2.3-9 3.5c-20.9 8.5-35.7 17.8-44.7 26.5C33.3 399.2 32 405.1 32 408s1.3 8.8 10.3 17.4c9.1 8.7 23.8 18 44.7 26.5C128.7 468.8 188.4 480 256 480s127.3-11.2 169-28.1c20.9-8.5 35.7-17.8 44.7-26.5c9-8.6 10.3-14.5 10.3-17.4s-1.3-8.8-10.3-17.4c-9.1-8.7-23.8-18-44.7-26.5C383.3 347.2 323.6 336 256 336c-34.5 0-67 2.9-96 8l0 28.2c17-7.6 39.4-12.2 64-12.2c53 0 96 21.5 96 48s-43 48-96 48s-96-21.5-96-48l0-57.1 0-32.9 0-77.9 0-224c0-5.5 2.9-10.7 7.6-13.6zM160 214.1L332.2 128 160 41.9l0 172.2zM288.4 405.4s0 0-.1 .1c0-.1 0-.1 .1-.1zm-10.8-2.7c-12.1-6-31-10.7-53.6-10.7s-41.5 4.7-53.6 10.7c-4.3 2.1-6.9 4-8.5 5.3c1.6 1.4 4.2 3.2 8.5 5.3c12.1 6 31 10.7 53.6 10.7s41.5-4.7 53.6-10.7c4.3-2.1 6.9-4 8.5-5.3c-1.6-1.4-4.2-3.2-8.5-5.3zm10.8 7.9s0 0-.1-.1l0 .1c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faBookBlank = {
    prefix: 'fal',
    iconName: 'book-blank',
    icon: [
      448,
      512,
      [128213,128215,128216,128217,"book-alt"],
      'f5d9',
      
      'M0 64C0 28.7 28.7 0 64 0L400 0c26.5 0 48 21.5 48 48l0 320c0 20.9-13.4 38.7-32 45.3l0 66.7 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0 0-64L64 416zM32 392.6c9.4-5.4 20.3-8.6 32-8.6l32 0L96 32 64 32C46.3 32 32 46.3 32 64l0 328.6zM128 32l0 352 272 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L128 32z'
      
    ]
  };

  
    var faBookAlt = faBookBlank;
  

  
  

  var faVialVirus = {
    prefix: 'fal',
    iconName: 'vial-virus',
    icon: [
      512,
      512,
      [],
      'e597',
      
      'M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l16 0 0 320c0 53 43 96 96 96c31.4 0 59.3-15.1 76.8-38.4c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2C167.5 438 148.9 448 128 448c-35.3 0-64-28.7-64-64l0-160 144 0c8.8 0 16-7.2 16-16l0-144 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32zM192 192L64 192 64 64l128 0 0 128zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM214.6 326.9c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1zm62.6-50.7c28.6 8.2 60.2-4.9 74.7-30.9c7.2 13 18.8 22.8 32.2 28.3c13.3 5.5 28.3 6.7 42.5 2.6c-8.2 28.6 4.9 60.2 30.9 74.7c-26 14.5-39.1 46.1-30.9 74.7c-28.6-8.2-60.2 4.9-74.7 30.9c-14.5-26-46.1-39.1-74.7-30.9c8.2-28.6-4.9-60.2-30.9-74.7c26-14.5 39.1-46.1 30.9-74.7z'
      
    ]
  };

  

  
  

  var faCloudXmark = {
    prefix: 'fal',
    iconName: 'cloud-xmark',
    icon: [
      640,
      512,
      [],
      'e35f',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM244.7 212.7c6.2-6.2 16.4-6.2 22.6 0L320 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faUserCheck = {
    prefix: 'fal',
    iconName: 'user-check',
    icon: [
      640,
      512,
      [],
      'f4fc',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 80l91.4 0c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144zm0-32C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zm457-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  

  
  

  var faArrowDownToSquare = {
    prefix: 'fal',
    iconName: 'arrow-down-to-square',
    icon: [
      512,
      512,
      [],
      'e096',
      
      'M267.8 330.9l96-104c6-6.5 5.6-16.6-.9-22.6s-16.6-5.6-22.6 .9L272 279.1 272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 263.1-68.2-73.9c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6l96 104c3 3.3 7.3 5.1 11.8 5.1s8.7-1.9 11.8-5.1zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32z'
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fal',
    iconName: 'note',
    icon: [
      448,
      512,
      [],
      'e1ff',
      
      'M384 64c17.7 0 32 14.3 32 32l0 208-96 0c-26.5 0-48 21.5-48 48l0 96L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zm18.7 272L304 434.7l0-82.7c0-8.8 7.2-16 16-16l82.7 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l213.5 0c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3L448 96c0-35.3-28.7-64-64-64L64 32zm64 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faTruckRampBox = {
    prefix: 'fal',
    iconName: 'truck-ramp-box',
    icon: [
      640,
      512,
      ["truck-loading"],
      'f4de',
      
      'M432 0c-44.2 0-80 35.8-80 80l0 304c0 1.3 .2 2.5 .4 3.7L11.8 480.6C3.3 482.9-1.8 491.7 .6 500.2s11.1 13.6 19.6 11.2L416.1 403.6C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5 .1L384 379.1 384 80c0-26.5 21.5-48 48-48l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L432 0zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM84.9 191.2l14.5 54.1c3.4 12.8 16.6 20.4 29.4 17l46.4-12.4c12.8-3.4 20.4-16.6 17-29.4l-14.5-54.1 30.9-8.3L250 312.6 95.4 354 54 199.4l30.9-8.3zm30.9-8.3l30.9-8.3L159.2 221l-30.9 8.3-12.4-46.4zM45.7 168.5c-17.1 4.6-27.2 22.1-22.6 39.2L64.5 362.3c4.6 17.1 22.1 27.2 39.2 22.6l154.5-41.4c17.1-4.6 27.2-22.1 22.6-39.2L239.5 149.7c-4.6-17.1-22.1-27.2-39.2-22.6L45.7 168.5z'
      
    ]
  };

  
    var faTruckLoading = faTruckRampBox;
  

  
  

  var faBlueberries = {
    prefix: 'fal',
    iconName: 'blueberries',
    icon: [
      512,
      512,
      [],
      'e2e8',
      
      'M382.7 312.3C439.3 292.9 480 239.2 480 176c0-79.5-64.5-144-144-144c-63.2 0-116.9 40.7-136.3 97.3c-7.8-.9-15.7-1.3-23.7-1.3c-3.2 0-6.3 .1-9.4 .2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176c0 80.6-54.2 148.6-128.2 169.4c.1-3.1 .2-6.3 .2-9.4c0-8-.5-15.9-1.3-23.7zM320 336A144 144 0 1 0 32 336a144 144 0 1 0 288 0zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zm176-96l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM368 80l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faChartSine = {
    prefix: 'fal',
    iconName: 'chart-sine',
    icon: [
      512,
      512,
      [],
      'e69d',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zm96.5 175.2c.5-2.4 1.3-5.8 2.5-9.9c2.3-8.4 6-19.3 11.4-30.1C153.6 160.7 169.4 144 192 144c19 0 33.1 8.7 45.9 24.2c13.4 16.2 24 38.2 35.6 62.7l.5 1c11.1 23.2 23.2 48.7 39.3 68.3C330.3 320.7 352.7 336 384 336c41.4 0 65.5-31.3 78.3-56.8c6.6-13.2 10.9-26.2 13.6-35.9c1.3-4.8 2.3-8.9 2.9-11.8c2.1-9.8 .3-21.2-12.2-23.3c-11.5-1.9-17.1 7.1-19.1 16.6c-.5 2.4-1.3 5.8-2.5 9.9c-2.3 8.4-6 19.3-11.4 30.1C422.4 287.3 406.6 304 384 304c-19 0-33.1-8.7-45.9-24.2c-13.4-16.2-24-38.2-35.6-62.7l-.5-1c-11.1-23.2-23.2-48.7-39.3-68.3C245.7 127.3 223.3 112 192 112c-41.4 0-65.5 31.3-78.3 56.8c-6.6 13.2-10.9 26.2-13.6 35.9c-1.3 4.8-2.3 8.9-2.9 11.8c-2.1 9.8-.3 21.2 12.2 23.3c11.5 1.9 17.1-7.1 19.1-16.6z'
      
    ]
  };

  

  
  

  var faPenField = {
    prefix: 'fal',
    iconName: 'pen-field',
    icon: [
      640,
      512,
      [],
      'e211',
      
      'M582.8 45.5l11.9 11.9c12.5 12.5 12.5 32.8 0 45.2L568 129.4l-57-57 26.4-26.8c12.5-12.6 32.8-12.7 45.4-.1zM346.2 239.2L488.5 95.1 545.4 152 402.3 295.2c-4.4 4.4-10 7.4-16.1 8.7l-61.5 12.9 12.9-61.7c1.3-6 4.2-11.5 8.6-15.9zM514.7 23.1L323.4 216.7c-8.6 8.7-14.6 19.8-17.1 31.8l-18 85.7c-1.1 5.3 .5 10.8 4.3 14.6s9.3 5.5 14.6 4.3l85.5-17.9c12.2-2.6 23.3-8.6 32.1-17.4L617.4 125.3c25-25 25-65.5 0-90.5L605.5 22.8c-25.1-25.1-65.8-25-90.8 .3zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l240 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 128zm64 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faClipboardList = {
    prefix: 'fal',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12l18 0c8.8 0 16 7.2 16 16l0 32-96 0-96 0 0-32c0-8.8 7.2-16 16-16l18 0c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48L112 48C91.1 48 73.3 61.4 66.7 80L64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64l-2.7 0c-6.6-18.6-24.4-32-45.3-32l-6.7 0C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32l0 304c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-304c0-17.7 14.3-32 32-32l0 16c0 17.7 14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32l0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPumpkin = {
    prefix: 'fal',
    iconName: 'pumpkin',
    icon: [
      576,
      512,
      [],
      'f707',
      
      'M299.1 36.1l20.9 9 0 53.8c11.1 2 21.8 5.1 32 9.1l0-72.6c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4l-41.1 94c12.2-3.9 25-6.5 38.3-7.7l26.5-60.5zM166 145.1c9.5-9.2 20.1-17.3 31.5-24.1c-14.3-5.8-29.5-9-45.5-9c-43.8 0-82.2 24.1-109 60.4S0 258.1 0 312s16.1 103.3 43 139.6S108.2 512 152 512c24.7 0 47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9s47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9c43.8 0 82.2-24.1 109-60.4s43-85.7 43-139.6s-16.1-103.3-43-139.6S467.8 112 424 112c-15.9 0-31.2 3.2-45.5 9c11.4 6.8 22 14.9 31.5 24.1c4.6-.8 9.3-1.1 14-1.1c31.3 0 60.9 17.1 83.3 47.4S544 264.3 544 312s-14.3 90.3-36.7 120.6s-52 47.4-83.3 47.4c-20.7 0-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C328.6 472.5 308.7 480 288 480s-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C192.6 472.5 172.7 480 152 480c-31.3 0-60.9-17.1-83.3-47.4S32 359.7 32 312s14.3-90.3 36.7-120.6s52-47.4 83.3-47.4c4.7 0 9.4 .4 14 1.1zM288 160c38.5 0 72.4 19.4 92.6 49c5 7.3 14.9 9.2 22.2 4.2s9.2-14.9 4.2-22.2c-25.9-38-69.6-63-119.1-63s-93.2 25-119.1 63c-5 7.3-3.1 17.3 4.2 22.2s17.3 3.1 22.2-4.2c20.2-29.6 54.1-49 92.6-49z'
      
    ]
  };

  

  
  

  var faCodePullRequest = {
    prefix: 'fal',
    iconName: 'code-pull-request',
    icon: [
      512,
      512,
      [],
      'e13c',
      
      'M323.8 5.2c5.9 6.5 5.5 16.7-1.1 22.6L265.4 80 336 80c61.9 0 112 50.1 112 112l0 161.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4L416 192c0-44.2-35.8-80-80-80l-70.6 0 57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1zM432 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM128 80A48 48 0 1 0 32 80a48 48 0 1 0 96 0zM96 158.4l0 195.2c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4l0-195.2C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 38.7-27.5 71-64 78.4zM128 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faDesktopArrowDown = {
    prefix: 'fal',
    iconName: 'desktop-arrow-down',
    icon: [
      576,
      512,
      [],
      'e155',
      
      'M64 0L240 0l0 32L64 32C46.3 32 32 46.3 32 64l0 192 512 0 0-192c0-17.7-14.3-32-32-32L336 32l0-32L512 0c35.3 0 64 28.7 64 64l0 192 0 32 0 64c0 35.3-28.7 64-64 64l-149.1 0 10.7 64 58.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-72 0-144 0-72 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l58.4 0 10.7-64L64 416c-35.3 0-64-28.7-64-64l0-64 0-32L0 64C0 28.7 28.7 0 64 0zM32 288l0 64c0 17.7 14.3 32 32 32l167.7 0c.2 0 .4 0 .6 0l111.5 0c.2 0 .4 0 .6 0L512 384c17.7 0 32-14.3 32-32l0-64L32 288zM234.9 480l106.2 0-10.7-64-84.9 0-10.7 64zM304 16l0 153.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 169.4 272 16c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faPaste = {
    prefix: 'fal',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      'M136.5 51.2C138.7 40.2 148.4 32 160 32s21.3 8.2 23.5 19.2C185 58.6 191.6 64 199.2 64l8.8 0c8.8 0 16 7.2 16 16l0 16L96 96l0-16c0-8.8 7.2-16 16-16l8.8 0c7.6 0 14.2-5.4 15.7-12.8zM160 0c-22.3 0-41.6 13.1-50.6 32L64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l128 0 0-32L64 416c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l2.7 0C65 69 64 74.4 64 80l0 16c0 17.7 14.3 32 32 32l112 0c11.5-15.4 28.5-26.4 48-30.4c0-.5 0-1.1 0-1.6l0-16c0-5.6-1-11-2.7-16l2.7 0c17.7 0 32 14.3 32 32l32 0c0-35.3-28.7-64-64-64l-45.4 0c-9-18.9-28.3-32-50.6-32zM448 480l-160 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l108.1 0c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3L480 448c0 17.7-14.3 32-32 32zm49.9-270.1l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L288 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9z'
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faComments = {
    prefix: 'fal',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      'M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144s-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5c-3.5-.7-7.1-.2-10.2 1.4c-6.1 3.1-12 6-18 8.7c-28.4 12.9-60.2 23.1-91.5 26c14.9-19 26.8-39.7 37.6-59.9c3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110c-11.7 21-24 40.6-39.5 57.5c0 0 0 0 0 0l-.1 .1c-6.5 7-8.2 17.1-4.4 25.8C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.9-2.2 9.6-4.5 14.3-6.8c15.3 2.8 30.9 4.6 47 4.6c114.9 0 208-78.9 208-176S322.9 0 208 0zM447.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6c-4.8 5-5.8 12.5-2.5 18.6c10.9 20.2 22.7 40.8 37.6 59.9c-31.3-3-63.2-13.2-91.5-26c-6-2.7-11.9-5.6-18-8.7c-3.2-1.6-6.8-2.1-10.2-1.4c-15.6 3.1-30.9 5-46.3 5c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6c4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.7 2-18.9-4.4-25.8l-.1-.1s0 0 0 0c-15.5-17-27.8-36.5-39.5-57.5c26.2-29.9 46-65.8 46-110c0-94.4-87.8-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3z'
      
    ]
  };

  

  
  

  var faCaretRight = {
    prefix: 'fal',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      'M221.8 250.4c1.3 1.4 2.2 3.5 2.2 5.6s-.8 4.2-2.2 5.6L108.3 381.8c-1.3 1.4-3.2 2.2-5.2 2.2c-3.9 0-7.1-3.2-7.1-7.1l0-241.7c0-3.9 3.2-7.1 7.1-7.1c2 0 3.8 .8 5.2 2.2L221.8 250.4zm23.3-22L131.6 108.3c-7.4-7.8-17.7-12.3-28.4-12.3C81.5 96 64 113.5 64 135.1l0 241.7c0 21.6 17.5 39.1 39.1 39.1c10.8 0 21.1-4.4 28.5-12.3L245.1 283.6c7-7.4 10.9-17.3 10.9-27.6s-3.9-20.1-10.9-27.6z'
      
    ]
  };

  

  
  

  var faBackward = {
    prefix: 'fal',
    iconName: 'backward',
    icon: [
      512,
      512,
      [9194],
      'f04a',
      
      'M37.6 256L256 414.1l0-316.2L37.6 256zM258 64c16.6 0 30 13.5 30 30l0 103.4L464.3 69.7C469.5 66 475.6 64 482 64c16.6 0 30 13.5 30 30L512 418c0 16.6-13.4 30-30 30c-6.3 0-12.5-2-17.6-5.7L288 314.6 288 418c0 16.6-13.5 30-30 30c-6.3 0-12.5-2-17.6-5.7L9.9 275.4C3.7 270.9 0 263.7 0 256s3.7-14.9 9.9-19.4L240.3 69.7C245.5 66 251.6 64 258 64zm30 211.1l192 139 0-316.2-192 139 0 38.2z'
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fal',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      'M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6l-219 219 0-12.6c0-8.8-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16l-12.6 0 219-219zM66.9 379.5c1.2-4 2.7-7.9 4.7-11.5L96 368l0 32c0 8.8 7.2 16 16 16l32 0 0 24.4c-3.7 1.9-7.5 3.5-11.6 4.7L39.6 472.4l27.3-92.8zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17zM331.3 202.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faLips = {
    prefix: 'fal',
    iconName: 'lips',
    icon: [
      576,
      512,
      [128068,128482],
      'f600',
      
      'M268.2 126.4C244.8 107.9 221.7 96 200 96c-7.8 0-22.7 3.4-42.7 12.1c-19.2 8.4-40.4 20.4-60.1 34.6C77.4 157 60.3 172.7 48.5 188C36.2 203.8 32 216 32 224c0 15.5 6.2 33.6 17.8 53.5C61.1 297.1 76 315.8 90 332c38 44 94 84 166 84l64 0c72 0 128-40 166-84c13.6-15.7 28.5-34.7 40-54.6c11.7-20.4 18-38.6 18-53.4c0-8-4.2-20.2-16.5-36c-11.9-15.3-29-31-48.7-45.3c-19.6-14.2-40.8-26.2-60.1-34.6C398.7 99.4 383.8 96 376 96c-21.7 0-44.8 11.9-68.2 30.4c-11.6 9.2-28.1 9.2-39.7 0zM510.2 352.9C468.8 400.9 404.7 448 320 448l-64 0c-84.7 0-148.8-47.1-190.2-95.1C36.9 319.5 0 271 0 224C0 151.5 142.5 64 200 64c32.7 0 63 17.5 88 37.3C313 81.5 343.3 64 376 64c57.5 0 200 87.5 200 160c0 45.8-37.5 96.2-65.8 128.9zm-153.9-136c-11.6 3.6-44 13.1-68.3 13.1s-56.7-9.5-68.3-13.1c-2-.6-3.8-.9-5.4-.9c-38.1 .4-66.1 5.6-84.1 11.1c-4.7 1.4-8.5 2.9-11.7 4.2c.4 .4 .9 .9 1.3 1.3c7.5 7.4 19 16.9 34.3 26.4c30.5 18.8 75.6 37 133.9 37s103.4-18.2 133.9-37c15.3-9.4 26.8-19 34.3-26.4c.5-.5 .9-.9 1.3-1.3c-3.2-1.3-7.1-2.8-11.7-4.2c-18-5.5-46-10.7-84.1-11.1c-1.6 0-3.4 .2-5.4 .9zm5.7-32.9c40.7 .5 71.7 5.9 93.1 12.5c10.6 3.3 19.2 6.9 25.5 10.6c3.1 1.8 6.2 3.9 8.7 6.4c1.7 1.7 6.7 6.8 6.7 14.5c0 3.1-.9 5.5-1.3 6.6c-.5 1.3-1.1 2.5-1.6 3.4c-1 1.8-2.3 3.6-3.6 5.4c-2.7 3.5-6.4 7.7-11 12.2c-9.2 9-22.6 20-39.9 30.7C404 307.6 353.2 328 288 328s-116-20.4-150.7-41.8c-17.3-10.7-30.7-21.7-39.9-30.7c-4.6-4.5-8.3-8.6-11-12.1c-1.3-1.7-2.6-3.6-3.6-5.4c-.5-.9-1.1-2-1.6-3.4c-.4-1.1-1.3-3.5-1.3-6.6c0-7.8 5-12.9 6.7-14.5c2.5-2.5 5.6-4.6 8.7-6.4c6.3-3.7 14.9-7.3 25.5-10.6c21.4-6.6 52.4-12 93.1-12.5c5.4-.1 10.5 .8 15.3 2.3c12 3.8 40 11.7 58.8 11.7s46.7-7.9 58.8-11.7c4.7-1.5 9.9-2.4 15.3-2.3z'
      
    ]
  };

  

  
  

  var faLandmarkFlag = {
    prefix: 'fal',
    iconName: 'landmark-flag',
    icon: [
      512,
      512,
      [],
      'e51c',
      
      'M272 32l0 32 64 0 0-32-64 0zm80 64l-80 0 0 32 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0 0-32 0-32 0-40 0-8c0-8.8 7.2-16 16-16l8 0 8 0 80 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16zM48 368c0-8.8 7.2-16 16-16l0-160 32 0 0 160 80 0 0-160 32 0 0 160 96 0 0-160 32 0 0 160 80 0 0-160 32 0 0 160c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 384c-8.8 0-16-7.2-16-16zM24 432c0-8.8 7.2-16 16-16l432 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L40 448c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faRam = {
    prefix: 'fal',
    iconName: 'ram',
    icon: [
      640,
      512,
      [128015],
      'f70a',
      
      'M336 56c0-30.9 25.1-56 56-56s56 25.1 56 56l0 10.8c7.7-1.8 15.7-2.8 24-2.8c14.2 0 27.7 2.8 40 8l0-16c0-30.9 25.1-56 56-56s56 25.1 56 56l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 37c11 10.5 19.7 23.5 25.2 37.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 173.9l0 66.1c0 53-43 96-96 96l-16 0c-53 0-96-43-96-96l0-60.8-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9c7.3-23.9 22.9-44.2 43.5-57.5L416 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8zM304.2 69.9l.2-.2c1.6 11.3 7.9 21 16.9 27.2c-13.2 8.3-30.7 6-41.2-6c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3c-3.9 16.1-19.6 26.6-36 24c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8c3.5 14.2-3 29-16 36c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4c16.4-2.5 32 7.9 36 24c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9c13.4-10.6 32.8-8.9 44 4c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4c5.5 4.3 12.3 6.9 19.9 6.9c15 0 27.7-10.4 31.1-24.3c1.4-5.8 4.3-10.8 8.2-14.8c6.2 5.2 13 9.9 20.1 14l20.1 5L397.6 475.6C392.2 497 373 512 351 512l-15 0c-26.5 0-48-21.5-48-48l0-40.6c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6l0 40.6c0 26.5-21.5 48-48 48l-15 0c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9zM344 424c-8.5 0-16.6-1.7-24-4.7l0 44.7c0 8.8 7.2 16 16 16l15 0c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zM131.7 412.7l13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1l15 0c8.8 0 16-7.2 16-16l0-44.7c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3zM544 168c0-39.8-32.2-72-72-72c-36.1 0-66 26.6-71.2 61.2l.1 .1-.1 .1c-.5 3.5-.8 7-.8 10.6l0 72c0 35.3 28.7 64 64 64l16 0c35.3 0 64-28.7 64-64l0-72zm-96 8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faExcavator = {
    prefix: 'fal',
    iconName: 'excavator',
    icon: [
      640,
      512,
      [],
      'e656',
      
      'M128 0C110.3 0 96 14.3 96 32l0 128-48 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-48 0-16 0-18.7c0-11.6-3.2-23-9.1-32.9L295 23.3C286.4 8.8 270.7 0 253.9 0L128 0zM339.8 160.2c-1.3-.1-2.5-.2-3.8-.2l-208 0 0-128 125.9 0c5.6 0 10.8 2.9 13.7 7.8l72.2 120.4zM32 272l0-64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 16 0 48c0 8.8-7.2 16-16 16L48 288c-8.8 0-16-7.2-16-16zM336 384c26.5 0 48 21.5 48 48s-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48s21.5-48 48-48l256 0zM80 352c-44.2 0-80 35.8-80 80s35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L80 352zM480.6 476.7L608 349.3l0 2.7 0 32 0 48c0 26.5-21.5 48-48 48l-78.1 0c-1.1 0-1.9-.9-1.9-1.9c0-.5 .2-1 .6-1.4zm-22.6-22.6c-6.4 6.4-9.9 15-9.9 24c0 18.7 15.2 33.9 33.9 33.9l78.1 0c44.2 0 80-35.8 80-80l0-48 0-32 0-32 0-2.7 0-45.3 0-144 0-70.9 0-10.5C640 20.9 619.1 0 593.4 0c-11.2 0-22.1 4-30.5 11.4L416 138.7l0 42.3L583.8 35.6c2.7-2.3 6.1-3.6 9.6-3.6c8.1 0 14.6 6.5 14.6 14.6l0 38.7L586.8 104 416 254.7l0 42.7L576 156.2 608 128l0 42.7L608 304 457.9 454.1zM112 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faEggplant = {
    prefix: 'fal',
    iconName: 'eggplant',
    icon: [
      512,
      512,
      [],
      'e16c',
      
      'M482.7 51.9C491.1 64.5 496 79.7 496 96l0 96c0 17.7-14.3 32-32 32l-4 0c-24.3 0-44-19.7-44-44l0-10c0-1.1-.9-2-2-2c-38.7 0-70-31.3-70-70c0-1.1-.9-2-2-2l-10 0c-24.3 0-44-19.7-44-44l0-4c0-17.7 14.3-32 32-32l96 0c16.3 0 31.5 4.9 44.1 13.3L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L482.7 51.9zM416 48l-96 0 0 4c0 6.6 5.4 12 12 12l10 0c18.8 0 34 15.2 34 34c0 21 17 38 38 38c18.8 0 34 15.2 34 34l0 10c0 6.6 5.4 12 12 12l4 0 0-96c0-26.5-21.5-48-48-48zM169.9 139.3c32.9-16 66-32 94.7-52.2c5 9.6 12 18 20.5 24.7c-11.3 8.1-23.1 15.4-34.8 22.2c-21.2 12.2-45.5 24-68.4 35.1c0 0 0 0 0 0s0 0 0 0c-14.1 6.8-27.6 13.4-39.5 19.7c-34 17.8-61.7 35.7-80.9 58.3c-18.2 21.5-30 48.8-29.4 88.5C33.1 413.9 98 479.9 176.4 480c66.7 .1 127.2-45.1 176.8-113.6c27.4-37.8 49.9-80.7 66.7-121.9c9 5.6 19.2 9.3 30.1 10.8C400.8 377 304.5 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z'
      
    ]
  };

  

  
  

  var faFolderGrid = {
    prefix: 'fal',
    iconName: 'folder-grid',
    icon: [
      512,
      512,
      [],
      'e188',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zm48 272l0-32 32 0 0 32-32 0zM80 264l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm160 40l0-32 32 0 0 32-32 0zm-32-40l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm160 8l32 0 0 32-32 0 0-32zm-8-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z'
      
    ]
  };

  

  
  

  var faGaugeMin = {
    prefix: 'fal',
    iconName: 'gauge-min',
    icon: [
      512,
      512,
      ["tachometer-alt-slowest"],
      'f628',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-35.3-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faTachometerAltSlowest = faGaugeMin;
  

  
  

  var faDiagramPrevious = {
    prefix: 'fal',
    iconName: 'diagram-previous',
    icon: [
      512,
      512,
      [],
      'e478',
      
      'M480 352c0-17.7-14.3-32-32-32l-176 0-32 0L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zM272 288l176 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l176 0 0-105.4-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 182.6 272 288zM448 32c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0z'
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fal',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 336 0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 94.1-94.1 165 225c5.2 7.1 15.2 8.7 22.4 3.4s8.7-15.2 3.4-22.4L149 225.6 315.3 59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 297.4 32 48z'
      
    ]
  };

  

  
  

  var faPage = {
    prefix: 'fal',
    iconName: 'page',
    icon: [
      384,
      512,
      [],
      'e428',
      
      'M64 480l256 0c17.7 0 32-14.3 32-32l0-309.5c0-8.5-3.4-16.6-9.4-22.6L268.1 41.4c-6-6-14.1-9.4-22.6-9.4L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zm256 32L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fal',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      'M129.7 132c4.8-25.9 22-44.8 49.7-56.2c28.3-11.7 67-15 111-8.4c13.8 2.1 56.1 10 69.7 13.5c8.6 2.2 17.3-3 19.5-11.5s-3-17.3-11.5-19.5c-15.1-3.9-58.6-12-72.9-14.1c-47.7-7.2-92.7-4.1-127.9 10.5c-35.7 14.7-62.1 41.6-69.1 80.6c-.1 .3-.1 .6-.1 .9c-2.8 22.9 .6 42.7 9.5 59.7c8.8 16.8 22.4 29.6 37.9 39.8c18.7 12.2 41.6 21.2 65.2 28.9L16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176.6 0c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1c-12.5-8.1-21.5-17.2-27.1-27.8c-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7c-4.7 26.1-21.9 45.2-49.8 56.6c-28.3 11.7-66.9 15-110.9 8.4c-22.1-3.5-59.5-15.7-88-25.1c0 0 0 0 0 0s0 0 0 0c-6.1-2-11.8-3.9-16.8-5.5c-8.4-2.7-17.4 1.9-20.1 10.4s1.9 17.4 10.4 20.1c4.4 1.4 9.6 3.1 15.3 5c28.3 9.3 69.3 22.8 94.4 26.7c0 0 .1 0 .1 0c47.7 7.2 92.7 4.1 127.9-10.5c35.7-14.7 62.1-41.6 69.1-80.6c4.2-23.3 2.2-43.7-5.6-61.3c-.6-1.3-1.2-2.7-1.9-4l-38.7 0c4.9 5.2 8.6 10.8 11.3 16.8z'
      
    ]
  };

  

  
  

  var faTrees = {
    prefix: 'fal',
    iconName: 'trees',
    icon: [
      640,
      512,
      [],
      'f724',
      
      'M167.6 11.9c12.8-15 35.9-15 48.7 0L318.5 131.8c4.1 4.8 6.4 11 6.4 17.4c0 14.8-12 26.8-26.8 26.8l-12.1 0 61.4 67.4c4.5 4.9 7 11.3 7 17.9c0 14.7-11.9 26.6-26.6 26.6l-15.1 0 65.6 84.4C382 377.2 384 383 384 389c0 14.9-12.1 27-27 27l-121.9 0L208 416l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-27.1 0L27 416c-14.9 0-27-12.1-27-27c0-6 2-11.8 5.7-16.6L71.3 288l-15.1 0c-14.7 0-26.6-11.9-26.6-26.6c0-6.6 2.5-13 7-17.9L97.9 176l-12.1 0c-14.8 0-26.8-12-26.8-26.8c0-6.4 2.3-12.5 6.4-17.4L167.6 11.9zM235.1 384l111.7 0L267.4 281.8c-3.7-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9l35.7 0L238 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5l37 0L192 32.7 97.1 144l37 0c6.3 0 12.1 3.7 14.6 9.5s1.5 12.6-2.8 17.2L68.3 256l35.7 0c6.1 0 11.7 3.5 14.4 9s2 12-1.7 16.9L37.2 384l111.7 0 27.1 0 0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 27.1 0zM423.5 12.6c12.7-15.4 36.2-15.6 49.1-.4l102 119.7c4.1 4.8 6.4 11 6.4 17.4c0 14.8-12 26.8-26.8 26.8l-12.1 0 61.4 67.4c4.5 4.9 7 11.3 7 17.9c0 14.7-11.9 26.6-26.6 26.6l-15.1 0 65.6 84.4C638 377.2 640 383 640 389c0 14.9-12.1 27-27 27l-149 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96 0-192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 138.8 0L523.4 281.8c-3.8-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9l35.7 0L494 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5l37 0L448.2 32.9 388 106.2c-5.6 6.8-15.7 7.8-22.5 2.2s-7.8-15.7-2.2-22.5l60.2-73.2z'
      
    ]
  };

  

  
  

  var faHandLove = {
    prefix: 'fal',
    iconName: 'hand-love',
    icon: [
      512,
      512,
      [],
      'e1a5',
      
      'M184 32c13.3 0 24 10.7 24 24l0 144c0 0 0 0 0 0l0 96c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56l0-64 0-56 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216c0 79.5-64.5 144-144 144l-8.5 0c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8L160 56c0-13.3 10.7-24 24-24zM288 296c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96.1c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24l0 8 0 24 0 64zm32-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64zm48-50.6c-7.3-3.5-15.4-5.4-24-5.4c-9.7 0-18.8 2.5-26.7 6.8C310 160.3 288.9 144 264 144c-8.6 0-16.7 1.9-24 5.4L240 80c0 0 0 0 0 0l0-24c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 232.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512l8.5 0c97.2 0 176-78.8 176-176l0-216c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 56 0 5.4z'
      
    ]
  };

  

  
  

  var faFootballHelmet = {
    prefix: 'fal',
    iconName: 'football-helmet',
    icon: [
      512,
      512,
      [],
      'f44f',
      
      'M456 198.7L277.1 221.1c-30.3 3.8-53.1 29.6-53.1 60.1c0 9.4 2.2 18.7 6.4 27.1l38.2 76.4c2.2 4.4 3.4 9.3 3.4 14.3l0 .9c0 17.7-14.3 32-32 32l-2.9 0c-4.3 0-8.6-.9-12.6-2.6l-93.9-40.2c-8-3.4-16.5-5.2-25.2-5.2L92 384c-27.6-35.3-44-79.7-44-128C48 141.1 141.1 48 256 48c95 0 175.2 63.7 200 150.7zm6.4 31.4c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9l14 0c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2l2.9 0c35.3 0 64-28.7 64-64l0-.9c0-9.9-2.3-19.7-6.8-28.6L288 352l39.7 0 9.6 50.9c10.1 54 57.2 93.1 112.1 93.1l17 0c25.2 0 45.6-20.4 45.6-45.6l0-50.4 0-32c0-26.5-21.5-48-48-48l-109.7 0-14-74.5 122.2-15.3zm-154 19.2L321.7 320 272 320l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l27.4-3.4zM200 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm166.3 48l-6-32L464 352c8.8 0 16 7.2 16 16l0 16-113.7 0zm8.4 32L480 416l0 34.4c0 7.5-6.1 13.6-13.6 13.6l-17 0c-32.7 0-61.6-19.3-74.7-48z'
      
    ]
  };

  

  
  

  var faGrid = {
    prefix: 'fal',
    iconName: 'grid',
    icon: [
      448,
      512,
      ["grid-3"],
      'e195',
      
      'M88 64c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zM40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32zM88 224c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zM40 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 192l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zM0 392l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM248 64c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zM200 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 192l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zm-48-32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM360 64l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l48 0zm-48-32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 192l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  
    var faGrid3 = faGrid;
  

  
  

  var faPanFrying = {
    prefix: 'fal',
    iconName: 'pan-frying',
    icon: [
      576,
      512,
      [127859],
      'e42c',
      
      'M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416c53 0 101.6-18.4 140-49.1l77 87c14.7 16.6 35.8 26.1 57.9 26.1c42.5 0 77.2-34.5 77.2-77c0-26.7-13.8-51.5-36.6-65.6L433.3 304c9.5-24.8 14.7-51.8 14.7-80C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448zm240.9 16.7l-77.5-87.6c12.4-13.3 23.3-28 32.2-44l103 63.5c13.3 8.2 21.4 22.7 21.4 38.3c0 24.8-20.2 45-45.2 45c-13 0-25.4-5.6-33.9-15.3zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM152.6 102.3c-14.5 13.9-22.6 32.1-24.3 50.7c-2.1 23.5-8.7 52.4-19.4 71C82.4 269.9 98.1 328.6 144 355.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8c7.9-4.9 16.4-8 23.1-9c12.8-1.8 25.4-6.7 36.5-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.3-27.2-25.5-44.4-29.8c-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2zm90 24.4c8.9 9.3 21.4 18.4 34.1 25.8s26.7 13.8 39.2 17c10.3 2.6 19.8 8.7 26.6 17.9c15.8 21.3 11.3 51.4-10 67.1c-6.7 5-14.2 7.9-21.9 9c-11.9 1.7-24.6 6.7-35.4 13.4c-10.8 6.7-21.4 15.9-27.8 27.1c-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4c14-24.3 21.3-58.4 23.6-84.2c1-11.2 5.8-22 14.5-30.4c19.1-18.4 49.5-17.8 67.9 1.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faAddressBook = {
    prefix: 'fal',
    iconName: 'address-book',
    icon: [
      512,
      512,
      [62138,"contact-book"],
      'f2b9',
      
      'M96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L96 32zM32 64C32 28.7 60.7 0 96 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zM272 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48l-64 0zM512 80l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 192c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm16 144l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faContactBook = faAddressBook;
  

  
  

  var faCartMinus = {
    prefix: 'fal',
    iconName: 'cart-minus',
    icon: [
      576,
      512,
      [],
      'e0db',
      
      'M0 16C0 7.2 7.2 0 16 0L53.9 0c22.8 0 42.5 16 47 38.4L145.4 256l321.1 0c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288L152 288l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-304.8 0c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32L16 32C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM256 112l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faPager = {
    prefix: 'fal',
    iconName: 'pager',
    icon: [
      512,
      512,
      [128223],
      'f815',
      
      'M448 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm0 272c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM96 160l320 0 0 96L96 256l0-96zm-32 0l0 96c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  

  
  

  var faMerge = {
    prefix: 'fal',
    iconName: 'merge',
    icon: [
      512,
      512,
      [],
      'e526',
      
      'M0 80c0-8.8 7.2-16 16-16l80 0 47.7 0c15.4 0 29.8 7.3 38.8 19.8L291.4 233.4c3 4.1 7.8 6.6 12.9 6.6l153.1 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272l-153.1 0c-5.1 0-9.9 2.4-12.9 6.6L182.5 428.2c-9 12.4-23.5 19.8-38.8 19.8L96 448l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 47.7 0c5.1 0 9.9-2.4 12.9-6.6L265.5 259.8c1-1.3 2-2.6 3-3.8c-1.1-1.2-2.1-2.5-3-3.8L156.6 102.6c-3-4.1-7.8-6.6-12.9-6.6L96 96 16 96C7.2 96 0 88.8 0 80z'
      
    ]
  };

  

  
  

  var faCircleH = {
    prefix: 'fal',
    iconName: 'circle-h',
    icon: [
      512,
      512,
      [9405,"hospital-symbol"],
      'f47e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96-160 0 0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 160 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 0-112z'
      
    ]
  };

  
    var faHospitalSymbol = faCircleH;
  

  
  

  var faHexagonXmark = {
    prefix: 'fal',
    iconName: 'hexagon-xmark',
    icon: [
      512,
      512,
      ["times-hexagon","xmark-hexagon"],
      'f2ee',
      
      'M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32l184.6 0c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32l-184.6 0c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16l184.6 0c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm137-59.3c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faTimesHexagon = faHexagonXmark;
  
    var faXmarkHexagon = faHexagonXmark;
  

  
  

  var faCartXmark = {
    prefix: 'fal',
    iconName: 'cart-xmark',
    icon: [
      576,
      512,
      [],
      'e0dd',
      
      'M0 16C0 7.2 7.2 0 16 0L53.9 0c22.8 0 42.5 16 47 38.4L145.4 256l321.1 0c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288L152 288l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-304.8 0c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32L16 32C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM379.3 91.3L342.6 128l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 150.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128 260.7 91.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L320 105.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faBowArrow = {
    prefix: 'fal',
    iconName: 'bow-arrow',
    icon: [
      512,
      512,
      [127993],
      'f6b9',
      
      'M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16L397.4 92 153.7 335.7l-59.9-15c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-15-59.9L420 114.6l40.7 40.7c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-49.9 92.3L400.8 50.1 476 36l-14.1 75.2zm-81.2 88C403 234.1 416 275.5 416 320c0 47.9-15 92.3-40.7 128.7L253.3 326.6l-22.6 22.6L388.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13-13C429.5 429.2 448 376.8 448 320c0-53.3-16.3-102.9-44.2-143.9l-23.1 23.1zM4.7 123.3L162.7 281.4l22.6-22.6L63.3 136.7C99.7 111 144.1 96 192 96c44.5 0 85.9 13 120.8 35.3l23.1-23.1C294.9 80.3 245.3 64 192 64C135.2 64 82.8 82.5 40.4 113.7l-13-13c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM99.3 436c-2.9-11.5-11.8-20.4-23.3-23.3l-36.3-9.1 50.8-50.8 54.9 13.7 13.7 54.9-50.8 50.8L99.3 436z'
      
    ]
  };

  

  
  

  var faFileCircleExclamation = {
    prefix: 'fal',
    iconName: 'file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4eb',
      
      'M64 480l232.2 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9l0 34.7c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faEnvelopesBulk = {
    prefix: 'fal',
    iconName: 'envelopes-bulk',
    icon: [
      640,
      512,
      ["mail-bulk"],
      'f674',
      
      'M112 32l288 0c8.8 0 16 7.2 16 16l0 16 32 0 0-16c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48l0 144 32 0L96 48c0-8.8 7.2-16 16-16zM224 144c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-176 0 0 32 176 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L240 96c-26.5 0-48 21.5-48 48l0 48 32 0 0-48zM48 256l288 0c8.8 0 16 7.2 16 16l0 5L196.9 391.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 277l0-5c0-8.8 7.2-16 16-16zM32 464l0-147.2L168 417.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9L352 316.8 352 464c0 8.8-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16zM48 224c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48L48 224zm448-64c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0zm16 64l0-32 32 0 0 32-32 0z'
      
    ]
  };

  
    var faMailBulk = faEnvelopesBulk;
  

  
  

  var faJarWheat = {
    prefix: 'fal',
    iconName: 'jar-wheat',
    icon: [
      320,
      512,
      [],
      'e517',
      
      'M48 16c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 0C55.2 0 48 7.2 48 16zM256 96c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32l192 0zM64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 64zm80 384c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 8 0c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16l-24 0c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32l-24 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80l8 0 0 16zm34.7-48c6.6-18.6 24.4-32 45.3-32l5.3 0c-6.6 18.6-24.4 32-45.3 32l-5.3 0zM96 368c20.9 0 38.7 13.4 45.3 32l-5.3 0c-20.9 0-38.7-13.4-45.3-32l5.3 0zm82.7-176c6.6-18.6 24.4-32 45.3-32l5.3 0c-6.6 18.6-24.4 32-45.3 32l-5.3 0zM264 144c0-8.8-7.2-16-16-16l-24 0c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32l-24 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80l24 0 24 0c44.2 0 80-35.8 80-80zM96 160c20.9 0 38.7 13.4 45.3 32l-5.3 0c-20.9 0-38.7-13.4-45.3-32l5.3 0zm82.7 136c6.6-18.6 24.4-32 45.3-32l5.3 0c-6.6 18.6-24.4 32-45.3 32l-5.3 0zM264 248c0-8.8-7.2-16-16-16l-24 0c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32l-24 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80l24 0 24 0c44.2 0 80-35.8 80-80zM96 264c20.9 0 38.7 13.4 45.3 32l-5.3 0c-20.9 0-38.7-13.4-45.3-32l5.3 0z'
      
    ]
  };

  

  
  

  var faSpoon = {
    prefix: 'fal',
    iconName: 'spoon',
    icon: [
      512,
      512,
      [61873,129348,"utensil-spoon"],
      'f2e5',
      
      'M274.7 205.3l32 32c12.5 12.5 28.7 18.7 45.1 18.7c27.5 0 59.3-17 85.5-48.5C463.3 176.4 480 135.5 480 96c0-35.3-28.7-64-64-64c-39.5 0-80.4 16.7-111.5 42.6C273 100.9 256 132.7 256 160.1c0 16.4 6.3 32.6 18.7 45.1zm-22.6 22.6c-18.7-18.7-28.1-43.2-28.1-67.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.5 0-49-9.4-67.7-28.1l-4.7-4.7L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L256.8 232.6l-4.7-4.7z'
      
    ]
  };

  
    var faUtensilSpoon = faSpoon;
  

  
  

  var faCheeseSwiss = {
    prefix: 'fal',
    iconName: 'cheese-swiss',
    icon: [
      512,
      512,
      [129472],
      'f7f0',
      
      'M480 240.2l0 15.8-66.7 0c-6.6-18.6-24.4-32-45.3-32s-38.7 13.4-45.3 32L32 256c0-9.3 4.6-18 12.4-23.1l148.7-99.2c-.7 3.3-1.1 6.7-1.1 10.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.6-17-43.2-39.4-47.2l44.1-29.4L274.9 40.7l17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4C401.1 64 480 142.9 480 240.2zM322.7 288c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32l66.7 0 0 128c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-128 290.7 0zm-19-256c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-160 0-15.8C512 125.2 418.8 32 303.8 32zM160 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16-240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM352 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faHouseBuilding = {
    prefix: 'fal',
    iconName: 'house-building',
    icon: [
      640,
      512,
      [],
      'e1b1',
      
      'M320 32l256 0c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32l-161.6 0c-2.4 11.8-7.4 22.7-14.4 32l176 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L320 0c-35.3 0-64 28.7-64 64l0 31.3 32 29.3L288 64c0-17.7 14.3-32 32-32zM496 208c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zM464 368l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zM368 80c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm0 32l32 0 0 32-32 0 0-32zm96 0l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm64 0l0 32-32 0 0-32 32 0zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6L352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-163.8zM0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2L0 448zM224 288l0 64-64 0 0-64 64 0zm-64-32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0z'
      
    ]
  };

  

  
  

  var faLeafHeart = {
    prefix: 'fal',
    iconName: 'leaf-heart',
    icon: [
      512,
      512,
      [],
      'f4cb',
      
      'M272 128l104 0c37.4 0 71.5-14.3 97.1-37.7c4.5 21.1 6.9 43.3 6.9 66.3c0 149-98.2 258.9-207.2 259.4l-.8 0c0 0 0 0 0 0c-79.5 0-144-64.5-144-144c0-79.5 64.5-144 144-144zM463.2 54.3C442.6 79.8 411.2 96 376 96L272 96C174.8 96 96 174.8 96 272c0 2.5 .1 4.9 .2 7.4c-.1-2.4-.2-4.9-.2-7.4c0-4 .1-8 .4-12C41.2 295.7 4 356.9 1.4 427.1L0 463.4c-.3 8.8 6.6 16.3 15.4 16.6s16.3-6.6 16.6-15.4l1.3-36.3C35.3 375.8 60 329.4 98 298.4c0 0 0 0 0 0C110.7 383.1 183.8 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-33.9-4.8-66.5-13.5-96.8l-.4-1.5c-1.1-3.6-2.2-7.2-3.4-10.8s-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-2 3.1-4.1 6.1-6.4 8.9l-.6 .8zM97.7 296.6c.1 .6 .2 1.2 .3 1.7l-.3-1.7zm124-53.8c0-11.9 9.6-21.5 21.5-21.5l1.5 0c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5l1.5 0c11.9 0 21.5 9.6 21.5 21.5c0 5.8-2.3 11.4-6.5 15.4L288 316.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0z'
      
    ]
  };

  

  
  

  var faArrowsRotateReverse = {
    prefix: 'fal',
    iconName: 'arrows-rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e630',
      
      'M442.6 210.6C422.2 126.5 346.4 64 256 64c-71.1 0-133.1 38.6-166.3 96l54.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80.7 0L48 192c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 60.6C103.2 75.5 174.5 32 256 32c106.4 0 195.5 74.2 218.3 173.6c2.2 9.6-5.4 18.4-15.3 18.4c-7.9 0-14.6-5.7-16.5-13.4zM69.4 301.4C89.8 385.5 165.6 448 256 448c71.1 0 133.1-38.6 166.3-96l-54.5 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80.9 0 15.1 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-60.2C408.6 436.6 337.3 480 256 480C149.6 480 60.5 405.8 37.7 306.4C35.5 296.8 43.1 288 53 288c7.9 0 14.6 5.7 16.5 13.4z'
      
    ]
  };

  

  
  

  var faArrowDownUpAcrossLine = {
    prefix: 'fal',
    iconName: 'arrow-down-up-across-line',
    icon: [
      576,
      512,
      [],
      'e4af',
      
      'M148.7 507.3c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4 176 272l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0 0-185.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L400 54.6 400 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0 0 185.4L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96zM144 192l32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144zM432 320l-32 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144z'
      
    ]
  };

  

  
  

  var faSpaghettiMonsterFlying = {
    prefix: 'fal',
    iconName: 'spaghetti-monster-flying',
    icon: [
      640,
      512,
      ["pastafarianism"],
      'f67b',
      
      'M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm42 80.3c13.5-11.7 22-29 22-48.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c4.6 0 9.1-.5 13.4-1.4L219 153.7c-24.9 14.5-43.8 33.5-59.2 52.1c-7.6 9.1-14.4 18.2-20.6 26.4l-.5 .7c-6.4 8.5-12 15.9-17.4 22.2c-11.3 13-18.7 17-25.2 17c-5 0-8.7-1.8-12.7-5.5c-4.5-4.4-8.5-10.5-13.8-18.9l-.5-.7c-4.7-7.5-10.6-16.9-18.3-24.3C42.3 214.2 31 208 16 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c5 0 8.7 1.8 12.7 5.5c4.5 4.4 8.5 10.5 13.8 18.9l.5 .7c4.7 7.5 10.6 16.9 18.3 24.3C69.7 297.8 81 304 96 304c19.4 0 34.1-11.4 45.7-23.9l1 1.5c4.4 6.5 10.2 14.3 17.2 22.6c-3 8.5-5.6 17-8 24.9c0 0 0 0 0 0l-1.3 4.3c-3.4 11.2-6.5 20.8-10.2 28.8c-3.7 8-7.5 13.3-11.7 16.7c-3.8 3-8.8 5.2-16.7 5.2c-11 0-21-5.3-36.8-13.8l-.6-.3c-15-8-34.2-17.9-58.5-17.9c-8.8 0-16 7.2-16 16s7.2 16 16 16c15.6 0 28.5 6.1 43.5 14.1l3.1 1.7C75.9 407 92.7 416 112 416c14.6 0 26.8-4.2 36.7-12.2c9.6-7.6 16-17.9 20.8-28.2c4.8-10.3 8.4-21.9 11.8-32.9l1.3-4.4c.9-2.8 1.7-5.6 2.6-8.4c19.3 17 44.1 33.4 74.6 43.2l-1 3.4s0 0 0 0c-5.4 18.4-13 43.8-24.3 65.6c-13 25-27.2 37.9-42.4 37.9c-8.8 0-16 7.2-16 16s7.2 16 16 16c35.1 0 57.3-29.1 70.8-55.1c12.8-24.7 21.2-53.1 26.6-71.2c.5-1.8 1-3.5 1.5-5.1l.1-.3c9.2 1.4 18.9 2.1 29 2.1s19.7-.7 29-2.1l.1 .3c.5 1.6 1 3.3 1.5 5.1c0 0 0 0 0 0c5.3 18.1 13.8 46.5 26.6 71.2c13.5 26 35.8 55.1 70.8 55.1c8.8 0 16-7.2 16-16s-7.2-16-16-16c-15.2 0-29.4-12.9-42.4-37.9c-11.3-21.8-18.9-47.2-24.3-65.6c0 0 0 0 0 0s0 0 0 0l-1-3.4c30.5-9.8 55.3-26.2 74.6-43.2c.9 2.8 1.7 5.6 2.6 8.4l1.3 4.4c3.4 11 7 22.6 11.8 32.9c4.8 10.3 11.2 20.6 20.8 28.2c9.9 7.9 22.1 12.2 36.7 12.2c19.3 0 36.1-9 49.4-16.2l3.1-1.7c15-8 27.8-14.1 43.5-14.1c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.4 0-43.5 9.9-58.5 17.9l-.6 .3C549 378.7 539 384 528 384c-7.9 0-12.9-2.1-16.7-5.2c-4.2-3.3-8-8.6-11.7-16.7c-3.7-8.1-6.8-17.7-10.2-28.8l-1.3-4.3c-2.4-7.9-5-16.4-8-24.9c7.1-8.3 12.8-16.1 17.2-22.6l1-1.5C509.9 292.6 524.6 304 544 304c15 0 26.3-6.2 34.8-14.5c7.7-7.4 13.6-16.8 18.3-24.3c0 0 0 0 0 0s0 0 0 0l.5-.7c5.3-8.4 9.2-14.6 13.8-18.9c3.9-3.8 7.6-5.5 12.7-5.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-15 0-26.3 6.2-34.8 14.5c-7.7 7.4-13.6 16.8-18.3 24.3c0 0 0 0 0 0s0 0 0 0l-.5 .7c-5.3 8.4-9.2 14.6-13.8 18.9c-3.9 3.8-7.6 5.5-12.7 5.5c-6.5 0-13.9-4-25.2-17c-5.4-6.2-11-13.6-17.4-22.2l-.5-.7c-6.2-8.2-13-17.3-20.6-26.4c-15.5-18.6-34.4-37.5-59.2-52.1l13.5-27.1c4.3 .9 8.8 1.4 13.4 1.4c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 19.3 8.5 36.5 22 48.3L392.1 140c-20.4-7.5-44.2-12-72.1-12s-51.7 4.5-72.1 12L234 112.3zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm4.6 259.8c-.9 .8-1.7 1.7-2.5 2.6c-2.2 2.4-4.6 4.8-7.1 7.2c-27.3 26.3-67.9 52-123 52s-95.7-25.6-123-52c-2.5-2.4-4.8-4.8-7.1-7.2c-.7-1-1.5-1.8-2.5-2.6c-8.9-9.7-15.9-19-20.9-26.4c-2.3-3.4-4.2-6.4-5.7-8.9l3.4-4.5 .3-.4c6.3-8.4 12.7-16.9 19.8-25.4C212.5 192.3 250.4 160 320 160s107.5 32.3 135.7 66.2c7.1 8.5 13.5 17 19.8 25.4l.3 .4 3.4 4.5c-1.5 2.5-3.4 5.5-5.7 8.9c-5 7.4-12 16.7-20.9 26.4z'
      
    ]
  };

  
    var faPastafarianism = faSpaghettiMonsterFlying;
  

  
  

  var faTruckFlatbed = {
    prefix: 'fal',
    iconName: 'truck-flatbed',
    icon: [
      640,
      512,
      [],
      'e2b6',
      
      'M408 96c-13.3 0-24 10.7-24 24l0 264-133.5 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-148.2c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96L408 96zm8 160l160 0 0 128-5.5 0c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4l0-88.4zm154.9-32L416 224l0-96 65.3 0c4.7 0 9.1 2 12.1 5.6L570.9 224zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faClarinet = {
    prefix: 'fal',
    iconName: 'clarinet',
    icon: [
      640,
      512,
      [],
      'f8ad',
      
      'M224 112c0-8.8 7.2-16 16-16l32 0 96 0 96 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 32 44.6 0c7.9 0 15.6-2.3 22.2-6.7L602.7 116c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136l0 240c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7l-411.2 0c-8.6 0-17.1-1.3-25.3-3.7L17.1 327C7 323.9 0 314.6 0 304l0-96c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7L256 160l0-32-16 0c-8.8 0-16-7.2-16-16zm224 16l-64 0 0 32 64 0 0-32zm-96 0l-64 0 0 32 64 0 0-32zm256 22.9l-43.4 29c-11.8 7.9-25.7 12.1-39.9 12.1l-411.2 0c-5.5 0-10.9 .8-16.1 2.4L32 214 32 298l65.3 19.6c5.2 1.6 10.6 2.4 16.1 2.4l411.2 0c14.2 0 28.1 4.2 39.9 12.1l43.4 29 0-210.1zM272 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBong = {
    prefix: 'fal',
    iconName: 'bong',
    icon: [
      448,
      512,
      [],
      'f55c',
      
      'M128 208.5c0 17.4-9.3 32.4-22.5 40.9C79 266.4 58 291 45.3 320l293.4 0c-12.7-29-33.7-53.6-60.2-70.6c-13.2-8.5-22.5-23.5-22.5-40.9L256 32 128 32l0 176.5zM35.2 352c-2.1 10.3-3.2 21-3.2 32c0 32.9 9.9 63.4 26.9 88.8c2.4 3.5 8 7.2 17.2 7.2l231.9 0c9.2 0 14.9-3.7 17.2-7.2c17-25.4 26.9-55.9 26.9-88.8c0-11-1.1-21.7-3.2-32L35.2 352zM96 208.5L96 32 80 32c-8.8 0-16-7.2-16-16S71.2 0 80 0l32 0L272 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 176.5c0 5.7 3.1 10.9 7.9 14c13.4 8.6 25.7 18.9 36.5 30.5l45-45-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l32 32 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 230.6l-47.7 47.7C372.3 308.6 384 345 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5L76.1 512c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14z'
      
    ]
  };

  

  
  

  var faCameraMovie = {
    prefix: 'fal',
    iconName: 'camera-movie',
    icon: [
      576,
      512,
      [127909,127910],
      'f8a9',
      
      'M144 0c40.8 0 76.4 21.8 96 54.3C259.6 21.8 295.2 0 336 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-192 0C82.1 224 32 173.9 32 112S82.1 0 144 0zM64 112c0 44.2 35.8 80 80 80l192 0c44.2 0 80-35.8 80-80s-35.8-80-80-80c-39.6 0-72.5 28.8-78.9 66.6c-1.3 7.7-8 13.4-15.8 13.4l-2.7 0c-7.8 0-14.5-5.6-15.8-13.4C216.5 60.8 183.6 32 144 32c-44.2 0-80 35.8-80 80zm80-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 288l-8 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-216 0zm0-32l216 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-128c0-11.7 3.1-22.6 8.6-32L16 288c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 8 0zM448 440.9l85.4 38.4c1 .4 2 .7 3.1 .7c4.2 0 7.5-3.4 7.5-7.5l0-180.6c0-3.2-2.9-5.6-6-5.1c-.4 .1-.9 .2-1.3 .4L448 327.1l0-35.1 75.6-34c2.9-1.3 6-2.2 9.1-2.8c22.6-3.8 43.3 13.7 43.3 36.6l0 180.6c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L448 476l0-35.1z'
      
    ]
  };

  

  
  

  var faSigma = {
    prefix: 'fal',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      'M1.3 41.6C3.9 35.8 9.6 32 16 32l328 0c22.1 0 40 17.9 40 40l0 72c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-72c0-4.4-3.6-8-8-8L52.5 64 219.8 245.1c5.7 6.1 5.7 15.6 0 21.7L52.5 448 344 448c4.4 0 8-3.6 8-8l0-72c0-8.8 7.2-16 16-16s16 7.2 16 16l0 72c0 22.1-17.9 40-40 40L16 480c-6.4 0-12.1-3.8-14.7-9.6s-1.4-12.6 2.9-17.3L186.2 256 4.2 58.9C-.1 54.2-1.2 47.4 1.3 41.6z'
      
    ]
  };

  

  
  

  var faFaceGrinStars = {
    prefix: 'fal',
    iconName: 'face-grin-stars',
    icon: [
      512,
      512,
      [129321,"grin-stars"],
      'f587',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM160 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1 .8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1L160 257.4l39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.5-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2l8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5l-14.5-13.7 19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18zM352 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1 .8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1L352 257.4l39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.4-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2l8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5l-14.5-13.7 19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18z'
      
    ]
  };

  
    var faGrinStars = faFaceGrinStars;
  

  
  

  var faSquareP = {
    prefix: 'fal',
    iconName: 'square-p',
    icon: [
      448,
      512,
      [],
      'e279',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 32l88 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-72 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-144c0-8.8 7.2-16 16-16zm88 144c30.9 0 56-25.1 56-56s-25.1-56-56-56l-72 0 0 112 72 0z'
      
    ]
  };

  

  
  

  var faBringForward = {
    prefix: 'fal',
    iconName: 'bring-forward',
    icon: [
      512,
      512,
      [],
      'f856',
      
      'M224 480l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0 0-32 64 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 32 0 0 64c0 17.7 14.3 32 32 32zM64 320l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 224c0 17.7 14.3 32 32 32zm224 32L64 352c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64zm-32-96l0-160L96 96l0 160 160 0zm32 0c0 17.7-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32L64 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160z'
      
    ]
  };

  

  
  

  var faRecordVinyl = {
    prefix: 'fal',
    iconName: 'record-vinyl',
    icon: [
      512,
      512,
      [],
      'f8d9',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTruckPlane = {
    prefix: 'fal',
    iconName: 'truck-plane',
    icon: [
      640,
      512,
      [],
      'e58f',
      
      'M189.2 13.3C198.8 5.7 210.6 0 224 0c26.9 0 47.1 21.6 59.2 41.8c10.4 17.3 17.7 38 20 56.3c-12.3 3.3-23.1 10.2-31.2 19.4l0-7.8c0-13.6-5.9-34.2-16.2-51.4C244.9 40.2 233.1 32 224 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20C182.1 75.6 176 96.2 176 109.7l0 80c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9l0 56.2 123.6-35.3c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8l0 57.1c0 5-2.4 9.8-6.4 12.8L112 440l0 39.4 107.6-30.7c2.9-.8 5.9-.8 8.8 0l38.8 11.1c5.4 7.8 12.5 14.4 20.8 19.2l0 20-64-18.3L118.3 510.8s0 0 0 0c-2.7 .8-5.5 1.2-8.3 1.2c-16.6 0-30-13.4-30-30l0-42c0-10.1 4.7-19.6 12.8-25.6L144 376l0-27.9L40.8 377.6C20.3 383.4 0 368 0 346.8l0-56.2c0-17.2 9.2-33.1 24.2-41.7L144 180.4l0-70.8c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zM592 160l-256 0c-8.8 0-16 7.2-16 16l0 136.6c4.3-2.5 8.9-4.5 13.8-5.9l3.5-11.8 12.4-41.2c8.1-27.1 33-45.6 61.3-45.6l106 0c28.3 0 53.2 18.5 61.3 45.6l12.4 41.2 3.5 11.8c4.9 1.4 9.5 3.4 13.8 5.9L608 176c0-8.8-7.2-16-16-16zm48 208l0 48c0 20.9-13.4 38.7-32 45.3l0 34.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-224 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-34.7c-18.6-6.6-32-24.4-32-45.3l0-48 0-192c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48l0 192zm-32 48l0-48c0-17.7-14.3-32-32-32l-16 0-192 0-16 0c-17.7 0-32 14.3-32 32l0 48c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16zM560 304l-9.6-32-2.8-9.2C543.6 249.3 531.1 240 517 240l-106 0c-14.1 0-26.6 9.3-30.6 22.8l-2.8 9.2L368 304l33.4 0 125.2 0 33.4 0zM376 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fal',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 164.9c-29.4 29.8-29.4 78.2 0 108L233.5 376.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 272.9c29.4-29.8 29.4-78.2 0-108c-27.8-28.2-71.9-29.7-101.5-4.6c-5.8 4.9-11 10.4-16.3 15.9c-2.1 2.2-4.2 4.5-6.4 6.6c-2.1-2.2-4.3-4.4-6.4-6.6c-5.2-5.5-10.5-11-16.3-15.9c-29.6-25.1-73.7-23.6-101.5 4.6zm83.6 22.5l29.1 29.6c6.3 6.4 16.5 6.4 22.8 0l29.1-29.6c16.8-17.1 44-17.1 60.8 0c17.1 17.4 17.1 45.7 0 63.1L256 353.3 154.7 250.4c-17.1-17.4-17.1-45.7 0-63.1c16.8-17.1 44-17.1 60.8 0z'
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faChevronsLeft = {
    prefix: 'fal',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      'M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 267.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-192 192zm384-192l-192 192c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 459.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faUnion = {
    prefix: 'fal',
    iconName: 'union',
    icon: [
      384,
      512,
      [8899],
      'f6a2',
      
      'M16 32c8.8 0 16 7.2 16 16l0 240c0 88.4 71.6 160 160 160s160-71.6 160-160l0-240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 240c0 106-86 192-192 192S0 394 0 288L0 48c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faMenorah = {
    prefix: 'fal',
    iconName: 'menorah',
    icon: [
      640,
      512,
      [],
      'f676',
      
      'M48 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64C16 7.2 23.2 0 32 0s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 128c8.8 0 16 7.2 16 16l0 160c0 26.5 21.5 48 48 48l16 0 0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208 64 0 0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208 64 0 0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208 64 0 0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208 64 0 0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208 16 0c26.5 0 48-21.5 48-48l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 44.2-35.8 80-80 80l-208 0 0 96 160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-176 0-176 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l160 0 0-96L96 384c-44.2 0-80-35.8-80-80l0-160c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faFileCsv = {
    prefix: 'fal',
    iconName: 'file-csv',
    icon: [
      512,
      512,
      [],
      'f6dd',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faLaptop = {
    prefix: 'fal',
    iconName: 'laptop',
    icon: [
      640,
      512,
      [128187],
      'f109',
      
      'M512 64L128 64c-17.7 0-32 14.3-32 32l0 256-32 0L64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-32 0 0-256c0-17.7-14.3-32-32-32zM76.8 448l486.4 0c20.3 0 37.4-13.5 42.9-32L33.9 416c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2z'
      
    ]
  };

  

  
  

  var faPerson = {
    prefix: 'fal',
    iconName: 'person',
    icon: [
      320,
      512,
      [129485,"male"],
      'f183',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164l0 156 64 0 0-156c-6-2.6-12.5-4-19.3-4l-25.4 0c-6.8 0-13.3 1.4-19.3 4zm0 188l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-293.9L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3l25.4 0c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L224 202.2 224 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0z'
      
    ]
  };

  
    var faMale = faPerson;
  

  
  

  var faFireFlameSimple = {
    prefix: 'fal',
    iconName: 'fire-flame-simple',
    icon: [
      384,
      512,
      ["burn"],
      'f46a',
      
      'M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4C125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM192 160c9.3 0 18.3 3.7 24.9 10.3l8.9 8.9c28.8 28.8 52.1 62.7 68.6 99.9l1.9 4.3c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432s-112-50.8-112-112.5c0-12.4 2.6-24.7 7.6-36l1.9-4.3c16.5-37.2 39.8-71.1 68.6-99.9l8.9-8.9c6.6-6.6 15.6-10.3 24.9-10.3zm-2.3 32.9l-8.9 8.9c-26 26-47.1 56.6-62 90.3l-1.9 4.3c-3.2 7.2-4.9 15.1-4.9 23c0 44.3 35.9 80.5 80 80.5s80-36.2 80-80.5c0-7.9-1.7-15.8-4.9-23l-1.9-4.3c-15-33.6-36-64.3-62-90.3l-8.9-8.9c-.6-.6-1.4-.9-2.3-.9s-1.7 .4-2.3 .9z'
      
    ]
  };

  
    var faBurn = faFireFlameSimple;
  

  
  

  var faPersonCarryBox = {
    prefix: 'fal',
    iconName: 'person-carry-box',
    icon: [
      384,
      512,
      ["person-carry"],
      'f4cf',
      
      'M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM60 176c7 0 13.8 1.5 20 4.2l0 139.3L39.1 292.2c-4.5-3-7.1-8-7.1-13.3L32 204c0-15.5 12.5-28 28-28zm52 38.5l37.8 58.8c5.9 9.2 16 14.7 26.9 14.7l47.3 0 16 0 112 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L224 96c-17.7 0-32 14.3-32 32l0 128-15.3 0-47.8-74.4C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60l0 74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8l0-126.3zM224 256l0-128 128 0 0 128-112 0-16 0z'
      
    ]
  };

  
    var faPersonCarry = faPersonCarryBox;
  

  
  

  var faArrowUpLong = {
    prefix: 'fal',
    iconName: 'arrow-up-long',
    icon: [
      384,
      512,
      ["long-arrow-up"],
      'f176',
      
      'M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-144 144c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-441.4L324.7 171.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-144-144z'
      
    ]
  };

  
    var faLongArrowUp = faArrowUpLong;
  

  
  

  var faCalendarCircleUser = {
    prefix: 'fal',
    iconName: 'calendar-circle-user',
    icon: [
      576,
      512,
      [],
      'e471',
      
      'M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l266.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256 320 0 64 0 16 0 16 0 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM492 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6l56.4 0c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8l-56.4 0c-21.8 0-42.2 9.6-56.1 25.8C330.5 422.1 320 396.2 320 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faTransporter = {
    prefix: 'fal',
    iconName: 'transporter',
    icon: [
      512,
      512,
      [],
      'e042',
      
      'M464 0c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zM48 64c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM128 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm64-302.9c-.5 .6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7l54.6 0c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9L320 304l0 96 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-96 0-110.9zm32-16.8L224 288l64 0 0-111.8c-1.6-.2-3.1-.2-4.7-.2l-54.6 0c-1.6 0-3.2 .1-4.7 .2z'
      
    ]
  };

  

  
  

  var faDiagramPredecessor = {
    prefix: 'fal',
    iconName: 'diagram-predecessor',
    icon: [
      512,
      512,
      [],
      'e477',
      
      'M480 352c0-17.7-14.3-32-32-32L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zm32 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM256 96c0-17.7-14.3-32-32-32l-32 0L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64zm23.4-32c5.4 9.4 8.6 20.3 8.6 32l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c35.3 0 64 28.7 64 64l0 89.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L400 185.4 400 96c0-17.7-14.3-32-32-32l-88.6 0zM96 112l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCrateEmpty = {
    prefix: 'fal',
    iconName: 'crate-empty',
    icon: [
      512,
      512,
      [],
      'e151',
      
      'M480 384l0 72c0 13.3-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24l0-72 448 0zm0-32L32 352l0-72c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24l0 72zm32 0l0-72c0-30.9-25.1-56-56-56L56 224c-30.9 0-56 25.1-56 56l0 72 0 16 0 16 0 72c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-72 0-16 0-16zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCarpool = {
    prefix: 'fal',
    iconName: 'carpool',
    icon: [
      512,
      512,
      ["car-people"],
      'e69c',
      
      'M100.1 101.2L71 227.3c8-2.1 16.3-3.3 25-3.3l4.5 0 1.4-4.2c5.1-15.2 15.4-27.5 28.6-35.1c-6.6-9.2-10.5-20.5-10.5-32.6c0-30.9 25.1-56 56-56s56 25.1 56 56c0 12.2-3.9 23.4-10.5 32.6c13.2 7.7 23.6 20 28.6 35.1l1.4 4.2 8.9 0 1.4-4.2c5.1-15.2 15.4-27.5 28.6-35.1c-6.6-9.2-10.5-20.5-10.5-32.6c0-30.9 25.1-56 56-56s56 25.1 56 56c0 12.2-3.9 23.4-10.5 32.6c13.2 7.7 23.5 20 28.6 35.1l1.4 4.2 4.5 0c8.6 0 17 1.1 25 3.3L411.9 101.2c-5-21.8-24.4-37.2-46.8-37.2L146.9 64c-22.4 0-41.7 15.4-46.8 37.2zM271.6 256l-31.3 0c-.2 0-.5 0-.7 0l-127.3 0c-.2 0-.5 0-.7 0L96 256c-35.3 0-64 28.7-64 64l0 64 448 0 0-64c0-35.3-28.7-64-64-64l-15.6 0c-.2 0-.5 0-.7 0l-127.3 0c-.2 0-.5 0-.7 0zm105.5-32c-5.6-9.8-16.1-16-27.7-16L336 208l-13.4 0c-11.6 0-22.1 6.2-27.7 16l82.2 0zM336 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM134.9 224l82.2 0c-5.6-9.8-16.1-16-27.7-16L176 208l-13.4 0c-11.6 0-22.1 6.2-27.7 16zM176 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM33.7 247L69 94c8.4-36.3 40.7-62 78-62l218.2 0c37.3 0 69.6 25.7 78 62l35.3 153c20.6 17.6 33.7 43.8 33.7 73l0 64 0 16 0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48L32 416l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16 0-16 0-64c0-29.2 13.1-55.4 33.7-73zM96 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm296 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faCarPeople = faCarpool;
  

  
  

  var faBeerMugEmpty = {
    prefix: 'fal',
    iconName: 'beer-mug-empty',
    icon: [
      512,
      512,
      ["beer"],
      'f0fc',
      
      'M352 64L64 64l0 352c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-55.6c0-.2 0-.5 0-.7L352 64zm32 306.5l0 45.5c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64L32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32 64 0c35.3 0 64 28.7 64 64l0 102.1c0 31.8-18.8 60.6-47.9 73.3l-80.1 35zM384 128l0 207.5 67.2-29.4c17.5-7.6 28.8-24.9 28.8-44L480 160c0-17.7-14.3-32-32-32l-64 0zm-240 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16z'
      
    ]
  };

  
    var faBeer = faBeerMugEmpty;
  

  
  

  var faPeopleLine = {
    prefix: 'fal',
    iconName: 'people-line',
    icon: [
      640,
      512,
      [],
      'e534',
      
      'M336 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208l48 0 0-110.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5L296 288zm122.4-15.6L376 203.5l0 84.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-84.5-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 299.5l0 68.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-68.5L45.6 368.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 254.4 104 240 131.8 240l24.5 0c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 158.4 280 144 307.8 144l24.5 0c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2l24.5 0c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 299.5l0 68.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-68.5-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM16 448l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 273.5l0 94.5 48 0 0-94.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5zM512 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192l48 0 0-94.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5l0 94.5z'
      
    ]
  };

  

  
  

  var faLightbulbExclamationOn = {
    prefix: 'fal',
    iconName: 'lightbulb-exclamation-on',
    icon: [
      640,
      512,
      [],
      'e1ca',
      
      'M55.2 1.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM119.2 318.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm416-28.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm-96.8-31.6C454.5 234.8 464 206.6 464 176c0-79.5-64.5-144-144-144s-144 64.5-144 144c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19c0 0 0 0 0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9L237 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-32.4 0c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM320 480c20.9 0 38.7-13.4 45.3-32l-90.5 0c6.6 18.6 24.4 32 45.3 32zm-80-53.3c0-5.9 4.8-10.7 10.7-10.7l138.7 0c5.9 0 10.7 4.8 10.7 10.7l0 5.3c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-5.3zM336 112l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faLocationPlus = {
    prefix: 'fal',
    iconName: 'location-plus',
    icon: [
      384,
      512,
      ["map-marker-plus"],
      'f60a',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM176 288l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  
    var faMapMarkerPlus = faLocationPlus;
  

  
  

  var faSquareArrowRight = {
    prefix: 'fal',
    iconName: 'square-arrow-right',
    icon: [
      448,
      512,
      ["arrow-square-right"],
      'f33b',
      
      'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM347.3 267.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 272 112 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l185.4 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faArrowSquareRight = faSquareArrowRight;
  

  
  

  var faPeopleRoof = {
    prefix: 'fal',
    iconName: 'people-roof',
    icon: [
      640,
      512,
      [],
      'e537',
      
      'M328.5 2.5l304 192c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5L320 34.9 24.5 221.5c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1l304-192c5.2-3.3 11.9-3.3 17.1 0zM336 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208l48 0 0-110.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5L296 400zm122.4-15.6L376 315.5l0 84.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-84.5-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5l0 68.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-68.5L45.6 480.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352l24.5 0c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 270.4 280 256 307.8 256l24.5 0c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2l24.5 0c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5l0 68.5c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-68.5-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 385.5l0 94.5 48 0 0-94.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192l48 0 0-94.5c-3.8-1-7.7-1.5-11.8-1.5l-24.5 0c-4 0-8 .5-11.8 1.5l0 94.5z'
      
    ]
  };

  

  
  

  var faUsersRectangle = {
    prefix: 'fal',
    iconName: 'users-rectangle',
    icon: [
      640,
      512,
      [],
      'e594',
      
      'M80 0C35.8 0 0 35.8 0 80L0 432c0 44.2 35.8 80 80 80l480 0c44.2 0 80-35.8 80-80l0-352c0-44.2-35.8-80-80-80L80 0zM32 80c0-26.5 21.5-48 48-48l480 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48L32 80zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32l-158.4 0c3.7-18.3 19.8-32 39.2-32l80 0zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72l-40 0-40 0zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24l56 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-56 0c-30.9 0-56 25.1-56 56l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24l0 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8c0-30.9-25.1-56-56-56l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fal',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M235.3 459.3c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 425.4 372.7 276.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-160 160zm160-352l-160 160c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 372.7 84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCrop = {
    prefix: 'fal',
    iconName: 'crop',
    icon: [
      512,
      512,
      [],
      'f125',
      
      'M416 118.6l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L393.4 96 160 96l0 32 201.4 0L128 361.4 128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 240c0 26.5 21.5 48 48 48l208 0 0-32-201.4 0L384 150.6 384 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-265.4z'
      
    ]
  };

  

  
  

  var faSchoolCircleExclamation = {
    prefix: 'fal',
    iconName: 'school-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e56c',
      
      'M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96 576 96c35.3 0 64 28.7 64 64l0 106.8c-9.1-12.9-19.9-24.5-32-34.6l0-72.2c0-17.7-14.3-32-32-32l-112 0c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7L64 128c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l192 0 0-96c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32l0 96 32 0 32 0 8.2 0c10 12.1 21.7 22.9 34.6 32L384 512l-32 0-64 0-32 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l107.2 0 140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 32 0 0-64-32 0zM96 352c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64zm64 0l-32 0 0 64 32 0 0-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faUserVneck = {
    prefix: 'fal',
    iconName: 'user-vneck',
    icon: [
      448,
      512,
      [],
      'e461',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm128-96A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM185.6 418.1l-57.2-76.3C72.6 358.8 32 410.7 32 472l0 8 384 0 0-8c0-61.3-40.6-113.2-96.4-130.1l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-80.5 56.6-147.7 132.1-164.1z'
      
    ]
  };

  

  
  

  var faFootball = {
    prefix: 'fal',
    iconName: 'football',
    icon: [
      512,
      512,
      [127944,"football-ball"],
      'f44e',
      
      'M456.2 55.4c-48.9-8.2-92.4-10.8-130.9-8.7L464.8 186.2c3.4-47.1-.8-92.9-8.6-130.8zM220 67.1C161.1 89 120.4 126.1 93.3 170.3c-21.6 35.2-34.6 74.9-41.3 115L227.3 460.7c.2 .2 .3 .3 .5 .5c23.5-3.6 44.8-9.1 64.2-16.3c58.9-21.9 99.6-58.9 126.7-103.2c21.6-35.2 34.6-74.9 41.3-115L284.7 51.3c-.2-.2-.3-.3-.5-.5C260.7 54.4 239.4 60 220 67.1zM47.2 325.8c-3.4 47.1 .8 92.9 8.6 130.8c48.9 8.2 92.4 10.8 130.9 8.7L47.2 325.8zM208.9 37.1C274.4 12.8 357.6 6.5 461.5 23.8c13 2.2 23.4 12.1 26.1 25.1c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3c-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6c30.6-50 76.8-92 142.9-116.5zm82.4 119.5l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  
    var faFootballBall = faFootball;
  

  
  

  var faChevronsUp = {
    prefix: 'fal',
    iconName: 'chevrons-up',
    icon: [
      512,
      512,
      ["chevron-double-up"],
      'f325',
      
      'M267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 86.6 436.7 267.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192zm192 384l-192-192c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6 436.7 459.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faChevronDoubleUp = faChevronsUp;
  

  
  

  var faFlagCheckered = {
    prefix: 'fal',
    iconName: 'flag-checkered',
    icon: [
      448,
      512,
      [127937],
      'f11e',
      
      'M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16L0 67.8 0 80 0 384l0 20.9L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.8 101.8-27.8c36.4-9.9 75.1-6.1 108.8 10.8c48.7 24.4 105.7 26 155.8 4.6l30.2-12.9c11.8-5 19.4-16.6 19.4-29.4l0-282.2c0-24.4-26.4-39.8-47.6-27.6l-15.8 9c-40.6 23.2-90.2 24.6-132.1 3.7c-37.9-18.9-81.4-23.2-122.2-12.1L32 59.1 32 16zm0 76.2L128 66l0 67.5L32 154.4l0-62.2zm0 94.9l96-20.9 0 71.3L32 258.4l0-71.3zm128-27.8l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3l0 70.7-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3l0-71.3zm160 26.9c17.5 1.3 35.2-.1 52.5-4l43.5-10 0 71.2L365.3 255c-14.9 3.4-30.2 4.5-45.3 3.1l0-71.9zm-32 98.6l0 77.3c-10.6-2.7-21-6.5-31-11.5c-30.2-15.1-63.7-21.6-97-19l0-68.3 3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3zm32 81.8l0-76.5c17.5 1.3 35.2-.1 52.5-4l43.5-10 0 65.3-30.2 12.9c-21 9-43.5 13.1-65.8 12.3zm0-212.6l0-63c27.8-.8 55.5-8.4 80.4-22.6L416 59.6l0 79.7L365.3 151c-14.9 3.4-30.2 4.5-45.3 3.1zM288 89l0 58.6-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3l0-67.6c26.7-3 53.9 1.8 78.2 13.9c15.9 8 32.7 13.3 49.8 16zM32 291.2l96-20.9 0 66.6c-.9 .2-1.7 .4-2.6 .7L32 363.1l0-71.9z'
      
    ]
  };

  

  
  

  var faUtilityPoleDouble = {
    prefix: 'fal',
    iconName: 'utility-pole-double',
    icon: [
      512,
      512,
      [],
      'e2c4',
      
      'M208 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64 80 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 15.8 0 .3 0L480 96l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 17.7-14.3 32-32 32l-42.5 0L304 231.8l0 56.2 80 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 15.8 0 .3 0 47.9 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 17.7-14.3 32-32 32l-42.5 0L304 423.8l0 72.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-79.8 0-.3 0-95.9-32 0 0 95.9 0 .3 0 79.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-72.2L74.5 320 32 320c-17.7 0-32-14.3-32-32l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 47.9 0 .3 0L96 288l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 80 0 0-56.2L74.5 128 32 128C14.3 128 0 113.7 0 96L0 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 47.9 0 .3 0L96 96l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 80 0 0-64zm-81.4 96L208 191.3l0-63.3-81.4 0zM240 224.2l0 63.8 32 0 0-63.8 0-.3 0-95.9-32 0 0 95.9 0 .3zm64-32.9L385.4 128 304 128l0 63.3zM126.6 320L208 383.3l0-63.3-81.4 0zM304 383.3L385.4 320 304 320l0 63.3zM272 32l-32 0 0 64 32 0 0-64z'
      
    ]
  };

  

  
  

  var faBuildingMemo = {
    prefix: 'fal',
    iconName: 'building-memo',
    icon: [
      640,
      512,
      [],
      'e61e',
      
      'M320 32L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 35.3 0c3.4 11.9 9.2 22.7 16.8 32L256 512l-32 0-64 0-32 0-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l-8 0c-8.3 0-16.4 1.2-24 3.3l0-3.3c0-17.7-14.3-32-32-32zM306.3 98.3c-6.7 8.7-11.9 18.8-15 29.7l-3.3 0-32 0 0 32 32 0 0 32-40 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c3.7 0 7.2 .8 10.3 2.3zM288 224l0 32-32 0 0 32 32 0 0 32-40 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l40 0zM192 384c-17.7 0-32 14.3-32 32l0 64 64 0 0-64c0-17.7-14.3-32-32-32zM88 96l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zm-8 64l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zM384 128c-17.7 0-32 14.3-32 32l0 288c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32l-192 0zm-64 32c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-288zm56 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-208l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM448 304c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm16 80l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faSquareX = {
    prefix: 'fal',
    iconName: 'square-x',
    icon: [
      448,
      512,
      [],
      'e286',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm140.1 37.6L224 231.4l83.9-97.8c5.8-6.7 15.9-7.5 22.6-1.7s7.5 15.9 1.7 22.6L245.1 256l87.1 101.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L224 280.6l-83.9 97.8c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.8-1.7-22.6L202.9 256 115.9 154.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7z'
      
    ]
  };

  

  
  

  var faBowlScoop = {
    prefix: 'fal',
    iconName: 'bowl-scoop',
    icon: [
      448,
      512,
      [127847,"bowl-shaved-ice"],
      'e3de',
      
      'M416 224l-32 0c0-88.4-71.6-160-160-160S64 135.6 64 224l-32 0C32 118 118 32 224 32s192 86 192 192zm29.9 65.9c-8.5 67.9-63.4 119.9-130.5 125.6c-4.1 .3-8.2 .5-12.4 .5l-28.8 0 26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2l-192 0c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L147.2 448l26.7-32L145 416c-4.2 0-8.3-.2-12.4-.5c-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6 .8-9.1 3.9-12.6s7.4-5.4 12-5.4l416 0c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96l28.8 0 32 0 36.3 0 32 0 28.8 0c55.8 0 102.9-41 110.9-96L34.1 288zM198.4 436.5L162.2 480l123.7 0-36.3-43.5L224 405.8l-25.6 30.7z'
      
    ]
  };

  
    var faBowlShavedIce = faBowlScoop;
  

  
  

  var faMessageExclamation = {
    prefix: 'fal',
    iconName: 'message-exclamation',
    icon: [
      512,
      512,
      ["comment-alt-exclamation"],
      'f4a5',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM256 80c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCommentAltExclamation = faMessageExclamation;
  

  
  

  var faLightCeiling = {
    prefix: 'fal',
    iconName: 'light-ceiling',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M256 0c8.8 0 16 7.2 16 16l0 144.5c123.3 7.6 223 102.5 238 223.6c2.2 17.5-12.4 31.9-30 31.9L32 416C14.3 416-.2 401.6 2 384.1C17 262.9 116.7 168.1 240 160.5L240 16c0-8.8 7.2-16 16-16zM34.3 384l443.5 0C462.2 275.5 368.8 192 256 192S49.8 275.5 34.3 384zM256 512c-38.7 0-71-27.5-78.4-64l33.1 0c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32l33.1 0c-7.4 36.5-39.7 64-78.4 64z'
      
    ]
  };

  

  
  

  var faFaceSmileBeam = {
    prefix: 'fal',
    iconName: 'face-smile-beam',
    icon: [
      512,
      512,
      [128522,"smile-beam"],
      'f5b8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm-7.6-131c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faSmileBeam = faFaceSmileBeam;
  

  
  

  var faForwardStep = {
    prefix: 'fal',
    iconName: 'forward-step',
    icon: [
      320,
      512,
      ["step-forward"],
      'f051',
      
      'M256 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 161.9 0 28.2L288 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-135.8L77.4 441.8c-5 4-11.2 6.2-17.6 6.2C44.4 448 32 435.6 32 420.2L32 91.8C32 76.4 44.4 64 59.8 64c6.4 0 12.6 2.2 17.6 6.2L256 215.8 256 80zM64 100.6l0 310.7L254.7 256 64 100.6z'
      
    ]
  };

  
    var faStepForward = faForwardStep;
  

  
  

  var faMessageBot = {
    prefix: 'fal',
    iconName: 'message-bot',
    icon: [
      640,
      512,
      [],
      'e3b8',
      
      'M224 384c17.7 0 32 14.3 32 32l0 48 98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4L480 384c17.7 0 32-14.3 32-32l0-160 0-128c0-17.7-14.3-32-32-32L160 32c-17.7 0-32 14.3-32 32l0 128 0 160c0 17.7 14.3 32 32 32l64 0zM544 64l0 112 36.3 0c5.5-9.6 15.9-16 27.7-16c17.7 0 32 14.3 32 32s-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16L544 208l0 144c0 35.3-28.7 64-64 64l-106.7 0L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48 0-32-32 0-32 0c-35.3 0-64-28.7-64-64l0-144-36.3 0c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16L96 176 96 64c0-35.3 28.7-64 64-64L480 0c35.3 0 64 28.7 64 64zM208 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-224 0zm-48 16c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-96zm56 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassLocation = {
    prefix: 'fal',
    iconName: 'magnifying-glass-location',
    icon: [
      512,
      512,
      ["search-location"],
      'f689',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm26.2-178.4c-8.3 14.5-17.7 28.2-26.2 39.6c-8.5-11.4-17.9-25.1-26.2-39.6c-13.7-24-21.8-45.9-21.8-61.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 15.7-8.1 37.6-21.8 61.6zm-14.8 77c22.1-27 68.6-89.8 68.6-138.6c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0zM232 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSearchLocation = faMagnifyingGlassLocation;
  

  
  

  var faHandPointRight = {
    prefix: 'fal',
    iconName: 'hand-point-right',
    icon: [
      512,
      512,
      [],
      'f0a4',
      
      'M456 128c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0-40 0 0-32c0-5.5-.6-10.8-1.6-16L456 128zM240 176s0 0 0 0l0 32s0 0 0 0l0 24c0 13.2-10.7 24-24 24c0 0 0 0 0 0c-13.3 0-24-10.7-24-24l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 15.7 6.4 29.8 16.8 40c-10.4 10.2-16.8 24.3-16.8 40c0 13.8 5 26.4 13.2 36.1C160.3 358.4 152 374.2 152 392c0 8.6 1.9 16.7 5.4 24C87.9 414.6 32 357.8 32 288l0-64C32 153.3 89.3 96 160 96l32 0c26.5 0 48 21.5 48 48l0 32zm32 32l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-31.9 0c0 0 0 0-.1 0l-13.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24zm90.6 0l93.4 0c30.9 0 56-25.1 56-56s-25.1-56-56-56L256 96c-14.6-19.4-37.8-32-64-32l-32 0C71.6 64 0 135.6 0 224l0 64c0 88.4 71.6 160 160 160l48 0 32 0 24 0c30.9 0 56-25.1 56-56c0-12.1-3.8-23.3-10.4-32.5C325.5 349.6 336 332 336 312c0-9.7-2.5-18.8-6.8-26.7C351.7 278 368 256.9 368 232c0-8.6-1.9-16.7-5.4-24zM240 288l40 0c13.2 0 24 10.8 24 24c0 13.3-10.7 24-24 24l-16 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24c0 0 0 0 0 0l24 0zm0 128l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0z'
      
    ]
  };

  

  
  

  var faH1 = {
    prefix: 'fal',
    iconName: 'h1',
    icon: [
      576,
      512,
      [],
      'f313',
      
      'M496 80c0-5.7-3-10.9-7.9-13.8s-10.9-2.9-15.9-.2l-72 40c-7.7 4.3-10.5 14-6.2 21.8s14 10.5 21.8 6.2L464 107.2 464 416l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-336zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 256 0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160 256 0 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160L32 240 32 80z'
      
    ]
  };

  

  
  

  var faStandardDefinition = {
    prefix: 'fal',
    iconName: 'standard-definition',
    icon: [
      576,
      512,
      ["rectangle-sd"],
      'e28a',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 176l0 160c0 8.8 7.2 16 16 16l64 0c53 0 96-43 96-96s-43-96-96-96l-64 0c-8.8 0-16 7.2-16 16zm32 16l48 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-48 0 0-128zm-176.4 2.4c10.1-3.3 24.9-3.6 43.9-1.1c5.8 .8 23.7 3.8 29.2 5c8.6 2 17.2-3.4 19.2-12s-3.4-17.2-12-19.2c-6.8-1.6-25.8-4.7-32-5.5c-20.5-2.7-41-3.1-58 2.4c-18.2 5.9-32.3 18.7-36.6 40.1c-.1 .3-.1 .6-.1 .9c-1.6 11.1-.2 21.3 4.6 30.2c4.7 8.8 11.9 15 19.4 19.5c13.9 8.3 32.4 12.6 47.8 16.2l1.4 .3c17.3 4 31 7.4 40.1 12.8c4.2 2.5 6.4 4.9 7.6 7.1c1.1 2 2 5.1 1.2 10.6c-.7 4.6-2.3 7.5-4.2 9.5c-2 2.2-5.2 4.2-10.1 5.8c-10.3 3.3-25.6 3.6-44.5 1c-8.8-1.2-24-5.7-36.3-9.2c0 0 0 0 0 0c-2.7-.8-5.3-1.5-7.6-2.2c-8.5-2.4-17.4 2.5-19.8 11s2.5 17.4 11 19.8c1.8 .5 3.9 1.1 6.2 1.8c0 0 0 0 0 0c12.1 3.5 30.6 9 42 10.6c0 0 .1 0 .1 0c20.4 2.7 41.4 3.2 58.5-2.2c8.8-2.8 17.2-7.3 23.8-14.4c6.8-7.2 10.9-16.3 12.5-26.7c1.6-11.1 .2-21.3-4.6-30.2c-4.7-8.8-11.9-15-19.4-19.5c-13.9-8.3-32.4-12.6-47.8-16.2c0 0 0 0 0 0l-1.4-.3c-17.3-4-31-7.4-40.1-12.8c-4.2-2.5-6.4-4.9-7.6-7.1c-1-1.9-1.9-4.9-1.2-10.1c1.8-8.2 6.3-12.8 15.1-15.6z'
      
    ]
  };

  
    var faRectangleSd = faStandardDefinition;
  

  
  

  var faSkiBoot = {
    prefix: 'fal',
    iconName: 'ski-boot',
    icon: [
      512,
      512,
      [],
      'e3cc',
      
      'M383.7 19.1c1.7-8.7-4-17.1-12.7-18.8s-17.1 4-18.8 12.7L348.6 32 130.3 32c-22.9 0-42.7 16.2-47.1 38.7L7.8 454.7C2 484.4 24.7 512 54.9 512L464 512l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-76.7c0-17.8-9.9-34.2-25.6-42.5L330 295.4 383.7 19.1zM239.4 64l103 0L317.5 192 256 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l55.3 0-12.4 64L224 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c1.2 0 2.3-.1 3.4-.4l132.1 69.5c5.3 2.8 8.5 8.2 8.5 14.2l0 76.7L54.9 480c-10.1 0-17.6-9.2-15.7-19.1l32-163.1c55-23.2 134.1-82.9 168.2-233.8zm-32.9 0C178.6 180.4 122.7 233.7 79 258.4L114.6 76.9c1.5-7.5 8.1-12.9 15.7-12.9l76.2 0z'
      
    ]
  };

  

  
  

  var faFingerprint = {
    prefix: 'fal',
    iconName: 'fingerprint',
    icon: [
      512,
      512,
      [],
      'f577',
      
      'M32 256C32 132.3 132.3 32 256 32c70.3 0 133 32.4 174.1 83c5.6 6.9 15.6 7.9 22.5 2.4s7.9-15.6 2.4-22.5C408.1 37 336.3 0 256 0C114.6 0 0 114.6 0 256l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zm470.8-68.3c-2.4-8.5-11.2-13.5-19.7-11.2s-13.5 11.2-11.2 19.7c5.2 19 8.1 39 8.1 59.7l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-23.6-3.2-46.5-9.2-68.3zM256 80c-22.8 0-44.6 4.3-64.6 12.2c-9.7 3.8-12 16.1-5.2 24.1c4.8 5.6 12.8 7.2 19.7 4.6c15.6-5.8 32.5-9 50.1-9c79.5 0 144 64.5 144 144l0 24.9c0 28.3-1.8 56.6-5.5 84.6c-1.3 9.7 6.2 18.5 16 18.5c7.9 0 14.6-5.8 15.6-13.6c3.9-29.6 5.8-59.5 5.8-89.5l0-24.9c0-97.2-78.8-176-176-176zM145.1 142.1c-6-7-16.8-7.6-22.8-.5C95.9 172.3 80 212.3 80 256l0 24.9c0 27.8-3.4 55.4-10.2 82.3c-2.6 10.4 5 20.8 15.7 20.8c7 0 13.2-4.6 15-11.4c7.7-29.9 11.6-60.7 11.6-91.7l0-24.9c0-34.7 12.3-66.5 32.7-91.4c5.4-6.5 5.8-16.1 .3-22.5zM256 160c-53 0-96 43-96 96l0 24.9c0 38.6-5.4 77-15.9 114c-3 10.4 4.7 21.1 15.5 21.1c6.9 0 13-4.5 14.9-11.1c11.6-40.2 17.5-82 17.5-124l0-24.9c0-35.3 28.7-64 64-64s64 28.7 64 64l0 24.9c0 38.8-3.9 77.5-11.7 115.4c-2.1 10.1 5.5 19.7 15.8 19.7c7.4 0 13.9-5.1 15.4-12.4c8.3-40.3 12.5-81.4 12.5-122.7l0-24.9c0-53-43-96-96-96zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24.9c0 60.9-11.2 121.2-33.1 178.1l-5.9 15.3c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l5.9-15.3C260.1 410 272 345.7 272 280.9l0-24.9z'
      
    ]
  };

  

  
  

  var faPumpMedical = {
    prefix: 'fal',
    iconName: 'pump-medical',
    icon: [
      448,
      512,
      [],
      'e06a',
      
      'M176 0l32 0c26.5 0 48 21.5 48 48l76.1 0c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L354.7 89.4c-6-6-14.1-9.4-22.6-9.4L256 80l0 48-32 0 0-80c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 80-32 0 0-80c0-26.5 21.5-48 48-48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480l186.4 0c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3l-149.1 0c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7l149.1 0c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3L98.8 512c-37.4 0-66.9-32-63.8-69.3l18.7-224zM208 288l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faLocationMinus = {
    prefix: 'fal',
    iconName: 'location-minus',
    icon: [
      384,
      512,
      ["map-marker-minus"],
      'f609',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM96 176l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 208c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faMapMarkerMinus = faLocationMinus;
  

  
  

  var faSlidersUp = {
    prefix: 'fal',
    iconName: 'sliders-up',
    icon: [
      512,
      512,
      ["sliders-v"],
      'f3f1',
      
      'M96 0c8.8 0 16 7.2 16 16l0 65.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4L112 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-257.6C43.5 231 16 198.7 16 160s27.5-71 64-78.4L80 16C80 7.2 87.2 0 96 0zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4l0 65.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-65.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4L240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 257.6c36.5 7.4 64 39.7 64 78.4zM464 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-32 78.4L432 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-225.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4L400 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 97.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4z'
      
    ]
  };

  
    var faSlidersV = faSlidersUp;
  

  
  

  var faBridgeCircleCheck = {
    prefix: 'fal',
    iconName: 'bridge-circle-check',
    icon: [
      640,
      512,
      [],
      'e4c9',
      
      'M48 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 128 0 128 0 128 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0L384 32 256 32 128 32 48 32zM496 64l0 64-96 0 0-64 96 0zM368 64l0 64-96 0 0-64 96 0zM240 64l0 64-96 0 0-64 96 0zM48 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c35.3 0 64 28.7 64 64l0 96c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-96c0-35.3 28.7-64 64-64c9 0 17.5 1.8 25.2 5.2c5.6-9.3 12.1-18.1 19.3-26.2C351.2 244 336.1 240 320 240c-53 0-96 43-96 96l0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96c0-53-43-96-96-96l-16 0zm448 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faCalculatorSimple = {
    prefix: 'fal',
    iconName: 'calculator-simple',
    icon: [
      512,
      512,
      ["calculator-alt"],
      'f64c',
      
      'M256 0c8.8 0 16 7.2 16 16l0 224 224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0 0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0 0-224c0-8.8 7.2-16 16-16zm88 96l40 0 0-40 0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8 0 40 40 0 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0-40 0 0 40 0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8 0-40-40 0-8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0zM53.1 341.1c6.2-6.2 16.4-6.2 22.6 0L112 377.4l36.3-36.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l36.3 36.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 75.7 458.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 53.1 363.7c-6.2-6.2-6.2-16.4 0-22.6zM48 96l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM336 352l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faCalculatorAlt = faCalculatorSimple;
  

  
  

  var faClosedCaptioningSlash = {
    prefix: 'fal',
    iconName: 'closed-captioning-slash',
    icon: [
      640,
      512,
      [],
      'e135',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480l-40.5-32L96 448c-17.7 0-32-14.3-32-32l0-280.6L32 110.2 32 416c0 35.3 28.7 64 64 64l404.4 0zM139.6 32l40.5 32L544 64c17.7 0 32 14.3 32 32l0 280.6 32 25.3L608 96c0-35.3-28.7-64-64-64L139.6 32zM373.5 216.7c11.7-15 30-24.7 50.5-24.7c17.4 0 33.2 7 44.8 18.3c6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6c-17.3-17-41-27.4-67.2-27.4c-30.7 0-58.1 14.4-75.6 36.9l25.1 19.8zM151.1 204.2C141.6 219.2 136 236.9 136 256c0 53 43 96 96 96c26.2 0 49.9-10.5 67.2-27.4c.7-.6 1.2-1.3 1.8-2l-25.2-19.9C264.3 313.4 249 320 232 320c-35.3 0-64-28.7-64-64c0-11.6 3.1-22.4 8.4-31.8l-25.3-20z'
      
    ]
  };

  

  
  

  var faMicrophoneLinesSlash = {
    prefix: 'fal',
    iconName: 'microphone-lines-slash',
    icon: [
      640,
      512,
      ["microphone-alt-slash"],
      'f539',
      
      'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM395.5 397.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128l0-19.5-32-25.3 0 44.8c0 83 63.1 151.2 144 159.2l0 64.8-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64.8c21.3-2.1 41.4-8.4 59.5-18.1zM256 123.9L256 96c0-35.3 28.7-64 64-64s64 28.7 64 64l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.3 0-15.2 6.4-15.9 14.5L342.2 192l41.8 0 0 32-1.2 0L416 250.2l0-10.2 0-64 0-64 0-16c0-53-43-96-96-96s-96 43-96 96l0 2.7 32 25.3zM446.7 274.5l28.1 22.2c3.4-13 5.2-26.6 5.2-40.7l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 6.3-.5 12.4-1.3 18.5z'
      
    ]
  };

  
    var faMicrophoneAltSlash = faMicrophoneLinesSlash;
  

  
  

  var faIcons = {
    prefix: 'fal',
    iconName: 'icons',
    icon: [
      512,
      512,
      ["heart-music-camera-bolt"],
      'f86d',
      
      'M473.7 4.1C493.5 .2 512 15.3 512 35.5L512 168l-.2 0c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-91.4L352 61.1 352 200l-.2 0c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-97.8c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM105.4 54.6l-6-6c-9-9-21.8-13.1-34.4-11c-19 3.2-33 19.6-33 38.9l0 2.9c0 11.9 4.9 23.2 13.6 31.4L128 187.7l82.4-76.9c8.7-8.1 13.6-19.5 13.6-31.4l0-2.9c0-19.3-13.9-35.8-33-38.9c-12.6-2.1-25.4 2-34.4 11l-6 6L128 77.3 105.4 54.6zM59.7 6C82.5 2.3 105.7 9.7 122 26c0 0 0 0 0 0l6 6 6-6C150.3 9.7 173.5 2.3 196.3 6C230.7 11.8 256 41.6 256 76.5l0 2.9c0 20.8-8.6 40.6-23.8 54.8l-90.4 84.3c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L23.8 134.2C8.6 120 0 100.2 0 79.5l0-2.9C0 41.6 25.3 11.8 59.7 6zM72 320l-24 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-24 0c-12.1 0-23.2-6.8-28.6-17.7L180.2 288l-72.4 0-7.2 14.3C95.2 313.2 84.1 320 72 320zm136.8-46.3L216 288l24 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 336c0-26.5 21.5-48 48-48l24 0 7.2-14.3c5.4-10.8 16.5-17.7 28.6-17.7l72.4 0c12.1 0 23.2 6.8 28.6 17.7zM112 392a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM475.3 283.3L390.6 368l89.4 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L441.4 400 352 400c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faHeartMusicCameraBolt = faIcons;
  

  
  

  var faSoap = {
    prefix: 'fal',
    iconName: 'soap',
    icon: [
      512,
      512,
      [129532],
      'e06e',
      
      'M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM96 192l129.3 0c1.9 11.5 5.9 22.3 11.5 32L96 224c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-12.8 0c5.6-9.7 9.6-20.5 11.5-32l1.3 0c53 0 96 43 96 96l0 128c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 288c0-53 43-96 96-96zm64 80l160 0 32 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-192 0c-44.2 0-80-35.8-80-80s35.8-80 80-80zm-48 80c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48zM400 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM352 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faAtom = {
    prefix: 'fal',
    iconName: 'atom',
    icon: [
      512,
      512,
      [9883],
      'f5d2',
      
      'M322 421.3c-.3 .7-.6 1.3-.9 1.9C301.4 464.7 278 480 256 480s-45.4-15.3-65.1-56.7c-.3-.6-.6-1.3-.9-1.9c21.1-5 43.3-12.6 66-22.6c22.7 9.9 44.9 17.5 66 22.6zM217.1 379.8c-13.4 4.8-26.4 8.6-38.7 11.4c-4-12.6-7.4-26.3-10.1-40.9c8.4 5.7 17.1 11.2 26 16.6c7.6 4.6 15.2 8.9 22.8 13zm116.4 11.4c-12.3-2.8-25.3-6.5-38.7-11.4c7.6-4.1 15.2-8.4 22.8-13c8.9-5.4 17.6-10.9 26-16.6c-2.8 14.6-6.2 28.3-10.1 40.9zm-32.3-51.8c-15.3 9.2-30.4 17.2-45.2 24.2c-14.8-7-29.9-15.1-45.2-24.2c-17.5-10.5-33.7-21.5-48.5-32.8c-1.5-16.2-2.3-33.1-2.3-50.6s.8-34.4 2.3-50.6c14.8-11.3 31.1-22.3 48.5-32.8c15.3-9.2 30.4-17.2 45.2-24.2c14.8 7 29.9 15.1 45.2 24.2c17.5 10.5 33.7 21.5 48.5 32.8c1.5 16.2 2.3 33.1 2.3 50.6s-.8 34.4-2.3 50.6c-14.8 11.3-31.1 22.3-48.5 32.8zm64.3 56.7c6.6-22.1 11.5-46.6 14.6-72.7c16.7-13.5 31.7-27.5 44.7-41.8l.8 1.2c25 37.7 26.8 66.1 16 85.6c-10.4 18.7-33.6 31-76.1 27.7zm18.1-118.2c.3-7.2 .4-14.5 .4-21.9s-.1-14.7-.4-21.9c7.7 7.3 14.8 14.6 21.3 21.9c-6.5 7.3-13.6 14.7-21.3 21.9zm86 106.1c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-28-240.4c10.8 19.5 9.1 47.9-16 85.6l-.8 1.2c-13-14.2-28-28.2-44.7-41.8c-3.1-26.1-8-50.6-14.6-72.7c42.6-3.3 65.7 8.9 76.1 27.7zM321.1 88.7c.3 .6 .6 1.3 .9 1.9c-21.1 5-43.3 12.6-66 22.6c-22.7-9.9-44.9-17.5-66-22.6c.3-.7 .6-1.3 .9-1.9C210.6 47.3 234 32 256 32s45.4 15.3 65.1 56.7zm12.5 32.1c4 12.6 7.4 26.3 10.1 40.9c-8.4-5.7-17.1-11.2-26-16.5c-7.6-4.6-15.2-8.9-22.8-13c13.4-4.8 26.4-8.6 38.7-11.3zm-155.1 0c12.3 2.8 25.3 6.5 38.7 11.3c-7.6 4.1-15.2 8.4-22.8 13c-8.9 5.4-17.6 10.9-26 16.5c2.8-14.6 6.2-28.3 10.1-40.9zm-32-4.9c-6.6 22.1-11.5 46.6-14.6 72.7c-16.7 13.5-31.7 27.5-44.7 41.8l-.8-1.2c-25-37.7-26.8-66.1-16-85.6c10.4-18.7 33.6-31 76.1-27.7zM86.3 282.8l.8-1.2c13 14.2 28 28.2 44.7 41.8c3.1 26.1 8 50.6 14.6 72.7c-42.6 3.3-65.7-8.9-76.1-27.7c-10.8-19.5-9.1-47.9 16-85.6zm42.1-48.8c-.3 7.2-.4 14.5-.4 21.9s.1 14.7 .4 21.9c-7.7-7.3-14.8-14.6-21.3-21.9c6.5-7.3 13.6-14.7 21.3-21.9zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faNfc = {
    prefix: 'fal',
    iconName: 'nfc',
    icon: [
      448,
      512,
      [],
      'e1f7',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm0 96l0 256c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L240 96c-17.7 0-32 14.3-32 32l0 82.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 256L96 384l0-256 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 96c-17.7 0-32 14.3-32 32zM224 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFaceGlasses = {
    prefix: 'fal',
    iconName: 'face-glasses',
    icon: [
      512,
      512,
      [],
      'e377',
      
      'M256 480C132.3 480 32 379.7 32 256c0-22.2 3.2-43.7 9.3-64l7.3 0c-.4 2.6-.6 5.3-.6 8l0 48c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-48c0-2.7-.2-5.4-.6-8l33.1 0c-.4 2.6-.6 5.3-.6 8l0 48c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-48c0-2.7-.2-5.4-.6-8l7.3 0c6 20.3 9.3 41.8 9.3 64c0 123.7-100.3 224-224 224zM224 160.8c-10.2-10.4-24.3-16.8-40-16.8l-80 0c-15.3 0-29.1 6.1-39.2 16l-11.3 0C89.5 84.3 166.6 32 256 32s166.5 52.3 202.4 128l-11.3 0c-10.1-9.9-23.9-16-39.2-16l-80 0c-15.7 0-29.8 6.4-40 16.8l0-.8-64 0 0 .8zM256 0C148.6 0 56.6 66.2 18.6 160L16 160c-8.8 0-16 7.2-16 16c0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c5.1-2.7 8.5-8 8.5-14.2c0-8.8-7.2-16-16-16l-2.6 0C455.4 66.2 363.4 0 256 0zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 200c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48zM104 176l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm88.4 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRightFromBracket = {
    prefix: 'fal',
    iconName: 'right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out-alt"],
      'f2f5',
      
      'M479.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L347.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L479.2 254.2zM512 256c0-9.5-3.9-18.6-10.8-25.1L369.2 106.5C362 99.8 352.5 96 342.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.4-3.8 26.5-10.5L501.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z'
      
    ]
  };

  
    var faSignOutAlt = faRightFromBracket;
  

  
  

  var faFilms = {
    prefix: 'fal',
    iconName: 'films',
    icon: [
      576,
      512,
      [],
      'e17a',
      
      'M224 272l0-48 224 0 0 48 0 80-224 0 0-80zm0-80l0-48 0-80 224 0 0 80 0 48-224 0zM464 32l-16 0L224 32l-16 0-16 0-32 0c-35.3 0-64 28.7-64 64l0 32 0 16 0 16 0 96 0 16 0 16 0 32c0 35.3 28.7 64 64 64l32 0 16 0 16 0 224 0 16 0 16 0 32 0c35.3 0 64-28.7 64-64l0-32 0-16 0-16 0-96 0-16 0-16 0-32c0-35.3-28.7-64-64-64l-32 0-16 0zM160 64l32 0 0 64-64 0 0-32c0-17.7 14.3-32 32-32zm-32 96l64 0 0 48 0 48-64 0 0-96zm0 160l0-32 64 0 0 64-32 0c-17.7 0-32-14.3-32-32zm384 32l-32 0 0-64 64 0 0 32c0 17.7-14.3 32-32 32zm32-96l-64 0 0-48 0-48 64 0 0 96zm0-128l-64 0 0-64 32 0c17.7 0 32 14.3 32 32l0 32zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 352c0 70.7 57.3 128 128 128l336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-336 0c-53 0-96-43-96-96l0-240z'
      
    ]
  };

  

  
  

  var faDoorOpen = {
    prefix: 'fal',
    iconName: 'door-open',
    icon: [
      576,
      512,
      [],
      'f52b',
      
      'M288 480L96 480 96 86.2c0-7.5 5.1-13.9 12.4-15.6l166-38.3c.8-.2 1.7-.3 2.5-.3C283 32 288 37 288 43.1L288 480zm32 0l0-436.9C320 19.3 300.7 0 276.9 0c-3.3 0-6.5 .4-9.7 1.1l-166 38.3C79.4 44.4 64 63.8 64 86.2L64 480l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0 16 0 192 0 32 0 0-32zM232 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM464 64L352 64l0 32 112 0c8.8 0 16 7.2 16 16l0 384c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-368c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faShovel = {
    prefix: 'fal',
    iconName: 'shovel',
    icon: [
      512,
      512,
      [],
      'f713',
      
      'M396 34.6L352.9 77.8C342.1 88.6 336 103.2 336 118.5c0 31.8 25.8 57.5 57.5 57.5c15.3 0 29.9-6.1 40.7-16.9L477.4 116 396 34.6zM377.9 7.5C382.7 2.7 389.2 0 396 0s13.3 2.7 18.1 7.5l90.3 90.3c4.8 4.8 7.5 11.3 7.5 18.1s-2.7 13.3-7.5 18.1l-47.6 47.6c-16.8 16.8-39.6 26.2-63.3 26.2c-18.9 0-36.5-5.9-51-15.9L235.3 299.3l62.1 62.1c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9L32 512c-17.7 0-32-14.3-32-32l0-93.7c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l62.1 62.1L319.9 169.4c-10-14.5-15.9-32-15.9-51c0-23.7 9.4-46.5 26.2-63.3L377.9 7.5zM32 480l93.7 0c33.9 0 66.5-13.5 90.5-37.5L274.7 384 128 237.3 69.5 295.8c-24 24-37.5 56.6-37.5 90.5L32 480z'
      
    ]
  };

  

  
  

  var faFaceIcicles = {
    prefix: 'fal',
    iconName: 'face-icicles',
    icon: [
      512,
      512,
      [],
      'e37c',
      
      'M256 32C132.3 32 32 132.3 32 256c0 .5 0 .9-.1 1.4L24.2 443.9c-.1 2.3-2 4.1-4.3 4.1c-2.2 0-4.1-1.7-4.2-3.9L.2 258.7c-.1-.9-.2-1.8-.2-2.7C0 114.6 114.6 0 256 0S512 114.6 512 256c0 .7 0 1.4-.1 2L496.2 508.1c-.1 2.2-2 3.9-4.2 3.9c-2.3 0-4.1-1.8-4.2-4.1L480 257c0-.3 0-.7 0-1C480 132.3 379.7 32 256 32zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l-9.3 90.7c-.3 3-2.8 5.3-5.9 5.3s-5.6-2.3-5.9-5.3L354.4 399c-3.4 .6-6.8 1-10.4 1l-26.7 0-7.1 42.7c-.5 3-3.1 5.3-6.2 5.3s-5.7-2.2-6.2-5.3L290.7 400 168 400c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 512c-80.2 0-151.8-36.9-198.7-94.6l2.2-53.7C97.6 433 171.3 480 256 480c11.6 0 23-.9 34.1-2.6c4.3 1.7 9 2.6 13.9 2.6c9.7 0 18.7-3.6 25.5-9.7l.8 7.7c.8 7.7 3.9 14.7 8.5 20.3C312.8 507.2 285 512 256 512zm151.3-49.5l4.7-45.8c15.5-15 28.8-32.2 39.4-51.2l1.7 53.8c-13.4 16.2-28.8 30.7-45.8 43.1z'
      
    ]
  };

  

  
  

  var faCircleMinus = {
    prefix: 'fal',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faFolderArrowDown = {
    prefix: 'fal',
    iconName: 'folder-arrow-down',
    icon: [
      512,
      512,
      ["folder-download"],
      'e053',
      
      'M32 96c0-17.7 14.3-32 32-32l124.1 0c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7L448 128c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.9 96c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7L64 32zM272 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4 272 208z'
      
    ]
  };

  
    var faFolderDownload = faFolderArrowDown;
  

  
  

  var faSortDown = {
    prefix: 'fal',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M154.4 445.8c1.4 1.3 3.5 2.2 5.6 2.2s4.2-.8 5.6-2.2L285.8 332.3c1.4-1.3 2.2-3.2 2.2-5.2c0-3.9-3.2-7.1-7.1-7.1L39.1 320c-3.9 0-7.1 3.2-7.1 7.1c0 2 .8 3.8 2.2 5.2L154.4 445.8zm-22 23.3L12.3 355.6C4.4 348.2 0 337.9 0 327.1C0 305.5 17.5 288 39.1 288l241.7 0c21.6 0 39.1 17.5 39.1 39.1c0 10.8-4.4 21.1-12.3 28.5L187.6 469.1c-7.4 7-17.3 10.9-27.6 10.9s-20.1-3.9-27.6-10.9z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faBarcodeScan = {
    prefix: 'fal',
    iconName: 'barcode-scan',
    icon: [
      640,
      512,
      [],
      'f465',
      
      'M64 48l0 144 32 0L96 48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm96 0l0-144-32 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16zM128 48l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 256c0 8.8 7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faMobileSignal = {
    prefix: 'fal',
    iconName: 'mobile-signal',
    icon: [
      512,
      512,
      [],
      'e1ef',
      
      'M96 32l192 0c17.7 0 32 14.3 32 32l0 220.3c10.1-8.3 20.8-15.9 32-22.7L352 64c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l128 0 0-24c0-2.7 0-5.3 .1-8L96 480c-17.7 0-32-14.3-32-32L64 64c0-17.7 14.3-32 32-32zM224 400l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c2.2 0 4.3-.4 6.2-1.3c1.8-8.2 4-16.4 6.6-24.3c-2.9-3.9-7.6-6.4-12.8-6.4zM496 256c-132.5 0-240 107.5-240 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9 93.1-208 208-208c8.8 0 16-7.2 16-16s-7.2-16-16-16zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-144c0-8.8-7.2-16-16-16c-79.5 0-144 64.5-144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9 50.1-112 112-112c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faArrowsUpToLine = {
    prefix: 'fal',
    iconName: 'arrows-up-to-line',
    icon: [
      576,
      512,
      [],
      'e4c2',
      
      'M16 64l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16zM4.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 166.6 112 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-297.4 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112zm320 22.6c6.2 6.2 16.4 6.2 22.6 0L432 166.6 432 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-297.4 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6z'
      
    ]
  };

  

  
  

  var faFork = {
    prefix: 'fal',
    iconName: 'fork',
    icon: [
      512,
      512,
      ["utensil-fork"],
      'f2e3',
      
      'M401.5 28.9c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4L268.2 86.9c-4.4 3.3-8.6 6.9-12.5 10.7l-1.6 1.6C234.8 118.5 224 144.7 224 172c0 25 9.1 49.1 25.5 67.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272.2 262.5C290.9 278.9 315 288 340 288c27.3 0 53.5-10.8 72.8-30.1l1.6-1.6c3.9-3.9 7.5-8.1 10.7-12.5l83.8-114.3c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L399.3 224.9c-2.3 3.1-4.8 6.1-7.6 8.8l-1.6 1.6C376.8 248.5 358.8 256 340 256s-36.8-7.5-50.1-20.8l-13.1-13.1C263.5 208.8 256 190.8 256 172s7.5-36.8 20.8-50.1l1.6-1.6c2.7-2.7 5.7-5.3 8.8-7.6L401.5 28.9zM442.5 60c6.6-5.8 7.3-15.9 1.5-22.6s-15.9-7.3-22.6-1.5l-128 112c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l128-112zM476 90.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5l-112 128c-5.8 6.7-5.1 16.8 1.5 22.6s16.8 5.1 22.6-1.5l112-128z'
      
    ]
  };

  
    var faUtensilFork = faFork;
  

  
  

  var faUfo = {
    prefix: 'fal',
    iconName: 'ufo',
    icon: [
      640,
      512,
      [128760],
      'e047',
      
      'M176.6 238.3c-11.7 11-11.7 11-11.6 11s0 0 0 0s0 0 0 0l.1 .1 .2 .2c.2 .2 .4 .4 .6 .6c.5 .5 1.1 1.1 1.9 1.8c1.6 1.5 4 3.4 7 5.7c6.1 4.5 15.2 10.3 27.7 16c25 11.4 63.1 22.3 117.5 22.3s92.5-10.9 117.5-22.3c12.5-5.7 21.6-11.5 27.7-16c3.1-2.3 5.4-4.2 7-5.7c.8-.7 1.5-1.3 1.9-1.8c.2-.2 .4-.4 .6-.6l.2-.2 .1-.1c0 0 0 0 0 0s0 0 0 0l-11.6-11 11.7 11c2.5-2.6 4-6 4.3-9.6c.8-9.6 .8-19 .1-28.1c38.3 10.3 69.8 24.1 92.1 39.7C597.1 269.1 608 287.5 608 304c0 12.2-5.8 25.2-19.2 38.5c-13.5 13.4-33.7 26.2-60.1 37.3C476.1 401.9 402.3 416 320 416s-156.1-14.1-208.8-36.2c-26.3-11.1-46.6-23.9-60.1-37.3C37.8 329.2 32 316.2 32 304c0-16.5 10.9-34.9 36.5-52.8c22.3-15.6 53.7-29.3 92.1-39.7c-.7 9.1-.7 18.5 .1 28.1c.3 3.6 1.8 7 4.3 9.6l11.7-11zm296.3-61.5C452.3 110.2 390.3 64 320 64s-132.3 46.2-152.8 112.9C120 188.1 79.5 204.5 50.1 225C20.7 245.6 0 272.3 0 304c0 23.2 11.2 43.9 28.6 61.2c17.3 17.2 41.6 32 70.2 44.1C156.2 433.4 234.4 448 320 448s163.8-14.6 221.2-38.7c28.7-12.1 52.9-26.9 70.2-44.1c17.4-17.3 28.6-38 28.6-61.2c0-31.7-20.7-58.4-50.1-79c-29.3-20.5-69.9-36.9-117-48.1zm-21.1 50.5l.1-.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0zm-3.9 3.3c-.5 .4-1.1 .8-1.7 1.3c-4.5 3.3-11.7 7.9-22 12.6C403.5 254 370 264 320 264s-83.5-10-104.2-19.4c-10.4-4.7-17.6-9.4-22-12.6c-.6-.5-1.2-.9-1.7-1.3C189.1 154.3 249.4 96 320 96s130.9 58.3 127.9 134.7zM152 312a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTextSize = {
    prefix: 'fal',
    iconName: 'text-size',
    icon: [
      640,
      512,
      [],
      'f894',
      
      'M32 32C14.3 32 0 46.3 0 64l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 144 0 0 384-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-384 144 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-17.7-14.3-32-32-32L32 32zM352 224c-17.7 0-32 14.3-32 32l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 112 0 0 192-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-192 112 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-17.7-14.3-32-32-32l-128 0-128 0z'
      
    ]
  };

  

  
  

  var faSunHaze = {
    prefix: 'fal',
    iconName: 'sun-haze',
    icon: [
      640,
      512,
      [],
      'f765',
      
      'M435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L320 65.1 229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L129.1 256s0 0 0 0l35.4 0c0-3.2-.9-6.4-2.8-9.1l-54.5-79.1 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-1.9 2.7-2.8 5.9-2.8 9.1l35.4 0s0 0 0 0l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L455 121 435.1 13.1zM448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 0 0 0 0 0l32 0s0 0 0 0c0-53 43-96 96-96s96 43 96 96c0 0 0 0 0 0l32 0s0 0 0 0zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 288zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 384zm64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 480zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0z'
      
    ]
  };

  

  
  

  var faVolleyball = {
    prefix: 'fal',
    iconName: 'volleyball',
    icon: [
      512,
      512,
      [127952,"volleyball-ball"],
      'f45f',
      
      'M415.1 413.7c-85.3 20-177.8 6.8-256.2-42.8c-13.5 21.4-24.2 44.4-31.9 68.2c36.5 25.8 81 40.9 129.1 40.9c62.2 0 118.5-25.4 159.1-66.3zm34-44c10.9-18.4 19.2-38.5 24.4-59.8c-72 12.5-148.4 1.8-217.2-35.5c-31 19.1-57.5 43.1-78.9 70.2c83.6 52.2 184.6 59.1 271.7 25zm30.1-93.4c.6-6.7 .9-13.4 .9-20.3c0-99.3-64.6-183.5-154.1-212.9c52.5 65.3 80.6 150 72.9 239.3c27.1 1.5 54.1-.6 80.3-6.2zM272.8 32.6c-5.5-.4-11.1-.6-16.8-.6c-21.5 0-42.3 3-62 8.7c46.8 56.1 75.7 127.6 77.9 205.8C302.4 263 334.5 273.7 367 279c8-95.3-29.1-184.8-94.2-246.4zM162 52.6C85.2 88.2 32 165.9 32 256c0 7.5 .4 14.9 1.1 22.1c34.4-69.3 92.8-127.1 169.6-159.7l3.7-1.6c-12-23.3-27-44.9-44.4-64.2zM45.3 332.3c11.8 32.5 30.9 61.5 55.3 85C125.7 348.8 173.2 288 239.9 247c-1-35.5-8.2-69.5-20.4-100.9l-4.4 1.9C131.4 183.5 71.8 252.2 45.3 332.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faVolleyballBall = faVolleyball;
  

  
  

  var faBuildingCircleArrowRight = {
    prefix: 'fal',
    iconName: 'building-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e4d1',
      
      'M64 32l256 0c17.7 0 32 14.3 32 32l0 202.8c9.1-12.9 19.9-24.5 32-34.6L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l64 0 32 0 64 0 32 0 64 0c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6l-64 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64-64 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 416l0 64-64 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zM248 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zM64 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm32 8l32 0 0 32-32 0 0-32zm152-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 64l0-32 32 0 0 32-32 0zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352 432 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faRectangleHistory = {
    prefix: 'fal',
    iconName: 'rectangle-history',
    icon: [
      512,
      512,
      [],
      'e4a2',
      
      'M480 192c0-17.7-14.3-32-32-32L64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256zm-32-64c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l384 0zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0zM400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L112 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L400 0z'
      
    ]
  };

  

  
  

  var faTally4 = {
    prefix: 'fal',
    iconName: 'tally-4',
    icon: [
      640,
      512,
      [],
      'e297',
      
      'M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416zM384 32c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zM528 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416z'
      
    ]
  };

  

  
  

  var faAnchorCircleCheck = {
    prefix: 'fal',
    iconName: 'anchor-circle-check',
    icon: [
      640,
      512,
      [],
      'e4aa',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 256-32 0c-79.5 0-144-64.5-144-144l0-25.4 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6 64 336c0 97.2 78.8 176 176 176l48 0 48 0c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8l-32 0 0-256 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faMp3Player = {
    prefix: 'fal',
    iconName: 'mp3-player',
    icon: [
      384,
      512,
      [],
      'f8ce',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 336a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 112a112 112 0 1 1 0-224 112 112 0 1 1 0 224zM168 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 96l0 64 192 0 0-64L96 96zM64 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 192c-17.7 0-32-14.3-32-32l0-64z'
      
    ]
  };

  

  
  

  var faCalendarDays = {
    prefix: 'fal',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192l-104 0 0 72 104 0 0-72zm0 104l-104 0 0 80 104 0 0-80zm0 112l-104 0 0 72 72 0c17.7 0 32-14.3 32-32l0-40zM280 376l0-80-112 0 0 80 112 0zM168 408l0 72 112 0 0-72-112 0zm-32-32l0-80L32 296l0 80 104 0zM32 408l0 40c0 17.7 14.3 32 32 32l72 0 0-72L32 408zm0-144l104 0 0-72L32 192l0 72zm136 0l112 0 0-72-112 0 0 72zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faWifiFair = {
    prefix: 'fal',
    iconName: 'wifi-fair',
    icon: [
      640,
      512,
      ["wifi-2"],
      'f6ab',
      
      'M139.3 298.7C185.6 252.5 249.5 224 320 224s134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0zM288 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faWifi2 = faWifiFair;
  

  
  

  var faTirePressureWarning = {
    prefix: 'fal',
    iconName: 'tire-pressure-warning',
    icon: [
      512,
      512,
      [],
      'f633',
      
      'M416 0c-8.8 0-16 7.2-16 16l0 11.6c0 42.2 9.8 83.9 28.7 121.6l5 9.9c.2 .3 .3 .6 .5 .9c18 30.9 36.4 73.1 35.8 120.5c-.6 45.5-18.7 97.9-76.2 151.4l-275.6 0C60.7 378.5 42.6 326.1 42 280.6c-.6-47.4 17.8-89.7 35.8-120.5c.2-.3 .3-.6 .5-.9l5-9.9C102.2 111.4 112 69.8 112 27.6L112 16c0-8.8-7.2-16-16-16S80 7.2 80 16l0 11.6c0 37.3-8.7 74-25.3 107.3l-4.7 9.5C30.7 177.5 9.3 225.5 10 281c.7 55 23.1 115.3 86 174.1c0 .3 0 .6 0 .9l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 64 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 64 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 64 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40c0-.3 0-.6 0-.9c63-58.8 85.3-119.1 86-174.1c.7-55.5-20.7-103.5-39.9-136.6l-4.7-9.5C440.7 101.6 432 64.8 432 27.6L432 16c0-8.8-7.2-16-16-16zM256 96c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faDiceThree = {
    prefix: 'fal',
    iconName: 'dice-three',
    icon: [
      448,
      512,
      [9858],
      'f527',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBuildingUn = {
    prefix: 'fal',
    iconName: 'building-un',
    icon: [
      384,
      512,
      [],
      'e4d9',
      
      'M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zm-96 96l-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-64 0-32 0-64 0-32 0zM248 224l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm8 64l32 0 0-32-32 0 0 32zM64 248c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zm32 8l0 32 32 0 0-32-32 0zM237.3 71.1l34.7 52L272 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  

  
  

  var faRing = {
    prefix: 'fal',
    iconName: 'ring',
    icon: [
      512,
      512,
      [],
      'f70b',
      
      'M93.1 127.3C133.9 108.2 191.5 96 256 96s122.1 12.2 162.9 31.3C461.1 147 480 171 480 192c0 14.3-8.7 30-27.6 44.8c-6.3-3.7-13-7.2-19.9-10.4C386.5 204.8 324.1 192 256 192s-130.5 12.8-176.5 34.3c-6.9 3.2-13.6 6.7-19.9 10.4C40.7 222 32 206.3 32 192c0-21 18.9-45 61.1-64.7zM480 255.3l0 64.7c0 21-18.9 45-61.1 64.7C378.1 403.8 320.5 416 256 416s-122.1-12.2-162.9-31.3C50.9 365 32 341 32 320l0-64.7c13.2 11.8 29.5 22 47.5 30.4C125.5 307.2 187.9 320 256 320s130.5-12.8 176.5-34.3c18-8.4 34.4-18.6 47.5-30.4zM0 192L0 320c0 40.8 34.8 72.8 79.5 93.7C125.5 435.2 187.9 448 256 448s130.5-12.8 176.5-34.3C477.2 392.8 512 360.8 512 320l0-128c0-40.8-34.8-72.8-79.5-93.7C386.5 76.8 324.1 64 256 64S125.5 76.8 79.5 98.3C34.8 119.2 0 151.2 0 192zm93.1 64.7l-1.5-.7 1.5-.7C133.9 236.2 191.5 224 256 224s122.1 12.2 162.9 31.3l1.5 .7-1.5 .7C378.1 275.8 320.5 288 256 288s-122.1-12.2-162.9-31.3z'
      
    ]
  };

  

  
  

  var faWaveSquare = {
    prefix: 'fal',
    iconName: 'wave-square',
    icon: [
      640,
      512,
      [],
      'f83e',
      
      'M192 64c-8.8 0-16 7.2-16 16l0 144c0 26.5-21.5 48-48 48L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0c8.8 0 16-7.2 16-16l0-144c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 352c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-144c0-26.5 21.5-48 48-48l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0c-8.8 0-16 7.2-16 16l0 144c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-352c0-8.8-7.2-16-16-16l-96 0z'
      
    ]
  };

  

  
  

  var faFileLines = {
    prefix: 'fal',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686,128441,128462,"file-alt","file-text"],
      'f15c',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  
    var faFileAlt = faFileLines;
  
    var faFileText = faFileLines;
  

  
  

  var faExplosion = {
    prefix: 'fal',
    iconName: 'explosion',
    icon: [
      576,
      512,
      [],
      'e4e9',
      
      'M543.4 20.4c2.2-7.7-1.7-15.9-9-19.1s-16-.4-20.1 6.4L342.2 294.6 303.5 140.1C301.7 133 295.3 128 288 128s-13.7 5-15.5 12.1L231.3 304.7l-108-108c-5.2-5.2-13.4-6.2-19.7-2.3s-9.1 11.6-6.8 18.7l39.8 119.5L49.2 320.2c-6.6-.9-13 2.3-16.2 8.1s-2.5 13 1.8 18.1l81 96 4.8 5.7 41.9 0-22.2-26.3-54-64 71.5 10.1c5.5 .8 11-1.3 14.5-5.6s4.6-10 2.9-15.3l-26.6-79.7 80.1 80.1c4.1 4.1 10 5.6 15.6 4.1s9.9-5.9 11.3-11.5L288 210l32.5 129.9c1.6 6.3 6.8 11 13.2 11.9s12.7-2 16.1-7.6L479.3 128.3 416.6 347.6c-1.5 5.3-.2 11 3.4 15.1s9.2 6 14.6 5.1l53.5-8.9-52.4 62.9L413.8 448l41.7 0 4.8-5.8 80-96c4.3-5.1 4.9-12.4 1.6-18.2s-9.9-8.9-16.5-7.8l-71 11.8 89-311.7zM304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0 160 0 192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-177.3 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80L16 480zm210 0c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48l-124 0z'
      
    ]
  };

  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fal',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      'M447 256c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L442.6 172l55.7-55.7c15.6-15.6 15.6-40.9 0-56.6L452.3 13.7C436.7-2 411.3-2 395.7 13.7L340 69.4 312.3 41.7C306.1 35.5 297.7 32 289 32c-18.2 0-33 14.8-33 33l0 159c0 17.7 14.3 32 32 32l159 0zm.7-33.7c.2 .2 .3 .4 .3 .7c0 .5-.4 1-1 1l-159 0 0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l67-67c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-67 67c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39zM65 256c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L69.4 340 13.7 395.7C-2 411.3-2 436.7 13.7 452.3l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L172 442.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L65 256zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-67 67c-3.1 3.1-8.2 3.1-11.3 0L36.3 429.7c-3.1-3.1-3.1-8.2 0-11.3l67-67c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7z'
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faSquareUser = {
    prefix: 'fal',
    iconName: 'square-user',
    icon: [
      448,
      512,
      [],
      'e283',
      
      'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32c0-70.7-57.3-128-128-128l-64 0c-70.7 0-128 57.3-128 128c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM352 448L96 448c0-53 43-96 96-96l64 0c53 0 96 43 96 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z'
      
    ]
  };

  

  
  

  var faFaceHandPeeking = {
    prefix: 'fal',
    iconName: 'face-hand-peeking',
    icon: [
      640,
      512,
      [129763],
      'e481',
      
      'M185.6 76.8C223 48.7 269.6 32 320 32c66.3 0 125.9 28.8 167 74.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C464 33 395.8 0 320 0C262.4 0 209.2 19.1 166.4 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2zM130.5 375.5c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512c65.6 0 125.4-24.7 170.7-65.2c6.6-5.9 7.1-16 1.3-22.6s-16-7.1-22.6-1.3c-39.6 35.5-91.9 57-149.3 57c-79.8 0-149.8-41.7-189.5-104.5zM415 232c.7-2.6 1-5.2 1-8c0-1.6-.1-3.2-.4-4.8L433.6 232 415 232zm-53.8 14.5c-5.8 6.9-9.2 15.8-9.2 25.5c0 13.4 6.6 25.3 16.7 32.5c-.5 2.4-.7 4.9-.7 7.5c0 22.1 17.9 40 40 40l8 0c0 .3 0 .6 0 .9c0 22.1 17.9 40 40 40l64.8 0c31.6 0 61.9-12.6 84.3-34.9c46.2-46.2 46.5-120.9 1-167.6c0 0 0 0 0 0l-.2-.1-.8-.8c0 0 0 0-.1-.1L560 144.3c-17.2-17.2-45-17.2-62.2 0c-7.3 7.3-11.5 16.6-12.6 26.2l-37.9-27.1c-18-12.8-43-8.7-55.8 9.3c-8.5 11.9-9.6 26.9-4 39.4c-1.1-.1-2.3-.2-3.4-.2c-17.7 0-32 14.3-32 32c0 8.8 3.5 16.7 9.2 22.5zM289.7 376.7c7.1-5.1 17.8-8.7 30.3-8.7s23.2 3.6 30.3 8.7c7.2 5.1 9.7 10.7 9.7 15.3s-2.5 10.2-9.7 15.3c-7.1 5.1-17.8 8.7-30.3 8.7s-23.2-3.6-30.3-8.7c-7.2-5.1-9.7-10.7-9.7-15.3s2.5-10.2 9.7-15.3zm-18.6-26C258 360.1 248 374.4 248 392s10 31.9 23.1 41.3c13.1 9.4 30.5 14.7 48.9 14.7s35.8-5.3 48.9-14.7C382 423.9 392 409.6 392 392s-10-31.9-23.1-41.3C355.8 341.3 338.4 336 320 336s-35.8 5.3-48.9 14.7zM379.4 144.1c-2-6.3-8.7-9.8-15-7.9C327.1 147.9 300 182.8 300 224c0 20.7 6.8 39.8 18.4 55.2c4 5.3 11.5 6.4 16.8 2.4s6.4-11.5 2.4-16.8C329.1 253.4 324 239.3 324 224c0-30.4 20-56.2 47.6-64.9c6.3-2 9.8-8.7 7.9-15zM96 88.3L34.9 149.4c0 0 0 0 0 0l-.8 .8s0 0 0 0l-.1 .2c-45.5 46.6-45.2 121.3 1 167.6c22.4 22.4 52.7 34.9 84.3 34.9l64.8 0c22.1 0 40-17.9 40-40c0-.3 0-.6 0-.9l8 0c22.1 0 40-17.9 40-40c0-2.6-.2-5.1-.7-7.5c10.1-7.3 16.7-19.1 16.7-32.5s-6.6-25.3-16.7-32.5c.5-2.4 .7-4.9 .7-7.5c0-22.1-17.9-40-40-40l-75.2 0 1.5-1.5c17.2-17.2 17.2-45 0-62.2s-45-17.2-62.2 0zm92.9 209.3c6.2 2 10.7 7.6 11.1 14.3c0 .3 0 .6 0 .9c0 8.8-7.2 16-16 16l-64.8 0c-25.2 0-49.5-10-67.3-27.9c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L113 105.3c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L122.8 152l-.5 .5-4.2 4.2-5.7 5.7c-5 5-1.5 13.7 5.7 13.7l8 0 5.9 0 .7 0 99.2 0c8.8 0 16 7.2 16 16c0 0 0 0 0 0l0 .2s0 0 0 0c-.1 8.8-7.2 15.8-16 15.8l-42.8 0-19.6 0c-2.2 0-4 1.8-4 4s1.8 4 4 4l19.6 0 42.8 0 16 0c4.6 0 8.7 1.9 11.6 5c2.7 2.9 4.4 6.8 4.4 11s-1.7 8.2-4.4 11c-2.9 3.1-7 5-11.6 5l-16 0-42.8 0-19.6 0c-2.2 0-4 1.8-4 4s1.8 4 4 4l19.6 0 42.8 0c8.8 0 16 7.1 16 15.9c0 0 0 0 0 0c0 0 0 .1 0 .1c0 0 0 0 0 0c0 8.8-7.2 16-16 16l-16.7 0-26.2 0-5.1 0-14 0c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5l14 0c1.7 0 3.3 .3 4.9 .8zM376 272c0-8.8 7.2-16 16-16l74.6 0c7.4 0 13.4-6 13.4-13.4c0-4.3-2.1-8.4-5.6-10.9L414.7 189c-7.2-5.1-8.9-15.1-3.7-22.3s15.1-8.9 22.3-3.7l73.1 52.2 3.6 2.5 3.6 2.5 1.5 1.1c2.3 1.6 5.1 2.3 7.8 2c9.3-1.1 13.2-12.4 6.6-19l-1.3-1.3-3.1-3.1-3.1-3.1-7.3-7.3c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l45.1 45.1 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9l-64.8 0c-8.8 0-16-7.2-16-16c0-.3 0-.6 0-.9c.5-8.4 7.4-15.1 16-15.1l.5 0 19 0c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5l-19 0-.5 0-31.3 0L408 328c-8.8 0-16-7.2-16-16c0 0 0-.1 0-.1c0-8.8 7.2-15.9 16-15.9l48.4 0 19.6 0c2.2 0 4-1.8 4-4s-1.8-4-4-4l-19.6 0L408 288l-16 0c-4.6 0-8.7-1.9-11.6-5c-2.7-2.9-4.4-6.8-4.4-11z'
      
    ]
  };

  

  
  

  var faTheta = {
    prefix: 'fal',
    iconName: 'theta',
    icon: [
      384,
      512,
      [],
      'f69e',
      
      'M48 256c0-58.9 17.1-111.6 43.9-149.1C118.7 69.4 154.3 48 192 48s73.3 21.4 100.1 58.9C318.9 144.4 336 197.1 336 256s-17.1 111.6-43.9 149.1C265.3 442.6 229.7 464 192 464s-73.3-21.4-100.1-58.9C65.1 367.6 48 314.9 48 256zM192 16C141.3 16 96.9 44.8 65.8 88.3C34.7 131.9 16 191.2 16 256s18.7 124.1 49.8 167.7C96.9 467.2 141.3 496 192 496s95.1-28.8 126.2-72.3C349.3 380.1 368 320.8 368 256s-18.7-124.1-49.8-167.7C287.1 44.8 242.7 16 192 16zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z'
      
    ]
  };

  

  
  

  var faFonduePot = {
    prefix: 'fal',
    iconName: 'fondue-pot',
    icon: [
      512,
      512,
      [129749],
      'e40d',
      
      'M282.1 32.3c-4.3-1.2-8.7 1.4-9.8 5.6l-24 88c-1.2 4.3 1.4 8.7 5.6 9.8s8.7-1.4 9.8-5.6l24-88c1.2-4.3-1.4-8.7-5.6-9.8zM262.5 167.5L255.1 192l-33.4 0 9.7-32.4c-12.3-9.6-18.4-26-14-42.1l24-88c5.8-21.3 27.8-33.9 49.1-28.1s33.9 27.8 28.1 49.1l-24 88c-4.3 15.6-17.2 26.5-32.1 29zM223.4 256l1.2 0c-.4 0-.8 0-1.2 0zm88 0l1.1 0c-.4 0-.7 0-1.1 0zm65.7-88.6L361.5 192l-37.9 0 26.9-42.2c-8.3-12.7-8.9-29.6-.2-43.3l56-88C418.1-.1 442.8-5.6 461.5 6.3s24.1 36.6 12.3 55.2l-56 88c-8.9 14-25.2 20.6-40.6 17.9zM444.3 33.3c-3.7-2.4-8.7-1.3-11 2.5l-56 88c-2.4 3.7-1.3 8.7 2.5 11s8.7 1.3 11-2.5l56-88c2.4-3.7 1.3-8.7-2.5-11zM32 256l0 64c0 70.7 57.3 128 128 128l128 0c70.7 0 128-57.3 128-128l0-64-256 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-32 0zM0 256c0-17.7 14.3-32 32-32l384 0 8 0 24 0 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 64c0 52.3-25.1 98.8-64 128l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.3c-19.6 8.6-41.2 13.3-64 13.3l-128 0c-22.8 0-44.4-4.8-64-13.3L96 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48C25.1 418.8 0 372.3 0 320l0-64z'
      
    ]
  };

  

  
  

  var faRingDiamond = {
    prefix: 'fal',
    iconName: 'ring-diamond',
    icon: [
      384,
      512,
      [],
      'e5ab',
      
      'M136 0c-5.7 0-11 3.1-13.9 8.1l-32 56c-3 5.3-2.8 11.8 .6 16.8l38.4 57.7C54 164.6 0 236 0 320C0 426 86 512 192 512s192-86 192-192c0-84-54-155.4-129.1-181.5l38.4-57.7c3.4-5 3.6-11.6 .6-16.8l-32-56C259 3.1 253.7 0 248 0L136 0zm85.9 130.3c-9.7-1.5-19.7-2.3-29.9-2.3s-20.2 .8-29.9 2.3l-39.3-59L145.3 32l93.4 0 22.5 39.4-39.3 59zM32 320a160 160 0 1 1 320 0A160 160 0 1 1 32 320z'
      
    ]
  };

  

  
  

  var faRobotAstromech = {
    prefix: 'fal',
    iconName: 'robot-astromech',
    icon: [
      512,
      512,
      [],
      'e2d2',
      
      'M256 0C176.5 0 112 64.5 112 144l0 16-16 0c-35.3 0-64 28.7-64 64l0 196.2L2.4 479.5C.8 482.6 0 486 0 489.5C0 501.9 10.1 512 22.5 512L128 512c8.8 0 16-7.2 16-16l0-89.4 36.7 36.7c3 3 7.1 4.7 11.3 4.7l128 0c4.2 0 8.3-1.7 11.3-4.7L368 406.6l0 89.4c0 8.8 7.2 16 16 16l105.5 0c12.4 0 22.5-10.1 22.5-22.5c0-3.5-.8-6.9-2.4-10L480 420.2 480 224c0-35.3-28.7-64-64-64l-16 0 0-16C400 64.5 335.5 0 256 0zM400 192l16 0c17.7 0 32 14.3 32 32l0 200c0 2.5 .6 4.9 1.7 7.2L474.1 480 400 480l0-112 0-176zm-32 0l0 169.4L313.4 416l-114.7 0L144 361.4 144 192l224 0zm-256 0l0 176 0 112-74.1 0 24.4-48.8c1.1-2.2 1.7-4.7 1.7-7.2l0-200c0-17.7 14.3-32 32-32l16 0zm32-48c0-61.9 50.1-112 112-112s112 50.1 112 112l0 16-224 0 0-16zm80-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 240c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fal',
    iconName: 'info',
    icon: [
      192,
      512,
      [],
      'f129',
      
      'M64 64a32 32 0 1 1 64 0A32 32 0 1 1 64 64zM16 176c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 272 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-256-48 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faSalad = {
    prefix: 'fal',
    iconName: 'salad',
    icon: [
      512,
      512,
      [129367,"bowl-salad"],
      'f81e',
      
      'M241.1 32c37.1 0 68.9 22.7 82.3 55c2.8 6.6 9.6 10.6 16.7 9.7c3.9-.5 7.8-.7 11.8-.7c7.4 0 14.6 .8 21.5 2.4C382.1 96.8 391 96 400 96c15.3 0 30 2.4 43.8 6.8C420.5 78.9 388 64 352 64c-1.3 0-2.7 0-4 .1C327.6 26 287.4 0 241.1 0c-46.3 0-86.5 26-106.9 64.1c-2.1-.1-4.1-.1-6.2-.1C57.3 64 0 121.3 0 192c0 23.3 6.2 45.2 17.1 64l39.3 0C41.2 239 32 216.6 32 192c0-53 43-96 96-96c4.6 0 9.2 .3 13.6 1c7.2 1 14.3-3 17-9.7C172 54.8 203.9 32 241.1 32zM400 160c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16l32.5 0c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 5.4 .4 10.8 1.1 16l32.5 0c-1-5.2-1.6-10.5-1.6-16c0-44.2 35.8-80 80-80zM129.3 457.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 417 33.9 372.3 32.1 320l447.8 0c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 470.4 366.5 480 352 480l-192 0c-14.5 0-26.7-9.6-30.7-22.9zM27.4 288C12.3 288 0 300.3 0 315.4c0 67.4 40.6 125.4 98.6 150.8C106.5 492.7 131 512 160 512l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 288zM256 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128zM107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80z'
      
    ]
  };

  
    var faBowlSalad = faSalad;
  

  
  

  var faMessage = {
    prefix: 'fal',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      'M160 384c17.7 0 32 14.3 32 32l0 48 98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4L448 384c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288c0 17.7 14.3 32 32 32l96 0zM0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48 0-32-32 0-64 0c-35.3 0-64-28.7-64-64L0 64z'
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faCoffin = {
    prefix: 'fal',
    iconName: 'coffin',
    icon: [
      384,
      512,
      [9904],
      'f6c6',
      
      'M126.5 32l131 0 91 104c2.3 2.6 3.6 6 3.6 9.5c0 1.4-.2 2.7-.6 4L255.9 480l-127.9 0L32.6 149.4c-.4-1.3-.6-2.6-.6-4c0-3.5 1.3-6.9 3.6-9.5l91-104zM102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1l127.9 0c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0l-131 0c-9.2 0-18 4-24.1 10.9z'
      
    ]
  };

  

  
  

  var faStethoscope = {
    prefix: 'fal',
    iconName: 'stethoscope',
    icon: [
      576,
      512,
      [129658],
      'f0f1',
      
      'M127 10.4c3.1 8.3-1.1 17.5-9.4 20.6L74.4 47.2C68.1 49.5 64 55.5 64 62.2L64 192c0 70.7 57.3 128 128 128s128-57.3 128-128l0-129.8c0-6.7-4.1-12.6-10.4-15L266.4 31c-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4l43.2 16.2c18.7 7 31.1 24.9 31.1 44.9L352 192c0 83-63.1 151.2-144 159.2l0 .8c0 70.7 57.3 128 128 128s128-57.3 128-128l0-98c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62l0 98c0 88.4-71.6 160-160 160s-160-71.6-160-160l0-.8C95.1 343.2 32 275 32 192L32 62.2c0-20 12.4-37.9 31.1-44.9L106.4 1c8.3-3.1 17.5 1.1 20.6 9.4zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMin = {
    prefix: 'fal',
    iconName: 'gauge-simple-min',
    icon: [
      512,
      512,
      ["tachometer-slowest"],
      'f62d',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faTachometerSlowest = faGaugeSimpleMin;
  

  
  

  var faFaceHandYawn = {
    prefix: 'fal',
    iconName: 'face-hand-yawn',
    icon: [
      512,
      512,
      [],
      'e379',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm233.3 45.3L248 318.6s0 0 0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3c0 0 0 0 0 0l-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0c0 0 0 0 0 0l17.3-17.3 34-34s0 0 0 0s0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5c0 0 0 0 0 0l-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3l0 11.7 0 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4s0 0 0 0l51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6c0 0 0 0 0 0l-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 53.6 0 32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0zM220.5 110c-5.5-6.9-15.6-8-22.5-2.5l-80 64c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l80-64c6.9-5.5 8-15.6 2.5-22.5zM294 132.5l80 64c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-80-64c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5z'
      
    ]
  };

  

  
  

  var faUserXmark = {
    prefix: 'fal',
    iconName: 'user-xmark',
    icon: [
      640,
      512,
      ["user-times"],
      'f235',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144l91.4 0zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM468.7 148.7c-6.2 6.2-6.2 16.4 0 22.6L521.4 224l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L544 246.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L566.6 224l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L544 201.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faUserTimes = faUserXmark;
  

  
  

  var faTextHeight = {
    prefix: 'fal',
    iconName: 'text-height',
    icon: [
      576,
      512,
      [],
      'f034',
      
      'M491.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L464 86.6l0 338.7-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 425.4l0-338.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM32 32C14.3 32 0 46.3 0 64l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 112 0 0 384-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-384 112 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-17.7-14.3-32-32-32L32 32z'
      
    ]
  };

  

  
  

  var faHeadSideGoggles = {
    prefix: 'fal',
    iconName: 'head-side-goggles',
    icon: [
      512,
      512,
      ["head-vr"],
      'f6ea',
      
      'M2.3 256c5.8 40.5 22.4 77.5 46.8 108C58.5 375.6 64 388.6 64 401.4L64 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-94.6c0-22.1-9.5-41.9-21.9-57.4c-20-25-33.9-55-39.4-88L2.3 256zM80.9 96C116 56.7 167.1 32 224 32l24 0c36 0 69.3 11.9 96 32l-56 0c-28.4 0-54 12.4-71.6 32L80.9 96zm-45.1 6.6C14.6 113 0 134.8 0 160c0 35.3 28.7 64 64 64l152.4 0c17.6 19.6 43.1 32 71.6 32l112 0 64 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-64 0-8.9 0C356 24.7 304.9 0 248 0L224 0C145 0 75.6 40.8 35.7 102.6zM197.5 192L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l133.5 0c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32zm313.3 96l-33.5 0c-4.5 9.5-14.2 16-25.4 16L432 304c-8.8 0-16 7.2-16 16l0 64c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c35.3 0 64-28.7 64-64l0-48 3.8 0c29.1 0 53.3-20.6 58.9-48zM288 96l96 0 0 128-96 0c-35.3 0-64-28.7-64-64s28.7-64 64-64zM416 224l0-128 48 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-48 0z'
      
    ]
  };

  
    var faHeadVr = faHeadSideGoggles;
  

  
  

  var faCircleL = {
    prefix: 'fal',
    iconName: 'circle-l',
    icon: [
      512,
      512,
      [],
      'e114',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 208c0 17.7 14.3 32 32 32l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-144 0 0-208z'
      
    ]
  };

  

  
  

  var faTrashCan = {
    prefix: 'fal',
    iconName: 'trash-can',
    icon: [
      448,
      512,
      [61460,"trash-alt"],
      'f2ed',
      
      'M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm80 80l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faTrashAlt = faTrashCan;
  

  
  

  var faPhoneArrowUpRight = {
    prefix: 'fal',
    iconName: 'phone-arrow-up-right',
    icon: [
      512,
      512,
      ["phone-arrow-up","phone-outgoing"],
      'e224',
      
      'M292.7 196.7L457.4 32 368 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L496 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4L315.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm36.4 90c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z'
      
    ]
  };

  
    var faPhoneArrowUp = faPhoneArrowUpRight;
  
    var faPhoneOutgoing = faPhoneArrowUpRight;
  

  
  

  var faRectanglesMixed = {
    prefix: 'fal',
    iconName: 'rectangles-mixed',
    icon: [
      576,
      512,
      [],
      'e323',
      
      'M272 64c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16L48 224c-8.8 0-16-7.2-16-16L32 80c0-8.8 7.2-16 16-16l224 0zM48 32C21.5 32 0 53.5 0 80L0 208c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L48 32zM528 64c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l96 0zM432 32c-26.5 0-48 21.5-48 48l0 256c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48l-96 0zM112 336l176 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16l-176 0c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16zM64 352l0 80c0 26.5 21.5 48 48 48l176 0c26.5 0 48-21.5 48-48l0-80c0-26.5-21.5-48-48-48l-176 0c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faAt = {
    prefix: 'fal',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 24c0 48.6-39.4 88-88 88c-33.4 0-62.5-18.7-77.4-46.1c-20.4 28-53.4 46.1-90.6 46.1c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6l0-1.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 0 24c0 30.9 25.1 56 56 56s56-25.1 56-56l0-24C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faTransporter7 = {
    prefix: 'fal',
    iconName: 'transporter-7',
    icon: [
      512,
      512,
      [],
      'e2a8',
      
      'M480 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm64 224c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faBagel = {
    prefix: 'fal',
    iconName: 'bagel',
    icon: [
      640,
      512,
      [129391],
      'e3d7',
      
      'M608 208c0-97.2-78.8-176-176-176c-49.3 0-93.9 20.3-125.8 52.9c-10.5-4.7-21.3-8.7-32.5-11.8C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.4-10.2 10-20.7 13.9-31.7C530.5 382.7 608 304.4 608 208zM364.6 84.4l17.6-.5c6.2-.2 12.1-2.1 17.2-5.6l14.5-10c10.9-7.5 25.3-7.5 36.2 0l14.5 10c5.1 3.5 11 5.4 17.2 5.6l17.6 .5c13.2 .4 24.8 8.8 29.3 21.3l5.9 16.6c2.1 5.8 5.8 10.9 10.6 14.6l14 10.7c10.5 8.1 14.9 21.7 11.2 34.4l-5 16.9c-1.7 5.9-1.7 12.2 0 18.1l5 16.9c3.7 12.7-.7 26.3-11.2 34.4l-14 10.7c-4.9 3.8-8.6 8.8-10.6 14.6l-5.9 16.6c-4.4 12.5-16.1 20.9-29.3 21.3l-17.6 .5c-6.2 .2-12.1 2.1-17.2 5.6l-14.5 10c-2.1 1.5-4.4 2.6-6.7 3.5c2.6-13.2 4.2-26.9 4.5-40.8c9.8-6.4 21.3-9.9 33-10.3l17.6-.5 5.9-16.6c4.1-11.6 11.5-21.8 21.3-29.3l14-10.7-5-16.9c-3.5-11.8-3.5-24.4 0-36.2l5-16.9-14-10.7c-9.8-7.5-17.1-17.7-21.3-29.3l-5.9-16.6-17.6-.5c-12.3-.3-24.3-4.2-34.4-11.2L432 94.8l-14.5 10c-10.2 7-22.1 10.8-34.4 11.2l-17.6 .5-1.8 4.9c-8.4-7.2-17.3-13.8-26.6-19.7c5.3-10.2 15.8-16.9 27.5-17.2zM384 304A176 176 0 1 0 32 304a176 176 0 1 0 352 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm208-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faLineHeight = {
    prefix: 'fal',
    iconName: 'line-height',
    icon: [
      576,
      512,
      [],
      'f871',
      
      'M107.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L80 86.6l0 338.7L27.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 425.4l0-338.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM272 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L272 80zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zM256 416c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faWagonCovered = {
    prefix: 'fal',
    iconName: 'wagon-covered',
    icon: [
      640,
      512,
      [],
      'f8ee',
      
      'M239.4 34.1C250.1 13.8 271.4 0 296 0l48 0c24.6 0 45.9 13.8 56.6 34.1c13.1-12.6 30.6-20.8 50.1-22.1L565.8 4.4c41.7-2.8 71.7 39.5 55.2 77.9L560.3 224c8.7 .1 15.7 7.2 15.7 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-8 0-144 0-16 0-112 0-16 0-144 0-8 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.7 7-15.9 15.7-16L19 82.3C2.5 43.9 32.5 1.6 74.2 4.4l115.1 7.7c19.5 1.3 36.9 9.5 50.1 22.1zM114.6 224L232 224l0-132.1c0-25.3-19.6-46.2-44.8-47.9L72.1 36.3C54.2 35.1 41.4 53.2 48.4 69.7L114.6 224zM408 224l117.4 0L591.6 69.7c7.1-16.5-5.8-34.6-23.7-33.4L452.8 44C427.6 45.7 408 66.6 408 91.9L408 224zM264 91.9L264 224l112 0 0-160c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 27.9zM176 512c-61.9 0-112-50.1-112-112s50.1-112 112-112c56.4 0 103.1 41.7 110.9 96l66.3 0c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l-66.3 0c-7.8 54.3-54.4 96-110.9 96zm16-33.6c31.3-6.4 56-31.1 62.4-62.4L192 416l0 62.4zm-32 0l0-62.4-62.4 0c6.4 31.3 31.1 56 62.4 62.4zM96 399.6l0 .4 0 .4 0-.8zM97.6 384l62.4 0 0-62.4c-31.3 6.4-56 31.1-62.4 62.4zM192 321.6l0 62.4 62.4 0c-6.4-31.3-31.1-56-62.4-62.4zM542.4 416L480 416l0 62.4c31.3-6.4 56-31.1 62.4-62.4zM448 416l-62.4 0c6.4 31.3 31.1 56 62.4 62.4l0-62.4zm-64-16l0-.4 0 .8 0-.4zm64-16l0-62.4c-31.3 6.4-56 31.1-62.4 62.4l62.4 0zm32 0l62.4 0c-6.4-31.3-31.1-56-62.4-62.4l0 62.4z'
      
    ]
  };

  

  
  

  var faCircleChevronRight = {
    prefix: 'fal',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM235.3 379.3l112-112c6.2-6.2 6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L313.4 256 212.7 356.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z'
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faArrowsToCircle = {
    prefix: 'fal',
    iconName: 'arrows-to-circle',
    icon: [
      640,
      512,
      [],
      'e4bd',
      
      'M27.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L137.4 160 80 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 57.4L27.3 4.7zM320 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-57.4 0L635.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 137.4 480 80c0-8.8-7.2-16-16-16zM176 448c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 374.6l0 57.4c0 8.8 7.2 16 16 16zm288 0c8.8 0 16-7.2 16-16l0-57.4L612.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 352l57.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16z'
      
    ]
  };

  

  
  

  var faFillDrip = {
    prefix: 'fal',
    iconName: 'fill-drip',
    icon: [
      576,
      512,
      [],
      'f576',
      
      'M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0l97.4 97.4 64.4-64.4c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L134.1 124.7 36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm208 230.6l-88-88L53.3 250.7C42.8 261.2 36.7 274.4 35 288l397 0 19.7-19.7c15.6-15.6 15.6-40.9 0-56.6L300.3 60.3c-15.6-15.6-40.9-15.6-56.6 0l-64.4 64.4 88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zM39.2 320c3.1 7.7 7.8 15 14.1 21.3L170.7 458.7c25 25 65.5 25 90.5 0L400 320 39.2 320zM544 448s0 0 0 0c0 0 0 0 0 0c0-.1-.1-1.2-.6-3.4c-.6-2.4-1.5-5.4-2.8-9.1c-2.7-7.4-6.8-16.2-11.7-25.8c-5.2-10.2-11.2-20.6-16.9-30.3c-5.8 9.7-11.7 20.1-16.9 30.3c-4.9 9.6-8.9 18.4-11.7 25.8c-1.4 3.7-2.3 6.7-2.8 9.1c-.5 2.2-.6 3.3-.6 3.4c0 0 0 0 0 0c0 17.7 14.3 32 32 32s32-14.3 32-32zm32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448z'
      
    ]
  };

  



export {

  faTurnUp,
  
  faLevelUpAlt,
  

  faMessageText,
  
  faCommentAltText,
  

  faSquareZ,
  

  faPersonCircleCheck,
  

  faHandHoldingMedical,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faMessageMiddle,
  
  faCommentMiddleAlt,
  

  faVideo,
  
  faVideoCamera,
  

  faSquareSlidersVertical,
  
  faSlidersVSquare,
  

  faPlusMinus,
  

  faBulldozer,
  

  faBarcode,
  

  faFileMp4,
  

  faShieldKeyhole,
  

  faReflectVertical,
  

  faSquareShareNodes,
  
  faShareAltSquare,
  

  faComet,
  

  faJetFighter,
  
  faFighterJet,
  

  faPageCaretUp,
  
  faFileCaretUp,
  

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faEyes,
  

  faCircleJ,
  

  faGalleryThumbnails,
  

  faHandPointLeft,
  

  faPineapple,
  

  faCloudQuestion,
  

  faFaceWoozy,
  

  faKipSign,
  

  faFileGif,
  

  faMasksTheater,
  
  faTheaterMasks,
  

  faStapler,
  

  faD,
  

  faBedFront,
  
  faBedAlt,
  

  faHorizontalRule,
  

  faTrowel,
  

  faUmbrella,
  

  faCameraCctv,
  
  faCctv,
  

  faGrid2,
  

  faSack,
  

  faCircleT,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faPersonMilitaryPointing,
  

  faUsersGear,
  
  faUsersCog,
  

  faMagnifyingGlassDollar,
  
  faSearchDollar,
  

  faX,
  

  faSkullCow,
  

  faComputerSpeaker,
  

  faFerrisWheel,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faCircleWaveformLines,
  
  faWaveformCircle,
  

  faFaceNoseSteam,
  

  faTurkishLiraSign,
  
  faTry,
  
  faTurkishLira,
  

  faPrint,
  

  faCommentXmark,
  
  faCommentTimes,
  

  faFaceSmileRelaxed,
  

  faArrowsSpin,
  

  faExclamation,
  

  faTentArrowsDown,
  

  faPlane,
  

  faFaceSadTear,
  
  faSadTear,
  

  faBlockBrickFire,
  
  faFirewall,
  

  faUserInjured,
  

  faTableCellsRowUnlock,
  

  faBrainCircuit,
  

  faSkiBootSki,
  

  faKeyboardBrightnessLow,
  

  faBenchTree,
  

  faCircle3,
  

  faCardsBlank,
  

  faBone,
  

  faFileCheck,
  

  faArrowUpFromWaterPump,
  

  faBoot,
  

  faTruckContainer,
  

  faPenFancySlash,
  

  faToggleLargeOff,
  

  faLightSwitchOff,
  

  faCupcake,
  

  faBugSlash,
  

  faFaceSadSweat,
  

  faLocationPinSlash,
  
  faMapMarkerSlash,
  

  faWindWarning,
  
  faWindCircleExclamation,
  

  faPaperclipVertical,
  

  faHundredPoints,
  
  fa100,
  

  faDown,
  
  faArrowAltDown,
  

  faNoteSticky,
  
  faStickyNote,
  

  faDiceD12,
  

  faGramophone,
  

  faJar,
  

  faMagnet,
  

  faCircle2,
  

  fa1,
  

  faFalafel,
  

  faPenSwirl,
  

  faCommentExclamation,
  

  faGripDots,
  

  faSquareFull,
  

  faStopwatch20,
  

  faShieldExclamation,
  

  faCloudSun,
  

  faSyringe,
  

  faBoombox,
  

  faUserNurse,
  

  faTrashCheck,
  

  faBridgeSuspension,
  

  faTrainTram,
  

  faStarshipFreighter,
  

  faUserLarge,
  
  faUserAlt,
  

  faCirclesOverlap,
  

  faRulerVertical,
  

  faRightLeftLarge,
  

  faArrowDownFromArc,
  

  faFlower,
  

  faMagnifyingGlassMinus,
  
  faSearchMinus,
  

  faCalendarHeart,
  

  faMask,
  

  faTreeDecorated,
  

  faFileHalfDashed,
  

  faBrush,
  

  faMugSaucer,
  
  faCoffee,
  

  faGarlic,
  

  faCommentArrowUp,
  

  faRectangleWide,
  

  faWindowMinimize,
  

  faFileInvoice,
  

  faHandDots,
  
  faAllergies,
  

  faArrowDownToDottedLine,
  

  faClockTwelveThirty,
  

  faOnion,
  

  faUserClock,
  

  faCloudShowers,
  

  faThumbsUp,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faIdCardClip,
  
  faIdCardAlt,
  

  faEarthAsia,
  
  faGlobeAsia,
  

  faHotel,
  

  fa9,
  

  faAlbumCollection,
  

  faGifts,
  

  faCircle4,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendarMinus,
  

  faBandage,
  
  faBandAid,
  

  faClapperboardPlay,
  

  faSensorCloud,
  
  faSensorSmoke,
  

  faBookUser,
  

  faWatchSmart,
  

  faBrain,
  

  faPompebled,
  

  faBowlingBall,
  

  faUnicorn,
  

  faDice,
  

  faSquareEnvelope,
  
  faEnvelopeSquare,
  

  faPersonWalkingArrowRight,
  

  faRectangleBarcode,
  
  faBarcodeAlt,
  

  faSquareS,
  

  faTurnDown,
  
  faLevelDownAlt,
  

  faWheelchairMove,
  
  faWheelchairAlt,
  

  faFaceGrimace,
  
  faGrimace,
  

  faChessPawnPiece,
  
  faChessPawnAlt,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faWaterLadder,
  
  faLadderWater,
  
  faSwimmingPool,
  

  faCalendarDay,
  

  faBellRing,
  

  faAudioDescriptionSlash,
  

  faFileSpreadsheet,
  

  faWheat,
  

  faTurnLeft,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faHands,
  
  faSignLanguage,
  
  faSigning,
  

  faLifeRing,
  

  faMoneyBill1Wave,
  
  faMoneyBillWaveAlt,
  

  faEngine,
  

  faTire,
  

  faScannerGun,
  
  faScanner,
  

  faAlignRight,
  

  faWindowFlip,
  
  faWindowAlt,
  

  faInputText,
  

  faHandHoldingBox,
  

  faDungeon,
  

  faRoadCircleExclamation,
  

  faPaperPlane,
  

  faColumns3,
  

  faRightLeft,
  
  faExchangeAlt,
  

  faMessageDollar,
  
  faCommentAltDollar,
  

  faGridHorizontal,
  

  faCircleO,
  

  faScannerKeyboard,
  

  faHillRockslide,
  

  faMaskFace,
  

  faBottleDroplet,
  

  faTurnDownRight,
  

  faFaceThinking,
  

  faShare,
  
  faMailForward,
  

  faDownLeft,
  

  faDatabase,
  

  faNoteMedical,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faSnake,
  

  faHandcuffs,
  

  faInhaler,
  

  faBookJournalWhills,
  
  faJournalWhills,
  

  faBookOpen,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCorner,
  

  faBahtSign,
  

  faCowbell,
  

  faLightbulbDollar,
  

  faTireRugged,
  

  faRectangleXmark,
  
  faRectangleTimes,
  
  faTimesRectangle,
  
  faWindowClose,
  

  faHandBackPointRibbon,
  

  faCartFlatbedSuitcase,
  
  faLuggageCart,
  

  faEarthEurope,
  
  faGlobeEurope,
  

  faPrintSlash,
  

  faRug,
  

  faUserTag,
  

  faImagePortrait,
  
  faPortrait,
  

  faPersonFalling,
  

  faBriefcase,
  

  faPotFood,
  

  faCloudMoon,
  

  faLocationPen,
  
  faMapMarkerEdit,
  

  faSlashForward,
  

  faShieldQuartered,
  

  faHandFist,
  
  faFistRaised,
  

  faAirplay,
  

  faLamp,
  

  faArrowsSplitUpAndLeft,
  

  faSquareW,
  

  faTruckArrowRight,
  

  faDiagramSuccessor,
  

  faCartFlatbedBoxes,
  
  faDollyFlatbedAlt,
  

  faAngleLeft,
  

  faBuildings,
  

  faHouseCircleCheck,
  

  faSwordLaser,
  

  faTomato,
  

  faBatteryThreeQuarters,
  
  faBattery4,
  

  faCheck,
  

  faIceSkate,
  

  faUserPlus,
  

  faBook,
  

  faTurkey,
  

  faClipboardListCheck,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faCommentSms,
  
  faSms,
  

  faBasketShoppingMinus,
  

  faTableList,
  
  faThList,
  

  faHandBackPointDown,
  

  faH5,
  

  fa4,
  

  faSoftServe,
  
  faCreemee,
  

  faFaceViewfinder,
  

  faGripDotsVertical,
  

  faSpinnerScale,
  

  faM,
  

  faDesktop,
  
  faDesktopAlt,
  

  faDiceD8,
  

  faShower,
  

  faDoNotEnter,
  

  faGaugeSimpleHigh,
  
  faTachometer,
  
  faTachometerFast,
  

  faArrowDownBigSmall,
  
  faSortSizeDown,
  

  faCalendarLines,
  
  faCalendarNote,
  

  faScaleBalanced,
  
  faBalanceScale,
  

  faDrawPolygon,
  

  faFaceMonocle,
  

  faRss,
  
  faFeed,
  

  faArrowTrendDown,
  

  faCookieBite,
  

  faPeopleSimple,
  

  faFaceAngry,
  
  faAngry,
  

  faFunction,
  

  faBorderAll,
  

  faAnchor,
  

  faCircleQuarter,
  

  faBookQuran,
  
  faQuran,
  

  faDeleteRight,
  

  faFileCirclePlus,
  

  faTornado,
  

  faFireFlameCurved,
  
  faFireAlt,
  

  faArrowUpZA,
  
  faSortAlphaUpAlt,
  

  faPersonWalkingArrowLoopLeft,
  

  faClone,
  

  faLinkSlash,
  
  faChainBroken,
  
  faChainSlash,
  
  faUnlink,
  

  faPlugCircleExclamation,
  

  faHandHolding,
  

  faFaceGrinTongueWink,
  
  faGrinTongueWink,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faShoePrints,
  

  faDragon,
  

  faWifiWeak,
  
  faWifi1,
  

  faBorderBottom,
  

  faVolumeSlash,
  

  faSdCard,
  

  faAmpGuitar,
  

  faLighthouse,
  

  faBahai,
  
  faHaykal,
  

  faUserDoctorMessage,
  
  faUserMdChat,
  

  faTrailer,
  

  faBoxHeart,
  

  faCalendar,
  

  faBoothCurtain,
  

  faCloudMoonRain,
  

  faUpDown,
  
  faArrowsAltV,
  

  faPencilMechanical,
  

  faTurtle,
  

  faCaravanSimple,
  
  faCaravanAlt,
  

  faPersonWalkingLuggage,
  

  faParagraphLeft,
  
  faParagraphRtl,
  

  faBagsShopping,
  

  faFan,
  

  faBlockBrick,
  
  faWallBrick,
  

  faVoicemail,
  

  faPersonArrowDownToLine,
  

  faObjectIntersect,
  

  faChimney,
  

  faVialCircleCheck,
  

  faInfinity,
  

  faCassetteVhs,
  
  faVhs,
  

  faChartColumn,
  

  faHippo,
  

  faTransformerBolt,
  

  faT,
  

  faOilCan,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faFaceExplode,
  
  faExplodingHead,
  

  faSquareXmark,
  
  faTimesSquare,
  
  faXmarkSquare,
  

  faFacePouting,
  

  faContainerStorage,
  

  faEarthOceania,
  
  faGlobeOceania,
  

  faGopuram,
  

  faMelon,
  

  faLightbulbCflOn,
  

  faCardHeart,
  

  faShieldHeart,
  

  faVacuum,
  

  faBroom,
  

  faCoinBlank,
  

  faCircleArrowUpLeft,
  

  faCircleG,
  

  faSkeleton,
  

  faDisplayChartUpCircleCurrency,
  

  faPersonBiking,
  
  faBiking,
  

  faTemperatureLow,
  

  faCodeCommit,
  

  faFileMusic,
  

  faClockOne,
  

  faCompassSlash,
  

  faMusic,
  

  faYinYang,
  

  faSendBackward,
  

  faCheese,
  

  faSquareStar,
  

  faWineGlassEmpty,
  
  faWineGlassAlt,
  

  faPenSlash,
  

  faMoon,
  

  faArrowUpFromLine,
  
  faArrowFromBottom,
  

  faCarrot,
  

  faAmpersand,
  

  faAtomSimple,
  
  faAtomAlt,
  

  faPenLine,
  

  faDog,
  

  faWandMagic,
  
  faMagic,
  

  faTents,
  

  faCricketBatBall,
  
  faCricket,
  

  faDiagramCells,
  

  faFaceDiagonalMouth,
  

  faTentArrowTurnLeft,
  

  faBanParking,
  
  faParkingCircleSlash,
  

  faPenNib,
  

  faScythe,
  

  faHouseChimneyWindow,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faGolfBallTee,
  
  faGolfBall,
  

  faHouseMedical,
  

  faPersonSeat,
  

  faDitto,
  

  faPhonePlus,
  

  faGlassesRound,
  
  faGlassesAlt,
  

  faCommentNodes,
  

  faBinary,
  

  faAvocado,
  

  faGunSlash,
  

  faArrowsRepeat1,
  
  faRepeat1Alt,
  

  faArrowUpShortWide,
  
  faSortAmountUpAlt,
  

  faShield,
  
  faShieldBlank,
  

  faFileExport,
  
  faArrowRightFromFile,
  

  faPhoneMissed,
  

  faFireSmoke,
  

  faFaceGrinBeamSweat,
  
  faGrinBeamSweat,
  

  faTrumpet,
  

  faClockRotateLeft,
  
  faHistory,
  

  faNestingDolls,
  

  faMagnifyingGlassMusic,
  

  faChairOffice,
  

  faFishCooked,
  

  faPenPaintbrush,
  
  faPencilPaintbrush,
  

  faBrowser,
  

  faFireplace,
  

  faDiceD10,
  

  faQrcode,
  

  faSubtitlesSlash,
  

  faAlbumCircleUser,
  

  faPancakes,
  

  faCamcorder,
  
  faVideoHandheld,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faBuilding,
  

  faTicketSimple,
  
  faTicketAlt,
  

  faAward,
  

  faUserGroupSimple,
  

  faConveyorBeltEmpty,
  

  faFlagPennant,
  
  faPennant,
  

  faPersonFallingBurst,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faAnt,
  

  faLineColumns,
  

  faCardSpade,
  

  faSpade,
  

  faArrowTurnDown,
  
  faLevelDown,
  

  faBorderRight,
  

  faKnifeKitchen,
  

  faUpFromBracket,
  

  faMercury,
  

  faTransgender,
  
  faTransgenderAlt,
  

  faSimCard,
  

  faDiceFour,
  

  faMandolin,
  

  faMeter,
  

  faFaceGrinHearts,
  
  faGrinHearts,
  

  faSplotch,
  

  faSquareN,
  

  faArrowUpRightDots,
  

  faSquareFragile,
  
  faBoxFragile,
  
  faSquareWineGlassCrack,
  

  faLockKeyholeOpen,
  
  faLockOpenAlt,
  

  faConveyorBeltArm,
  

  faWarehouse,
  

  faSunBright,
  
  faSunAlt,
  

  faGears,
  
  faCogs,
  

  faPartyHorn,
  

  faPeace,
  

  faRobot,
  

  faWhale,
  

  faArrowUpTriangleSquare,
  
  faSortShapesUp,
  

  faTowerControl,
  

  faSpinner,
  

  faCircleQuarters,
  

  faRotate,
  
  faSyncAlt,
  

  faCircleTrash,
  
  faTrashCircle,
  

  faHandPeace,
  

  faDial,
  
  faDialMedHigh,
  

  faAlt,
  

  faDiagramLeanCanvas,
  

  faMugTeaSaucer,
  

  faTtyAnswer,
  
  faTeletypeAnswer,
  

  faSpeakers,
  

  faFaceVomit,
  

  faHammer,
  

  faPersonPraying,
  
  faPray,
  

  faCloudsSun,
  

  faTrophy,
  

  faWheatSlash,
  

  faThumbtack,
  
  faThumbTack,
  

  faSignatureSlash,
  

  faPhoneHangup,
  

  faFaceSmile,
  
  faSmile,
  

  faPersonSign,
  

  faDisplay,
  

  faCoinVertical,
  

  faLocationCheck,
  
  faMapMarkerCheck,
  

  faConveyorBelt,
  

  faGlassWaterDroplet,
  

  faTruckMoving,
  

  faPercent,
  
  faPercentage,
  

  faHandMiddleFinger,
  

  faBrightnessLow,
  

  faGaugeCircleMinus,
  

  faCarTilt,
  

  faVrCardboard,
  

  faShieldMinus,
  

  faThermometer,
  

  faCloudMinus,
  

  faTrafficLight,
  

  faCloudMusic,
  

  faDownToDottedLine,
  

  faFaceExpressionless,
  

  faBabyCarriage,
  
  faCarriageBaby,
  

  faRadio,
  

  faEllipsisStroke,
  
  faEllipsisHAlt,
  

  faBatteryQuarter,
  
  faBattery2,
  

  faVideoSlash,
  

  faFrame,
  

  faComputerClassic,
  

  faPumpSoap,
  

  faCarRear,
  
  faCarAlt,
  

  faRetweet,
  

  faClockFive,
  

  faSignalWeak,
  
  faSignal1,
  

  faChevronRight,
  

  faGenderless,
  

  faBriefcaseMedical,
  

  faTurntable,
  

  faPersonToDoor,
  

  faDisease,
  

  faNotdef,
  

  faTrashCanUndo,
  
  faTrashCanArrowTurnLeft,
  
  faTrashUndoAlt,
  

  faFilterSlash,
  

  faTablePivot,
  

  faHandLizard,
  

  faMoneyBillSimple,
  

  faClouds,
  

  faBacteria,
  

  faChevronLeft,
  

  faArrowLeftToArc,
  

  faNose,
  

  faHollyBerry,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faDrumstickBite,
  

  faDinosaur,
  

  faAngleUp,
  

  faMessageMinus,
  
  faCommentAltMinus,
  

  faFill,
  

  faGlassHalf,
  
  faGlassHalfEmpty,
  
  faGlassHalfFull,
  

  faMessageCode,
  

  faSchoolFlag,
  

  faTablet,
  
  faTabletAndroid,
  

  faCommentQuote,
  

  faCameraSlash,
  

  faCloudBoltSun,
  
  faThunderstormSun,
  

  faBellSlash,
  

  faStoreLock,
  

  faEyeDropperHalf,
  

  faBezierCurve,
  

  faSignalStreamSlash,
  

  faFolderCheck,
  

  faSquareDivide,
  

  faSignHanging,
  
  faSign,
  

  faVacuumRobot,
  

  faAngle,
  

  faOliveBranch,
  

  faPlugCircleMinus,
  

  faArrowTrendUp,
  

  faStore,
  

  faDisplayArrowDown,
  

  faCircleGf,
  

  faChartScatter,
  

  faFaceEyesXmarks,
  

  faPlanetMoon,
  

  faHexagonNodesBolt,
  

  faFolderMinus,
  

  faFloppyDiskCircleArrowRight,
  
  faSaveCircleArrowRight,
  

  faPhotoFilm,
  
  faPhotoVideo,
  

  faVideoArrowDownLeft,
  

  faCandleHolder,
  

  faClockTen,
  

  faSirenOn,
  

  faRocket,
  

  faClockEleven,
  

  faLassoSparkles,
  

  faFaceDisappointed,
  

  faFileCircleInfo,
  

  faArrowLeftFromArc,
  

  faMap,
  

  faUserHairLong,
  

  faAxeBattle,
  

  faCars,
  

  faShekelSign,
  
  faIls,
  
  faShekel,
  
  faSheqel,
  
  faSheqelSign,
  

  faTally2,
  

  faTeeth,
  

  faBlender,
  

  faWrenchSimple,
  

  faPeanut,
  

  faBuildingMagnifyingGlass,
  

  faCakeSlice,
  
  faShortcake,
  

  faEquals,
  

  faH2,
  

  faArrowRightFromLine,
  
  faArrowFromLeft,
  

  faIslandTropical,
  
  faIslandTreePalm,
  

  faBracketSquare,
  
  faBracket,
  
  faBracketLeft,
  

  faHighlighterLine,
  

  faFlaskGear,
  

  faCopyright,
  

  faSymbols,
  
  faIconsAlt,
  

  faRulerCombined,
  

  faSquareQ,
  

  faLinesLeaning,
  

  faArrowDownToBracket,
  

  faArrowDownUpLock,
  

  faTrashArrowUp,
  
  faTrashRestore,
  

  faKeySkeleton,
  

  faDownFromBracket,
  

  faTractor,
  

  faQuoteLeft,
  
  faQuoteLeftAlt,
  

  faUsersLine,
  

  faBaby,
  

  faCirclePhoneFlip,
  
  faPhoneCircleAlt,
  

  faBuildingShield,
  

  faCartCircleXmark,
  

  faFaceSmileTongue,
  

  faPesoSign,
  

  faClawMarks,
  

  faRhombus,
  

  faChalkboardUser,
  
  faChalkboardTeacher,
  

  faArrowsUpDownLeftRight,
  
  faArrows,
  

  faFaceSmirking,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faCloudCheck,
  

  faFort,
  

  faComputer,
  

  faExpand,
  

  faPlus,
  
  faAdd,
  

  faHatBeach,
  

  faSquarePhone,
  
  faPhoneSquare,
  

  fa2,
  

  faGun,
  

  faChildCombatant,
  
  faChildRifle,
  

  faKeynote,
  

  faShareFromSquare,
  
  faShareSquare,
  

  faGrip,
  
  faGripHorizontal,
  

  faJackOLantern,
  

  faUserVneckHair,
  

  faPartyBell,
  

  faPaintbrushPencil,
  

  faBarsFilter,
  

  faHandSparkles,
  

  faVolumeXmark,
  
  faVolumeMute,
  
  faVolumeTimes,
  

  faBurgerGlass,
  

  faCopy,
  

  faSnowmanHead,
  
  faFrostyHead,
  

  faSidebar,
  

  faChartPyramid,
  

  faPedestal,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faJetFighterUp,
  

  faAwardSimple,
  

  faCircleP,
  

  faBaseball,
  
  faBaseballBall,
  

  faGlobeStand,
  

  faFaceTongueSweat,
  

  faCircleRadiation,
  
  faRadiationAlt,
  

  faMusicNoteSlash,
  
  faMusicAltSlash,
  

  faMango,
  

  faLinkHorizontal,
  
  faChainHorizontal,
  

  faPhoneIntercom,
  

  faSquareChevronLeft,
  
  faChevronSquareLeft,
  

  faClapperboard,
  

  faDiamondHalfStroke,
  

  faSquareArrowDown,
  
  faArrowSquareDown,
  

  faArrowRightLongToLine,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faStarfighter,
  

  faUserGraduate,
  

  faObjectUnion,
  

  faCartShoppingFast,
  

  faHexagonExclamation,
  

  faMusicNote,
  
  faMusicAlt,
  

  faWaffle,
  

  faCloudFog,
  
  faFog,
  

  faFish,
  

  faCircleStar,
  
  faStarCircle,
  

  faCircle1,
  

  faCommentHeart,
  

  faStarSharp,
  

  faUserMagnifyingGlass,
  

  faTruckFast,
  
  faShippingFast,
  

  faLacrosseStickBall,
  

  faSquareChevronRight,
  
  faChevronSquareRight,
  

  faPersonSnowboarding,
  
  faSnowboarding,
  

  faArrowsRetweet,
  
  faRetweetAlt,
  

  faUserHeadset,
  

  faY,
  

  faCarBurst,
  
  faCarCrash,
  

  faBoxDollar,
  
  faBoxUsd,
  

  faWind,
  

  faCircleExclamationCheck,
  

  faWreathLaurel,
  

  faMegaphone,
  

  faUserShield,
  

  faMushroom,
  

  faPlanetRinged,
  

  faUserDoctorHair,
  

  faSquareY,
  

  faCircleUser,
  
  faUserCircle,
  

  faJugDetergent,
  

  faDiagramSubtask,
  

  faListCheck,
  
  faTasks,
  

  faShrimp,
  

  faCircleDivide,
  

  faBorderLeft,
  

  faTv,
  
  faTelevision,
  
  faTvAlt,
  

  faDownFromDottedLine,
  

  faArrowUp,
  

  faBoneBreak,
  

  faLandmarkDome,
  
  faLandmarkAlt,
  

  faBrazilianRealSign,
  

  faHatWinter,
  

  faMagnifyingGlassPlay,
  

  faPersonHarassing,
  

  faNfcPen,
  

  faChessKing,
  

  faRankingStar,
  

  faPhoneOffice,
  

  faEnvelopes,
  

  faDownLong,
  
  faLongArrowAltDown,
  

  faJugBottle,
  

  faSdCards,
  

  faTowerCell,
  

  faSchoolLock,
  

  faCircleEllipsis,
  

  faWatermelonSlice,
  

  faHandHoldingMagic,
  

  faListUl,
  
  faListDots,
  

  faCodeCompare,
  

  faDropletDegree,
  
  faDewpoint,
  

  faSkullCrossbones,
  

  faClub,
  

  faHospitals,
  

  faBookArrowRight,
  

  faBellPlus,
  

  faBatteryFull,
  
  faBattery,
  
  faBattery5,
  

  faChevronDown,
  

  faMoneyBillSimpleWave,
  

  faHandsHoldingDiamond,
  
  faHandReceiving,
  

  faUserHoodie,
  

  faTransporter2,
  

  faPersonCircleExclamation,
  

  faSuitcaseRolling,
  

  faDisplaySlash,
  
  faDesktopSlash,
  

  faCircleMicrophoneLines,
  
  faMicrophoneCircleAlt,
  

  faSquarePen,
  
  faPenSquare,
  
  faPencilSquare,
  

  faTablePicnic,
  

  faReceipt,
  

  faFilePen,
  
  faFileEdit,
  

  faWalkieTalkie,
  

  faWand,
  

  faCartArrowDown,
  

  faColon,
  

  faCartFlatbedEmpty,
  
  faDollyFlatbedEmpty,
  

  faLobster,
  

  faBracketCurly,
  
  faBracketCurlyLeft,
  

  faTaxiBus,
  

  faCirclesOverlap3,
  
  faPronoun,
  

  faPeach,
  

  faNairaSign,
  

  faFloppyDiskCircleXmark,
  
  faFloppyDiskTimes,
  
  faSaveCircleXmark,
  
  faSaveTimes,
  

  faLocationQuestion,
  
  faMapMarkerQuestion,
  

  faSignalGood,
  
  faSignal3,
  

  faTrashCanArrowUp,
  
  faTrashRestoreAlt,
  

  faChevronsDown,
  
  faChevronDoubleDown,
  

  faPersonDotsFromLine,
  
  faDiagnoses,
  

  faTableTennisPaddleBall,
  
  faPingPongPaddleBall,
  
  faTableTennis,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faRupiahSign,
  

  faTableCellsRowLock,
  

  faBurgerLettuce,
  

  faSquareDownLeft,
  

  faCupTogo,
  
  faCoffeeTogo,
  

  faFont,
  

  faPlay,
  

  faTreeCity,
  

  faFileMinus,
  

  faEarListen,
  
  faAssistiveListeningSystems,
  

  faLink,
  
  faChain,
  

  faBallotCheck,
  

  faGrillHot,
  

  faLandmarkMagnifyingGlass,
  

  faBoxesStacked,
  
  faBoxes,
  
  faBoxesAlt,
  

  faTimer,
  

  faSpeaker,
  

  faCarBus,
  

  faStarHalf,
  

  faMoneyFromBracket,
  

  faCheckToSlot,
  
  faVoteYea,
  

  faCloudHail,
  

  faMeterFire,
  

  faSquareE,
  

  faHeadSideHeart,
  

  faParagraph,
  

  faFax,
  

  faDeerRudolph,
  

  faFishBones,
  

  faHeartCircleBolt,
  

  faIceCream,
  

  faScrubber,
  

  faDrum,
  

  faKite,
  

  faRectangleTerminal,
  

  faAngle90,
  

  faPersonWalkingWithCane,
  
  faBlind,
  

  faTransporterEmpty,
  

  faHotdog,
  

  faEarMuffs,
  

  faRouteInterstate,
  

  faBroccoli,
  

  faFaceSmilingHands,
  

  faOilCanDrip,
  

  faObjectsAlignLeft,
  

  faDharmachakra,
  

  faCircleUpLeft,
  

  faCloudHailMixed,
  

  faDiagramSankey,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faUserBountyHunter,
  

  faChessRook,
  

  faWineBottle,
  

  faWhiskeyGlassIce,
  
  faGlassWhiskeyRocks,
  

  faPollPeople,
  

  faHospital,
  
  faHospitalAlt,
  
  faHospitalWide,
  

  faLampDesk,
  

  faEnvelopeOpenText,
  

  faSquareAmpersand,
  

  faGaugeHigh,
  
  faTachometerAlt,
  
  faTachometerAltFast,
  

  faSquareThisWayUp,
  
  faBoxUp,
  

  faSection,
  

  faSquare0,
  

  faInbox,
  

  faFaceSunglasses,
  

  faSocks,
  

  faGrid4,
  

  faBatteryEmpty,
  
  faBattery0,
  

  faSnowflakeDroplets,
  

  faDove,
  

  faHandBackPointRight,
  

  faHatChef,
  

  faGameBoard,
  

  faPersonBurst,
  

  faCrateApple,
  
  faAppleCrate,
  

  faFileSvg,
  

  faEarthAmericas,
  
  faEarth,
  
  faEarthAmerica,
  
  faGlobeAmericas,
  

  faHexagonImage,
  

  faEraser,
  

  faBullseyePointer,
  

  faDroplet,
  
  faTint,
  

  faCircleWifi,
  

  faNotebook,
  

  faFolderMagnifyingGlass,
  
  faFolderSearch,
  

  faCandyCorn,
  

  faMessageQuote,
  
  faCommentAltQuote,
  

  faUserRobotXmarks,
  

  faArrowDown,
  

  faPersonSwimming,
  
  faSwimmer,
  

  faTRex,
  

  faPretzel,
  

  faQuotes,
  

  faGreaterThan,
  

  faFile,
  

  faBoxOpenFull,
  
  faBoxFull,
  

  faCrab,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faDialMedLow,
  

  faCircle0,
  

  faHandshakeAngle,
  
  faHandsHelping,
  

  faAccentGrave,
  

  faPaintRoller,
  

  faTrafficLightStop,
  

  faPhoneSlash,
  

  faStarOfLife,
  

  faPlugCircleXmark,
  

  faHexagonCheck,
  

  faBowlSpoon,
  

  faSuperscript,
  

  faArrowsFromLine,
  

  faFilePpt,
  

  faPinata,
  

  faXmarkLarge,
  

  faCandyBar,
  
  faChocolateBar,
  

  faBell,
  

  faTemperatureFull,
  
  faTemperature4,
  
  faThermometer4,
  
  faThermometerFull,
  

  faBee,
  

  faPodcast,
  

  faCalendarUsers,
  

  faSquareEllipsisVertical,
  

  faClockTwo,
  

  faSquareC,
  

  faSquareH,
  
  faHSquare,
  

  faBookCopy,
  

  faBed,
  

  faPersonFairy,
  

  faMedal,
  

  faTemperatureArrowUp,
  
  faTemperatureUp,
  

  faFileCircleXmark,
  

  faTruckDroplet,
  

  faDrone,
  

  faDiceD20,
  

  faBeerMug,
  
  faBeerFoam,
  

  faFileHeart,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faHandBackPointLeft,
  

  faArrowsLeftRightToLine,
  

  faBluetooth,
  

  faChartSimpleHorizontal,
  

  faMountainSun,
  

  faCabin,
  

  faCircleX,
  

  faFamilyDress,
  

  faBookOpenReader,
  
  faBookReader,
  

  faMicrophoneStand,
  

  faUserHairMullet,
  
  faBusinessFront,
  
  faPartyBack,
  
  faTrianBalbot,
  

  faPodiumStar,
  

  faUserTieHair,
  

  faHandHoldingHand,
  

  faCar,
  
  faAutomobile,
  

  faBoxBallot,
  

  faCircleS,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faBowlChopsticks,
  

  faBug,
  

  faHandsHoldingCircle,
  

  faMagnifyingGlassWaveform,
  

  faEnvelopeDot,
  
  faEnvelopeBadge,
  

  faGlobeWifi,
  

  faToolbox,
  

  faPersonThroughWindow,
  

  faBells,
  

  faGrid2Plus,
  

  faKitMedical,
  
  faFirstAid,
  

  faChessPawn,
  

  faNfcSlash,
  

  faEllipsis,
  
  faEllipsisH,
  

  faAnchorCircleXmark,
  

  faTentDoublePeak,
  

  faTicketsAirline,
  
  faTicketsPerforatedPlane,
  
  faTicketsPlane,
  

  faArrowRightLong,
  
  faLongArrowRight,
  

  faUserLock,
  

  faThumbsDown,
  

  faGripLines,
  

  faHeadSideCough,
  

  faPanFood,
  

  faPersonDollyEmpty,
  

  faCarTunnel,
  

  faOmega,
  

  faMountains,
  

  faAngleDown,
  

  faAirConditioner,
  

  faSquareQuestion,
  
  faQuestionSquare,
  

  faOilTemperature,
  
  faOilTemp,
  

  faFaceDrooling,
  

  faDisplayCode,
  
  faDesktopCode,
  

  faLessThan,
  

  faArrowDownShortWide,
  
  faSortAmountDesc,
  
  faSortAmountDownAlt,
  

  faFlorinSign,
  

  faChartMixed,
  
  faAnalytics,
  

  faArrowsTurnToDots,
  

  faGrill,
  

  faCircleDown,
  
  faArrowAltCircleDown,
  

  faPersonRunningFast,
  

  faTurnLeftDown,
  

  faWaveTriangle,
  

  faImagePolaroid,
  

  faIndustry,
  

  faBoreHole,
  

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faHorseHead,
  

  faCircleDollar,
  
  faDollarCircle,
  
  faUsdCircle,
  

  faFaceLaughWink,
  
  faLaughWink,
  

  faSignalFair,
  
  faSignal2,
  

  faHouseTree,
  

  faHockeyStickPuck,
  

  faLaptopArrowDown,
  

  faBracketsSquare,
  
  faBrackets,
  

  faFaceSmileHearts,
  

  faSquare8,
  

  faSquareArrowLeft,
  
  faArrowSquareLeft,
  

  faGuitar,
  

  faScreenUsers,
  
  faUsersClass,
  

  faTrashCanSlash,
  
  faTrashAltSlash,
  

  faSun,
  

  faObjectsAlignCenterHorizontal,
  

  faChampagneGlass,
  
  faGlassChampagne,
  

  faTrashUndo,
  
  faTrashArrowTurnLeft,
  

  faRubleSign,
  
  faRouble,
  
  faRub,
  
  faRuble,
  

  faNotes,
  

  faGearCode,
  

  faYenSign,
  
  faCny,
  
  faJpy,
  
  faRmb,
  
  faYen,
  

  faPlaneCircleXmark,
  

  faToilet,
  

  faMars,
  

  faVault,
  

  faArrowTurnLeftUp,
  

  faPersonSimple,
  

  faTableCellsColumnUnlock,
  

  faOilWell,
  

  faGlassWater,
  

  faTrashCanCheck,
  

  faBolt,
  
  faZap,
  

  faMessageSlash,
  
  faCommentAltSlash,
  

  faShieldCat,
  

  faCaravan,
  

  faArrowUpArrowDown,
  
  faSortUpDown,
  

  faHandWave,
  

  faFolderGear,
  
  faFolderCog,
  

  faFolderMedical,
  

  faCameraWebSlash,
  
  faWebcamSlash,
  

  faSaxophoneFire,
  
  faSaxHot,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faCompactDisc,
  

  faToiletPortable,
  

  faBrakeWarning,
  

  faCircleHalf,
  

  faWindsock,
  

  faMound,
  

  faPeoplePants,
  

  faGridRound2Plus,
  

  faHurricane,
  

  faUpload,
  

  faUpFromLine,
  
  faArrowAltFromBottom,
  

  faMoneyCheckDollarPen,
  
  faMoneyCheckEditAlt,
  

  faCodeMerge,
  

  faStop,
  

  faUpLong,
  
  faLongArrowAltUp,
  

  faBlockQuote,
  

  faTruckPickup,
  

  faTowerBroadcast,
  
  faBroadcastTower,
  

  faLoveseat,
  
  faCouchSmall,
  

  faPeopleDress,
  

  faHandHoldingSkull,
  

  faBanana,
  

  faHouseTurret,
  

  faChartScatterBubble,
  

  faCircleVideo,
  
  faVideoCircle,
  

  faGameBoardSimple,
  
  faGameBoardAlt,
  

  faSkull,
  

  faTimelineArrow,
  

  faBowlRice,
  

  faMillSign,
  

  faBalloons,
  

  faChartPieSimpleCircleDollar,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faUtensils,
  
  faCutlery,
  

  faRotateRight,
  
  faRedoAlt,
  
  faRotateForward,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faGolfClub,
  

  faCastle,
  

  faKiwiBird,
  

  faBlanketFire,
  

  faButter,
  

  faHelmetBattle,
  

  faCircleA,
  

  faDiceOne,
  

  faPotato,
  

  faFileMedical,
  

  faPipe,
  

  faMoonOverSun,
  
  faEclipseAlt,
  

  faSeatAirline,
  

  faB,
  

  faSquareDownRight,
  

  faLaptopMedical,
  

  faFlyingDisc,
  

  faCalendarWeek,
  

  faCarCircleBolt,
  

  faVectorCircle,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faHeartCircleExclamation,
  

  faCourtSport,
  

  faOutdent,
  
  faDedent,
  

  faFaceWorried,
  

  faFaceDotted,
  

  faIdCard,
  
  faDriversLicense,
  

  faBookSkull,
  
  faBookDead,
  

  faAlignCenter,
  

  faFaceMeh,
  
  faMeh,
  

  faCodePullRequestClosed,
  

  faMobile,
  
  faMobileAndroid,
  
  faMobilePhone,
  

  faUserPilot,
  

  faForward,
  

  faLoader,
  

  faGlass,
  

  faFileCircleCheck,
  

  faRotateExclamation,
  

  faScribble,
  

  faCommentsQuestion,
  

  faCommentCaptions,
  

  faEyeDropper,
  
  faEyeDropperEmpty,
  
  faEyedropper,
  

  faCloudBinary,
  

  faOven,
  

  faDeleteLeft,
  
  faBackspace,
  

  faFaceGrin,
  
  faGrin,
  

  faCloudSnow,
  

  faShelves,
  
  faInventory,
  

  faAnglesUpDown,
  

  faDownload,
  

  faArrowsDownToLine,
  

  faTugrikSign,
  

  faBatterySlash,
  

  faClockSixThirty,
  

  faShip,
  

  faGameConsoleHandheld,
  

  faPersonSledding,
  
  faSledding,
  

  faBuildingCircleXmark,
  

  faSprinkler,
  

  faFaceLying,
  

  faCloudRain,
  

  faShovelSnow,
  

  faCableCar,
  
  faTram,
  

  faGarage,
  

  faSwap,
  

  faN,
  

  faPeoplePulling,
  

  faEyeEvil,
  

  faUserHair,
  

  faShuttlecock,
  

  faCalculator,
  

  faImages,
  

  faVenusDouble,
  

  faRightFromLine,
  
  faArrowAltFromLeft,
  

  faPersonHiking,
  
  faHiking,
  

  faClosedCaptioning,
  

  faBadminton,
  

  faHouseMedicalCircleExclamation,
  

  faGearComplexCode,
  

  faCirclePhoneHangup,
  
  faPhoneCircleDown,
  

  faCompressWide,
  

  faFaceSpiralEyes,
  

  faArrowUpFromArc,
  

  faLightbulbMessage,
  

  faPipeValve,
  

  faClockFiveThirty,
  

  faPersonRifle,
  

  faDiagramNext,
  

  faChartTreeMap,
  

  faTty,
  
  faTeletype,
  

  faLaptopFile,
  

  faFlagUsa,
  

  faCitrus,
  

  faLightsHoliday,
  

  faPipeCollar,
  

  faPersonDressSimple,
  

  faCircleB,
  

  faRightLong,
  
  faLongArrowAltRight,
  

  faLaptopSlash,
  

  faCoin,
  

  faPowerOff,
  

  faTicket,
  

  faSwordLaserAlt,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faRouter,
  

  faWandSparkles,
  

  faSquareU,
  

  faPersonPregnant,
  

  faFlask,
  

  faSwordsLaser,
  

  faCentSign,
  

  faHamsa,
  

  faMapPin,
  

  faCroissant,
  

  faNetworkWired,
  

  faFolderTree,
  

  faPeople,
  

  faCauldron,
  

  faSliders,
  
  faSlidersH,
  

  faOutlet,
  

  faFilterList,
  

  faKhanda,
  

  faOlive,
  

  faHoneyPot,
  

  faCoins,
  

  faMountainCity,
  

  faFluxCapacitor,
  

  faBatteryHalf,
  
  faBattery3,
  

  faBoltAuto,
  

  faIndustryWindows,
  
  faIndustryAlt,
  

  faCarMirrors,
  

  faRacquet,
  

  faPiggyBank,
  

  faCarBump,
  

  faSushiRoll,
  
  faMakiRoll,
  
  faMakizushi,
  

  faFaceHeadBandage,
  

  faCircleLocationArrow,
  
  faLocationCircle,
  

  faFolderHeart,
  

  faPlaneUp,
  

  faMobileScreen,
  
  faMobileAndroidAlt,
  

  faBellSchool,
  

  faTemperatureThreeQuarters,
  
  faTemperature3,
  
  faThermometer3,
  
  faThermometerThreeQuarters,
  

  faBoxingGlove,
  
  faGloveBoxing,
  

  faHouseChimneyMedical,
  
  faClinicMedical,
  

  faCards,
  

  faLocationDotSlash,
  
  faMapMarkerAltSlash,
  

  faCaretDown,
  

  faBallot,
  

  faUsbDrive,
  

  faArrowsFromDottedLine,
  

  faKeyboard,
  

  faTimeline,
  

  faS,
  

  faOverline,
  

  faSquareUpLeft,
  

  faBaseballBatBall,
  

  faPenNibSlash,
  

  faListRadio,
  

  faLampStreet,
  

  faCloudSleet,
  

  faFaucet,
  

  faArrowsMaximize,
  
  faExpandArrows,
  

  faCarBolt,
  

  faPallet,
  

  faBackwardStep,
  
  faStepBackward,
  

  faTruckTow,
  

  faInputNumeric,
  

  faClock,
  
  faClockFour,
  

  faDash,
  
  faMinusLarge,
  

  faRaindrops,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faLightSwitchOn,
  

  faSquareRootVariable,
  
  faSquareRootAlt,
  

  faArrowUpFromDottedLine,
  

  faU,
  

  faArrowTurnUp,
  
  faLevelUp,
  

  faHexagonNodes,
  

  faMobileSignalOut,
  

  faGripVertical,
  

  faSquareD,
  

  faAxe,
  

  faChessClock,
  

  faPeapod,
  

  faShareAll,
  

  faDisplayMedical,
  
  faDesktopMedical,
  

  faFolderMusic,
  

  faHexagonVerticalNftSlanted,
  

  faTabletScreen,
  
  faTabletAndroidAlt,
  

  faToiletPaperBlank,
  
  faToiletPaperAlt,
  

  faFolderXmark,
  
  faFolderTimes,
  

  faFilmCanister,
  
  faFilmCannister,
  

  faSplit,
  

  faWaveformLines,
  
  faWaveformPath,
  

  faWaterArrowUp,
  
  faWaterRise,
  

  faPlaceOfWorship,
  

  faPersonSkiJumping,
  
  faSkiJump,
  

  faPlugCirclePlus,
  

  faCircle7,
  

  faScannerTouchscreen,
  

  faWaterArrowDown,
  
  faWaterLower,
  

  faFaceSwear,
  

  faRadioTuner,
  
  faRadioAlt,
  

  faFaceSmilePlus,
  
  faSmilePlus,
  

  faMoped,
  

  faTemperatureSnow,
  
  faTemperatureFrigid,
  

  faTabletRugged,
  

  faDistributeSpacingHorizontal,
  

  faEyeDropperFull,
  

  faVials,
  

  faShieldPlus,
  

  faBookFont,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCarGarage,
  

  faPersonMilitaryRifle,
  

  faFlagSwallowtail,
  
  faFlagAlt,
  

  faStarOfDavid,
  

  faMosquito,
  

  faDuck,
  

  faMosque,
  

  faBookHeart,
  

  faDropletSlash,
  
  faTintSlash,
  

  faGear,
  
  faCog,
  

  faCameraSecurity,
  
  faCameraHome,
  

  faUserDoctorHairLong,
  

  faFileCertificate,
  
  faFileAward,
  

  faMessageXmark,
  
  faCommentAltTimes,
  
  faMessageTimes,
  

  faHousePersonReturn,
  
  faHousePersonArrive,
  
  faHouseReturn,
  

  faCartCircleArrowDown,
  

  faFaceSmileHalo,
  

  faCircleBolt,
  

  faPresentationScreen,
  
  faPresentation,
  

  faHandsAslInterpreting,
  
  faAmericanSignLanguageInterpreting,
  
  faAslInterpreting,
  
  faHandsAmericanSignLanguageInterpreting,
  

  faChartUser,
  
  faUserChart,
  

  faBookCircleArrowRight,
  

  faVolumeOff,
  

  faFlaskRoundPoison,
  
  faFlaskPoison,
  

  faFrancSign,
  

  faArrowDownLeft,
  

  faStreetView,
  

  faFontCase,
  

  faPlugCircleCheck,
  

  faArrowLeftLong,
  
  faLongArrowLeft,
  

  faTrashSlash,
  

  faChess,
  

  faGif,
  

  faRightToLine,
  
  faArrowAltToRight,
  

  faFireFlame,
  
  faFlame,
  

  faMinus,
  
  faSubtract,
  

  faCircle5,
  

  faCircleSterling,
  

  faBracketRoundRight,
  

  faVirusSlash,
  

  faDna,
  

  faTurnLeftUp,
  

  faCloudBoltMoon,
  
  faThunderstormMoon,
  

  faCircleUpRight,
  

  faKeyboardDown,
  

  faLeftLong,
  
  faLongArrowAltLeft,
  

  faMoneyBill1,
  
  faMoneyBillAlt,
  

  faCropSimple,
  
  faCropAlt,
  

  faIndianRupeeSign,
  
  faIndianRupee,
  
  faInr,
  

  faListTimeline,
  

  faMoneyBillsSimple,
  
  faMoneyBillsAlt,
  

  faBadgeDollar,
  

  faBallPile,
  

  faFaceSmileUpsideDown,
  

  faChartGantt,
  

  faTrainSubway,
  
  faSubway,
  

  faGameConsoleHandheldCrank,
  

  faSportsball,
  

  faSignalBarsFair,
  
  faSignalAlt2,
  

  faDistributeSpacingVertical,
  

  faCircleLeft,
  
  faArrowAltCircleLeft,
  

  faCowbellCirclePlus,
  
  faCowbellMore,
  

  faPlaneArrival,
  

  faPersonFromPortal,
  
  faPortalExit,
  

  faCalendarPlus,
  

  faPersonSkiingNordic,
  
  faSkiingNordic,
  

  faArrowDownRight,
  

  faGrate,
  

  faTrafficCone,
  

  faHouseMedicalCircleCheck,
  

  faAlarmExclamation,
  

  faTarpDroplet,
  

  faRectangleList,
  
  faListAlt,
  

  faDumbbell,
  

  faFaceGrinSquintTears,
  
  faGrinSquintTears,
  

  faReel,
  

  faHardDrive,
  
  faHdd,
  

  faTvMusic,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faCookie,
  

  faOctagonDivide,
  

  faCommentArrowUpRight,
  

  faOctagon,
  

  faBorderBottomRight,
  
  faBorderStyleAlt,
  

  faCarBuilding,
  

  faMessageMusic,
  
  faCommentAltMusic,
  

  faCameraViewfinder,
  
  faScreenshot,
  

  faMoneyBillWheat,
  

  faPlusLarge,
  

  faBellSchoolSlash,
  

  faBowlingBallPin,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faCheckDouble,
  

  faPeopleDressSimple,
  

  faVestPatches,
  

  faLaptopBinary,
  

  faTent,
  

  faAlien,
  

  faPersonCane,
  

  faCloudRainbow,
  

  faCrosshairs,
  

  faMusicMagnifyingGlass,
  

  faTruck,
  

  faLandmark,
  

  faHouseWindow,
  

  faHoseReel,
  

  faFamilyPants,
  

  faPlateUtensils,
  

  faPrescriptionBottleMedical,
  
  faPrescriptionBottleAlt,
  

  faBraille,
  

  faCalendarClock,
  
  faCalendarTime,
  

  faClockDesk,
  

  faCalendarCheck,
  

  faPlaneProp,
  

  faNfcSignal,
  

  faStarSharpHalfStroke,
  
  faStarSharpHalfAlt,
  

  faWater,
  

  faWaveform,
  

  faTricycleAdult,
  

  faFileEps,
  

  faHandHoldingDroplet,
  
  faHandHoldingWater,
  

  faSquare4,
  

  faBuoyMooring,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faSleigh,
  

  faCarOn,
  

  faMeteor,
  

  faCartArrowUp,
  

  faSquareVirus,
  

  faCamera,
  
  faCameraAlt,
  

  faCameraPolaroid,
  

  faCloudMeatball,
  

  faMessageHeart,
  

  faHammerCrash,
  

  faFishingRod,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faSlashBack,
  

  faUserDoctor,
  
  faUserMd,
  

  faMeterBolt,
  

  faHouseChimneyBlank,
  

  faHouseHeart,
  
  faHomeHeart,
  

  faFileXmark,
  
  faFileTimes,
  

  faMountain,
  

  faHourglass,
  
  faHourglassEmpty,
  

  faNfcTrash,
  

  faTruckFieldUn,
  

  faPuzzlePieceSimple,
  
  faPuzzlePieceAlt,
  

  faTreeDeciduous,
  
  faTreeAlt,
  

  faIndent,
  

  faCommentMusic,
  

  faRugbyBall,
  

  faMessageMedical,
  
  faCommentAltMedical,
  

  faReflectHorizontal,
  

  faParachuteBox,
  

  faCircleNodes,
  

  faCircleWifiCircleWifi,
  
  faCircleWifiGroup,
  

  faArrowTurnDownLeft,
  

  faBorderNone,
  

  faCircleSmall,
  

  faBottleBaby,
  

  faLitecoinSign,
  

  faH6,
  

  faCircleY,
  

  faAppleCore,
  

  faArrowUp91,
  
  faSortNumericUpAlt,
  

  faPersonPinball,
  

  faLungs,
  

  faRibbon,
  

  faLockA,
  

  faArrowRightToCity,
  

  faChartLineDown,
  

  faPaperclip,
  

  faBinRecycle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faFaceTissue,
  

  faDollyEmpty,
  

  faEnvelope,
  

  faTruckLadder,
  

  faHeadSide,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faSquare1,
  

  faComment,
  

  faEllipsisStrokeVertical,
  
  faEllipsisVAlt,
  

  faBracketsCurly,
  

  faCircleYen,
  

  faCoffeeBean,
  

  faInboxes,
  

  faBookSection,
  
  faBookLaw,
  

  faStretcher,
  

  faTag,
  

  faSteeringWheel,
  

  faPlaneLock,
  

  faTruckFire,
  

  faSatellite,
  

  faChessClockFlip,
  
  faChessClockAlt,
  

  faFilePlusMinus,
  

  faUserVisor,
  

  faLiraSign,
  

  faChild,
  

  faWashingMachine,
  
  faWasher,
  

  faBookSparkles,
  
  faBookSpells,
  

  faSquareArrowDownRight,
  

  faFilmSlash,
  

  faBusSchool,
  

  faClipboardUser,
  

  faFaceFearful,
  

  faLocationExclamation,
  
  faMapMarkerExclamation,
  

  faTableRows,
  
  faRows,
  

  faHatCowboySide,
  

  faDiscDrive,
  

  faPhoneVolume,
  
  faVolumeControlPhone,
  

  faSealQuestion,
  

  faSolarSystem,
  

  faBookTanakh,
  
  faTanakh,
  

  faTableCellsLarge,
  
  faThLarge,
  

  faCloudDrizzle,
  

  faPeoplePantsSimple,
  

  faFlowerTulip,
  

  faBusinessTime,
  
  faBriefcaseClock,
  

  faCommentDollar,
  

  faPersonDress,
  
  faFemale,
  

  faDreidel,
  

  faOtter,
  

  faUserSecret,
  

  faRv,
  

  faClockElevenThirty,
  

  faExpandWide,
  

  faBriefcaseArrowRight,
  

  faSuitcaseMedical,
  
  faMedkit,
  

  faO,
  

  faBookBible,
  
  faBible,
  

  faMessagesQuestion,
  

  faGamepadModern,
  
  faGamepadAlt,
  

  faCurlingStone,
  
  faCurling,
  

  faTankWater,
  

  faImageLandscape,
  
  faLandscape,
  

  faArrowUpToDottedLine,
  

  faSiren,
  

  faFilePdf,
  

  faBagShoppingMinus,
  

  faTableCells,
  
  faTh,
  

  faCircleSort,
  
  faSortCircle,
  

  faUpRightFromSquare,
  
  faExternalLinkAlt,
  

  faCherries,
  

  faFileVideo,
  

  faUsersViewfinder,
  

  faGalaxy,
  

  faJ,
  

  faHighDefinition,
  
  faRectangleHd,
  

  faRestroom,
  

  faDiceD6,
  

  faAlignLeft,
  

  faTemperatureSun,
  
  faTemperatureHot,
  

  faCupStrawSwoosh,
  

  faArrowLeftFromBracket,
  

  faRuler,
  

  faPersonCircleXmark,
  

  faArrowLeft,
  

  faLeafMaple,
  

  faRepublican,
  

  faHandsClapping,
  

  faSnowflakes,
  

  faCircleAmpersand,
  

  faCampfire,
  

  faHandsHolding,
  

  faHeadphones,
  

  faTengeSign,
  
  faTenge,
  

  faSquare7,
  

  faLampFloor,
  

  faSunCloud,
  

  faDivide,
  

  faEnvelopeOpenDollar,
  

  faCubes,
  

  faSquareR,
  

  faBillboard,
  

  fa0,
  

  faShirt,
  
  faTShirt,
  
  faTshirt,
  

  faClockSix,
  

  faHose,
  

  faPhoneXmark,
  

  faGuitars,
  

  faScrollOld,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faPenClipSlash,
  
  faPenAltSlash,
  

  faPoo,
  

  faFaceMelting,
  

  faBookMedical,
  

  faArrowDownSmallBig,
  
  faSortSizeDownAlt,
  

  faGaugeSimple,
  
  faGaugeSimpleMed,
  
  faTachometerAverage,
  

  faTrash,
  

  faHandFingersCrossed,
  

  faCloudWord,
  

  faPhoneArrowDownLeft,
  
  faPhoneArrowDown,
  
  faPhoneIncoming,
  

  faOrnament,
  

  faFileXml,
  

  faCarSideBolt,
  

  faBrightness,
  

  faBoxCircleCheck,
  

  faShowerDown,
  
  faShowerAlt,
  

  faPersonDigging,
  
  faDigging,
  

  faMouseField,
  

  faCoffeePot,
  

  faPenFancy,
  

  faChartKanban,
  

  faHatWizard,
  

  faSquareKanban,
  

  faGarageCar,
  

  faTextWidth,
  

  faPersonBooth,
  

  faBanBug,
  
  faDebug,
  

  faBridgeWater,
  

  faVentDamper,
  

  faFileFragment,
  

  faMosquitoNet,
  

  faRocketLaunch,
  

  faStarfighterTwinIonEngine,
  
  faStarfighterAlt,
  

  faDiceSix,
  

  faStarfighterTwinIonEngineAdvanced,
  
  faStarfighterAltAdvanced,
  

  faShieldVirus,
  

  faConveyorBeltBoxes,
  
  faConveyorBeltAlt,
  

  faLaptopMobile,
  
  faPhoneLaptop,
  

  faDoorClosed,
  

  faDialLow,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faPipeCircleCheck,
  

  faUserGear,
  
  faUserCog,
  

  faPuzzle,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSquare5,
  

  faHouseBlank,
  
  faHomeBlank,
  

  faLightbulbSlash,
  

  faBooksMedical,
  

  faKeyboardBrightness,
  

  faHeadSideVirus,
  

  faRectangleCode,
  

  faTrafficLightSlow,
  

  faKiwiFruit,
  

  faPawClaws,
  

  faBorderInner,
  

  faToothbrush,
  

  faCalendarCirclePlus,
  

  faRampLoading,
  

  faNarwhal,
  

  faTableLayout,
  

  faChildReaching,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faComputerMouseScrollwheel,
  
  faMouseAlt,
  

  faPhone,
  

  faFaceGrinTears,
  
  faGrinTears,
  

  faSpinnerThird,
  

  faLungsVirus,
  

  faUsersBetweenLines,
  

  faChildDress,
  

  faCardClub,
  

  faRulerTriangle,
  

  faHousePersonLeave,
  
  faHouseLeave,
  
  faHousePersonDepart,
  

  faLeftFromBracket,
  

  faMarsDouble,
  

  faLocationCrosshairs,
  
  faLocation,
  

  faChessQueenPiece,
  
  faChessQueenAlt,
  

  faBiohazard,
  

  faWebAwesome,
  

  faBalloon,
  

  faSensorOn,
  

  faMessagesDollar,
  
  faCommentsAltDollar,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faUserMusic,
  

  faFacePensive,
  

  faHandsPraying,
  
  faPrayingHands,
  

  faHandScissors,
  

  faDrumSteelpan,
  

  faHandPointer,
  

  faBacterium,
  

  faChartDiagram,
  

  faGridDividers,
  

  faHandHoldingDollar,
  
  faHandHoldingUsd,
  

  faCircleEllipsisVertical,
  

  faFaceGrinSquint,
  
  faGrinSquint,
  

  faSquareLeft,
  
  faArrowAltSquareLeft,
  

  faDiamond,
  

  faUserNurseHairLong,
  

  faAlbumCirclePlus,
  

  faScarf,
  

  faPlantWilt,
  

  faCommentDots,
  
  faCommenting,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareL,
  

  faTennisBall,
  

  faFaceTongueMoney,
  

  faUserPoliceTie,
  

  faFileUser,
  

  faScaleUnbalanced,
  
  faBalanceScaleLeft,
  

  faFaceKissClosedEyes,
  

  faVihara,
  

  faFloppyDisk,
  
  faSave,
  

  faShop,
  
  faStoreAlt,
  

  faPrescription,
  

  faWalker,
  

  faScreencast,
  

  faDiploma,
  
  faScrollRibbon,
  

  faShirtTankTop,
  

  faChessBishopPiece,
  
  faChessBishopAlt,
  

  faFaceFrown,
  
  faFrown,
  

  faDryer,
  

  faWindowMaximize,
  

  faHouseChimney,
  
  faHomeLg,
  

  faArrowUpLeftFromCircle,
  

  faHeartCircleXmark,
  

  faBus,
  

  faPump,
  

  faSignal,
  
  faSignal5,
  
  faSignalPerfect,
  

  faFileCode,
  

  faToiletPaperBlankUnder,
  
  faToiletPaperReverseAlt,
  

  faFloppyDisks,
  

  faTowerObservation,
  

  faPen,
  

  faUserSlash,
  

  faManhole,
  

  faHexagon,
  

  faFileShield,
  

  faPersonMilitaryToPerson,
  

  faAudioDescription,
  

  faArrowsMinimize,
  
  faCompressArrows,
  

  faBootHeeled,
  

  faTicketAirline,
  
  faTicketPerforatedPlane,
  
  faTicketPlane,
  

  faHeat,
  

  faFaceSadCry,
  
  faSadCry,
  

  faEye,
  

  faBusSimple,
  
  faBusAlt,
  

  faChestnut,
  

  faTape,
  

  faBasketShopping,
  
  faShoppingBasket,
  

  faHouseMedicalFlag,
  

  faMobileButton,
  

  faTerminal,
  

  faCircleSortUp,
  
  faSortCircleUp,
  

  faBanSmoking,
  
  faSmokingBan,
  

  faCartFlatbed,
  
  faDollyFlatbed,
  

  faCircleR,
  

  faArrowUpRight,
  

  faDolphin,
  

  faArrowsToLine,
  

  faFaucetDrip,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faNfcSymbol,
  

  faSquareChevronUp,
  
  faChevronSquareUp,
  

  faHouseSignal,
  

  faFaceRaisedEyebrow,
  

  faFaceZipper,
  

  faCardDiamond,
  

  faSquareParking,
  
  faParking,
  

  faUserRobot,
  

  faFaceMehBlank,
  
  faMehBlank,
  

  faForwardFast,
  
  faFastForward,
  

  faWineGlass,
  

  faTags,
  

  faArrowTurnRight,
  

  faHeadSideMedical,
  

  faFileCircleMinus,
  

  faUserTieHairLong,
  

  faTeethOpen,
  

  faCommentMedical,
  

  faPanorama,
  

  faClipboardQuestion,
  

  faCartCircleCheck,
  

  faRoute,
  

  faTruckField,
  

  faBasketShoppingPlus,
  

  faUserCrown,
  

  faFaceClouds,
  

  faAnchorCircleExclamation,
  

  faFiles,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faTrashXmark,
  

  faCat,
  

  faTruckFront,
  

  faSquareQuarters,
  

  faFileDoc,
  

  faArrowDownFromDottedLine,
  

  faPhoneFlip,
  
  faPhoneAlt,
  

  faBridge,
  

  faHatCowboy,
  

  faWarehouseFull,
  
  faWarehouseAlt,
  

  faCodeBranch,
  

  faObjectSubtract,
  

  faHouseWater,
  
  faHouseFlood,
  

  faPopcorn,
  

  faFaceHandOverMouth,
  

  faCircleK,
  

  faArrowRightFromArc,
  

  faTypewriter,
  

  faCanFood,
  

  faBorderCenterH,
  

  faBookBookmark,
  

  faHandshakeSlash,
  

  faPlaneDeparture,
  

  faBuoy,
  

  faImageUser,
  

  faTicketsPerforated,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faFileImage,
  

  faRupeeSign,
  
  faRupee,
  

  faDiagramNested,
  

  faVectorPolygon,
  

  faBugs,
  

  faWrench,
  

  faArrowTurnLeft,
  

  faTransporter6,
  

  faUtilityPole,
  

  faBurger,
  
  faHamburger,
  

  faStaff,
  

  faChartRadar,
  

  faLockHashtag,
  

  faTurnDownLeft,
  

  faFileAudio,
  

  faPool8Ball,
  

  faTruckClock,
  
  faShippingTimed,
  

  faCartCirclePlus,
  

  faClipboardCheck,
  

  faFlatbreadStuffed,
  

  faOctagonCheck,
  

  faWallet,
  

  faUsersRays,
  

  faVolumeHigh,
  
  faVolumeUp,
  

  faCloudSlash,
  

  faInboxOut,
  
  faInboxArrowUp,
  

  faClockOneThirty,
  

  faMobileScreenButton,
  
  faMobileAlt,
  

  faSlider,
  

  faCircleUp,
  
  faArrowAltCircleUp,
  

  faBadgeCheck,
  

  faSatelliteDish,
  

  faForkKnife,
  
  faUtensilsAlt,
  

  faBasketball,
  
  faBasketballBall,
  

  faTrademark,
  

  faCircleDashed,
  

  faPlaneSlash,
  

  faInterrobang,
  

  faUserAstronaut,
  

  faRecycle,
  

  faBackwardFast,
  
  faFastBackward,
  

  faSword,
  

  faCartCircleExclamation,
  

  faLeftToBracket,
  

  faCircle,
  

  faSquarePollHorizontal,
  
  faPollH,
  

  faHouseFloodWaterCircleArrowRight,
  

  faMoneyBillTrendUp,
  

  faMoneyBillTransfer,
  

  faElevator,
  

  faTally3,
  

  faHouseChimneyHeart,
  

  faTableTree,
  

  faLockOpen,
  

  faSolarPanel,
  

  faShieldDog,
  

  faShutters,
  

  faBitcoinSign,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCube,
  

  faHandsHoldingDollar,
  
  faHandsUsd,
  

  faToiletPaperXmark,
  

  faWifiSlash,
  

  faSquareInfo,
  
  faInfoSquare,
  

  faTemperatureQuarter,
  
  faTemperature1,
  
  faThermometer1,
  
  faThermometerQuarter,
  

  faR,
  

  faLockKeyhole,
  
  faLockAlt,
  

  faDiamondHalf,
  

  faKitchenSet,
  

  faAppleWhole,
  
  faAppleAlt,
  

  faCircleEuro,
  

  faToiletPaperSlash,
  

  faRabbit,
  

  faValueAbsolute,
  

  faAngel,
  

  faFolders,
  

  faGaugeCirclePlus,
  

  faCirclePause,
  
  faPauseCircle,
  

  faBottleWater,
  

  faFaceSurprise,
  
  faSurprise,
  

  faArrowRightToArc,
  

  faUserShakespeare,
  

  faMartiniGlassCitrus,
  
  faCocktail,
  

  faBracketsRound,
  
  faParentheses,
  

  faArrowLeftLongToLine,
  

  faPawSimple,
  
  faPawAlt,
  

  faHouseCrack,
  

  faLeftToLine,
  
  faArrowAltToLeft,
  

  faHexagonMinus,
  
  faMinusHexagon,
  

  faDumpsterFire,
  

  faCircleArrowDownLeft,
  

  faHouseUser,
  
  faHomeUser,
  

  faMarsAndVenus,
  

  faFileChartPie,
  

  faHeart,
  

  faFaceNauseated,
  

  faBookCircleArrowUp,
  

  faShirtRunning,
  

  faSignPostsWrench,
  

  faGridRound4,
  

  faFaceThermometer,
  

  faPlugCircleBolt,
  

  faTrophyStar,
  
  faTrophyAlt,
  

  faCircleThreeQuarters,
  

  faArrowsToEye,
  

  faScrewdriverWrench,
  
  faTools,
  

  faHandHorns,
  

  faFaceSleepy,
  

  faTarp,
  

  faHammerBrush,
  

  faClockNine,
  

  faHandsHoldingHeart,
  
  faHandsHeart,
  

  faBasketShoppingSimple,
  
  faShoppingBasketAlt,
  

  faH,
  

  faLeftFromLine,
  
  faArrowAltFromRight,
  

  faCupStraw,
  

  faMessageSmile,
  
  faCommentAltSmile,
  

  faSpaceStationMoon,
  

  faMelonSlice,
  

  faPersonCircleQuestion,
  

  faCashRegister,
  

  faOctagonPlus,
  
  faPlusOctagon,
  

  faSignsPost,
  
  faMapSigns,
  

  faArrowRight,
  

  faSignatureLock,
  

  faTickets,
  

  faMaskVentilator,
  

  faSendBack,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faChartLine,
  
  faLineChart,
  

  faFrenchFries,
  

  faObjectGroup,
  

  faRingsWedding,
  

  faBreadLoaf,
  

  faFaceRollingEyes,
  
  faMehRollingEyes,
  

  faHexagonVerticalNft,
  

  faUserCowboy,
  

  faSeal,
  

  faPlaneCircleCheck,
  

  faCircleRight,
  
  faArrowAltCircleRight,
  

  faEject,
  

  faStarship,
  

  faSimCards,
  

  faCommentCode,
  

  faHelmetSafety,
  
  faHardHat,
  
  faHatHard,
  

  faToiletPaper,
  

  faKaaba,
  

  faSquareList,
  

  faLocationPin,
  
  faMapMarker,
  

  faTelescope,
  

  faObjectExclude,
  

  faPoop,
  

  faHandPointRibbon,
  

  faAlien8bit,
  
  faAlienMonster,
  

  faCircleArrowDownRight,
  

  faFaceDisguise,
  

  faObjectUngroup,
  

  faFaceGrinBeam,
  
  faGrinBeam,
  

  faBuildingFlag,
  

  faCircleQ,
  

  faFishFins,
  

  faFileContract,
  

  faFileExcel,
  

  faFileXls,
  

  faSackXmark,
  

  faClockEight,
  

  faBoltLightning,
  

  faChartPie,
  
  faPieChart,
  

  faPersonCirclePlus,
  

  faTaxi,
  
  faCab,
  

  faRoad,
  

  faBedBunk,
  

  faLeaf,
  

  faF,
  

  faCloudPlus,
  

  faAustralSign,
  

  faChessKnightPiece,
  
  faChessKnightAlt,
  

  faPie,
  

  faSquareEllipsis,
  

  faVirusCovid,
  

  faImagePolaroidUser,
  

  faWonSign,
  
  faKrw,
  
  faWon,
  

  faImagesUser,
  

  faCubesStacked,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faMagnifyingGlassChart,
  

  faMobileNotch,
  
  faMobileIphone,
  

  faClothesHanger,
  

  faBuildingCircleExclamation,
  

  faMoonStars,
  

  faWhiskeyGlass,
  
  faGlassWhiskey,
  

  faCode,
  

  faFileExclamation,
  

  faStarHalfStroke,
  
  faStarHalfAlt,
  

  faMoneyCheck,
  

  faPuzzlePiece,
  

  faTrainTrack,
  

  faArrowUpSmallBig,
  
  faSortSizeUpAlt,
  

  faHandHoldingHeart,
  

  faHouseChimneyUser,
  

  faDryerHeat,
  
  faDryerAlt,
  

  faUpDownLeftRight,
  
  faArrowsAlt,
  

  faToggleLargeOn,
  

  faFileSignature,
  

  faQuestion,
  

  faUserNurseHair,
  

  faClipboardPrescription,
  

  faCirclePhone,
  
  faPhoneCircle,
  

  faSquareG,
  

  faFilter,
  

  faDownToLine,
  
  faArrowAltToBottom,
  

  faRouteHighway,
  

  faMemoCircleCheck,
  

  faDiamonds4,
  

  faPodium,
  

  faDagger,
  

  faFaceKissWinkHeart,
  
  faKissWinkHeart,
  

  faWheatAwnSlash,
  

  faLanguage,
  

  faBreadSlice,
  

  faVectorSquare,
  

  faMoneyCheckDollar,
  
  faMoneyCheckAlt,
  

  faDiceD4,
  

  faPersonDressBurst,
  

  faChartNetwork,
  

  faWifiExclamation,
  

  faKidneys,
  

  faFaceParty,
  

  faSparkle,
  

  faChartWaterfall,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faLocust,
  

  faFilterCircleXmark,
  

  faToiletPaperCheck,
  

  faCircleI,
  

  faUserGroupCrown,
  
  faUsersCrown,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faBreadSliceButter,
  

  faMoonCloud,
  

  faArrowTurnDownRight,
  

  faGuitarElectric,
  

  faRectangleAd,
  
  faAd,
  

  faNewspaper,
  

  faStomach,
  

  faSnowflake,
  

  faBroomWide,
  

  faP,
  

  faTrashCanClock,
  

  faSausage,
  

  faFeatherPointed,
  
  faFeatherAlt,
  

  faMace,
  

  faTemperatureArrowDown,
  
  faTemperatureDown,
  

  faBookmarkSlash,
  

  faA,
  

  faRoadLock,
  

  faInputPipe,
  

  faDeer,
  

  faPersonSkiing,
  
  faSkiing,
  

  faZ,
  

  faPinball,
  

  faFaceConfused,
  

  faDemocrat,
  

  faLinkSimpleSlash,
  

  faPickaxe,
  

  faTicketsSimple,
  

  faCommentsDollar,
  

  faFaceHushed,
  

  faPersonSnowmobiling,
  
  faSnowmobile,
  

  faChurch,
  

  faTableCellsColumnLock,
  

  faCalendarLinesPen,
  

  faGlassCitrus,
  

  faItalic,
  

  faCediSign,
  

  faCouch,
  

  faMartiniGlassEmpty,
  
  faGlassMartini,
  

  faMemo,
  

  faSquare,
  

  faCommentCheck,
  

  faHeartHalf,
  

  faTicketPerforated,
  

  faFileZipper,
  
  faFileArchive,
  

  faHouseChimneyCrack,
  
  faHouseDamage,
  

  faHeartCircleCheck,
  

  faArchway,
  

  faClockTwoThirty,
  

  faHashtagLock,
  

  faBorderOuter,
  

  faArrowsToDot,
  

  faRestroomSimple,
  

  faLayerGroup,
  

  faEnvelopeCircleCheck,
  

  faWave,
  

  faCommentMiddleTop,
  

  faGridRound2,
  

  faVirus,
  

  faBookAtlas,
  
  faAtlas,
  

  faTruckPlow,
  

  faShieldHalved,
  
  faShieldAlt,
  

  faFaceConfounded,
  

  faPalletBox,
  

  faGreaterThanEqual,
  

  faSquareArrowUp,
  
  faArrowSquareUp,
  

  faBurgerSoda,
  

  faCabinetFiling,
  

  faListDropdown,
  

  faWatchCalculator,
  

  faWatchApple,
  

  faCruzeiroSign,
  

  faShelvesEmpty,
  

  faGarageOpen,
  

  faMagnifyingGlassArrowsRotate,
  

  faFireExtinguisher,
  

  faArrowsToDottedLine,
  

  faCircleBookOpen,
  
  faBookCircle,
  

  faArrowsRotate,
  
  faRefresh,
  
  faSync,
  

  faBorderTop,
  

  faMugTea,
  

  faBurgerFries,
  

  faGuaraniSign,
  

  faGingerbreadMan,
  

  faCommentQuestion,
  

  faAlicorn,
  

  faAlarmPlus,
  

  faMattressPillow,
  

  faMemoPad,
  

  faRabbitRunning,
  
  faRabbitFast,
  

  faHandshakeSimpleSlash,
  
  faHandshakeAltSlash,
  

  faCatSpace,
  

  faDrawCircle,
  

  faEnvelopeOpen,
  

  faListTree,
  

  faLollipop,
  
  faLollypop,
  

  faSignalStrong,
  
  faSignal4,
  

  faUserLargeSlash,
  
  faUserAltSlash,
  

  faChalkboard,
  
  faBlackboard,
  

  faMeterDroplet,
  

  faChildren,
  

  faWreath,
  

  faCloudArrowDown,
  
  faCloudDownload,
  
  faCloudDownloadAlt,
  

  faHouseLock,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faObjectsAlignCenterVertical,
  

  faSquareDown,
  
  faArrowAltSquareDown,
  

  faFilePowerpoint,
  

  faFileWord,
  

  faLeft,
  
  faArrowAltLeft,
  

  faWavesSine,
  

  faCircle6,
  

  faChessKingPiece,
  
  faChessKingAlt,
  

  faTombstoneBlank,
  
  faTombstoneAlt,
  

  faFaceSmileWink,
  
  faSmileWink,
  

  faProjector,
  

  faText,
  

  faCircleDownLeft,
  

  faWatch,
  

  faTextSlash,
  
  faRemoveFormat,
  

  faChartLineUpDown,
  

  faCloudBolt,
  
  faThunderstorm,
  

  faMessageCheck,
  
  faCommentAltCheck,
  

  faHandHoldingSeedling,
  

  faPhoneArrowRight,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCandyCane,
  

  faSquare9,
  

  faBowlFood,
  

  faGroupArrowsRotate,
  

  faFileJpg,
  

  faFlashlight,
  

  faCircleArrowLeft,
  
  faArrowCircleLeft,
  

  faBoxesPacking,
  

  faLeftRight,
  
  faArrowsAltH,
  

  faClockSeven,
  

  faSeedling,
  
  faSprout,
  

  faArrowsDownToPeople,
  

  faBullseyeArrow,
  

  faFerry,
  

  faTrianglePersonDigging,
  
  faConstruction,
  

  faCircleEnvelope,
  
  faEnvelopeCircle,
  

  faInboxFull,
  

  faPig,
  

  faVest,
  

  faArrowsTurnRight,
  

  faObjectsAlignRight,
  

  faChartMixedUpCircleCurrency,
  

  faTransporter4,
  

  faPalette,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faFontAwesome,
  
  faFontAwesomeFlag,
  
  faFontAwesomeLogoFull,
  

  faGasPumpSlash,
  

  faCrutch,
  

  faSquareALock,
  

  faUserVneckHairLong,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faHydra,
  

  faUfoBeam,
  

  faSmog,
  

  faBlindsRaised,
  

  faMoneyBills,
  

  faFaceTired,
  
  faTired,
  

  faHouseLaptop,
  
  faLaptopHouse,
  

  faBurst,
  

  faIntegral,
  

  faDiamondTurnRight,
  
  faDirections,
  

  faSubscript,
  

  faGlobeSnow,
  

  faScaleUnbalancedFlip,
  
  faBalanceScaleRight,
  

  faChartFft,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faTrashCanPlus,
  

  faRegistered,
  

  faGaugeLow,
  
  faTachometerAltSlow,
  

  faBomb,
  

  faTemperatureEmpty,
  
  faTemperature0,
  
  faThermometer0,
  
  faThermometerEmpty,
  

  faHillAvalanche,
  

  faPlaneEngines,
  
  faPlaneAlt,
  

  faClockEightThirty,
  

  faPause,
  

  faLocationPinLock,
  

  faStrawberry,
  

  faArrowLeftFromLine,
  
  faArrowFromRight,
  

  faSpa,
  

  faScroll,
  

  faSquareF,
  

  faBoxOpen,
  

  faKerning,
  

  faLightEmergencyOn,
  

  faSquareArrowUpRight,
  
  faExternalLinkSquare,
  

  faBanjo,
  

  faFileImport,
  
  faArrowRightToFile,
  

  faCommentPen,
  
  faCommentEdit,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faCameraRetro,
  

  faFilterCircleDollar,
  
  faFunnelDollar,
  

  faBinaryLock,
  

  faStarShooting,
  

  faPersonSkating,
  
  faSkating,
  

  faSuitcase,
  

  faReplyAll,
  
  faMailReplyAll,
  

  faCrystalBall,
  

  faCertificate,
  

  faTentArrowDownToLine,
  

  faArrowDownLong,
  
  faLongArrowDown,
  

  faUpToBracket,
  

  faUserTie,
  

  faSquarePersonConfined,
  

  faViruses,
  

  faBatteryExclamation,
  

  faSterlingSign,
  
  faGbp,
  
  faPoundSign,
  

  faSmoke,
  

  faMaskSnorkel,
  

  faImageSlash,
  

  faPersonWalkingDashedLineArrowRight,
  

  faStocking,
  

  faTeddyBear,
  

  faVolcano,
  

  faLariSign,
  

  faUserPolice,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faUpRight,
  

  faFileMagnifyingGlass,
  
  faFileSearch,
  

  faGearComplex,
  

  faUniversalAccess,
  

  faAperture,
  

  faHelicopterSymbol,
  

  faTreeLarge,
  

  faBatteryBolt,
  

  faSquareArrowDownLeft,
  

  faFaceLaughBeam,
  
  faLaughBeam,
  

  faBinBottles,
  

  faMarker,
  

  faKazoo,
  

  faIdBadge,
  

  faNeuter,
  

  faPersonShelter,
  

  faIcicles,
  

  faCarWrench,
  
  faCarMechanic,
  

  faChopsticks,
  

  faCalendarCircleMinus,
  

  faPlateWheat,
  

  faCompassDrafting,
  
  faDraftingCompass,
  

  faArrowUpToBracket,
  

  faPhoneRotary,
  

  faHeadSideHeadphones,
  

  faCircleStop,
  
  faStopCircle,
  

  faBat,
  

  faMoneySimpleFromBracket,
  

  faHandHoldingCircleDollar,
  

  faSquareDashedCirclePlus,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faChair,
  

  faEuroSign,
  
  faEur,
  
  faEuro,
  

  faEthernet,
  

  fa360Degrees,
  

  faTablets,
  

  faLocationArrowUp,
  

  faArrowUpRightAndArrowDownLeftFromCenter,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCannabis,
  

  faTruckRampCouch,
  
  faTruckCouch,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faSnowplow,
  

  faAlignSlash,
  

  faOctagonXmark,
  
  faTimesOctagon,
  
  faXmarkOctagon,
  

  faMonument,
  

  faRefrigerator,
  

  faMinimize,
  
  faCompressArrowsAlt,
  

  faSmoking,
  

  faDolly,
  
  faDollyBox,
  

  faGem,
  

  faHandshake,
  

  faHeadSideMask,
  

  faLemon,
  

  faTick,
  

  faSquareA,
  

  faTableColumns,
  
  faColumns,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faSquareBinary,
  

  faMartiniGlass,
  
  faGlassMartiniAlt,
  

  faBracketSquareRight,
  

  faArrowUpFromGroundWater,
  

  faForklift,
  

  faSquareNfi,
  

  faHouseTsunami,
  

  faFolderClosed,
  

  faCircleSortDown,
  
  faSortCircleDown,
  

  faScrewdriver,
  

  faShieldXmark,
  
  faShieldTimes,
  

  faCaretUp,
  

  faDownFromLine,
  
  faArrowAltFromTop,
  

  faSquareRing,
  

  fa3,
  

  faFileZip,
  

  faCow,
  

  faMicrophone,
  

  faWindowFrame,
  

  faImage,
  

  faFloppyDiskPen,
  

  faBucket,
  

  faFrog,
  

  faMessageLines,
  
  faCommentAltLines,
  

  faCloudExclamation,
  

  faToriiGate,
  

  faPanelEws,
  

  faSubtitles,
  

  faSunrise,
  

  faHockeyMask,
  

  faLacrosseStick,
  

  faCustard,
  

  faMistletoe,
  

  faBowlScoops,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faCircleV,
  

  faFileBinary,
  

  faNfcMagnifyingGlass,
  

  faWindowRestore,
  

  faSailboat,
  

  faCassetteBetamax,
  
  faBetamax,
  

  faCrow,
  

  fa00,
  

  faHexagonDivide,
  

  faUserUnlock,
  

  faSensorFire,
  

  faFaceExhaling,
  

  faTrafficLightGo,
  

  faEyeLowVision,
  
  faLowVision,
  

  faUpFromDottedLine,
  

  faTrain,
  

  faLessThanEqual,
  

  faHandsBubbles,
  
  faHandsWash,
  

  faChartBar,
  
  faBarChart,
  

  faCloudShowersWater,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faTally,
  
  faTally5,
  

  faGridRound5,
  

  faHandBackFist,
  
  faHandRock,
  

  faMarsStrokeRight,
  
  faMarsStrokeH,
  

  faPersonChalkboard,
  

  faRightLongToLine,
  

  faSwapArrows,
  

  faGrid5,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faRepeat1,
  

  faBuildingCircleCheck,
  

  faBurgerCheese,
  
  faCheeseburger,
  

  faChessBoard,
  

  faBringFront,
  

  faUpLeft,
  

  faSquareQuote,
  

  faHoodCloak,
  

  faGlasses,
  

  faPaintbrushFine,
  
  faPaintBrushAlt,
  
  faPaintBrushFine,
  
  faPaintbrushAlt,
  

  faChessQueen,
  

  faTreasureChest,
  

  faMessageArrowUpRight,
  

  faFileSlash,
  

  faCoinFront,
  

  faGaugeCircleBolt,
  

  faTransporter5,
  

  faVolume,
  
  faVolumeMedium,
  

  faDiceTwo,
  

  faGift,
  

  faMemoCircleInfo,
  

  faMailboxFlagUp,
  

  faFaceDowncastSweat,
  

  faCarBattery,
  
  faBatteryCar,
  

  faDogLeashed,
  

  faMugHot,
  

  faArrowDownSquareTriangle,
  
  faSortShapesDownAlt,
  

  faSquarePollVertical,
  
  faPoll,
  

  faJedi,
  

  faTilde,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faBorderTopLeft,
  
  faBorderStyle,
  

  faNotEqual,
  

  faMoneyCheckPen,
  
  faMoneyCheckEdit,
  

  faManatSign,
  

  faSquareK,
  

  faCircleDownRight,
  

  faEngineWarning,
  
  faEngineExclamation,
  

  faTransporter3,
  

  faBuildingNgo,
  

  faAnchorLock,
  

  faBold,
  

  faStroopwafel,
  

  faSignature,
  

  faCaduceus,
  

  faSquareO,
  

  faBinarySlash,
  

  faUserPen,
  
  faUserEdit,
  

  faPrescriptionBottlePill,
  

  faUnderline,
  

  faRectangleHistoryCirclePlus,
  

  faUmbrellaSimple,
  
  faUmbrellaAlt,
  

  faBath,
  
  faBathtub,
  

  faMessages,
  
  faCommentsAlt,
  

  faWifi,
  
  faWifi3,
  
  faWifiStrong,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseCircleExclamation,
  

  faClipboard,
  

  faHexagonPlus,
  
  faPlusHexagon,
  

  faTaco,
  

  faChampagneGlasses,
  
  faGlassCheers,
  

  faMarsStrokeUp,
  
  faMarsStrokeV,
  

  faUserMinus,
  

  faSignalSlash,
  

  faRoadCircleXmark,
  

  faStoreSlash,
  

  faH4,
  

  faBadgerHoney,
  

  faHeadset,
  

  faColonSign,
  

  faUnlock,
  

  faSheep,
  

  faCitrusSlice,
  

  faPepperHot,
  

  faClockTwelve,
  

  faMicrophoneLines,
  
  faMicrophoneAlt,
  

  faSignalBarsWeak,
  
  faSignalAlt1,
  

  faCity,
  

  faCodeFork,
  

  faHeartCirclePlus,
  

  faFlatbread,
  

  faBowlHot,
  
  faSoup,
  

  faCandy,
  

  faAlbumCollectionCircleUser,
  

  faFolderOpen,
  

  faFaceLaugh,
  
  faLaugh,
  

  faChartPieSimple,
  
  faChartPieAlt,
  

  faShirtLongSleeve,
  

  faShuttleSpace,
  
  faSpaceShuttle,
  

  faHouseDay,
  

  faBedPulse,
  
  faProcedures,
  

  faFire,
  

  faStars,
  

  faCircleZ,
  

  faDownToBracket,
  

  faSignalStream,
  

  faL,
  

  faPersonWalking,
  
  faWalking,
  

  faRectangleVertical,
  
  faRectanglePortrait,
  

  faToggleOn,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faBedEmpty,
  

  faPianoKeyboard,
  

  faUserPilotTie,
  

  faWheelchair,
  

  faTriangleInstrument,
  
  faTriangleMusic,
  

  faCommentPlus,
  

  faSquareChevronDown,
  
  faChevronSquareDown,
  

  faObjectsColumn,
  

  faViolin,
  

  faBurrito,
  

  faCommentMinus,
  

  faBinaryCircleCheck,
  

  faPanelFire,
  

  faBoltSlash,
  

  faCodeSimple,
  

  faFaceLaughSquint,
  
  faLaughSquint,
  

  faPalletBoxes,
  
  faPaletteBoxes,
  
  faPalletAlt,
  

  faBarsSort,
  

  faChessKnight,
  

  faFarm,
  
  faBarnSilo,
  

  faSquareT,
  

  faTvRetro,
  

  faScannerImage,
  

  faSnooze,
  
  faZzz,
  

  faBlockQuestion,
  

  faPlayPause,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faUserGroup,
  
  faUserFriends,
  

  faBooks,
  

  faStarExclamation,
  

  faArrowUpToArc,
  

  faWeightScale,
  
  faWeight,
  

  faHandBackPointUp,
  

  faFlowerDaffodil,
  

  faCalendarRange,
  

  faTableCellsLock,
  

  faFilePrescription,
  

  faXmarksLines,
  

  faWeightHanging,
  

  faCrown,
  

  faLeftLongToLine,
  

  faMicrochip,
  

  faTemperatureHigh,
  

  faTrashCanXmark,
  

  faFolderUser,
  

  faPeopleCarryBox,
  
  faPeopleCarry,
  

  faClockTenThirty,
  

  faCloudsMoon,
  

  faCircle8,
  

  faHeartPulse,
  
  faHeartbeat,
  

  faInboxIn,
  
  faInboxArrowDown,
  

  faThumbtackSlash,
  
  faThumbTackSlash,
  

  faPassport,
  

  faVenus,
  

  faCommentSmile,
  

  faSquareRight,
  
  faArrowAltSquareRight,
  

  faVideoPlus,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faFireHydrant,
  

  faFilePng,
  

  faApostrophe,
  

  faPersonBreastfeeding,
  

  faGaugeMax,
  
  faTachometerAltFastest,
  

  faBuildingWheat,
  

  faCircleE,
  

  faChartPieSimpleCircleCurrency,
  

  faLayerMinus,
  
  faLayerGroupMinus,
  

  faLightbulbExclamation,
  

  faMessageArrowUp,
  
  faCommentAltArrowUp,
  

  faPaperPlaneTop,
  
  faPaperPlaneAlt,
  
  faSend,
  

  faPersonSeatReclined,
  

  faHourglassClock,
  

  faBlenderPhone,
  

  faUserHairBuns,
  

  faHourglassStart,
  
  faHourglass1,
  

  faFamily,
  

  faShopLock,
  

  faIntersection,
  

  faVirusCovidSlash,
  

  faServer,
  

  faBadgeSheriff,
  

  faGridRound,
  

  faSlidersSimple,
  

  faWindTurbine,
  

  faShopSlash,
  
  faStoreAltSlash,
  

  faSquare6,
  

  faPersonSkiLift,
  
  faSkiLift,
  

  faNfcLock,
  

  faCannon,
  

  faFilesMedical,
  

  faPegasus,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faComputerMouse,
  
  faMouse,
  

  faCalendarStar,
  

  faPersonToPortal,
  
  faPortalEnter,
  

  faSlash,
  

  faLasso,
  

  faCircleQuarterStroke,
  

  faLocationXmark,
  
  faMapMarkerTimes,
  
  faMapMarkerXmark,
  

  faSpellCheck,
  

  faOctopus,
  

  faCoffinCross,
  

  faGoalNet,
  

  faXRay,
  

  faArrowDownFromBracket,
  

  faDiagramVenn,
  

  faFileLock,
  

  faEar,
  

  faPlaneCircleExclamation,
  

  faWindow,
  

  faFaceAstonished,
  

  faPipeSmoking,
  

  faFileInvoiceDollar,
  

  faScalpelLineDashed,
  
  faScalpelPath,
  

  faHandsBound,
  

  faClockThree,
  

  faSpider,
  

  faBracketCurlyRight,
  

  faFileDashedLine,
  
  faPageBreak,
  

  faArrowUpFromSquare,
  

  faBinBottlesRecycle,
  

  faGripLinesVertical,
  

  faMobileRetro,
  

  faPersonRunning,
  
  faRunning,
  

  faShuffle,
  
  faRandom,
  

  faPeanuts,
  

  faTransporter1,
  

  faArrowUpLeft,
  

  faSquarePhoneHangup,
  
  faPhoneSquareDown,
  

  faShieldSlash,
  

  faCircleU,
  

  faGaugeSimpleMax,
  
  faTachometerFastest,
  

  faPlaneTail,
  

  faShapes,
  
  faTriangleCircleSquare,
  

  faChargingStation,
  

  faMaximize,
  
  faExpandArrowsAlt,
  

  faLightbulbGear,
  

  faCactus,
  

  faSignalBarsGood,
  
  faSignalAlt3,
  

  faClockFourThirty,
  

  faArrowPointer,
  
  faMousePointer,
  

  faClockSevenThirty,
  

  faVenusMars,
  

  faBox,
  

  faPageCaretDown,
  
  faFileCaretDown,
  

  faCross,
  

  faRepeat,
  

  faDialMin,
  

  faStar,
  

  faDiamondExclamation,
  

  faSignalBars,
  
  faSignalAlt,
  
  faSignalAlt4,
  
  faSignalBarsStrong,
  

  faSprayCanSparkles,
  
  faAirFreshener,
  

  faCommentText,
  

  faSunDust,
  

  faCameraRotate,
  

  faUniformMartialArts,
  

  faFaceWeary,
  

  faEggFried,
  

  faCircleBookmark,
  
  faBookmarkCircle,
  

  faBellExclamation,
  

  faBan,
  
  faCancel,
  

  faScalpel,
  

  faPersonCircleMinus,
  

  faCircleThreeQuartersStroke,
  

  faHouseFlag,
  

  faChartArea,
  
  faAreaChart,
  

  faMoneyBillWave,
  

  faPizzaSlice,
  

  faTruckBolt,
  

  faSignPosts,
  

  faMailbox,
  

  faChartLineUp,
  

  faBuildingLock,
  

  faRectangleHistoryCircleUser,
  

  faPersonDressFairy,
  

  faTabletButton,
  

  faC,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faFaceSmileTear,
  

  faRoadBridge,
  

  faCalendarPen,
  
  faCalendarEdit,
  

  faFolderImage,
  

  faPersonHalfDress,
  

  faFileChartColumn,
  
  faFileChartLine,
  

  faSynagogue,
  

  faGlobe,
  

  faPersonDolly,
  

  faLocationCrosshairsSlash,
  
  faLocationSlash,
  

  faSteak,
  

  faBullhorn,
  

  faBoxCheck,
  

  faTamale,
  

  faHatSanta,
  

  faArrowLeftToBracket,
  

  faKey,
  

  faWavePulse,
  
  faHeartRate,
  

  faHighlighter,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faLightSwitch,
  

  faBuildingUser,
  

  faVanShuttle,
  
  faShuttleVan,
  

  faDumpster,
  

  faArrowDownToArc,
  

  faLightEmergency,
  

  faToiletPaperUnder,
  
  faToiletPaperReverse,
  

  faSchoolCircleCheck,
  

  faComma,
  

  faSensor,
  

  faUser,
  

  faRotateReverse,
  

  faBadgePercent,
  

  faBridgeCircleExclamation,
  

  faPenClip,
  
  faPenAlt,
  

  faH3,
  

  faBowlChopsticksNoodles,
  

  faPizza,
  

  faE,
  

  faLambda,
  

  faWandMagicSparkles,
  
  faMagicWandSparkles,
  

  faGauge,
  
  faDashboard,
  
  faGaugeMed,
  
  faTachometerAltAverage,
  

  faVial,
  

  faSquareBolt,
  

  faLeafOak,
  

  faMarsStroke,
  

  faCircleParking,
  
  faParkingCircle,
  

  faCrutches,
  

  faChartSimple,
  

  faBagSeedling,
  

  faPenCircle,
  

  faRadiation,
  

  faPlaneUpSlash,
  

  faMug,
  

  faMicrochipAi,
  

  faFileWaveform,
  
  faFileMedicalAlt,
  

  faCreditCardBlank,
  

  faFaceAnxiousSweat,
  

  faFolder,
  
  faFolderBlank,
  

  faObjectsAlignTop,
  

  faFileCad,
  

  faTrashPlus,
  

  faHeadSideGear,
  

  faArrowUpFromBracket,
  

  faHandPointDown,
  

  faRaccoon,
  

  faOption,
  

  faBacon,
  

  faTrashList,
  

  faMessageCaptions,
  
  faCommentAltCaptions,
  

  faSushi,
  
  faNigiri,
  

  faBullseye,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faLocationSmile,
  
  faMapMarkerSmile,
  

  faHelmetUn,
  

  faUmbrellaBeach,
  

  faBrainArrowCurvedRight,
  
  faMindShare,
  

  fa6,
  

  faCreditCardFront,
  

  faBatteryLow,
  
  faBattery1,
  

  faAlignJustify,
  

  faFanTable,
  

  faBookmark,
  

  faSemicolon,
  

  faSquareExclamation,
  
  faExclamationSquare,
  

  faTrainSubwayTunnel,
  
  faSubwayTunnel,
  

  faSquareUp,
  
  faArrowAltSquareUp,
  

  faFaceHoldingBackTears,
  

  faBowlSoftServe,
  

  faBaguette,
  

  faBarcodeRead,
  

  faArrowUpBigSmall,
  
  faSortSizeUp,
  

  faMoneyBill,
  

  faHandPointUp,
  

  faSquareJ,
  

  faBagShoppingPlus,
  

  faSquareDashed,
  

  faFaceFrownOpen,
  
  faFrownOpen,
  

  faFileVector,
  

  faTally1,
  

  faPooStorm,
  
  faPooBolt,
  

  faCapsules,
  

  faDonut,
  
  faDoughnut,
  

  faDongSign,
  

  faTemperatureHalf,
  
  faTemperature2,
  
  faThermometer2,
  
  faThermometerHalf,
  

  faCommentImage,
  

  faEscalator,
  

  faCarWash,
  

  faNotesMedical,
  

  faSlotMachine,
  

  faWineGlassCrack,
  
  faFragile,
  

  faG,
  

  faWhistle,
  

  faLinkSimple,
  

  faMonitorWaveform,
  
  faMonitorHeartRate,
  

  faQ,
  

  faHorse,
  

  faDialMed,
  

  faAngleRight,
  

  faBellOn,
  

  faFilters,
  

  faMugMarshmallows,
  

  faHorseSaddle,
  

  faJoint,
  

  faBracketRound,
  
  faParenthesis,
  

  faIgloo,
  

  faSchool,
  

  faBriefcaseBlank,
  

  faChartCandlestick,
  

  faRoadBarrier,
  

  faMortarPestle,
  

  faShieldCheck,
  

  faUserAlien,
  

  faSnowman,
  

  faWheatAwnCircleExclamation,
  

  faGunSquirt,
  

  faPiano,
  

  faPepper,
  

  faTruckMedical,
  
  faAmbulance,
  

  faApartment,
  

  faTriangle,
  

  faFileMov,
  

  faHeadSideCoughSlash,
  

  faPear,
  

  faStaffSnake,
  
  faRodAsclepius,
  
  faRodSnake,
  
  faStaffAesculapius,
  

  faSpiderBlackWidow,
  

  faCircleD,
  

  faHammerWar,
  

  faBicycle,
  

  faBangladeshiTakaSign,
  

  faCalendars,
  

  faCircleArrowUpRight,
  

  faLeafyGreen,
  

  faSquid,
  

  faSparkles,
  

  faV,
  

  faObjectsAlignBottom,
  

  faBasketballHoop,
  

  faTooth,
  

  faFaceGrinWide,
  
  faGrinAlt,
  

  faPills,
  

  faArrowDownLeftAndArrowUpRightToCenter,
  

  faHryvniaSign,
  
  faHryvnia,
  

  faI,
  

  faUserHelmetSafety,
  
  faUserConstruction,
  
  faUserHardHat,
  

  faDialHigh,
  

  faGlassEmpty,
  

  faDroneFront,
  
  faDroneAlt,
  

  faStairs,
  

  faToiletPaperUnderSlash,
  
  faToiletPaperReverseSlash,
  

  faDrawSquare,
  

  faFilePlus,
  

  faStamp,
  

  faSaltShaker,
  

  faChartMixedUpCircleDollar,
  

  faICursor,
  

  faSquareArrowUpLeft,
  

  fa5,
  

  faLandMineOn,
  

  faTricycle,
  

  faFaceZany,
  

  faSquareRss,
  
  faRssSquare,
  

  faOctagonMinus,
  
  faMinusOctagon,
  

  faDiceFive,
  

  faRoadCircleCheck,
  

  faFaceRelieved,
  

  faEclipse,
  

  faAlarmClock,
  

  faEarDeaf,
  
  faDeaf,
  
  faDeafness,
  
  faHardOfHearing,
  

  faClockThreeThirty,
  

  faFaceGrinWink,
  
  faGrinWink,
  

  faHatWitch,
  

  faCoffeeBeans,
  

  faMessageSms,
  

  faChessBishop,
  

  faSealExclamation,
  

  faGrateDroplet,
  

  faVideoArrowUpRight,
  

  faAcorn,
  

  faFlute,
  

  faRaygun,
  

  faSkeletonRibs,
  

  faThoughtBubble,
  

  faUpToDottedLine,
  

  faFaceGrinTongue,
  
  faGrinTongue,
  

  faPeriod,
  

  faBridgeCircleXmark,
  

  faFaceKiss,
  
  faKiss,
  

  faWindowFrameOpen,
  

  faLightbulbCfl,
  

  faCommentArrowDown,
  

  faCameraWeb,
  
  faWebcam,
  

  faSquareM,
  

  faFaceScream,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faFieldHockeyStickBall,
  
  faFieldHockey,
  

  faSquare2,
  

  faSaxophone,
  

  faStopwatch,
  

  faBlinds,
  

  faCommand,
  

  faPopsicle,
  

  faBookArrowUp,
  

  faCircleMicrophone,
  
  faMicrophoneCircle,
  

  faSpiderWeb,
  

  faHandSpock,
  

  faCircleCamera,
  
  faCameraCircle,
  

  faFacePersevering,
  

  faGaugeSimpleLow,
  
  faTachometerSlow,
  

  faFaceSaluting,
  

  faChevronUp,
  

  faSquareI,
  

  faCalendarCircleExclamation,
  

  faPlug,
  

  faHouseCircleXmark,
  

  faWorm,
  

  faFaceShush,
  

  faFlaskRoundPotion,
  
  faFlaskPotion,
  

  faPi,
  

  faOm,
  

  faArrowTurnLeftDown,
  

  faFolderBookmark,
  

  faTurnRight,
  

  faPrintMagnifyingGlass,
  
  faPrintSearch,
  

  faUtensilsSlash,
  

  faPersonBikingMountain,
  
  faBikingMountain,
  

  faHand,
  
  faHandPaper,
  

  faHeadSideBrain,
  

  faCucumber,
  

  faPoliceBox,
  

  faFlaskVial,
  

  faEyeSlash,
  

  faFacePleading,
  

  faUsers,
  

  faCircleF,
  

  faRight,
  
  faArrowAltRight,
  

  faPersonRays,
  

  faReplyClock,
  
  faReplyTime,
  

  faMitten,
  

  faArrowDownZA,
  
  faSortAlphaDesc,
  
  faSortAlphaDownAlt,
  

  faBagShopping,
  
  faShoppingBag,
  

  faHandHeart,
  

  faTruckContainerEmpty,
  

  faCalendarExclamation,
  

  faSink,
  

  faSunset,
  

  faMicroscope,
  

  faHourglassHalf,
  
  faHourglass2,
  

  faCircleCalendar,
  
  faCalendarCircle,
  

  faCircleW,
  

  faHeartCircleMinus,
  

  faWaveSine,
  

  faDisplayChartUpCircleDollar,
  

  faShareNodes,
  
  faShareAlt,
  

  faKnife,
  
  faUtensilKnife,
  

  faLightbulbOn,
  

  faMessageMiddleTop,
  
  faCommentMiddleTopAlt,
  

  faCarSide,
  

  faSquareSliders,
  
  faSlidersHSquare,
  

  faPenToSquare,
  
  faEdit,
  

  faSackDollar,
  

  faCrosshairsSimple,
  

  faBridgeLock,
  

  faFolderArrowUp,
  
  faFolderUpload,
  

  faSquareSmall,
  

  faBackpack,
  

  faArrowsCross,
  

  faTree,
  

  faCommentsQuestionCheck,
  

  faHouseFloodWater,
  

  faMapLocation,
  
  faMapMarked,
  

  faBlanket,
  

  faGlobePointer,
  

  faHotTubPerson,
  
  faHotTub,
  

  faHouseNight,
  

  faRectanglePro,
  
  faPro,
  

  faMonkey,
  

  faSignalBarsSlash,
  
  faSignalAltSlash,
  

  faGasPump,
  

  faArrowDownFromLine,
  
  faArrowFromTop,
  

  faLock,
  

  faPaintbrush,
  
  faPaintBrush,
  

  faSnowBlowing,
  

  faFutbol,
  
  faFutbolBall,
  
  faSoccerBall,
  

  faJug,
  

  faFolderPlus,
  

  faCampground,
  

  faClockNineThirty,
  

  faWatchFitness,
  

  faHouseMedicalCircleXmark,
  

  faUpToLine,
  
  faArrowAltToTop,
  

  faEgg,
  

  faFaceDizzy,
  
  faDizzy,
  

  faClipboardMedical,
  

  faCircleDot,
  
  faDotCircle,
  

  faBorderCenterV,
  

  faGamepad,
  

  faCartPlus,
  

  faUserBeardBolt,
  

  faSquarePhoneFlip,
  
  faPhoneSquareAlt,
  

  faTreePalm,
  

  faList,
  
  faListSquares,
  

  faFilmSimple,
  
  faFilmAlt,
  

  faAbacus,
  

  faHockeySticks,
  

  faFaceAnguished,
  

  faGhost,
  

  faHeading,
  
  faHeader,
  

  faTrainTunnel,
  

  faSquareParkingSlash,
  
  faParkingSlash,
  

  faPesetaSign,
  

  faSandwich,
  

  faBookOpenCover,
  
  faBookOpenAlt,
  

  faShredder,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faLuchadorMask,
  
  faLuchador,
  
  faMaskLuchador,
  

  faCommentLines,
  

  faKeySkeletonLeftRight,
  

  faAsterisk,
  

  faHandsHoldingChild,
  

  faAnkh,
  

  faWheatAwn,
  
  faWheatAlt,
  

  faCompress,
  

  faCircleN,
  

  faAlbum,
  

  faCloudSunRain,
  

  faSwords,
  

  faCommentSlash,
  

  faBoxTaped,
  
  faBoxAlt,
  

  faXmarkToSlot,
  
  faTimesToSlot,
  
  faVoteNay,
  

  faVolumeLow,
  
  faVolumeDown,
  

  faFeather,
  

  faSquareCode,
  

  faDisplayChartUp,
  

  faChartScatter3d,
  

  faHanukiah,
  

  faFaceCowboyHat,
  

  faFlag,
  

  faArrowUpToLine,
  
  faArrowToTop,
  

  faSquirrel,
  

  faFireBurner,
  

  faRoadSpikes,
  

  faFaceSleeping,
  

  faMemory,
  

  faCircleDollarToSlot,
  
  faDonate,
  

  faSpaceStationMoonConstruction,
  
  faSpaceStationMoonAlt,
  

  faPipeSection,
  

  faSitemap,
  

  faHeadphonesSimple,
  
  faHeadphonesAlt,
  

  faCloudShowersHeavy,
  

  faTemperatureList,
  

  faUnlockKeyhole,
  
  faUnlockAlt,
  

  faSidebarFlip,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faFaceFrownSlight,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faSchoolCircleXmark,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBlock,
  

  faTrashCanList,
  

  faCommentMiddle,
  

  faCaretLeft,
  

  faLightbulb,
  

  faPeopleRobbery,
  

  faSquareTerminal,
  

  faCassetteTape,
  

  faShieldCross,
  

  fa8,
  

  faRulerHorizontal,
  

  faCoconut,
  

  faFilm,
  

  faSickle,
  

  faRadar,
  

  faPhotoFilmMusic,
  

  faRollerCoaster,
  

  faCorn,
  

  faFaceKissBeam,
  
  faKissBeam,
  

  faSquareUpRight,
  
  faExternalLinkSquareAlt,
  

  faDropletPercent,
  
  faHumidity,
  

  faFaceBeamHandOverMouth,
  

  faHeartCrack,
  
  faHeartBroken,
  

  faHourglassEnd,
  
  faHourglass3,
  

  faPeopleGroup,
  

  faKeyboardLeft,
  

  faBars,
  
  faNavicon,
  

  faPrescriptionBottle,
  

  faSwatchbook,
  

  faRectangleVerticalHistory,
  

  faGrillFire,
  

  faJoystick,
  

  faLaptopCode,
  

  faTruckUtensils,
  

  faFileCircleQuestion,
  

  faHeartHalfStroke,
  
  faHeartHalfAlt,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faCompass,
  

  faBird,
  

  faHelicopter,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faHouseFire,
  

  faEmptySet,
  

  faStarAndCrescent,
  

  faReply,
  
  faMailReply,
  

  faMeat,
  

  faClover,
  

  faUsersSlash,
  

  faStarSharpHalf,
  

  faPickleball,
  

  faFaceMask,
  

  faTachographDigital,
  
  faDigitalTachograph,
  

  faMagnifyingGlassArrowRight,
  

  faSensorTriangleExclamation,
  
  faSensorAlert,
  

  faUsersMedical,
  

  faMessageImage,
  
  faCommentAltImage,
  

  faUserChef,
  

  faTable,
  

  faHyphen,
  

  faMustache,
  

  faHockeyPuck,
  

  faToiletsPortable,
  

  faSunPlantWilt,
  

  faListMusic,
  

  faScissors,
  
  faCut,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faTombstone,
  

  faMarsAndVenusBurst,
  

  faFaceAngryHorns,
  

  faSignPost,
  

  faPeopleArrows,
  
  faPeopleArrowsLeftRight,
  

  faAlbumCollectionCirclePlus,
  

  faSquareRoot,
  

  faChessRookPiece,
  
  faChessRookAlt,
  

  faArrowProgress,
  

  faFileMp3,
  

  faPenRuler,
  
  faPencilRuler,
  

  faBellConcierge,
  
  faConciergeBell,
  

  faMessagePen,
  
  faCommentAltEdit,
  
  faMessageEdit,
  

  faBadge,
  

  faSunglasses,
  

  faTireFlat,
  

  faTreeChristmas,
  

  faMotorcycle,
  

  faChartBullet,
  

  faStarChristmas,
  

  faCircleC,
  

  faBoxTissue,
  

  faMicrophoneSlash,
  

  faBinoculars,
  

  faTruckRamp,
  

  faMusicSlash,
  

  faTableCellsUnlock,
  

  faTrillium,
  

  faBrowsers,
  

  faSprinklerCeiling,
  

  faGavel,
  
  faLegal,
  

  faReflectBoth,
  

  faTrashClock,
  

  faCartCircleArrowUp,
  

  faTentArrowLeftRight,
  

  faChfSign,
  

  faMicrowave,
  

  faHospitalUser,
  

  faFaceFlushed,
  
  faFlushed,
  

  faSquare3,
  

  faTrowelBricks,
  

  faCloud,
  

  faMessageQuestion,
  

  faPaw,
  

  faTabletScreenButton,
  
  faTabletAlt,
  

  faCircleNotch,
  

  faRainbow,
  

  faEarthAfrica,
  
  faGlobeAfrica,
  

  faElephant,
  

  faSquareB,
  

  faCodePullRequestDraft,
  

  faW,
  

  faGiftCard,
  

  faTruckMonster,
  

  faScarecrow,
  

  faAlarmSnooze,
  

  faSprayCan,
  

  faShishKebab,
  

  faFaceGrinTongueSquint,
  
  faGrinTongueSquint,
  

  faArrowDown91,
  
  faSortNumericDesc,
  
  faSortNumericDownAlt,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCalendarImage,
  

  faCircleM,
  

  faDialMax,
  

  faPersonDrowning,
  

  faGrapes,
  

  faBoxArchive,
  
  faArchive,
  

  faFaceSmileHorns,
  

  faToggleOff,
  

  faDialOff,
  

  faFaceAwesome,
  
  faGaveDandy,
  

  faSquareV,
  

  faDrumstick,
  

  faBroomBall,
  
  faQuidditch,
  
  faQuidditchBroomBall,
  

  faUp,
  
  faArrowAltUp,
  

  faFence,
  

  faBlindsOpen,
  

  faWebhook,
  

  faScrollTorah,
  
  faTorah,
  

  faDownRight,
  

  faPersonArrowUpFromLine,
  

  faBowlingPins,
  

  faPencilSlash,
  

  faUserNinja,
  

  fa7,
  

  faBlog,
  

  faCircle9,
  

  faSheetPlastic,
  

  faFaceUnamused,
  

  faMessageArrowDown,
  
  faCommentAltArrowDown,
  

  faGolfFlagHole,
  

  faBookBlank,
  
  faBookAlt,
  

  faVialVirus,
  

  faCloudXmark,
  

  faUserCheck,
  

  faArrowDownToSquare,
  

  faNote,
  

  faTruckRampBox,
  
  faTruckLoading,
  

  faBlueberries,
  

  faChartSine,
  

  faPenField,
  

  faClipboardList,
  

  faPumpkin,
  

  faCodePullRequest,
  

  faDesktopArrowDown,
  

  faPaste,
  
  faFileClipboard,
  

  faComments,
  

  faCaretRight,
  

  faBackward,
  

  faPencil,
  
  faPencilAlt,
  

  faLips,
  

  faLandmarkFlag,
  

  faRam,
  

  faExcavator,
  

  faEggplant,
  

  faFolderGrid,
  

  faGaugeMin,
  
  faTachometerAltSlowest,
  

  faDiagramPrevious,
  

  faK,
  

  faPage,
  

  faStrikethrough,
  

  faTrees,
  

  faHandLove,
  

  faFootballHelmet,
  

  faGrid,
  
  faGrid3,
  

  faPanFrying,
  

  faAddressBook,
  
  faContactBook,
  

  faCartMinus,
  

  faPager,
  

  faMerge,
  

  faCircleH,
  
  faHospitalSymbol,
  

  faHexagonXmark,
  
  faTimesHexagon,
  
  faXmarkHexagon,
  

  faCartXmark,
  

  faBowArrow,
  

  faFileCircleExclamation,
  

  faEnvelopesBulk,
  
  faMailBulk,
  

  faJarWheat,
  

  faSpoon,
  
  faUtensilSpoon,
  

  faCheeseSwiss,
  

  faHouseBuilding,
  

  faLeafHeart,
  

  faArrowsRotateReverse,
  

  faArrowDownUpAcrossLine,
  

  faSpaghettiMonsterFlying,
  
  faPastafarianism,
  

  faTruckFlatbed,
  

  faClarinet,
  

  faBong,
  

  faCameraMovie,
  

  faSigma,
  

  faFaceGrinStars,
  
  faGrinStars,
  

  faSquareP,
  

  faBringForward,
  

  faRecordVinyl,
  

  faTruckPlane,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faUnion,
  

  faMenorah,
  

  faFileCsv,
  

  faLaptop,
  

  faPerson,
  
  faMale,
  

  faFireFlameSimple,
  
  faBurn,
  

  faPersonCarryBox,
  
  faPersonCarry,
  

  faArrowUpLong,
  
  faLongArrowUp,
  

  faCalendarCircleUser,
  

  faTransporter,
  

  faDiagramPredecessor,
  

  faCrateEmpty,
  

  faCarpool,
  
  faCarPeople,
  

  faBeerMugEmpty,
  
  faBeer,
  

  faPeopleLine,
  

  faLightbulbExclamationOn,
  

  faLocationPlus,
  
  faMapMarkerPlus,
  

  faSquareArrowRight,
  
  faArrowSquareRight,
  

  faPeopleRoof,
  

  faUsersRectangle,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCrop,
  

  faSchoolCircleExclamation,
  

  faUserVneck,
  

  faFootball,
  
  faFootballBall,
  

  faChevronsUp,
  
  faChevronDoubleUp,
  

  faFlagCheckered,
  

  faUtilityPoleDouble,
  

  faBuildingMemo,
  

  faSquareX,
  

  faBowlScoop,
  
  faBowlShavedIce,
  

  faMessageExclamation,
  
  faCommentAltExclamation,
  

  faLightCeiling,
  

  faFaceSmileBeam,
  
  faSmileBeam,
  

  faForwardStep,
  
  faStepForward,
  

  faMessageBot,
  

  faMagnifyingGlassLocation,
  
  faSearchLocation,
  

  faHandPointRight,
  

  faH1,
  

  faStandardDefinition,
  
  faRectangleSd,
  

  faSkiBoot,
  

  faFingerprint,
  

  faPumpMedical,
  

  faLocationMinus,
  
  faMapMarkerMinus,
  

  faSlidersUp,
  
  faSlidersV,
  

  faBridgeCircleCheck,
  

  faCalculatorSimple,
  
  faCalculatorAlt,
  

  faClosedCaptioningSlash,
  

  faMicrophoneLinesSlash,
  
  faMicrophoneAltSlash,
  

  faIcons,
  
  faHeartMusicCameraBolt,
  

  faSoap,
  

  faAtom,
  

  faNfc,
  

  faFaceGlasses,
  

  faRightFromBracket,
  
  faSignOutAlt,
  

  faFilms,
  

  faDoorOpen,
  

  faShovel,
  

  faFaceIcicles,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faFolderArrowDown,
  
  faFolderDownload,
  

  faSortDown,
  
  faSortDesc,
  

  faBarcodeScan,
  

  faMobileSignal,
  

  faArrowsUpToLine,
  

  faFork,
  
  faUtensilFork,
  

  faUfo,
  

  faTextSize,
  

  faSunHaze,
  

  faVolleyball,
  
  faVolleyballBall,
  

  faBuildingCircleArrowRight,
  

  faRectangleHistory,
  

  faTally4,
  

  faAnchorCircleCheck,
  

  faMp3Player,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faWifiFair,
  
  faWifi2,
  

  faTirePressureWarning,
  

  faDiceThree,
  

  faBuildingUn,
  

  faRing,
  

  faWaveSquare,
  

  faFileLines,
  
  faFileAlt,
  
  faFileText,
  

  faExplosion,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faSquareUser,
  

  faFaceHandPeeking,
  

  faTheta,
  

  faFonduePot,
  

  faRingDiamond,
  

  faRobotAstromech,
  

  faInfo,
  

  faSalad,
  
  faBowlSalad,
  

  faMessage,
  
  faCommentAlt,
  

  faCoffin,
  

  faStethoscope,
  

  faGaugeSimpleMin,
  
  faTachometerSlowest,
  

  faFaceHandYawn,
  

  faUserXmark,
  
  faUserTimes,
  

  faTextHeight,
  

  faHeadSideGoggles,
  
  faHeadVr,
  

  faCircleL,
  

  faTrashCan,
  
  faTrashAlt,
  

  faPhoneArrowUpRight,
  
  faPhoneArrowUp,
  
  faPhoneOutgoing,
  

  faRectanglesMixed,
  

  faAt,
  

  faTransporter7,
  

  faBagel,
  

  faLineHeight,
  

  faWagonCovered,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faArrowsToCircle,
  

  faFillDrip,
  

};
